// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7TmdX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _scaleCard = require("./ScaleCard");
var _scaleCardDefault = parcelHelpers.interopDefault(_scaleCard);
var _filterControls = require("./FilterControls");
var _filterControlsDefault = parcelHelpers.interopDefault(_filterControls);
var _scrollProgressBar = require("./components/ScrollProgressBar");
var _scrollProgressBarDefault = parcelHelpers.interopDefault(_scrollProgressBar);
var _scalesJson = require("./data/scales.json");
var _scalesJsonDefault = parcelHelpers.interopDefault(_scalesJson);
var _config = require("./lib/config");
var _hooks = require("./hooks");
var _stylesScss = require("./styles.scss");
// Update meta tags for social sharing
const updateMetaTags = (scaleNumber = null, scaleData = null)=>{
    const title = scaleNumber ? `Scale #${scaleNumber} - Every Scale` : 'The Encyclopedia of Scales - Every Scale';
    const description = scaleData ? `Musical scale with ${scaleData.scale.length} notes (Superscale ${scaleData.superscale_index}, Mode ${scaleData.mode})` : 'All 927 possible musical scales';
    const imageUrl = scaleNumber ? `${window.location.origin}/images/${scaleNumber}.png` : `${window.location.origin}/img/parchment.jpg`;
    const url = window.location.href;
    // Update document title
    document.title = title;
    // Helper to update or create meta tag
    const updateMeta = (property, content, useProperty = true)=>{
        const attribute = useProperty ? 'property' : 'name';
        let meta = document.querySelector(`meta[${attribute}="${property}"]`);
        if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute(attribute, property);
            document.head.appendChild(meta);
        }
        meta.setAttribute('content', content);
    };
    // OpenGraph tags
    updateMeta('og:title', title);
    updateMeta('og:description', description);
    updateMeta('og:image', imageUrl);
    updateMeta('og:url', url);
    updateMeta('og:type', 'website');
    // Twitter tags
    updateMeta('twitter:card', 'summary_large_image', false);
    updateMeta('twitter:title', title, false);
    updateMeta('twitter:description', description, false);
    updateMeta('twitter:image', imageUrl, false);
    // Standard meta description
    updateMeta('description', description, false);
};
const App = ()=>{
    const [allScales, setAllScales] = (0, _react.useState)([]);
    const [filteredScales, setFilteredScales] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [filters, setFilters] = (0, _react.useState)({
        pattern: ""
    });
    const [activeIntervalPattern, setActiveIntervalPattern] = (0, _react.useState)(null);
    // Global necklace expansion state
    const { toggleNecklace, isExpanded } = (0, _hooks.useNecklaceExpansion)();
    // Initial load
    (0, _react.useEffect)(()=>{
        // Apply CSS variables from config.json
        (0, _config.applyCSSVariables)();
        // Use imported data instead of fetch
        setAllScales((0, _scalesJsonDefault.default));
        setFilteredScales((0, _scalesJsonDefault.default));
        setLoading(false);
    }, []);
    // Handle hash changes (both initial load and URL changes)
    (0, _react.useEffect)(()=>{
        const handleHashChange = ()=>{
            const hash = window.location.hash;
            if (hash.startsWith('#scale-')) {
                const scaleNumber = parseInt(hash.replace('#scale-', ''));
                if (!isNaN(scaleNumber) && scaleNumber >= 1 && scaleNumber <= 927) {
                    // Find the scale data
                    const scaleData = (0, _scalesJsonDefault.default).find((s)=>s.scaleNumber === scaleNumber);
                    // Update meta tags for social sharing
                    updateMetaTags(scaleNumber, scaleData);
                    // Wait for DOM to render, then scroll to scale and open modal
                    setTimeout(()=>{
                        const element = document.querySelector(`[data-scale-number="${scaleNumber}"]`);
                        if (element) {
                            // Instant scroll (no smooth animation) for faster modal opening
                            element.scrollIntoView({
                                behavior: 'instant',
                                block: 'center'
                            });
                            // Open the necklace modal immediately after scroll
                            setTimeout(()=>toggleNecklace(scaleNumber), 50);
                        }
                    }, 100);
                }
            } else // Reset to default meta tags for home page - no scaleNumber
            updateMetaTags();
        };
        // Handle initial hash on load
        handleHashChange();
        // Listen for hash changes
        window.addEventListener('hashchange', handleHashChange);
        return ()=>{
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [
        toggleNecklace
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Filter scales based on pattern criteria
    (0, _react.useEffect)(()=>{
        let filtered = allScales;
        // Extract note count constraints (min5, max8)
        const minMatch = filters.pattern?.match(/min\[?(\d+)\]?/);
        const maxMatch = filters.pattern?.match(/max\[?(\d+)\]?/);
        const minNotes = minMatch ? parseInt(minMatch[1]) : null;
        const maxNotes = maxMatch ? parseInt(maxMatch[1]) : null;
        // Remove min/max from pattern for interval filtering
        const cleanPattern = filters.pattern?.replace(/min\[?\d+\]?/g, '').replace(/max\[?\d+\]?/g, '').trim() || '';
        if (filters.pattern) {
            // Apply note count filters
            if (minNotes !== null || maxNotes !== null) filtered = filtered.filter((scaleData)=>{
                const noteCount = scaleData.scale.length;
                if (minNotes !== null && noteCount < minNotes) return false;
                if (maxNotes !== null && noteCount > maxNotes) return false;
                return true;
            });
            // Apply interval pattern filters and extract patterns for highlighting
            if (cleanPattern) filtered = filtered.filter((scaleData)=>{
                const scaleString = scaleData.scale.join("");
                // Support OR logic with comma separation (e.g., "12,21" = contains 12 OR 21)
                const orGroups = cleanPattern.split(',').map((p)=>p.trim()).filter((p)=>p.length > 0);
                if (orGroups.length === 0) return true;
                // Support AND logic with + or & (e.g., "12&^3" = contains 12 AND starts with 3)
                return orGroups.some((orGroup)=>{
                    const andPatterns = orGroup.split(/[+&]/).map((p)=>p.trim()).filter((p)=>p.length > 0);
                    // All AND patterns must match for this OR group to be true
                    return andPatterns.every((pattern)=>{
                        // Special filters: s5 (superscale), m3 (mode), n42 (scale number), s5m2 (both)
                        if (pattern.startsWith('s') && pattern.length > 1) {
                            const match = pattern.match(/^s(\d+)(?:m(\d+))?$/);
                            if (match) {
                                const [, superscale, mode] = match;
                                const superscaleMatch = !superscale || scaleData.superscale_index === parseInt(superscale);
                                const modeMatch = !mode || scaleData.mode === parseInt(mode);
                                return superscaleMatch && modeMatch;
                            }
                        }
                        if (pattern.startsWith('m') && pattern.length > 1) {
                            const modeNum = parseInt(pattern.slice(1));
                            return !isNaN(modeNum) && scaleData.mode === modeNum;
                        }
                        if (pattern.startsWith('n') && pattern.length > 1) {
                            const scaleNum = parseInt(pattern.slice(1));
                            return !isNaN(scaleNum) && scaleData.scaleNumber === scaleNum;
                        }
                        // Interval patterns
                        if (pattern.startsWith('^')) {
                            // "Starts with" pattern
                            const startPattern = pattern.slice(1);
                            return startPattern && scaleString.startsWith(startPattern);
                        } else // Contains pattern
                        return pattern && scaleString.includes(pattern);
                    });
                });
            });
        }
        // Extract pure interval patterns (just digits) for highlighting
        const intervalPatterns = cleanPattern.split(',').flatMap((orGroup)=>orGroup.split(/[+&]/)).map((p)=>p.trim()).filter((p)=>/^\^?\d+$/.test(p)) // Only digit sequences, optionally with ^
        .map((p)=>p.replace(/^\^/, '')); // Remove ^ for highlighting purposes
        setActiveIntervalPattern(intervalPatterns.length > 0 ? intervalPatterns : null);
        setFilteredScales(filtered);
    }, [
        allScales,
        filters
    ]);
    const handleFilterChange = (newFilters)=>{
        setFilters(newFilters);
    };
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "app",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
            className: "app-header",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "Every Scale"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Loading all 927 scales..."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "app",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                className: "app-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "app-title",
                        children: "The Encyclopedia of Scales"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "app-tagline",
                        children: "All 927 possible musical scales. Available for purchase."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterControlsDefault.default), {
                        onFilterChange: handleFilterChange,
                        totalScales: allScales.length,
                        filteredCount: filteredScales.length
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollProgressBarDefault.default), {
                        filteredCount: filteredScales.length
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "app-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("main", {
                        className: "scales-grid",
                        children: allScales.map((scaleData)=>{
                            const isVisible = filteredScales.some((filtered)=>filtered.key === scaleData.key);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scaleCardDefault.default), {
                                scale: scaleData.scale,
                                scaleNumber: scaleData.scaleNumber,
                                scaleKey: scaleData.key,
                                superscaleIndex: scaleData.superscale_index,
                                mode: scaleData.mode,
                                isVisible: isVisible,
                                matchingPattern: activeIntervalPattern,
                                onNecklaceToggle: ()=>toggleNecklace(scaleData.scaleNumber),
                                isNecklaceExpanded: isExpanded(scaleData.scaleNumber)
                            }, scaleData.key);
                        })
                    }),
                    filteredScales.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "no-results",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "No scales match your current filters."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Try adjusting the note count range or clearing the pattern search."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const root = (0, _client.createRoot)(document.getElementById("root"));
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)(App, {}));

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","react-dom/client":"8W2JM","./ScaleCard":"4VDzJ","./FilterControls":"5zcVT","./components/ScrollProgressBar":"aTcna","./data/scales.json":"dWROg","./lib/config":"5TiHK","./hooks":"aBBAD","./styles.scss":"6GJK0","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"cOZNC":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"4GKs4"}],"4GKs4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"e1Nhq"}],"e1Nhq":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"IGuLd"}],"IGuLd":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"8W2JM":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"f3DXN"}],"f3DXN":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"dhJN5"}],"dhJN5":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"e1Nhq","ece50e903283a22f":"gE6Zx"}],"gE6Zx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"2Y83O"}],"2Y83O":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"4VDzJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooks = require("./hooks");
var _components = require("./components");
var _namesJson = require("./data/names.json");
var _namesJsonDefault = parcelHelpers.interopDefault(_namesJson);
const ScaleCard = ({ scale, scaleNumber, scaleKey, superscaleIndex, mode, isVisible = true, matchingPattern = null, onNecklaceToggle, isNecklaceExpanded = false })=>{
    const scaleInfo = (0, _namesJsonDefault.default)[scaleKey];
    const [showPurchaseModal, setShowPurchaseModal] = (0, _react.useState)(false);
    // Extract all audio logic into custom hook
    const { isPlaying, currentPlayingNote, handleNoteClick, handlePlayScale } = (0, _hooks.useScaleAudio)(scale, scaleNumber);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `scale-card ${!isVisible ? 'scale-card--hidden' : ''}`,
        "data-scale-number": scaleNumber,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "scale-card-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ScaleHeader), {
                    scaleNumber: scaleNumber,
                    scaleInfo: scaleInfo
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ScaleNotation), {
                    scale: scale,
                    onNoteClick: handleNoteClick,
                    matchingPattern: matchingPattern
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TechnicalId), {
                    superscaleIndex: superscaleIndex,
                    mode: mode
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "ux-buttons",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PlayButton), {
                            isPlaying: isPlaying,
                            onPlay: handlePlayScale
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.NecklaceButton), {
                            isVisible: isNecklaceExpanded,
                            onToggle: onNecklaceToggle
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "purchase-button-corner",
                            title: "Purchase this scale",
                            onClick: ()=>setShowPurchaseModal(true),
                            children: "$"
                        })
                    ]
                }),
                isNecklaceExpanded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.NecklaceModal), {
                    scale: scale,
                    mode: mode,
                    superscaleIndex: superscaleIndex,
                    scaleNumber: scaleNumber,
                    onClose: onNecklaceToggle,
                    onPlayScale: handlePlayScale,
                    onPurchase: ()=>{
                        onNecklaceToggle(); // Close necklace modal
                        setShowPurchaseModal(true); // Open purchase modal
                    }
                }),
                showPurchaseModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PurchaseModal), {
                    scaleNumber: scaleNumber,
                    scale: scale,
                    superscaleIndex: superscaleIndex,
                    mode: mode,
                    onClose: ()=>setShowPurchaseModal(false)
                })
            ]
        })
    });
};
exports.default = ScaleCard;

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","./hooks":"aBBAD","./components":"9Nehm","./data/names.json":"LHMUK","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"aBBAD":[function(require,module,exports,__globalThis) {
// Custom React hooks for Every Scale app
// Barrel exports for clean imports
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScaleAudio", ()=>(0, _useScaleAudio.useScaleAudio));
parcelHelpers.export(exports, "useConfig", ()=>(0, _useConfig.useConfig));
parcelHelpers.export(exports, "useAudioConfig", ()=>(0, _useConfig.useAudioConfig));
parcelHelpers.export(exports, "useVisualConfig", ()=>(0, _useConfig.useVisualConfig));
parcelHelpers.export(exports, "useTypographyConfig", ()=>(0, _useConfig.useTypographyConfig));
parcelHelpers.export(exports, "useNecklaceExpansion", ()=>(0, _useNecklaceExpansion.useNecklaceExpansion)) // Future hooks can be added here:
 // export { useScaleRendering } from './useScaleRendering';
 // export { useIntervalHighlighting } from './useIntervalHighlighting';
 // export { useFilters } from './useFilters';
;
var _useScaleAudio = require("./useScaleAudio");
var _useConfig = require("./useConfig");
var _useNecklaceExpansion = require("./useNecklaceExpansion");

},{"./useScaleAudio":"jDeur","./useConfig":"DWtOa","./useNecklaceExpansion":"fS8Ok","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"jDeur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScaleAudio", ()=>useScaleAudio);
var _react = require("react");
var _audioUtils = require("../lib/audioUtils");
var _intervalBrackets = require("../lib/intervalBrackets");
var _useConfig = require("./useConfig");
const useScaleAudio = (scale, scaleNumber)=>{
    const [isPlaying, setIsPlaying] = (0, _react.useState)(false);
    const [currentPlayingNote, setCurrentPlayingNote] = (0, _react.useState)(-1);
    const audioConfig = (0, _useConfig.useAudioConfig)();
    /**
   * Handle individual note clicks - plays single note with highlighting
   */ const handleNoteClick = (0, _react.useCallback)((noteIndex)=>{
        // Stop any current playback
        (0, _audioUtils.stopAudio)();
        setIsPlaying(false);
        setCurrentPlayingNote(-1);
        // Clear any interval highlighting from all scale notation containers
        const containers = document.querySelectorAll('.scale-notation');
        containers.forEach((container)=>(0, _intervalBrackets.clearIntervalHighlight)(container));
        // Calculate MIDI note for clicked note
        const startingPitch = audioConfig.pitch.startingPitch;
        const midiNote = startingPitch + scale.slice(0, noteIndex + 1).reduce((sum, interval)=>sum + interval, 0);
        // Find the current scale's notation container and play note with highlighting
        const currentScaleContainer = document.querySelector(`[data-scale-number="${scaleNumber}"] .scale-notation`);
        if (currentScaleContainer) (0, _audioUtils.playNoteWithHighlight)(midiNote, currentScaleContainer, noteIndex);
    }, [
        scale,
        scaleNumber
    ]);
    /**
   * Handle scale playback - plays entire scale with sequential highlighting
   */ const handlePlayScale = (0, _react.useCallback)(async ()=>{
        const scaleId = `scale-${scaleNumber}`;
        if (isPlaying && (0, _audioUtils.getCurrentlyPlayingScale)() === scaleId) {
            // Stop playback if this scale is currently playing
            (0, _audioUtils.stopAudio)();
            setIsPlaying(false);
            setCurrentPlayingNote(-1);
            return;
        }
        // Stop any other playing scale
        if ((0, _audioUtils.getIsPlaying)()) (0, _audioUtils.stopAudio)();
        // Clear any interval highlighting
        const currentScaleContainer = document.querySelector(`[data-scale-number="${scaleNumber}"] .scale-notation`);
        if (currentScaleContainer) (0, _intervalBrackets.clearIntervalHighlight)(currentScaleContainer);
        setIsPlaying(true);
        try {
            await (0, _audioUtils.playScale)(scale, {
                scaleId,
                // Audio timing parameters come from config
                startingPitch: audioConfig.pitch.startingPitch,
                noteDuration: audioConfig.tempo.noteDuration,
                noteGap: audioConfig.tempo.noteGap,
                playDescending: false,
                container: currentScaleContainer,
                onNoteStart: (noteIndex)=>{
                    setCurrentPlayingNote(noteIndex);
                },
                onNoteEnd: (noteIndex)=>{
                    setCurrentPlayingNote(-1);
                },
                onStop: ()=>{
                    setIsPlaying(false);
                    setCurrentPlayingNote(-1);
                }
            });
        } catch (error) {
            console.error("Error playing scale:", error);
        } finally{
            setIsPlaying(false);
            setCurrentPlayingNote(-1);
        }
    }, [
        scale,
        scaleNumber,
        isPlaying
    ]);
    // Return the audio state and control functions
    return {
        isPlaying,
        currentPlayingNote,
        handleNoteClick,
        handlePlayScale
    };
};
exports.default = useScaleAudio;

},{"react":"e1Nhq","../lib/audioUtils":"79bZ8","../lib/intervalBrackets":"9mjrb","./useConfig":"DWtOa","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"79bZ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initAudio", ()=>initAudio);
parcelHelpers.export(exports, "scaleToMidiNotes", ()=>scaleToMidiNotes);
parcelHelpers.export(exports, "playNote", ()=>playNote);
parcelHelpers.export(exports, "playNoteWithHighlight", ()=>playNoteWithHighlight);
parcelHelpers.export(exports, "playScale", ()=>playScale);
parcelHelpers.export(exports, "playScaleAsChord", ()=>playScaleAsChord);
parcelHelpers.export(exports, "stopAudio", ()=>stopAudio);
parcelHelpers.export(exports, "getIsPlaying", ()=>getIsPlaying);
parcelHelpers.export(exports, "setCurrentlyPlayingScale", ()=>setCurrentlyPlayingScale);
parcelHelpers.export(exports, "getCurrentlyPlayingScale", ()=>getCurrentlyPlayingScale);
parcelHelpers.export(exports, "highlightNote", ()=>highlightNote);
parcelHelpers.export(exports, "unhighlightNote", ()=>unhighlightNote);
parcelHelpers.export(exports, "clearAllHighlights", ()=>clearAllHighlights);
parcelHelpers.export(exports, "getMidiNoteName", ()=>getMidiNoteName);
var _tone = require("tone");
var _tonal = require("tonal");
var _config = require("./config");
// Global synth instance
let synth = null;
let isPlaying = false;
let currentlyPlayingScale = null;
const initAudio = async ()=>{
    if (!synth) {
        // Create a high-quality piano-like synthesizer
        synth = new _tone.PolySynth(_tone.Synth, {
            oscillator: {
                type: "sine"
            },
            envelope: {
                attack: 0.02,
                decay: 0.2,
                sustain: 0.3,
                release: 0.8
            },
            filter: {
                Q: 2,
                frequency: 800,
                rolloff: -12
            },
            filterEnvelope: {
                attack: 0.02,
                decay: 0.1,
                sustain: 0.5,
                release: 1.2,
                baseFrequency: 300,
                octaves: 2
            }
        }).toDestination();
        // Add some reverb for richness
        const reverb = new _tone.Reverb({
            decay: 2,
            wet: 0.3
        }).toDestination();
        synth.connect(reverb);
    }
};
const scaleToMidiNotes = (scale, startingPitch = (0, _config.getConfigValue)('audio.pitch.startingPitch', 60))=>{
    const midiNotes = scale.reduce((acc, step)=>{
        const lastNote = acc[acc.length - 1] || startingPitch;
        acc.push(lastNote + step);
        return acc;
    }, [
        startingPitch
    ]);
    return midiNotes;
};
const playNote = async (midiNote, duration = 0.5)=>{
    await initAudio();
    if (_tone.context.state !== 'running') await _tone.start();
    const frequency = (0, _tonal.Midi).midiToFreq(midiNote);
    synth.triggerAttackRelease(frequency, duration);
};
const playNoteWithHighlight = async (midiNote, container, noteIndex, duration = null)=>{
    // Stop any current playback
    stopAudio();
    await initAudio();
    if (_tone.context.state !== 'running') await _tone.start();
    const noteDuration = duration || (0, _config.getConfigValue)('audio.tempo.noteDuration', 0.3);
    // Highlight the note
    if (container) highlightNote(container, noteIndex);
    // Play the note
    const frequency = (0, _tonal.Midi).midiToFreq(midiNote);
    synth.triggerAttackRelease(frequency, noteDuration);
    // Remove highlight after note duration
    setTimeout(()=>{
        if (container) unhighlightNote(container, noteIndex);
    }, noteDuration * 1000);
};
const playScale = async (scale, options = {})=>{
    const { scaleId, startingPitch = (0, _config.getConfigValue)('audio.pitch.startingPitch', 60), noteDuration = (0, _config.getConfigValue)('audio.tempo.noteDuration', 0.3), noteGap = (0, _config.getConfigValue)('audio.tempo.noteGap', 0.2), playDescending = false, container, onNoteStart, onNoteEnd, onStop } = options;
    if (isPlaying) return; // Prevent overlapping playback
    await initAudio();
    if (_tone.context.state !== 'running') await _tone.start();
    isPlaying = true;
    if (scaleId) currentlyPlayingScale = scaleId;
    try {
        const midiNotes = scaleToMidiNotes(scale, startingPitch);
        // Play ascending
        for(let i = 0; i < midiNotes.length; i++){
            if (!isPlaying) break; // Allow stopping mid-playback
            // Highlight note start
            if (onNoteStart) onNoteStart(i);
            if (container) highlightNote(container, i);
            const frequency = (0, _tonal.Midi).midiToFreq(midiNotes[i]);
            synth.triggerAttackRelease(frequency, noteDuration);
            // Wait for note duration
            await new Promise((resolve)=>setTimeout(resolve, noteDuration * 1000));
            // Remove highlight
            if (onNoteEnd) onNoteEnd(i);
            if (container) unhighlightNote(container, i);
            // Wait for gap
            if (i < midiNotes.length - 1) await new Promise((resolve)=>setTimeout(resolve, noteGap * 1000));
        }
        // Play descending if requested
        if (playDescending && isPlaying) {
            // Small pause between ascending and descending
            await new Promise((resolve)=>setTimeout(resolve, 200));
            for(let i = midiNotes.length - 2; i >= 0; i--){
                if (!isPlaying) break;
                if (onNoteStart) onNoteStart(i);
                if (container) highlightNote(container, i);
                const frequency = (0, _tonal.Midi).midiToFreq(midiNotes[i]);
                synth.triggerAttackRelease(frequency, noteDuration);
                await new Promise((resolve)=>setTimeout(resolve, noteDuration * 1000));
                if (onNoteEnd) onNoteEnd(i);
                if (container) unhighlightNote(container, i);
                if (i > 0) await new Promise((resolve)=>setTimeout(resolve, noteGap * 1000));
            }
        }
    } finally{
        isPlaying = false;
        if (container) clearAllHighlights(container);
        if (onStop) onStop();
    }
};
const playScaleAsChord = async (scale, options = {})=>{
    const { startingPitch = 60, duration = 2 } = options;
    await initAudio();
    if (_tone.context.state !== 'running') await _tone.start();
    const midiNotes = scaleToMidiNotes(scale, startingPitch);
    const frequencies = midiNotes.map((note)=>(0, _tonal.Midi).midiToFreq(note));
    synth.triggerAttackRelease(frequencies, duration);
};
const stopAudio = ()=>{
    if (synth) synth.releaseAll();
    isPlaying = false;
    currentlyPlayingScale = null;
};
const getIsPlaying = ()=>isPlaying;
const setCurrentlyPlayingScale = (scaleId)=>{
    currentlyPlayingScale = scaleId;
};
const getCurrentlyPlayingScale = ()=>currentlyPlayingScale;
const DEBUG = false; // Set to true for audio/highlight debugging
const highlightNote = (container, noteIndex)=>{
    if (!container) return;
    const svg = container.querySelector('svg');
    if (!svg) return;
    const staveNotes = svg.querySelectorAll('.vf-stavenote');
    if (staveNotes[noteIndex]) {
        staveNotes[noteIndex].classList.add('note-highlight-container');
        // Add glow-only class if specified in config
        if ((0, _config.getConfigValue)('visual.animation.useGlowOnly', true)) staveNotes[noteIndex].classList.add('glow-only');
    }
};
const unhighlightNote = (container, noteIndex)=>{
    if (!container) return;
    const svg = container.querySelector('svg');
    if (!svg) return;
    const staveNotes = svg.querySelectorAll('.vf-stavenote');
    if (staveNotes[noteIndex]) {
        staveNotes[noteIndex].classList.remove('note-highlight-container');
        staveNotes[noteIndex].classList.remove('glow-only');
    }
};
const clearAllHighlights = (container)=>{
    if (!container) return;
    const svg = container.querySelector('svg');
    if (!svg) return;
    const highlightedContainers = svg.querySelectorAll('.note-highlight-container');
    highlightedContainers.forEach((element)=>{
        element.classList.remove('note-highlight-container');
    });
};
const getMidiNoteName = (midiNote)=>{
    return (0, _tonal.Midi).midiToNoteName(midiNote);
};

},{"tone":"lpQdC","tonal":"b7q1y","./config":"5TiHK","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"lpQdC":[function(require,module,exports,__globalThis) {
/*! For license information please see Tone.js.LICENSE.txt */ !function(t1, e) {
    module.exports = e();
}("undefined" != typeof self ? self : this, ()=>(()=>{
        var t1 = {
            382: function(t1, e, s1) {
                !function(t1, e, s1, n) {
                    "use strict";
                    var i = function(t1, e, s1) {
                        return {
                            endTime: e,
                            insertTime: s1,
                            type: "exponentialRampToValue",
                            value: t1
                        };
                    }, o = function(t1, e, s1) {
                        return {
                            endTime: e,
                            insertTime: s1,
                            type: "linearRampToValue",
                            value: t1
                        };
                    }, r = function(t1, e) {
                        return {
                            startTime: e,
                            type: "setValue",
                            value: t1
                        };
                    }, a = function(t1, e, s1) {
                        return {
                            duration: s1,
                            startTime: e,
                            type: "setValueCurve",
                            values: t1
                        };
                    }, c = function(t1, e, s1) {
                        var n = s1.startTime, i = s1.target, o = s1.timeConstant;
                        return i + (e - i) * Math.exp((n - t1) / o);
                    }, h = function(t1) {
                        return "exponentialRampToValue" === t1.type;
                    }, l = function(t1) {
                        return "linearRampToValue" === t1.type;
                    }, u = function(t1) {
                        return h(t1) || l(t1);
                    }, p = function(t1) {
                        return "setValue" === t1.type;
                    }, d = function(t1) {
                        return "setValueCurve" === t1.type;
                    }, f = function t1(e, s1, n, i) {
                        var o = e[s1];
                        return void 0 === o ? i : u(o) || p(o) ? o.value : d(o) ? o.values[o.values.length - 1] : c(n, t1(e, s1 - 1, o.startTime, i), o);
                    }, _ = function(t1, e, s1, n, i) {
                        return void 0 === s1 ? [
                            n.insertTime,
                            i
                        ] : u(s1) ? [
                            s1.endTime,
                            s1.value
                        ] : p(s1) ? [
                            s1.startTime,
                            s1.value
                        ] : d(s1) ? [
                            s1.startTime + s1.duration,
                            s1.values[s1.values.length - 1]
                        ] : [
                            s1.startTime,
                            f(t1, e - 1, s1.startTime, i)
                        ];
                    }, m = function(t1) {
                        return "cancelAndHold" === t1.type;
                    }, g = function(t1) {
                        return "cancelScheduledValues" === t1.type;
                    }, v = function(t1) {
                        return m(t1) || g(t1) ? t1.cancelTime : h(t1) || l(t1) ? t1.endTime : t1.startTime;
                    }, y = function(t1, e, s1, n) {
                        var i = n.endTime, o = n.value;
                        return s1 === o ? o : 0 < s1 && 0 < o || s1 < 0 && o < 0 ? s1 * Math.pow(o / s1, (t1 - e) / (i - e)) : 0;
                    }, x = function(t1, e, s1, n) {
                        return s1 + (t1 - e) / (n.endTime - e) * (n.value - s1);
                    }, w = function(t1, e) {
                        var s1 = e.duration, n = e.startTime, i = e.values;
                        return function(t1, e) {
                            var s1 = Math.floor(e), n = Math.ceil(e);
                            return s1 === n ? t1[s1] : (1 - (e - s1)) * t1[s1] + (1 - (n - e)) * t1[n];
                        }(i, (t1 - n) / s1 * (i.length - 1));
                    }, b = function(t1) {
                        return "setTarget" === t1.type;
                    }, T = function() {
                        return n(function t1(e) {
                            s1(this, t1), this._automationEvents = [], this._currenTime = 0, this._defaultValue = e;
                        }, [
                            {
                                key: Symbol.iterator,
                                value: function() {
                                    return this._automationEvents[Symbol.iterator]();
                                }
                            },
                            {
                                key: "add",
                                value: function(t1) {
                                    var e = v(t1);
                                    if (m(t1) || g(t1)) {
                                        var s1 = this._automationEvents.findIndex(function(s1) {
                                            return g(t1) && d(s1) ? s1.startTime + s1.duration >= e : v(s1) >= e;
                                        }), n = this._automationEvents[s1];
                                        if (-1 !== s1 && (this._automationEvents = this._automationEvents.slice(0, s1)), m(t1)) {
                                            var c = this._automationEvents[this._automationEvents.length - 1];
                                            if (void 0 !== n && u(n)) {
                                                if (void 0 !== c && b(c)) throw new Error("The internal list is malformed.");
                                                var p = void 0 === c ? n.insertTime : d(c) ? c.startTime + c.duration : v(c), f = void 0 === c ? this._defaultValue : d(c) ? c.values[c.values.length - 1] : c.value, _ = h(n) ? y(e, p, f, n) : x(e, p, f, n), w = h(n) ? i(_, e, this._currenTime) : o(_, e, this._currenTime);
                                                this._automationEvents.push(w);
                                            }
                                            if (void 0 !== c && b(c) && this._automationEvents.push(r(this.getValue(e), e)), void 0 !== c && d(c) && c.startTime + c.duration > e) {
                                                var T = e - c.startTime, S = (c.values.length - 1) / c.duration, k = Math.max(2, 1 + Math.ceil(T * S)), A = T / (k - 1) * S, C = c.values.slice(0, k);
                                                if (A < 1) for(var D = 1; D < k; D += 1){
                                                    var O = A * D % 1;
                                                    C[D] = c.values[D - 1] * (1 - O) + c.values[D] * O;
                                                }
                                                this._automationEvents[this._automationEvents.length - 1] = a(C, c.startTime, T);
                                            }
                                        }
                                    } else {
                                        var M = this._automationEvents.findIndex(function(t1) {
                                            return v(t1) > e;
                                        }), E = -1 === M ? this._automationEvents[this._automationEvents.length - 1] : this._automationEvents[M - 1];
                                        if (void 0 !== E && d(E) && v(E) + E.duration > e) return !1;
                                        var R = h(t1) ? i(t1.value, t1.endTime, this._currenTime) : l(t1) ? o(t1.value, e, this._currenTime) : t1;
                                        if (-1 === M) this._automationEvents.push(R);
                                        else {
                                            if (d(t1) && e + t1.duration > v(this._automationEvents[M])) return !1;
                                            this._automationEvents.splice(M, 0, R);
                                        }
                                    }
                                    return !0;
                                }
                            },
                            {
                                key: "flush",
                                value: function(t1) {
                                    var e = this._automationEvents.findIndex(function(e) {
                                        return v(e) > t1;
                                    });
                                    if (e > 1) {
                                        var s1 = this._automationEvents.slice(e - 1), n = s1[0];
                                        b(n) && s1.unshift(r(f(this._automationEvents, e - 2, n.startTime, this._defaultValue), n.startTime)), this._automationEvents = s1;
                                    }
                                }
                            },
                            {
                                key: "getValue",
                                value: function(t1) {
                                    if (0 === this._automationEvents.length) return this._defaultValue;
                                    var s1 = this._automationEvents.findIndex(function(e) {
                                        return v(e) > t1;
                                    }), n = this._automationEvents[s1], i = (-1 === s1 ? this._automationEvents.length : s1) - 1, o = this._automationEvents[i];
                                    if (void 0 !== o && b(o) && (void 0 === n || !u(n) || n.insertTime > t1)) return c(t1, f(this._automationEvents, i - 1, o.startTime, this._defaultValue), o);
                                    if (void 0 !== o && p(o) && (void 0 === n || !u(n))) return o.value;
                                    if (void 0 !== o && d(o) && (void 0 === n || !u(n) || o.startTime + o.duration > t1)) return t1 < o.startTime + o.duration ? w(t1, o) : o.values[o.values.length - 1];
                                    if (void 0 !== o && u(o) && (void 0 === n || !u(n))) return o.value;
                                    if (void 0 !== n && h(n)) {
                                        var r = _(this._automationEvents, i, o, n, this._defaultValue), a = e(r, 2), m = a[0], g = a[1];
                                        return y(t1, m, g, n);
                                    }
                                    if (void 0 !== n && l(n)) {
                                        var T = _(this._automationEvents, i, o, n, this._defaultValue), S = e(T, 2), k = S[0], A = S[1];
                                        return x(t1, k, A, n);
                                    }
                                    return this._defaultValue;
                                }
                            }
                        ]);
                    }();
                    t1.AutomationEventList = T, t1.createCancelAndHoldAutomationEvent = function(t1) {
                        return {
                            cancelTime: t1,
                            type: "cancelAndHold"
                        };
                    }, t1.createCancelScheduledValuesAutomationEvent = function(t1) {
                        return {
                            cancelTime: t1,
                            type: "cancelScheduledValues"
                        };
                    }, t1.createExponentialRampToValueAutomationEvent = function(t1, e) {
                        return {
                            endTime: e,
                            type: "exponentialRampToValue",
                            value: t1
                        };
                    }, t1.createLinearRampToValueAutomationEvent = function(t1, e) {
                        return {
                            endTime: e,
                            type: "linearRampToValue",
                            value: t1
                        };
                    }, t1.createSetTargetAutomationEvent = function(t1, e, s1) {
                        return {
                            startTime: e,
                            target: t1,
                            timeConstant: s1,
                            type: "setTarget"
                        };
                    }, t1.createSetValueAutomationEvent = r, t1.createSetValueCurveAutomationEvent = a;
                }(e, s1(424), s1(690), s1(728));
            },
            897: (t1)=>{
                t1.exports = function(t1, e) {
                    (null == e || e > t1.length) && (e = t1.length);
                    for(var s1 = 0, n = new Array(e); s1 < e; s1++)n[s1] = t1[s1];
                    return n;
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            372: (t1)=>{
                t1.exports = function(t1) {
                    if (Array.isArray(t1)) return t1;
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            690: (t1)=>{
                t1.exports = function(t1, e) {
                    if (!(t1 instanceof e)) throw new TypeError("Cannot call a class as a function");
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            728: (t1, e, s1)=>{
                var n = s1(62);
                function i(t1, e) {
                    for(var s1 = 0; s1 < e.length; s1++){
                        var i = e[s1];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t1, n(i.key), i);
                    }
                }
                t1.exports = function(t1, e, s1) {
                    return e && i(t1.prototype, e), s1 && i(t1, s1), Object.defineProperty(t1, "prototype", {
                        writable: !1
                    }), t1;
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            872: (t1)=>{
                t1.exports = function(t1, e) {
                    var s1 = null == t1 ? null : "undefined" != typeof Symbol && t1[Symbol.iterator] || t1["@@iterator"];
                    if (null != s1) {
                        var n, i, o, r, a = [], c = !0, h = !1;
                        try {
                            if (o = (s1 = s1.call(t1)).next, 0 === e) {
                                if (Object(s1) !== s1) return;
                                c = !1;
                            } else for(; !(c = (n = o.call(s1)).done) && (a.push(n.value), a.length !== e); c = !0);
                        } catch (t1) {
                            h = !0, i = t1;
                        } finally{
                            try {
                                if (!c && null != s1.return && (r = s1.return(), Object(r) !== r)) return;
                            } finally{
                                if (h) throw i;
                            }
                        }
                        return a;
                    }
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            218: (t1)=>{
                t1.exports = function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            424: (t1, e, s1)=>{
                var n = s1(372), i = s1(872), o = s1(116), r = s1(218);
                t1.exports = function(t1, e) {
                    return n(t1) || i(t1, e) || o(t1, e) || r();
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            36: (t1, e, s1)=>{
                var n = s1(698).default;
                t1.exports = function(t1, e) {
                    if ("object" != n(t1) || !t1) return t1;
                    var s1 = t1[Symbol.toPrimitive];
                    if (void 0 !== s1) {
                        var i = s1.call(t1, e || "default");
                        if ("object" != n(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === e ? String : Number)(t1);
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            62: (t1, e, s1)=>{
                var n = s1(698).default, i = s1(36);
                t1.exports = function(t1) {
                    var e = i(t1, "string");
                    return "symbol" == n(e) ? e : e + "";
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            698: (t1)=>{
                function e(s1) {
                    return t1.exports = e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t1) {
                        return typeof t1;
                    } : function(t1) {
                        return t1 && "function" == typeof Symbol && t1.constructor === Symbol && t1 !== Symbol.prototype ? "symbol" : typeof t1;
                    }, t1.exports.__esModule = !0, t1.exports.default = t1.exports, e(s1);
                }
                t1.exports = e, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            },
            116: (t1, e, s1)=>{
                var n = s1(897);
                t1.exports = function(t1, e) {
                    if (t1) {
                        if ("string" == typeof t1) return n(t1, e);
                        var s1 = Object.prototype.toString.call(t1).slice(8, -1);
                        return "Object" === s1 && t1.constructor && (s1 = t1.constructor.name), "Map" === s1 || "Set" === s1 ? Array.from(t1) : "Arguments" === s1 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s1) ? n(t1, e) : void 0;
                    }
                }, t1.exports.__esModule = !0, t1.exports.default = t1.exports;
            }
        }, e = {};
        function s1(n) {
            var i = e[n];
            if (void 0 !== i) return i.exports;
            var o = e[n] = {
                exports: {}
            };
            return t1[n].call(o.exports, o, o.exports, s1), o.exports;
        }
        s1.d = (t1, e)=>{
            for(var n in e)s1.o(e, n) && !s1.o(t1, n) && Object.defineProperty(t1, n, {
                enumerable: !0,
                get: e[n]
            });
        }, s1.o = (t1, e)=>Object.prototype.hasOwnProperty.call(t1, e), s1.r = (t1)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t1, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            "use strict";
            s1.r(n), s1.d(n, {
                AMOscillator: ()=>$o,
                AMSynth: ()=>Cr,
                Abs: ()=>pr,
                Add: ()=>nr,
                AmplitudeEnvelope: ()=>Sr,
                Analyser: ()=>Xa,
                AudioToGain: ()=>Xo,
                AutoFilter: ()=>ua,
                AutoPanner: ()=>da,
                AutoWah: ()=>_a,
                BaseContext: ()=>Ci,
                BiquadFilter: ()=>Dr,
                BitCrusher: ()=>ga,
                Buffer: ()=>Dc,
                BufferSource: ()=>Mc,
                Buffers: ()=>Oc,
                Channel: ()=>sc,
                Chebyshev: ()=>ya,
                Chorus: ()=>Sa,
                Clock: ()=>vo,
                Compressor: ()=>cc,
                Context: ()=>Di,
                Convolver: ()=>fc,
                CrossFade: ()=>ca,
                DCMeter: ()=>Ja,
                Delay: ()=>yo,
                Destination: ()=>yc,
                Distortion: ()=>ka,
                Draw: ()=>Sc,
                DuoSynth: ()=>Rr,
                EQ3: ()=>dc,
                Emitter: ()=>Ai,
                Envelope: ()=>xr,
                FFT: ()=>Ha,
                FMOscillator: ()=>Ho,
                FMSynth: ()=>qr,
                FatOscillator: ()=>Ko,
                FeedbackCombFilter: ()=>Br,
                FeedbackDelay: ()=>Ca,
                Filter: ()=>Or,
                Follower: ()=>fa,
                Freeverb: ()=>Ra,
                Frequency: ()=>Ji,
                FrequencyClass: ()=>Yi,
                FrequencyEnvelope: ()=>Mr,
                FrequencyShifter: ()=>Oa,
                Gain: ()=>ho,
                GainToAudio: ()=>dr,
                Gate: ()=>hc,
                GrainPlayer: ()=>ur,
                GreaterThan: ()=>gr,
                GreaterThanZero: ()=>mr,
                IntervalTimeline: ()=>Co,
                JCReverb: ()=>Va,
                LFO: ()=>rr,
                Limiter: ()=>lc,
                Listener: ()=>bc,
                Loop: ()=>$r,
                LowpassCombFilter: ()=>Gr,
                Master: ()=>xc,
                MembraneSynth: ()=>Vr,
                Merge: ()=>wa,
                MetalSynth: ()=>Ir,
                Meter: ()=>$a,
                MidSideCompressor: ()=>uc,
                MidSideMerge: ()=>Ba,
                MidSideSplit: ()=>Wa,
                Midi: ()=>To,
                MidiClass: ()=>bo,
                Mono: ()=>nc,
                MonoSynth: ()=>Er,
                MultibandCompressor: ()=>pc,
                MultibandSplit: ()=>ic,
                Multiply: ()=>Yo,
                Negate: ()=>fr,
                Noise: ()=>Lo,
                NoiseSynth: ()=>Nr,
                Offline: ()=>xo,
                OfflineContext: ()=>qi,
                OmniOscillator: ()=>sr,
                OnePoleFilter: ()=>Ur,
                Oscillator: ()=>Zo,
                PWMOscillator: ()=>tr,
                PanVol: ()=>ec,
                Panner: ()=>pa,
                Panner3D: ()=>rc,
                Param: ()=>no,
                Part: ()=>Hr,
                Pattern: ()=>ra,
                Phaser: ()=>La,
                PingPongDelay: ()=>Pa,
                PitchShift: ()=>ja,
                Player: ()=>hr,
                Players: ()=>lr,
                PluckSynth: ()=>Qr,
                PolySynth: ()=>Zr,
                Pow: ()=>Fo,
                PulseOscillator: ()=>Jo,
                Recorder: ()=>ac,
                Reverb: ()=>za,
                Sampler: ()=>Xr,
                Scale: ()=>ir,
                ScaleExp: ()=>vr,
                Sequence: ()=>aa,
                Signal: ()=>po,
                Solo: ()=>tc,
                Split: ()=>xa,
                StateTimeline: ()=>so,
                StereoWidener: ()=>Ga,
                Subtract: ()=>_r,
                SyncedSignal: ()=>yr,
                Synth: ()=>kr,
                Ticks: ()=>ko,
                TicksClass: ()=>So,
                Time: ()=>Xi,
                TimeClass: ()=>Zi,
                Timeline: ()=>wi,
                ToneAudioBuffer: ()=>Ri,
                ToneAudioBuffers: ()=>wo,
                ToneAudioNode: ()=>io,
                ToneBufferSource: ()=>jo,
                ToneEvent: ()=>Yr,
                ToneOscillatorNode: ()=>Qo,
                Transport: ()=>gc,
                TransportTime: ()=>to,
                TransportTimeClass: ()=>Ki,
                Tremolo: ()=>Qa,
                Unit: ()=>e,
                UserMedia: ()=>Uo,
                Vibrato: ()=>Za,
                Volume: ()=>Oo,
                WaveShaper: ()=>qo,
                Waveform: ()=>Ka,
                Zero: ()=>or,
                connect: ()=>ro,
                connectSeries: ()=>oo,
                connectSignal: ()=>fo,
                context: ()=>Ac,
                dbToGain: ()=>ji,
                debug: ()=>t1,
                defaultArg: ()=>pi,
                disconnect: ()=>ao,
                fanIn: ()=>co,
                ftom: ()=>Bi,
                gainToDb: ()=>Li,
                getContext: ()=>Vi,
                getDestination: ()=>wc,
                getDraw: ()=>kc,
                getListener: ()=>Tc,
                getTransport: ()=>vc,
                immediate: ()=>mc,
                intervalToFrequencyRatio: ()=>zi,
                isArray: ()=>Ln,
                isBoolean: ()=>jn,
                isDefined: ()=>In,
                isFunction: ()=>Vn,
                isNote: ()=>Wn,
                isNumber: ()=>Nn,
                isObject: ()=>Pn,
                isString: ()=>zn,
                isUndef: ()=>Fn,
                loaded: ()=>Cc,
                mtof: ()=>Gi,
                now: ()=>_c,
                optionsFromArguments: ()=>ui,
                setContext: ()=>Ni,
                start: ()=>Pi,
                supported: ()=>qn,
                version: ()=>i
            });
            var t1 = {};
            s1.r(t1), s1.d(t1, {
                assert: ()=>Bn,
                assertContextRunning: ()=>Gn,
                assertRange: ()=>Un,
                assertUsedScheduleTime: ()=>Yn,
                enterScheduledCallback: ()=>Xn,
                log: ()=>Jn,
                setLogger: ()=>Hn,
                warn: ()=>Kn
            });
            var e = {};
            s1.r(e);
            const i = "14.9.17";
            var o = s1(382);
            const r = new WeakSet, a = new WeakMap, c = new WeakMap, h = new WeakMap, l = new WeakMap, u = new WeakMap, p = new WeakMap, d = new WeakMap, f = new WeakMap, _ = new WeakMap, m = {
                construct: ()=>m
            }, g = /^import(?:(?:[\s]+[\w]+|(?:[\s]+[\w]+[\s]*,)?[\s]*\{[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?(?:[\s]*,[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?)*[\s]*}|(?:[\s]+[\w]+[\s]*,)?[\s]*\*[\s]+as[\s]+[\w]+)[\s]+from)?(?:[\s]*)("([^"\\]|\\.)+"|'([^'\\]|\\.)+')(?:[\s]*);?/, v = (t1, e)=>{
                const s1 = [];
                let n = t1.replace(/^[\s]+/, ""), i = n.match(g);
                for(; null !== i;){
                    const t1 = i[1].slice(1, -1), o = i[0].replace(/([\s]+)?;?$/, "").replace(t1, new URL(t1, e).toString());
                    s1.push(o), n = n.slice(i[0].length).replace(/^[\s]+/, ""), i = n.match(g);
                }
                return [
                    s1.join(";"),
                    n
                ];
            }, y = (t1)=>{
                if (void 0 !== t1 && !Array.isArray(t1)) throw new TypeError("The parameterDescriptors property of given value for processorCtor is not an array.");
            }, x = (t1)=>{
                if (!((t1)=>{
                    try {
                        new new Proxy(t1, m);
                    } catch  {
                        return !1;
                    }
                    return !0;
                })(t1)) throw new TypeError("The given value for processorCtor should be a constructor.");
                if (null === t1.prototype || "object" != typeof t1.prototype) throw new TypeError("The given value for processorCtor should have a prototype.");
            }, w = (t1, e)=>{
                const s1 = t1.get(e);
                if (void 0 === s1) throw new Error("A value with the given key could not be found.");
                return s1;
            }, b = (t1, e)=>{
                const s1 = Array.from(t1).filter(e);
                if (s1.length > 1) throw Error("More than one element was found.");
                if (0 === s1.length) throw Error("No element was found.");
                const [n] = s1;
                return t1.delete(n), n;
            }, T = (t1, e, s1, n)=>{
                const i = w(t1, e), o = b(i, (t1)=>t1[0] === s1 && t1[1] === n);
                return 0 === i.size && t1.delete(e), o;
            }, S = (t1)=>w(p, t1), k = (t1)=>{
                if (r.has(t1)) throw new Error("The AudioNode is already stored.");
                r.add(t1), S(t1).forEach((t1)=>t1(!0));
            }, A = (t1)=>"port" in t1, C = (t1)=>{
                if (!r.has(t1)) throw new Error("The AudioNode is not stored.");
                r.delete(t1), S(t1).forEach((t1)=>t1(!1));
            }, D = (t1, e)=>{
                !A(t1) && e.every((t1)=>0 === t1.size) && C(t1);
            }, O = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                fftSize: 2048,
                maxDecibels: -30,
                minDecibels: -100,
                smoothingTimeConstant: .8
            }, M = (t1, e)=>t1.context === e, E = (t1)=>{
                try {
                    t1.copyToChannel(new Float32Array(1), 0, -1);
                } catch  {
                    return !1;
                }
                return !0;
            }, R = ()=>new DOMException("", "IndexSizeError"), q = (t1)=>{
                var e;
                t1.getChannelData = (e = t1.getChannelData, (s1)=>{
                    try {
                        return e.call(t1, s1);
                    } catch (t1) {
                        if (12 === t1.code) throw R();
                        throw t1;
                    }
                });
            }, F = {
                numberOfChannels: 1
            }, I = -340282346638528860000000000000000000000, V = -I, N = (t1)=>r.has(t1), P = {
                buffer: null,
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                loop: !1,
                loopEnd: 0,
                loopStart: 0,
                playbackRate: 1
            }, j = (t1)=>w(a, t1), L = (t1)=>w(h, t1), z = (t1, e)=>{
                const { activeInputs: s1 } = j(t1);
                s1.forEach((s1)=>s1.forEach(([s1])=>{
                        e.includes(t1) || z(s1, [
                            ...e,
                            t1
                        ]);
                    }));
                const n = ((t1)=>"playbackRate" in t1)(t1) ? [
                    t1.playbackRate
                ] : A(t1) ? Array.from(t1.parameters.values()) : ((t1)=>"frequency" in t1 && "gain" in t1)(t1) ? [
                    t1.Q,
                    t1.detune,
                    t1.frequency,
                    t1.gain
                ] : ((t1)=>"offset" in t1)(t1) ? [
                    t1.offset
                ] : ((t1)=>!("frequency" in t1) && "gain" in t1)(t1) ? [
                    t1.gain
                ] : ((t1)=>"detune" in t1 && "frequency" in t1)(t1) ? [
                    t1.detune,
                    t1.frequency
                ] : ((t1)=>"pan" in t1)(t1) ? [
                    t1.pan
                ] : [];
                for (const t1 of n){
                    const s1 = L(t1);
                    void 0 !== s1 && s1.activeInputs.forEach(([t1])=>z(t1, e));
                }
                N(t1) && C(t1);
            }, W = (t1)=>{
                z(t1.destination, []);
            }, B = (t1)=>"context" in t1, U = (t1)=>B(t1[0]), G = (t1, e, s1, n)=>{
                for (const e of t1)if (s1(e)) {
                    if (n) return !1;
                    throw Error("The set contains at least one similar element.");
                }
                return t1.add(e), !0;
            }, Q = (t1, e, [s1, n], i)=>{
                G(t1, [
                    e,
                    s1,
                    n
                ], (t1)=>t1[0] === e && t1[1] === s1, i);
            }, Z = (t1, [e, s1, n], i)=>{
                const o = t1.get(e);
                void 0 === o ? t1.set(e, new Set([
                    [
                        s1,
                        n
                    ]
                ])) : G(o, [
                    s1,
                    n
                ], (t1)=>t1[0] === s1, i);
            }, X = (t1)=>"inputs" in t1, Y = (t1, e, s1, n)=>{
                if (X(e)) {
                    const i = e.inputs[n];
                    return t1.connect(i, s1, 0), [
                        i,
                        s1,
                        0
                    ];
                }
                return t1.connect(e, s1, n), [
                    e,
                    s1,
                    n
                ];
            }, $ = (t1, e, s1)=>{
                for (const n of t1)if (n[0] === e && n[1] === s1) return t1.delete(n), n;
                return null;
            }, H = (t1, e)=>{
                if (!S(t1).delete(e)) throw new Error("Missing the expected event listener.");
            }, J = (t1, e, s1)=>{
                const n = w(t1, e), i = b(n, (t1)=>t1[0] === s1);
                return 0 === n.size && t1.delete(e), i;
            }, K = (t1, e, s1, n)=>{
                X(e) ? t1.disconnect(e.inputs[n], s1, 0) : t1.disconnect(e, s1, n);
            }, tt = (t1)=>w(c, t1), et = (t1)=>w(l, t1), st = (t1)=>d.has(t1), nt = (t1)=>!r.has(t1), it = (t1, e)=>new Promise((s1)=>{
                    if (null !== e) s1(!0);
                    else {
                        const e = t1.createScriptProcessor(256, 1, 1), n = t1.createGain(), i = t1.createBuffer(1, 2, 44100), o = i.getChannelData(0);
                        o[0] = 1, o[1] = 1;
                        const r = t1.createBufferSource();
                        r.buffer = i, r.loop = !0, r.connect(e).connect(t1.destination), r.connect(n), r.disconnect(n), e.onaudioprocess = (n)=>{
                            const i = n.inputBuffer.getChannelData(0);
                            Array.prototype.some.call(i, (t1)=>1 === t1) ? s1(!0) : s1(!1), r.stop(), e.onaudioprocess = null, r.disconnect(e), e.disconnect(t1.destination);
                        }, r.start();
                    }
                }), ot = (t1, e)=>{
                const s1 = new Map;
                for (const e of t1)for (const t1 of e){
                    const e = s1.get(t1);
                    s1.set(t1, void 0 === e ? 1 : e + 1);
                }
                s1.forEach((t1, s1)=>e(s1, t1));
            }, rt = (t1)=>"context" in t1, at = (t1)=>{
                const e = new Map;
                t1.connect = ((t1)=>(s1, n = 0, i = 0)=>{
                        const o = rt(s1) ? t1(s1, n, i) : t1(s1, n), r = e.get(s1);
                        return void 0 === r ? e.set(s1, [
                            {
                                input: i,
                                output: n
                            }
                        ]) : r.every((t1)=>t1.input !== i || t1.output !== n) && r.push({
                            input: i,
                            output: n
                        }), o;
                    })(t1.connect.bind(t1)), t1.disconnect = ((s1)=>(n, i, o)=>{
                        if (s1.apply(t1), void 0 === n) e.clear();
                        else if ("number" == typeof n) for (const [t1, s1] of e){
                            const i = s1.filter((t1)=>t1.output !== n);
                            0 === i.length ? e.delete(t1) : e.set(t1, i);
                        }
                        else if (e.has(n)) {
                            if (void 0 === i) e.delete(n);
                            else {
                                const t1 = e.get(n);
                                if (void 0 !== t1) {
                                    const s1 = t1.filter((t1)=>t1.output !== i && (t1.input !== o || void 0 === o));
                                    0 === s1.length ? e.delete(n) : e.set(n, s1);
                                }
                            }
                        }
                        for (const [s1, n] of e)n.forEach((e)=>{
                            rt(s1) ? t1.connect(s1, e.output, e.input) : t1.connect(s1, e.output);
                        });
                    })(t1.disconnect);
            }, ct = (t1, e, s1, n, i)=>{
                const [o, r] = ((t1, e, s1, n)=>{
                    const { activeInputs: i, passiveInputs: o } = j(e), r = $(i[n], t1, s1);
                    return null === r ? [
                        T(o, t1, s1, n)[2],
                        !1
                    ] : [
                        r[2],
                        !0
                    ];
                })(t1, s1, n, i);
                if (null !== o && (H(t1, o), !r || e || st(t1) || K(tt(t1), tt(s1), n, i)), N(s1)) {
                    const { activeInputs: t1 } = j(s1);
                    D(s1, t1);
                }
            }, ht = (t1, e, s1, n)=>{
                const [i, o] = ((t1, e, s1)=>{
                    const { activeInputs: n, passiveInputs: i } = L(e), o = $(n, t1, s1);
                    return null === o ? [
                        J(i, t1, s1)[1],
                        !1
                    ] : [
                        o[2],
                        !0
                    ];
                })(t1, s1, n);
                null !== i && (H(t1, i), !o || e || st(t1) || tt(t1).disconnect(et(s1), n));
            };
            class lt {
                constructor(t1){
                    this._map = new Map(t1);
                }
                get size() {
                    return this._map.size;
                }
                entries() {
                    return this._map.entries();
                }
                forEach(t1, e = null) {
                    return this._map.forEach((s1, n)=>t1.call(e, s1, n, this));
                }
                get(t1) {
                    return this._map.get(t1);
                }
                has(t1) {
                    return this._map.has(t1);
                }
                keys() {
                    return this._map.keys();
                }
                values() {
                    return this._map.values();
                }
            }
            const ut = {
                channelCount: 2,
                channelCountMode: "explicit",
                channelInterpretation: "speakers",
                numberOfInputs: 1,
                numberOfOutputs: 1,
                parameterData: {},
                processorOptions: {}
            };
            function pt(t1, e, s1, n, i) {
                if ("function" == typeof t1.copyFromChannel) 0 === e[s1].byteLength && (e[s1] = new Float32Array(128)), t1.copyFromChannel(e[s1], n, i);
                else {
                    const o = t1.getChannelData(n);
                    if (0 === e[s1].byteLength) e[s1] = o.slice(i, i + 128);
                    else {
                        const t1 = new Float32Array(o.buffer, i * Float32Array.BYTES_PER_ELEMENT, 128);
                        e[s1].set(t1);
                    }
                }
            }
            const dt = (t1, e, s1, n, i)=>{
                "function" == typeof t1.copyToChannel ? 0 !== e[s1].byteLength && t1.copyToChannel(e[s1], n, i) : 0 !== e[s1].byteLength && t1.getChannelData(n).set(e[s1], i);
            }, ft = (t1, e)=>{
                const s1 = [];
                for(let n = 0; n < t1; n += 1){
                    const t1 = [], i = "number" == typeof e ? e : e[n];
                    for(let e = 0; e < i; e += 1)t1.push(new Float32Array(128));
                    s1.push(t1);
                }
                return s1;
            }, _t = async (t1, e, s1, n, i, o, r)=>{
                const a = null === e ? 128 * Math.ceil(t1.context.length / 128) : e.length, c = n.channelCount * n.numberOfInputs, h = i.reduce((t1, e)=>t1 + e, 0), l = 0 === h ? null : s1.createBuffer(h, a, s1.sampleRate);
                if (void 0 === o) throw new Error("Missing the processor constructor.");
                const u = j(t1), p = await ((t1, e)=>{
                    const s1 = w(_, t1), n = tt(e);
                    return w(s1, n);
                })(s1, t1), d = ft(n.numberOfInputs, n.channelCount), f = ft(n.numberOfOutputs, i), m = Array.from(t1.parameters.keys()).reduce((t1, e)=>({
                        ...t1,
                        [e]: new Float32Array(128)
                    }), {});
                for(let h = 0; h < a; h += 128){
                    if (n.numberOfInputs > 0 && null !== e) for(let t1 = 0; t1 < n.numberOfInputs; t1 += 1)for(let s1 = 0; s1 < n.channelCount; s1 += 1)pt(e, d[t1], s1, s1, h);
                    void 0 !== o.parameterDescriptors && null !== e && o.parameterDescriptors.forEach(({ name: t1 }, s1)=>{
                        pt(e, m, t1, c + s1, h);
                    });
                    for(let t1 = 0; t1 < n.numberOfInputs; t1 += 1)for(let e = 0; e < i[t1]; e += 1)0 === f[t1][e].byteLength && (f[t1][e] = new Float32Array(128));
                    try {
                        const t1 = d.map((t1, e)=>0 === u.activeInputs[e].size ? [] : t1), e = r(h / s1.sampleRate, s1.sampleRate, ()=>p.process(t1, f, m));
                        if (null !== l) for(let t1 = 0, e = 0; t1 < n.numberOfOutputs; t1 += 1){
                            for(let s1 = 0; s1 < i[t1]; s1 += 1)dt(l, f[t1], s1, e + s1, h);
                            e += i[t1];
                        }
                        if (!e) break;
                    } catch (e) {
                        t1.dispatchEvent(new ErrorEvent("processorerror", {
                            colno: e.colno,
                            filename: e.filename,
                            lineno: e.lineno,
                            message: e.message
                        }));
                        break;
                    }
                }
                return l;
            }, mt = {
                Q: 1,
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                detune: 0,
                frequency: 350,
                gain: 0,
                type: "lowpass"
            }, gt = {
                channelCount: 1,
                channelCountMode: "explicit",
                channelInterpretation: "speakers",
                numberOfInputs: 6
            }, vt = {
                channelCount: 6,
                channelCountMode: "explicit",
                channelInterpretation: "discrete",
                numberOfOutputs: 6
            }, yt = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                offset: 1
            }, xt = {
                buffer: null,
                channelCount: 2,
                channelCountMode: "clamped-max",
                channelInterpretation: "speakers",
                disableNormalization: !1
            }, wt = (t1)=>{
                const { port1: e, port2: s1 } = new MessageChannel;
                return new Promise((n)=>{
                    const i = ()=>{
                        s1.onmessage = null, e.close(), s1.close(), n();
                    };
                    s1.onmessage = ()=>i();
                    try {
                        e.postMessage(t1, [
                            t1
                        ]);
                    } catch  {} finally{
                        i();
                    }
                });
            }, bt = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                delayTime: 0,
                maxDelayTime: 1
            }, Tt = (t1, e, s1)=>{
                const n = e[s1];
                if (void 0 === n) throw t1();
                return n;
            }, St = {
                attack: .003,
                channelCount: 2,
                channelCountMode: "clamped-max",
                channelInterpretation: "speakers",
                knee: 30,
                ratio: 12,
                release: .25,
                threshold: -24
            }, kt = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                gain: 1
            }, At = ()=>new DOMException("", "InvalidStateError"), Ct = ()=>new DOMException("", "InvalidAccessError"), Dt = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers"
            }, Ot = (t1, e, s1, n, i, o, r, a, c, h, l)=>{
                const u = h.length;
                let p = a;
                for(let a = 0; a < u; a += 1){
                    let u = s1[0] * h[a];
                    for(let e = 1; e < i; e += 1){
                        const n = p - e & c - 1;
                        u += s1[e] * o[n], u -= t1[e] * r[n];
                    }
                    for(let t1 = i; t1 < n; t1 += 1)u += s1[t1] * o[p - t1 & c - 1];
                    for(let s1 = i; s1 < e; s1 += 1)u -= t1[s1] * r[p - s1 & c - 1];
                    o[p] = h[a], r[p] = u, p = p + 1 & c - 1, l[a] = u;
                }
                return p;
            }, Mt = {
                channelCount: 2,
                channelCountMode: "explicit",
                channelInterpretation: "speakers"
            }, Et = (t1)=>{
                const e = new Uint32Array([
                    1179011410,
                    40,
                    1163280727,
                    544501094,
                    16,
                    131073,
                    44100,
                    176400,
                    1048580,
                    1635017060,
                    4,
                    0
                ]);
                try {
                    const s1 = t1.decodeAudioData(e.buffer, ()=>{});
                    return void 0 !== s1 && (s1.catch(()=>{}), !0);
                } catch  {}
                return !1;
            }, Rt = (t1, e, s1)=>{
                const n = e[s1];
                void 0 !== n && n !== t1[s1] && (t1[s1] = n);
            }, qt = (t1, e)=>{
                Rt(t1, e, "channelCount"), Rt(t1, e, "channelCountMode"), Rt(t1, e, "channelInterpretation");
            }, Ft = (t1)=>"function" == typeof t1.getFloatTimeDomainData, It = (t1, e, s1)=>{
                const n = e[s1];
                void 0 !== n && n !== t1[s1].value && (t1[s1].value = n);
            }, Vt = (t1)=>{
                t1.start = ((e)=>(s1 = 0, n = 0, i)=>{
                        if ("number" == typeof i && i < 0 || n < 0 || s1 < 0) throw new RangeError("The parameters can't be negative.");
                        e.call(t1, s1, n, i);
                    })(t1.start);
            }, Nt = (t1)=>{
                var e;
                t1.stop = (e = t1.stop, (s1 = 0)=>{
                    if (s1 < 0) throw new RangeError("The parameter can't be negative.");
                    e.call(t1, s1);
                });
            }, Pt = (t1, e)=>null === t1 ? 512 : Math.max(512, Math.min(16384, Math.pow(2, Math.round(Math.log2(t1 * e))))), jt = (t1, e)=>{
                const s1 = t1.createBiquadFilter();
                return qt(s1, e), It(s1, e, "Q"), It(s1, e, "detune"), It(s1, e, "frequency"), It(s1, e, "gain"), Rt(s1, e, "type"), s1;
            }, Lt = (t1, e)=>{
                const s1 = t1.createChannelSplitter(e.numberOfOutputs);
                return qt(s1, e), ((t1)=>{
                    const e = t1.numberOfOutputs;
                    Object.defineProperty(t1, "channelCount", {
                        get: ()=>e,
                        set: (t1)=>{
                            if (t1 !== e) throw At();
                        }
                    }), Object.defineProperty(t1, "channelCountMode", {
                        get: ()=>"explicit",
                        set: (t1)=>{
                            if ("explicit" !== t1) throw At();
                        }
                    }), Object.defineProperty(t1, "channelInterpretation", {
                        get: ()=>"discrete",
                        set: (t1)=>{
                            if ("discrete" !== t1) throw At();
                        }
                    });
                })(s1), s1;
            }, zt = (t1, e)=>(t1.connect = e.connect.bind(e), t1.disconnect = e.disconnect.bind(e), t1), Wt = (t1, e)=>{
                const s1 = t1.createDelay(e.maxDelayTime);
                return qt(s1, e), It(s1, e, "delayTime"), s1;
            }, Bt = (t1, e)=>{
                const s1 = t1.createGain();
                return qt(s1, e), It(s1, e, "gain"), s1;
            };
            function Ut(t1, e) {
                const s1 = e[0] * e[0] + e[1] * e[1];
                return [
                    (t1[0] * e[0] + t1[1] * e[1]) / s1,
                    (t1[1] * e[0] - t1[0] * e[1]) / s1
                ];
            }
            function Gt(t1, e) {
                let s1 = [
                    0,
                    0
                ];
                for(let o = t1.length - 1; o >= 0; o -= 1)i = e, s1 = [
                    (n = s1)[0] * i[0] - n[1] * i[1],
                    n[0] * i[1] + n[1] * i[0]
                ], s1[0] += t1[o];
                var n, i;
                return s1;
            }
            const Qt = (t1, e, s1, n)=>t1.createScriptProcessor(e, s1, n), Zt = ()=>new DOMException("", "NotSupportedError"), Xt = {
                numberOfChannels: 1
            }, Yt = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                detune: 0,
                frequency: 440,
                periodicWave: void 0,
                type: "sine"
            }, $t = {
                channelCount: 2,
                channelCountMode: "clamped-max",
                channelInterpretation: "speakers",
                coneInnerAngle: 360,
                coneOuterAngle: 360,
                coneOuterGain: 0,
                distanceModel: "inverse",
                maxDistance: 1e4,
                orientationX: 1,
                orientationY: 0,
                orientationZ: 0,
                panningModel: "equalpower",
                positionX: 0,
                positionY: 0,
                positionZ: 0,
                refDistance: 1,
                rolloffFactor: 1
            }, Ht = {
                disableNormalization: !1
            }, Jt = {
                channelCount: 2,
                channelCountMode: "explicit",
                channelInterpretation: "speakers",
                pan: 0
            }, Kt = ()=>new DOMException("", "UnknownError"), te = {
                channelCount: 2,
                channelCountMode: "max",
                channelInterpretation: "speakers",
                curve: null,
                oversample: "none"
            }, ee = (t1, e, s1)=>void 0 === t1.copyFromChannel ? t1.getChannelData(s1)[0] : (t1.copyFromChannel(e, s1), e[0]), se = (t1)=>{
                if (null === t1) return !1;
                const e = t1.length;
                return e % 2 != 0 ? 0 !== t1[Math.floor(e / 2)] : t1[e / 2 - 1] + t1[e / 2] !== 0;
            }, ne = (t1, e, s1, n)=>{
                let i = t1;
                for(; !i.hasOwnProperty(e);)i = Object.getPrototypeOf(i);
                const { get: o, set: r } = Object.getOwnPropertyDescriptor(i, e);
                Object.defineProperty(t1, e, {
                    get: s1(o),
                    set: n(r)
                });
            }, ie = (t1, e, s1)=>{
                try {
                    t1.setValueAtTime(e, s1);
                } catch (n) {
                    if (9 !== n.code) throw n;
                    ie(t1, e, s1 + 1e-7);
                }
            }, oe = (t1)=>{
                const e = t1.createOscillator();
                try {
                    e.start(-1);
                } catch (t1) {
                    return t1 instanceof RangeError;
                }
                return !1;
            }, re = (t1)=>{
                const e = t1.createBuffer(1, 1, 44100), s1 = t1.createBufferSource();
                s1.buffer = e, s1.start(), s1.stop();
                try {
                    return s1.stop(), !0;
                } catch  {
                    return !1;
                }
            }, ae = (t1)=>{
                const e = t1.createOscillator();
                try {
                    e.stop(-1);
                } catch (t1) {
                    return t1 instanceof RangeError;
                }
                return !1;
            }, ce = ()=>{
                try {
                    new DOMException;
                } catch  {
                    return !1;
                }
                return !0;
            }, he = ()=>new Promise((t1)=>{
                    const e = new ArrayBuffer(0), { port1: s1, port2: n } = new MessageChannel;
                    s1.onmessage = ({ data: e })=>t1(null !== e), n.postMessage(e, [
                        e
                    ]);
                }), le = (t1, e)=>{
                const s1 = e.createGain();
                t1.connect(s1);
                const n = ((e)=>()=>{
                        e.call(t1, s1), t1.removeEventListener("ended", n);
                    })(t1.disconnect);
                t1.addEventListener("ended", n), zt(t1, s1), t1.stop = ((e)=>{
                    let n = !1;
                    return (i = 0)=>{
                        if (n) try {
                            e.call(t1, i);
                        } catch  {
                            s1.gain.setValueAtTime(0, i);
                        }
                        else e.call(t1, i), n = !0;
                    };
                })(t1.stop);
            }, ue = (t1, e)=>(s1)=>{
                    const n = {
                        value: t1
                    };
                    return Object.defineProperties(s1, {
                        currentTarget: n,
                        target: n
                    }), "function" == typeof e ? e.call(t1, s1) : e.handleEvent.call(t1, s1);
                }, pe = ((t1)=>(e, s1, [n, i, o], r)=>{
                    t1(e[i], [
                        s1,
                        n,
                        o
                    ], (t1)=>t1[0] === s1 && t1[1] === n, r);
                })(G), de = ((t1)=>(e, s1, [n, i, o], r)=>{
                    const a = e.get(n);
                    void 0 === a ? e.set(n, new Set([
                        [
                            i,
                            s1,
                            o
                        ]
                    ])) : t1(a, [
                        i,
                        s1,
                        o
                    ], (t1)=>t1[0] === i && t1[1] === s1, r);
                })(G), fe = ((t1)=>(e, s1, n, i)=>t1(e[i], (t1)=>t1[0] === s1 && t1[1] === n))(b), _e = new WeakMap, me = ((t1)=>(e)=>{
                    var s1;
                    return null !== (s1 = t1.get(e)) && void 0 !== s1 ? s1 : 0;
                })(_e), ge = (ve = new Map, ye = new WeakMap, (t1, e)=>{
                const s1 = ye.get(t1);
                if (void 0 !== s1) return s1;
                const n = ve.get(t1);
                if (void 0 !== n) return n;
                try {
                    const s1 = e();
                    return s1 instanceof Promise ? (ve.set(t1, s1), s1.catch(()=>!1).then((e)=>(ve.delete(t1), ye.set(t1, e), e))) : (ye.set(t1, s1), s1);
                } catch  {
                    return ye.set(t1, !1), !1;
                }
            });
            var ve, ye;
            const xe = "undefined" == typeof window ? null : window, we = ((t1, e)=>(s1, n)=>{
                    const i = s1.createAnalyser();
                    if (qt(i, n), !(n.maxDecibels > n.minDecibels)) throw e();
                    return Rt(i, n, "fftSize"), Rt(i, n, "maxDecibels"), Rt(i, n, "minDecibels"), Rt(i, n, "smoothingTimeConstant"), t1(Ft, ()=>Ft(i)) || ((t1)=>{
                        t1.getFloatTimeDomainData = (e)=>{
                            const s1 = new Uint8Array(e.length);
                            t1.getByteTimeDomainData(s1);
                            const n = Math.max(s1.length, t1.fftSize);
                            for(let t1 = 0; t1 < n; t1 += 1)e[t1] = .0078125 * (s1[t1] - 128);
                            return e;
                        };
                    })(i), i;
                })(ge, R), be = ((t1)=>(e)=>{
                    const s1 = t1(e);
                    if (null === s1.renderer) throw new Error("Missing the renderer of the given AudioNode in the audio graph.");
                    return s1.renderer;
                })(j), Te = ((t1, e, s1)=>async (n, i, o)=>{
                    const r = t1(n);
                    await Promise.all(r.activeInputs.map((t1, r)=>Array.from(t1).map(async ([t1, a])=>{
                            const c = e(t1), h = await c.render(t1, i), l = n.context.destination;
                            s1(t1) || n === l && s1(n) || h.connect(o, a, r);
                        })).reduce((t1, e)=>[
                            ...t1,
                            ...e
                        ], []));
                })(j, be, st), Se = ((t1, e, s1)=>()=>{
                    const n = new WeakMap;
                    return {
                        render (i, o) {
                            const r = n.get(o);
                            return void 0 !== r ? Promise.resolve(r) : (async (i, o)=>{
                                let r = e(i);
                                if (!M(r, o)) {
                                    const e = {
                                        channelCount: r.channelCount,
                                        channelCountMode: r.channelCountMode,
                                        channelInterpretation: r.channelInterpretation,
                                        fftSize: r.fftSize,
                                        maxDecibels: r.maxDecibels,
                                        minDecibels: r.minDecibels,
                                        smoothingTimeConstant: r.smoothingTimeConstant
                                    };
                                    r = t1(o, e);
                                }
                                return n.set(o, r), await s1(i, o, r), r;
                            })(i, o);
                        }
                    };
                })(we, tt, Te), ke = (Ae = u, (t1)=>{
                const e = Ae.get(t1);
                if (void 0 === e) throw At();
                return e;
            });
            var Ae;
            const Ce = ((t1)=>null === t1 ? null : t1.hasOwnProperty("OfflineAudioContext") ? t1.OfflineAudioContext : t1.hasOwnProperty("webkitOfflineAudioContext") ? t1.webkitOfflineAudioContext : null)(xe), De = ((t1)=>(e)=>null !== t1 && e instanceof t1)(Ce), Oe = new WeakMap, Me = ((t1)=>class {
                    constructor(t1){
                        this._nativeEventTarget = t1, this._listeners = new WeakMap;
                    }
                    addEventListener(e, s1, n) {
                        if (null !== s1) {
                            let i = this._listeners.get(s1);
                            void 0 === i && (i = t1(this, s1), "function" == typeof s1 && this._listeners.set(s1, i)), this._nativeEventTarget.addEventListener(e, i, n);
                        }
                    }
                    dispatchEvent(t1) {
                        return this._nativeEventTarget.dispatchEvent(t1);
                    }
                    removeEventListener(t1, e, s1) {
                        const n = null === e ? void 0 : this._listeners.get(e);
                        this._nativeEventTarget.removeEventListener(t1, void 0 === n ? null : n, s1);
                    }
                })(ue), Ee = ((t1)=>null === t1 ? null : t1.hasOwnProperty("AudioContext") ? t1.AudioContext : t1.hasOwnProperty("webkitAudioContext") ? t1.webkitAudioContext : null)(xe), Re = ((t1)=>(e)=>null !== t1 && e instanceof t1)(Ee), qe = ((t1)=>(e)=>null !== t1 && "function" == typeof t1.AudioNode && e instanceof t1.AudioNode)(xe), Fe = ((t1)=>(e)=>null !== t1 && "function" == typeof t1.AudioParam && e instanceof t1.AudioParam)(xe), Ie = ((t1)=>null === t1 ? null : t1.hasOwnProperty("AudioWorkletNode") ? t1.AudioWorkletNode : null)(xe), Ve = ((t1, e, s1, n, i, o, r, a, h, l, u, d, f, _, m, g)=>class extends l {
                    constructor(e, n, i, o){
                        super(i), this._context = e, this._nativeAudioNode = i;
                        const r = u(e);
                        d(r) && !0 !== s1(it, ()=>it(r, g)) && at(i), c.set(this, i), p.set(this, new Set), "closed" !== e.state && n && k(this), t1(this, o, i);
                    }
                    get channelCount() {
                        return this._nativeAudioNode.channelCount;
                    }
                    set channelCount(t1) {
                        this._nativeAudioNode.channelCount = t1;
                    }
                    get channelCountMode() {
                        return this._nativeAudioNode.channelCountMode;
                    }
                    set channelCountMode(t1) {
                        this._nativeAudioNode.channelCountMode = t1;
                    }
                    get channelInterpretation() {
                        return this._nativeAudioNode.channelInterpretation;
                    }
                    set channelInterpretation(t1) {
                        this._nativeAudioNode.channelInterpretation = t1;
                    }
                    get context() {
                        return this._context;
                    }
                    get numberOfInputs() {
                        return this._nativeAudioNode.numberOfInputs;
                    }
                    get numberOfOutputs() {
                        return this._nativeAudioNode.numberOfOutputs;
                    }
                    connect(t1, s1 = 0, a = 0) {
                        if (s1 < 0 || s1 >= this._nativeAudioNode.numberOfOutputs) throw i();
                        const c = u(this._context), l = m(c);
                        if (f(t1) || _(t1)) throw o();
                        if (B(t1)) {
                            const i = tt(t1);
                            try {
                                const e = Y(this._nativeAudioNode, i, s1, a), n = nt(this);
                                (l || n) && this._nativeAudioNode.disconnect(...e), "closed" !== this.context.state && !n && nt(t1) && k(t1);
                            } catch (t1) {
                                if (12 === t1.code) throw o();
                                throw t1;
                            }
                            if (e(this, t1, s1, a, l)) {
                                const e = h([
                                    this
                                ], t1);
                                ot(e, n(l));
                            }
                            return t1;
                        }
                        const p = et(t1);
                        if ("playbackRate" === p.name && 1024 === p.maxValue) throw r();
                        try {
                            this._nativeAudioNode.connect(p, s1), (l || nt(this)) && this._nativeAudioNode.disconnect(p, s1);
                        } catch (t1) {
                            if (12 === t1.code) throw o();
                            throw t1;
                        }
                        if (((t1, e, s1, n)=>{
                            const { activeInputs: i, passiveInputs: o } = L(e), { outputs: r } = j(t1), a = S(t1), c = (r)=>{
                                const a = tt(t1), c = et(e);
                                if (r) {
                                    const e = J(o, t1, s1);
                                    Q(i, t1, e, !1), n || st(t1) || a.connect(c, s1);
                                } else {
                                    const e = ((t1, e, s1)=>b(t1, (t1)=>t1[0] === e && t1[1] === s1))(i, t1, s1);
                                    Z(o, e, !1), n || st(t1) || a.disconnect(c, s1);
                                }
                            };
                            return !!G(r, [
                                e,
                                s1
                            ], (t1)=>t1[0] === e && t1[1] === s1, !0) && (a.add(c), N(t1) ? Q(i, t1, [
                                s1,
                                c
                            ], !0) : Z(o, [
                                t1,
                                s1,
                                c
                            ], !0), !0);
                        })(this, t1, s1, l)) {
                            const e = h([
                                this
                            ], t1);
                            ot(e, n(l));
                        }
                    }
                    disconnect(t1, e, s1) {
                        let n;
                        const r = u(this._context), c = m(r);
                        if (void 0 === t1) n = ((t1, e)=>{
                            const s1 = j(t1), n = [];
                            for (const i of s1.outputs)U(i) ? ct(t1, e, ...i) : ht(t1, e, ...i), n.push(i[0]);
                            return s1.outputs.clear(), n;
                        })(this, c);
                        else if ("number" == typeof t1) {
                            if (t1 < 0 || t1 >= this.numberOfOutputs) throw i();
                            n = ((t1, e, s1)=>{
                                const n = j(t1), i = [];
                                for (const o of n.outputs)o[1] === s1 && (U(o) ? ct(t1, e, ...o) : ht(t1, e, ...o), i.push(o[0]), n.outputs.delete(o));
                                return i;
                            })(this, c, t1);
                        } else {
                            if (void 0 !== e && (e < 0 || e >= this.numberOfOutputs)) throw i();
                            if (B(t1) && void 0 !== s1 && (s1 < 0 || s1 >= t1.numberOfInputs)) throw i();
                            if (n = ((t1, e, s1, n, i)=>{
                                const o = j(t1);
                                return Array.from(o.outputs).filter((t1)=>!(t1[0] !== s1 || void 0 !== n && t1[1] !== n || void 0 !== i && t1[2] !== i)).map((s1)=>(U(s1) ? ct(t1, e, ...s1) : ht(t1, e, ...s1), o.outputs.delete(s1), s1[0]));
                            })(this, c, t1, e, s1), 0 === n.length) throw o();
                        }
                        for (const t1 of n){
                            const e = h([
                                this
                            ], t1);
                            ot(e, a);
                        }
                    }
                })((Ne = a, (t1, e, s1)=>{
                const n = [];
                for(let t1 = 0; t1 < s1.numberOfInputs; t1 += 1)n.push(new Set);
                Ne.set(t1, {
                    activeInputs: n,
                    outputs: new Set,
                    passiveInputs: new WeakMap,
                    renderer: e
                });
            }), ((t1, e, s1, n, i, o, r, a, c, h, l, u, p)=>{
                const d = new WeakMap;
                return (f, _, m, g, v)=>{
                    const { activeInputs: y, passiveInputs: x } = o(_), { outputs: w } = o(f), b = a(f), S = (o)=>{
                        const a = c(_), h = c(f);
                        if (o) {
                            const e = T(x, f, m, g);
                            t1(y, f, e, !1), v || u(f) || s1(h, a, m, g), p(_) && k(_);
                        } else {
                            const t1 = n(y, f, m, g);
                            e(x, g, t1, !1), v || u(f) || i(h, a, m, g);
                            const s1 = r(_);
                            if (0 === s1) l(_) && D(_, y);
                            else {
                                const t1 = d.get(_);
                                void 0 !== t1 && clearTimeout(t1), d.set(_, setTimeout(()=>{
                                    l(_) && D(_, y);
                                }, 1e3 * s1));
                            }
                        }
                    };
                    return !!h(w, [
                        _,
                        m,
                        g
                    ], (t1)=>t1[0] === _ && t1[1] === m && t1[2] === g, !0) && (b.add(S), l(f) ? t1(y, f, [
                        m,
                        g,
                        S
                    ], !0) : e(x, g, [
                        f,
                        m,
                        S
                    ], !0), !0);
                };
            })(pe, de, Y, fe, K, j, me, S, tt, G, N, st, nt), ge, ((t1, e, s1, n, i, o)=>(r)=>(a, c)=>{
                        const h = t1.get(a);
                        if (void 0 === h) {
                            if (!r && o(a)) {
                                const t1 = n(a), { outputs: o } = s1(a);
                                for (const s1 of o)if (U(s1)) {
                                    const i = n(s1[0]);
                                    e(t1, i, s1[1], s1[2]);
                                } else {
                                    const e = i(s1[0]);
                                    t1.disconnect(e, s1[1]);
                                }
                            }
                            t1.set(a, c);
                        } else t1.set(a, h + c);
                    })(d, K, j, tt, et, N), R, Ct, Zt, ((t1, e, s1, n, i, o, r, a)=>(c, h)=>{
                    const l = e.get(c);
                    if (void 0 === l) throw new Error("Missing the expected cycle count.");
                    const u = o(c.context), p = a(u);
                    if (l === h) {
                        if (e.delete(c), !p && r(c)) {
                            const e = n(c), { outputs: o } = s1(c);
                            for (const s1 of o)if (U(s1)) {
                                const i = n(s1[0]);
                                t1(e, i, s1[1], s1[2]);
                            } else {
                                const t1 = i(s1[0]);
                                e.connect(t1, s1[1]);
                            }
                        }
                    } else e.set(c, l - h);
                })(Y, d, j, tt, et, ke, N, De), ((t1, e, s1)=>function n(i, o) {
                    const r = B(o) ? o : s1(t1, o);
                    if (((t1)=>"delayTime" in t1)(r)) return [];
                    if (i[0] === r) return [
                        i
                    ];
                    if (i.includes(r)) return [];
                    const { outputs: a } = e(r);
                    return Array.from(a).map((t1)=>n([
                            ...i,
                            r
                        ], t1[0])).reduce((t1, e)=>t1.concat(e), []);
                })(Oe, j, w), Me, ke, Re, qe, Fe, De, Ie);
            var Ne;
            const Pe = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, s1){
                        const r = i(t1), a = {
                            ...O,
                            ...s1
                        }, c = n(r, a);
                        super(t1, !1, c, o(r) ? e() : null), this._nativeAnalyserNode = c;
                    }
                    get fftSize() {
                        return this._nativeAnalyserNode.fftSize;
                    }
                    set fftSize(t1) {
                        this._nativeAnalyserNode.fftSize = t1;
                    }
                    get frequencyBinCount() {
                        return this._nativeAnalyserNode.frequencyBinCount;
                    }
                    get maxDecibels() {
                        return this._nativeAnalyserNode.maxDecibels;
                    }
                    set maxDecibels(t1) {
                        const e = this._nativeAnalyserNode.maxDecibels;
                        if (this._nativeAnalyserNode.maxDecibels = t1, !(t1 > this._nativeAnalyserNode.minDecibels)) throw this._nativeAnalyserNode.maxDecibels = e, s1();
                    }
                    get minDecibels() {
                        return this._nativeAnalyserNode.minDecibels;
                    }
                    set minDecibels(t1) {
                        const e = this._nativeAnalyserNode.minDecibels;
                        if (this._nativeAnalyserNode.minDecibels = t1, !(this._nativeAnalyserNode.maxDecibels > t1)) throw this._nativeAnalyserNode.minDecibels = e, s1();
                    }
                    get smoothingTimeConstant() {
                        return this._nativeAnalyserNode.smoothingTimeConstant;
                    }
                    set smoothingTimeConstant(t1) {
                        this._nativeAnalyserNode.smoothingTimeConstant = t1;
                    }
                    getByteFrequencyData(t1) {
                        this._nativeAnalyserNode.getByteFrequencyData(t1);
                    }
                    getByteTimeDomainData(t1) {
                        this._nativeAnalyserNode.getByteTimeDomainData(t1);
                    }
                    getFloatFrequencyData(t1) {
                        this._nativeAnalyserNode.getFloatFrequencyData(t1);
                    }
                    getFloatTimeDomainData(t1) {
                        this._nativeAnalyserNode.getFloatTimeDomainData(t1);
                    }
                })(Ve, Se, R, we, ke, De), je = new WeakSet, Le = ((t1)=>null === t1 ? null : t1.hasOwnProperty("AudioBuffer") ? t1.AudioBuffer : null)(xe), ze = (We = new Uint32Array(1), (t1)=>(We[0] = t1, We[0]));
            var We;
            const Be = ((t1, e)=>(s1)=>{
                    s1.copyFromChannel = (n, i, o = 0)=>{
                        const r = t1(o), a = t1(i);
                        if (a >= s1.numberOfChannels) throw e();
                        const c = s1.length, h = s1.getChannelData(a), l = n.length;
                        for(let t1 = r < 0 ? -r : 0; t1 + r < c && t1 < l; t1 += 1)n[t1] = h[t1 + r];
                    }, s1.copyToChannel = (n, i, o = 0)=>{
                        const r = t1(o), a = t1(i);
                        if (a >= s1.numberOfChannels) throw e();
                        const c = s1.length, h = s1.getChannelData(a), l = n.length;
                        for(let t1 = r < 0 ? -r : 0; t1 + r < c && t1 < l; t1 += 1)h[t1 + r] = n[t1];
                    };
                })(ze, R), Ue = ((t1)=>(e)=>{
                    e.copyFromChannel = ((s1)=>(n, i, o = 0)=>{
                            const r = t1(o), a = t1(i);
                            if (r < e.length) return s1.call(e, n, a, r);
                        })(e.copyFromChannel), e.copyToChannel = ((s1)=>(n, i, o = 0)=>{
                            const r = t1(o), a = t1(i);
                            if (r < e.length) return s1.call(e, n, a, r);
                        })(e.copyToChannel);
                })(ze), Ge = ((t1, e, s1, n, i, o, r, a)=>{
                let c = null;
                return class h {
                    constructor(h){
                        if (null === i) throw new Error("Missing the native OfflineAudioContext constructor.");
                        const { length: l, numberOfChannels: u, sampleRate: p } = {
                            ...F,
                            ...h
                        };
                        null === c && (c = new i(1, 1, 44100));
                        const d = null !== n && e(o, o) ? new n({
                            length: l,
                            numberOfChannels: u,
                            sampleRate: p
                        }) : c.createBuffer(u, l, p);
                        if (0 === d.numberOfChannels) throw s1();
                        return "function" != typeof d.copyFromChannel ? (r(d), q(d)) : e(E, ()=>E(d)) || a(d), t1.add(d), d;
                    }
                    static [Symbol.hasInstance](e) {
                        return null !== e && "object" == typeof e && Object.getPrototypeOf(e) === h.prototype || t1.has(e);
                    }
                };
            })(je, ge, Zt, Le, Ce, ((t1)=>()=>{
                    if (null === t1) return !1;
                    try {
                        new t1({
                            length: 1,
                            sampleRate: 44100
                        });
                    } catch  {
                        return !1;
                    }
                    return !0;
                })(Le), Be, Ue), Qe = ((t1)=>(e, s1)=>{
                    const n = t1(e, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        gain: 0
                    });
                    s1.connect(n).connect(e.destination);
                    const i = ()=>{
                        s1.removeEventListener("ended", i), s1.disconnect(n), n.disconnect();
                    };
                    s1.addEventListener("ended", i);
                })(Bt), Ze = ((t1, e, s1)=>async (n, i, o)=>{
                    const r = e(n);
                    await Promise.all(Array.from(r.activeInputs).map(async ([e, n])=>{
                        const r = t1(e), a = await r.render(e, i);
                        s1(e) || a.connect(o, n);
                    }));
                })(be, L, st), Xe = ((t1)=>(e, s1, n)=>t1(s1, e, n))(Ze), Ye = ((t1, e, s1, n, i, o, r, a, c, h, l)=>(c, u)=>{
                    const p = c.createBufferSource();
                    return qt(p, u), It(p, u, "playbackRate"), Rt(p, u, "buffer"), Rt(p, u, "loop"), Rt(p, u, "loopEnd"), Rt(p, u, "loopStart"), e(s1, ()=>s1(c)) || ((t1)=>{
                        t1.start = ((e)=>{
                            let s1 = !1;
                            return (n = 0, i = 0, o)=>{
                                if (s1) throw At();
                                e.call(t1, n, i, o), s1 = !0;
                            };
                        })(t1.start);
                    })(p), e(n, ()=>n(c)) || ((t1)=>{
                        t1.start = ((e)=>(s1 = 0, n = 0, i)=>{
                                const o = t1.buffer, r = null === o ? n : Math.min(o.duration, n);
                                null !== o && r > o.duration - .5 / t1.context.sampleRate ? e.call(t1, s1, 0, 0) : e.call(t1, s1, r, i);
                            })(t1.start);
                    })(p), e(i, ()=>i(c)) || h(p, c), e(o, ()=>o(c)) || Vt(p), e(r, ()=>r(c)) || l(p, c), e(a, ()=>a(c)) || Nt(p), t1(c, p), p;
                })(Qe, ge, (t1)=>{
                const e = t1.createBufferSource();
                e.start();
                try {
                    e.start();
                } catch  {
                    return !0;
                }
                return !1;
            }, (t1)=>{
                const e = t1.createBufferSource(), s1 = t1.createBuffer(1, 1, 44100);
                e.buffer = s1;
                try {
                    e.start(0, 1);
                } catch  {
                    return !1;
                }
                return !0;
            }, (t1)=>{
                const e = t1.createBufferSource();
                e.start();
                try {
                    e.stop();
                } catch  {
                    return !1;
                }
                return !0;
            }, oe, re, ae, 0, ((t1)=>(e, s1)=>{
                    const n = s1.createBuffer(1, 1, 44100);
                    null === e.buffer && (e.buffer = n), t1(e, "buffer", (t1)=>()=>{
                            const s1 = t1.call(e);
                            return s1 === n ? null : s1;
                        }, (t1)=>(s1)=>t1.call(e, null === s1 ? n : s1));
                })(ne), le), $e = ((t1, e)=>(s1, n, i)=>(t1(n).replay(i), e(n, s1, i)))(((t1)=>(e)=>{
                    const s1 = t1(e);
                    if (null === s1.renderer) throw new Error("Missing the renderer of the given AudioParam in the audio graph.");
                    return s1.renderer;
                })(L), Ze), He = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    let r = null, a = null;
                    return {
                        set start (t){
                            r = t;
                        },
                        set stop (t){
                            a = t;
                        },
                        render (c, h) {
                            const l = o.get(h);
                            return void 0 !== l ? Promise.resolve(l) : (async (c, h)=>{
                                let l = s1(c);
                                const u = M(l, h);
                                if (!u) {
                                    const t1 = {
                                        buffer: l.buffer,
                                        channelCount: l.channelCount,
                                        channelCountMode: l.channelCountMode,
                                        channelInterpretation: l.channelInterpretation,
                                        loop: l.loop,
                                        loopEnd: l.loopEnd,
                                        loopStart: l.loopStart,
                                        playbackRate: l.playbackRate.value
                                    };
                                    l = e(h, t1), null !== r && l.start(...r), null !== a && l.stop(a);
                                }
                                return o.set(h, l), u ? await t1(h, c.playbackRate, l.playbackRate) : await n(h, c.playbackRate, l.playbackRate), await i(c, h, l), l;
                            })(c, h);
                        }
                    };
                })(Xe, Ye, tt, $e, Te), Je = ((t1, e, s1, n, i, r, a, c, h, l, u, p, d)=>(n, f, _, m = null, g = null)=>{
                    const v = _.value, y = new o.AutomationEventList(v), x = f ? ((t1)=>({
                            replay (e) {
                                for (const s1 of t1)if ("exponentialRampToValue" === s1.type) {
                                    const { endTime: t1, value: n } = s1;
                                    e.exponentialRampToValueAtTime(n, t1);
                                } else if ("linearRampToValue" === s1.type) {
                                    const { endTime: t1, value: n } = s1;
                                    e.linearRampToValueAtTime(n, t1);
                                } else if ("setTarget" === s1.type) {
                                    const { startTime: t1, target: n, timeConstant: i } = s1;
                                    e.setTargetAtTime(n, t1, i);
                                } else if ("setValue" === s1.type) {
                                    const { startTime: t1, value: n } = s1;
                                    e.setValueAtTime(n, t1);
                                } else {
                                    if ("setValueCurve" !== s1.type) throw new Error("Can't apply an unknown automation.");
                                    {
                                        const { duration: t1, startTime: n, values: i } = s1;
                                        e.setValueCurveAtTime(i, n, t1);
                                    }
                                }
                            }
                        }))(y) : null, w = {
                        get defaultValue () {
                            return v;
                        },
                        get maxValue () {
                            return null === m ? _.maxValue : m;
                        },
                        get minValue () {
                            return null === g ? _.minValue : g;
                        },
                        get value () {
                            return _.value;
                        },
                        set value (t){
                            _.value = t, w.setValueAtTime(t, n.context.currentTime);
                        },
                        cancelAndHoldAtTime (t1) {
                            if ("function" == typeof _.cancelAndHoldAtTime) null === x && y.flush(n.context.currentTime), y.add(i(t1)), _.cancelAndHoldAtTime(t1);
                            else {
                                const e = Array.from(y).pop();
                                null === x && y.flush(n.context.currentTime), y.add(i(t1));
                                const s1 = Array.from(y).pop();
                                _.cancelScheduledValues(t1), e !== s1 && void 0 !== s1 && ("exponentialRampToValue" === s1.type ? _.exponentialRampToValueAtTime(s1.value, s1.endTime) : "linearRampToValue" === s1.type ? _.linearRampToValueAtTime(s1.value, s1.endTime) : "setValue" === s1.type ? _.setValueAtTime(s1.value, s1.startTime) : "setValueCurve" === s1.type && _.setValueCurveAtTime(s1.values, s1.startTime, s1.duration));
                            }
                            return w;
                        },
                        cancelScheduledValues: (t1)=>(null === x && y.flush(n.context.currentTime), y.add(r(t1)), _.cancelScheduledValues(t1), w),
                        exponentialRampToValueAtTime (t1, e) {
                            if (0 === t1) throw new RangeError;
                            if (!Number.isFinite(e) || e < 0) throw new RangeError;
                            const s1 = n.context.currentTime;
                            return null === x && y.flush(s1), 0 === Array.from(y).length && (y.add(l(v, s1)), _.setValueAtTime(v, s1)), y.add(a(t1, e)), _.exponentialRampToValueAtTime(t1, e), w;
                        },
                        linearRampToValueAtTime (t1, e) {
                            const s1 = n.context.currentTime;
                            return null === x && y.flush(s1), 0 === Array.from(y).length && (y.add(l(v, s1)), _.setValueAtTime(v, s1)), y.add(c(t1, e)), _.linearRampToValueAtTime(t1, e), w;
                        },
                        setTargetAtTime: (t1, e, s1)=>(null === x && y.flush(n.context.currentTime), y.add(h(t1, e, s1)), _.setTargetAtTime(t1, e, s1), w),
                        setValueAtTime: (t1, e)=>(null === x && y.flush(n.context.currentTime), y.add(l(t1, e)), _.setValueAtTime(t1, e), w),
                        setValueCurveAtTime (t1, e, s1) {
                            const i = t1 instanceof Float32Array ? t1 : new Float32Array(t1);
                            if (null !== p && "webkitAudioContext" === p.name) {
                                const t1 = e + s1, o = n.context.sampleRate, r = Math.ceil(e * o), a = Math.floor(t1 * o), c = a - r, h = new Float32Array(c);
                                for(let t1 = 0; t1 < c; t1 += 1){
                                    const n = (i.length - 1) / s1 * ((r + t1) / o - e), a = Math.floor(n), c = Math.ceil(n);
                                    h[t1] = a === c ? i[a] : (1 - (n - a)) * i[a] + (1 - (c - n)) * i[c];
                                }
                                null === x && y.flush(n.context.currentTime), y.add(u(h, e, s1)), _.setValueCurveAtTime(h, e, s1);
                                const l = a / o;
                                l < t1 && d(w, h[h.length - 1], l), d(w, i[i.length - 1], t1);
                            } else null === x && y.flush(n.context.currentTime), y.add(u(i, e, s1)), _.setValueCurveAtTime(i, e, s1);
                            return w;
                        }
                    };
                    return s1.set(w, _), e.set(w, n), t1(w, x), w;
                })((Ke = h, (t1, e)=>{
                Ke.set(t1, {
                    activeInputs: new Set,
                    passiveInputs: new WeakMap,
                    renderer: e
                });
            }), Oe, l, 0, o.createCancelAndHoldAutomationEvent, o.createCancelScheduledValuesAutomationEvent, o.createExponentialRampToValueAutomationEvent, o.createLinearRampToValueAutomationEvent, o.createSetTargetAutomationEvent, o.createSetValueAutomationEvent, o.createSetValueCurveAutomationEvent, Ee, ie);
            var Ke;
            const ts = ((t1, e, s1, n, i, o, r, a)=>class extends t1 {
                    constructor(t1, n){
                        const a = o(t1), c = {
                            ...P,
                            ...n
                        }, h = i(a, c), l = r(a), u = l ? e() : null;
                        super(t1, !1, h, u), this._audioBufferSourceNodeRenderer = u, this._isBufferNullified = !1, this._isBufferSet = null !== c.buffer, this._nativeAudioBufferSourceNode = h, this._onended = null, this._playbackRate = s1(this, l, h.playbackRate, V, I);
                    }
                    get buffer() {
                        return this._isBufferNullified ? null : this._nativeAudioBufferSourceNode.buffer;
                    }
                    set buffer(t1) {
                        if (this._nativeAudioBufferSourceNode.buffer = t1, null !== t1) {
                            if (this._isBufferSet) throw n();
                            this._isBufferSet = !0;
                        }
                    }
                    get loop() {
                        return this._nativeAudioBufferSourceNode.loop;
                    }
                    set loop(t1) {
                        this._nativeAudioBufferSourceNode.loop = t1;
                    }
                    get loopEnd() {
                        return this._nativeAudioBufferSourceNode.loopEnd;
                    }
                    set loopEnd(t1) {
                        this._nativeAudioBufferSourceNode.loopEnd = t1;
                    }
                    get loopStart() {
                        return this._nativeAudioBufferSourceNode.loopStart;
                    }
                    set loopStart(t1) {
                        this._nativeAudioBufferSourceNode.loopStart = t1;
                    }
                    get onended() {
                        return this._onended;
                    }
                    set onended(t1) {
                        const e = "function" == typeof t1 ? a(this, t1) : null;
                        this._nativeAudioBufferSourceNode.onended = e;
                        const s1 = this._nativeAudioBufferSourceNode.onended;
                        this._onended = null !== s1 && s1 === e ? t1 : s1;
                    }
                    get playbackRate() {
                        return this._playbackRate;
                    }
                    start(t1 = 0, e = 0, s1) {
                        if (this._nativeAudioBufferSourceNode.start(t1, e, s1), null !== this._audioBufferSourceNodeRenderer && (this._audioBufferSourceNodeRenderer.start = void 0 === s1 ? [
                            t1,
                            e
                        ] : [
                            t1,
                            e,
                            s1
                        ]), "closed" !== this.context.state) {
                            k(this);
                            const t1 = ()=>{
                                this._nativeAudioBufferSourceNode.removeEventListener("ended", t1), N(this) && C(this);
                            };
                            this._nativeAudioBufferSourceNode.addEventListener("ended", t1);
                        }
                    }
                    stop(t1 = 0) {
                        this._nativeAudioBufferSourceNode.stop(t1), null !== this._audioBufferSourceNodeRenderer && (this._audioBufferSourceNodeRenderer.stop = t1);
                    }
                })(Ve, He, Je, At, Ye, ke, De, ue), es = ((t1, e, s1, n, i, o, r, a)=>class extends t1 {
                    constructor(t1, e){
                        const s1 = o(t1), n = r(s1), c = i(s1, e, n);
                        super(t1, !1, c, n ? ((t1)=>{
                            const e = new WeakMap;
                            return {
                                render (s1, n) {
                                    const i = e.get(n);
                                    return void 0 !== i ? Promise.resolve(i) : (async (s1, n)=>{
                                        const i = n.destination;
                                        return e.set(n, i), await t1(s1, n, i), i;
                                    })(s1, n);
                                }
                            };
                        })(a) : null), this._isNodeOfNativeOfflineAudioContext = n, this._nativeAudioDestinationNode = c;
                    }
                    get channelCount() {
                        return this._nativeAudioDestinationNode.channelCount;
                    }
                    set channelCount(t1) {
                        if (this._isNodeOfNativeOfflineAudioContext) throw n();
                        if (t1 > this._nativeAudioDestinationNode.maxChannelCount) throw s1();
                        this._nativeAudioDestinationNode.channelCount = t1;
                    }
                    get channelCountMode() {
                        return this._nativeAudioDestinationNode.channelCountMode;
                    }
                    set channelCountMode(t1) {
                        if (this._isNodeOfNativeOfflineAudioContext) throw n();
                        this._nativeAudioDestinationNode.channelCountMode = t1;
                    }
                    get maxChannelCount() {
                        return this._nativeAudioDestinationNode.maxChannelCount;
                    }
                })(Ve, 0, R, At, ((t1, e)=>(s1, n, i)=>{
                    const o = s1.destination;
                    if (o.channelCount !== n) try {
                        o.channelCount = n;
                    } catch  {}
                    i && "explicit" !== o.channelCountMode && (o.channelCountMode = "explicit"), 0 === o.maxChannelCount && Object.defineProperty(o, "maxChannelCount", {
                        value: n
                    });
                    const r = t1(s1, {
                        channelCount: n,
                        channelCountMode: o.channelCountMode,
                        channelInterpretation: o.channelInterpretation,
                        gain: 1
                    });
                    return e(r, "channelCount", (t1)=>()=>t1.call(r), (t1)=>(e)=>{
                            t1.call(r, e);
                            try {
                                o.channelCount = e;
                            } catch (t1) {
                                if (e > o.maxChannelCount) throw t1;
                            }
                        }), e(r, "channelCountMode", (t1)=>()=>t1.call(r), (t1)=>(e)=>{
                            t1.call(r, e), o.channelCountMode = e;
                        }), e(r, "channelInterpretation", (t1)=>()=>t1.call(r), (t1)=>(e)=>{
                            t1.call(r, e), o.channelInterpretation = e;
                        }), Object.defineProperty(r, "maxChannelCount", {
                        get: ()=>o.maxChannelCount
                    }), r.connect(o), r;
                })(Bt, ne), ke, De, Te), ss = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    return {
                        render (r, a) {
                            const c = o.get(a);
                            return void 0 !== c ? Promise.resolve(c) : (async (r, a)=>{
                                let c = s1(r);
                                const h = M(c, a);
                                if (!h) {
                                    const t1 = {
                                        Q: c.Q.value,
                                        channelCount: c.channelCount,
                                        channelCountMode: c.channelCountMode,
                                        channelInterpretation: c.channelInterpretation,
                                        detune: c.detune.value,
                                        frequency: c.frequency.value,
                                        gain: c.gain.value,
                                        type: c.type
                                    };
                                    c = e(a, t1);
                                }
                                return o.set(a, c), h ? (await t1(a, r.Q, c.Q), await t1(a, r.detune, c.detune), await t1(a, r.frequency, c.frequency), await t1(a, r.gain, c.gain)) : (await n(a, r.Q, c.Q), await n(a, r.detune, c.detune), await n(a, r.frequency, c.frequency), await n(a, r.gain, c.gain)), await i(r, a, c), c;
                            })(r, a);
                        }
                    };
                })(Xe, jt, tt, $e, Te), ns = ((t1)=>(e, s1)=>t1.set(e, s1))(_e), is = ((t1, e, s1, n, i, o, r, a)=>class extends t1 {
                    constructor(t1, n){
                        const c = o(t1), h = {
                            ...mt,
                            ...n
                        }, l = i(c, h), u = r(c);
                        super(t1, !1, l, u ? s1() : null), this._Q = e(this, u, l.Q, V, I), this._detune = e(this, u, l.detune, 1200 * Math.log2(V), -1200 * Math.log2(V)), this._frequency = e(this, u, l.frequency, t1.sampleRate / 2, 0), this._gain = e(this, u, l.gain, 40 * Math.log10(V), I), this._nativeBiquadFilterNode = l, a(this, 1);
                    }
                    get detune() {
                        return this._detune;
                    }
                    get frequency() {
                        return this._frequency;
                    }
                    get gain() {
                        return this._gain;
                    }
                    get Q() {
                        return this._Q;
                    }
                    get type() {
                        return this._nativeBiquadFilterNode.type;
                    }
                    set type(t1) {
                        this._nativeBiquadFilterNode.type = t1;
                    }
                    getFrequencyResponse(t1, e, s1) {
                        try {
                            this._nativeBiquadFilterNode.getFrequencyResponse(t1, e, s1);
                        } catch (t1) {
                            if (11 === t1.code) throw n();
                            throw t1;
                        }
                        if (t1.length !== e.length || e.length !== s1.length) throw n();
                    }
                })(Ve, Je, ss, Ct, jt, ke, De, ns), os = ((t1, e)=>(s1, n, i)=>{
                    const o = new Set;
                    return s1.connect = ((i)=>(r, a = 0, c = 0)=>{
                            const h = 0 === o.size;
                            if (e(r)) return i.call(s1, r, a, c), t1(o, [
                                r,
                                a,
                                c
                            ], (t1)=>t1[0] === r && t1[1] === a && t1[2] === c, !0), h && n(), r;
                            i.call(s1, r, a), t1(o, [
                                r,
                                a
                            ], (t1)=>t1[0] === r && t1[1] === a, !0), h && n();
                        })(s1.connect), s1.disconnect = ((t1)=>(n, r, a)=>{
                            const c = o.size > 0;
                            if (void 0 === n) t1.apply(s1), o.clear();
                            else if ("number" == typeof n) {
                                t1.call(s1, n);
                                for (const t1 of o)t1[1] === n && o.delete(t1);
                            } else {
                                e(n) ? t1.call(s1, n, r, a) : t1.call(s1, n, r);
                                for (const t1 of o)t1[0] !== n || void 0 !== r && t1[1] !== r || void 0 !== a && t1[2] !== a || o.delete(t1);
                            }
                            const h = 0 === o.size;
                            c && h && i();
                        })(s1.disconnect), s1;
                })(G, qe), rs = ((t1, e)=>(s1, n)=>{
                    n.channelCount = 1, n.channelCountMode = "explicit", Object.defineProperty(n, "channelCount", {
                        get: ()=>1,
                        set: ()=>{
                            throw t1();
                        }
                    }), Object.defineProperty(n, "channelCountMode", {
                        get: ()=>"explicit",
                        set: ()=>{
                            throw t1();
                        }
                    });
                    const i = s1.createBufferSource();
                    e(n, ()=>{
                        const t1 = n.numberOfInputs;
                        for(let e = 0; e < t1; e += 1)i.connect(n, 0, e);
                    }, ()=>i.disconnect(n));
                })(At, os), as = ((t1, e)=>(s1, n)=>{
                    const i = s1.createChannelMerger(n.numberOfInputs);
                    return null !== t1 && "webkitAudioContext" === t1.name && e(s1, i), qt(i, n), i;
                })(Ee, rs), cs = ((t1, e, s1)=>()=>{
                    const n = new WeakMap;
                    return {
                        render (i, o) {
                            const r = n.get(o);
                            return void 0 !== r ? Promise.resolve(r) : (async (i, o)=>{
                                let r = e(i);
                                if (!M(r, o)) {
                                    const e = {
                                        channelCount: r.channelCount,
                                        channelCountMode: r.channelCountMode,
                                        channelInterpretation: r.channelInterpretation,
                                        numberOfInputs: r.numberOfInputs
                                    };
                                    r = t1(o, e);
                                }
                                return n.set(o, r), await s1(i, o, r), r;
                            })(i, o);
                        }
                    };
                })(as, tt, Te), hs = ((t1, e, s1, n, i)=>class extends t1 {
                    constructor(t1, o){
                        const r = n(t1), a = {
                            ...gt,
                            ...o
                        };
                        super(t1, !1, s1(r, a), i(r) ? e() : null);
                    }
                })(Ve, cs, as, ke, De), ls = ((t1, e, s1)=>()=>{
                    const n = new WeakMap;
                    return {
                        render (i, o) {
                            const r = n.get(o);
                            return void 0 !== r ? Promise.resolve(r) : (async (i, o)=>{
                                let r = e(i);
                                if (!M(r, o)) {
                                    const e = {
                                        channelCount: r.channelCount,
                                        channelCountMode: r.channelCountMode,
                                        channelInterpretation: r.channelInterpretation,
                                        numberOfOutputs: r.numberOfOutputs
                                    };
                                    r = t1(o, e);
                                }
                                return n.set(o, r), await s1(i, o, r), r;
                            })(i, o);
                        }
                    };
                })(Lt, tt, Te), us = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, o){
                        const r = n(t1), a = ((t1)=>({
                                ...t1,
                                channelCount: t1.numberOfOutputs
                            }))({
                            ...vt,
                            ...o
                        });
                        super(t1, !1, s1(r, a), i(r) ? e() : null);
                    }
                })(Ve, ls, Lt, ke, De), ps = ((t1, e, s1, n)=>(i, { offset: o, ...r })=>{
                    const a = i.createBuffer(1, 2, 44100), c = e(i, {
                        buffer: null,
                        channelCount: 2,
                        channelCountMode: "max",
                        channelInterpretation: "speakers",
                        loop: !1,
                        loopEnd: 0,
                        loopStart: 0,
                        playbackRate: 1
                    }), h = s1(i, {
                        ...r,
                        gain: o
                    }), l = a.getChannelData(0);
                    l[0] = 1, l[1] = 1, c.buffer = a, c.loop = !0;
                    const u = {
                        get bufferSize () {},
                        get channelCount () {
                            return h.channelCount;
                        },
                        set channelCount (t){
                            h.channelCount = t;
                        },
                        get channelCountMode () {
                            return h.channelCountMode;
                        },
                        set channelCountMode (t){
                            h.channelCountMode = t;
                        },
                        get channelInterpretation () {
                            return h.channelInterpretation;
                        },
                        set channelInterpretation (t){
                            h.channelInterpretation = t;
                        },
                        get context () {
                            return h.context;
                        },
                        get inputs () {
                            return [];
                        },
                        get numberOfInputs () {
                            return c.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return h.numberOfOutputs;
                        },
                        get offset () {
                            return h.gain;
                        },
                        get onended () {
                            return c.onended;
                        },
                        set onended (t){
                            c.onended = t;
                        },
                        addEventListener: (...t1)=>c.addEventListener(t1[0], t1[1], t1[2]),
                        dispatchEvent: (...t1)=>c.dispatchEvent(t1[0]),
                        removeEventListener: (...t1)=>c.removeEventListener(t1[0], t1[1], t1[2]),
                        start (t1 = 0) {
                            c.start.call(c, t1);
                        },
                        stop (t1 = 0) {
                            c.stop.call(c, t1);
                        }
                    };
                    return t1(i, c), n(zt(u, h), ()=>c.connect(h), ()=>c.disconnect(h));
                })(Qe, Ye, Bt, os), ds = ((t1, e, s1, n, i)=>(o, r)=>{
                    if (void 0 === o.createConstantSource) return s1(o, r);
                    const a = o.createConstantSource();
                    return qt(a, r), It(a, r, "offset"), e(n, ()=>n(o)) || Vt(a), e(i, ()=>i(o)) || Nt(a), t1(o, a), a;
                })(Qe, ge, ps, oe, ae), fs = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    let r = null, a = null;
                    return {
                        set start (t){
                            r = t;
                        },
                        set stop (t){
                            a = t;
                        },
                        render (c, h) {
                            const l = o.get(h);
                            return void 0 !== l ? Promise.resolve(l) : (async (c, h)=>{
                                let l = s1(c);
                                const u = M(l, h);
                                if (!u) {
                                    const t1 = {
                                        channelCount: l.channelCount,
                                        channelCountMode: l.channelCountMode,
                                        channelInterpretation: l.channelInterpretation,
                                        offset: l.offset.value
                                    };
                                    l = e(h, t1), null !== r && l.start(r), null !== a && l.stop(a);
                                }
                                return o.set(h, l), u ? await t1(h, c.offset, l.offset) : await n(h, c.offset, l.offset), await i(c, h, l), l;
                            })(c, h);
                        }
                    };
                })(Xe, ds, tt, $e, Te), _s = ((t1, e, s1, n, i, o, r)=>class extends t1 {
                    constructor(t1, r){
                        const a = i(t1), c = {
                            ...yt,
                            ...r
                        }, h = n(a, c), l = o(a), u = l ? s1() : null;
                        super(t1, !1, h, u), this._constantSourceNodeRenderer = u, this._nativeConstantSourceNode = h, this._offset = e(this, l, h.offset, V, I), this._onended = null;
                    }
                    get offset() {
                        return this._offset;
                    }
                    get onended() {
                        return this._onended;
                    }
                    set onended(t1) {
                        const e = "function" == typeof t1 ? r(this, t1) : null;
                        this._nativeConstantSourceNode.onended = e;
                        const s1 = this._nativeConstantSourceNode.onended;
                        this._onended = null !== s1 && s1 === e ? t1 : s1;
                    }
                    start(t1 = 0) {
                        if (this._nativeConstantSourceNode.start(t1), null !== this._constantSourceNodeRenderer && (this._constantSourceNodeRenderer.start = t1), "closed" !== this.context.state) {
                            k(this);
                            const t1 = ()=>{
                                this._nativeConstantSourceNode.removeEventListener("ended", t1), N(this) && C(this);
                            };
                            this._nativeConstantSourceNode.addEventListener("ended", t1);
                        }
                    }
                    stop(t1 = 0) {
                        this._nativeConstantSourceNode.stop(t1), null !== this._constantSourceNodeRenderer && (this._constantSourceNodeRenderer.stop = t1);
                    }
                })(Ve, Je, fs, ds, ke, De, ue), ms = ((t1, e)=>(s1, n)=>{
                    const i = s1.createConvolver();
                    if (qt(i, n), n.disableNormalization === i.normalize && (i.normalize = !n.disableNormalization), Rt(i, n, "buffer"), n.channelCount > 2) throw t1();
                    if (e(i, "channelCount", (t1)=>()=>t1.call(i), (e)=>(s1)=>{
                            if (s1 > 2) throw t1();
                            return e.call(i, s1);
                        }), "max" === n.channelCountMode) throw t1();
                    return e(i, "channelCountMode", (t1)=>()=>t1.call(i), (e)=>(s1)=>{
                            if ("max" === s1) throw t1();
                            return e.call(i, s1);
                        }), i;
                })(Zt, ne), gs = ((t1, e, s1)=>()=>{
                    const n = new WeakMap;
                    return {
                        render (i, o) {
                            const r = n.get(o);
                            return void 0 !== r ? Promise.resolve(r) : (async (i, o)=>{
                                let r = e(i);
                                if (!M(r, o)) {
                                    const e = {
                                        buffer: r.buffer,
                                        channelCount: r.channelCount,
                                        channelCountMode: r.channelCountMode,
                                        channelInterpretation: r.channelInterpretation,
                                        disableNormalization: !r.normalize
                                    };
                                    r = t1(o, e);
                                }
                                return n.set(o, r), X(r) ? await s1(i, o, r.inputs[0]) : await s1(i, o, r), r;
                            })(i, o);
                        }
                    };
                })(ms, tt, Te), vs = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, r){
                        const a = n(t1), c = {
                            ...xt,
                            ...r
                        }, h = s1(a, c);
                        super(t1, !1, h, i(a) ? e() : null), this._isBufferNullified = !1, this._nativeConvolverNode = h, null !== c.buffer && o(this, c.buffer.duration);
                    }
                    get buffer() {
                        return this._isBufferNullified ? null : this._nativeConvolverNode.buffer;
                    }
                    set buffer(t1) {
                        if (this._nativeConvolverNode.buffer = t1, null === t1 && null !== this._nativeConvolverNode.buffer) {
                            const t1 = this._nativeConvolverNode.context;
                            this._nativeConvolverNode.buffer = t1.createBuffer(1, 1, t1.sampleRate), this._isBufferNullified = !0, o(this, 0);
                        } else this._isBufferNullified = !1, o(this, null === this._nativeConvolverNode.buffer ? 0 : this._nativeConvolverNode.buffer.duration);
                    }
                    get normalize() {
                        return this._nativeConvolverNode.normalize;
                    }
                    set normalize(t1) {
                        this._nativeConvolverNode.normalize = t1;
                    }
                })(Ve, gs, ms, ke, De, ns), ys = ((t1, e, s1, n, i)=>(o)=>{
                    const r = new WeakMap;
                    return {
                        render (a, c) {
                            const h = r.get(c);
                            return void 0 !== h ? Promise.resolve(h) : (async (a, c)=>{
                                let h = s1(a);
                                const l = M(h, c);
                                if (!l) {
                                    const t1 = {
                                        channelCount: h.channelCount,
                                        channelCountMode: h.channelCountMode,
                                        channelInterpretation: h.channelInterpretation,
                                        delayTime: h.delayTime.value,
                                        maxDelayTime: o
                                    };
                                    h = e(c, t1);
                                }
                                return r.set(c, h), l ? await t1(c, a.delayTime, h.delayTime) : await n(c, a.delayTime, h.delayTime), await i(a, c, h), h;
                            })(a, c);
                        }
                    };
                })(Xe, Wt, tt, $e, Te), xs = ((t1, e, s1, n, i, o, r)=>class extends t1 {
                    constructor(t1, a){
                        const c = i(t1), h = {
                            ...bt,
                            ...a
                        }, l = n(c, h), u = o(c);
                        super(t1, !1, l, u ? s1(h.maxDelayTime) : null), this._delayTime = e(this, u, l.delayTime), r(this, h.maxDelayTime);
                    }
                    get delayTime() {
                        return this._delayTime;
                    }
                })(Ve, Je, ys, Wt, ke, De, ns), ws = ((t1)=>(e, s1)=>{
                    const n = e.createDynamicsCompressor();
                    if (qt(n, s1), s1.channelCount > 2) throw t1();
                    if ("max" === s1.channelCountMode) throw t1();
                    return It(n, s1, "attack"), It(n, s1, "knee"), It(n, s1, "ratio"), It(n, s1, "release"), It(n, s1, "threshold"), n;
                })(Zt), bs = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    return {
                        render (r, a) {
                            const c = o.get(a);
                            return void 0 !== c ? Promise.resolve(c) : (async (r, a)=>{
                                let c = s1(r);
                                const h = M(c, a);
                                if (!h) {
                                    const t1 = {
                                        attack: c.attack.value,
                                        channelCount: c.channelCount,
                                        channelCountMode: c.channelCountMode,
                                        channelInterpretation: c.channelInterpretation,
                                        knee: c.knee.value,
                                        ratio: c.ratio.value,
                                        release: c.release.value,
                                        threshold: c.threshold.value
                                    };
                                    c = e(a, t1);
                                }
                                return o.set(a, c), h ? (await t1(a, r.attack, c.attack), await t1(a, r.knee, c.knee), await t1(a, r.ratio, c.ratio), await t1(a, r.release, c.release), await t1(a, r.threshold, c.threshold)) : (await n(a, r.attack, c.attack), await n(a, r.knee, c.knee), await n(a, r.ratio, c.ratio), await n(a, r.release, c.release), await n(a, r.threshold, c.threshold)), await i(r, a, c), c;
                            })(r, a);
                        }
                    };
                })(Xe, ws, tt, $e, Te), Ts = ((t1, e, s1, n, i, o, r, a)=>class extends t1 {
                    constructor(t1, i){
                        const c = o(t1), h = {
                            ...St,
                            ...i
                        }, l = n(c, h), u = r(c);
                        super(t1, !1, l, u ? s1() : null), this._attack = e(this, u, l.attack), this._knee = e(this, u, l.knee), this._nativeDynamicsCompressorNode = l, this._ratio = e(this, u, l.ratio), this._release = e(this, u, l.release), this._threshold = e(this, u, l.threshold), a(this, .006);
                    }
                    get attack() {
                        return this._attack;
                    }
                    get channelCount() {
                        return this._nativeDynamicsCompressorNode.channelCount;
                    }
                    set channelCount(t1) {
                        const e = this._nativeDynamicsCompressorNode.channelCount;
                        if (this._nativeDynamicsCompressorNode.channelCount = t1, t1 > 2) throw this._nativeDynamicsCompressorNode.channelCount = e, i();
                    }
                    get channelCountMode() {
                        return this._nativeDynamicsCompressorNode.channelCountMode;
                    }
                    set channelCountMode(t1) {
                        const e = this._nativeDynamicsCompressorNode.channelCountMode;
                        if (this._nativeDynamicsCompressorNode.channelCountMode = t1, "max" === t1) throw this._nativeDynamicsCompressorNode.channelCountMode = e, i();
                    }
                    get knee() {
                        return this._knee;
                    }
                    get ratio() {
                        return this._ratio;
                    }
                    get reduction() {
                        return "number" == typeof this._nativeDynamicsCompressorNode.reduction.value ? this._nativeDynamicsCompressorNode.reduction.value : this._nativeDynamicsCompressorNode.reduction;
                    }
                    get release() {
                        return this._release;
                    }
                    get threshold() {
                        return this._threshold;
                    }
                })(Ve, Je, bs, ws, Zt, ke, De, ns), Ss = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    return {
                        render (r, a) {
                            const c = o.get(a);
                            return void 0 !== c ? Promise.resolve(c) : (async (r, a)=>{
                                let c = s1(r);
                                const h = M(c, a);
                                if (!h) {
                                    const t1 = {
                                        channelCount: c.channelCount,
                                        channelCountMode: c.channelCountMode,
                                        channelInterpretation: c.channelInterpretation,
                                        gain: c.gain.value
                                    };
                                    c = e(a, t1);
                                }
                                return o.set(a, c), h ? await t1(a, r.gain, c.gain) : await n(a, r.gain, c.gain), await i(r, a, c), c;
                            })(r, a);
                        }
                    };
                })(Xe, Bt, tt, $e, Te), ks = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, r){
                        const a = i(t1), c = {
                            ...kt,
                            ...r
                        }, h = n(a, c), l = o(a);
                        super(t1, !1, h, l ? s1() : null), this._gain = e(this, l, h.gain, V, I);
                    }
                    get gain() {
                        return this._gain;
                    }
                })(Ve, Je, Ss, Bt, ke, De), As = ((t1, e, s1, n)=>(i, o, { channelCount: r, channelCountMode: a, channelInterpretation: c, feedback: h, feedforward: l })=>{
                    const u = Pt(o, i.sampleRate), p = h instanceof Float64Array ? h : new Float64Array(h), d = l instanceof Float64Array ? l : new Float64Array(l), f = p.length, _ = d.length, m = Math.min(f, _);
                    if (0 === f || f > 20) throw n();
                    if (0 === p[0]) throw e();
                    if (0 === _ || _ > 20) throw n();
                    if (0 === d[0]) throw e();
                    if (1 !== p[0]) {
                        for(let t1 = 0; t1 < _; t1 += 1)d[t1] /= p[0];
                        for(let t1 = 1; t1 < f; t1 += 1)p[t1] /= p[0];
                    }
                    const g = s1(i, u, r, r);
                    g.channelCount = r, g.channelCountMode = a, g.channelInterpretation = c;
                    const v = [], y = [], x = [];
                    for(let t1 = 0; t1 < r; t1 += 1){
                        v.push(0);
                        const t1 = new Float32Array(32), e = new Float32Array(32);
                        t1.fill(0), e.fill(0), y.push(t1), x.push(e);
                    }
                    g.onaudioprocess = (t1)=>{
                        const e = t1.inputBuffer, s1 = t1.outputBuffer, n = e.numberOfChannels;
                        for(let t1 = 0; t1 < n; t1 += 1){
                            const n = e.getChannelData(t1), i = s1.getChannelData(t1);
                            v[t1] = Ot(p, f, d, _, m, y[t1], x[t1], v[t1], 32, n, i);
                        }
                    };
                    const w = i.sampleRate / 2;
                    return zt({
                        get bufferSize () {
                            return u;
                        },
                        get channelCount () {
                            return g.channelCount;
                        },
                        set channelCount (t){
                            g.channelCount = t;
                        },
                        get channelCountMode () {
                            return g.channelCountMode;
                        },
                        set channelCountMode (t){
                            g.channelCountMode = t;
                        },
                        get channelInterpretation () {
                            return g.channelInterpretation;
                        },
                        set channelInterpretation (t){
                            g.channelInterpretation = t;
                        },
                        get context () {
                            return g.context;
                        },
                        get inputs () {
                            return [
                                g
                            ];
                        },
                        get numberOfInputs () {
                            return g.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return g.numberOfOutputs;
                        },
                        addEventListener: (...t1)=>g.addEventListener(t1[0], t1[1], t1[2]),
                        dispatchEvent: (...t1)=>g.dispatchEvent(t1[0]),
                        getFrequencyResponse (e, s1, n) {
                            if (e.length !== s1.length || s1.length !== n.length) throw t1();
                            const i = e.length;
                            for(let t1 = 0; t1 < i; t1 += 1){
                                const i = -Math.PI * (e[t1] / w), o = [
                                    Math.cos(i),
                                    Math.sin(i)
                                ], r = Ut(Gt(d, o), Gt(p, o));
                                s1[t1] = Math.sqrt(r[0] * r[0] + r[1] * r[1]), n[t1] = Math.atan2(r[1], r[0]);
                            }
                        },
                        removeEventListener: (...t1)=>g.removeEventListener(t1[0], t1[1], t1[2])
                    }, g);
                })(Ct, At, Qt, Zt), Cs = ((t1, e, s1, n)=>(i)=>t1(Et, ()=>Et(i)) ? Promise.resolve(t1(n, n)).then((t1)=>{
                        if (!t1) {
                            const t1 = s1(i, 512, 0, 1);
                            i.oncomplete = ()=>{
                                t1.onaudioprocess = null, t1.disconnect();
                            }, t1.onaudioprocess = ()=>i.currentTime, t1.connect(i.destination);
                        }
                        return i.startRendering();
                    }) : new Promise((t1)=>{
                        const s1 = e(i, {
                            channelCount: 1,
                            channelCountMode: "explicit",
                            channelInterpretation: "discrete",
                            gain: 0
                        });
                        i.oncomplete = (e)=>{
                            s1.disconnect(), t1(e.renderedBuffer);
                        }, s1.connect(i.destination), i.startRendering();
                    }))(ge, Bt, Qt, ((t1, e)=>()=>{
                    if (null === e) return Promise.resolve(!1);
                    const s1 = new e(1, 1, 44100), n = t1(s1, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        gain: 0
                    });
                    return new Promise((t1)=>{
                        s1.oncomplete = ()=>{
                            n.disconnect(), t1(0 !== s1.currentTime);
                        }, s1.startRendering();
                    });
                })(Bt, Ce)), Ds = ((t1, e, s1, n, i)=>(o, r)=>{
                    const a = new WeakMap;
                    let c = null;
                    return {
                        render (h, l) {
                            const u = a.get(l);
                            return void 0 !== u ? Promise.resolve(u) : (async (h, l)=>{
                                let u = null, p = e(h);
                                const d = M(p, l);
                                if (void 0 === l.createIIRFilter ? u = t1(l, {
                                    buffer: null,
                                    channelCount: 2,
                                    channelCountMode: "max",
                                    channelInterpretation: "speakers",
                                    loop: !1,
                                    loopEnd: 0,
                                    loopStart: 0,
                                    playbackRate: 1
                                }) : d || (p = l.createIIRFilter(r, o)), a.set(l, null === u ? p : u), null !== u) {
                                    if (null === c) {
                                        if (null === s1) throw new Error("Missing the native OfflineAudioContext constructor.");
                                        const t1 = new s1(h.context.destination.channelCount, h.context.length, l.sampleRate);
                                        c = (async ()=>(await n(h, t1, t1.destination), ((t1, e, s1, n)=>{
                                                const i = s1 instanceof Float64Array ? s1 : new Float64Array(s1), o = n instanceof Float64Array ? n : new Float64Array(n), r = i.length, a = o.length, c = Math.min(r, a);
                                                if (1 !== i[0]) {
                                                    for(let t1 = 0; t1 < r; t1 += 1)o[t1] /= i[0];
                                                    for(let t1 = 1; t1 < a; t1 += 1)i[t1] /= i[0];
                                                }
                                                const h = new Float32Array(32), l = new Float32Array(32), u = e.createBuffer(t1.numberOfChannels, t1.length, t1.sampleRate), p = t1.numberOfChannels;
                                                for(let e = 0; e < p; e += 1){
                                                    const s1 = t1.getChannelData(e), n = u.getChannelData(e);
                                                    h.fill(0), l.fill(0), Ot(i, r, o, a, c, h, l, 0, 32, s1, n);
                                                }
                                                return u;
                                            })(await i(t1), l, o, r)))();
                                    }
                                    const t1 = await c;
                                    return u.buffer = t1, u.start(0), u;
                                }
                                return await n(h, l, p), p;
                            })(h, l);
                        }
                    };
                })(Ye, tt, Ce, Te, Cs), Os = ((t1)=>(e, s1, n)=>{
                    if (void 0 === e.createIIRFilter) return t1(e, s1, n);
                    const i = e.createIIRFilter(n.feedforward, n.feedback);
                    return qt(i, n), i;
                })(As), Ms = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, r){
                        const a = n(t1), c = i(a), h = {
                            ...Dt,
                            ...r
                        }, l = e(a, c ? null : t1.baseLatency, h);
                        super(t1, !1, l, c ? s1(h.feedback, h.feedforward) : null), ((t1)=>{
                            var e;
                            t1.getFrequencyResponse = (e = t1.getFrequencyResponse, (s1, n, i)=>{
                                if (s1.length !== n.length || n.length !== i.length) throw Ct();
                                return e.call(t1, s1, n, i);
                            });
                        })(l), this._nativeIIRFilterNode = l, o(this, 1);
                    }
                    getFrequencyResponse(t1, e, s1) {
                        return this._nativeIIRFilterNode.getFrequencyResponse(t1, e, s1);
                    }
                })(Ve, Os, Ds, ke, De, ns), Es = ((t1, e, s1, n, i, o, r, a)=>(c, h)=>{
                    const l = h.listener, { forwardX: u, forwardY: p, forwardZ: d, positionX: f, positionY: _, positionZ: m, upX: g, upY: v, upZ: y } = void 0 === l.forwardX ? (()=>{
                        const u = new Float32Array(1), p = e(h, {
                            channelCount: 1,
                            channelCountMode: "explicit",
                            channelInterpretation: "speakers",
                            numberOfInputs: 9
                        }), d = r(h);
                        let f = !1, _ = [
                            0,
                            0,
                            -1,
                            0,
                            1,
                            0
                        ], m = [
                            0,
                            0,
                            0
                        ];
                        const g = ()=>{
                            if (f) return;
                            f = !0;
                            const t1 = n(h, 256, 9, 0);
                            t1.onaudioprocess = ({ inputBuffer: t1 })=>{
                                const e = [
                                    o(t1, u, 0),
                                    o(t1, u, 1),
                                    o(t1, u, 2),
                                    o(t1, u, 3),
                                    o(t1, u, 4),
                                    o(t1, u, 5)
                                ];
                                e.some((t1, e)=>t1 !== _[e]) && (l.setOrientation(...e), _ = e);
                                const s1 = [
                                    o(t1, u, 6),
                                    o(t1, u, 7),
                                    o(t1, u, 8)
                                ];
                                s1.some((t1, e)=>t1 !== m[e]) && (l.setPosition(...s1), m = s1);
                            }, p.connect(t1);
                        }, v = (t1)=>(e)=>{
                                e !== _[t1] && (_[t1] = e, l.setOrientation(..._));
                            }, y = (t1)=>(e)=>{
                                e !== m[t1] && (m[t1] = e, l.setPosition(...m));
                            }, x = (e, n, o)=>{
                            const r = s1(h, {
                                channelCount: 1,
                                channelCountMode: "explicit",
                                channelInterpretation: "discrete",
                                offset: n
                            });
                            r.connect(p, 0, e), r.start(), Object.defineProperty(r.offset, "defaultValue", {
                                get: ()=>n
                            });
                            const l = t1({
                                context: c
                            }, d, r.offset, V, I);
                            var u, f, _, m, v, y, x;
                            return a(l, "value", (t1)=>()=>t1.call(l), (t1)=>(e)=>{
                                    try {
                                        t1.call(l, e);
                                    } catch (t1) {
                                        if (9 !== t1.code) throw t1;
                                    }
                                    g(), d && o(e);
                                }), l.cancelAndHoldAtTime = (u = l.cancelAndHoldAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = u.apply(l, t1);
                                return g(), e;
                            }), l.cancelScheduledValues = (f = l.cancelScheduledValues, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = f.apply(l, t1);
                                return g(), e;
                            }), l.exponentialRampToValueAtTime = (_ = l.exponentialRampToValueAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = _.apply(l, t1);
                                return g(), e;
                            }), l.linearRampToValueAtTime = (m = l.linearRampToValueAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = m.apply(l, t1);
                                return g(), e;
                            }), l.setTargetAtTime = (v = l.setTargetAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = v.apply(l, t1);
                                return g(), e;
                            }), l.setValueAtTime = (y = l.setValueAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = y.apply(l, t1);
                                return g(), e;
                            }), l.setValueCurveAtTime = (x = l.setValueCurveAtTime, d ? ()=>{
                                throw i();
                            } : (...t1)=>{
                                const e = x.apply(l, t1);
                                return g(), e;
                            }), l;
                        };
                        return {
                            forwardX: x(0, 0, v(0)),
                            forwardY: x(1, 0, v(1)),
                            forwardZ: x(2, -1, v(2)),
                            positionX: x(6, 0, y(0)),
                            positionY: x(7, 0, y(1)),
                            positionZ: x(8, 0, y(2)),
                            upX: x(3, 0, v(3)),
                            upY: x(4, 1, v(4)),
                            upZ: x(5, 0, v(5))
                        };
                    })() : l;
                    return {
                        get forwardX () {
                            return u;
                        },
                        get forwardY () {
                            return p;
                        },
                        get forwardZ () {
                            return d;
                        },
                        get positionX () {
                            return f;
                        },
                        get positionY () {
                            return _;
                        },
                        get positionZ () {
                            return m;
                        },
                        get upX () {
                            return g;
                        },
                        get upY () {
                            return v;
                        },
                        get upZ () {
                            return y;
                        }
                    };
                })(Je, as, ds, Qt, Zt, ee, De, ne), Rs = new WeakMap, qs = ((t1, e, s1, n, i, o)=>class extends s1 {
                    constructor(s1, o){
                        super(s1), this._nativeContext = s1, u.set(this, s1), n(s1) && i.set(s1, new Set), this._destination = new t1(this, o), this._listener = e(this, s1), this._onstatechange = null;
                    }
                    get currentTime() {
                        return this._nativeContext.currentTime;
                    }
                    get destination() {
                        return this._destination;
                    }
                    get listener() {
                        return this._listener;
                    }
                    get onstatechange() {
                        return this._onstatechange;
                    }
                    set onstatechange(t1) {
                        const e = "function" == typeof t1 ? o(this, t1) : null;
                        this._nativeContext.onstatechange = e;
                        const s1 = this._nativeContext.onstatechange;
                        this._onstatechange = null !== s1 && s1 === e ? t1 : s1;
                    }
                    get sampleRate() {
                        return this._nativeContext.sampleRate;
                    }
                    get state() {
                        return this._nativeContext.state;
                    }
                })(es, Es, Me, De, Rs, ue), Fs = ((t1, e, s1, n, i, o)=>(r, a)=>{
                    const c = r.createOscillator();
                    return qt(c, a), It(c, a, "detune"), It(c, a, "frequency"), void 0 !== a.periodicWave ? c.setPeriodicWave(a.periodicWave) : Rt(c, a, "type"), e(s1, ()=>s1(r)) || Vt(c), e(n, ()=>n(r)) || o(c, r), e(i, ()=>i(r)) || Nt(c), t1(r, c), c;
                })(Qe, ge, oe, re, ae, le), Is = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    let r = null, a = null, c = null;
                    return {
                        set periodicWave (t){
                            r = t;
                        },
                        set start (t){
                            a = t;
                        },
                        set stop (t){
                            c = t;
                        },
                        render (h, l) {
                            const u = o.get(l);
                            return void 0 !== u ? Promise.resolve(u) : (async (h, l)=>{
                                let u = s1(h);
                                const p = M(u, l);
                                if (!p) {
                                    const t1 = {
                                        channelCount: u.channelCount,
                                        channelCountMode: u.channelCountMode,
                                        channelInterpretation: u.channelInterpretation,
                                        detune: u.detune.value,
                                        frequency: u.frequency.value,
                                        periodicWave: null === r ? void 0 : r,
                                        type: u.type
                                    };
                                    u = e(l, t1), null !== a && u.start(a), null !== c && u.stop(c);
                                }
                                return o.set(l, u), p ? (await t1(l, h.detune, u.detune), await t1(l, h.frequency, u.frequency)) : (await n(l, h.detune, u.detune), await n(l, h.frequency, u.frequency)), await i(h, l, u), u;
                            })(h, l);
                        }
                    };
                })(Xe, Fs, tt, $e, Te), Vs = ((t1, e, s1, n, i, o, r)=>class extends t1 {
                    constructor(t1, r){
                        const a = i(t1), c = {
                            ...Yt,
                            ...r
                        }, h = s1(a, c), l = o(a), u = l ? n() : null, p = t1.sampleRate / 2;
                        super(t1, !1, h, u), this._detune = e(this, l, h.detune, 153600, -153600), this._frequency = e(this, l, h.frequency, p, -p), this._nativeOscillatorNode = h, this._onended = null, this._oscillatorNodeRenderer = u, null !== this._oscillatorNodeRenderer && void 0 !== c.periodicWave && (this._oscillatorNodeRenderer.periodicWave = c.periodicWave);
                    }
                    get detune() {
                        return this._detune;
                    }
                    get frequency() {
                        return this._frequency;
                    }
                    get onended() {
                        return this._onended;
                    }
                    set onended(t1) {
                        const e = "function" == typeof t1 ? r(this, t1) : null;
                        this._nativeOscillatorNode.onended = e;
                        const s1 = this._nativeOscillatorNode.onended;
                        this._onended = null !== s1 && s1 === e ? t1 : s1;
                    }
                    get type() {
                        return this._nativeOscillatorNode.type;
                    }
                    set type(t1) {
                        this._nativeOscillatorNode.type = t1, null !== this._oscillatorNodeRenderer && (this._oscillatorNodeRenderer.periodicWave = null);
                    }
                    setPeriodicWave(t1) {
                        this._nativeOscillatorNode.setPeriodicWave(t1), null !== this._oscillatorNodeRenderer && (this._oscillatorNodeRenderer.periodicWave = t1);
                    }
                    start(t1 = 0) {
                        if (this._nativeOscillatorNode.start(t1), null !== this._oscillatorNodeRenderer && (this._oscillatorNodeRenderer.start = t1), "closed" !== this.context.state) {
                            k(this);
                            const t1 = ()=>{
                                this._nativeOscillatorNode.removeEventListener("ended", t1), N(this) && C(this);
                            };
                            this._nativeOscillatorNode.addEventListener("ended", t1);
                        }
                    }
                    stop(t1 = 0) {
                        this._nativeOscillatorNode.stop(t1), null !== this._oscillatorNodeRenderer && (this._oscillatorNodeRenderer.stop = t1);
                    }
                })(Ve, Je, Fs, Is, ke, De, ue), Ns = ((t1)=>(e, s1)=>{
                    const n = t1(e, {
                        buffer: null,
                        channelCount: 2,
                        channelCountMode: "max",
                        channelInterpretation: "speakers",
                        loop: !1,
                        loopEnd: 0,
                        loopStart: 0,
                        playbackRate: 1
                    }), i = e.createBuffer(1, 2, 44100);
                    return n.buffer = i, n.loop = !0, n.connect(s1), n.start(), ()=>{
                        n.stop(), n.disconnect(s1);
                    };
                })(Ye), Ps = ((t1, e, s1, n, i)=>(o, { curve: r, oversample: a, ...c })=>{
                    const h = o.createWaveShaper(), l = o.createWaveShaper();
                    qt(h, c), qt(l, c);
                    const u = s1(o, {
                        ...c,
                        gain: 1
                    }), p = s1(o, {
                        ...c,
                        gain: -1
                    }), d = s1(o, {
                        ...c,
                        gain: 1
                    }), f = s1(o, {
                        ...c,
                        gain: -1
                    });
                    let _ = null, m = !1, g = null;
                    const v = {
                        get bufferSize () {},
                        get channelCount () {
                            return h.channelCount;
                        },
                        set channelCount (t){
                            u.channelCount = t, p.channelCount = t, h.channelCount = t, d.channelCount = t, l.channelCount = t, f.channelCount = t;
                        },
                        get channelCountMode () {
                            return h.channelCountMode;
                        },
                        set channelCountMode (t){
                            u.channelCountMode = t, p.channelCountMode = t, h.channelCountMode = t, d.channelCountMode = t, l.channelCountMode = t, f.channelCountMode = t;
                        },
                        get channelInterpretation () {
                            return h.channelInterpretation;
                        },
                        set channelInterpretation (t){
                            u.channelInterpretation = t, p.channelInterpretation = t, h.channelInterpretation = t, d.channelInterpretation = t, l.channelInterpretation = t, f.channelInterpretation = t;
                        },
                        get context () {
                            return h.context;
                        },
                        get curve () {
                            return g;
                        },
                        set curve (s){
                            if (null !== s && s.length < 2) throw e();
                            if (null === s) h.curve = s, l.curve = s;
                            else {
                                const t1 = s.length, e = new Float32Array(t1 + 2 - t1 % 2), n = new Float32Array(t1 + 2 - t1 % 2);
                                e[0] = s[0], n[0] = -s[t1 - 1];
                                const i = Math.ceil((t1 + 1) / 2), o = (t1 + 1) / 2 - 1;
                                for(let r = 1; r < i; r += 1){
                                    const a = r / i * o, c = Math.floor(a), h = Math.ceil(a);
                                    e[r] = c === h ? s[c] : (1 - (a - c)) * s[c] + (1 - (h - a)) * s[h], n[r] = c === h ? -s[t1 - 1 - c] : -(1 - (a - c)) * s[t1 - 1 - c] - (1 - (h - a)) * s[t1 - 1 - h];
                                }
                                e[i] = t1 % 2 == 1 ? s[i - 1] : (s[i - 2] + s[i - 1]) / 2, h.curve = e, l.curve = n;
                            }
                            g = s, m && (n(g) && null === _ ? _ = t1(o, u) : null !== _ && (_(), _ = null));
                        },
                        get inputs () {
                            return [
                                u
                            ];
                        },
                        get numberOfInputs () {
                            return h.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return h.numberOfOutputs;
                        },
                        get oversample () {
                            return h.oversample;
                        },
                        set oversample (t){
                            h.oversample = t, l.oversample = t;
                        },
                        addEventListener: (...t1)=>u.addEventListener(t1[0], t1[1], t1[2]),
                        dispatchEvent: (...t1)=>u.dispatchEvent(t1[0]),
                        removeEventListener: (...t1)=>u.removeEventListener(t1[0], t1[1], t1[2])
                    };
                    return null !== r && (v.curve = r instanceof Float32Array ? r : new Float32Array(r)), a !== v.oversample && (v.oversample = a), i(zt(v, d), ()=>{
                        u.connect(h).connect(d), u.connect(p).connect(l).connect(f).connect(d), m = !0, n(g) && (_ = t1(o, u));
                    }, ()=>{
                        u.disconnect(h), h.disconnect(d), u.disconnect(p), p.disconnect(l), l.disconnect(f), f.disconnect(d), m = !1, null !== _ && (_(), _ = null);
                    });
                })(Ns, At, Bt, se, os), js = ((t1, e, s1, n, i, o, r)=>(a, c)=>{
                    const h = a.createWaveShaper();
                    if (null !== o && "webkitAudioContext" === o.name && void 0 === a.createGain().gain.automationRate) return s1(a, c);
                    qt(h, c);
                    const l = null === c.curve || c.curve instanceof Float32Array ? c.curve : new Float32Array(c.curve);
                    if (null !== l && l.length < 2) throw e();
                    Rt(h, {
                        curve: l
                    }, "curve"), Rt(h, c, "oversample");
                    let u = null, p = !1;
                    return r(h, "curve", (t1)=>()=>t1.call(h), (e)=>(s1)=>(e.call(h, s1), p && (n(s1) && null === u ? u = t1(a, h) : n(s1) || null === u || (u(), u = null)), s1)), i(h, ()=>{
                        p = !0, n(h.curve) && (u = t1(a, h));
                    }, ()=>{
                        p = !1, null !== u && (u(), u = null);
                    });
                })(Ns, At, Ps, se, os, Ee, ne), Ls = ((t1, e, s1, n, i, o, r, a, c, h)=>(l, { coneInnerAngle: u, coneOuterAngle: p, coneOuterGain: d, distanceModel: f, maxDistance: _, orientationX: m, orientationY: g, orientationZ: v, panningModel: y, positionX: x, positionY: w, positionZ: b, refDistance: T, rolloffFactor: S, ...k })=>{
                    const A = l.createPanner();
                    if (k.channelCount > 2) throw r();
                    if ("max" === k.channelCountMode) throw r();
                    qt(A, k);
                    const C = {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete"
                    }, D = s1(l, {
                        ...C,
                        channelInterpretation: "speakers",
                        numberOfInputs: 6
                    }), O = n(l, {
                        ...k,
                        gain: 1
                    }), M = n(l, {
                        ...C,
                        gain: 1
                    }), E = n(l, {
                        ...C,
                        gain: 0
                    }), R = n(l, {
                        ...C,
                        gain: 0
                    }), q = n(l, {
                        ...C,
                        gain: 0
                    }), F = n(l, {
                        ...C,
                        gain: 0
                    }), I = n(l, {
                        ...C,
                        gain: 0
                    }), V = i(l, 256, 6, 1), N = o(l, {
                        ...C,
                        curve: new Float32Array([
                            1,
                            1
                        ]),
                        oversample: "none"
                    });
                    let P = [
                        m,
                        g,
                        v
                    ], j = [
                        x,
                        w,
                        b
                    ];
                    const L = new Float32Array(1);
                    V.onaudioprocess = ({ inputBuffer: t1 })=>{
                        const e = [
                            c(t1, L, 0),
                            c(t1, L, 1),
                            c(t1, L, 2)
                        ];
                        e.some((t1, e)=>t1 !== P[e]) && (A.setOrientation(...e), P = e);
                        const s1 = [
                            c(t1, L, 3),
                            c(t1, L, 4),
                            c(t1, L, 5)
                        ];
                        s1.some((t1, e)=>t1 !== j[e]) && (A.setPosition(...s1), j = s1);
                    }, Object.defineProperty(E.gain, "defaultValue", {
                        get: ()=>0
                    }), Object.defineProperty(R.gain, "defaultValue", {
                        get: ()=>0
                    }), Object.defineProperty(q.gain, "defaultValue", {
                        get: ()=>0
                    }), Object.defineProperty(F.gain, "defaultValue", {
                        get: ()=>0
                    }), Object.defineProperty(I.gain, "defaultValue", {
                        get: ()=>0
                    });
                    const z = {
                        get bufferSize () {},
                        get channelCount () {
                            return A.channelCount;
                        },
                        set channelCount (t){
                            if (t > 2) throw r();
                            O.channelCount = t, A.channelCount = t;
                        },
                        get channelCountMode () {
                            return A.channelCountMode;
                        },
                        set channelCountMode (t){
                            if ("max" === t) throw r();
                            O.channelCountMode = t, A.channelCountMode = t;
                        },
                        get channelInterpretation () {
                            return A.channelInterpretation;
                        },
                        set channelInterpretation (t){
                            O.channelInterpretation = t, A.channelInterpretation = t;
                        },
                        get coneInnerAngle () {
                            return A.coneInnerAngle;
                        },
                        set coneInnerAngle (t){
                            A.coneInnerAngle = t;
                        },
                        get coneOuterAngle () {
                            return A.coneOuterAngle;
                        },
                        set coneOuterAngle (t){
                            A.coneOuterAngle = t;
                        },
                        get coneOuterGain () {
                            return A.coneOuterGain;
                        },
                        set coneOuterGain (t){
                            if (t < 0 || t > 1) throw e();
                            A.coneOuterGain = t;
                        },
                        get context () {
                            return A.context;
                        },
                        get distanceModel () {
                            return A.distanceModel;
                        },
                        set distanceModel (t){
                            A.distanceModel = t;
                        },
                        get inputs () {
                            return [
                                O
                            ];
                        },
                        get maxDistance () {
                            return A.maxDistance;
                        },
                        set maxDistance (t){
                            if (t < 0) throw new RangeError;
                            A.maxDistance = t;
                        },
                        get numberOfInputs () {
                            return A.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return A.numberOfOutputs;
                        },
                        get orientationX () {
                            return M.gain;
                        },
                        get orientationY () {
                            return E.gain;
                        },
                        get orientationZ () {
                            return R.gain;
                        },
                        get panningModel () {
                            return A.panningModel;
                        },
                        set panningModel (t){
                            A.panningModel = t;
                        },
                        get positionX () {
                            return q.gain;
                        },
                        get positionY () {
                            return F.gain;
                        },
                        get positionZ () {
                            return I.gain;
                        },
                        get refDistance () {
                            return A.refDistance;
                        },
                        set refDistance (t){
                            if (t < 0) throw new RangeError;
                            A.refDistance = t;
                        },
                        get rolloffFactor () {
                            return A.rolloffFactor;
                        },
                        set rolloffFactor (t){
                            if (t < 0) throw new RangeError;
                            A.rolloffFactor = t;
                        },
                        addEventListener: (...t1)=>O.addEventListener(t1[0], t1[1], t1[2]),
                        dispatchEvent: (...t1)=>O.dispatchEvent(t1[0]),
                        removeEventListener: (...t1)=>O.removeEventListener(t1[0], t1[1], t1[2])
                    };
                    return u !== z.coneInnerAngle && (z.coneInnerAngle = u), p !== z.coneOuterAngle && (z.coneOuterAngle = p), d !== z.coneOuterGain && (z.coneOuterGain = d), f !== z.distanceModel && (z.distanceModel = f), _ !== z.maxDistance && (z.maxDistance = _), m !== z.orientationX.value && (z.orientationX.value = m), g !== z.orientationY.value && (z.orientationY.value = g), v !== z.orientationZ.value && (z.orientationZ.value = v), y !== z.panningModel && (z.panningModel = y), x !== z.positionX.value && (z.positionX.value = x), w !== z.positionY.value && (z.positionY.value = w), b !== z.positionZ.value && (z.positionZ.value = b), T !== z.refDistance && (z.refDistance = T), S !== z.rolloffFactor && (z.rolloffFactor = S), 1 === P[0] && 0 === P[1] && 0 === P[2] || A.setOrientation(...P), 0 === j[0] && 0 === j[1] && 0 === j[2] || A.setPosition(...j), h(zt(z, A), ()=>{
                        O.connect(A), t1(O, N, 0, 0), N.connect(M).connect(D, 0, 0), N.connect(E).connect(D, 0, 1), N.connect(R).connect(D, 0, 2), N.connect(q).connect(D, 0, 3), N.connect(F).connect(D, 0, 4), N.connect(I).connect(D, 0, 5), D.connect(V).connect(l.destination);
                    }, ()=>{
                        O.disconnect(A), a(O, N, 0, 0), N.disconnect(M), M.disconnect(D), N.disconnect(E), E.disconnect(D), N.disconnect(R), R.disconnect(D), N.disconnect(q), q.disconnect(D), N.disconnect(F), F.disconnect(D), N.disconnect(I), I.disconnect(D), D.disconnect(V), V.disconnect(l.destination);
                    });
                })(Y, At, as, Bt, Qt, js, Zt, K, ee, os), zs = ((t1)=>(e, s1)=>{
                    const n = e.createPanner();
                    return void 0 === n.orientationX ? t1(e, s1) : (qt(n, s1), It(n, s1, "orientationX"), It(n, s1, "orientationY"), It(n, s1, "orientationZ"), It(n, s1, "positionX"), It(n, s1, "positionY"), It(n, s1, "positionZ"), Rt(n, s1, "coneInnerAngle"), Rt(n, s1, "coneOuterAngle"), Rt(n, s1, "coneOuterGain"), Rt(n, s1, "distanceModel"), Rt(n, s1, "maxDistance"), Rt(n, s1, "panningModel"), Rt(n, s1, "refDistance"), Rt(n, s1, "rolloffFactor"), n);
                })(Ls), Ws = ((t1, e, s1, n, i, o, r, a, c, h)=>()=>{
                    const l = new WeakMap;
                    let u = null;
                    return {
                        render (p, d) {
                            const f = l.get(d);
                            return void 0 !== f ? Promise.resolve(f) : (async (p, d)=>{
                                let f = null, _ = o(p);
                                const m = {
                                    channelCount: _.channelCount,
                                    channelCountMode: _.channelCountMode,
                                    channelInterpretation: _.channelInterpretation
                                }, g = {
                                    ...m,
                                    coneInnerAngle: _.coneInnerAngle,
                                    coneOuterAngle: _.coneOuterAngle,
                                    coneOuterGain: _.coneOuterGain,
                                    distanceModel: _.distanceModel,
                                    maxDistance: _.maxDistance,
                                    panningModel: _.panningModel,
                                    refDistance: _.refDistance,
                                    rolloffFactor: _.rolloffFactor
                                }, v = M(_, d);
                                if ("bufferSize" in _) f = n(d, {
                                    ...m,
                                    gain: 1
                                });
                                else if (!v) {
                                    const t1 = {
                                        ...g,
                                        orientationX: _.orientationX.value,
                                        orientationY: _.orientationY.value,
                                        orientationZ: _.orientationZ.value,
                                        positionX: _.positionX.value,
                                        positionY: _.positionY.value,
                                        positionZ: _.positionZ.value
                                    };
                                    _ = i(d, t1);
                                }
                                if (l.set(d, null === f ? _ : f), null !== f) {
                                    if (null === u) {
                                        if (null === r) throw new Error("Missing the native OfflineAudioContext constructor.");
                                        const t1 = new r(6, p.context.length, d.sampleRate), n = e(t1, {
                                            channelCount: 1,
                                            channelCountMode: "explicit",
                                            channelInterpretation: "speakers",
                                            numberOfInputs: 6
                                        });
                                        n.connect(t1.destination), u = (async ()=>{
                                            const e = await Promise.all([
                                                p.orientationX,
                                                p.orientationY,
                                                p.orientationZ,
                                                p.positionX,
                                                p.positionY,
                                                p.positionZ
                                            ].map(async (e, n)=>{
                                                const i = s1(t1, {
                                                    channelCount: 1,
                                                    channelCountMode: "explicit",
                                                    channelInterpretation: "discrete",
                                                    offset: 0 === n ? 1 : 0
                                                });
                                                return await a(t1, e, i.offset), i;
                                            }));
                                            for(let t1 = 0; t1 < 6; t1 += 1)e[t1].connect(n, 0, t1), e[t1].start(0);
                                            return h(t1);
                                        })();
                                    }
                                    const t1 = await u, o = n(d, {
                                        ...m,
                                        gain: 1
                                    });
                                    await c(p, d, o);
                                    const l = [];
                                    for(let e = 0; e < t1.numberOfChannels; e += 1)l.push(t1.getChannelData(e));
                                    let _ = [
                                        l[0][0],
                                        l[1][0],
                                        l[2][0]
                                    ], v = [
                                        l[3][0],
                                        l[4][0],
                                        l[5][0]
                                    ], y = n(d, {
                                        ...m,
                                        gain: 1
                                    }), x = i(d, {
                                        ...g,
                                        orientationX: _[0],
                                        orientationY: _[1],
                                        orientationZ: _[2],
                                        positionX: v[0],
                                        positionY: v[1],
                                        positionZ: v[2]
                                    });
                                    o.connect(y).connect(x.inputs[0]), x.connect(f);
                                    for(let e = 128; e < t1.length; e += 128){
                                        const t1 = [
                                            l[0][e],
                                            l[1][e],
                                            l[2][e]
                                        ], s1 = [
                                            l[3][e],
                                            l[4][e],
                                            l[5][e]
                                        ];
                                        if (t1.some((t1, e)=>t1 !== _[e]) || s1.some((t1, e)=>t1 !== v[e])) {
                                            _ = t1, v = s1;
                                            const r = e / d.sampleRate;
                                            y.gain.setValueAtTime(0, r), y = n(d, {
                                                ...m,
                                                gain: 0
                                            }), x = i(d, {
                                                ...g,
                                                orientationX: _[0],
                                                orientationY: _[1],
                                                orientationZ: _[2],
                                                positionX: v[0],
                                                positionY: v[1],
                                                positionZ: v[2]
                                            }), y.gain.setValueAtTime(1, r), o.connect(y).connect(x.inputs[0]), x.connect(f);
                                        }
                                    }
                                    return f;
                                }
                                return v ? (await t1(d, p.orientationX, _.orientationX), await t1(d, p.orientationY, _.orientationY), await t1(d, p.orientationZ, _.orientationZ), await t1(d, p.positionX, _.positionX), await t1(d, p.positionY, _.positionY), await t1(d, p.positionZ, _.positionZ)) : (await a(d, p.orientationX, _.orientationX), await a(d, p.orientationY, _.orientationY), await a(d, p.orientationZ, _.orientationZ), await a(d, p.positionX, _.positionX), await a(d, p.positionY, _.positionY), await a(d, p.positionZ, _.positionZ)), X(_) ? await c(p, d, _.inputs[0]) : await c(p, d, _), _;
                            })(p, d);
                        }
                    };
                })(Xe, as, ds, Bt, zs, tt, Ce, $e, Te, Cs), Bs = ((t1, e, s1, n, i, o, r)=>class extends t1 {
                    constructor(t1, a){
                        const c = i(t1), h = {
                            ...$t,
                            ...a
                        }, l = s1(c, h), u = o(c);
                        super(t1, !1, l, u ? n() : null), this._nativePannerNode = l, this._orientationX = e(this, u, l.orientationX, V, I), this._orientationY = e(this, u, l.orientationY, V, I), this._orientationZ = e(this, u, l.orientationZ, V, I), this._positionX = e(this, u, l.positionX, V, I), this._positionY = e(this, u, l.positionY, V, I), this._positionZ = e(this, u, l.positionZ, V, I), r(this, 1);
                    }
                    get coneInnerAngle() {
                        return this._nativePannerNode.coneInnerAngle;
                    }
                    set coneInnerAngle(t1) {
                        this._nativePannerNode.coneInnerAngle = t1;
                    }
                    get coneOuterAngle() {
                        return this._nativePannerNode.coneOuterAngle;
                    }
                    set coneOuterAngle(t1) {
                        this._nativePannerNode.coneOuterAngle = t1;
                    }
                    get coneOuterGain() {
                        return this._nativePannerNode.coneOuterGain;
                    }
                    set coneOuterGain(t1) {
                        this._nativePannerNode.coneOuterGain = t1;
                    }
                    get distanceModel() {
                        return this._nativePannerNode.distanceModel;
                    }
                    set distanceModel(t1) {
                        this._nativePannerNode.distanceModel = t1;
                    }
                    get maxDistance() {
                        return this._nativePannerNode.maxDistance;
                    }
                    set maxDistance(t1) {
                        this._nativePannerNode.maxDistance = t1;
                    }
                    get orientationX() {
                        return this._orientationX;
                    }
                    get orientationY() {
                        return this._orientationY;
                    }
                    get orientationZ() {
                        return this._orientationZ;
                    }
                    get panningModel() {
                        return this._nativePannerNode.panningModel;
                    }
                    set panningModel(t1) {
                        this._nativePannerNode.panningModel = t1;
                    }
                    get positionX() {
                        return this._positionX;
                    }
                    get positionY() {
                        return this._positionY;
                    }
                    get positionZ() {
                        return this._positionZ;
                    }
                    get refDistance() {
                        return this._nativePannerNode.refDistance;
                    }
                    set refDistance(t1) {
                        this._nativePannerNode.refDistance = t1;
                    }
                    get rolloffFactor() {
                        return this._nativePannerNode.rolloffFactor;
                    }
                    set rolloffFactor(t1) {
                        this._nativePannerNode.rolloffFactor = t1;
                    }
                })(Ve, Je, zs, Ws, ke, De, ns), Us = ((t1)=>(e, { disableNormalization: s1, imag: n, real: i })=>{
                    const o = n instanceof Float32Array ? n : new Float32Array(n), r = i instanceof Float32Array ? i : new Float32Array(i), a = e.createPeriodicWave(r, o, {
                        disableNormalization: s1
                    });
                    if (Array.from(n).length < 2) throw t1();
                    return a;
                })(R), Gs = ((t1, e, s1, n)=>class n {
                    constructor(n, i){
                        const o = e(n), r = ((t1)=>{
                            const { imag: e, real: s1 } = t1;
                            return void 0 === e ? void 0 === s1 ? {
                                ...t1,
                                imag: [
                                    0,
                                    0
                                ],
                                real: [
                                    0,
                                    0
                                ]
                            } : {
                                ...t1,
                                imag: Array.from(s1, ()=>0),
                                real: s1
                            } : void 0 === s1 ? {
                                ...t1,
                                imag: e,
                                real: Array.from(e, ()=>0)
                            } : {
                                ...t1,
                                imag: e,
                                real: s1
                            };
                        })({
                            ...Ht,
                            ...i
                        }), a = t1(o, r);
                        return s1.add(a), a;
                    }
                    static [Symbol.hasInstance](t1) {
                        return null !== t1 && "object" == typeof t1 && Object.getPrototypeOf(t1) === n.prototype || s1.has(t1);
                    }
                })(Us, ke, new WeakSet), Qs = ((t1, e, s1, n, i, o)=>{
                const r = 16385, a = new Float32Array([
                    1,
                    1
                ]), c = Math.PI / 2, h = {
                    channelCount: 1,
                    channelCountMode: "explicit",
                    channelInterpretation: "discrete"
                }, l = {
                    ...h,
                    oversample: "none"
                }, u = (t1, o, u, p, d)=>{
                    if (1 === o) return ((t1, e, i, o)=>{
                        const u = new Float32Array(r), p = new Float32Array(r);
                        for(let t1 = 0; t1 < r; t1 += 1){
                            const e = t1 / 16384 * c;
                            u[t1] = Math.cos(e), p[t1] = Math.sin(e);
                        }
                        const d = s1(t1, {
                            ...h,
                            gain: 0
                        }), f = n(t1, {
                            ...l,
                            curve: u
                        }), _ = n(t1, {
                            ...l,
                            curve: a
                        }), m = s1(t1, {
                            ...h,
                            gain: 0
                        }), g = n(t1, {
                            ...l,
                            curve: p
                        });
                        return {
                            connectGraph () {
                                e.connect(d), e.connect(void 0 === _.inputs ? _ : _.inputs[0]), e.connect(m), _.connect(i), i.connect(void 0 === f.inputs ? f : f.inputs[0]), i.connect(void 0 === g.inputs ? g : g.inputs[0]), f.connect(d.gain), g.connect(m.gain), d.connect(o, 0, 0), m.connect(o, 0, 1);
                            },
                            disconnectGraph () {
                                e.disconnect(d), e.disconnect(void 0 === _.inputs ? _ : _.inputs[0]), e.disconnect(m), _.disconnect(i), i.disconnect(void 0 === f.inputs ? f : f.inputs[0]), i.disconnect(void 0 === g.inputs ? g : g.inputs[0]), f.disconnect(d.gain), g.disconnect(m.gain), d.disconnect(o, 0, 0), m.disconnect(o, 0, 1);
                            }
                        };
                    })(t1, u, p, d);
                    if (2 === o) return ((t1, i, o, u)=>{
                        const p = new Float32Array(r), d = new Float32Array(r), f = new Float32Array(r), _ = new Float32Array(r), m = Math.floor(8192.5);
                        for(let t1 = 0; t1 < r; t1 += 1)if (t1 > m) {
                            const e = (t1 - m) / (16384 - m) * c;
                            p[t1] = Math.cos(e), d[t1] = Math.sin(e), f[t1] = 0, _[t1] = 1;
                        } else {
                            const e = t1 / (16384 - m) * c;
                            p[t1] = 1, d[t1] = 0, f[t1] = Math.cos(e), _[t1] = Math.sin(e);
                        }
                        const g = e(t1, {
                            channelCount: 2,
                            channelCountMode: "explicit",
                            channelInterpretation: "discrete",
                            numberOfOutputs: 2
                        }), v = s1(t1, {
                            ...h,
                            gain: 0
                        }), y = n(t1, {
                            ...l,
                            curve: p
                        }), x = s1(t1, {
                            ...h,
                            gain: 0
                        }), w = n(t1, {
                            ...l,
                            curve: d
                        }), b = n(t1, {
                            ...l,
                            curve: a
                        }), T = s1(t1, {
                            ...h,
                            gain: 0
                        }), S = n(t1, {
                            ...l,
                            curve: f
                        }), k = s1(t1, {
                            ...h,
                            gain: 0
                        }), A = n(t1, {
                            ...l,
                            curve: _
                        });
                        return {
                            connectGraph () {
                                i.connect(g), i.connect(void 0 === b.inputs ? b : b.inputs[0]), g.connect(v, 0), g.connect(x, 0), g.connect(T, 1), g.connect(k, 1), b.connect(o), o.connect(void 0 === y.inputs ? y : y.inputs[0]), o.connect(void 0 === w.inputs ? w : w.inputs[0]), o.connect(void 0 === S.inputs ? S : S.inputs[0]), o.connect(void 0 === A.inputs ? A : A.inputs[0]), y.connect(v.gain), w.connect(x.gain), S.connect(T.gain), A.connect(k.gain), v.connect(u, 0, 0), T.connect(u, 0, 0), x.connect(u, 0, 1), k.connect(u, 0, 1);
                            },
                            disconnectGraph () {
                                i.disconnect(g), i.disconnect(void 0 === b.inputs ? b : b.inputs[0]), g.disconnect(v, 0), g.disconnect(x, 0), g.disconnect(T, 1), g.disconnect(k, 1), b.disconnect(o), o.disconnect(void 0 === y.inputs ? y : y.inputs[0]), o.disconnect(void 0 === w.inputs ? w : w.inputs[0]), o.disconnect(void 0 === S.inputs ? S : S.inputs[0]), o.disconnect(void 0 === A.inputs ? A : A.inputs[0]), y.disconnect(v.gain), w.disconnect(x.gain), S.disconnect(T.gain), A.disconnect(k.gain), v.disconnect(u, 0, 0), T.disconnect(u, 0, 0), x.disconnect(u, 0, 1), k.disconnect(u, 0, 1);
                            }
                        };
                    })(t1, u, p, d);
                    throw i();
                };
                return (e, { channelCount: n, channelCountMode: r, pan: a, ...c })=>{
                    if ("max" === r) throw i();
                    const h = t1(e, {
                        ...c,
                        channelCount: 1,
                        channelCountMode: r,
                        numberOfInputs: 2
                    }), l = s1(e, {
                        ...c,
                        channelCount: n,
                        channelCountMode: r,
                        gain: 1
                    }), p = s1(e, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        gain: a
                    });
                    let { connectGraph: d, disconnectGraph: f } = u(e, n, l, p, h);
                    Object.defineProperty(p.gain, "defaultValue", {
                        get: ()=>0
                    }), Object.defineProperty(p.gain, "maxValue", {
                        get: ()=>1
                    }), Object.defineProperty(p.gain, "minValue", {
                        get: ()=>-1
                    });
                    const _ = {
                        get bufferSize () {},
                        get channelCount () {
                            return l.channelCount;
                        },
                        set channelCount (t){
                            l.channelCount !== t && (m && f(), { connectGraph: d, disconnectGraph: f } = u(e, t, l, p, h), m && d()), l.channelCount = t;
                        },
                        get channelCountMode () {
                            return l.channelCountMode;
                        },
                        set channelCountMode (t){
                            if ("clamped-max" === t || "max" === t) throw i();
                            l.channelCountMode = t;
                        },
                        get channelInterpretation () {
                            return l.channelInterpretation;
                        },
                        set channelInterpretation (t){
                            l.channelInterpretation = t;
                        },
                        get context () {
                            return l.context;
                        },
                        get inputs () {
                            return [
                                l
                            ];
                        },
                        get numberOfInputs () {
                            return l.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return l.numberOfOutputs;
                        },
                        get pan () {
                            return p.gain;
                        },
                        addEventListener: (...t1)=>l.addEventListener(t1[0], t1[1], t1[2]),
                        dispatchEvent: (...t1)=>l.dispatchEvent(t1[0]),
                        removeEventListener: (...t1)=>l.removeEventListener(t1[0], t1[1], t1[2])
                    };
                    let m = !1;
                    return o(zt(_, h), ()=>{
                        d(), m = !0;
                    }, ()=>{
                        f(), m = !1;
                    });
                };
            })(as, Lt, Bt, js, Zt, os), Zs = ((t1, e)=>(s1, n)=>{
                    const i = n.channelCountMode;
                    if ("clamped-max" === i) throw e();
                    if (void 0 === s1.createStereoPanner) return t1(s1, n);
                    const o = s1.createStereoPanner();
                    return qt(o, n), It(o, n, "pan"), Object.defineProperty(o, "channelCountMode", {
                        get: ()=>i,
                        set: (t1)=>{
                            if (t1 !== i) throw e();
                        }
                    }), o;
                })(Qs, Zt), Xs = ((t1, e, s1, n, i)=>()=>{
                    const o = new WeakMap;
                    return {
                        render (r, a) {
                            const c = o.get(a);
                            return void 0 !== c ? Promise.resolve(c) : (async (r, a)=>{
                                let c = s1(r);
                                const h = M(c, a);
                                if (!h) {
                                    const t1 = {
                                        channelCount: c.channelCount,
                                        channelCountMode: c.channelCountMode,
                                        channelInterpretation: c.channelInterpretation,
                                        pan: c.pan.value
                                    };
                                    c = e(a, t1);
                                }
                                return o.set(a, c), h ? await t1(a, r.pan, c.pan) : await n(a, r.pan, c.pan), X(c) ? await i(r, a, c.inputs[0]) : await i(r, a, c), c;
                            })(r, a);
                        }
                    };
                })(Xe, Zs, tt, $e, Te), Ys = ((t1, e, s1, n, i, o)=>class extends t1 {
                    constructor(t1, r){
                        const a = i(t1), c = {
                            ...Jt,
                            ...r
                        }, h = s1(a, c), l = o(a);
                        super(t1, !1, h, l ? n() : null), this._pan = e(this, l, h.pan);
                    }
                    get pan() {
                        return this._pan;
                    }
                })(Ve, Je, Zs, Xs, ke, De), $s = ((t1, e, s1)=>()=>{
                    const n = new WeakMap;
                    return {
                        render (i, o) {
                            const r = n.get(o);
                            return void 0 !== r ? Promise.resolve(r) : (async (i, o)=>{
                                let r = e(i);
                                if (!M(r, o)) {
                                    const e = {
                                        channelCount: r.channelCount,
                                        channelCountMode: r.channelCountMode,
                                        channelInterpretation: r.channelInterpretation,
                                        curve: r.curve,
                                        oversample: r.oversample
                                    };
                                    r = t1(o, e);
                                }
                                return n.set(o, r), X(r) ? await s1(i, o, r.inputs[0]) : await s1(i, o, r), r;
                            })(i, o);
                        }
                    };
                })(js, tt, Te), Hs = ((t1, e, s1, n, i, o, r)=>class extends t1 {
                    constructor(t1, e){
                        const a = i(t1), c = {
                            ...te,
                            ...e
                        }, h = s1(a, c);
                        super(t1, !0, h, o(a) ? n() : null), this._isCurveNullified = !1, this._nativeWaveShaperNode = h, r(this, 1);
                    }
                    get curve() {
                        return this._isCurveNullified ? null : this._nativeWaveShaperNode.curve;
                    }
                    set curve(t1) {
                        if (null === t1) this._isCurveNullified = !0, this._nativeWaveShaperNode.curve = new Float32Array([
                            0,
                            0
                        ]);
                        else {
                            if (t1.length < 2) throw e();
                            this._isCurveNullified = !1, this._nativeWaveShaperNode.curve = t1;
                        }
                    }
                    get oversample() {
                        return this._nativeWaveShaperNode.oversample;
                    }
                    set oversample(t1) {
                        this._nativeWaveShaperNode.oversample = t1;
                    }
                })(Ve, At, js, $s, ke, De, ns), Js = ((t1)=>null !== t1 && t1.isSecureContext)(xe), Ks = ((t1)=>(e, s1, n)=>{
                    Object.defineProperties(t1, {
                        currentFrame: {
                            configurable: !0,
                            get: ()=>Math.round(e * s1)
                        },
                        currentTime: {
                            configurable: !0,
                            get: ()=>e
                        }
                    });
                    try {
                        return n();
                    } finally{
                        null !== t1 && (delete t1.currentFrame, delete t1.currentTime);
                    }
                })(xe), tn = new WeakMap, en = ((t1, e)=>(s1)=>{
                    let n = t1.get(s1);
                    if (void 0 !== n) return n;
                    if (null === e) throw new Error("Missing the native OfflineAudioContext constructor.");
                    return n = new e(1, 1, 44100), t1.set(s1, n), n;
                })(tn, Ce), sn = Js ? ((t1, e, s1, n, i, o, r, a, c, h, l, u, p)=>{
                let d = 0;
                return (_, m, g = {
                    credentials: "omit"
                })=>{
                    const w = l.get(_);
                    if (void 0 !== w && w.has(m)) return Promise.resolve();
                    const b = h.get(_);
                    if (void 0 !== b) {
                        const t1 = b.get(m);
                        if (void 0 !== t1) return t1;
                    }
                    const T = o(_), S = void 0 === T.audioWorklet ? i(m).then(([t1, e])=>{
                        const [n, i] = v(t1, e);
                        return s1(`${n};((a,b)=>{(a[b]=a[b]||[]).push((AudioWorkletProcessor,global,registerProcessor,sampleRate,self,window)=>{${i}\n})})(window,'_AWGS')`);
                    }).then(()=>{
                        const t1 = p._AWGS.pop();
                        if (void 0 === t1) throw new SyntaxError;
                        n(T.currentTime, T.sampleRate, ()=>t1(class {
                            }, void 0, (t1, s1)=>{
                                if ("" === t1.trim()) throw e();
                                const n = f.get(T);
                                if (void 0 !== n) {
                                    if (n.has(t1)) throw e();
                                    x(s1), y(s1.parameterDescriptors), n.set(t1, s1);
                                } else x(s1), y(s1.parameterDescriptors), f.set(T, new Map([
                                    [
                                        t1,
                                        s1
                                    ]
                                ]));
                            }, T.sampleRate, void 0, void 0));
                    }) : Promise.all([
                        i(m),
                        Promise.resolve(t1(u, u))
                    ]).then(([[t1, e], s1])=>{
                        const n = d + 1;
                        d = n;
                        const [i, o] = v(t1, e), h = new Blob([
                            `${i};((AudioWorkletProcessor,registerProcessor)=>{${o}\n})(${s1 ? "AudioWorkletProcessor" : "class extends AudioWorkletProcessor {__b=new WeakSet();constructor(){super();(p=>p.postMessage=(q=>(m,t)=>q.call(p,m,t?t.filter(u=>!this.__b.has(u)):t))(p.postMessage))(this.port)}}"},(n,p)=>registerProcessor(n,class extends p{${s1 ? "" : "__c = (a) => a.forEach(e=>this.__b.add(e.buffer));"}process(i,o,p){${s1 ? "" : "i.forEach(this.__c);o.forEach(this.__c);this.__c(Object.values(p));"}return super.process(i.map(j=>j.some(k=>k.length===0)?[]:j),o,p)}}));registerProcessor('__sac${n}',class extends AudioWorkletProcessor{process(){return !1}})`
                        ], {
                            type: "application/javascript; charset=utf-8"
                        }), l = URL.createObjectURL(h);
                        return T.audioWorklet.addModule(l, g).then(()=>{
                            if (a(T)) return T;
                            const t1 = r(T);
                            return t1.audioWorklet.addModule(l, g).then(()=>t1);
                        }).then((t1)=>{
                            if (null === c) throw new SyntaxError;
                            try {
                                new c(t1, `__sac${n}`);
                            } catch  {
                                throw new SyntaxError;
                            }
                        }).finally(()=>URL.revokeObjectURL(l));
                    });
                    return void 0 === b ? h.set(_, new Map([
                        [
                            m,
                            S
                        ]
                    ])) : b.set(m, S), S.then(()=>{
                        const t1 = l.get(_);
                        void 0 === t1 ? l.set(_, new Set([
                            m
                        ])) : t1.add(m);
                    }).finally(()=>{
                        const t1 = h.get(_);
                        void 0 !== t1 && t1.delete(m);
                    }), S;
                };
            })(ge, Zt, ((t1)=>(e)=>new Promise((s1, n)=>{
                        if (null === t1) return void n(new SyntaxError);
                        const i = t1.document.head;
                        if (null === i) n(new SyntaxError);
                        else {
                            const o = t1.document.createElement("script"), r = new Blob([
                                e
                            ], {
                                type: "application/javascript"
                            }), a = URL.createObjectURL(r), c = t1.onerror, h = ()=>{
                                t1.onerror = c, URL.revokeObjectURL(a);
                            };
                            t1.onerror = (e, s1, i, o, r)=>s1 === a || s1 === t1.location.href && 1 === i && 1 === o ? (h(), n(r), !1) : null !== c ? c(e, s1, i, o, r) : void 0, o.onerror = ()=>{
                                h(), n(new SyntaxError);
                            }, o.onload = ()=>{
                                h(), s1();
                            }, o.src = a, o.type = "module", i.appendChild(o);
                        }
                    }))(xe), Ks, async (t1)=>{
                try {
                    const e = await fetch(t1);
                    if (e.ok) return [
                        await e.text(),
                        e.url
                    ];
                } catch  {}
                throw new DOMException("", "AbortError");
            }, ke, en, De, Ie, new WeakMap, new WeakMap, ((t1, e)=>async ()=>{
                    if (null === t1) return !0;
                    if (null === e) return !1;
                    const s1 = new Blob([
                        'class A extends AudioWorkletProcessor{process(i){this.port.postMessage(i,[i[0][0].buffer])}}registerProcessor("a",A)'
                    ], {
                        type: "application/javascript; charset=utf-8"
                    }), n = new e(1, 128, 44100), i = URL.createObjectURL(s1);
                    let o = !1, r = !1;
                    try {
                        await n.audioWorklet.addModule(i);
                        const e = new t1(n, "a", {
                            numberOfOutputs: 0
                        }), s1 = n.createOscillator();
                        e.port.onmessage = ()=>o = !0, e.onprocessorerror = ()=>r = !0, s1.connect(e), s1.start(0), await n.startRendering(), await new Promise((t1)=>setTimeout(t1));
                    } catch  {} finally{
                        URL.revokeObjectURL(i);
                    }
                    return o && !r;
                })(Ie, Ce), xe) : void 0, nn = ((t1, e)=>(s1)=>t1(s1) || e(s1))(Re, De), on = ((t1, e, s1, n, i, o, r, a, c, h, l)=>(s1, n)=>{
                    const u = r(s1) ? s1 : o(s1);
                    if (i.has(n)) {
                        const t1 = new DOMException("", "DataCloneError");
                        return Promise.reject(t1);
                    }
                    try {
                        i.add(n);
                    } catch  {}
                    return e(c, ()=>c(u)) ? u.decodeAudioData(n).then((s1)=>(wt(n).catch(()=>{}), e(a, ()=>a(s1)) || l(s1), t1.add(s1), s1)) : new Promise((e, s1)=>{
                        const i = async ()=>{
                            try {
                                await wt(n);
                            } catch  {}
                        }, o = (t1)=>{
                            s1(t1), i();
                        };
                        try {
                            u.decodeAudioData(n, (s1)=>{
                                "function" != typeof s1.copyFromChannel && (h(s1), q(s1)), t1.add(s1), i().then(()=>e(s1));
                            }, (t1)=>{
                                o(null === t1 ? new DOMException("", "EncodingError") : t1);
                            });
                        } catch (t1) {
                            o(t1);
                        }
                    });
                })(je, ge, 0, 0, new WeakSet, ke, nn, E, Et, Be, Ue), rn = ((t1, e, s1, n, i, o, r, a, c, h, l, u, p, d, f, _, m, g, v, y)=>class extends f {
                    constructor(e, s1){
                        super(e, s1), this._nativeContext = e, this._audioWorklet = void 0 === t1 ? void 0 : {
                            addModule: (e, s1)=>t1(this, e, s1)
                        };
                    }
                    get audioWorklet() {
                        return this._audioWorklet;
                    }
                    createAnalyser() {
                        return new e(this);
                    }
                    createBiquadFilter() {
                        return new i(this);
                    }
                    createBuffer(t1, e, n) {
                        return new s1({
                            length: e,
                            numberOfChannels: t1,
                            sampleRate: n
                        });
                    }
                    createBufferSource() {
                        return new n(this);
                    }
                    createChannelMerger(t1 = 6) {
                        return new o(this, {
                            numberOfInputs: t1
                        });
                    }
                    createChannelSplitter(t1 = 6) {
                        return new r(this, {
                            numberOfOutputs: t1
                        });
                    }
                    createConstantSource() {
                        return new a(this);
                    }
                    createConvolver() {
                        return new c(this);
                    }
                    createDelay(t1 = 1) {
                        return new l(this, {
                            maxDelayTime: t1
                        });
                    }
                    createDynamicsCompressor() {
                        return new u(this);
                    }
                    createGain() {
                        return new p(this);
                    }
                    createIIRFilter(t1, e) {
                        return new d(this, {
                            feedback: e,
                            feedforward: t1
                        });
                    }
                    createOscillator() {
                        return new _(this);
                    }
                    createPanner() {
                        return new m(this);
                    }
                    createPeriodicWave(t1, e, s1 = {
                        disableNormalization: !1
                    }) {
                        return new g(this, {
                            ...s1,
                            imag: e,
                            real: t1
                        });
                    }
                    createStereoPanner() {
                        return new v(this);
                    }
                    createWaveShaper() {
                        return new y(this);
                    }
                    decodeAudioData(t1, e, s1) {
                        return h(this._nativeContext, t1).then((t1)=>("function" == typeof e && e(t1), t1), (t1)=>{
                            throw "function" == typeof s1 && s1(t1), t1;
                        });
                    }
                })(sn, Pe, Ge, ts, is, hs, us, _s, vs, on, xs, Ts, ks, Ms, qs, Vs, Bs, Gs, Ys, Hs), an = ((t1, e, s1, n)=>class extends t1 {
                    constructor(t1, e){
                        const i = s1(t1), o = ((t1, e)=>t1.createMediaElementSource(e.mediaElement))(i, e);
                        if (n(i)) throw TypeError();
                        super(t1, !0, o, null), this._nativeMediaElementAudioSourceNode = o;
                    }
                    get mediaElement() {
                        return this._nativeMediaElementAudioSourceNode.mediaElement;
                    }
                })(Ve, 0, ke, De), cn = ((t1, e, s1, n)=>class extends t1 {
                    constructor(t1, e){
                        const i = s1(t1);
                        if (n(i)) throw new TypeError;
                        const o = ((t1, e)=>{
                            const s1 = t1.createMediaStreamDestination();
                            return qt(s1, e), 1 === s1.numberOfOutputs && Object.defineProperty(s1, "numberOfOutputs", {
                                get: ()=>0
                            }), s1;
                        })(i, {
                            ...Mt,
                            ...e
                        });
                        super(t1, !1, o, null), this._nativeMediaStreamAudioDestinationNode = o;
                    }
                    get stream() {
                        return this._nativeMediaStreamAudioDestinationNode.stream;
                    }
                })(Ve, 0, ke, De), hn = ((t1, e, s1, n)=>class extends t1 {
                    constructor(t1, e){
                        const i = s1(t1), o = ((t1, { mediaStream: e })=>{
                            const s1 = e.getAudioTracks();
                            s1.sort((t1, e)=>t1.id < e.id ? -1 : t1.id > e.id ? 1 : 0);
                            const n = s1.slice(0, 1), i = t1.createMediaStreamSource(new MediaStream(n));
                            return Object.defineProperty(i, "mediaStream", {
                                value: e
                            }), i;
                        })(i, e);
                        if (n(i)) throw new TypeError;
                        super(t1, !0, o, null), this._nativeMediaStreamAudioSourceNode = o;
                    }
                    get mediaStream() {
                        return this._nativeMediaStreamAudioSourceNode.mediaStream;
                    }
                })(Ve, 0, ke, De), ln = ((t1, e)=>(s1, { mediaStreamTrack: n })=>{
                    if ("function" == typeof s1.createMediaStreamTrackSource) return s1.createMediaStreamTrackSource(n);
                    const i = new MediaStream([
                        n
                    ]), o = s1.createMediaStreamSource(i);
                    if ("audio" !== n.kind) throw t1();
                    if (e(s1)) throw new TypeError;
                    return o;
                })(At, De), un = ((t1, e, s1)=>class extends t1 {
                    constructor(t1, n){
                        const i = s1(t1);
                        super(t1, !0, e(i, n), null);
                    }
                })(Ve, ln, ke), pn = ((t1, e, s1, n, i, o, r, a, c)=>class extends t1 {
                    constructor(t1 = {}){
                        if (null === c) throw new Error("Missing the native AudioContext constructor.");
                        let e;
                        try {
                            e = new c(t1);
                        } catch (t1) {
                            if (12 === t1.code && "sampleRate is not in range" === t1.message) throw s1();
                            throw t1;
                        }
                        if (null === e) throw n();
                        if (!((t1)=>void 0 === t1 || "number" == typeof t1 || "string" == typeof t1 && ("balanced" === t1 || "interactive" === t1 || "playback" === t1))(t1.latencyHint)) throw new TypeError(`The provided value '${t1.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
                        if (void 0 !== t1.sampleRate && e.sampleRate !== t1.sampleRate) throw s1();
                        super(e, 2);
                        const { latencyHint: i } = t1, { sampleRate: o } = e;
                        if (this._baseLatency = "number" == typeof e.baseLatency ? e.baseLatency : "balanced" === i ? 512 / o : "interactive" === i || void 0 === i ? 256 / o : "playback" === i ? 1024 / o : 128 * Math.max(2, Math.min(128, Math.round(i * o / 128))) / o, this._nativeAudioContext = e, "webkitAudioContext" === c.name ? (this._nativeGainNode = e.createGain(), this._nativeOscillatorNode = e.createOscillator(), this._nativeGainNode.gain.value = 1e-37, this._nativeOscillatorNode.connect(this._nativeGainNode).connect(e.destination), this._nativeOscillatorNode.start()) : (this._nativeGainNode = null, this._nativeOscillatorNode = null), this._state = null, "running" === e.state) {
                            this._state = "suspended";
                            const t1 = ()=>{
                                "suspended" === this._state && (this._state = null), e.removeEventListener("statechange", t1);
                            };
                            e.addEventListener("statechange", t1);
                        }
                    }
                    get baseLatency() {
                        return this._baseLatency;
                    }
                    get state() {
                        return null !== this._state ? this._state : this._nativeAudioContext.state;
                    }
                    close() {
                        return "closed" === this.state ? this._nativeAudioContext.close().then(()=>{
                            throw e();
                        }) : ("suspended" === this._state && (this._state = null), this._nativeAudioContext.close().then(()=>{
                            null !== this._nativeGainNode && null !== this._nativeOscillatorNode && (this._nativeOscillatorNode.stop(), this._nativeGainNode.disconnect(), this._nativeOscillatorNode.disconnect()), W(this);
                        }));
                    }
                    createMediaElementSource(t1) {
                        return new i(this, {
                            mediaElement: t1
                        });
                    }
                    createMediaStreamDestination() {
                        return new o(this);
                    }
                    createMediaStreamSource(t1) {
                        return new r(this, {
                            mediaStream: t1
                        });
                    }
                    createMediaStreamTrackSource(t1) {
                        return new a(this, {
                            mediaStreamTrack: t1
                        });
                    }
                    resume() {
                        return "suspended" === this._state ? new Promise((t1, e)=>{
                            const s1 = ()=>{
                                this._nativeAudioContext.removeEventListener("statechange", s1), "running" === this._nativeAudioContext.state ? t1() : this.resume().then(t1, e);
                            };
                            this._nativeAudioContext.addEventListener("statechange", s1);
                        }) : this._nativeAudioContext.resume().catch((t1)=>{
                            if (void 0 === t1 || 15 === t1.code) throw e();
                            throw t1;
                        });
                    }
                    suspend() {
                        return this._nativeAudioContext.suspend().catch((t1)=>{
                            if (void 0 === t1) throw e();
                            throw t1;
                        });
                    }
                })(rn, At, Zt, Kt, an, cn, hn, un, Ee), dn = ((t1)=>(e)=>{
                    const s1 = t1.get(e);
                    if (void 0 === s1) throw new Error("The context has no set of AudioWorkletNodes.");
                    return s1;
                })(Rs), fn = ((t1)=>(e, s1)=>{
                    t1(e).add(s1);
                })(dn), _n = ((t1)=>(e, s1, n = 0, i = 0)=>{
                    const o = e[n];
                    if (void 0 === o) throw t1();
                    return rt(s1) ? o.connect(s1, 0, i) : o.connect(s1, 0);
                })(R), mn = ((t1)=>(e, s1)=>{
                    t1(e).delete(s1);
                })(dn), gn = ((t1)=>(e, s1, n, i = 0)=>void 0 === s1 ? e.forEach((t1)=>t1.disconnect()) : "number" == typeof s1 ? Tt(t1, e, s1).disconnect() : rt(s1) ? void 0 === n ? e.forEach((t1)=>t1.disconnect(s1)) : void 0 === i ? Tt(t1, e, n).disconnect(s1, 0) : Tt(t1, e, n).disconnect(s1, 0, i) : void 0 === n ? e.forEach((t1)=>t1.disconnect(s1)) : Tt(t1, e, n).disconnect(s1, 0))(R), vn = new WeakMap, yn = ((t1, e)=>(s1)=>e(t1, s1))(vn, w), xn = ((t1, e, s1, n, i, o, r, a, c, h, l, u, p)=>(d, f, m, g)=>{
                    if (0 === g.numberOfInputs && 0 === g.numberOfOutputs) throw c();
                    const v = Array.isArray(g.outputChannelCount) ? g.outputChannelCount : Array.from(g.outputChannelCount);
                    if (v.some((t1)=>t1 < 1)) throw c();
                    if (v.length !== g.numberOfOutputs) throw e();
                    if ("explicit" !== g.channelCountMode) throw c();
                    const y = g.channelCount * g.numberOfInputs, x = v.reduce((t1, e)=>t1 + e, 0), w = void 0 === m.parameterDescriptors ? 0 : m.parameterDescriptors.length;
                    if (y + w > 6 || x > 6) throw c();
                    const b = new MessageChannel, T = [], S = [];
                    for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1)T.push(r(d, {
                        channelCount: g.channelCount,
                        channelCountMode: g.channelCountMode,
                        channelInterpretation: g.channelInterpretation,
                        gain: 1
                    })), S.push(i(d, {
                        channelCount: g.channelCount,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        numberOfOutputs: g.channelCount
                    }));
                    const k = [];
                    if (void 0 !== m.parameterDescriptors) for (const { defaultValue: t1, maxValue: e, minValue: s1, name: n } of m.parameterDescriptors){
                        const i = o(d, {
                            channelCount: 1,
                            channelCountMode: "explicit",
                            channelInterpretation: "discrete",
                            offset: void 0 !== g.parameterData[n] ? g.parameterData[n] : void 0 === t1 ? 0 : t1
                        });
                        Object.defineProperties(i.offset, {
                            defaultValue: {
                                get: ()=>void 0 === t1 ? 0 : t1
                            },
                            maxValue: {
                                get: ()=>void 0 === e ? V : e
                            },
                            minValue: {
                                get: ()=>void 0 === s1 ? I : s1
                            }
                        }), k.push(i);
                    }
                    const A = n(d, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "speakers",
                        numberOfInputs: Math.max(1, y + w)
                    }), C = Pt(f, d.sampleRate), D = a(d, C, y + w, Math.max(1, x)), O = i(d, {
                        channelCount: Math.max(1, x),
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        numberOfOutputs: Math.max(1, x)
                    }), M = [];
                    for(let t1 = 0; t1 < g.numberOfOutputs; t1 += 1)M.push(n(d, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "speakers",
                        numberOfInputs: v[t1]
                    }));
                    for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1){
                        T[t1].connect(S[t1]);
                        for(let e = 0; e < g.channelCount; e += 1)S[t1].connect(A, e, t1 * g.channelCount + e);
                    }
                    const E = new lt(void 0 === m.parameterDescriptors ? [] : m.parameterDescriptors.map(({ name: t1 }, e)=>{
                        const s1 = k[e];
                        return s1.connect(A, 0, y + e), s1.start(0), [
                            t1,
                            s1.offset
                        ];
                    }));
                    A.connect(D);
                    let R = g.channelInterpretation, q = null;
                    const F = 0 === g.numberOfOutputs ? [
                        D
                    ] : M, N = {
                        get bufferSize () {
                            return C;
                        },
                        get channelCount () {
                            return g.channelCount;
                        },
                        set channelCount (t){
                            throw s1();
                        },
                        get channelCountMode () {
                            return g.channelCountMode;
                        },
                        set channelCountMode (t){
                            throw s1();
                        },
                        get channelInterpretation () {
                            return R;
                        },
                        set channelInterpretation (t){
                            for (const e of T)e.channelInterpretation = t;
                            R = t;
                        },
                        get context () {
                            return D.context;
                        },
                        get inputs () {
                            return T;
                        },
                        get numberOfInputs () {
                            return g.numberOfInputs;
                        },
                        get numberOfOutputs () {
                            return g.numberOfOutputs;
                        },
                        get onprocessorerror () {
                            return q;
                        },
                        set onprocessorerror (t){
                            "function" == typeof q && N.removeEventListener("processorerror", q), q = "function" == typeof t ? t : null, "function" == typeof q && N.addEventListener("processorerror", q);
                        },
                        get parameters () {
                            return E;
                        },
                        get port () {
                            return b.port2;
                        },
                        addEventListener: (...t1)=>D.addEventListener(t1[0], t1[1], t1[2]),
                        connect: t1.bind(null, F),
                        disconnect: h.bind(null, F),
                        dispatchEvent: (...t1)=>D.dispatchEvent(t1[0]),
                        removeEventListener: (...t1)=>D.removeEventListener(t1[0], t1[1], t1[2])
                    }, P = new Map;
                    var j, L;
                    b.port1.addEventListener = (j = b.port1.addEventListener, (...t1)=>{
                        if ("message" === t1[0]) {
                            const e = "function" == typeof t1[1] ? t1[1] : "object" == typeof t1[1] && null !== t1[1] && "function" == typeof t1[1].handleEvent ? t1[1].handleEvent : null;
                            if (null !== e) {
                                const s1 = P.get(t1[1]);
                                void 0 !== s1 ? t1[1] = s1 : (t1[1] = (t1)=>{
                                    l(d.currentTime, d.sampleRate, ()=>e(t1));
                                }, P.set(e, t1[1]));
                            }
                        }
                        return j.call(b.port1, t1[0], t1[1], t1[2]);
                    }), b.port1.removeEventListener = (L = b.port1.removeEventListener, (...t1)=>{
                        if ("message" === t1[0]) {
                            const e = P.get(t1[1]);
                            void 0 !== e && (P.delete(t1[1]), t1[1] = e);
                        }
                        return L.call(b.port1, t1[0], t1[1], t1[2]);
                    });
                    let z = null;
                    Object.defineProperty(b.port1, "onmessage", {
                        get: ()=>z,
                        set: (t1)=>{
                            "function" == typeof z && b.port1.removeEventListener("message", z), z = "function" == typeof t1 ? t1 : null, "function" == typeof z && (b.port1.addEventListener("message", z), b.port1.start());
                        }
                    }), m.prototype.port = b.port1;
                    let W = null;
                    const B = ((t1, e, s1, n)=>{
                        let i = _.get(t1);
                        void 0 === i && (i = new WeakMap, _.set(t1, i));
                        const o = (async (t1, e)=>{
                            const s1 = await ((t1)=>new Promise((e, s1)=>{
                                    const { port1: n, port2: i } = new MessageChannel;
                                    n.onmessage = ({ data: t1 })=>{
                                        n.close(), i.close(), e(t1);
                                    }, n.onmessageerror = ({ data: t1 })=>{
                                        n.close(), i.close(), s1(t1);
                                    }, i.postMessage(t1);
                                }))(e);
                            return new t1(s1);
                        })(s1, n);
                        return i.set(e, o), o;
                    })(d, N, m, g);
                    B.then((t1)=>W = t1);
                    const U = ft(g.numberOfInputs, g.channelCount), G = ft(g.numberOfOutputs, v), Q = void 0 === m.parameterDescriptors ? [] : m.parameterDescriptors.reduce((t1, { name: e })=>({
                            ...t1,
                            [e]: new Float32Array(128)
                        }), {});
                    let Z = !0;
                    const X = ()=>{
                        g.numberOfOutputs > 0 && D.disconnect(O);
                        for(let t1 = 0, e = 0; t1 < g.numberOfOutputs; t1 += 1){
                            const s1 = M[t1];
                            for(let n = 0; n < v[t1]; n += 1)O.disconnect(s1, e + n, n);
                            e += v[t1];
                        }
                    }, Y = new Map;
                    D.onaudioprocess = ({ inputBuffer: t1, outputBuffer: e })=>{
                        if (null !== W) {
                            const s1 = u(N);
                            for(let n = 0; n < C; n += 128){
                                for(let e = 0; e < g.numberOfInputs; e += 1)for(let s1 = 0; s1 < g.channelCount; s1 += 1)pt(t1, U[e], s1, s1, n);
                                void 0 !== m.parameterDescriptors && m.parameterDescriptors.forEach(({ name: e }, s1)=>{
                                    pt(t1, Q, e, y + s1, n);
                                });
                                for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1)for(let e = 0; e < v[t1]; e += 1)0 === G[t1][e].byteLength && (G[t1][e] = new Float32Array(128));
                                try {
                                    const t1 = U.map((t1, e)=>{
                                        if (s1[e].size > 0) return Y.set(e, C / 128), t1;
                                        const n = Y.get(e);
                                        return void 0 === n ? [] : (t1.every((t1)=>t1.every((t1)=>0 === t1)) && (1 === n ? Y.delete(e) : Y.set(e, n - 1)), t1);
                                    }), i = l(d.currentTime + n / d.sampleRate, d.sampleRate, ()=>W.process(t1, G, Q));
                                    Z = i;
                                    for(let t1 = 0, s1 = 0; t1 < g.numberOfOutputs; t1 += 1){
                                        for(let i = 0; i < v[t1]; i += 1)dt(e, G[t1], i, s1 + i, n);
                                        s1 += v[t1];
                                    }
                                } catch (t1) {
                                    Z = !1, N.dispatchEvent(new ErrorEvent("processorerror", {
                                        colno: t1.colno,
                                        filename: t1.filename,
                                        lineno: t1.lineno,
                                        message: t1.message
                                    }));
                                }
                                if (!Z) {
                                    for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1){
                                        T[t1].disconnect(S[t1]);
                                        for(let e = 0; e < g.channelCount; e += 1)S[n].disconnect(A, e, t1 * g.channelCount + e);
                                    }
                                    if (void 0 !== m.parameterDescriptors) {
                                        const t1 = m.parameterDescriptors.length;
                                        for(let e = 0; e < t1; e += 1){
                                            const t1 = k[e];
                                            t1.disconnect(A, 0, y + e), t1.stop();
                                        }
                                    }
                                    A.disconnect(D), D.onaudioprocess = null, $ ? X() : K();
                                    break;
                                }
                            }
                        }
                    };
                    let $ = !1;
                    const H = r(d, {
                        channelCount: 1,
                        channelCountMode: "explicit",
                        channelInterpretation: "discrete",
                        gain: 0
                    }), J = ()=>D.connect(H).connect(d.destination), K = ()=>{
                        D.disconnect(H), H.disconnect();
                    };
                    return J(), p(N, ()=>{
                        if (Z) {
                            K(), g.numberOfOutputs > 0 && D.connect(O);
                            for(let t1 = 0, e = 0; t1 < g.numberOfOutputs; t1 += 1){
                                const s1 = M[t1];
                                for(let n = 0; n < v[t1]; n += 1)O.connect(s1, e + n, n);
                                e += v[t1];
                            }
                        }
                        $ = !0;
                    }, ()=>{
                        Z && (J(), X()), $ = !1;
                    });
                })(_n, R, At, as, Lt, ds, Bt, Qt, Zt, gn, Ks, yn, os), wn = ((t1, e, s1, n, i)=>(o, r, a, c, h, l)=>{
                    if (null !== a) try {
                        const e = new a(o, c, l), n = new Map;
                        let r = null;
                        if (Object.defineProperties(e, {
                            channelCount: {
                                get: ()=>l.channelCount,
                                set: ()=>{
                                    throw t1();
                                }
                            },
                            channelCountMode: {
                                get: ()=>"explicit",
                                set: ()=>{
                                    throw t1();
                                }
                            },
                            onprocessorerror: {
                                get: ()=>r,
                                set: (t1)=>{
                                    "function" == typeof r && e.removeEventListener("processorerror", r), r = "function" == typeof t1 ? t1 : null, "function" == typeof r && e.addEventListener("processorerror", r);
                                }
                            }
                        }), e.addEventListener = (p = e.addEventListener, (...t1)=>{
                            if ("processorerror" === t1[0]) {
                                const e = "function" == typeof t1[1] ? t1[1] : "object" == typeof t1[1] && null !== t1[1] && "function" == typeof t1[1].handleEvent ? t1[1].handleEvent : null;
                                if (null !== e) {
                                    const s1 = n.get(t1[1]);
                                    void 0 !== s1 ? t1[1] = s1 : (t1[1] = (s1)=>{
                                        "error" === s1.type ? (Object.defineProperties(s1, {
                                            type: {
                                                value: "processorerror"
                                            }
                                        }), e(s1)) : e(new ErrorEvent(t1[0], {
                                            ...s1
                                        }));
                                    }, n.set(e, t1[1]));
                                }
                            }
                            return p.call(e, "error", t1[1], t1[2]), p.call(e, ...t1);
                        }), e.removeEventListener = (u = e.removeEventListener, (...t1)=>{
                            if ("processorerror" === t1[0]) {
                                const e = n.get(t1[1]);
                                void 0 !== e && (n.delete(t1[1]), t1[1] = e);
                            }
                            return u.call(e, "error", t1[1], t1[2]), u.call(e, t1[0], t1[1], t1[2]);
                        }), 0 !== l.numberOfOutputs) {
                            const t1 = s1(o, {
                                channelCount: 1,
                                channelCountMode: "explicit",
                                channelInterpretation: "discrete",
                                gain: 0
                            });
                            return e.connect(t1).connect(o.destination), i(e, ()=>t1.disconnect(), ()=>t1.connect(o.destination));
                        }
                        return e;
                    } catch (t1) {
                        if (11 === t1.code) throw n();
                        throw t1;
                    }
                    var u, p;
                    if (void 0 === h) throw n();
                    return ((t1)=>{
                        const { port1: e } = new MessageChannel;
                        try {
                            e.postMessage(t1);
                        } finally{
                            e.close();
                        }
                    })(l), e(o, r, h, l);
                })(At, xn, Bt, Zt, os), bn = ((t1, e, s1, n, i, o, r, a, c, h, l, u, p, d, f, _)=>(m, g, v)=>{
                    const y = new WeakMap;
                    let x = null;
                    return {
                        render (w, b) {
                            a(b, w);
                            const T = y.get(b);
                            return void 0 !== T ? Promise.resolve(T) : (async (a, w)=>{
                                let b = l(a), T = null;
                                const S = M(b, w), k = Array.isArray(g.outputChannelCount) ? g.outputChannelCount : Array.from(g.outputChannelCount);
                                if (null === u) {
                                    const t1 = k.reduce((t1, e)=>t1 + e, 0), s1 = i(w, {
                                        channelCount: Math.max(1, t1),
                                        channelCountMode: "explicit",
                                        channelInterpretation: "discrete",
                                        numberOfOutputs: Math.max(1, t1)
                                    }), o = [];
                                    for(let t1 = 0; t1 < a.numberOfOutputs; t1 += 1)o.push(n(w, {
                                        channelCount: 1,
                                        channelCountMode: "explicit",
                                        channelInterpretation: "speakers",
                                        numberOfInputs: k[t1]
                                    }));
                                    const h = r(w, {
                                        channelCount: g.channelCount,
                                        channelCountMode: g.channelCountMode,
                                        channelInterpretation: g.channelInterpretation,
                                        gain: 1
                                    });
                                    h.connect = e.bind(null, o), h.disconnect = c.bind(null, o), T = [
                                        s1,
                                        o,
                                        h
                                    ];
                                } else S || (b = new u(w, m));
                                if (y.set(w, null === T ? b : T[2]), null !== T) {
                                    if (null === x) {
                                        if (void 0 === v) throw new Error("Missing the processor constructor.");
                                        if (null === p) throw new Error("Missing the native OfflineAudioContext constructor.");
                                        const t1 = a.channelCount * a.numberOfInputs, e = void 0 === v.parameterDescriptors ? 0 : v.parameterDescriptors.length, s1 = t1 + e, c = async ()=>{
                                            const c = new p(s1, 128 * Math.ceil(a.context.length / 128), w.sampleRate), h = [], l = [];
                                            for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1)h.push(r(c, {
                                                channelCount: g.channelCount,
                                                channelCountMode: g.channelCountMode,
                                                channelInterpretation: g.channelInterpretation,
                                                gain: 1
                                            })), l.push(i(c, {
                                                channelCount: g.channelCount,
                                                channelCountMode: "explicit",
                                                channelInterpretation: "discrete",
                                                numberOfOutputs: g.channelCount
                                            }));
                                            const u = await Promise.all(Array.from(a.parameters.values()).map(async (t1)=>{
                                                const e = o(c, {
                                                    channelCount: 1,
                                                    channelCountMode: "explicit",
                                                    channelInterpretation: "discrete",
                                                    offset: t1.value
                                                });
                                                return await d(c, t1, e.offset), e;
                                            })), m = n(c, {
                                                channelCount: 1,
                                                channelCountMode: "explicit",
                                                channelInterpretation: "speakers",
                                                numberOfInputs: Math.max(1, t1 + e)
                                            });
                                            for(let t1 = 0; t1 < g.numberOfInputs; t1 += 1){
                                                h[t1].connect(l[t1]);
                                                for(let e = 0; e < g.channelCount; e += 1)l[t1].connect(m, e, t1 * g.channelCount + e);
                                            }
                                            for (const [e, s1] of u.entries())s1.connect(m, 0, t1 + e), s1.start(0);
                                            return m.connect(c.destination), await Promise.all(h.map((t1)=>f(a, c, t1))), _(c);
                                        };
                                        x = _t(a, 0 === s1 ? null : await c(), w, g, k, v, h);
                                    }
                                    const t1 = await x, e = s1(w, {
                                        buffer: null,
                                        channelCount: 2,
                                        channelCountMode: "max",
                                        channelInterpretation: "speakers",
                                        loop: !1,
                                        loopEnd: 0,
                                        loopStart: 0,
                                        playbackRate: 1
                                    }), [c, l, u] = T;
                                    null !== t1 && (e.buffer = t1, e.start(0)), e.connect(c);
                                    for(let t1 = 0, e = 0; t1 < a.numberOfOutputs; t1 += 1){
                                        const s1 = l[t1];
                                        for(let n = 0; n < k[t1]; n += 1)c.connect(s1, e + n, n);
                                        e += k[t1];
                                    }
                                    return u;
                                }
                                if (S) for (const [e, s1] of a.parameters.entries())await t1(w, s1, b.parameters.get(e));
                                else for (const [t1, e] of a.parameters.entries())await d(w, e, b.parameters.get(t1));
                                return await f(a, w, b), b;
                            })(w, b);
                        }
                    };
                })(Xe, _n, Ye, as, Lt, ds, Bt, mn, gn, Ks, tt, Ie, Ce, $e, Te, Cs), Tn = ((t1)=>(e)=>t1.get(e))(tn), Sn = ((t1)=>(e, s1)=>{
                    t1.set(e, s1);
                })(vn), kn = Js ? ((t1, e, s1, n, i, o, r, a, c, h, l, u, p, d)=>class extends e {
                    constructor(e, l, p){
                        var d;
                        const _ = a(e), m = c(_), g = ((t1)=>({
                                ...t1,
                                outputChannelCount: void 0 !== t1.outputChannelCount ? t1.outputChannelCount : 1 === t1.numberOfInputs && 1 === t1.numberOfOutputs ? [
                                    t1.channelCount
                                ] : Array.from({
                                    length: t1.numberOfOutputs
                                }, ()=>1)
                            }))({
                            ...ut,
                            ...p
                        });
                        ((t1)=>{
                            const { port1: e, port2: s1 } = new MessageChannel;
                            try {
                                e.postMessage(t1);
                            } finally{
                                e.close(), s1.close();
                            }
                        })(g);
                        const v = f.get(_), y = null == v ? void 0 : v.get(l), x = m || "closed" !== _.state ? _ : null !== (d = r(_)) && void 0 !== d ? d : _, w = i(x, m ? null : e.baseLatency, h, l, y, g);
                        super(e, !0, w, m ? n(l, g, y) : null);
                        const b = [];
                        w.parameters.forEach((t1, e)=>{
                            const n = s1(this, m, t1);
                            b.push([
                                e,
                                n
                            ]);
                        }), this._nativeAudioWorkletNode = w, this._onprocessorerror = null, this._parameters = new lt(b), m && t1(_, this);
                        const { activeInputs: T } = o(this);
                        u(w, T);
                    }
                    get onprocessorerror() {
                        return this._onprocessorerror;
                    }
                    set onprocessorerror(t1) {
                        const e = "function" == typeof t1 ? d(this, t1) : null;
                        this._nativeAudioWorkletNode.onprocessorerror = e;
                        const s1 = this._nativeAudioWorkletNode.onprocessorerror;
                        this._onprocessorerror = null !== s1 && s1 === e ? t1 : s1;
                    }
                    get parameters() {
                        return null === this._parameters ? this._nativeAudioWorkletNode.parameters : this._parameters;
                    }
                    get port() {
                        return this._nativeAudioWorkletNode.port;
                    }
                })(fn, Ve, Je, bn, wn, j, Tn, ke, De, Ie, 0, Sn, 0, ue) : void 0, An = ((t1, e)=>(s1, n, i)=>{
                    if (null === e) throw new Error("Missing the native OfflineAudioContext constructor.");
                    try {
                        return new e(s1, n, i);
                    } catch (e) {
                        if ("SyntaxError" === e.name) throw t1();
                        throw e;
                    }
                })(Zt, Ce), Cn = ((t1, e, s1, n, i, o, r, a)=>(c, h)=>s1(c).render(c, h).then(()=>Promise.all(Array.from(n(h)).map((t1)=>s1(t1).render(t1, h)))).then(()=>i(h)).then((s1)=>("function" != typeof s1.copyFromChannel ? (r(s1), q(s1)) : e(o, ()=>o(s1)) || a(s1), t1.add(s1), s1)))(je, ge, be, dn, Cs, E, Be, Ue), Dn = ((t1, e, s1, n, i)=>class extends t1 {
                    constructor(t1, s1, i){
                        let o;
                        if ("number" == typeof t1 && void 0 !== s1 && void 0 !== i) o = {
                            length: s1,
                            numberOfChannels: t1,
                            sampleRate: i
                        };
                        else {
                            if ("object" != typeof t1) throw new Error("The given parameters are not valid.");
                            o = t1;
                        }
                        const { length: r, numberOfChannels: a, sampleRate: c } = {
                            ...Xt,
                            ...o
                        }, h = n(a, r, c);
                        e(Et, ()=>Et(h)) || h.addEventListener("statechange", (()=>{
                            let t1 = 0;
                            const e = (s1)=>{
                                "running" === this._state && (t1 > 0 ? (h.removeEventListener("statechange", e), s1.stopImmediatePropagation(), this._waitForThePromiseToSettle(s1)) : t1 += 1);
                            };
                            return e;
                        })()), super(h, a), this._length = r, this._nativeOfflineAudioContext = h, this._state = null;
                    }
                    get length() {
                        return void 0 === this._nativeOfflineAudioContext.length ? this._length : this._nativeOfflineAudioContext.length;
                    }
                    get state() {
                        return null === this._state ? this._nativeOfflineAudioContext.state : this._state;
                    }
                    startRendering() {
                        return "running" === this._state ? Promise.reject(s1()) : (this._state = "running", i(this.destination, this._nativeOfflineAudioContext).finally(()=>{
                            this._state = null, W(this);
                        }));
                    }
                    _waitForThePromiseToSettle(t1) {
                        null === this._state ? this._nativeOfflineAudioContext.dispatchEvent(t1) : setTimeout(()=>this._waitForThePromiseToSettle(t1));
                    }
                })(rn, ge, At, An, Cn), On = ((t1, e)=>(s1)=>{
                    const n = t1.get(s1);
                    return e(n) || e(s1);
                })(u, Re), Mn = ((t1, e)=>(s1)=>t1.has(s1) || e(s1))(c, qe), En = ((t1, e)=>(s1)=>t1.has(s1) || e(s1))(l, Fe), Rn = ((t1, e)=>(s1)=>{
                    const n = t1.get(s1);
                    return e(n) || e(s1);
                })(u, De), qn = ()=>(async (t1, e, s1, n, i, o, r, a, c, h, l, u, p, d, f, _)=>!!(t1(e, e) && t1(s1, s1) && t1(i, i) && t1(o, o) && t1(a, a) && t1(c, c) && t1(h, h) && t1(l, l) && t1(u, u) && t1(p, p) && t1(d, d)) && (await Promise.all([
                        t1(n, n),
                        t1(r, r),
                        t1(f, f),
                        t1(_, _)
                    ])).every((t1)=>t1))(ge, ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100).createBuffer(1, 1, 44100);
                        if (void 0 === e.copyToChannel) return !0;
                        const s1 = new Float32Array(2);
                        try {
                            e.copyFromChannel(s1, 0, 0);
                        } catch  {
                            return !1;
                        }
                        return !0;
                    })(Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        if (void 0 !== t1.prototype && void 0 !== t1.prototype.close) return !0;
                        const e = new t1, s1 = void 0 !== e.close;
                        try {
                            e.close();
                        } catch  {}
                        return s1;
                    })(Ee), ((t1)=>()=>{
                        if (null === t1) return Promise.resolve(!1);
                        const e = new t1(1, 1, 44100);
                        return new Promise((t1)=>{
                            let s1 = !0;
                            const n = (n)=>{
                                s1 && (s1 = !1, e.startRendering(), t1(n instanceof TypeError));
                            };
                            let i;
                            try {
                                i = e.decodeAudioData(null, ()=>{}, n);
                            } catch (t1) {
                                n(t1);
                            }
                            void 0 !== i && i.catch(n);
                        });
                    })(Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        let e;
                        try {
                            e = new t1({
                                latencyHint: "balanced"
                            });
                        } catch  {
                            return !1;
                        }
                        return e.close(), !0;
                    })(Ee), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100).createGain(), s1 = e.connect(e) === e;
                        return e.disconnect(e), s1;
                    })(Ce), ((t1, e)=>async ()=>{
                        if (null === t1) return !0;
                        if (null === e) return !1;
                        const s1 = new Blob([
                            'let c,p;class A extends AudioWorkletProcessor{constructor(){super();this.port.onmessage=(e)=>{p=e.data;p.onmessage=()=>{p.postMessage(c);p.close()};this.port.postMessage(0)}}process(){c=1}}registerProcessor("a",A)'
                        ], {
                            type: "application/javascript; charset=utf-8"
                        }), n = new MessageChannel, i = new e(1, 128, 44100), o = URL.createObjectURL(s1);
                        let r = !1;
                        try {
                            await i.audioWorklet.addModule(o);
                            const e = new t1(i, "a", {
                                numberOfOutputs: 0
                            }), s1 = i.createOscillator();
                            await new Promise((t1)=>{
                                e.port.onmessage = ()=>t1(), e.port.postMessage(n.port2, [
                                    n.port2
                                ]);
                            }), e.port.onmessage = ()=>r = !0, s1.connect(e), s1.start(0), await i.startRendering(), r = await new Promise((t1)=>{
                                n.port1.onmessage = ({ data: e })=>t1(1 === e), n.port1.postMessage(0);
                            });
                        } catch  {} finally{
                            n.port1.close(), URL.revokeObjectURL(o);
                        }
                        return r;
                    })(Ie, Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100).createChannelMerger();
                        if ("max" === e.channelCountMode) return !0;
                        try {
                            e.channelCount = 2;
                        } catch  {
                            return !0;
                        }
                        return !1;
                    })(Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100);
                        return void 0 === e.createConstantSource || e.createConstantSource().offset.maxValue !== Number.POSITIVE_INFINITY;
                    })(Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100), s1 = e.createConvolver();
                        s1.buffer = e.createBuffer(1, 1, e.sampleRate);
                        try {
                            s1.buffer = e.createBuffer(1, 1, e.sampleRate);
                        } catch  {
                            return !1;
                        }
                        return !0;
                    })(Ce), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1(1, 1, 44100).createConvolver();
                        try {
                            e.channelCount = 1;
                        } catch  {
                            return !1;
                        }
                        return !0;
                    })(Ce), ce, ((t1)=>()=>null !== t1 && t1.hasOwnProperty("isSecureContext"))(xe), ((t1)=>()=>{
                        if (null === t1) return !1;
                        const e = new t1;
                        try {
                            return e.createMediaStreamSource(new MediaStream), !1;
                        } catch (t1) {
                            return !0;
                        } finally{
                            e.close();
                        }
                    })(Ee), ((t1)=>()=>{
                        if (null === t1) return Promise.resolve(!1);
                        const e = new t1(1, 1, 44100);
                        if (void 0 === e.createStereoPanner) return Promise.resolve(!0);
                        if (void 0 === e.createConstantSource) return Promise.resolve(!0);
                        const s1 = e.createConstantSource(), n = e.createStereoPanner();
                        return s1.channelCount = 1, s1.offset.value = 1, n.channelCount = 1, s1.start(), s1.connect(n).connect(e.destination), e.startRendering().then((t1)=>1 !== t1.getChannelData(0)[0]);
                    })(Ce), he);
            function Fn(t1) {
                return void 0 === t1;
            }
            function In(t1) {
                return void 0 !== t1;
            }
            function Vn(t1) {
                return "function" == typeof t1;
            }
            function Nn(t1) {
                return "number" == typeof t1;
            }
            function Pn(t1) {
                return "[object Object]" === Object.prototype.toString.call(t1) && t1.constructor === Object;
            }
            function jn(t1) {
                return "boolean" == typeof t1;
            }
            function Ln(t1) {
                return Array.isArray(t1);
            }
            function zn(t1) {
                return "string" == typeof t1;
            }
            function Wn(t1) {
                return zn(t1) && /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i.test(t1);
            }
            function Bn(t1, e) {
                if (!t1) throw new Error(e);
            }
            function Un(t1, e, s1 = 1 / 0) {
                if (!(e <= t1 && t1 <= s1)) throw new RangeError(`Value must be within [${e}, ${s1}], got: ${t1}`);
            }
            function Gn(t1) {
                t1.isOffline || "running" === t1.state || Kn('The AudioContext is "suspended". Invoke Tone.start() from a user action to start the audio.');
            }
            let Qn = !1, Zn = !1;
            function Xn(t1) {
                Qn = t1;
            }
            function Yn(t1) {
                Fn(t1) && Qn && !Zn && (Zn = !0, Kn("Events scheduled inside of scheduled callbacks should use the passed in scheduling time. See https://github.com/Tonejs/Tone.js/wiki/Accurate-Timing"));
            }
            let $n = console;
            function Hn(t1) {
                $n = t1;
            }
            function Jn(...t1) {
                $n.log(...t1);
            }
            function Kn(...t1) {
                $n.warn(...t1);
            }
            const ti = "object" == typeof self ? self : null, ei = ti && (ti.hasOwnProperty("AudioContext") || ti.hasOwnProperty("webkitAudioContext"));
            function si(t1, e, s1, n) {
                var i, o = arguments.length, r = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, s1) : n;
                if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(t1, e, s1, n);
                else for(var a = t1.length - 1; a >= 0; a--)(i = t1[a]) && (r = (o < 3 ? i(r) : o > 3 ? i(e, s1, r) : i(e, s1)) || r);
                return o > 3 && r && Object.defineProperty(e, s1, r), r;
            }
            function ni(t1, e, s1, n) {
                return new (s1 || (s1 = Promise))(function(i, o) {
                    function r(t1) {
                        try {
                            c(n.next(t1));
                        } catch (t1) {
                            o(t1);
                        }
                    }
                    function a(t1) {
                        try {
                            c(n.throw(t1));
                        } catch (t1) {
                            o(t1);
                        }
                    }
                    function c(t1) {
                        var e;
                        t1.done ? i(t1.value) : (e = t1.value, e instanceof s1 ? e : new s1(function(t1) {
                            t1(e);
                        })).then(r, a);
                    }
                    c((n = n.apply(t1, e || [])).next());
                });
            }
            Object.create, Object.create, "function" == typeof SuppressedError && SuppressedError;
            class ii {
                constructor(t1, e, s1, n){
                    this._callback = t1, this._type = e, this._minimumUpdateInterval = Math.max(128 / (n || 44100), .001), this.updateInterval = s1, this._createClock();
                }
                _createWorker() {
                    const t1 = new Blob([
                        `\n\t\t\t// the initial timeout time\n\t\t\tlet timeoutTime =  ${(1e3 * this._updateInterval).toFixed(1)};\n\t\t\t// onmessage callback\n\t\t\tself.onmessage = function(msg){\n\t\t\t\ttimeoutTime = parseInt(msg.data);\n\t\t\t};\n\t\t\t// the tick function which posts a message\n\t\t\t// and schedules a new tick\n\t\t\tfunction tick(){\n\t\t\t\tsetTimeout(tick, timeoutTime);\n\t\t\t\tself.postMessage('tick');\n\t\t\t}\n\t\t\t// call tick initially\n\t\t\ttick();\n\t\t\t`
                    ], {
                        type: "text/javascript"
                    }), e = URL.createObjectURL(t1), s1 = new Worker(e);
                    s1.onmessage = this._callback.bind(this), this._worker = s1;
                }
                _createTimeout() {
                    this._timeout = setTimeout(()=>{
                        this._createTimeout(), this._callback();
                    }, 1e3 * this._updateInterval);
                }
                _createClock() {
                    if ("worker" === this._type) try {
                        this._createWorker();
                    } catch (t1) {
                        this._type = "timeout", this._createClock();
                    }
                    else "timeout" === this._type && this._createTimeout();
                }
                _disposeClock() {
                    this._timeout && clearTimeout(this._timeout), this._worker && (this._worker.terminate(), this._worker.onmessage = null);
                }
                get updateInterval() {
                    return this._updateInterval;
                }
                set updateInterval(t1) {
                    var e;
                    this._updateInterval = Math.max(t1, this._minimumUpdateInterval), "worker" === this._type && (null === (e = this._worker) || void 0 === e || e.postMessage(1e3 * this._updateInterval));
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    this._disposeClock(), this._type = t1, this._createClock();
                }
                dispose() {
                    this._disposeClock();
                }
            }
            function oi(t1) {
                return En(t1);
            }
            function ri(t1) {
                return Mn(t1);
            }
            function ai(t1) {
                return Rn(t1);
            }
            function ci(t1) {
                return On(t1);
            }
            function hi(t1, e) {
                return "value" === t1 || oi(e) || ri(e) || function(t1) {
                    return t1 instanceof Ge;
                }(e);
            }
            function li(t1, ...e) {
                if (!e.length) return t1;
                const s1 = e.shift();
                if (Pn(t1) && Pn(s1)) for(const e in s1)hi(e, s1[e]) ? t1[e] = s1[e] : Pn(s1[e]) ? (t1[e] || Object.assign(t1, {
                    [e]: {}
                }), li(t1[e], s1[e])) : Object.assign(t1, {
                    [e]: s1[e]
                });
                return li(t1, ...e);
            }
            function ui(t1, e, s1 = [], n) {
                const i = {}, o = Array.from(e);
                if (Pn(o[0]) && n && !Reflect.has(o[0], n) && (Object.keys(o[0]).some((e)=>Reflect.has(t1, e)) || (li(i, {
                    [n]: o[0]
                }), s1.splice(s1.indexOf(n), 1), o.shift())), 1 === o.length && Pn(o[0])) li(i, o[0]);
                else for(let t1 = 0; t1 < s1.length; t1++)In(o[t1]) && (i[s1[t1]] = o[t1]);
                return li(t1, i);
            }
            function pi(t1, e) {
                return Fn(t1) ? e : t1;
            }
            function di(t1, e) {
                return e.forEach((e)=>{
                    Reflect.has(t1, e) && delete t1[e];
                }), t1;
            }
            class fi {
                constructor(){
                    this.debug = !1, this._wasDisposed = !1;
                }
                static getDefaults() {
                    return {};
                }
                log(...t1) {
                    (this.debug || ti && this.toString() === ti.TONE_DEBUG_CLASS) && Jn(this, ...t1);
                }
                dispose() {
                    return this._wasDisposed = !0, this;
                }
                get disposed() {
                    return this._wasDisposed;
                }
                toString() {
                    return this.name;
                }
            }
            fi.version = i;
            const _i = 1e-6;
            function mi(t1, e) {
                return t1 > e + _i;
            }
            function gi(t1, e) {
                return mi(t1, e) || yi(t1, e);
            }
            function vi(t1, e) {
                return t1 + _i < e;
            }
            function yi(t1, e) {
                return Math.abs(t1 - e) < _i;
            }
            function xi(t1, e, s1) {
                return Math.max(Math.min(t1, s1), e);
            }
            class wi extends fi {
                constructor(){
                    super(), this.name = "Timeline", this._timeline = [];
                    const t1 = ui(wi.getDefaults(), arguments, [
                        "memory"
                    ]);
                    this.memory = t1.memory, this.increasing = t1.increasing;
                }
                static getDefaults() {
                    return {
                        memory: 1 / 0,
                        increasing: !1
                    };
                }
                get length() {
                    return this._timeline.length;
                }
                add(t1) {
                    if (Bn(Reflect.has(t1, "time"), "Timeline: events must have a time attribute"), t1.time = t1.time.valueOf(), this.increasing && this.length) {
                        const e = this._timeline[this.length - 1];
                        Bn(gi(t1.time, e.time), "The time must be greater than or equal to the last scheduled time"), this._timeline.push(t1);
                    } else {
                        const e = this._search(t1.time);
                        this._timeline.splice(e + 1, 0, t1);
                    }
                    if (this.length > this.memory) {
                        const t1 = this.length - this.memory;
                        this._timeline.splice(0, t1);
                    }
                    return this;
                }
                remove(t1) {
                    const e = this._timeline.indexOf(t1);
                    return -1 !== e && this._timeline.splice(e, 1), this;
                }
                get(t1, e = "time") {
                    const s1 = this._search(t1, e);
                    return -1 !== s1 ? this._timeline[s1] : null;
                }
                peek() {
                    return this._timeline[0];
                }
                shift() {
                    return this._timeline.shift();
                }
                getAfter(t1, e = "time") {
                    const s1 = this._search(t1, e);
                    return s1 + 1 < this._timeline.length ? this._timeline[s1 + 1] : null;
                }
                getBefore(t1) {
                    const e = this._timeline.length;
                    if (e > 0 && this._timeline[e - 1].time < t1) return this._timeline[e - 1];
                    const s1 = this._search(t1);
                    return s1 - 1 >= 0 ? this._timeline[s1 - 1] : null;
                }
                cancel(t1) {
                    if (this._timeline.length > 1) {
                        let e = this._search(t1);
                        if (e >= 0) {
                            if (yi(this._timeline[e].time, t1)) {
                                for(let s1 = e; s1 >= 0 && yi(this._timeline[s1].time, t1); s1--)e = s1;
                                this._timeline = this._timeline.slice(0, e);
                            } else this._timeline = this._timeline.slice(0, e + 1);
                        } else this._timeline = [];
                    } else 1 === this._timeline.length && gi(this._timeline[0].time, t1) && (this._timeline = []);
                    return this;
                }
                cancelBefore(t1) {
                    const e = this._search(t1);
                    return e >= 0 && (this._timeline = this._timeline.slice(e + 1)), this;
                }
                previousEvent(t1) {
                    const e = this._timeline.indexOf(t1);
                    return e > 0 ? this._timeline[e - 1] : null;
                }
                _search(t1, e = "time") {
                    if (0 === this._timeline.length) return -1;
                    let s1 = 0;
                    const n = this._timeline.length;
                    let i = n;
                    if (n > 0 && this._timeline[n - 1][e] <= t1) return n - 1;
                    for(; s1 < i;){
                        let n = Math.floor(s1 + (i - s1) / 2);
                        const o = this._timeline[n], r = this._timeline[n + 1];
                        if (yi(o[e], t1)) {
                            for(let s1 = n; s1 < this._timeline.length && yi(this._timeline[s1][e], t1); s1++)n = s1;
                            return n;
                        }
                        if (vi(o[e], t1) && mi(r[e], t1)) return n;
                        mi(o[e], t1) ? i = n : s1 = n + 1;
                    }
                    return -1;
                }
                _iterate(t1, e = 0, s1 = this._timeline.length - 1) {
                    this._timeline.slice(e, s1 + 1).forEach(t1);
                }
                forEach(t1) {
                    return this._iterate(t1), this;
                }
                forEachBefore(t1, e) {
                    const s1 = this._search(t1);
                    return -1 !== s1 && this._iterate(e, 0, s1), this;
                }
                forEachAfter(t1, e) {
                    const s1 = this._search(t1);
                    return this._iterate(e, s1 + 1), this;
                }
                forEachBetween(t1, e, s1) {
                    let n = this._search(t1), i = this._search(e);
                    return -1 !== n && -1 !== i ? (this._timeline[n].time !== t1 && (n += 1), this._timeline[i].time === e && (i -= 1), this._iterate(s1, n, i)) : -1 === n && this._iterate(s1, 0, i), this;
                }
                forEachFrom(t1, e) {
                    let s1 = this._search(t1);
                    for(; s1 >= 0 && this._timeline[s1].time >= t1;)s1--;
                    return this._iterate(e, s1 + 1), this;
                }
                forEachAtTime(t1, e) {
                    const s1 = this._search(t1);
                    if (-1 !== s1 && yi(this._timeline[s1].time, t1)) {
                        let n = s1;
                        for(let e = s1; e >= 0 && yi(this._timeline[e].time, t1); e--)n = e;
                        this._iterate((t1)=>{
                            e(t1);
                        }, n, s1);
                    }
                    return this;
                }
                dispose() {
                    return super.dispose(), this._timeline = [], this;
                }
            }
            const bi = [];
            function Ti(t1) {
                bi.push(t1);
            }
            const Si = [];
            function ki(t1) {
                Si.push(t1);
            }
            class Ai extends fi {
                constructor(){
                    super(...arguments), this.name = "Emitter";
                }
                on(t1, e) {
                    return t1.split(/\W+/).forEach((t1)=>{
                        Fn(this._events) && (this._events = {}), this._events.hasOwnProperty(t1) || (this._events[t1] = []), this._events[t1].push(e);
                    }), this;
                }
                once(t1, e) {
                    const s1 = (...n)=>{
                        e(...n), this.off(t1, s1);
                    };
                    return this.on(t1, s1), this;
                }
                off(t1, e) {
                    return t1.split(/\W+/).forEach((t1)=>{
                        if (Fn(this._events) && (this._events = {}), this._events.hasOwnProperty(t1)) {
                            if (Fn(e)) this._events[t1] = [];
                            else {
                                const s1 = this._events[t1];
                                for(let t1 = s1.length - 1; t1 >= 0; t1--)s1[t1] === e && s1.splice(t1, 1);
                            }
                        }
                    }), this;
                }
                emit(t1, ...e) {
                    if (this._events && this._events.hasOwnProperty(t1)) {
                        const s1 = this._events[t1].slice(0);
                        for(let t1 = 0, n = s1.length; t1 < n; t1++)s1[t1].apply(this, e);
                    }
                    return this;
                }
                static mixin(t1) {
                    [
                        "on",
                        "once",
                        "off",
                        "emit"
                    ].forEach((e)=>{
                        const s1 = Object.getOwnPropertyDescriptor(Ai.prototype, e);
                        Object.defineProperty(t1.prototype, e, s1);
                    });
                }
                dispose() {
                    return super.dispose(), this._events = void 0, this;
                }
            }
            class Ci extends Ai {
                constructor(){
                    super(...arguments), this.isOffline = !1;
                }
                toJSON() {
                    return {};
                }
            }
            class Di extends Ci {
                constructor(){
                    var t1, e;
                    super(), this.name = "Context", this._constants = new Map, this._timeouts = new wi, this._timeoutIds = 0, this._initialized = !1, this._closeStarted = !1, this.isOffline = !1, this._workletPromise = null;
                    const s1 = ui(Di.getDefaults(), arguments, [
                        "context"
                    ]);
                    s1.context ? (this._context = s1.context, this._latencyHint = (null === (t1 = arguments[0]) || void 0 === t1 ? void 0 : t1.latencyHint) || "") : (this._context = function(t1) {
                        return new pn(t1);
                    }({
                        latencyHint: s1.latencyHint
                    }), this._latencyHint = s1.latencyHint), this._ticker = new ii(this.emit.bind(this, "tick"), s1.clockSource, s1.updateInterval, this._context.sampleRate), this.on("tick", this._timeoutLoop.bind(this)), this._context.onstatechange = ()=>{
                        this.emit("statechange", this.state);
                    }, this[(null === (e = arguments[0]) || void 0 === e ? void 0 : e.hasOwnProperty("updateInterval")) ? "_lookAhead" : "lookAhead"] = s1.lookAhead;
                }
                static getDefaults() {
                    return {
                        clockSource: "worker",
                        latencyHint: "interactive",
                        lookAhead: .1,
                        updateInterval: .05
                    };
                }
                initialize() {
                    var t1;
                    return this._initialized || (t1 = this, bi.forEach((e)=>e(t1)), this._initialized = !0), this;
                }
                createAnalyser() {
                    return this._context.createAnalyser();
                }
                createOscillator() {
                    return this._context.createOscillator();
                }
                createBufferSource() {
                    return this._context.createBufferSource();
                }
                createBiquadFilter() {
                    return this._context.createBiquadFilter();
                }
                createBuffer(t1, e, s1) {
                    return this._context.createBuffer(t1, e, s1);
                }
                createChannelMerger(t1) {
                    return this._context.createChannelMerger(t1);
                }
                createChannelSplitter(t1) {
                    return this._context.createChannelSplitter(t1);
                }
                createConstantSource() {
                    return this._context.createConstantSource();
                }
                createConvolver() {
                    return this._context.createConvolver();
                }
                createDelay(t1) {
                    return this._context.createDelay(t1);
                }
                createDynamicsCompressor() {
                    return this._context.createDynamicsCompressor();
                }
                createGain() {
                    return this._context.createGain();
                }
                createIIRFilter(t1, e) {
                    return this._context.createIIRFilter(t1, e);
                }
                createPanner() {
                    return this._context.createPanner();
                }
                createPeriodicWave(t1, e, s1) {
                    return this._context.createPeriodicWave(t1, e, s1);
                }
                createStereoPanner() {
                    return this._context.createStereoPanner();
                }
                createWaveShaper() {
                    return this._context.createWaveShaper();
                }
                createMediaStreamSource(t1) {
                    return Bn(ci(this._context), "Not available if OfflineAudioContext"), this._context.createMediaStreamSource(t1);
                }
                createMediaElementSource(t1) {
                    return Bn(ci(this._context), "Not available if OfflineAudioContext"), this._context.createMediaElementSource(t1);
                }
                createMediaStreamDestination() {
                    return Bn(ci(this._context), "Not available if OfflineAudioContext"), this._context.createMediaStreamDestination();
                }
                decodeAudioData(t1) {
                    return this._context.decodeAudioData(t1);
                }
                get currentTime() {
                    return this._context.currentTime;
                }
                get state() {
                    return this._context.state;
                }
                get sampleRate() {
                    return this._context.sampleRate;
                }
                get listener() {
                    return this.initialize(), this._listener;
                }
                set listener(t1) {
                    Bn(!this._initialized, "The listener cannot be set after initialization."), this._listener = t1;
                }
                get transport() {
                    return this.initialize(), this._transport;
                }
                set transport(t1) {
                    Bn(!this._initialized, "The transport cannot be set after initialization."), this._transport = t1;
                }
                get draw() {
                    return this.initialize(), this._draw;
                }
                set draw(t1) {
                    Bn(!this._initialized, "Draw cannot be set after initialization."), this._draw = t1;
                }
                get destination() {
                    return this.initialize(), this._destination;
                }
                set destination(t1) {
                    Bn(!this._initialized, "The destination cannot be set after initialization."), this._destination = t1;
                }
                createAudioWorkletNode(t1, e) {
                    return function(t1, e, s1) {
                        return Bn(In(kn), "This node only works in a secure context (https or localhost)"), new kn(t1, e, s1);
                    }(this.rawContext, t1, e);
                }
                addAudioWorkletModule(t1) {
                    return ni(this, void 0, void 0, function*() {
                        Bn(In(this.rawContext.audioWorklet), "AudioWorkletNode is only available in a secure context (https or localhost)"), this._workletPromise || (this._workletPromise = this.rawContext.audioWorklet.addModule(t1)), yield this._workletPromise;
                    });
                }
                workletsAreReady() {
                    return ni(this, void 0, void 0, function*() {
                        (yield this._workletPromise) ? this._workletPromise : Promise.resolve();
                    });
                }
                get updateInterval() {
                    return this._ticker.updateInterval;
                }
                set updateInterval(t1) {
                    this._ticker.updateInterval = t1;
                }
                get clockSource() {
                    return this._ticker.type;
                }
                set clockSource(t1) {
                    this._ticker.type = t1;
                }
                get lookAhead() {
                    return this._lookAhead;
                }
                set lookAhead(t1) {
                    this._lookAhead = t1, this.updateInterval = t1 ? t1 / 2 : .01;
                }
                get latencyHint() {
                    return this._latencyHint;
                }
                get rawContext() {
                    return this._context;
                }
                now() {
                    return this._context.currentTime + this._lookAhead;
                }
                immediate() {
                    return this._context.currentTime;
                }
                resume() {
                    return ci(this._context) ? this._context.resume() : Promise.resolve();
                }
                close() {
                    return ni(this, void 0, void 0, function*() {
                        var t1;
                        ci(this._context) && "closed" !== this.state && !this._closeStarted && (this._closeStarted = !0, yield this._context.close()), this._initialized && (t1 = this, Si.forEach((e)=>e(t1)));
                    });
                }
                getConstant(t1) {
                    if (this._constants.has(t1)) return this._constants.get(t1);
                    {
                        const e = this._context.createBuffer(1, 128, this._context.sampleRate), s1 = e.getChannelData(0);
                        for(let e = 0; e < s1.length; e++)s1[e] = t1;
                        const n = this._context.createBufferSource();
                        return n.channelCount = 1, n.channelCountMode = "explicit", n.buffer = e, n.loop = !0, n.start(0), this._constants.set(t1, n), n;
                    }
                }
                dispose() {
                    return super.dispose(), this._ticker.dispose(), this._timeouts.dispose(), Object.keys(this._constants).map((t1)=>this._constants[t1].disconnect()), this.close(), this;
                }
                _timeoutLoop() {
                    const t1 = this.now();
                    let e = this._timeouts.peek();
                    for(; this._timeouts.length && e && e.time <= t1;)e.callback(), this._timeouts.shift(), e = this._timeouts.peek();
                }
                setTimeout(t1, e) {
                    this._timeoutIds++;
                    const s1 = this.now();
                    return this._timeouts.add({
                        callback: t1,
                        id: this._timeoutIds,
                        time: s1 + e
                    }), this._timeoutIds;
                }
                clearTimeout(t1) {
                    return this._timeouts.forEach((e)=>{
                        e.id === t1 && this._timeouts.remove(e);
                    }), this;
                }
                clearInterval(t1) {
                    return this.clearTimeout(t1);
                }
                setInterval(t1, e) {
                    const s1 = ++this._timeoutIds, n = ()=>{
                        const i = this.now();
                        this._timeouts.add({
                            callback: ()=>{
                                t1(), n();
                            },
                            id: s1,
                            time: i + e
                        });
                    };
                    return n(), s1;
                }
            }
            function Oi(t1, e) {
                Ln(e) ? e.forEach((e)=>Oi(t1, e)) : Object.defineProperty(t1, e, {
                    enumerable: !0,
                    writable: !1
                });
            }
            function Mi(t1, e) {
                Ln(e) ? e.forEach((e)=>Mi(t1, e)) : Object.defineProperty(t1, e, {
                    writable: !0
                });
            }
            const Ei = ()=>{};
            class Ri extends fi {
                constructor(){
                    super(), this.name = "ToneAudioBuffer", this.onload = Ei;
                    const t1 = ui(Ri.getDefaults(), arguments, [
                        "url",
                        "onload",
                        "onerror"
                    ]);
                    this.reverse = t1.reverse, this.onload = t1.onload, zn(t1.url) ? this.load(t1.url).catch(t1.onerror) : t1.url && this.set(t1.url);
                }
                static getDefaults() {
                    return {
                        onerror: Ei,
                        onload: Ei,
                        reverse: !1
                    };
                }
                get sampleRate() {
                    return this._buffer ? this._buffer.sampleRate : Vi().sampleRate;
                }
                set(t1) {
                    return t1 instanceof Ri ? t1.loaded ? this._buffer = t1.get() : t1.onload = ()=>{
                        this.set(t1), this.onload(this);
                    } : this._buffer = t1, this._reversed && this._reverse(), this;
                }
                get() {
                    return this._buffer;
                }
                load(t1) {
                    return ni(this, void 0, void 0, function*() {
                        const e = Ri.load(t1).then((t1)=>{
                            this.set(t1), this.onload(this);
                        });
                        Ri.downloads.push(e);
                        try {
                            yield e;
                        } finally{
                            const t1 = Ri.downloads.indexOf(e);
                            Ri.downloads.splice(t1, 1);
                        }
                        return this;
                    });
                }
                dispose() {
                    return super.dispose(), this._buffer = void 0, this;
                }
                fromArray(t1) {
                    const e = Ln(t1) && t1[0].length > 0, s1 = e ? t1.length : 1, n = e ? t1[0].length : t1.length, i = Vi(), o = i.createBuffer(s1, n, i.sampleRate), r = e || 1 !== s1 ? t1 : [
                        t1
                    ];
                    for(let t1 = 0; t1 < s1; t1++)o.copyToChannel(r[t1], t1);
                    return this._buffer = o, this;
                }
                toMono(t1) {
                    if (Nn(t1)) this.fromArray(this.toArray(t1));
                    else {
                        let t1 = new Float32Array(this.length);
                        const e = this.numberOfChannels;
                        for(let s1 = 0; s1 < e; s1++){
                            const e = this.toArray(s1);
                            for(let s1 = 0; s1 < e.length; s1++)t1[s1] += e[s1];
                        }
                        t1 = t1.map((t1)=>t1 / e), this.fromArray(t1);
                    }
                    return this;
                }
                toArray(t1) {
                    if (Nn(t1)) return this.getChannelData(t1);
                    if (1 === this.numberOfChannels) return this.toArray(0);
                    {
                        const t1 = [];
                        for(let e = 0; e < this.numberOfChannels; e++)t1[e] = this.getChannelData(e);
                        return t1;
                    }
                }
                getChannelData(t1) {
                    return this._buffer ? this._buffer.getChannelData(t1) : new Float32Array(0);
                }
                slice(t1, e = this.duration) {
                    Bn(this.loaded, "Buffer is not loaded");
                    const s1 = Math.floor(t1 * this.sampleRate), n = Math.floor(e * this.sampleRate);
                    Bn(s1 < n, "The start time must be less than the end time");
                    const i = n - s1, o = Vi().createBuffer(this.numberOfChannels, i, this.sampleRate);
                    for(let t1 = 0; t1 < this.numberOfChannels; t1++)o.copyToChannel(this.getChannelData(t1).subarray(s1, n), t1);
                    return new Ri(o);
                }
                _reverse() {
                    if (this.loaded) for(let t1 = 0; t1 < this.numberOfChannels; t1++)this.getChannelData(t1).reverse();
                    return this;
                }
                get loaded() {
                    return this.length > 0;
                }
                get duration() {
                    return this._buffer ? this._buffer.duration : 0;
                }
                get length() {
                    return this._buffer ? this._buffer.length : 0;
                }
                get numberOfChannels() {
                    return this._buffer ? this._buffer.numberOfChannels : 0;
                }
                get reverse() {
                    return this._reversed;
                }
                set reverse(t1) {
                    this._reversed !== t1 && (this._reversed = t1, this._reverse());
                }
                static fromArray(t1) {
                    return (new Ri).fromArray(t1);
                }
                static fromUrl(t1) {
                    return ni(this, void 0, void 0, function*() {
                        const e = new Ri;
                        return yield e.load(t1);
                    });
                }
                static load(t1) {
                    return ni(this, void 0, void 0, function*() {
                        const e = t1.match(/\[([^\]\[]+\|.+)\]$/);
                        if (e) {
                            const s1 = e[1].split("|");
                            let n = s1[0];
                            for (const t1 of s1)if (Ri.supportsType(t1)) {
                                n = t1;
                                break;
                            }
                            t1 = t1.replace(e[0], n);
                        }
                        const s1 = "" === Ri.baseUrl || Ri.baseUrl.endsWith("/") ? Ri.baseUrl : Ri.baseUrl + "/", n = document.createElement("a");
                        n.href = s1 + t1, n.pathname = (n.pathname + n.hash).split("/").map(encodeURIComponent).join("/");
                        const i = yield fetch(n.href);
                        if (!i.ok) throw new Error(`could not load url: ${t1}`);
                        const o = yield i.arrayBuffer();
                        return yield Vi().decodeAudioData(o);
                    });
                }
                static supportsType(t1) {
                    const e = t1.split("."), s1 = e[e.length - 1];
                    return "" !== document.createElement("audio").canPlayType("audio/" + s1);
                }
                static loaded() {
                    return ni(this, void 0, void 0, function*() {
                        for(yield Promise.resolve(); Ri.downloads.length;)yield Ri.downloads[0];
                    });
                }
            }
            Ri.baseUrl = "", Ri.downloads = [];
            class qi extends Di {
                constructor(){
                    var t1, e, s1;
                    super({
                        clockSource: "offline",
                        context: ai(arguments[0]) ? arguments[0] : (t1 = arguments[0], e = arguments[1] * arguments[2], s1 = arguments[2], new Dn(t1, e, s1)),
                        lookAhead: 0,
                        updateInterval: ai(arguments[0]) ? 128 / arguments[0].sampleRate : 128 / arguments[2]
                    }), this.name = "OfflineContext", this._currentTime = 0, this.isOffline = !0, this._duration = ai(arguments[0]) ? arguments[0].length / arguments[0].sampleRate : arguments[1];
                }
                now() {
                    return this._currentTime;
                }
                get currentTime() {
                    return this._currentTime;
                }
                _renderClock(t1) {
                    return ni(this, void 0, void 0, function*() {
                        let e = 0;
                        for(; this._duration - this._currentTime >= 0;){
                            this.emit("tick"), this._currentTime += 128 / this.sampleRate, e++;
                            const s1 = Math.floor(this.sampleRate / 128);
                            t1 && e % s1 == 0 && (yield new Promise((t1)=>setTimeout(t1, 1)));
                        }
                    });
                }
                render(t1 = !0) {
                    return ni(this, void 0, void 0, function*() {
                        yield this.workletsAreReady(), yield this._renderClock(t1);
                        const e = yield this._context.startRendering();
                        return new Ri(e);
                    });
                }
                close() {
                    return Promise.resolve();
                }
            }
            const Fi = new class extends Ci {
                constructor(){
                    super(...arguments), this.lookAhead = 0, this.latencyHint = 0, this.isOffline = !1;
                }
                createAnalyser() {
                    return {};
                }
                createOscillator() {
                    return {};
                }
                createBufferSource() {
                    return {};
                }
                createBiquadFilter() {
                    return {};
                }
                createBuffer(t1, e, s1) {
                    return {};
                }
                createChannelMerger(t1) {
                    return {};
                }
                createChannelSplitter(t1) {
                    return {};
                }
                createConstantSource() {
                    return {};
                }
                createConvolver() {
                    return {};
                }
                createDelay(t1) {
                    return {};
                }
                createDynamicsCompressor() {
                    return {};
                }
                createGain() {
                    return {};
                }
                createIIRFilter(t1, e) {
                    return {};
                }
                createPanner() {
                    return {};
                }
                createPeriodicWave(t1, e, s1) {
                    return {};
                }
                createStereoPanner() {
                    return {};
                }
                createWaveShaper() {
                    return {};
                }
                createMediaStreamSource(t1) {
                    return {};
                }
                createMediaElementSource(t1) {
                    return {};
                }
                createMediaStreamDestination() {
                    return {};
                }
                decodeAudioData(t1) {
                    return Promise.resolve({});
                }
                createAudioWorkletNode(t1, e) {
                    return {};
                }
                get rawContext() {
                    return {};
                }
                addAudioWorkletModule(t1) {
                    return ni(this, void 0, void 0, function*() {
                        return Promise.resolve();
                    });
                }
                resume() {
                    return Promise.resolve();
                }
                setTimeout(t1, e) {
                    return 0;
                }
                clearTimeout(t1) {
                    return this;
                }
                setInterval(t1, e) {
                    return 0;
                }
                clearInterval(t1) {
                    return this;
                }
                getConstant(t1) {
                    return {};
                }
                get currentTime() {
                    return 0;
                }
                get state() {
                    return {};
                }
                get sampleRate() {
                    return 0;
                }
                get listener() {
                    return {};
                }
                get transport() {
                    return {};
                }
                get draw() {
                    return {};
                }
                set draw(t1) {}
                get destination() {
                    return {};
                }
                set destination(t1) {}
                now() {
                    return 0;
                }
                immediate() {
                    return 0;
                }
            };
            let Ii = Fi;
            function Vi() {
                return Ii === Fi && ei && Ni(new Di), Ii;
            }
            function Ni(t1, e = !1) {
                e && Ii.dispose(), Ii = ci(t1) ? new Di(t1) : ai(t1) ? new qi(t1) : t1;
            }
            function Pi() {
                return Ii.resume();
            }
            if (ti && !ti.TONE_SILENCE_LOGGING) {
                let t1 = "v";
                "dev" === i && (t1 = "");
                const e = ` * Tone.js ${t1}${i} * `;
                console.log(`%c${e}`, "background: #000; color: #fff");
            }
            function ji(t1) {
                return Math.pow(10, t1 / 20);
            }
            function Li(t1) {
                return Math.log(t1) / Math.LN10 * 20;
            }
            function zi(t1) {
                return Math.pow(2, t1 / 12);
            }
            let Wi = 440;
            function Bi(t1) {
                return Math.round(Ui(t1));
            }
            function Ui(t1) {
                return 69 + 12 * Math.log2(t1 / Wi);
            }
            function Gi(t1) {
                return Wi * Math.pow(2, (t1 - 69) / 12);
            }
            class Qi extends fi {
                constructor(t1, e, s1){
                    super(), this.defaultUnits = "s", this._val = e, this._units = s1, this.context = t1, this._expressions = this._getExpressions();
                }
                _getExpressions() {
                    return {
                        hz: {
                            method: (t1)=>this._frequencyToUnits(parseFloat(t1)),
                            regexp: /^(\d+(?:\.\d+)?)hz$/i
                        },
                        i: {
                            method: (t1)=>this._ticksToUnits(parseInt(t1, 10)),
                            regexp: /^(\d+)i$/i
                        },
                        m: {
                            method: (t1)=>this._beatsToUnits(parseInt(t1, 10) * this._getTimeSignature()),
                            regexp: /^(\d+)m$/i
                        },
                        n: {
                            method: (t1, e)=>{
                                const s1 = parseInt(t1, 10), n = "." === e ? 1.5 : 1;
                                return 1 === s1 ? this._beatsToUnits(this._getTimeSignature()) * n : this._beatsToUnits(4 / s1) * n;
                            },
                            regexp: /^(\d+)n(\.?)$/i
                        },
                        number: {
                            method: (t1)=>this._expressions[this.defaultUnits].method.call(this, t1),
                            regexp: /^(\d+(?:\.\d+)?)$/
                        },
                        s: {
                            method: (t1)=>this._secondsToUnits(parseFloat(t1)),
                            regexp: /^(\d+(?:\.\d+)?)s$/
                        },
                        samples: {
                            method: (t1)=>parseInt(t1, 10) / this.context.sampleRate,
                            regexp: /^(\d+)samples$/
                        },
                        t: {
                            method: (t1)=>{
                                const e = parseInt(t1, 10);
                                return this._beatsToUnits(8 / (3 * Math.floor(e)));
                            },
                            regexp: /^(\d+)t$/i
                        },
                        tr: {
                            method: (t1, e, s1)=>{
                                let n = 0;
                                return t1 && "0" !== t1 && (n += this._beatsToUnits(this._getTimeSignature() * parseFloat(t1))), e && "0" !== e && (n += this._beatsToUnits(parseFloat(e))), s1 && "0" !== s1 && (n += this._beatsToUnits(parseFloat(s1) / 4)), n;
                            },
                            regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?$/
                        }
                    };
                }
                valueOf() {
                    if (this._val instanceof Qi && this.fromType(this._val), Fn(this._val)) return this._noArg();
                    if (zn(this._val) && Fn(this._units)) {
                        for(const t1 in this._expressions)if (this._expressions[t1].regexp.test(this._val.trim())) {
                            this._units = t1;
                            break;
                        }
                    } else if (Pn(this._val)) {
                        let t1 = 0;
                        for(const e in this._val)if (In(this._val[e])) {
                            const s1 = this._val[e];
                            t1 += new this.constructor(this.context, e).valueOf() * s1;
                        }
                        return t1;
                    }
                    if (In(this._units)) {
                        const t1 = this._expressions[this._units], e = this._val.toString().trim().match(t1.regexp);
                        return e ? t1.method.apply(this, e.slice(1)) : t1.method.call(this, this._val);
                    }
                    return zn(this._val) ? parseFloat(this._val) : this._val;
                }
                _frequencyToUnits(t1) {
                    return 1 / t1;
                }
                _beatsToUnits(t1) {
                    return 60 / this._getBpm() * t1;
                }
                _secondsToUnits(t1) {
                    return t1;
                }
                _ticksToUnits(t1) {
                    return t1 * this._beatsToUnits(1) / this._getPPQ();
                }
                _noArg() {
                    return this._now();
                }
                _getBpm() {
                    return this.context.transport.bpm.value;
                }
                _getTimeSignature() {
                    return this.context.transport.timeSignature;
                }
                _getPPQ() {
                    return this.context.transport.PPQ;
                }
                fromType(t1) {
                    switch(this._units = void 0, this.defaultUnits){
                        case "s":
                            this._val = t1.toSeconds();
                            break;
                        case "i":
                            this._val = t1.toTicks();
                            break;
                        case "hz":
                            this._val = t1.toFrequency();
                            break;
                        case "midi":
                            this._val = t1.toMidi();
                    }
                    return this;
                }
                toFrequency() {
                    return 1 / this.toSeconds();
                }
                toSamples() {
                    return this.toSeconds() * this.context.sampleRate;
                }
                toMilliseconds() {
                    return 1e3 * this.toSeconds();
                }
            }
            class Zi extends Qi {
                constructor(){
                    super(...arguments), this.name = "TimeClass";
                }
                _getExpressions() {
                    return Object.assign(super._getExpressions(), {
                        now: {
                            method: (t1)=>this._now() + new this.constructor(this.context, t1).valueOf(),
                            regexp: /^\+(.+)/
                        },
                        quantize: {
                            method: (t1)=>{
                                const e = new Zi(this.context, t1).valueOf();
                                return this._secondsToUnits(this.context.transport.nextSubdivision(e));
                            },
                            regexp: /^@(.+)/
                        }
                    });
                }
                quantize(t1, e = 1) {
                    const s1 = new this.constructor(this.context, t1).valueOf(), n = this.valueOf();
                    return n + (Math.round(n / s1) * s1 - n) * e;
                }
                toNotation() {
                    const t1 = this.toSeconds(), e = [
                        "1m"
                    ];
                    for(let t1 = 1; t1 < 9; t1++){
                        const s1 = Math.pow(2, t1);
                        e.push(s1 + "n."), e.push(s1 + "n"), e.push(s1 + "t");
                    }
                    e.push("0");
                    let s1 = e[0], n = new Zi(this.context, e[0]).toSeconds();
                    return e.forEach((e)=>{
                        const i = new Zi(this.context, e).toSeconds();
                        Math.abs(i - t1) < Math.abs(n - t1) && (s1 = e, n = i);
                    }), s1;
                }
                toBarsBeatsSixteenths() {
                    const t1 = this._beatsToUnits(1);
                    let e = this.valueOf() / t1;
                    e = parseFloat(e.toFixed(4));
                    const s1 = Math.floor(e / this._getTimeSignature());
                    let n = e % 1 * 4;
                    e = Math.floor(e) % this._getTimeSignature();
                    const i = n.toString();
                    return i.length > 3 && (n = parseFloat(parseFloat(i).toFixed(3))), [
                        s1,
                        e,
                        n
                    ].join(":");
                }
                toTicks() {
                    const t1 = this._beatsToUnits(1);
                    return this.valueOf() / t1 * this._getPPQ();
                }
                toSeconds() {
                    return this.valueOf();
                }
                toMidi() {
                    return Bi(this.toFrequency());
                }
                _now() {
                    return this.context.now();
                }
            }
            function Xi(t1, e) {
                return new Zi(Vi(), t1, e);
            }
            class Yi extends Zi {
                constructor(){
                    super(...arguments), this.name = "Frequency", this.defaultUnits = "hz";
                }
                static get A4() {
                    return Wi;
                }
                static set A4(t1) {
                    !function(t1) {
                        Wi = t1;
                    }(t1);
                }
                _getExpressions() {
                    return Object.assign({}, super._getExpressions(), {
                        midi: {
                            regexp: /^(\d+(?:\.\d+)?midi)/,
                            method (t1) {
                                return "midi" === this.defaultUnits ? t1 : Yi.mtof(t1);
                            }
                        },
                        note: {
                            regexp: /^([a-g]{1}(?:b|#|##|x|bb|###|#x|x#|bbb)?)(-?[0-9]+)/i,
                            method (t1, e) {
                                const s1 = $i[t1.toLowerCase()] + 12 * (parseInt(e, 10) + 1);
                                return "midi" === this.defaultUnits ? s1 : Yi.mtof(s1);
                            }
                        },
                        tr: {
                            regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?/,
                            method (t1, e, s1) {
                                let n = 1;
                                return t1 && "0" !== t1 && (n *= this._beatsToUnits(this._getTimeSignature() * parseFloat(t1))), e && "0" !== e && (n *= this._beatsToUnits(parseFloat(e))), s1 && "0" !== s1 && (n *= this._beatsToUnits(parseFloat(s1) / 4)), n;
                            }
                        }
                    });
                }
                transpose(t1) {
                    return new Yi(this.context, this.valueOf() * zi(t1));
                }
                harmonize(t1) {
                    return t1.map((t1)=>this.transpose(t1));
                }
                toMidi() {
                    return Bi(this.valueOf());
                }
                toNote() {
                    const t1 = this.toFrequency(), e = Math.log2(t1 / Yi.A4);
                    let s1 = Math.round(12 * e) + 57;
                    const n = Math.floor(s1 / 12);
                    return n < 0 && (s1 += -12 * n), Hi[s1 % 12] + n.toString();
                }
                toSeconds() {
                    return 1 / super.toSeconds();
                }
                toTicks() {
                    const t1 = this._beatsToUnits(1), e = this.valueOf() / t1;
                    return Math.floor(e * this._getPPQ());
                }
                _noArg() {
                    return 0;
                }
                _frequencyToUnits(t1) {
                    return t1;
                }
                _ticksToUnits(t1) {
                    return 1 / (60 * t1 / (this._getBpm() * this._getPPQ()));
                }
                _beatsToUnits(t1) {
                    return 1 / super._beatsToUnits(t1);
                }
                _secondsToUnits(t1) {
                    return 1 / t1;
                }
                static mtof(t1) {
                    return Gi(t1);
                }
                static ftom(t1) {
                    return Bi(t1);
                }
            }
            const $i = {
                cbbb: -3,
                cbb: -2,
                cb: -1,
                c: 0,
                "c#": 1,
                cx: 2,
                "c##": 2,
                "c###": 3,
                "cx#": 3,
                "c#x": 3,
                dbbb: -1,
                dbb: 0,
                db: 1,
                d: 2,
                "d#": 3,
                dx: 4,
                "d##": 4,
                "d###": 5,
                "dx#": 5,
                "d#x": 5,
                ebbb: 1,
                ebb: 2,
                eb: 3,
                e: 4,
                "e#": 5,
                ex: 6,
                "e##": 6,
                "e###": 7,
                "ex#": 7,
                "e#x": 7,
                fbbb: 2,
                fbb: 3,
                fb: 4,
                f: 5,
                "f#": 6,
                fx: 7,
                "f##": 7,
                "f###": 8,
                "fx#": 8,
                "f#x": 8,
                gbbb: 4,
                gbb: 5,
                gb: 6,
                g: 7,
                "g#": 8,
                gx: 9,
                "g##": 9,
                "g###": 10,
                "gx#": 10,
                "g#x": 10,
                abbb: 6,
                abb: 7,
                ab: 8,
                a: 9,
                "a#": 10,
                ax: 11,
                "a##": 11,
                "a###": 12,
                "ax#": 12,
                "a#x": 12,
                bbbb: 8,
                bbb: 9,
                bb: 10,
                b: 11,
                "b#": 12,
                bx: 13,
                "b##": 13,
                "b###": 14,
                "bx#": 14,
                "b#x": 14
            }, Hi = [
                "C",
                "C#",
                "D",
                "D#",
                "E",
                "F",
                "F#",
                "G",
                "G#",
                "A",
                "A#",
                "B"
            ];
            function Ji(t1, e) {
                return new Yi(Vi(), t1, e);
            }
            class Ki extends Zi {
                constructor(){
                    super(...arguments), this.name = "TransportTime";
                }
                _now() {
                    return this.context.transport.seconds;
                }
            }
            function to(t1, e) {
                return new Ki(Vi(), t1, e);
            }
            class eo extends fi {
                constructor(){
                    super();
                    const t1 = ui(eo.getDefaults(), arguments, [
                        "context"
                    ]);
                    this.defaultContext ? this.context = this.defaultContext : this.context = t1.context;
                }
                static getDefaults() {
                    return {
                        context: Vi()
                    };
                }
                now() {
                    return this.context.currentTime + this.context.lookAhead;
                }
                immediate() {
                    return this.context.currentTime;
                }
                get sampleTime() {
                    return 1 / this.context.sampleRate;
                }
                get blockTime() {
                    return 128 / this.context.sampleRate;
                }
                toSeconds(t1) {
                    return Yn(t1), new Zi(this.context, t1).toSeconds();
                }
                toFrequency(t1) {
                    return new Yi(this.context, t1).toFrequency();
                }
                toTicks(t1) {
                    return new Ki(this.context, t1).toTicks();
                }
                _getPartialProperties(t1) {
                    const e = this.get();
                    return Object.keys(e).forEach((s1)=>{
                        Fn(t1[s1]) && delete e[s1];
                    }), e;
                }
                get() {
                    const t1 = this.constructor.getDefaults();
                    return Object.keys(t1).forEach((e)=>{
                        if (Reflect.has(this, e)) {
                            const s1 = this[e];
                            In(s1) && In(s1.value) && In(s1.setValueAtTime) ? t1[e] = s1.value : s1 instanceof eo ? t1[e] = s1._getPartialProperties(t1[e]) : Ln(s1) || Nn(s1) || zn(s1) || jn(s1) ? t1[e] = s1 : delete t1[e];
                        }
                    }), t1;
                }
                set(t1) {
                    return Object.keys(t1).forEach((e)=>{
                        Reflect.has(this, e) && In(this[e]) && (this[e] && In(this[e].value) && In(this[e].setValueAtTime) ? this[e].value !== t1[e] && (this[e].value = t1[e]) : this[e] instanceof eo ? this[e].set(t1[e]) : this[e] = t1[e]);
                    }), this;
                }
            }
            class so extends wi {
                constructor(t1 = "stopped"){
                    super(), this.name = "StateTimeline", this._initial = t1, this.setStateAtTime(this._initial, 0);
                }
                getValueAtTime(t1) {
                    const e = this.get(t1);
                    return null !== e ? e.state : this._initial;
                }
                setStateAtTime(t1, e, s1) {
                    return Un(e, 0), this.add(Object.assign({}, s1, {
                        state: t1,
                        time: e
                    })), this;
                }
                getLastState(t1, e) {
                    for(let s1 = this._search(e); s1 >= 0; s1--){
                        const e = this._timeline[s1];
                        if (e.state === t1) return e;
                    }
                }
                getNextState(t1, e) {
                    const s1 = this._search(e);
                    if (-1 !== s1) for(let e = s1; e < this._timeline.length; e++){
                        const s1 = this._timeline[e];
                        if (s1.state === t1) return s1;
                    }
                }
            }
            class no extends eo {
                constructor(){
                    super(ui(no.getDefaults(), arguments, [
                        "param",
                        "units",
                        "convert"
                    ])), this.name = "Param", this.overridden = !1, this._minOutput = 1e-7;
                    const t1 = ui(no.getDefaults(), arguments, [
                        "param",
                        "units",
                        "convert"
                    ]);
                    for(Bn(In(t1.param) && (oi(t1.param) || t1.param instanceof no), "param must be an AudioParam"); !oi(t1.param);)t1.param = t1.param._param;
                    this._swappable = !!In(t1.swappable) && t1.swappable, this._swappable ? (this.input = this.context.createGain(), this._param = t1.param, this.input.connect(this._param)) : this._param = this.input = t1.param, this._events = new wi(1e3), this._initialValue = this._param.defaultValue, this.units = t1.units, this.convert = t1.convert, this._minValue = t1.minValue, this._maxValue = t1.maxValue, In(t1.value) && t1.value !== this._toType(this._initialValue) && this.setValueAtTime(t1.value, 0);
                }
                static getDefaults() {
                    return Object.assign(eo.getDefaults(), {
                        convert: !0,
                        units: "number"
                    });
                }
                get value() {
                    const t1 = this.now();
                    return this.getValueAtTime(t1);
                }
                set value(t1) {
                    this.cancelScheduledValues(this.now()), this.setValueAtTime(t1, this.now());
                }
                get minValue() {
                    return In(this._minValue) ? this._minValue : "time" === this.units || "frequency" === this.units || "normalRange" === this.units || "positive" === this.units || "transportTime" === this.units || "ticks" === this.units || "bpm" === this.units || "hertz" === this.units || "samples" === this.units ? 0 : "audioRange" === this.units ? -1 : "decibels" === this.units ? -1 / 0 : this._param.minValue;
                }
                get maxValue() {
                    return In(this._maxValue) ? this._maxValue : "normalRange" === this.units || "audioRange" === this.units ? 1 : this._param.maxValue;
                }
                _is(t1, e) {
                    return this.units === e;
                }
                _assertRange(t1) {
                    return In(this.maxValue) && In(this.minValue) && Un(t1, this._fromType(this.minValue), this._fromType(this.maxValue)), t1;
                }
                _fromType(t1) {
                    return this.convert && !this.overridden ? this._is(t1, "time") ? this.toSeconds(t1) : this._is(t1, "decibels") ? ji(t1) : this._is(t1, "frequency") ? this.toFrequency(t1) : t1 : this.overridden ? 0 : t1;
                }
                _toType(t1) {
                    return this.convert && "decibels" === this.units ? Li(t1) : t1;
                }
                setValueAtTime(t1, e) {
                    const s1 = this.toSeconds(e), n = this._fromType(t1);
                    return Bn(isFinite(n) && isFinite(s1), `Invalid argument(s) to setValueAtTime: ${JSON.stringify(t1)}, ${JSON.stringify(e)}`), this._assertRange(n), this.log(this.units, "setValueAtTime", t1, s1), this._events.add({
                        time: s1,
                        type: "setValueAtTime",
                        value: n
                    }), this._param.setValueAtTime(n, s1), this;
                }
                getValueAtTime(t1) {
                    const e = Math.max(this.toSeconds(t1), 0), s1 = this._events.getAfter(e), n = this._events.get(e);
                    let i = this._initialValue;
                    if (null === n) i = this._initialValue;
                    else if ("setTargetAtTime" !== n.type || null !== s1 && "setValueAtTime" !== s1.type) {
                        if (null === s1) i = n.value;
                        else if ("linearRampToValueAtTime" === s1.type || "exponentialRampToValueAtTime" === s1.type) {
                            let t1 = n.value;
                            if ("setTargetAtTime" === n.type) {
                                const e = this._events.getBefore(n.time);
                                t1 = null === e ? this._initialValue : e.value;
                            }
                            i = "linearRampToValueAtTime" === s1.type ? this._linearInterpolate(n.time, t1, s1.time, s1.value, e) : this._exponentialInterpolate(n.time, t1, s1.time, s1.value, e);
                        } else i = n.value;
                    } else {
                        const t1 = this._events.getBefore(n.time);
                        let s1;
                        s1 = null === t1 ? this._initialValue : t1.value, "setTargetAtTime" === n.type && (i = this._exponentialApproach(n.time, s1, n.value, n.constant, e));
                    }
                    return this._toType(i);
                }
                setRampPoint(t1) {
                    t1 = this.toSeconds(t1);
                    let e = this.getValueAtTime(t1);
                    return this.cancelAndHoldAtTime(t1), 0 === this._fromType(e) && (e = this._toType(this._minOutput)), this.setValueAtTime(e, t1), this;
                }
                linearRampToValueAtTime(t1, e) {
                    const s1 = this._fromType(t1), n = this.toSeconds(e);
                    return Bn(isFinite(s1) && isFinite(n), `Invalid argument(s) to linearRampToValueAtTime: ${JSON.stringify(t1)}, ${JSON.stringify(e)}`), this._assertRange(s1), this._events.add({
                        time: n,
                        type: "linearRampToValueAtTime",
                        value: s1
                    }), this.log(this.units, "linearRampToValueAtTime", t1, n), this._param.linearRampToValueAtTime(s1, n), this;
                }
                exponentialRampToValueAtTime(t1, e) {
                    let s1 = this._fromType(t1);
                    s1 = yi(s1, 0) ? this._minOutput : s1, this._assertRange(s1);
                    const n = this.toSeconds(e);
                    return Bn(isFinite(s1) && isFinite(n), `Invalid argument(s) to exponentialRampToValueAtTime: ${JSON.stringify(t1)}, ${JSON.stringify(e)}`), this._events.add({
                        time: n,
                        type: "exponentialRampToValueAtTime",
                        value: s1
                    }), this.log(this.units, "exponentialRampToValueAtTime", t1, n), this._param.exponentialRampToValueAtTime(s1, n), this;
                }
                exponentialRampTo(t1, e, s1) {
                    return s1 = this.toSeconds(s1), this.setRampPoint(s1), this.exponentialRampToValueAtTime(t1, s1 + this.toSeconds(e)), this;
                }
                linearRampTo(t1, e, s1) {
                    return s1 = this.toSeconds(s1), this.setRampPoint(s1), this.linearRampToValueAtTime(t1, s1 + this.toSeconds(e)), this;
                }
                targetRampTo(t1, e, s1) {
                    return s1 = this.toSeconds(s1), this.setRampPoint(s1), this.exponentialApproachValueAtTime(t1, s1, e), this;
                }
                exponentialApproachValueAtTime(t1, e, s1) {
                    e = this.toSeconds(e), s1 = this.toSeconds(s1);
                    const n = Math.log(s1 + 1) / Math.log(200);
                    return this.setTargetAtTime(t1, e, n), this.cancelAndHoldAtTime(e + .9 * s1), this.linearRampToValueAtTime(t1, e + s1), this;
                }
                setTargetAtTime(t1, e, s1) {
                    const n = this._fromType(t1);
                    Bn(isFinite(s1) && s1 > 0, "timeConstant must be a number greater than 0");
                    const i = this.toSeconds(e);
                    return this._assertRange(n), Bn(isFinite(n) && isFinite(i), `Invalid argument(s) to setTargetAtTime: ${JSON.stringify(t1)}, ${JSON.stringify(e)}`), this._events.add({
                        constant: s1,
                        time: i,
                        type: "setTargetAtTime",
                        value: n
                    }), this.log(this.units, "setTargetAtTime", t1, i, s1), this._param.setTargetAtTime(n, i, s1), this;
                }
                setValueCurveAtTime(t1, e, s1, n = 1) {
                    s1 = this.toSeconds(s1), e = this.toSeconds(e);
                    const i = this._fromType(t1[0]) * n;
                    this.setValueAtTime(this._toType(i), e);
                    const o = s1 / (t1.length - 1);
                    for(let s1 = 1; s1 < t1.length; s1++){
                        const i = this._fromType(t1[s1]) * n;
                        this.linearRampToValueAtTime(this._toType(i), e + s1 * o);
                    }
                    return this;
                }
                cancelScheduledValues(t1) {
                    const e = this.toSeconds(t1);
                    return Bn(isFinite(e), `Invalid argument to cancelScheduledValues: ${JSON.stringify(t1)}`), this._events.cancel(e), this._param.cancelScheduledValues(e), this.log(this.units, "cancelScheduledValues", e), this;
                }
                cancelAndHoldAtTime(t1) {
                    const e = this.toSeconds(t1), s1 = this._fromType(this.getValueAtTime(e));
                    Bn(isFinite(e), `Invalid argument to cancelAndHoldAtTime: ${JSON.stringify(t1)}`), this.log(this.units, "cancelAndHoldAtTime", e, "value=" + s1);
                    const n = this._events.get(e), i = this._events.getAfter(e);
                    return n && yi(n.time, e) ? i ? (this._param.cancelScheduledValues(i.time), this._events.cancel(i.time)) : (this._param.cancelAndHoldAtTime(e), this._events.cancel(e + this.sampleTime)) : i && (this._param.cancelScheduledValues(i.time), this._events.cancel(i.time), "linearRampToValueAtTime" === i.type ? this.linearRampToValueAtTime(this._toType(s1), e) : "exponentialRampToValueAtTime" === i.type && this.exponentialRampToValueAtTime(this._toType(s1), e)), this._events.add({
                        time: e,
                        type: "setValueAtTime",
                        value: s1
                    }), this._param.setValueAtTime(s1, e), this;
                }
                rampTo(t1, e = .1, s1) {
                    return "frequency" === this.units || "bpm" === this.units || "decibels" === this.units ? this.exponentialRampTo(t1, e, s1) : this.linearRampTo(t1, e, s1), this;
                }
                apply(t1) {
                    const e = this.context.currentTime;
                    t1.setValueAtTime(this.getValueAtTime(e), e);
                    const s1 = this._events.get(e);
                    if (s1 && "setTargetAtTime" === s1.type) {
                        const n = this._events.getAfter(s1.time), i = n ? n.time : e + 2, o = (i - e) / 10;
                        for(let s1 = e; s1 < i; s1 += o)t1.linearRampToValueAtTime(this.getValueAtTime(s1), s1);
                    }
                    return this._events.forEachAfter(this.context.currentTime, (e)=>{
                        "cancelScheduledValues" === e.type ? t1.cancelScheduledValues(e.time) : "setTargetAtTime" === e.type ? t1.setTargetAtTime(e.value, e.time, e.constant) : t1[e.type](e.value, e.time);
                    }), this;
                }
                setParam(t1) {
                    Bn(this._swappable, "The Param must be assigned as 'swappable' in the constructor");
                    const e = this.input;
                    return e.disconnect(this._param), this.apply(t1), this._param = t1, e.connect(this._param), this;
                }
                dispose() {
                    return super.dispose(), this._events.dispose(), this;
                }
                get defaultValue() {
                    return this._toType(this._param.defaultValue);
                }
                _exponentialApproach(t1, e, s1, n, i) {
                    return s1 + (e - s1) * Math.exp(-(i - t1) / n);
                }
                _linearInterpolate(t1, e, s1, n, i) {
                    return e + (i - t1) / (s1 - t1) * (n - e);
                }
                _exponentialInterpolate(t1, e, s1, n, i) {
                    return e * Math.pow(n / e, (i - t1) / (s1 - t1));
                }
            }
            class io extends eo {
                constructor(){
                    super(...arguments), this._internalChannels = [];
                }
                get numberOfInputs() {
                    return In(this.input) ? oi(this.input) || this.input instanceof no ? 1 : this.input.numberOfInputs : 0;
                }
                get numberOfOutputs() {
                    return In(this.output) ? this.output.numberOfOutputs : 0;
                }
                _isAudioNode(t1) {
                    return In(t1) && (t1 instanceof io || ri(t1));
                }
                _getInternalNodes() {
                    const t1 = this._internalChannels.slice(0);
                    return this._isAudioNode(this.input) && t1.push(this.input), this._isAudioNode(this.output) && this.input !== this.output && t1.push(this.output), t1;
                }
                _setChannelProperties(t1) {
                    this._getInternalNodes().forEach((e)=>{
                        e.channelCount = t1.channelCount, e.channelCountMode = t1.channelCountMode, e.channelInterpretation = t1.channelInterpretation;
                    });
                }
                _getChannelProperties() {
                    const t1 = this._getInternalNodes();
                    Bn(t1.length > 0, "ToneAudioNode does not have any internal nodes");
                    const e = t1[0];
                    return {
                        channelCount: e.channelCount,
                        channelCountMode: e.channelCountMode,
                        channelInterpretation: e.channelInterpretation
                    };
                }
                get channelCount() {
                    return this._getChannelProperties().channelCount;
                }
                set channelCount(t1) {
                    const e = this._getChannelProperties();
                    this._setChannelProperties(Object.assign(e, {
                        channelCount: t1
                    }));
                }
                get channelCountMode() {
                    return this._getChannelProperties().channelCountMode;
                }
                set channelCountMode(t1) {
                    const e = this._getChannelProperties();
                    this._setChannelProperties(Object.assign(e, {
                        channelCountMode: t1
                    }));
                }
                get channelInterpretation() {
                    return this._getChannelProperties().channelInterpretation;
                }
                set channelInterpretation(t1) {
                    const e = this._getChannelProperties();
                    this._setChannelProperties(Object.assign(e, {
                        channelInterpretation: t1
                    }));
                }
                connect(t1, e = 0, s1 = 0) {
                    return ro(this, t1, e, s1), this;
                }
                toDestination() {
                    return this.connect(this.context.destination), this;
                }
                toMaster() {
                    return Kn("toMaster() has been renamed toDestination()"), this.toDestination();
                }
                disconnect(t1, e = 0, s1 = 0) {
                    return ao(this, t1, e, s1), this;
                }
                chain(...t1) {
                    return oo(this, ...t1), this;
                }
                fan(...t1) {
                    return t1.forEach((t1)=>this.connect(t1)), this;
                }
                dispose() {
                    return super.dispose(), In(this.input) && (this.input instanceof io ? this.input.dispose() : ri(this.input) && this.input.disconnect()), In(this.output) && (this.output instanceof io ? this.output.dispose() : ri(this.output) && this.output.disconnect()), this._internalChannels = [], this;
                }
            }
            function oo(...t1) {
                const e = t1.shift();
                t1.reduce((t1, e)=>(t1 instanceof io ? t1.connect(e) : ri(t1) && ro(t1, e), e), e);
            }
            function ro(t1, e, s1 = 0, n = 0) {
                for(Bn(In(t1), "Cannot connect from undefined node"), Bn(In(e), "Cannot connect to undefined node"), (e instanceof io || ri(e)) && Bn(e.numberOfInputs > 0, "Cannot connect to node with no inputs"), Bn(t1.numberOfOutputs > 0, "Cannot connect from node with no outputs"); e instanceof io || e instanceof no;)In(e.input) && (e = e.input);
                for(; t1 instanceof io;)In(t1.output) && (t1 = t1.output);
                oi(e) ? t1.connect(e, s1) : t1.connect(e, s1, n);
            }
            function ao(t1, e, s1 = 0, n = 0) {
                if (In(e)) for(; e instanceof io;)e = e.input;
                for(; !ri(t1);)In(t1.output) && (t1 = t1.output);
                oi(e) ? t1.disconnect(e, s1) : ri(e) ? t1.disconnect(e, s1, n) : t1.disconnect();
            }
            function co(...t1) {
                const e = t1.pop();
                In(e) && t1.forEach((t1)=>ro(t1, e));
            }
            class ho extends io {
                constructor(){
                    super(ui(ho.getDefaults(), arguments, [
                        "gain",
                        "units"
                    ])), this.name = "Gain", this._gainNode = this.context.createGain(), this.input = this._gainNode, this.output = this._gainNode;
                    const t1 = ui(ho.getDefaults(), arguments, [
                        "gain",
                        "units"
                    ]);
                    this.gain = new no({
                        context: this.context,
                        convert: t1.convert,
                        param: this._gainNode.gain,
                        units: t1.units,
                        value: t1.gain,
                        minValue: t1.minValue,
                        maxValue: t1.maxValue
                    }), Oi(this, "gain");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        convert: !0,
                        gain: 1,
                        units: "gain"
                    });
                }
                dispose() {
                    return super.dispose(), this._gainNode.disconnect(), this.gain.dispose(), this;
                }
            }
            class lo extends io {
                constructor(t1){
                    super(t1), this.onended = Ei, this._startTime = -1, this._stopTime = -1, this._timeout = -1, this.output = new ho({
                        context: this.context,
                        gain: 0
                    }), this._gainNode = this.output, this.getStateAtTime = function(t1) {
                        const e = this.toSeconds(t1);
                        return -1 !== this._startTime && e >= this._startTime && (-1 === this._stopTime || e <= this._stopTime) ? "started" : "stopped";
                    }, this._fadeIn = t1.fadeIn, this._fadeOut = t1.fadeOut, this._curve = t1.curve, this.onended = t1.onended;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        curve: "linear",
                        fadeIn: 0,
                        fadeOut: 0,
                        onended: Ei
                    });
                }
                _startGain(t1, e = 1) {
                    Bn(-1 === this._startTime, "Source cannot be started more than once");
                    const s1 = this.toSeconds(this._fadeIn);
                    return this._startTime = t1 + s1, this._startTime = Math.max(this._startTime, this.context.currentTime), s1 > 0 ? (this._gainNode.gain.setValueAtTime(0, t1), "linear" === this._curve ? this._gainNode.gain.linearRampToValueAtTime(e, t1 + s1) : this._gainNode.gain.exponentialApproachValueAtTime(e, t1, s1)) : this._gainNode.gain.setValueAtTime(e, t1), this;
                }
                stop(t1) {
                    return this.log("stop", t1), this._stopGain(this.toSeconds(t1)), this;
                }
                _stopGain(t1) {
                    Bn(-1 !== this._startTime, "'start' must be called before 'stop'"), this.cancelStop();
                    const e = this.toSeconds(this._fadeOut);
                    return this._stopTime = this.toSeconds(t1) + e, this._stopTime = Math.max(this._stopTime, this.now()), e > 0 ? "linear" === this._curve ? this._gainNode.gain.linearRampTo(0, e, t1) : this._gainNode.gain.targetRampTo(0, e, t1) : (this._gainNode.gain.cancelAndHoldAtTime(t1), this._gainNode.gain.setValueAtTime(0, t1)), this.context.clearTimeout(this._timeout), this._timeout = this.context.setTimeout(()=>{
                        const t1 = "exponential" === this._curve ? 2 * e : 0;
                        this._stopSource(this.now() + t1), this._onended();
                    }, this._stopTime - this.context.currentTime), this;
                }
                _onended() {
                    if (this.onended !== Ei && (this.onended(this), this.onended = Ei, !this.context.isOffline)) {
                        const t1 = ()=>this.dispose();
                        void 0 !== window.requestIdleCallback ? window.requestIdleCallback(t1) : setTimeout(t1, 1e3);
                    }
                }
                get state() {
                    return this.getStateAtTime(this.now());
                }
                cancelStop() {
                    return this.log("cancelStop"), Bn(-1 !== this._startTime, "Source is not started"), this._gainNode.gain.cancelScheduledValues(this._startTime + this.sampleTime), this.context.clearTimeout(this._timeout), this._stopTime = -1, this;
                }
                dispose() {
                    return super.dispose(), this._gainNode.dispose(), this.onended = Ei, this;
                }
            }
            class uo extends lo {
                constructor(){
                    super(ui(uo.getDefaults(), arguments, [
                        "offset"
                    ])), this.name = "ToneConstantSource", this._source = this.context.createConstantSource();
                    const t1 = ui(uo.getDefaults(), arguments, [
                        "offset"
                    ]);
                    ro(this._source, this._gainNode), this.offset = new no({
                        context: this.context,
                        convert: t1.convert,
                        param: this._source.offset,
                        units: t1.units,
                        value: t1.offset,
                        minValue: t1.minValue,
                        maxValue: t1.maxValue
                    });
                }
                static getDefaults() {
                    return Object.assign(lo.getDefaults(), {
                        convert: !0,
                        offset: 1,
                        units: "number"
                    });
                }
                start(t1) {
                    const e = this.toSeconds(t1);
                    return this.log("start", e), this._startGain(e), this._source.start(e), this;
                }
                _stopSource(t1) {
                    this._source.stop(t1);
                }
                dispose() {
                    return super.dispose(), "started" === this.state && this.stop(), this._source.disconnect(), this.offset.dispose(), this;
                }
            }
            class po extends io {
                constructor(){
                    super(ui(po.getDefaults(), arguments, [
                        "value",
                        "units"
                    ])), this.name = "Signal", this.override = !0;
                    const t1 = ui(po.getDefaults(), arguments, [
                        "value",
                        "units"
                    ]);
                    this.output = this._constantSource = new uo({
                        context: this.context,
                        convert: t1.convert,
                        offset: t1.value,
                        units: t1.units,
                        minValue: t1.minValue,
                        maxValue: t1.maxValue
                    }), this._constantSource.start(0), this.input = this._param = this._constantSource.offset;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        convert: !0,
                        units: "number",
                        value: 0
                    });
                }
                connect(t1, e = 0, s1 = 0) {
                    return fo(this, t1, e, s1), this;
                }
                dispose() {
                    return super.dispose(), this._param.dispose(), this._constantSource.dispose(), this;
                }
                setValueAtTime(t1, e) {
                    return this._param.setValueAtTime(t1, e), this;
                }
                getValueAtTime(t1) {
                    return this._param.getValueAtTime(t1);
                }
                setRampPoint(t1) {
                    return this._param.setRampPoint(t1), this;
                }
                linearRampToValueAtTime(t1, e) {
                    return this._param.linearRampToValueAtTime(t1, e), this;
                }
                exponentialRampToValueAtTime(t1, e) {
                    return this._param.exponentialRampToValueAtTime(t1, e), this;
                }
                exponentialRampTo(t1, e, s1) {
                    return this._param.exponentialRampTo(t1, e, s1), this;
                }
                linearRampTo(t1, e, s1) {
                    return this._param.linearRampTo(t1, e, s1), this;
                }
                targetRampTo(t1, e, s1) {
                    return this._param.targetRampTo(t1, e, s1), this;
                }
                exponentialApproachValueAtTime(t1, e, s1) {
                    return this._param.exponentialApproachValueAtTime(t1, e, s1), this;
                }
                setTargetAtTime(t1, e, s1) {
                    return this._param.setTargetAtTime(t1, e, s1), this;
                }
                setValueCurveAtTime(t1, e, s1, n) {
                    return this._param.setValueCurveAtTime(t1, e, s1, n), this;
                }
                cancelScheduledValues(t1) {
                    return this._param.cancelScheduledValues(t1), this;
                }
                cancelAndHoldAtTime(t1) {
                    return this._param.cancelAndHoldAtTime(t1), this;
                }
                rampTo(t1, e, s1) {
                    return this._param.rampTo(t1, e, s1), this;
                }
                get value() {
                    return this._param.value;
                }
                set value(t1) {
                    this._param.value = t1;
                }
                get convert() {
                    return this._param.convert;
                }
                set convert(t1) {
                    this._param.convert = t1;
                }
                get units() {
                    return this._param.units;
                }
                get overridden() {
                    return this._param.overridden;
                }
                set overridden(t1) {
                    this._param.overridden = t1;
                }
                get maxValue() {
                    return this._param.maxValue;
                }
                get minValue() {
                    return this._param.minValue;
                }
                apply(t1) {
                    return this._param.apply(t1), this;
                }
            }
            function fo(t1, e, s1, n) {
                (e instanceof no || oi(e) || e instanceof po && e.override) && (e.cancelScheduledValues(0), e.setValueAtTime(0, 0), e instanceof po && (e.overridden = !0)), ro(t1, e, s1, n);
            }
            class _o extends no {
                constructor(){
                    super(ui(_o.getDefaults(), arguments, [
                        "value"
                    ])), this.name = "TickParam", this._events = new wi(1 / 0), this._multiplier = 1;
                    const t1 = ui(_o.getDefaults(), arguments, [
                        "value"
                    ]);
                    this._multiplier = t1.multiplier, this._events.cancel(0), this._events.add({
                        ticks: 0,
                        time: 0,
                        type: "setValueAtTime",
                        value: this._fromType(t1.value)
                    }), this.setValueAtTime(t1.value, 0);
                }
                static getDefaults() {
                    return Object.assign(no.getDefaults(), {
                        multiplier: 1,
                        units: "hertz",
                        value: 1
                    });
                }
                setTargetAtTime(t1, e, s1) {
                    e = this.toSeconds(e), this.setRampPoint(e);
                    const n = this._fromType(t1), i = this._events.get(e), o = Math.round(Math.max(1 / s1, 1));
                    for(let t1 = 0; t1 <= o; t1++){
                        const o = s1 * t1 + e, r = this._exponentialApproach(i.time, i.value, n, s1, o);
                        this.linearRampToValueAtTime(this._toType(r), o);
                    }
                    return this;
                }
                setValueAtTime(t1, e) {
                    const s1 = this.toSeconds(e);
                    super.setValueAtTime(t1, e);
                    const n = this._events.get(s1), i = this._events.previousEvent(n), o = this._getTicksUntilEvent(i, s1);
                    return n.ticks = Math.max(o, 0), this;
                }
                linearRampToValueAtTime(t1, e) {
                    const s1 = this.toSeconds(e);
                    super.linearRampToValueAtTime(t1, e);
                    const n = this._events.get(s1), i = this._events.previousEvent(n), o = this._getTicksUntilEvent(i, s1);
                    return n.ticks = Math.max(o, 0), this;
                }
                exponentialRampToValueAtTime(t1, e) {
                    e = this.toSeconds(e);
                    const s1 = this._fromType(t1), n = this._events.get(e), i = Math.round(Math.max(10 * (e - n.time), 1)), o = (e - n.time) / i;
                    for(let t1 = 0; t1 <= i; t1++){
                        const i = o * t1 + n.time, r = this._exponentialInterpolate(n.time, n.value, e, s1, i);
                        this.linearRampToValueAtTime(this._toType(r), i);
                    }
                    return this;
                }
                _getTicksUntilEvent(t1, e) {
                    if (null === t1) t1 = {
                        ticks: 0,
                        time: 0,
                        type: "setValueAtTime",
                        value: 0
                    };
                    else if (Fn(t1.ticks)) {
                        const e = this._events.previousEvent(t1);
                        t1.ticks = this._getTicksUntilEvent(e, t1.time);
                    }
                    const s1 = this._fromType(this.getValueAtTime(t1.time));
                    let n = this._fromType(this.getValueAtTime(e));
                    const i = this._events.get(e);
                    return i && i.time === e && "setValueAtTime" === i.type && (n = this._fromType(this.getValueAtTime(e - this.sampleTime))), .5 * (e - t1.time) * (s1 + n) + t1.ticks;
                }
                getTicksAtTime(t1) {
                    const e = this.toSeconds(t1), s1 = this._events.get(e);
                    return Math.max(this._getTicksUntilEvent(s1, e), 0);
                }
                getDurationOfTicks(t1, e) {
                    const s1 = this.toSeconds(e), n = this.getTicksAtTime(e);
                    return this.getTimeOfTick(n + t1) - s1;
                }
                getTimeOfTick(t1) {
                    const e = this._events.get(t1, "ticks"), s1 = this._events.getAfter(t1, "ticks");
                    if (e && e.ticks === t1) return e.time;
                    if (e && s1 && "linearRampToValueAtTime" === s1.type && e.value !== s1.value) {
                        const n = this._fromType(this.getValueAtTime(e.time)), i = (this._fromType(this.getValueAtTime(s1.time)) - n) / (s1.time - e.time), o = Math.sqrt(Math.pow(n, 2) - 2 * i * (e.ticks - t1)), r = (-n + o) / i, a = (-n - o) / i;
                        return (r > 0 ? r : a) + e.time;
                    }
                    return e ? 0 === e.value ? 1 / 0 : e.time + (t1 - e.ticks) / e.value : t1 / this._initialValue;
                }
                ticksToTime(t1, e) {
                    return this.getDurationOfTicks(t1, e);
                }
                timeToTicks(t1, e) {
                    const s1 = this.toSeconds(e), n = this.toSeconds(t1), i = this.getTicksAtTime(s1);
                    return this.getTicksAtTime(s1 + n) - i;
                }
                _fromType(t1) {
                    return "bpm" === this.units && this.multiplier ? 1 / (60 / t1 / this.multiplier) : super._fromType(t1);
                }
                _toType(t1) {
                    return "bpm" === this.units && this.multiplier ? t1 / this.multiplier * 60 : super._toType(t1);
                }
                get multiplier() {
                    return this._multiplier;
                }
                set multiplier(t1) {
                    const e = this.value;
                    this._multiplier = t1, this.cancelScheduledValues(0), this.setValueAtTime(e, 0);
                }
            }
            class mo extends po {
                constructor(){
                    super(ui(mo.getDefaults(), arguments, [
                        "value"
                    ])), this.name = "TickSignal";
                    const t1 = ui(mo.getDefaults(), arguments, [
                        "value"
                    ]);
                    this.input = this._param = new _o({
                        context: this.context,
                        convert: t1.convert,
                        multiplier: t1.multiplier,
                        param: this._constantSource.offset,
                        units: t1.units,
                        value: t1.value
                    });
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        multiplier: 1,
                        units: "hertz",
                        value: 1
                    });
                }
                ticksToTime(t1, e) {
                    return this._param.ticksToTime(t1, e);
                }
                timeToTicks(t1, e) {
                    return this._param.timeToTicks(t1, e);
                }
                getTimeOfTick(t1) {
                    return this._param.getTimeOfTick(t1);
                }
                getDurationOfTicks(t1, e) {
                    return this._param.getDurationOfTicks(t1, e);
                }
                getTicksAtTime(t1) {
                    return this._param.getTicksAtTime(t1);
                }
                get multiplier() {
                    return this._param.multiplier;
                }
                set multiplier(t1) {
                    this._param.multiplier = t1;
                }
                dispose() {
                    return super.dispose(), this._param.dispose(), this;
                }
            }
            class go extends eo {
                constructor(){
                    super(ui(go.getDefaults(), arguments, [
                        "frequency"
                    ])), this.name = "TickSource", this._state = new so, this._tickOffset = new wi, this._ticksAtTime = new wi, this._secondsAtTime = new wi;
                    const t1 = ui(go.getDefaults(), arguments, [
                        "frequency"
                    ]);
                    this.frequency = new mo({
                        context: this.context,
                        units: t1.units,
                        value: t1.frequency
                    }), Oi(this, "frequency"), this._state.setStateAtTime("stopped", 0), this.setTicksAtTime(0, 0);
                }
                static getDefaults() {
                    return Object.assign({
                        frequency: 1,
                        units: "hertz"
                    }, eo.getDefaults());
                }
                get state() {
                    return this.getStateAtTime(this.now());
                }
                start(t1, e) {
                    const s1 = this.toSeconds(t1);
                    return "started" !== this._state.getValueAtTime(s1) && (this._state.setStateAtTime("started", s1), In(e) && this.setTicksAtTime(e, s1), this._ticksAtTime.cancel(s1), this._secondsAtTime.cancel(s1)), this;
                }
                stop(t1) {
                    const e = this.toSeconds(t1);
                    if ("stopped" === this._state.getValueAtTime(e)) {
                        const t1 = this._state.get(e);
                        t1 && t1.time > 0 && (this._tickOffset.cancel(t1.time), this._state.cancel(t1.time));
                    }
                    return this._state.cancel(e), this._state.setStateAtTime("stopped", e), this.setTicksAtTime(0, e), this._ticksAtTime.cancel(e), this._secondsAtTime.cancel(e), this;
                }
                pause(t1) {
                    const e = this.toSeconds(t1);
                    return "started" === this._state.getValueAtTime(e) && (this._state.setStateAtTime("paused", e), this._ticksAtTime.cancel(e), this._secondsAtTime.cancel(e)), this;
                }
                cancel(t1) {
                    return t1 = this.toSeconds(t1), this._state.cancel(t1), this._tickOffset.cancel(t1), this._ticksAtTime.cancel(t1), this._secondsAtTime.cancel(t1), this;
                }
                getTicksAtTime(t1) {
                    const e = this.toSeconds(t1), s1 = this._state.getLastState("stopped", e), n = this._ticksAtTime.get(e), i = {
                        state: "paused",
                        time: e
                    };
                    this._state.add(i);
                    let o = n || s1, r = n ? n.ticks : 0, a = null;
                    return this._state.forEachBetween(o.time, e + this.sampleTime, (t1)=>{
                        let e = o.time;
                        const s1 = this._tickOffset.get(t1.time);
                        s1 && s1.time >= o.time && (r = s1.ticks, e = s1.time), "started" === o.state && "started" !== t1.state && (r += this.frequency.getTicksAtTime(t1.time) - this.frequency.getTicksAtTime(e), t1.time !== i.time && (a = {
                            state: t1.state,
                            time: t1.time,
                            ticks: r
                        })), o = t1;
                    }), this._state.remove(i), a && this._ticksAtTime.add(a), r;
                }
                get ticks() {
                    return this.getTicksAtTime(this.now());
                }
                set ticks(t1) {
                    this.setTicksAtTime(t1, this.now());
                }
                get seconds() {
                    return this.getSecondsAtTime(this.now());
                }
                set seconds(t1) {
                    const e = this.now(), s1 = this.frequency.timeToTicks(t1, e);
                    this.setTicksAtTime(s1, e);
                }
                getSecondsAtTime(t1) {
                    t1 = this.toSeconds(t1);
                    const e = this._state.getLastState("stopped", t1), s1 = {
                        state: "paused",
                        time: t1
                    };
                    this._state.add(s1);
                    const n = this._secondsAtTime.get(t1);
                    let i = n || e, o = n ? n.seconds : 0, r = null;
                    return this._state.forEachBetween(i.time, t1 + this.sampleTime, (t1)=>{
                        let e = i.time;
                        const n = this._tickOffset.get(t1.time);
                        n && n.time >= i.time && (o = n.seconds, e = n.time), "started" === i.state && "started" !== t1.state && (o += t1.time - e, t1.time !== s1.time && (r = {
                            state: t1.state,
                            time: t1.time,
                            seconds: o
                        })), i = t1;
                    }), this._state.remove(s1), r && this._secondsAtTime.add(r), o;
                }
                setTicksAtTime(t1, e) {
                    return e = this.toSeconds(e), this._tickOffset.cancel(e), this._tickOffset.add({
                        seconds: this.frequency.getDurationOfTicks(t1, e),
                        ticks: t1,
                        time: e
                    }), this._ticksAtTime.cancel(e), this._secondsAtTime.cancel(e), this;
                }
                getStateAtTime(t1) {
                    return t1 = this.toSeconds(t1), this._state.getValueAtTime(t1);
                }
                getTimeOfTick(t1, e = this.now()) {
                    const s1 = this._tickOffset.get(e), n = this._state.get(e), i = Math.max(s1.time, n.time), o = this.frequency.getTicksAtTime(i) + t1 - s1.ticks;
                    return this.frequency.getTimeOfTick(o);
                }
                forEachTickBetween(t1, e, s1) {
                    let n = this._state.get(t1);
                    this._state.forEachBetween(t1, e, (e)=>{
                        n && "started" === n.state && "started" !== e.state && this.forEachTickBetween(Math.max(n.time, t1), e.time - this.sampleTime, s1), n = e;
                    });
                    let i = null;
                    if (n && "started" === n.state) {
                        const o = Math.max(n.time, t1), r = this.frequency.getTicksAtTime(o), a = r - this.frequency.getTicksAtTime(n.time);
                        let c = Math.ceil(a) - a;
                        c = yi(c, 1) ? 0 : c;
                        let h = this.frequency.getTimeOfTick(r + c);
                        for(; h < e;){
                            try {
                                s1(h, Math.round(this.getTicksAtTime(h)));
                            } catch (t1) {
                                i = t1;
                                break;
                            }
                            h += this.frequency.getDurationOfTicks(1, h);
                        }
                    }
                    if (i) throw i;
                    return this;
                }
                dispose() {
                    return super.dispose(), this._state.dispose(), this._tickOffset.dispose(), this._ticksAtTime.dispose(), this._secondsAtTime.dispose(), this.frequency.dispose(), this;
                }
            }
            class vo extends eo {
                constructor(){
                    super(ui(vo.getDefaults(), arguments, [
                        "callback",
                        "frequency"
                    ])), this.name = "Clock", this.callback = Ei, this._lastUpdate = 0, this._state = new so("stopped"), this._boundLoop = this._loop.bind(this);
                    const t1 = ui(vo.getDefaults(), arguments, [
                        "callback",
                        "frequency"
                    ]);
                    this.callback = t1.callback, this._tickSource = new go({
                        context: this.context,
                        frequency: t1.frequency,
                        units: t1.units
                    }), this._lastUpdate = 0, this.frequency = this._tickSource.frequency, Oi(this, "frequency"), this._state.setStateAtTime("stopped", 0), this.context.on("tick", this._boundLoop);
                }
                static getDefaults() {
                    return Object.assign(eo.getDefaults(), {
                        callback: Ei,
                        frequency: 1,
                        units: "hertz"
                    });
                }
                get state() {
                    return this._state.getValueAtTime(this.now());
                }
                start(t1, e) {
                    Gn(this.context);
                    const s1 = this.toSeconds(t1);
                    return this.log("start", s1), "started" !== this._state.getValueAtTime(s1) && (this._state.setStateAtTime("started", s1), this._tickSource.start(s1, e), s1 < this._lastUpdate && this.emit("start", s1, e)), this;
                }
                stop(t1) {
                    const e = this.toSeconds(t1);
                    return this.log("stop", e), this._state.cancel(e), this._state.setStateAtTime("stopped", e), this._tickSource.stop(e), e < this._lastUpdate && this.emit("stop", e), this;
                }
                pause(t1) {
                    const e = this.toSeconds(t1);
                    return "started" === this._state.getValueAtTime(e) && (this._state.setStateAtTime("paused", e), this._tickSource.pause(e), e < this._lastUpdate && this.emit("pause", e)), this;
                }
                get ticks() {
                    return Math.ceil(this.getTicksAtTime(this.now()));
                }
                set ticks(t1) {
                    this._tickSource.ticks = t1;
                }
                get seconds() {
                    return this._tickSource.seconds;
                }
                set seconds(t1) {
                    this._tickSource.seconds = t1;
                }
                getSecondsAtTime(t1) {
                    return this._tickSource.getSecondsAtTime(t1);
                }
                setTicksAtTime(t1, e) {
                    return this._tickSource.setTicksAtTime(t1, e), this;
                }
                getTimeOfTick(t1, e = this.now()) {
                    return this._tickSource.getTimeOfTick(t1, e);
                }
                getTicksAtTime(t1) {
                    return this._tickSource.getTicksAtTime(t1);
                }
                nextTickTime(t1, e) {
                    const s1 = this.toSeconds(e), n = this.getTicksAtTime(s1);
                    return this._tickSource.getTimeOfTick(n + t1, s1);
                }
                _loop() {
                    const t1 = this._lastUpdate, e = this.now();
                    this._lastUpdate = e, this.log("loop", t1, e), t1 !== e && (this._state.forEachBetween(t1, e, (t1)=>{
                        switch(t1.state){
                            case "started":
                                const e = this._tickSource.getTicksAtTime(t1.time);
                                this.emit("start", t1.time, e);
                                break;
                            case "stopped":
                                0 !== t1.time && this.emit("stop", t1.time);
                                break;
                            case "paused":
                                this.emit("pause", t1.time);
                        }
                    }), this._tickSource.forEachTickBetween(t1, e, (t1, e)=>{
                        this.callback(t1, e);
                    }));
                }
                getStateAtTime(t1) {
                    const e = this.toSeconds(t1);
                    return this._state.getValueAtTime(e);
                }
                dispose() {
                    return super.dispose(), this.context.off("tick", this._boundLoop), this._tickSource.dispose(), this._state.dispose(), this;
                }
            }
            Ai.mixin(vo);
            class yo extends io {
                constructor(){
                    super(ui(yo.getDefaults(), arguments, [
                        "delayTime",
                        "maxDelay"
                    ])), this.name = "Delay";
                    const t1 = ui(yo.getDefaults(), arguments, [
                        "delayTime",
                        "maxDelay"
                    ]), e = this.toSeconds(t1.maxDelay);
                    this._maxDelay = Math.max(e, this.toSeconds(t1.delayTime)), this._delayNode = this.input = this.output = this.context.createDelay(e), this.delayTime = new no({
                        context: this.context,
                        param: this._delayNode.delayTime,
                        units: "time",
                        value: t1.delayTime,
                        minValue: 0,
                        maxValue: this.maxDelay
                    }), Oi(this, "delayTime");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        delayTime: 0,
                        maxDelay: 1
                    });
                }
                get maxDelay() {
                    return this._maxDelay;
                }
                dispose() {
                    return super.dispose(), this._delayNode.disconnect(), this.delayTime.dispose(), this;
                }
            }
            function xo(t1, e, s1 = 2, n = Vi().sampleRate) {
                return ni(this, void 0, void 0, function*() {
                    const i = Vi(), o = new qi(s1, e, n);
                    Ni(o), yield t1(o);
                    const r = o.render();
                    Ni(i);
                    const a = yield r;
                    return new Ri(a);
                });
            }
            class wo extends fi {
                constructor(){
                    super(), this.name = "ToneAudioBuffers", this._buffers = new Map, this._loadingCount = 0;
                    const t1 = ui(wo.getDefaults(), arguments, [
                        "urls",
                        "onload",
                        "baseUrl"
                    ], "urls");
                    this.baseUrl = t1.baseUrl, Object.keys(t1.urls).forEach((e)=>{
                        this._loadingCount++;
                        const s1 = t1.urls[e];
                        this.add(e, s1, this._bufferLoaded.bind(this, t1.onload), t1.onerror);
                    });
                }
                static getDefaults() {
                    return {
                        baseUrl: "",
                        onerror: Ei,
                        onload: Ei,
                        urls: {}
                    };
                }
                has(t1) {
                    return this._buffers.has(t1.toString());
                }
                get(t1) {
                    return Bn(this.has(t1), `ToneAudioBuffers has no buffer named: ${t1}`), this._buffers.get(t1.toString());
                }
                _bufferLoaded(t1) {
                    this._loadingCount--, 0 === this._loadingCount && t1 && t1();
                }
                get loaded() {
                    return Array.from(this._buffers).every(([t1, e])=>e.loaded);
                }
                add(t1, e, s1 = Ei, n = Ei) {
                    return zn(e) ? (this.baseUrl && "data:audio/" === e.trim().substring(0, 11).toLowerCase() && (this.baseUrl = ""), this._buffers.set(t1.toString(), new Ri(this.baseUrl + e, s1, n))) : this._buffers.set(t1.toString(), new Ri(e, s1, n)), this;
                }
                dispose() {
                    return super.dispose(), this._buffers.forEach((t1)=>t1.dispose()), this._buffers.clear(), this;
                }
            }
            class bo extends Yi {
                constructor(){
                    super(...arguments), this.name = "MidiClass", this.defaultUnits = "midi";
                }
                _frequencyToUnits(t1) {
                    return Bi(super._frequencyToUnits(t1));
                }
                _ticksToUnits(t1) {
                    return Bi(super._ticksToUnits(t1));
                }
                _beatsToUnits(t1) {
                    return Bi(super._beatsToUnits(t1));
                }
                _secondsToUnits(t1) {
                    return Bi(super._secondsToUnits(t1));
                }
                toMidi() {
                    return this.valueOf();
                }
                toFrequency() {
                    return Gi(this.toMidi());
                }
                transpose(t1) {
                    return new bo(this.context, this.toMidi() + t1);
                }
            }
            function To(t1, e) {
                return new bo(Vi(), t1, e);
            }
            class So extends Ki {
                constructor(){
                    super(...arguments), this.name = "Ticks", this.defaultUnits = "i";
                }
                _now() {
                    return this.context.transport.ticks;
                }
                _beatsToUnits(t1) {
                    return this._getPPQ() * t1;
                }
                _secondsToUnits(t1) {
                    return Math.floor(t1 / (60 / this._getBpm()) * this._getPPQ());
                }
                _ticksToUnits(t1) {
                    return t1;
                }
                toTicks() {
                    return this.valueOf();
                }
                toSeconds() {
                    return this.valueOf() / this._getPPQ() * (60 / this._getBpm());
                }
            }
            function ko(t1, e) {
                return new So(Vi(), t1, e);
            }
            class Ao extends eo {
                constructor(){
                    super(...arguments), this.name = "Draw", this.expiration = .25, this.anticipation = .008, this._events = new wi, this._boundDrawLoop = this._drawLoop.bind(this), this._animationFrame = -1;
                }
                schedule(t1, e) {
                    return this._events.add({
                        callback: t1,
                        time: this.toSeconds(e)
                    }), 1 === this._events.length && (this._animationFrame = requestAnimationFrame(this._boundDrawLoop)), this;
                }
                cancel(t1) {
                    return this._events.cancel(this.toSeconds(t1)), this;
                }
                _drawLoop() {
                    const t1 = this.context.currentTime;
                    for(; this._events.length && this._events.peek().time - this.anticipation <= t1;){
                        const e = this._events.shift();
                        e && t1 - e.time <= this.expiration && e.callback();
                    }
                    this._events.length > 0 && (this._animationFrame = requestAnimationFrame(this._boundDrawLoop));
                }
                dispose() {
                    return super.dispose(), this._events.dispose(), cancelAnimationFrame(this._animationFrame), this;
                }
            }
            Ti((t1)=>{
                t1.draw = new Ao({
                    context: t1
                });
            }), ki((t1)=>{
                t1.draw.dispose();
            });
            class Co extends fi {
                constructor(){
                    super(...arguments), this.name = "IntervalTimeline", this._root = null, this._length = 0;
                }
                add(t1) {
                    Bn(In(t1.time), "Events must have a time property"), Bn(In(t1.duration), "Events must have a duration parameter"), t1.time = t1.time.valueOf();
                    let e = new Do(t1.time, t1.time + t1.duration, t1);
                    for(null === this._root ? this._root = e : this._root.insert(e), this._length++; null !== e;)e.updateHeight(), e.updateMax(), this._rebalance(e), e = e.parent;
                    return this;
                }
                remove(t1) {
                    if (null !== this._root) {
                        const e = [];
                        this._root.search(t1.time, e);
                        for (const s1 of e)if (s1.event === t1) {
                            this._removeNode(s1), this._length--;
                            break;
                        }
                    }
                    return this;
                }
                get length() {
                    return this._length;
                }
                cancel(t1) {
                    return this.forEachFrom(t1, (t1)=>this.remove(t1)), this;
                }
                _setRoot(t1) {
                    this._root = t1, null !== this._root && (this._root.parent = null);
                }
                _replaceNodeInParent(t1, e) {
                    null !== t1.parent ? (t1.isLeftChild() ? t1.parent.left = e : t1.parent.right = e, this._rebalance(t1.parent)) : this._setRoot(e);
                }
                _removeNode(t1) {
                    if (null === t1.left && null === t1.right) this._replaceNodeInParent(t1, null);
                    else if (null === t1.right) this._replaceNodeInParent(t1, t1.left);
                    else if (null === t1.left) this._replaceNodeInParent(t1, t1.right);
                    else {
                        let e, s1 = null;
                        if (t1.getBalance() > 0) {
                            if (null === t1.left.right) e = t1.left, e.right = t1.right, s1 = e;
                            else {
                                for(e = t1.left.right; null !== e.right;)e = e.right;
                                e.parent && (e.parent.right = e.left, s1 = e.parent, e.left = t1.left, e.right = t1.right);
                            }
                        } else if (null === t1.right.left) e = t1.right, e.left = t1.left, s1 = e;
                        else {
                            for(e = t1.right.left; null !== e.left;)e = e.left;
                            e.parent && (e.parent.left = e.right, s1 = e.parent, e.left = t1.left, e.right = t1.right);
                        }
                        null !== t1.parent ? t1.isLeftChild() ? t1.parent.left = e : t1.parent.right = e : this._setRoot(e), s1 && this._rebalance(s1);
                    }
                    t1.dispose();
                }
                _rotateLeft(t1) {
                    const e = t1.parent, s1 = t1.isLeftChild(), n = t1.right;
                    n && (t1.right = n.left, n.left = t1), null !== e ? s1 ? e.left = n : e.right = n : this._setRoot(n);
                }
                _rotateRight(t1) {
                    const e = t1.parent, s1 = t1.isLeftChild(), n = t1.left;
                    n && (t1.left = n.right, n.right = t1), null !== e ? s1 ? e.left = n : e.right = n : this._setRoot(n);
                }
                _rebalance(t1) {
                    const e = t1.getBalance();
                    e > 1 && t1.left ? t1.left.getBalance() < 0 ? this._rotateLeft(t1.left) : this._rotateRight(t1) : e < -1 && t1.right && (t1.right.getBalance() > 0 ? this._rotateRight(t1.right) : this._rotateLeft(t1));
                }
                get(t1) {
                    if (null !== this._root) {
                        const e = [];
                        if (this._root.search(t1, e), e.length > 0) {
                            let t1 = e[0];
                            for(let s1 = 1; s1 < e.length; s1++)e[s1].low > t1.low && (t1 = e[s1]);
                            return t1.event;
                        }
                    }
                    return null;
                }
                forEach(t1) {
                    if (null !== this._root) {
                        const e = [];
                        this._root.traverse((t1)=>e.push(t1)), e.forEach((e)=>{
                            e.event && t1(e.event);
                        });
                    }
                    return this;
                }
                forEachAtTime(t1, e) {
                    if (null !== this._root) {
                        const s1 = [];
                        this._root.search(t1, s1), s1.forEach((t1)=>{
                            t1.event && e(t1.event);
                        });
                    }
                    return this;
                }
                forEachFrom(t1, e) {
                    if (null !== this._root) {
                        const s1 = [];
                        this._root.searchAfter(t1, s1), s1.forEach((t1)=>{
                            t1.event && e(t1.event);
                        });
                    }
                    return this;
                }
                dispose() {
                    return super.dispose(), null !== this._root && this._root.traverse((t1)=>t1.dispose()), this._root = null, this;
                }
            }
            class Do {
                constructor(t1, e, s1){
                    this._left = null, this._right = null, this.parent = null, this.height = 0, this.event = s1, this.low = t1, this.high = e, this.max = this.high;
                }
                insert(t1) {
                    t1.low <= this.low ? null === this.left ? this.left = t1 : this.left.insert(t1) : null === this.right ? this.right = t1 : this.right.insert(t1);
                }
                search(t1, e) {
                    t1 > this.max || (null !== this.left && this.left.search(t1, e), this.low <= t1 && this.high > t1 && e.push(this), this.low > t1 || null !== this.right && this.right.search(t1, e));
                }
                searchAfter(t1, e) {
                    this.low >= t1 && (e.push(this), null !== this.left && this.left.searchAfter(t1, e)), null !== this.right && this.right.searchAfter(t1, e);
                }
                traverse(t1) {
                    t1(this), null !== this.left && this.left.traverse(t1), null !== this.right && this.right.traverse(t1);
                }
                updateHeight() {
                    null !== this.left && null !== this.right ? this.height = Math.max(this.left.height, this.right.height) + 1 : null !== this.right ? this.height = this.right.height + 1 : null !== this.left ? this.height = this.left.height + 1 : this.height = 0;
                }
                updateMax() {
                    this.max = this.high, null !== this.left && (this.max = Math.max(this.max, this.left.max)), null !== this.right && (this.max = Math.max(this.max, this.right.max));
                }
                getBalance() {
                    let t1 = 0;
                    return null !== this.left && null !== this.right ? t1 = this.left.height - this.right.height : null !== this.left ? t1 = this.left.height + 1 : null !== this.right && (t1 = -(this.right.height + 1)), t1;
                }
                isLeftChild() {
                    return null !== this.parent && this.parent.left === this;
                }
                get left() {
                    return this._left;
                }
                set left(t1) {
                    this._left = t1, null !== t1 && (t1.parent = this), this.updateHeight(), this.updateMax();
                }
                get right() {
                    return this._right;
                }
                set right(t1) {
                    this._right = t1, null !== t1 && (t1.parent = this), this.updateHeight(), this.updateMax();
                }
                dispose() {
                    this.parent = null, this._left = null, this._right = null, this.event = null;
                }
            }
            class Oo extends io {
                constructor(){
                    super(ui(Oo.getDefaults(), arguments, [
                        "volume"
                    ])), this.name = "Volume";
                    const t1 = ui(Oo.getDefaults(), arguments, [
                        "volume"
                    ]);
                    this.input = this.output = new ho({
                        context: this.context,
                        gain: t1.volume,
                        units: "decibels"
                    }), this.volume = this.output.gain, Oi(this, "volume"), this._unmutedVolume = t1.volume, this.mute = t1.mute;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mute: !1,
                        volume: 0
                    });
                }
                get mute() {
                    return this.volume.value === -1 / 0;
                }
                set mute(t1) {
                    !this.mute && t1 ? (this._unmutedVolume = this.volume.value, this.volume.value = -1 / 0) : this.mute && !t1 && (this.volume.value = this._unmutedVolume);
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this.volume.dispose(), this;
                }
            }
            class Mo extends io {
                constructor(){
                    super(ui(Mo.getDefaults(), arguments)), this.name = "Destination", this.input = new Oo({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this.volume = this.input.volume;
                    const t1 = ui(Mo.getDefaults(), arguments);
                    oo(this.input, this.output, this.context.rawContext.destination), this.mute = t1.mute, this._internalChannels = [
                        this.input,
                        this.context.rawContext.destination,
                        this.output
                    ];
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mute: !1,
                        volume: 0
                    });
                }
                get mute() {
                    return this.input.mute;
                }
                set mute(t1) {
                    this.input.mute = t1;
                }
                chain(...t1) {
                    return this.input.disconnect(), t1.unshift(this.input), t1.push(this.output), oo(...t1), this;
                }
                get maxChannelCount() {
                    return this.context.rawContext.destination.maxChannelCount;
                }
                dispose() {
                    return super.dispose(), this.volume.dispose(), this;
                }
            }
            Ti((t1)=>{
                t1.destination = new Mo({
                    context: t1
                });
            }), ki((t1)=>{
                t1.destination.dispose();
            });
            class Eo extends fi {
                constructor(t1){
                    super(), this.name = "TimelineValue", this._timeline = new wi({
                        memory: 10
                    }), this._initialValue = t1;
                }
                set(t1, e) {
                    return this._timeline.add({
                        value: t1,
                        time: e
                    }), this;
                }
                get(t1) {
                    const e = this._timeline.get(t1);
                    return e ? e.value : this._initialValue;
                }
            }
            class Ro extends io {
                constructor(){
                    super(Object.assign(ui(Ro.getDefaults(), arguments, [
                        "context"
                    ])));
                }
                connect(t1, e = 0, s1 = 0) {
                    return fo(this, t1, e, s1), this;
                }
            }
            class qo extends Ro {
                constructor(){
                    super(Object.assign(ui(qo.getDefaults(), arguments, [
                        "mapping",
                        "length"
                    ]))), this.name = "WaveShaper", this._shaper = this.context.createWaveShaper(), this.input = this._shaper, this.output = this._shaper;
                    const t1 = ui(qo.getDefaults(), arguments, [
                        "mapping",
                        "length"
                    ]);
                    Ln(t1.mapping) || t1.mapping instanceof Float32Array ? this.curve = Float32Array.from(t1.mapping) : Vn(t1.mapping) && this.setMap(t1.mapping, t1.length);
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        length: 1024
                    });
                }
                setMap(t1, e = 1024) {
                    const s1 = new Float32Array(e);
                    for(let n = 0, i = e; n < i; n++){
                        const e = n / (i - 1) * 2 - 1;
                        s1[n] = t1(e, n);
                    }
                    return this.curve = s1, this;
                }
                get curve() {
                    return this._shaper.curve;
                }
                set curve(t1) {
                    this._shaper.curve = t1;
                }
                get oversample() {
                    return this._shaper.oversample;
                }
                set oversample(t1) {
                    Bn([
                        "none",
                        "2x",
                        "4x"
                    ].some((e)=>e.includes(t1)), "oversampling must be either 'none', '2x', or '4x'"), this._shaper.oversample = t1;
                }
                dispose() {
                    return super.dispose(), this._shaper.disconnect(), this;
                }
            }
            class Fo extends Ro {
                constructor(){
                    super(Object.assign(ui(Fo.getDefaults(), arguments, [
                        "value"
                    ]))), this.name = "Pow";
                    const t1 = ui(Fo.getDefaults(), arguments, [
                        "value"
                    ]);
                    this._exponentScaler = this.input = this.output = new qo({
                        context: this.context,
                        mapping: this._expFunc(t1.value),
                        length: 8192
                    }), this._exponent = t1.value;
                }
                static getDefaults() {
                    return Object.assign(Ro.getDefaults(), {
                        value: 1
                    });
                }
                _expFunc(t1) {
                    return (e)=>Math.pow(Math.abs(e), t1);
                }
                get value() {
                    return this._exponent;
                }
                set value(t1) {
                    this._exponent = t1, this._exponentScaler.setMap(this._expFunc(this._exponent));
                }
                dispose() {
                    return super.dispose(), this._exponentScaler.dispose(), this;
                }
            }
            class Io {
                constructor(t1, e){
                    this.id = Io._eventId++, this._remainderTime = 0;
                    const s1 = Object.assign(Io.getDefaults(), e);
                    this.transport = t1, this.callback = s1.callback, this._once = s1.once, this.time = Math.floor(s1.time), this._remainderTime = s1.time - this.time;
                }
                static getDefaults() {
                    return {
                        callback: Ei,
                        once: !1,
                        time: 0
                    };
                }
                get floatTime() {
                    return this.time + this._remainderTime;
                }
                invoke(t1) {
                    if (this.callback) {
                        const e = this.transport.bpm.getDurationOfTicks(1, t1);
                        this.callback(t1 + this._remainderTime * e), this._once && this.transport.clear(this.id);
                    }
                }
                dispose() {
                    return this.callback = void 0, this;
                }
            }
            Io._eventId = 0;
            class Vo extends Io {
                constructor(t1, e){
                    super(t1, e), this._currentId = -1, this._nextId = -1, this._nextTick = this.time, this._boundRestart = this._restart.bind(this);
                    const s1 = Object.assign(Vo.getDefaults(), e);
                    this.duration = s1.duration, this._interval = s1.interval, this._nextTick = s1.time, this.transport.on("start", this._boundRestart), this.transport.on("loopStart", this._boundRestart), this.transport.on("ticks", this._boundRestart), this.context = this.transport.context, this._restart();
                }
                static getDefaults() {
                    return Object.assign({}, Io.getDefaults(), {
                        duration: 1 / 0,
                        interval: 1,
                        once: !1
                    });
                }
                invoke(t1) {
                    this._createEvents(t1), super.invoke(t1);
                }
                _createEvent() {
                    return vi(this._nextTick, this.floatTime + this.duration) ? this.transport.scheduleOnce(this.invoke.bind(this), new So(this.context, this._nextTick).toSeconds()) : -1;
                }
                _createEvents(t1) {
                    vi(this._nextTick + this._interval, this.floatTime + this.duration) && (this._nextTick += this._interval, this._currentId = this._nextId, this._nextId = this.transport.scheduleOnce(this.invoke.bind(this), new So(this.context, this._nextTick).toSeconds()));
                }
                _restart(t1) {
                    this.transport.clear(this._currentId), this.transport.clear(this._nextId), this._nextTick = this.floatTime;
                    const e = this.transport.getTicksAtTime(t1);
                    mi(e, this.time) && (this._nextTick = this.floatTime + Math.ceil((e - this.floatTime) / this._interval) * this._interval), this._currentId = this._createEvent(), this._nextTick += this._interval, this._nextId = this._createEvent();
                }
                dispose() {
                    return super.dispose(), this.transport.clear(this._currentId), this.transport.clear(this._nextId), this.transport.off("start", this._boundRestart), this.transport.off("loopStart", this._boundRestart), this.transport.off("ticks", this._boundRestart), this;
                }
            }
            class No extends eo {
                constructor(){
                    super(ui(No.getDefaults(), arguments)), this.name = "Transport", this._loop = new Eo(!1), this._loopStart = 0, this._loopEnd = 0, this._scheduledEvents = {}, this._timeline = new wi, this._repeatedEvents = new Co, this._syncedSignals = [], this._swingAmount = 0;
                    const t1 = ui(No.getDefaults(), arguments);
                    this._ppq = t1.ppq, this._clock = new vo({
                        callback: this._processTick.bind(this),
                        context: this.context,
                        frequency: 0,
                        units: "bpm"
                    }), this._bindClockEvents(), this.bpm = this._clock.frequency, this._clock.frequency.multiplier = t1.ppq, this.bpm.setValueAtTime(t1.bpm, 0), Oi(this, "bpm"), this._timeSignature = t1.timeSignature, this._swingTicks = t1.ppq / 2;
                }
                static getDefaults() {
                    return Object.assign(eo.getDefaults(), {
                        bpm: 120,
                        loopEnd: "4m",
                        loopStart: 0,
                        ppq: 192,
                        swing: 0,
                        swingSubdivision: "8n",
                        timeSignature: 4
                    });
                }
                _processTick(t1, e) {
                    if (this._loop.get(t1) && e >= this._loopEnd && (this.emit("loopEnd", t1), this._clock.setTicksAtTime(this._loopStart, t1), e = this._loopStart, this.emit("loopStart", t1, this._clock.getSecondsAtTime(t1)), this.emit("loop", t1)), this._swingAmount > 0 && e % this._ppq != 0 && e % (2 * this._swingTicks) != 0) {
                        const s1 = e % (2 * this._swingTicks) / (2 * this._swingTicks), n = Math.sin(s1 * Math.PI) * this._swingAmount;
                        t1 += new So(this.context, 2 * this._swingTicks / 3).toSeconds() * n;
                    }
                    Xn(!0), this._timeline.forEachAtTime(e, (e)=>e.invoke(t1)), Xn(!1);
                }
                schedule(t1, e) {
                    const s1 = new Io(this, {
                        callback: t1,
                        time: new Ki(this.context, e).toTicks()
                    });
                    return this._addEvent(s1, this._timeline);
                }
                scheduleRepeat(t1, e, s1, n = 1 / 0) {
                    const i = new Vo(this, {
                        callback: t1,
                        duration: new Zi(this.context, n).toTicks(),
                        interval: new Zi(this.context, e).toTicks(),
                        time: new Ki(this.context, s1).toTicks()
                    });
                    return this._addEvent(i, this._repeatedEvents);
                }
                scheduleOnce(t1, e) {
                    const s1 = new Io(this, {
                        callback: t1,
                        once: !0,
                        time: new Ki(this.context, e).toTicks()
                    });
                    return this._addEvent(s1, this._timeline);
                }
                clear(t1) {
                    if (this._scheduledEvents.hasOwnProperty(t1)) {
                        const e = this._scheduledEvents[t1.toString()];
                        e.timeline.remove(e.event), e.event.dispose(), delete this._scheduledEvents[t1.toString()];
                    }
                    return this;
                }
                _addEvent(t1, e) {
                    return this._scheduledEvents[t1.id.toString()] = {
                        event: t1,
                        timeline: e
                    }, e.add(t1), t1.id;
                }
                cancel(t1 = 0) {
                    const e = this.toTicks(t1);
                    return this._timeline.forEachFrom(e, (t1)=>this.clear(t1.id)), this._repeatedEvents.forEachFrom(e, (t1)=>this.clear(t1.id)), this;
                }
                _bindClockEvents() {
                    this._clock.on("start", (t1, e)=>{
                        e = new So(this.context, e).toSeconds(), this.emit("start", t1, e);
                    }), this._clock.on("stop", (t1)=>{
                        this.emit("stop", t1);
                    }), this._clock.on("pause", (t1)=>{
                        this.emit("pause", t1);
                    });
                }
                get state() {
                    return this._clock.getStateAtTime(this.now());
                }
                start(t1, e) {
                    let s1;
                    return this.context.resume(), In(e) && (s1 = this.toTicks(e)), this._clock.start(t1, s1), this;
                }
                stop(t1) {
                    return this._clock.stop(t1), this;
                }
                pause(t1) {
                    return this._clock.pause(t1), this;
                }
                toggle(t1) {
                    return t1 = this.toSeconds(t1), "started" !== this._clock.getStateAtTime(t1) ? this.start(t1) : this.stop(t1), this;
                }
                get timeSignature() {
                    return this._timeSignature;
                }
                set timeSignature(t1) {
                    Ln(t1) && (t1 = t1[0] / t1[1] * 4), this._timeSignature = t1;
                }
                get loopStart() {
                    return new Zi(this.context, this._loopStart, "i").toSeconds();
                }
                set loopStart(t1) {
                    this._loopStart = this.toTicks(t1);
                }
                get loopEnd() {
                    return new Zi(this.context, this._loopEnd, "i").toSeconds();
                }
                set loopEnd(t1) {
                    this._loopEnd = this.toTicks(t1);
                }
                get loop() {
                    return this._loop.get(this.now());
                }
                set loop(t1) {
                    this._loop.set(t1, this.now());
                }
                setLoopPoints(t1, e) {
                    return this.loopStart = t1, this.loopEnd = e, this;
                }
                get swing() {
                    return this._swingAmount;
                }
                set swing(t1) {
                    this._swingAmount = t1;
                }
                get swingSubdivision() {
                    return new So(this.context, this._swingTicks).toNotation();
                }
                set swingSubdivision(t1) {
                    this._swingTicks = this.toTicks(t1);
                }
                get position() {
                    const t1 = this.now(), e = this._clock.getTicksAtTime(t1);
                    return new So(this.context, e).toBarsBeatsSixteenths();
                }
                set position(t1) {
                    const e = this.toTicks(t1);
                    this.ticks = e;
                }
                get seconds() {
                    return this._clock.seconds;
                }
                set seconds(t1) {
                    const e = this.now(), s1 = this._clock.frequency.timeToTicks(t1, e);
                    this.ticks = s1;
                }
                get progress() {
                    if (this.loop) {
                        const t1 = this.now();
                        return (this._clock.getTicksAtTime(t1) - this._loopStart) / (this._loopEnd - this._loopStart);
                    }
                    return 0;
                }
                get ticks() {
                    return this._clock.ticks;
                }
                set ticks(t1) {
                    if (this._clock.ticks !== t1) {
                        const e = this.now();
                        if ("started" === this.state) {
                            const s1 = this._clock.getTicksAtTime(e), n = e + this._clock.frequency.getDurationOfTicks(Math.ceil(s1) - s1, e);
                            this.emit("stop", n), this._clock.setTicksAtTime(t1, n), this.emit("start", n, this._clock.getSecondsAtTime(n));
                        } else this.emit("ticks", e), this._clock.setTicksAtTime(t1, e);
                    }
                }
                getTicksAtTime(t1) {
                    return this._clock.getTicksAtTime(t1);
                }
                getSecondsAtTime(t1) {
                    return this._clock.getSecondsAtTime(t1);
                }
                get PPQ() {
                    return this._clock.frequency.multiplier;
                }
                set PPQ(t1) {
                    this._clock.frequency.multiplier = t1;
                }
                nextSubdivision(t1) {
                    if (t1 = this.toTicks(t1), "started" !== this.state) return 0;
                    {
                        const e = this.now(), s1 = t1 - this.getTicksAtTime(e) % t1;
                        return this._clock.nextTickTime(s1, e);
                    }
                }
                syncSignal(t1, e) {
                    const s1 = this.now();
                    let n = this.bpm, i = 1 / (60 / n.getValueAtTime(s1) / this.PPQ), o = [];
                    if ("time" === t1.units) {
                        const t1 = 1 / 64 / i, e = new ho(t1), s1 = new Fo(-1), r = new ho(t1);
                        n.chain(e, s1, r), n = r, i = 1 / i, o = [
                            e,
                            s1,
                            r
                        ];
                    }
                    e || (e = 0 !== t1.getValueAtTime(s1) ? t1.getValueAtTime(s1) / i : 0);
                    const r = new ho(e);
                    return n.connect(r), r.connect(t1._param), o.push(r), this._syncedSignals.push({
                        initial: t1.value,
                        nodes: o,
                        signal: t1
                    }), t1.value = 0, this;
                }
                unsyncSignal(t1) {
                    for(let e = this._syncedSignals.length - 1; e >= 0; e--){
                        const s1 = this._syncedSignals[e];
                        s1.signal === t1 && (s1.nodes.forEach((t1)=>t1.dispose()), s1.signal.value = s1.initial, this._syncedSignals.splice(e, 1));
                    }
                    return this;
                }
                dispose() {
                    return super.dispose(), this._clock.dispose(), Mi(this, "bpm"), this._timeline.dispose(), this._repeatedEvents.dispose(), this;
                }
            }
            Ai.mixin(No), Ti((t1)=>{
                t1.transport = new No({
                    context: t1
                });
            }), ki((t1)=>{
                t1.transport.dispose();
            });
            class Po extends io {
                constructor(t1){
                    super(t1), this.input = void 0, this._state = new so("stopped"), this._synced = !1, this._scheduled = [], this._syncedStart = Ei, this._syncedStop = Ei, this._state.memory = 100, this._state.increasing = !0, this._volume = this.output = new Oo({
                        context: this.context,
                        mute: t1.mute,
                        volume: t1.volume
                    }), this.volume = this._volume.volume, Oi(this, "volume"), this.onstop = t1.onstop;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mute: !1,
                        onstop: Ei,
                        volume: 0
                    });
                }
                get state() {
                    return this._synced ? "started" === this.context.transport.state ? this._state.getValueAtTime(this.context.transport.seconds) : "stopped" : this._state.getValueAtTime(this.now());
                }
                get mute() {
                    return this._volume.mute;
                }
                set mute(t1) {
                    this._volume.mute = t1;
                }
                _clampToCurrentTime(t1) {
                    return this._synced ? t1 : Math.max(t1, this.context.currentTime);
                }
                start(t1, e, s1) {
                    let n = Fn(t1) && this._synced ? this.context.transport.seconds : this.toSeconds(t1);
                    if (n = this._clampToCurrentTime(n), this._synced || "started" !== this._state.getValueAtTime(n)) {
                        if (this.log("start", n), this._state.setStateAtTime("started", n), this._synced) {
                            const t1 = this._state.get(n);
                            t1 && (t1.offset = this.toSeconds(pi(e, 0)), t1.duration = s1 ? this.toSeconds(s1) : void 0);
                            const i = this.context.transport.schedule((t1)=>{
                                this._start(t1, e, s1);
                            }, n);
                            this._scheduled.push(i), "started" === this.context.transport.state && this.context.transport.getSecondsAtTime(this.immediate()) > n && this._syncedStart(this.now(), this.context.transport.seconds);
                        } else Gn(this.context), this._start(n, e, s1);
                    } else Bn(mi(n, this._state.get(n).time), "Start time must be strictly greater than previous start time"), this._state.cancel(n), this._state.setStateAtTime("started", n), this.log("restart", n), this.restart(n, e, s1);
                    return this;
                }
                stop(t1) {
                    let e = Fn(t1) && this._synced ? this.context.transport.seconds : this.toSeconds(t1);
                    if (e = this._clampToCurrentTime(e), "started" === this._state.getValueAtTime(e) || In(this._state.getNextState("started", e))) {
                        if (this.log("stop", e), this._synced) {
                            const t1 = this.context.transport.schedule(this._stop.bind(this), e);
                            this._scheduled.push(t1);
                        } else this._stop(e);
                        this._state.cancel(e), this._state.setStateAtTime("stopped", e);
                    }
                    return this;
                }
                restart(t1, e, s1) {
                    return t1 = this.toSeconds(t1), "started" === this._state.getValueAtTime(t1) && (this._state.cancel(t1), this._restart(t1, e, s1)), this;
                }
                sync() {
                    return this._synced || (this._synced = !0, this._syncedStart = (t1, e)=>{
                        if (mi(e, 0)) {
                            const s1 = this._state.get(e);
                            if (s1 && "started" === s1.state && s1.time !== e) {
                                const n = e - this.toSeconds(s1.time);
                                let i;
                                s1.duration && (i = this.toSeconds(s1.duration) - n), this._start(t1, this.toSeconds(s1.offset) + n, i);
                            }
                        }
                    }, this._syncedStop = (t1)=>{
                        const e = this.context.transport.getSecondsAtTime(Math.max(t1 - this.sampleTime, 0));
                        "started" === this._state.getValueAtTime(e) && this._stop(t1);
                    }, this.context.transport.on("start", this._syncedStart), this.context.transport.on("loopStart", this._syncedStart), this.context.transport.on("stop", this._syncedStop), this.context.transport.on("pause", this._syncedStop), this.context.transport.on("loopEnd", this._syncedStop)), this;
                }
                unsync() {
                    return this._synced && (this.context.transport.off("stop", this._syncedStop), this.context.transport.off("pause", this._syncedStop), this.context.transport.off("loopEnd", this._syncedStop), this.context.transport.off("start", this._syncedStart), this.context.transport.off("loopStart", this._syncedStart)), this._synced = !1, this._scheduled.forEach((t1)=>this.context.transport.clear(t1)), this._scheduled = [], this._state.cancel(0), this._stop(0), this;
                }
                dispose() {
                    return super.dispose(), this.onstop = Ei, this.unsync(), this._volume.dispose(), this._state.dispose(), this;
                }
            }
            class jo extends lo {
                constructor(){
                    super(ui(jo.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ])), this.name = "ToneBufferSource", this._source = this.context.createBufferSource(), this._internalChannels = [
                        this._source
                    ], this._sourceStarted = !1, this._sourceStopped = !1;
                    const t1 = ui(jo.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ]);
                    ro(this._source, this._gainNode), this._source.onended = ()=>this._stopSource(), this.playbackRate = new no({
                        context: this.context,
                        param: this._source.playbackRate,
                        units: "positive",
                        value: t1.playbackRate
                    }), this.loop = t1.loop, this.loopStart = t1.loopStart, this.loopEnd = t1.loopEnd, this._buffer = new Ri(t1.url, t1.onload, t1.onerror), this._internalChannels.push(this._source);
                }
                static getDefaults() {
                    return Object.assign(lo.getDefaults(), {
                        url: new Ri,
                        loop: !1,
                        loopEnd: 0,
                        loopStart: 0,
                        onload: Ei,
                        onerror: Ei,
                        playbackRate: 1
                    });
                }
                get fadeIn() {
                    return this._fadeIn;
                }
                set fadeIn(t1) {
                    this._fadeIn = t1;
                }
                get fadeOut() {
                    return this._fadeOut;
                }
                set fadeOut(t1) {
                    this._fadeOut = t1;
                }
                get curve() {
                    return this._curve;
                }
                set curve(t1) {
                    this._curve = t1;
                }
                start(t1, e, s1, n = 1) {
                    Bn(this.buffer.loaded, "buffer is either not set or not loaded");
                    const i = this.toSeconds(t1);
                    this._startGain(i, n), e = this.loop ? pi(e, this.loopStart) : pi(e, 0);
                    let o = Math.max(this.toSeconds(e), 0);
                    if (this.loop) {
                        const t1 = this.toSeconds(this.loopEnd) || this.buffer.duration, e = this.toSeconds(this.loopStart), s1 = t1 - e;
                        gi(o, t1) && (o = (o - e) % s1 + e), yi(o, this.buffer.duration) && (o = 0);
                    }
                    if (this._source.buffer = this.buffer.get(), this._source.loopEnd = this.toSeconds(this.loopEnd) || this.buffer.duration, vi(o, this.buffer.duration) && (this._sourceStarted = !0, this._source.start(i, o)), In(s1)) {
                        let t1 = this.toSeconds(s1);
                        t1 = Math.max(t1, 0), this.stop(i + t1);
                    }
                    return this;
                }
                _stopSource(t1) {
                    !this._sourceStopped && this._sourceStarted && (this._sourceStopped = !0, this._source.stop(this.toSeconds(t1)), this._onended());
                }
                get loopStart() {
                    return this._source.loopStart;
                }
                set loopStart(t1) {
                    this._source.loopStart = this.toSeconds(t1);
                }
                get loopEnd() {
                    return this._source.loopEnd;
                }
                set loopEnd(t1) {
                    this._source.loopEnd = this.toSeconds(t1);
                }
                get buffer() {
                    return this._buffer;
                }
                set buffer(t1) {
                    this._buffer.set(t1);
                }
                get loop() {
                    return this._source.loop;
                }
                set loop(t1) {
                    this._source.loop = t1, this._sourceStarted && this.cancelStop();
                }
                dispose() {
                    return super.dispose(), this._source.onended = null, this._source.disconnect(), this._buffer.dispose(), this.playbackRate.dispose(), this;
                }
            }
            class Lo extends Po {
                constructor(){
                    super(ui(Lo.getDefaults(), arguments, [
                        "type"
                    ])), this.name = "Noise", this._source = null;
                    const t1 = ui(Lo.getDefaults(), arguments, [
                        "type"
                    ]);
                    this._playbackRate = t1.playbackRate, this.type = t1.type, this._fadeIn = t1.fadeIn, this._fadeOut = t1.fadeOut;
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        fadeIn: 0,
                        fadeOut: 0,
                        playbackRate: 1,
                        type: "white"
                    });
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    if (Bn(t1 in Bo, "Noise: invalid type: " + t1), this._type !== t1 && (this._type = t1, "started" === this.state)) {
                        const t1 = this.now();
                        this._stop(t1), this._start(t1);
                    }
                }
                get playbackRate() {
                    return this._playbackRate;
                }
                set playbackRate(t1) {
                    this._playbackRate = t1, this._source && (this._source.playbackRate.value = t1);
                }
                _start(t1) {
                    const e = Bo[this._type];
                    this._source = new jo({
                        url: e,
                        context: this.context,
                        fadeIn: this._fadeIn,
                        fadeOut: this._fadeOut,
                        loop: !0,
                        onended: ()=>this.onstop(this),
                        playbackRate: this._playbackRate
                    }).connect(this.output), this._source.start(this.toSeconds(t1), Math.random() * (e.duration - .001));
                }
                _stop(t1) {
                    this._source && (this._source.stop(this.toSeconds(t1)), this._source = null);
                }
                get fadeIn() {
                    return this._fadeIn;
                }
                set fadeIn(t1) {
                    this._fadeIn = t1, this._source && (this._source.fadeIn = this._fadeIn);
                }
                get fadeOut() {
                    return this._fadeOut;
                }
                set fadeOut(t1) {
                    this._fadeOut = t1, this._source && (this._source.fadeOut = this._fadeOut);
                }
                _restart(t1) {
                    this._stop(t1), this._start(t1);
                }
                dispose() {
                    return super.dispose(), this._source && this._source.disconnect(), this;
                }
            }
            const zo = 220500, Wo = {
                brown: null,
                pink: null,
                white: null
            }, Bo = {
                get brown () {
                    if (!Wo.brown) {
                        const t1 = [];
                        for(let e = 0; e < 2; e++){
                            const s1 = new Float32Array(zo);
                            t1[e] = s1;
                            let n = 0;
                            for(let t1 = 0; t1 < zo; t1++){
                                const e = 2 * Math.random() - 1;
                                s1[t1] = (n + .02 * e) / 1.02, n = s1[t1], s1[t1] *= 3.5;
                            }
                        }
                        Wo.brown = (new Ri).fromArray(t1);
                    }
                    return Wo.brown;
                },
                get pink () {
                    if (!Wo.pink) {
                        const t1 = [];
                        for(let e = 0; e < 2; e++){
                            const s1 = new Float32Array(zo);
                            let n, i, o, r, a, c, h;
                            t1[e] = s1, n = i = o = r = a = c = h = 0;
                            for(let t1 = 0; t1 < zo; t1++){
                                const e = 2 * Math.random() - 1;
                                n = .99886 * n + .0555179 * e, i = .99332 * i + .0750759 * e, o = .969 * o + .153852 * e, r = .8665 * r + .3104856 * e, a = .55 * a + .5329522 * e, c = -0.7616 * c - .016898 * e, s1[t1] = n + i + o + r + a + c + h + .5362 * e, s1[t1] *= .11, h = .115926 * e;
                            }
                        }
                        Wo.pink = (new Ri).fromArray(t1);
                    }
                    return Wo.pink;
                },
                get white () {
                    if (!Wo.white) {
                        const t1 = [];
                        for(let e = 0; e < 2; e++){
                            const s1 = new Float32Array(zo);
                            t1[e] = s1;
                            for(let t1 = 0; t1 < zo; t1++)s1[t1] = 2 * Math.random() - 1;
                        }
                        Wo.white = (new Ri).fromArray(t1);
                    }
                    return Wo.white;
                }
            };
            class Uo extends io {
                constructor(){
                    super(ui(Uo.getDefaults(), arguments, [
                        "volume"
                    ])), this.name = "UserMedia";
                    const t1 = ui(Uo.getDefaults(), arguments, [
                        "volume"
                    ]);
                    this._volume = this.output = new Oo({
                        context: this.context,
                        volume: t1.volume
                    }), this.volume = this._volume.volume, Oi(this, "volume"), this.mute = t1.mute;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mute: !1,
                        volume: 0
                    });
                }
                open(t1) {
                    return ni(this, void 0, void 0, function*() {
                        Bn(Uo.supported, "UserMedia is not supported"), "started" === this.state && this.close();
                        const e = yield Uo.enumerateDevices();
                        Nn(t1) ? this._device = e[t1] : (this._device = e.find((e)=>e.label === t1 || e.deviceId === t1), !this._device && e.length > 0 && (this._device = e[0]), Bn(In(this._device), `No matching device ${t1}`));
                        const s1 = {
                            audio: {
                                echoCancellation: !1,
                                sampleRate: this.context.sampleRate,
                                noiseSuppression: !1,
                                mozNoiseSuppression: !1
                            }
                        };
                        this._device && (s1.audio.deviceId = this._device.deviceId);
                        const n = yield navigator.mediaDevices.getUserMedia(s1);
                        if (!this._stream) {
                            this._stream = n;
                            const t1 = this.context.createMediaStreamSource(n);
                            ro(t1, this.output), this._mediaStream = t1;
                        }
                        return this;
                    });
                }
                close() {
                    return this._stream && this._mediaStream && (this._stream.getAudioTracks().forEach((t1)=>{
                        t1.stop();
                    }), this._stream = void 0, this._mediaStream.disconnect(), this._mediaStream = void 0), this._device = void 0, this;
                }
                static enumerateDevices() {
                    return ni(this, void 0, void 0, function*() {
                        return (yield navigator.mediaDevices.enumerateDevices()).filter((t1)=>"audioinput" === t1.kind);
                    });
                }
                get state() {
                    return this._stream && this._stream.active ? "started" : "stopped";
                }
                get deviceId() {
                    return this._device ? this._device.deviceId : void 0;
                }
                get groupId() {
                    return this._device ? this._device.groupId : void 0;
                }
                get label() {
                    return this._device ? this._device.label : void 0;
                }
                get mute() {
                    return this._volume.mute;
                }
                set mute(t1) {
                    this._volume.mute = t1;
                }
                dispose() {
                    return super.dispose(), this.close(), this._volume.dispose(), this.volume.dispose(), this;
                }
                static get supported() {
                    return In(navigator.mediaDevices) && In(navigator.mediaDevices.getUserMedia);
                }
            }
            function Go(t1, e) {
                return ni(this, void 0, void 0, function*() {
                    const s1 = e / t1.context.sampleRate, n = new qi(1, s1, t1.context.sampleRate);
                    return new t1.constructor(Object.assign(t1.get(), {
                        frequency: 2 / s1,
                        detune: 0,
                        context: n
                    })).toDestination().start(0), (yield n.render()).getChannelData(0);
                });
            }
            class Qo extends lo {
                constructor(){
                    super(ui(Qo.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ])), this.name = "ToneOscillatorNode", this._oscillator = this.context.createOscillator(), this._internalChannels = [
                        this._oscillator
                    ];
                    const t1 = ui(Qo.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ]);
                    ro(this._oscillator, this._gainNode), this.type = t1.type, this.frequency = new no({
                        context: this.context,
                        param: this._oscillator.frequency,
                        units: "frequency",
                        value: t1.frequency
                    }), this.detune = new no({
                        context: this.context,
                        param: this._oscillator.detune,
                        units: "cents",
                        value: t1.detune
                    }), Oi(this, [
                        "frequency",
                        "detune"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(lo.getDefaults(), {
                        detune: 0,
                        frequency: 440,
                        type: "sine"
                    });
                }
                start(t1) {
                    const e = this.toSeconds(t1);
                    return this.log("start", e), this._startGain(e), this._oscillator.start(e), this;
                }
                _stopSource(t1) {
                    this._oscillator.stop(t1);
                }
                setPeriodicWave(t1) {
                    return this._oscillator.setPeriodicWave(t1), this;
                }
                get type() {
                    return this._oscillator.type;
                }
                set type(t1) {
                    this._oscillator.type = t1;
                }
                dispose() {
                    return super.dispose(), "started" === this.state && this.stop(), this._oscillator.disconnect(), this.frequency.dispose(), this.detune.dispose(), this;
                }
            }
            class Zo extends Po {
                constructor(){
                    super(ui(Zo.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ])), this.name = "Oscillator", this._oscillator = null;
                    const t1 = ui(Zo.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ]);
                    this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency
                    }), Oi(this, "frequency"), this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), Oi(this, "detune"), this._partials = t1.partials, this._partialCount = t1.partialCount, this._type = t1.type, t1.partialCount && "custom" !== t1.type && (this._type = this.baseType + t1.partialCount.toString()), this.phase = t1.phase;
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        detune: 0,
                        frequency: 440,
                        partialCount: 0,
                        partials: [],
                        phase: 0,
                        type: "sine"
                    });
                }
                _start(t1) {
                    const e = this.toSeconds(t1), s1 = new Qo({
                        context: this.context,
                        onended: ()=>this.onstop(this)
                    });
                    this._oscillator = s1, this._wave ? this._oscillator.setPeriodicWave(this._wave) : this._oscillator.type = this._type, this._oscillator.connect(this.output), this.frequency.connect(this._oscillator.frequency), this.detune.connect(this._oscillator.detune), this._oscillator.start(e);
                }
                _stop(t1) {
                    const e = this.toSeconds(t1);
                    this._oscillator && this._oscillator.stop(e);
                }
                _restart(t1) {
                    const e = this.toSeconds(t1);
                    return this.log("restart", e), this._oscillator && this._oscillator.cancelStop(), this._state.cancel(e), this;
                }
                syncFrequency() {
                    return this.context.transport.syncSignal(this.frequency), this;
                }
                unsyncFrequency() {
                    return this.context.transport.unsyncSignal(this.frequency), this;
                }
                _getCachedPeriodicWave() {
                    if ("custom" === this._type) return Zo._periodicWaveCache.find((t1)=>{
                        var e, s1;
                        return t1.phase === this._phase && (e = t1.partials, s1 = this._partials, e.length === s1.length && e.every((t1, e)=>s1[e] === t1));
                    });
                    {
                        const t1 = Zo._periodicWaveCache.find((t1)=>t1.type === this._type && t1.phase === this._phase);
                        return this._partialCount = t1 ? t1.partialCount : this._partialCount, t1;
                    }
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    this._type = t1;
                    const e = -1 !== [
                        "sine",
                        "square",
                        "sawtooth",
                        "triangle"
                    ].indexOf(t1);
                    if (0 === this._phase && e) this._wave = void 0, this._partialCount = 0, null !== this._oscillator && (this._oscillator.type = t1);
                    else {
                        const e = this._getCachedPeriodicWave();
                        if (In(e)) {
                            const { partials: t1, wave: s1 } = e;
                            this._wave = s1, this._partials = t1, null !== this._oscillator && this._oscillator.setPeriodicWave(this._wave);
                        } else {
                            const [e, s1] = this._getRealImaginary(t1, this._phase), n = this.context.createPeriodicWave(e, s1);
                            this._wave = n, null !== this._oscillator && this._oscillator.setPeriodicWave(this._wave), Zo._periodicWaveCache.push({
                                imag: s1,
                                partialCount: this._partialCount,
                                partials: this._partials,
                                phase: this._phase,
                                real: e,
                                type: this._type,
                                wave: this._wave
                            }), Zo._periodicWaveCache.length > 100 && Zo._periodicWaveCache.shift();
                        }
                    }
                }
                get baseType() {
                    return this._type.replace(this.partialCount.toString(), "");
                }
                set baseType(t1) {
                    this.partialCount && "custom" !== this._type && "custom" !== t1 ? this.type = t1 + this.partialCount : this.type = t1;
                }
                get partialCount() {
                    return this._partialCount;
                }
                set partialCount(t1) {
                    Un(t1, 0);
                    let e = this._type;
                    const s1 = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(this._type);
                    if (s1 && (e = s1[1]), "custom" !== this._type) this.type = 0 === t1 ? e : e + t1.toString();
                    else {
                        const e = new Float32Array(t1);
                        this._partials.forEach((t1, s1)=>e[s1] = t1), this._partials = Array.from(e), this.type = this._type;
                    }
                }
                _getRealImaginary(t1, e) {
                    let s1 = 2048;
                    const n = new Float32Array(s1), i = new Float32Array(s1);
                    let o = 1;
                    if ("custom" === t1) {
                        if (o = this._partials.length + 1, this._partialCount = this._partials.length, s1 = o, 0 === this._partials.length) return [
                            n,
                            i
                        ];
                    } else {
                        const e = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(t1);
                        e ? (o = parseInt(e[2], 10) + 1, this._partialCount = parseInt(e[2], 10), t1 = e[1], o = Math.max(o, 2), s1 = o) : this._partialCount = 0, this._partials = [];
                    }
                    for(let r = 1; r < s1; ++r){
                        const s1 = 2 / (r * Math.PI);
                        let a;
                        switch(t1){
                            case "sine":
                                a = r <= o ? 1 : 0, this._partials[r - 1] = a;
                                break;
                            case "square":
                                a = 1 & r ? 2 * s1 : 0, this._partials[r - 1] = a;
                                break;
                            case "sawtooth":
                                a = s1 * (1 & r ? 1 : -1), this._partials[r - 1] = a;
                                break;
                            case "triangle":
                                a = 1 & r ? s1 * s1 * 2 * (r - 1 >> 1 & 1 ? -1 : 1) : 0, this._partials[r - 1] = a;
                                break;
                            case "custom":
                                a = this._partials[r - 1];
                                break;
                            default:
                                throw new TypeError("Oscillator: invalid type: " + t1);
                        }
                        0 !== a ? (n[r] = -a * Math.sin(e * r), i[r] = a * Math.cos(e * r)) : (n[r] = 0, i[r] = 0);
                    }
                    return [
                        n,
                        i
                    ];
                }
                _inverseFFT(t1, e, s1) {
                    let n = 0;
                    const i = t1.length;
                    for(let o = 0; o < i; o++)n += t1[o] * Math.cos(o * s1) + e[o] * Math.sin(o * s1);
                    return n;
                }
                getInitialValue() {
                    const [t1, e] = this._getRealImaginary(this._type, 0);
                    let s1 = 0;
                    const n = 2 * Math.PI;
                    for(let i = 0; i < 32; i++)s1 = Math.max(this._inverseFFT(t1, e, i / 32 * n), s1);
                    return xi(-this._inverseFFT(t1, e, this._phase) / s1, -1, 1);
                }
                get partials() {
                    return this._partials.slice(0, this.partialCount);
                }
                set partials(t1) {
                    this._partials = t1, this._partialCount = this._partials.length, t1.length && (this.type = "custom");
                }
                get phase() {
                    return this._phase * (180 / Math.PI);
                }
                set phase(t1) {
                    this._phase = t1 * Math.PI / 180, this.type = this._type;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), null !== this._oscillator && this._oscillator.dispose(), this._wave = void 0, this.frequency.dispose(), this.detune.dispose(), this;
                }
            }
            Zo._periodicWaveCache = [];
            class Xo extends Ro {
                constructor(){
                    super(...arguments), this.name = "AudioToGain", this._norm = new qo({
                        context: this.context,
                        mapping: (t1)=>(t1 + 1) / 2
                    }), this.input = this._norm, this.output = this._norm;
                }
                dispose() {
                    return super.dispose(), this._norm.dispose(), this;
                }
            }
            class Yo extends po {
                constructor(){
                    super(Object.assign(ui(Yo.getDefaults(), arguments, [
                        "value"
                    ]))), this.name = "Multiply", this.override = !1;
                    const t1 = ui(Yo.getDefaults(), arguments, [
                        "value"
                    ]);
                    this._mult = this.input = this.output = new ho({
                        context: this.context,
                        minValue: t1.minValue,
                        maxValue: t1.maxValue
                    }), this.factor = this._param = this._mult.gain, this.factor.setValueAtTime(t1.value, 0);
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        value: 0
                    });
                }
                dispose() {
                    return super.dispose(), this._mult.dispose(), this;
                }
            }
            class $o extends Po {
                constructor(){
                    super(ui($o.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "modulationType"
                    ])), this.name = "AMOscillator", this._modulationScale = new Xo({
                        context: this.context
                    }), this._modulationNode = new ho({
                        context: this.context
                    });
                    const t1 = ui($o.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "modulationType"
                    ]);
                    this._carrier = new Zo({
                        context: this.context,
                        detune: t1.detune,
                        frequency: t1.frequency,
                        onstop: ()=>this.onstop(this),
                        phase: t1.phase,
                        type: t1.type
                    }), this.frequency = this._carrier.frequency, this.detune = this._carrier.detune, this._modulator = new Zo({
                        context: this.context,
                        phase: t1.phase,
                        type: t1.modulationType
                    }), this.harmonicity = new Yo({
                        context: this.context,
                        units: "positive",
                        value: t1.harmonicity
                    }), this.frequency.chain(this.harmonicity, this._modulator.frequency), this._modulator.chain(this._modulationScale, this._modulationNode.gain), this._carrier.chain(this._modulationNode, this.output), Oi(this, [
                        "frequency",
                        "detune",
                        "harmonicity"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Zo.getDefaults(), {
                        harmonicity: 1,
                        modulationType: "square"
                    });
                }
                _start(t1) {
                    this._modulator.start(t1), this._carrier.start(t1);
                }
                _stop(t1) {
                    this._modulator.stop(t1), this._carrier.stop(t1);
                }
                _restart(t1) {
                    this._modulator.restart(t1), this._carrier.restart(t1);
                }
                get type() {
                    return this._carrier.type;
                }
                set type(t1) {
                    this._carrier.type = t1;
                }
                get baseType() {
                    return this._carrier.baseType;
                }
                set baseType(t1) {
                    this._carrier.baseType = t1;
                }
                get partialCount() {
                    return this._carrier.partialCount;
                }
                set partialCount(t1) {
                    this._carrier.partialCount = t1;
                }
                get modulationType() {
                    return this._modulator.type;
                }
                set modulationType(t1) {
                    this._modulator.type = t1;
                }
                get phase() {
                    return this._carrier.phase;
                }
                set phase(t1) {
                    this._carrier.phase = t1, this._modulator.phase = t1;
                }
                get partials() {
                    return this._carrier.partials;
                }
                set partials(t1) {
                    this._carrier.partials = t1;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this.frequency.dispose(), this.detune.dispose(), this.harmonicity.dispose(), this._carrier.dispose(), this._modulator.dispose(), this._modulationNode.dispose(), this._modulationScale.dispose(), this;
                }
            }
            class Ho extends Po {
                constructor(){
                    super(ui(Ho.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "modulationType"
                    ])), this.name = "FMOscillator", this._modulationNode = new ho({
                        context: this.context,
                        gain: 0
                    });
                    const t1 = ui(Ho.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "modulationType"
                    ]);
                    this._carrier = new Zo({
                        context: this.context,
                        detune: t1.detune,
                        frequency: 0,
                        onstop: ()=>this.onstop(this),
                        phase: t1.phase,
                        type: t1.type
                    }), this.detune = this._carrier.detune, this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency
                    }), this._modulator = new Zo({
                        context: this.context,
                        phase: t1.phase,
                        type: t1.modulationType
                    }), this.harmonicity = new Yo({
                        context: this.context,
                        units: "positive",
                        value: t1.harmonicity
                    }), this.modulationIndex = new Yo({
                        context: this.context,
                        units: "positive",
                        value: t1.modulationIndex
                    }), this.frequency.connect(this._carrier.frequency), this.frequency.chain(this.harmonicity, this._modulator.frequency), this.frequency.chain(this.modulationIndex, this._modulationNode), this._modulator.connect(this._modulationNode.gain), this._modulationNode.connect(this._carrier.frequency), this._carrier.connect(this.output), this.detune.connect(this._modulator.detune), Oi(this, [
                        "modulationIndex",
                        "frequency",
                        "detune",
                        "harmonicity"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Zo.getDefaults(), {
                        harmonicity: 1,
                        modulationIndex: 2,
                        modulationType: "square"
                    });
                }
                _start(t1) {
                    this._modulator.start(t1), this._carrier.start(t1);
                }
                _stop(t1) {
                    this._modulator.stop(t1), this._carrier.stop(t1);
                }
                _restart(t1) {
                    return this._modulator.restart(t1), this._carrier.restart(t1), this;
                }
                get type() {
                    return this._carrier.type;
                }
                set type(t1) {
                    this._carrier.type = t1;
                }
                get baseType() {
                    return this._carrier.baseType;
                }
                set baseType(t1) {
                    this._carrier.baseType = t1;
                }
                get partialCount() {
                    return this._carrier.partialCount;
                }
                set partialCount(t1) {
                    this._carrier.partialCount = t1;
                }
                get modulationType() {
                    return this._modulator.type;
                }
                set modulationType(t1) {
                    this._modulator.type = t1;
                }
                get phase() {
                    return this._carrier.phase;
                }
                set phase(t1) {
                    this._carrier.phase = t1, this._modulator.phase = t1;
                }
                get partials() {
                    return this._carrier.partials;
                }
                set partials(t1) {
                    this._carrier.partials = t1;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this.frequency.dispose(), this.harmonicity.dispose(), this._carrier.dispose(), this._modulator.dispose(), this._modulationNode.dispose(), this.modulationIndex.dispose(), this;
                }
            }
            class Jo extends Po {
                constructor(){
                    super(ui(Jo.getDefaults(), arguments, [
                        "frequency",
                        "width"
                    ])), this.name = "PulseOscillator", this._widthGate = new ho({
                        context: this.context,
                        gain: 0
                    }), this._thresh = new qo({
                        context: this.context,
                        mapping: (t1)=>t1 <= 0 ? -1 : 1
                    });
                    const t1 = ui(Jo.getDefaults(), arguments, [
                        "frequency",
                        "width"
                    ]);
                    this.width = new po({
                        context: this.context,
                        units: "audioRange",
                        value: t1.width
                    }), this._triangle = new Zo({
                        context: this.context,
                        detune: t1.detune,
                        frequency: t1.frequency,
                        onstop: ()=>this.onstop(this),
                        phase: t1.phase,
                        type: "triangle"
                    }), this.frequency = this._triangle.frequency, this.detune = this._triangle.detune, this._triangle.chain(this._thresh, this.output), this.width.chain(this._widthGate, this._thresh), Oi(this, [
                        "width",
                        "frequency",
                        "detune"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        detune: 0,
                        frequency: 440,
                        phase: 0,
                        type: "pulse",
                        width: .2
                    });
                }
                _start(t1) {
                    t1 = this.toSeconds(t1), this._triangle.start(t1), this._widthGate.gain.setValueAtTime(1, t1);
                }
                _stop(t1) {
                    t1 = this.toSeconds(t1), this._triangle.stop(t1), this._widthGate.gain.cancelScheduledValues(t1), this._widthGate.gain.setValueAtTime(0, t1);
                }
                _restart(t1) {
                    this._triangle.restart(t1), this._widthGate.gain.cancelScheduledValues(t1), this._widthGate.gain.setValueAtTime(1, t1);
                }
                get phase() {
                    return this._triangle.phase;
                }
                set phase(t1) {
                    this._triangle.phase = t1;
                }
                get type() {
                    return "pulse";
                }
                get baseType() {
                    return "pulse";
                }
                get partials() {
                    return [];
                }
                get partialCount() {
                    return 0;
                }
                set carrierType(t1) {
                    this._triangle.type = t1;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this._triangle.dispose(), this.width.dispose(), this._widthGate.dispose(), this._thresh.dispose(), this;
                }
            }
            class Ko extends Po {
                constructor(){
                    super(ui(Ko.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "spread"
                    ])), this.name = "FatOscillator", this._oscillators = [];
                    const t1 = ui(Ko.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "spread"
                    ]);
                    this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency
                    }), this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), this._spread = t1.spread, this._type = t1.type, this._phase = t1.phase, this._partials = t1.partials, this._partialCount = t1.partialCount, this.count = t1.count, Oi(this, [
                        "frequency",
                        "detune"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Zo.getDefaults(), {
                        count: 3,
                        spread: 20,
                        type: "sawtooth"
                    });
                }
                _start(t1) {
                    t1 = this.toSeconds(t1), this._forEach((e)=>e.start(t1));
                }
                _stop(t1) {
                    t1 = this.toSeconds(t1), this._forEach((e)=>e.stop(t1));
                }
                _restart(t1) {
                    this._forEach((e)=>e.restart(t1));
                }
                _forEach(t1) {
                    for(let e = 0; e < this._oscillators.length; e++)t1(this._oscillators[e], e);
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    this._type = t1, this._forEach((e)=>e.type = t1);
                }
                get spread() {
                    return this._spread;
                }
                set spread(t1) {
                    if (this._spread = t1, this._oscillators.length > 1) {
                        const e = -t1 / 2, s1 = t1 / (this._oscillators.length - 1);
                        this._forEach((t1, n)=>t1.detune.value = e + s1 * n);
                    }
                }
                get count() {
                    return this._oscillators.length;
                }
                set count(t1) {
                    if (Un(t1, 1), this._oscillators.length !== t1) {
                        this._forEach((t1)=>t1.dispose()), this._oscillators = [];
                        for(let e = 0; e < t1; e++){
                            const s1 = new Zo({
                                context: this.context,
                                volume: -6 - 1.1 * t1,
                                type: this._type,
                                phase: this._phase + e / t1 * 360,
                                partialCount: this._partialCount,
                                onstop: 0 === e ? ()=>this.onstop(this) : Ei
                            });
                            "custom" === this.type && (s1.partials = this._partials), this.frequency.connect(s1.frequency), this.detune.connect(s1.detune), s1.detune.overridden = !1, s1.connect(this.output), this._oscillators[e] = s1;
                        }
                        this.spread = this._spread, "started" === this.state && this._forEach((t1)=>t1.start());
                    }
                }
                get phase() {
                    return this._phase;
                }
                set phase(t1) {
                    this._phase = t1, this._forEach((t1, e)=>t1.phase = this._phase + e / this.count * 360);
                }
                get baseType() {
                    return this._oscillators[0].baseType;
                }
                set baseType(t1) {
                    this._forEach((e)=>e.baseType = t1), this._type = this._oscillators[0].type;
                }
                get partials() {
                    return this._oscillators[0].partials;
                }
                set partials(t1) {
                    this._partials = t1, this._partialCount = this._partials.length, t1.length && (this._type = "custom", this._forEach((e)=>e.partials = t1));
                }
                get partialCount() {
                    return this._oscillators[0].partialCount;
                }
                set partialCount(t1) {
                    this._partialCount = t1, this._forEach((e)=>e.partialCount = t1), this._type = this._oscillators[0].type;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this.frequency.dispose(), this.detune.dispose(), this._forEach((t1)=>t1.dispose()), this;
                }
            }
            class tr extends Po {
                constructor(){
                    super(ui(tr.getDefaults(), arguments, [
                        "frequency",
                        "modulationFrequency"
                    ])), this.name = "PWMOscillator", this.sourceType = "pwm", this._scale = new Yo({
                        context: this.context,
                        value: 2
                    });
                    const t1 = ui(tr.getDefaults(), arguments, [
                        "frequency",
                        "modulationFrequency"
                    ]);
                    this._pulse = new Jo({
                        context: this.context,
                        frequency: t1.modulationFrequency
                    }), this._pulse.carrierType = "sine", this.modulationFrequency = this._pulse.frequency, this._modulator = new Zo({
                        context: this.context,
                        detune: t1.detune,
                        frequency: t1.frequency,
                        onstop: ()=>this.onstop(this),
                        phase: t1.phase
                    }), this.frequency = this._modulator.frequency, this.detune = this._modulator.detune, this._modulator.chain(this._scale, this._pulse.width), this._pulse.connect(this.output), Oi(this, [
                        "modulationFrequency",
                        "frequency",
                        "detune"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        detune: 0,
                        frequency: 440,
                        modulationFrequency: .4,
                        phase: 0,
                        type: "pwm"
                    });
                }
                _start(t1) {
                    t1 = this.toSeconds(t1), this._modulator.start(t1), this._pulse.start(t1);
                }
                _stop(t1) {
                    t1 = this.toSeconds(t1), this._modulator.stop(t1), this._pulse.stop(t1);
                }
                _restart(t1) {
                    this._modulator.restart(t1), this._pulse.restart(t1);
                }
                get type() {
                    return "pwm";
                }
                get baseType() {
                    return "pwm";
                }
                get partials() {
                    return [];
                }
                get partialCount() {
                    return 0;
                }
                get phase() {
                    return this._modulator.phase;
                }
                set phase(t1) {
                    this._modulator.phase = t1;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this._pulse.dispose(), this._scale.dispose(), this._modulator.dispose(), this;
                }
            }
            const er = {
                am: $o,
                fat: Ko,
                fm: Ho,
                oscillator: Zo,
                pulse: Jo,
                pwm: tr
            };
            class sr extends Po {
                constructor(){
                    super(ui(sr.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ])), this.name = "OmniOscillator";
                    const t1 = ui(sr.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ]);
                    this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency
                    }), this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), Oi(this, [
                        "frequency",
                        "detune"
                    ]), this.set(t1);
                }
                static getDefaults() {
                    return Object.assign(Zo.getDefaults(), Ho.getDefaults(), $o.getDefaults(), Ko.getDefaults(), Jo.getDefaults(), tr.getDefaults());
                }
                _start(t1) {
                    this._oscillator.start(t1);
                }
                _stop(t1) {
                    this._oscillator.stop(t1);
                }
                _restart(t1) {
                    return this._oscillator.restart(t1), this;
                }
                get type() {
                    let t1 = "";
                    return [
                        "am",
                        "fm",
                        "fat"
                    ].some((t1)=>this._sourceType === t1) && (t1 = this._sourceType), t1 + this._oscillator.type;
                }
                set type(t1) {
                    "fm" === t1.substr(0, 2) ? (this._createNewOscillator("fm"), this._oscillator = this._oscillator, this._oscillator.type = t1.substr(2)) : "am" === t1.substr(0, 2) ? (this._createNewOscillator("am"), this._oscillator = this._oscillator, this._oscillator.type = t1.substr(2)) : "fat" === t1.substr(0, 3) ? (this._createNewOscillator("fat"), this._oscillator = this._oscillator, this._oscillator.type = t1.substr(3)) : "pwm" === t1 ? (this._createNewOscillator("pwm"), this._oscillator = this._oscillator) : "pulse" === t1 ? this._createNewOscillator("pulse") : (this._createNewOscillator("oscillator"), this._oscillator = this._oscillator, this._oscillator.type = t1);
                }
                get partials() {
                    return this._oscillator.partials;
                }
                set partials(t1) {
                    this._getOscType(this._oscillator, "pulse") || this._getOscType(this._oscillator, "pwm") || (this._oscillator.partials = t1);
                }
                get partialCount() {
                    return this._oscillator.partialCount;
                }
                set partialCount(t1) {
                    this._getOscType(this._oscillator, "pulse") || this._getOscType(this._oscillator, "pwm") || (this._oscillator.partialCount = t1);
                }
                set(t1) {
                    return Reflect.has(t1, "type") && t1.type && (this.type = t1.type), super.set(t1), this;
                }
                _createNewOscillator(t1) {
                    if (t1 !== this._sourceType) {
                        this._sourceType = t1;
                        const e = er[t1], s1 = this.now();
                        if (this._oscillator) {
                            const t1 = this._oscillator;
                            t1.stop(s1), this.context.setTimeout(()=>t1.dispose(), this.blockTime);
                        }
                        this._oscillator = new e({
                            context: this.context
                        }), this.frequency.connect(this._oscillator.frequency), this.detune.connect(this._oscillator.detune), this._oscillator.connect(this.output), this._oscillator.onstop = ()=>this.onstop(this), "started" === this.state && this._oscillator.start(s1);
                    }
                }
                get phase() {
                    return this._oscillator.phase;
                }
                set phase(t1) {
                    this._oscillator.phase = t1;
                }
                get sourceType() {
                    return this._sourceType;
                }
                set sourceType(t1) {
                    let e = "sine";
                    "pwm" !== this._oscillator.type && "pulse" !== this._oscillator.type && (e = this._oscillator.type), "fm" === t1 ? this.type = "fm" + e : "am" === t1 ? this.type = "am" + e : "fat" === t1 ? this.type = "fat" + e : "oscillator" === t1 ? this.type = e : "pulse" === t1 ? this.type = "pulse" : "pwm" === t1 && (this.type = "pwm");
                }
                _getOscType(t1, e) {
                    return t1 instanceof er[e];
                }
                get baseType() {
                    return this._oscillator.baseType;
                }
                set baseType(t1) {
                    this._getOscType(this._oscillator, "pulse") || this._getOscType(this._oscillator, "pwm") || "pulse" === t1 || "pwm" === t1 || (this._oscillator.baseType = t1);
                }
                get width() {
                    return this._getOscType(this._oscillator, "pulse") ? this._oscillator.width : void 0;
                }
                get count() {
                    return this._getOscType(this._oscillator, "fat") ? this._oscillator.count : void 0;
                }
                set count(t1) {
                    this._getOscType(this._oscillator, "fat") && Nn(t1) && (this._oscillator.count = t1);
                }
                get spread() {
                    return this._getOscType(this._oscillator, "fat") ? this._oscillator.spread : void 0;
                }
                set spread(t1) {
                    this._getOscType(this._oscillator, "fat") && Nn(t1) && (this._oscillator.spread = t1);
                }
                get modulationType() {
                    return this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am") ? this._oscillator.modulationType : void 0;
                }
                set modulationType(t1) {
                    (this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) && zn(t1) && (this._oscillator.modulationType = t1);
                }
                get modulationIndex() {
                    return this._getOscType(this._oscillator, "fm") ? this._oscillator.modulationIndex : void 0;
                }
                get harmonicity() {
                    return this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am") ? this._oscillator.harmonicity : void 0;
                }
                get modulationFrequency() {
                    return this._getOscType(this._oscillator, "pwm") ? this._oscillator.modulationFrequency : void 0;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        return Go(this, t1);
                    });
                }
                dispose() {
                    return super.dispose(), this.detune.dispose(), this.frequency.dispose(), this._oscillator.dispose(), this;
                }
            }
            class nr extends po {
                constructor(){
                    super(Object.assign(ui(nr.getDefaults(), arguments, [
                        "value"
                    ]))), this.override = !1, this.name = "Add", this._sum = new ho({
                        context: this.context
                    }), this.input = this._sum, this.output = this._sum, this.addend = this._param, oo(this._constantSource, this._sum);
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        value: 0
                    });
                }
                dispose() {
                    return super.dispose(), this._sum.dispose(), this;
                }
            }
            class ir extends Ro {
                constructor(){
                    super(Object.assign(ui(ir.getDefaults(), arguments, [
                        "min",
                        "max"
                    ]))), this.name = "Scale";
                    const t1 = ui(ir.getDefaults(), arguments, [
                        "min",
                        "max"
                    ]);
                    this._mult = this.input = new Yo({
                        context: this.context,
                        value: t1.max - t1.min
                    }), this._add = this.output = new nr({
                        context: this.context,
                        value: t1.min
                    }), this._min = t1.min, this._max = t1.max, this.input.connect(this.output);
                }
                static getDefaults() {
                    return Object.assign(Ro.getDefaults(), {
                        max: 1,
                        min: 0
                    });
                }
                get min() {
                    return this._min;
                }
                set min(t1) {
                    this._min = t1, this._setRange();
                }
                get max() {
                    return this._max;
                }
                set max(t1) {
                    this._max = t1, this._setRange();
                }
                _setRange() {
                    this._add.value = this._min, this._mult.value = this._max - this._min;
                }
                dispose() {
                    return super.dispose(), this._add.dispose(), this._mult.dispose(), this;
                }
            }
            class or extends Ro {
                constructor(){
                    super(Object.assign(ui(or.getDefaults(), arguments))), this.name = "Zero", this._gain = new ho({
                        context: this.context
                    }), this.output = this._gain, this.input = void 0, ro(this.context.getConstant(0), this._gain);
                }
                dispose() {
                    return super.dispose(), ao(this.context.getConstant(0), this._gain), this;
                }
            }
            class rr extends io {
                constructor(){
                    super(ui(rr.getDefaults(), arguments, [
                        "frequency",
                        "min",
                        "max"
                    ])), this.name = "LFO", this._stoppedValue = 0, this._units = "number", this.convert = !0, this._fromType = no.prototype._fromType, this._toType = no.prototype._toType, this._is = no.prototype._is, this._clampValue = no.prototype._clampValue;
                    const t1 = ui(rr.getDefaults(), arguments, [
                        "frequency",
                        "min",
                        "max"
                    ]);
                    this._oscillator = new Zo(t1), this.frequency = this._oscillator.frequency, this._amplitudeGain = new ho({
                        context: this.context,
                        gain: t1.amplitude,
                        units: "normalRange"
                    }), this.amplitude = this._amplitudeGain.gain, this._stoppedSignal = new po({
                        context: this.context,
                        units: "audioRange",
                        value: 0
                    }), this._zeros = new or({
                        context: this.context
                    }), this._a2g = new Xo({
                        context: this.context
                    }), this._scaler = this.output = new ir({
                        context: this.context,
                        max: t1.max,
                        min: t1.min
                    }), this.units = t1.units, this.min = t1.min, this.max = t1.max, this._oscillator.chain(this._amplitudeGain, this._a2g, this._scaler), this._zeros.connect(this._a2g), this._stoppedSignal.connect(this._a2g), Oi(this, [
                        "amplitude",
                        "frequency"
                    ]), this.phase = t1.phase;
                }
                static getDefaults() {
                    return Object.assign(Zo.getDefaults(), {
                        amplitude: 1,
                        frequency: "4n",
                        max: 1,
                        min: 0,
                        type: "sine",
                        units: "number"
                    });
                }
                start(t1) {
                    return t1 = this.toSeconds(t1), this._stoppedSignal.setValueAtTime(0, t1), this._oscillator.start(t1), this;
                }
                stop(t1) {
                    return t1 = this.toSeconds(t1), this._stoppedSignal.setValueAtTime(this._stoppedValue, t1), this._oscillator.stop(t1), this;
                }
                sync() {
                    return this._oscillator.sync(), this._oscillator.syncFrequency(), this;
                }
                unsync() {
                    return this._oscillator.unsync(), this._oscillator.unsyncFrequency(), this;
                }
                _setStoppedValue() {
                    this._stoppedValue = this._oscillator.getInitialValue(), this._stoppedSignal.value = this._stoppedValue;
                }
                get min() {
                    return this._toType(this._scaler.min);
                }
                set min(t1) {
                    t1 = this._fromType(t1), this._scaler.min = t1;
                }
                get max() {
                    return this._toType(this._scaler.max);
                }
                set max(t1) {
                    t1 = this._fromType(t1), this._scaler.max = t1;
                }
                get type() {
                    return this._oscillator.type;
                }
                set type(t1) {
                    this._oscillator.type = t1, this._setStoppedValue();
                }
                get partials() {
                    return this._oscillator.partials;
                }
                set partials(t1) {
                    this._oscillator.partials = t1, this._setStoppedValue();
                }
                get phase() {
                    return this._oscillator.phase;
                }
                set phase(t1) {
                    this._oscillator.phase = t1, this._setStoppedValue();
                }
                get units() {
                    return this._units;
                }
                set units(t1) {
                    const e = this.min, s1 = this.max;
                    this._units = t1, this.min = e, this.max = s1;
                }
                get state() {
                    return this._oscillator.state;
                }
                connect(t1, e, s1) {
                    return (t1 instanceof no || t1 instanceof po) && (this.convert = t1.convert, this.units = t1.units), fo(this, t1, e, s1), this;
                }
                dispose() {
                    return super.dispose(), this._oscillator.dispose(), this._stoppedSignal.dispose(), this._zeros.dispose(), this._scaler.dispose(), this._a2g.dispose(), this._amplitudeGain.dispose(), this.amplitude.dispose(), this;
                }
            }
            function ar(t1, e = 1 / 0) {
                const s1 = new WeakMap;
                return function(n, i) {
                    Reflect.defineProperty(n, i, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            return s1.get(this);
                        },
                        set: function(n) {
                            Un(n, t1, e), s1.set(this, n);
                        }
                    });
                };
            }
            function cr(t1, e = 1 / 0) {
                const s1 = new WeakMap;
                return function(n, i) {
                    Reflect.defineProperty(n, i, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            return s1.get(this);
                        },
                        set: function(n) {
                            Un(this.toSeconds(n), t1, e), s1.set(this, n);
                        }
                    });
                };
            }
            class hr extends Po {
                constructor(){
                    super(ui(hr.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ])), this.name = "Player", this._activeSources = new Set;
                    const t1 = ui(hr.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ]);
                    this._buffer = new Ri({
                        onload: this._onload.bind(this, t1.onload),
                        onerror: t1.onerror,
                        reverse: t1.reverse,
                        url: t1.url
                    }), this.autostart = t1.autostart, this._loop = t1.loop, this._loopStart = t1.loopStart, this._loopEnd = t1.loopEnd, this._playbackRate = t1.playbackRate, this.fadeIn = t1.fadeIn, this.fadeOut = t1.fadeOut;
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        autostart: !1,
                        fadeIn: 0,
                        fadeOut: 0,
                        loop: !1,
                        loopEnd: 0,
                        loopStart: 0,
                        onload: Ei,
                        onerror: Ei,
                        playbackRate: 1,
                        reverse: !1
                    });
                }
                load(t1) {
                    return ni(this, void 0, void 0, function*() {
                        return yield this._buffer.load(t1), this._onload(), this;
                    });
                }
                _onload(t1 = Ei) {
                    t1(), this.autostart && this.start();
                }
                _onSourceEnd(t1) {
                    this.onstop(this), this._activeSources.delete(t1), 0 !== this._activeSources.size || this._synced || "started" !== this._state.getValueAtTime(this.now()) || (this._state.cancel(this.now()), this._state.setStateAtTime("stopped", this.now()));
                }
                start(t1, e, s1) {
                    return super.start(t1, e, s1), this;
                }
                _start(t1, e, s1) {
                    e = this._loop ? pi(e, this._loopStart) : pi(e, 0);
                    const n = this.toSeconds(e), i = s1;
                    s1 = pi(s1, Math.max(this._buffer.duration - n, 0));
                    let o = this.toSeconds(s1);
                    o /= this._playbackRate, t1 = this.toSeconds(t1);
                    const r = new jo({
                        url: this._buffer,
                        context: this.context,
                        fadeIn: this.fadeIn,
                        fadeOut: this.fadeOut,
                        loop: this._loop,
                        loopEnd: this._loopEnd,
                        loopStart: this._loopStart,
                        onended: this._onSourceEnd.bind(this),
                        playbackRate: this._playbackRate
                    }).connect(this.output);
                    this._loop || this._synced || (this._state.cancel(t1 + o), this._state.setStateAtTime("stopped", t1 + o, {
                        implicitEnd: !0
                    })), this._activeSources.add(r), this._loop && Fn(i) ? r.start(t1, n) : r.start(t1, n, o - this.toSeconds(this.fadeOut));
                }
                _stop(t1) {
                    const e = this.toSeconds(t1);
                    this._activeSources.forEach((t1)=>t1.stop(e));
                }
                restart(t1, e, s1) {
                    return super.restart(t1, e, s1), this;
                }
                _restart(t1, e, s1) {
                    var n;
                    null === (n = [
                        ...this._activeSources
                    ].pop()) || void 0 === n || n.stop(t1), this._start(t1, e, s1);
                }
                seek(t1, e) {
                    const s1 = this.toSeconds(e);
                    if ("started" === this._state.getValueAtTime(s1)) {
                        const e = this.toSeconds(t1);
                        this._stop(s1), this._start(s1, e);
                    }
                    return this;
                }
                setLoopPoints(t1, e) {
                    return this.loopStart = t1, this.loopEnd = e, this;
                }
                get loopStart() {
                    return this._loopStart;
                }
                set loopStart(t1) {
                    this._loopStart = t1, this.buffer.loaded && Un(this.toSeconds(t1), 0, this.buffer.duration), this._activeSources.forEach((e)=>{
                        e.loopStart = t1;
                    });
                }
                get loopEnd() {
                    return this._loopEnd;
                }
                set loopEnd(t1) {
                    this._loopEnd = t1, this.buffer.loaded && Un(this.toSeconds(t1), 0, this.buffer.duration), this._activeSources.forEach((e)=>{
                        e.loopEnd = t1;
                    });
                }
                get buffer() {
                    return this._buffer;
                }
                set buffer(t1) {
                    this._buffer.set(t1);
                }
                get loop() {
                    return this._loop;
                }
                set loop(t1) {
                    if (this._loop !== t1 && (this._loop = t1, this._activeSources.forEach((e)=>{
                        e.loop = t1;
                    }), t1)) {
                        const t1 = this._state.getNextState("stopped", this.now());
                        t1 && this._state.cancel(t1.time);
                    }
                }
                get playbackRate() {
                    return this._playbackRate;
                }
                set playbackRate(t1) {
                    this._playbackRate = t1;
                    const e = this.now(), s1 = this._state.getNextState("stopped", e);
                    s1 && s1.implicitEnd && (this._state.cancel(s1.time), this._activeSources.forEach((t1)=>t1.cancelStop())), this._activeSources.forEach((s1)=>{
                        s1.playbackRate.setValueAtTime(t1, e);
                    });
                }
                get reverse() {
                    return this._buffer.reverse;
                }
                set reverse(t1) {
                    this._buffer.reverse = t1;
                }
                get loaded() {
                    return this._buffer.loaded;
                }
                dispose() {
                    return super.dispose(), this._activeSources.forEach((t1)=>t1.dispose()), this._activeSources.clear(), this._buffer.dispose(), this;
                }
            }
            si([
                cr(0)
            ], hr.prototype, "fadeIn", void 0), si([
                cr(0)
            ], hr.prototype, "fadeOut", void 0);
            class lr extends io {
                constructor(){
                    super(ui(lr.getDefaults(), arguments, [
                        "urls",
                        "onload"
                    ], "urls")), this.name = "Players", this.input = void 0, this._players = new Map;
                    const t1 = ui(lr.getDefaults(), arguments, [
                        "urls",
                        "onload"
                    ], "urls");
                    this._volume = this.output = new Oo({
                        context: this.context,
                        volume: t1.volume
                    }), this.volume = this._volume.volume, Oi(this, "volume"), this._buffers = new wo({
                        urls: t1.urls,
                        onload: t1.onload,
                        baseUrl: t1.baseUrl,
                        onerror: t1.onerror
                    }), this.mute = t1.mute, this._fadeIn = t1.fadeIn, this._fadeOut = t1.fadeOut;
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        baseUrl: "",
                        fadeIn: 0,
                        fadeOut: 0,
                        mute: !1,
                        onload: Ei,
                        onerror: Ei,
                        urls: {},
                        volume: 0
                    });
                }
                get mute() {
                    return this._volume.mute;
                }
                set mute(t1) {
                    this._volume.mute = t1;
                }
                get fadeIn() {
                    return this._fadeIn;
                }
                set fadeIn(t1) {
                    this._fadeIn = t1, this._players.forEach((e)=>{
                        e.fadeIn = t1;
                    });
                }
                get fadeOut() {
                    return this._fadeOut;
                }
                set fadeOut(t1) {
                    this._fadeOut = t1, this._players.forEach((e)=>{
                        e.fadeOut = t1;
                    });
                }
                get state() {
                    return Array.from(this._players).some(([t1, e])=>"started" === e.state) ? "started" : "stopped";
                }
                has(t1) {
                    return this._buffers.has(t1);
                }
                player(t1) {
                    if (Bn(this.has(t1), `No Player with the name ${t1} exists on this object`), !this._players.has(t1)) {
                        const e = new hr({
                            context: this.context,
                            fadeIn: this._fadeIn,
                            fadeOut: this._fadeOut,
                            url: this._buffers.get(t1)
                        }).connect(this.output);
                        this._players.set(t1, e);
                    }
                    return this._players.get(t1);
                }
                get loaded() {
                    return this._buffers.loaded;
                }
                add(t1, e, s1) {
                    return Bn(!this._buffers.has(t1), "A buffer with that name already exists on this object"), this._buffers.add(t1, e, s1), this;
                }
                stopAll(t1) {
                    return this._players.forEach((e)=>e.stop(t1)), this;
                }
                dispose() {
                    return super.dispose(), this._volume.dispose(), this.volume.dispose(), this._players.forEach((t1)=>t1.dispose()), this._buffers.dispose(), this;
                }
            }
            class ur extends Po {
                constructor(){
                    super(ui(ur.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ])), this.name = "GrainPlayer", this._loopStart = 0, this._loopEnd = 0, this._activeSources = [];
                    const t1 = ui(ur.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ]);
                    this.buffer = new Ri({
                        onload: t1.onload,
                        onerror: t1.onerror,
                        reverse: t1.reverse,
                        url: t1.url
                    }), this._clock = new vo({
                        context: this.context,
                        callback: this._tick.bind(this),
                        frequency: 1 / t1.grainSize
                    }), this._playbackRate = t1.playbackRate, this._grainSize = t1.grainSize, this._overlap = t1.overlap, this.detune = t1.detune, this.overlap = t1.overlap, this.loop = t1.loop, this.playbackRate = t1.playbackRate, this.grainSize = t1.grainSize, this.loopStart = t1.loopStart, this.loopEnd = t1.loopEnd, this.reverse = t1.reverse, this._clock.on("stop", this._onstop.bind(this));
                }
                static getDefaults() {
                    return Object.assign(Po.getDefaults(), {
                        onload: Ei,
                        onerror: Ei,
                        overlap: .1,
                        grainSize: .2,
                        playbackRate: 1,
                        detune: 0,
                        loop: !1,
                        loopStart: 0,
                        loopEnd: 0,
                        reverse: !1
                    });
                }
                _start(t1, e, s1) {
                    e = pi(e, 0), e = this.toSeconds(e), t1 = this.toSeconds(t1);
                    const n = 1 / this._clock.frequency.getValueAtTime(t1);
                    this._clock.start(t1, e / n), s1 && this.stop(t1 + this.toSeconds(s1));
                }
                restart(t1, e, s1) {
                    return super.restart(t1, e, s1), this;
                }
                _restart(t1, e, s1) {
                    this._stop(t1), this._start(t1, e, s1);
                }
                _stop(t1) {
                    this._clock.stop(t1);
                }
                _onstop(t1) {
                    this._activeSources.forEach((e)=>{
                        e.fadeOut = 0, e.stop(t1);
                    }), this.onstop(this);
                }
                _tick(t1) {
                    const e = this._clock.getTicksAtTime(t1), s1 = e * this._grainSize;
                    if (this.log("offset", s1), !this.loop && s1 > this.buffer.duration) return void this.stop(t1);
                    const n = s1 < this._overlap ? 0 : this._overlap, i = new jo({
                        context: this.context,
                        url: this.buffer,
                        fadeIn: n,
                        fadeOut: this._overlap,
                        loop: this.loop,
                        loopStart: this._loopStart,
                        loopEnd: this._loopEnd,
                        playbackRate: zi(this.detune / 100)
                    }).connect(this.output);
                    i.start(t1, this._grainSize * e), i.stop(t1 + this._grainSize / this.playbackRate), this._activeSources.push(i), i.onended = ()=>{
                        const t1 = this._activeSources.indexOf(i);
                        -1 !== t1 && this._activeSources.splice(t1, 1);
                    };
                }
                get playbackRate() {
                    return this._playbackRate;
                }
                set playbackRate(t1) {
                    Un(t1, .001), this._playbackRate = t1, this.grainSize = this._grainSize;
                }
                get loopStart() {
                    return this._loopStart;
                }
                set loopStart(t1) {
                    this.buffer.loaded && Un(this.toSeconds(t1), 0, this.buffer.duration), this._loopStart = this.toSeconds(t1);
                }
                get loopEnd() {
                    return this._loopEnd;
                }
                set loopEnd(t1) {
                    this.buffer.loaded && Un(this.toSeconds(t1), 0, this.buffer.duration), this._loopEnd = this.toSeconds(t1);
                }
                get reverse() {
                    return this.buffer.reverse;
                }
                set reverse(t1) {
                    this.buffer.reverse = t1;
                }
                get grainSize() {
                    return this._grainSize;
                }
                set grainSize(t1) {
                    this._grainSize = this.toSeconds(t1), this._clock.frequency.setValueAtTime(this._playbackRate / this._grainSize, this.now());
                }
                get overlap() {
                    return this._overlap;
                }
                set overlap(t1) {
                    const e = this.toSeconds(t1);
                    Un(e, 0), this._overlap = e;
                }
                get loaded() {
                    return this.buffer.loaded;
                }
                dispose() {
                    return super.dispose(), this.buffer.dispose(), this._clock.dispose(), this._activeSources.forEach((t1)=>t1.dispose()), this;
                }
            }
            class pr extends Ro {
                constructor(){
                    super(...arguments), this.name = "Abs", this._abs = new qo({
                        context: this.context,
                        mapping: (t1)=>Math.abs(t1) < .001 ? 0 : Math.abs(t1)
                    }), this.input = this._abs, this.output = this._abs;
                }
                dispose() {
                    return super.dispose(), this._abs.dispose(), this;
                }
            }
            class dr extends Ro {
                constructor(){
                    super(...arguments), this.name = "GainToAudio", this._norm = new qo({
                        context: this.context,
                        mapping: (t1)=>2 * Math.abs(t1) - 1
                    }), this.input = this._norm, this.output = this._norm;
                }
                dispose() {
                    return super.dispose(), this._norm.dispose(), this;
                }
            }
            class fr extends Ro {
                constructor(){
                    super(...arguments), this.name = "Negate", this._multiply = new Yo({
                        context: this.context,
                        value: -1
                    }), this.input = this._multiply, this.output = this._multiply;
                }
                dispose() {
                    return super.dispose(), this._multiply.dispose(), this;
                }
            }
            class _r extends po {
                constructor(){
                    super(Object.assign(ui(_r.getDefaults(), arguments, [
                        "value"
                    ]))), this.override = !1, this.name = "Subtract", this._sum = new ho({
                        context: this.context
                    }), this.input = this._sum, this.output = this._sum, this._neg = new fr({
                        context: this.context
                    }), this.subtrahend = this._param, oo(this._constantSource, this._neg, this._sum);
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        value: 0
                    });
                }
                dispose() {
                    return super.dispose(), this._neg.dispose(), this._sum.dispose(), this;
                }
            }
            class mr extends Ro {
                constructor(){
                    super(Object.assign(ui(mr.getDefaults(), arguments))), this.name = "GreaterThanZero", this._thresh = this.output = new qo({
                        context: this.context,
                        length: 127,
                        mapping: (t1)=>t1 <= 0 ? 0 : 1
                    }), this._scale = this.input = new Yo({
                        context: this.context,
                        value: 1e4
                    }), this._scale.connect(this._thresh);
                }
                dispose() {
                    return super.dispose(), this._scale.dispose(), this._thresh.dispose(), this;
                }
            }
            class gr extends po {
                constructor(){
                    super(Object.assign(ui(gr.getDefaults(), arguments, [
                        "value"
                    ]))), this.name = "GreaterThan", this.override = !1;
                    const t1 = ui(gr.getDefaults(), arguments, [
                        "value"
                    ]);
                    this._subtract = this.input = new _r({
                        context: this.context,
                        value: t1.value
                    }), this._gtz = this.output = new mr({
                        context: this.context
                    }), this.comparator = this._param = this._subtract.subtrahend, Oi(this, "comparator"), this._subtract.connect(this._gtz);
                }
                static getDefaults() {
                    return Object.assign(po.getDefaults(), {
                        value: 0
                    });
                }
                dispose() {
                    return super.dispose(), this._gtz.dispose(), this._subtract.dispose(), this.comparator.dispose(), this;
                }
            }
            class vr extends ir {
                constructor(){
                    super(Object.assign(ui(vr.getDefaults(), arguments, [
                        "min",
                        "max",
                        "exponent"
                    ]))), this.name = "ScaleExp";
                    const t1 = ui(vr.getDefaults(), arguments, [
                        "min",
                        "max",
                        "exponent"
                    ]);
                    this.input = this._exp = new Fo({
                        context: this.context,
                        value: t1.exponent
                    }), this._exp.connect(this._mult);
                }
                static getDefaults() {
                    return Object.assign(ir.getDefaults(), {
                        exponent: 1
                    });
                }
                get exponent() {
                    return this._exp.value;
                }
                set exponent(t1) {
                    this._exp.value = t1;
                }
                dispose() {
                    return super.dispose(), this._exp.dispose(), this;
                }
            }
            class yr extends po {
                constructor(){
                    super(ui(po.getDefaults(), arguments, [
                        "value",
                        "units"
                    ])), this.name = "SyncedSignal", this.override = !1;
                    const t1 = ui(po.getDefaults(), arguments, [
                        "value",
                        "units"
                    ]);
                    this._lastVal = t1.value, this._synced = this.context.transport.scheduleRepeat(this._onTick.bind(this), "1i"), this._syncedCallback = this._anchorValue.bind(this), this.context.transport.on("start", this._syncedCallback), this.context.transport.on("pause", this._syncedCallback), this.context.transport.on("stop", this._syncedCallback), this._constantSource.disconnect(), this._constantSource.stop(0), this._constantSource = this.output = new uo({
                        context: this.context,
                        offset: t1.value,
                        units: t1.units
                    }).start(0), this.setValueAtTime(t1.value, 0);
                }
                _onTick(t1) {
                    const e = super.getValueAtTime(this.context.transport.seconds);
                    this._lastVal !== e && (this._lastVal = e, this._constantSource.offset.setValueAtTime(e, t1));
                }
                _anchorValue(t1) {
                    const e = super.getValueAtTime(this.context.transport.seconds);
                    this._lastVal = e, this._constantSource.offset.cancelAndHoldAtTime(t1), this._constantSource.offset.setValueAtTime(e, t1);
                }
                getValueAtTime(t1) {
                    const e = new Ki(this.context, t1).toSeconds();
                    return super.getValueAtTime(e);
                }
                setValueAtTime(t1, e) {
                    const s1 = new Ki(this.context, e).toSeconds();
                    return super.setValueAtTime(t1, s1), this;
                }
                linearRampToValueAtTime(t1, e) {
                    const s1 = new Ki(this.context, e).toSeconds();
                    return super.linearRampToValueAtTime(t1, s1), this;
                }
                exponentialRampToValueAtTime(t1, e) {
                    const s1 = new Ki(this.context, e).toSeconds();
                    return super.exponentialRampToValueAtTime(t1, s1), this;
                }
                setTargetAtTime(t1, e, s1) {
                    const n = new Ki(this.context, e).toSeconds();
                    return super.setTargetAtTime(t1, n, s1), this;
                }
                cancelScheduledValues(t1) {
                    const e = new Ki(this.context, t1).toSeconds();
                    return super.cancelScheduledValues(e), this;
                }
                setValueCurveAtTime(t1, e, s1, n) {
                    const i = new Ki(this.context, e).toSeconds();
                    return s1 = this.toSeconds(s1), super.setValueCurveAtTime(t1, i, s1, n), this;
                }
                cancelAndHoldAtTime(t1) {
                    const e = new Ki(this.context, t1).toSeconds();
                    return super.cancelAndHoldAtTime(e), this;
                }
                setRampPoint(t1) {
                    const e = new Ki(this.context, t1).toSeconds();
                    return super.setRampPoint(e), this;
                }
                exponentialRampTo(t1, e, s1) {
                    const n = new Ki(this.context, s1).toSeconds();
                    return super.exponentialRampTo(t1, e, n), this;
                }
                linearRampTo(t1, e, s1) {
                    const n = new Ki(this.context, s1).toSeconds();
                    return super.linearRampTo(t1, e, n), this;
                }
                targetRampTo(t1, e, s1) {
                    const n = new Ki(this.context, s1).toSeconds();
                    return super.targetRampTo(t1, e, n), this;
                }
                dispose() {
                    return super.dispose(), this.context.transport.clear(this._synced), this.context.transport.off("start", this._syncedCallback), this.context.transport.off("pause", this._syncedCallback), this.context.transport.off("stop", this._syncedCallback), this._constantSource.dispose(), this;
                }
            }
            class xr extends io {
                constructor(){
                    super(ui(xr.getDefaults(), arguments, [
                        "attack",
                        "decay",
                        "sustain",
                        "release"
                    ])), this.name = "Envelope", this._sig = new po({
                        context: this.context,
                        value: 0
                    }), this.output = this._sig, this.input = void 0;
                    const t1 = ui(xr.getDefaults(), arguments, [
                        "attack",
                        "decay",
                        "sustain",
                        "release"
                    ]);
                    this.attack = t1.attack, this.decay = t1.decay, this.sustain = t1.sustain, this.release = t1.release, this.attackCurve = t1.attackCurve, this.releaseCurve = t1.releaseCurve, this.decayCurve = t1.decayCurve;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        attack: .01,
                        attackCurve: "linear",
                        decay: .1,
                        decayCurve: "exponential",
                        release: 1,
                        releaseCurve: "exponential",
                        sustain: .5
                    });
                }
                get value() {
                    return this.getValueAtTime(this.now());
                }
                _getCurve(t1, e) {
                    if (zn(t1)) return t1;
                    {
                        let s1;
                        for(s1 in wr)if (wr[s1][e] === t1) return s1;
                        return t1;
                    }
                }
                _setCurve(t1, e, s1) {
                    if (zn(s1) && Reflect.has(wr, s1)) {
                        const n = wr[s1];
                        Pn(n) ? "_decayCurve" !== t1 && (this[t1] = n[e]) : this[t1] = n;
                    } else {
                        if (!Ln(s1) || "_decayCurve" === t1) throw new Error("Envelope: invalid curve: " + s1);
                        this[t1] = s1;
                    }
                }
                get attackCurve() {
                    return this._getCurve(this._attackCurve, "In");
                }
                set attackCurve(t1) {
                    this._setCurve("_attackCurve", "In", t1);
                }
                get releaseCurve() {
                    return this._getCurve(this._releaseCurve, "Out");
                }
                set releaseCurve(t1) {
                    this._setCurve("_releaseCurve", "Out", t1);
                }
                get decayCurve() {
                    return this._getCurve(this._decayCurve, "Out");
                }
                set decayCurve(t1) {
                    this._setCurve("_decayCurve", "Out", t1);
                }
                triggerAttack(t1, e = 1) {
                    this.log("triggerAttack", t1, e), t1 = this.toSeconds(t1);
                    let s1 = this.toSeconds(this.attack);
                    const n = this.toSeconds(this.decay), i = this.getValueAtTime(t1);
                    if (i > 0 && (s1 = (1 - i) / (1 / s1)), s1 < this.sampleTime) this._sig.cancelScheduledValues(t1), this._sig.setValueAtTime(e, t1);
                    else if ("linear" === this._attackCurve) this._sig.linearRampTo(e, s1, t1);
                    else if ("exponential" === this._attackCurve) this._sig.targetRampTo(e, s1, t1);
                    else {
                        this._sig.cancelAndHoldAtTime(t1);
                        let n = this._attackCurve;
                        for(let t1 = 1; t1 < n.length; t1++)if (n[t1 - 1] <= i && i <= n[t1]) {
                            n = this._attackCurve.slice(t1), n[0] = i;
                            break;
                        }
                        this._sig.setValueCurveAtTime(n, t1, s1, e);
                    }
                    if (n && this.sustain < 1) {
                        const i = e * this.sustain, o = t1 + s1;
                        this.log("decay", o), "linear" === this._decayCurve ? this._sig.linearRampToValueAtTime(i, n + o) : this._sig.exponentialApproachValueAtTime(i, o, n);
                    }
                    return this;
                }
                triggerRelease(t1) {
                    this.log("triggerRelease", t1), t1 = this.toSeconds(t1);
                    const e = this.getValueAtTime(t1);
                    if (e > 0) {
                        const s1 = this.toSeconds(this.release);
                        s1 < this.sampleTime ? this._sig.setValueAtTime(0, t1) : "linear" === this._releaseCurve ? this._sig.linearRampTo(0, s1, t1) : "exponential" === this._releaseCurve ? this._sig.targetRampTo(0, s1, t1) : (Bn(Ln(this._releaseCurve), "releaseCurve must be either 'linear', 'exponential' or an array"), this._sig.cancelAndHoldAtTime(t1), this._sig.setValueCurveAtTime(this._releaseCurve, t1, s1, e));
                    }
                    return this;
                }
                getValueAtTime(t1) {
                    return this._sig.getValueAtTime(t1);
                }
                triggerAttackRelease(t1, e, s1 = 1) {
                    return e = this.toSeconds(e), this.triggerAttack(e, s1), this.triggerRelease(e + this.toSeconds(t1)), this;
                }
                cancel(t1) {
                    return this._sig.cancelScheduledValues(this.toSeconds(t1)), this;
                }
                connect(t1, e = 0, s1 = 0) {
                    return fo(this, t1, e, s1), this;
                }
                asArray(t1 = 1024) {
                    return ni(this, void 0, void 0, function*() {
                        const e = t1 / this.context.sampleRate, s1 = new qi(1, e, this.context.sampleRate), n = this.toSeconds(this.attack) + this.toSeconds(this.decay), i = n + this.toSeconds(this.release), o = .1 * i, r = i + o, a = new this.constructor(Object.assign(this.get(), {
                            attack: e * this.toSeconds(this.attack) / r,
                            decay: e * this.toSeconds(this.decay) / r,
                            release: e * this.toSeconds(this.release) / r,
                            context: s1
                        }));
                        return a._sig.toDestination(), a.triggerAttackRelease(e * (n + o) / r, 0), (yield s1.render()).getChannelData(0);
                    });
                }
                dispose() {
                    return super.dispose(), this._sig.dispose(), this;
                }
            }
            si([
                cr(0)
            ], xr.prototype, "attack", void 0), si([
                cr(0)
            ], xr.prototype, "decay", void 0), si([
                ar(0, 1)
            ], xr.prototype, "sustain", void 0), si([
                cr(0)
            ], xr.prototype, "release", void 0);
            const wr = (()=>{
                const t1 = 128;
                let e, s1;
                const n = [];
                for(e = 0; e < t1; e++)n[e] = Math.sin(e / 127 * (Math.PI / 2));
                const i = [];
                for(e = 0; e < 127; e++){
                    s1 = e / 127;
                    const t1 = Math.sin(s1 * (2 * Math.PI) * 6.4 - Math.PI / 2) + 1;
                    i[e] = t1 / 10 + .83 * s1;
                }
                i[127] = 1;
                const o = [];
                for(e = 0; e < t1; e++)o[e] = Math.ceil(e / 127 * 5) / 5;
                const r = [];
                for(e = 0; e < t1; e++)s1 = e / 127, r[e] = .5 * (1 - Math.cos(Math.PI * s1));
                const a = [];
                for(e = 0; e < t1; e++){
                    s1 = e / 127;
                    const t1 = 4 * Math.pow(s1, 3) + .2, n = Math.cos(t1 * Math.PI * 2 * s1);
                    a[e] = Math.abs(n * (1 - s1));
                }
                function c(t1) {
                    const e = new Array(t1.length);
                    for(let s1 = 0; s1 < t1.length; s1++)e[s1] = 1 - t1[s1];
                    return e;
                }
                var h;
                return {
                    bounce: {
                        In: c(a),
                        Out: a
                    },
                    cosine: {
                        In: n,
                        Out: (h = n, h.slice(0).reverse())
                    },
                    exponential: "exponential",
                    linear: "linear",
                    ripple: {
                        In: i,
                        Out: c(i)
                    },
                    sine: {
                        In: r,
                        Out: c(r)
                    },
                    step: {
                        In: o,
                        Out: c(o)
                    }
                };
            })();
            class br extends io {
                constructor(){
                    super(ui(br.getDefaults(), arguments)), this._scheduledEvents = [], this._synced = !1, this._original_triggerAttack = this.triggerAttack, this._original_triggerRelease = this.triggerRelease, this._syncedRelease = (t1)=>this._original_triggerRelease(t1);
                    const t1 = ui(br.getDefaults(), arguments);
                    this._volume = this.output = new Oo({
                        context: this.context,
                        volume: t1.volume
                    }), this.volume = this._volume.volume, Oi(this, "volume");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        volume: 0
                    });
                }
                sync() {
                    return this._syncState() && (this._syncMethod("triggerAttack", 1), this._syncMethod("triggerRelease", 0), this.context.transport.on("stop", this._syncedRelease), this.context.transport.on("pause", this._syncedRelease), this.context.transport.on("loopEnd", this._syncedRelease)), this;
                }
                _syncState() {
                    let t1 = !1;
                    return this._synced || (this._synced = !0, t1 = !0), t1;
                }
                _syncMethod(t1, e) {
                    const s1 = this["_original_" + t1] = this[t1];
                    this[t1] = (...t1)=>{
                        const n = t1[e], i = this.context.transport.schedule((n)=>{
                            t1[e] = n, s1.apply(this, t1);
                        }, n);
                        this._scheduledEvents.push(i);
                    };
                }
                unsync() {
                    return this._scheduledEvents.forEach((t1)=>this.context.transport.clear(t1)), this._scheduledEvents = [], this._synced && (this._synced = !1, this.triggerAttack = this._original_triggerAttack, this.triggerRelease = this._original_triggerRelease, this.context.transport.off("stop", this._syncedRelease), this.context.transport.off("pause", this._syncedRelease), this.context.transport.off("loopEnd", this._syncedRelease)), this;
                }
                triggerAttackRelease(t1, e, s1, n) {
                    const i = this.toSeconds(s1), o = this.toSeconds(e);
                    return this.triggerAttack(t1, i, n), this.triggerRelease(i + o), this;
                }
                dispose() {
                    return super.dispose(), this._volume.dispose(), this.unsync(), this._scheduledEvents = [], this;
                }
            }
            class Tr extends br {
                constructor(){
                    super(ui(Tr.getDefaults(), arguments));
                    const t1 = ui(Tr.getDefaults(), arguments);
                    this.portamento = t1.portamento, this.onsilence = t1.onsilence;
                }
                static getDefaults() {
                    return Object.assign(br.getDefaults(), {
                        detune: 0,
                        onsilence: Ei,
                        portamento: 0
                    });
                }
                triggerAttack(t1, e, s1 = 1) {
                    this.log("triggerAttack", t1, e, s1);
                    const n = this.toSeconds(e);
                    return this._triggerEnvelopeAttack(n, s1), this.setNote(t1, n), this;
                }
                triggerRelease(t1) {
                    this.log("triggerRelease", t1);
                    const e = this.toSeconds(t1);
                    return this._triggerEnvelopeRelease(e), this;
                }
                setNote(t1, e) {
                    const s1 = this.toSeconds(e), n = t1 instanceof Yi ? t1.toFrequency() : t1;
                    if (this.portamento > 0 && this.getLevelAtTime(s1) > .05) {
                        const t1 = this.toSeconds(this.portamento);
                        this.frequency.exponentialRampTo(n, t1, s1);
                    } else this.frequency.setValueAtTime(n, s1);
                    return this;
                }
            }
            si([
                cr(0)
            ], Tr.prototype, "portamento", void 0);
            class Sr extends xr {
                constructor(){
                    super(ui(Sr.getDefaults(), arguments, [
                        "attack",
                        "decay",
                        "sustain",
                        "release"
                    ])), this.name = "AmplitudeEnvelope", this._gainNode = new ho({
                        context: this.context,
                        gain: 0
                    }), this.output = this._gainNode, this.input = this._gainNode, this._sig.connect(this._gainNode.gain), this.output = this._gainNode, this.input = this._gainNode;
                }
                dispose() {
                    return super.dispose(), this._gainNode.dispose(), this;
                }
            }
            class kr extends Tr {
                constructor(){
                    super(ui(kr.getDefaults(), arguments)), this.name = "Synth";
                    const t1 = ui(kr.getDefaults(), arguments);
                    this.oscillator = new sr(Object.assign({
                        context: this.context,
                        detune: t1.detune,
                        onstop: ()=>this.onsilence(this)
                    }, t1.oscillator)), this.frequency = this.oscillator.frequency, this.detune = this.oscillator.detune, this.envelope = new Sr(Object.assign({
                        context: this.context
                    }, t1.envelope)), this.oscillator.chain(this.envelope, this.output), Oi(this, [
                        "oscillator",
                        "frequency",
                        "detune",
                        "envelope"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Tr.getDefaults(), {
                        envelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .005,
                            decay: .1,
                            release: 1,
                            sustain: .3
                        }),
                        oscillator: Object.assign(di(sr.getDefaults(), [
                            ...Object.keys(Po.getDefaults()),
                            "frequency",
                            "detune"
                        ]), {
                            type: "triangle"
                        })
                    });
                }
                _triggerEnvelopeAttack(t1, e) {
                    if (this.envelope.triggerAttack(t1, e), this.oscillator.start(t1), 0 === this.envelope.sustain) {
                        const e = this.toSeconds(this.envelope.attack), s1 = this.toSeconds(this.envelope.decay);
                        this.oscillator.stop(t1 + e + s1);
                    }
                }
                _triggerEnvelopeRelease(t1) {
                    this.envelope.triggerRelease(t1), this.oscillator.stop(t1 + this.toSeconds(this.envelope.release));
                }
                getLevelAtTime(t1) {
                    return t1 = this.toSeconds(t1), this.envelope.getValueAtTime(t1);
                }
                dispose() {
                    return super.dispose(), this.oscillator.dispose(), this.envelope.dispose(), this;
                }
            }
            class Ar extends Tr {
                constructor(){
                    super(ui(Ar.getDefaults(), arguments)), this.name = "ModulationSynth";
                    const t1 = ui(Ar.getDefaults(), arguments);
                    this._carrier = new kr({
                        context: this.context,
                        oscillator: t1.oscillator,
                        envelope: t1.envelope,
                        onsilence: ()=>this.onsilence(this),
                        volume: -10
                    }), this._modulator = new kr({
                        context: this.context,
                        oscillator: t1.modulation,
                        envelope: t1.modulationEnvelope,
                        volume: -10
                    }), this.oscillator = this._carrier.oscillator, this.envelope = this._carrier.envelope, this.modulation = this._modulator.oscillator, this.modulationEnvelope = this._modulator.envelope, this.frequency = new po({
                        context: this.context,
                        units: "frequency"
                    }), this.detune = new po({
                        context: this.context,
                        value: t1.detune,
                        units: "cents"
                    }), this.harmonicity = new Yo({
                        context: this.context,
                        value: t1.harmonicity,
                        minValue: 0
                    }), this._modulationNode = new ho({
                        context: this.context,
                        gain: 0
                    }), Oi(this, [
                        "frequency",
                        "harmonicity",
                        "oscillator",
                        "envelope",
                        "modulation",
                        "modulationEnvelope",
                        "detune"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Tr.getDefaults(), {
                        harmonicity: 3,
                        oscillator: Object.assign(di(sr.getDefaults(), [
                            ...Object.keys(Po.getDefaults()),
                            "frequency",
                            "detune"
                        ]), {
                            type: "sine"
                        }),
                        envelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .01,
                            decay: .01,
                            sustain: 1,
                            release: .5
                        }),
                        modulation: Object.assign(di(sr.getDefaults(), [
                            ...Object.keys(Po.getDefaults()),
                            "frequency",
                            "detune"
                        ]), {
                            type: "square"
                        }),
                        modulationEnvelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .5,
                            decay: 0,
                            sustain: 1,
                            release: .5
                        })
                    });
                }
                _triggerEnvelopeAttack(t1, e) {
                    this._carrier._triggerEnvelopeAttack(t1, e), this._modulator._triggerEnvelopeAttack(t1, e);
                }
                _triggerEnvelopeRelease(t1) {
                    return this._carrier._triggerEnvelopeRelease(t1), this._modulator._triggerEnvelopeRelease(t1), this;
                }
                getLevelAtTime(t1) {
                    return t1 = this.toSeconds(t1), this.envelope.getValueAtTime(t1);
                }
                dispose() {
                    return super.dispose(), this._carrier.dispose(), this._modulator.dispose(), this.frequency.dispose(), this.detune.dispose(), this.harmonicity.dispose(), this._modulationNode.dispose(), this;
                }
            }
            class Cr extends Ar {
                constructor(){
                    super(ui(Cr.getDefaults(), arguments)), this.name = "AMSynth", this._modulationScale = new Xo({
                        context: this.context
                    }), this.frequency.connect(this._carrier.frequency), this.frequency.chain(this.harmonicity, this._modulator.frequency), this.detune.fan(this._carrier.detune, this._modulator.detune), this._modulator.chain(this._modulationScale, this._modulationNode.gain), this._carrier.chain(this._modulationNode, this.output);
                }
                dispose() {
                    return super.dispose(), this._modulationScale.dispose(), this;
                }
            }
            class Dr extends io {
                constructor(){
                    super(ui(Dr.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ])), this.name = "BiquadFilter";
                    const t1 = ui(Dr.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ]);
                    this._filter = this.context.createBiquadFilter(), this.input = this.output = this._filter, this.Q = new no({
                        context: this.context,
                        units: "number",
                        value: t1.Q,
                        param: this._filter.Q
                    }), this.frequency = new no({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency,
                        param: this._filter.frequency
                    }), this.detune = new no({
                        context: this.context,
                        units: "cents",
                        value: t1.detune,
                        param: this._filter.detune
                    }), this.gain = new no({
                        context: this.context,
                        units: "decibels",
                        convert: !1,
                        value: t1.gain,
                        param: this._filter.gain
                    }), this.type = t1.type;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        Q: 1,
                        type: "lowpass",
                        frequency: 350,
                        detune: 0,
                        gain: 0
                    });
                }
                get type() {
                    return this._filter.type;
                }
                set type(t1) {
                    Bn(-1 !== [
                        "lowpass",
                        "highpass",
                        "bandpass",
                        "lowshelf",
                        "highshelf",
                        "notch",
                        "allpass",
                        "peaking"
                    ].indexOf(t1), `Invalid filter type: ${t1}`), this._filter.type = t1;
                }
                getFrequencyResponse(t1 = 128) {
                    const e = new Float32Array(t1);
                    for(let s1 = 0; s1 < t1; s1++){
                        const n = 19980 * Math.pow(s1 / t1, 2) + 20;
                        e[s1] = n;
                    }
                    const s1 = new Float32Array(t1), n = new Float32Array(t1), i = this.context.createBiquadFilter();
                    return i.type = this.type, i.Q.value = this.Q.value, i.frequency.value = this.frequency.value, i.gain.value = this.gain.value, i.getFrequencyResponse(e, s1, n), s1;
                }
                dispose() {
                    return super.dispose(), this._filter.disconnect(), this.Q.dispose(), this.frequency.dispose(), this.gain.dispose(), this.detune.dispose(), this;
                }
            }
            class Or extends io {
                constructor(){
                    super(ui(Or.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "rolloff"
                    ])), this.name = "Filter", this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this._filters = [];
                    const t1 = ui(Or.getDefaults(), arguments, [
                        "frequency",
                        "type",
                        "rolloff"
                    ]);
                    this._filters = [], this.Q = new po({
                        context: this.context,
                        units: "positive",
                        value: t1.Q
                    }), this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency
                    }), this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), this.gain = new po({
                        context: this.context,
                        units: "decibels",
                        convert: !1,
                        value: t1.gain
                    }), this._type = t1.type, this.rolloff = t1.rolloff, Oi(this, [
                        "detune",
                        "frequency",
                        "gain",
                        "Q"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        Q: 1,
                        detune: 0,
                        frequency: 350,
                        gain: 0,
                        rolloff: -12,
                        type: "lowpass"
                    });
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    Bn(-1 !== [
                        "lowpass",
                        "highpass",
                        "bandpass",
                        "lowshelf",
                        "highshelf",
                        "notch",
                        "allpass",
                        "peaking"
                    ].indexOf(t1), `Invalid filter type: ${t1}`), this._type = t1, this._filters.forEach((e)=>e.type = t1);
                }
                get rolloff() {
                    return this._rolloff;
                }
                set rolloff(t1) {
                    const e = Nn(t1) ? t1 : parseInt(t1, 10), s1 = [
                        -12,
                        -24,
                        -48,
                        -96
                    ];
                    let n = s1.indexOf(e);
                    Bn(-1 !== n, `rolloff can only be ${s1.join(", ")}`), n += 1, this._rolloff = e, this.input.disconnect(), this._filters.forEach((t1)=>t1.disconnect()), this._filters = new Array(n);
                    for(let t1 = 0; t1 < n; t1++){
                        const e = new Dr({
                            context: this.context
                        });
                        e.type = this._type, this.frequency.connect(e.frequency), this.detune.connect(e.detune), this.Q.connect(e.Q), this.gain.connect(e.gain), this._filters[t1] = e;
                    }
                    this._internalChannels = this._filters, oo(this.input, ...this._internalChannels, this.output);
                }
                getFrequencyResponse(t1 = 128) {
                    const e = new Dr({
                        frequency: this.frequency.value,
                        gain: this.gain.value,
                        Q: this.Q.value,
                        type: this._type,
                        detune: this.detune.value
                    }), s1 = new Float32Array(t1).map(()=>1);
                    return this._filters.forEach(()=>{
                        e.getFrequencyResponse(t1).forEach((t1, e)=>s1[e] *= t1);
                    }), e.dispose(), s1;
                }
                dispose() {
                    return super.dispose(), this._filters.forEach((t1)=>{
                        t1.dispose();
                    }), Mi(this, [
                        "detune",
                        "frequency",
                        "gain",
                        "Q"
                    ]), this.frequency.dispose(), this.Q.dispose(), this.detune.dispose(), this.gain.dispose(), this;
                }
            }
            class Mr extends xr {
                constructor(){
                    super(ui(Mr.getDefaults(), arguments, [
                        "attack",
                        "decay",
                        "sustain",
                        "release"
                    ])), this.name = "FrequencyEnvelope";
                    const t1 = ui(Mr.getDefaults(), arguments, [
                        "attack",
                        "decay",
                        "sustain",
                        "release"
                    ]);
                    this._octaves = t1.octaves, this._baseFrequency = this.toFrequency(t1.baseFrequency), this._exponent = this.input = new Fo({
                        context: this.context,
                        value: t1.exponent
                    }), this._scale = this.output = new ir({
                        context: this.context,
                        min: this._baseFrequency,
                        max: this._baseFrequency * Math.pow(2, this._octaves)
                    }), this._sig.chain(this._exponent, this._scale);
                }
                static getDefaults() {
                    return Object.assign(xr.getDefaults(), {
                        baseFrequency: 200,
                        exponent: 1,
                        octaves: 4
                    });
                }
                get baseFrequency() {
                    return this._baseFrequency;
                }
                set baseFrequency(t1) {
                    const e = this.toFrequency(t1);
                    Un(e, 0), this._baseFrequency = e, this._scale.min = this._baseFrequency, this.octaves = this._octaves;
                }
                get octaves() {
                    return this._octaves;
                }
                set octaves(t1) {
                    this._octaves = t1, this._scale.max = this._baseFrequency * Math.pow(2, t1);
                }
                get exponent() {
                    return this._exponent.value;
                }
                set exponent(t1) {
                    this._exponent.value = t1;
                }
                dispose() {
                    return super.dispose(), this._exponent.dispose(), this._scale.dispose(), this;
                }
            }
            class Er extends Tr {
                constructor(){
                    super(ui(Er.getDefaults(), arguments)), this.name = "MonoSynth";
                    const t1 = ui(Er.getDefaults(), arguments);
                    this.oscillator = new sr(Object.assign(t1.oscillator, {
                        context: this.context,
                        detune: t1.detune,
                        onstop: ()=>this.onsilence(this)
                    })), this.frequency = this.oscillator.frequency, this.detune = this.oscillator.detune, this.filter = new Or(Object.assign(t1.filter, {
                        context: this.context
                    })), this.filterEnvelope = new Mr(Object.assign(t1.filterEnvelope, {
                        context: this.context
                    })), this.envelope = new Sr(Object.assign(t1.envelope, {
                        context: this.context
                    })), this.oscillator.chain(this.filter, this.envelope, this.output), this.filterEnvelope.connect(this.filter.frequency), Oi(this, [
                        "oscillator",
                        "frequency",
                        "detune",
                        "filter",
                        "filterEnvelope",
                        "envelope"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Tr.getDefaults(), {
                        envelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .005,
                            decay: .1,
                            release: 1,
                            sustain: .9
                        }),
                        filter: Object.assign(di(Or.getDefaults(), Object.keys(io.getDefaults())), {
                            Q: 1,
                            rolloff: -12,
                            type: "lowpass"
                        }),
                        filterEnvelope: Object.assign(di(Mr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .6,
                            baseFrequency: 200,
                            decay: .2,
                            exponent: 2,
                            octaves: 3,
                            release: 2,
                            sustain: .5
                        }),
                        oscillator: Object.assign(di(sr.getDefaults(), Object.keys(Po.getDefaults())), {
                            type: "sawtooth"
                        })
                    });
                }
                _triggerEnvelopeAttack(t1, e = 1) {
                    if (this.envelope.triggerAttack(t1, e), this.filterEnvelope.triggerAttack(t1), this.oscillator.start(t1), 0 === this.envelope.sustain) {
                        const e = this.toSeconds(this.envelope.attack), s1 = this.toSeconds(this.envelope.decay);
                        this.oscillator.stop(t1 + e + s1);
                    }
                }
                _triggerEnvelopeRelease(t1) {
                    this.envelope.triggerRelease(t1), this.filterEnvelope.triggerRelease(t1), this.oscillator.stop(t1 + this.toSeconds(this.envelope.release));
                }
                getLevelAtTime(t1) {
                    return t1 = this.toSeconds(t1), this.envelope.getValueAtTime(t1);
                }
                dispose() {
                    return super.dispose(), this.oscillator.dispose(), this.envelope.dispose(), this.filterEnvelope.dispose(), this.filter.dispose(), this;
                }
            }
            class Rr extends Tr {
                constructor(){
                    super(ui(Rr.getDefaults(), arguments)), this.name = "DuoSynth";
                    const t1 = ui(Rr.getDefaults(), arguments);
                    this.voice0 = new Er(Object.assign(t1.voice0, {
                        context: this.context,
                        onsilence: ()=>this.onsilence(this)
                    })), this.voice1 = new Er(Object.assign(t1.voice1, {
                        context: this.context
                    })), this.harmonicity = new Yo({
                        context: this.context,
                        units: "positive",
                        value: t1.harmonicity
                    }), this._vibrato = new rr({
                        frequency: t1.vibratoRate,
                        context: this.context,
                        min: -50,
                        max: 50
                    }), this._vibrato.start(), this.vibratoRate = this._vibrato.frequency, this._vibratoGain = new ho({
                        context: this.context,
                        units: "normalRange",
                        gain: t1.vibratoAmount
                    }), this.vibratoAmount = this._vibratoGain.gain, this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: 440
                    }), this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), this.frequency.connect(this.voice0.frequency), this.frequency.chain(this.harmonicity, this.voice1.frequency), this._vibrato.connect(this._vibratoGain), this._vibratoGain.fan(this.voice0.detune, this.voice1.detune), this.detune.fan(this.voice0.detune, this.voice1.detune), this.voice0.connect(this.output), this.voice1.connect(this.output), Oi(this, [
                        "voice0",
                        "voice1",
                        "frequency",
                        "vibratoAmount",
                        "vibratoRate"
                    ]);
                }
                getLevelAtTime(t1) {
                    return t1 = this.toSeconds(t1), this.voice0.envelope.getValueAtTime(t1) + this.voice1.envelope.getValueAtTime(t1);
                }
                static getDefaults() {
                    return li(Tr.getDefaults(), {
                        vibratoAmount: .5,
                        vibratoRate: 5,
                        harmonicity: 1.5,
                        voice0: li(di(Er.getDefaults(), Object.keys(Tr.getDefaults())), {
                            filterEnvelope: {
                                attack: .01,
                                decay: 0,
                                sustain: 1,
                                release: .5
                            },
                            envelope: {
                                attack: .01,
                                decay: 0,
                                sustain: 1,
                                release: .5
                            }
                        }),
                        voice1: li(di(Er.getDefaults(), Object.keys(Tr.getDefaults())), {
                            filterEnvelope: {
                                attack: .01,
                                decay: 0,
                                sustain: 1,
                                release: .5
                            },
                            envelope: {
                                attack: .01,
                                decay: 0,
                                sustain: 1,
                                release: .5
                            }
                        })
                    });
                }
                _triggerEnvelopeAttack(t1, e) {
                    this.voice0._triggerEnvelopeAttack(t1, e), this.voice1._triggerEnvelopeAttack(t1, e);
                }
                _triggerEnvelopeRelease(t1) {
                    return this.voice0._triggerEnvelopeRelease(t1), this.voice1._triggerEnvelopeRelease(t1), this;
                }
                dispose() {
                    return super.dispose(), this.voice0.dispose(), this.voice1.dispose(), this.frequency.dispose(), this.detune.dispose(), this._vibrato.dispose(), this.vibratoRate.dispose(), this._vibratoGain.dispose(), this.harmonicity.dispose(), this;
                }
            }
            class qr extends Ar {
                constructor(){
                    super(ui(qr.getDefaults(), arguments)), this.name = "FMSynth";
                    const t1 = ui(qr.getDefaults(), arguments);
                    this.modulationIndex = new Yo({
                        context: this.context,
                        value: t1.modulationIndex
                    }), this.frequency.connect(this._carrier.frequency), this.frequency.chain(this.harmonicity, this._modulator.frequency), this.frequency.chain(this.modulationIndex, this._modulationNode), this.detune.fan(this._carrier.detune, this._modulator.detune), this._modulator.connect(this._modulationNode.gain), this._modulationNode.connect(this._carrier.frequency), this._carrier.connect(this.output);
                }
                static getDefaults() {
                    return Object.assign(Ar.getDefaults(), {
                        modulationIndex: 10
                    });
                }
                dispose() {
                    return super.dispose(), this.modulationIndex.dispose(), this;
                }
            }
            const Fr = [
                1,
                1.483,
                1.932,
                2.546,
                2.63,
                3.897
            ];
            class Ir extends Tr {
                constructor(){
                    super(ui(Ir.getDefaults(), arguments)), this.name = "MetalSynth", this._oscillators = [], this._freqMultipliers = [];
                    const t1 = ui(Ir.getDefaults(), arguments);
                    this.detune = new po({
                        context: this.context,
                        units: "cents",
                        value: t1.detune
                    }), this.frequency = new po({
                        context: this.context,
                        units: "frequency"
                    }), this._amplitude = new ho({
                        context: this.context,
                        gain: 0
                    }).connect(this.output), this._highpass = new Or({
                        Q: 0,
                        context: this.context,
                        type: "highpass"
                    }).connect(this._amplitude);
                    for(let e = 0; e < Fr.length; e++){
                        const s1 = new Ho({
                            context: this.context,
                            harmonicity: t1.harmonicity,
                            modulationIndex: t1.modulationIndex,
                            modulationType: "square",
                            onstop: 0 === e ? ()=>this.onsilence(this) : Ei,
                            type: "square"
                        });
                        s1.connect(this._highpass), this._oscillators[e] = s1;
                        const n = new Yo({
                            context: this.context,
                            value: Fr[e]
                        });
                        this._freqMultipliers[e] = n, this.frequency.chain(n, s1.frequency), this.detune.connect(s1.detune);
                    }
                    this._filterFreqScaler = new ir({
                        context: this.context,
                        max: 7e3,
                        min: this.toFrequency(t1.resonance)
                    }), this.envelope = new xr({
                        attack: t1.envelope.attack,
                        attackCurve: "linear",
                        context: this.context,
                        decay: t1.envelope.decay,
                        release: t1.envelope.release,
                        sustain: 0
                    }), this.envelope.chain(this._filterFreqScaler, this._highpass.frequency), this.envelope.connect(this._amplitude.gain), this._octaves = t1.octaves, this.octaves = t1.octaves;
                }
                static getDefaults() {
                    return li(Tr.getDefaults(), {
                        envelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            attack: .001,
                            decay: 1.4,
                            release: .2
                        }),
                        harmonicity: 5.1,
                        modulationIndex: 32,
                        octaves: 1.5,
                        resonance: 4e3
                    });
                }
                _triggerEnvelopeAttack(t1, e = 1) {
                    return this.envelope.triggerAttack(t1, e), this._oscillators.forEach((e)=>e.start(t1)), 0 === this.envelope.sustain && this._oscillators.forEach((e)=>{
                        e.stop(t1 + this.toSeconds(this.envelope.attack) + this.toSeconds(this.envelope.decay));
                    }), this;
                }
                _triggerEnvelopeRelease(t1) {
                    return this.envelope.triggerRelease(t1), this._oscillators.forEach((e)=>e.stop(t1 + this.toSeconds(this.envelope.release))), this;
                }
                getLevelAtTime(t1) {
                    return t1 = this.toSeconds(t1), this.envelope.getValueAtTime(t1);
                }
                get modulationIndex() {
                    return this._oscillators[0].modulationIndex.value;
                }
                set modulationIndex(t1) {
                    this._oscillators.forEach((e)=>e.modulationIndex.value = t1);
                }
                get harmonicity() {
                    return this._oscillators[0].harmonicity.value;
                }
                set harmonicity(t1) {
                    this._oscillators.forEach((e)=>e.harmonicity.value = t1);
                }
                get resonance() {
                    return this._filterFreqScaler.min;
                }
                set resonance(t1) {
                    this._filterFreqScaler.min = this.toFrequency(t1), this.octaves = this._octaves;
                }
                get octaves() {
                    return this._octaves;
                }
                set octaves(t1) {
                    this._octaves = t1, this._filterFreqScaler.max = this._filterFreqScaler.min * Math.pow(2, t1);
                }
                dispose() {
                    return super.dispose(), this._oscillators.forEach((t1)=>t1.dispose()), this._freqMultipliers.forEach((t1)=>t1.dispose()), this.frequency.dispose(), this.detune.dispose(), this._filterFreqScaler.dispose(), this._amplitude.dispose(), this.envelope.dispose(), this._highpass.dispose(), this;
                }
            }
            class Vr extends kr {
                constructor(){
                    super(ui(Vr.getDefaults(), arguments)), this.name = "MembraneSynth", this.portamento = 0;
                    const t1 = ui(Vr.getDefaults(), arguments);
                    this.pitchDecay = t1.pitchDecay, this.octaves = t1.octaves, Oi(this, [
                        "oscillator",
                        "envelope"
                    ]);
                }
                static getDefaults() {
                    return li(Tr.getDefaults(), kr.getDefaults(), {
                        envelope: {
                            attack: .001,
                            attackCurve: "exponential",
                            decay: .4,
                            release: 1.4,
                            sustain: .01
                        },
                        octaves: 10,
                        oscillator: {
                            type: "sine"
                        },
                        pitchDecay: .05
                    });
                }
                setNote(t1, e) {
                    const s1 = this.toSeconds(e), n = this.toFrequency(t1 instanceof Yi ? t1.toFrequency() : t1), i = n * this.octaves;
                    return this.oscillator.frequency.setValueAtTime(i, s1), this.oscillator.frequency.exponentialRampToValueAtTime(n, s1 + this.toSeconds(this.pitchDecay)), this;
                }
                dispose() {
                    return super.dispose(), this;
                }
            }
            si([
                ar(0)
            ], Vr.prototype, "octaves", void 0), si([
                cr(0)
            ], Vr.prototype, "pitchDecay", void 0);
            class Nr extends br {
                constructor(){
                    super(ui(Nr.getDefaults(), arguments)), this.name = "NoiseSynth";
                    const t1 = ui(Nr.getDefaults(), arguments);
                    this.noise = new Lo(Object.assign({
                        context: this.context
                    }, t1.noise)), this.envelope = new Sr(Object.assign({
                        context: this.context
                    }, t1.envelope)), this.noise.chain(this.envelope, this.output);
                }
                static getDefaults() {
                    return Object.assign(br.getDefaults(), {
                        envelope: Object.assign(di(xr.getDefaults(), Object.keys(io.getDefaults())), {
                            decay: .1,
                            sustain: 0
                        }),
                        noise: Object.assign(di(Lo.getDefaults(), Object.keys(Po.getDefaults())), {
                            type: "white"
                        })
                    });
                }
                triggerAttack(t1, e = 1) {
                    return t1 = this.toSeconds(t1), this.envelope.triggerAttack(t1, e), this.noise.start(t1), 0 === this.envelope.sustain && this.noise.stop(t1 + this.toSeconds(this.envelope.attack) + this.toSeconds(this.envelope.decay)), this;
                }
                triggerRelease(t1) {
                    return t1 = this.toSeconds(t1), this.envelope.triggerRelease(t1), this.noise.stop(t1 + this.toSeconds(this.envelope.release)), this;
                }
                sync() {
                    return this._syncState() && (this._syncMethod("triggerAttack", 0), this._syncMethod("triggerRelease", 0)), this;
                }
                triggerAttackRelease(t1, e, s1 = 1) {
                    return e = this.toSeconds(e), t1 = this.toSeconds(t1), this.triggerAttack(e, s1), this.triggerRelease(e + t1), this;
                }
                dispose() {
                    return super.dispose(), this.noise.dispose(), this.envelope.dispose(), this;
                }
            }
            const Pr = new Set;
            function jr(t1) {
                Pr.add(t1);
            }
            function Lr(t1, e) {
                const s1 = `registerProcessor("${t1}", ${e})`;
                Pr.add(s1);
            }
            class zr extends io {
                constructor(t1){
                    super(t1), this.name = "ToneAudioWorklet", this.workletOptions = {}, this.onprocessorerror = Ei;
                    const e = URL.createObjectURL(new Blob([
                        Array.from(Pr).join("\n")
                    ], {
                        type: "text/javascript"
                    })), s1 = this._audioWorkletName();
                    this._dummyGain = this.context.createGain(), this._dummyParam = this._dummyGain.gain, this.context.addAudioWorkletModule(e).then(()=>{
                        this.disposed || (this._worklet = this.context.createAudioWorkletNode(s1, this.workletOptions), this._worklet.onprocessorerror = this.onprocessorerror.bind(this), this.onReady(this._worklet));
                    });
                }
                dispose() {
                    return super.dispose(), this._dummyGain.disconnect(), this._worklet && (this._worklet.port.postMessage("dispose"), this._worklet.disconnect()), this;
                }
            }
            jr('\n\t/**\n\t * The base AudioWorkletProcessor for use in Tone.js. Works with the {@link ToneAudioWorklet}. \n\t */\n\tclass ToneAudioWorkletProcessor extends AudioWorkletProcessor {\n\n\t\tconstructor(options) {\n\t\t\t\n\t\t\tsuper(options);\n\t\t\t/**\n\t\t\t * If the processor was disposed or not. Keep alive until it\'s disposed.\n\t\t\t */\n\t\t\tthis.disposed = false;\n\t\t   \t/** \n\t\t\t * The number of samples in the processing block\n\t\t\t */\n\t\t\tthis.blockSize = 128;\n\t\t\t/**\n\t\t\t * the sample rate\n\t\t\t */\n\t\t\tthis.sampleRate = sampleRate;\n\n\t\t\tthis.port.onmessage = (event) => {\n\t\t\t\t// when it receives a dispose \n\t\t\t\tif (event.data === "dispose") {\n\t\t\t\t\tthis.disposed = true;\n\t\t\t\t}\n\t\t\t};\n\t\t}\n\t}\n'), jr("\n\t/**\n\t * Abstract class for a single input/output processor. \n\t * has a 'generate' function which processes one sample at a time\n\t */\n\tclass SingleIOProcessor extends ToneAudioWorkletProcessor {\n\n\t\tconstructor(options) {\n\t\t\tsuper(Object.assign(options, {\n\t\t\t\tnumberOfInputs: 1,\n\t\t\t\tnumberOfOutputs: 1\n\t\t\t}));\n\t\t\t/**\n\t\t\t * Holds the name of the parameter and a single value of that\n\t\t\t * parameter at the current sample\n\t\t\t * @type { [name: string]: number }\n\t\t\t */\n\t\t\tthis.params = {}\n\t\t}\n\n\t\t/**\n\t\t * Generate an output sample from the input sample and parameters\n\t\t * @abstract\n\t\t * @param input number\n\t\t * @param channel number\n\t\t * @param parameters { [name: string]: number }\n\t\t * @returns number\n\t\t */\n\t\tgenerate(){}\n\n\t\t/**\n\t\t * Update the private params object with the \n\t\t * values of the parameters at the given index\n\t\t * @param parameters { [name: string]: Float32Array },\n\t\t * @param index number\n\t\t */\n\t\tupdateParams(parameters, index) {\n\t\t\tfor (const paramName in parameters) {\n\t\t\t\tconst param = parameters[paramName];\n\t\t\t\tif (param.length > 1) {\n\t\t\t\t\tthis.params[paramName] = parameters[paramName][index];\n\t\t\t\t} else {\n\t\t\t\t\tthis.params[paramName] = parameters[paramName][0];\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/**\n\t\t * Process a single frame of the audio\n\t\t * @param inputs Float32Array[][]\n\t\t * @param outputs Float32Array[][]\n\t\t */\n\t\tprocess(inputs, outputs, parameters) {\n\t\t\tconst input = inputs[0];\n\t\t\tconst output = outputs[0];\n\t\t\t// get the parameter values\n\t\t\tconst channelCount = Math.max(input && input.length || 0, output.length);\n\t\t\tfor (let sample = 0; sample < this.blockSize; sample++) {\n\t\t\t\tthis.updateParams(parameters, sample);\n\t\t\t\tfor (let channel = 0; channel < channelCount; channel++) {\n\t\t\t\t\tconst inputSample = input && input.length ? input[channel][sample] : 0;\n\t\t\t\t\toutput[channel][sample] = this.generate(inputSample, channel, this.params);\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn !this.disposed;\n\t\t}\n\t};\n"), jr("\n\t/**\n\t * A multichannel buffer for use within an AudioWorkletProcessor as a delay line\n\t */\n\tclass DelayLine {\n\t\t\n\t\tconstructor(size, channels) {\n\t\t\tthis.buffer = [];\n\t\t\tthis.writeHead = []\n\t\t\tthis.size = size;\n\n\t\t\t// create the empty channels\n\t\t\tfor (let i = 0; i < channels; i++) {\n\t\t\t\tthis.buffer[i] = new Float32Array(this.size);\n\t\t\t\tthis.writeHead[i] = 0;\n\t\t\t}\n\t\t}\n\n\t\t/**\n\t\t * Push a value onto the end\n\t\t * @param channel number\n\t\t * @param value number\n\t\t */\n\t\tpush(channel, value) {\n\t\t\tthis.writeHead[channel] += 1;\n\t\t\tif (this.writeHead[channel] > this.size) {\n\t\t\t\tthis.writeHead[channel] = 0;\n\t\t\t}\n\t\t\tthis.buffer[channel][this.writeHead[channel]] = value;\n\t\t}\n\n\t\t/**\n\t\t * Get the recorded value of the channel given the delay\n\t\t * @param channel number\n\t\t * @param delay number delay samples\n\t\t */\n\t\tget(channel, delay) {\n\t\t\tlet readHead = this.writeHead[channel] - Math.floor(delay);\n\t\t\tif (readHead < 0) {\n\t\t\t\treadHead += this.size;\n\t\t\t}\n\t\t\treturn this.buffer[channel][readHead];\n\t\t}\n\t}\n");
            const Wr = "feedback-comb-filter";
            Lr(Wr, '\n\tclass FeedbackCombFilterWorklet extends SingleIOProcessor {\n\n\t\tconstructor(options) {\n\t\t\tsuper(options);\n\t\t\tthis.delayLine = new DelayLine(this.sampleRate, options.channelCount || 2);\n\t\t}\n\n\t\tstatic get parameterDescriptors() {\n\t\t\treturn [{\n\t\t\t\tname: "delayTime",\n\t\t\t\tdefaultValue: 0.1,\n\t\t\t\tminValue: 0,\n\t\t\t\tmaxValue: 1,\n\t\t\t\tautomationRate: "k-rate"\n\t\t\t}, {\n\t\t\t\tname: "feedback",\n\t\t\t\tdefaultValue: 0.5,\n\t\t\t\tminValue: 0,\n\t\t\t\tmaxValue: 0.9999,\n\t\t\t\tautomationRate: "k-rate"\n\t\t\t}];\n\t\t}\n\n\t\tgenerate(input, channel, parameters) {\n\t\t\tconst delayedSample = this.delayLine.get(channel, parameters.delayTime * this.sampleRate);\n\t\t\tthis.delayLine.push(channel, input + delayedSample * parameters.feedback);\n\t\t\treturn delayedSample;\n\t\t}\n\t}\n');
            class Br extends zr {
                constructor(){
                    super(ui(Br.getDefaults(), arguments, [
                        "delayTime",
                        "resonance"
                    ])), this.name = "FeedbackCombFilter";
                    const t1 = ui(Br.getDefaults(), arguments, [
                        "delayTime",
                        "resonance"
                    ]);
                    this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this.delayTime = new no({
                        context: this.context,
                        value: t1.delayTime,
                        units: "time",
                        minValue: 0,
                        maxValue: 1,
                        param: this._dummyParam,
                        swappable: !0
                    }), this.resonance = new no({
                        context: this.context,
                        value: t1.resonance,
                        units: "normalRange",
                        param: this._dummyParam,
                        swappable: !0
                    }), Oi(this, [
                        "resonance",
                        "delayTime"
                    ]);
                }
                _audioWorkletName() {
                    return Wr;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        delayTime: .1,
                        resonance: .5
                    });
                }
                onReady(t1) {
                    oo(this.input, t1, this.output);
                    const e = t1.parameters.get("delayTime");
                    this.delayTime.setParam(e);
                    const s1 = t1.parameters.get("feedback");
                    this.resonance.setParam(s1);
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this.output.dispose(), this.delayTime.dispose(), this.resonance.dispose(), this;
                }
            }
            class Ur extends io {
                constructor(){
                    super(ui(Ur.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ])), this.name = "OnePoleFilter";
                    const t1 = ui(Ur.getDefaults(), arguments, [
                        "frequency",
                        "type"
                    ]);
                    this._frequency = t1.frequency, this._type = t1.type, this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this._createFilter();
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        frequency: 880,
                        type: "lowpass"
                    });
                }
                _createFilter() {
                    const t1 = this._filter, e = this.toFrequency(this._frequency), s1 = 1 / (2 * Math.PI * e);
                    if ("lowpass" === this._type) {
                        const t1 = 1 / (s1 * this.context.sampleRate), e = t1 - 1;
                        this._filter = this.context.createIIRFilter([
                            t1,
                            0
                        ], [
                            1,
                            e
                        ]);
                    } else {
                        const t1 = 1 / (s1 * this.context.sampleRate) - 1;
                        this._filter = this.context.createIIRFilter([
                            1,
                            -1
                        ], [
                            1,
                            t1
                        ]);
                    }
                    this.input.chain(this._filter, this.output), t1 && this.context.setTimeout(()=>{
                        this.disposed || (this.input.disconnect(t1), t1.disconnect());
                    }, this.blockTime);
                }
                get frequency() {
                    return this._frequency;
                }
                set frequency(t1) {
                    this._frequency = t1, this._createFilter();
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    this._type = t1, this._createFilter();
                }
                getFrequencyResponse(t1 = 128) {
                    const e = new Float32Array(t1);
                    for(let s1 = 0; s1 < t1; s1++){
                        const n = 19980 * Math.pow(s1 / t1, 2) + 20;
                        e[s1] = n;
                    }
                    const s1 = new Float32Array(t1), n = new Float32Array(t1);
                    return this._filter.getFrequencyResponse(e, s1, n), s1;
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this.output.dispose(), this._filter.disconnect(), this;
                }
            }
            class Gr extends io {
                constructor(){
                    super(ui(Gr.getDefaults(), arguments, [
                        "delayTime",
                        "resonance",
                        "dampening"
                    ])), this.name = "LowpassCombFilter";
                    const t1 = ui(Gr.getDefaults(), arguments, [
                        "delayTime",
                        "resonance",
                        "dampening"
                    ]);
                    this._combFilter = this.output = new Br({
                        context: this.context,
                        delayTime: t1.delayTime,
                        resonance: t1.resonance
                    }), this.delayTime = this._combFilter.delayTime, this.resonance = this._combFilter.resonance, this._lowpass = this.input = new Ur({
                        context: this.context,
                        frequency: t1.dampening,
                        type: "lowpass"
                    }), this._lowpass.connect(this._combFilter);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        dampening: 3e3,
                        delayTime: .1,
                        resonance: .5
                    });
                }
                get dampening() {
                    return this._lowpass.frequency;
                }
                set dampening(t1) {
                    this._lowpass.frequency = t1;
                }
                dispose() {
                    return super.dispose(), this._combFilter.dispose(), this._lowpass.dispose(), this;
                }
            }
            class Qr extends br {
                constructor(){
                    super(ui(Qr.getDefaults(), arguments)), this.name = "PluckSynth";
                    const t1 = ui(Qr.getDefaults(), arguments);
                    this._noise = new Lo({
                        context: this.context,
                        type: "pink"
                    }), this.attackNoise = t1.attackNoise, this._lfcf = new Gr({
                        context: this.context,
                        dampening: t1.dampening,
                        resonance: t1.resonance
                    }), this.resonance = t1.resonance, this.release = t1.release, this._noise.connect(this._lfcf), this._lfcf.connect(this.output);
                }
                static getDefaults() {
                    return li(br.getDefaults(), {
                        attackNoise: 1,
                        dampening: 4e3,
                        resonance: .7,
                        release: 1
                    });
                }
                get dampening() {
                    return this._lfcf.dampening;
                }
                set dampening(t1) {
                    this._lfcf.dampening = t1;
                }
                triggerAttack(t1, e) {
                    const s1 = this.toFrequency(t1);
                    e = this.toSeconds(e);
                    const n = 1 / s1;
                    return this._lfcf.delayTime.setValueAtTime(n, e), this._noise.start(e), this._noise.stop(e + n * this.attackNoise), this._lfcf.resonance.cancelScheduledValues(e), this._lfcf.resonance.setValueAtTime(this.resonance, e), this;
                }
                triggerRelease(t1) {
                    return this._lfcf.resonance.linearRampTo(0, this.release, t1), this;
                }
                dispose() {
                    return super.dispose(), this._noise.dispose(), this._lfcf.dispose(), this;
                }
            }
            class Zr extends br {
                constructor(){
                    super(ui(Zr.getDefaults(), arguments, [
                        "voice",
                        "options"
                    ])), this.name = "PolySynth", this._availableVoices = [], this._activeVoices = [], this._voices = [], this._gcTimeout = -1, this._averageActiveVoices = 0, this._syncedRelease = (t1)=>this.releaseAll(t1);
                    const t1 = ui(Zr.getDefaults(), arguments, [
                        "voice",
                        "options"
                    ]);
                    Bn(!Nn(t1.voice), "DEPRECATED: The polyphony count is no longer the first argument.");
                    const e = t1.voice.getDefaults();
                    this.options = Object.assign(e, t1.options), this.voice = t1.voice, this.maxPolyphony = t1.maxPolyphony, this._dummyVoice = this._getNextAvailableVoice();
                    const s1 = this._voices.indexOf(this._dummyVoice);
                    this._voices.splice(s1, 1), this._gcTimeout = this.context.setInterval(this._collectGarbage.bind(this), 1);
                }
                static getDefaults() {
                    return Object.assign(br.getDefaults(), {
                        maxPolyphony: 32,
                        options: {},
                        voice: kr
                    });
                }
                get activeVoices() {
                    return this._activeVoices.length;
                }
                _makeVoiceAvailable(t1) {
                    this._availableVoices.push(t1);
                    const e = this._activeVoices.findIndex((e)=>e.voice === t1);
                    this._activeVoices.splice(e, 1);
                }
                _getNextAvailableVoice() {
                    if (this._availableVoices.length) return this._availableVoices.shift();
                    if (this._voices.length < this.maxPolyphony) {
                        const t1 = new this.voice(Object.assign(this.options, {
                            context: this.context,
                            onsilence: this._makeVoiceAvailable.bind(this)
                        }));
                        return Bn(t1 instanceof Tr, "Voice must extend Monophonic class"), t1.connect(this.output), this._voices.push(t1), t1;
                    }
                    Kn("Max polyphony exceeded. Note dropped.");
                }
                _collectGarbage() {
                    if (this._averageActiveVoices = Math.max(.95 * this._averageActiveVoices, this.activeVoices), this._availableVoices.length && this._voices.length > Math.ceil(this._averageActiveVoices + 1)) {
                        const t1 = this._availableVoices.shift(), e = this._voices.indexOf(t1);
                        this._voices.splice(e, 1), this.context.isOffline || t1.dispose();
                    }
                }
                _triggerAttack(t1, e, s1) {
                    t1.forEach((t1)=>{
                        const n = new bo(this.context, t1).toMidi(), i = this._getNextAvailableVoice();
                        i && (i.triggerAttack(t1, e, s1), this._activeVoices.push({
                            midi: n,
                            voice: i,
                            released: !1
                        }), this.log("triggerAttack", t1, e));
                    });
                }
                _triggerRelease(t1, e) {
                    t1.forEach((t1)=>{
                        const s1 = new bo(this.context, t1).toMidi(), n = this._activeVoices.find(({ midi: t1, released: e })=>t1 === s1 && !e);
                        n && (n.voice.triggerRelease(e), n.released = !0, this.log("triggerRelease", t1, e));
                    });
                }
                _scheduleEvent(t1, e, s1, n) {
                    Bn(!this.disposed, "Synth was already disposed"), s1 <= this.now() ? "attack" === t1 ? this._triggerAttack(e, s1, n) : this._triggerRelease(e, s1) : this.context.setTimeout(()=>{
                        this.disposed || this._scheduleEvent(t1, e, s1, n);
                    }, s1 - this.now());
                }
                triggerAttack(t1, e, s1) {
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    const n = this.toSeconds(e);
                    return this._scheduleEvent("attack", t1, n, s1), this;
                }
                triggerRelease(t1, e) {
                    Array.isArray(t1) || (t1 = [
                        t1
                    ]);
                    const s1 = this.toSeconds(e);
                    return this._scheduleEvent("release", t1, s1), this;
                }
                triggerAttackRelease(t1, e, s1, n) {
                    const i = this.toSeconds(s1);
                    if (this.triggerAttack(t1, i, n), Ln(e)) {
                        Bn(Ln(t1), "If the duration is an array, the notes must also be an array");
                        for(let s1 = 0; s1 < t1.length; s1++){
                            const n = e[Math.min(s1, e.length - 1)], o = this.toSeconds(n);
                            Bn(o > 0, "The duration must be greater than 0"), this.triggerRelease(t1[s1], i + o);
                        }
                    } else {
                        const s1 = this.toSeconds(e);
                        Bn(s1 > 0, "The duration must be greater than 0"), this.triggerRelease(t1, i + s1);
                    }
                    return this;
                }
                sync() {
                    return this._syncState() && (this._syncMethod("triggerAttack", 1), this._syncMethod("triggerRelease", 1), this.context.transport.on("stop", this._syncedRelease), this.context.transport.on("pause", this._syncedRelease), this.context.transport.on("loopEnd", this._syncedRelease)), this;
                }
                set(t1) {
                    const e = di(t1, [
                        "onsilence",
                        "context"
                    ]);
                    return this.options = li(this.options, e), this._voices.forEach((t1)=>t1.set(e)), this._dummyVoice.set(e), this;
                }
                get() {
                    return this._dummyVoice.get();
                }
                releaseAll(t1) {
                    const e = this.toSeconds(t1);
                    return this._activeVoices.forEach(({ voice: t1 })=>{
                        t1.triggerRelease(e);
                    }), this;
                }
                dispose() {
                    return super.dispose(), this._dummyVoice.dispose(), this._voices.forEach((t1)=>t1.dispose()), this._activeVoices = [], this._availableVoices = [], this.context.clearInterval(this._gcTimeout), this;
                }
            }
            class Xr extends br {
                constructor(){
                    super(ui(Xr.getDefaults(), arguments, [
                        "urls",
                        "onload",
                        "baseUrl"
                    ], "urls")), this.name = "Sampler", this._activeSources = new Map;
                    const t1 = ui(Xr.getDefaults(), arguments, [
                        "urls",
                        "onload",
                        "baseUrl"
                    ], "urls"), e = {};
                    Object.keys(t1.urls).forEach((s1)=>{
                        const n = parseInt(s1, 10);
                        if (Bn(Wn(s1) || Nn(n) && isFinite(n), `url key is neither a note or midi pitch: ${s1}`), Wn(s1)) {
                            const n = new Yi(this.context, s1).toMidi();
                            e[n] = t1.urls[s1];
                        } else Nn(n) && isFinite(n) && (e[n] = t1.urls[n]);
                    }), this._buffers = new wo({
                        urls: e,
                        onload: t1.onload,
                        baseUrl: t1.baseUrl,
                        onerror: t1.onerror
                    }), this.attack = t1.attack, this.release = t1.release, this.curve = t1.curve, this._buffers.loaded && Promise.resolve().then(t1.onload);
                }
                static getDefaults() {
                    return Object.assign(br.getDefaults(), {
                        attack: 0,
                        baseUrl: "",
                        curve: "exponential",
                        onload: Ei,
                        onerror: Ei,
                        release: .1,
                        urls: {}
                    });
                }
                _findClosest(t1) {
                    let e = 0;
                    for(; e < 96;){
                        if (this._buffers.has(t1 + e)) return -e;
                        if (this._buffers.has(t1 - e)) return e;
                        e++;
                    }
                    throw new Error(`No available buffers for note: ${t1}`);
                }
                triggerAttack(t1, e, s1 = 1) {
                    return this.log("triggerAttack", t1, e, s1), Array.isArray(t1) || (t1 = [
                        t1
                    ]), t1.forEach((t1)=>{
                        const n = Ui(new Yi(this.context, t1).toFrequency()), i = Math.round(n), o = n - i, r = this._findClosest(i), a = i - r, c = this._buffers.get(a), h = zi(r + o), l = new jo({
                            url: c,
                            context: this.context,
                            curve: this.curve,
                            fadeIn: this.attack,
                            fadeOut: this.release,
                            playbackRate: h
                        }).connect(this.output);
                        l.start(e, 0, c.duration / h, s1), Ln(this._activeSources.get(i)) || this._activeSources.set(i, []), this._activeSources.get(i).push(l), l.onended = ()=>{
                            if (this._activeSources && this._activeSources.has(i)) {
                                const t1 = this._activeSources.get(i), e = t1.indexOf(l);
                                -1 !== e && t1.splice(e, 1);
                            }
                        };
                    }), this;
                }
                triggerRelease(t1, e) {
                    return this.log("triggerRelease", t1, e), Array.isArray(t1) || (t1 = [
                        t1
                    ]), t1.forEach((t1)=>{
                        const s1 = new Yi(this.context, t1).toMidi();
                        if (this._activeSources.has(s1) && this._activeSources.get(s1).length) {
                            const t1 = this._activeSources.get(s1);
                            e = this.toSeconds(e), t1.forEach((t1)=>{
                                t1.stop(e);
                            }), this._activeSources.set(s1, []);
                        }
                    }), this;
                }
                releaseAll(t1) {
                    const e = this.toSeconds(t1);
                    return this._activeSources.forEach((t1)=>{
                        for(; t1.length;)t1.shift().stop(e);
                    }), this;
                }
                sync() {
                    return this._syncState() && (this._syncMethod("triggerAttack", 1), this._syncMethod("triggerRelease", 1)), this;
                }
                triggerAttackRelease(t1, e, s1, n = 1) {
                    const i = this.toSeconds(s1);
                    return this.triggerAttack(t1, i, n), Ln(e) ? (Bn(Ln(t1), "notes must be an array when duration is array"), t1.forEach((t1, s1)=>{
                        const n = e[Math.min(s1, e.length - 1)];
                        this.triggerRelease(t1, i + this.toSeconds(n));
                    })) : this.triggerRelease(t1, i + this.toSeconds(e)), this;
                }
                add(t1, e, s1) {
                    if (Bn(Wn(t1) || isFinite(t1), `note must be a pitch or midi: ${t1}`), Wn(t1)) {
                        const n = new Yi(this.context, t1).toMidi();
                        this._buffers.add(n, e, s1);
                    } else this._buffers.add(t1, e, s1);
                    return this;
                }
                get loaded() {
                    return this._buffers.loaded;
                }
                dispose() {
                    return super.dispose(), this._buffers.dispose(), this._activeSources.forEach((t1)=>{
                        t1.forEach((t1)=>t1.dispose());
                    }), this._activeSources.clear(), this;
                }
            }
            si([
                cr(0)
            ], Xr.prototype, "attack", void 0), si([
                cr(0)
            ], Xr.prototype, "release", void 0);
            class Yr extends eo {
                constructor(){
                    super(ui(Yr.getDefaults(), arguments, [
                        "callback",
                        "value"
                    ])), this.name = "ToneEvent", this._state = new so("stopped"), this._startOffset = 0;
                    const t1 = ui(Yr.getDefaults(), arguments, [
                        "callback",
                        "value"
                    ]);
                    this._loop = t1.loop, this.callback = t1.callback, this.value = t1.value, this._loopStart = this.toTicks(t1.loopStart), this._loopEnd = this.toTicks(t1.loopEnd), this._playbackRate = t1.playbackRate, this._probability = t1.probability, this._humanize = t1.humanize, this.mute = t1.mute, this._playbackRate = t1.playbackRate, this._state.increasing = !0, this._rescheduleEvents();
                }
                static getDefaults() {
                    return Object.assign(eo.getDefaults(), {
                        callback: Ei,
                        humanize: !1,
                        loop: !1,
                        loopEnd: "1m",
                        loopStart: 0,
                        mute: !1,
                        playbackRate: 1,
                        probability: 1,
                        value: null
                    });
                }
                _rescheduleEvents(t1 = -1) {
                    this._state.forEachFrom(t1, (t1)=>{
                        let e;
                        if ("started" === t1.state) {
                            -1 !== t1.id && this.context.transport.clear(t1.id);
                            const s1 = t1.time + Math.round(this.startOffset / this._playbackRate);
                            if (!0 === this._loop || Nn(this._loop) && this._loop > 1) {
                                e = 1 / 0, Nn(this._loop) && (e = this._loop * this._getLoopDuration());
                                const n = this._state.getAfter(s1);
                                null !== n && (e = Math.min(e, n.time - s1)), e !== 1 / 0 && (e = new So(this.context, e));
                                const i = new So(this.context, this._getLoopDuration());
                                t1.id = this.context.transport.scheduleRepeat(this._tick.bind(this), i, new So(this.context, s1), e);
                            } else t1.id = this.context.transport.schedule(this._tick.bind(this), new So(this.context, s1));
                        }
                    });
                }
                get state() {
                    return this._state.getValueAtTime(this.context.transport.ticks);
                }
                get startOffset() {
                    return this._startOffset;
                }
                set startOffset(t1) {
                    this._startOffset = t1;
                }
                get probability() {
                    return this._probability;
                }
                set probability(t1) {
                    this._probability = t1;
                }
                get humanize() {
                    return this._humanize;
                }
                set humanize(t1) {
                    this._humanize = t1;
                }
                start(t1) {
                    const e = this.toTicks(t1);
                    return "stopped" === this._state.getValueAtTime(e) && (this._state.add({
                        id: -1,
                        state: "started",
                        time: e
                    }), this._rescheduleEvents(e)), this;
                }
                stop(t1) {
                    this.cancel(t1);
                    const e = this.toTicks(t1);
                    if ("started" === this._state.getValueAtTime(e)) {
                        this._state.setStateAtTime("stopped", e, {
                            id: -1
                        });
                        const t1 = this._state.getBefore(e);
                        let s1 = e;
                        null !== t1 && (s1 = t1.time), this._rescheduleEvents(s1);
                    }
                    return this;
                }
                cancel(t1) {
                    t1 = pi(t1, -1 / 0);
                    const e = this.toTicks(t1);
                    return this._state.forEachFrom(e, (t1)=>{
                        this.context.transport.clear(t1.id);
                    }), this._state.cancel(e), this;
                }
                _tick(t1) {
                    const e = this.context.transport.getTicksAtTime(t1);
                    if (!this.mute && "started" === this._state.getValueAtTime(e)) {
                        if (this.probability < 1 && Math.random() > this.probability) return;
                        if (this.humanize) {
                            let e = .02;
                            jn(this.humanize) || (e = this.toSeconds(this.humanize)), t1 += (2 * Math.random() - 1) * e;
                        }
                        this.callback(t1, this.value);
                    }
                }
                _getLoopDuration() {
                    return (this._loopEnd - this._loopStart) / this._playbackRate;
                }
                get loop() {
                    return this._loop;
                }
                set loop(t1) {
                    this._loop = t1, this._rescheduleEvents();
                }
                get playbackRate() {
                    return this._playbackRate;
                }
                set playbackRate(t1) {
                    this._playbackRate = t1, this._rescheduleEvents();
                }
                get loopEnd() {
                    return new So(this.context, this._loopEnd).toSeconds();
                }
                set loopEnd(t1) {
                    this._loopEnd = this.toTicks(t1), this._loop && this._rescheduleEvents();
                }
                get loopStart() {
                    return new So(this.context, this._loopStart).toSeconds();
                }
                set loopStart(t1) {
                    this._loopStart = this.toTicks(t1), this._loop && this._rescheduleEvents();
                }
                get progress() {
                    if (this._loop) {
                        const t1 = this.context.transport.ticks, e = this._state.get(t1);
                        if (null !== e && "started" === e.state) {
                            const s1 = this._getLoopDuration();
                            return (t1 - e.time) % s1 / s1;
                        }
                        return 0;
                    }
                    return 0;
                }
                dispose() {
                    return super.dispose(), this.cancel(), this._state.dispose(), this;
                }
            }
            class $r extends eo {
                constructor(){
                    super(ui($r.getDefaults(), arguments, [
                        "callback",
                        "interval"
                    ])), this.name = "Loop";
                    const t1 = ui($r.getDefaults(), arguments, [
                        "callback",
                        "interval"
                    ]);
                    this._event = new Yr({
                        context: this.context,
                        callback: this._tick.bind(this),
                        loop: !0,
                        loopEnd: t1.interval,
                        playbackRate: t1.playbackRate,
                        probability: t1.probability,
                        humanize: t1.humanize
                    }), this.callback = t1.callback, this.iterations = t1.iterations;
                }
                static getDefaults() {
                    return Object.assign(eo.getDefaults(), {
                        interval: "4n",
                        callback: Ei,
                        playbackRate: 1,
                        iterations: 1 / 0,
                        probability: 1,
                        mute: !1,
                        humanize: !1
                    });
                }
                start(t1) {
                    return this._event.start(t1), this;
                }
                stop(t1) {
                    return this._event.stop(t1), this;
                }
                cancel(t1) {
                    return this._event.cancel(t1), this;
                }
                _tick(t1) {
                    this.callback(t1);
                }
                get state() {
                    return this._event.state;
                }
                get progress() {
                    return this._event.progress;
                }
                get interval() {
                    return this._event.loopEnd;
                }
                set interval(t1) {
                    this._event.loopEnd = t1;
                }
                get playbackRate() {
                    return this._event.playbackRate;
                }
                set playbackRate(t1) {
                    this._event.playbackRate = t1;
                }
                get humanize() {
                    return this._event.humanize;
                }
                set humanize(t1) {
                    this._event.humanize = t1;
                }
                get probability() {
                    return this._event.probability;
                }
                set probability(t1) {
                    this._event.probability = t1;
                }
                get mute() {
                    return this._event.mute;
                }
                set mute(t1) {
                    this._event.mute = t1;
                }
                get iterations() {
                    return !0 === this._event.loop ? 1 / 0 : this._event.loop;
                }
                set iterations(t1) {
                    this._event.loop = t1 === 1 / 0 || t1;
                }
                dispose() {
                    return super.dispose(), this._event.dispose(), this;
                }
            }
            class Hr extends Yr {
                constructor(){
                    super(ui(Hr.getDefaults(), arguments, [
                        "callback",
                        "events"
                    ])), this.name = "Part", this._state = new so("stopped"), this._events = new Set;
                    const t1 = ui(Hr.getDefaults(), arguments, [
                        "callback",
                        "events"
                    ]);
                    this._state.increasing = !0, t1.events.forEach((t1)=>{
                        Ln(t1) ? this.add(t1[0], t1[1]) : this.add(t1);
                    });
                }
                static getDefaults() {
                    return Object.assign(Yr.getDefaults(), {
                        events: []
                    });
                }
                start(t1, e) {
                    const s1 = this.toTicks(t1);
                    if ("started" !== this._state.getValueAtTime(s1)) {
                        e = pi(e, this._loop ? this._loopStart : 0), e = this._loop ? pi(e, this._loopStart) : pi(e, 0);
                        const t1 = this.toTicks(e);
                        this._state.add({
                            id: -1,
                            offset: t1,
                            state: "started",
                            time: s1
                        }), this._forEach((e)=>{
                            this._startNote(e, s1, t1);
                        });
                    }
                    return this;
                }
                _startNote(t1, e, s1) {
                    e -= s1, this._loop ? t1.startOffset >= this._loopStart && t1.startOffset < this._loopEnd ? (t1.startOffset < s1 && (e += this._getLoopDuration()), t1.start(new So(this.context, e))) : t1.startOffset < this._loopStart && t1.startOffset >= s1 && (t1.loop = !1, t1.start(new So(this.context, e))) : t1.startOffset >= s1 && t1.start(new So(this.context, e));
                }
                get startOffset() {
                    return this._startOffset;
                }
                set startOffset(t1) {
                    this._startOffset = t1, this._forEach((t1)=>{
                        t1.startOffset += this._startOffset;
                    });
                }
                stop(t1) {
                    const e = this.toTicks(t1);
                    return this._state.cancel(e), this._state.setStateAtTime("stopped", e), this._forEach((e)=>{
                        e.stop(t1);
                    }), this;
                }
                at(t1, e) {
                    const s1 = new Ki(this.context, t1).toTicks(), n = new So(this.context, 1).toSeconds(), i = this._events.values();
                    let o = i.next();
                    for(; !o.done;){
                        const t1 = o.value;
                        if (Math.abs(s1 - t1.startOffset) < n) return In(e) && (t1.value = e), t1;
                        o = i.next();
                    }
                    return In(e) ? (this.add(t1, e), this.at(t1)) : null;
                }
                add(t1, e) {
                    t1 instanceof Object && Reflect.has(t1, "time") && (t1 = (e = t1).time);
                    const s1 = this.toTicks(t1);
                    let n;
                    return e instanceof Yr ? (n = e, n.callback = this._tick.bind(this)) : n = new Yr({
                        callback: this._tick.bind(this),
                        context: this.context,
                        value: e
                    }), n.startOffset = s1, n.set({
                        humanize: this.humanize,
                        loop: this.loop,
                        loopEnd: this.loopEnd,
                        loopStart: this.loopStart,
                        playbackRate: this.playbackRate,
                        probability: this.probability
                    }), this._events.add(n), this._restartEvent(n), this;
                }
                _restartEvent(t1) {
                    this._state.forEach((e)=>{
                        "started" === e.state ? this._startNote(t1, e.time, e.offset) : t1.stop(new So(this.context, e.time));
                    });
                }
                remove(t1, e) {
                    return Pn(t1) && t1.hasOwnProperty("time") && (t1 = (e = t1).time), t1 = this.toTicks(t1), this._events.forEach((s1)=>{
                        s1.startOffset === t1 && (Fn(e) || In(e) && s1.value === e) && (this._events.delete(s1), s1.dispose());
                    }), this;
                }
                clear() {
                    return this._forEach((t1)=>t1.dispose()), this._events.clear(), this;
                }
                cancel(t1) {
                    return this._forEach((e)=>e.cancel(t1)), this._state.cancel(this.toTicks(t1)), this;
                }
                _forEach(t1) {
                    return this._events && this._events.forEach((e)=>{
                        e instanceof Hr ? e._forEach(t1) : t1(e);
                    }), this;
                }
                _setAll(t1, e) {
                    this._forEach((s1)=>{
                        s1[t1] = e;
                    });
                }
                _tick(t1, e) {
                    this.mute || this.callback(t1, e);
                }
                _testLoopBoundries(t1) {
                    this._loop && (t1.startOffset < this._loopStart || t1.startOffset >= this._loopEnd) ? t1.cancel(0) : "stopped" === t1.state && this._restartEvent(t1);
                }
                get probability() {
                    return this._probability;
                }
                set probability(t1) {
                    this._probability = t1, this._setAll("probability", t1);
                }
                get humanize() {
                    return this._humanize;
                }
                set humanize(t1) {
                    this._humanize = t1, this._setAll("humanize", t1);
                }
                get loop() {
                    return this._loop;
                }
                set loop(t1) {
                    this._loop = t1, this._forEach((e)=>{
                        e.loopStart = this.loopStart, e.loopEnd = this.loopEnd, e.loop = t1, this._testLoopBoundries(e);
                    });
                }
                get loopEnd() {
                    return new So(this.context, this._loopEnd).toSeconds();
                }
                set loopEnd(t1) {
                    this._loopEnd = this.toTicks(t1), this._loop && this._forEach((e)=>{
                        e.loopEnd = t1, this._testLoopBoundries(e);
                    });
                }
                get loopStart() {
                    return new So(this.context, this._loopStart).toSeconds();
                }
                set loopStart(t1) {
                    this._loopStart = this.toTicks(t1), this._loop && this._forEach((t1)=>{
                        t1.loopStart = this.loopStart, this._testLoopBoundries(t1);
                    });
                }
                get playbackRate() {
                    return this._playbackRate;
                }
                set playbackRate(t1) {
                    this._playbackRate = t1, this._setAll("playbackRate", t1);
                }
                get length() {
                    return this._events.size;
                }
                dispose() {
                    return super.dispose(), this.clear(), this;
                }
            }
            function* Jr(t1) {
                let e = 0;
                for(; e < t1;)e = xi(e, 0, t1 - 1), yield e, e++;
            }
            function* Kr(t1) {
                let e = t1 - 1;
                for(; e >= 0;)e = xi(e, 0, t1 - 1), yield e, e--;
            }
            function* ta(t1, e) {
                for(;;)yield* e(t1);
            }
            function* ea(t1, e) {
                let s1 = e ? 0 : t1 - 1;
                for(;;)s1 = xi(s1, 0, t1 - 1), yield s1, e ? (s1++, s1 >= t1 - 1 && (e = !1)) : (s1--, s1 <= 0 && (e = !0));
            }
            function* sa(t1) {
                let e = 0, s1 = 0;
                for(; e < t1;)e = xi(e, 0, t1 - 1), yield e, s1++, e += s1 % 2 ? 2 : -1;
            }
            function* na(t1) {
                let e = t1 - 1, s1 = 0;
                for(; e >= 0;)e = xi(e, 0, t1 - 1), yield e, s1++, e += s1 % 2 ? -2 : 1;
            }
            function* ia(t1) {
                const e = [];
                for(let s1 = 0; s1 < t1; s1++)e.push(s1);
                for(; e.length > 0;){
                    const s1 = xi(e.splice(Math.floor(e.length * Math.random()), 1)[0], 0, t1 - 1);
                    yield s1;
                }
            }
            function* oa(t1, e = "up", s1 = 0) {
                switch(Bn(t1 >= 1, "The number of values must be at least one"), e){
                    case "up":
                        yield* ta(t1, Jr);
                    case "down":
                        yield* ta(t1, Kr);
                    case "upDown":
                        yield* ea(t1, !0);
                    case "downUp":
                        yield* ea(t1, !1);
                    case "alternateUp":
                        yield* ta(t1, sa);
                    case "alternateDown":
                        yield* ta(t1, na);
                    case "random":
                        yield* function*(t1) {
                            for(;;){
                                const e = Math.floor(Math.random() * t1);
                                yield e;
                            }
                        }(t1);
                    case "randomOnce":
                        yield* ta(t1, ia);
                    case "randomWalk":
                        yield* function*(t1) {
                            let e = Math.floor(Math.random() * t1);
                            for(;;)0 === e ? e++ : e === t1 - 1 || Math.random() < .5 ? e-- : e++, yield e;
                        }(t1);
                }
            }
            class ra extends $r {
                constructor(){
                    super(ui(ra.getDefaults(), arguments, [
                        "callback",
                        "values",
                        "pattern"
                    ])), this.name = "Pattern";
                    const t1 = ui(ra.getDefaults(), arguments, [
                        "callback",
                        "values",
                        "pattern"
                    ]);
                    this.callback = t1.callback, this._values = t1.values, this._pattern = oa(t1.values.length, t1.pattern), this._type = t1.pattern;
                }
                static getDefaults() {
                    return Object.assign($r.getDefaults(), {
                        pattern: "up",
                        values: [],
                        callback: Ei
                    });
                }
                _tick(t1) {
                    const e = this._pattern.next();
                    this._index = e.value, this._value = this._values[e.value], this.callback(t1, this._value);
                }
                get values() {
                    return this._values;
                }
                set values(t1) {
                    this._values = t1, this.pattern = this._type;
                }
                get value() {
                    return this._value;
                }
                get index() {
                    return this._index;
                }
                get pattern() {
                    return this._type;
                }
                set pattern(t1) {
                    this._type = t1, this._pattern = oa(this._values.length, this._type);
                }
            }
            class aa extends Yr {
                constructor(){
                    super(ui(aa.getDefaults(), arguments, [
                        "callback",
                        "events",
                        "subdivision"
                    ])), this.name = "Sequence", this._part = new Hr({
                        callback: this._seqCallback.bind(this),
                        context: this.context
                    }), this._events = [], this._eventsArray = [];
                    const t1 = ui(aa.getDefaults(), arguments, [
                        "callback",
                        "events",
                        "subdivision"
                    ]);
                    this._subdivision = this.toTicks(t1.subdivision), this.events = t1.events, this.loop = t1.loop, this.loopStart = t1.loopStart, this.loopEnd = t1.loopEnd, this.playbackRate = t1.playbackRate, this.probability = t1.probability, this.humanize = t1.humanize, this.mute = t1.mute, this.playbackRate = t1.playbackRate;
                }
                static getDefaults() {
                    return Object.assign(di(Yr.getDefaults(), [
                        "value"
                    ]), {
                        events: [],
                        loop: !0,
                        loopEnd: 0,
                        loopStart: 0,
                        subdivision: "8n"
                    });
                }
                _seqCallback(t1, e) {
                    null === e || this.mute || this.callback(t1, e);
                }
                get events() {
                    return this._events;
                }
                set events(t1) {
                    this.clear(), this._eventsArray = t1, this._events = this._createSequence(this._eventsArray), this._eventsUpdated();
                }
                start(t1, e) {
                    return this._part.start(t1, e ? this._indexTime(e) : e), this;
                }
                stop(t1) {
                    return this._part.stop(t1), this;
                }
                get subdivision() {
                    return new So(this.context, this._subdivision).toSeconds();
                }
                _createSequence(t1) {
                    return new Proxy(t1, {
                        get: (t1, e)=>t1[e],
                        set: (t1, e, s1)=>(zn(e) && isFinite(parseInt(e, 10)) && Ln(s1) ? t1[e] = this._createSequence(s1) : t1[e] = s1, this._eventsUpdated(), !0)
                    });
                }
                _eventsUpdated() {
                    this._part.clear(), this._rescheduleSequence(this._eventsArray, this._subdivision, this.startOffset), this.loopEnd = this.loopEnd;
                }
                _rescheduleSequence(t1, e, s1) {
                    t1.forEach((t1, n)=>{
                        const i = n * e + s1;
                        if (Ln(t1)) this._rescheduleSequence(t1, e / t1.length, i);
                        else {
                            const e = new So(this.context, i, "i").toSeconds();
                            this._part.add(e, t1);
                        }
                    });
                }
                _indexTime(t1) {
                    return new So(this.context, t1 * this._subdivision + this.startOffset).toSeconds();
                }
                clear() {
                    return this._part.clear(), this;
                }
                dispose() {
                    return super.dispose(), this._part.dispose(), this;
                }
                get loop() {
                    return this._part.loop;
                }
                set loop(t1) {
                    this._part.loop = t1;
                }
                get loopStart() {
                    return this._loopStart;
                }
                set loopStart(t1) {
                    this._loopStart = t1, this._part.loopStart = this._indexTime(t1);
                }
                get loopEnd() {
                    return this._loopEnd;
                }
                set loopEnd(t1) {
                    this._loopEnd = t1, this._part.loopEnd = 0 === t1 ? this._indexTime(this._eventsArray.length) : this._indexTime(t1);
                }
                get startOffset() {
                    return this._part.startOffset;
                }
                set startOffset(t1) {
                    this._part.startOffset = t1;
                }
                get playbackRate() {
                    return this._part.playbackRate;
                }
                set playbackRate(t1) {
                    this._part.playbackRate = t1;
                }
                get probability() {
                    return this._part.probability;
                }
                set probability(t1) {
                    this._part.probability = t1;
                }
                get progress() {
                    return this._part.progress;
                }
                get humanize() {
                    return this._part.humanize;
                }
                set humanize(t1) {
                    this._part.humanize = t1;
                }
                get length() {
                    return this._part.length;
                }
            }
            class ca extends io {
                constructor(){
                    super(Object.assign(ui(ca.getDefaults(), arguments, [
                        "fade"
                    ]))), this.name = "CrossFade", this._panner = this.context.createStereoPanner(), this._split = this.context.createChannelSplitter(2), this._g2a = new dr({
                        context: this.context
                    }), this.a = new ho({
                        context: this.context,
                        gain: 0
                    }), this.b = new ho({
                        context: this.context,
                        gain: 0
                    }), this.output = new ho({
                        context: this.context
                    }), this._internalChannels = [
                        this.a,
                        this.b
                    ];
                    const t1 = ui(ca.getDefaults(), arguments, [
                        "fade"
                    ]);
                    this.fade = new po({
                        context: this.context,
                        units: "normalRange",
                        value: t1.fade
                    }), Oi(this, "fade"), this.context.getConstant(1).connect(this._panner), this._panner.connect(this._split), this._panner.channelCount = 1, this._panner.channelCountMode = "explicit", ro(this._split, this.a.gain, 0), ro(this._split, this.b.gain, 1), this.fade.chain(this._g2a, this._panner.pan), this.a.connect(this.output), this.b.connect(this.output);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        fade: .5
                    });
                }
                dispose() {
                    return super.dispose(), this.a.dispose(), this.b.dispose(), this.output.dispose(), this.fade.dispose(), this._g2a.dispose(), this._panner.disconnect(), this._split.disconnect(), this;
                }
            }
            class ha extends io {
                constructor(t1){
                    super(t1), this.name = "Effect", this._dryWet = new ca({
                        context: this.context
                    }), this.wet = this._dryWet.fade, this.effectSend = new ho({
                        context: this.context
                    }), this.effectReturn = new ho({
                        context: this.context
                    }), this.input = new ho({
                        context: this.context
                    }), this.output = this._dryWet, this.input.fan(this._dryWet.a, this.effectSend), this.effectReturn.connect(this._dryWet.b), this.wet.setValueAtTime(t1.wet, 0), this._internalChannels = [
                        this.effectReturn,
                        this.effectSend
                    ], Oi(this, "wet");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        wet: 1
                    });
                }
                connectEffect(t1) {
                    return this._internalChannels.push(t1), this.effectSend.chain(t1, this.effectReturn), this;
                }
                dispose() {
                    return super.dispose(), this._dryWet.dispose(), this.effectSend.dispose(), this.effectReturn.dispose(), this.wet.dispose(), this;
                }
            }
            class la extends ha {
                constructor(t1){
                    super(t1), this.name = "LFOEffect", this._lfo = new rr({
                        context: this.context,
                        frequency: t1.frequency,
                        amplitude: t1.depth
                    }), this.depth = this._lfo.amplitude, this.frequency = this._lfo.frequency, this.type = t1.type, Oi(this, [
                        "frequency",
                        "depth"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        frequency: 1,
                        type: "sine",
                        depth: 1
                    });
                }
                start(t1) {
                    return this._lfo.start(t1), this;
                }
                stop(t1) {
                    return this._lfo.stop(t1), this;
                }
                sync() {
                    return this._lfo.sync(), this;
                }
                unsync() {
                    return this._lfo.unsync(), this;
                }
                get type() {
                    return this._lfo.type;
                }
                set type(t1) {
                    this._lfo.type = t1;
                }
                dispose() {
                    return super.dispose(), this._lfo.dispose(), this.frequency.dispose(), this.depth.dispose(), this;
                }
            }
            class ua extends la {
                constructor(){
                    super(ui(ua.getDefaults(), arguments, [
                        "frequency",
                        "baseFrequency",
                        "octaves"
                    ])), this.name = "AutoFilter";
                    const t1 = ui(ua.getDefaults(), arguments, [
                        "frequency",
                        "baseFrequency",
                        "octaves"
                    ]);
                    this.filter = new Or(Object.assign(t1.filter, {
                        context: this.context
                    })), this.connectEffect(this.filter), this._lfo.connect(this.filter.frequency), this.octaves = t1.octaves, this.baseFrequency = t1.baseFrequency;
                }
                static getDefaults() {
                    return Object.assign(la.getDefaults(), {
                        baseFrequency: 200,
                        octaves: 2.6,
                        filter: {
                            type: "lowpass",
                            rolloff: -12,
                            Q: 1
                        }
                    });
                }
                get baseFrequency() {
                    return this._lfo.min;
                }
                set baseFrequency(t1) {
                    this._lfo.min = this.toFrequency(t1), this.octaves = this._octaves;
                }
                get octaves() {
                    return this._octaves;
                }
                set octaves(t1) {
                    this._octaves = t1, this._lfo.max = this._lfo.min * Math.pow(2, t1);
                }
                dispose() {
                    return super.dispose(), this.filter.dispose(), this;
                }
            }
            class pa extends io {
                constructor(){
                    super(Object.assign(ui(pa.getDefaults(), arguments, [
                        "pan"
                    ]))), this.name = "Panner", this._panner = this.context.createStereoPanner(), this.input = this._panner, this.output = this._panner;
                    const t1 = ui(pa.getDefaults(), arguments, [
                        "pan"
                    ]);
                    this.pan = new no({
                        context: this.context,
                        param: this._panner.pan,
                        value: t1.pan,
                        minValue: -1,
                        maxValue: 1
                    }), this._panner.channelCount = t1.channelCount, this._panner.channelCountMode = "explicit", Oi(this, "pan");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        pan: 0,
                        channelCount: 1
                    });
                }
                dispose() {
                    return super.dispose(), this._panner.disconnect(), this.pan.dispose(), this;
                }
            }
            class da extends la {
                constructor(){
                    super(ui(da.getDefaults(), arguments, [
                        "frequency"
                    ])), this.name = "AutoPanner";
                    const t1 = ui(da.getDefaults(), arguments, [
                        "frequency"
                    ]);
                    this._panner = new pa({
                        context: this.context,
                        channelCount: t1.channelCount
                    }), this.connectEffect(this._panner), this._lfo.connect(this._panner.pan), this._lfo.min = -1, this._lfo.max = 1;
                }
                static getDefaults() {
                    return Object.assign(la.getDefaults(), {
                        channelCount: 1
                    });
                }
                dispose() {
                    return super.dispose(), this._panner.dispose(), this;
                }
            }
            class fa extends io {
                constructor(){
                    super(ui(fa.getDefaults(), arguments, [
                        "smoothing"
                    ])), this.name = "Follower";
                    const t1 = ui(fa.getDefaults(), arguments, [
                        "smoothing"
                    ]);
                    this._abs = this.input = new pr({
                        context: this.context
                    }), this._lowpass = this.output = new Ur({
                        context: this.context,
                        frequency: 1 / this.toSeconds(t1.smoothing),
                        type: "lowpass"
                    }), this._abs.connect(this._lowpass), this._smoothing = t1.smoothing;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        smoothing: .05
                    });
                }
                get smoothing() {
                    return this._smoothing;
                }
                set smoothing(t1) {
                    this._smoothing = t1, this._lowpass.frequency = 1 / this.toSeconds(this.smoothing);
                }
                dispose() {
                    return super.dispose(), this._abs.dispose(), this._lowpass.dispose(), this;
                }
            }
            class _a extends ha {
                constructor(){
                    super(ui(_a.getDefaults(), arguments, [
                        "baseFrequency",
                        "octaves",
                        "sensitivity"
                    ])), this.name = "AutoWah";
                    const t1 = ui(_a.getDefaults(), arguments, [
                        "baseFrequency",
                        "octaves",
                        "sensitivity"
                    ]);
                    this._follower = new fa({
                        context: this.context,
                        smoothing: t1.follower
                    }), this._sweepRange = new vr({
                        context: this.context,
                        min: 0,
                        max: 1,
                        exponent: .5
                    }), this._baseFrequency = this.toFrequency(t1.baseFrequency), this._octaves = t1.octaves, this._inputBoost = new ho({
                        context: this.context
                    }), this._bandpass = new Or({
                        context: this.context,
                        rolloff: -48,
                        frequency: 0,
                        Q: t1.Q
                    }), this._peaking = new Or({
                        context: this.context,
                        type: "peaking"
                    }), this._peaking.gain.value = t1.gain, this.gain = this._peaking.gain, this.Q = this._bandpass.Q, this.effectSend.chain(this._inputBoost, this._follower, this._sweepRange), this._sweepRange.connect(this._bandpass.frequency), this._sweepRange.connect(this._peaking.frequency), this.effectSend.chain(this._bandpass, this._peaking, this.effectReturn), this._setSweepRange(), this.sensitivity = t1.sensitivity, Oi(this, [
                        "gain",
                        "Q"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        baseFrequency: 100,
                        octaves: 6,
                        sensitivity: 0,
                        Q: 2,
                        gain: 2,
                        follower: .2
                    });
                }
                get octaves() {
                    return this._octaves;
                }
                set octaves(t1) {
                    this._octaves = t1, this._setSweepRange();
                }
                get follower() {
                    return this._follower.smoothing;
                }
                set follower(t1) {
                    this._follower.smoothing = t1;
                }
                get baseFrequency() {
                    return this._baseFrequency;
                }
                set baseFrequency(t1) {
                    this._baseFrequency = this.toFrequency(t1), this._setSweepRange();
                }
                get sensitivity() {
                    return Li(1 / this._inputBoost.gain.value);
                }
                set sensitivity(t1) {
                    this._inputBoost.gain.value = 1 / ji(t1);
                }
                _setSweepRange() {
                    this._sweepRange.min = this._baseFrequency, this._sweepRange.max = Math.min(this._baseFrequency * Math.pow(2, this._octaves), this.context.sampleRate / 2);
                }
                dispose() {
                    return super.dispose(), this._follower.dispose(), this._sweepRange.dispose(), this._bandpass.dispose(), this._peaking.dispose(), this._inputBoost.dispose(), this;
                }
            }
            const ma = "bit-crusher";
            Lr(ma, "\n\tclass BitCrusherWorklet extends SingleIOProcessor {\n\n\t\tstatic get parameterDescriptors() {\n\t\t\treturn [{\n\t\t\t\tname: \"bits\",\n\t\t\t\tdefaultValue: 12,\n\t\t\t\tminValue: 1,\n\t\t\t\tmaxValue: 16,\n\t\t\t\tautomationRate: 'k-rate'\n\t\t\t}];\n\t\t}\n\n\t\tgenerate(input, _channel, parameters) {\n\t\t\tconst step = Math.pow(0.5, parameters.bits - 1);\n\t\t\tconst val = step * Math.floor(input / step + 0.5);\n\t\t\treturn val;\n\t\t}\n\t}\n");
            class ga extends ha {
                constructor(){
                    super(ui(ga.getDefaults(), arguments, [
                        "bits"
                    ])), this.name = "BitCrusher";
                    const t1 = ui(ga.getDefaults(), arguments, [
                        "bits"
                    ]);
                    this._bitCrusherWorklet = new va({
                        context: this.context,
                        bits: t1.bits
                    }), this.connectEffect(this._bitCrusherWorklet), this.bits = this._bitCrusherWorklet.bits;
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        bits: 4
                    });
                }
                dispose() {
                    return super.dispose(), this._bitCrusherWorklet.dispose(), this;
                }
            }
            class va extends zr {
                constructor(){
                    super(ui(va.getDefaults(), arguments)), this.name = "BitCrusherWorklet";
                    const t1 = ui(va.getDefaults(), arguments);
                    this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this.bits = new no({
                        context: this.context,
                        value: t1.bits,
                        units: "positive",
                        minValue: 1,
                        maxValue: 16,
                        param: this._dummyParam,
                        swappable: !0
                    });
                }
                static getDefaults() {
                    return Object.assign(zr.getDefaults(), {
                        bits: 12
                    });
                }
                _audioWorkletName() {
                    return ma;
                }
                onReady(t1) {
                    oo(this.input, t1, this.output);
                    const e = t1.parameters.get("bits");
                    this.bits.setParam(e);
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this.output.dispose(), this.bits.dispose(), this;
                }
            }
            class ya extends ha {
                constructor(){
                    super(ui(ya.getDefaults(), arguments, [
                        "order"
                    ])), this.name = "Chebyshev";
                    const t1 = ui(ya.getDefaults(), arguments, [
                        "order"
                    ]);
                    this._shaper = new qo({
                        context: this.context,
                        length: 4096
                    }), this._order = t1.order, this.connectEffect(this._shaper), this.order = t1.order, this.oversample = t1.oversample;
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        order: 1,
                        oversample: "none"
                    });
                }
                _getCoefficient(t1, e, s1) {
                    return s1.has(e) || (0 === e ? s1.set(e, 0) : 1 === e ? s1.set(e, t1) : s1.set(e, 2 * t1 * this._getCoefficient(t1, e - 1, s1) - this._getCoefficient(t1, e - 2, s1))), s1.get(e);
                }
                get order() {
                    return this._order;
                }
                set order(t1) {
                    Bn(Number.isInteger(t1), "'order' must be an integer"), this._order = t1, this._shaper.setMap((e)=>this._getCoefficient(e, t1, new Map));
                }
                get oversample() {
                    return this._shaper.oversample;
                }
                set oversample(t1) {
                    this._shaper.oversample = t1;
                }
                dispose() {
                    return super.dispose(), this._shaper.dispose(), this;
                }
            }
            class xa extends io {
                constructor(){
                    super(ui(xa.getDefaults(), arguments, [
                        "channels"
                    ])), this.name = "Split";
                    const t1 = ui(xa.getDefaults(), arguments, [
                        "channels"
                    ]);
                    this._splitter = this.input = this.output = this.context.createChannelSplitter(t1.channels), this._internalChannels = [
                        this._splitter
                    ];
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        channels: 2
                    });
                }
                dispose() {
                    return super.dispose(), this._splitter.disconnect(), this;
                }
            }
            class wa extends io {
                constructor(){
                    super(ui(wa.getDefaults(), arguments, [
                        "channels"
                    ])), this.name = "Merge";
                    const t1 = ui(wa.getDefaults(), arguments, [
                        "channels"
                    ]);
                    this._merger = this.output = this.input = this.context.createChannelMerger(t1.channels);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        channels: 2
                    });
                }
                dispose() {
                    return super.dispose(), this._merger.disconnect(), this;
                }
            }
            class ba extends io {
                constructor(t1){
                    super(t1), this.name = "StereoEffect", this.input = new ho({
                        context: this.context
                    }), this.input.channelCount = 2, this.input.channelCountMode = "explicit", this._dryWet = this.output = new ca({
                        context: this.context,
                        fade: t1.wet
                    }), this.wet = this._dryWet.fade, this._split = new xa({
                        context: this.context,
                        channels: 2
                    }), this._merge = new wa({
                        context: this.context,
                        channels: 2
                    }), this.input.connect(this._split), this.input.connect(this._dryWet.a), this._merge.connect(this._dryWet.b), Oi(this, [
                        "wet"
                    ]);
                }
                connectEffectLeft(...t1) {
                    this._split.connect(t1[0], 0, 0), oo(...t1), ro(t1[t1.length - 1], this._merge, 0, 0);
                }
                connectEffectRight(...t1) {
                    this._split.connect(t1[0], 1, 0), oo(...t1), ro(t1[t1.length - 1], this._merge, 0, 1);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        wet: 1
                    });
                }
                dispose() {
                    return super.dispose(), this._dryWet.dispose(), this._split.dispose(), this._merge.dispose(), this;
                }
            }
            class Ta extends ba {
                constructor(t1){
                    super(t1), this.feedback = new po({
                        context: this.context,
                        value: t1.feedback,
                        units: "normalRange"
                    }), this._feedbackL = new ho({
                        context: this.context
                    }), this._feedbackR = new ho({
                        context: this.context
                    }), this._feedbackSplit = new xa({
                        context: this.context,
                        channels: 2
                    }), this._feedbackMerge = new wa({
                        context: this.context,
                        channels: 2
                    }), this._merge.connect(this._feedbackSplit), this._feedbackMerge.connect(this._split), this._feedbackSplit.connect(this._feedbackL, 0, 0), this._feedbackL.connect(this._feedbackMerge, 0, 0), this._feedbackSplit.connect(this._feedbackR, 1, 0), this._feedbackR.connect(this._feedbackMerge, 0, 1), this.feedback.fan(this._feedbackL.gain, this._feedbackR.gain), Oi(this, [
                        "feedback"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ba.getDefaults(), {
                        feedback: .5
                    });
                }
                dispose() {
                    return super.dispose(), this.feedback.dispose(), this._feedbackL.dispose(), this._feedbackR.dispose(), this._feedbackSplit.dispose(), this._feedbackMerge.dispose(), this;
                }
            }
            class Sa extends Ta {
                constructor(){
                    super(ui(Sa.getDefaults(), arguments, [
                        "frequency",
                        "delayTime",
                        "depth"
                    ])), this.name = "Chorus";
                    const t1 = ui(Sa.getDefaults(), arguments, [
                        "frequency",
                        "delayTime",
                        "depth"
                    ]);
                    this._depth = t1.depth, this._delayTime = t1.delayTime / 1e3, this._lfoL = new rr({
                        context: this.context,
                        frequency: t1.frequency,
                        min: 0,
                        max: 1
                    }), this._lfoR = new rr({
                        context: this.context,
                        frequency: t1.frequency,
                        min: 0,
                        max: 1,
                        phase: 180
                    }), this._delayNodeL = new yo({
                        context: this.context
                    }), this._delayNodeR = new yo({
                        context: this.context
                    }), this.frequency = this._lfoL.frequency, Oi(this, [
                        "frequency"
                    ]), this._lfoL.frequency.connect(this._lfoR.frequency), this.connectEffectLeft(this._delayNodeL), this.connectEffectRight(this._delayNodeR), this._lfoL.connect(this._delayNodeL.delayTime), this._lfoR.connect(this._delayNodeR.delayTime), this.depth = this._depth, this.type = t1.type, this.spread = t1.spread;
                }
                static getDefaults() {
                    return Object.assign(Ta.getDefaults(), {
                        frequency: 1.5,
                        delayTime: 3.5,
                        depth: .7,
                        type: "sine",
                        spread: 180,
                        feedback: 0,
                        wet: .5
                    });
                }
                get depth() {
                    return this._depth;
                }
                set depth(t1) {
                    this._depth = t1;
                    const e = this._delayTime * t1;
                    this._lfoL.min = Math.max(this._delayTime - e, 0), this._lfoL.max = this._delayTime + e, this._lfoR.min = Math.max(this._delayTime - e, 0), this._lfoR.max = this._delayTime + e;
                }
                get delayTime() {
                    return 1e3 * this._delayTime;
                }
                set delayTime(t1) {
                    this._delayTime = t1 / 1e3, this.depth = this._depth;
                }
                get type() {
                    return this._lfoL.type;
                }
                set type(t1) {
                    this._lfoL.type = t1, this._lfoR.type = t1;
                }
                get spread() {
                    return this._lfoR.phase - this._lfoL.phase;
                }
                set spread(t1) {
                    this._lfoL.phase = 90 - t1 / 2, this._lfoR.phase = t1 / 2 + 90;
                }
                start(t1) {
                    return this._lfoL.start(t1), this._lfoR.start(t1), this;
                }
                stop(t1) {
                    return this._lfoL.stop(t1), this._lfoR.stop(t1), this;
                }
                sync() {
                    return this._lfoL.sync(), this._lfoR.sync(), this;
                }
                unsync() {
                    return this._lfoL.unsync(), this._lfoR.unsync(), this;
                }
                dispose() {
                    return super.dispose(), this._lfoL.dispose(), this._lfoR.dispose(), this._delayNodeL.dispose(), this._delayNodeR.dispose(), this.frequency.dispose(), this;
                }
            }
            class ka extends ha {
                constructor(){
                    super(ui(ka.getDefaults(), arguments, [
                        "distortion"
                    ])), this.name = "Distortion";
                    const t1 = ui(ka.getDefaults(), arguments, [
                        "distortion"
                    ]);
                    this._shaper = new qo({
                        context: this.context,
                        length: 4096
                    }), this._distortion = t1.distortion, this.connectEffect(this._shaper), this.distortion = t1.distortion, this.oversample = t1.oversample;
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        distortion: .4,
                        oversample: "none"
                    });
                }
                get distortion() {
                    return this._distortion;
                }
                set distortion(t1) {
                    this._distortion = t1;
                    const e = 100 * t1, s1 = Math.PI / 180;
                    this._shaper.setMap((t1)=>Math.abs(t1) < .001 ? 0 : (3 + e) * t1 * 20 * s1 / (Math.PI + e * Math.abs(t1)));
                }
                get oversample() {
                    return this._shaper.oversample;
                }
                set oversample(t1) {
                    this._shaper.oversample = t1;
                }
                dispose() {
                    return super.dispose(), this._shaper.dispose(), this;
                }
            }
            class Aa extends ha {
                constructor(t1){
                    super(t1), this.name = "FeedbackEffect", this._feedbackGain = new ho({
                        context: this.context,
                        gain: t1.feedback,
                        units: "normalRange"
                    }), this.feedback = this._feedbackGain.gain, Oi(this, "feedback"), this.effectReturn.chain(this._feedbackGain, this.effectSend);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        feedback: .125
                    });
                }
                dispose() {
                    return super.dispose(), this._feedbackGain.dispose(), this.feedback.dispose(), this;
                }
            }
            class Ca extends Aa {
                constructor(){
                    super(ui(Ca.getDefaults(), arguments, [
                        "delayTime",
                        "feedback"
                    ])), this.name = "FeedbackDelay";
                    const t1 = ui(Ca.getDefaults(), arguments, [
                        "delayTime",
                        "feedback"
                    ]);
                    this._delayNode = new yo({
                        context: this.context,
                        delayTime: t1.delayTime,
                        maxDelay: t1.maxDelay
                    }), this.delayTime = this._delayNode.delayTime, this.connectEffect(this._delayNode), Oi(this, "delayTime");
                }
                static getDefaults() {
                    return Object.assign(Aa.getDefaults(), {
                        delayTime: .25,
                        maxDelay: 1
                    });
                }
                dispose() {
                    return super.dispose(), this._delayNode.dispose(), this.delayTime.dispose(), this;
                }
            }
            class Da extends io {
                constructor(t1){
                    super(t1), this.name = "PhaseShiftAllpass", this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this.offset90 = new ho({
                        context: this.context
                    }), this._bank0 = this._createAllPassFilterBank([
                        .6923878,
                        .9360654322959,
                        .988229522686,
                        .9987488452737
                    ]), this._bank1 = this._createAllPassFilterBank([
                        .4021921162426,
                        .856171088242,
                        .9722909545651,
                        .9952884791278
                    ]), this._oneSampleDelay = this.context.createIIRFilter([
                        0,
                        1
                    ], [
                        1,
                        0
                    ]), oo(this.input, ...this._bank0, this._oneSampleDelay, this.output), oo(this.input, ...this._bank1, this.offset90);
                }
                _createAllPassFilterBank(t1) {
                    return t1.map((t1)=>{
                        const e = [
                            [
                                t1 * t1,
                                0,
                                -1
                            ],
                            [
                                1,
                                0,
                                -t1 * t1
                            ]
                        ];
                        return this.context.createIIRFilter(e[0], e[1]);
                    });
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this.output.dispose(), this.offset90.dispose(), this._bank0.forEach((t1)=>t1.disconnect()), this._bank1.forEach((t1)=>t1.disconnect()), this._oneSampleDelay.disconnect(), this;
                }
            }
            class Oa extends ha {
                constructor(){
                    super(ui(Oa.getDefaults(), arguments, [
                        "frequency"
                    ])), this.name = "FrequencyShifter";
                    const t1 = ui(Oa.getDefaults(), arguments, [
                        "frequency"
                    ]);
                    this.frequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.frequency,
                        minValue: -this.context.sampleRate / 2,
                        maxValue: this.context.sampleRate / 2
                    }), this._sine = new Qo({
                        context: this.context,
                        type: "sine"
                    }), this._cosine = new Zo({
                        context: this.context,
                        phase: -90,
                        type: "sine"
                    }), this._sineMultiply = new Yo({
                        context: this.context
                    }), this._cosineMultiply = new Yo({
                        context: this.context
                    }), this._negate = new fr({
                        context: this.context
                    }), this._add = new nr({
                        context: this.context
                    }), this._phaseShifter = new Da({
                        context: this.context
                    }), this.effectSend.connect(this._phaseShifter), this.frequency.fan(this._sine.frequency, this._cosine.frequency), this._phaseShifter.offset90.connect(this._cosineMultiply), this._cosine.connect(this._cosineMultiply.factor), this._phaseShifter.connect(this._sineMultiply), this._sine.connect(this._sineMultiply.factor), this._sineMultiply.connect(this._negate), this._cosineMultiply.connect(this._add), this._negate.connect(this._add.addend), this._add.connect(this.effectReturn);
                    const e = this.immediate();
                    this._sine.start(e), this._cosine.start(e);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        frequency: 0
                    });
                }
                dispose() {
                    return super.dispose(), this.frequency.dispose(), this._add.dispose(), this._cosine.dispose(), this._cosineMultiply.dispose(), this._negate.dispose(), this._phaseShifter.dispose(), this._sine.dispose(), this._sineMultiply.dispose(), this;
                }
            }
            const Ma = [
                1557 / 44100,
                1617 / 44100,
                1491 / 44100,
                1422 / 44100,
                1277 / 44100,
                1356 / 44100,
                1188 / 44100,
                1116 / 44100
            ], Ea = [
                225,
                556,
                441,
                341
            ];
            class Ra extends ba {
                constructor(){
                    super(ui(Ra.getDefaults(), arguments, [
                        "roomSize",
                        "dampening"
                    ])), this.name = "Freeverb", this._combFilters = [], this._allpassFiltersL = [], this._allpassFiltersR = [];
                    const t1 = ui(Ra.getDefaults(), arguments, [
                        "roomSize",
                        "dampening"
                    ]);
                    this.roomSize = new po({
                        context: this.context,
                        value: t1.roomSize,
                        units: "normalRange"
                    }), this._allpassFiltersL = Ea.map((t1)=>{
                        const e = this.context.createBiquadFilter();
                        return e.type = "allpass", e.frequency.value = t1, e;
                    }), this._allpassFiltersR = Ea.map((t1)=>{
                        const e = this.context.createBiquadFilter();
                        return e.type = "allpass", e.frequency.value = t1, e;
                    }), this._combFilters = Ma.map((e, s1)=>{
                        const n = new Gr({
                            context: this.context,
                            dampening: t1.dampening,
                            delayTime: e
                        });
                        return s1 < Ma.length / 2 ? this.connectEffectLeft(n, ...this._allpassFiltersL) : this.connectEffectRight(n, ...this._allpassFiltersR), this.roomSize.connect(n.resonance), n;
                    }), Oi(this, [
                        "roomSize"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ba.getDefaults(), {
                        roomSize: .7,
                        dampening: 3e3
                    });
                }
                get dampening() {
                    return this._combFilters[0].dampening;
                }
                set dampening(t1) {
                    this._combFilters.forEach((e)=>e.dampening = t1);
                }
                dispose() {
                    return super.dispose(), this._allpassFiltersL.forEach((t1)=>t1.disconnect()), this._allpassFiltersR.forEach((t1)=>t1.disconnect()), this._combFilters.forEach((t1)=>t1.dispose()), this.roomSize.dispose(), this;
                }
            }
            const qa = [
                .06748,
                .06404,
                .08212,
                .09004
            ], Fa = [
                .773,
                .802,
                .753,
                .733
            ], Ia = [
                347,
                113,
                37
            ];
            class Va extends ba {
                constructor(){
                    super(ui(Va.getDefaults(), arguments, [
                        "roomSize"
                    ])), this.name = "JCReverb", this._allpassFilters = [], this._feedbackCombFilters = [];
                    const t1 = ui(Va.getDefaults(), arguments, [
                        "roomSize"
                    ]);
                    this.roomSize = new po({
                        context: this.context,
                        value: t1.roomSize,
                        units: "normalRange"
                    }), this._scaleRoomSize = new ir({
                        context: this.context,
                        min: -0.733,
                        max: .197
                    }), this._allpassFilters = Ia.map((t1)=>{
                        const e = this.context.createBiquadFilter();
                        return e.type = "allpass", e.frequency.value = t1, e;
                    }), this._feedbackCombFilters = qa.map((t1, e)=>{
                        const s1 = new Br({
                            context: this.context,
                            delayTime: t1
                        });
                        return this._scaleRoomSize.connect(s1.resonance), s1.resonance.value = Fa[e], e < qa.length / 2 ? this.connectEffectLeft(...this._allpassFilters, s1) : this.connectEffectRight(...this._allpassFilters, s1), s1;
                    }), this.roomSize.connect(this._scaleRoomSize), Oi(this, [
                        "roomSize"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ba.getDefaults(), {
                        roomSize: .5
                    });
                }
                dispose() {
                    return super.dispose(), this._allpassFilters.forEach((t1)=>t1.disconnect()), this._feedbackCombFilters.forEach((t1)=>t1.dispose()), this.roomSize.dispose(), this._scaleRoomSize.dispose(), this;
                }
            }
            class Na extends Ta {
                constructor(t1){
                    super(t1), this._feedbackL.disconnect(), this._feedbackL.connect(this._feedbackMerge, 0, 1), this._feedbackR.disconnect(), this._feedbackR.connect(this._feedbackMerge, 0, 0), Oi(this, [
                        "feedback"
                    ]);
                }
            }
            class Pa extends Na {
                constructor(){
                    super(ui(Pa.getDefaults(), arguments, [
                        "delayTime",
                        "feedback"
                    ])), this.name = "PingPongDelay";
                    const t1 = ui(Pa.getDefaults(), arguments, [
                        "delayTime",
                        "feedback"
                    ]);
                    this._leftDelay = new yo({
                        context: this.context,
                        maxDelay: t1.maxDelay
                    }), this._rightDelay = new yo({
                        context: this.context,
                        maxDelay: t1.maxDelay
                    }), this._rightPreDelay = new yo({
                        context: this.context,
                        maxDelay: t1.maxDelay
                    }), this.delayTime = new po({
                        context: this.context,
                        units: "time",
                        value: t1.delayTime
                    }), this.connectEffectLeft(this._leftDelay), this.connectEffectRight(this._rightPreDelay, this._rightDelay), this.delayTime.fan(this._leftDelay.delayTime, this._rightDelay.delayTime, this._rightPreDelay.delayTime), this._feedbackL.disconnect(), this._feedbackL.connect(this._rightDelay), Oi(this, [
                        "delayTime"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(Na.getDefaults(), {
                        delayTime: .25,
                        maxDelay: 1
                    });
                }
                dispose() {
                    return super.dispose(), this._leftDelay.dispose(), this._rightDelay.dispose(), this._rightPreDelay.dispose(), this.delayTime.dispose(), this;
                }
            }
            class ja extends Aa {
                constructor(){
                    super(ui(ja.getDefaults(), arguments, [
                        "pitch"
                    ])), this.name = "PitchShift";
                    const t1 = ui(ja.getDefaults(), arguments, [
                        "pitch"
                    ]);
                    this._frequency = new po({
                        context: this.context
                    }), this._delayA = new yo({
                        maxDelay: 1,
                        context: this.context
                    }), this._lfoA = new rr({
                        context: this.context,
                        min: 0,
                        max: .1,
                        type: "sawtooth"
                    }).connect(this._delayA.delayTime), this._delayB = new yo({
                        maxDelay: 1,
                        context: this.context
                    }), this._lfoB = new rr({
                        context: this.context,
                        min: 0,
                        max: .1,
                        type: "sawtooth",
                        phase: 180
                    }).connect(this._delayB.delayTime), this._crossFade = new ca({
                        context: this.context
                    }), this._crossFadeLFO = new rr({
                        context: this.context,
                        min: 0,
                        max: 1,
                        type: "triangle",
                        phase: 90
                    }).connect(this._crossFade.fade), this._feedbackDelay = new yo({
                        delayTime: t1.delayTime,
                        context: this.context
                    }), this.delayTime = this._feedbackDelay.delayTime, Oi(this, "delayTime"), this._pitch = t1.pitch, this._windowSize = t1.windowSize, this._delayA.connect(this._crossFade.a), this._delayB.connect(this._crossFade.b), this._frequency.fan(this._lfoA.frequency, this._lfoB.frequency, this._crossFadeLFO.frequency), this.effectSend.fan(this._delayA, this._delayB), this._crossFade.chain(this._feedbackDelay, this.effectReturn);
                    const e = this.now();
                    this._lfoA.start(e), this._lfoB.start(e), this._crossFadeLFO.start(e), this.windowSize = this._windowSize;
                }
                static getDefaults() {
                    return Object.assign(Aa.getDefaults(), {
                        pitch: 0,
                        windowSize: .1,
                        delayTime: 0,
                        feedback: 0
                    });
                }
                get pitch() {
                    return this._pitch;
                }
                set pitch(t1) {
                    this._pitch = t1;
                    let e = 0;
                    t1 < 0 ? (this._lfoA.min = 0, this._lfoA.max = this._windowSize, this._lfoB.min = 0, this._lfoB.max = this._windowSize, e = zi(t1 - 1) + 1) : (this._lfoA.min = this._windowSize, this._lfoA.max = 0, this._lfoB.min = this._windowSize, this._lfoB.max = 0, e = zi(t1) - 1), this._frequency.value = e * (1.2 / this._windowSize);
                }
                get windowSize() {
                    return this._windowSize;
                }
                set windowSize(t1) {
                    this._windowSize = this.toSeconds(t1), this.pitch = this._pitch;
                }
                dispose() {
                    return super.dispose(), this._frequency.dispose(), this._delayA.dispose(), this._delayB.dispose(), this._lfoA.dispose(), this._lfoB.dispose(), this._crossFade.dispose(), this._crossFadeLFO.dispose(), this._feedbackDelay.dispose(), this;
                }
            }
            class La extends ba {
                constructor(){
                    super(ui(La.getDefaults(), arguments, [
                        "frequency",
                        "octaves",
                        "baseFrequency"
                    ])), this.name = "Phaser";
                    const t1 = ui(La.getDefaults(), arguments, [
                        "frequency",
                        "octaves",
                        "baseFrequency"
                    ]);
                    this._lfoL = new rr({
                        context: this.context,
                        frequency: t1.frequency,
                        min: 0,
                        max: 1
                    }), this._lfoR = new rr({
                        context: this.context,
                        frequency: t1.frequency,
                        min: 0,
                        max: 1,
                        phase: 180
                    }), this._baseFrequency = this.toFrequency(t1.baseFrequency), this._octaves = t1.octaves, this.Q = new po({
                        context: this.context,
                        value: t1.Q,
                        units: "positive"
                    }), this._filtersL = this._makeFilters(t1.stages, this._lfoL), this._filtersR = this._makeFilters(t1.stages, this._lfoR), this.frequency = this._lfoL.frequency, this.frequency.value = t1.frequency, this.connectEffectLeft(...this._filtersL), this.connectEffectRight(...this._filtersR), this._lfoL.frequency.connect(this._lfoR.frequency), this.baseFrequency = t1.baseFrequency, this.octaves = t1.octaves, this._lfoL.start(), this._lfoR.start(), Oi(this, [
                        "frequency",
                        "Q"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(ba.getDefaults(), {
                        frequency: .5,
                        octaves: 3,
                        stages: 10,
                        Q: 10,
                        baseFrequency: 350
                    });
                }
                _makeFilters(t1, e) {
                    const s1 = [];
                    for(let n = 0; n < t1; n++){
                        const t1 = this.context.createBiquadFilter();
                        t1.type = "allpass", this.Q.connect(t1.Q), e.connect(t1.frequency), s1.push(t1);
                    }
                    return s1;
                }
                get octaves() {
                    return this._octaves;
                }
                set octaves(t1) {
                    this._octaves = t1;
                    const e = this._baseFrequency * Math.pow(2, t1);
                    this._lfoL.max = e, this._lfoR.max = e;
                }
                get baseFrequency() {
                    return this._baseFrequency;
                }
                set baseFrequency(t1) {
                    this._baseFrequency = this.toFrequency(t1), this._lfoL.min = this._baseFrequency, this._lfoR.min = this._baseFrequency, this.octaves = this._octaves;
                }
                dispose() {
                    return super.dispose(), this.Q.dispose(), this._lfoL.dispose(), this._lfoR.dispose(), this._filtersL.forEach((t1)=>t1.disconnect()), this._filtersR.forEach((t1)=>t1.disconnect()), this.frequency.dispose(), this;
                }
            }
            class za extends ha {
                constructor(){
                    super(ui(za.getDefaults(), arguments, [
                        "decay"
                    ])), this.name = "Reverb", this._convolver = this.context.createConvolver(), this.ready = Promise.resolve();
                    const t1 = ui(za.getDefaults(), arguments, [
                        "decay"
                    ]);
                    this._decay = t1.decay, this._preDelay = t1.preDelay, this.generate(), this.connectEffect(this._convolver);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        decay: 1.5,
                        preDelay: .01
                    });
                }
                get decay() {
                    return this._decay;
                }
                set decay(t1) {
                    Un(t1 = this.toSeconds(t1), .001), this._decay = t1, this.generate();
                }
                get preDelay() {
                    return this._preDelay;
                }
                set preDelay(t1) {
                    Un(t1 = this.toSeconds(t1), 0), this._preDelay = t1, this.generate();
                }
                generate() {
                    return ni(this, void 0, void 0, function*() {
                        const t1 = this.ready, e = new qi(2, this._decay + this._preDelay, this.context.sampleRate), s1 = new Lo({
                            context: e
                        }), n = new Lo({
                            context: e
                        }), i = new wa({
                            context: e
                        });
                        s1.connect(i, 0, 0), n.connect(i, 0, 1);
                        const o = new ho({
                            context: e
                        }).toDestination();
                        i.connect(o), s1.start(0), n.start(0), o.gain.setValueAtTime(0, 0), o.gain.setValueAtTime(1, this._preDelay), o.gain.exponentialApproachValueAtTime(0, this._preDelay, this.decay);
                        const r = e.render();
                        return this.ready = r.then(Ei), yield t1, this._convolver.buffer = (yield r).get(), this;
                    });
                }
                dispose() {
                    return super.dispose(), this._convolver.disconnect(), this;
                }
            }
            class Wa extends io {
                constructor(){
                    super(ui(Wa.getDefaults(), arguments)), this.name = "MidSideSplit", this._split = this.input = new xa({
                        channels: 2,
                        context: this.context
                    }), this._midAdd = new nr({
                        context: this.context
                    }), this.mid = new Yo({
                        context: this.context,
                        value: Math.SQRT1_2
                    }), this._sideSubtract = new _r({
                        context: this.context
                    }), this.side = new Yo({
                        context: this.context,
                        value: Math.SQRT1_2
                    }), this._split.connect(this._midAdd, 0), this._split.connect(this._midAdd.addend, 1), this._split.connect(this._sideSubtract, 0), this._split.connect(this._sideSubtract.subtrahend, 1), this._midAdd.connect(this.mid), this._sideSubtract.connect(this.side);
                }
                dispose() {
                    return super.dispose(), this.mid.dispose(), this.side.dispose(), this._midAdd.dispose(), this._sideSubtract.dispose(), this._split.dispose(), this;
                }
            }
            class Ba extends io {
                constructor(){
                    super(ui(Ba.getDefaults(), arguments)), this.name = "MidSideMerge", this.mid = new ho({
                        context: this.context
                    }), this.side = new ho({
                        context: this.context
                    }), this._left = new nr({
                        context: this.context
                    }), this._leftMult = new Yo({
                        context: this.context,
                        value: Math.SQRT1_2
                    }), this._right = new _r({
                        context: this.context
                    }), this._rightMult = new Yo({
                        context: this.context,
                        value: Math.SQRT1_2
                    }), this._merge = this.output = new wa({
                        context: this.context
                    }), this.mid.fan(this._left), this.side.connect(this._left.addend), this.mid.connect(this._right), this.side.connect(this._right.subtrahend), this._left.connect(this._leftMult), this._right.connect(this._rightMult), this._leftMult.connect(this._merge, 0, 0), this._rightMult.connect(this._merge, 0, 1);
                }
                dispose() {
                    return super.dispose(), this.mid.dispose(), this.side.dispose(), this._leftMult.dispose(), this._rightMult.dispose(), this._left.dispose(), this._right.dispose(), this;
                }
            }
            class Ua extends ha {
                constructor(t1){
                    super(t1), this.name = "MidSideEffect", this._midSideMerge = new Ba({
                        context: this.context
                    }), this._midSideSplit = new Wa({
                        context: this.context
                    }), this._midSend = this._midSideSplit.mid, this._sideSend = this._midSideSplit.side, this._midReturn = this._midSideMerge.mid, this._sideReturn = this._midSideMerge.side, this.effectSend.connect(this._midSideSplit), this._midSideMerge.connect(this.effectReturn);
                }
                connectEffectMid(...t1) {
                    this._midSend.chain(...t1, this._midReturn);
                }
                connectEffectSide(...t1) {
                    this._sideSend.chain(...t1, this._sideReturn);
                }
                dispose() {
                    return super.dispose(), this._midSideSplit.dispose(), this._midSideMerge.dispose(), this._midSend.dispose(), this._sideSend.dispose(), this._midReturn.dispose(), this._sideReturn.dispose(), this;
                }
            }
            class Ga extends Ua {
                constructor(){
                    super(ui(Ga.getDefaults(), arguments, [
                        "width"
                    ])), this.name = "StereoWidener";
                    const t1 = ui(Ga.getDefaults(), arguments, [
                        "width"
                    ]);
                    this.width = new po({
                        context: this.context,
                        value: t1.width,
                        units: "normalRange"
                    }), Oi(this, [
                        "width"
                    ]), this._twoTimesWidthMid = new Yo({
                        context: this.context,
                        value: 2
                    }), this._twoTimesWidthSide = new Yo({
                        context: this.context,
                        value: 2
                    }), this._midMult = new Yo({
                        context: this.context
                    }), this._twoTimesWidthMid.connect(this._midMult.factor), this.connectEffectMid(this._midMult), this._oneMinusWidth = new _r({
                        context: this.context
                    }), this._oneMinusWidth.connect(this._twoTimesWidthMid), ro(this.context.getConstant(1), this._oneMinusWidth), this.width.connect(this._oneMinusWidth.subtrahend), this._sideMult = new Yo({
                        context: this.context
                    }), this.width.connect(this._twoTimesWidthSide), this._twoTimesWidthSide.connect(this._sideMult.factor), this.connectEffectSide(this._sideMult);
                }
                static getDefaults() {
                    return Object.assign(Ua.getDefaults(), {
                        width: .5
                    });
                }
                dispose() {
                    return super.dispose(), this.width.dispose(), this._midMult.dispose(), this._sideMult.dispose(), this._twoTimesWidthMid.dispose(), this._twoTimesWidthSide.dispose(), this._oneMinusWidth.dispose(), this;
                }
            }
            class Qa extends ba {
                constructor(){
                    super(ui(Qa.getDefaults(), arguments, [
                        "frequency",
                        "depth"
                    ])), this.name = "Tremolo";
                    const t1 = ui(Qa.getDefaults(), arguments, [
                        "frequency",
                        "depth"
                    ]);
                    this._lfoL = new rr({
                        context: this.context,
                        type: t1.type,
                        min: 1,
                        max: 0
                    }), this._lfoR = new rr({
                        context: this.context,
                        type: t1.type,
                        min: 1,
                        max: 0
                    }), this._amplitudeL = new ho({
                        context: this.context
                    }), this._amplitudeR = new ho({
                        context: this.context
                    }), this.frequency = new po({
                        context: this.context,
                        value: t1.frequency,
                        units: "frequency"
                    }), this.depth = new po({
                        context: this.context,
                        value: t1.depth,
                        units: "normalRange"
                    }), Oi(this, [
                        "frequency",
                        "depth"
                    ]), this.connectEffectLeft(this._amplitudeL), this.connectEffectRight(this._amplitudeR), this._lfoL.connect(this._amplitudeL.gain), this._lfoR.connect(this._amplitudeR.gain), this.frequency.fan(this._lfoL.frequency, this._lfoR.frequency), this.depth.fan(this._lfoR.amplitude, this._lfoL.amplitude), this.spread = t1.spread;
                }
                static getDefaults() {
                    return Object.assign(ba.getDefaults(), {
                        frequency: 10,
                        type: "sine",
                        depth: .5,
                        spread: 180
                    });
                }
                start(t1) {
                    return this._lfoL.start(t1), this._lfoR.start(t1), this;
                }
                stop(t1) {
                    return this._lfoL.stop(t1), this._lfoR.stop(t1), this;
                }
                sync() {
                    return this._lfoL.sync(), this._lfoR.sync(), this.context.transport.syncSignal(this.frequency), this;
                }
                unsync() {
                    return this._lfoL.unsync(), this._lfoR.unsync(), this.context.transport.unsyncSignal(this.frequency), this;
                }
                get type() {
                    return this._lfoL.type;
                }
                set type(t1) {
                    this._lfoL.type = t1, this._lfoR.type = t1;
                }
                get spread() {
                    return this._lfoR.phase - this._lfoL.phase;
                }
                set spread(t1) {
                    this._lfoL.phase = 90 - t1 / 2, this._lfoR.phase = t1 / 2 + 90;
                }
                dispose() {
                    return super.dispose(), this._lfoL.dispose(), this._lfoR.dispose(), this._amplitudeL.dispose(), this._amplitudeR.dispose(), this.frequency.dispose(), this.depth.dispose(), this;
                }
            }
            class Za extends ha {
                constructor(){
                    super(ui(Za.getDefaults(), arguments, [
                        "frequency",
                        "depth"
                    ])), this.name = "Vibrato";
                    const t1 = ui(Za.getDefaults(), arguments, [
                        "frequency",
                        "depth"
                    ]);
                    this._delayNode = new yo({
                        context: this.context,
                        delayTime: 0,
                        maxDelay: t1.maxDelay
                    }), this._lfo = new rr({
                        context: this.context,
                        type: t1.type,
                        min: 0,
                        max: t1.maxDelay,
                        frequency: t1.frequency,
                        phase: -90
                    }).start().connect(this._delayNode.delayTime), this.frequency = this._lfo.frequency, this.depth = this._lfo.amplitude, this.depth.value = t1.depth, Oi(this, [
                        "frequency",
                        "depth"
                    ]), this.effectSend.chain(this._delayNode, this.effectReturn);
                }
                static getDefaults() {
                    return Object.assign(ha.getDefaults(), {
                        maxDelay: .005,
                        frequency: 5,
                        depth: .1,
                        type: "sine"
                    });
                }
                get type() {
                    return this._lfo.type;
                }
                set type(t1) {
                    this._lfo.type = t1;
                }
                dispose() {
                    return super.dispose(), this._delayNode.dispose(), this._lfo.dispose(), this.frequency.dispose(), this.depth.dispose(), this;
                }
            }
            class Xa extends io {
                constructor(){
                    super(ui(Xa.getDefaults(), arguments, [
                        "type",
                        "size"
                    ])), this.name = "Analyser", this._analysers = [], this._buffers = [];
                    const t1 = ui(Xa.getDefaults(), arguments, [
                        "type",
                        "size"
                    ]);
                    this.input = this.output = this._gain = new ho({
                        context: this.context
                    }), this._split = new xa({
                        context: this.context,
                        channels: t1.channels
                    }), this.input.connect(this._split), Un(t1.channels, 1);
                    for(let e = 0; e < t1.channels; e++)this._analysers[e] = this.context.createAnalyser(), this._split.connect(this._analysers[e], e, 0);
                    this.size = t1.size, this.type = t1.type, this.smoothing = t1.smoothing;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        size: 1024,
                        smoothing: .8,
                        type: "fft",
                        channels: 1
                    });
                }
                getValue() {
                    return this._analysers.forEach((t1, e)=>{
                        const s1 = this._buffers[e];
                        "fft" === this._type ? t1.getFloatFrequencyData(s1) : "waveform" === this._type && t1.getFloatTimeDomainData(s1);
                    }), 1 === this.channels ? this._buffers[0] : this._buffers;
                }
                get size() {
                    return this._analysers[0].frequencyBinCount;
                }
                set size(t1) {
                    this._analysers.forEach((e, s1)=>{
                        e.fftSize = 2 * t1, this._buffers[s1] = new Float32Array(t1);
                    });
                }
                get channels() {
                    return this._analysers.length;
                }
                get type() {
                    return this._type;
                }
                set type(t1) {
                    Bn("waveform" === t1 || "fft" === t1, `Analyser: invalid type: ${t1}`), this._type = t1;
                }
                get smoothing() {
                    return this._analysers[0].smoothingTimeConstant;
                }
                set smoothing(t1) {
                    this._analysers.forEach((e)=>e.smoothingTimeConstant = t1);
                }
                dispose() {
                    return super.dispose(), this._analysers.forEach((t1)=>t1.disconnect()), this._split.dispose(), this._gain.dispose(), this;
                }
            }
            class Ya extends io {
                constructor(){
                    super(ui(Ya.getDefaults(), arguments)), this.name = "MeterBase", this.input = this.output = this._analyser = new Xa({
                        context: this.context,
                        size: 256,
                        type: "waveform"
                    });
                }
                dispose() {
                    return super.dispose(), this._analyser.dispose(), this;
                }
            }
            class $a extends Ya {
                constructor(){
                    super(ui($a.getDefaults(), arguments, [
                        "smoothing"
                    ])), this.name = "Meter";
                    const t1 = ui($a.getDefaults(), arguments, [
                        "smoothing"
                    ]);
                    this.input = this.output = this._analyser = new Xa({
                        context: this.context,
                        size: 256,
                        type: "waveform",
                        channels: t1.channelCount
                    }), this.smoothing = t1.smoothing, this.normalRange = t1.normalRange, this._rms = new Array(t1.channelCount), this._rms.fill(0);
                }
                static getDefaults() {
                    return Object.assign(Ya.getDefaults(), {
                        smoothing: .8,
                        normalRange: !1,
                        channelCount: 1
                    });
                }
                getLevel() {
                    return Kn("'getLevel' has been changed to 'getValue'"), this.getValue();
                }
                getValue() {
                    const t1 = this._analyser.getValue(), e = (1 === this.channels ? [
                        t1
                    ] : t1).map((t1, e)=>{
                        const s1 = t1.reduce((t1, e)=>t1 + e * e, 0), n = Math.sqrt(s1 / t1.length);
                        return this._rms[e] = Math.max(n, this._rms[e] * this.smoothing), this.normalRange ? this._rms[e] : Li(this._rms[e]);
                    });
                    return 1 === this.channels ? e[0] : e;
                }
                get channels() {
                    return this._analyser.channels;
                }
                dispose() {
                    return super.dispose(), this._analyser.dispose(), this;
                }
            }
            class Ha extends Ya {
                constructor(){
                    super(ui(Ha.getDefaults(), arguments, [
                        "size"
                    ])), this.name = "FFT";
                    const t1 = ui(Ha.getDefaults(), arguments, [
                        "size"
                    ]);
                    this.normalRange = t1.normalRange, this._analyser.type = "fft", this.size = t1.size;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        normalRange: !1,
                        size: 1024,
                        smoothing: .8
                    });
                }
                getValue() {
                    return this._analyser.getValue().map((t1)=>this.normalRange ? ji(t1) : t1);
                }
                get size() {
                    return this._analyser.size;
                }
                set size(t1) {
                    this._analyser.size = t1;
                }
                get smoothing() {
                    return this._analyser.smoothing;
                }
                set smoothing(t1) {
                    this._analyser.smoothing = t1;
                }
                getFrequencyOfIndex(t1) {
                    return Bn(0 <= t1 && t1 < this.size, `index must be greater than or equal to 0 and less than ${this.size}`), t1 * this.context.sampleRate / (2 * this.size);
                }
            }
            class Ja extends Ya {
                constructor(){
                    super(ui(Ja.getDefaults(), arguments)), this.name = "DCMeter", this._analyser.type = "waveform", this._analyser.size = 256;
                }
                getValue() {
                    return this._analyser.getValue()[0];
                }
            }
            class Ka extends Ya {
                constructor(){
                    super(ui(Ka.getDefaults(), arguments, [
                        "size"
                    ])), this.name = "Waveform";
                    const t1 = ui(Ka.getDefaults(), arguments, [
                        "size"
                    ]);
                    this._analyser.type = "waveform", this.size = t1.size;
                }
                static getDefaults() {
                    return Object.assign(Ya.getDefaults(), {
                        size: 1024
                    });
                }
                getValue() {
                    return this._analyser.getValue();
                }
                get size() {
                    return this._analyser.size;
                }
                set size(t1) {
                    this._analyser.size = t1;
                }
            }
            class tc extends io {
                constructor(){
                    super(ui(tc.getDefaults(), arguments, [
                        "solo"
                    ])), this.name = "Solo";
                    const t1 = ui(tc.getDefaults(), arguments, [
                        "solo"
                    ]);
                    this.input = this.output = new ho({
                        context: this.context
                    }), tc._allSolos.has(this.context) || tc._allSolos.set(this.context, new Set), tc._allSolos.get(this.context).add(this), this.solo = t1.solo;
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        solo: !1
                    });
                }
                get solo() {
                    return this._isSoloed();
                }
                set solo(t1) {
                    t1 ? this._addSolo() : this._removeSolo(), tc._allSolos.get(this.context).forEach((t1)=>t1._updateSolo());
                }
                get muted() {
                    return 0 === this.input.gain.value;
                }
                _addSolo() {
                    tc._soloed.has(this.context) || tc._soloed.set(this.context, new Set), tc._soloed.get(this.context).add(this);
                }
                _removeSolo() {
                    tc._soloed.has(this.context) && tc._soloed.get(this.context).delete(this);
                }
                _isSoloed() {
                    return tc._soloed.has(this.context) && tc._soloed.get(this.context).has(this);
                }
                _noSolos() {
                    return !tc._soloed.has(this.context) || tc._soloed.has(this.context) && 0 === tc._soloed.get(this.context).size;
                }
                _updateSolo() {
                    this._isSoloed() || this._noSolos() ? this.input.gain.value = 1 : this.input.gain.value = 0;
                }
                dispose() {
                    return super.dispose(), tc._allSolos.get(this.context).delete(this), this._removeSolo(), this;
                }
            }
            tc._allSolos = new Map, tc._soloed = new Map;
            class ec extends io {
                constructor(){
                    super(ui(ec.getDefaults(), arguments, [
                        "pan",
                        "volume"
                    ])), this.name = "PanVol";
                    const t1 = ui(ec.getDefaults(), arguments, [
                        "pan",
                        "volume"
                    ]);
                    this._panner = this.input = new pa({
                        context: this.context,
                        pan: t1.pan,
                        channelCount: t1.channelCount
                    }), this.pan = this._panner.pan, this._volume = this.output = new Oo({
                        context: this.context,
                        volume: t1.volume
                    }), this.volume = this._volume.volume, this._panner.connect(this._volume), this.mute = t1.mute, Oi(this, [
                        "pan",
                        "volume"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mute: !1,
                        pan: 0,
                        volume: 0,
                        channelCount: 1
                    });
                }
                get mute() {
                    return this._volume.mute;
                }
                set mute(t1) {
                    this._volume.mute = t1;
                }
                dispose() {
                    return super.dispose(), this._panner.dispose(), this.pan.dispose(), this._volume.dispose(), this.volume.dispose(), this;
                }
            }
            class sc extends io {
                constructor(){
                    super(ui(sc.getDefaults(), arguments, [
                        "volume",
                        "pan"
                    ])), this.name = "Channel";
                    const t1 = ui(sc.getDefaults(), arguments, [
                        "volume",
                        "pan"
                    ]);
                    this._solo = this.input = new tc({
                        solo: t1.solo,
                        context: this.context
                    }), this._panVol = this.output = new ec({
                        context: this.context,
                        pan: t1.pan,
                        volume: t1.volume,
                        mute: t1.mute,
                        channelCount: t1.channelCount
                    }), this.pan = this._panVol.pan, this.volume = this._panVol.volume, this._solo.connect(this._panVol), Oi(this, [
                        "pan",
                        "volume"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        pan: 0,
                        volume: 0,
                        mute: !1,
                        solo: !1,
                        channelCount: 1
                    });
                }
                get solo() {
                    return this._solo.solo;
                }
                set solo(t1) {
                    this._solo.solo = t1;
                }
                get muted() {
                    return this._solo.muted || this.mute;
                }
                get mute() {
                    return this._panVol.mute;
                }
                set mute(t1) {
                    this._panVol.mute = t1;
                }
                _getBus(t1) {
                    return sc.buses.has(t1) || sc.buses.set(t1, new ho({
                        context: this.context
                    })), sc.buses.get(t1);
                }
                send(t1, e = 0) {
                    const s1 = this._getBus(t1), n = new ho({
                        context: this.context,
                        units: "decibels",
                        gain: e
                    });
                    return this.connect(n), n.connect(s1), n;
                }
                receive(t1) {
                    return this._getBus(t1).connect(this), this;
                }
                dispose() {
                    return super.dispose(), this._panVol.dispose(), this.pan.dispose(), this.volume.dispose(), this._solo.dispose(), this;
                }
            }
            sc.buses = new Map;
            class nc extends io {
                constructor(){
                    super(ui(nc.getDefaults(), arguments)), this.name = "Mono", this.input = new ho({
                        context: this.context
                    }), this._merge = this.output = new wa({
                        channels: 2,
                        context: this.context
                    }), this.input.connect(this._merge, 0, 0), this.input.connect(this._merge, 0, 1);
                }
                dispose() {
                    return super.dispose(), this._merge.dispose(), this.input.dispose(), this;
                }
            }
            class ic extends io {
                constructor(){
                    super(ui(ic.getDefaults(), arguments, [
                        "lowFrequency",
                        "highFrequency"
                    ])), this.name = "MultibandSplit", this.input = new ho({
                        context: this.context
                    }), this.output = void 0, this.low = new Or({
                        context: this.context,
                        frequency: 0,
                        type: "lowpass"
                    }), this._lowMidFilter = new Or({
                        context: this.context,
                        frequency: 0,
                        type: "highpass"
                    }), this.mid = new Or({
                        context: this.context,
                        frequency: 0,
                        type: "lowpass"
                    }), this.high = new Or({
                        context: this.context,
                        frequency: 0,
                        type: "highpass"
                    }), this._internalChannels = [
                        this.low,
                        this.mid,
                        this.high
                    ];
                    const t1 = ui(ic.getDefaults(), arguments, [
                        "lowFrequency",
                        "highFrequency"
                    ]);
                    this.lowFrequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.lowFrequency
                    }), this.highFrequency = new po({
                        context: this.context,
                        units: "frequency",
                        value: t1.highFrequency
                    }), this.Q = new po({
                        context: this.context,
                        units: "positive",
                        value: t1.Q
                    }), this.input.fan(this.low, this.high), this.input.chain(this._lowMidFilter, this.mid), this.lowFrequency.fan(this.low.frequency, this._lowMidFilter.frequency), this.highFrequency.fan(this.mid.frequency, this.high.frequency), this.Q.connect(this.low.Q), this.Q.connect(this._lowMidFilter.Q), this.Q.connect(this.mid.Q), this.Q.connect(this.high.Q), Oi(this, [
                        "high",
                        "mid",
                        "low",
                        "highFrequency",
                        "lowFrequency"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        Q: 1,
                        highFrequency: 2500,
                        lowFrequency: 400
                    });
                }
                dispose() {
                    return super.dispose(), Mi(this, [
                        "high",
                        "mid",
                        "low",
                        "highFrequency",
                        "lowFrequency"
                    ]), this.low.dispose(), this._lowMidFilter.dispose(), this.mid.dispose(), this.high.dispose(), this.lowFrequency.dispose(), this.highFrequency.dispose(), this.Q.dispose(), this;
                }
            }
            class oc extends io {
                constructor(){
                    super(...arguments), this.name = "Listener", this.positionX = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.positionX
                    }), this.positionY = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.positionY
                    }), this.positionZ = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.positionZ
                    }), this.forwardX = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.forwardX
                    }), this.forwardY = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.forwardY
                    }), this.forwardZ = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.forwardZ
                    }), this.upX = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.upX
                    }), this.upY = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.upY
                    }), this.upZ = new no({
                        context: this.context,
                        param: this.context.rawContext.listener.upZ
                    });
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        positionX: 0,
                        positionY: 0,
                        positionZ: 0,
                        forwardX: 0,
                        forwardY: 0,
                        forwardZ: -1,
                        upX: 0,
                        upY: 1,
                        upZ: 0
                    });
                }
                dispose() {
                    return super.dispose(), this.positionX.dispose(), this.positionY.dispose(), this.positionZ.dispose(), this.forwardX.dispose(), this.forwardY.dispose(), this.forwardZ.dispose(), this.upX.dispose(), this.upY.dispose(), this.upZ.dispose(), this;
                }
            }
            Ti((t1)=>{
                t1.listener = new oc({
                    context: t1
                });
            }), ki((t1)=>{
                t1.listener.dispose();
            });
            class rc extends io {
                constructor(){
                    super(ui(rc.getDefaults(), arguments, [
                        "positionX",
                        "positionY",
                        "positionZ"
                    ])), this.name = "Panner3D";
                    const t1 = ui(rc.getDefaults(), arguments, [
                        "positionX",
                        "positionY",
                        "positionZ"
                    ]);
                    this._panner = this.input = this.output = this.context.createPanner(), this.panningModel = t1.panningModel, this.maxDistance = t1.maxDistance, this.distanceModel = t1.distanceModel, this.coneOuterGain = t1.coneOuterGain, this.coneOuterAngle = t1.coneOuterAngle, this.coneInnerAngle = t1.coneInnerAngle, this.refDistance = t1.refDistance, this.rolloffFactor = t1.rolloffFactor, this.positionX = new no({
                        context: this.context,
                        param: this._panner.positionX,
                        value: t1.positionX
                    }), this.positionY = new no({
                        context: this.context,
                        param: this._panner.positionY,
                        value: t1.positionY
                    }), this.positionZ = new no({
                        context: this.context,
                        param: this._panner.positionZ,
                        value: t1.positionZ
                    }), this.orientationX = new no({
                        context: this.context,
                        param: this._panner.orientationX,
                        value: t1.orientationX
                    }), this.orientationY = new no({
                        context: this.context,
                        param: this._panner.orientationY,
                        value: t1.orientationY
                    }), this.orientationZ = new no({
                        context: this.context,
                        param: this._panner.orientationZ,
                        value: t1.orientationZ
                    });
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        coneInnerAngle: 360,
                        coneOuterAngle: 360,
                        coneOuterGain: 0,
                        distanceModel: "inverse",
                        maxDistance: 1e4,
                        orientationX: 0,
                        orientationY: 0,
                        orientationZ: 0,
                        panningModel: "equalpower",
                        positionX: 0,
                        positionY: 0,
                        positionZ: 0,
                        refDistance: 1,
                        rolloffFactor: 1
                    });
                }
                setPosition(t1, e, s1) {
                    return this.positionX.value = t1, this.positionY.value = e, this.positionZ.value = s1, this;
                }
                setOrientation(t1, e, s1) {
                    return this.orientationX.value = t1, this.orientationY.value = e, this.orientationZ.value = s1, this;
                }
                get panningModel() {
                    return this._panner.panningModel;
                }
                set panningModel(t1) {
                    this._panner.panningModel = t1;
                }
                get refDistance() {
                    return this._panner.refDistance;
                }
                set refDistance(t1) {
                    this._panner.refDistance = t1;
                }
                get rolloffFactor() {
                    return this._panner.rolloffFactor;
                }
                set rolloffFactor(t1) {
                    this._panner.rolloffFactor = t1;
                }
                get distanceModel() {
                    return this._panner.distanceModel;
                }
                set distanceModel(t1) {
                    this._panner.distanceModel = t1;
                }
                get coneInnerAngle() {
                    return this._panner.coneInnerAngle;
                }
                set coneInnerAngle(t1) {
                    this._panner.coneInnerAngle = t1;
                }
                get coneOuterAngle() {
                    return this._panner.coneOuterAngle;
                }
                set coneOuterAngle(t1) {
                    this._panner.coneOuterAngle = t1;
                }
                get coneOuterGain() {
                    return this._panner.coneOuterGain;
                }
                set coneOuterGain(t1) {
                    this._panner.coneOuterGain = t1;
                }
                get maxDistance() {
                    return this._panner.maxDistance;
                }
                set maxDistance(t1) {
                    this._panner.maxDistance = t1;
                }
                dispose() {
                    return super.dispose(), this._panner.disconnect(), this.orientationX.dispose(), this.orientationY.dispose(), this.orientationZ.dispose(), this.positionX.dispose(), this.positionY.dispose(), this.positionZ.dispose(), this;
                }
            }
            class ac extends io {
                constructor(){
                    super(ui(ac.getDefaults(), arguments)), this.name = "Recorder";
                    const t1 = ui(ac.getDefaults(), arguments);
                    this.input = new ho({
                        context: this.context
                    }), Bn(ac.supported, "Media Recorder API is not available"), this._stream = this.context.createMediaStreamDestination(), this.input.connect(this._stream), this._recorder = new MediaRecorder(this._stream.stream, {
                        mimeType: t1.mimeType
                    });
                }
                static getDefaults() {
                    return io.getDefaults();
                }
                get mimeType() {
                    return this._recorder.mimeType;
                }
                static get supported() {
                    return null !== ti && Reflect.has(ti, "MediaRecorder");
                }
                get state() {
                    return "inactive" === this._recorder.state ? "stopped" : "paused" === this._recorder.state ? "paused" : "started";
                }
                start() {
                    return ni(this, void 0, void 0, function*() {
                        Bn("started" !== this.state, "Recorder is already started");
                        const t1 = new Promise((t1)=>{
                            const e = ()=>{
                                this._recorder.removeEventListener("start", e, !1), t1();
                            };
                            this._recorder.addEventListener("start", e, !1);
                        });
                        return this._recorder.start(), yield t1;
                    });
                }
                stop() {
                    return ni(this, void 0, void 0, function*() {
                        Bn("stopped" !== this.state, "Recorder is not started");
                        const t1 = new Promise((t1)=>{
                            const e = (s1)=>{
                                this._recorder.removeEventListener("dataavailable", e, !1), t1(s1.data);
                            };
                            this._recorder.addEventListener("dataavailable", e, !1);
                        });
                        return this._recorder.stop(), yield t1;
                    });
                }
                pause() {
                    return Bn("started" === this.state, "Recorder must be started"), this._recorder.pause(), this;
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this._stream.disconnect(), this;
                }
            }
            class cc extends io {
                constructor(){
                    super(ui(cc.getDefaults(), arguments, [
                        "threshold",
                        "ratio"
                    ])), this.name = "Compressor", this._compressor = this.context.createDynamicsCompressor(), this.input = this._compressor, this.output = this._compressor;
                    const t1 = ui(cc.getDefaults(), arguments, [
                        "threshold",
                        "ratio"
                    ]);
                    this.threshold = new no({
                        minValue: this._compressor.threshold.minValue,
                        maxValue: this._compressor.threshold.maxValue,
                        context: this.context,
                        convert: !1,
                        param: this._compressor.threshold,
                        units: "decibels",
                        value: t1.threshold
                    }), this.attack = new no({
                        minValue: this._compressor.attack.minValue,
                        maxValue: this._compressor.attack.maxValue,
                        context: this.context,
                        param: this._compressor.attack,
                        units: "time",
                        value: t1.attack
                    }), this.release = new no({
                        minValue: this._compressor.release.minValue,
                        maxValue: this._compressor.release.maxValue,
                        context: this.context,
                        param: this._compressor.release,
                        units: "time",
                        value: t1.release
                    }), this.knee = new no({
                        minValue: this._compressor.knee.minValue,
                        maxValue: this._compressor.knee.maxValue,
                        context: this.context,
                        convert: !1,
                        param: this._compressor.knee,
                        units: "decibels",
                        value: t1.knee
                    }), this.ratio = new no({
                        minValue: this._compressor.ratio.minValue,
                        maxValue: this._compressor.ratio.maxValue,
                        context: this.context,
                        convert: !1,
                        param: this._compressor.ratio,
                        units: "positive",
                        value: t1.ratio
                    }), Oi(this, [
                        "knee",
                        "release",
                        "attack",
                        "ratio",
                        "threshold"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        attack: .003,
                        knee: 30,
                        ratio: 12,
                        release: .25,
                        threshold: -24
                    });
                }
                get reduction() {
                    return this._compressor.reduction;
                }
                dispose() {
                    return super.dispose(), this._compressor.disconnect(), this.attack.dispose(), this.release.dispose(), this.threshold.dispose(), this.ratio.dispose(), this.knee.dispose(), this;
                }
            }
            class hc extends io {
                constructor(){
                    super(Object.assign(ui(hc.getDefaults(), arguments, [
                        "threshold",
                        "smoothing"
                    ]))), this.name = "Gate";
                    const t1 = ui(hc.getDefaults(), arguments, [
                        "threshold",
                        "smoothing"
                    ]);
                    this._follower = new fa({
                        context: this.context,
                        smoothing: t1.smoothing
                    }), this._gt = new gr({
                        context: this.context,
                        value: ji(t1.threshold)
                    }), this.input = new ho({
                        context: this.context
                    }), this._gate = this.output = new ho({
                        context: this.context
                    }), this.input.connect(this._gate), this.input.chain(this._follower, this._gt, this._gate.gain);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        smoothing: .1,
                        threshold: -40
                    });
                }
                get threshold() {
                    return Li(this._gt.value);
                }
                set threshold(t1) {
                    this._gt.value = ji(t1);
                }
                get smoothing() {
                    return this._follower.smoothing;
                }
                set smoothing(t1) {
                    this._follower.smoothing = t1;
                }
                dispose() {
                    return super.dispose(), this.input.dispose(), this._follower.dispose(), this._gt.dispose(), this._gate.dispose(), this;
                }
            }
            class lc extends io {
                constructor(){
                    super(Object.assign(ui(lc.getDefaults(), arguments, [
                        "threshold"
                    ]))), this.name = "Limiter";
                    const t1 = ui(lc.getDefaults(), arguments, [
                        "threshold"
                    ]);
                    this._compressor = this.input = this.output = new cc({
                        context: this.context,
                        ratio: 20,
                        attack: .003,
                        release: .01,
                        threshold: t1.threshold
                    }), this.threshold = this._compressor.threshold, Oi(this, "threshold");
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        threshold: -12
                    });
                }
                get reduction() {
                    return this._compressor.reduction;
                }
                dispose() {
                    return super.dispose(), this._compressor.dispose(), this.threshold.dispose(), this;
                }
            }
            class uc extends io {
                constructor(){
                    super(Object.assign(ui(uc.getDefaults(), arguments))), this.name = "MidSideCompressor";
                    const t1 = ui(uc.getDefaults(), arguments);
                    this._midSideSplit = this.input = new Wa({
                        context: this.context
                    }), this._midSideMerge = this.output = new Ba({
                        context: this.context
                    }), this.mid = new cc(Object.assign(t1.mid, {
                        context: this.context
                    })), this.side = new cc(Object.assign(t1.side, {
                        context: this.context
                    })), this._midSideSplit.mid.chain(this.mid, this._midSideMerge.mid), this._midSideSplit.side.chain(this.side, this._midSideMerge.side), Oi(this, [
                        "mid",
                        "side"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        mid: {
                            ratio: 3,
                            threshold: -24,
                            release: .03,
                            attack: .02,
                            knee: 16
                        },
                        side: {
                            ratio: 6,
                            threshold: -30,
                            release: .25,
                            attack: .03,
                            knee: 10
                        }
                    });
                }
                dispose() {
                    return super.dispose(), this.mid.dispose(), this.side.dispose(), this._midSideSplit.dispose(), this._midSideMerge.dispose(), this;
                }
            }
            class pc extends io {
                constructor(){
                    super(Object.assign(ui(pc.getDefaults(), arguments))), this.name = "MultibandCompressor";
                    const t1 = ui(pc.getDefaults(), arguments);
                    this._splitter = this.input = new ic({
                        context: this.context,
                        lowFrequency: t1.lowFrequency,
                        highFrequency: t1.highFrequency
                    }), this.lowFrequency = this._splitter.lowFrequency, this.highFrequency = this._splitter.highFrequency, this.output = new ho({
                        context: this.context
                    }), this.low = new cc(Object.assign(t1.low, {
                        context: this.context
                    })), this.mid = new cc(Object.assign(t1.mid, {
                        context: this.context
                    })), this.high = new cc(Object.assign(t1.high, {
                        context: this.context
                    })), this._splitter.low.chain(this.low, this.output), this._splitter.mid.chain(this.mid, this.output), this._splitter.high.chain(this.high, this.output), Oi(this, [
                        "high",
                        "mid",
                        "low",
                        "highFrequency",
                        "lowFrequency"
                    ]);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        lowFrequency: 250,
                        highFrequency: 2e3,
                        low: {
                            ratio: 6,
                            threshold: -30,
                            release: .25,
                            attack: .03,
                            knee: 10
                        },
                        mid: {
                            ratio: 3,
                            threshold: -24,
                            release: .03,
                            attack: .02,
                            knee: 16
                        },
                        high: {
                            ratio: 3,
                            threshold: -24,
                            release: .03,
                            attack: .02,
                            knee: 16
                        }
                    });
                }
                dispose() {
                    return super.dispose(), this._splitter.dispose(), this.low.dispose(), this.mid.dispose(), this.high.dispose(), this.output.dispose(), this;
                }
            }
            class dc extends io {
                constructor(){
                    super(ui(dc.getDefaults(), arguments, [
                        "low",
                        "mid",
                        "high"
                    ])), this.name = "EQ3", this.output = new ho({
                        context: this.context
                    }), this._internalChannels = [];
                    const t1 = ui(dc.getDefaults(), arguments, [
                        "low",
                        "mid",
                        "high"
                    ]);
                    this.input = this._multibandSplit = new ic({
                        context: this.context,
                        highFrequency: t1.highFrequency,
                        lowFrequency: t1.lowFrequency
                    }), this._lowGain = new ho({
                        context: this.context,
                        gain: t1.low,
                        units: "decibels"
                    }), this._midGain = new ho({
                        context: this.context,
                        gain: t1.mid,
                        units: "decibels"
                    }), this._highGain = new ho({
                        context: this.context,
                        gain: t1.high,
                        units: "decibels"
                    }), this.low = this._lowGain.gain, this.mid = this._midGain.gain, this.high = this._highGain.gain, this.Q = this._multibandSplit.Q, this.lowFrequency = this._multibandSplit.lowFrequency, this.highFrequency = this._multibandSplit.highFrequency, this._multibandSplit.low.chain(this._lowGain, this.output), this._multibandSplit.mid.chain(this._midGain, this.output), this._multibandSplit.high.chain(this._highGain, this.output), Oi(this, [
                        "low",
                        "mid",
                        "high",
                        "lowFrequency",
                        "highFrequency"
                    ]), this._internalChannels = [
                        this._multibandSplit
                    ];
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        high: 0,
                        highFrequency: 2500,
                        low: 0,
                        lowFrequency: 400,
                        mid: 0
                    });
                }
                dispose() {
                    return super.dispose(), Mi(this, [
                        "low",
                        "mid",
                        "high",
                        "lowFrequency",
                        "highFrequency"
                    ]), this._multibandSplit.dispose(), this.lowFrequency.dispose(), this.highFrequency.dispose(), this._lowGain.dispose(), this._midGain.dispose(), this._highGain.dispose(), this.low.dispose(), this.mid.dispose(), this.high.dispose(), this.Q.dispose(), this;
                }
            }
            class fc extends io {
                constructor(){
                    super(ui(fc.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ])), this.name = "Convolver", this._convolver = this.context.createConvolver();
                    const t1 = ui(fc.getDefaults(), arguments, [
                        "url",
                        "onload"
                    ]);
                    this._buffer = new Ri(t1.url, (e)=>{
                        this.buffer = e, t1.onload();
                    }), this.input = new ho({
                        context: this.context
                    }), this.output = new ho({
                        context: this.context
                    }), this._buffer.loaded && (this.buffer = this._buffer), this.normalize = t1.normalize, this.input.chain(this._convolver, this.output);
                }
                static getDefaults() {
                    return Object.assign(io.getDefaults(), {
                        normalize: !0,
                        onload: Ei
                    });
                }
                load(t1) {
                    return ni(this, void 0, void 0, function*() {
                        this.buffer = yield this._buffer.load(t1);
                    });
                }
                get buffer() {
                    return this._buffer.length ? this._buffer : null;
                }
                set buffer(t1) {
                    t1 && this._buffer.set(t1), this._convolver.buffer && (this.input.disconnect(), this._convolver.disconnect(), this._convolver = this.context.createConvolver(), this.input.chain(this._convolver, this.output));
                    const e = this._buffer.get();
                    this._convolver.buffer = e || null;
                }
                get normalize() {
                    return this._convolver.normalize;
                }
                set normalize(t1) {
                    this._convolver.normalize = t1;
                }
                dispose() {
                    return super.dispose(), this._buffer.dispose(), this._convolver.disconnect(), this;
                }
            }
            function _c() {
                return Vi().now();
            }
            function mc() {
                return Vi().immediate();
            }
            const gc = Vi().transport;
            function vc() {
                return Vi().transport;
            }
            const yc = Vi().destination, xc = Vi().destination;
            function wc() {
                return Vi().destination;
            }
            const bc = Vi().listener;
            function Tc() {
                return Vi().listener;
            }
            const Sc = Vi().draw;
            function kc() {
                return Vi().draw;
            }
            const Ac = Vi();
            function Cc() {
                return Ri.loaded();
            }
            const Dc = Ri, Oc = wo, Mc = jo;
        })(), n;
    })());

},{}],"b7q1y":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbcNotation", ()=>_abcNotation);
parcelHelpers.export(exports, "Array", ()=>_array);
parcelHelpers.export(exports, "Chord", ()=>_chord);
parcelHelpers.export(exports, "ChordDictionary", ()=>ChordDictionary);
parcelHelpers.export(exports, "ChordType", ()=>_chordType);
parcelHelpers.export(exports, "Collection", ()=>_collection);
parcelHelpers.export(exports, "Core", ()=>_core);
parcelHelpers.export(exports, "DurationValue", ()=>_durationValue);
parcelHelpers.export(exports, "Interval", ()=>_interval);
parcelHelpers.export(exports, "Key", ()=>_key);
parcelHelpers.export(exports, "Midi", ()=>_midi);
parcelHelpers.export(exports, "Mode", ()=>_mode);
parcelHelpers.export(exports, "Note", ()=>_note);
parcelHelpers.export(exports, "PcSet", ()=>PcSet);
parcelHelpers.export(exports, "Pcset", ()=>_pcset);
parcelHelpers.export(exports, "Progression", ()=>_progression);
parcelHelpers.export(exports, "Range", ()=>_range);
parcelHelpers.export(exports, "RhythmPattern", ()=>_rhythmPattern);
parcelHelpers.export(exports, "RomanNumeral", ()=>_romanNumeral);
parcelHelpers.export(exports, "Scale", ()=>_scale);
parcelHelpers.export(exports, "ScaleDictionary", ()=>ScaleDictionary);
parcelHelpers.export(exports, "ScaleType", ()=>_scaleType);
parcelHelpers.export(exports, "TimeSignature", ()=>_timeSignature);
parcelHelpers.export(exports, "Tonal", ()=>Tonal);
parcelHelpers.export(exports, "VoiceLeading", ()=>_voiceLeading);
parcelHelpers.export(exports, "Voicing", ()=>_voicing);
parcelHelpers.export(exports, "VoicingDictionary", ()=>_voicingDictionary);
var _abcNotation = require("@tonaljs/abc-notation");
var _array = require("@tonaljs/array");
var _chord = require("@tonaljs/chord");
var _chordType = require("@tonaljs/chord-type");
var _collection = require("@tonaljs/collection");
var _durationValue = require("@tonaljs/duration-value");
var _interval = require("@tonaljs/interval");
var _key = require("@tonaljs/key");
var _midi = require("@tonaljs/midi");
var _mode = require("@tonaljs/mode");
var _note = require("@tonaljs/note");
var _pcset = require("@tonaljs/pcset");
var _progression = require("@tonaljs/progression");
var _range = require("@tonaljs/range");
var _rhythmPattern = require("@tonaljs/rhythm-pattern");
var _romanNumeral = require("@tonaljs/roman-numeral");
var _scale = require("@tonaljs/scale");
var _scaleType = require("@tonaljs/scale-type");
var _timeSignature = require("@tonaljs/time-signature");
var _voiceLeading = require("@tonaljs/voice-leading");
var _voicing = require("@tonaljs/voicing");
var _voicingDictionary = require("@tonaljs/voicing-dictionary");
var _core = require("@tonaljs/core");
parcelHelpers.exportAll(_core, exports);
var Tonal = _core;
var PcSet = _pcset;
var ChordDictionary = _chordType;
var ScaleDictionary = _scaleType;

},{"@tonaljs/abc-notation":"fIuw5","@tonaljs/array":"c8mll","@tonaljs/chord":"jiMl3","@tonaljs/chord-type":"1iNIt","@tonaljs/collection":"eZd3r","@tonaljs/duration-value":"kuUaL","@tonaljs/interval":"aFeW6","@tonaljs/key":"diJKE","@tonaljs/midi":"ywjEO","@tonaljs/mode":"eO6JV","@tonaljs/note":"kNy38","@tonaljs/pcset":"d6uTg","@tonaljs/progression":"hBC0B","@tonaljs/range":"372it","@tonaljs/rhythm-pattern":"hjGfL","@tonaljs/roman-numeral":"2rpBM","@tonaljs/scale":"bVzve","@tonaljs/scale-type":"kiKIP","@tonaljs/time-signature":"d4eD5","@tonaljs/voice-leading":"kqIFf","@tonaljs/voicing":"79ZNE","@tonaljs/voicing-dictionary":"4jk3Q","@tonaljs/core":"i2CsJ","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"fIuw5":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abcToScientificNotation", ()=>abcToScientificNotation);
parcelHelpers.export(exports, "default", ()=>abc_notation_default);
parcelHelpers.export(exports, "distance", ()=>distance);
parcelHelpers.export(exports, "scientificToAbcNotation", ()=>scientificToAbcNotation);
parcelHelpers.export(exports, "tokenize", ()=>tokenize);
parcelHelpers.export(exports, "transpose", ()=>transpose);
var _pitchDistance = require("@tonaljs/pitch-distance");
var _pitchNote = require("@tonaljs/pitch-note");
var fillStr = (character, times)=>Array(times + 1).join(character);
var REGEX = /^(_{1,}|=|\^{1,}|)([abcdefgABCDEFG])([,']*)$/;
function tokenize(str) {
    const m = REGEX.exec(str);
    if (!m) return [
        "",
        "",
        ""
    ];
    return [
        m[1],
        m[2],
        m[3]
    ];
}
function abcToScientificNotation(str) {
    const [acc, letter, oct] = tokenize(str);
    if (letter === "") return "";
    let o = 4;
    for(let i = 0; i < oct.length; i++)o += oct.charAt(i) === "," ? -1 : 1;
    const a = acc[0] === "_" ? acc.replace(/_/g, "b") : acc[0] === "^" ? acc.replace(/\^/g, "#") : "";
    return letter.charCodeAt(0) > 96 ? letter.toUpperCase() + a + (o + 1) : letter + a + o;
}
function scientificToAbcNotation(str) {
    const n = (0, _pitchNote.note)(str);
    if (n.empty || !n.oct && n.oct !== 0) return "";
    const { letter, acc, oct } = n;
    const a = acc[0] === "b" ? acc.replace(/b/g, "_") : acc.replace(/#/g, "^");
    const l = oct > 4 ? letter.toLowerCase() : letter;
    const o = oct === 5 ? "" : oct > 4 ? fillStr("'", oct - 5) : fillStr(",", 4 - oct);
    return a + l + o;
}
function transpose(note2, interval) {
    return scientificToAbcNotation((0, _pitchDistance.transpose)(abcToScientificNotation(note2), interval));
}
function distance(from, to) {
    return (0, _pitchDistance.distance)(abcToScientificNotation(from), abcToScientificNotation(to));
}
var abc_notation_default = {
    abcToScientificNotation,
    scientificToAbcNotation,
    tokenize,
    transpose,
    distance
};

},{"@tonaljs/pitch-distance":"hUy2y","@tonaljs/pitch-note":"4vzmL","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"hUy2y":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distance", ()=>distance);
parcelHelpers.export(exports, "tonicIntervalsTransposer", ()=>tonicIntervalsTransposer);
parcelHelpers.export(exports, "transpose", ()=>transpose);
var _pitchInterval = require("@tonaljs/pitch-interval");
var _pitchNote = require("@tonaljs/pitch-note");
function transpose(noteName, intervalName) {
    const note = (0, _pitchNote.note)(noteName);
    const intervalCoord = Array.isArray(intervalName) ? intervalName : (0, _pitchInterval.interval)(intervalName).coord;
    if (note.empty || !intervalCoord || intervalCoord.length < 2) return "";
    const noteCoord = note.coord;
    const tr = noteCoord.length === 1 ? [
        noteCoord[0] + intervalCoord[0]
    ] : [
        noteCoord[0] + intervalCoord[0],
        noteCoord[1] + intervalCoord[1]
    ];
    return (0, _pitchNote.coordToNote)(tr).name;
}
function tonicIntervalsTransposer(intervals, tonic) {
    const len = intervals.length;
    return (normalized)=>{
        if (!tonic) return "";
        const index = normalized < 0 ? (len - -normalized % len) % len : normalized % len;
        const octaves = Math.floor(normalized / len);
        const root = transpose(tonic, [
            0,
            octaves
        ]);
        return transpose(root, intervals[index]);
    };
}
function distance(fromNote, toNote) {
    const from = (0, _pitchNote.note)(fromNote);
    const to = (0, _pitchNote.note)(toNote);
    if (from.empty || to.empty) return "";
    const fcoord = from.coord;
    const tcoord = to.coord;
    const fifths = tcoord[0] - fcoord[0];
    const octs = fcoord.length === 2 && tcoord.length === 2 ? tcoord[1] - fcoord[1] : -Math.floor(fifths * 7 / 12);
    const forceDescending = to.height === from.height && to.midi !== null && from.oct === to.oct && from.step > to.step;
    return (0, _pitchInterval.coordToInterval)([
        fifths,
        octs
    ], forceDescending).name;
}

},{"@tonaljs/pitch-interval":"76Nbo","@tonaljs/pitch-note":"4vzmL","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"76Nbo":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "coordToInterval", ()=>coordToInterval);
parcelHelpers.export(exports, "interval", ()=>interval);
parcelHelpers.export(exports, "tokenizeInterval", ()=>tokenizeInterval);
var _pitch = require("@tonaljs/pitch");
var fillStr = (s, n)=>Array(Math.abs(n) + 1).join(s);
var NoInterval = Object.freeze({
    empty: true,
    name: "",
    num: NaN,
    q: "",
    type: "",
    step: NaN,
    alt: NaN,
    dir: NaN,
    simple: NaN,
    semitones: NaN,
    chroma: NaN,
    coord: [],
    oct: NaN
});
var INTERVAL_TONAL_REGEX = "([-+]?\\d+)(d{1,4}|m|M|P|A{1,4})";
var INTERVAL_SHORTHAND_REGEX = "(AA|A|P|M|m|d|dd)([-+]?\\d+)";
var REGEX = new RegExp("^" + INTERVAL_TONAL_REGEX + "|" + INTERVAL_SHORTHAND_REGEX + "$");
function tokenizeInterval(str) {
    const m = REGEX.exec(`${str}`);
    if (m === null) return [
        "",
        ""
    ];
    return m[1] ? [
        m[1],
        m[2]
    ] : [
        m[4],
        m[3]
    ];
}
var cache = {};
function interval(src) {
    return typeof src === "string" ? cache[src] || (cache[src] = parse(src)) : (0, _pitch.isPitch)(src) ? interval(pitchName(src)) : (0, _pitch.isNamedPitch)(src) ? interval(src.name) : NoInterval;
}
var SIZES = [
    0,
    2,
    4,
    5,
    7,
    9,
    11
];
var TYPES = "PMMPPMM";
function parse(str) {
    const tokens = tokenizeInterval(str);
    if (tokens[0] === "") return NoInterval;
    const num = +tokens[0];
    const q = tokens[1];
    const step = (Math.abs(num) - 1) % 7;
    const t = TYPES[step];
    if (t === "M" && q === "P") return NoInterval;
    const type = t === "M" ? "majorable" : "perfectable";
    const name = "" + num + q;
    const dir = num < 0 ? -1 : 1;
    const simple = num === 8 || num === -8 ? num : dir * (step + 1);
    const alt = qToAlt(type, q);
    const oct = Math.floor((Math.abs(num) - 1) / 7);
    const semitones = dir * (SIZES[step] + alt + 12 * oct);
    const chroma = (dir * (SIZES[step] + alt) % 12 + 12) % 12;
    const coord = (0, _pitch.coordinates)({
        step,
        alt,
        oct,
        dir
    });
    return {
        empty: false,
        name,
        num,
        q,
        step,
        alt,
        dir,
        type,
        simple,
        semitones,
        chroma,
        coord,
        oct
    };
}
function coordToInterval(coord, forceDescending) {
    const [f, o = 0] = coord;
    const isDescending = f * 7 + o * 12 < 0;
    const ivl = forceDescending || isDescending ? [
        -f,
        -o,
        -1
    ] : [
        f,
        o,
        1
    ];
    return interval((0, _pitch.pitch)(ivl));
}
function qToAlt(type, q) {
    return q === "M" && type === "majorable" || q === "P" && type === "perfectable" ? 0 : q === "m" && type === "majorable" ? -1 : /^A+$/.test(q) ? q.length : /^d+$/.test(q) ? -1 * (type === "perfectable" ? q.length : q.length + 1) : 0;
}
function pitchName(props) {
    const { step, alt, oct = 0, dir } = props;
    if (!dir) return "";
    const calcNum = step + 1 + 7 * oct;
    const num = calcNum === 0 ? step + 1 : calcNum;
    const d = dir < 0 ? "-" : "";
    const type = TYPES[step] === "M" ? "majorable" : "perfectable";
    const name = d + num + altToQ(type, alt);
    return name;
}
function altToQ(type, alt) {
    if (alt === 0) return type === "majorable" ? "M" : "P";
    else if (alt === -1 && type === "majorable") return "m";
    else if (alt > 0) return fillStr("A", alt);
    else return fillStr("d", type === "perfectable" ? alt : alt + 1);
}

},{"@tonaljs/pitch":"2v7nB","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"2v7nB":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chroma", ()=>chroma);
parcelHelpers.export(exports, "coordinates", ()=>coordinates);
parcelHelpers.export(exports, "height", ()=>height);
parcelHelpers.export(exports, "isNamedPitch", ()=>isNamedPitch);
parcelHelpers.export(exports, "isPitch", ()=>isPitch);
parcelHelpers.export(exports, "midi", ()=>midi);
parcelHelpers.export(exports, "pitch", ()=>pitch);
function isNamedPitch(src) {
    return src !== null && typeof src === "object" && "name" in src && typeof src.name === "string" ? true : false;
}
var SIZES = [
    0,
    2,
    4,
    5,
    7,
    9,
    11
];
var chroma = ({ step, alt })=>(SIZES[step] + alt + 120) % 12;
var height = ({ step, alt, oct, dir = 1 })=>dir * (SIZES[step] + alt + 12 * (oct === void 0 ? -100 : oct));
var midi = (pitch2)=>{
    const h = height(pitch2);
    return pitch2.oct !== void 0 && h >= -12 && h <= 115 ? h + 12 : null;
};
function isPitch(pitch2) {
    return pitch2 !== null && typeof pitch2 === "object" && "step" in pitch2 && typeof pitch2.step === "number" && "alt" in pitch2 && typeof pitch2.alt === "number" && !isNaN(pitch2.step) && !isNaN(pitch2.alt) ? true : false;
}
var FIFTHS = [
    0,
    2,
    4,
    -1,
    1,
    3,
    5
];
var STEPS_TO_OCTS = FIFTHS.map((fifths)=>Math.floor(fifths * 7 / 12));
function coordinates(pitch2) {
    const { step, alt, oct, dir = 1 } = pitch2;
    const f = FIFTHS[step] + 7 * alt;
    if (oct === void 0) return [
        dir * f
    ];
    const o = oct - STEPS_TO_OCTS[step] - 4 * alt;
    return [
        dir * f,
        dir * o
    ];
}
var FIFTHS_TO_STEPS = [
    3,
    0,
    4,
    1,
    5,
    2,
    6
];
function pitch(coord) {
    const [f, o, dir] = coord;
    const step = FIFTHS_TO_STEPS[unaltered(f)];
    const alt = Math.floor((f + 1) / 7);
    if (o === void 0) return {
        step,
        alt,
        dir
    };
    const oct = o + 4 * alt + STEPS_TO_OCTS[step];
    return {
        step,
        alt,
        oct,
        dir
    };
}
function unaltered(f) {
    const i = (f + 1) % 7;
    return i < 0 ? 7 + i : i;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"9eXmb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"4vzmL":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "accToAlt", ()=>accToAlt);
parcelHelpers.export(exports, "altToAcc", ()=>altToAcc);
parcelHelpers.export(exports, "coordToNote", ()=>coordToNote);
parcelHelpers.export(exports, "note", ()=>note);
parcelHelpers.export(exports, "stepToLetter", ()=>stepToLetter);
parcelHelpers.export(exports, "tokenizeNote", ()=>tokenizeNote);
var _pitch = require("@tonaljs/pitch");
var fillStr = (s, n)=>Array(Math.abs(n) + 1).join(s);
var NoNote = Object.freeze({
    empty: true,
    name: "",
    letter: "",
    acc: "",
    pc: "",
    step: NaN,
    alt: NaN,
    chroma: NaN,
    height: NaN,
    coord: [],
    midi: null,
    freq: null
});
var cache = /* @__PURE__ */ new Map();
var stepToLetter = (step)=>"CDEFGAB".charAt(step);
var altToAcc = (alt)=>alt < 0 ? fillStr("b", -alt) : fillStr("#", alt);
var accToAlt = (acc)=>acc[0] === "b" ? -acc.length : acc.length;
function note(src) {
    const stringSrc = JSON.stringify(src);
    const cached = cache.get(stringSrc);
    if (cached) return cached;
    const value = typeof src === "string" ? parse(src) : (0, _pitch.isPitch)(src) ? note(pitchName(src)) : (0, _pitch.isNamedPitch)(src) ? note(src.name) : NoNote;
    cache.set(stringSrc, value);
    return value;
}
var REGEX = /^([a-gA-G]?)(#{1,}|b{1,}|x{1,}|)(-?\d*)\s*(.*)$/;
function tokenizeNote(str) {
    const m = REGEX.exec(str);
    return m ? [
        m[1].toUpperCase(),
        m[2].replace(/x/g, "##"),
        m[3],
        m[4]
    ] : [
        "",
        "",
        "",
        ""
    ];
}
function coordToNote(noteCoord) {
    return note((0, _pitch.pitch)(noteCoord));
}
var mod = (n, m)=>(n % m + m) % m;
var SEMI = [
    0,
    2,
    4,
    5,
    7,
    9,
    11
];
function parse(noteName) {
    const tokens = tokenizeNote(noteName);
    if (tokens[0] === "" || tokens[3] !== "") return NoNote;
    const letter = tokens[0];
    const acc = tokens[1];
    const octStr = tokens[2];
    const step = (letter.charCodeAt(0) + 3) % 7;
    const alt = accToAlt(acc);
    const oct = octStr.length ? +octStr : void 0;
    const coord = (0, _pitch.coordinates)({
        step,
        alt,
        oct
    });
    const name = letter + acc + octStr;
    const pc = letter + acc;
    const chroma = (SEMI[step] + alt + 120) % 12;
    const height = oct === void 0 ? mod(SEMI[step] + alt, 12) - 1188 : SEMI[step] + alt + 12 * (oct + 1);
    const midi = height >= 0 && height <= 127 ? height : null;
    const freq = oct === void 0 ? null : Math.pow(2, (height - 69) / 12) * 440;
    return {
        empty: false,
        acc,
        alt,
        chroma,
        coord,
        freq,
        height,
        letter,
        midi,
        name,
        oct,
        pc,
        step
    };
}
function pitchName(props) {
    const { step, alt, oct } = props;
    const letter = stepToLetter(step);
    if (!letter) return "";
    const pc = letter + altToAcc(alt);
    return oct || oct === 0 ? pc + oct : pc;
}

},{"@tonaljs/pitch":"2v7nB","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"c8mll":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compact", ()=>compact);
parcelHelpers.export(exports, "permutations", ()=>permutations);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "rotate", ()=>rotate);
parcelHelpers.export(exports, "shuffle", ()=>shuffle);
parcelHelpers.export(exports, "sortedNoteNames", ()=>sortedNoteNames);
parcelHelpers.export(exports, "sortedUniqNoteNames", ()=>sortedUniqNoteNames);
var _pitchNote = require("@tonaljs/pitch-note");
function ascR(b, n) {
    const a = [];
    for(; n--; a[n] = n + b);
    return a;
}
function descR(b, n) {
    const a = [];
    for(; n--; a[n] = b - n);
    return a;
}
function range(from, to) {
    return from < to ? ascR(from, to - from + 1) : descR(from, from - to + 1);
}
function rotate(times, arr) {
    const len = arr.length;
    const n = (times % len + len) % len;
    return arr.slice(n, len).concat(arr.slice(0, n));
}
function compact(arr) {
    return arr.filter((n)=>n === 0 || n);
}
function sortedNoteNames(notes) {
    const valid = notes.map((n)=>(0, _pitchNote.note)(n)).filter((n)=>!n.empty);
    return valid.sort((a, b)=>a.height - b.height).map((n)=>n.name);
}
function sortedUniqNoteNames(arr) {
    return sortedNoteNames(arr).filter((n, i, a)=>i === 0 || n !== a[i - 1]);
}
function shuffle(arr, rnd = Math.random) {
    let i;
    let t;
    let m = arr.length;
    while(m){
        i = Math.floor(rnd() * m--);
        t = arr[m];
        arr[m] = arr[i];
        arr[i] = t;
    }
    return arr;
}
function permutations(arr) {
    if (arr.length === 0) return [
        []
    ];
    return permutations(arr.slice(1)).reduce((acc, perm)=>{
        return acc.concat(arr.map((e, pos)=>{
            const newPerm = perm.slice();
            newPerm.splice(pos, 0, arr[0]);
            return newPerm;
        }));
    }, []);
}

},{"@tonaljs/pitch-note":"4vzmL","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"jiMl3":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chord", ()=>chord);
parcelHelpers.export(exports, "chordScales", ()=>chordScales);
parcelHelpers.export(exports, "default", ()=>chord_default);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "detect", ()=>(0, _chordDetect.detect));
parcelHelpers.export(exports, "extended", ()=>extended);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "getChord", ()=>getChord);
parcelHelpers.export(exports, "notes", ()=>notes);
parcelHelpers.export(exports, "reduced", ()=>reduced);
parcelHelpers.export(exports, "steps", ()=>steps);
parcelHelpers.export(exports, "tokenize", ()=>tokenize);
parcelHelpers.export(exports, "transpose", ()=>transpose);
var _chordDetect = require("@tonaljs/chord-detect");
var _chordType = require("@tonaljs/chord-type");
var _interval = require("@tonaljs/interval");
var _pcset = require("@tonaljs/pcset");
var _pitchDistance = require("@tonaljs/pitch-distance");
var _pitchNote = require("@tonaljs/pitch-note");
var _scaleType = require("@tonaljs/scale-type");
var NoChord = {
    empty: true,
    name: "",
    symbol: "",
    root: "",
    bass: "",
    rootDegree: 0,
    type: "",
    tonic: null,
    setNum: NaN,
    quality: "Unknown",
    chroma: "",
    normalized: "",
    aliases: [],
    notes: [],
    intervals: []
};
function tokenize(name) {
    const [letter, acc, oct, type] = (0, _pitchNote.tokenizeNote)(name);
    if (letter === "") return tokenizeBass("", name);
    else if (letter === "A" && type === "ug") return tokenizeBass("", "aug");
    else return tokenizeBass(letter + acc, oct + type);
}
function tokenizeBass(note2, chord2) {
    const split = chord2.split("/");
    if (split.length === 1) return [
        note2,
        split[0],
        ""
    ];
    const [letter, acc, oct, type] = (0, _pitchNote.tokenizeNote)(split[1]);
    if (letter !== "" && oct === "" && type === "") return [
        note2,
        split[0],
        letter + acc
    ];
    else return [
        note2,
        chord2,
        ""
    ];
}
function get(src) {
    if (Array.isArray(src)) return getChord(src[1] || "", src[0], src[2]);
    else if (src === "") return NoChord;
    else {
        const [tonic, type, bass] = tokenize(src);
        const chord2 = getChord(type, tonic, bass);
        return chord2.empty ? getChord(src) : chord2;
    }
}
function getChord(typeName, optionalTonic, optionalBass) {
    const type = (0, _chordType.get)(typeName);
    const tonic = (0, _pitchNote.note)(optionalTonic || "");
    const bass = (0, _pitchNote.note)(optionalBass || "");
    if (type.empty || optionalTonic && tonic.empty || optionalBass && bass.empty) return NoChord;
    const bassInterval = (0, _pitchDistance.distance)(tonic.pc, bass.pc);
    const bassIndex = type.intervals.indexOf(bassInterval);
    const hasRoot = bassIndex >= 0;
    const root = hasRoot ? bass : (0, _pitchNote.note)("");
    const rootDegree = bassIndex === -1 ? NaN : bassIndex + 1;
    const hasBass = bass.pc && bass.pc !== tonic.pc;
    const intervals = Array.from(type.intervals);
    if (hasRoot) for(let i = 1; i < rootDegree; i++){
        const num = intervals[0][0];
        const quality = intervals[0][1];
        const newNum = parseInt(num, 10) + 7;
        intervals.push(`${newNum}${quality}`);
        intervals.shift();
    }
    else if (hasBass) {
        const ivl = (0, _interval.subtract)((0, _pitchDistance.distance)(tonic.pc, bass.pc), "8P");
        if (ivl) intervals.unshift(ivl);
    }
    const notes2 = tonic.empty ? [] : intervals.map((i)=>(0, _pitchDistance.transpose)(tonic.pc, i));
    typeName = type.aliases.indexOf(typeName) !== -1 ? typeName : type.aliases[0];
    const symbol = `${tonic.empty ? "" : tonic.pc}${typeName}${hasRoot && rootDegree > 1 ? "/" + root.pc : hasBass ? "/" + bass.pc : ""}`;
    const name = `${optionalTonic ? tonic.pc + " " : ""}${type.name}${hasRoot && rootDegree > 1 ? " over " + root.pc : hasBass ? " over " + bass.pc : ""}`;
    return {
        ...type,
        name,
        symbol,
        tonic: tonic.pc,
        type: type.name,
        root: root.pc,
        bass: hasBass ? bass.pc : "",
        intervals,
        rootDegree,
        notes: notes2
    };
}
var chord = get;
function transpose(chordName, interval) {
    const [tonic, type, bass] = tokenize(chordName);
    if (!tonic) return chordName;
    const tr = (0, _pitchDistance.transpose)(bass, interval);
    const slash = tr ? "/" + tr : "";
    return (0, _pitchDistance.transpose)(tonic, interval) + type + slash;
}
function chordScales(name) {
    const s = get(name);
    const isChordIncluded = (0, _pcset.isSupersetOf)(s.chroma);
    return (0, _scaleType.all)().filter((scale)=>isChordIncluded(scale.chroma)).map((scale)=>scale.name);
}
function extended(chordName) {
    const s = get(chordName);
    const isSuperset = (0, _pcset.isSupersetOf)(s.chroma);
    return (0, _chordType.all)().filter((chord2)=>isSuperset(chord2.chroma)).map((chord2)=>s.tonic + chord2.aliases[0]);
}
function reduced(chordName) {
    const s = get(chordName);
    const isSubset = (0, _pcset.isSubsetOf)(s.chroma);
    return (0, _chordType.all)().filter((chord2)=>isSubset(chord2.chroma)).map((chord2)=>s.tonic + chord2.aliases[0]);
}
function notes(chordName, tonic) {
    const chord2 = get(chordName);
    const note2 = tonic || chord2.tonic;
    if (!note2 || chord2.empty) return [];
    return chord2.intervals.map((ivl)=>(0, _pitchDistance.transpose)(note2, ivl));
}
function degrees(chordName, tonic) {
    const chord2 = get(chordName);
    const note2 = tonic || chord2.tonic;
    const transpose2 = (0, _pitchDistance.tonicIntervalsTransposer)(chord2.intervals, note2);
    return (degree)=>degree ? transpose2(degree > 0 ? degree - 1 : degree) : "";
}
function steps(chordName, tonic) {
    const chord2 = get(chordName);
    const note2 = tonic || chord2.tonic;
    return (0, _pitchDistance.tonicIntervalsTransposer)(chord2.intervals, note2);
}
var chord_default = {
    getChord,
    get,
    detect: (0, _chordDetect.detect),
    chordScales,
    extended,
    reduced,
    tokenize,
    transpose,
    degrees,
    steps,
    notes,
    chord
};

},{"@tonaljs/chord-detect":"cL4Vu","@tonaljs/chord-type":"1iNIt","@tonaljs/interval":"aFeW6","@tonaljs/pcset":"d6uTg","@tonaljs/pitch-distance":"hUy2y","@tonaljs/pitch-note":"4vzmL","@tonaljs/scale-type":"kiKIP","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"cL4Vu":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>chord_detect_default);
parcelHelpers.export(exports, "detect", ()=>detect);
var _chordType = require("@tonaljs/chord-type");
var _pcset = require("@tonaljs/pcset");
var _pitchNote = require("@tonaljs/pitch-note");
var namedSet = (notes)=>{
    const pcToName = notes.reduce((record, n)=>{
        const chroma = (0, _pitchNote.note)(n).chroma;
        if (chroma !== void 0) record[chroma] = record[chroma] || (0, _pitchNote.note)(n).name;
        return record;
    }, {});
    return (chroma)=>pcToName[chroma];
};
function detect(source, options = {}) {
    const notes = source.map((n)=>(0, _pitchNote.note)(n).pc).filter((x)=>x);
    if ((0, _pitchNote.note).length === 0) return [];
    const found = findMatches(notes, 1, options);
    return found.filter((chord)=>chord.weight).sort((a, b)=>b.weight - a.weight).map((chord)=>chord.name);
}
var BITMASK = {
    // 3m 000100000000
    // 3M 000010000000
    anyThirds: 384,
    // 5P 000000010000
    perfectFifth: 16,
    // 5d 000000100000
    // 5A 000000001000
    nonPerfectFifths: 40,
    anySeventh: 3
};
var testChromaNumber = (bitmask)=>(chromaNumber)=>Boolean(chromaNumber & bitmask);
var hasAnyThird = testChromaNumber(BITMASK.anyThirds);
var hasPerfectFifth = testChromaNumber(BITMASK.perfectFifth);
var hasAnySeventh = testChromaNumber(BITMASK.anySeventh);
var hasNonPerfectFifth = testChromaNumber(BITMASK.nonPerfectFifths);
function hasAnyThirdAndPerfectFifthAndAnySeventh(chordType) {
    const chromaNumber = parseInt(chordType.chroma, 2);
    return hasAnyThird(chromaNumber) && hasPerfectFifth(chromaNumber) && hasAnySeventh(chromaNumber);
}
function withPerfectFifth(chroma) {
    const chromaNumber = parseInt(chroma, 2);
    return hasNonPerfectFifth(chromaNumber) ? chroma : (chromaNumber | 16).toString(2);
}
function findMatches(notes, weight, options) {
    const tonic = notes[0];
    const tonicChroma = (0, _pitchNote.note)(tonic).chroma;
    const noteName = namedSet(notes);
    const allModes = (0, _pcset.modes)(notes, false);
    const found = [];
    allModes.forEach((mode, index)=>{
        const modeWithPerfectFifth = options.assumePerfectFifth && withPerfectFifth(mode);
        const chordTypes = (0, _chordType.all)().filter((chordType)=>{
            if (options.assumePerfectFifth && hasAnyThirdAndPerfectFifthAndAnySeventh(chordType)) return chordType.chroma === modeWithPerfectFifth;
            return chordType.chroma === mode;
        });
        chordTypes.forEach((chordType)=>{
            const chordName = chordType.aliases[0];
            const baseNote = noteName(index);
            const isInversion = index !== tonicChroma;
            if (isInversion) found.push({
                weight: 0.5 * weight,
                name: `${baseNote}${chordName}/${tonic}`
            });
            else found.push({
                weight: 1 * weight,
                name: `${baseNote}${chordName}`
            });
        });
    });
    return found;
}
var chord_detect_default = {
    detect
};

},{"@tonaljs/chord-type":"1iNIt","@tonaljs/pcset":"d6uTg","@tonaljs/pitch-note":"4vzmL","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"1iNIt":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "addAlias", ()=>addAlias);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "chordType", ()=>chordType);
parcelHelpers.export(exports, "default", ()=>chord_type_default);
parcelHelpers.export(exports, "entries", ()=>entries);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "keys", ()=>keys);
parcelHelpers.export(exports, "names", ()=>names);
parcelHelpers.export(exports, "removeAll", ()=>removeAll);
parcelHelpers.export(exports, "symbols", ()=>symbols);
var _pcset = require("@tonaljs/pcset");
// data.ts
var CHORDS = [
    // ==Major==
    [
        "1P 3M 5P",
        "major",
        "M ^  maj"
    ],
    [
        "1P 3M 5P 7M",
        "major seventh",
        "maj7 \u0394 ma7 M7 Maj7 ^7"
    ],
    [
        "1P 3M 5P 7M 9M",
        "major ninth",
        "maj9 \u03949 ^9"
    ],
    [
        "1P 3M 5P 7M 9M 13M",
        "major thirteenth",
        "maj13 Maj13 ^13"
    ],
    [
        "1P 3M 5P 6M",
        "sixth",
        "6 add6 add13 M6"
    ],
    [
        "1P 3M 5P 6M 9M",
        "sixth added ninth",
        "6add9 6/9 69 M69"
    ],
    [
        "1P 3M 6m 7M",
        "major seventh flat sixth",
        "M7b6 ^7b6"
    ],
    [
        "1P 3M 5P 7M 11A",
        "major seventh sharp eleventh",
        "maj#4 \u0394#4 \u0394#11 M7#11 ^7#11 maj7#11"
    ],
    // ==Minor==
    // '''Normal'''
    [
        "1P 3m 5P",
        "minor",
        "m min -"
    ],
    [
        "1P 3m 5P 7m",
        "minor seventh",
        "m7 min7 mi7 -7"
    ],
    [
        "1P 3m 5P 7M",
        "minor/major seventh",
        "m/ma7 m/maj7 mM7 mMaj7 m/M7 -\u03947 m\u0394 -^7 -maj7"
    ],
    [
        "1P 3m 5P 6M",
        "minor sixth",
        "m6 -6"
    ],
    [
        "1P 3m 5P 7m 9M",
        "minor ninth",
        "m9 -9"
    ],
    [
        "1P 3m 5P 7M 9M",
        "minor/major ninth",
        "mM9 mMaj9 -^9"
    ],
    [
        "1P 3m 5P 7m 9M 11P",
        "minor eleventh",
        "m11 -11"
    ],
    [
        "1P 3m 5P 7m 9M 13M",
        "minor thirteenth",
        "m13 -13"
    ],
    // '''Diminished'''
    [
        "1P 3m 5d",
        "diminished",
        "dim \xB0 o"
    ],
    [
        "1P 3m 5d 7d",
        "diminished seventh",
        "dim7 \xB07 o7"
    ],
    [
        "1P 3m 5d 7m",
        "half-diminished",
        "m7b5 \xF8 -7b5 h7 h"
    ],
    // ==Dominant/Seventh==
    // '''Normal'''
    [
        "1P 3M 5P 7m",
        "dominant seventh",
        "7 dom"
    ],
    [
        "1P 3M 5P 7m 9M",
        "dominant ninth",
        "9"
    ],
    [
        "1P 3M 5P 7m 9M 13M",
        "dominant thirteenth",
        "13"
    ],
    [
        "1P 3M 5P 7m 11A",
        "lydian dominant seventh",
        "7#11 7#4"
    ],
    // '''Altered'''
    [
        "1P 3M 5P 7m 9m",
        "dominant flat ninth",
        "7b9"
    ],
    [
        "1P 3M 5P 7m 9A",
        "dominant sharp ninth",
        "7#9"
    ],
    [
        "1P 3M 7m 9m",
        "altered",
        "alt7"
    ],
    // '''Suspended'''
    [
        "1P 4P 5P",
        "suspended fourth",
        "sus4 sus"
    ],
    [
        "1P 2M 5P",
        "suspended second",
        "sus2"
    ],
    [
        "1P 4P 5P 7m",
        "suspended fourth seventh",
        "7sus4 7sus"
    ],
    [
        "1P 5P 7m 9M 11P",
        "eleventh",
        "11"
    ],
    [
        "1P 4P 5P 7m 9m",
        "suspended fourth flat ninth",
        "b9sus phryg 7b9sus 7b9sus4"
    ],
    // ==Other==
    [
        "1P 5P",
        "fifth",
        "5"
    ],
    [
        "1P 3M 5A",
        "augmented",
        "aug + +5 ^#5"
    ],
    [
        "1P 3m 5A",
        "minor augmented",
        "m#5 -#5 m+"
    ],
    [
        "1P 3M 5A 7M",
        "augmented seventh",
        "maj7#5 maj7+5 +maj7 ^7#5"
    ],
    [
        "1P 3M 5P 7M 9M 11A",
        "major sharp eleventh (lydian)",
        "maj9#11 \u03949#11 ^9#11"
    ],
    // ==Legacy==
    [
        "1P 2M 4P 5P",
        "",
        "sus24 sus4add9"
    ],
    [
        "1P 3M 5A 7M 9M",
        "",
        "maj9#5 Maj9#5"
    ],
    [
        "1P 3M 5A 7m",
        "",
        "7#5 +7 7+ 7aug aug7"
    ],
    [
        "1P 3M 5A 7m 9A",
        "",
        "7#5#9 7#9#5 7alt"
    ],
    [
        "1P 3M 5A 7m 9M",
        "",
        "9#5 9+"
    ],
    [
        "1P 3M 5A 7m 9M 11A",
        "",
        "9#5#11"
    ],
    [
        "1P 3M 5A 7m 9m",
        "",
        "7#5b9 7b9#5"
    ],
    [
        "1P 3M 5A 7m 9m 11A",
        "",
        "7#5b9#11"
    ],
    [
        "1P 3M 5A 9A",
        "",
        "+add#9"
    ],
    [
        "1P 3M 5A 9M",
        "",
        "M#5add9 +add9"
    ],
    [
        "1P 3M 5P 6M 11A",
        "",
        "M6#11 M6b5 6#11 6b5"
    ],
    [
        "1P 3M 5P 6M 7M 9M",
        "",
        "M7add13"
    ],
    [
        "1P 3M 5P 6M 9M 11A",
        "",
        "69#11"
    ],
    [
        "1P 3m 5P 6M 9M",
        "",
        "m69 -69"
    ],
    [
        "1P 3M 5P 6m 7m",
        "",
        "7b6"
    ],
    [
        "1P 3M 5P 7M 9A 11A",
        "",
        "maj7#9#11"
    ],
    [
        "1P 3M 5P 7M 9M 11A 13M",
        "",
        "M13#11 maj13#11 M13+4 M13#4"
    ],
    [
        "1P 3M 5P 7M 9m",
        "",
        "M7b9"
    ],
    [
        "1P 3M 5P 7m 11A 13m",
        "",
        "7#11b13 7b5b13"
    ],
    [
        "1P 3M 5P 7m 13M",
        "",
        "7add6 67 7add13"
    ],
    [
        "1P 3M 5P 7m 9A 11A",
        "",
        "7#9#11 7b5#9 7#9b5"
    ],
    [
        "1P 3M 5P 7m 9A 11A 13M",
        "",
        "13#9#11"
    ],
    [
        "1P 3M 5P 7m 9A 11A 13m",
        "",
        "7#9#11b13"
    ],
    [
        "1P 3M 5P 7m 9A 13M",
        "",
        "13#9"
    ],
    [
        "1P 3M 5P 7m 9A 13m",
        "",
        "7#9b13"
    ],
    [
        "1P 3M 5P 7m 9M 11A",
        "",
        "9#11 9+4 9#4"
    ],
    [
        "1P 3M 5P 7m 9M 11A 13M",
        "",
        "13#11 13+4 13#4"
    ],
    [
        "1P 3M 5P 7m 9M 11A 13m",
        "",
        "9#11b13 9b5b13"
    ],
    [
        "1P 3M 5P 7m 9m 11A",
        "",
        "7b9#11 7b5b9 7b9b5"
    ],
    [
        "1P 3M 5P 7m 9m 11A 13M",
        "",
        "13b9#11"
    ],
    [
        "1P 3M 5P 7m 9m 11A 13m",
        "",
        "7b9b13#11 7b9#11b13 7b5b9b13"
    ],
    [
        "1P 3M 5P 7m 9m 13M",
        "",
        "13b9"
    ],
    [
        "1P 3M 5P 7m 9m 13m",
        "",
        "7b9b13"
    ],
    [
        "1P 3M 5P 7m 9m 9A",
        "",
        "7b9#9"
    ],
    [
        "1P 3M 5P 9M",
        "",
        "Madd9 2 add9 add2"
    ],
    [
        "1P 3M 5P 9m",
        "",
        "Maddb9"
    ],
    [
        "1P 3M 5d",
        "",
        "Mb5"
    ],
    [
        "1P 3M 5d 6M 7m 9M",
        "",
        "13b5"
    ],
    [
        "1P 3M 5d 7M",
        "",
        "M7b5"
    ],
    [
        "1P 3M 5d 7M 9M",
        "",
        "M9b5"
    ],
    [
        "1P 3M 5d 7m",
        "",
        "7b5"
    ],
    [
        "1P 3M 5d 7m 9M",
        "",
        "9b5"
    ],
    [
        "1P 3M 7m",
        "",
        "7no5"
    ],
    [
        "1P 3M 7m 13m",
        "",
        "7b13"
    ],
    [
        "1P 3M 7m 9M",
        "",
        "9no5"
    ],
    [
        "1P 3M 7m 9M 13M",
        "",
        "13no5"
    ],
    [
        "1P 3M 7m 9M 13m",
        "",
        "9b13"
    ],
    [
        "1P 3m 4P 5P",
        "",
        "madd4"
    ],
    [
        "1P 3m 5P 6m 7M",
        "",
        "mMaj7b6"
    ],
    [
        "1P 3m 5P 6m 7M 9M",
        "",
        "mMaj9b6"
    ],
    [
        "1P 3m 5P 7m 11P",
        "",
        "m7add11 m7add4"
    ],
    [
        "1P 3m 5P 9M",
        "",
        "madd9"
    ],
    [
        "1P 3m 5d 6M 7M",
        "",
        "o7M7"
    ],
    [
        "1P 3m 5d 7M",
        "",
        "oM7"
    ],
    [
        "1P 3m 6m 7M",
        "",
        "mb6M7"
    ],
    [
        "1P 3m 6m 7m",
        "",
        "m7#5"
    ],
    [
        "1P 3m 6m 7m 9M",
        "",
        "m9#5"
    ],
    [
        "1P 3m 5A 7m 9M 11P",
        "",
        "m11A"
    ],
    [
        "1P 3m 6m 9m",
        "",
        "mb6b9"
    ],
    [
        "1P 2M 3m 5d 7m",
        "",
        "m9b5"
    ],
    [
        "1P 4P 5A 7M",
        "",
        "M7#5sus4"
    ],
    [
        "1P 4P 5A 7M 9M",
        "",
        "M9#5sus4"
    ],
    [
        "1P 4P 5A 7m",
        "",
        "7#5sus4"
    ],
    [
        "1P 4P 5P 7M",
        "",
        "M7sus4"
    ],
    [
        "1P 4P 5P 7M 9M",
        "",
        "M9sus4"
    ],
    [
        "1P 4P 5P 7m 9M",
        "",
        "9sus4 9sus"
    ],
    [
        "1P 4P 5P 7m 9M 13M",
        "",
        "13sus4 13sus"
    ],
    [
        "1P 4P 5P 7m 9m 13m",
        "",
        "7sus4b9b13 7b9b13sus4"
    ],
    [
        "1P 4P 7m 10m",
        "",
        "4 quartal"
    ],
    [
        "1P 5P 7m 9m 11P",
        "",
        "11b9"
    ]
];
var data_default = CHORDS;
// index.ts
var NoChordType = {
    ...(0, _pcset.EmptyPcset),
    name: "",
    quality: "Unknown",
    intervals: [],
    aliases: []
};
var dictionary = [];
var index = {};
function get(type) {
    return index[type] || NoChordType;
}
var chordType = get;
function names() {
    return dictionary.map((chord)=>chord.name).filter((x)=>x);
}
function symbols() {
    return dictionary.map((chord)=>chord.aliases[0]).filter((x)=>x);
}
function keys() {
    return Object.keys(index);
}
function all() {
    return dictionary.slice();
}
var entries = all;
function removeAll() {
    dictionary = [];
    index = {};
}
function add(intervals, aliases, fullName) {
    const quality = getQuality(intervals);
    const chord = {
        ...(0, _pcset.get)(intervals),
        name: fullName || "",
        quality,
        intervals,
        aliases
    };
    dictionary.push(chord);
    if (chord.name) index[chord.name] = chord;
    index[chord.setNum] = chord;
    index[chord.chroma] = chord;
    chord.aliases.forEach((alias)=>addAlias(chord, alias));
}
function addAlias(chord, alias) {
    index[alias] = chord;
}
function getQuality(intervals) {
    const has = (interval)=>intervals.indexOf(interval) !== -1;
    return has("5A") ? "Augmented" : has("3M") ? "Major" : has("5d") ? "Diminished" : has("3m") ? "Minor" : "Unknown";
}
data_default.forEach(([ivls, fullName, names2])=>add(ivls.split(" "), names2.split(" "), fullName));
dictionary.sort((a, b)=>a.setNum - b.setNum);
var chord_type_default = {
    names,
    symbols,
    get,
    all,
    add,
    removeAll,
    keys,
    // deprecated
    entries,
    chordType
};

},{"@tonaljs/pcset":"d6uTg","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"d6uTg":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyPcset", ()=>EmptyPcset);
parcelHelpers.export(exports, "chroma", ()=>chroma);
parcelHelpers.export(exports, "chromas", ()=>chromas);
parcelHelpers.export(exports, "default", ()=>pcset_default);
parcelHelpers.export(exports, "filter", ()=>filter);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "includes", ()=>includes);
parcelHelpers.export(exports, "intervals", ()=>intervals);
parcelHelpers.export(exports, "isChroma", ()=>isChroma);
parcelHelpers.export(exports, "isEqual", ()=>isEqual);
parcelHelpers.export(exports, "isNoteIncludedIn", ()=>isNoteIncludedIn);
parcelHelpers.export(exports, "isSubsetOf", ()=>isSubsetOf);
parcelHelpers.export(exports, "isSupersetOf", ()=>isSupersetOf);
parcelHelpers.export(exports, "modes", ()=>modes);
parcelHelpers.export(exports, "notes", ()=>notes);
parcelHelpers.export(exports, "num", ()=>num);
parcelHelpers.export(exports, "pcset", ()=>pcset);
var _collection = require("@tonaljs/collection");
var _pitchDistance = require("@tonaljs/pitch-distance");
var _pitchInterval = require("@tonaljs/pitch-interval");
var _pitchNote = require("@tonaljs/pitch-note");
var EmptyPcset = {
    empty: true,
    name: "",
    setNum: 0,
    chroma: "000000000000",
    normalized: "000000000000",
    intervals: []
};
var setNumToChroma = (num2)=>Number(num2).toString(2).padStart(12, "0");
var chromaToNumber = (chroma2)=>parseInt(chroma2, 2);
var REGEX = /^[01]{12}$/;
function isChroma(set) {
    return REGEX.test(set);
}
var isPcsetNum = (set)=>typeof set === "number" && set >= 0 && set <= 4095;
var isPcset = (set)=>set && isChroma(set.chroma);
var cache = {
    [EmptyPcset.chroma]: EmptyPcset
};
function get(src) {
    const chroma2 = isChroma(src) ? src : isPcsetNum(src) ? setNumToChroma(src) : Array.isArray(src) ? listToChroma(src) : isPcset(src) ? src.chroma : EmptyPcset.chroma;
    return cache[chroma2] = cache[chroma2] || chromaToPcset(chroma2);
}
var pcset = get;
var chroma = (set)=>get(set).chroma;
var intervals = (set)=>get(set).intervals;
var num = (set)=>get(set).setNum;
var IVLS = [
    "1P",
    "2m",
    "2M",
    "3m",
    "3M",
    "4P",
    "5d",
    "5P",
    "6m",
    "6M",
    "7m",
    "7M"
];
function chromaToIntervals(chroma2) {
    const intervals2 = [];
    for(let i = 0; i < 12; i++)if (chroma2.charAt(i) === "1") intervals2.push(IVLS[i]);
    return intervals2;
}
function notes(set) {
    return get(set).intervals.map((ivl)=>(0, _pitchDistance.transpose)("C", ivl));
}
function chromas() {
    return (0, _collection.range)(2048, 4095).map(setNumToChroma);
}
function modes(set, normalize = true) {
    const pcs = get(set);
    const binary = pcs.chroma.split("");
    return (0, _collection.compact)(binary.map((_, i)=>{
        const r = (0, _collection.rotate)(i, binary);
        return normalize && r[0] === "0" ? null : r.join("");
    }));
}
function isEqual(s1, s2) {
    return get(s1).setNum === get(s2).setNum;
}
function isSubsetOf(set) {
    const s = get(set).setNum;
    return (notes2)=>{
        const o = get(notes2).setNum;
        return s && s !== o && (o & s) === o;
    };
}
function isSupersetOf(set) {
    const s = get(set).setNum;
    return (notes2)=>{
        const o = get(notes2).setNum;
        return s && s !== o && (o | s) === o;
    };
}
function isNoteIncludedIn(set) {
    const s = get(set);
    return (noteName)=>{
        const n = (0, _pitchNote.note)(noteName);
        return s && !n.empty && s.chroma.charAt(n.chroma) === "1";
    };
}
var includes = isNoteIncludedIn;
function filter(set) {
    const isIncluded = isNoteIncludedIn(set);
    return (notes2)=>{
        return notes2.filter(isIncluded);
    };
}
var pcset_default = {
    get,
    chroma,
    num,
    intervals,
    chromas,
    isSupersetOf,
    isSubsetOf,
    isNoteIncludedIn,
    isEqual,
    filter,
    modes,
    notes,
    // deprecated
    pcset
};
function chromaRotations(chroma2) {
    const binary = chroma2.split("");
    return binary.map((_, i)=>(0, _collection.rotate)(i, binary).join(""));
}
function chromaToPcset(chroma2) {
    const setNum = chromaToNumber(chroma2);
    const normalizedNum = chromaRotations(chroma2).map(chromaToNumber).filter((n)=>n >= 2048).sort()[0];
    const normalized = setNumToChroma(normalizedNum);
    const intervals2 = chromaToIntervals(chroma2);
    return {
        empty: false,
        name: "",
        setNum,
        chroma: chroma2,
        normalized,
        intervals: intervals2
    };
}
function listToChroma(set) {
    if (set.length === 0) return EmptyPcset.chroma;
    let pitch;
    const binary = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(let i = 0; i < set.length; i++){
        pitch = (0, _pitchNote.note)(set[i]);
        if (pitch.empty) pitch = (0, _pitchInterval.interval)(set[i]);
        if (!pitch.empty) binary[pitch.chroma] = 1;
    }
    return binary.join("");
}

},{"@tonaljs/collection":"eZd3r","@tonaljs/pitch-distance":"hUy2y","@tonaljs/pitch-interval":"76Nbo","@tonaljs/pitch-note":"4vzmL","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"eZd3r":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compact", ()=>compact);
parcelHelpers.export(exports, "default", ()=>collection_default);
parcelHelpers.export(exports, "permutations", ()=>permutations);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "rotate", ()=>rotate);
parcelHelpers.export(exports, "shuffle", ()=>shuffle);
function ascR(b, n) {
    const a = [];
    for(; n--; a[n] = n + b);
    return a;
}
function descR(b, n) {
    const a = [];
    for(; n--; a[n] = b - n);
    return a;
}
function range(from, to) {
    return from < to ? ascR(from, to - from + 1) : descR(from, from - to + 1);
}
function rotate(times, arr) {
    const len = arr.length;
    const n = (times % len + len) % len;
    return arr.slice(n, len).concat(arr.slice(0, n));
}
function compact(arr) {
    return arr.filter((n)=>n === 0 || n);
}
function shuffle(arr, rnd = Math.random) {
    let i;
    let t;
    let m = arr.length;
    while(m){
        i = Math.floor(rnd() * m--);
        t = arr[m];
        arr[m] = arr[i];
        arr[i] = t;
    }
    return arr;
}
function permutations(arr) {
    if (arr.length === 0) return [
        []
    ];
    return permutations(arr.slice(1)).reduce((acc, perm)=>{
        return acc.concat(arr.map((e, pos)=>{
            const newPerm = perm.slice();
            newPerm.splice(pos, 0, arr[0]);
            return newPerm;
        }));
    }, []);
}
var collection_default = {
    compact,
    permutations,
    range,
    rotate,
    shuffle
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"aFeW6":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "addTo", ()=>addTo);
parcelHelpers.export(exports, "default", ()=>interval_default);
parcelHelpers.export(exports, "distance", ()=>distance);
parcelHelpers.export(exports, "fromSemitones", ()=>fromSemitones);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "invert", ()=>invert);
parcelHelpers.export(exports, "name", ()=>name);
parcelHelpers.export(exports, "names", ()=>names);
parcelHelpers.export(exports, "num", ()=>num);
parcelHelpers.export(exports, "quality", ()=>quality);
parcelHelpers.export(exports, "semitones", ()=>semitones);
parcelHelpers.export(exports, "simplify", ()=>simplify);
parcelHelpers.export(exports, "subtract", ()=>subtract);
parcelHelpers.export(exports, "transposeFifths", ()=>transposeFifths);
var _pitchDistance = require("@tonaljs/pitch-distance");
var _pitchInterval = require("@tonaljs/pitch-interval");
function names() {
    return "1P 2M 3M 4P 5P 6m 7m".split(" ");
}
var get = (0, _pitchInterval.interval);
var name = (name2)=>(0, _pitchInterval.interval)(name2).name;
var semitones = (name2)=>(0, _pitchInterval.interval)(name2).semitones;
var quality = (name2)=>(0, _pitchInterval.interval)(name2).q;
var num = (name2)=>(0, _pitchInterval.interval)(name2).num;
function simplify(name2) {
    const i = (0, _pitchInterval.interval)(name2);
    return i.empty ? "" : i.simple + i.q;
}
function invert(name2) {
    const i = (0, _pitchInterval.interval)(name2);
    if (i.empty) return "";
    const step = (7 - i.step) % 7;
    const alt = i.type === "perfectable" ? -i.alt : -(i.alt + 1);
    return (0, _pitchInterval.interval)({
        step,
        alt,
        oct: i.oct,
        dir: i.dir
    }).name;
}
var IN = [
    1,
    2,
    2,
    3,
    3,
    4,
    5,
    5,
    6,
    6,
    7,
    7
];
var IQ = "P m M m M P d P m M m M".split(" ");
function fromSemitones(semitones2) {
    const d = semitones2 < 0 ? -1 : 1;
    const n = Math.abs(semitones2);
    const c = n % 12;
    const o = Math.floor(n / 12);
    return d * (IN[c] + 7 * o) + IQ[c];
}
var distance = (0, _pitchDistance.distance);
var add = combinator((a, b)=>[
        a[0] + b[0],
        a[1] + b[1]
    ]);
var addTo = (interval)=>(other)=>add(interval, other);
var subtract = combinator((a, b)=>[
        a[0] - b[0],
        a[1] - b[1]
    ]);
function transposeFifths(interval, fifths) {
    const ivl = get(interval);
    if (ivl.empty) return "";
    const [nFifths, nOcts, dir] = ivl.coord;
    return (0, _pitchInterval.coordToInterval)([
        nFifths + fifths,
        nOcts,
        dir
    ]).name;
}
var interval_default = {
    names,
    get,
    name,
    num,
    semitones,
    quality,
    fromSemitones,
    distance,
    invert,
    simplify,
    add,
    addTo,
    subtract,
    transposeFifths
};
function combinator(fn) {
    return (a, b)=>{
        const coordA = (0, _pitchInterval.interval)(a).coord;
        const coordB = (0, _pitchInterval.interval)(b).coord;
        if (coordA && coordB) {
            const coord = fn(coordA, coordB);
            return (0, _pitchInterval.coordToInterval)(coord).name;
        }
    };
}

},{"@tonaljs/pitch-distance":"hUy2y","@tonaljs/pitch-interval":"76Nbo","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"kiKIP":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoScaleType", ()=>NoScaleType);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "addAlias", ()=>addAlias);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "default", ()=>scale_type_default);
parcelHelpers.export(exports, "entries", ()=>entries);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "keys", ()=>keys);
parcelHelpers.export(exports, "names", ()=>names);
parcelHelpers.export(exports, "removeAll", ()=>removeAll);
parcelHelpers.export(exports, "scaleType", ()=>scaleType);
var _pcset = require("@tonaljs/pcset");
// data.ts
var SCALES = [
    // Basic scales
    [
        "1P 2M 3M 5P 6M",
        "major pentatonic",
        "pentatonic"
    ],
    [
        "1P 2M 3M 4P 5P 6M 7M",
        "major",
        "ionian"
    ],
    [
        "1P 2M 3m 4P 5P 6m 7m",
        "minor",
        "aeolian"
    ],
    // Jazz common scales
    [
        "1P 2M 3m 3M 5P 6M",
        "major blues"
    ],
    [
        "1P 3m 4P 5d 5P 7m",
        "minor blues",
        "blues"
    ],
    [
        "1P 2M 3m 4P 5P 6M 7M",
        "melodic minor"
    ],
    [
        "1P 2M 3m 4P 5P 6m 7M",
        "harmonic minor"
    ],
    [
        "1P 2M 3M 4P 5P 6M 7m 7M",
        "bebop"
    ],
    [
        "1P 2M 3m 4P 5d 6m 6M 7M",
        "diminished",
        "whole-half diminished"
    ],
    // Modes
    [
        "1P 2M 3m 4P 5P 6M 7m",
        "dorian"
    ],
    [
        "1P 2M 3M 4A 5P 6M 7M",
        "lydian"
    ],
    [
        "1P 2M 3M 4P 5P 6M 7m",
        "mixolydian",
        "dominant"
    ],
    [
        "1P 2m 3m 4P 5P 6m 7m",
        "phrygian"
    ],
    [
        "1P 2m 3m 4P 5d 6m 7m",
        "locrian"
    ],
    // 5-note scales
    [
        "1P 3M 4P 5P 7M",
        "ionian pentatonic"
    ],
    [
        "1P 3M 4P 5P 7m",
        "mixolydian pentatonic",
        "indian"
    ],
    [
        "1P 2M 4P 5P 6M",
        "ritusen"
    ],
    [
        "1P 2M 4P 5P 7m",
        "egyptian"
    ],
    [
        "1P 3M 4P 5d 7m",
        "neopolitan major pentatonic"
    ],
    [
        "1P 3m 4P 5P 6m",
        "vietnamese 1"
    ],
    [
        "1P 2m 3m 5P 6m",
        "pelog"
    ],
    [
        "1P 2m 4P 5P 6m",
        "kumoijoshi"
    ],
    [
        "1P 2M 3m 5P 6m",
        "hirajoshi"
    ],
    [
        "1P 2m 4P 5d 7m",
        "iwato"
    ],
    [
        "1P 2m 4P 5P 7m",
        "in-sen"
    ],
    [
        "1P 3M 4A 5P 7M",
        "lydian pentatonic",
        "chinese"
    ],
    [
        "1P 3m 4P 6m 7m",
        "malkos raga"
    ],
    [
        "1P 3m 4P 5d 7m",
        "locrian pentatonic",
        "minor seven flat five pentatonic"
    ],
    [
        "1P 3m 4P 5P 7m",
        "minor pentatonic",
        "vietnamese 2"
    ],
    [
        "1P 3m 4P 5P 6M",
        "minor six pentatonic"
    ],
    [
        "1P 2M 3m 5P 6M",
        "flat three pentatonic",
        "kumoi"
    ],
    [
        "1P 2M 3M 5P 6m",
        "flat six pentatonic"
    ],
    [
        "1P 2m 3M 5P 6M",
        "scriabin"
    ],
    [
        "1P 3M 5d 6m 7m",
        "whole tone pentatonic"
    ],
    [
        "1P 3M 4A 5A 7M",
        "lydian #5P pentatonic"
    ],
    [
        "1P 3M 4A 5P 7m",
        "lydian dominant pentatonic"
    ],
    [
        "1P 3m 4P 5P 7M",
        "minor #7M pentatonic"
    ],
    [
        "1P 3m 4d 5d 7m",
        "super locrian pentatonic"
    ],
    // 6-note scales
    [
        "1P 2M 3m 4P 5P 7M",
        "minor hexatonic"
    ],
    [
        "1P 2A 3M 5P 5A 7M",
        "augmented"
    ],
    [
        "1P 2M 4P 5P 6M 7m",
        "piongio"
    ],
    [
        "1P 2m 3M 4A 6M 7m",
        "prometheus neopolitan"
    ],
    [
        "1P 2M 3M 4A 6M 7m",
        "prometheus"
    ],
    [
        "1P 2m 3M 5d 6m 7m",
        "mystery #1"
    ],
    [
        "1P 2m 3M 4P 5A 6M",
        "six tone symmetric"
    ],
    [
        "1P 2M 3M 4A 5A 6A",
        "whole tone",
        "messiaen's mode #1"
    ],
    [
        "1P 2m 4P 4A 5P 7M",
        "messiaen's mode #5"
    ],
    // 7-note scales
    [
        "1P 2M 3M 4P 5d 6m 7m",
        "locrian major",
        "arabian"
    ],
    [
        "1P 2m 3M 4A 5P 6m 7M",
        "double harmonic lydian"
    ],
    [
        "1P 2m 2A 3M 4A 6m 7m",
        "altered",
        "super locrian",
        "diminished whole tone",
        "pomeroy"
    ],
    [
        "1P 2M 3m 4P 5d 6m 7m",
        "locrian #2",
        "half-diminished",
        "aeolian b5"
    ],
    [
        "1P 2M 3M 4P 5P 6m 7m",
        "mixolydian b6",
        "melodic minor fifth mode",
        "hindu"
    ],
    [
        "1P 2M 3M 4A 5P 6M 7m",
        "lydian dominant",
        "lydian b7",
        "overtone"
    ],
    [
        "1P 2M 3M 4A 5A 6M 7M",
        "lydian augmented"
    ],
    [
        "1P 2m 3m 4P 5P 6M 7m",
        "dorian b2",
        "phrygian #6",
        "melodic minor second mode"
    ],
    [
        "1P 2m 3m 4d 5d 6m 7d",
        "ultralocrian",
        "superlocrian bb7",
        "superlocrian diminished"
    ],
    [
        "1P 2m 3m 4P 5d 6M 7m",
        "locrian 6",
        "locrian natural 6",
        "locrian sharp 6"
    ],
    [
        "1P 2A 3M 4P 5P 5A 7M",
        "augmented heptatonic"
    ],
    // Source https://en.wikipedia.org/wiki/Ukrainian_Dorian_scale
    [
        "1P 2M 3m 4A 5P 6M 7m",
        "dorian #4",
        "ukrainian dorian",
        "romanian minor",
        "altered dorian"
    ],
    [
        "1P 2M 3m 4A 5P 6M 7M",
        "lydian diminished"
    ],
    [
        "1P 2M 3M 4A 5A 7m 7M",
        "leading whole tone"
    ],
    [
        "1P 2M 3M 4A 5P 6m 7m",
        "lydian minor"
    ],
    [
        "1P 2m 3M 4P 5P 6m 7m",
        "phrygian dominant",
        "spanish",
        "phrygian major"
    ],
    [
        "1P 2m 3m 4P 5P 6m 7M",
        "balinese"
    ],
    [
        "1P 2m 3m 4P 5P 6M 7M",
        "neopolitan major"
    ],
    [
        "1P 2M 3M 4P 5P 6m 7M",
        "harmonic major"
    ],
    [
        "1P 2m 3M 4P 5P 6m 7M",
        "double harmonic major",
        "gypsy"
    ],
    [
        "1P 2M 3m 4A 5P 6m 7M",
        "hungarian minor"
    ],
    [
        "1P 2A 3M 4A 5P 6M 7m",
        "hungarian major"
    ],
    [
        "1P 2m 3M 4P 5d 6M 7m",
        "oriental"
    ],
    [
        "1P 2m 3m 3M 4A 5P 7m",
        "flamenco"
    ],
    [
        "1P 2m 3m 4A 5P 6m 7M",
        "todi raga"
    ],
    [
        "1P 2m 3M 4P 5d 6m 7M",
        "persian"
    ],
    [
        "1P 2m 3M 5d 6m 7m 7M",
        "enigmatic"
    ],
    [
        "1P 2M 3M 4P 5A 6M 7M",
        "major augmented",
        "major #5",
        "ionian augmented",
        "ionian #5"
    ],
    [
        "1P 2A 3M 4A 5P 6M 7M",
        "lydian #9"
    ],
    // 8-note scales
    [
        "1P 2m 2M 4P 4A 5P 6m 7M",
        "messiaen's mode #4"
    ],
    [
        "1P 2m 3M 4P 4A 5P 6m 7M",
        "purvi raga"
    ],
    [
        "1P 2m 3m 3M 4P 5P 6m 7m",
        "spanish heptatonic"
    ],
    [
        "1P 2M 3m 3M 4P 5P 6M 7m",
        "bebop minor"
    ],
    [
        "1P 2M 3M 4P 5P 5A 6M 7M",
        "bebop major"
    ],
    [
        "1P 2m 3m 4P 5d 5P 6m 7m",
        "bebop locrian"
    ],
    [
        "1P 2M 3m 4P 5P 6m 7m 7M",
        "minor bebop"
    ],
    [
        "1P 2M 3M 4P 5d 5P 6M 7M",
        "ichikosucho"
    ],
    [
        "1P 2M 3m 4P 5P 6m 6M 7M",
        "minor six diminished"
    ],
    [
        "1P 2m 3m 3M 4A 5P 6M 7m",
        "half-whole diminished",
        "dominant diminished",
        "messiaen's mode #2"
    ],
    [
        "1P 3m 3M 4P 5P 6M 7m 7M",
        "kafi raga"
    ],
    [
        "1P 2M 3M 4P 4A 5A 6A 7M",
        "messiaen's mode #6"
    ],
    // 9-note scales
    [
        "1P 2M 3m 3M 4P 5d 5P 6M 7m",
        "composite blues"
    ],
    [
        "1P 2M 3m 3M 4A 5P 6m 7m 7M",
        "messiaen's mode #3"
    ],
    // 10-note scales
    [
        "1P 2m 2M 3m 4P 4A 5P 6m 6M 7M",
        "messiaen's mode #7"
    ],
    // 12-note scales
    [
        "1P 2m 2M 3m 3M 4P 5d 5P 6m 6M 7m 7M",
        "chromatic"
    ]
];
var data_default = SCALES;
// index.ts
var NoScaleType = {
    ...(0, _pcset.EmptyPcset),
    intervals: [],
    aliases: []
};
var dictionary = [];
var index = {};
function names() {
    return dictionary.map((scale)=>scale.name);
}
function get(type) {
    return index[type] || NoScaleType;
}
var scaleType = get;
function all() {
    return dictionary.slice();
}
var entries = all;
function keys() {
    return Object.keys(index);
}
function removeAll() {
    dictionary = [];
    index = {};
}
function add(intervals, name, aliases = []) {
    const scale = {
        ...(0, _pcset.get)(intervals),
        name,
        intervals,
        aliases
    };
    dictionary.push(scale);
    index[scale.name] = scale;
    index[scale.setNum] = scale;
    index[scale.chroma] = scale;
    scale.aliases.forEach((alias)=>addAlias(scale, alias));
    return scale;
}
function addAlias(scale, alias) {
    index[alias] = scale;
}
data_default.forEach(([ivls, name, ...aliases])=>add(ivls.split(" "), name, aliases));
var scale_type_default = {
    names,
    get,
    all,
    add,
    removeAll,
    keys,
    // deprecated
    entries,
    scaleType
};

},{"@tonaljs/pcset":"d6uTg","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"kuUaL":[function(require,module,exports,__globalThis) {
// data.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>duration_value_default);
parcelHelpers.export(exports, "fraction", ()=>fraction);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "names", ()=>names);
parcelHelpers.export(exports, "shorthands", ()=>shorthands);
parcelHelpers.export(exports, "value", ()=>value);
var DATA = [
    [
        0.125,
        "dl",
        [
            "large",
            "duplex longa",
            "maxima",
            "octuple",
            "octuple whole"
        ]
    ],
    [
        0.25,
        "l",
        [
            "long",
            "longa"
        ]
    ],
    [
        0.5,
        "d",
        [
            "double whole",
            "double",
            "breve"
        ]
    ],
    [
        1,
        "w",
        [
            "whole",
            "semibreve"
        ]
    ],
    [
        2,
        "h",
        [
            "half",
            "minim"
        ]
    ],
    [
        4,
        "q",
        [
            "quarter",
            "crotchet"
        ]
    ],
    [
        8,
        "e",
        [
            "eighth",
            "quaver"
        ]
    ],
    [
        16,
        "s",
        [
            "sixteenth",
            "semiquaver"
        ]
    ],
    [
        32,
        "t",
        [
            "thirty-second",
            "demisemiquaver"
        ]
    ],
    [
        64,
        "sf",
        [
            "sixty-fourth",
            "hemidemisemiquaver"
        ]
    ],
    [
        128,
        "h",
        [
            "hundred twenty-eighth"
        ]
    ],
    [
        256,
        "th",
        [
            "two hundred fifty-sixth"
        ]
    ]
];
var data_default = DATA;
// index.ts
var VALUES = [];
data_default.forEach(([denominator, shorthand, names2])=>add(denominator, shorthand, names2));
var NoDuration = {
    empty: true,
    name: "",
    value: 0,
    fraction: [
        0,
        0
    ],
    shorthand: "",
    dots: "",
    names: []
};
function names() {
    return VALUES.reduce((names2, duration)=>{
        duration.names.forEach((name)=>names2.push(name));
        return names2;
    }, []);
}
function shorthands() {
    return VALUES.map((dur)=>dur.shorthand);
}
var REGEX = /^([^.]+)(\.*)$/;
function get(name) {
    const [_, simple, dots] = REGEX.exec(name) || [];
    const base = VALUES.find((dur)=>dur.shorthand === simple || dur.names.includes(simple));
    if (!base) return NoDuration;
    const fraction2 = calcDots(base.fraction, dots.length);
    const value2 = fraction2[0] / fraction2[1];
    return {
        ...base,
        name,
        dots,
        value: value2,
        fraction: fraction2
    };
}
var value = (name)=>get(name).value;
var fraction = (name)=>get(name).fraction;
var duration_value_default = {
    names,
    shorthands,
    get,
    value,
    fraction
};
function add(denominator, shorthand, names2) {
    VALUES.push({
        empty: false,
        dots: "",
        name: "",
        value: 1 / denominator,
        fraction: denominator < 1 ? [
            1 / denominator,
            1
        ] : [
            1,
            denominator
        ],
        shorthand,
        names: names2
    });
}
function calcDots(fraction2, dots) {
    const pow = Math.pow(2, dots);
    let numerator = fraction2[0] * pow;
    let denominator = fraction2[1] * pow;
    const base = numerator;
    for(let i = 0; i < dots; i++)numerator += base / Math.pow(2, i + 1);
    while(numerator % 2 === 0 && denominator % 2 === 0){
        numerator /= 2;
        denominator /= 2;
    }
    return [
        numerator,
        denominator
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"diJKE":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "majorKey", ()=>majorKey);
parcelHelpers.export(exports, "majorKeyChords", ()=>majorKeyChords);
parcelHelpers.export(exports, "majorTonicFromKeySignature", ()=>majorTonicFromKeySignature);
parcelHelpers.export(exports, "minorKey", ()=>minorKey);
parcelHelpers.export(exports, "minorKeyChords", ()=>minorKeyChords);
var _note = require("@tonaljs/note");
var _pitchNote = require("@tonaljs/pitch-note");
var _romanNumeral = require("@tonaljs/roman-numeral");
var Empty = Object.freeze([]);
var NoKey = {
    type: "major",
    tonic: "",
    alteration: 0,
    keySignature: ""
};
var NoKeyScale = {
    tonic: "",
    grades: Empty,
    intervals: Empty,
    scale: Empty,
    triads: Empty,
    chords: Empty,
    chordsHarmonicFunction: Empty,
    chordScales: Empty,
    secondaryDominants: Empty,
    secondaryDominantSupertonics: Empty,
    substituteDominantsMinorRelative: Empty,
    substituteDominants: Empty,
    substituteDominantSupertonics: Empty,
    secondaryDominantsMinorRelative: Empty
};
var NoMajorKey = {
    ...NoKey,
    ...NoKeyScale,
    type: "major",
    minorRelative: "",
    scale: Empty,
    substituteDominants: Empty,
    secondaryDominantSupertonics: Empty,
    substituteDominantsMinorRelative: Empty
};
var NoMinorKey = {
    ...NoKey,
    type: "minor",
    relativeMajor: "",
    natural: NoKeyScale,
    harmonic: NoKeyScale,
    melodic: NoKeyScale
};
var mapScaleToType = (scale, list, sep = "")=>list.map((type, i)=>`${scale[i]}${sep}${type}`);
function keyScale(grades, triads, chordTypes, harmonicFunctions, chordScales) {
    return (tonic)=>{
        const intervals = grades.map((gr)=>(0, _romanNumeral.get)(gr).interval || "");
        const scale = intervals.map((interval)=>(0, _note.transpose)(tonic, interval));
        const chords = mapScaleToType(scale, chordTypes);
        const secondaryDominants = scale.map((note2)=>(0, _note.transpose)(note2, "5P")).map((note2)=>// A secondary dominant is a V chord which:
            // 1. is not diatonic to the key,
            // 2. it must have a diatonic root.
            scale.includes(note2) && !chords.includes(note2 + "7") ? note2 + "7" : "");
        const secondaryDominantSupertonics = supertonics(secondaryDominants, triads);
        const substituteDominants = secondaryDominants.map((chord)=>{
            if (!chord) return "";
            const domRoot = chord.slice(0, -1);
            const subRoot = (0, _note.transpose)(domRoot, "5d");
            return subRoot + "7";
        });
        const substituteDominantSupertonics = supertonics(substituteDominants, triads);
        return {
            tonic,
            grades,
            intervals,
            scale,
            triads: mapScaleToType(scale, triads),
            chords,
            chordsHarmonicFunction: harmonicFunctions.slice(),
            chordScales: mapScaleToType(scale, chordScales, " "),
            secondaryDominants,
            secondaryDominantSupertonics,
            substituteDominants,
            substituteDominantSupertonics,
            // @deprecated use secondaryDominantsSupertonic
            secondaryDominantsMinorRelative: secondaryDominantSupertonics,
            // @deprecated use secondaryDominantsSupertonic
            substituteDominantsMinorRelative: substituteDominantSupertonics
        };
    };
}
var supertonics = (dominants, targetTriads)=>{
    return dominants.map((chord, index)=>{
        if (!chord) return "";
        const domRoot = chord.slice(0, -1);
        const minorRoot = (0, _note.transpose)(domRoot, "5P");
        const target = targetTriads[index];
        const isMinor = target.endsWith("m");
        return isMinor ? minorRoot + "m7" : minorRoot + "m7b5";
    });
};
var distInFifths = (from, to)=>{
    const f = (0, _pitchNote.note)(from);
    const t = (0, _pitchNote.note)(to);
    return f.empty || t.empty ? 0 : t.coord[0] - f.coord[0];
};
var MajorScale = keyScale("I II III IV V VI VII".split(" "), " m m   m dim".split(" "), "maj7 m7 m7 maj7 7 m7 m7b5".split(" "), "T SD T SD D T D".split(" "), "major,dorian,phrygian,lydian,mixolydian,minor,locrian".split(","));
var NaturalScale = keyScale("I II bIII IV V bVI bVII".split(" "), "m dim  m m  ".split(" "), "m7 m7b5 maj7 m7 m7 maj7 7".split(" "), "T SD T SD D SD SD".split(" "), "minor,locrian,major,dorian,phrygian,lydian,mixolydian".split(","));
var HarmonicScale = keyScale("I II bIII IV V bVI VII".split(" "), "m dim aug m   dim".split(" "), "mMaj7 m7b5 +maj7 m7 7 maj7 o7".split(" "), "T SD T SD D SD D".split(" "), "harmonic minor,locrian 6,major augmented,lydian diminished,phrygian dominant,lydian #9,ultralocrian".split(","));
var MelodicScale = keyScale("I II bIII IV V VI VII".split(" "), "m m aug   dim dim".split(" "), "m6 m7 +maj7 7 7 m7b5 m7b5".split(" "), "T SD T SD D  ".split(" "), "melodic minor,dorian b2,lydian augmented,lydian dominant,mixolydian b6,locrian #2,altered".split(","));
function majorKey(tonic) {
    const pc = (0, _pitchNote.note)(tonic).pc;
    if (!pc) return NoMajorKey;
    const keyScale2 = MajorScale(pc);
    const alteration = distInFifths("C", pc);
    return {
        ...keyScale2,
        type: "major",
        minorRelative: (0, _note.transpose)(pc, "-3m"),
        alteration,
        keySignature: (0, _pitchNote.altToAcc)(alteration)
    };
}
function majorKeyChords(tonic) {
    const key = majorKey(tonic);
    const chords = [];
    keyChordsOf(key, chords);
    return chords;
}
function minorKeyChords(tonic) {
    const key = minorKey(tonic);
    const chords = [];
    keyChordsOf(key.natural, chords);
    keyChordsOf(key.harmonic, chords);
    keyChordsOf(key.melodic, chords);
    return chords;
}
function keyChordsOf(key, chords) {
    const updateChord = (name, newRole)=>{
        if (!name) return;
        let keyChord = chords.find((chord)=>chord.name === name);
        if (!keyChord) {
            keyChord = {
                name,
                roles: []
            };
            chords.push(keyChord);
        }
        if (newRole && !keyChord.roles.includes(newRole)) keyChord.roles.push(newRole);
    };
    key.chords.forEach((chordName, index)=>updateChord(chordName, key.chordsHarmonicFunction[index]));
    key.secondaryDominants.forEach((chordName, index)=>updateChord(chordName, `V/${key.grades[index]}`));
    key.secondaryDominantSupertonics.forEach((chordName, index)=>updateChord(chordName, `ii/${key.grades[index]}`));
    key.substituteDominants.forEach((chordName, index)=>updateChord(chordName, `subV/${key.grades[index]}`));
    key.substituteDominantSupertonics.forEach((chordName, index)=>updateChord(chordName, `subii/${key.grades[index]}`));
}
function minorKey(tnc) {
    const pc = (0, _pitchNote.note)(tnc).pc;
    if (!pc) return NoMinorKey;
    const alteration = distInFifths("C", pc) - 3;
    return {
        type: "minor",
        tonic: pc,
        relativeMajor: (0, _note.transpose)(pc, "3m"),
        alteration,
        keySignature: (0, _pitchNote.altToAcc)(alteration),
        natural: NaturalScale(pc),
        harmonic: HarmonicScale(pc),
        melodic: MelodicScale(pc)
    };
}
function majorTonicFromKeySignature(sig) {
    if (typeof sig === "number") return (0, _note.transposeFifths)("C", sig);
    else if (typeof sig === "string" && /^b+|#+$/.test(sig)) return (0, _note.transposeFifths)("C", (0, _pitchNote.accToAlt)(sig));
    return null;
}
var index_default = {
    majorKey,
    majorTonicFromKeySignature,
    minorKey
};

},{"@tonaljs/note":"kNy38","@tonaljs/pitch-note":"4vzmL","@tonaljs/roman-numeral":"2rpBM","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"kNy38":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "accidentals", ()=>accidentals);
parcelHelpers.export(exports, "ascending", ()=>ascending);
parcelHelpers.export(exports, "chroma", ()=>chroma);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "descending", ()=>descending);
parcelHelpers.export(exports, "distance", ()=>distance);
parcelHelpers.export(exports, "enharmonic", ()=>enharmonic);
parcelHelpers.export(exports, "freq", ()=>freq);
parcelHelpers.export(exports, "fromFreq", ()=>fromFreq);
parcelHelpers.export(exports, "fromFreqSharps", ()=>fromFreqSharps);
parcelHelpers.export(exports, "fromMidi", ()=>fromMidi);
parcelHelpers.export(exports, "fromMidiSharps", ()=>fromMidiSharps);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "midi", ()=>midi);
parcelHelpers.export(exports, "name", ()=>name);
parcelHelpers.export(exports, "names", ()=>names);
parcelHelpers.export(exports, "octave", ()=>octave);
parcelHelpers.export(exports, "pitchClass", ()=>pitchClass);
parcelHelpers.export(exports, "simplify", ()=>simplify);
parcelHelpers.export(exports, "sortedNames", ()=>sortedNames);
parcelHelpers.export(exports, "sortedUniqNames", ()=>sortedUniqNames);
parcelHelpers.export(exports, "tr", ()=>tr);
parcelHelpers.export(exports, "trBy", ()=>trBy);
parcelHelpers.export(exports, "trFifths", ()=>trFifths);
parcelHelpers.export(exports, "trFrom", ()=>trFrom);
parcelHelpers.export(exports, "transpose", ()=>transpose);
parcelHelpers.export(exports, "transposeBy", ()=>transposeBy);
parcelHelpers.export(exports, "transposeFifths", ()=>transposeFifths);
parcelHelpers.export(exports, "transposeFrom", ()=>transposeFrom);
parcelHelpers.export(exports, "transposeOctaves", ()=>transposeOctaves);
var _midi = require("@tonaljs/midi");
var _pitchDistance = require("@tonaljs/pitch-distance");
var _pitchNote = require("@tonaljs/pitch-note");
var NAMES = [
    "C",
    "D",
    "E",
    "F",
    "G",
    "A",
    "B"
];
var toName = (n)=>n.name;
var onlyNotes = (array)=>array.map((0, _pitchNote.note)).filter((n)=>!n.empty);
function names(array) {
    if (array === void 0) return NAMES.slice();
    else if (!Array.isArray(array)) return [];
    else return onlyNotes(array).map(toName);
}
var get = (0, _pitchNote.note);
var name = (note)=>get(note).name;
var pitchClass = (note)=>get(note).pc;
var accidentals = (note)=>get(note).acc;
var octave = (note)=>get(note).oct;
var midi = (note)=>get(note).midi;
var freq = (note)=>get(note).freq;
var chroma = (note)=>get(note).chroma;
function fromMidi(midi2) {
    return (0, _midi.midiToNoteName)(midi2);
}
function fromFreq(freq2) {
    return (0, _midi.midiToNoteName)((0, _midi.freqToMidi)(freq2));
}
function fromFreqSharps(freq2) {
    return (0, _midi.midiToNoteName)((0, _midi.freqToMidi)(freq2), {
        sharps: true
    });
}
function fromMidiSharps(midi2) {
    return (0, _midi.midiToNoteName)(midi2, {
        sharps: true
    });
}
var distance = (0, _pitchDistance.distance);
var transpose = (0, _pitchDistance.transpose);
var tr = (0, _pitchDistance.transpose);
var transposeBy = (interval)=>(note)=>transpose(note, interval);
var trBy = transposeBy;
var transposeFrom = (note)=>(interval)=>transpose(note, interval);
var trFrom = transposeFrom;
function transposeFifths(noteName, fifths) {
    return transpose(noteName, [
        fifths,
        0
    ]);
}
var trFifths = transposeFifths;
function transposeOctaves(noteName, octaves) {
    return transpose(noteName, [
        0,
        octaves
    ]);
}
var ascending = (a, b)=>a.height - b.height;
var descending = (a, b)=>b.height - a.height;
function sortedNames(notes, comparator) {
    comparator = comparator || ascending;
    return onlyNotes(notes).sort(comparator).map(toName);
}
function sortedUniqNames(notes) {
    return sortedNames(notes, ascending).filter((n, i, a)=>i === 0 || n !== a[i - 1]);
}
var simplify = (noteName)=>{
    const note = get(noteName);
    if (note.empty) return "";
    return (0, _midi.midiToNoteName)(note.midi || note.chroma, {
        sharps: note.alt > 0,
        pitchClass: note.midi === null
    });
};
function enharmonic(noteName, destName) {
    const src = get(noteName);
    if (src.empty) return "";
    const dest = get(destName || (0, _midi.midiToNoteName)(src.midi || src.chroma, {
        sharps: src.alt < 0,
        pitchClass: true
    }));
    if (dest.empty || dest.chroma !== src.chroma) return "";
    if (src.oct === void 0) return dest.pc;
    const srcChroma = src.chroma - src.alt;
    const destChroma = dest.chroma - dest.alt;
    const destOctOffset = srcChroma > 11 || destChroma < 0 ? -1 : srcChroma < 0 || destChroma > 11 ? 1 : 0;
    const destOct = src.oct + destOctOffset;
    return dest.pc + destOct;
}
var index_default = {
    names,
    get,
    name,
    pitchClass,
    accidentals,
    octave,
    midi,
    ascending,
    descending,
    distance,
    sortedNames,
    sortedUniqNames,
    fromMidi,
    fromMidiSharps,
    freq,
    fromFreq,
    fromFreqSharps,
    chroma,
    transpose,
    tr,
    transposeBy,
    trBy,
    transposeFrom,
    trFrom,
    transposeFifths,
    transposeOctaves,
    trFifths,
    simplify,
    enharmonic
};

},{"@tonaljs/midi":"ywjEO","@tonaljs/pitch-distance":"hUy2y","@tonaljs/pitch-note":"4vzmL","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"ywjEO":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chroma", ()=>chroma);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "freqToMidi", ()=>freqToMidi);
parcelHelpers.export(exports, "isMidi", ()=>isMidi);
parcelHelpers.export(exports, "midiToFreq", ()=>midiToFreq);
parcelHelpers.export(exports, "midiToNoteName", ()=>midiToNoteName);
parcelHelpers.export(exports, "pcset", ()=>pcset);
parcelHelpers.export(exports, "pcsetDegrees", ()=>pcsetDegrees);
parcelHelpers.export(exports, "pcsetNearest", ()=>pcsetNearest);
parcelHelpers.export(exports, "pcsetSteps", ()=>pcsetSteps);
parcelHelpers.export(exports, "toMidi", ()=>toMidi);
var _pitchNote = require("@tonaljs/pitch-note");
function isMidi(arg) {
    return +arg >= 0 && +arg <= 127;
}
function toMidi(note) {
    if (isMidi(note)) return +note;
    const n = (0, _pitchNote.note)(note);
    return n.empty ? null : n.midi;
}
function midiToFreq(midi, tuning = 440) {
    return Math.pow(2, (midi - 69) / 12) * tuning;
}
var L2 = Math.log(2);
var L440 = Math.log(440);
function freqToMidi(freq) {
    const v = 12 * (Math.log(freq) - L440) / L2 + 69;
    return Math.round(v * 100) / 100;
}
var SHARPS = "C C# D D# E F F# G G# A A# B".split(" ");
var FLATS = "C Db D Eb E F Gb G Ab A Bb B".split(" ");
function midiToNoteName(midi, options = {}) {
    if (isNaN(midi) || midi === -Infinity || midi === Infinity) return "";
    midi = Math.round(midi);
    const pcs = options.sharps === true ? SHARPS : FLATS;
    const pc = pcs[midi % 12];
    if (options.pitchClass) return pc;
    const o = Math.floor(midi / 12) - 1;
    return pc + o;
}
function chroma(midi) {
    return midi % 12;
}
function pcsetFromChroma(chroma2) {
    return chroma2.split("").reduce((pcset2, val, index)=>{
        if (index < 12 && val === "1") pcset2.push(index);
        return pcset2;
    }, []);
}
function pcsetFromMidi(midi) {
    return midi.map(chroma).sort((a, b)=>a - b).filter((n, i, a)=>i === 0 || n !== a[i - 1]);
}
function pcset(notes) {
    return Array.isArray(notes) ? pcsetFromMidi(notes) : pcsetFromChroma(notes);
}
function pcsetNearest(notes) {
    const set = pcset(notes);
    return (midi)=>{
        const ch = chroma(midi);
        for(let i = 0; i < 12; i++){
            if (set.includes(ch + i)) return midi + i;
            if (set.includes(ch - i)) return midi - i;
        }
        return void 0;
    };
}
function pcsetSteps(notes, tonic) {
    const set = pcset(notes);
    const len = set.length;
    return (step)=>{
        const index = step < 0 ? (len - -step % len) % len : step % len;
        const octaves = Math.floor(step / len);
        return set[index] + octaves * 12 + tonic;
    };
}
function pcsetDegrees(notes, tonic) {
    const steps = pcsetSteps(notes, tonic);
    return (degree)=>{
        if (degree === 0) return void 0;
        return steps(degree > 0 ? degree - 1 : degree);
    };
}
var index_default = {
    chroma,
    freqToMidi,
    isMidi,
    midiToFreq,
    midiToNoteName,
    pcsetNearest,
    pcset,
    pcsetDegrees,
    pcsetSteps,
    toMidi
};

},{"@tonaljs/pitch-note":"4vzmL","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"2rpBM":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>roman_numeral_default);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "names", ()=>names);
parcelHelpers.export(exports, "romanNumeral", ()=>romanNumeral);
parcelHelpers.export(exports, "tokenize", ()=>tokenize);
var _pitch = require("@tonaljs/pitch");
var _pitchInterval = require("@tonaljs/pitch-interval");
var _pitchNote = require("@tonaljs/pitch-note");
var NoRomanNumeral = {
    empty: true,
    name: "",
    chordType: ""
};
var cache = {};
function get(src) {
    return typeof src === "string" ? cache[src] || (cache[src] = parse(src)) : typeof src === "number" ? get(NAMES[src] || "") : (0, _pitch.isPitch)(src) ? fromPitch(src) : (0, _pitch.isNamedPitch)(src) ? get(src.name) : NoRomanNumeral;
}
var romanNumeral = get;
function names(major = true) {
    return (major ? NAMES : NAMES_MINOR).slice();
}
function fromPitch(pitch) {
    return get((0, _pitchNote.altToAcc)(pitch.alt) + NAMES[pitch.step]);
}
var REGEX = /^(#{1,}|b{1,}|x{1,}|)(IV|I{1,3}|VI{0,2}|iv|i{1,3}|vi{0,2})([^IViv]*)$/;
function tokenize(str) {
    return REGEX.exec(str) || [
        "",
        "",
        "",
        ""
    ];
}
var ROMANS = "I II III IV V VI VII";
var NAMES = ROMANS.split(" ");
var NAMES_MINOR = ROMANS.toLowerCase().split(" ");
function parse(src) {
    const [name, acc, roman, chordType] = tokenize(src);
    if (!roman) return NoRomanNumeral;
    const upperRoman = roman.toUpperCase();
    const step = NAMES.indexOf(upperRoman);
    const alt = (0, _pitchNote.accToAlt)(acc);
    const dir = 1;
    return {
        empty: false,
        name,
        roman,
        interval: (0, _pitchInterval.interval)({
            step,
            alt,
            dir
        }).name,
        acc,
        chordType,
        alt,
        step,
        major: roman === upperRoman,
        oct: 0,
        dir
    };
}
var roman_numeral_default = {
    names,
    get,
    // deprecated
    romanNumeral
};

},{"@tonaljs/pitch":"2v7nB","@tonaljs/pitch-interval":"76Nbo","@tonaljs/pitch-note":"4vzmL","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"eO6JV":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "default", ()=>mode_default);
parcelHelpers.export(exports, "distance", ()=>distance);
parcelHelpers.export(exports, "entries", ()=>entries);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "mode", ()=>mode);
parcelHelpers.export(exports, "names", ()=>names);
parcelHelpers.export(exports, "notes", ()=>notes);
parcelHelpers.export(exports, "relativeTonic", ()=>relativeTonic);
parcelHelpers.export(exports, "seventhChords", ()=>seventhChords);
parcelHelpers.export(exports, "triads", ()=>triads);
var _collection = require("@tonaljs/collection");
var _interval = require("@tonaljs/interval");
var _pcset = require("@tonaljs/pcset");
var _pitchDistance = require("@tonaljs/pitch-distance");
var _scaleType = require("@tonaljs/scale-type");
var MODES = [
    [
        0,
        2773,
        0,
        "ionian",
        "",
        "Maj7",
        "major"
    ],
    [
        1,
        2902,
        2,
        "dorian",
        "m",
        "m7"
    ],
    [
        2,
        3418,
        4,
        "phrygian",
        "m",
        "m7"
    ],
    [
        3,
        2741,
        -1,
        "lydian",
        "",
        "Maj7"
    ],
    [
        4,
        2774,
        1,
        "mixolydian",
        "",
        "7"
    ],
    [
        5,
        2906,
        3,
        "aeolian",
        "m",
        "m7",
        "minor"
    ],
    [
        6,
        3434,
        5,
        "locrian",
        "dim",
        "m7b5"
    ]
];
var NoMode = {
    ...(0, _pcset.EmptyPcset),
    name: "",
    alt: 0,
    modeNum: NaN,
    triad: "",
    seventh: "",
    aliases: []
};
var modes = MODES.map(toMode);
var index = {};
modes.forEach((mode2)=>{
    index[mode2.name] = mode2;
    mode2.aliases.forEach((alias)=>{
        index[alias] = mode2;
    });
});
function get(name) {
    return typeof name === "string" ? index[name.toLowerCase()] || NoMode : name && name.name ? get(name.name) : NoMode;
}
var mode = get;
function all() {
    return modes.slice();
}
var entries = all;
function names() {
    return modes.map((mode2)=>mode2.name);
}
function toMode(mode2) {
    const [modeNum, setNum, alt, name, triad, seventh, alias] = mode2;
    const aliases = alias ? [
        alias
    ] : [];
    const chroma = Number(setNum).toString(2);
    const intervals = (0, _scaleType.get)(name).intervals;
    return {
        empty: false,
        intervals,
        modeNum,
        chroma,
        normalized: chroma,
        name,
        setNum,
        alt,
        triad,
        seventh,
        aliases
    };
}
function notes(modeName, tonic) {
    return get(modeName).intervals.map((ivl)=>(0, _pitchDistance.transpose)(tonic, ivl));
}
function chords(chords2) {
    return (modeName, tonic)=>{
        const mode2 = get(modeName);
        if (mode2.empty) return [];
        const triads2 = (0, _collection.rotate)(mode2.modeNum, chords2);
        const tonics = mode2.intervals.map((i)=>(0, _pitchDistance.transpose)(tonic, i));
        return triads2.map((triad, i)=>tonics[i] + triad);
    };
}
var triads = chords(MODES.map((x)=>x[4]));
var seventhChords = chords(MODES.map((x)=>x[5]));
function distance(destination, source) {
    const from = get(source);
    const to = get(destination);
    if (from.empty || to.empty) return "";
    return (0, _interval.simplify)((0, _interval.transposeFifths)("1P", to.alt - from.alt));
}
function relativeTonic(destination, source, tonic) {
    return (0, _pitchDistance.transpose)(tonic, distance(destination, source));
}
var mode_default = {
    get,
    names,
    all,
    distance,
    relativeTonic,
    notes,
    triads,
    seventhChords,
    // deprecated
    entries,
    mode
};

},{"@tonaljs/collection":"eZd3r","@tonaljs/interval":"aFeW6","@tonaljs/pcset":"d6uTg","@tonaljs/pitch-distance":"hUy2y","@tonaljs/scale-type":"kiKIP","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"hBC0B":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>progression_default);
parcelHelpers.export(exports, "fromRomanNumerals", ()=>fromRomanNumerals);
parcelHelpers.export(exports, "toRomanNumerals", ()=>toRomanNumerals);
var _chord = require("@tonaljs/chord");
var _pitchDistance = require("@tonaljs/pitch-distance");
var _pitchInterval = require("@tonaljs/pitch-interval");
var _romanNumeral = require("@tonaljs/roman-numeral");
function fromRomanNumerals(tonic, chords) {
    const romanNumerals = chords.map((0, _romanNumeral.get));
    return romanNumerals.map((rn)=>(0, _pitchDistance.transpose)(tonic, (0, _pitchInterval.interval)(rn)) + rn.chordType);
}
function toRomanNumerals(tonic, chords) {
    return chords.map((chord)=>{
        const [note, chordType] = (0, _chord.tokenize)(chord);
        const intervalName = (0, _pitchDistance.distance)(tonic, note);
        const roman = (0, _romanNumeral.get)((0, _pitchInterval.interval)(intervalName));
        return roman.name + chordType;
    });
}
var progression_default = {
    fromRomanNumerals,
    toRomanNumerals
};

},{"@tonaljs/chord":"jiMl3","@tonaljs/pitch-distance":"hUy2y","@tonaljs/pitch-interval":"76Nbo","@tonaljs/roman-numeral":"2rpBM","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"372it":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chromatic", ()=>chromatic);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "numeric", ()=>numeric);
var _collection = require("@tonaljs/collection");
var _midi = require("@tonaljs/midi");
function numeric(notes) {
    const midi = (0, _collection.compact)(notes.map((note)=>typeof note === "number" ? note : (0, _midi.toMidi)(note)));
    if (!notes.length || midi.length !== notes.length) return [];
    return midi.reduce((result, note)=>{
        const last = result[result.length - 1];
        return result.concat((0, _collection.range)(last, note).slice(1));
    }, [
        midi[0]
    ]);
}
function chromatic(notes, options) {
    return numeric(notes).map((midi)=>(0, _midi.midiToNoteName)(midi, options));
}
var index_default = {
    numeric,
    chromatic
};

},{"@tonaljs/collection":"eZd3r","@tonaljs/midi":"ywjEO","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"hjGfL":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "binary", ()=>binary);
parcelHelpers.export(exports, "euclid", ()=>euclid);
parcelHelpers.export(exports, "hex", ()=>hex);
parcelHelpers.export(exports, "onsets", ()=>onsets);
parcelHelpers.export(exports, "probability", ()=>probability);
parcelHelpers.export(exports, "random", ()=>random);
parcelHelpers.export(exports, "rotate", ()=>rotate);
function binary(...numbers) {
    return numbers.reduce((pattern, number)=>{
        number.toString(2).split("").forEach((digit)=>{
            pattern.push(parseInt(digit));
        });
        return pattern;
    }, []);
}
function hex(hexNumber) {
    const pattern = [];
    for(let i = 0; i < hexNumber.length; i++){
        const digit = parseInt("0x" + hexNumber[i]);
        const binary2 = isNaN(digit) ? "0000" : digit.toString(2).padStart(4, "0");
        binary2.split("").forEach((digit2)=>{
            pattern.push(digit2 === "1" ? 1 : 0);
        });
    }
    return pattern;
}
function onsets(...numbers) {
    return numbers.reduce((pattern, number)=>{
        pattern.push(1);
        for(let i = 0; i < number; i++)pattern.push(0);
        return pattern;
    }, []);
}
function random(length, probability2 = 0.5, rnd = Math.random) {
    const pattern = [];
    for(let i = 0; i < length; i++)pattern.push(rnd() >= probability2 ? 1 : 0);
    return pattern;
}
function probability(probabilities, rnd = Math.random) {
    return probabilities.map((probability2)=>rnd() <= probability2 ? 1 : 0);
}
function rotate(pattern, rotations) {
    const len = pattern.length;
    const rotated = [];
    for(let i = 0; i < len; i++){
        const pos = ((i - rotations) % len + len) % len;
        rotated[i] = pattern[pos];
    }
    return rotated;
}
function euclid(steps, beats) {
    const pattern = [];
    let d = -1;
    for(let i = 0; i < steps; i++){
        const v = Math.floor(i * (beats / steps));
        pattern[i] = v !== d ? 1 : 0;
        d = v;
    }
    return pattern;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"bVzve":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "detect", ()=>detect);
parcelHelpers.export(exports, "extended", ()=>extended);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "modeNames", ()=>modeNames);
parcelHelpers.export(exports, "names", ()=>names);
parcelHelpers.export(exports, "rangeOf", ()=>rangeOf);
parcelHelpers.export(exports, "reduced", ()=>reduced);
parcelHelpers.export(exports, "scale", ()=>scale);
parcelHelpers.export(exports, "scaleChords", ()=>scaleChords);
parcelHelpers.export(exports, "scaleNotes", ()=>scaleNotes);
parcelHelpers.export(exports, "steps", ()=>steps);
parcelHelpers.export(exports, "tokenize", ()=>tokenize);
var _chordType = require("@tonaljs/chord-type");
var _collection = require("@tonaljs/collection");
var _note = require("@tonaljs/note");
var _pcset = require("@tonaljs/pcset");
var _pitchDistance = require("@tonaljs/pitch-distance");
var _pitchNote = require("@tonaljs/pitch-note");
var _scaleType = require("@tonaljs/scale-type");
var NoScale = {
    empty: true,
    name: "",
    type: "",
    tonic: null,
    setNum: NaN,
    chroma: "",
    normalized: "",
    aliases: [],
    notes: [],
    intervals: []
};
function tokenize(name) {
    if (typeof name !== "string") return [
        "",
        ""
    ];
    const i = name.indexOf(" ");
    const tonic = (0, _pitchNote.note)(name.substring(0, i));
    if (tonic.empty) {
        const n = (0, _pitchNote.note)(name);
        return n.empty ? [
            "",
            name.toLowerCase()
        ] : [
            n.name,
            ""
        ];
    }
    const type = name.substring(tonic.name.length + 1).toLowerCase();
    return [
        tonic.name,
        type.length ? type : ""
    ];
}
var names = (0, _scaleType.names);
function get(src) {
    const tokens = Array.isArray(src) ? src : tokenize(src);
    const tonic = (0, _pitchNote.note)(tokens[0]).name;
    const st = (0, _scaleType.get)(tokens[1]);
    if (st.empty) return NoScale;
    const type = st.name;
    const notes = tonic ? st.intervals.map((i)=>(0, _pitchDistance.transpose)(tonic, i)) : [];
    const name = tonic ? tonic + " " + type : type;
    return {
        ...st,
        name,
        type,
        tonic,
        notes
    };
}
var scale = get;
function detect(notes, options = {}) {
    const notesChroma = (0, _pcset.chroma)(notes);
    const tonic = (0, _pitchNote.note)(options.tonic ?? notes[0] ?? "");
    const tonicChroma = tonic.chroma;
    if (tonicChroma === void 0) return [];
    const pitchClasses = notesChroma.split("");
    pitchClasses[tonicChroma] = "1";
    const scaleChroma = (0, _collection.rotate)(tonicChroma, pitchClasses).join("");
    const match = (0, _scaleType.all)().find((scaleType)=>scaleType.chroma === scaleChroma);
    const results = [];
    if (match) results.push(tonic.name + " " + match.name);
    if (options.match === "exact") return results;
    extended(scaleChroma).forEach((scaleName)=>{
        results.push(tonic.name + " " + scaleName);
    });
    return results;
}
function scaleChords(name) {
    const s = get(name);
    const inScale = (0, _pcset.isSubsetOf)(s.chroma);
    return (0, _chordType.all)().filter((chord)=>inScale(chord.chroma)).map((chord)=>chord.aliases[0]);
}
function extended(name) {
    const chroma2 = (0, _pcset.isChroma)(name) ? name : get(name).chroma;
    const isSuperset = (0, _pcset.isSupersetOf)(chroma2);
    return (0, _scaleType.all)().filter((scale2)=>isSuperset(scale2.chroma)).map((scale2)=>scale2.name);
}
function reduced(name) {
    const isSubset = (0, _pcset.isSubsetOf)(get(name).chroma);
    return (0, _scaleType.all)().filter((scale2)=>isSubset(scale2.chroma)).map((scale2)=>scale2.name);
}
function scaleNotes(notes) {
    const pcset = notes.map((n)=>(0, _pitchNote.note)(n).pc).filter((x)=>x);
    const tonic = pcset[0];
    const scale2 = (0, _note.sortedUniqNames)(pcset);
    return (0, _collection.rotate)(scale2.indexOf(tonic), scale2);
}
function modeNames(name) {
    const s = get(name);
    if (s.empty) return [];
    const tonics = s.tonic ? s.notes : s.intervals;
    return (0, _pcset.modes)(s.chroma).map((chroma2, i)=>{
        const modeName = get(chroma2).name;
        return modeName ? [
            tonics[i],
            modeName
        ] : [
            "",
            ""
        ];
    }).filter((x)=>x[0]);
}
function getNoteNameOf(scale2) {
    const names2 = Array.isArray(scale2) ? scaleNotes(scale2) : get(scale2).notes;
    const chromas = names2.map((name)=>(0, _pitchNote.note)(name).chroma);
    return (noteOrMidi)=>{
        const currNote = typeof noteOrMidi === "number" ? (0, _pitchNote.note)((0, _note.fromMidi)(noteOrMidi)) : (0, _pitchNote.note)(noteOrMidi);
        const height = currNote.height;
        if (height === void 0) return void 0;
        const chroma2 = height % 12;
        const position = chromas.indexOf(chroma2);
        if (position === -1) return void 0;
        return (0, _note.enharmonic)(currNote.name, names2[position]);
    };
}
function rangeOf(scale2) {
    const getName = getNoteNameOf(scale2);
    return (fromNote, toNote)=>{
        const from = (0, _pitchNote.note)(fromNote).height;
        const to = (0, _pitchNote.note)(toNote).height;
        if (from === void 0 || to === void 0) return [];
        return (0, _collection.range)(from, to).map(getName).filter((x)=>x);
    };
}
function degrees(scaleName) {
    const { intervals, tonic } = get(scaleName);
    const transpose2 = (0, _pitchDistance.tonicIntervalsTransposer)(intervals, tonic);
    return (degree)=>degree ? transpose2(degree > 0 ? degree - 1 : degree) : "";
}
function steps(scaleName) {
    const { intervals, tonic } = get(scaleName);
    return (0, _pitchDistance.tonicIntervalsTransposer)(intervals, tonic);
}
var index_default = {
    degrees,
    detect,
    extended,
    get,
    modeNames,
    names,
    rangeOf,
    reduced,
    scaleChords,
    scaleNotes,
    steps,
    tokenize,
    // deprecated
    scale
};

},{"@tonaljs/chord-type":"1iNIt","@tonaljs/collection":"eZd3r","@tonaljs/note":"kNy38","@tonaljs/pcset":"d6uTg","@tonaljs/pitch-distance":"hUy2y","@tonaljs/pitch-note":"4vzmL","@tonaljs/scale-type":"kiKIP","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"d4eD5":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>time_signature_default);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "names", ()=>names);
parcelHelpers.export(exports, "parse", ()=>parse);
var NONE = {
    empty: true,
    name: "",
    upper: void 0,
    lower: void 0,
    type: void 0,
    additive: []
};
var NAMES = [
    "4/4",
    "3/4",
    "2/4",
    "2/2",
    "12/8",
    "9/8",
    "6/8",
    "3/8"
];
function names() {
    return NAMES.slice();
}
var REGEX = /^(\d*\d(?:\+\d)*)\/(\d+)$/;
var CACHE = /* @__PURE__ */ new Map();
function get(literal) {
    const stringifiedLiteral = JSON.stringify(literal);
    const cached = CACHE.get(stringifiedLiteral);
    if (cached) return cached;
    const ts = build(parse(literal));
    CACHE.set(stringifiedLiteral, ts);
    return ts;
}
function parse(literal) {
    if (typeof literal === "string") {
        const [_, up2, low] = REGEX.exec(literal) || [];
        return parse([
            up2,
            low
        ]);
    }
    const [up, down] = literal;
    const denominator = +down;
    if (typeof up === "number") return [
        up,
        denominator
    ];
    const list = up.split("+").map((n)=>+n);
    return list.length === 1 ? [
        list[0],
        denominator
    ] : [
        list,
        denominator
    ];
}
var time_signature_default = {
    names,
    parse,
    get
};
var isPowerOfTwo = (x)=>Math.log(x) / Math.log(2) % 1 === 0;
function build([up, down]) {
    const upper = Array.isArray(up) ? up.reduce((a, b)=>a + b, 0) : up;
    const lower = down;
    if (upper === 0 || lower === 0) return NONE;
    const name = Array.isArray(up) ? `${up.join("+")}/${down}` : `${up}/${down}`;
    const additive = Array.isArray(up) ? up : [];
    const type = lower === 4 || lower === 2 ? "simple" : lower === 8 && upper % 3 === 0 ? "compound" : isPowerOfTwo(lower) ? "irregular" : "irrational";
    return {
        empty: false,
        name,
        type,
        upper,
        lower,
        additive
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"kqIFf":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "topNoteDiff", ()=>topNoteDiff);
var _note = require("@tonaljs/note");
var _noteDefault = parcelHelpers.interopDefault(_note);
var topNoteDiff = (voicings, lastVoicing)=>{
    if (!lastVoicing || !lastVoicing.length) return voicings[0];
    const topNoteMidi = (voicing)=>(0, _noteDefault.default).midi(voicing[voicing.length - 1]) || 0;
    const diff = (voicing)=>Math.abs(topNoteMidi(lastVoicing) - topNoteMidi(voicing));
    return voicings.sort((a, b)=>diff(a) - diff(b))[0];
};
var index_default = {
    topNoteDiff
};

},{"@tonaljs/note":"kNy38","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"79ZNE":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "search", ()=>search);
parcelHelpers.export(exports, "sequence", ()=>sequence);
var _chord = require("@tonaljs/chord");
var _chordDefault = parcelHelpers.interopDefault(_chord);
var _interval = require("@tonaljs/interval");
var _intervalDefault = parcelHelpers.interopDefault(_interval);
var _note = require("@tonaljs/note");
var _noteDefault = parcelHelpers.interopDefault(_note);
var _range = require("@tonaljs/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _voiceLeading = require("@tonaljs/voice-leading");
var _voiceLeadingDefault = parcelHelpers.interopDefault(_voiceLeading);
var _voicingDictionary = require("@tonaljs/voicing-dictionary");
var _voicingDictionaryDefault = parcelHelpers.interopDefault(_voicingDictionary);
var defaultRange = [
    "C3",
    "C5"
];
var defaultDictionary = (0, _voicingDictionaryDefault.default).all;
var defaultVoiceLeading = (0, _voiceLeadingDefault.default).topNoteDiff;
function get(chord, range = defaultRange, dictionary = defaultDictionary, voiceLeading = defaultVoiceLeading, lastVoicing) {
    const voicings = search(chord, range, dictionary);
    if (!lastVoicing || !lastVoicing.length) return voicings[0];
    else return voiceLeading(voicings, lastVoicing);
}
function search(chord, range = defaultRange, dictionary = (0, _voicingDictionaryDefault.default).triads) {
    const [tonic, symbol] = (0, _chordDefault.default).tokenize(chord);
    const sets = (0, _voicingDictionaryDefault.default).lookup(symbol, dictionary);
    if (!sets) return [];
    const voicings = sets.map((intervals)=>intervals.split(" "));
    const notesInRange = (0, _rangeDefault.default).chromatic(range);
    return voicings.reduce((voiced, voicing)=>{
        const relativeIntervals = voicing.map((interval)=>(0, _intervalDefault.default).subtract(interval, voicing[0]) || "");
        const bottomPitchClass = (0, _noteDefault.default).transpose(tonic, voicing[0]);
        const starts = notesInRange.filter((note)=>(0, _noteDefault.default).chroma(note) === (0, _noteDefault.default).chroma(bottomPitchClass)).filter((note)=>((0, _noteDefault.default).midi((0, _noteDefault.default).transpose(note, relativeIntervals[relativeIntervals.length - 1])) || 0) <= ((0, _noteDefault.default).midi(range[1]) || 0)).map((note)=>(0, _noteDefault.default).enharmonic(note, bottomPitchClass));
        const notes = starts.map((start)=>relativeIntervals.map((interval)=>(0, _noteDefault.default).transpose(start, interval)));
        return voiced.concat(notes);
    }, []);
}
function sequence(chords, range = defaultRange, dictionary = defaultDictionary, voiceLeading = defaultVoiceLeading, lastVoicing) {
    const { voicings } = chords.reduce(({ voicings: voicings2, lastVoicing: lastVoicing2 }, chord)=>{
        const voicing = get(chord, range, dictionary, voiceLeading, lastVoicing2);
        lastVoicing2 = voicing;
        voicings2.push(voicing);
        return {
            voicings: voicings2,
            lastVoicing: lastVoicing2
        };
    }, {
        voicings: [],
        lastVoicing
    });
    return voicings;
}
var index_default = {
    get,
    search,
    sequence
};

},{"@tonaljs/chord":"jiMl3","@tonaljs/interval":"aFeW6","@tonaljs/note":"kNy38","@tonaljs/range":"372it","@tonaljs/voice-leading":"kqIFf","@tonaljs/voicing-dictionary":"4jk3Q","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"4jk3Q":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "defaultDictionary", ()=>defaultDictionary);
parcelHelpers.export(exports, "lefthand", ()=>lefthand);
parcelHelpers.export(exports, "lookup", ()=>lookup);
parcelHelpers.export(exports, "triads", ()=>triads);
var _chord = require("@tonaljs/chord");
var _chordDefault = parcelHelpers.interopDefault(_chord);
// data.ts
var triads = {
    M: [
        "1P 3M 5P",
        "3M 5P 8P",
        "5P 8P 10M"
    ],
    m: [
        "1P 3m 5P",
        "3m 5P 8P",
        "5P 8P 10m"
    ],
    o: [
        "1P 3m 5d",
        "3m 5d 8P",
        "5d 8P 10m"
    ],
    aug: [
        "1P 3m 5A",
        "3m 5A 8P",
        "5A 8P 10m"
    ]
};
var lefthand = {
    m7: [
        "3m 5P 7m 9M",
        "7m 9M 10m 12P"
    ],
    "7": [
        "3M 6M 7m 9M",
        "7m 9M 10M 13M"
    ],
    "^7": [
        "3M 5P 7M 9M",
        "7M 9M 10M 12P"
    ],
    "69": [
        "3M 5P 6A 9M"
    ],
    m7b5: [
        "3m 5d 7m 8P",
        "7m 8P 10m 12d"
    ],
    "7b9": [
        "3M 6m 7m 9m",
        "7m 9m 10M 13m"
    ],
    // b9 / b13
    "7b13": [
        "3M 6m 7m 9m",
        "7m 9m 10M 13m"
    ],
    // b9 / b13
    o7: [
        "1P 3m 5d 6M",
        "5d 6M 8P 10m"
    ],
    "7#11": [
        "7m 9M 11A 13A"
    ],
    "7#9": [
        "3M 7m 9A"
    ],
    mM7: [
        "3m 5P 7M 9M",
        "7M 9M 10m 12P"
    ],
    m6: [
        "3m 5P 6M 9M",
        "6M 9M 10m 12P"
    ]
};
var all = {
    M: [
        "1P 3M 5P",
        "3M 5P 8P",
        "5P 8P 10M"
    ],
    m: [
        "1P 3m 5P",
        "3m 5P 8P",
        "5P 8P 10m"
    ],
    o: [
        "1P 3m 5d",
        "3m 5d 8P",
        "5d 8P 10m"
    ],
    aug: [
        "1P 3m 5A",
        "3m 5A 8P",
        "5A 8P 10m"
    ],
    m7: [
        "3m 5P 7m 9M",
        "7m 9M 10m 12P"
    ],
    "7": [
        "3M 6M 7m 9M",
        "7m 9M 10M 13M"
    ],
    "^7": [
        "3M 5P 7M 9M",
        "7M 9M 10M 12P"
    ],
    "69": [
        "3M 5P 6A 9M"
    ],
    m7b5: [
        "3m 5d 7m 8P",
        "7m 8P 10m 12d"
    ],
    "7b9": [
        "3M 6m 7m 9m",
        "7m 9m 10M 13m"
    ],
    // b9 / b13
    "7b13": [
        "3M 6m 7m 9m",
        "7m 9m 10M 13m"
    ],
    // b9 / b13
    o7: [
        "1P 3m 5d 6M",
        "5d 6M 8P 10m"
    ],
    "7#11": [
        "7m 9M 11A 13A"
    ],
    "7#9": [
        "3M 7m 9A"
    ],
    mM7: [
        "3m 5P 7M 9M",
        "7M 9M 10m 12P"
    ],
    m6: [
        "3m 5P 6M 9M",
        "6M 9M 10m 12P"
    ]
};
// index.ts
var defaultDictionary = lefthand;
function lookup(symbol, dictionary = defaultDictionary) {
    if (dictionary[symbol]) return dictionary[symbol];
    const { aliases } = (0, _chordDefault.default).get("C" + symbol);
    const match = Object.keys(dictionary).find((_symbol)=>aliases.includes(_symbol)) || "";
    if (match !== void 0) return dictionary[match];
    return void 0;
}
var index_default = {
    lookup,
    lefthand,
    triads,
    all,
    defaultDictionary
};

},{"@tonaljs/chord":"jiMl3","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"i2CsJ":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deprecate", ()=>deprecate);
parcelHelpers.export(exports, "fillStr", ()=>fillStr);
parcelHelpers.export(exports, "isNamed", ()=>isNamed);
var _pitch = require("@tonaljs/pitch");
parcelHelpers.exportAll(_pitch, exports);
var _pitchDistance = require("@tonaljs/pitch-distance");
parcelHelpers.exportAll(_pitchDistance, exports);
var _pitchInterval = require("@tonaljs/pitch-interval");
parcelHelpers.exportAll(_pitchInterval, exports);
var _pitchNote = require("@tonaljs/pitch-note");
parcelHelpers.exportAll(_pitchNote, exports);
var fillStr = (s, n)=>Array(Math.abs(n) + 1).join(s);
function deprecate(original, alternative, fn) {
    return function(...args) {
        console.warn(`${original} is deprecated. Use ${alternative}.`);
        return fn.apply(this, args);
    };
}
var isNamed = deprecate("isNamed", "isNamedPitch", (0, _pitch.isNamedPitch));

},{"@tonaljs/pitch":"2v7nB","@tonaljs/pitch-distance":"hUy2y","@tonaljs/pitch-interval":"76Nbo","@tonaljs/pitch-note":"4vzmL","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"5TiHK":[function(require,module,exports,__globalThis) {
/**
 * Configuration Manager
 * Centralizes config.json and generates CSS custom properties
 * Eliminates duplication between config.json and styles.scss
 */ // Import config - Parcel handles JSON imports automatically
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateCSSVariables", ()=>generateCSSVariables);
parcelHelpers.export(exports, "applyCSSVariables", ()=>applyCSSVariables);
parcelHelpers.export(exports, "getConfig", ()=>getConfig);
parcelHelpers.export(exports, "getConfigValue", ()=>getConfigValue);
var _configJson = require("../../config.json");
var _configJsonDefault = parcelHelpers.interopDefault(_configJson);
const generateCSSVariables = ()=>{
    const cssVars = [];
    // Visual configuration
    if ((0, _configJsonDefault.default).visual) {
        // Colors
        if ((0, _configJsonDefault.default).visual.highlighting?.color) cssVars.push(`--highlight-color: ${(0, _configJsonDefault.default).visual.highlighting.color}`);
        if ((0, _configJsonDefault.default).visual.intervals?.color) cssVars.push(`--bracket-color: ${(0, _configJsonDefault.default).visual.intervals.color}`);
        // Layout spacing
        if ((0, _configJsonDefault.default).visual.layout?.scaleHeaderSpacing) cssVars.push(`--scale-header-spacing: ${(0, _configJsonDefault.default).visual.layout.scaleHeaderSpacing}rem`);
        // Animation settings
        if ((0, _configJsonDefault.default).visual.animation) {
            const anim = (0, _configJsonDefault.default).visual.animation;
            if (anim.noteGlowScale) cssVars.push(`--note-glow-scale: ${anim.noteGlowScale}`);
            if (anim.glowDuration) cssVars.push(`--glow-duration: ${anim.glowDuration}`);
            if (anim.shadowIntensity) cssVars.push(`--shadow-intensity: ${anim.shadowIntensity}px`);
        }
        // Interval highlighting
        if ((0, _configJsonDefault.default).visual.intervals?.highlighting) {
            const highlight = (0, _configJsonDefault.default).visual.intervals.highlighting;
            if (highlight.dimOpacity) cssVars.push(`--interval-dim-opacity: ${highlight.dimOpacity}`);
            if (highlight.highlightStrokeWidth) cssVars.push(`--interval-highlight-stroke: ${highlight.highlightStrokeWidth}`);
            if (highlight.transitionDuration) cssVars.push(`--interval-transition-duration: ${highlight.transitionDuration}`);
        }
    }
    // Typography configuration
    if ((0, _configJsonDefault.default).typography) {
        if ((0, _configJsonDefault.default).typography.scaleTitle) {
            const title = (0, _configJsonDefault.default).typography.scaleTitle;
            if (title.opacity) cssVars.push(`--scale-title-opacity: ${title.opacity}`);
            if (title.fontSize) cssVars.push(`--scale-title-font-size: ${title.fontSize}`);
        }
        if ((0, _configJsonDefault.default).typography.scaleName) {
            const name = (0, _configJsonDefault.default).typography.scaleName;
            if (name.opacity) cssVars.push(`--scale-name-opacity: ${name.opacity}`);
            if (name.fontSize) cssVars.push(`--scale-name-font-size: ${name.fontSize}`);
        }
    }
    return cssVars.join(';\n  ') + ';';
};
const applyCSSVariables = ()=>{
    const cssText = `:root {\n  ${generateCSSVariables()}\n}`;
    // Remove existing config-generated styles
    const existingStyle = document.getElementById('config-css-variables');
    if (existingStyle) existingStyle.remove();
    // Inject new styles
    const style = document.createElement('style');
    style.id = 'config-css-variables';
    style.textContent = cssText;
    document.head.appendChild(style);
};
const getConfig = ()=>(0, _configJsonDefault.default);
const getConfigValue = (path, fallback = null)=>{
    const keys = path.split('.');
    let current = (0, _configJsonDefault.default);
    for (const key of keys){
        if (current && typeof current === 'object' && key in current) current = current[key];
        else return fallback;
    }
    return current;
};
exports.default = {
    generateCSSVariables,
    applyCSSVariables,
    getConfig,
    getConfigValue
};

},{"../../config.json":"7ciY5","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"7ciY5":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"audio\":{\"tempo\":{\"noteDuration\":0.3,\"noteGap\":0.2,\"description\":\"Duration of each note and gap between notes in seconds\"},\"pitch\":{\"startingPitch\":60,\"description\":\"Starting MIDI note number (60 = Middle C)\"}},\"visual\":{\"highlighting\":{\"color\":\"#ff6b35\",\"description\":\"Color for note highlighting during playback\"},\"intervals\":{\"bracketMargins\":{\"bottomOffset\":30,\"topOffset\":24,\"description\":\"Distance from staff bottom: bottomOffset for brackets, topOffset for text (both relative to stave bottom)\"},\"bracketSpacing\":{\"curveHeight\":4.8,\"curveControl\":4.8,\"description\":\"Height and control point offset for curly bracket curves\"},\"color\":\"#a5998c\",\"description\":\"Color for interval brackets and numbers\",\"highlighting\":{\"enabled\":true,\"dimOpacity\":0.3,\"highlightStrokeWidth\":3,\"transitionDuration\":\"0.2s\",\"description\":\"Settings for interval note highlighting on hover/tap. Set enabled to false to disable.\"}},\"layout\":{\"scaleHeaderSpacing\":0.4,\"description\":\"Space between Scale# title and staff (in rem)\"},\"notation\":{\"containerMargin\":20,\"staveMargin\":20,\"staveLeftOffset\":0,\"staveTopOffset\":-20,\"svgHeight\":120,\"maxWidth\":460,\"formatWidth\":360,\"description\":\"Layout values for VexFlow notation rendering - ensure margins don't cause overflow. staveLeftOffset aligns with left edge, staveTopOffset controls gap from title.\"},\"filters\":{\"noteCount\":{\"defaultMin\":4,\"defaultMax\":12,\"description\":\"Default range for note count filter (not including octave)\"}},\"animation\":{\"noteGlowScale\":1,\"glowDuration\":\"0.5s\",\"shadowIntensity\":3,\"useGlowOnly\":true,\"description\":\"Scale factor, duration, and shadow intensity for note highlight animation. Set useGlowOnly to true for no movement.\"}},\"typography\":{\"scaleTitle\":{\"opacity\":0.6,\"fontSize\":\"0.85rem\",\"description\":\"Styling for 'Scale #X' titles\"},\"scaleName\":{\"opacity\":0.8,\"fontSize\":\"0.9rem\",\"description\":\"Styling for scale name (e.g., 'Major (Ionian)')\"}}}");

},{}],"9mjrb":[function(require,module,exports,__globalThis) {
// Interval bracket rendering utilities
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "highlightInterval", ()=>highlightInterval);
parcelHelpers.export(exports, "clearIntervalHighlight", ()=>clearIntervalHighlight);
parcelHelpers.export(exports, "renderIntervalBrackets", ()=>renderIntervalBrackets);
var _curlyBrackets = require("./curlyBrackets");
var _config = require("./config");
const highlightInterval = (container, startNoteIndex, endNoteIndex)=>{
    const svg = container.querySelector('svg');
    if (!svg) return;
    const noteElements = svg.querySelectorAll('.vf-stavenote');
    noteElements.forEach((noteElement, index)=>{
        if (index === startNoteIndex || index === endNoteIndex) // Make interval notes bold/prominent
        noteElement.classList.add('interval-note-highlight');
        else // Dim other notes
        noteElement.classList.add('interval-note-dimmed');
    });
};
const clearIntervalHighlight = (container)=>{
    const svg = container.querySelector('svg');
    if (!svg) return;
    const noteElements = svg.querySelectorAll('.vf-stavenote');
    noteElements.forEach((noteElement)=>{
        noteElement.classList.remove('interval-note-highlight', 'interval-note-dimmed');
    });
};
const renderIntervalBrackets = (container, notes, scale, stave, options = {})=>{
    const { matchingPattern = null, bracketOffset = (0, _config.getConfigValue)('visual.intervals.bracketMargins.bottomOffset', 30), textOffset = (0, _config.getConfigValue)('visual.intervals.bracketMargins.topOffset', 24), color = (0, _config.getConfigValue)('visual.intervals.color', '#a5998c'), fontSize = '10', fontFamily = 'Arial, sans-serif' } = options;
    // Calculate positions relative to the stave position
    const staveBottomY = stave.getY() + stave.getHeight();
    const bracketY = staveBottomY + bracketOffset;
    const textY = staveBottomY + textOffset;
    // Create group for all brackets
    const svgElement = container.querySelector('svg');
    const bracketsGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    bracketsGroup.setAttribute('class', 'interval-brackets');
    svgElement.appendChild(bracketsGroup);
    // Calculate all bracket positions
    const bracketPositions = (0, _curlyBrackets.calculateBracketPositions)(notes);
    // Create brackets and labels
    bracketPositions.forEach(({ startX, endX, centerX, intervalValue })=>{
        // Create bracket path
        const pathElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        const pathData = (0, _curlyBrackets.createCurlyBracketPath)(startX, bracketY, endX, bracketY);
        pathElement.setAttribute('d', pathData);
        pathElement.setAttribute('stroke', color);
        pathElement.setAttribute('fill', 'none');
        pathElement.setAttribute('stroke-width', '1');
        pathElement.setAttribute('stroke-linecap', 'round');
        pathElement.setAttribute('stroke-linejoin', 'round');
        pathElement.setAttribute('class', 'interval-bracket');
        bracketsGroup.appendChild(pathElement);
        // Create interval number text
        const textElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        textElement.setAttribute('x', centerX);
        textElement.setAttribute('y', textY);
        textElement.setAttribute('text-anchor', 'middle');
        textElement.setAttribute('dominant-baseline', 'middle');
        textElement.setAttribute('font-family', fontFamily);
        textElement.setAttribute('font-size', fontSize);
        textElement.setAttribute('fill', color);
        textElement.setAttribute('class', 'interval-number');
        textElement.setAttribute('data-start-note', intervalValue);
        textElement.setAttribute('data-end-note', intervalValue + 1);
        textElement.textContent = scale[intervalValue].toString();
        // Check if this interval is part of a matching pattern
        if (matchingPattern && matchingPattern.length > 0) {
            const scaleString = scale.join('');
            const isMatching = matchingPattern.some((pattern)=>{
                // Find all occurrences of this pattern in the scale
                for(let i = 0; i <= scaleString.length - pattern.length; i++)if (scaleString.substring(i, i + pattern.length) === pattern) {
                    // Check if current interval index is within this match
                    if (intervalValue >= i && intervalValue < i + pattern.length) return true;
                }
                return false;
            });
            if (isMatching) textElement.classList.add('interval-number-matching');
        }
        // Add interaction handlers
        textElement.style.cursor = 'pointer';
        // Mouse/touch event handlers
        const handleIntervalClick = (e)=>{
            // Check if playback is active - don't interfere with audio highlighting
            if (container.querySelector('.note-highlight-container')) return;
            e.stopPropagation();
            const startNoteIndex = parseInt(textElement.getAttribute('data-start-note'));
            const endNoteIndex = parseInt(textElement.getAttribute('data-end-note'));
            highlightInterval(container, startNoteIndex, endNoteIndex);
        };
        let hoverTimeout;
        const handleIntervalHover = (e)=>{
            // Check if playback is active - don't interfere with audio highlighting
            if (container.querySelector('.note-highlight-container')) return;
            // Clear any pending clear timeout
            if (hoverTimeout) {
                clearTimeout(hoverTimeout);
                hoverTimeout = null;
            }
            const startNoteIndex = parseInt(textElement.getAttribute('data-start-note'));
            const endNoteIndex = parseInt(textElement.getAttribute('data-end-note'));
            highlightInterval(container, startNoteIndex, endNoteIndex);
        };
        const handleIntervalLeave = (e)=>{
            // Use a small delay to prevent flickering from rapid mouse movements
            hoverTimeout = setTimeout(()=>{
                clearIntervalHighlight(container);
            }, 50);
        };
        // Add event listeners
        textElement.addEventListener('click', handleIntervalClick);
        textElement.addEventListener('mouseenter', handleIntervalHover);
        textElement.addEventListener('mouseleave', handleIntervalLeave);
        bracketsGroup.appendChild(textElement);
    });
};

},{"./curlyBrackets":"iQYgW","./config":"5TiHK","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"iQYgW":[function(require,module,exports,__globalThis) {
// Helper functions for creating curly bracket SVG elements
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCurlyBracketPath", ()=>createCurlyBracketPath);
parcelHelpers.export(exports, "calculateBracketPositions", ()=>calculateBracketPositions);
var _configJson = require("../config.json");
var _configJsonDefault = parcelHelpers.interopDefault(_configJson);
const createCurlyBracketPath = (x1, y1, x2, y2, width = (0, _configJsonDefault.default).visual.intervals.bracketSpacing.curveHeight, expressiveness = 0.6)=>{
    const dx = x1 - x2;
    const dy = y1 - y2;
    const len = Math.sqrt(dx * dx + dy * dy);
    const udx = dx / len;
    const udy = dy / len;
    const qx1 = x1 + expressiveness * width * udy;
    const qy1 = y1 - expressiveness * width * udx;
    const qx2 = x1 - 0.25 * len * udx + (1 - expressiveness) * width * udy;
    const qy2 = y1 - 0.25 * len * udy - (1 - expressiveness) * width * udx;
    const tx1 = x1 - 0.5 * len * udx + width * udy;
    const ty1 = y1 - 0.5 * len * udy - width * udx;
    const qx3 = x2 + expressiveness * width * udy;
    const qy3 = y2 - expressiveness * width * udx;
    const qx4 = x1 - 0.75 * len * udx + (1 - expressiveness) * width * udy;
    const qy4 = y1 - 0.75 * len * udy - (1 - expressiveness) * width * udx;
    return `M ${x1} ${y1} Q ${qx1} ${qy1} ${qx2} ${qy2} T ${tx1} ${ty1} M ${x2} ${y2} Q ${qx3} ${qy3} ${qx4} ${qy4} T ${tx1} ${ty1}`;
};
const calculateBracketPositions = (notes, noteWidth = 6)=>{
    return notes.slice(0, -1).map((note, index)=>{
        const currentX = note.getAbsoluteX();
        const nextX = notes[index + 1].getAbsoluteX();
        const startX = currentX + noteWidth;
        const endX = nextX - noteWidth / 2;
        const centerX = (startX + endX) / 2;
        return {
            startX,
            endX,
            centerX,
            intervalValue: index
        };
    });
};

},{"../config.json":"7ciY5","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"DWtOa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useConfig", ()=>useConfig);
parcelHelpers.export(exports, "useAudioConfig", ()=>useAudioConfig);
parcelHelpers.export(exports, "useVisualConfig", ()=>useVisualConfig);
parcelHelpers.export(exports, "useTypographyConfig", ()=>useTypographyConfig);
var _react = require("react");
var _config = require("../lib/config");
const useConfig = (path = null)=>{
    const config = (0, _react.useMemo)(()=>{
        if (path) return (0, _config.getConfigValue)(path);
        return (0, _config.getConfig)();
    }, [
        path
    ]);
    return config;
};
const useAudioConfig = ()=>{
    return useConfig('audio');
};
const useVisualConfig = ()=>{
    return useConfig('visual');
};
const useTypographyConfig = ()=>{
    return useConfig('typography');
};
exports.default = useConfig;

},{"react":"e1Nhq","../lib/config":"5TiHK","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"fS8Ok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNecklaceExpansion", ()=>useNecklaceExpansion);
var _react = require("react");
const useNecklaceExpansion = ()=>{
    const [expandedScale, setExpandedScale] = (0, _react.useState)(null);
    const toggleNecklace = (0, _react.useCallback)((scaleNumber)=>{
        setExpandedScale((current)=>current === scaleNumber ? null : scaleNumber);
    }, []); // Remove expandedScale dependency to avoid stale closures
    const isExpanded = (0, _react.useCallback)((scaleNumber)=>{
        return expandedScale === scaleNumber;
    }, [
        expandedScale
    ]);
    return {
        toggleNecklace,
        isExpanded,
        expandedScale
    };
};

},{"react":"e1Nhq","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"9Nehm":[function(require,module,exports,__globalThis) {
// Component barrel exports
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScaleHeader", ()=>(0, _scaleHeaderJsxDefault.default));
parcelHelpers.export(exports, "ScaleNotation", ()=>(0, _scaleNotationJsxDefault.default));
parcelHelpers.export(exports, "PlayButton", ()=>(0, _playButtonJsxDefault.default));
parcelHelpers.export(exports, "TechnicalId", ()=>(0, _technicalIdJsxDefault.default));
parcelHelpers.export(exports, "NecklaceVisualization", ()=>(0, _necklaceVisualizationJsxDefault.default));
parcelHelpers.export(exports, "NecklaceButton", ()=>(0, _necklaceButtonJsxDefault.default));
parcelHelpers.export(exports, "PurchaseModal", ()=>(0, _purchaseModalJsxDefault.default));
parcelHelpers.export(exports, "NecklaceModal", ()=>(0, _necklaceModalJsx.NecklaceModal));
var _scaleHeaderJsx = require("./ScaleHeader.jsx");
var _scaleHeaderJsxDefault = parcelHelpers.interopDefault(_scaleHeaderJsx);
var _scaleNotationJsx = require("./ScaleNotation.jsx");
var _scaleNotationJsxDefault = parcelHelpers.interopDefault(_scaleNotationJsx);
var _playButtonJsx = require("./PlayButton.jsx");
var _playButtonJsxDefault = parcelHelpers.interopDefault(_playButtonJsx);
var _technicalIdJsx = require("./TechnicalId.jsx");
var _technicalIdJsxDefault = parcelHelpers.interopDefault(_technicalIdJsx);
var _necklaceVisualizationJsx = require("./NecklaceVisualization.jsx");
var _necklaceVisualizationJsxDefault = parcelHelpers.interopDefault(_necklaceVisualizationJsx);
var _necklaceButtonJsx = require("./NecklaceButton.jsx");
var _necklaceButtonJsxDefault = parcelHelpers.interopDefault(_necklaceButtonJsx);
var _purchaseModalJsx = require("./PurchaseModal.jsx");
var _purchaseModalJsxDefault = parcelHelpers.interopDefault(_purchaseModalJsx);
var _necklaceModalJsx = require("./NecklaceModal.jsx");

},{"./ScaleHeader.jsx":"5rjcD","./ScaleNotation.jsx":"7CjhN","./PlayButton.jsx":"3LfGz","./TechnicalId.jsx":"6CrJb","./NecklaceVisualization.jsx":"HAXPh","./NecklaceButton.jsx":"d7WpC","./PurchaseModal.jsx":"hykr3","./NecklaceModal.jsx":"1SLqT","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"5rjcD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * ScaleHeader Component - Displays scale title with optional name and Wikipedia link
 * 
 * @param {number} scaleNumber - The scale number identifier
 * @param {Object} scaleInfo - Scale information object with name and source
 * @param {string} scaleInfo.name - The scale name
 * @param {string} scaleInfo.source - Wikipedia or other source URL
 */ const ScaleHeader = ({ scaleNumber, scaleInfo })=>{
    const renderScaleName = ()=>{
        if (!scaleInfo) return null;
        if (scaleInfo.source) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                ' ("',
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: scaleInfo.source,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    title: "View Wikipedia source",
                    className: "scale-name-link",
                    children: scaleInfo.name
                }),
                '")'
            ]
        });
        return ` ("${scaleInfo.name}")`;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "scale-header",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "scale-info",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "scale-title",
                children: [
                    "Scale #",
                    scaleNumber,
                    renderScaleName()
                ]
            })
        })
    });
};
exports.default = ScaleHeader;

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"7CjhN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _vexflowUtils = require("../lib/vexflowUtils");
var _intervalBrackets = require("../lib/intervalBrackets");
var _hooks = require("../hooks");
/**
 * ScaleNotation Component - Handles VexFlow musical notation rendering
 * 
 * @param {Array} scale - Array of scale degrees/intervals
 * @param {Function} onNoteClick - Callback when a note is clicked
 * @param {Array} matchingPattern - Array of interval patterns to highlight
 */ const ScaleNotation = ({ scale, onNoteClick, matchingPattern = null })=>{
    const containerRef = (0, _react.useRef)(null);
    const visualConfig = (0, _hooks.useVisualConfig)();
    const renderScale = (container, scale, onNoteClick, visualConfig, matchingPattern)=>{
        if (!container) return;
        container.innerHTML = "";
        // Create notes from scale
        const { staveNotes } = (0, _vexflowUtils.createNotesFromScale)(scale);
        // Setup VexFlow renderer
        const { context, stave, svgWidth } = (0, _vexflowUtils.setupVexFlowRenderer)(container);
        // Calculate responsive format width using config
        const formatWidth = Math.min(visualConfig?.notation?.formatWidth || 360, svgWidth - 60);
        // Render musical notation
        (0, _vexflowUtils.renderNotesWithVexFlow)(staveNotes, context, stave, formatWidth);
        // Add interval analysis brackets
        (0, _intervalBrackets.renderIntervalBrackets)(container, staveNotes, scale, stave, {
            matchingPattern
        });
        // Add click handlers to notes
        if (onNoteClick) {
            const svg = container.querySelector('svg');
            if (svg) {
                const noteElements = svg.querySelectorAll('.vf-stavenote');
                noteElements.forEach((noteElement, index)=>{
                    noteElement.style.cursor = 'pointer';
                    noteElement.addEventListener('click', ()=>onNoteClick(index));
                });
            }
        }
    };
    (0, _react.useEffect)(()=>{
        if (containerRef.current) renderScale(containerRef.current, scale, onNoteClick, visualConfig, matchingPattern);
    }, [
        scale,
        onNoteClick,
        visualConfig,
        matchingPattern
    ]);
    // Global click handler to clear interval highlighting
    (0, _react.useEffect)(()=>{
        const handleGlobalClick = (e)=>{
            // Don't clear if clicking on an interval number or note
            if (e.target.classList.contains('interval-number') || e.target.closest('.vf-stavenote') || e.target.closest('.play-button')) return;
            // Clear interval highlighting
            if (containerRef.current) (0, _intervalBrackets.clearIntervalHighlight)(containerRef.current);
        };
        document.addEventListener('click', handleGlobalClick);
        return ()=>{
            document.removeEventListener('click', handleGlobalClick);
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: containerRef,
        className: "scale-notation"
    });
};
exports.default = ScaleNotation;

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","../lib/vexflowUtils":"fOpET","../lib/intervalBrackets":"9mjrb","../hooks":"aBBAD","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"fOpET":[function(require,module,exports,__globalThis) {
// VexFlow rendering utilities
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNotesFromScale", ()=>createNotesFromScale);
parcelHelpers.export(exports, "setupVexFlowRenderer", ()=>setupVexFlowRenderer);
parcelHelpers.export(exports, "renderNotesWithVexFlow", ()=>renderNotesWithVexFlow);
var _vexflow = require("vexflow");
var _tonal = require("tonal");
var _getEnharmonics = require("./getEnharmonics");
var _getEnharmonicsDefault = parcelHelpers.interopDefault(_getEnharmonics);
var _config = require("./config");
// Use config values for all layout constants
const STARTING_PITCH = (0, _config.getConfigValue)('audio.pitch.startingPitch', 60);
const createNotesFromScale = (scale)=>{
    // Convert scale to MIDI notes
    const midiNotes = scale.reduce((acc, step)=>{
        acc.push(acc[acc.length - 1] + step);
        return acc;
    }, [
        STARTING_PITCH
    ]);
    // Get note names and optimize enharmonics
    const rawNoteNames = midiNotes.map((midiNote)=>(0, _tonal.Midi).midiToNoteName(midiNote));
    const optimizedNoteNames = (0, _getEnharmonicsDefault.default)(rawNoteNames);
    // Create VexFlow StaveNote objects
    const staveNotes = optimizedNoteNames.map((noteName, index)=>{
        const note = (0, _tonal.Note).get(noteName);
        const key = `${note.pc.toLowerCase()}/${note.oct}`;
        const staveNote = new (0, _vexflow.StaveNote)({
            clef: "treble",
            keys: [
                key
            ],
            duration: "q"
        });
        // Add accidentals with enhanced logic
        if (note.acc) staveNote.addModifier(new (0, _vexflow.Accidental)(note.acc));
        else if (index > 0) {
            const prevNote = (0, _tonal.Note).get(optimizedNoteNames[index - 1]);
            if (prevNote.letter === note.letter && prevNote.acc) staveNote.addModifier(new (0, _vexflow.Accidental)('n'));
            else if (prevNote.acc && Math.abs(prevNote.chroma - note.chroma) === 1) {
                const prevLetter = prevNote.letter;
                const currentLetter = note.letter;
                if (prevLetter === 'D' && currentLetter === 'E' && prevNote.acc === '#' || prevLetter === 'E' && currentLetter === 'F' && prevNote.acc === '#' || prevLetter === 'A' && currentLetter === 'B' && prevNote.acc === '#' || prevLetter === 'B' && currentLetter === 'C' && prevNote.acc === '#') staveNote.addModifier(new (0, _vexflow.Accidental)('n'));
            }
        }
        return staveNote;
    });
    return {
        midiNotes,
        optimizedNoteNames,
        staveNotes
    };
};
const setupVexFlowRenderer = (container)=>{
    // Get container width and make responsive using config values
    const containerWidth = container.offsetWidth || (0, _config.getConfigValue)('visual.notation.maxWidth', 460);
    const svgWidth = Math.min((0, _config.getConfigValue)('visual.notation.maxWidth', 460), containerWidth - (0, _config.getConfigValue)('visual.notation.containerMargin', 20));
    const svgHeight = (0, _config.getConfigValue)('visual.notation.svgHeight', 120);
    const renderer = new (0, _vexflow.Renderer)(container, (0, _vexflow.Renderer).Backends.SVG);
    renderer.resize(svgWidth, svgHeight);
    const context = renderer.getContext();
    // Style the SVG for responsiveness
    const svg = container.querySelector('svg');
    if (svg) {
        svg.style.background = 'transparent';
        svg.style.maxWidth = '100%';
        svg.style.height = 'auto';
    }
    // Create and draw stave with responsive width using config values
    const staveWidth = Math.min((0, _config.getConfigValue)('visual.notation.maxWidth', 460) - 40, svgWidth - (0, _config.getConfigValue)('visual.notation.staveMargin', 20));
    const stave = new (0, _vexflow.Stave)((0, _config.getConfigValue)('visual.notation.staveLeftOffset', 0), (0, _config.getConfigValue)('visual.notation.staveTopOffset', 20), staveWidth);
    stave.addClef("treble").setContext(context).draw();
    return {
        renderer,
        context,
        stave,
        svgWidth
    };
};
const renderNotesWithVexFlow = (notes, context, stave, formatWidth = (0, _config.getConfigValue)('visual.notation.formatWidth', 360))=>{
    const voice = new (0, _vexflow.Voice)({
        num_beats: notes.length,
        beat_value: 4
    });
    voice.addTickables(notes);
    new (0, _vexflow.Formatter)().joinVoices([
        voice
    ]).format([
        voice
    ], formatWidth);
    voice.draw(context, stave);
};

},{"vexflow":"2fWVy","tonal":"b7q1y","./getEnharmonics":"9v1kQ","./config":"5TiHK","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"2fWVy":[function(require,module,exports,__globalThis) {
/*!
 * VexFlow 4.2.5   2024-05-12T08:56:23.690Z   5b5b43b18254cc5cf607a0977823900a375b48ed
 * Copyright (c) 2010 Mohit Muthanna Cheppudira <mohit@muthanna.com>
 * https://www.vexflow.com   https://github.com/0xfe/vexflow
 */ !function(t, e) {
    module.exports = e();
}("undefined" != typeof window ? window : "undefined" != typeof globalThis ? globalThis : this, ()=>(()=>{
        "use strict";
        var t = {
            d: (e, i)=>{
                for(var b in i)t.o(i, b) && !t.o(e, b) && Object.defineProperty(e, b, {
                    enumerable: !0,
                    get: i[b]
                });
            }
        };
        t.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t) {
                if ("object" == typeof window) return window;
            }
        }(), t.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), t.r = (t)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        };
        var e = {};
        t.d(e, {
            default: ()=>i
        });
        var i = {};
        function b(t, e, i = !0) {
            if ("object" != typeof t || null === t) return !1;
            let b1 = t.constructor;
            if (i) {
                for(; null !== t;){
                    if (b1 = t.constructor, "CATEGORY" in b1 && b1.CATEGORY === e) return !0;
                    t = Object.getPrototypeOf(t);
                }
                return !1;
            }
            return "CATEGORY" in b1 && b1.CATEGORY === e;
        }
        t.r(i), t.d(i, {
            Accidental: ()=>bt,
            Annotation: ()=>ct,
            AnnotationHorizontalJustify: ()=>ht,
            AnnotationVerticalJustify: ()=>mt,
            Articulation: ()=>ut,
            BEAM_BOTH: ()=>Oe,
            BEAM_LEFT: ()=>Fe,
            BEAM_RIGHT: ()=>Me,
            BarNote: ()=>At,
            Barline: ()=>kt,
            BarlineType: ()=>zt,
            Beam: ()=>Re,
            Bend: ()=>Nt,
            BoundingBox: ()=>D,
            BoundingBoxComputation: ()=>C,
            Builder: ()=>Ke,
            CanvasContext: ()=>Qt,
            Category: ()=>x,
            ChordSymbol: ()=>Mt,
            ChordSymbolHorizontalJustify: ()=>Bt,
            ChordSymbolVerticalJustify: ()=>Dt,
            Clef: ()=>de,
            ClefNote: ()=>Le,
            Crescendo: ()=>We,
            Curve: ()=>Ie,
            CurvePosition: ()=>Ue,
            Dot: ()=>Ot,
            EasyScore: ()=>Qe,
            EasyScoreGrammar: ()=>je,
            Element: ()=>R,
            Factory: ()=>vi,
            Flow: ()=>ki,
            Font: ()=>F,
            FontStyle: ()=>P,
            FontWeight: ()=>E,
            Formatter: ()=>Pe,
            Fraction: ()=>z,
            FretHandFinger: ()=>Rt,
            GhostNote: ()=>ti,
            Glyph: ()=>Z,
            GlyphNote: ()=>ei,
            GraceNote: ()=>ii,
            GraceNoteGroup: ()=>jt,
            GraceTabNote: ()=>wi,
            KeyManager: ()=>zi,
            KeySigNote: ()=>bi,
            KeySignature: ()=>_e,
            Modifier: ()=>tt,
            ModifierContext: ()=>ce,
            ModifierPosition: ()=>J,
            MultiMeasureRest: ()=>ni,
            Music: ()=>et,
            Note: ()=>vt,
            NoteHead: ()=>Lt,
            NoteSubGroup: ()=>Vt,
            Ornament: ()=>Kt,
            OutlineCode: ()=>$,
            Parenthesis: ()=>$t,
            Parser: ()=>Ye,
            PedalMarking: ()=>li,
            Piece: ()=>Ve,
            Registry: ()=>O,
            RenderContext: ()=>ft,
            Renderer: ()=>le,
            RendererBackends: ()=>be,
            RendererLineEndType: ()=>ae,
            RepeatNote: ()=>ri,
            Repetition: ()=>xe,
            RuntimeError: ()=>g,
            SVGContext: ()=>ie,
            Stave: ()=>ze,
            StaveConnector: ()=>De,
            StaveHairpin: ()=>Bi,
            StaveLine: ()=>mi,
            StaveModifier: ()=>Pt,
            StaveModifierPosition: ()=>wt,
            StaveNote: ()=>It,
            StaveSection: ()=>ge,
            StaveTempo: ()=>ye,
            StaveText: ()=>ue,
            StaveTie: ()=>Gt,
            Stem: ()=>at,
            StemmableNote: ()=>Wt,
            StringNumber: ()=>oe,
            Stroke: ()=>re,
            SymbolModifiers: ()=>Et,
            SymbolTypes: ()=>Ct,
            System: ()=>ci,
            TabNote: ()=>di,
            TabSlide: ()=>Di,
            TabStave: ()=>_i,
            TabTie: ()=>Ht,
            TextBracket: ()=>yi,
            TextBracketPosition: ()=>gi,
            TextDynamics: ()=>ui,
            TextFormatter: ()=>rt,
            TextJustification: ()=>ne,
            TextNote: ()=>pe,
            TickContext: ()=>Ce,
            Tickable: ()=>Tt,
            TimeSigNote: ()=>fi,
            TimeSignature: ()=>Te,
            TimeSignatureGlyph: ()=>Se,
            Tremolo: ()=>Ci,
            Tuning: ()=>Ei,
            Tuplet: ()=>Ae,
            TupletLocation: ()=>ke,
            Vex: ()=>Yi,
            Vibrato: ()=>he,
            VibratoBracket: ()=>Si,
            Voice: ()=>Xt,
            VoiceMode: ()=>Yt,
            Volta: ()=>fe,
            VoltaType: ()=>se,
            defined: ()=>p,
            drawDot: ()=>St,
            globalObject: ()=>y,
            isAccidental: ()=>a,
            isAnnotation: ()=>n,
            isBarline: ()=>s,
            isCategory: ()=>b,
            isDot: ()=>l,
            isGraceNote: ()=>o,
            isGraceNoteGroup: ()=>r,
            isHTMLCanvas: ()=>Jt,
            isHTMLDiv: ()=>qt,
            isNote: ()=>h,
            isRenderContext: ()=>m,
            isStaveNote: ()=>c,
            isStemmableNote: ()=>d,
            isTabNote: ()=>_,
            log: ()=>u,
            midLine: ()=>S,
            normalizeAngle: ()=>v,
            prefix: ()=>T,
            sumArray: ()=>w,
            warn: ()=>f
        });
        const a = (t)=>b(t, x.Accidental), n = (t)=>b(t, x.Annotation), s = (t)=>b(t, x.Barline), l = (t)=>b(t, x.Dot), o = (t)=>b(t, x.GraceNote), r = (t)=>b(t, x.GraceNoteGroup), h = (t)=>b(t, x.Note), m = (t)=>b(t, x.RenderContext), c = (t)=>b(t, x.StaveNote), d = (t)=>b(t, x.StemmableNote), _ = (t)=>b(t, x.TabNote);
        var x;
        !function(t) {
            t.Accidental = "Accidental", t.Annotation = "Annotation", t.Articulation = "Articulation", t.Barline = "Barline", t.BarNote = "BarNote", t.Beam = "Beam", t.Bend = "Bend", t.ChordSymbol = "ChordSymbol", t.Clef = "Clef", t.ClefNote = "ClefNote", t.Crescendo = "Crescendo", t.Curve = "Curve", t.Dot = "Dot", t.Element = "Element", t.Fraction = "Fraction", t.FretHandFinger = "FretHandFinger", t.GhostNote = "GhostNote", t.Glyph = "Glyph", t.GlyphNote = "GlyphNote", t.GraceNote = "GraceNote", t.GraceNoteGroup = "GraceNoteGroup", t.GraceTabNote = "GraceTabNote", t.KeySignature = "KeySignature", t.KeySigNote = "KeySigNote", t.Modifier = "Modifier", t.MultiMeasureRest = "MultiMeasureRest", t.Note = "Note", t.NoteHead = "NoteHead", t.NoteSubGroup = "NoteSubGroup", t.Ornament = "Ornament", t.Parenthesis = "Parenthesis", t.PedalMarking = "PedalMarking", t.RenderContext = "RenderContext", t.RepeatNote = "RepeatNote", t.Repetition = "Repetition", t.Stave = "Stave", t.StaveConnector = "StaveConnector", t.StaveHairpin = "StaveHairpin", t.StaveLine = "StaveLine", t.StaveModifier = "StaveModifier", t.StaveNote = "StaveNote", t.StaveSection = "StaveSection", t.StaveTempo = "StaveTempo", t.StaveText = "StaveText", t.StaveTie = "StaveTie", t.Stem = "Stem", t.StemmableNote = "StemmableNote", t.StringNumber = "StringNumber", t.Stroke = "Stroke", t.System = "System", t.TabNote = "TabNote", t.TabSlide = "TabSlide", t.TabStave = "TabStave", t.TabTie = "TabTie", t.TextBracket = "TextBracket", t.TextDynamics = "TextDynamics", t.TextNote = "TextNote", t.Tickable = "Tickable", t.TimeSignature = "TimeSignature", t.TimeSigNote = "TimeSigNote", t.Tremolo = "Tremolo", t.Tuplet = "Tuplet", t.Vibrato = "Vibrato", t.VibratoBracket = "VibratoBracket", t.Voice = "Voice", t.Volta = "Volta";
        }(x || (x = {}));
        class g extends Error {
            constructor(t, e = ""){
                super("[RuntimeError] " + t + ": " + e), this.code = t;
            }
        }
        function y() {
            return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== t.g ? t.g : Function("return this")();
        }
        function p(t, e = "undefined", i = "") {
            if (void 0 === t) throw new g(e, i);
            return t;
        }
        function u(t, ...e) {
            if (!e) return;
            const i = Array.prototype.slice.call(e).join(" ");
            y().console.log(t + ": " + i);
        }
        function f(...t) {
            const e = t.join(" "), i = new Error;
            y().console.log("Warning: ", e, i.stack);
        }
        function S(t, e) {
            let i = e + (t - e) / 2;
            var b, a;
            return i % 2 > 0 && (i = ((b = 10 * i) % (a = 5) >= a / 2 ? parseInt("" + b / a, 10) * a + a : parseInt("" + b / a, 10) * a) / 10), i;
        }
        function T(t) {
            return `vf-${t}`;
        }
        function v(t) {
            return (t %= 2 * Math.PI) < 0 && (t += 2 * Math.PI), t;
        }
        function w(t) {
            return t.reduce((t, e)=>t + e, 0);
        }
        class z {
            static get CATEGORY() {
                return x.Fraction;
            }
            static GCD(t, e) {
                if ("number" != typeof t || Number.isNaN(t) || "number" != typeof e || Number.isNaN(e)) throw new g("BadArgument", `Invalid numbers: ${t}, ${e}`);
                let i;
                for(; 0 !== e;)i = e, e = t % e, t = i;
                return t;
            }
            static LCM(t, e) {
                return t * e / z.GCD(t, e);
            }
            static LCMM(t) {
                return 0 === t.length ? 0 : 1 === t.length ? t[0] : 2 === t.length ? z.LCM(t[0], t[1]) : z.LCM(t.shift(), z.LCMM(t));
            }
            constructor(t, e){
                this.numerator = 1, this.denominator = 1, this.set(t, e);
            }
            set(t = 1, e = 1) {
                return this.numerator = t, this.denominator = e, this;
            }
            value() {
                return this.numerator / this.denominator;
            }
            simplify() {
                let t = this.numerator, e = this.denominator;
                const i = z.GCD(t, e);
                return t /= i, e /= i, e < 0 && (e = -e, t = -t), this.set(t, e);
            }
            add(t = 0, e = 1) {
                const [i, b] = B(t, e), a = z.LCM(this.denominator, b), n = a / this.denominator, s = a / b, l = this.numerator * n + i * s;
                return this.set(l, a);
            }
            subtract(t = 0, e = 1) {
                const [i, b] = B(t, e), a = z.LCM(this.denominator, b), n = a / this.denominator, s = a / b, l = this.numerator * n - i * s;
                return this.set(l, a);
            }
            multiply(t = 1, e = 1) {
                const [i, b] = B(t, e);
                return this.set(this.numerator * i, this.denominator * b);
            }
            divide(t = 1, e = 1) {
                const [i, b] = B(t, e);
                return this.set(this.numerator * b, this.denominator * i);
            }
            equals(t) {
                const e = z.__staticFractionA.copy(t).simplify(), i = z.__staticFractionB.copy(this).simplify();
                return e.numerator === i.numerator && e.denominator === i.denominator;
            }
            greaterThan(t) {
                const e = z.__staticFractionB.copy(this);
                return e.subtract(t), e.numerator > 0;
            }
            greaterThanEquals(t) {
                const e = z.__staticFractionB.copy(this);
                return e.subtract(t), e.numerator >= 0;
            }
            lessThan(t) {
                return !this.greaterThanEquals(t);
            }
            lessThanEquals(t) {
                return !this.greaterThan(t);
            }
            clone() {
                return new z(this.numerator, this.denominator);
            }
            copy(t) {
                return "number" == typeof t ? this.set(t, 1) : this.set(t.numerator, t.denominator);
            }
            quotient() {
                return Math.floor(this.numerator / this.denominator);
            }
            remainder() {
                return this.numerator % this.denominator;
            }
            makeAbs() {
                return this.denominator = Math.abs(this.denominator), this.numerator = Math.abs(this.numerator), this;
            }
            toString() {
                return `${this.numerator}/${this.denominator}`;
            }
            toSimplifiedString() {
                return z.__staticFractionTmp.copy(this).simplify().toString();
            }
            toMixedString() {
                let t = "";
                const e = this.quotient(), i = z.__staticFractionTmp.copy(this);
                return e < 0 && i.makeAbs(), 0 !== e ? (t += e, 0 !== i.numerator && (t += ` ${i.toSimplifiedString()}`)) : t = 0 === i.numerator ? "0" : i.toSimplifiedString(), t;
            }
            parse(t) {
                const e = t.split("/"), i = parseInt(e[0], 10), b = e[1] ? parseInt(e[1], 10) : 1;
                return this.set(i, b);
            }
        }
        function B(t, e = 1) {
            return "number" == typeof t ? [
                t,
                e
            ] : [
                t.numerator,
                t.denominator
            ];
        }
        z.__staticFractionA = new z, z.__staticFractionB = new z, z.__staticFractionTmp = new z;
        class D {
            static copy(t) {
                return new D(t.x, t.y, t.w, t.h);
            }
            constructor(t, e, i, b){
                this.x = t, this.y = e, this.w = i, this.h = b;
            }
            getX() {
                return this.x;
            }
            getY() {
                return this.y;
            }
            getW() {
                return this.w;
            }
            getH() {
                return this.h;
            }
            setX(t) {
                return this.x = t, this;
            }
            setY(t) {
                return this.y = t, this;
            }
            setW(t) {
                return this.w = t, this;
            }
            setH(t) {
                return this.h = t, this;
            }
            move(t, e) {
                return this.x += t, this.y += e, this;
            }
            clone() {
                return D.copy(this);
            }
            mergeWith(t) {
                const e = t, i = this.x < e.x ? this.x : e.x, b = this.y < e.y ? this.y : e.y, a = Math.max(this.x + this.w, e.x + e.w) - i, n = Math.max(this.y + this.h, e.y + e.h) - b;
                return this.x = i, this.y = b, this.w = a, this.h = n, this;
            }
        }
        class C {
            constructor(){
                this.x1 = Number.NaN, this.y1 = Number.NaN, this.x2 = Number.NaN, this.y2 = Number.NaN;
            }
            getX1() {
                return this.x1;
            }
            getY1() {
                return this.y1;
            }
            width() {
                return this.x2 - this.x1;
            }
            height() {
                return this.y2 - this.y1;
            }
            addPoint(t, e) {
                (isNaN(this.x1) || t < this.x1) && (this.x1 = t), (isNaN(this.x2) || t > this.x2) && (this.x2 = t), (isNaN(this.y1) || e < this.y1) && (this.y1 = e), (isNaN(this.y2) || e > this.y2) && (this.y2 = e);
            }
            addX(t) {
                this.addPoint(t, this.y1);
            }
            addY(t) {
                this.addPoint(this.x1, t);
            }
            addQuadraticCurve(t, e, i, b, a, n) {
                this.addPoint(t, e), this.addPoint(a, n);
                const s = i - t;
                let l = s - (a - i);
                if (0 != l) {
                    const e = s / l;
                    if (e > 0 && e < 1) {
                        const b = 1 - e;
                        this.addX(b * b * t + 2 * b * e * i + e * e * a);
                    }
                }
                const o = b - e;
                if (l = o - (n - b), 0 != l) {
                    const t = o / l;
                    if (t > 0 && t < 1) {
                        const i = 1 - t;
                        this.addY(i * i * e + 2 * i * t * b + t * t * n);
                    }
                }
            }
            addBezierCurve(t, e, i, b, a, n, s, l) {
                const o = [
                    t,
                    e
                ], r = [
                    i,
                    b
                ], h = [
                    a,
                    n
                ], m = [
                    s,
                    l
                ];
                let c;
                this.addPoint(o[0], o[1]), this.addPoint(m[0], m[1]);
                const d = (t, e)=>Math.pow(1 - t, 3) * o[e] + 3 * Math.pow(1 - t, 2) * t * r[e] + 3 * (1 - t) * Math.pow(t, 2) * h[e] + Math.pow(t, 3) * m[e];
                for(c = 0; c <= 1; c++){
                    const t = 6 * o[c] - 12 * r[c] + 6 * h[c], e = -3 * o[c] + 9 * r[c] - 9 * h[c] + 3 * m[c], i = 3 * r[c] - 3 * o[c];
                    if (0 === e) {
                        if (0 === t) continue;
                        const e = -i / t;
                        0 < e && e < 1 && (0 === c && this.addX(d(e, c)), 1 === c && this.addY(d(e, c)));
                        continue;
                    }
                    const b = Math.pow(t, 2) - 4 * i * e;
                    if (b < 0) continue;
                    const a = (-t + Math.sqrt(b)) / (2 * e);
                    0 < a && a < 1 && (0 === c && this.addX(d(a, c)), 1 === c && this.addY(d(a, c)));
                    const n = (-t - Math.sqrt(b)) / (2 * e);
                    0 < n && n < 1 && (0 === c && this.addX(d(n, c)), 1 === c && this.addY(d(n, c)));
                }
            }
        }
        var E, P, k = function(t, e, i, b) {
            return new (i || (i = Promise))(function(a, n) {
                function s(t) {
                    try {
                        o(b.next(t));
                    } catch (t) {
                        n(t);
                    }
                }
                function l(t) {
                    try {
                        o(b.throw(t));
                    } catch (t) {
                        n(t);
                    }
                }
                function o(t) {
                    var e;
                    t.done ? a(t.value) : (e = t.value, e instanceof i ? e : new i(function(t) {
                        t(e);
                    })).then(s, l);
                }
                o((b = b.apply(t, e || [])).next());
            });
        };
        let A;
        !function(t) {
            t.NORMAL = "normal", t.BOLD = "bold";
        }(E || (E = {})), function(t) {
            t.NORMAL = "normal", t.ITALIC = "italic";
        }(P || (P = {}));
        const N = {};
        class F {
            static convertSizeToPixelValue(t = F.SIZE) {
                var e;
                if ("number" == typeof t) return t * F.scaleToPxFrom.pt;
                {
                    const i = parseFloat(t);
                    if (isNaN(i)) return 0;
                    const b = t.replace(/[\d.\s]/g, "").toLowerCase();
                    return i * (null !== (e = F.scaleToPxFrom[b]) && void 0 !== e ? e : 1);
                }
            }
            static convertSizeToPointValue(t = F.SIZE) {
                var e;
                if ("number" == typeof t) return t;
                {
                    const i = parseFloat(t);
                    if (isNaN(i)) return 0;
                    const b = t.replace(/[\d.\s]/g, "").toLowerCase();
                    return i * ((null !== (e = F.scaleToPxFrom[b]) && void 0 !== e ? e : 1) / F.scaleToPxFrom.pt);
                }
            }
            static validate(t, e, i, b) {
                if ("string" == typeof t && void 0 === e && void 0 === i && void 0 === b) return F.fromCSSString(t);
                let a;
                return "object" == typeof t ? (a = t.family, e = t.size, i = t.weight, b = t.style) : a = t, a = null != a ? a : F.SANS_SERIF, e = null != e ? e : F.SIZE + "pt", i = null != i ? i : E.NORMAL, b = null != b ? b : P.NORMAL, "" === i && (i = E.NORMAL), "" === b && (b = P.NORMAL), "number" == typeof e && (e = `${e}pt`), "number" == typeof i && (i = i.toString()), {
                    family: a,
                    size: e,
                    weight: i,
                    style: b
                };
            }
            static fromCSSString(t) {
                A || (A = document.createElement("span")), A.style.font = t;
                const { fontFamily: e, fontSize: i, fontWeight: b, fontStyle: a } = A.style;
                return {
                    family: e,
                    size: i,
                    weight: b,
                    style: a
                };
            }
            static toCSSString(t) {
                var e;
                if (!t) return "";
                let i;
                const b = t.style;
                let a;
                i = b === P.NORMAL || "" === b || void 0 === b ? "" : b.trim() + " ";
                const n = t.weight;
                let s;
                a = n === E.NORMAL || "" === n || void 0 === n ? "" : "number" == typeof n ? n + " " : n.trim() + " ";
                const l = t.size;
                s = void 0 === l ? F.SIZE + "pt " : "number" == typeof l ? l + "pt " : l.trim() + " ";
                return `${i}${a}${s}${null !== (e = t.family) && void 0 !== e ? e : F.SANS_SERIF}`;
            }
            static scaleSize(t, e) {
                if ("number" == typeof t) return t * e;
                return `${parseFloat(t) * e}${t.replace(/[\d.\s]/g, "")}`;
            }
            static isBold(t) {
                if (t) {
                    if ("number" == typeof t) return t >= 600;
                    {
                        const e = parseInt(t, 10);
                        return isNaN(e) ? "bold" === t.toLowerCase() : e >= 600;
                    }
                }
                return !1;
            }
            static isItalic(t) {
                return !!t && t.toLowerCase() === P.ITALIC;
            }
            static loadWebFont(t, e, i = !0) {
                return k(this, void 0, void 0, function*() {
                    const b = new FontFace(t, (i ? `url(${e}2) format('woff2'), ` : "") + `url(${e}) format('woff')`);
                    return yield b.load(), document.fonts.add(b), b;
                });
            }
            static loadWebFonts() {
                return k(this, void 0, void 0, function*() {
                    const t = F.WEB_FONT_HOST, e = F.WEB_FONT_FILES;
                    for(const i in e){
                        const b = e[i];
                        F.loadWebFont(i, t + b);
                    }
                });
            }
            static load(t, e, i) {
                let b = N[t];
                return b || (b = new F(t), N[t] = b), e && b.setData(e), i && b.setMetrics(i), b;
            }
            constructor(t){
                this.name = t;
            }
            getName() {
                return this.name;
            }
            getData() {
                return p(this.data, "FontError", "Missing font data");
            }
            getMetrics() {
                return p(this.metrics, "FontError", "Missing metrics");
            }
            setData(t) {
                this.data = t;
            }
            setMetrics(t) {
                this.metrics = t;
            }
            hasData() {
                return void 0 !== this.data;
            }
            getResolution() {
                return this.getData().resolution;
            }
            getGlyphs() {
                return this.getData().glyphs;
            }
            lookupMetric(t, e) {
                const i = t.split(".");
                let b = this.getMetrics();
                for(let t = 0; t < i.length; t++){
                    const a = b[i[t]];
                    if (void 0 === a) return e;
                    b = a;
                }
                return b;
            }
            toString() {
                return "[" + this.name + " Font]";
            }
        }
        F.SANS_SERIF = "Arial, sans-serif", F.SERIF = "Times New Roman, serif", F.SIZE = 10, F.scaleToPxFrom = {
            pt: 4 / 3,
            px: 1,
            em: 16,
            "%": .16,
            in: 96,
            mm: 96 / 25.4,
            cm: 96 / 2.54
        }, F.WEB_FONT_HOST = "https://unpkg.com/vexflow-fonts@1.0.3/", F.WEB_FONT_FILES = {
            "Roboto Slab": "robotoslab/RobotoSlab-Medium_2.001.woff",
            PetalumaScript: "petaluma/PetalumaScript_1.10_FS.woff"
        };
        class M {
            constructor(){
                this.id = {}, this.type = {}, this.class = {};
            }
        }
        class O {
            static getDefaultRegistry() {
                return O.defaultRegistry;
            }
            static enableDefaultRegistry(t) {
                O.defaultRegistry = t;
            }
            static disableDefaultRegistry() {
                O.defaultRegistry = void 0;
            }
            constructor(){
                this.index = new M;
            }
            clear() {
                return this.index = new M, this;
            }
            setIndexValue(t, e, i, b) {
                const a = this.index;
                a[t][e] || (a[t][e] = {}), a[t][e][i] = b;
            }
            updateIndex({ id: t, name: e, value: i, oldValue: b }) {
                const a = this.getElementById(t);
                void 0 !== b && this.index[e][b] && delete this.index[e][b][t], i && a && this.setIndexValue(e, i, a.getAttribute("id"), a);
            }
            register(t, e) {
                if (!(e = e || t.getAttribute("id"))) throw new g("Can't add element without `id` attribute to registry");
                return t.setAttribute("id", e), this.setIndexValue("id", e, e, t), this.updateIndex({
                    id: e,
                    name: "type",
                    value: t.getAttribute("type"),
                    oldValue: void 0
                }), t.onRegister(this), this;
            }
            getElementById(t) {
                var e, i;
                return null === (i = null === (e = this.index.id) || void 0 === e ? void 0 : e[t]) || void 0 === i ? void 0 : i[t];
            }
            getElementsByAttribute(t, e) {
                const i = this.index[t];
                if (i) {
                    const t = i[e];
                    if (t) return Object.keys(t).map((e)=>t[e]);
                }
                return [];
            }
            getElementsByType(t) {
                return this.getElementsByAttribute("type", t);
            }
            getElementsByClass(t) {
                return this.getElementsByAttribute("class", t);
            }
            onUpdate(t) {
                return [
                    "id",
                    "type",
                    "class"
                ].includes(t.name) && this.updateIndex(t), this;
            }
        }
        class R {
            static get CATEGORY() {
                return x.Element;
            }
            static newID() {
                return "auto" + R.ID++;
            }
            constructor(){
                var t;
                this.children = [], this.attrs = {
                    id: R.newID(),
                    type: this.getCategory(),
                    class: ""
                }, this.rendered = !1, null === (t = O.getDefaultRegistry()) || void 0 === t || t.register(this);
            }
            addChildElement(t) {
                return this.children.push(t), this;
            }
            getCategory() {
                return this.constructor.CATEGORY;
            }
            setStyle(t) {
                return this.style = t, this;
            }
            setGroupStyle(t) {
                return this.style = t, this.children.forEach((e)=>e.setGroupStyle(t)), this;
            }
            getStyle() {
                return this.style;
            }
            applyStyle(t = this.context, e = this.getStyle()) {
                return e && t ? (t.save(), e.shadowColor && t.setShadowColor(e.shadowColor), e.shadowBlur && t.setShadowBlur(e.shadowBlur), e.fillStyle && t.setFillStyle(e.fillStyle), e.strokeStyle && t.setStrokeStyle(e.strokeStyle), e.lineWidth && t.setLineWidth(e.lineWidth), this) : this;
            }
            restoreStyle(t = this.context, e = this.getStyle()) {
                return e && t ? (t.restore(), this) : this;
            }
            drawWithStyle() {
                this.checkContext(), this.applyStyle(), this.draw(), this.restoreStyle();
            }
            hasClass(t) {
                var e;
                return !!this.attrs.class && -1 != (null === (e = this.attrs.class) || void 0 === e ? void 0 : e.split(" ").indexOf(t));
            }
            addClass(t) {
                var e;
                return this.hasClass(t) || (this.attrs.class ? this.attrs.class = `${this.attrs.class} ${t}` : this.attrs.class = `${t}`, null === (e = this.registry) || void 0 === e || e.onUpdate({
                    id: this.attrs.id,
                    name: "class",
                    value: t,
                    oldValue: void 0
                })), this;
            }
            removeClass(t) {
                var e, i;
                if (!this.hasClass(t)) return this;
                const b = null === (e = this.attrs.class) || void 0 === e ? void 0 : e.split(" ");
                return b && (b.splice(b.indexOf(t)), this.attrs.class = b.join(" ")), null === (i = this.registry) || void 0 === i || i.onUpdate({
                    id: this.attrs.id,
                    name: "class",
                    value: void 0,
                    oldValue: t
                }), this;
            }
            onRegister(t) {
                return this.registry = t, this;
            }
            isRendered() {
                return this.rendered;
            }
            setRendered(t = !0) {
                return this.rendered = t, this;
            }
            getAttributes() {
                return this.attrs;
            }
            getAttribute(t) {
                return this.attrs[t];
            }
            getSVGElement(t = "") {
                const e = T(this.attrs.id + t), i = document.getElementById(e);
                if (i) return i;
            }
            setAttribute(t, e) {
                var i;
                const b = this.attrs.id, a = this.attrs[t];
                return this.attrs[t] = e, null === (i = this.registry) || void 0 === i || i.onUpdate({
                    id: b,
                    name: t,
                    value: e,
                    oldValue: a
                }), this;
            }
            getBoundingBox() {
                return this.boundingBox;
            }
            getContext() {
                return this.context;
            }
            setContext(t) {
                return this.context = t, this;
            }
            checkContext() {
                return p(this.context, "NoContext", "No rendering context attached to instance.");
            }
            set font(t) {
                this.setFont(t);
            }
            get font() {
                return F.toCSSString(this.textFont);
            }
            setFont(t, e, i, b) {
                const a = this.constructor.TEXT_FONT, n = "object" == typeof t, s = "string" == typeof t, l = void 0 === t, o = void 0 === e && void 0 === i && void 0 === b;
                return this.textFont = n ? Object.assign(Object.assign({}, a), t) : s && o ? F.fromCSSString(t) : l && o ? Object.assign({}, a) : F.validate(null != t ? t : a.family, null != e ? e : a.size, null != i ? i : a.weight, null != b ? b : a.style), this;
            }
            getFont() {
                return this.textFont || this.resetFont(), F.toCSSString(this.textFont);
            }
            resetFont() {
                this.setFont();
            }
            get fontInfo() {
                return this.textFont || this.resetFont(), Object.assign({}, this.textFont);
            }
            set fontInfo(t) {
                this.setFont(t);
            }
            setFontSize(t) {
                const e = this.fontInfo;
                return this.setFont(e.family, t, e.weight, e.style), this;
            }
            getFontSize() {
                return this.fontSize;
            }
            set fontSize(t) {
                this.setFontSize(t);
            }
            get fontSize() {
                let t = this.fontInfo.size;
                return "number" == typeof t && (t = `${t}pt`), t;
            }
            get fontSizeInPoints() {
                return F.convertSizeToPointValue(this.fontSize);
            }
            get fontSizeInPixels() {
                return F.convertSizeToPixelValue(this.fontSize);
            }
            get fontStyle() {
                return this.fontInfo.style;
            }
            set fontStyle(t) {
                const e = this.fontInfo;
                this.setFont(e.family, e.size, e.weight, t);
            }
            get fontWeight() {
                return this.fontInfo.weight + "";
            }
            set fontWeight(t) {
                const e = this.fontInfo;
                this.setFont(e.family, e.size, t, e.style);
            }
        }
        R.ID = 1e3, R.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: F.SIZE,
            weight: E.NORMAL,
            style: P.NORMAL
        };
        const L = 16384, W = {
            "1/2": 32768,
            1: 16384,
            2: 8192,
            4: 4096,
            8: 2048,
            16: 1024,
            32: 512,
            64: 256,
            128: 128,
            256: 64
        }, U = {
            w: "1",
            h: "2",
            q: "4",
            b: "256"
        }, I = {
            C: {
                num: 0
            },
            Am: {
                num: 0
            },
            F: {
                acc: "b",
                num: 1
            },
            Dm: {
                acc: "b",
                num: 1
            },
            Bb: {
                acc: "b",
                num: 2
            },
            Gm: {
                acc: "b",
                num: 2
            },
            Eb: {
                acc: "b",
                num: 3
            },
            Cm: {
                acc: "b",
                num: 3
            },
            Ab: {
                acc: "b",
                num: 4
            },
            Fm: {
                acc: "b",
                num: 4
            },
            Db: {
                acc: "b",
                num: 5
            },
            Bbm: {
                acc: "b",
                num: 5
            },
            Gb: {
                acc: "b",
                num: 6
            },
            Ebm: {
                acc: "b",
                num: 6
            },
            Cb: {
                acc: "b",
                num: 7
            },
            Abm: {
                acc: "b",
                num: 7
            },
            G: {
                acc: "#",
                num: 1
            },
            Em: {
                acc: "#",
                num: 1
            },
            D: {
                acc: "#",
                num: 2
            },
            Bm: {
                acc: "#",
                num: 2
            },
            A: {
                acc: "#",
                num: 3
            },
            "F#m": {
                acc: "#",
                num: 3
            },
            E: {
                acc: "#",
                num: 4
            },
            "C#m": {
                acc: "#",
                num: 4
            },
            B: {
                acc: "#",
                num: 5
            },
            "G#m": {
                acc: "#",
                num: 5
            },
            "F#": {
                acc: "#",
                num: 6
            },
            "D#m": {
                acc: "#",
                num: 6
            },
            "C#": {
                acc: "#",
                num: 7
            },
            "A#m": {
                acc: "#",
                num: 7
            }
        }, G = {
            treble: {
                line_shift: 0
            },
            bass: {
                line_shift: 6
            },
            tenor: {
                line_shift: 4
            },
            alto: {
                line_shift: 3
            },
            soprano: {
                line_shift: 1
            },
            percussion: {
                line_shift: 0
            },
            "mezzo-soprano": {
                line_shift: 2
            },
            "baritone-c": {
                line_shift: 5
            },
            "baritone-f": {
                line_shift: 5
            },
            subbass: {
                line_shift: 7
            },
            french: {
                line_shift: -1
            }
        }, H = {
            C: {
                index: 0,
                int_val: 0
            },
            CN: {
                index: 0,
                int_val: 0,
                accidental: "n"
            },
            "C#": {
                index: 0,
                int_val: 1,
                accidental: "#"
            },
            "C##": {
                index: 0,
                int_val: 2,
                accidental: "##"
            },
            CB: {
                index: 0,
                int_val: 11,
                accidental: "b"
            },
            CBB: {
                index: 0,
                int_val: 10,
                accidental: "bb"
            },
            D: {
                index: 1,
                int_val: 2
            },
            DN: {
                index: 1,
                int_val: 2,
                accidental: "n"
            },
            "D#": {
                index: 1,
                int_val: 3,
                accidental: "#"
            },
            "D##": {
                index: 1,
                int_val: 4,
                accidental: "##"
            },
            DB: {
                index: 1,
                int_val: 1,
                accidental: "b"
            },
            DBB: {
                index: 1,
                int_val: 0,
                accidental: "bb"
            },
            E: {
                index: 2,
                int_val: 4
            },
            EN: {
                index: 2,
                int_val: 4,
                accidental: "n"
            },
            "E#": {
                index: 2,
                int_val: 5,
                accidental: "#"
            },
            "E##": {
                index: 2,
                int_val: 6,
                accidental: "##"
            },
            EB: {
                index: 2,
                int_val: 3,
                accidental: "b"
            },
            EBB: {
                index: 2,
                int_val: 2,
                accidental: "bb"
            },
            F: {
                index: 3,
                int_val: 5
            },
            FN: {
                index: 3,
                int_val: 5,
                accidental: "n"
            },
            "F#": {
                index: 3,
                int_val: 6,
                accidental: "#"
            },
            "F##": {
                index: 3,
                int_val: 7,
                accidental: "##"
            },
            FB: {
                index: 3,
                int_val: 4,
                accidental: "b"
            },
            FBB: {
                index: 3,
                int_val: 3,
                accidental: "bb"
            },
            G: {
                index: 4,
                int_val: 7
            },
            GN: {
                index: 4,
                int_val: 7,
                accidental: "n"
            },
            "G#": {
                index: 4,
                int_val: 8,
                accidental: "#"
            },
            "G##": {
                index: 4,
                int_val: 9,
                accidental: "##"
            },
            GB: {
                index: 4,
                int_val: 6,
                accidental: "b"
            },
            GBB: {
                index: 4,
                int_val: 5,
                accidental: "bb"
            },
            A: {
                index: 5,
                int_val: 9
            },
            AN: {
                index: 5,
                int_val: 9,
                accidental: "n"
            },
            "A#": {
                index: 5,
                int_val: 10,
                accidental: "#"
            },
            "A##": {
                index: 5,
                int_val: 11,
                accidental: "##"
            },
            AB: {
                index: 5,
                int_val: 8,
                accidental: "b"
            },
            ABB: {
                index: 5,
                int_val: 7,
                accidental: "bb"
            },
            B: {
                index: 6,
                int_val: 11
            },
            BN: {
                index: 6,
                int_val: 11,
                accidental: "n"
            },
            "B#": {
                index: 6,
                int_val: 12,
                accidental: "#"
            },
            "B##": {
                index: 6,
                int_val: 13,
                accidental: "##"
            },
            BB: {
                index: 6,
                int_val: 10,
                accidental: "b"
            },
            BBB: {
                index: 6,
                int_val: 9,
                accidental: "bb"
            },
            R: {
                index: 6,
                rest: !0
            },
            X: {
                index: 6,
                accidental: "",
                octave: 4,
                code: "noteheadXBlack",
                shift_right: 5.5
            }
        }, Y = {
            "#": {
                code: "accidentalSharp",
                parenRightPaddingAdjustment: -1
            },
            "##": {
                code: "accidentalDoubleSharp",
                parenRightPaddingAdjustment: -1
            },
            b: {
                code: "accidentalFlat",
                parenRightPaddingAdjustment: -2
            },
            bb: {
                code: "accidentalDoubleFlat",
                parenRightPaddingAdjustment: -2
            },
            n: {
                code: "accidentalNatural",
                parenRightPaddingAdjustment: -1
            },
            "{": {
                code: "accidentalParensLeft",
                parenRightPaddingAdjustment: -1
            },
            "}": {
                code: "accidentalParensRight",
                parenRightPaddingAdjustment: -1
            },
            db: {
                code: "accidentalThreeQuarterTonesFlatZimmermann",
                parenRightPaddingAdjustment: -1
            },
            d: {
                code: "accidentalQuarterToneFlatStein",
                parenRightPaddingAdjustment: 0
            },
            "++": {
                code: "accidentalThreeQuarterTonesSharpStein",
                parenRightPaddingAdjustment: -1
            },
            "+": {
                code: "accidentalQuarterToneSharpStein",
                parenRightPaddingAdjustment: -1
            },
            "+-": {
                code: "accidentalKucukMucennebSharp",
                parenRightPaddingAdjustment: -1
            },
            bs: {
                code: "accidentalBakiyeFlat",
                parenRightPaddingAdjustment: -1
            },
            bss: {
                code: "accidentalBuyukMucennebFlat",
                parenRightPaddingAdjustment: -1
            },
            o: {
                code: "accidentalSori",
                parenRightPaddingAdjustment: -1
            },
            k: {
                code: "accidentalKoron",
                parenRightPaddingAdjustment: -1
            },
            bbs: {
                code: "vexAccidentalMicrotonal1",
                parenRightPaddingAdjustment: -1
            },
            "++-": {
                code: "accidentalBuyukMucennebSharp",
                parenRightPaddingAdjustment: -1
            },
            ashs: {
                code: "vexAccidentalMicrotonal3",
                parenRightPaddingAdjustment: -1
            },
            afhf: {
                code: "vexAccidentalMicrotonal4",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v7KleismaUp: {
                code: "accSagittal5v7KleismaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v7KleismaDown: {
                code: "accSagittal5v7KleismaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5CommaUp: {
                code: "accSagittal5CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5CommaDown: {
                code: "accSagittal5CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7CommaUp: {
                code: "accSagittal7CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7CommaDown: {
                code: "accSagittal7CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal25SmallDiesisUp: {
                code: "accSagittal25SmallDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal25SmallDiesisDown: {
                code: "accSagittal25SmallDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal35MediumDiesisUp: {
                code: "accSagittal35MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal35MediumDiesisDown: {
                code: "accSagittal35MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11MediumDiesisUp: {
                code: "accSagittal11MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11MediumDiesisDown: {
                code: "accSagittal11MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11LargeDiesisUp: {
                code: "accSagittal11LargeDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11LargeDiesisDown: {
                code: "accSagittal11LargeDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal35LargeDiesisUp: {
                code: "accSagittal35LargeDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal35LargeDiesisDown: {
                code: "accSagittal35LargeDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp25SDown: {
                code: "accSagittalSharp25SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat25SUp: {
                code: "accSagittalFlat25SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7CDown: {
                code: "accSagittalSharp7CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7CUp: {
                code: "accSagittalFlat7CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5CDown: {
                code: "accSagittalSharp5CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5CUp: {
                code: "accSagittalFlat5CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v7kDown: {
                code: "accSagittalSharp5v7kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v7kUp: {
                code: "accSagittalFlat5v7kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp: {
                code: "accSagittalSharp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat: {
                code: "accSagittalFlat",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v7kUp: {
                code: "accSagittalSharp5v7kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v7kDown: {
                code: "accSagittalFlat5v7kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5CUp: {
                code: "accSagittalSharp5CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5CDown: {
                code: "accSagittalFlat5CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7CUp: {
                code: "accSagittalSharp7CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7CDown: {
                code: "accSagittalFlat7CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp25SUp: {
                code: "accSagittalSharp25SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat25SDown: {
                code: "accSagittalFlat25SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp35MUp: {
                code: "accSagittalSharp35MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat35MDown: {
                code: "accSagittalFlat35MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11MUp: {
                code: "accSagittalSharp11MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11MDown: {
                code: "accSagittalFlat11MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11LUp: {
                code: "accSagittalSharp11LUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11LDown: {
                code: "accSagittalFlat11LDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp35LUp: {
                code: "accSagittalSharp35LUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat35LDown: {
                code: "accSagittalFlat35LDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp25SDown: {
                code: "accSagittalDoubleSharp25SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat25SUp: {
                code: "accSagittalDoubleFlat25SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp7CDown: {
                code: "accSagittalDoubleSharp7CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat7CUp: {
                code: "accSagittalDoubleFlat7CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp5CDown: {
                code: "accSagittalDoubleSharp5CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat5CUp: {
                code: "accSagittalDoubleFlat5CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp5v7kDown: {
                code: "accSagittalDoubleSharp5v7kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat5v7kUp: {
                code: "accSagittalDoubleFlat5v7kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp: {
                code: "accSagittalDoubleSharp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat: {
                code: "accSagittalDoubleFlat",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v11KleismaUp: {
                code: "accSagittal7v11KleismaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v11KleismaDown: {
                code: "accSagittal7v11KleismaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal17CommaUp: {
                code: "accSagittal17CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal17CommaDown: {
                code: "accSagittal17CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal55CommaUp: {
                code: "accSagittal55CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal55CommaDown: {
                code: "accSagittal55CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v11CommaUp: {
                code: "accSagittal7v11CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v11CommaDown: {
                code: "accSagittal7v11CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v11SmallDiesisUp: {
                code: "accSagittal5v11SmallDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v11SmallDiesisDown: {
                code: "accSagittal5v11SmallDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v11SDown: {
                code: "accSagittalSharp5v11SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v11SUp: {
                code: "accSagittalFlat5v11SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v11CDown: {
                code: "accSagittalSharp7v11CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v11CUp: {
                code: "accSagittalFlat7v11CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp55CDown: {
                code: "accSagittalSharp55CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat55CUp: {
                code: "accSagittalFlat55CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp17CDown: {
                code: "accSagittalSharp17CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat17CUp: {
                code: "accSagittalFlat17CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v11kDown: {
                code: "accSagittalSharp7v11kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v11kUp: {
                code: "accSagittalFlat7v11kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v11kUp: {
                code: "accSagittalSharp7v11kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v11kDown: {
                code: "accSagittalFlat7v11kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp17CUp: {
                code: "accSagittalSharp17CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat17CDown: {
                code: "accSagittalFlat17CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp55CUp: {
                code: "accSagittalSharp55CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat55CDown: {
                code: "accSagittalFlat55CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v11CUp: {
                code: "accSagittalSharp7v11CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v11CDown: {
                code: "accSagittalFlat7v11CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v11SUp: {
                code: "accSagittalSharp5v11SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v11SDown: {
                code: "accSagittalFlat5v11SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp5v11SDown: {
                code: "accSagittalDoubleSharp5v11SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat5v11SUp: {
                code: "accSagittalDoubleFlat5v11SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp7v11CDown: {
                code: "accSagittalDoubleSharp7v11CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat7v11CUp: {
                code: "accSagittalDoubleFlat7v11CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp55CDown: {
                code: "accSagittalDoubleSharp55CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat55CUp: {
                code: "accSagittalDoubleFlat55CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp17CDown: {
                code: "accSagittalDoubleSharp17CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat17CUp: {
                code: "accSagittalDoubleFlat17CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp7v11kDown: {
                code: "accSagittalDoubleSharp7v11kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat7v11kUp: {
                code: "accSagittalDoubleFlat7v11kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal23CommaUp: {
                code: "accSagittal23CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal23CommaDown: {
                code: "accSagittal23CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v19CommaUp: {
                code: "accSagittal5v19CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v19CommaDown: {
                code: "accSagittal5v19CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v23SmallDiesisUp: {
                code: "accSagittal5v23SmallDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v23SmallDiesisDown: {
                code: "accSagittal5v23SmallDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v23SDown: {
                code: "accSagittalSharp5v23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v23SUp: {
                code: "accSagittalFlat5v23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v19CDown: {
                code: "accSagittalSharp5v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v19CUp: {
                code: "accSagittalFlat5v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp23CDown: {
                code: "accSagittalSharp23CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat23CUp: {
                code: "accSagittalFlat23CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp23CUp: {
                code: "accSagittalSharp23CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat23CDown: {
                code: "accSagittalFlat23CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v19CUp: {
                code: "accSagittalSharp5v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v19CDown: {
                code: "accSagittalFlat5v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v23SUp: {
                code: "accSagittalSharp5v23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v23SDown: {
                code: "accSagittalFlat5v23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp5v23SDown: {
                code: "accSagittalDoubleSharp5v23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat5v23SUp: {
                code: "accSagittalDoubleFlat5v23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp5v19CDown: {
                code: "accSagittalDoubleSharp5v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat5v19CUp: {
                code: "accSagittalDoubleFlat5v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp23CDown: {
                code: "accSagittalDoubleSharp23CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat23CUp: {
                code: "accSagittalDoubleFlat23CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal19SchismaUp: {
                code: "accSagittal19SchismaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal19SchismaDown: {
                code: "accSagittal19SchismaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal17KleismaUp: {
                code: "accSagittal17KleismaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal17KleismaDown: {
                code: "accSagittal17KleismaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal143CommaUp: {
                code: "accSagittal143CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal143CommaDown: {
                code: "accSagittal143CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v49CommaUp: {
                code: "accSagittal11v49CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v49CommaDown: {
                code: "accSagittal11v49CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal19CommaUp: {
                code: "accSagittal19CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal19CommaDown: {
                code: "accSagittal19CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v19CommaUp: {
                code: "accSagittal7v19CommaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7v19CommaDown: {
                code: "accSagittal7v19CommaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49SmallDiesisUp: {
                code: "accSagittal49SmallDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49SmallDiesisDown: {
                code: "accSagittal49SmallDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal23SmallDiesisUp: {
                code: "accSagittal23SmallDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal23SmallDiesisDown: {
                code: "accSagittal23SmallDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v13MediumDiesisUp: {
                code: "accSagittal5v13MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v13MediumDiesisDown: {
                code: "accSagittal5v13MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v19MediumDiesisUp: {
                code: "accSagittal11v19MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v19MediumDiesisDown: {
                code: "accSagittal11v19MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49MediumDiesisUp: {
                code: "accSagittal49MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49MediumDiesisDown: {
                code: "accSagittal49MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v49MediumDiesisUp: {
                code: "accSagittal5v49MediumDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v49MediumDiesisDown: {
                code: "accSagittal5v49MediumDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49LargeDiesisUp: {
                code: "accSagittal49LargeDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal49LargeDiesisDown: {
                code: "accSagittal49LargeDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v19LargeDiesisUp: {
                code: "accSagittal11v19LargeDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal11v19LargeDiesisDown: {
                code: "accSagittal11v19LargeDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v13LargeDiesisUp: {
                code: "accSagittal5v13LargeDiesisUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5v13LargeDiesisDown: {
                code: "accSagittal5v13LargeDiesisDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp23SDown: {
                code: "accSagittalSharp23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat23SUp: {
                code: "accSagittalFlat23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp49SDown: {
                code: "accSagittalSharp49SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat49SUp: {
                code: "accSagittalFlat49SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v19CDown: {
                code: "accSagittalSharp7v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v19CUp: {
                code: "accSagittalFlat7v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp19CDown: {
                code: "accSagittalSharp19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat19CUp: {
                code: "accSagittalFlat19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11v49CDown: {
                code: "accSagittalSharp11v49CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11v49CUp: {
                code: "accSagittalFlat11v49CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp143CDown: {
                code: "accSagittalSharp143CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat143CUp: {
                code: "accSagittalFlat143CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp17kDown: {
                code: "accSagittalSharp17kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat17kUp: {
                code: "accSagittalFlat17kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp19sDown: {
                code: "accSagittalSharp19sDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat19sUp: {
                code: "accSagittalFlat19sUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp19sUp: {
                code: "accSagittalSharp19sUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat19sDown: {
                code: "accSagittalFlat19sDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp17kUp: {
                code: "accSagittalSharp17kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat17kDown: {
                code: "accSagittalFlat17kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp143CUp: {
                code: "accSagittalSharp143CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat143CDown: {
                code: "accSagittalFlat143CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11v49CUp: {
                code: "accSagittalSharp11v49CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11v49CDown: {
                code: "accSagittalFlat11v49CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp19CUp: {
                code: "accSagittalSharp19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat19CDown: {
                code: "accSagittalFlat19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp7v19CUp: {
                code: "accSagittalSharp7v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat7v19CDown: {
                code: "accSagittalFlat7v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp49SUp: {
                code: "accSagittalSharp49SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat49SDown: {
                code: "accSagittalFlat49SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp23SUp: {
                code: "accSagittalSharp23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat23SDown: {
                code: "accSagittalFlat23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v13MUp: {
                code: "accSagittalSharp5v13MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v13MDown: {
                code: "accSagittalFlat5v13MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11v19MUp: {
                code: "accSagittalSharp11v19MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11v19MDown: {
                code: "accSagittalFlat11v19MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp49MUp: {
                code: "accSagittalSharp49MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat49MDown: {
                code: "accSagittalFlat49MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v49MUp: {
                code: "accSagittalSharp5v49MUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v49MDown: {
                code: "accSagittalFlat5v49MDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp49LUp: {
                code: "accSagittalSharp49LUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat49LDown: {
                code: "accSagittalFlat49LDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp11v19LUp: {
                code: "accSagittalSharp11v19LUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat11v19LDown: {
                code: "accSagittalFlat11v19LDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalSharp5v13LUp: {
                code: "accSagittalSharp5v13LUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFlat5v13LDown: {
                code: "accSagittalFlat5v13LDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp23SDown: {
                code: "accSagittalDoubleSharp23SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat23SUp: {
                code: "accSagittalDoubleFlat23SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp49SDown: {
                code: "accSagittalDoubleSharp49SDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat49SUp: {
                code: "accSagittalDoubleFlat49SUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp7v19CDown: {
                code: "accSagittalDoubleSharp7v19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat7v19CUp: {
                code: "accSagittalDoubleFlat7v19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp19CDown: {
                code: "accSagittalDoubleSharp19CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat19CUp: {
                code: "accSagittalDoubleFlat19CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp11v49CDown: {
                code: "accSagittalDoubleSharp11v49CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat11v49CUp: {
                code: "accSagittalDoubleFlat11v49CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp143CDown: {
                code: "accSagittalDoubleSharp143CDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat143CUp: {
                code: "accSagittalDoubleFlat143CUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp17kDown: {
                code: "accSagittalDoubleSharp17kDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat17kUp: {
                code: "accSagittalDoubleFlat17kUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleSharp19sDown: {
                code: "accSagittalDoubleSharp19sDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalDoubleFlat19sUp: {
                code: "accSagittalDoubleFlat19sUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalShaftUp: {
                code: "accSagittalShaftUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalShaftDown: {
                code: "accSagittalShaftDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalAcute: {
                code: "accSagittalAcute",
                parenRightPaddingAdjustment: -1
            },
            accSagittalGrave: {
                code: "accSagittalGrave",
                parenRightPaddingAdjustment: -1
            },
            accSagittal1MinaUp: {
                code: "accSagittal1MinaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal1MinaDown: {
                code: "accSagittal1MinaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal2MinasUp: {
                code: "accSagittal2MinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal2MinasDown: {
                code: "accSagittal2MinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal1TinaUp: {
                code: "accSagittal1TinaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal1TinaDown: {
                code: "accSagittal1TinaDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal2TinasUp: {
                code: "accSagittal2TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal2TinasDown: {
                code: "accSagittal2TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal3TinasUp: {
                code: "accSagittal3TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal3TinasDown: {
                code: "accSagittal3TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal4TinasUp: {
                code: "accSagittal4TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal4TinasDown: {
                code: "accSagittal4TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5TinasUp: {
                code: "accSagittal5TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal5TinasDown: {
                code: "accSagittal5TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal6TinasUp: {
                code: "accSagittal6TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal6TinasDown: {
                code: "accSagittal6TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7TinasUp: {
                code: "accSagittal7TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal7TinasDown: {
                code: "accSagittal7TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal8TinasUp: {
                code: "accSagittal8TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal8TinasDown: {
                code: "accSagittal8TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittal9TinasUp: {
                code: "accSagittal9TinasUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittal9TinasDown: {
                code: "accSagittal9TinasDown",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFractionalTinaUp: {
                code: "accSagittalFractionalTinaUp",
                parenRightPaddingAdjustment: -1
            },
            accSagittalFractionalTinaDown: {
                code: "accSagittalFractionalTinaDown",
                parenRightPaddingAdjustment: -1
            },
            accidentalNarrowReversedFlat: {
                code: "accidentalNarrowReversedFlat",
                parenRightPaddingAdjustment: -1
            },
            accidentalNarrowReversedFlatAndFlat: {
                code: "accidentalNarrowReversedFlatAndFlat",
                parenRightPaddingAdjustment: -1
            },
            accidentalWilsonPlus: {
                code: "accidentalWilsonPlus",
                parenRightPaddingAdjustment: -1
            },
            accidentalWilsonMinus: {
                code: "accidentalWilsonMinus",
                parenRightPaddingAdjustment: -1
            }
        }, X = {
            "a.": {
                code: "augmentationDot",
                between_lines: !0
            },
            av: {
                aboveCode: "articStaccatissimoAbove",
                belowCode: "articStaccatissimoBelow",
                between_lines: !0
            },
            "a>": {
                aboveCode: "articAccentAbove",
                belowCode: "articAccentBelow",
                between_lines: !0
            },
            "a-": {
                aboveCode: "articTenutoAbove",
                belowCode: "articTenutoBelow",
                between_lines: !0
            },
            "a^": {
                aboveCode: "articMarcatoAbove",
                belowCode: "articMarcatoBelow",
                between_lines: !1
            },
            "a+": {
                code: "pluckedLeftHandPizzicato",
                between_lines: !1
            },
            ao: {
                aboveCode: "pluckedSnapPizzicatoAbove",
                belowCode: "pluckedSnapPizzicatoBelow",
                between_lines: !1
            },
            ah: {
                code: "stringsHarmonic",
                between_lines: !1
            },
            "a@": {
                aboveCode: "fermataAbove",
                belowCode: "fermataBelow",
                between_lines: !1
            },
            "a@a": {
                code: "fermataAbove",
                between_lines: !1
            },
            "a@u": {
                code: "fermataBelow",
                between_lines: !1
            },
            "a@s": {
                aboveCode: "fermataShortAbove",
                belowCode: "fermataShortBelow",
                between_lines: !1
            },
            "a@as": {
                code: "fermataShortAbove",
                between_lines: !1
            },
            "a@us": {
                code: "fermataShortBelow",
                between_lines: !1
            },
            "a@l": {
                aboveCode: "fermataLongAbove",
                belowCode: "fermataLongBelow",
                between_lines: !1
            },
            "a@al": {
                code: "fermataLongAbove",
                between_lines: !1
            },
            "a@ul": {
                code: "fermataLongBelow",
                between_lines: !1
            },
            "a@vl": {
                aboveCode: "fermataVeryLongAbove",
                belowCode: "fermataVeryLongBelow",
                between_lines: !1
            },
            "a@avl": {
                code: "fermataVeryLongAbove",
                between_lines: !1
            },
            "a@uvl": {
                code: "fermataVeryLongBelow",
                between_lines: !1
            },
            "a|": {
                code: "stringsUpBow",
                between_lines: !1
            },
            am: {
                code: "stringsDownBow",
                between_lines: !1
            },
            "a,": {
                code: "pictChokeCymbal",
                between_lines: !1
            }
        }, j = {
            mordent: {
                code: "ornamentShortTrill"
            },
            mordent_inverted: {
                code: "ornamentMordent"
            },
            turn: {
                code: "ornamentTurn"
            },
            turn_inverted: {
                code: "ornamentTurnSlash"
            },
            tr: {
                code: "ornamentTrill"
            },
            upprall: {
                code: "ornamentPrecompSlideTrillDAnglebert"
            },
            downprall: {
                code: "ornamentPrecompDoubleCadenceUpperPrefix"
            },
            prallup: {
                code: "ornamentPrecompTrillSuffixDandrieu"
            },
            pralldown: {
                code: "ornamentPrecompTrillLowerSuffix"
            },
            upmordent: {
                code: "ornamentPrecompSlideTrillBach"
            },
            downmordent: {
                code: "ornamentPrecompDoubleCadenceUpperPrefixTurn"
            },
            lineprall: {
                code: "ornamentPrecompAppoggTrill"
            },
            prallprall: {
                code: "ornamentTremblement"
            },
            scoop: {
                code: "brassScoop"
            },
            doit: {
                code: "brassDoitMedium"
            },
            fall: {
                code: "brassFallLipShort"
            },
            doitLong: {
                code: "brassLiftMedium"
            },
            fallLong: {
                code: "brassFallRoughMedium"
            },
            bend: {
                code: "brassBend"
            },
            plungerClosed: {
                code: "brassMuteClosed"
            },
            plungerOpen: {
                code: "brassMuteOpen"
            },
            flip: {
                code: "brassFlip"
            },
            jazzTurn: {
                code: "brassJazzTurn"
            },
            smear: {
                code: "brassSmear"
            }
        };
        class V {
            static currentMusicFont() {
                if (0 === V.MUSIC_FONT_STACK.length) throw new g("NoFonts", "The font stack is empty. See: await Flow.fetchMusicFont(...); Flow.setMusicFont(...).");
                return V.MUSIC_FONT_STACK[0];
            }
            static clefProperties(t) {
                if (!t || !(t in G)) throw new g("BadArgument", "Invalid clef: " + t);
                return G[t];
            }
            static keyProperties(t, e = "treble", i) {
                let b = {
                    octave_shift: 0,
                    duration: "4"
                };
                "object" == typeof i && (b = Object.assign(Object.assign({}, b), i));
                const a = V.sanitizeDuration(b.duration), n = t.split("/");
                if (n.length < 2) throw new g("BadArguments", `First argument must be note/octave or note/octave/glyph-code: ${t}`);
                const s = n[0].toUpperCase(), l = H[s];
                if (!l) throw new g("BadArguments", "Invalid key name: " + s);
                l.octave && (n[1] = l.octave.toString());
                let o = parseInt(n[1], 10);
                o -= b.octave_shift;
                let r = (7 * o - 28 + l.index) / 2;
                r += V.clefProperties(e).line_shift;
                let h = 0;
                r <= 0 && 2 * r % 2 == 0 && (h = 1), r >= 6 && 2 * r % 2 == 0 && (h = -1);
                const m = void 0 !== l.int_val ? 12 * o + l.int_val : void 0, c = l.code, d = l.shift_right;
                let _ = {};
                if (n.length > 2 && n[2]) {
                    const t = n[2].toUpperCase();
                    _ = {
                        code: this.codeNoteHead(t, a)
                    };
                }
                return Object.assign({
                    key: s,
                    octave: o,
                    line: r,
                    int_value: m,
                    accidental: l.accidental,
                    code: c,
                    stroke: h,
                    shift_right: d,
                    displaced: !1
                }, _);
            }
            static integerToNote(t) {
                if (void 0 === t || t < 0 || t > 11) throw new g("BadArguments", `integerToNote() requires an integer in the range [0, 11]: ${t}`);
                const e = {
                    0: "C",
                    1: "C#",
                    2: "D",
                    3: "D#",
                    4: "E",
                    5: "F",
                    6: "F#",
                    7: "G",
                    8: "G#",
                    9: "A",
                    10: "A#",
                    11: "B"
                }[t];
                if (!e) throw new g("BadArguments", `Unknown note value for integer: ${t}`);
                return e;
            }
            static tabToGlyphProps(t, e = 1) {
                let i, b = 0, a = 0;
                if ("X" === t.toUpperCase()) {
                    const t = new Z("accidentalDoubleSharp", V.TABLATURE_FONT_SCALE).getMetrics();
                    if (i = "accidentalDoubleSharp", null == t.width || null == t.height) throw new g("InvalidMetrics", "Width and height required");
                    b = t.width, a = -t.height / 2;
                } else b = V.textWidth(t);
                return {
                    text: t,
                    code: i,
                    getWidth: ()=>b * e,
                    shift_y: a
                };
            }
            static textWidth(t) {
                return 7 * t.toString().length;
            }
            static articulationCodes(t) {
                return X[t];
            }
            static accidentalCodes(t) {
                return Y[t];
            }
            static ornamentCodes(t) {
                return j[t];
            }
            static keySignature(t) {
                const e = I[t];
                if (!e) throw new g("BadKeySignature", `Bad key signature spec: '${t}'`);
                if (!e.acc) return [];
                const i = {
                    b: [
                        2,
                        .5,
                        2.5,
                        1,
                        3,
                        1.5,
                        3.5
                    ],
                    "#": [
                        0,
                        1.5,
                        -0.5,
                        1,
                        2.5,
                        .5,
                        2
                    ]
                }[e.acc], b = [];
                for(let t = 0; t < e.num; ++t){
                    const a = i[t];
                    b.push({
                        type: e.acc,
                        line: a
                    });
                }
                return b;
            }
            static getKeySignatures() {
                return I;
            }
            static hasKeySignature(t) {
                return t in I;
            }
            static sanitizeDuration(t) {
                const e = U[t];
                if (void 0 !== e && (t = e), void 0 === W[t]) throw new g("BadArguments", `The provided duration is not valid: ${t}`);
                return t;
            }
            static durationToFraction(t) {
                return (new z).parse(V.sanitizeDuration(t));
            }
            static durationToNumber(t) {
                return V.durationToFraction(t).value();
            }
            static durationToTicks(t) {
                t = V.sanitizeDuration(t);
                const e = W[t];
                if (void 0 === e) throw new g("InvalidDuration");
                return e;
            }
            static codeNoteHead(t, e) {
                let i = "";
                switch(t){
                    case "D0":
                        i = "noteheadDiamondWhole";
                        break;
                    case "D1":
                        i = "noteheadDiamondHalf";
                        break;
                    case "D2":
                    case "D3":
                    case "MI":
                        i = "noteheadDiamondBlack";
                        break;
                    case "T0":
                        i = "noteheadTriangleUpWhole";
                        break;
                    case "T1":
                        i = "noteheadTriangleUpHalf";
                        break;
                    case "T2":
                    case "T3":
                    case "DO":
                        i = "noteheadTriangleUpBlack";
                        break;
                    case "X0":
                        i = "noteheadXWhole";
                        break;
                    case "X1":
                        i = "noteheadXHalf";
                        break;
                    case "X2":
                        i = "noteheadXBlack";
                        break;
                    case "X3":
                        i = "noteheadCircleX";
                        break;
                    case "S1":
                        i = "noteheadSquareWhite";
                        break;
                    case "S2":
                    case "LA":
                        i = "noteheadSquareBlack";
                        break;
                    case "R1":
                        i = "vexNoteHeadRectWhite";
                        break;
                    case "R2":
                        i = "vexNoteHeadRectBlack";
                        break;
                    case "RE":
                        i = "noteheadMoonBlack";
                        break;
                    case "FA":
                        i = "noteheadTriangleLeftBlack";
                        break;
                    case "FAUP":
                        i = "noteheadTriangleRightBlack";
                        break;
                    case "SO":
                        i = "noteheadBlack";
                        break;
                    case "TI":
                        i = "noteheadTriangleRoundDownBlack";
                        break;
                    case "D":
                    case "H":
                        switch(e){
                            case "1/2":
                                i = "noteheadDiamondDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadDiamondWhole";
                                break;
                            case "2":
                                i = "noteheadDiamondHalf";
                                break;
                            default:
                                i = "noteheadDiamondBlack";
                        }
                        break;
                    case "N":
                    case "G":
                        switch(e){
                            case "1/2":
                                i = "noteheadDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadWhole";
                                break;
                            case "2":
                                i = "noteheadHalf";
                                break;
                            default:
                                i = "noteheadBlack";
                        }
                        break;
                    case "M":
                    case "X":
                        switch(e){
                            case "1/2":
                                i = "noteheadXDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadXWhole";
                                break;
                            case "2":
                                i = "noteheadXHalf";
                                break;
                            default:
                                i = "noteheadXBlack";
                        }
                        break;
                    case "CX":
                        switch(e){
                            case "1/2":
                                i = "noteheadCircleXDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadCircleXWhole";
                                break;
                            case "2":
                                i = "noteheadCircleXHalf";
                                break;
                            default:
                                i = "noteheadCircleX";
                        }
                        break;
                    case "CI":
                        switch(e){
                            case "1/2":
                                i = "noteheadCircledDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadCircledWhole";
                                break;
                            case "2":
                                i = "noteheadCircledHalf";
                                break;
                            default:
                                i = "noteheadCircledBlack";
                        }
                        break;
                    case "SQ":
                        switch(e){
                            case "1/2":
                                i = "noteheadDoubleWholeSquare";
                                break;
                            case "1":
                            case "2":
                                i = "noteheadSquareWhite";
                                break;
                            default:
                                i = "noteheadSquareBlack";
                        }
                        break;
                    case "TU":
                        switch(e){
                            case "1/2":
                                i = "noteheadTriangleUpDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadTriangleUpWhole";
                                break;
                            case "2":
                                i = "noteheadTriangleUpHalf";
                                break;
                            default:
                                i = "noteheadTriangleUpBlack";
                        }
                        break;
                    case "TD":
                        switch(e){
                            case "1/2":
                                i = "noteheadTriangleDownDoubleWhole";
                                break;
                            case "1":
                                i = "noteheadTriangleDownWhole";
                                break;
                            case "2":
                                i = "noteheadTriangleDownHalf";
                                break;
                            default:
                                i = "noteheadTriangleDownBlack";
                        }
                        break;
                    case "SF":
                        switch(e){
                            case "1/2":
                                i = "noteheadSlashedDoubleWhole1";
                                break;
                            case "1":
                                i = "noteheadSlashedWhole1";
                                break;
                            case "2":
                                i = "noteheadSlashedHalf1";
                                break;
                            default:
                                i = "noteheadSlashedBlack1";
                        }
                        break;
                    case "SB":
                        switch(e){
                            case "1/2":
                                i = "noteheadSlashedDoubleWhole2";
                                break;
                            case "1":
                                i = "noteheadSlashedWhole2";
                                break;
                            case "2":
                                i = "noteheadSlashedHalf2";
                                break;
                            default:
                                i = "noteheadSlashedBlack2";
                        }
                }
                return i;
            }
            static getGlyphProps(t, e = "n") {
                t = V.sanitizeDuration(t);
                let i = K[t];
                void 0 === i && (i = K[4]);
                let b = i[e];
                const a = V.codeNoteHead(e.toUpperCase(), t);
                "" != a && (b = Object.assign(Object.assign({}, b), {
                    code_head: a,
                    code: a
                }));
                const n = b.code_head;
                return Object.assign(Object.assign(Object.assign({}, i.common), {
                    getWidth: (t = V.NOTATION_FONT_SCALE)=>Z.getWidth(n, t)
                }), b);
            }
        }
        V.UNISON = !0, V.SOFTMAX_FACTOR = 10, V.STEM_WIDTH = 1.5, V.STEM_HEIGHT = 35, V.STAVE_LINE_THICKNESS = 1, V.RENDER_PRECISION_PLACES = 3, V.RESOLUTION = L, V.MUSIC_FONT_STACK = [], V.NOTATION_FONT_SCALE = 39, V.TABLATURE_FONT_SCALE = 39, V.SLASH_NOTEHEAD_WIDTH = 15, V.STAVE_LINE_DISTANCE = 10, V.TEXT_HEIGHT_OFFSET_HACK = 1, V.accidentalMap = Y, V.accidentalColumnsTable = {
            1: {
                a: [
                    1
                ],
                b: [
                    1
                ]
            },
            2: {
                a: [
                    1,
                    2
                ]
            },
            3: {
                a: [
                    1,
                    3,
                    2
                ],
                b: [
                    1,
                    2,
                    1
                ],
                second_on_bottom: [
                    1,
                    2,
                    3
                ]
            },
            4: {
                a: [
                    1,
                    3,
                    4,
                    2
                ],
                b: [
                    1,
                    2,
                    3,
                    1
                ],
                spaced_out_tetrachord: [
                    1,
                    2,
                    1,
                    2
                ]
            },
            5: {
                a: [
                    1,
                    3,
                    5,
                    4,
                    2
                ],
                b: [
                    1,
                    2,
                    4,
                    3,
                    1
                ],
                spaced_out_pentachord: [
                    1,
                    2,
                    3,
                    2,
                    1
                ],
                very_spaced_out_pentachord: [
                    1,
                    2,
                    1,
                    2,
                    1
                ]
            },
            6: {
                a: [
                    1,
                    3,
                    5,
                    6,
                    4,
                    2
                ],
                b: [
                    1,
                    2,
                    4,
                    5,
                    3,
                    1
                ],
                spaced_out_hexachord: [
                    1,
                    3,
                    2,
                    1,
                    3,
                    2
                ],
                very_spaced_out_hexachord: [
                    1,
                    2,
                    1,
                    2,
                    1,
                    2
                ]
            }
        }, V.unicode = {
            sharp: String.fromCharCode(9839),
            flat: String.fromCharCode(9837),
            natural: String.fromCharCode(9838),
            triangle: String.fromCharCode(9651),
            "o-with-slash": String.fromCharCode(248),
            degrees: String.fromCharCode(176),
            circle: String.fromCharCode(9675)
        }, V.validTypes = {
            n: {
                name: "note"
            },
            r: {
                name: "rest"
            },
            h: {
                name: "harmonic"
            },
            m: {
                name: "muted"
            },
            s: {
                name: "slash"
            },
            g: {
                name: "ghost"
            },
            d: {
                name: "diamond"
            },
            x: {
                name: "x"
            },
            ci: {
                name: "circled"
            },
            cx: {
                name: "circle x"
            },
            sf: {
                name: "slashed"
            },
            sb: {
                name: "slashed backward"
            },
            sq: {
                name: "square"
            },
            tu: {
                name: "triangle up"
            },
            td: {
                name: "triangle down"
            }
        }, V.TIME4_4 = {
            num_beats: 4,
            beat_value: 4,
            resolution: L
        };
        const K = {
            "1/2": {
                common: {
                    code_head: "",
                    stem: !1,
                    flag: !1,
                    stem_up_extension: -V.STEM_HEIGHT,
                    stem_down_extension: -V.STEM_HEIGHT,
                    tabnote_stem_up_extension: -V.STEM_HEIGHT,
                    tabnote_stem_down_extension: -V.STEM_HEIGHT,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "restDoubleWhole",
                    rest: !0,
                    position: "B/5",
                    dot_shiftY: .5
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            1: {
                common: {
                    code_head: "",
                    stem: !1,
                    flag: !1,
                    stem_up_extension: -V.STEM_HEIGHT,
                    stem_down_extension: -V.STEM_HEIGHT,
                    tabnote_stem_up_extension: -V.STEM_HEIGHT,
                    tabnote_stem_down_extension: -V.STEM_HEIGHT,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "restWhole",
                    ledger_code_head: "restWholeLegerLine",
                    rest: !0,
                    position: "D/5",
                    dot_shiftY: .5
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            2: {
                common: {
                    code_head: "",
                    stem: !0,
                    flag: !1,
                    stem_up_extension: 0,
                    stem_down_extension: 0,
                    tabnote_stem_up_extension: 0,
                    tabnote_stem_down_extension: 0,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "restHalf",
                    ledger_code_head: "restHalfLegerLine",
                    stem: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -0.5
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            4: {
                common: {
                    code_head: "",
                    stem: !0,
                    flag: !1,
                    stem_up_extension: 0,
                    stem_down_extension: 0,
                    tabnote_stem_up_extension: 0,
                    tabnote_stem_down_extension: 0,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "restQuarter",
                    stem: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -0.5,
                    line_above: 1.5,
                    line_below: 1.5
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            8: {
                common: {
                    code_head: "",
                    stem: !0,
                    flag: !0,
                    beam_count: 1,
                    stem_beam_extension: 0,
                    code_flag_upstem: "flag8thUp",
                    code_flag_downstem: "flag8thDown",
                    stem_up_extension: 0,
                    stem_down_extension: 0,
                    tabnote_stem_up_extension: 0,
                    tabnote_stem_down_extension: 0,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "rest8th",
                    stem: !1,
                    flag: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -0.5,
                    line_above: 1,
                    line_below: 1
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            16: {
                common: {
                    code_head: "",
                    beam_count: 2,
                    stem_beam_extension: 0,
                    stem: !0,
                    flag: !0,
                    code_flag_upstem: "flag16thUp",
                    code_flag_downstem: "flag16thDown",
                    stem_up_extension: 0,
                    stem_down_extension: 0,
                    tabnote_stem_up_extension: 0,
                    tabnote_stem_down_extension: 0,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "rest16th",
                    stem: !1,
                    flag: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -0.5,
                    line_above: 1,
                    line_below: 2
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            32: {
                common: {
                    code_head: "",
                    beam_count: 3,
                    stem_beam_extension: 7.5,
                    stem: !0,
                    flag: !0,
                    code_flag_upstem: "flag32ndUp",
                    code_flag_downstem: "flag32ndDown",
                    stem_up_extension: 9,
                    stem_down_extension: 9,
                    tabnote_stem_up_extension: 9,
                    tabnote_stem_down_extension: 9,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "rest32nd",
                    stem: !1,
                    flag: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -1.5,
                    line_above: 2,
                    line_below: 2
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            64: {
                common: {
                    code_head: "",
                    beam_count: 4,
                    stem_beam_extension: 15,
                    stem: !0,
                    flag: !0,
                    code_flag_upstem: "flag64thUp",
                    code_flag_downstem: "flag64thDown",
                    stem_up_extension: 13,
                    stem_down_extension: 13,
                    tabnote_stem_up_extension: 13,
                    tabnote_stem_down_extension: 13,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "rest64th",
                    stem: !1,
                    flag: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -1.5,
                    line_above: 2,
                    line_below: 3
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            },
            128: {
                common: {
                    code_head: "",
                    beam_count: 5,
                    stem_beam_extension: 22.5,
                    stem: !0,
                    flag: !0,
                    code_flag_upstem: "flag128thUp",
                    code_flag_downstem: "flag128thDown",
                    stem_up_extension: 22,
                    stem_down_extension: 22,
                    tabnote_stem_up_extension: 22,
                    tabnote_stem_down_extension: 22,
                    dot_shiftY: 0,
                    line_above: 0,
                    line_below: 0
                },
                r: {
                    code_head: "rest128th",
                    stem: !1,
                    flag: !1,
                    rest: !0,
                    position: "B/4",
                    dot_shiftY: -2.5,
                    line_above: 3,
                    line_below: 3
                },
                s: {
                    getWidth: ()=>V.SLASH_NOTEHEAD_WIDTH,
                    position: "B/4"
                }
            }
        };
        var $, J;
        !function(t) {
            t[t.MOVE = 0] = "MOVE", t[t.LINE = 1] = "LINE", t[t.QUADRATIC = 2] = "QUADRATIC", t[t.BEZIER = 3] = "BEZIER";
        }($ || ($ = {}));
        class q {
            constructor(t, e, i){
                this.point = -1, this.metrics = Z.loadMetrics(t, e, i), this.bbox = Z.getOutlineBoundingBox(this.metrics.outline, this.metrics.scale, this.metrics.x_shift, this.metrics.y_shift), i && (this.point = Z.lookupFontMetric(this.metrics.font, i, e, "point", -1));
            }
        }
        class Q {
            constructor(t, e, i, b){
                this.outline = t, this.originX = e, this.originY = i, this.scale = b, this.i = 0, this.precision = 1, this.precision = Math.pow(10, V.RENDER_PRECISION_PLACES);
            }
            done() {
                return this.i >= this.outline.length;
            }
            next() {
                return Math.round(this.outline[this.i++] * this.precision / this.precision);
            }
            nextX() {
                return Math.round((this.originX + this.outline[this.i++] * this.scale) * this.precision) / this.precision;
            }
            nextY() {
                return Math.round((this.originY - this.outline[this.i++] * this.scale) * this.precision) / this.precision;
            }
            static parse(t) {
                const e = [], i = t.split(" ");
                let b = 0;
                for(; b < i.length;)switch(i[b++]){
                    case "m":
                        e.push($.MOVE, parseInt(i[b++]), parseInt(i[b++]));
                        break;
                    case "l":
                        e.push($.LINE, parseInt(i[b++]), parseInt(i[b++]));
                        break;
                    case "q":
                        e.push($.QUADRATIC, parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]));
                        break;
                    case "b":
                        e.push($.BEZIER, parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]), parseInt(i[b++]));
                }
                return e;
            }
        }
        class Z extends R {
            static get CATEGORY() {
                return x.Glyph;
            }
            static lookupFontMetric(t, e, i, b, a) {
                let n = t.lookupMetric(`glyphs.${e}.${i}.${b}`, void 0);
                return void 0 === n && (n = t.lookupMetric(`glyphs.${e}.${b}`, a)), n;
            }
            static lookupGlyph(t, e) {
                let i, b;
                p(t, "BadFontStack", "Font stack is misconfigured");
                for(let a = 0; a < t.length; a++)if (b = t[a], i = b.getGlyphs()[e], i) return {
                    glyph: i,
                    font: b
                };
                throw new g("BadGlyph", `Glyph ${e} does not exist in font.`);
            }
            static loadMetrics(t, e, i) {
                const { glyph: b, font: a } = Z.lookupGlyph(t, e);
                if (!b.o) throw new g("BadGlyph", `Glyph ${e} has no outline defined.`);
                let n = 0, s = 0, l = 1;
                i && a && (n = Z.lookupFontMetric(a, i, e, "shiftX", 0), s = Z.lookupFontMetric(a, i, e, "shiftY", 0), l = Z.lookupFontMetric(a, i, e, "scale", 1));
                const o = b.x_min, r = b.x_max, h = b.ha;
                return b.cached_outline || (b.cached_outline = Q.parse(b.o)), {
                    x_min: o,
                    x_max: r,
                    x_shift: n,
                    y_shift: s,
                    scale: l,
                    ha: h,
                    outline: b.cached_outline,
                    font: a,
                    width: r - o,
                    height: h
                };
            }
            static renderGlyph(t, e, i, b, a, n) {
                var s;
                const l = Z.cache.lookup(a, null == n ? void 0 : n.category), o = l.metrics;
                -1 != l.point && (b = l.point);
                const r = null !== (s = null == n ? void 0 : n.scale) && void 0 !== s ? s : 1, h = 72 * b / (100 * o.font.getResolution()) * o.scale * r;
                return Z.renderOutline(t, o.outline, h, e + o.x_shift * r, i + o.y_shift * r), o;
            }
            static renderOutline(t, e, i, b, a) {
                const n = new Q(e, b, a, i);
                let s, l;
                for(t.beginPath(); !n.done();)switch(n.next()){
                    case $.MOVE:
                        t.moveTo(n.nextX(), n.nextY());
                        break;
                    case $.LINE:
                        t.lineTo(n.nextX(), n.nextY());
                        break;
                    case $.QUADRATIC:
                        s = n.nextX(), l = n.nextY(), t.quadraticCurveTo(n.nextX(), n.nextY(), s, l);
                        break;
                    case $.BEZIER:
                        s = n.nextX(), l = n.nextY(), t.bezierCurveTo(n.nextX(), n.nextY(), n.nextX(), n.nextY(), s, l);
                }
                t.fill();
            }
            static getOutlineBoundingBox(t, e, i, b) {
                const a = new Q(t, i, b, e), n = new C;
                let s, l, o = i, r = b;
                for(; !a.done();)switch(a.next()){
                    case $.MOVE:
                        o = a.nextX(), r = a.nextY();
                        break;
                    case $.LINE:
                        n.addPoint(o, r), o = a.nextX(), r = a.nextY(), n.addPoint(o, r);
                        break;
                    case $.QUADRATIC:
                        s = a.nextX(), l = a.nextY(), n.addQuadraticCurve(o, r, a.nextX(), a.nextY(), s, l), o = s, r = l;
                        break;
                    case $.BEZIER:
                        s = a.nextX(), l = a.nextY(), n.addBezierCurve(o, r, a.nextX(), a.nextY(), a.nextX(), a.nextY(), s, l), o = s, r = l;
                }
                return new D(n.getX1(), n.getY1(), n.width(), n.height());
            }
            static getWidth(t, e, i) {
                const b = Z.cache.lookup(t, i);
                -1 != b.point && (e = b.point);
                const a = 72 * e / (100 * b.metrics.font.getResolution());
                return b.bbox.getW() * a;
            }
            constructor(t, e, i){
                super(), this.bbox = new D(0, 0, 0, 0), this.topGlyphs = [], this.botGlyphs = [], this.options = {}, this.scale = 1, this.code = t, this.point = e, this.originShift = {
                    x: 0,
                    y: 0
                }, this.x_shift = 0, this.y_shift = 0, i ? this.setOptions(i) : this.reset();
            }
            draw(...t) {}
            getCode() {
                return this.code;
            }
            setOptions(t) {
                this.options = Object.assign(Object.assign({}, this.options), t), this.reset();
            }
            setPoint(t) {
                return this.point = t, this;
            }
            setStave(t) {
                return this.stave = t, this;
            }
            getXShift() {
                return this.x_shift;
            }
            setXShift(t) {
                return this.x_shift = t, this;
            }
            getYshift() {
                return this.y_shift;
            }
            setYShift(t) {
                return this.y_shift = t, this;
            }
            reset() {
                const t = Z.cache.lookup(this.code, this.options.category);
                this.metrics = t.metrics, -1 != t.point && (this.point = t.point), this.scale = 72 * this.point / (100 * this.metrics.font.getResolution()), this.bbox = new D(t.bbox.getX() * this.scale, t.bbox.getY() * this.scale, t.bbox.getW() * this.scale, t.bbox.getH() * this.scale);
            }
            checkMetrics() {
                return p(this.metrics, "BadGlyph", `Glyph ${this.code} is not initialized.`);
            }
            getMetrics() {
                const t = this.checkMetrics(), e = t.scale;
                return {
                    x_min: t.x_min * this.scale * e,
                    x_max: t.x_max * this.scale * e,
                    width: this.bbox.getW(),
                    height: this.bbox.getH(),
                    scale: this.scale * e,
                    x_shift: t.x_shift,
                    y_shift: t.y_shift,
                    outline: t.outline,
                    font: t.font,
                    ha: t.ha
                };
            }
            setOriginX(t) {
                const { bbox: e } = this, i = (t - Math.abs(e.getX() / e.getW())) * e.getW();
                this.originShift.x = -i;
            }
            setOriginY(t) {
                const { bbox: e } = this, i = (t - Math.abs(e.getY() / e.getH())) * e.getH();
                this.originShift.y = -i;
            }
            setOrigin(t, e) {
                this.setOriginX(t), this.setOriginY(e);
            }
            render(t, e, i) {
                const b = this.checkMetrics(), a = b.outline, n = this.scale * b.scale;
                this.setRendered(), this.applyStyle(t);
                const s = e + this.originShift.x + b.x_shift, l = i + this.originShift.y + b.y_shift;
                Z.renderOutline(t, a, n, s, l), this.restoreStyle(t);
            }
            checkStave() {
                return p(this.stave, "NoStave", "No stave attached to instance.");
            }
            renderToStave(t) {
                const e = this.checkContext(), i = this.checkMetrics(), b = this.checkStave(), a = i.outline, n = this.scale * i.scale;
                this.setRendered(), this.applyStyle();
                const s = t + this.x_shift + i.x_shift, l = b.getYForGlyphs() + this.y_shift + i.y_shift;
                Z.renderOutline(e, a, n, s, l), this.restoreStyle();
            }
        }
        Z.cache = new class {
            constructor(){
                this.cache = new Map;
            }
            lookup(t, e) {
                let i = this.cache.get(Z.CURRENT_CACHE_KEY);
                void 0 === i && (i = {}, this.cache.set(Z.CURRENT_CACHE_KEY, i));
                const b = e ? `${t}%${e}` : t;
                let a = i[b];
                return void 0 === a && (a = new q(Z.MUSIC_FONT_STACK, t, e), i[b] = a), a;
            }
        }, Z.CURRENT_CACHE_KEY = "", Z.MUSIC_FONT_STACK = [], function(t) {
            t[t.CENTER = 0] = "CENTER", t[t.LEFT = 1] = "LEFT", t[t.RIGHT = 2] = "RIGHT", t[t.ABOVE = 3] = "ABOVE", t[t.BELOW = 4] = "BELOW";
        }(J || (J = {}));
        class tt extends R {
            static get CATEGORY() {
                return x.Modifier;
            }
            static get Position() {
                return J;
            }
            static get PositionString() {
                return {
                    center: J.CENTER,
                    above: J.ABOVE,
                    below: J.BELOW,
                    left: J.LEFT,
                    right: J.RIGHT
                };
            }
            constructor(){
                super(), this.width = 0, this.text_line = 0, this.position = tt.Position.LEFT, this.x_shift = 0, this.y_shift = 0, this.spacingFromNextModifier = 0;
            }
            reset() {}
            getWidth() {
                return this.width;
            }
            setWidth(t) {
                return this.width = t, this;
            }
            getNote() {
                return p(this.note, "NoNote", "Modifier has no note.");
            }
            checkAttachedNote() {
                const t = this.getCategory();
                return p(this.index, "NoIndex", `Can't draw ${t} without an index.`), p(this.note, "NoNote", `Can't draw ${t} without a note.`);
            }
            setNote(t) {
                return this.note = t, this;
            }
            getIndex() {
                return this.index;
            }
            checkIndex() {
                return p(this.index, "NoIndex", "Modifier has an invalid index.");
            }
            setIndex(t) {
                return this.index = t, this;
            }
            getModifierContext() {
                return this.modifierContext;
            }
            checkModifierContext() {
                return p(this.modifierContext, "NoModifierContext", "Modifier Context Required");
            }
            setModifierContext(t) {
                return this.modifierContext = t, this;
            }
            getPosition() {
                return this.position;
            }
            setPosition(t) {
                return this.position = "string" == typeof t ? tt.PositionString[t] : t, this.reset(), this;
            }
            setTextLine(t) {
                return this.text_line = t, this;
            }
            setYShift(t) {
                return this.y_shift = t, this;
            }
            setSpacingFromNextModifier(t) {
                this.spacingFromNextModifier = t;
            }
            getSpacingFromNextModifier() {
                return this.spacingFromNextModifier;
            }
            setXShift(t) {
                return this.x_shift = 0, this.position === tt.Position.LEFT ? this.x_shift -= t : this.x_shift += t, this;
            }
            getXShift() {
                return this.x_shift;
            }
            draw() {
                throw this.checkContext(), new g("NotImplemented", "draw() not implemented for this modifier.");
            }
            alignSubNotesWithNote(t, e) {
                const i = e.getTickContext(), b = i.getMetrics(), a = e.getStave(), n = i.getX() - b.modLeftPx - b.modRightPx + this.getSpacingFromNextModifier();
                t.forEach((t)=>{
                    const e = t.getTickContext();
                    a && t.setStave(a), e.setXOffset(n);
                });
            }
        }
        class et {
            static get NUM_TONES() {
                return this.canonical_notes.length;
            }
            static get roots() {
                return [
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "a",
                    "b"
                ];
            }
            static get root_values() {
                return [
                    0,
                    2,
                    4,
                    5,
                    7,
                    9,
                    11
                ];
            }
            static get root_indices() {
                return {
                    c: 0,
                    d: 1,
                    e: 2,
                    f: 3,
                    g: 4,
                    a: 5,
                    b: 6
                };
            }
            static get canonical_notes() {
                return [
                    "c",
                    "c#",
                    "d",
                    "d#",
                    "e",
                    "f",
                    "f#",
                    "g",
                    "g#",
                    "a",
                    "a#",
                    "b"
                ];
            }
            static get diatonic_intervals() {
                return [
                    "unison",
                    "m2",
                    "M2",
                    "m3",
                    "M3",
                    "p4",
                    "dim5",
                    "p5",
                    "m6",
                    "M6",
                    "b7",
                    "M7",
                    "octave"
                ];
            }
            static get diatonic_accidentals() {
                return {
                    unison: {
                        note: 0,
                        accidental: 0
                    },
                    m2: {
                        note: 1,
                        accidental: -1
                    },
                    M2: {
                        note: 1,
                        accidental: 0
                    },
                    m3: {
                        note: 2,
                        accidental: -1
                    },
                    M3: {
                        note: 2,
                        accidental: 0
                    },
                    p4: {
                        note: 3,
                        accidental: 0
                    },
                    dim5: {
                        note: 4,
                        accidental: -1
                    },
                    p5: {
                        note: 4,
                        accidental: 0
                    },
                    m6: {
                        note: 5,
                        accidental: -1
                    },
                    M6: {
                        note: 5,
                        accidental: 0
                    },
                    b7: {
                        note: 6,
                        accidental: -1
                    },
                    M7: {
                        note: 6,
                        accidental: 0
                    },
                    octave: {
                        note: 7,
                        accidental: 0
                    }
                };
            }
            static get intervals() {
                return {
                    u: 0,
                    unison: 0,
                    m2: 1,
                    b2: 1,
                    min2: 1,
                    S: 1,
                    H: 1,
                    2: 2,
                    M2: 2,
                    maj2: 2,
                    T: 2,
                    W: 2,
                    m3: 3,
                    b3: 3,
                    min3: 3,
                    M3: 4,
                    3: 4,
                    maj3: 4,
                    4: 5,
                    p4: 5,
                    "#4": 6,
                    b5: 6,
                    aug4: 6,
                    dim5: 6,
                    5: 7,
                    p5: 7,
                    "#5": 8,
                    b6: 8,
                    aug5: 8,
                    6: 9,
                    M6: 9,
                    maj6: 9,
                    b7: 10,
                    m7: 10,
                    min7: 10,
                    dom7: 10,
                    M7: 11,
                    maj7: 11,
                    8: 12,
                    octave: 12
                };
            }
            static get scales() {
                return {
                    major: [
                        2,
                        2,
                        1,
                        2,
                        2,
                        2,
                        1
                    ],
                    minor: [
                        2,
                        1,
                        2,
                        2,
                        1,
                        2,
                        2
                    ],
                    ionian: [
                        2,
                        2,
                        1,
                        2,
                        2,
                        2,
                        1
                    ],
                    dorian: [
                        2,
                        1,
                        2,
                        2,
                        2,
                        1,
                        2
                    ],
                    phyrgian: [
                        1,
                        2,
                        2,
                        2,
                        1,
                        2,
                        2
                    ],
                    lydian: [
                        2,
                        2,
                        2,
                        1,
                        2,
                        2,
                        1
                    ],
                    mixolydian: [
                        2,
                        2,
                        1,
                        2,
                        2,
                        1,
                        2
                    ],
                    aeolian: [
                        2,
                        1,
                        2,
                        2,
                        1,
                        2,
                        2
                    ],
                    locrian: [
                        1,
                        2,
                        2,
                        1,
                        2,
                        2,
                        2
                    ]
                };
            }
            static get scaleTypes() {
                return {
                    M: et.scales.major,
                    m: et.scales.minor
                };
            }
            static get accidentals() {
                return [
                    "bb",
                    "b",
                    "n",
                    "#",
                    "##"
                ];
            }
            static get noteValues() {
                return {
                    c: {
                        root_index: 0,
                        int_val: 0
                    },
                    cn: {
                        root_index: 0,
                        int_val: 0
                    },
                    "c#": {
                        root_index: 0,
                        int_val: 1
                    },
                    "c##": {
                        root_index: 0,
                        int_val: 2
                    },
                    cb: {
                        root_index: 0,
                        int_val: 11
                    },
                    cbb: {
                        root_index: 0,
                        int_val: 10
                    },
                    d: {
                        root_index: 1,
                        int_val: 2
                    },
                    dn: {
                        root_index: 1,
                        int_val: 2
                    },
                    "d#": {
                        root_index: 1,
                        int_val: 3
                    },
                    "d##": {
                        root_index: 1,
                        int_val: 4
                    },
                    db: {
                        root_index: 1,
                        int_val: 1
                    },
                    dbb: {
                        root_index: 1,
                        int_val: 0
                    },
                    e: {
                        root_index: 2,
                        int_val: 4
                    },
                    en: {
                        root_index: 2,
                        int_val: 4
                    },
                    "e#": {
                        root_index: 2,
                        int_val: 5
                    },
                    "e##": {
                        root_index: 2,
                        int_val: 6
                    },
                    eb: {
                        root_index: 2,
                        int_val: 3
                    },
                    ebb: {
                        root_index: 2,
                        int_val: 2
                    },
                    f: {
                        root_index: 3,
                        int_val: 5
                    },
                    fn: {
                        root_index: 3,
                        int_val: 5
                    },
                    "f#": {
                        root_index: 3,
                        int_val: 6
                    },
                    "f##": {
                        root_index: 3,
                        int_val: 7
                    },
                    fb: {
                        root_index: 3,
                        int_val: 4
                    },
                    fbb: {
                        root_index: 3,
                        int_val: 3
                    },
                    g: {
                        root_index: 4,
                        int_val: 7
                    },
                    gn: {
                        root_index: 4,
                        int_val: 7
                    },
                    "g#": {
                        root_index: 4,
                        int_val: 8
                    },
                    "g##": {
                        root_index: 4,
                        int_val: 9
                    },
                    gb: {
                        root_index: 4,
                        int_val: 6
                    },
                    gbb: {
                        root_index: 4,
                        int_val: 5
                    },
                    a: {
                        root_index: 5,
                        int_val: 9
                    },
                    an: {
                        root_index: 5,
                        int_val: 9
                    },
                    "a#": {
                        root_index: 5,
                        int_val: 10
                    },
                    "a##": {
                        root_index: 5,
                        int_val: 11
                    },
                    ab: {
                        root_index: 5,
                        int_val: 8
                    },
                    abb: {
                        root_index: 5,
                        int_val: 7
                    },
                    b: {
                        root_index: 6,
                        int_val: 11
                    },
                    bn: {
                        root_index: 6,
                        int_val: 11
                    },
                    "b#": {
                        root_index: 6,
                        int_val: 0
                    },
                    "b##": {
                        root_index: 6,
                        int_val: 1
                    },
                    bb: {
                        root_index: 6,
                        int_val: 10
                    },
                    bbb: {
                        root_index: 6,
                        int_val: 9
                    }
                };
            }
            isValidNoteValue(t) {
                return t >= 0 && t < et.canonical_notes.length;
            }
            isValidIntervalValue(t) {
                return t >= 0 && t < et.diatonic_intervals.length;
            }
            getNoteParts(t) {
                if (!t || t.length < 1) throw new g("BadArguments", "Invalid note name: " + t);
                if (t.length > 3) throw new g("BadArguments", "Invalid note name: " + t);
                const e = t.toLowerCase(), i = /^([cdefgab])(b|bb|n|#|##)?$/.exec(e);
                if (null !== i) return {
                    root: i[1],
                    accidental: i[2]
                };
                throw new g("BadArguments", "Invalid note name: " + t);
            }
            getKeyParts(t) {
                if (!t || t.length < 1) throw new g("BadArguments", "Invalid key: " + t);
                const e = t.toLowerCase(), i = /^([cdefgab])(b|#)?(mel|harm|m|M)?$/.exec(e);
                if (null !== i) {
                    const t = i[1], e = i[2];
                    let b = i[3];
                    return b || (b = "M"), {
                        root: t,
                        accidental: e,
                        type: b
                    };
                }
                throw new g("BadArguments", `Invalid key: ${t}`);
            }
            getNoteValue(t) {
                const e = et.noteValues[t];
                if (void 0 === e) throw new g("BadArguments", `Invalid note name: ${t}`);
                return e.int_val;
            }
            getIntervalValue(t) {
                const e = et.intervals[t];
                if (void 0 === e) throw new g("BadArguments", `Invalid interval name: ${t}`);
                return e;
            }
            getCanonicalNoteName(t) {
                if (!this.isValidNoteValue(t)) throw new g("BadArguments", `Invalid note value: ${t}`);
                return et.canonical_notes[t];
            }
            getCanonicalIntervalName(t) {
                if (!this.isValidIntervalValue(t)) throw new g("BadArguments", `Invalid interval value: ${t}`);
                return et.diatonic_intervals[t];
            }
            getRelativeNoteValue(t, e, i = 1) {
                if (1 !== i && -1 !== i) throw new g("BadArguments", `Invalid direction: ${i}`);
                let b = (t + i * e) % et.NUM_TONES;
                return b < 0 && (b += et.NUM_TONES), b;
            }
            getRelativeNoteName(t, e) {
                const i = this.getNoteParts(t), b = this.getNoteValue(i.root);
                let a = e - b;
                if (Math.abs(a) > et.NUM_TONES - 3) {
                    let i = 1;
                    a > 0 && (i = -1);
                    const n = (e + 1 + (b + 1)) % et.NUM_TONES * i;
                    if (Math.abs(n) > 2) throw new g("BadArguments", `Notes not related: ${t}, ${e})`);
                    a = n;
                }
                if (Math.abs(a) > 2) throw new g("BadArguments", `Notes not related: ${t}, ${e})`);
                let n = i.root;
                if (a > 0) for(let t = 1; t <= a; ++t)n += "#";
                else if (a < 0) for(let t = -1; t >= a; --t)n += "b";
                return n;
            }
            getScaleTones(t, e) {
                const i = [
                    t
                ];
                let b = t;
                for(let a = 0; a < e.length; a++)b = this.getRelativeNoteValue(b, e[a]), b !== t && i.push(b);
                return i;
            }
            getIntervalBetween(t, e, i = 1) {
                if (1 !== i && -1 !== i) throw new g("BadArguments", `Invalid direction: ${i}`);
                if (!this.isValidNoteValue(t) || !this.isValidNoteValue(e)) throw new g("BadArguments", `Invalid notes: ${t}, ${e}`);
                let b = 1 === i ? e - t : t - e;
                return b < 0 && (b += et.NUM_TONES), b;
            }
            createScaleMap(t) {
                const e = this.getKeyParts(t);
                if (!e.type) throw new g("BadArguments", "Unsupported key type: undefined");
                const i = et.scaleTypes[e.type];
                let b = e.root;
                if (e.accidental && (b += e.accidental), !i) throw new g("BadArguments", "Unsupported key type: " + t);
                const a = this.getScaleTones(this.getNoteValue(b), i), n = et.root_indices[e.root], s = {};
                for(let t = 0; t < et.roots.length; ++t){
                    const e = (n + t) % et.roots.length, i = et.roots[e];
                    let b = this.getRelativeNoteName(i, a[t]);
                    1 === b.length && (b += "n"), s[i] = b;
                }
                return s;
            }
        }
        function it(...t) {
            bt.DEBUG && u("Vex.Flow.Accidental", t);
        }
        class bt extends tt {
            static get CATEGORY() {
                return x.Accidental;
            }
            static format(t, e) {
                if (!t || 0 === t.length) return;
                const i = V.currentMusicFont(), b = i.lookupMetric("accidental.noteheadAccidentalPadding"), a = e.left_shift + b, n = i.lookupMetric("accidental.accidentalSpacing"), s = i.lookupMetric("accidental.leftPadding"), l = [];
                let o, r = 0;
                for(let e = 0; e < t.length; ++e){
                    const i = t[e], b = i.getNote(), a = b.getStave(), n = i.checkIndex(), s = b.getKeyProps()[n];
                    if (b !== o) {
                        for(let t = 0; t < b.keys.length; ++t)r = Math.max(b.getLeftDisplacedHeadPx() - b.getXShift(), r);
                        o = b;
                    }
                    if (a) {
                        const t = a.getSpacingBetweenLines(), e = a.getYForLine(s.line), b = Math.round(e / t * 2) / 2;
                        l.push({
                            y: e,
                            line: b,
                            extraXSpaceNeeded: r,
                            acc: i,
                            spacingBetweenStaveLines: t
                        });
                    } else l.push({
                        line: s.line,
                        extraXSpaceNeeded: r,
                        acc: i
                    });
                }
                l.sort((t, e)=>e.line - t.line);
                const h = [];
                let m = 0;
                for(let t = 0; t < l.length; t++){
                    const e = l[t], i = h[h.length - 1];
                    let b;
                    i && (null == i ? void 0 : i.line) === e.line ? b = i : (b = {
                        line: e.line,
                        flatLine: !0,
                        dblSharpLine: !0,
                        numAcc: 0,
                        width: 0,
                        column: 0
                    }, h.push(b)), "b" !== e.acc.type && "bb" !== e.acc.type && (b.flatLine = !1), "##" !== e.acc.type && (b.dblSharpLine = !1), b.numAcc++, b.width += e.acc.getWidth() + n, m = Math.max(e.extraXSpaceNeeded, m);
                }
                let c = 0;
                for(let t = 0; t < h.length; t++){
                    let e = !1;
                    const i = t;
                    let b = t;
                    for(; b + 1 < h.length && !e;)this.checkCollision(h[b], h[b + 1]) ? b++ : e = !0;
                    const a = (t)=>h[i + t], n = (t)=>t.map(a), s = (t, e)=>{
                        const [i, b] = n([
                            t,
                            e
                        ]).map((t)=>t.line);
                        return i - b;
                    }, l = (...t)=>t.map(n).every(([t, e])=>!this.checkCollision(t, e)), o = b - i + 1;
                    let r, m, d = this.checkCollision(h[i], h[b]) ? "a" : "b";
                    switch(o){
                        case 3:
                            "a" === d && .5 === s(1, 2) && .5 !== s(0, 1) && (d = "second_on_bottom");
                            break;
                        case 4:
                            l([
                                0,
                                2
                            ], [
                                1,
                                3
                            ]) && (d = "spaced_out_tetrachord");
                            break;
                        case 5:
                            "b" === d && l([
                                1,
                                3
                            ]) && (d = "spaced_out_pentachord", l([
                                0,
                                2
                            ], [
                                2,
                                4
                            ]) && (d = "very_spaced_out_pentachord"));
                            break;
                        case 6:
                            l([
                                0,
                                3
                            ], [
                                1,
                                4
                            ], [
                                2,
                                5
                            ]) && (d = "spaced_out_hexachord"), l([
                                0,
                                2
                            ], [
                                2,
                                4
                            ], [
                                1,
                                3
                            ], [
                                3,
                                5
                            ]) && (d = "very_spaced_out_hexachord");
                    }
                    if (o >= 7) {
                        let e = 2, i = !0;
                        for(; !0 === i;){
                            i = !1;
                            for(let t = 0; t + e < h.length; t++)if (this.checkCollision(h[t], h[t + e])) {
                                i = !0, e++;
                                break;
                            }
                        }
                        for(r = t; r <= b; r++)m = (r - t) % e + 1, h[r].column = m, c = c > m ? c : m;
                    } else for(r = t; r <= b; r++)m = V.accidentalColumnsTable[o][d][r - t], h[r].column = m, c = c > m ? c : m;
                    t = b;
                }
                const d = [], _ = [];
                for(let t = 0; t <= c; t++)d[t] = 0, _[t] = 0;
                d[0] = a + m, _[0] = a, h.forEach((t)=>{
                    t.width > d[t.column] && (d[t.column] = t.width);
                });
                for(let t = 1; t < d.length; t++)_[t] = d[t] + _[t - 1];
                const x = _[_.length - 1];
                let g = 0;
                h.forEach((t)=>{
                    let e = 0;
                    const i = g + t.numAcc;
                    for(; g < i; g++){
                        const i = _[t.column - 1] + e + m;
                        l[g].acc.setXShift(i), e += l[g].acc.getWidth() + n, it("Line, accCount, shift: ", t.line, g, i);
                    }
                }), e.left_shift = x + s;
            }
            static checkCollision(t, e) {
                let i = e.line - t.line, b = 3;
                i > 0 ? (b = e.flatLine || e.dblSharpLine ? 2.5 : 3, t.dblSharpLine && (i -= .5)) : (b = t.flatLine || t.dblSharpLine ? 2.5 : 3, e.dblSharpLine && (i -= .5));
                const a = Math.abs(i) < b;
                return it("Line_1, Line_2, Collision: ", t.line, e.line, a), a;
            }
            static applyAccidentals(t, e) {
                const i = [], b = {};
                t.forEach((t)=>{
                    const e = new z(0, 1);
                    t.getTickables().forEach((t)=>{
                        if (t.shouldIgnoreTicks()) return;
                        const a = b[e.value()];
                        a ? a.push(t) : (i.push(e.value()), b[e.value()] = [
                            t
                        ]), e.add(t.getTicks());
                    });
                });
                const n = new et;
                e || (e = "C");
                const s = n.createScaleMap(e), l = {};
                i.forEach((t)=>{
                    const e = b[t], i = [], o = (t)=>{
                        if (!c(t) || t.isRest() || t.shouldIgnoreTicks()) return;
                        const e = t;
                        e.keys.forEach((t, b)=>{
                            const o = n.getNoteParts(t.split("/")[0]), r = t.split("/")[1], h = o.accidental || "n", m = o.root + h;
                            l[o.root + r] || (l[o.root + r] = s[o.root]);
                            const c = l[o.root + r] === m, d = i.indexOf(t) > -1;
                            if (e.getModifiers().forEach((t, i)=>{
                                a(t) && t.type == h && t.getIndex() == b && e.getModifiers().splice(i, 1);
                            }), !c || c && d) {
                                l[o.root + r] = m;
                                const a = new bt(h);
                                e.addModifier(a, b), i.push(t);
                            }
                        }), e.getModifiers().forEach((t)=>{
                            r(t) && t.getGraceNotes().forEach(o);
                        });
                    };
                    e.forEach(o);
                });
            }
            constructor(t){
                super(), it("New accidental: ", t), this.type = t, this.position = tt.Position.LEFT, this.render_options = {
                    font_scale: V.NOTATION_FONT_SCALE,
                    parenLeftPadding: 2,
                    parenRightPadding: 2
                }, this.accidental = V.accidentalCodes(this.type), p(this.accidental, "ArgumentError", `Unknown accidental type: ${t}`), this.cautionary = !1, this.reset();
            }
            reset() {
                const t = this.render_options.font_scale;
                this.glyph = new Z(this.accidental.code, t), this.glyph.setOriginX(1), this.cautionary && (this.parenLeft = new Z(V.accidentalCodes("{").code, t), this.parenRight = new Z(V.accidentalCodes("}").code, t), this.parenLeft.setOriginX(1), this.parenRight.setOriginX(1));
            }
            getWidth() {
                if (this.cautionary) {
                    const t = p(this.parenLeft), e = p(this.parenRight), i = t.getMetrics().width + e.getMetrics().width + this.render_options.parenLeftPadding + this.render_options.parenRightPadding;
                    return this.glyph.getMetrics().width + i;
                }
                return this.glyph.getMetrics().width;
            }
            setNote(t) {
                return p(t, "ArgumentError", `Bad note value: ${t}`), this.note = t, o(t) && (this.render_options.font_scale = 25, this.reset()), this;
            }
            setAsCautionary() {
                return this.cautionary = !0, this.render_options.font_scale = 28, this.reset(), this;
            }
            draw() {
                const { type: t, position: e, index: i, cautionary: b, x_shift: a, y_shift: n, glyph: s, render_options: { parenLeftPadding: l, parenRightPadding: o } } = this, r = this.checkContext(), h = this.checkAttachedNote();
                this.setRendered();
                const m = h.getModifierStartXY(e, i);
                let c = m.x + a;
                const d = m.y + n;
                if (it("Rendering: ", t, c, d), b) {
                    const t = p(this.parenLeft), e = p(this.parenRight);
                    e.render(r, c, d), c -= e.getMetrics().width, c -= o, c -= this.accidental.parenRightPaddingAdjustment, s.render(r, c, d), c -= s.getMetrics().width, c -= l, t.render(r, c, d);
                } else s.render(r, c, d);
            }
        }
        bt.DEBUG = !1;
        class at extends R {
            static get CATEGORY() {
                return x.Stem;
            }
            static get UP() {
                return 1;
            }
            static get DOWN() {
                return -1;
            }
            static get WIDTH() {
                return V.STEM_WIDTH;
            }
            static get HEIGHT() {
                return V.STEM_HEIGHT;
            }
            constructor(t){
                super(), this.stem_up_y_offset = 0, this.stem_down_y_offset = 0, this.stem_up_y_base_offset = 0, this.stem_down_y_base_offset = 0, this.x_begin = (null == t ? void 0 : t.x_begin) || 0, this.x_end = (null == t ? void 0 : t.x_end) || 0, this.y_top = (null == t ? void 0 : t.y_top) || 0, this.y_bottom = (null == t ? void 0 : t.y_bottom) || 0, this.stem_extension = (null == t ? void 0 : t.stem_extension) || 0, this.stem_direction = (null == t ? void 0 : t.stem_direction) || 0, this.hide = (null == t ? void 0 : t.hide) || !1, this.isStemlet = (null == t ? void 0 : t.isStemlet) || !1, this.stemletHeight = (null == t ? void 0 : t.stemletHeight) || 0, this.renderHeightAdjustment = 0, this.setOptions(t);
            }
            setOptions(t) {
                this.stem_up_y_offset = (null == t ? void 0 : t.stem_up_y_offset) || 0, this.stem_down_y_offset = (null == t ? void 0 : t.stem_down_y_offset) || 0, this.stem_up_y_base_offset = (null == t ? void 0 : t.stem_up_y_base_offset) || 0, this.stem_down_y_base_offset = (null == t ? void 0 : t.stem_down_y_base_offset) || 0;
            }
            setNoteHeadXBounds(t, e) {
                return this.x_begin = t, this.x_end = e, this;
            }
            setDirection(t) {
                this.stem_direction = t;
            }
            setExtension(t) {
                this.stem_extension = t;
            }
            getExtension() {
                return this.stem_extension;
            }
            setYBounds(t, e) {
                this.y_top = t, this.y_bottom = e;
            }
            getHeight() {
                const t = this.stem_direction === at.UP ? this.stem_up_y_offset : this.stem_down_y_offset;
                return (this.y_bottom - this.y_top + (at.HEIGHT - t + this.stem_extension)) * this.stem_direction;
            }
            getBoundingBox() {
                throw new g("NotImplemented", "getBoundingBox() not implemented.");
            }
            getExtents() {
                const t = this.stem_direction === at.UP, e = [
                    this.y_top,
                    this.y_bottom
                ], i = at.HEIGHT + this.stem_extension, b = (t ? Math.min : Math.max)(...e), a = (t ? Math.max : Math.min)(...e);
                return {
                    topY: b + i * -this.stem_direction,
                    baseY: a
                };
            }
            setVisibility(t) {
                return this.hide = !t, this;
            }
            setStemlet(t, e) {
                return this.isStemlet = t, this.stemletHeight = e, this;
            }
            adjustHeightForFlag() {
                this.renderHeightAdjustment = V.currentMusicFont().lookupMetric("stem.heightAdjustmentForFlag", -3);
            }
            adjustHeightForBeam() {
                this.renderHeightAdjustment = -at.WIDTH / 2;
            }
            draw() {
                if (this.setRendered(), this.hide) return;
                const t = this.checkContext();
                let e, i;
                const b = this.stem_direction;
                let a = 0;
                b === at.DOWN ? (e = this.x_begin, i = this.y_top + this.stem_down_y_offset, a = this.stem_down_y_base_offset) : (e = this.x_end, i = this.y_bottom - this.stem_up_y_offset, a = this.stem_up_y_base_offset);
                const n = this.getHeight();
                !function(...t) {
                    at.DEBUG && u("Vex.Flow.Stem", t);
                }("Rendering stem - ", "Top Y: ", this.y_top, "Bottom Y: ", this.y_bottom);
                const s = this.isStemlet ? n - this.stemletHeight * this.stem_direction : 0;
                t.save(), this.applyStyle(), t.openGroup("stem", this.getAttribute("id"), {
                    pointerBBox: !0
                }), t.beginPath(), t.setLineWidth(at.WIDTH), t.moveTo(e, i - s + a), t.lineTo(e, i - n - this.renderHeightAdjustment * b), t.stroke(), t.closeGroup(), this.restoreStyle(), t.restore();
            }
        }
        function nt(...t) {
            rt.DEBUG && u("Vex.Flow.TextFormatter", t);
        }
        at.DEBUG = !1;
        const st = {}, lt = {}, ot = {};
        class rt {
            static getFontFamilies() {
                const t = [];
                for(const e in ot){
                    const i = ot[e];
                    t.push(Object.assign({}, i));
                }
                return t;
            }
            static create(t = {}) {
                nt("create: ", t), t.family || (t.family = F.SANS_SERIF);
                const e = [], i = t.family.split(/\s*,\s*/);
                for (const t of i){
                    for(const i in ot)i.startsWith(t) && e.push(ot[i]);
                    if (e.length > 0) break;
                }
                let b;
                if (0 === e.length) b = new rt(Object.values(ot)[0]);
                else if (1 === e.length) b = new rt(e[0]);
                else {
                    const i = F.isBold(t.weight), a = F.isItalic(t.style), n = e.find((t)=>t.bold === i && t.italic === a);
                    if (n) b = new rt(n);
                    else {
                        const t = e.find((t)=>t.italic === a || t.bold === i);
                        b = new rt(t || e[0]);
                    }
                }
                const a = t.size;
                if (void 0 !== a) {
                    const t = F.convertSizeToPointValue(a);
                    b.setFontSize(t);
                }
                return b;
            }
            static getInfo(t) {
                return ot[t];
            }
            static registerInfo(t, e = !1) {
                nt("registerInfo: ", t, e);
                const i = t.family;
                (void 0 === ot[i] || e) && (ot[i] = t);
            }
            constructor(t){
                this.family = "", this.size = 14, this.resolution = 1e3, this.glyphs = {}, this.serifs = !1, this.monospaced = !1, this.italic = !1, this.bold = !1, this.superscriptOffset = 0, this.subscriptOffset = 0, this.maxSizeGlyph = "@", this.cacheKey = "", this.updateParams(t);
            }
            get localHeightCache() {
                var t;
                return void 0 === lt[this.cacheKey] && (lt[this.cacheKey] = {}), null !== (t = lt[this.cacheKey]) && void 0 !== t ? t : {};
            }
            updateParams(t) {
                t.family && (this.family = t.family), t.resolution && (this.resolution = t.resolution), t.glyphs && (this.glyphs = t.glyphs), t.serifs && (this.serifs = t.serifs), t.monospaced && (this.monospaced = t.monospaced), t.italic && (this.italic = t.italic), t.bold && (this.bold = t.bold), t.maxSizeGlyph && (this.maxSizeGlyph = t.maxSizeGlyph), t.superscriptOffset && (this.superscriptOffset = t.superscriptOffset), t.subscriptOffset && (this.subscriptOffset = t.subscriptOffset), this.updateCacheKey();
            }
            updateCacheKey() {
                const t = this.family.replace(/\s+/g, "_"), e = this.size, i = this.bold ? E.BOLD : E.NORMAL, b = this.italic ? P.ITALIC : P.NORMAL;
                this.cacheKey = `${t}%${e}%${i}%${b}`;
            }
            getGlyphMetrics(t) {
                return this.glyphs[t] ? this.glyphs[t] : this.glyphs[this.maxSizeGlyph];
            }
            get maxHeight() {
                return this.getGlyphMetrics(this.maxSizeGlyph).ha / this.resolution * this.fontSizeInPixels;
            }
            getWidthForCharacterInEm(t) {
                var e;
                const i = this.getGlyphMetrics(t);
                if (i) return (null !== (e = i.advanceWidth) && void 0 !== e ? e : 0) / this.resolution;
                return .65;
            }
            getYForCharacterInPx(t) {
                const e = this.getGlyphMetrics(t), i = {
                    yMin: 0,
                    yMax: this.maxHeight,
                    height: this.maxHeight
                };
                return e ? ("number" == typeof e.y_min && (i.yMin = e.y_min / this.resolution * this.fontSizeInPixels), "number" == typeof e.y_max && (i.yMax = e.y_max / this.resolution * this.fontSizeInPixels), i.height = i.yMax - i.yMin, i) : i;
            }
            getYForStringInPx(t) {
                const e = this.localHeightCache, i = {
                    yMin: 0,
                    yMax: this.maxHeight,
                    height: this.maxHeight
                }, b = e[t];
                if (void 0 !== b) return b;
                for(let e = 0; e < t.length; ++e){
                    const b = this.getYForCharacterInPx(t[e]);
                    i.yMin = Math.min(i.yMin, b.yMin), i.yMax = Math.max(i.yMax, b.yMax), i.height = i.yMax - i.yMin;
                }
                return e[t] = i, i;
            }
            getWidthForTextInEm(t) {
                const e = this.cacheKey;
                let i = st[e];
                void 0 === i && (i = {}, st[e] = i);
                let b = i[t];
                if (void 0 === b) {
                    b = 0;
                    for(let e = 0; e < t.length; ++e)b += this.getWidthForCharacterInEm(t[e]);
                    i[t] = b;
                }
                return b;
            }
            getWidthForTextInPx(t) {
                return this.getWidthForTextInEm(t) * this.fontSizeInPixels;
            }
            setFontSize(t) {
                return this.size = t, this.updateCacheKey(), this;
            }
            get fontSizeInPixels() {
                return this.size * F.scaleToPxFrom.pt;
            }
            getResolution() {
                return this.resolution;
            }
        }
        var ht, mt;
        rt.DEBUG = !1, function(t) {
            t[t.LEFT = 1] = "LEFT", t[t.CENTER = 2] = "CENTER", t[t.RIGHT = 3] = "RIGHT", t[t.CENTER_STEM = 4] = "CENTER_STEM";
        }(ht || (ht = {})), function(t) {
            t[t.TOP = 1] = "TOP", t[t.CENTER = 2] = "CENTER", t[t.BOTTOM = 3] = "BOTTOM", t[t.CENTER_STEM = 4] = "CENTER_STEM";
        }(mt || (mt = {}));
        class ct extends tt {
            static get CATEGORY() {
                return x.Annotation;
            }
            static get minAnnotationPadding() {
                return V.currentMusicFont().lookupMetric("noteHead.minPadding");
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0, b = 0, a = 0, n = 0;
                for(let s = 0; s < t.length; ++s){
                    const l = t[s], o = rt.create(l.textFont);
                    let r = (2 + o.getYForStringInPx(l.text).height) / V.STAVE_LINE_DISTANCE;
                    const h = l.checkAttachedNote(), m = h.getGlyphProps().getWidth(), c = o.getWidthForTextInPx(l.text);
                    l.horizontalJustification === ht.LEFT ? (a = Math.max(m, a), i = Math.max(i, c) + ct.minAnnotationPadding) : l.horizontalJustification === ht.RIGHT ? (n = Math.max(m, n), b = Math.max(b, c)) : (i = Math.max(i, c / 2) + ct.minAnnotationPadding, b = Math.max(b, c / 2), a = Math.max(m / 2, a), n = Math.max(m / 2, n));
                    const x = h.getStave(), g = h.hasStem() ? h.getStemDirection() : at.UP;
                    let y = 0, p = 5;
                    if (_(h)) {
                        if (h.render_options.draw_stem) {
                            const t = h.getStem();
                            t && (y = Math.abs(t.getHeight()) / V.STAVE_LINE_DISTANCE);
                        } else y = 0;
                    } else if (d(h)) {
                        const t = h.getStem();
                        t && "n" === h.getNoteType() && (y = Math.abs(t.getHeight()) / V.STAVE_LINE_DISTANCE);
                    }
                    if (x && (p = x.getNumLines()), l.verticalJustification === this.VerticalJustify.TOP) {
                        let t = h.getLineNumber(!0);
                        _(h) && (t = p - (h.leastString() - .5)), g === at.UP && (t += y);
                        t + e.top_text_line + .5 < p ? (l.setTextLine(p - t), r += p - t, e.top_text_line = r) : (l.setTextLine(e.top_text_line), e.top_text_line += r);
                    } else if (l.verticalJustification === this.VerticalJustify.BOTTOM) {
                        let t = p - h.getLineNumber();
                        _(h) && (t = h.greatestString() - 1), g === at.DOWN && (t += y);
                        const i = t + e.text_line + 1;
                        i < p ? (l.setTextLine(p - i), r += p - i, e.text_line = r) : (l.setTextLine(e.text_line), e.text_line += r);
                    } else l.setTextLine(e.text_line);
                }
                const s = Math.min(Math.max(b - n, 0), Math.max(b - e.right_shift, 0)), l = Math.min(Math.max(i - a, 0), Math.max(i - e.left_shift, 0));
                return e.left_shift += l, e.right_shift += s, !0;
            }
            constructor(t){
                super(), this.text = t, this.horizontalJustification = ht.CENTER, this.verticalJustification = mt.TOP, this.resetFont(), this.setWidth(V.textWidth(t));
            }
            setVerticalJustification(t) {
                return this.verticalJustification = "string" == typeof t ? ct.VerticalJustifyString[t] : t, this;
            }
            getJustification() {
                return this.horizontalJustification;
            }
            setJustification(t) {
                return this.horizontalJustification = "string" == typeof t ? ct.HorizontalJustifyString[t] : t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote(), i = e.hasStem() ? e.getStemDirection() : at.UP, b = rt.create(this.textFont), a = e.getModifierStartXY(J.ABOVE, this.index);
                this.setRendered(), t.save(), this.applyStyle(), t.openGroup("annotation", this.getAttribute("id")), t.setFont(this.textFont);
                const n = b.getWidthForTextInPx(this.text), s = b.getYForStringInPx(this.text).height;
                let l, o;
                l = this.horizontalJustification === ht.LEFT ? a.x : this.horizontalJustification === ht.RIGHT ? a.x - n : this.horizontalJustification === ht.CENTER ? a.x - n / 2 : e.getStemX() - n / 2;
                let r = {}, h = 0;
                const m = e.hasStem(), c = e.checkStave();
                if (m && (r = e.checkStem().getExtents(), h = c.getSpacingBetweenLines()), this.verticalJustification === mt.BOTTOM) o = e.getYs().reduce((t, e)=>t > e ? t : e), o += (this.text_line + 1) * V.STAVE_LINE_DISTANCE + s, m && i === at.DOWN && (o = Math.max(o, r.topY + s + h * this.text_line));
                else if (this.verticalJustification === mt.CENTER) {
                    const t = e.getYForTopText(this.text_line) - 1;
                    o = t + (c.getYForBottomText(this.text_line) - t) / 2 + s / 2;
                } else if (this.verticalJustification === mt.TOP) o = Math.min(...e.getYs()) - (this.text_line + 1) * V.STAVE_LINE_DISTANCE, m && i === at.UP && (h = r.topY < c.getTopLineTopY() ? V.STAVE_LINE_DISTANCE : h, o = Math.min(o, r.topY - h * (this.text_line + 1)));
                else {
                    const t = e.getStemExtents();
                    o = t.topY + (t.baseY - t.topY) / 2 + s / 2;
                }
                !function(...t) {
                    ct.DEBUG && u("Vex.Flow.Annotation", t);
                }("Rendering annotation: ", this.text, l, o), t.fillText(this.text, l, o), t.closeGroup(), this.restoreStyle(), t.restore();
            }
        }
        ct.DEBUG = !1, ct.TEXT_FONT = Object.assign({}, R.TEXT_FONT), ct.HorizontalJustify = ht, ct.HorizontalJustifyString = {
            left: ht.LEFT,
            right: ht.RIGHT,
            center: ht.CENTER,
            centerStem: ht.CENTER_STEM
        }, ct.VerticalJustify = mt, ct.VerticalJustifyString = {
            above: mt.TOP,
            top: mt.TOP,
            below: mt.BOTTOM,
            bottom: mt.BOTTOM,
            center: mt.CENTER,
            centerStem: mt.CENTER_STEM
        };
        const { ABOVE: dt, BELOW: _t } = tt.Position;
        function xt(t, e) {
            return .5 * t(e / .5);
        }
        function gt(t, e) {
            return e === dt ? t <= 5 : t >= 1;
        }
        function yt(t, e) {
            return gt(t, e) ? e === dt ? Math.ceil : Math.floor : Math.round;
        }
        const pt = (t)=>c(t) || o(t);
        class ut extends tt {
            static get CATEGORY() {
                return x.Articulation;
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0;
                const b = (t, e, i)=>xt(yt(e, i), p(t.glyph.getMetrics().height) / 10 + .5);
                t.forEach((t)=>{
                    const a = t.checkAttachedNote();
                    i = Math.max(a.getGlyphProps().getWidth(), i);
                    let n = 5;
                    const s = a.hasStem() ? a.getStemDirection() : at.UP;
                    let l = 0;
                    if (d(a)) {
                        const t = a.getStem();
                        t && (l = Math.abs(t.getHeight()) / V.STAVE_LINE_DISTANCE);
                    }
                    const o = a.getStave();
                    if (o && (n = o.getNumLines()), t.getPosition() === dt) {
                        let i = a.getLineNumber(!0);
                        s === at.UP && (i += l);
                        let o = b(t, e.top_text_line, dt);
                        const r = i + e.top_text_line + .5;
                        !t.articulation.between_lines && r < n && (o += n - r), t.setTextLine(e.top_text_line), e.top_text_line += o;
                    } else if (t.getPosition() === _t) {
                        let i = Math.max(n - a.getLineNumber(), 0);
                        s === at.DOWN && (i += l);
                        let o = b(t, e.text_line, _t);
                        const r = i + e.text_line + .5;
                        !t.articulation.between_lines && r < n && (o += n - r), t.setTextLine(e.text_line), e.text_line += o;
                    }
                });
                const a = t.map((t)=>t.getWidth()).reduce((t, e)=>Math.max(e, t)), n = Math.min(Math.max(a - i, 0), Math.max(a - (e.left_shift + e.right_shift), 0));
                return e.left_shift += n / 2, e.right_shift += n / 2, !0;
            }
            static easyScoreHook({ articulations: t }, e, i) {
                if (!t) return;
                const b = {
                    staccato: "a.",
                    tenuto: "a-",
                    accent: "a>"
                };
                t.split(",").map((t)=>t.trim().split(".")).map(([t, e])=>{
                    const a = {
                        type: b[t]
                    };
                    return e && (a.position = tt.PositionString[e]), i.getFactory().Articulation(a);
                }).map((t)=>e.addModifier(t, 0));
            }
            constructor(t){
                super(), this.type = t, this.position = dt, this.render_options = {
                    font_scale: V.NOTATION_FONT_SCALE
                }, this.reset();
            }
            reset() {
                this.articulation = V.articulationCodes(this.type), this.articulation || (this.articulation = {
                    code: this.type,
                    between_lines: !1
                }, this.type.endsWith("Above") && (this.position = dt), this.type.endsWith("Below") && (this.position = _t));
                const t = (this.position === dt ? this.articulation.aboveCode : this.articulation.belowCode) || this.articulation.code;
                this.glyph = new Z(null != t ? t : "", this.render_options.font_scale), p(this.glyph, "ArgumentError", `Articulation not found: ${this.type}`), this.setWidth(p(this.glyph.getMetrics().width));
            }
            setBetweenLines(t = !0) {
                return this.articulation.between_lines = t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = this.checkIndex(), { position: b, glyph: a, text_line: n } = this, s = this.articulation.between_lines, l = e.checkStave(), o = l.getSpacingBetweenLines(), r = _(e), { x: h } = e.getModifierStartXY(b, i), m = !s || r, c = function(t, e) {
                    const i = e === dt && t.getStemDirection() === at.UP || e === _t && t.getStemDirection() === at.DOWN;
                    return pt(t) ? t.hasStem() && i ? .5 : 1 : t.hasStem() && i ? 1 : 0;
                }(e, b), d = V.currentMusicFont().lookupMetric(`articulation.${a.getCode()}.padding`, 0);
                let x = ({
                    [dt]: ()=>{
                        a.setOrigin(.5, 1);
                        const t = function(t, e) {
                            const i = t.getStemDirection(), { topY: b, baseY: a } = t.getStemExtents();
                            if (pt(t)) return t.hasStem() ? i === at.UP ? b : a : Math.min(...t.getYs());
                            if (_(t)) return t.hasStem() && i === at.UP ? b : t.checkStave().getYForTopText(e);
                            throw new g("UnknownCategory", "Only can get the top and bottom ys of stavenotes and tabnotes");
                        }(e, n) - (n + c) * o;
                        return m ? Math.min(l.getYForTopText(ut.INITIAL_OFFSET), t) : t;
                    },
                    [_t]: ()=>{
                        a.setOrigin(.5, 0);
                        const t = function(t, e) {
                            const i = t.getStemDirection(), { topY: b, baseY: a } = t.getStemExtents();
                            if (pt(t)) return t.hasStem() ? i === at.UP ? a : b : Math.max(...t.getYs());
                            if (_(t)) return t.hasStem() ? i === at.UP ? t.checkStave().getYForBottomText(e) : b : t.checkStave().getYForBottomText(e);
                            throw new g("UnknownCategory", "Only can get the top and bottom ys of stavenotes and tabnotes");
                        }(e, n) + (n + c) * o;
                        return m ? Math.max(l.getYForBottomText(ut.INITIAL_OFFSET), t) : t;
                    }
                })[b]();
                if (!r) {
                    const t = b === dt ? -1 : 1, n = e.getKeyProps()[i].line, l = (e.getYs()[i] - x) / o + Number(n), r = function(t, e, i, b) {
                        const a = xt(yt(e, i), e);
                        if (t && gt(a, i) && a % 1 == 0) return a + .5 * -b;
                        return a;
                    }(s, l, b, t);
                    gt(r, b) && a.setOrigin(.5, .5), x += Math.abs(r - l) * o * t + d * t;
                }
                !function(...t) {
                    ut.DEBUG && u("Vex.Flow.Articulation", t);
                }(`Rendering articulation at (x: ${h}, y: ${x})`), a.render(t, h, x);
            }
        }
        ut.DEBUG = !1, ut.INITIAL_OFFSET = -0.5;
        class ft {
            static get CATEGORY() {
                return x.RenderContext;
            }
            set font(t) {
                this.setFont(t);
            }
            get font() {
                return this.getFont();
            }
            setRawFont(t) {
                return this.setFont(t), this;
            }
        }
        function St(t, e, i, b = "#F55") {
            t.save(), t.setFillStyle(b), t.beginPath(), t.arc(e, i, 3, 0, 2 * Math.PI, !1), t.closePath(), t.fill(), t.restore();
        }
        class Tt extends R {
            static get CATEGORY() {
                return x.Tickable;
            }
            constructor(){
                super(), this._preFormatted = !1, this._postFormatted = !1, this.ticks = new z(0, 1), this.intrinsicTicks = 0, this.tickMultiplier = new z(1, 1), this.width = 0, this.x_shift = 0, this.modifiers = [], this.tupletStack = [], this.align_center = !1, this.center_x_shift = 0, this.ignore_ticks = !1, this.formatterMetrics = {
                    freedom: {
                        left: 0,
                        right: 0
                    },
                    duration: "",
                    iterations: 0,
                    space: {
                        used: 0,
                        mean: 0,
                        deviation: 0
                    }
                };
            }
            reset() {
                return this;
            }
            getTicks() {
                return this.ticks;
            }
            shouldIgnoreTicks() {
                return this.ignore_ticks;
            }
            setIgnoreTicks(t) {
                return this.ignore_ticks = t, this;
            }
            setWidth(t) {
                this.width = t;
            }
            getWidth() {
                if (!this._preFormatted) throw new g("UnformattedNote", "Can't call GetWidth on an unformatted note.");
                return this.width + (this.modifierContext ? this.modifierContext.getWidth() : 0);
            }
            setXShift(t) {
                return this.x_shift = t, this;
            }
            getXShift() {
                return this.x_shift;
            }
            getX() {
                return this.checkTickContext("Can't getX() without a TickContext.").getX() + this.x_shift;
            }
            getFormatterMetrics() {
                return this.formatterMetrics;
            }
            getCenterXShift() {
                return this.isCenterAligned() ? this.center_x_shift : 0;
            }
            setCenterXShift(t) {
                return this.center_x_shift = t, this;
            }
            isCenterAligned() {
                return this.align_center;
            }
            setCenterAlignment(t) {
                return this.align_center = t, this;
            }
            getVoice() {
                return p(this.voice, "NoVoice", "Tickable has no voice.");
            }
            setVoice(t) {
                this.voice = t;
            }
            getTuplet() {
                return this.tuplet;
            }
            getTupletStack() {
                return this.tupletStack;
            }
            resetTuplet(t) {
                let e, i;
                if (t) {
                    const b = this.tupletStack.indexOf(t);
                    return -1 !== b && (this.tupletStack.splice(b, 1), e = t.getNoteCount(), i = t.getNotesOccupied(), this.applyTickMultiplier(e, i)), this;
                }
                for(; this.tupletStack.length;)e = (t = this.tupletStack.pop()).getNoteCount(), i = t.getNotesOccupied(), this.applyTickMultiplier(e, i);
                return this;
            }
            setTuplet(t) {
                if (t) {
                    this.tupletStack.push(t);
                    const e = t.getNoteCount(), i = t.getNotesOccupied();
                    this.applyTickMultiplier(i, e);
                }
                return this.tuplet = t, this;
            }
            addToModifierContext(t) {
                this.modifierContext = t;
                for(let t = 0; t < this.modifiers.length; ++t)this.modifierContext.addMember(this.modifiers[t]);
                return this.modifierContext.addMember(this), this._preFormatted = !1, this;
            }
            addModifier(t, e = 0) {
                return this.modifiers.push(t), this._preFormatted = !1, this;
            }
            getModifiers() {
                return this.modifiers;
            }
            setTickContext(t) {
                this.tickContext = t, this._preFormatted = !1;
            }
            checkTickContext(t = "Tickable has no tick context.") {
                return p(this.tickContext, "NoTickContext", t);
            }
            preFormat() {
                this._preFormatted || (this.width = 0, this.modifierContext && (this.modifierContext.preFormat(), this.width += this.modifierContext.getWidth()));
            }
            set preFormatted(t) {
                this._preFormatted = t;
            }
            get preFormatted() {
                return this._preFormatted;
            }
            postFormat() {
                return this._postFormatted || (this._postFormatted = !0), this;
            }
            set postFormatted(t) {
                this._postFormatted = t;
            }
            get postFormatted() {
                return this._postFormatted;
            }
            getIntrinsicTicks() {
                return this.intrinsicTicks;
            }
            setIntrinsicTicks(t) {
                this.intrinsicTicks = t, this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
            }
            getTickMultiplier() {
                return this.tickMultiplier;
            }
            applyTickMultiplier(t, e) {
                this.tickMultiplier.multiply(t, e), this.ticks = this.tickMultiplier.clone().multiply(this.intrinsicTicks);
            }
            setDuration(t) {
                const e = t.numerator * (V.RESOLUTION / t.denominator);
                this.ticks = this.tickMultiplier.clone().multiply(e), this.intrinsicTicks = this.ticks.value();
            }
            getAbsoluteX() {
                return this.checkTickContext("Can't getAbsoluteX() without a TickContext.").getX();
            }
            setModifierContext(t) {
                return this.modifierContext = t, this;
            }
            getModifierContext() {
                return this.modifierContext;
            }
            checkModifierContext() {
                return p(this.modifierContext, "NoModifierContext", "No modifier context attached to this tickable.");
            }
        }
        class vt extends Tt {
            static get CATEGORY() {
                return x.Note;
            }
            static plotMetrics(t, e, i) {
                const b = e.getMetrics(), a = e.getAbsoluteX() - b.modLeftPx - b.leftDisplacedHeadPx, n = e.getAbsoluteX() - b.leftDisplacedHeadPx, s = e.getAbsoluteX(), l = e.getAbsoluteX() + b.notePx, o = e.getAbsoluteX() + b.notePx + b.rightDisplacedHeadPx, r = e.getAbsoluteX() + b.notePx + b.rightDisplacedHeadPx + b.modRightPx, h = r + (e.getFormatterMetrics().freedom.right || 0), m = r - a;
                t.save(), t.setFont(F.SANS_SERIF, 8), t.fillText(Math.round(m) + "px", a + e.getXShift(), i);
                const c = i + 7;
                function d(i, b, a, n = c) {
                    t.beginPath(), t.setStrokeStyle(a), t.setFillStyle(a), t.setLineWidth(3), t.moveTo(i + e.getXShift(), n), t.lineTo(b + e.getXShift(), n), t.stroke();
                }
                d(a, n, "red"), d(n, s, "#999"), d(s, l, "green"), d(l, o, "#999"), d(o, r, "red"), d(r, h, "#DD0"), d(a - e.getXShift(), a, "#BBB"), St(t, s + e.getXShift(), c, "blue");
                const _ = e.getFormatterMetrics();
                if (_.iterations > 0) {
                    const b = _.space.deviation, a = b >= 0 ? "+" : "";
                    t.setFillStyle("red"), t.fillText(a + Math.round(b), s + e.getXShift(), i - 10);
                }
                t.restore();
            }
            static parseDuration(t) {
                if (!t) return;
                const e = /(\d*\/?\d+|[a-z])(d*)([nrhms]|$)/.exec(t);
                if (!e) return;
                return {
                    duration: e[1],
                    dots: e[2].length,
                    type: e[3] || "n"
                };
            }
            static parseNoteStruct(t) {
                const e = vt.parseDuration(t.duration);
                if (!e) return;
                let i = t.type;
                if (i && !V.validTypes[i]) return;
                const b = [];
                i || (i = e.type || "n", void 0 !== t.keys && t.keys.forEach((t, e)=>{
                    const a = t.split("/");
                    b[e] = a && 3 === a.length ? a[2] : i;
                }));
                let a = V.durationToTicks(e.duration);
                if (!a) return;
                const n = t.dots ? t.dots : e.dots;
                if ("number" != typeof n) return;
                let s = a;
                for(let t = 0; t < n; t++){
                    if (s <= 1) return;
                    s /= 2, a += s;
                }
                return {
                    duration: e.duration,
                    type: i,
                    customTypes: b,
                    dots: n,
                    ticks: a
                };
            }
            constructor(t){
                if (super(), !t) throw new g("BadArguments", "Note must have valid initialization data to identify duration and type.");
                const e = vt.parseNoteStruct(t);
                if (!e) throw new g("BadArguments", `Invalid note initialization object: ${JSON.stringify(t)}`);
                this.keys = t.keys || [], this.keyProps = [], this.duration = e.duration, this.noteType = e.type, this.customTypes = e.customTypes, t.duration_override ? this.setDuration(t.duration_override) : this.setIntrinsicTicks(e.ticks), this.modifiers = [], this.glyphProps = V.getGlyphProps(this.duration, this.noteType), this.customGlyphs = this.customTypes.map((t)=>V.getGlyphProps(this.duration, t)), this.playNote = void 0, this.ignore_ticks = !1, this.width = 0, this.leftDisplacedHeadPx = 0, this.rightDisplacedHeadPx = 0, this.x_shift = 0, this.ys = [], t.align_center && this.setCenterAlignment(t.align_center), this.render_options = {
                    annotation_spacing: 5,
                    glyph_font_scale: 1,
                    stroke_px: 1,
                    scale: 1,
                    font: "",
                    y_shift: 0
                };
            }
            getPlayNote() {
                return this.playNote;
            }
            setPlayNote(t) {
                return this.playNote = t, this;
            }
            isRest() {
                return !1;
            }
            addStroke(t, e) {
                return e.setNote(this), e.setIndex(t), this.modifiers.push(e), this.preFormatted = !1, this;
            }
            getStave() {
                return this.stave;
            }
            checkStave() {
                return p(this.stave, "NoStave", "No stave attached to instance.");
            }
            setStave(t) {
                return this.stave = t, this.setYs([
                    t.getYForLine(0)
                ]), this.setContext(this.stave.getContext()), this;
            }
            getLeftDisplacedHeadPx() {
                return this.leftDisplacedHeadPx;
            }
            getRightDisplacedHeadPx() {
                return this.rightDisplacedHeadPx;
            }
            setLeftDisplacedHeadPx(t) {
                return this.leftDisplacedHeadPx = t, this;
            }
            setRightDisplacedHeadPx(t) {
                return this.rightDisplacedHeadPx = t, this;
            }
            shouldIgnoreTicks() {
                return this.ignore_ticks;
            }
            getLineNumber(t) {
                return 0;
            }
            getLineForRest() {
                return 0;
            }
            getGlyph() {
                return this.glyphProps;
            }
            getGlyphProps() {
                return this.glyphProps;
            }
            getGlyphWidth() {
                return this.glyphProps.getWidth(this.render_options.glyph_font_scale);
            }
            setYs(t) {
                return this.ys = t, this;
            }
            getYs() {
                if (0 === this.ys.length) throw new g("NoYValues", "No Y-values calculated for this note.");
                return this.ys;
            }
            getYForTopText(t) {
                return this.checkStave().getYForTopText(t);
            }
            getVoice() {
                if (!this.voice) throw new g("NoVoice", "Note has no voice.");
                return this.voice;
            }
            setVoice(t) {
                return this.voice = t, this.preFormatted = !1, this;
            }
            getTickContext() {
                return this.checkTickContext();
            }
            setTickContext(t) {
                return this.tickContext = t, this.preFormatted = !1, this;
            }
            getDuration() {
                return this.duration;
            }
            isDotted() {
                return this.getModifiersByType(x.Dot).length > 0;
            }
            hasStem() {
                return !1;
            }
            getNoteType() {
                return this.noteType;
            }
            getBeam() {
                return this.beam;
            }
            checkBeam() {
                return p(this.beam, "NoBeam", "No beam attached to instance");
            }
            hasBeam() {
                return null != this.beam;
            }
            setBeam(t) {
                return this.beam = t, this;
            }
            addModifier(t, e = 0) {
                const i = "Note.addModifier(modifier: Modifier, index: number=0)";
                if ("string" == typeof e && (e = parseInt(e), console.warn(i + " expected a number for `index`, but received a string.")), "object" != typeof t || "number" != typeof e) throw new g("WrongParams", "Incorrect call signature. Use " + i + " instead.");
                return t.setNote(this), t.setIndex(e), super.addModifier(t), this;
            }
            getModifiersByType(t) {
                return this.modifiers.filter((e)=>e.getCategory() === t);
            }
            getModifierStartXY(t, e, i) {
                if (!this.preFormatted) throw new g("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
                return {
                    x: this.getAbsoluteX(),
                    y: this.ys[0]
                };
            }
            getRightParenthesisPx(t) {
                return this.getKeyProps()[t].displaced ? this.getRightDisplacedHeadPx() : 0;
            }
            getLeftParenthesisPx(t) {
                return this.getKeyProps()[t].displaced ? this.getLeftDisplacedHeadPx() - this.x_shift : -this.x_shift;
            }
            getFirstDotPx() {
                let t = this.getRightDisplacedHeadPx();
                return 0 !== this.checkModifierContext().getMembers("Parenthesis").length && (t += V.currentMusicFont().lookupMetric("parenthesis.default.width")), t;
            }
            getMetrics() {
                if (!this.preFormatted) throw new g("UnformattedNote", "Can't call getMetrics on an unformatted note.");
                const t = this.modifierContext ? this.modifierContext.getState().left_shift : 0, e = this.modifierContext ? this.modifierContext.getState().right_shift : 0, i = this.getWidth();
                return {
                    width: i,
                    glyphWidth: this.getGlyphWidth(),
                    notePx: i - t - e - this.leftDisplacedHeadPx - this.rightDisplacedHeadPx,
                    modLeftPx: t,
                    modRightPx: e,
                    leftDisplacedHeadPx: this.leftDisplacedHeadPx,
                    rightDisplacedHeadPx: this.rightDisplacedHeadPx,
                    glyphPx: 0
                };
            }
            getAbsoluteX() {
                let t = this.checkTickContext("Can't getAbsoluteX() without a TickContext.").getX();
                return this.stave && (t += this.stave.getNoteStartX() + V.currentMusicFont().lookupMetric("stave.padding")), this.isCenterAligned() && (t += this.getCenterXShift()), t;
            }
            static getPoint(t) {
                return "default" == t ? V.NOTATION_FONT_SCALE : V.NOTATION_FONT_SCALE / 5 * 3;
            }
            getStemDirection() {
                throw new g("NoStem", "No stem attached to this note.");
            }
            getStemExtents() {
                throw new g("NoStem", "No stem attached to this note.");
            }
            getTieRightX() {
                let t = this.getAbsoluteX();
                return t += this.glyphProps.getWidth() / 2, t += -this.width / 2 + this.width + 2, t;
            }
            getTieLeftX() {
                let t = this.getAbsoluteX();
                return t += this.glyphProps.getWidth() / 2, t -= this.width / 2 + 2, t;
            }
            getKeys() {
                return this.keys;
            }
            getKeyProps() {
                return this.keyProps;
            }
        }
        var wt, zt, Bt, Dt, Ct, Et;
        !function(t) {
            t[t.CENTER = 0] = "CENTER", t[t.LEFT = 1] = "LEFT", t[t.RIGHT = 2] = "RIGHT", t[t.ABOVE = 3] = "ABOVE", t[t.BELOW = 4] = "BELOW", t[t.BEGIN = 5] = "BEGIN", t[t.END = 6] = "END";
        }(wt || (wt = {}));
        class Pt extends R {
            static get CATEGORY() {
                return x.StaveModifier;
            }
            static get Position() {
                return wt;
            }
            constructor(){
                super(), this.width = 0, this.x = 0, this.padding = 10, this.position = wt.ABOVE;
            }
            getPosition() {
                return this.position;
            }
            setPosition(t) {
                return this.position = t, this;
            }
            getStave() {
                return this.stave;
            }
            checkStave() {
                return p(this.stave, "NoStave", "No stave attached to instance.");
            }
            setStave(t) {
                return this.stave = t, this;
            }
            getWidth() {
                return this.width;
            }
            setWidth(t) {
                return this.width = t, this;
            }
            getX() {
                return this.x;
            }
            setX(t) {
                return this.x = t, this;
            }
            placeGlyphOnLine(t, e, i, b = 0) {
                t.setYShift(e.getYForLine(null != i ? i : 0) - e.getYForGlyphs() + b);
            }
            getPadding(t) {
                return void 0 !== t && t < 2 ? 0 : this.padding;
            }
            setPadding(t) {
                return this.padding = t, this;
            }
            setLayoutMetrics(t) {
                return this.layoutMetrics = t, this;
            }
            getLayoutMetrics() {
                return this.layoutMetrics;
            }
            draw(...t) {}
        }
        !function(t) {
            t[t.SINGLE = 1] = "SINGLE", t[t.DOUBLE = 2] = "DOUBLE", t[t.END = 3] = "END", t[t.REPEAT_BEGIN = 4] = "REPEAT_BEGIN", t[t.REPEAT_END = 5] = "REPEAT_END", t[t.REPEAT_BOTH = 6] = "REPEAT_BOTH", t[t.NONE = 7] = "NONE";
        }(zt || (zt = {}));
        class kt extends Pt {
            static get CATEGORY() {
                return x.Barline;
            }
            static get type() {
                return zt;
            }
            static get typeString() {
                return {
                    single: zt.SINGLE,
                    double: zt.DOUBLE,
                    end: zt.END,
                    repeatBegin: zt.REPEAT_BEGIN,
                    repeatEnd: zt.REPEAT_END,
                    repeatBoth: zt.REPEAT_BOTH,
                    none: zt.NONE
                };
            }
            constructor(t){
                super(), this.thickness = V.STAVE_LINE_THICKNESS;
                const e = zt;
                this.widths = {}, this.widths[e.SINGLE] = 5, this.widths[e.DOUBLE] = 5, this.widths[e.END] = 5, this.widths[e.REPEAT_BEGIN] = 5, this.widths[e.REPEAT_END] = 5, this.widths[e.REPEAT_BOTH] = 5, this.widths[e.NONE] = 5, this.paddings = {}, this.paddings[e.SINGLE] = 0, this.paddings[e.DOUBLE] = 0, this.paddings[e.END] = 0, this.paddings[e.REPEAT_BEGIN] = 15, this.paddings[e.REPEAT_END] = 15, this.paddings[e.REPEAT_BOTH] = 15, this.paddings[e.NONE] = 0, this.layoutMetricsMap = {}, this.layoutMetricsMap[e.SINGLE] = {
                    xMin: 0,
                    xMax: 1,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.DOUBLE] = {
                    xMin: -3,
                    xMax: 1,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.END] = {
                    xMin: -5,
                    xMax: 1,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.REPEAT_END] = {
                    xMin: -10,
                    xMax: 1,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.REPEAT_BEGIN] = {
                    xMin: -2,
                    xMax: 10,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.REPEAT_BOTH] = {
                    xMin: -10,
                    xMax: 10,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.layoutMetricsMap[e.NONE] = {
                    xMin: 0,
                    xMax: 0,
                    paddingLeft: 5,
                    paddingRight: 5
                }, this.setPosition(wt.BEGIN), this.setType(t);
            }
            getType() {
                return this.type;
            }
            setType(t) {
                return this.type = "string" == typeof t ? kt.typeString[t] : t, this.setWidth(this.widths[this.type]), this.setPadding(this.paddings[this.type]), this.setLayoutMetrics(this.layoutMetricsMap[this.type]), this;
            }
            draw(t) {
                const e = t.checkContext();
                switch(this.setRendered(), this.applyStyle(e), e.openGroup("stavebarline", this.getAttribute("id")), this.type){
                    case zt.SINGLE:
                        this.drawVerticalBar(t, this.x, !1);
                        break;
                    case zt.DOUBLE:
                        this.drawVerticalBar(t, this.x, !0);
                        break;
                    case zt.END:
                        this.drawVerticalEndBar(t, this.x);
                        break;
                    case zt.REPEAT_BEGIN:
                        this.drawRepeatBar(t, this.x, !0), t.getX() !== this.x && this.drawVerticalBar(t, t.getX());
                        break;
                    case zt.REPEAT_END:
                        this.drawRepeatBar(t, this.x, !1);
                        break;
                    case zt.REPEAT_BOTH:
                        this.drawRepeatBar(t, this.x, !1), this.drawRepeatBar(t, this.x, !0);
                }
                e.closeGroup(), this.restoreStyle(e);
            }
            drawVerticalBar(t, e, i) {
                const b = t.checkContext(), a = t.getTopLineTopY(), n = t.getBottomLineBottomY();
                i && b.fillRect(e - 3, a, 1, n - a), b.fillRect(e, a, 1, n - a);
            }
            drawVerticalEndBar(t, e) {
                const i = t.checkContext(), b = t.getTopLineTopY(), a = t.getBottomLineBottomY();
                i.fillRect(e - 5, b, 1, a - b), i.fillRect(e - 2, b, 3, a - b);
            }
            drawRepeatBar(t, e, i) {
                const b = t.checkContext(), a = t.getTopLineTopY(), n = t.getBottomLineBottomY();
                let s = 3;
                i || (s = -5), b.fillRect(e + s, a, 1, n - a), b.fillRect(e - 2, a, 3, n - a);
                i ? s += 4 : s -= 4;
                const l = e + s + 1;
                let o = (t.getNumLines() - 1) * t.getSpacingBetweenLines();
                o = o / 2 - t.getSpacingBetweenLines() / 2;
                let r = a + o + 1;
                b.beginPath(), b.arc(l, r, 2, 0, 2 * Math.PI, !1), b.fill(), r += t.getSpacingBetweenLines(), b.beginPath(), b.arc(l, r, 2, 0, 2 * Math.PI, !1), b.fill();
            }
        }
        class At extends vt {
            static get CATEGORY() {
                return x.BarNote;
            }
            constructor(t = zt.SINGLE){
                super({
                    duration: "b"
                }), this.metrics = {
                    widths: {}
                };
                const e = zt;
                this.metrics.widths = {
                    [e.SINGLE]: 8,
                    [e.DOUBLE]: 12,
                    [e.END]: 15,
                    [e.REPEAT_BEGIN]: 14,
                    [e.REPEAT_END]: 14,
                    [e.REPEAT_BOTH]: 18,
                    [e.NONE]: 0
                }, this.ignore_ticks = !0, this.setType(t), this.barline = new kt(t);
            }
            getType() {
                return this.type;
            }
            setType(t) {
                return this.type = "string" == typeof t ? kt.typeString[t] : t, this.setWidth(this.metrics.widths[this.type]), this;
            }
            addToModifierContext(t) {
                return this;
            }
            preFormat() {
                return this.preFormatted = !0, this;
            }
            draw() {
                const t = this.checkContext();
                !function(...t) {
                    At.DEBUG && u("Vex.Flow.BarNote", t);
                }("Rendering bar line at: ", this.getAbsoluteX()), this.applyStyle(t), t.openGroup("barnote", this.getAttribute("id")), this.barline.setType(this.type), this.barline.setX(this.getAbsoluteX()), this.barline.draw(this.checkStave()), t.closeGroup(), this.restoreStyle(t), this.setRendered();
            }
        }
        At.DEBUG = !1;
        class Nt extends tt {
            static get CATEGORY() {
                return x.Bend;
            }
            static get UP() {
                return 0;
            }
            static get DOWN() {
                return 1;
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0;
                for(let b = 0; b < t.length; ++b){
                    const a = t[b], n = a.checkAttachedNote();
                    if (_(n)) {
                        const t = n.leastString() - 1;
                        e.top_text_line < t && (e.top_text_line = t);
                    }
                    a.setXShift(i), i = a.getWidth(), a.setTextLine(e.top_text_line);
                }
                return e.right_shift += i, e.top_text_line += 1, !0;
            }
            constructor(t, e = !1, i){
                super(), this.text = t, this.x_shift = 0, this.release = e, this.tap = "", this.resetFont(), this.render_options = {
                    line_width: 1.5,
                    line_style: "#777777",
                    bend_width: 8,
                    release_width: 8
                }, i ? this.phrase = i : (this.phrase = [
                    {
                        type: Nt.UP,
                        text: this.text
                    }
                ], this.release && this.phrase.push({
                    type: Nt.DOWN,
                    text: ""
                })), this.updateWidth();
            }
            setXShift(t) {
                return this.x_shift = t, this.updateWidth(), this;
            }
            setTap(t) {
                return this.tap = t, this;
            }
            getText() {
                return this.text;
            }
            getTextHeight() {
                return rt.create(this.textFont).maxHeight;
            }
            updateWidth() {
                const t = rt.create(this.textFont);
                let e = 0;
                for(let b = 0; b < this.phrase.length; ++b){
                    const a = this.phrase[b];
                    if (void 0 !== a.width) e += a.width;
                    else {
                        const b = a.type === Nt.UP ? this.render_options.bend_width : this.render_options.release_width;
                        a.width = Math.max(b, (i = a.text, t.getWidthForTextInPx(i))) + 3, a.draw_width = a.width / 2, e += a.width;
                    }
                }
                var i;
                return this.setWidth(e + this.x_shift), this;
            }
            draw() {
                var t;
                const e = this.checkContext(), i = this.checkAttachedNote();
                this.setRendered();
                const b = i.getModifierStartXY(tt.Position.RIGHT, this.index);
                b.x += 3, b.y += .5;
                const a = this.x_shift, n = i.checkStave().getSpacingBetweenLines(), s = i.getYs().reduce((t, e)=>t < e ? t : e), l = b.y - ((this.text_line + 1) * n + b.y - s) + 3, o = b.y - ((this.text_line + 1) * n + b.y - s) - 1, r = (t, i, b, a)=>{
                    const n = t + b, s = i;
                    e.save(), e.beginPath(), e.setLineWidth(this.render_options.line_width), e.setStrokeStyle(this.render_options.line_style), e.setFillStyle(this.render_options.line_style), e.moveTo(t, i), e.quadraticCurveTo(n, s, t + b, a), e.stroke(), e.restore();
                }, h = (t, i, b, a)=>{
                    e.save(), e.beginPath(), e.setLineWidth(this.render_options.line_width), e.setStrokeStyle(this.render_options.line_style), e.setFillStyle(this.render_options.line_style), e.moveTo(t, a), e.quadraticCurveTo(t + b, a, t + b, i), e.stroke(), e.restore();
                }, m = (t, i, b)=>{
                    const a = i + 4 * b;
                    e.beginPath(), e.moveTo(t, i), e.lineTo(t - 4, a), e.lineTo(t + 4, a), e.closePath(), e.fill();
                }, c = (t, i)=>{
                    e.save(), e.setFont(this.textFont);
                    const b = t - e.measureText(i).width / 2;
                    e.fillText(i, b, o), e.restore();
                };
                let d, _ = 0, x = 0;
                if (null === (t = this.tap) || void 0 === t ? void 0 : t.length) c(i.getModifierStartXY(tt.Position.CENTER, this.index).x, this.tap);
                for(let t = 0; t < this.phrase.length; ++t){
                    const e = this.phrase[t];
                    e.draw_width || (e.draw_width = 0), 0 === t && (e.draw_width += a), x = e.draw_width + _ - (1 === t ? a : 0), e.type === Nt.UP && (d && d.type === Nt.UP && m(b.x, l, 1), r(b.x, b.y, x, l)), e.type === Nt.DOWN && (d && d.type === Nt.UP && h(b.x, b.y, x, l), d && d.type === Nt.DOWN && (m(b.x, b.y, -1), h(b.x, b.y, x, l)), d || (x = e.draw_width, h(b.x, b.y, x, l))), c(b.x + x, e.text), d = e, _ = e.draw_width, d.x = b.x, b.x += x;
                }
                if (!d || null == d.x) throw new g("NoLastBendForBend", "Internal error.");
                d.type === Nt.UP ? m(d.x + x, l, 1) : d.type === Nt.DOWN && m(d.x + x, b.y, -1);
            }
        }
        function Ft(...t) {
            Mt.DEBUG && u("Vex.Flow.ChordSymbol", t);
        }
        Nt.TEXT_FONT = Object.assign({}, R.TEXT_FONT), function(t) {
            t[t.LEFT = 1] = "LEFT", t[t.CENTER = 2] = "CENTER", t[t.RIGHT = 3] = "RIGHT", t[t.CENTER_STEM = 4] = "CENTER_STEM";
        }(Bt || (Bt = {})), function(t) {
            t[t.TOP = 1] = "TOP", t[t.BOTTOM = 2] = "BOTTOM";
        }(Dt || (Dt = {})), function(t) {
            t[t.GLYPH = 1] = "GLYPH", t[t.TEXT = 2] = "TEXT", t[t.LINE = 3] = "LINE";
        }(Ct || (Ct = {})), function(t) {
            t[t.NONE = 1] = "NONE", t[t.SUBSCRIPT = 2] = "SUBSCRIPT", t[t.SUPERSCRIPT = 3] = "SUPERSCRIPT";
        }(Et || (Et = {}));
        class Mt extends tt {
            static get CATEGORY() {
                return x.ChordSymbol;
            }
            static get superSubRatio() {
                return Mt.metrics.global.superSubRatio;
            }
            static set NO_TEXT_FORMAT(t) {
                Mt.noFormat = t;
            }
            static get NO_TEXT_FORMAT() {
                return Mt.noFormat;
            }
            static getMetricForGlyph(t) {
                if (Mt.metrics.glyphs[t]) return Mt.metrics.glyphs[t];
            }
            static get engravingFontResolution() {
                return V.currentMusicFont().getResolution();
            }
            static get spacingBetweenBlocks() {
                return Mt.metrics.global.spacing / Mt.engravingFontResolution;
            }
            static getWidthForGlyph(t) {
                const e = Mt.getMetricForGlyph(t.code);
                return e ? e.advanceWidth / Mt.engravingFontResolution : .65;
            }
            static getYShiftForGlyph(t) {
                const e = Mt.getMetricForGlyph(t.code);
                return e ? e.yOffset / Mt.engravingFontResolution : 0;
            }
            static getXShiftForGlyph(t) {
                const e = Mt.getMetricForGlyph(t.code);
                return e ? -1 * e.leftSideBearing / Mt.engravingFontResolution : 0;
            }
            static get superscriptOffset() {
                return Mt.metrics.global.superscriptOffset / Mt.engravingFontResolution;
            }
            static get subscriptOffset() {
                return Mt.metrics.global.subscriptOffset / Mt.engravingFontResolution;
            }
            static get kerningOffset() {
                return Mt.metrics.global.kerningOffset / Mt.engravingFontResolution;
            }
            static get metrics() {
                const t = V.currentMusicFont().getMetrics().chordSymbol;
                if (!t) throw new g("BadMetrics", "chordSymbol missing");
                return t;
            }
            static get lowerKerningText() {
                return Mt.metrics.global.lowerKerningText;
            }
            static get upperKerningText() {
                return Mt.metrics.global.upperKerningText;
            }
            static isSuperscript(t) {
                return void 0 !== t.symbolModifier && t.symbolModifier === Et.SUPERSCRIPT;
            }
            static isSubscript(t) {
                return void 0 !== t.symbolModifier && t.symbolModifier === Et.SUBSCRIPT;
            }
            static get minPadding() {
                return V.currentMusicFont().lookupMetric("noteHead.minPadding");
            }
            static format(t, e) {
                var i;
                if (!t || 0 === t.length) return !1;
                let b = 0, a = 0, n = 0, s = 0, l = 0, o = 0;
                for (const r of t){
                    const t = F.convertSizeToPointValue(null === (i = r.textFont) || void 0 === i ? void 0 : i.size), h = F.scaleSize(t, .05), m = 2 * h, c = r.checkAttachedNote();
                    let _ = 0, x = 1, g = !1;
                    for(let t = 0; t < r.symbolBlocks.length; ++t){
                        const e = r.symbolBlocks[t], i = Mt.isSuperscript(e), n = Mt.isSubscript(e), s = i || n ? Mt.superSubRatio : 1, l = e.symbolType === Ct.GLYPH ? m * s : h * s;
                        (i || n) && (x = 2);
                        const o = r.textFormatter.fontSizeInPixels, c = o * s;
                        if (e.symbolType === Ct.GLYPH && void 0 !== e.glyph ? (e.width = Mt.getWidthForGlyph(e.glyph) * c, e.yShift += Mt.getYShiftForGlyph(e.glyph) * c, e.xShift += Mt.getXShiftForGlyph(e.glyph) * c, e.glyph.scale = e.glyph.scale * l) : e.symbolType === Ct.TEXT && (e.width = e.width * c, e.yShift += r.getYOffsetForText(e.text) * l), e.symbolType === Ct.GLYPH && void 0 !== e.glyph && e.glyph.code === Mt.glyphs.over.code && (x = 2), e.width += Mt.spacingBetweenBlocks * o * s, i && t > 0) {
                            const e = r.symbolBlocks[t - 1];
                            Mt.isSuperscript(e) || (a = b);
                        }
                        n && a > 0 && (g = !0, e.xShift = e.xShift + (a - b), b = a, a = 0, r.setEnableKerning(!1)), i || n || (a = 0), e.vAlign = g, b += e.width, _ = b;
                    }
                    if (r.updateKerningAdjustments(), r.updateOverBarAdjustments(), r.getVertical() === Dt.TOP ? (r.setTextLine(e.top_text_line), e.top_text_line += x) : (r.setTextLine(e.text_line + 1), e.text_line += x + 1), r.getReportWidth() && d(c)) {
                        const t = c.getGlyphProps().getWidth();
                        r.getHorizontal() === Bt.LEFT ? (l = Math.max(t, l), n = Math.max(n, _) + Mt.minPadding) : r.getHorizontal() === Bt.RIGHT ? (o = Math.max(t, o), s = Math.max(s, _)) : (n = Math.max(n, _ / 2) + Mt.minPadding, s = Math.max(s, _ / 2), l = Math.max(t / 2, l), o = Math.max(t / 2, o));
                    }
                    b = 0;
                }
                const r = Math.min(Math.max(s - o, 0), Math.max(s - e.right_shift, 0)), h = Math.min(Math.max(n - l, 0), Math.max(n - e.left_shift, 0));
                return e.left_shift += h, e.right_shift += r, !0;
            }
            constructor(){
                super(), this.symbolBlocks = [], this.horizontal = Bt.LEFT, this.vertical = Dt.TOP, this.useKerning = !0, this.reportWidth = !0, this.resetFont();
            }
            static get TEXT_FONT() {
                let t = "Roboto Slab, Times, serif";
                return "Petaluma" === V.currentMusicFont().getName() && (t = "PetalumaScript, Arial, sans-serif"), {
                    family: t,
                    size: 12,
                    weight: E.NORMAL,
                    style: P.NORMAL
                };
            }
            get superscriptOffset() {
                return Mt.superscriptOffset * this.textFormatter.fontSizeInPixels;
            }
            get subscriptOffset() {
                return Mt.subscriptOffset * this.textFormatter.fontSizeInPixels;
            }
            setReportWidth(t) {
                return this.reportWidth = t, this;
            }
            getReportWidth() {
                return this.reportWidth;
            }
            updateOverBarAdjustments() {
                const t = this.symbolBlocks.findIndex(({ symbolType: t, glyph: e })=>t === Ct.GLYPH && void 0 !== e && "csymDiagonalArrangementSlash" === e.code);
                if (t < 0) return;
                const e = this.symbolBlocks[t].width / 4, i = .25 * this.textFormatter.fontSizeInPixels;
                let b = 0;
                for(; b < t; ++b){
                    const t = this.symbolBlocks[b];
                    t.xShift = t.xShift + e, t.yShift = t.yShift - i;
                }
                for(b = t + 1; b < this.symbolBlocks.length; ++b){
                    const t = this.symbolBlocks[b];
                    t.xShift = t.xShift - e, t.yShift = t.yShift + i;
                }
            }
            updateKerningAdjustments() {
                let t = 0;
                for(let e = 0; e < this.symbolBlocks.length; ++e){
                    const i = this.symbolBlocks[e];
                    t += this.getKerningAdjustment(e), i.xShift += t;
                }
            }
            getKerningAdjustment(t) {
                if (!this.useKerning) return 0;
                const e = this.symbolBlocks[t], i = t > 0 ? this.symbolBlocks[t - 1] : void 0;
                let b = 0;
                e.symbolType === Ct.GLYPH && void 0 !== e.glyph && e.glyph.code === Mt.glyphs.over.code && (b += e.glyph.metrics.x_shift), void 0 !== i && i.symbolType === Ct.GLYPH && void 0 !== i.glyph && i.glyph.code === Mt.glyphs.over.code && (b += i.glyph.metrics.x_shift);
                let a = !1, n = !1;
                void 0 !== i && i.symbolType === Ct.TEXT && (a = Mt.upperKerningText.some((t)=>t === i.text[i.text.length - 1]), n = Mt.lowerKerningText.some((t)=>t === i.text[i.text.length - 1]));
                const s = Mt.kerningOffset * this.textFormatter.fontSizeInPixels;
                return a && e.symbolModifier === Et.SUPERSCRIPT && (b += s), n && e.symbolType === Ct.TEXT && (e.text[0] >= "a" && e.text[0] <= "z" && (b += s / 2), Mt.upperKerningText.some((t)=>t === (null == i ? void 0 : i.text[i.text.length - 1])) && (b += s / 2)), b;
            }
            getSymbolBlock(t = {}) {
                var e, i, b;
                const a = null !== (e = t.symbolType) && void 0 !== e ? e : Ct.TEXT, n = {
                    text: null !== (i = t.text) && void 0 !== i ? i : "",
                    symbolType: a,
                    symbolModifier: null !== (b = t.symbolModifier) && void 0 !== b ? b : Et.NONE,
                    xShift: 0,
                    yShift: 0,
                    vAlign: !1,
                    width: 0
                };
                if (a === Ct.GLYPH && "string" == typeof t.glyph) {
                    const e = Mt.glyphs[t.glyph], i = 20;
                    n.glyph = new Z(e.code, i, {
                        category: "chordSymbol"
                    });
                } else a === Ct.TEXT ? n.width = this.textFormatter.getWidthForTextInEm(n.text) : a === Ct.LINE && (n.width = t.width);
                return n;
            }
            addSymbolBlock(t) {
                return this.symbolBlocks.push(this.getSymbolBlock(t)), this;
            }
            addText(t, e = {}) {
                const i = Ct.TEXT;
                return this.addSymbolBlock(Object.assign(Object.assign({}, e), {
                    text: t,
                    symbolType: i
                }));
            }
            addTextSuperscript(t) {
                const e = Ct.TEXT, i = Et.SUPERSCRIPT;
                return this.addSymbolBlock({
                    text: t,
                    symbolType: e,
                    symbolModifier: i
                });
            }
            addTextSubscript(t) {
                const e = Ct.TEXT, i = Et.SUBSCRIPT;
                return this.addSymbolBlock({
                    text: t,
                    symbolType: e,
                    symbolModifier: i
                });
            }
            addGlyphSuperscript(t) {
                const e = Ct.GLYPH, i = Et.SUPERSCRIPT;
                return this.addSymbolBlock({
                    glyph: t,
                    symbolType: e,
                    symbolModifier: i
                });
            }
            addGlyph(t, e = {}) {
                const i = Ct.GLYPH;
                return this.addSymbolBlock(Object.assign(Object.assign({}, e), {
                    glyph: t,
                    symbolType: i
                }));
            }
            addGlyphOrText(t, e = {}) {
                let i = "";
                for(let b = 0; b < t.length; ++b){
                    const a = t[b];
                    Mt.glyphs[a] ? (i.length > 0 && (this.addText(i, e), i = ""), this.addGlyph(a, e)) : i += a;
                }
                return i.length > 0 && this.addText(i, e), this;
            }
            addLine(t, e = {}) {
                const i = Ct.LINE;
                return this.addSymbolBlock(Object.assign(Object.assign({}, e), {
                    symbolType: i,
                    width: t
                }));
            }
            setFont(t, e, i, b) {
                return super.setFont(t, e, i, b), this.textFormatter = rt.create(this.textFont), this;
            }
            setEnableKerning(t) {
                return this.useKerning = t, this;
            }
            setVertical(t) {
                return this.vertical = "string" == typeof t ? Mt.VerticalJustifyString[t] : t, this;
            }
            getVertical() {
                return this.vertical;
            }
            setHorizontal(t) {
                return this.horizontal = "string" == typeof t ? Mt.HorizontalJustifyString[t] : t, this;
            }
            getHorizontal() {
                return this.horizontal;
            }
            getWidth() {
                let t = 0;
                return this.symbolBlocks.forEach((e)=>{
                    t += e.vAlign ? 0 : e.width;
                }), t;
            }
            getYOffsetForText(t) {
                var e;
                let i = 0, b = 0;
                for(b = 0; b < t.length; ++b){
                    const a = this.textFormatter.getGlyphMetrics(t[b]);
                    if (a) {
                        const t = null !== (e = a.y_max) && void 0 !== e ? e : 0;
                        i = t < i ? t : i;
                    }
                }
                const a = this.textFormatter.getResolution();
                return b > 0 ? i / a * -1 : 0;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered(), t.save(), this.applyStyle(), t.openGroup("chordsymbol", this.getAttribute("id"));
                const i = e.getModifierStartXY(tt.Position.ABOVE, this.index);
                let b;
                t.setFont(this.textFont);
                const a = e.hasStem(), n = e.checkStave();
                if (this.vertical === Dt.BOTTOM) {
                    if (b = n.getYForBottomText(this.text_line + V.TEXT_HEIGHT_OFFSET_HACK), a) {
                        const t = e.checkStem().getExtents(), i = n.getSpacingBetweenLines(), a = 1 === e.getStemDirection() ? t.baseY : t.topY;
                        b = Math.max(b, a + i * (this.text_line + 2));
                    }
                } else {
                    const t = Math.min(...e.getYs());
                    if (b = Math.min(n.getYForTopText(this.text_line), t - 10), a) {
                        const t = e.checkStem().getExtents(), i = n.getSpacingBetweenLines();
                        b = Math.min(b, t.topY - 5 - i * this.text_line);
                    }
                }
                let s = i.x;
                s = this.horizontal === Bt.LEFT ? i.x : this.horizontal === Bt.RIGHT ? i.x + this.getWidth() : this.horizontal === Bt.CENTER ? i.x - this.getWidth() / 2 : e.getStemX() - this.getWidth() / 2, Ft("Rendering ChordSymbol: ", this.textFormatter, s, b), this.symbolBlocks.forEach((e)=>{
                    const i = Mt.isSuperscript(e), a = Mt.isSubscript(e);
                    let n = b;
                    if (Ft("shift was ", e.xShift, e.yShift), Ft("curY pre sub ", n), i && (n += this.superscriptOffset), a && (n += this.subscriptOffset), Ft("curY sup/sub ", n), e.symbolType === Ct.TEXT) {
                        if ((i || a) && (t.save(), this.textFont)) {
                            const { family: e, size: i, weight: b, style: a } = this.textFont, n = F.scaleSize(i, Mt.superSubRatio);
                            t.setFont(e, n, b, a);
                        }
                        Ft("Rendering Text: ", e.text, s + e.xShift, n + e.yShift), t.fillText(e.text, s + e.xShift, n + e.yShift), (i || a) && t.restore();
                    } else e.symbolType === Ct.GLYPH && e.glyph ? (n += e.yShift, Ft("Rendering Glyph: ", e.glyph.code, s + e.xShift, n), e.glyph.render(t, s + e.xShift, n)) : e.symbolType === Ct.LINE && (Ft("Rendering Line : ", e.width, s, n), t.beginPath(), t.setLineWidth(1), t.moveTo(s, b), t.lineTo(s + e.width, n), t.stroke());
                    s += e.width, e.vAlign && (s += e.xShift);
                }), t.closeGroup(), this.restoreStyle(), t.restore();
            }
        }
        Mt.DEBUG = !1, Mt.HorizontalJustify = Bt, Mt.HorizontalJustifyString = {
            left: Bt.LEFT,
            right: Bt.RIGHT,
            center: Bt.CENTER,
            centerStem: Bt.CENTER_STEM
        }, Mt.VerticalJustify = Dt, Mt.VerticalJustifyString = {
            top: Dt.TOP,
            above: Dt.TOP,
            below: Dt.BOTTOM,
            bottom: Dt.BOTTOM
        }, Mt.glyphs = {
            diminished: {
                code: "csymDiminished"
            },
            dim: {
                code: "csymDiminished"
            },
            halfDiminished: {
                code: "csymHalfDiminished"
            },
            "+": {
                code: "csymAugmented"
            },
            augmented: {
                code: "csymAugmented"
            },
            majorSeventh: {
                code: "csymMajorSeventh"
            },
            minor: {
                code: "csymMinor"
            },
            "-": {
                code: "csymMinor"
            },
            "(": {
                code: "csymParensLeftTall"
            },
            leftParen: {
                code: "csymParensLeftTall"
            },
            ")": {
                code: "csymParensRightTall"
            },
            rightParen: {
                code: "csymParensRightTall"
            },
            leftBracket: {
                code: "csymBracketLeftTall"
            },
            rightBracket: {
                code: "csymBracketRightTall"
            },
            leftParenTall: {
                code: "csymParensLeftVeryTall"
            },
            rightParenTall: {
                code: "csymParensRightVeryTall"
            },
            "/": {
                code: "csymDiagonalArrangementSlash"
            },
            over: {
                code: "csymDiagonalArrangementSlash"
            },
            "#": {
                code: "accidentalSharp"
            },
            b: {
                code: "accidentalFlat"
            }
        }, Mt.symbolTypes = Ct, Mt.symbolModifiers = Et, Mt.noFormat = !1;
        class Ot extends tt {
            static get CATEGORY() {
                return x.Dot;
            }
            static getDots(t) {
                return t.getModifiersByType(Ot.CATEGORY);
            }
            static buildAndAttach(t, e) {
                for (const i of t)if (null == e ? void 0 : e.all) for(let t = 0; t < i.keys.length; t++){
                    const e = new Ot;
                    e.setDotShiftY(i.glyphProps.dot_shiftY), i.addModifier(e, t);
                }
                else if (null != (null == e ? void 0 : e.index)) {
                    const t = new Ot;
                    t.setDotShiftY(i.glyphProps.dot_shiftY), i.addModifier(t, null == e ? void 0 : e.index);
                } else {
                    const t = new Ot;
                    t.setDotShiftY(i.glyphProps.dot_shiftY), i.addModifier(t, 0);
                }
            }
            static format(t, e) {
                const i = e.right_shift;
                if (!t || 0 === t.length) return !1;
                const b = [], a = {};
                for(let e = 0; e < t.length; ++e){
                    const n = t[e], s = n.getNote();
                    let l, o;
                    if (c(s)) {
                        const t = n.checkIndex();
                        l = s.getKeyProps()[t], o = s.getFirstDotPx();
                    } else {
                        if (!_(s)) throw new g("Internal", "Unexpected instance.");
                        l = {
                            line: .5
                        }, o = i;
                    }
                    const r = s.getAttribute("id");
                    b.push({
                        line: l.line,
                        note: s,
                        note_id: r,
                        dot: n
                    }), a[r] = Math.max(a[r] || o, o);
                }
                b.sort((t, e)=>e.line - t.line);
                let n = i, s = 0, l = null, o = null, r = null, h = 0;
                for(let t = 0; t < b.length; ++t){
                    const { dot: e, note: i, note_id: m, line: c } = b[t];
                    c === l && i === o || (n = a[m]), i.isRest() || c === l || (.5 === Math.abs(c % 1) ? h = 0 : (h = .5, null == o || o.isRest() || null == l || l - c != .5 ? c + h === r && (h = -0.5) : h = -0.5)), i.isRest() ? e.dot_shiftY += -h : e.dot_shiftY = -h, r = c + h, e.setXShift(n), n += e.getWidth() + 1, s = n > s ? n : s, l = c, o = i;
                }
                return e.right_shift += s, !0;
            }
            constructor(){
                super(), this.position = tt.Position.RIGHT, this.radius = 2, this.setWidth(5), this.dot_shiftY = 0;
            }
            setNote(t) {
                return this.note = t, o(t) && (this.radius *= .5, this.setWidth(3)), this;
            }
            setDotShiftY(t) {
                return this.dot_shiftY = t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.checkStave().getSpacingBetweenLines(), b = e.getModifierStartXY(this.position, this.index, {
                    forceFlagRight: !0
                });
                _(e) && (b.y = e.getStemExtents().baseY);
                const a = b.x + this.x_shift + this.width - this.radius, n = b.y + this.y_shift + this.dot_shiftY * i;
                t.beginPath(), t.arc(a, n, this.radius, 0, 2 * Math.PI, !1), t.fill();
            }
        }
        class Rt extends tt {
            static get CATEGORY() {
                return x.FretHandFinger;
            }
            static format(t, e) {
                const { left_shift: i, right_shift: b } = e;
                if (!t || 0 === t.length) return !1;
                const a = [];
                let n = null, s = 0, l = 0;
                for(let o = 0; o < t.length; ++o){
                    const r = t[o], h = r.getNote(), m = r.getPosition(), c = r.checkIndex(), d = h.getKeyProps()[c], _ = rt.create(r.textFont).maxHeight;
                    if (r.position === J.ABOVE && (e.top_text_line += _ / V.STAVE_LINE_DISTANCE + .5), r.position === J.BELOW && (e.text_line += _ / V.STAVE_LINE_DISTANCE + .5), h !== n) {
                        for(let t = 0; t < h.keys.length; ++t)0 === i && (s = Math.max(h.getLeftDisplacedHeadPx(), s)), 0 === b && (l = Math.max(h.getRightDisplacedHeadPx(), l));
                        n = h;
                    }
                    a.push({
                        note: h,
                        num: r,
                        pos: m,
                        line: d.line,
                        shiftL: s,
                        shiftR: l
                    });
                }
                a.sort((t, e)=>e.line - t.line);
                let o = 0, r = 0, h = 0, m = 0, c = null, d = null;
                for(let t = 0; t < a.length; ++t){
                    let e = 0;
                    const { note: n, pos: s, num: _, line: x, shiftL: g, shiftR: y } = a[t];
                    x === c && n === d || (o = i + g, r = b + y);
                    const p = _.getWidth() + 1;
                    s === tt.Position.LEFT ? (_.setXShift(i + o), e = i + p, h = e > h ? e : h) : s === tt.Position.RIGHT && (_.setXShift(r), e = l + p, m = e > m ? e : m), c = x, d = n;
                }
                return e.left_shift += h, e.right_shift += m, !0;
            }
            static easyScoreHook({ fingerings: t } = {}, e, i) {
                null == t || t.split(",").map((t)=>{
                    const e = t.trim().split("."), b = {
                        number: e[0]
                    };
                    return e[1] && (b.position = e[1]), i.getFactory().Fingering(b);
                }).map((t, i)=>e.addModifier(t, i));
            }
            constructor(t){
                super(), this.finger = t, this.width = 7, this.position = tt.Position.LEFT, this.x_shift = 0, this.y_shift = 0, this.x_offset = 0, this.y_offset = 0, this.resetFont();
            }
            setFretHandFinger(t) {
                return this.finger = t, this;
            }
            getFretHandFinger() {
                return this.finger;
            }
            setOffsetX(t) {
                return this.x_offset = t, this;
            }
            setOffsetY(t) {
                return this.y_offset = t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getModifierStartXY(this.position, this.index);
                let b = i.x + this.x_shift + this.x_offset, a = i.y + this.y_shift + this.y_offset + 5;
                switch(this.position){
                    case tt.Position.ABOVE:
                        b -= 4, a -= 12;
                        break;
                    case tt.Position.BELOW:
                        b -= 2, a += 10;
                        break;
                    case tt.Position.LEFT:
                        b -= this.width;
                        break;
                    case tt.Position.RIGHT:
                        b += 1;
                        break;
                    default:
                        throw new g("InvalidPosition", `The position ${this.position} does not exist`);
                }
                t.save(), t.setFont(this.textFont), t.fillText("" + this.finger, b, a), t.restore();
            }
        }
        Rt.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: 9,
            weight: E.BOLD,
            style: P.NORMAL
        };
        class Lt extends vt {
            static get CATEGORY() {
                return x.NoteHead;
            }
            constructor(t){
                super(t), this.custom_glyph = !1, this.stem_up_x_offset = 0, this.stem_down_x_offset = 0, this.index = t.index, this.x = t.x || 0, this.y = t.y || 0, t.note_type && (this.noteType = t.note_type), this.displaced = t.displaced || !1, this.stem_direction = t.stem_direction || at.UP, this.line = t.line || 0, this.glyphProps = V.getGlyphProps(this.duration, this.noteType), p(this.glyphProps, "BadArguments", `No glyph found for duration '${this.duration}' and type '${this.noteType}'`), (this.line > 5 || this.line < 0) && this.glyphProps.ledger_code_head && (this.glyphProps.code_head = this.glyphProps.ledger_code_head), this.glyph_code = this.glyphProps.code_head, this.x_shift = t.x_shift || 0, t.custom_glyph_code && (this.custom_glyph = !0, this.glyph_code = t.custom_glyph_code, this.stem_up_x_offset = t.stem_up_x_offset || 0, this.stem_down_x_offset = t.stem_down_x_offset || 0), this.setStyle(t.style), this.slashed = t.slashed || !1, this.render_options = Object.assign(Object.assign({}, this.render_options), {
                    glyph_font_scale: t.glyph_font_scale || V.NOTATION_FONT_SCALE
                }), this.setWidth(!this.custom_glyph || this.glyph_code.startsWith("noteheadSlashed") || this.glyph_code.startsWith("noteheadCircled") ? this.glyphProps.getWidth(this.render_options.glyph_font_scale) : Z.getWidth(this.glyph_code, this.render_options.glyph_font_scale));
            }
            getWidth() {
                return this.width;
            }
            isDisplaced() {
                return !0 === this.displaced;
            }
            setX(t) {
                return this.x = t, this;
            }
            getY() {
                return this.y;
            }
            setY(t) {
                return this.y = t, this;
            }
            getLine() {
                return this.line;
            }
            setLine(t) {
                return this.line = t, this;
            }
            getAbsoluteX() {
                const t = this.preFormatted ? super.getAbsoluteX() : this.x, e = at.WIDTH / 2, i = V.currentMusicFont(), b = i.lookupMetric("notehead.shiftX", 0) * this.stem_direction, a = i.lookupMetric("noteHead.displacedShiftX", 0) * this.stem_direction;
                return t + b + (this.displaced ? (this.width - e) * this.stem_direction + a : 0);
            }
            getBoundingBox() {
                const t = this.checkStave().getSpacingBetweenLines(), e = t / 2, i = this.y - e;
                return new D(this.getAbsoluteX(), i, this.width, t);
            }
            setStave(t) {
                const e = this.getLine();
                return this.stave = t, this.stave && (this.setY(this.stave.getYForNote(e)), this.setContext(this.stave.getContext())), this;
            }
            preFormat() {
                if (this.preFormatted) return this;
                const t = this.getWidth() + this.leftDisplacedHeadPx + this.rightDisplacedHeadPx;
                return this.setWidth(t), this.preFormatted = !0, this;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                let e = this.getAbsoluteX();
                this.custom_glyph && (e += this.stem_direction === at.UP ? this.stem_up_x_offset + (this.glyphProps.stem ? this.glyphProps.getWidth(this.render_options.glyph_font_scale) - this.width : 0) : this.stem_down_x_offset);
                const i = this.y;
                !function(...t) {
                    Lt.DEBUG && u("Vex.Flow.NoteHead", t);
                }("Drawing note head '", this.noteType, this.duration, "' at", e, i);
                const b = this.stem_direction, a = this.render_options.glyph_font_scale, n = `${this.glyph_code}Stem${b === at.UP ? "Up" : "Down"}`;
                if ("s" === this.noteType) {
                    const a = this.checkStave().getSpacingBetweenLines();
                    !function(t, e, i, b, a, n) {
                        const s = V.SLASH_NOTEHEAD_WIDTH;
                        t.save(), t.setLineWidth(V.STEM_WIDTH);
                        let l = !1;
                        if (V.durationToNumber(e) > 2 && (l = !0), l || (i -= V.STEM_WIDTH / 2 * a), t.beginPath(), t.moveTo(i, b + n), t.lineTo(i, b + 1), t.lineTo(i + s, b - n), t.lineTo(i + s, b), t.lineTo(i, b + n), t.closePath(), l ? t.fill() : t.stroke(), V.durationToFraction(e).equals(.5)) {
                            const e = [
                                -3,
                                -1,
                                s + 1,
                                s + 3
                            ];
                            for(let a = 0; a < e.length; a++)t.beginPath(), t.moveTo(i + e[a], b - 10), t.lineTo(i + e[a], b + 11), t.stroke();
                        }
                        t.restore();
                    }(t, this.duration, e, i, b, a);
                } else Z.renderGlyph(t, e, i, a, this.glyph_code, {
                    category: `noteHead.${n}`
                });
            }
        }
        Lt.DEBUG = !1;
        class Wt extends vt {
            static get CATEGORY() {
                return x.StemmableNote;
            }
            constructor(t){
                super(t);
            }
            getStem() {
                return this.stem;
            }
            checkStem() {
                if (!this.stem) throw new g("NoStem", "No stem attached to instance");
                return this.stem;
            }
            setStem(t) {
                return this.stem = t, this.addChildElement(t), this;
            }
            buildStem() {
                const t = new at;
                return this.setStem(t), this;
            }
            buildFlag(t = "flag") {
                const { glyphProps: e } = this;
                if (this.hasFlag()) {
                    const i = this.getStemDirection() === at.DOWN ? e.code_flag_downstem : e.code_flag_upstem;
                    i && (this.flag = new Z(i, this.render_options.glyph_font_scale, {
                        category: t
                    }));
                }
            }
            getBaseCustomNoteHeadGlyphProps() {
                return this.getStemDirection() === at.DOWN ? this.customGlyphs[this.customGlyphs.length - 1] : this.customGlyphs[0];
            }
            getStemLength() {
                return at.HEIGHT + this.getStemExtension();
            }
            getBeamCount() {
                const t = this.getGlyphProps();
                return t ? t.beam_count : 0;
            }
            getStemMinimumLength() {
                let t = V.durationToFraction(this.duration).value() <= 1 ? 0 : 20;
                switch(this.duration){
                    case "8":
                        null == this.beam && (t = 35);
                        break;
                    case "16":
                        t = null == this.beam ? 35 : 25;
                        break;
                    case "32":
                        t = null == this.beam ? 45 : 35;
                        break;
                    case "64":
                        t = null == this.beam ? 50 : 40;
                        break;
                    case "128":
                        t = null == this.beam ? 55 : 45;
                }
                return t;
            }
            getStemDirection() {
                if (!this.stem_direction) throw new g("NoStem", "No stem attached to this note.");
                return this.stem_direction;
            }
            setStemDirection(t) {
                if (t || (t = at.UP), t !== at.UP && t !== at.DOWN) throw new g("BadArgument", `Invalid stem direction: ${t}`);
                if (this.stem_direction = t, this.reset(), this.hasFlag() && this.buildFlag(), this.beam = void 0, this.stem) {
                    this.stem.setDirection(t), this.stem.setExtension(this.getStemExtension());
                    const e = this.getBaseCustomNoteHeadGlyphProps() || this.getGlyphProps(), i = V.currentMusicFont().lookupMetric(`stem.noteHead.${e.code_head}`, {
                        offsetYBaseStemUp: 0,
                        offsetYTopStemUp: 0,
                        offsetYBaseStemDown: 0,
                        offsetYTopStemDown: 0
                    });
                    this.stem.setOptions({
                        stem_up_y_offset: i.offsetYTopStemUp,
                        stem_down_y_offset: i.offsetYTopStemDown,
                        stem_up_y_base_offset: i.offsetYBaseStemUp,
                        stem_down_y_base_offset: i.offsetYBaseStemDown
                    });
                }
                return this.preFormatted && this.preFormat(), this;
            }
            getStemX() {
                const t = this.getAbsoluteX() + this.x_shift, e = this.getAbsoluteX() + this.x_shift + this.getGlyphWidth();
                return this.stem_direction === at.DOWN ? t : e;
            }
            getCenterGlyphX() {
                return this.getAbsoluteX() + this.x_shift + this.getGlyphWidth() / 2;
            }
            getStemExtension() {
                const t = this.getGlyphProps();
                return null != this.stem_extension_override ? this.stem_extension_override : this.beam ? t.stem_beam_extension : t ? this.getStemDirection() === at.UP ? t.stem_up_extension : t.stem_down_extension : 0;
            }
            setStemLength(t) {
                return this.stem_extension_override = t - at.HEIGHT, this;
            }
            getStemExtents() {
                if (!this.stem) throw new g("NoStem", "No stem attached to this note.");
                return this.stem.getExtents();
            }
            getYForTopText(t) {
                const e = this.checkStave();
                if (this.hasStem()) {
                    const i = this.getStemExtents();
                    if (!i) throw new g("InvalidState", "Stem does not have extents.");
                    return Math.min(e.getYForTopText(t), i.topY - this.render_options.annotation_spacing * (t + 1));
                }
                return e.getYForTopText(t);
            }
            getYForBottomText(t) {
                const e = this.checkStave();
                if (this.hasStem()) {
                    const i = this.getStemExtents();
                    if (!i) throw new g("InvalidState", "Stem does not have extents.");
                    return Math.max(e.getYForTopText(t), i.baseY + this.render_options.annotation_spacing * t);
                }
                return e.getYForBottomText(t);
            }
            hasFlag() {
                return 1 == V.getGlyphProps(this.duration).flag && !this.beam;
            }
            postFormat() {
                var t;
                return null === (t = this.beam) || void 0 === t || t.postFormat(), this.postFormatted = !0, this;
            }
            drawStem(t) {
                var e;
                this.checkContext(), this.setRendered(), this.setStem(new at(t)), null === (e = this.stem) || void 0 === e || e.setContext(this.getContext()).draw();
            }
        }
        function Ut(t, e, i) {
            const b = i;
            t.line += b, t.maxLine += b, t.minLine += b, t.note.setKeyLine(0, t.note.getKeyLine(0) + b);
        }
        class It extends Wt {
            static get CATEGORY() {
                return x.StaveNote;
            }
            static get STEM_UP() {
                return at.UP;
            }
            static get STEM_DOWN() {
                return at.DOWN;
            }
            static get LEDGER_LINE_OFFSET() {
                return 3;
            }
            static get minNoteheadPadding() {
                return V.currentMusicFont().lookupMetric("noteHead.minPadding");
            }
            static format(t, e) {
                var i, b;
                if (!t || t.length < 2) return !1;
                const a = [];
                for(let e = 0; e < t.length; e++){
                    const i = t[e].sortedKeyProps, b = i[0].keyProps.line;
                    let n = i[i.length - 1].keyProps.line;
                    const s = t[e].getStemDirection(), l = t[e].getStemLength() / 10, o = t[e].getStemMinimumLength() / 10;
                    let r;
                    t[e].isRest() ? (r = b + t[e].glyphProps.line_above, n = b - t[e].glyphProps.line_below) : (r = 1 === s ? i[i.length - 1].keyProps.line + l : i[i.length - 1].keyProps.line, n = 1 === s ? i[0].keyProps.line : i[0].keyProps.line - l), a.push({
                        line: i[0].keyProps.line,
                        maxLine: r,
                        minLine: n,
                        isrest: t[e].isRest(),
                        stemDirection: s,
                        stemMax: l,
                        stemMin: o,
                        voice_shift: t[e].getVoiceShiftWidth(),
                        is_displaced: t[e].isDisplaced(),
                        note: t[e]
                    });
                }
                let n, s, l, o = 0;
                const r = [
                    !1,
                    !1,
                    !1
                ];
                for(let t = 0; t < a.length; t++)r[t] = 0 != a[t].note.render_options.draw;
                if (r[0] && r[1] && r[2]) o = 3, n = a[0], s = a[1], l = a[2];
                else if (r[0] && r[1]) o = 2, n = a[0], l = a[1];
                else if (r[0] && r[2]) o = 2, n = a[0], l = a[2];
                else {
                    if (!r[1] || !r[2]) return !0;
                    o = 2, n = a[1], l = a[2];
                }
                2 === o && -1 === n.stemDirection && 1 === l.stemDirection && (n = a[1], l = a[0]);
                const h = Math.max(n.voice_shift, l.voice_shift);
                let m = 0;
                if (2 === o) {
                    const t = n.note.hasStem() && l.note.hasStem() && n.stemDirection === l.stemDirection ? 0 : .5;
                    if (l.isrest && n.isrest && n.note.duration === l.note.duration) l.note.render_options.draw = !1;
                    else if (n.minLine <= l.maxLine + t) {
                        if (n.isrest) Ut(n, 0, 1);
                        else if (l.isrest) Ut(l, 0, -1);
                        else {
                            const t = Math.abs(n.line - l.line);
                            if (n.note.hasStem() && l.note.hasStem()) {
                                const e = V.codeNoteHead(null !== (i = n.note.sortedKeyProps[0].keyProps.code) && void 0 !== i ? i : "N", n.note.duration), a = V.codeNoteHead(null !== (b = l.note.sortedKeyProps[l.note.sortedKeyProps.length - 1].keyProps.code) && void 0 !== b ? b : "N", l.note.duration);
                                !V.UNISON || e !== a || n.note.getModifiers().filter((t)=>t.getCategory() === x.Dot && 0 === t.getIndex()).length !== l.note.getModifiers().filter((t)=>t.getCategory() === x.Dot && 0 === t.getIndex()).length || t < 1 && t > 0 || JSON.stringify(n.note.getStyle()) !== JSON.stringify(l.note.getStyle()) ? (m = h + 2, n.stemDirection === l.stemDirection ? n.note.setXShift(m) : l.note.setXShift(m)) : n.note.voice !== l.note.voice && n.stemDirection === l.stemDirection && (n.line != l.line ? (m = h + 2, n.note.setXShift(m)) : 1 === l.stemDirection && (l.stemDirection = -1, l.note.setStemDirection(-1)));
                            } else t < 1 ? (m = h + 2, n.note.duration < l.note.duration ? n.note.setXShift(m) : l.note.setXShift(m)) : n.note.hasStem() ? (n.stemDirection = -n.note.getStemDirection(), n.note.setStemDirection(n.stemDirection)) : l.note.hasStem() && (l.stemDirection = -l.note.getStemDirection(), l.note.setStemDirection(l.stemDirection));
                        }
                    }
                    return e.right_shift += m, !0;
                }
                if (!s) throw new g("InvalidState", "noteM not defined.");
                if (s.isrest && !n.isrest && !l.isrest && (n.minLine <= s.maxLine || s.minLine <= l.maxLine)) return s.maxLine - s.minLine < n.minLine - l.maxLine ? function(t, e, i) {
                    const b = t.line - S(e.minLine, i.maxLine);
                    t.note.setKeyLine(0, t.note.getKeyLine(0) - b), t.line -= b, t.maxLine -= b, t.minLine -= b;
                }(s, n, l) : (m = h + 2, s.note.setXShift(m), !1 === l.note.hasBeam() && (l.stemDirection = -1, l.note.setStemDirection(-1)), n.minLine <= l.maxLine && !1 === n.note.hasBeam() && (n.stemDirection = 1, n.note.setStemDirection(1))), e.right_shift += m, !0;
                return n.isrest && s.isrest && l.isrest ? (n.note.render_options.draw = !1, l.note.render_options.draw = !1, e.right_shift += m, !0) : (s.isrest && n.isrest && s.minLine <= l.maxLine && (s.note.render_options.draw = !1), s.isrest && l.isrest && n.minLine <= s.maxLine && (s.note.render_options.draw = !1), n.isrest && n.minLine <= s.maxLine && Ut(n, 0, 1), l.isrest && s.minLine <= l.maxLine && Ut(l, 0, -1), (n.minLine <= s.maxLine + .5 || s.minLine <= l.maxLine) && (m = h + 2, s.note.setXShift(m), !1 === l.note.hasBeam() && (l.stemDirection = -1, l.note.setStemDirection(-1)), n.minLine <= l.maxLine && !1 === n.note.hasBeam() && (n.stemDirection = 1, n.note.setStemDirection(1))), e.right_shift += m, !0);
            }
            static postFormat(t) {
                return !!t && (t.forEach((t)=>t.postFormat()), !0);
            }
            constructor(t){
                var e, i, b;
                super(t), this.minLine = 0, this.maxLine = 0, this.sortedKeyProps = [], this.ledgerLineStyle = {}, this.clef = null !== (e = t.clef) && void 0 !== e ? e : "treble", this.octave_shift = null !== (i = t.octave_shift) && void 0 !== i ? i : 0, this.glyphProps = V.getGlyphProps(this.duration, this.noteType), p(this.glyphProps, "BadArguments", `No glyph found for duration '${this.duration}' and type '${this.noteType}'`), this.displaced = !1, this.dot_shiftY = 0, this.use_default_head_x = !1, this._noteHeads = [], this.modifiers = [], this.render_options = Object.assign(Object.assign({}, this.render_options), {
                    glyph_font_scale: t.glyph_font_scale || V.NOTATION_FONT_SCALE,
                    stroke_px: t.stroke_px || It.LEDGER_LINE_OFFSET
                }), this.calculateKeyProps(), this.buildStem(), t.auto_stem ? this.autoStem() : this.setStemDirection(null !== (b = t.stem_direction) && void 0 !== b ? b : at.UP), this.reset(), this.buildFlag();
            }
            reset() {
                super.reset();
                const t = this._noteHeads.map((t)=>t.getStyle());
                this.buildNoteHeads(), this._noteHeads.forEach((e, i)=>{
                    const b = t[i];
                    b && e.setStyle(b);
                });
                const e = this.stave;
                return e && this.setStave(e), this.calcNoteDisplacements(), this;
            }
            setBeam(t) {
                return this.beam = t, this.calcNoteDisplacements(), this.stem && this.stem.setExtension(this.getStemExtension()), this;
            }
            buildStem() {
                return this.setStem(new at({
                    hide: !!this.isRest()
                })), this;
            }
            buildNoteHeads() {
                this._noteHeads = [];
                const t = this.getStemDirection(), e = this.getKeys();
                let i, b, a, n, s, l = !1;
                t === at.UP ? (a = 0, n = e.length, s = 1) : (a = e.length - 1, n = -1, s = -1);
                for(let e = a; e !== n; e += s){
                    const a = this.sortedKeyProps[e].keyProps, n = a.line;
                    void 0 === i ? i = n : (b = Math.abs(i - n), 0 === b || .5 === b ? l = !l : (l = !1, this.use_default_head_x = !0)), i = n;
                    const s = new Lt({
                        duration: this.duration,
                        note_type: this.noteType,
                        displaced: l,
                        stem_direction: t,
                        custom_glyph_code: a.code,
                        glyph_font_scale: this.render_options.glyph_font_scale,
                        x_shift: a.shift_right,
                        stem_up_x_offset: a.stem_up_x_offset,
                        stem_down_x_offset: a.stem_down_x_offset,
                        line: a.line
                    });
                    this.addChildElement(s), this._noteHeads[this.sortedKeyProps[e].index] = s;
                }
                return this._noteHeads;
            }
            autoStem() {
                this.setStemDirection(this.calculateOptimalStemDirection());
            }
            calculateOptimalStemDirection() {
                this.minLine = this.sortedKeyProps[0].keyProps.line, this.maxLine = this.sortedKeyProps[this.keyProps.length - 1].keyProps.line;
                return (this.minLine + this.maxLine) / 2 < 3 ? at.UP : at.DOWN;
            }
            calculateKeyProps() {
                let t;
                for(let e = 0; e < this.keys.length; ++e){
                    const i = this.keys[e];
                    this.glyphProps.rest && (this.glyphProps.position = i);
                    const b = {
                        octave_shift: this.octave_shift || 0,
                        duration: this.duration
                    }, a = V.keyProperties(i, this.clef, b);
                    if (!a) throw new g("BadArguments", `Invalid key for note properties: ${i}`);
                    "R" === a.key && ("1" === this.duration || "w" === this.duration ? a.line = 4 : a.line = 3);
                    const n = a.line;
                    null == t ? t = n : .5 === Math.abs(t - n) && (this.displaced = !0, a.displaced = !0, this.keyProps.length > 0 && (this.keyProps[e - 1].displaced = !0)), t = n, this.keyProps.push(a);
                }
                this.keyProps.forEach((t, e)=>{
                    this.sortedKeyProps.push({
                        keyProps: t,
                        index: e
                    });
                }), this.sortedKeyProps.sort((t, e)=>t.keyProps.line - e.keyProps.line);
            }
            getBoundingBox() {
                var t, e;
                if (!this.preFormatted) throw new g("UnformattedNote", "Can't call getBoundingBox on an unformatted note.");
                const { width: i, modLeftPx: b, leftDisplacedHeadPx: a } = this.getMetrics(), n = this.getAbsoluteX() - b - a;
                let s = 0, l = 0;
                const o = (null !== (e = null === (t = this.getStave()) || void 0 === t ? void 0 : t.getSpacingBetweenLines()) && void 0 !== e ? e : 0) / 2, r = 2 * o;
                if (this.isRest()) {
                    const t = this.ys[0], e = V.durationToFraction(this.duration);
                    e.equals(1) || e.equals(2) ? (s = t - o, l = t + o) : (s = t - this.glyphProps.line_above * r, l = t + this.glyphProps.line_below * r);
                } else if (this.glyphProps.stem) {
                    const t = this.getStemExtents();
                    t.baseY += o * this.getStemDirection(), s = Math.min(t.topY, t.baseY), l = Math.max(t.topY, t.baseY);
                } else {
                    s = 0, l = 0;
                    for(let t = 0; t < this.ys.length; ++t){
                        const e = this.ys[t];
                        0 === t ? (s = e, l = e) : (s = Math.min(e, s), l = Math.max(e, l));
                    }
                    s -= o, l += o;
                }
                return new D(n, s, i, l - s);
            }
            getLineNumber(t) {
                if (!this.keyProps.length) throw new g("NoKeyProps", "Can't get bottom note line, because note is not initialized properly.");
                let e = this.keyProps[0].line;
                for(let i = 0; i < this.keyProps.length; i++){
                    const b = this.keyProps[i].line;
                    t ? b > e && (e = b) : b < e && (e = b);
                }
                return e;
            }
            isRest() {
                return this.glyphProps.rest;
            }
            isChord() {
                return !this.isRest() && this.keys.length > 1;
            }
            hasStem() {
                return this.glyphProps.stem;
            }
            hasFlag() {
                return super.hasFlag() && !this.isRest();
            }
            getStemX() {
                return "r" === this.noteType ? this.getCenterGlyphX() : super.getStemX() + (this.stem_direction ? at.WIDTH / (2 * -this.stem_direction) : 0);
            }
            getYForTopText(t) {
                const e = this.getStemExtents();
                return Math.min(this.checkStave().getYForTopText(t), e.topY - this.render_options.annotation_spacing * (t + 1));
            }
            getYForBottomText(t) {
                const e = this.getStemExtents();
                return Math.max(this.checkStave().getYForTopText(t), e.baseY + this.render_options.annotation_spacing * t);
            }
            setStave(t) {
                super.setStave(t);
                const e = this._noteHeads.map((e)=>(e.setStave(t), e.getY()));
                if (this.setYs(e), this.stem) {
                    const { y_top: t, y_bottom: e } = this.getNoteHeadBounds();
                    this.stem.setYBounds(t, e);
                }
                return this;
            }
            isDisplaced() {
                return this.displaced;
            }
            setNoteDisplaced(t) {
                return this.displaced = t, this;
            }
            getTieRightX() {
                let t = this.getAbsoluteX();
                return t += this.getGlyphWidth() + this.x_shift + this.rightDisplacedHeadPx, this.modifierContext && (t += this.modifierContext.getRightShift()), t;
            }
            getTieLeftX() {
                let t = this.getAbsoluteX();
                return t += this.x_shift - this.leftDisplacedHeadPx, t;
            }
            getLineForRest() {
                let t = this.keyProps[0].line;
                if (this.keyProps.length > 1) {
                    const e = this.keyProps[this.keyProps.length - 1].line;
                    t = S(Math.max(t, e), Math.min(t, e));
                }
                return t;
            }
            getModifierStartXY(t, e, i = {}) {
                var b, a;
                if (!this.preFormatted) throw new g("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
                if (0 === this.ys.length) throw new g("NoYValues", "No Y-Values calculated for this note.");
                const { ABOVE: n, BELOW: s, LEFT: l, RIGHT: o } = tt.Position;
                let r = 0;
                return t === l ? r = -2 : t === o ? (r = this.getGlyphWidth() + this.x_shift + 2, this.stem_direction === at.UP && this.hasFlag() && (i.forceFlagRight || ((t, e)=>e === (t.getStemDirection() === at.UP ? t.keyProps.length - 1 : 0))(this, e)) && (r += null !== (a = null === (b = null == this ? void 0 : this.flag) || void 0 === b ? void 0 : b.getMetrics().width) && void 0 !== a ? a : 0)) : t !== s && t !== n || (r = this.getGlyphWidth() / 2), {
                    x: this.getAbsoluteX() + r,
                    y: this.ys[e]
                };
            }
            setStyle(t) {
                return super.setGroupStyle(t);
            }
            setStemStyle(t) {
                const e = this.getStem();
                return e && e.setStyle(t), this;
            }
            getStemStyle() {
                var t;
                return null === (t = this.stem) || void 0 === t ? void 0 : t.getStyle();
            }
            setLedgerLineStyle(t) {
                this.ledgerLineStyle = t;
            }
            getLedgerLineStyle() {
                return this.ledgerLineStyle;
            }
            setFlagStyle(t) {
                var e;
                null === (e = this.flag) || void 0 === e || e.setStyle(t);
            }
            getFlagStyle() {
                var t;
                return null === (t = this.flag) || void 0 === t ? void 0 : t.getStyle();
            }
            setKeyStyle(t, e) {
                return this._noteHeads[t].setStyle(e), this;
            }
            setKeyLine(t, e) {
                return this.keyProps[t].line = e, this.reset(), this;
            }
            getKeyLine(t) {
                return this.keyProps[t].line;
            }
            getVoiceShiftWidth() {
                return this.getGlyphWidth() * (this.displaced ? 2 : 1);
            }
            calcNoteDisplacements() {
                this.setLeftDisplacedHeadPx(this.displaced && this.stem_direction === at.DOWN ? this.getGlyphWidth() : 0), this.setRightDisplacedHeadPx(!this.hasFlag() && this.displaced && this.stem_direction === at.UP ? this.getGlyphWidth() : 0);
            }
            preFormat() {
                if (this.preFormatted) return;
                let t = 0;
                this.modifierContext && (this.modifierContext.preFormat(), 0 === this.modifierContext.getWidth() && (t = It.minNoteheadPadding));
                let e = this.getGlyphWidth() + this.leftDisplacedHeadPx + this.rightDisplacedHeadPx + t;
                this.shouldDrawFlag() && this.stem_direction === at.UP && (e += this.getGlyphWidth()), this.setWidth(e), this.preFormatted = !0;
            }
            getNoteHeadBounds() {
                let t, e, i, b, a = 1 / 0, n = -1 / 0, s = this.checkStave().getNumLines(), l = 1, o = s, r = l;
                return this._noteHeads.forEach((h)=>{
                    const m = h.getLine(), c = h.getY();
                    a = Math.min(c, a), n = Math.max(c, n), void 0 === e && h.isDisplaced() && (e = h.getAbsoluteX()), void 0 !== t || h.isDisplaced() || (t = h.getAbsoluteX()), s = Math.max(m, s), l = Math.min(m, l), h.isDisplaced() ? (i = void 0 === i ? m : Math.max(m, i), b = void 0 === b ? m : Math.min(m, b)) : (o = Math.max(m, o), r = Math.min(m, r));
                }, this), {
                    y_top: a,
                    y_bottom: n,
                    displaced_x: e,
                    non_displaced_x: t,
                    highest_line: s,
                    lowest_line: l,
                    highest_displaced_line: i,
                    lowest_displaced_line: b,
                    highest_non_displaced_line: o,
                    lowest_non_displaced_line: r
                };
            }
            getNoteHeadBeginX() {
                return this.getAbsoluteX() + this.x_shift;
            }
            getNoteHeadEndX() {
                return this.getNoteHeadBeginX() + this.getGlyphWidth();
            }
            get noteHeads() {
                return this._noteHeads.slice();
            }
            get note_heads() {
                return console.warn("StaveNote.note_heads is deprecated. Use StaveNote.noteHeads instead.", "This accessor will be removed in VexFlow 5.0."), this.noteHeads;
            }
            drawLedgerLines() {
                const t = this.checkStave(), { glyphProps: e, render_options: { stroke_px: i } } = this, b = this.checkContext(), a = e.getWidth() + 2 * i, n = 2 * (e.getWidth() + i) - at.WIDTH / 2;
                if (this.isRest()) return;
                if (!b) throw new g("NoCanvasContext", "Can't draw without a canvas context.");
                const { highest_line: s, lowest_line: l, highest_displaced_line: o, highest_non_displaced_line: r, lowest_displaced_line: h, lowest_non_displaced_line: m, displaced_x: c, non_displaced_x: d } = this.getNoteHeadBounds();
                if (s < 6 && l > 0) return;
                const _ = Math.min(null != c ? c : 0, null != d ? d : 0), x = (t, e, s)=>{
                    let l;
                    l = s && e ? _ - i : e ? (null != d ? d : 0) - i : (null != c ? c : 0) - i;
                    const o = e && s ? n : a;
                    b.beginPath(), b.moveTo(l, t), b.lineTo(l + o, t), b.stroke();
                }, y = Object.assign(Object.assign({}, t.getDefaultLedgerLineStyle()), this.getLedgerLineStyle());
                this.applyStyle(b, y);
                for(let e = 6; e <= s; ++e){
                    const i = void 0 !== d && e <= r, b = void 0 !== o && e <= o;
                    x(t.getYForNote(e), i, b);
                }
                for(let e = 0; e >= l; --e){
                    const i = void 0 !== d && e >= m, b = void 0 !== h && e >= h;
                    x(t.getYForNote(e), i, b);
                }
                this.restoreStyle(b, y);
            }
            drawModifiers(t) {
                const e = this.checkContext();
                for(let i = 0; i < this.modifiers.length; i++){
                    const b = this.modifiers[i], a = b.checkIndex(), n = this._noteHeads[a];
                    if (n == t) {
                        const t = n.getStyle();
                        n.applyStyle(e, t), b.setContext(e), b.drawWithStyle(), n.restoreStyle(e, t);
                    }
                }
            }
            shouldDrawFlag() {
                const t = void 0 !== this.stem, e = 1 == this.glyphProps.flag, i = void 0 === this.beam;
                return t && e && i;
            }
            drawFlag() {
                var t, e, i, b, a;
                const n = this.checkContext();
                if (!n) throw new g("NoCanvasContext", "Can't draw without a canvas context.");
                if (this.shouldDrawFlag()) {
                    const { y_top: s, y_bottom: l } = this.getNoteHeadBounds(), o = this.stem.getHeight(), r = this.getStemX(), h = this.getStemDirection() === at.DOWN ? s - o + 2 - (this.glyphProps ? this.glyphProps.stem_down_extension : 0) * this.getStaveNoteScale() - (null !== (e = null === (t = this.flag) || void 0 === t ? void 0 : t.getMetrics().y_shift) && void 0 !== e ? e : 0) * (1 - this.getStaveNoteScale()) : l - o - 2 + (this.glyphProps ? this.glyphProps.stem_up_extension : 0) * this.getStaveNoteScale() - (null !== (b = null === (i = this.flag) || void 0 === i ? void 0 : i.getMetrics().y_shift) && void 0 !== b ? b : 0) * (1 - this.getStaveNoteScale());
                    null === (a = this.flag) || void 0 === a || a.render(n, r, h);
                }
            }
            drawNoteHeads() {
                const t = this.checkContext();
                this._noteHeads.forEach((e)=>{
                    e.applyStyle(t), t.openGroup("notehead", e.getAttribute("id"), {
                        pointerBBox: !0
                    }), e.setContext(t).draw(), this.drawModifiers(e), t.closeGroup(), e.restoreStyle(t);
                });
            }
            drawStem(t) {
                const e = this.checkContext();
                t && this.setStem(new at(t)), this.shouldDrawFlag() && this.stem && this.stem.adjustHeightForFlag(), this.stem && this.stem.setContext(e).draw();
            }
            getStaveNoteScale() {
                return 1;
            }
            getStemExtension() {
                const t = super.getStemExtension();
                if (!this.glyphProps.stem) return t;
                const e = this.getStemDirection();
                if (e !== this.calculateOptimalStemDirection()) return t;
                let i;
                i = e === at.UP ? 3 - this.maxLine : this.minLine - 3;
                const b = i - 3.5;
                if (b <= 0) return t;
                const a = this.getStave();
                let n = 10;
                return null != a && (n = a.getSpacingBetweenLines()), t + b * n;
            }
            draw() {
                if (!1 === this.render_options.draw) return;
                if (0 === this.ys.length) throw new g("NoYValues", "Can't draw note without Y values.");
                const t = this.checkContext(), e = this.getNoteHeadBeginX(), i = this.hasStem() && !this.beam;
                if (this._noteHeads.forEach((t)=>t.setX(e)), this.stem) {
                    const t = this.getStemX();
                    this.stem.setNoteHeadXBounds(t, t);
                }
                !function(...t) {
                    It.DEBUG && u("Vex.Flow.StaveNote", t);
                }("Rendering ", this.isChord() ? "chord :" : "note :", this.keys), this.applyStyle(), t.openGroup("stavenote", this.getAttribute("id")), this.drawLedgerLines(), i && this.drawStem(), this.drawNoteHeads(), this.drawFlag(), t.closeGroup(), this.restoreStyle(), this.setRendered();
            }
        }
        It.DEBUG = !1;
        class Gt extends R {
            static get CATEGORY() {
                return x.StaveTie;
            }
            constructor(t, e){
                super(), this.setNotes(t), this.text = e, this.render_options = {
                    cp1: 8,
                    cp2: 12,
                    text_shift_x: 0,
                    first_x_shift: 0,
                    last_x_shift: 0,
                    y_shift: 7,
                    tie_spacing: 0
                }, this.resetFont();
            }
            setDirection(t) {
                return this.direction = t, this;
            }
            setNotes(t) {
                if (!t.first_note && !t.last_note) throw new g("BadArguments", "Tie needs to have either first_note or last_note set.");
                if (t.first_indices || (t.first_indices = [
                    0
                ]), t.last_indices || (t.last_indices = [
                    0
                ]), t.first_indices.length !== t.last_indices.length) throw new g("BadArguments", "Tied notes must have same number of indices.");
                return this.notes = t, this;
            }
            isPartial() {
                return !this.notes.first_note || !this.notes.last_note;
            }
            renderTie(t) {
                if (0 === t.first_ys.length || 0 === t.last_ys.length) throw new g("BadArguments", "No Y-values to render");
                const e = this.checkContext();
                let i = this.render_options.cp1, b = this.render_options.cp2;
                Math.abs(t.last_x_px - t.first_x_px) < 10 && (i = 2, b = 8);
                const a = this.render_options.first_x_shift, n = this.render_options.last_x_shift, s = this.render_options.y_shift * t.direction, l = this.notes.first_indices, o = this.notes.last_indices;
                this.applyStyle(), e.openGroup("stavetie", this.getAttribute("id"));
                for(let r = 0; r < l.length; ++r){
                    const h = (t.last_x_px + n + (t.first_x_px + a)) / 2, m = t.first_ys[l[r]] + s, c = t.last_ys[o[r]] + s;
                    if (isNaN(m) || isNaN(c)) throw new g("BadArguments", "Bad indices for tie rendering.");
                    const d = (m + c) / 2 + i * t.direction, _ = (m + c) / 2 + b * t.direction;
                    e.beginPath(), e.moveTo(t.first_x_px + a, m), e.quadraticCurveTo(h, d, t.last_x_px + n, c), e.quadraticCurveTo(h, _, t.first_x_px + a, m), e.closePath(), e.fill();
                }
                e.closeGroup(), this.restoreStyle();
            }
            renderText(t, e) {
                var i, b, a;
                if (!this.text) return;
                const n = this.checkContext();
                let s = (t + e) / 2;
                s -= n.measureText(this.text).width / 2;
                const l = null !== (b = null === (i = this.notes.first_note) || void 0 === i ? void 0 : i.checkStave()) && void 0 !== b ? b : null === (a = this.notes.last_note) || void 0 === a ? void 0 : a.checkStave();
                l && (n.save(), n.setFont(this.textFont), n.fillText(this.text, s + this.render_options.text_shift_x, l.getYForTopText() - 1), n.restore());
            }
            getNotes() {
                return this.notes;
            }
            draw() {
                this.checkContext(), this.setRendered();
                const t = this.notes.first_note, e = this.notes.last_note;
                let i = 0, b = 0, a = [
                    0
                ], n = [
                    0
                ], s = 0;
                if (t) i = t.getTieRightX() + this.render_options.tie_spacing, s = t.getStemDirection(), a = t.getYs();
                else if (e) i = e.checkStave().getTieStartX(), a = e.getYs(), this.notes.first_indices = this.notes.last_indices;
                if (e) b = e.getTieLeftX() + this.render_options.tie_spacing, s = e.getStemDirection(), n = e.getYs();
                else if (t) b = t.checkStave().getTieEndX(), n = t.getYs(), this.notes.last_indices = this.notes.first_indices;
                return this.direction && (s = this.direction), this.renderTie({
                    first_x_px: i,
                    last_x_px: b,
                    first_ys: a,
                    last_ys: n,
                    direction: s
                }), this.renderText(i, b), !0;
            }
        }
        Gt.TEXT_FONT = Object.assign({}, R.TEXT_FONT);
        class Ht extends Gt {
            static get CATEGORY() {
                return x.TabTie;
            }
            static createHammeron(t) {
                return new Ht(t, "H");
            }
            static createPulloff(t) {
                return new Ht(t, "P");
            }
            constructor(t, e){
                super(t, e), this.render_options.cp1 = 9, this.render_options.cp2 = 11, this.render_options.y_shift = 3, this.direction = -1;
            }
        }
        var Yt;
        !function(t) {
            t[t.STRICT = 1] = "STRICT", t[t.SOFT = 2] = "SOFT", t[t.FULL = 3] = "FULL";
        }(Yt || (Yt = {}));
        class Xt extends R {
            static get CATEGORY() {
                return x.Voice;
            }
            static get Mode() {
                return Yt;
            }
            constructor(t){
                let e;
                if (super(), this.resolutionMultiplier = 1, this.mode = Yt.STRICT, this.preFormatted = !1, this.ticksUsed = new z(0, 1), this.largestTickWidth = 0, this.tickables = [], this.options = {
                    softmaxFactor: V.SOFTMAX_FACTOR
                }, "string" == typeof t) {
                    const i = t.match(/(\d+)\/(\d+)/);
                    i && (e = {
                        num_beats: parseInt(i[1]),
                        beat_value: parseInt(i[2])
                    });
                } else e = t;
                this.time = Object.assign({
                    num_beats: 4,
                    beat_value: 4,
                    resolution: V.RESOLUTION
                }, e), this.totalTicks = new z(this.time.num_beats * (this.time.resolution / this.time.beat_value), 1), this.smallestTickCount = this.totalTicks.clone();
            }
            getTotalTicks() {
                return this.totalTicks;
            }
            getTicksUsed() {
                return this.ticksUsed;
            }
            getLargestTickWidth() {
                return this.largestTickWidth;
            }
            getSmallestTickCount() {
                return this.smallestTickCount;
            }
            getTickables() {
                return this.tickables;
            }
            getMode() {
                return this.mode;
            }
            setMode(t) {
                return this.mode = t, this;
            }
            getResolutionMultiplier() {
                return this.resolutionMultiplier;
            }
            getActualResolution() {
                return this.resolutionMultiplier * this.time.resolution;
            }
            setStave(t) {
                return this.stave = t, this.boundingBox = void 0, this;
            }
            getStave() {
                return this.stave;
            }
            getBoundingBox() {
                if (!this.boundingBox) {
                    const t = this.checkStave();
                    let e;
                    for(let i = 0; i < this.tickables.length; ++i){
                        const b = this.tickables[i];
                        b.getStave() || b.setStave(t);
                        const a = b.getBoundingBox();
                        a && (e = e ? e.mergeWith(a) : a);
                    }
                    this.boundingBox = e;
                }
                return this.boundingBox;
            }
            setStrict(t) {
                return this.mode = t ? Yt.STRICT : Yt.SOFT, this;
            }
            isComplete() {
                return this.mode !== Yt.STRICT && this.mode !== Yt.FULL || this.ticksUsed.equals(this.totalTicks);
            }
            setSoftmaxFactor(t) {
                return this.options.softmaxFactor = t, this.expTicksUsed = 0, this;
            }
            reCalculateExpTicksUsed() {
                const t = this.ticksUsed.value();
                return this.expTicksUsed = w(this.tickables.map((e)=>Math.pow(this.options.softmaxFactor, e.getTicks().value() / t))), this.expTicksUsed;
            }
            softmax(t) {
                this.expTicksUsed || (this.expTicksUsed = this.reCalculateExpTicksUsed());
                const e = this.ticksUsed.value();
                return ((t)=>Math.pow(this.options.softmaxFactor, t / e))(t) / this.expTicksUsed;
            }
            addTickable(t) {
                if (!t.shouldIgnoreTicks()) {
                    const e = t.getTicks();
                    if (this.ticksUsed.add(e), this.expTicksUsed = 0, (this.mode === Yt.STRICT || this.mode === Yt.FULL) && this.ticksUsed.greaterThan(this.totalTicks)) throw this.ticksUsed.subtract(e), new g("BadArgument", "Too many ticks.");
                    e.lessThan(this.smallestTickCount) && (this.smallestTickCount = e.clone()), this.resolutionMultiplier = this.ticksUsed.denominator, this.totalTicks.add(0, this.ticksUsed.denominator);
                }
                return this.tickables.push(t), t.setVoice(this), this;
            }
            addTickables(t) {
                for(let e = 0; e < t.length; ++e)this.addTickable(t[e]);
                return this;
            }
            preFormat() {
                if (this.preFormatted) return this;
                const t = this.checkStave();
                return this.tickables.forEach((e)=>{
                    e.getStave() || e.setStave(t);
                }), this.preFormatted = !0, this;
            }
            checkStave() {
                return p(this.stave, "NoStave", "No stave attached to instance.");
            }
            draw(t = this.checkContext(), e) {
                let i;
                e = null != e ? e : this.stave, this.setRendered();
                for(let b = 0; b < this.tickables.length; ++b){
                    const a = this.tickables[b];
                    e && a.setStave(e), p(a.getStave(), "MissingStave", "The voice cannot draw tickables without staves.");
                    const n = a.getBoundingBox();
                    n && (i = i ? i.mergeWith(n) : n), a.setContext(t), a.drawWithStyle();
                }
                this.boundingBox = i;
            }
        }
        class jt extends tt {
            static get CATEGORY() {
                return x.GraceNoteGroup;
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                const i = [];
                let b = null, a = 0;
                for(let e = 0; e < t.length; ++e){
                    const n = t[e], s = n.getNote(), l = c(s), o = l ? 4 : 0;
                    if (l && s !== b) {
                        for(let t = 0; t < s.keys.length; ++t)a = Math.max(s.getLeftDisplacedHeadPx(), a);
                        b = s;
                    }
                    i.push({
                        shift: a,
                        gracenote_group: n,
                        spacing: o
                    });
                }
                let n, s = i[0].shift;
                for(let t = 0; t < i.length; ++t){
                    const e = i[t].gracenote_group;
                    e.preFormat(), n = e.getWidth() + i[t].spacing, s = Math.max(n, s);
                }
                for(let t = 0; t < i.length; ++t){
                    const e = i[t].gracenote_group;
                    n = e.getWidth() + i[t].spacing, e.setSpacingFromNextModifier(s - Math.min(n, s) + It.minNoteheadPadding);
                }
                return e.left_shift += s, !0;
            }
            constructor(t, e){
                return super(), this.preFormatted = !1, this.position = tt.Position.LEFT, this.grace_notes = t, this.width = 0, this.show_slur = e, this.slur = void 0, this.voice = new Xt({
                    num_beats: 4,
                    beat_value: 4,
                    resolution: V.RESOLUTION
                }).setStrict(!1), this.render_options = {
                    slur_y_shift: 0
                }, this.beams = [], this.voice.addTickables(this.grace_notes), this;
            }
            preFormat() {
                this.preFormatted || (this.formatter || (this.formatter = new Pe), this.formatter.joinVoices([
                    this.voice
                ]).format([
                    this.voice
                ], 0, {}), this.setWidth(this.formatter.getMinTotalWidth()), this.preFormatted = !0);
            }
            beamNotes(t) {
                if ((t = t || this.grace_notes).length > 1) {
                    const e = new Re(t);
                    e.render_options.beam_width = 3, e.render_options.partial_beam_length = 4, this.beams.push(e);
                }
                return this;
            }
            setWidth(t) {
                return this.width = t, this;
            }
            getWidth() {
                return this.width + It.minNoteheadPadding;
            }
            getGraceNotes() {
                return this.grace_notes;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                if (this.setRendered(), function(...t) {
                    jt.DEBUG && u("Vex.Flow.GraceNoteGroup", t);
                }("Drawing grace note group for:", e), this.alignSubNotesWithNote(this.getGraceNotes(), e), this.grace_notes.forEach((e)=>e.setContext(t).draw()), this.beams.forEach((e)=>e.setContext(t).draw()), this.show_slur) {
                    const i = c(e), b = i ? Gt : Ht;
                    this.slur = new b({
                        last_note: this.grace_notes[0],
                        first_note: e,
                        first_indices: [
                            0
                        ],
                        last_indices: [
                            0
                        ]
                    }), this.slur.render_options.cp2 = 12, this.slur.render_options.y_shift = (i ? 7 : 5) + this.render_options.slur_y_shift, this.slur.setContext(t).draw();
                }
            }
        }
        jt.DEBUG = !1;
        class Vt extends tt {
            static get CATEGORY() {
                return x.NoteSubGroup;
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0;
                for(let e = 0; e < t.length; ++e){
                    const b = t[e];
                    b.preFormat(), i += b.getWidth();
                }
                return e.left_shift += i, !0;
            }
            constructor(t){
                super(), this.preFormatted = !1, this.position = tt.Position.LEFT, this.subNotes = t, this.subNotes.forEach((t)=>{
                    t.setIgnoreTicks(!1);
                }), this.width = 0, this.formatter = new Pe, this.voice = new Xt({
                    num_beats: 4,
                    beat_value: 4,
                    resolution: V.RESOLUTION
                }).setStrict(!1), this.voice.addTickables(this.subNotes);
            }
            preFormat() {
                this.preFormatted || (this.formatter.joinVoices([
                    this.voice
                ]).format([
                    this.voice
                ], 0), this.setWidth(this.formatter.getMinTotalWidth()), this.preFormatted = !0);
            }
            setWidth(t) {
                return this.width = t, this;
            }
            getWidth() {
                return this.width;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered(), this.alignSubNotesWithNote(this.subNotes, e), this.subNotes.forEach((e)=>e.setContext(t).drawWithStyle());
            }
        }
        class Kt extends tt {
            static get CATEGORY() {
                return x.Ornament;
            }
            static get minPadding() {
                return V.currentMusicFont().lookupMetric("noteHead.minPadding");
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0, b = e.right_shift, a = e.left_shift, n = 0;
                for(let s = 0; s < t.length; ++s){
                    const l = t[s], o = 2;
                    if (Kt.ornamentRelease.indexOf(l.type) >= 0 && (l.x_shift += b + 2), Kt.ornamentAttack.indexOf(l.type) >= 0 && (l.x_shift -= a + 2), l.reportedWidth && l.x_shift < 0 ? a += l.reportedWidth : l.reportedWidth && l.x_shift >= 0 ? b += l.reportedWidth + Kt.minPadding : i = Math.max(l.getWidth(), i), Kt.ornamentArticulation.indexOf(l.type) >= 0) p(l.note, "NoAttachedNote").getLineNumber() >= 3 || l.getPosition() === tt.Position.ABOVE ? (e.top_text_line += o, l.y_shift += n, n -= l.glyph.bbox.getH()) : (e.text_line += o, l.y_shift += n, n += l.glyph.bbox.getH());
                    else l.getPosition() === tt.Position.ABOVE ? (l.setTextLine(e.top_text_line), e.top_text_line += o) : (l.setTextLine(e.text_line), e.text_line += o);
                }
                return e.left_shift = a + i / 2, e.right_shift = b + i / 2, !0;
            }
            static get ornamentNoteTransition() {
                return [
                    "flip",
                    "jazzTurn",
                    "smear"
                ];
            }
            static get ornamentAttack() {
                return [
                    "scoop"
                ];
            }
            static get ornamentAlignWithNoteHead() {
                return [
                    "doit",
                    "fall",
                    "fallLong",
                    "doitLong",
                    "bend",
                    "plungerClosed",
                    "plungerOpen",
                    "scoop"
                ];
            }
            static get ornamentRelease() {
                return [
                    "doit",
                    "fall",
                    "fallLong",
                    "doitLong",
                    "jazzTurn",
                    "smear",
                    "flip"
                ];
            }
            static get ornamentArticulation() {
                return [
                    "bend",
                    "plungerClosed",
                    "plungerOpen"
                ];
            }
            getMetrics() {
                const t = V.currentMusicFont().getMetrics().ornament;
                if (!t) throw new g("BadMetrics", "ornament missing");
                return t[this.ornament.code];
            }
            constructor(t){
                super(), this.type = t, this.delayed = !1, this.render_options = {
                    font_scale: V.NOTATION_FONT_SCALE,
                    accidentalLowerPadding: 3,
                    accidentalUpperPadding: 3
                }, this.ornament = V.ornamentCodes(this.type);
                const e = this.getMetrics();
                if (this.adjustForStemDirection = !1, this.reportedWidth = e && e.reportedWidth ? e.reportedWidth : 0, this.stemUpYOffset = e && e.stemUpYOffset ? e.stemUpYOffset : 0, this.ornamentAlignWithNoteHead = Kt.ornamentAlignWithNoteHead.indexOf(this.type) >= 0, !this.ornament) throw new g("ArgumentError", `Ornament not found: '${this.type}'`);
                this.x_shift = e ? e.xOffset : 0, this.y_shift = e ? e.yOffset : 0, this.glyph = new Z(this.ornament.code, this.render_options.font_scale, {
                    category: `ornament.${this.ornament.code}`
                }), Kt.ornamentNoteTransition.indexOf(this.type) >= 0 && (this.delayed = !0), e || this.glyph.setOrigin(.5, 1);
            }
            setDelayed(t) {
                return this.delayed = t, this;
            }
            setUpperAccidental(t) {
                const e = this.render_options.font_scale / 1.3;
                return this.accidentalUpper = new Z(V.accidentalCodes(t).code, e), this.accidentalUpper.setOrigin(.5, 1), this;
            }
            setLowerAccidental(t) {
                const e = this.render_options.font_scale / 1.3;
                return this.accidentalLower = new Z(V.accidentalCodes(t).code, e), this.accidentalLower.setOrigin(.5, 1), this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getStemDirection(), b = e.checkStave();
                this.applyStyle(), t.openGroup("ornament", this.getAttribute("id"));
                const a = e.checkStem().getExtents();
                let n = i === at.DOWN ? a.baseY : a.topY;
                _(e) && (e.hasStem() ? i === at.DOWN && (n = b.getYForTopText(this.text_line)) : n = b.getYForTopText(this.text_line));
                const s = i === at.DOWN, l = b.getSpacingBetweenLines();
                let o = 1;
                !s && e.hasBeam() && (o += .5);
                const r = n - l * (this.text_line + o), h = e.getModifierStartXY(this.position, this.index);
                let m = h.x, c = this.ornamentAlignWithNoteHead ? h.y : Math.min(b.getYForTopText(this.text_line), r);
                if (c += this.y_shift, this.delayed) {
                    let t = 0;
                    const i = m - b.getNoteStartX();
                    if (void 0 !== this.delayXShift) t = this.delayXShift;
                    else {
                        t += this.glyph.getMetrics().width / 2;
                        const a = e.getVoice().getTickables(), n = a.indexOf(e), s = n + 1 < a.length ? a[n + 1].checkTickContext() : void 0;
                        t += s ? .5 * (s.getX() - i) : .5 * (b.getX() + b.getWidth() - m), this.delayXShift = t;
                    }
                    m += t;
                }
                !function(...t) {
                    Kt.DEBUG && u("Vex.Flow.Ornament", t);
                }("Rendering ornament: ", this.ornament, m, c), this.accidentalLower && (this.accidentalLower.render(t, m, c), c -= this.accidentalLower.getMetrics().height, c -= this.render_options.accidentalLowerPadding), this.stemUpYOffset && e.hasStem() && 1 === e.getStemDirection() && (c += this.stemUpYOffset), e.getLineNumber() < 5 && Kt.ornamentNoteTransition.indexOf(this.type) >= 0 && (c = e.checkStave().getBoundingBox().getY() + 40), this.glyph.render(t, m + this.x_shift, c), this.accidentalUpper && (c -= this.glyph.getMetrics().height + this.render_options.accidentalUpperPadding, this.accidentalUpper.render(t, m, c)), t.closeGroup(), this.restoreStyle();
            }
        }
        Kt.DEBUG = !1;
        class $t extends tt {
            static get CATEGORY() {
                return x.Parenthesis;
            }
            static buildAndAttach(t) {
                for (const e of t)for(let t = 0; t < e.keys.length; t++)e.addModifier(new $t(J.LEFT), t), e.addModifier(new $t(J.RIGHT), t);
            }
            static format(t, e) {
                if (!t || 0 === t.length) return !1;
                let i = 0, b = 0;
                for(let e = 0; e < t.length; ++e){
                    const a = t[e], n = a.getNote(), s = a.getPosition(), l = a.checkIndex();
                    let o = 0;
                    s === J.RIGHT && (o = n.getRightParenthesisPx(l), b = b > o + a.width ? b : o + a.width), s === J.LEFT && (o = n.getLeftParenthesisPx(l), i = i > o + a.width ? i : o + a.width), a.setXShift(o);
                }
                return e.left_shift += i, e.right_shift += b, !0;
            }
            constructor(t){
                var e;
                super(), this.position = null != t ? t : tt.Position.LEFT, this.point = null !== (e = V.currentMusicFont().lookupMetric("parenthesis.default.point")) && void 0 !== e ? e : vt.getPoint("default"), this.setWidth(V.currentMusicFont().lookupMetric("parenthesis.default.width"));
            }
            setNote(t) {
                var e, i;
                return this.note = t, this.point = null !== (e = V.currentMusicFont().lookupMetric("parenthesis.default.point")) && void 0 !== e ? e : vt.getPoint("default"), this.setWidth(V.currentMusicFont().lookupMetric("parenthesis.default.width")), o(t) && (this.point = null !== (i = V.currentMusicFont().lookupMetric("parenthesis.gracenote.point")) && void 0 !== i ? i : vt.getPoint("gracenote"), this.setWidth(V.currentMusicFont().lookupMetric("parenthesis.gracenote.width"))), this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getModifierStartXY(this.position, this.index, {
                    forceFlagRight: !0
                }), b = i.x + this.x_shift, a = i.y + this.y_shift;
                this.position == tt.Position.RIGHT ? Z.renderGlyph(t, b + 1, a, this.point, "noteheadParenthesisRight", {
                    category: "noteHead.standard.noteheadParenthesisRight"
                }) : this.position == tt.Position.LEFT && Z.renderGlyph(t, b - 2, a, this.point, "noteheadParenthesisLeft", {
                    category: "noteHead.standard.noteheadParenthesisLeft"
                });
            }
        }
        function Jt(t) {
            if (!t) return !1;
            const e = y();
            return "function" == typeof e.HTMLCanvasElement && t instanceof e.HTMLCanvasElement || "function" == typeof t.getContext && "function" == typeof t.toDataURL;
        }
        function qt(t) {
            if (!t) return !1;
            const e = y();
            return "function" == typeof e.HTMLDivElement && t instanceof e.HTMLDivElement || "function" == typeof t.appendChild && "object" == typeof t.style;
        }
        class Qt extends ft {
            static get WIDTH() {
                return 600;
            }
            static get HEIGHT() {
                return 400;
            }
            static get CANVAS_BROWSER_SIZE_LIMIT() {
                return 32767;
            }
            static sanitizeCanvasDims(t, e) {
                const i = this.CANVAS_BROWSER_SIZE_LIMIT;
                return Math.max(t, e) > i && (f("Canvas dimensions exceed browser limit. Cropping to " + i), t > i && (t = i), e > i && (e = i)), [
                    t,
                    e
                ];
            }
            constructor(t){
                super(), this.textHeight = 0, this.context2D = t, t.canvas ? this.canvas = t.canvas : this.canvas = {
                    width: Qt.WIDTH,
                    height: Qt.HEIGHT
                };
            }
            clear() {
                this.context2D.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
            openGroup(t, e, i) {}
            closeGroup() {}
            add(t) {}
            setFillStyle(t) {
                return this.context2D.fillStyle = t, this;
            }
            setBackgroundFillStyle(t) {
                return this;
            }
            setStrokeStyle(t) {
                return this.context2D.strokeStyle = t, this;
            }
            setShadowColor(t) {
                return this.context2D.shadowColor = t, this;
            }
            setShadowBlur(t) {
                const e = this.context2D.getTransform(), i = Math.sqrt(e.a * e.a + e.b * e.b + e.c * e.c + e.d * e.d);
                return this.context2D.shadowBlur = i * t, this;
            }
            setLineWidth(t) {
                return this.context2D.lineWidth = t, this;
            }
            setLineCap(t) {
                return this.context2D.lineCap = t, this;
            }
            setLineDash(t) {
                return this.context2D.setLineDash(t), this;
            }
            scale(t, e) {
                return this.context2D.scale(t, e), this;
            }
            resize(t, e, i) {
                var b;
                const a = this.context2D.canvas, n = null !== (b = null != i ? i : y().devicePixelRatio) && void 0 !== b ? b : 1;
                return [t, e] = Qt.sanitizeCanvasDims(t * n, e * n), t = t / n | 0, e = e / n | 0, a.width = t * n, a.height = e * n, Jt(a) && (a.style.width = t + "px", a.style.height = e + "px"), this.scale(n, n);
            }
            rect(t, e, i, b) {
                return this.context2D.rect(t, e, i, b), this;
            }
            fillRect(t, e, i, b) {
                return this.context2D.fillRect(t, e, i, b), this;
            }
            clearRect(t, e, i, b) {
                return this.context2D.clearRect(t, e, i, b), this;
            }
            beginPath() {
                return this.context2D.beginPath(), this;
            }
            moveTo(t, e) {
                return this.context2D.moveTo(t, e), this;
            }
            lineTo(t, e) {
                return this.context2D.lineTo(t, e), this;
            }
            bezierCurveTo(t, e, i, b, a, n) {
                return this.context2D.bezierCurveTo(t, e, i, b, a, n), this;
            }
            quadraticCurveTo(t, e, i, b) {
                return this.context2D.quadraticCurveTo(t, e, i, b), this;
            }
            arc(t, e, i, b, a, n) {
                return this.context2D.arc(t, e, i, b, a, n), this;
            }
            fill() {
                return this.context2D.fill(), this;
            }
            stroke() {
                return this.context2D.stroke(), this;
            }
            closePath() {
                return this.context2D.closePath(), this;
            }
            measureText(t) {
                const e = this.context2D.measureText(t);
                let i = 0, b = 0;
                return e.fontBoundingBoxAscent ? (i = -e.fontBoundingBoxAscent, b = e.fontBoundingBoxDescent + e.fontBoundingBoxAscent) : (i = -e.actualBoundingBoxAscent, b = e.actualBoundingBoxDescent + e.actualBoundingBoxAscent), {
                    x: 0,
                    y: i,
                    width: e.width,
                    height: b
                };
            }
            fillText(t, e, i) {
                return this.context2D.fillText(t, e, i), this;
            }
            save() {
                return this.context2D.save(), this;
            }
            restore() {
                return this.context2D.restore(), this;
            }
            set fillStyle(t) {
                this.context2D.fillStyle = t;
            }
            get fillStyle() {
                return this.context2D.fillStyle;
            }
            set strokeStyle(t) {
                this.context2D.strokeStyle = t;
            }
            get strokeStyle() {
                return this.context2D.strokeStyle;
            }
            setFont(t, e, i, b) {
                const a = F.validate(t, e, i, b);
                return this.context2D.font = F.toCSSString(a), this.textHeight = F.convertSizeToPixelValue(a.size), this;
            }
            getFont() {
                return this.context2D.font;
            }
        }
        const Zt = {
            path: {
                x: !0,
                y: !0,
                width: !0,
                height: !0,
                "font-family": !0,
                "font-weight": !0,
                "font-style": !0,
                "font-size": !0
            },
            rect: {
                "font-family": !0,
                "font-weight": !0,
                "font-style": !0,
                "font-size": !0
            },
            text: {
                width: !0,
                height: !0
            }
        }, te = "http://www.w3.org/2000/svg", ee = 2 * Math.PI;
        class ie extends ft {
            constructor(t){
                super(), this.width = 0, this.height = 0, this.precision = 1, this.backgroundFillStyle = "white", this.fontCSSString = "", this.element = t, this.precision = Math.pow(10, V.RENDER_PRECISION_PLACES);
                const e = this.create("svg");
                this.element.appendChild(e), this.svg = e, this.parent = this.svg, this.groups = [
                    this.svg
                ], this.path = "", this.pen = {
                    x: NaN,
                    y: NaN
                }, this.lineWidth = 1;
                const i = {
                    "font-family": F.SANS_SERIF,
                    "font-size": F.SIZE + "pt",
                    "font-weight": E.NORMAL,
                    "font-style": P.NORMAL
                };
                this.state = Object.assign({
                    scaleX: 1,
                    scaleY: 1
                }, i), this.attributes = Object.assign({
                    "stroke-width": .3,
                    "stroke-dasharray": "none",
                    fill: "black",
                    stroke: "black"
                }, i), this.groupAttributes = [], this.applyAttributes(e, this.attributes), this.groupAttributes.push(Object.assign({}, this.attributes)), this.shadow_attributes = {
                    width: 0,
                    color: "black"
                }, this.state_stack = [];
            }
            round(t) {
                return Math.round(t * this.precision) / this.precision;
            }
            create(t) {
                return document.createElementNS(te, t);
            }
            openGroup(t, e, i) {
                const b = this.create("g");
                return this.groups.push(b), this.parent.appendChild(b), this.parent = b, t && b.setAttribute("class", T(t)), e && b.setAttribute("id", T(e)), i && i.pointerBBox && b.setAttribute("pointer-events", "bounding-box"), this.applyAttributes(b, this.attributes), this.groupAttributes.push(Object.assign(Object.assign({}, this.groupAttributes[this.groupAttributes.length - 1]), this.attributes)), b;
            }
            closeGroup() {
                this.groups.pop(), this.groupAttributes.pop(), this.parent = this.groups[this.groups.length - 1];
            }
            add(t) {
                this.parent.appendChild(t);
            }
            setFillStyle(t) {
                return this.attributes.fill = t, this;
            }
            setBackgroundFillStyle(t) {
                return this.backgroundFillStyle = t, this;
            }
            setStrokeStyle(t) {
                return this.attributes.stroke = t, this;
            }
            setShadowColor(t) {
                return this.shadow_attributes.color = t, this;
            }
            setShadowBlur(t) {
                return this.shadow_attributes.width = t, this;
            }
            setLineWidth(t) {
                return this.attributes["stroke-width"] = t, this.lineWidth = t, this;
            }
            setLineDash(t) {
                if ("[object Array]" === Object.prototype.toString.call(t)) return this.attributes["stroke-dasharray"] = t.join(","), this;
                throw new g("ArgumentError", "lineDash must be an array of integers.");
            }
            setLineCap(t) {
                return this.attributes["stroke-linecap"] = t, this;
            }
            resize(t, e) {
                this.width = t, this.height = e, this.element.style.width = t.toString(), this.svg.style.width = t.toString(), this.svg.style.height = e.toString();
                const i = {
                    width: t,
                    height: e
                };
                return this.applyAttributes(this.svg, i), this.scale(this.state.scaleX, this.state.scaleY), this;
            }
            scale(t, e) {
                this.state.scaleX = this.state.scaleX ? this.state.scaleX * t : t, this.state.scaleY = this.state.scaleY ? this.state.scaleY * e : e;
                const i = this.width / this.state.scaleX, b = this.height / this.state.scaleY;
                return this.setViewBox(0, 0, i, b), this;
            }
            setViewBox(t, e, i, b) {
                if ("string" == typeof t) this.svg.setAttribute("viewBox", t);
                else {
                    const a = t + " " + e + " " + i + " " + b;
                    this.svg.setAttribute("viewBox", a);
                }
            }
            applyAttributes(t, e) {
                const i = Zt[t.nodeName];
                for(const b in e)i && i[b] || !e[b] || 0 != this.groupAttributes.length && e[b] == this.groupAttributes[this.groupAttributes.length - 1][b] || t.setAttributeNS(null, b, e[b]);
                return t;
            }
            clear() {
                for(; this.svg.lastChild;)this.svg.removeChild(this.svg.lastChild);
                this.scale(this.state.scaleX, this.state.scaleY);
            }
            rect(t, e, i, b, a) {
                b < 0 && (e += b, b *= -1);
                const n = this.create("rect");
                return a = null != a ? a : {
                    fill: "none",
                    "stroke-width": this.lineWidth,
                    stroke: "black"
                }, t = this.round(t), e = this.round(e), i = this.round(i), b = this.round(b), this.applyAttributes(n, Object.assign({
                    x: t,
                    y: e,
                    width: i,
                    height: b
                }, a)), this.add(n), this;
            }
            fillRect(t, e, i, b) {
                const a = {
                    fill: this.attributes.fill,
                    stroke: "none"
                };
                return this.rect(t, e, i, b, a), this;
            }
            clearRect(t, e, i, b) {
                return this.rect(t, e, i, b, {
                    fill: this.backgroundFillStyle,
                    stroke: "none"
                }), this;
            }
            beginPath() {
                return this.path = "", this.pen.x = NaN, this.pen.y = NaN, this;
            }
            moveTo(t, e) {
                return t = this.round(t), e = this.round(e), this.path += "M" + t + " " + e, this.pen.x = t, this.pen.y = e, this;
            }
            lineTo(t, e) {
                return t = this.round(t), e = this.round(e), this.path += "L" + t + " " + e, this.pen.x = t, this.pen.y = e, this;
            }
            bezierCurveTo(t, e, i, b, a, n) {
                return a = this.round(a), n = this.round(n), t = this.round(t), e = this.round(e), i = this.round(i), b = this.round(b), this.path += "C" + t + " " + e + "," + i + " " + b + "," + a + " " + n, this.pen.x = a, this.pen.y = n, this;
            }
            quadraticCurveTo(t, e, i, b) {
                return i = this.round(i), b = this.round(b), t = this.round(t), e = this.round(e), this.path += "Q" + t + " " + e + "," + i + " " + b, this.pen.x = i, this.pen.y = b, this;
            }
            arc(t, e, i, b, a, n) {
                let s = t + i * Math.cos(b), l = e + i * Math.sin(b);
                s = this.round(s), l = this.round(l);
                const o = v(b), r = v(a);
                if (!n && a - b >= ee || n && b - a >= ee || o === r) {
                    let a = t + i * Math.cos(b + Math.PI), n = e + i * Math.sin(b + Math.PI);
                    a = this.round(a), n = this.round(n), i = this.round(i), this.path += `M${s} ${l} A${i} ${i} 0 0 0 ${a} ${n} `, this.path += `A${i} ${i} 0 0 0 ${s} ${l}`, this.pen.x = s, this.pen.y = l;
                } else {
                    let h, m = t + i * Math.cos(a), c = e + i * Math.sin(a);
                    b = o, a = r, h = Math.abs(a - b) < Math.PI ? n : !n, b > a && (h = !h);
                    const d = !n;
                    m = this.round(m), c = this.round(c), i = this.round(i), this.path += `M${s} ${l} A${i} ${i} 0 ${+h} ${+d} ${m} ${c}`, this.pen.x = m, this.pen.y = c;
                }
                return this;
            }
            closePath() {
                return this.path += "Z", this;
            }
            getShadowStyle() {
                const t = this.shadow_attributes;
                return `filter: drop-shadow(0 0 ${t.width / 1.5}px ${t.color})`;
            }
            fill(t) {
                const e = this.create("path");
                return void 0 === t && (t = Object.assign(Object.assign({}, this.attributes), {
                    stroke: "none"
                })), t.d = this.path, this.shadow_attributes.width > 0 && (t.style = this.getShadowStyle()), this.applyAttributes(e, t), this.add(e), this;
            }
            stroke() {
                const t = this.create("path"), e = Object.assign(Object.assign({}, this.attributes), {
                    fill: "none",
                    "stroke-width": this.lineWidth,
                    d: this.path
                });
                return this.shadow_attributes.width > 0 && (e.style = this.getShadowStyle()), this.applyAttributes(t, e), this.add(t), this;
            }
            measureText(t) {
                return ie.measureTextCache.lookup(t, this.svg, this.attributes);
            }
            fillText(t, e, i) {
                if (!t || t.length <= 0) return this;
                e = this.round(e), i = this.round(i);
                const b = Object.assign(Object.assign({}, this.attributes), {
                    stroke: "none",
                    x: e,
                    y: i
                }), a = this.create("text");
                return a.textContent = t, this.applyAttributes(a, b), this.add(a), this;
            }
            save() {
                return this.state_stack.push({
                    state: {
                        "font-family": this.state["font-family"],
                        "font-weight": this.state["font-weight"],
                        "font-style": this.state["font-style"],
                        "font-size": this.state["font-size"],
                        scale: this.state.scale
                    },
                    attributes: {
                        "font-family": this.attributes["font-family"],
                        "font-weight": this.attributes["font-weight"],
                        "font-style": this.attributes["font-style"],
                        "font-size": this.attributes["font-size"],
                        fill: this.attributes.fill,
                        stroke: this.attributes.stroke,
                        "stroke-width": this.attributes["stroke-width"],
                        "stroke-dasharray": this.attributes["stroke-dasharray"]
                    },
                    shadow_attributes: {
                        width: this.shadow_attributes.width,
                        color: this.shadow_attributes.color
                    },
                    lineWidth: this.lineWidth
                }), this;
            }
            restore() {
                const t = this.state_stack.pop();
                if (t) {
                    const e = t;
                    this.state["font-family"] = e.state["font-family"], this.state["font-weight"] = e.state["font-weight"], this.state["font-style"] = e.state["font-style"], this.state["font-size"] = e.state["font-size"], this.state.scale = e.state.scale, this.attributes["font-family"] = e.attributes["font-family"], this.attributes["font-weight"] = e.attributes["font-weight"], this.attributes["font-style"] = e.attributes["font-style"], this.attributes["font-size"] = e.attributes["font-size"], this.attributes.fill = e.attributes.fill, this.attributes.stroke = e.attributes.stroke, this.attributes["stroke-width"] = e.attributes["stroke-width"], this.attributes["stroke-dasharray"] = e.attributes["stroke-dasharray"], this.shadow_attributes.width = e.shadow_attributes.width, this.shadow_attributes.color = e.shadow_attributes.color, this.lineWidth = e.lineWidth;
                }
                return this;
            }
            set fillStyle(t) {
                this.setFillStyle(t);
            }
            get fillStyle() {
                return this.attributes.fill;
            }
            set strokeStyle(t) {
                this.setStrokeStyle(t);
            }
            get strokeStyle() {
                return this.attributes.stroke;
            }
            setFont(t, e, i, b) {
                const a = F.validate(t, e, i, b);
                this.fontCSSString = F.toCSSString(a);
                const n = {
                    "font-family": a.family,
                    "font-size": a.size,
                    "font-weight": a.weight,
                    "font-style": a.style
                };
                return this.attributes = Object.assign(Object.assign({}, this.attributes), n), this.state = Object.assign(Object.assign({}, this.state), n), this;
            }
            getFont() {
                return this.fontCSSString;
            }
        }
        var be, ae, ne, se;
        ie.measureTextCache = new class {
            constructor(){
                this.cache = {};
            }
            lookup(t, e, i) {
                let b = this.cache[t];
                void 0 === b && (b = {}, this.cache[t] = b);
                const a = `${i["font-family"]}%${i["font-size"]}%${i["font-weight"]}%${i["font-style"]}`;
                let n = b[a];
                return void 0 === n && (n = this.measureImpl(t, e, i), b[a] = n), n;
            }
            measureImpl(t, e, i) {
                let b = this.txt;
                b || (b = document.createElementNS(te, "text"), this.txt = b), b.textContent = t, i["font-family"] && b.setAttributeNS(null, "font-family", i["font-family"]), i["font-size"] && b.setAttributeNS(null, "font-size", `${i["font-size"]}`), i["font-style"] && b.setAttributeNS(null, "font-style", i["font-style"]), i["font-weight"] && b.setAttributeNS(null, "font-weight", `${i["font-weight"]}`), e.appendChild(b);
                const a = b.getBBox();
                return e.removeChild(b), {
                    x: a.x,
                    y: a.y,
                    width: a.width,
                    height: a.height
                };
            }
        }, function(t) {
            t[t.CANVAS = 1] = "CANVAS", t[t.SVG = 2] = "SVG";
        }(be || (be = {})), function(t) {
            t[t.NONE = 1] = "NONE", t[t.UP = 2] = "UP", t[t.DOWN = 3] = "DOWN";
        }(ae || (ae = {}));
        class le {
            static buildContext(t, e, i, b, a = "#FFF") {
                const n = new le(t, e);
                i && b && n.resize(i, b);
                const s = n.getContext();
                return s.setBackgroundFillStyle(a), le.lastContext = s, s;
            }
            static getCanvasContext(t, e, i, b) {
                return le.buildContext(t, le.Backends.CANVAS, e, i, b);
            }
            static getSVGContext(t, e, i, b) {
                return le.buildContext(t, le.Backends.SVG, e, i, b);
            }
            static drawDashedLine(t, e, i, b, a, n) {
                t.beginPath();
                const s = b - e, l = a - i, o = Math.atan2(l, s);
                let r = e, h = i;
                t.moveTo(e, i);
                let m = 0, c = !0;
                for(; !(s < 0 ? r <= b : r >= b) || !(l < 0 ? h <= a : h >= a);){
                    const e = n[m++ % n.length], i = r + Math.cos(o) * e;
                    r = s < 0 ? Math.max(b, i) : Math.min(b, i);
                    const d = h + Math.sin(o) * e;
                    h = l < 0 ? Math.max(a, d) : Math.min(a, d), c ? t.lineTo(r, h) : t.moveTo(r, h), c = !c;
                }
                t.closePath(), t.stroke();
            }
            constructor(t, e){
                if (m(t)) this.ctx = t;
                else {
                    if (void 0 === e) throw new g("InvalidArgument", "Missing backend argument");
                    const i = e;
                    let b;
                    if ("string" == typeof t) {
                        const e = document.getElementById(t);
                        if (!e) throw new g("BadElementId", `Can't find element with ID "${e}"`);
                        b = e;
                    } else b = t;
                    if (i === le.Backends.CANVAS) {
                        if (!Jt(b)) throw new g("BadElement", "CANVAS context requires an HTMLCanvasElement.");
                        const t = b.getContext("2d", {
                            willReadFrequently: !0
                        });
                        if (!t) throw new g("BadElement", "Can't get canvas context");
                        this.ctx = new Qt(t);
                    } else {
                        if (i !== le.Backends.SVG) throw new g("InvalidBackend", `No support for backend: ${i}`);
                        if (!qt(b)) throw new g("BadElement", "SVG context requires an HTMLDivElement.");
                        this.ctx = new ie(b);
                    }
                }
            }
            resize(t, e) {
                return this.ctx.resize(t, e), this;
            }
            getContext() {
                return this.ctx;
            }
        }
        le.Backends = be, le.LineEndType = ae, le.lastContext = void 0;
        class oe extends tt {
            static get CATEGORY() {
                return x.StringNumber;
            }
            static get metrics() {
                var t;
                return null !== (t = V.currentMusicFont().getMetrics().stringNumber) && void 0 !== t ? t : {
                    verticalPadding: 0,
                    stemPadding: 0,
                    leftPadding: 0,
                    rightPadding: 0
                };
            }
            static format(t, e) {
                const i = e.left_shift, b = e.right_shift;
                if (!t || 0 === t.length) return !1;
                const a = [];
                let n = null, s = 0, l = 0;
                for(let i = 0; i < t.length; ++i){
                    const o = t[i], r = o.getNote(), h = o.getPosition();
                    if (!c(r)) throw new g("NoStaveNote");
                    const m = o.checkIndex(), d = r.getKeyProps()[m], _ = r.getModifierContext(), x = 2 * o.radius / V.STAVE_LINE_DISTANCE + .5;
                    if (_ && (h === J.ABOVE ? (o.text_line = _.getState().top_text_line, e.top_text_line += x) : h === J.BELOW && (o.text_line = _.getState().text_line, e.text_line += x)), r !== n) {
                        for(let t = 0; t < r.keys.length; ++t)h === tt.Position.LEFT && (s = Math.max(r.getLeftDisplacedHeadPx(), s)), 0 === b && (l = Math.max(r.getRightDisplacedHeadPx(), l));
                        n = r;
                    }
                    const y = d.line;
                    a.push({
                        pos: h,
                        note: r,
                        num: o,
                        line: y,
                        shiftL: s,
                        shiftR: l
                    });
                }
                a.sort((t, e)=>e.line - t.line);
                let o = 0, r = 0, h = 0, m = null, d = null;
                for(let t = 0; t < a.length; ++t){
                    const e = a[t].note, n = a[t].pos, l = a[t].num, c = a[t].line, _ = a[t].shiftR;
                    c === m && e === d || (o = b + _);
                    const x = l.getWidth() + 1;
                    let g = 0;
                    n === tt.Position.LEFT ? (l.setXShift(i + s), g = x, r = Math.max(g, r)) : n === tt.Position.RIGHT && (l.setXShift(o), g += x, h = g > h ? g : h), m = c, d = e;
                }
                return e.left_shift += r, e.right_shift += h, !0;
            }
            constructor(t){
                super(), this.string_number = t, this.position = tt.Position.ABOVE, this.x_shift = 0, this.y_shift = 0, this.text_line = 0, this.stem_offset = 0, this.x_offset = 0, this.y_offset = 0, this.dashed = !0, this.leg = le.LineEndType.NONE, this.radius = 8, this.drawCircle = !0, this.setWidth(2 * this.radius + 4), this.resetFont();
            }
            setLineEndType(t) {
                return t >= le.LineEndType.NONE && t <= le.LineEndType.DOWN && (this.leg = t), this;
            }
            setStringNumber(t) {
                return this.string_number = t, this;
            }
            setOffsetX(t) {
                return this.x_offset = t, this;
            }
            setOffsetY(t) {
                return this.y_offset = t, this;
            }
            setLastNote(t) {
                return this.last_note = t, this;
            }
            setDashed(t) {
                return this.dashed = t, this;
            }
            setDrawCircle(t) {
                return this.drawCircle = t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getModifierStartXY(this.position, this.index), b = e.hasStem() ? e.getStemDirection() : at.UP;
                let a = i.x + this.x_shift + this.x_offset, n = {};
                e.hasStem() && (n = e.checkStem().getExtents());
                let s = i.y + this.y_shift + this.y_offset;
                switch(this.position){
                    case tt.Position.ABOVE:
                        s = e.getYs().reduce((t, e)=>t < e ? t : e), e.hasStem() && b == at.UP && (s = n.topY + oe.metrics.stemPadding), s -= this.radius + oe.metrics.verticalPadding + this.text_line * V.STAVE_LINE_DISTANCE;
                        break;
                    case tt.Position.BELOW:
                        s = e.getYs().reduce((t, e)=>t > e ? t : e), e.hasStem() && b == at.DOWN && (s = n.topY - oe.metrics.stemPadding), s += this.radius + oe.metrics.verticalPadding + this.text_line * V.STAVE_LINE_DISTANCE;
                        break;
                    case tt.Position.LEFT:
                        a -= this.radius / 2 + oe.metrics.leftPadding;
                        break;
                    case tt.Position.RIGHT:
                        a += this.radius / 2 + oe.metrics.rightPadding;
                        break;
                    default:
                        throw new g("InvalidPosition", `The position ${this.position} is invalid`);
                }
                t.save(), this.drawCircle && (t.beginPath(), t.arc(a, s, this.radius, 0, 2 * Math.PI, !1), t.setLineWidth(1.5), t.stroke()), t.setFont(this.textFont);
                const l = a - t.measureText(this.string_number).width / 2;
                t.fillText("" + this.string_number, l, s + 4.5);
                const o = this.last_note;
                if (d(o)) {
                    const i = o.getStemX() - e.getX() + 5;
                    let b, n;
                    switch(t.setStrokeStyle("#000000"), t.setLineCap("round"), t.setLineWidth(.6), this.dashed ? le.drawDashedLine(t, a + 10, s, a + i, s, [
                        3,
                        3
                    ]) : le.drawDashedLine(t, a + 10, s, a + i, s, [
                        3,
                        0
                    ]), this.leg){
                        case le.LineEndType.UP:
                            b = -10, n = this.dashed ? [
                                3,
                                3
                            ] : [
                                3,
                                0
                            ], le.drawDashedLine(t, a + i, s, a + i, s + b, n);
                            break;
                        case le.LineEndType.DOWN:
                            b = 10, n = this.dashed ? [
                                3,
                                3
                            ] : [
                                3,
                                0
                            ], le.drawDashedLine(t, a + i, s, a + i, s + b, n);
                    }
                }
                t.restore();
            }
        }
        oe.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: F.SIZE,
            weight: E.BOLD,
            style: P.NORMAL
        };
        class re extends tt {
            static get CATEGORY() {
                return x.Stroke;
            }
            static format(t, e) {
                const i = e.left_shift;
                if (!t || 0 === t.length) return !1;
                const b = t.map((t)=>{
                    const e = t.getNote(), i = t.checkIndex();
                    if (c(e)) {
                        const { line: b } = e.getKeyProps()[i];
                        return {
                            line: b,
                            shift: e.getLeftDisplacedHeadPx(),
                            stroke: t
                        };
                    }
                    if (_(e)) {
                        const { str: b } = e.getPositions()[i];
                        return {
                            line: b,
                            shift: 0,
                            stroke: t
                        };
                    }
                    throw new g("Internal", "Unexpected instance.");
                }), a = i, n = b.reduce((t, { stroke: e, shift: i })=>(e.setXShift(a + i), Math.max(e.getWidth() + 0, t)), 0);
                return e.left_shift += n, !0;
            }
            constructor(t, e){
                super(), this.options = Object.assign({
                    all_voices: !0
                }, e), this.all_voices = this.options.all_voices, this.type = t, this.position = tt.Position.LEFT, this.render_options = {
                    font_scale: V.NOTATION_FONT_SCALE
                }, this.resetFont(), this.setXShift(0), this.setWidth(10);
            }
            getPosition() {
                return this.position;
            }
            addEndNote(t) {
                return this.note_end = t, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getModifierStartXY(this.position, this.index);
                let b = e.getYs(), a = i.y, n = i.y;
                const s = i.x - 5, l = e.checkStave().getSpacingBetweenLines(), o = this.checkModifierContext().getMembers(e.getCategory());
                for(let t = 0; t < o.length; t++){
                    const e = o[t];
                    if (h(e)) {
                        b = e.getYs();
                        for(let e = 0; e < b.length; e++)(this.note === o[t] || this.all_voices) && (a = Math.min(a, b[e]), n = Math.max(n, b[e]));
                    }
                }
                let r = "", m = 0, d = 0, _ = 0, x = 0;
                switch(this.type){
                    case re.Type.BRUSH_DOWN:
                        r = "arrowheadBlackUp", m = -3, d = a - l / 2 + 10, n += l / 2;
                        break;
                    case re.Type.BRUSH_UP:
                        r = "arrowheadBlackDown", m = .5, d = n + l / 2, a -= l / 2;
                        break;
                    case re.Type.ROLL_DOWN:
                    case re.Type.RASQUEDO_DOWN:
                        r = "arrowheadBlackUp", m = -3, _ = this.x_shift + m - 2, c(e) ? (a += 1.5 * l, n += (n - a) % 2 != 0 ? .5 * l : l, d = a - l, x = n + l + 2) : (a += 1.5 * l, n += l, d = a - .75 * l, x = n + .25 * l);
                        break;
                    case re.Type.ROLL_UP:
                    case re.Type.RASQUEDO_UP:
                        r = "arrowheadBlackDown", m = -4, _ = this.x_shift + m - 1, c(e) ? (d = l / 2, a += .5 * l, (n - a) % 2 == 0 && (n += l / 2), d = n + .5 * l, x = a - 1.25 * l) : (a += .25 * l, n += .5 * l, d = n + .25 * l, x = a - l);
                        break;
                    case re.Type.ARPEGGIO_DIRECTIONLESS:
                        a += .5 * l, n += l;
                        break;
                    default:
                        throw new g("InvalidType", `The stroke type ${this.type} does not exist`);
                }
                let y = "straight";
                if (this.type === re.Type.BRUSH_DOWN || this.type === re.Type.BRUSH_UP) t.fillRect(s + this.x_shift, a, 1, n - a);
                else if (y = "wiggly", c(e)) for(let e = a; e <= n; e += l)Z.renderGlyph(t, s + this.x_shift - 4, e, this.render_options.font_scale, "vexWiggleArpeggioUp");
                else {
                    let e;
                    for(e = a; e <= n; e += 10)Z.renderGlyph(t, s + this.x_shift - 4, e, this.render_options.font_scale, "vexWiggleArpeggioUp");
                    this.type === re.Type.RASQUEDO_DOWN && (x = e + .25 * l);
                }
                this.type !== re.Type.ARPEGGIO_DIRECTIONLESS && (Z.renderGlyph(t, s + this.x_shift + m, d, this.render_options.font_scale, r, {
                    category: `stroke_${y}.${r}`
                }), this.type !== re.Type.RASQUEDO_DOWN && this.type !== re.Type.RASQUEDO_UP || (t.save(), t.setFont(this.textFont), t.fillText("R", s + _, x), t.restore()));
            }
        }
        re.Type = {
            BRUSH_DOWN: 1,
            BRUSH_UP: 2,
            ROLL_DOWN: 3,
            ROLL_UP: 4,
            RASQUEDO_DOWN: 5,
            RASQUEDO_UP: 6,
            ARPEGGIO_DIRECTIONLESS: 7
        }, re.TEXT_FONT = {
            family: F.SERIF,
            size: F.SIZE,
            weight: E.BOLD,
            style: P.ITALIC
        };
        class he extends tt {
            static get CATEGORY() {
                return x.Vibrato;
            }
            static format(t, e, i) {
                if (!t || 0 === t.length) return !1;
                let b = e.top_text_line, a = 0, n = e.right_shift - 7;
                const s = i.getMembers(Nt.CATEGORY);
                if (s && s.length > 0) b -= s.map((t)=>t.getTextHeight()).reduce((t, e)=>t > e ? t : e) / V.STAVE_LINE_DISTANCE + 1;
                else e.top_text_line += 1;
                for(let e = 0; e < t.length; ++e){
                    const i = t[e];
                    i.setXShift(n), i.setTextLine(b), a += i.getWidth(), n += a;
                }
                return e.right_shift += a, !0;
            }
            constructor(){
                super(), this.position = tt.Position.RIGHT, this.render_options = {
                    harsh: !1,
                    vibrato_width: 20,
                    wave_height: 6,
                    wave_width: 4,
                    wave_girth: 2
                }, this.setVibratoWidth(this.render_options.vibrato_width);
            }
            setHarsh(t) {
                return this.render_options.harsh = t, this;
            }
            setVibratoWidth(t) {
                return this.render_options.vibrato_width = t, this.setWidth(t), this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkAttachedNote();
                this.setRendered();
                const i = e.getModifierStartXY(tt.Position.RIGHT, this.index).x + this.x_shift, b = e.getYForTopText(this.text_line) + 2;
                he.renderVibrato(t, i, b, this.render_options);
            }
            static renderVibrato(t, e, i, b) {
                const { harsh: a, vibrato_width: n, wave_width: s, wave_girth: l, wave_height: o } = b, r = n / s;
                let h;
                if (t.beginPath(), a) {
                    for(t.moveTo(e, i + l + 1), h = 0; h < r / 2; ++h)t.lineTo(e + s, i - o / 2), e += s, t.lineTo(e + s, i + o / 2), e += s;
                    for(h = 0; h < r / 2; ++h)t.lineTo(e - s, i - o / 2 + l + 1), e -= s, t.lineTo(e - s, i + o / 2 + l + 1), e -= s;
                    t.fill();
                } else {
                    for(t.moveTo(e, i + l), h = 0; h < r / 2; ++h)t.quadraticCurveTo(e + s / 2, i - o / 2, e + s, i), e += s, t.quadraticCurveTo(e + s / 2, i + o / 2, e + s, i), e += s;
                    for(h = 0; h < r / 2; ++h)t.quadraticCurveTo(e - s / 2, i + o / 2 + l, e - s, i + l), e -= s, t.quadraticCurveTo(e - s / 2, i - o / 2 + l, e - s, i + l), e -= s;
                    t.fill();
                }
            }
        }
        function me(...t) {
            ce.DEBUG && u("Vex.Flow.ModifierContext", t);
        }
        class ce {
            constructor(){
                this.state = {
                    left_shift: 0,
                    right_shift: 0,
                    text_line: 0,
                    top_text_line: 0
                }, this.members = {}, this.preFormatted = !1, this.postFormatted = !1, this.formatted = !1, this.width = 0, this.spacing = 0;
            }
            addModifier(t) {
                return me("addModifier is deprecated, use addMember instead."), this.addMember(t);
            }
            addMember(t) {
                const e = t.getCategory();
                return this.members[e] || (this.members[e] = []), this.members[e].push(t), t.setModifierContext(this), this.preFormatted = !1, this;
            }
            getModifiers(t) {
                return me("getModifiers is deprecated, use getMembers instead."), this.getMembers(t);
            }
            getMembers(t) {
                var e;
                return null !== (e = this.members[t]) && void 0 !== e ? e : [];
            }
            getWidth() {
                return this.width;
            }
            getLeftShift() {
                return this.state.left_shift;
            }
            getRightShift() {
                return this.state.right_shift;
            }
            getState() {
                return this.state;
            }
            getMetrics() {
                if (!this.formatted) throw new g("UnformattedMember", "Unformatted member has no metrics.");
                return {
                    width: this.state.left_shift + this.state.right_shift + this.spacing,
                    spacing: this.spacing
                };
            }
            preFormat() {
                if (this.preFormatted) return;
                me("Preformatting ModifierContext");
                const t = this.state, e = this.members;
                It.format(e[x.StaveNote], t), $t.format(e[x.Parenthesis], t), Ot.format(e[x.Dot], t), Rt.format(e[x.FretHandFinger], t), bt.format(e[x.Accidental], t), re.format(e[x.Stroke], t), jt.format(e[x.GraceNoteGroup], t), Vt.format(e[x.NoteSubGroup], t), oe.format(e[x.StringNumber], t), ut.format(e[x.Articulation], t), Kt.format(e[x.Ornament], t), ct.format(e[x.Annotation], t), Mt.format(e[x.ChordSymbol], t), Nt.format(e[x.Bend], t), he.format(e[x.Vibrato], t, this), this.width = t.left_shift + t.right_shift, this.preFormatted = !0;
            }
            postFormat() {
                this.postFormatted || (me("Postformatting ModifierContext"), It.postFormat(this.getMembers(x.StaveNote)));
            }
        }
        ce.DEBUG = !1;
        class de extends Pt {
            static get CATEGORY() {
                return x.Clef;
            }
            static get types() {
                return {
                    treble: {
                        code: "gClef",
                        line: 3
                    },
                    bass: {
                        code: "fClef",
                        line: 1
                    },
                    alto: {
                        code: "cClef",
                        line: 2
                    },
                    tenor: {
                        code: "cClef",
                        line: 1
                    },
                    percussion: {
                        code: "unpitchedPercussionClef1",
                        line: 2
                    },
                    soprano: {
                        code: "cClef",
                        line: 4
                    },
                    "mezzo-soprano": {
                        code: "cClef",
                        line: 3
                    },
                    "baritone-c": {
                        code: "cClef",
                        line: 0
                    },
                    "baritone-f": {
                        code: "fClef",
                        line: 2
                    },
                    subbass: {
                        code: "fClef",
                        line: 0
                    },
                    french: {
                        code: "gClef",
                        line: 4
                    },
                    tab: {
                        code: "6stringTabClef",
                        line: 2.5
                    }
                };
            }
            static get annotationSmufl() {
                return {
                    "8va": "timeSig8",
                    "8vb": "timeSig8"
                };
            }
            constructor(t, e, i){
                super(), this.clef = de.types.treble, this.setPosition(wt.BEGIN), this.setType(t, e, i), this.setWidth(Z.getWidth(this.clef.code, de.getPoint(this.size), `clef_${this.size}`)), function(...t) {
                    de.DEBUG && u("Vex.Flow.Clef", t);
                }("Creating clef:", t);
            }
            setType(t, e, i) {
                this.type = t, this.clef = de.types[t], this.size = void 0 === e ? "default" : e;
                const b = V.currentMusicFont();
                if (void 0 !== i) {
                    const t = de.annotationSmufl[i], e = de.getPoint(this.size) / 5 * 3, a = b.lookupMetric(`clef_${this.size}.annotations.${i}.${this.type}.line`), n = b.lookupMetric(`clef_${this.size}.annotations.${i}.${this.type}.shiftX`);
                    this.annotation = {
                        code: t,
                        point: e,
                        line: a,
                        x_shift: n
                    }, this.attachment = new Z(this.annotation.code, this.annotation.point), this.attachment.metrics.x_max = 0, this.attachment.setXShift(this.annotation.x_shift);
                } else this.annotation = void 0;
                return this;
            }
            getWidth() {
                return "tab" === this.type && p(this.stave, "ClefError", "Can't get width without stave."), this.width;
            }
            static getPoint(t) {
                return "default" == t ? V.NOTATION_FONT_SCALE : V.NOTATION_FONT_SCALE / 3 * 2;
            }
            setStave(t) {
                return this.stave = t, this;
            }
            draw() {
                const t = this.checkStave(), e = t.checkContext();
                this.setRendered(), this.applyStyle(e), e.openGroup("clef", this.getAttribute("id")), Z.renderGlyph(e, this.x, t.getYForLine(this.clef.line), de.getPoint(this.size), this.clef.code, {
                    category: `clef_${this.size}`
                }), void 0 !== this.annotation && void 0 !== this.attachment && (this.placeGlyphOnLine(this.attachment, t, this.annotation.line), this.attachment.setStave(t), this.attachment.setContext(e), this.attachment.renderToStave(this.x)), e.closeGroup(), this.restoreStyle(e);
            }
        }
        de.DEBUG = !1;
        class _e extends Pt {
            static get CATEGORY() {
                return x.KeySignature;
            }
            constructor(t, e, i){
                super(), this.accList = [], this.setKeySig(t, e, i), this.setPosition(wt.BEGIN), this.glyphFontScale = V.NOTATION_FONT_SCALE, this.glyphs = [], this.xPositions = [], this.paddingForced = !1;
            }
            convertToGlyph(t, e) {
                const i = V.accidentalCodes(t.type), b = new Z(i.code, this.glyphFontScale);
                let a = 1;
                if ("n" === t.type && e) {
                    const i = _e.accidentalSpacing[e.type];
                    if (i) a = e.line >= t.line ? i.above : i.below;
                }
                this.placeGlyphOnLine(b, this.checkStave(), t.line), this.glyphs.push(b);
                const n = this.xPositions[this.xPositions.length - 1], s = b.getMetrics().width + a;
                this.xPositions.push(n + s), this.width += s;
            }
            cancelKey(t) {
                return this.formatted = !1, this.cancelKeySpec = t, this;
            }
            convertToCancelAccList(t) {
                const e = V.keySignature(t), i = this.accList.length > 0 && e.length > 0 && e[0].type !== this.accList[0].type, b = i ? e.length : e.length - this.accList.length;
                if (b < 1) return;
                const a = [];
                for(let t = 0; t < b; t++){
                    let n = t;
                    i || (n = e.length - b + t);
                    const s = e[n];
                    a.push({
                        type: "n",
                        line: s.line
                    });
                }
                return this.accList = a.concat(this.accList), {
                    accList: a,
                    type: e[0].type
                };
            }
            addToStave(t) {
                return this.paddingForced = !0, t.addModifier(this), this;
            }
            convertAccLines(t, e, i = this.accList) {
                let b, a, n = 0;
                switch(t){
                    case "soprano":
                        "#" === e ? b = [
                            2.5,
                            .5,
                            2,
                            0,
                            1.5,
                            -0.5,
                            1
                        ] : n = -1;
                        break;
                    case "mezzo-soprano":
                        "b" === e ? b = [
                            0,
                            2,
                            .5,
                            2.5,
                            1,
                            3,
                            1.5
                        ] : n = 1.5;
                        break;
                    case "alto":
                        n = .5;
                        break;
                    case "tenor":
                        "#" === e ? b = [
                            3,
                            1,
                            2.5,
                            .5,
                            2,
                            0,
                            1.5
                        ] : n = -0.5;
                        break;
                    case "baritone-f":
                    case "baritone-c":
                        "b" === e ? b = [
                            .5,
                            2.5,
                            1,
                            3,
                            1.5,
                            3.5,
                            2
                        ] : n = 2;
                        break;
                    case "bass":
                    case "french":
                        n = 1;
                }
                if (void 0 !== b) for(a = 0; a < i.length; ++a)i[a].line = b[a];
                else if (0 !== n) for(a = 0; a < i.length; ++a)i[a].line += n;
            }
            getPadding(t) {
                return this.formatted || this.format(), 0 === this.glyphs.length || !this.paddingForced && t < 2 ? 0 : this.padding;
            }
            getWidth() {
                return this.formatted || this.format(), this.width;
            }
            setKeySig(t, e, i) {
                return this.formatted = !1, this.keySpec = t, this.cancelKeySpec = e, this.alterKeySpec = i, this;
            }
            alterKey(t) {
                return this.formatted = !1, this.alterKeySpec = t, this;
            }
            convertToAlterAccList(t) {
                const e = Math.min(t.length, this.accList.length);
                for(let i = 0; i < e; ++i)t[i] && (this.accList[i].type = t[i]);
            }
            format() {
                const t = this.checkStave();
                this.width = 0, this.glyphs = [], this.xPositions = [
                    0
                ], this.accList = V.keySignature(p(this.keySpec));
                const e = this.accList, i = e.length > 0 ? e[0].type : void 0;
                let b;
                if (this.cancelKeySpec && (b = this.convertToCancelAccList(this.cancelKeySpec)), this.alterKeySpec && this.convertToAlterAccList(this.alterKeySpec), this.accList.length > 0) {
                    const a = (this.position === wt.END ? t.getEndClef() : t.getClef()) || t.getClef();
                    b && this.convertAccLines(a, b.type, b.accList), this.convertAccLines(a, i, e);
                    for(let t = 0; t < this.accList.length; ++t)this.convertToGlyph(this.accList[t], this.accList[t + 1]);
                }
                this.formatted = !0;
            }
            getGlyphs() {
                return this.formatted || this.format(), this.glyphs;
            }
            draw() {
                const t = this.checkStave(), e = t.checkContext();
                this.formatted || this.format(), this.setRendered(), this.applyStyle(e), e.openGroup("keysignature", this.getAttribute("id"));
                for(let i = 0; i < this.glyphs.length; i++){
                    const b = this.glyphs[i], a = this.x + this.xPositions[i];
                    b.setStave(t), b.setContext(e), b.renderToStave(a);
                }
                e.closeGroup(), this.restoreStyle(e);
            }
        }
        _e.accidentalSpacing = {
            "#": {
                above: 6,
                below: 4
            },
            b: {
                above: 4,
                below: 7
            },
            n: {
                above: 4,
                below: 1
            },
            "##": {
                above: 6,
                below: 4
            },
            bb: {
                above: 4,
                below: 7
            },
            db: {
                above: 4,
                below: 7
            },
            d: {
                above: 4,
                below: 7
            },
            bbs: {
                above: 4,
                below: 7
            },
            "++": {
                above: 6,
                below: 4
            },
            "+": {
                above: 6,
                below: 4
            },
            "+-": {
                above: 6,
                below: 4
            },
            "++-": {
                above: 6,
                below: 4
            },
            bs: {
                above: 4,
                below: 10
            },
            bss: {
                above: 4,
                below: 10
            }
        };
        class xe extends Pt {
            static get CATEGORY() {
                return x.Repetition;
            }
            constructor(t, e, i){
                super(), this.symbol_type = t, this.x = e, this.x_shift = 0, this.y_shift = i, this.resetFont();
            }
            setShiftX(t) {
                return this.x_shift = t, this;
            }
            setShiftY(t) {
                return this.y_shift = t, this;
            }
            draw(t, e) {
                switch(this.setRendered(), this.symbol_type){
                    case xe.type.CODA_RIGHT:
                        this.drawCodaFixed(t, e + t.getWidth());
                        break;
                    case xe.type.CODA_LEFT:
                        this.drawSymbolText(t, e, "Coda", !0);
                        break;
                    case xe.type.SEGNO_LEFT:
                        this.drawSignoFixed(t, e);
                        break;
                    case xe.type.SEGNO_RIGHT:
                        this.drawSignoFixed(t, e + t.getWidth());
                        break;
                    case xe.type.DC:
                        this.drawSymbolText(t, e, "D.C.", !1);
                        break;
                    case xe.type.DC_AL_CODA:
                        this.drawSymbolText(t, e, "D.C. al", !0);
                        break;
                    case xe.type.DC_AL_FINE:
                        this.drawSymbolText(t, e, "D.C. al Fine", !1);
                        break;
                    case xe.type.DS:
                        this.drawSymbolText(t, e, "D.S.", !1);
                        break;
                    case xe.type.DS_AL_CODA:
                        this.drawSymbolText(t, e, "D.S. al", !0);
                        break;
                    case xe.type.DS_AL_FINE:
                        this.drawSymbolText(t, e, "D.S. al Fine", !1);
                        break;
                    case xe.type.FINE:
                        this.drawSymbolText(t, e, "Fine", !1);
                        break;
                    case xe.type.TO_CODA:
                        this.drawSymbolText(t, e, "To", !0);
                }
                return this;
            }
            drawCodaFixed(t, e) {
                const i = t.getYForTopText(t.getNumLines()) + this.y_shift;
                return Z.renderGlyph(t.checkContext(), this.x + e + this.x_shift, i + V.currentMusicFont().lookupMetric("staveRepetition.coda.offsetY"), 40, "coda", {
                    category: "coda"
                }), this;
            }
            drawSignoFixed(t, e) {
                const i = t.getYForTopText(t.getNumLines()) + this.y_shift;
                return Z.renderGlyph(t.checkContext(), this.x + e + this.x_shift, i + V.currentMusicFont().lookupMetric("staveRepetition.segno.offsetY"), 30, "segno", {
                    category: "segno"
                }), this;
            }
            drawSymbolText(t, e, i, b) {
                var a;
                const n = t.checkContext();
                n.save(), n.setFont(this.textFont);
                let s = 0, l = 0;
                const o = t.getNoteStartX() - this.x;
                switch(this.symbol_type){
                    case xe.type.CODA_LEFT:
                        s = this.x + t.getVerticalBarWidth(), l = s + n.measureText(i).width + V.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetX");
                        break;
                    case xe.type.DC:
                    case xe.type.DC_AL_FINE:
                    case xe.type.DS:
                    case xe.type.DS_AL_FINE:
                    case xe.type.FINE:
                        s = this.x + e + this.x_shift + t.getWidth() - V.currentMusicFont().lookupMetric("staveRepetition.symbolText.spacing") - o - n.measureText(i).width;
                        break;
                    default:
                        s = this.x + e + this.x_shift + t.getWidth() - V.currentMusicFont().lookupMetric("staveRepetition.symbolText.spacing") - o - n.measureText(i).width - V.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetX"), l = s + n.measureText(i).width + V.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetX");
                }
                const r = t.getYForTopText(t.getNumLines()) + this.y_shift + V.currentMusicFont().lookupMetric("staveRepetition.symbolText.offsetY");
                return b && Z.renderGlyph(n, l, r, 2 * F.convertSizeToPointValue(null === (a = this.textFont) || void 0 === a ? void 0 : a.size), "coda", {
                    category: "coda"
                }), n.fillText(i, s, r + 5), n.restore(), this;
            }
        }
        xe.TEXT_FONT = {
            family: F.SERIF,
            size: V.NOTATION_FONT_SCALE / 3,
            weight: E.BOLD,
            style: P.NORMAL
        }, xe.type = {
            NONE: 1,
            CODA_LEFT: 2,
            CODA_RIGHT: 3,
            SEGNO_LEFT: 4,
            SEGNO_RIGHT: 5,
            DC: 6,
            DC_AL_CODA: 7,
            DC_AL_FINE: 8,
            DS: 9,
            DS_AL_CODA: 10,
            DS_AL_FINE: 11,
            FINE: 12,
            TO_CODA: 13
        };
        class ge extends Pt {
            static get CATEGORY() {
                return x.StaveSection;
            }
            constructor(t, e, i, b = !0){
                super(), this.setWidth(16), this.section = t, this.x = e, this.shift_x = 0, this.shift_y = i, this.drawRect = b, this.resetFont();
            }
            setStaveSection(t) {
                return this.section = t, this;
            }
            setShiftX(t) {
                return this.shift_x = t, this;
            }
            setShiftY(t) {
                return this.shift_y = t, this;
            }
            draw(t, e) {
                const i = t.checkContext();
                this.setRendered(), i.save(), i.setLineWidth(2), i.setFont(this.textFont);
                const b = rt.create(this.textFont), a = b.getWidthForTextInPx(this.section), n = b.getYForStringInPx(this.section), s = n.height, l = -1 * n.yMin, o = a + 4, r = s + 4, h = t.getYForTopText(1.5) + this.shift_y, m = this.x + e;
                return this.drawRect && (i.beginPath(), i.rect(m, h - r + l, o, r), i.stroke()), i.fillText(this.section, m + 2, h - 2), i.restore(), this;
            }
        }
        ge.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: 10,
            weight: E.BOLD,
            style: P.NORMAL
        };
        class ye extends Pt {
            static get CATEGORY() {
                return x.StaveTempo;
            }
            constructor(t, e, i){
                super(), this.render_options = {
                    glyph_font_scale: 30
                }, this.tempo = t, this.position = wt.ABOVE, this.x = e, this.shift_x = 10, this.shift_y = i, this.resetFont();
            }
            setTempo(t) {
                return this.tempo = t, this;
            }
            setShiftX(t) {
                return this.shift_x = t, this;
            }
            setShiftY(t) {
                return this.shift_y = t, this;
            }
            draw(t, e) {
                const i = t.checkContext();
                this.setRendered();
                const b = this.render_options, a = b.glyph_font_scale / V.NOTATION_FONT_SCALE, n = this.tempo.name, s = this.tempo.duration, l = this.tempo.dots || 0, o = this.tempo.bpm;
                let r = this.x + this.shift_x + e;
                const h = t.getYForTopText(1) + this.shift_y;
                i.save();
                const m = rt.create(this.textFont);
                if (n && (i.setFont(this.textFont), i.fillText(n, r, h), r += m.getWidthForTextInPx(n)), s && o) {
                    const t = Object.assign(Object.assign({}, this.textFont), {
                        weight: "normal",
                        style: "normal"
                    });
                    i.setFont(t);
                    const e = rt.create(t);
                    n && (r += e.getWidthForTextInPx("|"), i.fillText("(", r, h), r += e.getWidthForTextInPx("("));
                    const m = V.getGlyphProps(s);
                    if (r += 3 * a, Z.renderGlyph(i, r, h, b.glyph_font_scale, m.code_head), r += Z.getWidth(m.code_head, b.glyph_font_scale), m.stem) {
                        let t = 30;
                        m.beam_count && (t += 3 * (m.beam_count - 1)), t *= a;
                        const e = h - t;
                        if (i.fillRect(r - a, e, a, t), m.code && m.code_flag_upstem) {
                            const t = Z.renderGlyph(i, r, e, b.glyph_font_scale, m.code_flag_upstem, {
                                category: "flag.staveTempo"
                            });
                            r += t.width * V.NOTATION_FONT_SCALE / t.font.getData().resolution;
                        }
                    }
                    for(let t = 0; t < l; t++)r += 6 * a, i.beginPath(), i.arc(r, h + 2 * a, 2 * a, 0, 2 * Math.PI, !1), i.fill();
                    i.fillText(" = " + o + (n ? ")" : ""), r + 3 * a, h);
                }
                return i.restore(), this;
            }
        }
        ye.TEXT_FONT = {
            family: F.SERIF,
            size: 14,
            weight: E.BOLD,
            style: P.NORMAL
        }, function(t) {
            t[t.LEFT = 1] = "LEFT", t[t.CENTER = 2] = "CENTER", t[t.RIGHT = 3] = "RIGHT";
        }(ne || (ne = {}));
        class pe extends vt {
            static get CATEGORY() {
                return x.TextNote;
            }
            static get GLYPHS() {
                return {
                    segno: {
                        code: "segno"
                    },
                    tr: {
                        code: "ornamentTrill"
                    },
                    mordent: {
                        code: "ornamentMordent"
                    },
                    mordent_upper: {
                        code: "ornamentShortTrill"
                    },
                    mordent_lower: {
                        code: "ornamentMordent"
                    },
                    f: {
                        code: "dynamicForte"
                    },
                    p: {
                        code: "dynamicPiano"
                    },
                    m: {
                        code: "dynamicMezzo"
                    },
                    s: {
                        code: "dynamicSforzando"
                    },
                    z: {
                        code: "dynamicZ"
                    },
                    coda: {
                        code: "coda"
                    },
                    pedal_open: {
                        code: "keyboardPedalPed"
                    },
                    pedal_close: {
                        code: "keyboardPedalUp"
                    },
                    caesura_straight: {
                        code: "caesura"
                    },
                    caesura_curved: {
                        code: "caesuraCurved"
                    },
                    breath: {
                        code: "breathMarkComma"
                    },
                    tick: {
                        code: "breathMarkTick"
                    },
                    turn: {
                        code: "ornamentTurn"
                    },
                    turn_inverted: {
                        code: "ornamentTurnSlash"
                    }
                };
            }
            constructor(t){
                if (super(t), this.text = t.text || "", this.superscript = t.superscript, this.subscript = t.subscript, this.setFont(t.font), this.line = t.line || 0, this.smooth = t.smooth || !1, this.ignore_ticks = t.ignore_ticks || !1, this.justification = ne.LEFT, t.glyph) {
                    const e = pe.GLYPHS[t.glyph];
                    if (!e) throw new g("Invalid glyph type: " + t.glyph);
                    this.glyph = new Z(e.code, V.NOTATION_FONT_SCALE, {
                        category: "textNote"
                    }), this.setWidth(this.glyph.getMetrics().width);
                } else this.glyph = void 0;
            }
            setJustification(t) {
                return this.justification = t, this;
            }
            setLine(t) {
                return this.line = t, this;
            }
            getLine() {
                return this.line;
            }
            getText() {
                return this.text;
            }
            preFormat() {
                if (this.preFormatted) return;
                const t = this.checkTickContext("Can't preformat without a TickContext.");
                if (this.smooth) this.setWidth(0);
                else if (this.glyph) ;
                else {
                    const t = this.checkContext();
                    t.setFont(this.textFont), this.setWidth(t.measureText(this.text).width);
                }
                this.justification === ne.CENTER ? this.leftDisplacedHeadPx = this.width / 2 : this.justification === ne.RIGHT && (this.leftDisplacedHeadPx = this.width), this.rightDisplacedHeadPx = t.getMetrics().glyphPx / 2, this.preFormatted = !0;
            }
            draw() {
                const t = this.checkContext(), e = this.checkStave(), i = this.checkTickContext("Can't draw without a TickContext.");
                this.setRendered();
                let b = this.getAbsoluteX() + i.getMetrics().glyphPx / 2;
                const a = this.getWidth();
                let n;
                if (this.justification === ne.CENTER ? b -= a / 2 : this.justification === ne.RIGHT && (b -= a), this.glyph) n = e.getYForLine(this.line + -3), this.glyph.render(t, b, n);
                else {
                    n = e.getYForLine(this.line + -3), this.applyStyle(t), t.setFont(this.textFont), t.fillText(this.text, b, n);
                    const i = t.measureText(this.text).height, { family: a, size: s, weight: l, style: o } = this.textFont, r = F.scaleSize(s, .769231);
                    this.superscript && (t.setFont(a, r, l, o), t.fillText(this.superscript, b + this.width + 2, n - i / 2.2)), this.subscript && (t.setFont(a, r, l, o), t.fillText(this.subscript, b + this.width + 2, n + i / 2.2 - 1)), this.restoreStyle(t);
                }
            }
        }
        pe.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: 12,
            weight: E.NORMAL,
            style: P.NORMAL
        }, pe.Justification = ne;
        class ue extends Pt {
            static get CATEGORY() {
                return x.StaveText;
            }
            constructor(t, e, i = {}){
                super(), this.setWidth(16), this.text = t, this.position = e, this.options = Object.assign({
                    shift_x: 0,
                    shift_y: 0,
                    justification: pe.Justification.CENTER
                }, i), this.resetFont();
            }
            setStaveText(t) {
                return this.text = t, this;
            }
            setShiftX(t) {
                return this.shift_x = t, this;
            }
            setShiftY(t) {
                return this.shift_y = t, this;
            }
            setText(t) {
                return this.text = t, this;
            }
            draw(t) {
                const e = t.checkContext();
                this.setRendered(), e.save(), e.setLineWidth(2), e.setFont(this.textFont);
                const i = e.measureText("" + this.text).width;
                let b, a;
                switch(this.position){
                    case wt.LEFT:
                    case wt.RIGHT:
                        a = (t.getYForLine(0) + t.getBottomLineY()) / 2 + this.options.shift_y, b = this.position === wt.LEFT ? t.getX() - i - 24 + this.options.shift_x : t.getX() + t.getWidth() + 24 + this.options.shift_x;
                        break;
                    case wt.ABOVE:
                    case wt.BELOW:
                        b = t.getX() + this.options.shift_x, this.options.justification === ne.CENTER ? b += t.getWidth() / 2 - i / 2 : this.options.justification === ne.RIGHT && (b += t.getWidth() - i), a = this.position === wt.ABOVE ? t.getYForTopText(2) + this.options.shift_y : t.getYForBottomText(2) + this.options.shift_y;
                        break;
                    default:
                        throw new g("InvalidPosition", "Value Must be in Modifier.Position.");
                }
                return e.fillText("" + this.text, b, a + 4), e.restore(), this;
            }
        }
        ue.TEXT_FONT = {
            family: F.SERIF,
            size: 16,
            weight: E.NORMAL,
            style: P.NORMAL
        }, function(t) {
            t[t.NONE = 1] = "NONE", t[t.BEGIN = 2] = "BEGIN", t[t.MID = 3] = "MID", t[t.END = 4] = "END", t[t.BEGIN_END = 5] = "BEGIN_END";
        }(se || (se = {}));
        class fe extends Pt {
            static get CATEGORY() {
                return x.Volta;
            }
            static get type() {
                return se;
            }
            constructor(t, e, i, b){
                super(), this.volta = t, this.x = i, this.y_shift = b, this.number = e, this.resetFont();
            }
            setShiftY(t) {
                return this.y_shift = t, this;
            }
            draw(t, e) {
                const i = t.checkContext();
                this.setRendered();
                let b = t.getWidth() - e;
                const a = t.getYForTopText(t.getNumLines()) + this.y_shift, n = 1.5 * t.getSpacingBetweenLines();
                switch(this.volta){
                    case se.BEGIN:
                        i.fillRect(this.x + e, a, 1, n);
                        break;
                    case se.END:
                        b -= 5, i.fillRect(this.x + e + b, a, 1, n);
                        break;
                    case se.BEGIN_END:
                        b -= 3, i.fillRect(this.x + e, a, 1, n), i.fillRect(this.x + e + b, a, 1, n);
                }
                return this.volta !== se.BEGIN && this.volta !== se.BEGIN_END || (i.save(), i.setFont(this.textFont), i.fillText(this.number, this.x + e + 5, a + 15), i.restore()), i.fillRect(this.x + e, a, b, 1), this;
            }
        }
        fe.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: 9,
            weight: E.BOLD,
            style: P.NORMAL
        };
        class Se extends Z {
            constructor(t, e, i, b, a, n){
                var s;
                super(b, a, n), this.timeSignature = t, this.topGlyphs = [], this.botGlyphs = [];
                let l = 0, o = 0;
                for(let t = 0; t < e.length; ++t){
                    let b = e[t];
                    switch(e[t]){
                        case "-":
                            b = "Minus";
                            break;
                        case "+":
                            b = i.length > 0 ? "PlusSmall" : "Plus";
                            break;
                        case "(":
                            b = i.length > 0 ? "ParensLeftSmall" : "ParensLeft";
                            break;
                        case ")":
                            b = i.length > 0 ? "ParensRightSmall" : "ParensRight";
                    }
                    const a = new Z("timeSig" + b, this.timeSignature.point);
                    this.topGlyphs.push(a), l += null !== (s = a.getMetrics().width) && void 0 !== s ? s : 0, o = Math.max(o, a.getMetrics().height);
                }
                let r = 0;
                for(let t = 0; t < i.length; ++t){
                    let e = i[t];
                    switch(i[t]){
                        case "+":
                            e = "PlusSmall";
                            break;
                        case "(":
                            e = "ParensLeftSmall";
                            break;
                        case ")":
                            e = "ParensRightSmall";
                    }
                    const b = new Z("timeSig" + e, this.timeSignature.point);
                    this.botGlyphs.push(b), r += p(b.getMetrics().width), o = Math.max(o, b.getMetrics().height);
                }
                this.lineShift = o > 22 ? 1 : 0, this.width = Math.max(l, r), this.xMin = this.getMetrics().x_min, this.topStartX = (this.width - l) / 2, this.botStartX = (this.width - r) / 2, this.reset();
            }
            getMetrics() {
                return {
                    x_min: this.xMin,
                    x_max: this.xMin + this.width,
                    width: this.width
                };
            }
            renderToStave(t) {
                const e = this.checkStave(), i = this.checkContext();
                let b = t + this.topStartX, a = 0;
                a = this.botGlyphs.length > 0 ? e.getYForLine(this.timeSignature.topLine - this.lineShift) : (e.getYForLine(this.timeSignature.topLine) + e.getYForLine(this.timeSignature.bottomLine)) / 2;
                for(let t = 0; t < this.topGlyphs.length; ++t){
                    const e = this.topGlyphs[t];
                    Z.renderOutline(i, e.getMetrics().outline, this.scale, b + this.x_shift, a), b += p(e.getMetrics().width);
                }
                b = t + this.botStartX, a = e.getYForLine(this.timeSignature.bottomLine + this.lineShift);
                for(let t = 0; t < this.botGlyphs.length; ++t){
                    const n = this.botGlyphs[t];
                    this.timeSignature.placeGlyphOnLine(n, e, this.timeSignature.getLine()), Z.renderOutline(i, n.getMetrics().outline, this.scale, b + n.getMetrics().x_shift, a), b += p(n.getMetrics().width);
                }
            }
        }
        class Te extends Pt {
            static get CATEGORY() {
                return x.TimeSignature;
            }
            static get glyphs() {
                return {
                    C: {
                        code: "timeSigCommon",
                        line: 2
                    },
                    "C|": {
                        code: "timeSigCutCommon",
                        line: 2
                    }
                };
            }
            constructor(t = "4/4", e = 15, i = !0){
                super(), this.timeSpec = "4/4", this.line = 0, this.is_numeric = !0, this.validate_args = i;
                const b = e, a = V.currentMusicFont();
                this.point = a.lookupMetric("digits.point") || V.NOTATION_FONT_SCALE;
                const n = a.lookupMetric("digits.shiftLine", 0);
                this.topLine = 2 + n, this.bottomLine = 4 + n, this.setPosition(wt.BEGIN), this.setTimeSig(t), this.setPadding(b);
            }
            parseTimeSpec(t) {
                var e, i;
                if ("C" === t || "C|" === t) {
                    const { line: e, code: i } = Te.glyphs[t];
                    return {
                        line: e,
                        num: !1,
                        glyph: new Z(i, V.NOTATION_FONT_SCALE)
                    };
                }
                this.validate_args && ((t)=>{
                    const e = t.split("/");
                    if (2 !== e.length && "+" !== e[0] && "-" !== e[0]) throw new g("BadTimeSignature", `Invalid time spec: ${t}. Must be in the form "<numerator>/<denominator>"`);
                    e.forEach((e)=>{
                        if (0 == /^[0-9+\-()]+$/.test(e)) throw new g("BadTimeSignature", `Invalid time spec: ${t}. Must contain valid signatures.`);
                    });
                })(t);
                const b = t.split("/");
                return {
                    line: 0,
                    num: !0,
                    glyph: this.makeTimeSignatureGlyph(null !== (e = b[0]) && void 0 !== e ? e : "", null !== (i = b[1]) && void 0 !== i ? i : "")
                };
            }
            makeTimeSignatureGlyph(t, e) {
                return new Se(this, t, e, "timeSig0", this.point);
            }
            getInfo() {
                const { line: t, is_numeric: e, glyph: i } = this;
                return {
                    line: t,
                    num: e,
                    glyph: i
                };
            }
            setTimeSig(t) {
                this.timeSpec = t;
                const e = this.parseTimeSpec(t);
                return this.setGlyph(e.glyph), this.is_numeric = e.num, this.line = e.line, this;
            }
            getTimeSpec() {
                return this.timeSpec;
            }
            getLine() {
                return this.line;
            }
            setLine(t) {
                this.line = t;
            }
            getGlyph() {
                return this.glyph;
            }
            setGlyph(t) {
                this.glyph = t, this.setWidth(p(this.glyph.getMetrics().width));
            }
            getIsNumeric() {
                return this.is_numeric;
            }
            setIsNumeric(t) {
                this.is_numeric = t;
            }
            draw() {
                const t = this.checkStave(), e = t.checkContext();
                this.setRendered(), this.applyStyle(e), e.openGroup("timesignature", this.getAttribute("id")), this.glyph.setStave(t), this.glyph.setContext(e), this.placeGlyphOnLine(this.glyph, t, this.line), this.glyph.renderToStave(this.x), e.closeGroup(), this.restoreStyle(e);
            }
        }
        const ve = {
            [kt.CATEGORY]: 0,
            [de.CATEGORY]: 1,
            [_e.CATEGORY]: 2,
            [Te.CATEGORY]: 3
        }, we = {
            [Te.CATEGORY]: 0,
            [_e.CATEGORY]: 1,
            [kt.CATEGORY]: 2,
            [de.CATEGORY]: 3
        };
        class ze extends R {
            static get CATEGORY() {
                return x.Stave;
            }
            static get defaultPadding() {
                const t = V.currentMusicFont();
                return t.lookupMetric("stave.padding") + t.lookupMetric("stave.endPaddingMax");
            }
            static get rightPadding() {
                return V.currentMusicFont().lookupMetric("stave.endPaddingMax");
            }
            constructor(t, e, i, b){
                super(), this.height = 0, this.x = t, this.y = e, this.width = i, this.formatted = !1, this.start_x = t + 5, this.end_x = t + i, this.modifiers = [], this.measure = 0, this.clef = "treble", this.endClef = void 0, this.resetFont(), this.options = Object.assign({
                    vertical_bar_width: 10,
                    num_lines: 5,
                    fill_style: "#999999",
                    left_bar: !0,
                    right_bar: !0,
                    spacing_between_lines_px: V.STAVE_LINE_DISTANCE,
                    space_above_staff_ln: 4,
                    space_below_staff_ln: 4,
                    top_text_position: 1,
                    bottom_text_position: 4,
                    line_config: []
                }, b), this.bounds = {
                    x: this.x,
                    y: this.y,
                    w: this.width,
                    h: 0
                }, this.defaultLedgerLineStyle = {
                    strokeStyle: "#444",
                    lineWidth: 1.4
                }, this.resetLines(), this.addModifier(new kt(this.options.left_bar ? zt.SINGLE : zt.NONE)), this.addEndModifier(new kt(this.options.right_bar ? zt.SINGLE : zt.NONE));
            }
            setDefaultLedgerLineStyle(t) {
                this.defaultLedgerLineStyle = t;
            }
            getDefaultLedgerLineStyle() {
                return Object.assign(Object.assign({}, this.getStyle()), this.defaultLedgerLineStyle);
            }
            space(t) {
                return this.options.spacing_between_lines_px * t;
            }
            resetLines() {
                this.options.line_config = [];
                for(let t = 0; t < this.options.num_lines; t++)this.options.line_config.push({
                    visible: !0
                });
                this.height = (this.options.num_lines + this.options.space_above_staff_ln) * this.options.spacing_between_lines_px, this.options.bottom_text_position = this.options.num_lines;
            }
            setNoteStartX(t) {
                return this.formatted || this.format(), this.start_x = t, this;
            }
            getNoteStartX() {
                return this.formatted || this.format(), this.start_x;
            }
            getNoteEndX() {
                return this.formatted || this.format(), this.end_x;
            }
            getTieStartX() {
                return this.start_x;
            }
            getTieEndX() {
                return this.end_x;
            }
            getX() {
                return this.x;
            }
            getNumLines() {
                return this.options.num_lines;
            }
            setNumLines(t) {
                return this.options.num_lines = t, this.resetLines(), this;
            }
            setY(t) {
                return this.y = t, this;
            }
            getY() {
                return this.y;
            }
            getTopLineTopY() {
                return this.getYForLine(0) - V.STAVE_LINE_THICKNESS / 2;
            }
            getBottomLineBottomY() {
                return this.getYForLine(this.getNumLines() - 1) + V.STAVE_LINE_THICKNESS / 2;
            }
            setX(t) {
                const e = t - this.x;
                this.formatted = !1, this.x = t, this.start_x += e, this.end_x += e;
                for(let t = 0; t < this.modifiers.length; t++){
                    const i = this.modifiers[t];
                    i.setX(i.getX() + e);
                }
                return this;
            }
            setWidth(t) {
                return this.formatted = !1, this.width = t, this.end_x = this.x + t, this;
            }
            getWidth() {
                return this.width;
            }
            getStyle() {
                return Object.assign({
                    fillStyle: this.options.fill_style,
                    strokeStyle: this.options.fill_style,
                    lineWidth: V.STAVE_LINE_THICKNESS
                }, super.getStyle());
            }
            setMeasure(t) {
                return this.measure = t, this;
            }
            getMeasure() {
                return this.measure;
            }
            getModifierXShift(t = 0) {
                if ("number" != typeof t) throw new g("InvalidIndex", "Must be of number type");
                if (this.formatted || this.format(), 1 === this.getModifiers(wt.BEGIN).length) return 0;
                if (this.modifiers[t].getPosition() === wt.RIGHT) return 0;
                let e = this.start_x - this.x;
                const i = this.modifiers[0];
                return i.getType() === zt.REPEAT_BEGIN && e > i.getWidth() && (e -= i.getWidth()), e;
            }
            setRepetitionType(t, e = 0) {
                return this.modifiers.push(new xe(t, this.x, e)), this;
            }
            setVoltaType(t, e, i) {
                return this.modifiers.push(new fe(t, e, this.x, i)), this;
            }
            setSection(t, e, i = 0, b, a = !0) {
                const n = new ge(t, this.x + i, e, a);
                return b && n.setFontSize(b), this.modifiers.push(n), this;
            }
            setTempo(t, e) {
                return this.modifiers.push(new ye(t, this.x, e)), this;
            }
            setText(t, e, i = {}) {
                return this.modifiers.push(new ue(t, e, i)), this;
            }
            getHeight() {
                return this.height;
            }
            getSpacingBetweenLines() {
                return this.options.spacing_between_lines_px;
            }
            getBoundingBox() {
                return new D(this.x, this.y, this.width, this.getBottomY() - this.y);
            }
            getBottomY() {
                const t = this.options, e = t.spacing_between_lines_px;
                return this.getYForLine(t.num_lines) + t.space_below_staff_ln * e;
            }
            getBottomLineY() {
                return this.getYForLine(this.options.num_lines);
            }
            getYForLine(t) {
                const e = this.options, i = e.spacing_between_lines_px, b = e.space_above_staff_ln;
                return this.y + t * i + b * i;
            }
            getLineForY(t) {
                const e = this.options, i = e.spacing_between_lines_px, b = e.space_above_staff_ln;
                return (t - this.y) / i - b;
            }
            getYForTopText(t = 0) {
                return this.getYForLine(-t - this.options.top_text_position);
            }
            getYForBottomText(t = 0) {
                return this.getYForLine(this.options.bottom_text_position + t);
            }
            getYForNote(t) {
                const e = this.options, i = e.spacing_between_lines_px, b = e.space_above_staff_ln;
                return this.y + b * i + 5 * i - t * i;
            }
            getYForGlyphs() {
                return this.getYForLine(3);
            }
            addModifier(t, e) {
                return void 0 !== e && t.setPosition(e), t.setStave(this), this.formatted = !1, this.modifiers.push(t), this;
            }
            addEndModifier(t) {
                return this.addModifier(t, wt.END), this;
            }
            setBegBarType(t) {
                const { SINGLE: e, REPEAT_BEGIN: i, NONE: b } = zt;
                return t !== e && t !== i && t !== b || (this.modifiers[0].setType(t), this.formatted = !1), this;
            }
            setEndBarType(t) {
                return t !== zt.REPEAT_BEGIN && (this.modifiers[1].setType(t), this.formatted = !1), this;
            }
            setClefLines(t) {
                return this.clef = t, this;
            }
            setClef(t, e, i, b) {
                void 0 === b && (b = wt.BEGIN), b === wt.END ? this.endClef = t : this.clef = t;
                const a = this.getModifiers(b, de.CATEGORY);
                return 0 === a.length ? this.addClef(t, e, i, b) : a[0].setType(t, e, i), this;
            }
            getClef() {
                return this.clef;
            }
            setEndClef(t, e, i) {
                return this.setClef(t, e, i, wt.END), this;
            }
            getEndClef() {
                return this.endClef;
            }
            setKeySignature(t, e, i) {
                void 0 === i && (i = wt.BEGIN);
                const b = this.getModifiers(i, _e.CATEGORY);
                return 0 === b.length ? this.addKeySignature(t, e, i) : b[0].setKeySig(t, e), this;
            }
            setEndKeySignature(t, e) {
                return this.setKeySignature(t, e, wt.END), this;
            }
            setTimeSignature(t, e, i) {
                void 0 === i && (i = wt.BEGIN);
                const b = this.getModifiers(i, Te.CATEGORY);
                return 0 === b.length ? this.addTimeSignature(t, e, i) : b[0].setTimeSig(t), this;
            }
            setEndTimeSignature(t, e) {
                return this.setTimeSignature(t, e, wt.END), this;
            }
            addKeySignature(t, e, i) {
                return void 0 === i && (i = wt.BEGIN), this.addModifier(new _e(t, e).setPosition(i), i), this;
            }
            addClef(t, e, i, b) {
                return void 0 === b || b === wt.BEGIN ? this.clef = t : b === wt.END && (this.endClef = t), this.addModifier(new de(t, e, i), b), this;
            }
            addEndClef(t, e, i) {
                return this.addClef(t, e, i, wt.END), this;
            }
            addTimeSignature(t, e, i) {
                return this.addModifier(new Te(t, e), i), this;
            }
            addEndTimeSignature(t, e) {
                return this.addTimeSignature(t, e, wt.END), this;
            }
            addTrebleGlyph() {
                return this.addClef("treble"), this;
            }
            getModifiers(t, e) {
                const i = void 0 === t, b = void 0 === e;
                return i && b ? this.modifiers : i ? this.modifiers.filter((t)=>e === t.getCategory()) : b ? this.modifiers.filter((e)=>t === e.getPosition()) : this.modifiers.filter((i)=>t === i.getPosition() && e === i.getCategory());
            }
            sortByCategory(t, e) {
                for(let i = t.length - 1; i >= 0; i--)for(let b = 0; b < i; b++)if (e[t[b].getCategory()] > e[t[b + 1].getCategory()]) {
                    const e = t[b];
                    t[b] = t[b + 1], t[b + 1] = e;
                }
            }
            format() {
                const t = this.modifiers[0], e = this.modifiers[1], i = this.getModifiers(wt.BEGIN), b = this.getModifiers(wt.END);
                let a, n, l;
                this.sortByCategory(i, ve), this.sortByCategory(b, we), i.length > 1 && t.getType() === zt.REPEAT_BEGIN && (i.push(i.splice(0, 1)[0]), i.splice(0, 0, new kt(zt.SINGLE))), b.indexOf(e) > 0 && b.splice(0, 0, new kt(zt.NONE));
                let o = 0, r = this.x;
                for(let t = 0; t < i.length; t++)l = i[t], n = l.getPadding(t + o), a = l.getWidth(), r += n, l.setX(r), r += a, n + a === 0 && o--;
                this.start_x = r, r = this.x + this.width;
                const h = {
                    left: 0,
                    right: 0,
                    paddingRight: 0,
                    paddingLeft: 0
                };
                let m = 0;
                for(let t = 0; t < b.length; t++){
                    l = b[t], m = s(l) ? t : m, h.right = 0, h.left = 0, h.paddingRight = 0, h.paddingLeft = 0;
                    const e = l.getLayoutMetrics();
                    e ? (0 !== t && (h.right = e.xMax || 0, h.paddingRight = e.paddingRight || 0), h.left = -e.xMin || 0, h.paddingLeft = e.paddingLeft || 0, t === b.length - 1 && (h.paddingLeft = 0)) : (h.paddingRight = l.getPadding(t - m), 0 !== t && (h.right = l.getWidth()), 0 === t && (h.left = l.getWidth())), r -= h.paddingRight, r -= h.right, l.setX(r), r -= h.left, r -= h.paddingLeft;
                }
                this.end_x = 1 === b.length ? this.x + this.width : r, this.formatted = !0;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered(), this.applyStyle(), t.openGroup("stave", this.getAttribute("id")), this.formatted || this.format();
                const e = this.options.num_lines, i = this.width, b = this.x;
                let a;
                for(let n = 0; n < e; n++)a = this.getYForLine(n), this.options.line_config[n].visible && (t.beginPath(), t.moveTo(b, a), t.lineTo(b + i, a), t.stroke());
                t.closeGroup(), this.restoreStyle();
                for(let e = 0; e < this.modifiers.length; e++){
                    const i = this.modifiers[e];
                    "function" == typeof i.draw && (i.applyStyle(t), i.draw(this, this.getModifierXShift(e)), i.restoreStyle(t));
                }
                if (this.measure > 0) {
                    t.save(), t.setFont(this.textFont);
                    const e = t.measureText("" + this.measure).width;
                    a = this.getYForTopText(0) + 3, t.fillText("" + this.measure, this.x - e / 2, a), t.restore();
                }
                return this;
            }
            getVerticalBarWidth() {
                return this.options.vertical_bar_width;
            }
            getConfigForLines() {
                return this.options.line_config;
            }
            setConfigForLine(t, e) {
                if (t >= this.options.num_lines || t < 0) throw new g("StaveConfigError", "The line number must be within the range of the number of lines in the Stave.");
                if (void 0 === e.visible) throw new g("StaveConfigError", "The line configuration object is missing the 'visible' property.");
                if ("boolean" != typeof e.visible) throw new g("StaveConfigError", "The line configuration objects 'visible' property must be true or false.");
                return this.options.line_config[t] = e, this;
            }
            setConfigForLines(t) {
                if (t.length !== this.options.num_lines) throw new g("StaveConfigError", "The length of the lines configuration array must match the number of lines in the Stave");
                for(const e in t)null == t[e].visible && (t[e] = this.options.line_config[e]), this.options.line_config[e] = Object.assign(Object.assign({}, this.options.line_config[e]), t[e]);
                return this.options.line_config = t, this;
            }
            static formatBegModifiers(t) {
                const e = (e)=>{
                    let i = 0;
                    t.forEach((t)=>{
                        const b = t.getModifiers(wt.BEGIN, e);
                        b.length > 0 && b[0].getX() > i && (i = b[0].getX());
                    });
                    let b = 0;
                    t.forEach((t)=>{
                        b = 0;
                        t.getModifiers(wt.BEGIN, e).forEach((t)=>{
                            i - t.getX() > b && (b = i - t.getX());
                        });
                        const a = t.getModifiers(wt.BEGIN);
                        let n = !1;
                        a.forEach((t)=>{
                            t.getCategory() === e && (n = !0), n && b > 0 && t.setX(t.getX() + b);
                        }), t.setNoteStartX(t.getNoteStartX() + b);
                    });
                };
                t.forEach((t)=>{
                    t.formatted || t.format();
                }), e(x.Clef), e(x.KeySignature), e(x.TimeSignature);
                let i = 0;
                t.forEach((t)=>{
                    t.getNoteStartX() > i && (i = t.getNoteStartX());
                }), t.forEach((t)=>{
                    t.setNoteStartX(i);
                }), i = 0, t.forEach((t)=>{
                    t.getModifiers(wt.BEGIN, x.Barline).forEach((t)=>{
                        t.getType() == zt.REPEAT_BEGIN && t.getX() > i && (i = t.getX());
                    });
                }), t.forEach((t)=>{
                    t.getModifiers(wt.BEGIN, x.Barline).forEach((t)=>{
                        t.getType() == zt.REPEAT_BEGIN && t.setX(i);
                    });
                });
            }
        }
        function Be(t, e, i, b, a) {
            if (e !== De.type.BOLD_DOUBLE_LEFT && e !== De.type.BOLD_DOUBLE_RIGHT) throw new g("InvalidConnector", "A REPEAT_BEGIN or REPEAT_END type must be provided.");
            let n = 3, s = 3.5;
            e === De.type.BOLD_DOUBLE_RIGHT && (n = -5, s = 3), t.fillRect(i + n, b, 1, a - b), t.fillRect(i - 2, b, s, a - b);
        }
        ze.TEXT_FONT = {
            family: F.SANS_SERIF,
            size: 8,
            weight: E.NORMAL,
            style: P.NORMAL
        };
        class De extends R {
            static get CATEGORY() {
                return x.StaveConnector;
            }
            constructor(t, e){
                super(), this.thickness = V.STAVE_LINE_THICKNESS, this.width = 3, this.top_stave = t, this.bottom_stave = e, this.type = De.type.DOUBLE, this.resetFont(), this.x_shift = 0, this.texts = [];
            }
            setType(t) {
                const e = "string" == typeof t ? De.typeString[t] : t;
                return Object.values(De.type).includes(e) && (this.type = e), this;
            }
            getType() {
                return this.type;
            }
            setText(t, e = {}) {
                return this.texts.push({
                    content: t,
                    options: Object.assign({
                        shift_x: 0,
                        shift_y: 0
                    }, e)
                }), this;
            }
            setXShift(t) {
                if ("number" != typeof t) throw new g("InvalidType", "x_shift must be a Number");
                return this.x_shift = t, this;
            }
            getXShift() {
                return this.x_shift;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                let e = this.top_stave.getYForLine(0), i = this.bottom_stave.getYForLine(this.bottom_stave.getNumLines() - 1) + this.thickness, b = this.width, a = this.top_stave.getX();
                (this.type === De.type.SINGLE_RIGHT || this.type === De.type.BOLD_DOUBLE_RIGHT || this.type === De.type.THIN_DOUBLE) && (a = this.top_stave.getX() + this.top_stave.getWidth());
                let n = i - e;
                switch(this.type){
                    case De.type.SINGLE:
                    case De.type.SINGLE_LEFT:
                    case De.type.SINGLE_RIGHT:
                        b = 1;
                        break;
                    case De.type.DOUBLE:
                        a -= this.width + 2, e -= this.thickness, n += .5;
                        break;
                    case De.type.BRACE:
                        {
                            b = 12;
                            const a = this.top_stave.getX() - 2 + this.x_shift, s = e, l = a, o = i, r = a - b, h = s + n / 2, m = r - .9 * b, c = s + .2 * n, d = a + 1.1 * b, _ = h - .135 * n, x = d, g = h + .135 * n, y = m, p = o - .2 * n, u = r - b, f = p, S = a + .4 * b, T = h + .135 * n, v = S, w = h - .135 * n, z = u, B = c;
                            t.beginPath(), t.moveTo(a, s), t.bezierCurveTo(m, c, d, _, r, h), t.bezierCurveTo(x, g, y, p, l, o), t.bezierCurveTo(u, f, S, T, r, h), t.bezierCurveTo(v, w, z, B, a, s), t.fill(), t.stroke();
                            break;
                        }
                    case De.type.BRACKET:
                        e -= 6, i += 6, n = i - e, Z.renderGlyph(t, a - 5, e, 40, "bracketTop"), Z.renderGlyph(t, a - 5, i, 40, "bracketBottom"), a -= this.width + 2;
                        break;
                    case De.type.BOLD_DOUBLE_LEFT:
                        Be(t, this.type, a + this.x_shift, e, i - this.thickness);
                        break;
                    case De.type.BOLD_DOUBLE_RIGHT:
                        Be(t, this.type, a, e, i - this.thickness);
                        break;
                    case De.type.THIN_DOUBLE:
                        b = 1, n -= this.thickness;
                        break;
                    case De.type.NONE:
                        break;
                    default:
                        throw new g("InvalidType", `The provided StaveConnector.type (${this.type}) is invalid.`);
                }
                this.type !== De.type.BRACE && this.type !== De.type.BOLD_DOUBLE_LEFT && this.type !== De.type.BOLD_DOUBLE_RIGHT && this.type !== De.type.NONE && t.fillRect(a, e, b, n), this.type === De.type.THIN_DOUBLE && t.fillRect(a - 3, e, b, n), t.save(), t.setLineWidth(2), t.setFont(this.textFont);
                for(let e = 0; e < this.texts.length; e++){
                    const i = this.texts[e], b = t.measureText("" + i.content).width, a = this.top_stave.getX() - b - 24 + i.options.shift_x, n = (this.top_stave.getYForLine(0) + this.bottom_stave.getBottomLineY()) / 2 + i.options.shift_y;
                    t.fillText("" + i.content, a, n + 4);
                }
                t.restore();
            }
        }
        De.TEXT_FONT = {
            family: F.SERIF,
            size: 16,
            weight: E.NORMAL,
            style: P.NORMAL
        }, De.type = {
            SINGLE_RIGHT: 0,
            SINGLE_LEFT: 1,
            SINGLE: 1,
            DOUBLE: 2,
            BRACE: 3,
            BRACKET: 4,
            BOLD_DOUBLE_LEFT: 5,
            BOLD_DOUBLE_RIGHT: 6,
            THIN_DOUBLE: 7,
            NONE: 8
        }, De.typeString = {
            singleRight: De.type.SINGLE_RIGHT,
            singleLeft: De.type.SINGLE_LEFT,
            single: De.type.SINGLE,
            double: De.type.DOUBLE,
            brace: De.type.BRACE,
            bracket: De.type.BRACKET,
            boldDoubleLeft: De.type.BOLD_DOUBLE_LEFT,
            boldDoubleRight: De.type.BOLD_DOUBLE_RIGHT,
            thinDouble: De.type.THIN_DOUBLE,
            none: De.type.NONE
        };
        class Ce {
            static getNextContext(t) {
                const e = t.tContexts, i = e.indexOf(t);
                if (i + 1 < e.length) return e[i + 1];
            }
            constructor(t){
                this.preFormatted = !1, this.postFormatted = !1, this.tickID = t && t.tickID ? t.tickID : 0, this.currentTick = new z(0, 1), this.maxTicks = new z(0, 1), this.maxTickable = void 0, this.minTicks = void 0, this.minTickable = void 0, this.padding = 1, this.x = 0, this.xBase = 0, this.xOffset = 0, this.tickables = [], this.tickablesByVoice = {}, this.notePx = 0, this.glyphPx = 0, this.leftDisplacedHeadPx = 0, this.rightDisplacedHeadPx = 0, this.modLeftPx = 0, this.modRightPx = 0, this.totalLeftPx = 0, this.totalRightPx = 0, this.tContexts = [], this.width = 0, this.formatterMetrics = {
                    freedom: {
                        left: 0,
                        right: 0
                    }
                };
            }
            getTickID() {
                return this.tickID;
            }
            getX() {
                return this.x;
            }
            setX(t) {
                return this.x = t, this.xBase = t, this.xOffset = 0, this;
            }
            getXBase() {
                return this.xBase;
            }
            setXBase(t) {
                this.xBase = t, this.x = t + this.xOffset;
            }
            getXOffset() {
                return this.xOffset;
            }
            setXOffset(t) {
                this.xOffset = t, this.x = this.xBase + t;
            }
            getWidth() {
                return this.width + 2 * this.padding;
            }
            setPadding(t) {
                return this.padding = t, this;
            }
            getMaxTicks() {
                return this.maxTicks;
            }
            getMinTicks() {
                return this.minTicks;
            }
            getMaxTickable() {
                return this.maxTickable;
            }
            getMinTickable() {
                return this.minTickable;
            }
            getTickables() {
                return this.tickables;
            }
            getTickableForVoice(t) {
                return this.tickablesByVoice[t];
            }
            getTickablesByVoice() {
                return this.tickablesByVoice;
            }
            getCenterAlignedTickables() {
                return this.tickables.filter((t)=>t.isCenterAligned());
            }
            getMetrics() {
                const { width: t, glyphPx: e, notePx: i, leftDisplacedHeadPx: b, rightDisplacedHeadPx: a, modLeftPx: n, modRightPx: s, totalLeftPx: l, totalRightPx: o } = this;
                return {
                    width: t,
                    glyphPx: e,
                    notePx: i,
                    leftDisplacedHeadPx: b,
                    rightDisplacedHeadPx: a,
                    modLeftPx: n,
                    modRightPx: s,
                    totalLeftPx: l,
                    totalRightPx: o
                };
            }
            getCurrentTick() {
                return this.currentTick;
            }
            setCurrentTick(t) {
                this.currentTick = t, this.preFormatted = !1;
            }
            addTickable(t, e) {
                if (!t) throw new g("BadArgument", "Invalid tickable added.");
                if (!t.shouldIgnoreTicks()) {
                    const e = t.getTicks();
                    e.greaterThan(this.maxTicks) && (this.maxTicks = e.clone(), this.maxTickable = t), (null == this.minTicks || e.lessThan(this.minTicks)) && (this.minTicks = e.clone(), this.minTickable = t);
                }
                return t.setTickContext(this), this.tickables.push(t), this.tickablesByVoice[e || 0] = t, this.preFormatted = !1, this;
            }
            preFormat() {
                if (this.preFormatted) return this;
                for(let t = 0; t < this.tickables.length; ++t){
                    const e = this.tickables[t];
                    e.preFormat();
                    const i = e.getMetrics();
                    this.leftDisplacedHeadPx = Math.max(this.leftDisplacedHeadPx, i.leftDisplacedHeadPx), this.rightDisplacedHeadPx = Math.max(this.rightDisplacedHeadPx, i.rightDisplacedHeadPx), this.notePx = Math.max(this.notePx, i.notePx), this.glyphPx = Math.max(this.glyphPx, i.glyphWidth || 0), this.modLeftPx = Math.max(this.modLeftPx, i.modLeftPx), this.modRightPx = Math.max(this.modRightPx, i.modRightPx), this.totalLeftPx = Math.max(this.totalLeftPx, i.modLeftPx + i.leftDisplacedHeadPx), this.totalRightPx = Math.max(this.totalRightPx, i.modRightPx + i.rightDisplacedHeadPx), this.width = this.notePx + this.totalLeftPx + this.totalRightPx;
                }
                return this;
            }
            postFormat() {
                return this.postFormatted || (this.postFormatted = !0), this;
            }
            getFormatterMetrics() {
                return this.formatterMetrics;
            }
        }
        function Ee(t, e, i, b) {
            let a = e;
            for(let e = i + 1; e < t.length; e++){
                const i = t[e];
                if (h(i) && !i.isRest() && !i.shouldIgnoreTicks()) {
                    a = i.getLineForRest();
                    break;
                }
            }
            if (b && e !== a) a = S(Math.max(e, a), Math.min(e, a));
            return a;
        }
        class Pe {
            static SimpleFormat(t, e = 0, { paddingBetween: i = 10 } = {}) {
                t.reduce((t, e)=>{
                    e.addToModifierContext(new ce);
                    const b = (new Ce).addTickable(e).preFormat(), a = b.getMetrics();
                    return b.setX(t + a.totalLeftPx), t + b.getWidth() + a.totalRightPx + i;
                }, e);
            }
            static plotDebugging(t, e, i, b, a, n) {
                const s = i + (n = Object.assign({
                    stavePadding: V.currentMusicFont().lookupMetric("stave.padding")
                }, n)).stavePadding, l = e.contextGaps;
                t.save(), t.setFont(F.SANS_SERIF, 8), l.gaps.forEach((e)=>{
                    var i, n, l;
                    i = s + e.x1, n = s + e.x2, l = "rgba(100,200,100,0.4)", t.beginPath(), t.setStrokeStyle(l), t.setFillStyle(l), t.setLineWidth(1), t.fillRect(i, b, Math.max(n - i, 0), a - b), t.setFillStyle("green"), t.fillText(Math.round(e.x2 - e.x1).toString(), s + e.x1, a + 12);
                }), t.setFillStyle("red"), t.fillText(`Loss: ${(e.totalCost || 0).toFixed(2)} Shift: ${(e.totalShift || 0).toFixed(2)} Gap: ${l.total.toFixed(2)}`, s - 20, a + 27), t.restore();
            }
            static FormatAndDraw(t, e, i, b) {
                let a = {
                    auto_beam: !1,
                    align_rests: !1
                };
                "object" == typeof b ? a = Object.assign(Object.assign({}, a), b) : "boolean" == typeof b && (a.auto_beam = b);
                const n = new Xt(V.TIME4_4).setMode(Xt.Mode.SOFT).addTickables(i), s = a.auto_beam ? Re.applyAndGetBeams(n) : [];
                return (new Pe).joinVoices([
                    n
                ]).formatToStave([
                    n
                ], e, {
                    align_rests: a.align_rests,
                    stave: e
                }), n.setStave(e).draw(t, e), s.forEach((e)=>e.setContext(t).draw()), n.getBoundingBox();
            }
            static FormatAndDrawTab(t, e, i, b, a, n, s) {
                let l = {
                    auto_beam: n,
                    align_rests: !1
                };
                "object" == typeof s ? l = Object.assign(Object.assign({}, l), s) : "boolean" == typeof s && (l.auto_beam = s);
                const o = new Xt(V.TIME4_4).setMode(Xt.Mode.SOFT).addTickables(a), r = new Xt(V.TIME4_4).setMode(Xt.Mode.SOFT).addTickables(b), h = l.auto_beam ? Re.applyAndGetBeams(o) : [];
                (new Pe).joinVoices([
                    o
                ]).joinVoices([
                    r
                ]).formatToStave([
                    o,
                    r
                ], i, {
                    align_rests: l.align_rests
                }), o.draw(t, i), r.draw(t, e), h.forEach((e)=>e.setContext(t).draw()), new De(i, e).setContext(t).draw();
            }
            static AlignRestsToNotes(t, e, i) {
                t.forEach((b, a)=>{
                    if (c(b) && b.isRest()) {
                        if (b.getTuplet() && !i) return;
                        const n = b.getGlyphProps().position.toUpperCase();
                        if ("R/4" !== n && "B/4" !== n) return;
                        if (e || b.getBeam()) {
                            const e = b.getKeyProps()[0];
                            if (0 === a) e.line = Ee(t, e.line, a, !1);
                            else if (a > 0 && a < t.length) {
                                const i = t[a - 1];
                                if (c(i)) {
                                    if (i.isRest()) e.line = i.getKeyProps()[0].line;
                                    else {
                                        const b = i.getLineForRest();
                                        e.line = Ee(t, b, a, !0);
                                    }
                                }
                            }
                            b.setKeyLine(0, e.line);
                        }
                    }
                });
            }
            constructor(t){
                this.formatterOptions = Object.assign({
                    globalSoftmax: !1,
                    softmaxFactor: V.SOFTMAX_FACTOR,
                    maxIterations: 5
                }, t), this.justifyWidth = 0, this.totalCost = 0, this.totalShift = 0, this.durationStats = {}, this.minTotalWidth = 0, this.hasMinTotalWidth = !1, this.tickContexts = {
                    map: {},
                    array: [],
                    list: [],
                    resolutionMultiplier: 0
                }, this.modifierContexts = [], this.contextGaps = {
                    total: 0,
                    gaps: []
                }, this.voices = [], this.lossHistory = [];
            }
            alignRests(t, e) {
                if (!t || !t.length) throw new g("BadArgument", "No voices to format rests");
                t.forEach((t)=>Pe.AlignRestsToNotes(t.getTickables(), e));
            }
            preCalculateMinTotalWidth(t) {
                const e = V.currentMusicFont().lookupMetric("stave.unalignedNotePadding");
                let i = 0, b = 0, a = 0;
                const n = [], s = [];
                if (this.hasMinTotalWidth) return this.minTotalWidth;
                if (!t) throw new g("BadArgument", "'voices' required to run preCalculateMinTotalWidth");
                this.createTickContexts(t);
                const { list: l, map: o } = this.tickContexts;
                this.minTotalWidth = 0, l.forEach((e)=>{
                    const l = o[e];
                    l.preFormat(), l.getTickables().length < t.length && (i += 1), l.getTickables().forEach((t)=>{
                        b += t.getMetrics().width, a += t.getTicks().value(), n.push(t.getMetrics().width), s.push(t.getTicks().value());
                    });
                    const r = l.getWidth();
                    this.minTotalWidth += r;
                }), this.hasMinTotalWidth = !0;
                const r = b > 0 ? b / n.length : 1 / n.length, h = w(n.map((t)=>Math.pow(t - r, 2))), m = Math.pow(h / n.length, .5) / r, c = a / s.length, d = w(s.map((t)=>Math.pow(t - c, 2))), _ = Math.pow(d / s.length, .5) / c, x = Math.max(_, m) * l.length * e, y = e * i;
                return this.minTotalWidth + Math.max(y, x);
            }
            getMinTotalWidth() {
                if (!this.hasMinTotalWidth) throw new g("NoMinTotalWidth", "Call 'preCalculateMinTotalWidth' or 'preFormat' before calling 'getMinTotalWidth'");
                return this.minTotalWidth;
            }
            static getResolutionMultiplier(t) {
                if (!t || !t.length) throw new g("BadArgument", "No voices to format");
                const e = t[0].getTotalTicks();
                return t.reduce((t, i)=>{
                    if (!i.getTotalTicks().equals(e)) throw new g("TickMismatch", "Voices should have same total note duration in ticks.");
                    if (i.getMode() === Xt.Mode.STRICT && !i.isComplete()) throw new g("IncompleteVoice", "Voice does not have enough notes.");
                    return Math.max(t, z.LCM(t, i.getResolutionMultiplier()));
                }, 1);
            }
            createModifierContexts(t) {
                if (0 == t.length) return;
                const e = Pe.getResolutionMultiplier(t), i = new Map, b = [];
                t.forEach((t)=>{
                    const a = new z(0, e);
                    t.getTickables().forEach((t)=>{
                        const e = a.numerator;
                        let n = i.get(t.getStave());
                        if (n || (i.set(t.getStave(), {}), n = i.get(t.getStave())), !(n ? n[e] : void 0)) {
                            const t = new ce;
                            b.push(t), n[e] = t;
                        }
                        t.addToModifierContext(n[e]), a.add(t.getTicks());
                    });
                }), this.modifierContexts.push({
                    map: i,
                    array: b,
                    resolutionMultiplier: e
                });
            }
            createTickContexts(t) {
                const e = function(t, e, i) {
                    if (0 == t.length) return {
                        map: {},
                        array: [],
                        list: [],
                        resolutionMultiplier: 0
                    };
                    const b = {}, a = [], n = [], s = Pe.getResolutionMultiplier(t);
                    return t.forEach((t, l)=>{
                        const o = new z(0, s);
                        t.getTickables().forEach((t)=>{
                            const s = o.numerator;
                            if (!b[s]) {
                                const t = e({
                                    tickID: s
                                });
                                n.push(t), b[s] = t, a.push(s);
                            }
                            i(t, b[s], l), o.add(t.getTicks());
                        });
                    }), {
                        map: b,
                        array: n,
                        list: a.sort((t, e)=>t - e),
                        resolutionMultiplier: s
                    };
                }(t, (t)=>new Ce(t), (t, e, i)=>e.addTickable(t, i));
                this.tickContexts = e;
                const i = this.tickContexts.array;
                return i.forEach((t)=>{
                    t.tContexts = i;
                }), e;
            }
            getTickContexts() {
                return this.tickContexts;
            }
            preFormat(t = 0, e, i, b) {
                const a = this.tickContexts;
                if (!a) throw new g("NoTickContexts", "preFormat requires TickContexts");
                const { list: n, map: s } = a;
                this.lossHistory = [], i && b && i.forEach((t)=>t.setStave(b).preFormat());
                let l = 0, o = 0;
                this.minTotalWidth = 0;
                let r = 0;
                n.forEach((t)=>{
                    const e = s[t];
                    e.preFormat();
                    const i = e.getWidth();
                    this.minTotalWidth += i;
                    const b = e.getMaxTicks().value();
                    r += b;
                    const a = e.getMetrics();
                    l = l + o + a.totalLeftPx, e.setX(l), o = i - a.totalLeftPx;
                });
                const { globalSoftmax: h, softmaxFactor: m, maxIterations: c } = this.formatterOptions, d = w(n.map((t)=>Math.pow(m, s[t].getMaxTicks().value() / r)));
                if (this.minTotalWidth = l + o, this.hasMinTotalWidth = !0, t <= 0) return this.evaluate();
                const _ = s[n[0]], x = s[n[n.length - 1]];
                function y(t) {
                    return n.map((e, i)=>{
                        const b = s[e], a = b.getTickablesByVoice();
                        let l;
                        if (i > 0) {
                            const e = s[n[i - 1]];
                            for(let o = i - 1; o >= 0; o--){
                                const i = s[n[o]].getTickablesByVoice(), c = [];
                                if (Object.keys(a).forEach((t)=>{
                                    i[t] && c.push(t);
                                }), c.length > 0) {
                                    let n = 0, s = 1 / 0, o = 0;
                                    if (c.forEach((t)=>{
                                        const e = i[t].getTicks().value();
                                        e > n && (l = i[t], n = e);
                                        const b = a[t], o = b.getX() - (b.getMetrics().modLeftPx + b.getMetrics().leftDisplacedHeadPx), r = i[t].getMetrics(), h = i[t].getX() + r.notePx + r.modRightPx + r.rightDisplacedHeadPx;
                                        s = Math.min(s, o - h);
                                    }), s = Math.min(s, b.getX() - (e.getX() + .05 * t)), h) {
                                        const e = r;
                                        o = Math.pow(m, n / e) / d * t;
                                    } else void 0 !== l && (o = l.getVoice().softmax(n) * t);
                                    return {
                                        expectedDistance: o,
                                        maxNegativeShiftPx: s,
                                        fromTickable: l
                                    };
                                }
                            }
                        }
                        return {
                            expectedDistance: 0,
                            fromTickablePx: 0,
                            maxNegativeShiftPx: 0
                        };
                    });
                }
                function u(t) {
                    const e = f / 2;
                    let i = 0;
                    return n.forEach((b, a)=>{
                        const n = s[b];
                        if (a > 0) {
                            const e = n.getX(), b = t[a], s = p(b.fromTickable).getX() + b.expectedDistance - (e + i);
                            let l = 0;
                            s > 0 ? i += s : s < 0 && (l = Math.min(b.maxNegativeShiftPx, Math.abs(s)), i += -l), n.setX(e + i);
                        }
                        n.getCenterAlignedTickables().forEach((t)=>{
                            t.setCenterXShift(e - n.getX());
                        });
                    }), x.getX() - _.getX();
                }
                const f = t - x.getMetrics().notePx - x.getMetrics().totalRightPx - _.getMetrics().totalLeftPx, S = V.currentMusicFont(), T = S.lookupMetric("stave.endPaddingMin"), v = S.lookupMetric("stave.endPaddingMax"), z = S.lookupMetric("stave.padding");
                let B = f;
                const D = y(B);
                let C = u(D);
                if (1 === n.length) return 0;
                const E = ((t, e)=>{
                    let i = t / 2;
                    if (e.length > 1) for(let t = 1; t < e.length; ++t)i = Math.min(e[t].expectedDistance / 2, i);
                    return i;
                })(B, D), P = (t)=>{
                    let e = 0;
                    const i = x && x.getMaxTickable();
                    if (i) {
                        const b = i.getVoice();
                        if (b.getTicksUsed().value() > b.getTotalTicks().value()) return 2 * v < E ? E : v;
                        const a = i.getWidth();
                        e = b.softmax(x.getMaxTicks().value()) * t - (a + z);
                    }
                    return 2 * v < e ? e : v;
                };
                let k = P(B), A = k - (v - T);
                const N = f - A;
                let F = c;
                for(; C > N && F > 0 || C + k < N && F > 1;)B -= C - N, k = P(B), A = k - (v - T), C = u(y(B)), F--;
                return this.justifyWidth = t, this.evaluate();
            }
            evaluate() {
                const t = this.tickContexts, e = this.justifyWidth;
                this.contextGaps = {
                    total: 0,
                    gaps: []
                }, t.list.forEach((e, i)=>{
                    if (0 === i) return;
                    const b = t.list[i - 1], a = t.map[b], n = t.map[e], s = a.getMetrics(), l = n.getMetrics(), o = a.getX() + s.notePx + s.totalRightPx, r = n.getX() - l.totalLeftPx, h = r - o;
                    this.contextGaps.total += h, this.contextGaps.gaps.push({
                        x1: o,
                        x2: r
                    }), n.getFormatterMetrics().freedom.left = h, a.getFormatterMetrics().freedom.right = h;
                }), this.durationStats = {};
                const i = this.durationStats;
                this.voices.forEach((t)=>{
                    t.getTickables().forEach((t, b, a)=>{
                        const n = t.getTicks().clone().simplify().toString(), s = t.getMetrics(), l = t.getFormatterMetrics(), o = t.getX() + s.notePx + s.modRightPx + s.rightDisplacedHeadPx;
                        let r = 0;
                        if (b < a.length - 1) {
                            const e = a[b + 1], i = e.getMetrics();
                            r = e.getX() - i.modLeftPx - i.leftDisplacedHeadPx - o, l.space.used = e.getX() - t.getX(), e.getFormatterMetrics().freedom.left = r;
                        } else r = e - o, l.space.used = e - t.getX();
                        l.freedom.right = r, function(t, e) {
                            const b = i[t];
                            void 0 === b ? i[t] = {
                                mean: e,
                                count: 1
                            } : (b.count += 1, b.mean = (b.mean + e) / 2);
                        }(n, l.space.used);
                    });
                });
                let b = 0;
                return this.voices.forEach((t)=>{
                    t.getTickables().forEach((t)=>{
                        const e = t.getTicks().clone().simplify().toString(), a = t.getFormatterMetrics();
                        a.space.mean = i[e].mean, a.duration = e, a.iterations += 1, a.space.deviation = a.space.used - a.space.mean, b += Math.pow(a.space.deviation, 2);
                    });
                }), this.totalCost = Math.sqrt(b), this.lossHistory.push(this.totalCost), this.totalCost;
            }
            tune(t) {
                var e;
                const i = this.tickContexts;
                if (!i) return 0;
                const b = null !== (e = null == t ? void 0 : t.alpha) && void 0 !== e ? e : .5;
                let a = 0;
                return this.totalShift = 0, i.list.forEach((t, e, n)=>{
                    const s = i.map[t], l = e > 0 ? i.map[n[e - 1]] : void 0, o = e < n.length - 1 ? i.map[n[e + 1]] : void 0;
                    !function(t, e, i, b) {
                        t.setX(t.getX() + e), t.getFormatterMetrics().freedom.left += e, t.getFormatterMetrics().freedom.right -= e, i && (i.getFormatterMetrics().freedom.right += e), b && (b.getFormatterMetrics().freedom.left -= e);
                    }(s, a, l, o);
                    const r = -w(s.getTickables().map((t)=>t.getFormatterMetrics().space.deviation));
                    r > 0 ? a = -Math.min(s.getFormatterMetrics().freedom.right, Math.abs(r)) : r < 0 && (a = o ? Math.min(o.getFormatterMetrics().freedom.right, Math.abs(r)) : 0), a *= b, this.totalShift += a;
                }), this.evaluate();
            }
            postFormat() {
                return this.modifierContexts.forEach((t)=>{
                    t.array.forEach((t)=>t.postFormat());
                }), this.tickContexts.list.forEach((t)=>{
                    this.tickContexts.map[t].postFormat();
                }), this;
            }
            joinVoices(t) {
                return this.createModifierContexts(t), this.hasMinTotalWidth = !1, this;
            }
            format(t, e, i) {
                const b = Object.assign({
                    align_rests: !1
                }, i);
                this.voices = t;
                const a = this.formatterOptions.softmaxFactor;
                return a && this.voices.forEach((t)=>t.setSoftmaxFactor(a)), this.alignRests(t, b.align_rests), this.createTickContexts(t), this.preFormat(e, b.context, t, b.stave), b.stave && this.postFormat(), this;
            }
            formatToStave(t, e, i) {
                const b = Object.assign({
                    context: e.getContext()
                }, i), a = e.getNoteEndX() - e.getNoteStartX() - ze.defaultPadding;
                return function(...t) {
                    Pe.DEBUG && u("Vex.Flow.Formatter", t);
                }("Formatting voices to width: ", a), this.format(t, a, b);
            }
            getTickContext(t) {
                var e;
                return null === (e = this.tickContexts) || void 0 === e ? void 0 : e.map[t];
            }
        }
        var ke;
        Pe.DEBUG = !1, function(t) {
            t[t.BOTTOM = -1] = "BOTTOM", t[t.TOP = 1] = "TOP";
        }(ke || (ke = {}));
        class Ae extends R {
            static get CATEGORY() {
                return x.Tuplet;
            }
            static get LOCATION_TOP() {
                return ke.TOP;
            }
            static get LOCATION_BOTTOM() {
                return ke.BOTTOM;
            }
            static get NESTING_OFFSET() {
                return 15;
            }
            static get metrics() {
                const t = V.currentMusicFont().getMetrics().tuplet;
                if (!t) throw new g("BadMetrics", "tuplet missing");
                return t;
            }
            constructor(t, e = {}){
                if (super(), this.numerator_glyphs = [], this.denom_glyphs = [], !t || !t.length) throw new g("BadArguments", "No notes provided for tuplet.");
                this.options = e, this.notes = t, this.num_notes = null != this.options.num_notes ? this.options.num_notes : t.length, this.options.beats_occupied && this.beatsOccupiedDeprecationWarning(), this.notes_occupied = this.options.notes_occupied || this.options.beats_occupied || 2, null != this.options.bracketed ? this.bracketed = this.options.bracketed : this.bracketed = t.some((t)=>!t.hasBeam()), this.ratioed = null != this.options.ratioed ? this.options.ratioed : Math.abs(this.notes_occupied - this.num_notes) > 1, this.point = 3 * V.NOTATION_FONT_SCALE / 5, this.y_pos = 16, this.x_pos = 100, this.width = 200, this.setTupletLocation(this.options.location || Ae.LOCATION_TOP), Pe.AlignRestsToNotes(t, !0, !0), this.resolveGlyphs(), this.attach();
            }
            attach() {
                for(let t = 0; t < this.notes.length; t++)this.notes[t].setTuplet(this);
            }
            detach() {
                for(let t = 0; t < this.notes.length; t++)this.notes[t].resetTuplet(this);
            }
            setBracketed(t) {
                return this.bracketed = !!t, this;
            }
            setRatioed(t) {
                return this.ratioed = !!t, this;
            }
            setTupletLocation(t) {
                return t !== Ae.LOCATION_TOP && t !== Ae.LOCATION_BOTTOM && (console.warn(`Invalid tuplet location [${t}]. Using Tuplet.LOCATION_TOP.`), t = Ae.LOCATION_TOP), this.location = t, this;
            }
            getNotes() {
                return this.notes;
            }
            getNoteCount() {
                return this.num_notes;
            }
            beatsOccupiedDeprecationWarning() {
                console.warn("beats_occupied has been deprecated as an option for tuplets. Please use notes_occupied instead.", "Calls to getBeatsOccupied / setBeatsOccupied should now be routed to getNotesOccupied / setNotesOccupied.", "The old methods will be removed in VexFlow 5.0.");
            }
            getBeatsOccupied() {
                return this.beatsOccupiedDeprecationWarning(), this.getNotesOccupied();
            }
            setBeatsOccupied(t) {
                return this.beatsOccupiedDeprecationWarning(), this.setNotesOccupied(t);
            }
            getNotesOccupied() {
                return this.notes_occupied;
            }
            setNotesOccupied(t) {
                this.detach(), this.notes_occupied = t, this.resolveGlyphs(), this.attach();
            }
            resolveGlyphs() {
                this.numerator_glyphs = [];
                let t = this.num_notes;
                for(; t >= 1;)this.numerator_glyphs.unshift(new Z("timeSig" + t % 10, this.point)), t = parseInt((t / 10).toString(), 10);
                for(this.denom_glyphs = [], t = this.notes_occupied; t >= 1;)this.denom_glyphs.unshift(new Z("timeSig" + t % 10, this.point)), t = parseInt((t / 10).toString(), 10);
            }
            getNestedTupletCount() {
                const t = this.location, e = this.notes[0];
                let i = a(e, t), b = a(e, t);
                function a(t, e) {
                    return t.getTupletStack().filter((t)=>t.location === e).length;
                }
                return this.notes.forEach((e)=>{
                    const n = a(e, t);
                    i = n > i ? n : i, b = n < b ? n : b;
                }), i - b;
            }
            getYPosition() {
                const t = this.getNestedTupletCount() * Ae.NESTING_OFFSET * -this.location, e = this.options.y_offset || 0, i = this.notes[0];
                let b;
                if (this.location === Ae.LOCATION_TOP) {
                    b = i.checkStave().getYForLine(0) - Ae.metrics.topModifierOffset;
                    for(let t = 0; t < this.notes.length; ++t){
                        const e = this.notes[t];
                        let i = 0;
                        const a = e.getModifierContext();
                        a && (i = Math.max(i, a.getState().top_text_line));
                        const n = e.getYForTopText(i) - Ae.metrics.noteHeadOffset;
                        if (e.hasStem() || e.isRest()) {
                            const t = e.getStemDirection() === at.UP ? e.getStemExtents().topY - Ae.metrics.stemOffset : e.getStemExtents().baseY - Ae.metrics.noteHeadOffset;
                            b = Math.min(t, b), i > 0 && (b = Math.min(n, b));
                        }
                    }
                } else {
                    let t = Ae.metrics.bottomLine;
                    this.notes.forEach((e)=>{
                        const i = e.getModifierContext();
                        i && (t = Math.max(t, i.getState().text_line + 1));
                    }), b = i.checkStave().getYForLine(t) + Ae.metrics.noteHeadOffset;
                    for(let t = 0; t < this.notes.length; ++t)if (this.notes[t].hasStem() || this.notes[t].isRest()) {
                        const e = this.notes[t].getStemDirection() === at.UP ? this.notes[t].getStemExtents().baseY + Ae.metrics.noteHeadOffset : this.notes[t].getStemExtents().topY + Ae.metrics.stemOffset;
                        e > b && (b = e);
                    }
                }
                return b + t + e;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                const e = this.notes[0], i = this.notes[this.notes.length - 1];
                this.bracketed ? (this.x_pos = e.getTieLeftX() - 5, this.width = i.getTieRightX() - this.x_pos + 5) : (this.x_pos = e.getStemX(), this.width = i.getStemX() - this.x_pos), this.y_pos = this.getYPosition();
                const b = (t, e)=>t + p(e.getMetrics().width);
                let a = this.numerator_glyphs.reduce(b, 0);
                this.ratioed && (a = this.denom_glyphs.reduce(b, a), a += .32 * this.point);
                const n = this.x_pos + this.width / 2 - a / 2;
                if (this.bracketed) {
                    const e = this.width / 2 - a / 2 - 5;
                    e > 0 && (t.fillRect(this.x_pos, this.y_pos, e, 1), t.fillRect(this.x_pos + this.width / 2 + a / 2 + 5, this.y_pos, e, 1), t.fillRect(this.x_pos, this.y_pos + (this.location === Ae.LOCATION_BOTTOM ? 1 : 0), 1, 10 * this.location), t.fillRect(this.x_pos + this.width, this.y_pos + (this.location === Ae.LOCATION_BOTTOM ? 1 : 0), 1, 10 * this.location));
                }
                const s = V.currentMusicFont().lookupMetric("digits.shiftY", 0);
                let l = 0;
                if (this.numerator_glyphs.forEach((e)=>{
                    e.render(t, n + l, this.y_pos + this.point / 3 - 2 + s), l += p(e.getMetrics().width);
                }), this.ratioed) {
                    const e = n + l + .16 * this.point, i = .06 * this.point;
                    t.beginPath(), t.arc(e, this.y_pos - .08 * this.point, i, 0, 2 * Math.PI, !1), t.closePath(), t.fill(), t.beginPath(), t.arc(e, this.y_pos + .12 * this.point, i, 0, 2 * Math.PI, !1), t.closePath(), t.fill(), l += .32 * this.point, this.denom_glyphs.forEach((e)=>{
                        e.render(t, n + l, this.y_pos + this.point / 3 - 2 + s), l += p(e.getMetrics().width);
                    });
                }
            }
        }
        function Ne(t) {
            let e = 0;
            return t.forEach((t)=>{
                t.keyProps && t.keyProps.forEach((t)=>{
                    e += t.line - 3;
                });
            }), e >= 0 ? at.DOWN : at.UP;
        }
        const Fe = "L", Me = "R", Oe = "B";
        class Re extends R {
            static get CATEGORY() {
                return x.Beam;
            }
            getStemDirection() {
                return this.stem_direction;
            }
            static getDefaultBeamGroups(t) {
                t && "c" !== t || (t = "4/4");
                const e = {
                    "1/2": [
                        "1/2"
                    ],
                    "2/2": [
                        "1/2"
                    ],
                    "3/2": [
                        "1/2"
                    ],
                    "4/2": [
                        "1/2"
                    ],
                    "1/4": [
                        "1/4"
                    ],
                    "2/4": [
                        "1/4"
                    ],
                    "3/4": [
                        "1/4"
                    ],
                    "4/4": [
                        "1/4"
                    ],
                    "1/8": [
                        "1/8"
                    ],
                    "2/8": [
                        "2/8"
                    ],
                    "3/8": [
                        "3/8"
                    ],
                    "4/8": [
                        "2/8"
                    ],
                    "1/16": [
                        "1/16"
                    ],
                    "2/16": [
                        "2/16"
                    ],
                    "3/16": [
                        "3/16"
                    ],
                    "4/16": [
                        "2/16"
                    ]
                }[t];
                if (void 0 !== e) return e.map((t)=>(new z).parse(t));
                {
                    const e = parseInt(t.split("/")[0], 10), i = parseInt(t.split("/")[1], 10);
                    if (e % 3 == 0) return [
                        new z(3, i)
                    ];
                    if (i > 4) return [
                        new z(2, i)
                    ];
                    if (i <= 4) return [
                        new z(1, i)
                    ];
                }
                return [
                    new z(1, 4)
                ];
            }
            static applyAndGetBeams(t, e, i) {
                return Re.generateBeams(t.getTickables(), {
                    groups: i,
                    stem_direction: e
                });
            }
            static generateBeams(t, e = {}) {
                e.groups && e.groups.length || (e.groups = [
                    new z(2, 8)
                ]);
                const i = e.groups.map((t)=>{
                    if (!t.multiply) throw new g("InvalidBeamGroups", "The beam groups must be an array of Vex.Flow.Fractions");
                    return t.clone().multiply(V.RESOLUTION, 1);
                }), b = t;
                let a = 0, n = [], s = [];
                function l() {
                    i.length - 1 > a ? a += 1 : a = 0;
                }
                !function() {
                    let t = [], e = new z(0, 1);
                    b.forEach((b)=>{
                        if (t = [], b.shouldIgnoreTicks()) return n.push(s), void (s = t);
                        s.push(b);
                        const o = i[a].clone(), r = (h = s, h.reduce((t, e)=>e.getTicks().clone().add(t), new z(0, 1))).add(e);
                        var h;
                        const m = V.durationToNumber(b.getDuration()) < 8;
                        if (m && b.getTuplet() && (o.numerator *= 2), r.greaterThan(o)) {
                            if (!m) {
                                const e = s.pop();
                                e && t.push(e);
                            }
                            n.push(s);
                            do e = r.subtract(i[a]), l();
                            while (e.greaterThanEquals(i[a]));
                            s = t;
                        } else r.equals(o) && (n.push(s), e = new z(0, 1), s = t, l());
                    }), s.length > 0 && n.push(s);
                }(), function() {
                    const t = [];
                    n.forEach((i)=>{
                        let b = [];
                        i.forEach((i, a, n)=>{
                            const s = 0 === a || a === n.length - 1, l = n[a - 1], o = !e.beam_rests && i.isRest(), r = e.beam_rests && e.beam_middle_only && i.isRest() && s;
                            let h = !1;
                            if (e.maintain_stem_directions && l && !i.isRest() && !l.isRest()) {
                                const t = l.getStemDirection();
                                h = i.getStemDirection() !== t;
                            }
                            const m = parseInt(i.getDuration(), 10) < 8;
                            o || r || h || m ? (b.length > 0 && t.push(b), b = h ? [
                                i
                            ] : []) : b.push(i);
                        }), b.length > 0 && t.push(b);
                    }), n = t;
                }(), n.forEach((t)=>{
                    let i;
                    if (e.maintain_stem_directions) {
                        const e = function(t) {
                            for(let e = 0; e < t.length; e++){
                                const i = t[e];
                                if (!i.isRest()) return i;
                            }
                            return !1;
                        }(t);
                        i = e ? e.getStemDirection() : at.UP;
                    } else i = e.stem_direction ? e.stem_direction : Ne(t);
                    !function(t, e) {
                        t.forEach((t)=>{
                            t.setStemDirection(e);
                        });
                    }(t, i);
                });
                const o = n.filter((t)=>{
                    if (t.length > 1) {
                        let e = !0;
                        return t.forEach((t)=>{
                            t.getIntrinsicTicks() >= V.durationToTicks("4") && (e = !1);
                        }), e;
                    }
                    return !1;
                }), r = function() {
                    const t = [];
                    return n.forEach((e)=>{
                        let i;
                        e.forEach((e)=>{
                            const b = e.getTuplet();
                            b && i !== b && (i = b, t.push(i));
                        });
                    }), t;
                }(), h = [];
                return o.forEach((t)=>{
                    const i = new Re(t);
                    e.show_stemlets && (i.render_options.show_stemlets = !0), e.secondary_breaks && (i.render_options.secondary_break_ticks = V.durationToTicks(e.secondary_breaks)), !0 === e.flat_beams && (i.render_options.flat_beams = !0, i.render_options.flat_beam_offset = e.flat_beam_offset), h.push(i);
                }), r.forEach((t)=>{
                    const e = t.notes[0].stem_direction === at.DOWN ? ke.BOTTOM : ke.TOP;
                    t.setTupletLocation(e);
                    let i = !1;
                    for(let e = 0; e < t.notes.length; e++)if (!t.notes[e].hasBeam()) {
                        i = !0;
                        break;
                    }
                    t.setBracketed(i);
                }), h;
            }
            constructor(t, e = !1){
                if (super(), this.slope = 0, this.y_shift = 0, this.forcedPartialDirections = {}, !t || 0 === t.length) throw new g("BadArguments", "No notes provided for beam.");
                if (1 === t.length) throw new g("BadArguments", "Too few notes for beam.");
                if (this.ticks = t[0].getIntrinsicTicks(), this.ticks >= V.durationToTicks("4")) throw new g("BadArguments", "Beams can only be applied to notes shorter than a quarter note.");
                let i, b;
                this.stem_direction = t[0].getStemDirection();
                let a = this.stem_direction;
                if (e && c(t[0])) a = Ne(t);
                else if (e && _(t[0])) {
                    const e = t.reduce((t, e)=>t + e.getStemDirection(), 0);
                    a = e > -1 ? at.UP : at.DOWN;
                }
                for(i = 0; i < t.length; ++i)b = t[i], e && (b.setStemDirection(a), this.stem_direction = a), b.setBeam(this);
                this.postFormatted = !1, this.notes = t, this.beam_count = this.getBeamCount(), this.break_on_indices = [], this.render_options = {
                    beam_width: 5,
                    max_slope: .25,
                    min_slope: -0.25,
                    slope_iterations: 20,
                    slope_cost: 100,
                    show_stemlets: !1,
                    stemlet_extension: 7,
                    partial_beam_length: 10,
                    flat_beams: !1,
                    min_flat_beam_offset: 15
                };
            }
            getNotes() {
                return this.notes;
            }
            getBeamCount() {
                return this.notes.map((t)=>t.getGlyphProps().beam_count).reduce((t, e)=>e > t ? e : t);
            }
            breakSecondaryAt(t) {
                return this.break_on_indices = t, this;
            }
            setPartialBeamSideAt(t, e) {
                return this.forcedPartialDirections[t] = e, this;
            }
            unsetPartialBeamSideAt(t) {
                return delete this.forcedPartialDirections[t], this;
            }
            getSlopeY(t, e, i, b) {
                return i + (t - e) * b;
            }
            calculateSlope() {
                const { notes: t, stem_direction: e, render_options: { max_slope: i, min_slope: b, slope_iterations: a, slope_cost: n } } = this, s = t[0], l = function(t, e) {
                    const i = t.getStemExtents().topY, b = t.getStemX();
                    return (e.getStemExtents().topY - i) / (e.getStemX() - b);
                }(s, t[t.length - 1]), o = (i - b) / a;
                let r = Number.MAX_VALUE, h = 0, m = 0;
                for(let a = b; a <= i; a += o){
                    let i = 0, b = 0;
                    for(let n = 1; n < t.length; ++n){
                        const l = t[n];
                        if (l.hasStem() || l.isRest()) {
                            const t = this.getSlopeY(l.getStemX(), s.getStemX(), s.getStemExtents().topY, a) + b, o = l.getStemExtents().topY;
                            if (o * e < t * e) {
                                const a = Math.abs(o - t);
                                b += a * -e, i += a * n;
                            } else i += (o - t) * e;
                        }
                    }
                    const o = l / 2, c = n * Math.abs(o - a) + Math.abs(i);
                    c < r && (r = c, h = a, m = b);
                }
                this.slope = h, this.y_shift = m;
            }
            calculateFlatSlope() {
                const { notes: t, stem_direction: e, render_options: { beam_width: i, min_flat_beam_offset: b, flat_beam_offset: a } } = this;
                let n = 0, s = 0, l = 0, o = 0;
                for(let i = 0; i < t.length; i++){
                    const b = t[i], a = b.getStemExtents().topY;
                    n += a, e === at.DOWN && o < a ? (o = a, s = Math.max(...b.getYs()), l = b.getBeamCount()) : e === at.UP && (0 === o || o > a) && (o = a, s = Math.min(...b.getYs()), l = b.getBeamCount());
                }
                let r = n / t.length;
                const h = b + l * (1.5 * i), m = s + h * -e;
                e === at.DOWN && r < m ? r = s + h : e === at.UP && r > m && (r = s - h), a ? (e === at.DOWN && r > a || e === at.UP && r < a) && (this.render_options.flat_beam_offset = r) : this.render_options.flat_beam_offset = r, this.slope = 0, this.y_shift = 0;
            }
            getBeamYToDraw() {
                let t = this.notes[0].getStemExtents().topY;
                return this.render_options.flat_beams && this.render_options.flat_beam_offset && (t = this.render_options.flat_beam_offset), t;
            }
            applyStemExtensions() {
                const { notes: t, slope: e, y_shift: i, beam_count: b, render_options: { show_stemlets: a, stemlet_extension: n, beam_width: s } } = this, l = t[0], o = this.getBeamYToDraw(), r = l.getStemX();
                for(let l = 0; l < t.length; ++l){
                    const h = t[l], m = h.getStem();
                    if (m) {
                        const t = h.getStemX(), { topY: l } = h.getStemExtents(), c = this.getSlopeY(t, r, o, e) + i, d = m.getExtension(), _ = h.getStemDirection() === at.UP ? l - c : c - l;
                        let x = 0;
                        if (h.getStemDirection() !== this.stem_direction) x = (1 + 1.5 * (h.getGlyphProps().beam_count - 1)) * this.render_options.beam_width;
                        if (m.setExtension(d + _ + x), m.adjustHeightForBeam(), h.isRest() && a) {
                            const t = (b - 1) * s * 1.5 + s;
                            m.setVisibility(!0).setStemlet(!0, t + n);
                        }
                    }
                }
            }
            lookupBeamDirection(t, e, i, b, a) {
                if ("4" === t) return Fe;
                const n = this.forcedPartialDirections[a];
                if (n) return n;
                const s = "" + V.durationToNumber(t) / 2, l = e < V.durationToTicks(s), o = b < V.durationToTicks(s), r = i < V.durationToTicks(s);
                return l && o && r ? Oe : l && !o && r ? Fe : !l && o && r ? Me : this.lookupBeamDirection(s, e, i, b, a);
            }
            getBeamLines(t) {
                const e = V.durationToTicks(t);
                let i = !1;
                const b = [];
                let a;
                const n = this.render_options.partial_beam_length;
                let s = !1, l = 0;
                for(let o = 0; o < this.notes.length; ++o){
                    const r = this.notes[o];
                    l += r.getTicks().value();
                    let h = !1;
                    parseInt(t, 10) >= 8 && (h = -1 !== this.break_on_indices.indexOf(o), this.render_options.secondary_break_ticks && l >= this.render_options.secondary_break_ticks && (l = 0, h = !0));
                    const m = r.getIntrinsicTicks() < e, c = r.getStemX() - at.WIDTH / 2, d = this.notes[o - 1], _ = this.notes[o + 1], x = _ && _.getIntrinsicTicks() < e, g = d && d.getIntrinsicTicks() < e, y = d && _ && m && !g && !x;
                    if (m) {
                        if (i) a = b[b.length - 1], a.end = c, h && (i = !1, _ && !x && void 0 === a.end && (a.end = a.start - n));
                        else {
                            if (a = {
                                start: c,
                                end: void 0
                            }, i = !0, y) {
                                const e = d.getIntrinsicTicks(), i = _.getIntrinsicTicks(), b = r.getIntrinsicTicks(), s = this.lookupBeamDirection(t, e, b, i, o);
                                [
                                    Fe,
                                    Oe
                                ].includes(s) ? a.end = a.start - n : a.end = a.start + n;
                            } else x ? h && (a.end = a.start - n, i = !1) : a.end = (s || 0 === o) && _ ? a.start + n : a.start - n;
                            b.push(a);
                        }
                    } else i = !1;
                    s = h;
                }
                const o = b[b.length - 1];
                return o && void 0 === o.end && (o.end = o.start - n), b;
            }
            drawStems(t) {
                this.notes.forEach((e)=>{
                    const i = e.getStem();
                    if (i) {
                        const b = e.getStemX();
                        i.setNoteHeadXBounds(b, b), i.setContext(t).draw();
                    }
                }, this);
            }
            drawBeamLines(t) {
                const e = [
                    "4",
                    "8",
                    "16",
                    "32",
                    "64"
                ], i = this.notes[0];
                let b = this.getBeamYToDraw();
                const a = i.getStemX(), n = this.render_options.beam_width * this.stem_direction;
                for(let i = 0; i < e.length; ++i){
                    const s = e[i], l = this.getBeamLines(s);
                    for(let e = 0; e < l.length; ++e){
                        const i = l[e], s = i.start, o = this.getSlopeY(s, a, b, this.slope), r = i.end;
                        if (!r) throw new g("NoLastBeamX", "lastBeamX undefined.");
                        {
                            const e = this.getSlopeY(r, a, b, this.slope);
                            t.beginPath(), t.moveTo(s, o), t.lineTo(s, o + n), t.lineTo(r + 1, e + n), t.lineTo(r + 1, e), t.closePath(), t.fill();
                        }
                    }
                    b += 1.5 * n;
                }
            }
            preFormat() {
                return this;
            }
            postFormat() {
                this.postFormatted || (_(this.notes[0]) || this.render_options.flat_beams ? this.calculateFlatSlope() : this.calculateSlope(), this.applyStemExtensions(), this.postFormatted = !0);
            }
            draw() {
                const t = this.checkContext();
                this.setRendered(), this.unbeamable || (this.postFormatted || this.postFormat(), this.drawStems(t), this.applyStyle(), t.openGroup("beam", this.getAttribute("id")), this.drawBeamLines(t), t.closeGroup(), this.restoreStyle());
            }
        }
        class Le extends vt {
            static get CATEGORY() {
                return x.ClefNote;
            }
            constructor(t, e, i){
                super({
                    duration: "b"
                }), this.type = t;
                const b = new de(t, e, i);
                this.clef = b.clef, this.annotation = b.annotation, this.size = void 0 === e ? "default" : e, this.setWidth(Z.getWidth(this.clef.code, de.getPoint(this.size), `clefNote_${this.size}`)), this.ignore_ticks = !0;
            }
            setType(t, e, i) {
                this.type = t, this.size = e;
                const b = new de(t, e, i);
                return this.clef = b.clef, this.annotation = b.annotation, this.setWidth(Z.getWidth(this.clef.code, de.getPoint(this.size), `clefNote_${this.size}`)), this;
            }
            getClef() {
                return this.clef;
            }
            preFormat() {
                return this.preFormatted = !0, this;
            }
            draw() {
                const t = this.checkStave(), e = this.checkContext();
                this.setRendered();
                const i = this.getAbsoluteX();
                if (Z.renderGlyph(e, i, t.getYForLine(this.clef.line), de.getPoint(this.size), this.clef.code, {
                    category: `clefNote_${this.size}`
                }), void 0 !== this.annotation) {
                    const b = new Z(this.annotation.code, this.annotation.point);
                    b.setContext(e), b.setStave(t), b.setYShift(t.getYForLine(this.annotation.line) - t.getYForGlyphs()), b.setXShift(this.annotation.x_shift), b.renderToStave(i);
                }
            }
        }
        class We extends vt {
            static get CATEGORY() {
                return x.Crescendo;
            }
            constructor(t){
                super(t), this.options = {
                    extend_left: 0,
                    extend_right: 0,
                    y_shift: 0
                }, this.decrescendo = !1, this.line = t.line || 0, this.height = 15;
            }
            setLine(t) {
                return this.line = t, this;
            }
            setHeight(t) {
                return this.height = t, this;
            }
            setDecrescendo(t) {
                return this.decrescendo = t, this;
            }
            preFormat() {
                return this.preFormatted = !0, this;
            }
            draw() {
                const t = this.checkContext(), e = this.checkStave();
                this.setRendered();
                const i = this.getTickContext(), b = Ce.getNextContext(i), a = this.getAbsoluteX(), n = b ? b.getX() : e.getX() + e.getWidth(), s = e.getYForLine(this.line + -3) + 1;
                !function(...t) {
                    We.DEBUG && u("Vex.Flow.Crescendo", t);
                }("Drawing ", this.decrescendo ? "decrescendo " : "crescendo ", this.height, "x", a - n), function(t, e) {
                    const i = e.begin_x, b = e.end_x, a = e.y, n = e.height / 2;
                    t.beginPath(), e.reverse ? (t.moveTo(i, a - n), t.lineTo(b, a), t.lineTo(i, a + n)) : (t.moveTo(b, a - n), t.lineTo(i, a), t.lineTo(b, a + n)), t.stroke(), t.closePath();
                }(t, {
                    begin_x: a - this.options.extend_left,
                    end_x: n + this.options.extend_right,
                    y: s + this.options.y_shift,
                    height: this.height,
                    reverse: this.decrescendo
                });
            }
        }
        var Ue;
        We.DEBUG = !1, function(t) {
            t[t.NEAR_HEAD = 1] = "NEAR_HEAD", t[t.NEAR_TOP = 2] = "NEAR_TOP";
        }(Ue || (Ue = {}));
        class Ie extends R {
            static get CATEGORY() {
                return x.Curve;
            }
            static get Position() {
                return Ue;
            }
            static get PositionString() {
                return {
                    nearHead: Ue.NEAR_HEAD,
                    nearTop: Ue.NEAR_TOP
                };
            }
            constructor(t, e, i){
                super(), this.render_options = Object.assign({
                    thickness: 2,
                    x_shift: 0,
                    y_shift: 10,
                    position: Ue.NEAR_HEAD,
                    position_end: Ue.NEAR_HEAD,
                    invert: !1,
                    cps: [
                        {
                            x: 0,
                            y: 10
                        },
                        {
                            x: 0,
                            y: 10
                        }
                    ]
                }, i), this.from = t, this.to = e;
            }
            setNotes(t, e) {
                if (!t && !e) throw new g("BadArguments", "Curve needs to have either `from` or `to` set.");
                return this.from = t, this.to = e, this;
            }
            isPartial() {
                return !this.from || !this.to;
            }
            renderCurve(t) {
                const e = this.checkContext(), i = this.render_options.x_shift, b = this.render_options.y_shift * t.direction, a = t.first_x + i, n = t.first_y + b, s = t.last_x - i, l = t.last_y + b, o = this.render_options.thickness, r = this.render_options.cps, { x: h, y: m } = r[0], { x: c, y: d } = r[1], _ = (s - a) / (r.length + 2);
                e.beginPath(), e.moveTo(a, n), e.bezierCurveTo(a + _ + h, n + m * t.direction, s - _ + c, l + d * t.direction, s, l), e.bezierCurveTo(s - _ + c, l + (d + o) * t.direction, a + _ + h, n + (m + o) * t.direction, a, n), e.stroke(), e.closePath(), e.fill();
            }
            draw() {
                this.checkContext(), this.setRendered();
                const t = this.from, e = this.to;
                let i, b, a, n, s = 0, l = "baseY", o = "baseY";
                function r(t) {
                    return "string" == typeof t ? Ie.PositionString[t] : t;
                }
                const h = r(this.render_options.position), m = r(this.render_options.position_end);
                if (h === Ue.NEAR_TOP && (l = "topY", o = "topY"), m === Ue.NEAR_HEAD ? o = "baseY" : m === Ue.NEAR_TOP && (o = "topY"), t) i = t.getTieRightX(), s = t.getStemDirection(), a = t.getStemExtents()[l];
                else i = e.checkStave().getTieStartX(), a = e.getStemExtents()[l];
                if (e) b = e.getTieLeftX(), s = e.getStemDirection(), n = e.getStemExtents()[o];
                else b = t.checkStave().getTieEndX(), n = t.getStemExtents()[o];
                return this.renderCurve({
                    first_x: i,
                    last_x: b,
                    first_y: a,
                    last_y: n,
                    direction: s * (!0 === this.render_options.invert ? -1 : 1)
                }), !0;
            }
        }
        function Ge(...t) {
            Ye.DEBUG && u("Vex.Flow.Parser", t);
        }
        function He(t) {
            if ("matchedString" in t) return t.matchedString;
            if ("results" in t) return He(t.results);
            const e = t;
            return 1 === e.length ? He(e[0]) : 0 === e.length ? null : e.map(He);
        }
        class Ye {
            constructor(t){
                this.grammar = t, this.line = "", this.pos = 0, this.errorPos = -1;
            }
            parse(t) {
                this.line = t, this.pos = 0, this.errorPos = -1;
                const e = this.expect(this.grammar.begin());
                return e.errorPos = this.errorPos, e;
            }
            matchFail(t) {
                -1 === this.errorPos && (this.errorPos = this.pos), this.pos = t;
            }
            matchSuccess() {
                this.errorPos = -1;
            }
            matchToken(t, e = !1) {
                const i = e ? new RegExp("^((" + t + "))") : new RegExp("^((" + t + ")\\s*)"), b = this.line.slice(this.pos).match(i);
                return null !== b ? {
                    success: !0,
                    matchedString: b[2],
                    incrementPos: b[1].length,
                    pos: this.pos
                } : {
                    success: !1,
                    pos: this.pos
                };
            }
            expectOne(t, e = !1) {
                const i = [], b = this.pos;
                let a = !0, n = !1;
                if (e = !0 === e || !0 === t.maybe, t.expect) for (const e of t.expect){
                    const b = this.pos, s = this.expect(e);
                    if (s.success) {
                        if (i.push(s), n = !0, t.or) break;
                    } else if (a = !1, !t.or) {
                        this.pos = b;
                        break;
                    }
                }
                const s = t.or && n || a, l = s || !0 === e, o = s ? 1 : 0;
                return e && !s && (this.pos = b), l ? this.matchSuccess() : this.matchFail(b), {
                    success: l,
                    results: i,
                    numMatches: o
                };
            }
            expectOneOrMore(t, e = !1) {
                const i = [], b = this.pos;
                let a = 0, n = !0;
                do {
                    const e = this.expectOne(t);
                    e.success && e.results ? (a++, i.push(e.results)) : n = !1;
                }while (n);
                const s = a > 0 || !0 === e;
                return !e || a > 0 || (this.pos = b), s ? this.matchSuccess() : this.matchFail(b), {
                    success: s,
                    results: i,
                    numMatches: a
                };
            }
            expectZeroOrMore(t) {
                return this.expectOneOrMore(t, !0);
            }
            expect(t) {
                if (Ge("Evaluating rule function:", t), !t) throw new g("Invalid rule function");
                let e;
                const i = t.bind(this.grammar)();
                if (i.token) e = this.matchToken(i.token, !0 === i.noSpace), e.success && (this.pos += e.incrementPos);
                else {
                    if (!i.expect) throw Ge(i), new g("Bad grammar! No `token` or `expect` property " + i);
                    e = i.oneOrMore ? this.expectOneOrMore(i) : i.zeroOrMore ? this.expectZeroOrMore(i) : this.expectOne(i);
                }
                const b = [];
                return e.matches = b, e.results && e.results.forEach((t)=>b.push(He(t))), i.run && e.success && i.run({
                    matches: b
                }), e;
            }
        }
        function Xe(...t) {
            Qe.DEBUG && u("Vex.Flow.EasyScore", t);
        }
        Ye.DEBUG = !1;
        class je {
            constructor(t){
                this.builder = t;
            }
            begin() {
                return this.LINE;
            }
            LINE() {
                return {
                    expect: [
                        this.PIECE,
                        this.PIECES,
                        this.EOL
                    ]
                };
            }
            PIECE() {
                return {
                    expect: [
                        this.CHORDORNOTE,
                        this.PARAMS
                    ],
                    run: ()=>this.builder.commitPiece()
                };
            }
            PIECES() {
                return {
                    expect: [
                        this.COMMA,
                        this.PIECE
                    ],
                    zeroOrMore: !0
                };
            }
            PARAMS() {
                return {
                    expect: [
                        this.DURATION,
                        this.TYPE,
                        this.DOTS,
                        this.OPTS
                    ]
                };
            }
            CHORDORNOTE() {
                return {
                    expect: [
                        this.CHORD,
                        this.SINGLENOTE
                    ],
                    or: !0
                };
            }
            CHORD() {
                return {
                    expect: [
                        this.LPAREN,
                        this.NOTES,
                        this.RPAREN
                    ],
                    run: (t)=>this.builder.addChord(t.matches[1])
                };
            }
            NOTES() {
                return {
                    expect: [
                        this.NOTE
                    ],
                    oneOrMore: !0
                };
            }
            NOTE() {
                return {
                    expect: [
                        this.NOTENAME,
                        this.ACCIDENTAL,
                        this.OCTAVE
                    ]
                };
            }
            SINGLENOTE() {
                return {
                    expect: [
                        this.NOTENAME,
                        this.ACCIDENTAL,
                        this.OCTAVE
                    ],
                    run: (t)=>{
                        const e = t;
                        this.builder.addSingleNote(e.matches[0], e.matches[1], e.matches[2]);
                    }
                };
            }
            ACCIDENTAL() {
                return {
                    expect: [
                        this.MICROTONES,
                        this.ACCIDENTALS
                    ],
                    maybe: !0,
                    or: !0
                };
            }
            DOTS() {
                return {
                    expect: [
                        this.DOT
                    ],
                    zeroOrMore: !0,
                    run: (t)=>this.builder.setNoteDots(t.matches)
                };
            }
            TYPE() {
                return {
                    expect: [
                        this.SLASH,
                        this.MAYBESLASH,
                        this.TYPES
                    ],
                    maybe: !0,
                    run: (t)=>this.builder.setNoteType(t.matches[2])
                };
            }
            DURATION() {
                return {
                    expect: [
                        this.SLASH,
                        this.DURATIONS
                    ],
                    maybe: !0,
                    run: (t)=>this.builder.setNoteDuration(t.matches[1])
                };
            }
            OPTS() {
                return {
                    expect: [
                        this.LBRACKET,
                        this.KEYVAL,
                        this.KEYVALS,
                        this.RBRACKET
                    ],
                    maybe: !0
                };
            }
            KEYVALS() {
                return {
                    expect: [
                        this.COMMA,
                        this.KEYVAL
                    ],
                    zeroOrMore: !0
                };
            }
            KEYVAL() {
                return {
                    expect: [
                        this.KEY,
                        this.EQUALS,
                        this.VAL
                    ],
                    run: (t)=>this.builder.addNoteOption(t.matches[0], t.matches[2].slice(1, -1))
                };
            }
            VAL() {
                return {
                    expect: [
                        this.SVAL,
                        this.DVAL
                    ],
                    or: !0
                };
            }
            KEY() {
                return {
                    token: "[a-zA-Z][a-zA-Z0-9]*"
                };
            }
            DVAL() {
                return {
                    token: '["][^"]*["]'
                };
            }
            SVAL() {
                return {
                    token: "['][^']*[']"
                };
            }
            NOTENAME() {
                return {
                    token: "[a-gA-G]"
                };
            }
            OCTAVE() {
                return {
                    token: "[0-9]+"
                };
            }
            ACCIDENTALS() {
                return {
                    token: "bb|b|##|#|n"
                };
            }
            MICROTONES() {
                return {
                    token: "bbs|bss|bs|db|d|\\+\\+-|\\+-|\\+\\+|\\+|k|o"
                };
            }
            DURATIONS() {
                return {
                    token: "[0-9whq]+"
                };
            }
            TYPES() {
                return {
                    token: "[rRsSmMhHgG]"
                };
            }
            LPAREN() {
                return {
                    token: "[(]"
                };
            }
            RPAREN() {
                return {
                    token: "[)]"
                };
            }
            COMMA() {
                return {
                    token: "[,]"
                };
            }
            DOT() {
                return {
                    token: "[.]"
                };
            }
            SLASH() {
                return {
                    token: "[/]"
                };
            }
            MAYBESLASH() {
                return {
                    token: "[/]?"
                };
            }
            EQUALS() {
                return {
                    token: "[=]"
                };
            }
            LBRACKET() {
                return {
                    token: "\\["
                };
            }
            RBRACKET() {
                return {
                    token: "\\]"
                };
            }
            EOL() {
                return {
                    token: "$"
                };
            }
        }
        class Ve {
            constructor(t){
                this.chord = [], this.dots = 0, this.options = {}, this.duration = t;
            }
        }
        class Ke {
            constructor(t){
                this.commitHooks = [], this.factory = t, this.reset();
            }
            reset(t) {
                this.options = Object.assign({
                    stem: "auto",
                    clef: "treble"
                }, t), this.elements = {
                    notes: [],
                    accidentals: []
                }, this.rollingDuration = "8", this.resetPiece();
            }
            getFactory() {
                return this.factory;
            }
            getElements() {
                return this.elements;
            }
            addCommitHook(t) {
                this.commitHooks.push(t);
            }
            resetPiece() {
                Xe("resetPiece"), this.piece = new Ve(this.rollingDuration);
            }
            setNoteDots(t) {
                Xe("setNoteDots:", t), t && (this.piece.dots = t.length);
            }
            setNoteDuration(t) {
                Xe("setNoteDuration:", t), this.rollingDuration = this.piece.duration = t || this.rollingDuration;
            }
            setNoteType(t) {
                Xe("setNoteType:", t), t && (this.piece.type = t);
            }
            addNoteOption(t, e) {
                Xe("addNoteOption: key:", t, "value:", e), this.piece.options[t] = e;
            }
            addNote(t, e, i) {
                Xe("addNote:", t, e, i), this.piece.chord.push({
                    key: t,
                    accid: e,
                    octave: i
                });
            }
            addSingleNote(t, e, i) {
                Xe("addSingleNote:", t, e, i), this.addNote(t, e, i);
            }
            addChord(t) {
                Xe("startChord"), "object" != typeof t[0] ? this.addSingleNote(t[0]) : t.forEach((t)=>{
                    t && this.addNote(...t);
                }), Xe("endChord");
            }
            commitPiece() {
                Xe("commitPiece");
                const { factory: t } = this;
                if (!t) return;
                const e = Object.assign(Object.assign({}, this.options), this.piece.options), i = p(e.stem, "BadArguments", "options.stem is not defined").toLowerCase(), b = p(e.clef, "BadArguments", "options.clef is not defined").toLowerCase(), { chord: a, duration: n, dots: s, type: l } = this.piece, o = et.accidentals, r = a.map((t)=>{
                    var e;
                    return t.key + (o.includes(null !== (e = t.accid) && void 0 !== e ? e : "") ? t.accid : "") + "/" + t.octave;
                }), h = "auto" === i, m = "g" == (null == l ? void 0 : l.toLowerCase()) ? t.GhostNote({
                    duration: n,
                    dots: s
                }) : t.StaveNote({
                    keys: r,
                    duration: n,
                    dots: s,
                    type: l,
                    clef: b,
                    auto_stem: h
                });
                h || m.setStemDirection("up" === i ? at.UP : at.DOWN);
                const c = [];
                a.forEach((e, i)=>{
                    const b = e.accid;
                    if ("string" == typeof b) {
                        const e = t.Accidental({
                            type: b
                        });
                        m.addModifier(e, i), c.push(e);
                    } else c.push(void 0);
                });
                for(let t = 0; t < s; t++)Ot.buildAndAttach([
                    m
                ], {
                    all: !0
                });
                this.commitHooks.forEach((t)=>t(e, m, this)), this.elements.notes.push(m), this.elements.accidentals.push(c), this.resetPiece();
            }
        }
        function $e(t, e) {
            void 0 !== t.id && e.setAttribute("id", t.id);
        }
        const Je = /\s*,\s*/;
        function qe(t, e) {
            void 0 !== t.class && t.class.split(Je).forEach((t)=>e.addClass(t));
        }
        class Qe {
            constructor(t = {}){
                this.defaults = {
                    clef: "treble",
                    time: "4/4",
                    stem: "auto"
                }, this.setOptions(t);
            }
            set(t) {
                return this.defaults = Object.assign(Object.assign({}, this.defaults), t), this;
            }
            setOptions(t) {
                var e, i;
                const b = t.factory, a = null !== (e = t.builder) && void 0 !== e ? e : new Ke(b);
                return this.options = Object.assign(Object.assign({
                    commitHooks: [
                        $e,
                        qe,
                        ut.easyScoreHook,
                        Rt.easyScoreHook
                    ],
                    throwOnError: !1
                }, t), {
                    factory: b,
                    builder: a
                }), this.factory = b, this.builder = a, this.grammar = new je(this.builder), this.parser = new Ye(this.grammar), null === (i = this.options.commitHooks) || void 0 === i || i.forEach((t)=>this.addCommitHook(t)), this;
            }
            setContext(t) {
                return this.factory.setContext(t), this;
            }
            parse(t, e = {}) {
                this.builder.reset(e);
                const i = this.parser.parse(t);
                if (!i.success && this.options.throwOnError) throw Xe(i), new g("Error parsing line: " + t);
                return i;
            }
            beam(t, e) {
                return this.factory.Beam({
                    notes: t,
                    options: e
                }), t;
            }
            tuplet(t, e) {
                return this.factory.Tuplet({
                    notes: t,
                    options: e
                }), t;
            }
            notes(t, e = {}) {
                return e = Object.assign({
                    clef: this.defaults.clef,
                    stem: this.defaults.stem
                }, e), this.parse(t, e), this.builder.getElements().notes;
            }
            voice(t, e = {}) {
                return e = Object.assign({
                    time: this.defaults.time
                }, e), this.factory.Voice(e).addTickables(t);
            }
            addCommitHook(t) {
                this.builder.addCommitHook(t);
            }
        }
        Qe.DEBUG = !1;
        const Ze = "Ghost note must have valid initialization data to identify duration.";
        class ti extends Wt {
            static get CATEGORY() {
                return x.GhostNote;
            }
            constructor(t){
                if (!t) throw new g("BadArguments", Ze);
                let e;
                if ("string" == typeof t) e = {
                    duration: t
                };
                else {
                    if ("object" != typeof t) throw new g("BadArguments", Ze);
                    e = t;
                }
                super(e), this.setWidth(0);
            }
            isRest() {
                return !0;
            }
            setStave(t) {
                return super.setStave(t), this;
            }
            addToModifierContext(t) {
                return this;
            }
            preFormat() {
                return this.preFormatted = !0, this;
            }
            draw() {
                this.setRendered();
                for(let t = 0; t < this.modifiers.length; ++t){
                    const e = this.modifiers[t];
                    n(e) && (e.setContext(this.getContext()), e.drawWithStyle());
                }
            }
        }
        class ei extends vt {
            static get CATEGORY() {
                return x.GlyphNote;
            }
            constructor(t, e, i){
                super(e), this.options = Object.assign({
                    ignoreTicks: !1,
                    line: 2
                }, i), this.ignore_ticks = this.options.ignoreTicks, this.setGlyph(t);
            }
            setGlyph(t) {
                return this.glyph = t, this.setWidth(this.glyph.getMetrics().width), this;
            }
            getBoundingBox() {
                return this.glyph.getBoundingBox();
            }
            preFormat() {
                return !this.preFormatted && this.modifierContext && this.modifierContext.preFormat(), this.preFormatted = !0, this;
            }
            drawModifiers() {
                const t = this.checkContext();
                for(let e = 0; e < this.modifiers.length; e++){
                    const i = this.modifiers[e];
                    i.setContext(t), i.drawWithStyle();
                }
            }
            getGlyphWidth() {
                return this.glyph.getMetrics().width;
            }
            draw() {
                const t = this.checkStave(), e = t.checkContext();
                this.setRendered(), this.applyStyle(e), e.openGroup("glyphNote", this.getAttribute("id"));
                const i = this.glyph;
                i.getContext() || i.setContext(e), i.setStave(t), i.setYShift(t.getYForLine(this.options.line) - t.getYForGlyphs());
                const b = this.isCenterAligned() ? this.getAbsoluteX() - this.getWidth() / 2 : this.getAbsoluteX();
                i.renderToStave(b), this.drawModifiers(), e.closeGroup(), this.restoreStyle(e);
            }
        }
        class ii extends It {
            static get CATEGORY() {
                return x.GraceNote;
            }
            static get LEDGER_LINE_OFFSET() {
                return 2;
            }
            static get SCALE() {
                return .66;
            }
            constructor(t){
                super(Object.assign({
                    glyph_font_scale: V.NOTATION_FONT_SCALE * ii.SCALE,
                    stroke_px: ii.LEDGER_LINE_OFFSET
                }, t)), this.slash = t.slash || !1, this.slur = !0, this.buildNoteHeads(), this.width = 3;
            }
            getStemExtension() {
                if (this.stem_extension_override) return this.stem_extension_override;
                const t = this.getGlyphProps();
                if (t) {
                    let e = super.getStemExtension();
                    if (t.stem) {
                        const t = this.getStaveNoteScale();
                        e = (at.HEIGHT + e) * t - at.HEIGHT;
                    }
                    return e;
                }
                return 0;
            }
            getStaveNoteScale() {
                return this.render_options.glyph_font_scale / V.NOTATION_FONT_SCALE;
            }
            draw() {
                super.draw(), this.setRendered();
                const t = this.stem;
                if (this.slash && t) {
                    const e = this.getStaveNoteScale(), i = e / .66;
                    let b;
                    const a = this.beam;
                    if (a) a.postFormatted || a.postFormat(), b = this.calcBeamedNotesSlashBBox(8 * i, 8 * i, {
                        stem: 6 * i,
                        beam: 5 * i
                    });
                    else {
                        const a = this.getStemDirection(), n = this.getNoteHeadBounds(), s = t.getHeight();
                        let l = this.getAbsoluteX(), o = a === at.DOWN ? n.y_top - s : n.y_bottom - s;
                        const r = a === at.DOWN ? this.glyphProps.stem_down_extension : this.glyphProps.stem_up_extension;
                        let h = V.STEM_HEIGHT;
                        h -= h / 2.8, h += r, o += h * e * a;
                        const m = a === at.UP ? {
                            x1: 1,
                            y1: 0,
                            x2: 13,
                            y2: -9
                        } : {
                            x1: -4,
                            y1: 1,
                            x2: 13,
                            y2: 9
                        };
                        l += m.x1 * i, o += m.y1 * i, b = {
                            x1: l,
                            y1: o,
                            x2: l + m.x2 * i,
                            y2: o + m.y2 * i
                        };
                    }
                    const n = this.checkContext();
                    n.save(), n.setLineWidth(1 * i), n.beginPath(), n.moveTo(b.x1, b.y1), n.lineTo(b.x2, b.y2), n.closePath(), n.stroke(), n.restore();
                }
            }
            calcBeamedNotesSlashBBox(t, e, i) {
                const b = this.beam;
                if (!b) throw new g("NoBeam", "Can't calculate without a beam.");
                const a = b.slope, n = b.notes[b.notes.length - 1] === this ? -1 : 1, s = Math.atan(a * n), l = Math.cos(s) * e, o = Math.sin(s) * e;
                t *= this.getStemDirection();
                const r = Math.atan((o - t) / l), h = Math.cos(r) * i.stem * n, m = Math.sin(r) * i.stem, c = Math.cos(r) * i.beam * n, d = Math.sin(r) * i.beam, _ = this.getStemX(), x = b.notes[0].getStemX(), y = b.getBeamYToDraw() + (_ - x) * a;
                return {
                    x1: _ - h,
                    y1: y + t - m,
                    x2: _ + l * n + c,
                    y2: y + o + d
                };
            }
        }
        class bi extends vt {
            static get CATEGORY() {
                return x.KeySigNote;
            }
            constructor(t, e, i){
                super({
                    duration: "b"
                }), this.keySignature = new _e(t, e, i), this.ignore_ticks = !0;
            }
            addToModifierContext(t) {
                return this;
            }
            preFormat() {
                return this.preFormatted = !0, this.keySignature.setStave(this.checkStave()), this.setWidth(this.keySignature.getWidth()), this;
            }
            draw() {
                const t = this.checkStave().checkContext();
                this.setRendered(), this.keySignature.setX(this.getAbsoluteX()), this.keySignature.setContext(t), this.keySignature.draw();
            }
        }
        let ai;
        class ni extends R {
            static get CATEGORY() {
                return x.MultiMeasureRest;
            }
            constructor(t, e){
                var i;
                super(), this.xs = {
                    left: NaN,
                    right: NaN
                }, this.hasPaddingLeft = !1, this.hasPaddingRight = !1, this.hasLineThickness = !1, this.hasSymbolSpacing = !1, this.number_of_measures = t, this.hasPaddingLeft = "number" == typeof e.padding_left, this.hasPaddingRight = "number" == typeof e.padding_right, this.hasLineThickness = "number" == typeof e.line_thickness, this.hasSymbolSpacing = "number" == typeof e.symbol_spacing;
                const b = V.currentMusicFont();
                this.render_options = Object.assign({
                    use_symbols: !1,
                    show_number: !0,
                    number_line: -0.5,
                    number_glyph_point: null !== (i = b.lookupMetric("digits.point")) && void 0 !== i ? i : V.NOTATION_FONT_SCALE,
                    line: 2,
                    spacing_between_lines_px: V.STAVE_LINE_DISTANCE,
                    serif_thickness: 2,
                    semibreve_rest_glyph_scale: V.NOTATION_FONT_SCALE,
                    padding_left: 0,
                    padding_right: 0,
                    line_thickness: 5,
                    symbol_spacing: 0
                }, e);
                const a = b.lookupMetric("digits.shiftLine", 0);
                this.render_options.number_line += a;
            }
            getXs() {
                return this.xs;
            }
            setStave(t) {
                return this.stave = t, this;
            }
            getStave() {
                return this.stave;
            }
            checkStave() {
                return p(this.stave, "NoStave", "No stave attached to instance.");
            }
            drawLine(t, e, i, b, a) {
                const n = this.render_options, s = t.getYForLine(n.line), l = .1 * (b - i);
                let o;
                i += l, b -= l, o = this.hasLineThickness ? .5 * n.line_thickness : .25 * a;
                const r = n.serif_thickness, h = s - a, m = s + a, c = i + r, d = b - r, _ = s - o, x = s + o;
                e.save(), e.beginPath(), e.moveTo(i, h), e.lineTo(c, h), e.lineTo(c, _), e.lineTo(d, _), e.lineTo(d, h), e.lineTo(b, h), e.lineTo(b, m), e.lineTo(d, m), e.lineTo(d, x), e.lineTo(c, x), e.lineTo(c, m), e.lineTo(i, m), e.closePath(), e.fill();
            }
            drawSymbols(t, e, i, b, a) {
                const n = Math.floor(this.number_of_measures / 4), s = this.number_of_measures % 4, l = Math.floor(s / 2), o = s % 2, r = this.render_options;
                ai = void 0;
                const h = function() {
                    if (!ai) {
                        const t = new Lt({
                            duration: "w",
                            note_type: "r"
                        });
                        ai = {
                            glyph_font_scale: t.render_options.glyph_font_scale,
                            glyph_code: t.glyph_code,
                            width: t.getWidth()
                        };
                    }
                    return ai;
                }(), m = r.semibreve_rest_glyph_scale, c = h.width * (m / h.glyph_font_scale), d = {
                    2: {
                        width: .5 * c,
                        height: a
                    },
                    1: {
                        width: c
                    }
                }, _ = this.hasSymbolSpacing ? r.symbol_spacing : 10;
                let x = i + .5 * (b - i) - .5 * (n * d[2].width + l * d[2].width + o * d[1].width + (n + l + o - 1) * _);
                const g = r.line, y = t.getYForLine(g - 1), p = t.getYForLine(g), u = t.getYForLine(g + 1);
                e.save(), e.setStrokeStyle("none"), e.setLineWidth(0);
                for(let t = 0; t < n; ++t)e.fillRect(x, p - d[2].height, d[2].width, d[2].height), e.fillRect(x, u - d[2].height, d[2].width, d[2].height), x += d[2].width + _;
                for(let t = 0; t < l; ++t)e.fillRect(x, p - d[2].height, d[2].width, d[2].height), x += d[2].width + _;
                for(let t = 0; t < o; ++t)Z.renderGlyph(e, x, y, m, h.glyph_code), x += d[1].width + _;
                e.restore();
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                const e = this.checkStave();
                let i = e.getNoteStartX(), b = e.getNoteEndX();
                const a = e.getModifiers(wt.BEGIN);
                1 === a.length && s(a[0]) && (i -= a[0].getWidth());
                const n = this.render_options;
                this.hasPaddingLeft && (i = e.getX() + n.padding_left), this.hasPaddingRight && (b = e.getX() + e.getWidth() - n.padding_right), this.xs.left = i, this.xs.right = b;
                const l = n.spacing_between_lines_px;
                if (n.use_symbols ? this.drawSymbols(e, t, i, b, l) : this.drawLine(e, t, i, b, l), n.show_number) {
                    const a = "/" + this.number_of_measures, s = new Te(a, 0, !1);
                    s.point = n.number_glyph_point, s.setTimeSig(a), s.setStave(e), s.setX(i + .5 * (b - i) - .5 * s.getInfo().glyph.getMetrics().width), s.bottomLine = n.number_line, s.setContext(t).draw();
                }
            }
        }
        function si(t, e, i, b, a) {
            const n = li.GLYPHS[t], s = new Z(n.code, a, {
                category: "pedalMarking"
            });
            s.render(e, i - (s.getMetrics().width - V.STAVE_LINE_DISTANCE) / 2, b);
        }
        class li extends R {
            static get CATEGORY() {
                return x.PedalMarking;
            }
            static createSustain(t) {
                return new li(t);
            }
            static createSostenuto(t) {
                const e = new li(t);
                return e.setType(li.type.MIXED), e.setCustomText("Sost. Ped."), e;
            }
            static createUnaCorda(t) {
                const e = new li(t);
                return e.setType(li.type.TEXT), e.setCustomText("una corda", "tre corda"), e;
            }
            constructor(t){
                super(), this.notes = t, this.type = li.type.TEXT, this.line = 0, this.custom_depress_text = "", this.custom_release_text = "", this.resetFont(), this.render_options = {
                    bracket_height: 10,
                    text_margin_right: 6,
                    bracket_line_width: 1,
                    color: "black"
                };
            }
            setType(t) {
                return (t = "string" == typeof t ? li.typeString[t] : t) >= li.type.TEXT && t <= li.type.MIXED && (this.type = t), this;
            }
            setCustomText(t, e) {
                return this.custom_depress_text = t || "", this.custom_release_text = e || "", this;
            }
            setLine(t) {
                return this.line = t, this;
            }
            drawBracketed() {
                const t = this.checkContext();
                let e, i, b = !1;
                this.notes.forEach((a, n, s)=>{
                    var l;
                    b = !b;
                    const o = a.getAbsoluteX(), r = a.checkStave().getYForBottomText(this.line + 3);
                    if (o < e) throw new g("InvalidConfiguration", "The notes provided must be in order of ascending x positions");
                    const h = s[n + 1] === a, m = s[n - 1] === a;
                    let c = 0;
                    const d = null !== (l = V.currentMusicFont().lookupMetric(`pedalMarking.${b ? "down" : "up"}.point`)) && void 0 !== l ? l : V.NOTATION_FONT_SCALE;
                    if (b) {
                        if (c = m ? 5 : 0, this.type !== li.type.MIXED || m) t.beginPath(), t.moveTo(o, r - this.render_options.bracket_height), t.lineTo(o + c, r), t.stroke(), t.closePath();
                        else if (this.custom_depress_text) {
                            const e = t.measureText(this.custom_depress_text).width;
                            t.fillText(this.custom_depress_text, o - e / 2, r), c = e / 2 + this.render_options.text_margin_right;
                        } else si("pedal_depress", t, o, r, d), c = 20 + this.render_options.text_margin_right;
                    } else c = h ? -5 : 0, t.beginPath(), t.moveTo(e, i), t.lineTo(o + c, r), t.lineTo(o, r - this.render_options.bracket_height), t.stroke(), t.closePath();
                    e = o + c, i = r;
                });
            }
            drawText() {
                const t = this.checkContext();
                let e = !1;
                this.notes.forEach((i)=>{
                    var b;
                    e = !e;
                    const a = i.checkStave(), n = i.getAbsoluteX(), s = a.getYForBottomText(this.line + 3), l = null !== (b = V.currentMusicFont().lookupMetric(`pedalMarking.${e ? "down" : "up"}.point`)) && void 0 !== b ? b : V.NOTATION_FONT_SCALE;
                    let o = 0;
                    e ? this.custom_depress_text ? (o = t.measureText(this.custom_depress_text).width, t.fillText(this.custom_depress_text, n - o / 2, s)) : si("pedal_depress", t, n, s, l) : this.custom_release_text ? (o = t.measureText(this.custom_release_text).width, t.fillText(this.custom_release_text, n - o / 2, s)) : si("pedal_release", t, n, s, l);
                });
            }
            draw() {
                const t = this.checkContext();
                this.setRendered(), t.save(), t.setStrokeStyle(this.render_options.color), t.setFillStyle(this.render_options.color), t.setFont(this.textFont), function(...t) {
                    li.DEBUG && u("Vex.Flow.PedalMarking", t);
                }("Rendering Pedal Marking"), this.type === li.type.BRACKET || this.type === li.type.MIXED ? (t.setLineWidth(this.render_options.bracket_line_width), this.drawBracketed()) : this.type === li.type.TEXT && this.drawText(), t.restore();
            }
        }
        li.DEBUG = !1, li.TEXT_FONT = {
            family: F.SERIF,
            size: 12,
            weight: E.BOLD,
            style: P.ITALIC
        }, li.GLYPHS = {
            pedal_depress: {
                code: "keyboardPedalPed"
            },
            pedal_release: {
                code: "keyboardPedalUp"
            }
        }, li.type = {
            TEXT: 1,
            BRACKET: 2,
            MIXED: 3
        }, li.typeString = {
            text: li.type.TEXT,
            bracket: li.type.BRACKET,
            mixed: li.type.MIXED
        };
        const oi = {
            1: "repeat1Bar",
            2: "repeat2Bars",
            4: "repeat4Bars",
            slash: "repeatBarSlash"
        };
        class ri extends ei {
            static get CATEGORY() {
                return x.RepeatNote;
            }
            constructor(t, e, i){
                super(new Z(oi[t] || "repeat1Bar", V.currentMusicFont().lookupMetric("repeatNote.point", 40), {
                    category: "repeatNote"
                }), Object.assign({
                    duration: "q",
                    align_center: "slash" !== t
                }, e), i);
            }
        }
        function hi(t, e, i, b, a, n, s) {
            t.beginPath(), t.moveTo(e, i), t.lineTo(b, a), t.lineTo(n, s), t.lineTo(e, i), t.closePath(), t.fill();
        }
        class mi extends R {
            static get CATEGORY() {
                return x.StaveLine;
            }
            constructor(t){
                super(), this.setNotes(t), this.text = "", this.resetFont(), this.render_options = {
                    padding_left: 4,
                    padding_right: 3,
                    line_width: 1,
                    line_dash: void 0,
                    rounded_end: !0,
                    color: void 0,
                    draw_start_arrow: !1,
                    draw_end_arrow: !1,
                    arrowhead_length: 10,
                    arrowhead_angle: Math.PI / 8,
                    text_position_vertical: mi.TextVerticalPosition.TOP,
                    text_justification: mi.TextJustification.CENTER
                };
            }
            setText(t) {
                return this.text = t, this;
            }
            setNotes(t) {
                if (!t.first_note && !t.last_note) throw new g("BadArguments", "Notes needs to have either first_note or last_note set.");
                if (t.first_indices || (t.first_indices = [
                    0
                ]), t.last_indices || (t.last_indices = [
                    0
                ]), t.first_indices.length !== t.last_indices.length) throw new g("BadArguments", "Connected notes must have same number of indices.");
                return this.notes = t, this.first_note = t.first_note, this.first_indices = t.first_indices, this.last_note = t.last_note, this.last_indices = t.last_indices, this;
            }
            applyLineStyle() {
                const t = this.checkContext(), e = this.render_options;
                e.line_dash && t.setLineDash(e.line_dash), e.line_width && t.setLineWidth(e.line_width), e.rounded_end ? t.setLineCap("round") : t.setLineCap("square");
            }
            applyFontStyle() {
                const t = this.checkContext();
                t.setFont(this.textFont);
                const e = this.render_options.color;
                e && (t.setStrokeStyle(e), t.setFillStyle(e));
            }
            drawArrowLine(t, e, i) {
                const b = this.render_options.draw_start_arrow && this.render_options.draw_end_arrow, a = e.x, n = e.y, s = i.x, l = i.y, o = Math.sqrt((s - a) * (s - a) + (l - n) * (l - n)), r = (o - this.render_options.arrowhead_length / 3) / o;
                let h, m, c, d;
                this.render_options.draw_end_arrow || b ? (h = Math.round(a + (s - a) * r), m = Math.round(n + (l - n) * r)) : (h = s, m = l), this.render_options.draw_start_arrow || b ? (c = a + (s - a) * (1 - r), d = n + (l - n) * (1 - r)) : (c = a, d = n), this.render_options.color && (t.setStrokeStyle(this.render_options.color), t.setFillStyle(this.render_options.color)), t.beginPath(), t.moveTo(c, d), t.lineTo(h, m), t.stroke(), t.closePath();
                const _ = Math.atan2(l - n, s - a), x = Math.abs(this.render_options.arrowhead_length / Math.cos(this.render_options.arrowhead_angle));
                let g, y, p, u, f, S;
                (this.render_options.draw_end_arrow || b) && (g = _ + Math.PI + this.render_options.arrowhead_angle, p = s + Math.cos(g) * x, u = l + Math.sin(g) * x, y = _ + Math.PI - this.render_options.arrowhead_angle, f = s + Math.cos(y) * x, S = l + Math.sin(y) * x, hi(t, p, u, s, l, f, S)), (this.render_options.draw_start_arrow || b) && (g = _ + this.render_options.arrowhead_angle, p = a + Math.cos(g) * x, u = n + Math.sin(g) * x, y = _ - this.render_options.arrowhead_angle, f = a + Math.cos(y) * x, S = n + Math.sin(y) * x, hi(t, p, u, a, n, f, S));
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                const e = this.first_note, i = this.last_note, b = this.render_options;
                t.save(), this.applyLineStyle();
                let a = {
                    x: 0,
                    y: 0
                }, n = {
                    x: 0,
                    y: 0
                };
                this.first_indices.forEach((s, l)=>{
                    const o = this.last_indices[l];
                    a = e.getModifierStartXY(2, s), n = i.getModifierStartXY(1, o);
                    const r = a.y > n.y;
                    a.x += e.getMetrics().modRightPx + b.padding_left, n.x -= i.getMetrics().modLeftPx + b.padding_right;
                    const h = e.getGlyphProps().getWidth();
                    e.getKeyProps()[s].displaced && 1 === e.getStemDirection() && (a.x += h + b.padding_left);
                    i.getKeyProps()[o].displaced && -1 === i.getStemDirection() && (n.x -= h + b.padding_right), a.y += r ? -3 : 1, n.y += r ? 2 : 0, this.drawArrowLine(t, a, n);
                }), t.restore();
                const s = t.measureText(this.text).width, l = b.text_justification;
                let o = 0;
                if (l === mi.TextJustification.LEFT) o = a.x;
                else if (l === mi.TextJustification.CENTER) o = (n.x - a.x) / 2 + a.x - s / 2;
                else l === mi.TextJustification.RIGHT && (o = n.x - s);
                let r = 0;
                const h = b.text_position_vertical;
                return h === mi.TextVerticalPosition.TOP ? r = e.checkStave().getYForTopText() : h === mi.TextVerticalPosition.BOTTOM && (r = e.checkStave().getYForBottomText(V.TEXT_HEIGHT_OFFSET_HACK)), t.save(), this.applyFontStyle(), t.fillText(this.text, o, r), t.restore(), this;
            }
        }
        mi.TEXT_FONT = Object.assign({}, R.TEXT_FONT), mi.TextVerticalPosition = {
            TOP: 1,
            BOTTOM: 2
        }, mi.TextJustification = ne;
        class ci extends R {
            static get CATEGORY() {
                return x.System;
            }
            constructor(t = {}){
                super(), this.setOptions(t), this.partStaves = [], this.partStaveInfos = [], this.partVoices = [];
            }
            setOptions(t = {}) {
                if (!t.factory) throw new g("NoFactory", "System.setOptions(options) requires a factory.");
                this.factory = t.factory, this.options = Object.assign(Object.assign({
                    factory: this.factory,
                    x: 10,
                    y: 10,
                    width: 500,
                    spaceBetweenStaves: 12,
                    autoWidth: !1,
                    noJustification: !1,
                    debugFormatter: !1,
                    formatIterations: 0,
                    noPadding: !1
                }, t), {
                    details: Object.assign({
                        alpha: .5
                    }, t.details),
                    formatOptions: Object.assign({}, t.formatOptions)
                }), !1 === this.options.noJustification && void 0 === t.width && (this.options.autoWidth = !0);
            }
            getX() {
                return this.options.x;
            }
            setX(t) {
                this.options.x = t, this.partStaves.forEach((e)=>{
                    e.setX(t);
                });
            }
            getY() {
                return this.options.y;
            }
            setY(t) {
                this.options.y = t, this.partStaves.forEach((e)=>{
                    e.setY(t);
                });
            }
            getStaves() {
                return this.partStaves;
            }
            getVoices() {
                return this.partVoices;
            }
            setContext(t) {
                return super.setContext(t), this.factory.setContext(t), this;
            }
            addConnector(t = "double") {
                return this.connector = this.factory.StaveConnector({
                    top_stave: this.partStaves[0],
                    bottom_stave: this.partStaves[this.partStaves.length - 1],
                    type: t
                }), this.connector;
            }
            addStave(t) {
                var e;
                const i = Object.assign({
                    left_bar: !1
                }, t.options), b = null !== (e = t.stave) && void 0 !== e ? e : this.factory.Stave({
                    x: this.options.x,
                    y: this.options.y,
                    width: this.options.width,
                    options: i
                }), a = Object.assign(Object.assign({
                    spaceAbove: 0,
                    spaceBelow: 0,
                    debugNoteMetrics: !1,
                    noJustification: !1
                }, t), {
                    options: i
                }), n = this.getContext();
                return a.voices.forEach((t)=>{
                    t.setContext(n).setStave(b).getTickables().forEach((t)=>t.setStave(b)), this.partVoices.push(t);
                }), this.partStaves.push(b), this.partStaveInfos.push(a), b;
            }
            addVoices(t) {
                const e = this.getContext();
                t.forEach((t)=>{
                    t.setContext(e), this.partVoices.push(t);
                });
            }
            format() {
                const t = this.options.details;
                let e = 0;
                const i = new Pe(t);
                this.formatter = i;
                let b = this.options.y, a = 0;
                const n = [];
                this.partStaves.forEach((t, e)=>{
                    b += t.space(this.partStaveInfos[e].spaceAbove), t.setY(b), b += t.space(this.partStaveInfos[e].spaceBelow), b += t.space(this.options.spaceBetweenStaves), this.partStaveInfos[e].debugNoteMetrics && (n.push({
                        y: b,
                        stave: t
                    }), b += 15), a = Math.max(a, t.getNoteStartX());
                }), this.partVoices.forEach((t)=>{
                    t.getTickables().forEach((t)=>{
                        const e = t.getStave();
                        e && t.setStave(e);
                    });
                }), i.joinVoices(this.partVoices), this.partStaves.forEach((t)=>t.setNoteStartX(a)), this.options.autoWidth && this.partVoices.length > 0 ? (e = i.preCalculateMinTotalWidth(this.partVoices), this.options.width = e + ze.rightPadding + (a - this.options.x), this.partStaves.forEach((t)=>{
                    t.setWidth(this.options.width);
                })) : e = this.options.noPadding ? this.options.width - (a - this.options.x) : this.options.width - (a - this.options.x) - ze.defaultPadding, this.partVoices.length > 0 && i.format(this.partVoices, this.options.noJustification ? 0 : e, this.options.formatOptions), i.postFormat();
                for(let e = 0; e < this.options.formatIterations; e++)i.tune(t);
                this.startX = a, this.debugNoteMetricsYs = n, this.lastY = b, this.boundingBox = new D(this.options.x, this.options.y, this.options.width, this.lastY - this.options.y), ze.formatBegModifiers(this.partStaves);
            }
            draw() {
                const t = this.checkContext();
                if (!(this.formatter && this.startX && this.lastY && this.debugNoteMetricsYs)) throw new g("NoFormatter", "format() must be called before draw()");
                this.setRendered(), this.options.debugFormatter && Pe.plotDebugging(t, this.formatter, this.startX, this.options.y, this.lastY), this.debugNoteMetricsYs.forEach((e)=>{
                    this.partVoices.forEach((i)=>{
                        i.getTickables().forEach((i)=>{
                            i.getStave() === e.stave && vt.plotMetrics(t, i, e.y);
                        });
                    });
                });
            }
        }
        class di extends Wt {
            static get CATEGORY() {
                return x.TabNote;
            }
            constructor(t, e = !1){
                super(t), this.glyphPropsArr = [], this.greatestString = ()=>this.positions.map((t)=>t.str).reduce((t, e)=>t > e ? t : e), this.leastString = ()=>this.positions.map((t)=>t.str).reduce((t, e)=>t < e ? t : e), this.ghost = !1, this.positions = t.positions || [], this.render_options = Object.assign(Object.assign({}, this.render_options), {
                    glyph_font_scale: V.TABLATURE_FONT_SCALE,
                    draw_stem: e,
                    draw_dots: e,
                    draw_stem_through_stave: !1,
                    y_shift: 0,
                    scale: 1,
                    font: `${F.SIZE}pt ${F.SANS_SERIF}`
                }), this.glyphProps = V.getGlyphProps(this.duration, this.noteType), p(this.glyphProps, "BadArguments", `No glyph found for duration '${this.duration}' and type '${this.noteType}'`), this.buildStem(), t.stem_direction ? this.setStemDirection(t.stem_direction) : this.setStemDirection(at.UP), this.ghost = !1, this.updateWidth();
            }
            reset() {
                return super.reset(), this.stave && this.setStave(this.stave), this;
            }
            setGhost(t) {
                return this.ghost = t, this.updateWidth(), this;
            }
            hasStem() {
                return !!this.render_options.draw_stem;
            }
            getStemExtension() {
                const t = this.getGlyphProps();
                return null != this.stem_extension_override ? this.stem_extension_override : t ? this.getStemDirection() === at.UP ? t.tabnote_stem_up_extension : t.tabnote_stem_down_extension : 0;
            }
            updateWidth() {
                this.glyphPropsArr = [], this.width = 0;
                for(let t = 0; t < this.positions.length; ++t){
                    let e = this.positions[t].fret;
                    this.ghost && (e = "(" + e + ")");
                    const i = V.tabToGlyphProps(e.toString(), this.render_options.scale);
                    this.glyphPropsArr.push(i), this.width = Math.max(i.getWidth(), this.width);
                }
                this.glyphProps.getWidth = ()=>this.width;
            }
            setStave(t) {
                super.setStave(t);
                const e = t.getContext();
                if (this.setContext(e), e) {
                    this.width = 0;
                    for(let t = 0; t < this.glyphPropsArr.length; ++t){
                        const i = this.glyphPropsArr[t], b = "" + i.text;
                        "X" !== b.toUpperCase() && (e.save(), e.setFont(this.render_options.font), i.width = e.measureText(b).width, e.restore(), i.getWidth = ()=>i.width), this.width = Math.max(i.getWidth(), this.width);
                    }
                    this.glyphProps.getWidth = ()=>this.width;
                }
                const i = this.positions.map(({ str: e })=>t.getYForLine(Number(e) - 1));
                return this.setYs(i), this.stem && this.stem.setYBounds(this.getStemY(), this.getStemY()), this;
            }
            getPositions() {
                return this.positions;
            }
            getModifierStartXY(t, e) {
                if (!this.preFormatted) throw new g("UnformattedNote", "Can't call GetModifierStartXY on an unformatted note");
                if (0 === this.ys.length) throw new g("NoYValues", "No Y-Values calculated for this note.");
                let i = 0;
                if (t === tt.Position.LEFT) i = -2;
                else if (t === tt.Position.RIGHT) i = this.width + 2;
                else if (t === tt.Position.BELOW || t === tt.Position.ABOVE) i = this.glyphProps.getWidth() / 2;
                return {
                    x: this.getAbsoluteX() + i,
                    y: this.ys[e]
                };
            }
            getLineForRest() {
                return Number(this.positions[0].str);
            }
            preFormat() {
                this.preFormatted || (this.modifierContext && this.modifierContext.preFormat(), this.preFormatted = !0);
            }
            getStemX() {
                return this.getCenterGlyphX();
            }
            getStemY() {
                const t = this.checkStave().getNumLines() - .5, e = at.UP === this.stem_direction ? -0.5 : t;
                return this.checkStave().getYForLine(e);
            }
            getStemExtents() {
                return this.checkStem().getExtents();
            }
            drawFlag() {
                var t;
                const { beam: e, glyphProps: i, render_options: { draw_stem: b } } = this, a = this.checkContext(), n = null == e && b;
                if (i.flag && n) {
                    const e = this.getStemX(), i = this.getStemDirection() === at.DOWN ? this.getStemY() - this.checkStem().getHeight() - (this.glyphProps ? this.glyphProps.stem_down_extension : 0) : this.getStemY() - this.checkStem().getHeight() + (this.glyphProps ? this.glyphProps.stem_up_extension : 0);
                    null === (t = this.flag) || void 0 === t || t.render(a, e, i);
                }
            }
            drawModifiers() {
                this.modifiers.forEach((t)=>{
                    l(t) && !this.render_options.draw_dots || (t.setContext(this.getContext()), t.drawWithStyle());
                });
            }
            drawStemThrough() {
                const t = this.getStemX(), e = this.getStemY(), i = this.checkContext(), b = this.render_options.draw_stem, a = this.render_options.draw_stem_through_stave;
                if (b && a) {
                    const b = function(t, e, i, b) {
                        const a = 1 !== b, n = -1 !== b, s = i.getSpacingBetweenLines(), l = i.getNumLines(), o = [];
                        return e.forEach((e)=>{
                            const r = e.indexOf(l) > -1, h = e.indexOf(1) > -1;
                            if (a && h || n && r) return;
                            1 === e.length && e.push(e[0]);
                            const m = [];
                            e.forEach((e, a, n)=>{
                                const o = 1 === e, r = e === l;
                                let h = i.getYForLine(e - 1);
                                0 !== a || o ? a !== n.length - 1 || r || (h += s / 2 - 1) : h -= s / 2 - 1, m.push(h), 1 === b && o ? m.push(t - 2) : -1 === b && r && m.push(t + 2);
                            }), o.push(m.sort((t, e)=>t - e));
                        }), o;
                    }(e, function(t, e) {
                        const i = [];
                        let b = [];
                        for(let a = 1; a <= t; a++)e.indexOf(a) > -1 ? (i.push(b), b = []) : b.push(a);
                        return b.length > 0 && i.push(b), i;
                    }(this.checkStave().getNumLines(), this.positions.map((t)=>Number(t.str))), this.checkStave(), this.getStemDirection());
                    i.save(), i.setLineWidth(at.WIDTH), b.forEach((e)=>{
                        0 !== e.length && (i.beginPath(), i.moveTo(t, e[0]), i.lineTo(t, e[e.length - 1]), i.stroke(), i.closePath());
                    }), i.restore();
                }
            }
            drawPositions() {
                var t;
                const e = this.checkContext(), i = this.getAbsoluteX(), b = this.ys;
                for(let a = 0; a < this.positions.length; ++a){
                    const n = b[a] + this.render_options.y_shift, s = this.glyphPropsArr[a], l = i + this.glyphProps.getWidth() / 2 - s.getWidth() / 2;
                    if (e.clearRect(l - 2, n - 3, s.getWidth() + 4, 6), s.code) Z.renderGlyph(e, l, n, this.render_options.glyph_font_scale * this.render_options.scale, s.code);
                    else {
                        e.save(), e.setFont(this.render_options.font);
                        const i = null !== (t = s.text) && void 0 !== t ? t : "";
                        e.fillText(i, l, n + 5 * this.render_options.scale), e.restore();
                    }
                }
            }
            draw() {
                const t = this.checkContext();
                if (0 === this.ys.length) throw new g("NoYValues", "Can't draw note without Y values.");
                this.setRendered();
                const e = null == this.beam && this.render_options.draw_stem;
                if (this.applyStyle(), t.openGroup("tabnote", this.getAttribute("id"), {
                    pointerBBox: !0
                }), this.drawPositions(), this.drawStemThrough(), this.stem && e) {
                    const e = this.getStemX();
                    this.stem.setNoteHeadXBounds(e, e), this.stem.setContext(t).draw();
                }
                this.drawFlag(), this.drawModifiers(), t.closeGroup(), this.restoreStyle();
            }
        }
        class _i extends ze {
            static get CATEGORY() {
                return x.TabStave;
            }
            constructor(t, e, i, b){
                super(t, e, i, Object.assign({
                    spacing_between_lines_px: 13,
                    num_lines: 6,
                    top_text_position: 1
                }, b));
            }
            getYForGlyphs() {
                return this.getYForLine(2.5);
            }
            addTabGlyph() {
                return this.addClef("tab"), this;
            }
        }
        function xi(...t) {
            yi.DEBUG && u("Vex.Flow.TextBracket", t);
        }
        var gi;
        !function(t) {
            t[t.TOP = 1] = "TOP", t[t.BOTTOM = -1] = "BOTTOM";
        }(gi || (gi = {}));
        class yi extends R {
            static get CATEGORY() {
                return x.TextBracket;
            }
            static get Position() {
                return gi;
            }
            static get PositionString() {
                return {
                    top: gi.TOP,
                    bottom: gi.BOTTOM
                };
            }
            static get Positions() {
                return xi("Positions is deprecated, use TextBracketPosition instead."), gi;
            }
            static get PositionsString() {
                return xi("PositionsString is deprecated, use PositionString instead."), yi.PositionString;
            }
            constructor({ start: t, stop: e, text: i = "", superscript: b = "", position: a = gi.TOP }){
                super(), this.start = t, this.stop = e, this.text = i, this.superscript = b, this.position = "string" == typeof a ? yi.PositionString[a] : a, this.line = 1, this.resetFont(), this.render_options = {
                    dashed: !0,
                    dash: [
                        5
                    ],
                    color: "black",
                    line_width: 1,
                    show_bracket: !0,
                    bracket_height: 8,
                    underline_superscript: !0
                };
            }
            applyStyle(t) {
                t.setFont(this.font);
                const e = this.render_options;
                return t.setStrokeStyle(e.color), t.setFillStyle(e.color), t.setLineWidth(e.line_width), this;
            }
            setDashed(t, e) {
                return this.render_options.dashed = t, e && (this.render_options.dash = e), this;
            }
            setLine(t) {
                return this.line = t, this;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                let e = 0;
                switch(this.position){
                    case gi.TOP:
                        e = this.start.checkStave().getYForTopText(this.line);
                        break;
                    case gi.BOTTOM:
                        e = this.start.checkStave().getYForBottomText(this.line + V.TEXT_HEIGHT_OFFSET_HACK);
                        break;
                    default:
                        throw new g("InvalidPosition", `The position ${this.position} is invalid.`);
                }
                const i = {
                    x: this.start.getAbsoluteX(),
                    y: e
                }, b = {
                    x: this.stop.getAbsoluteX(),
                    y: e
                };
                xi("Rendering TextBracket: start:", i, "stop:", b, "y:", e);
                const a = this.render_options.bracket_height * this.position;
                t.save(), this.applyStyle(t), t.fillText(this.text, i.x, i.y);
                const n = t.measureText(this.text), s = n.width, l = n.height, o = i.y - l / 2.5, { family: r, size: h, weight: m, style: c } = this.textFont, d = F.scaleSize(h, .714286);
                t.setFont(r, d, m, c), t.fillText(this.superscript, i.x + s + 1, o);
                const _ = t.measureText(this.superscript), x = _.width, y = _.height;
                let p = i.x, u = o;
                const f = b.x + this.stop.getGlyphProps().getWidth();
                this.position === gi.TOP ? (p += s + x + 5, u -= y / 2.7) : this.position === gi.BOTTOM && (u += y / 2.7, p += s + 2, this.render_options.underline_superscript || (p += x)), this.render_options.dashed ? (le.drawDashedLine(t, p, u, f, u, this.render_options.dash), this.render_options.show_bracket && le.drawDashedLine(t, f, u + 1 * this.position, f, u + a, this.render_options.dash)) : (t.beginPath(), t.moveTo(p, u), t.lineTo(f, u), this.render_options.show_bracket && t.lineTo(f, u + a), t.stroke(), t.closePath()), t.restore();
            }
        }
        function pi(...t) {
            ui.DEBUG && u("Vex.Flow.TextDynamics", t);
        }
        yi.DEBUG = !1, yi.TEXT_FONT = {
            family: F.SERIF,
            size: 15,
            weight: E.NORMAL,
            style: P.ITALIC
        };
        class ui extends vt {
            static get CATEGORY() {
                return x.TextDynamics;
            }
            static get GLYPHS() {
                return {
                    f: {
                        code: "dynamicForte",
                        width: 12
                    },
                    p: {
                        code: "dynamicPiano",
                        width: 14
                    },
                    m: {
                        code: "dynamicMezzo",
                        width: 17
                    },
                    s: {
                        code: "dynamicSforzando",
                        width: 10
                    },
                    z: {
                        code: "dynamicZ",
                        width: 12
                    },
                    r: {
                        code: "dynamicRinforzando",
                        width: 12
                    }
                };
            }
            constructor(t){
                super(t), this.sequence = (t.text || "").toLowerCase(), this.line = t.line || 0, this.glyphs = [], this.render_options = Object.assign(Object.assign({}, this.render_options), {
                    glyph_font_size: V.NOTATION_FONT_SCALE
                }), pi("New Dynamics Text: ", this.sequence);
            }
            setLine(t) {
                return this.line = t, this;
            }
            preFormat() {
                let t = 0;
                return this.glyphs = [], this.sequence.split("").forEach((e)=>{
                    const i = ui.GLYPHS[e];
                    if (!i) throw new g("Invalid dynamics character: " + e);
                    const b = p(this.render_options.glyph_font_size), a = new Z(i.code, b, {
                        category: "textNote"
                    });
                    this.glyphs.push(a), t += i.width;
                }), this.setWidth(t), this.preFormatted = !0, this;
            }
            draw() {
                this.setRendered();
                const t = this.getAbsoluteX(), e = this.checkStave().getYForLine(this.line + -3);
                pi("Rendering Dynamics: ", this.sequence);
                let i = t;
                this.glyphs.forEach((t, b)=>{
                    const a = this.sequence[b];
                    t.render(this.checkContext(), i, e), i += ui.GLYPHS[a].width;
                });
            }
        }
        ui.DEBUG = !1;
        class fi extends vt {
            static get CATEGORY() {
                return x.TimeSigNote;
            }
            constructor(t, e){
                super({
                    duration: "b"
                }), this.timeSig = new Te(t, e), this.setWidth(this.timeSig.getGlyph().getMetrics().width), this.ignore_ticks = !0;
            }
            addToModifierContext(t) {
                return this;
            }
            preFormat() {
                return this.preFormatted = !0, this;
            }
            draw() {
                const t = this.checkStave(), e = this.checkContext();
                this.setRendered();
                const i = this.timeSig.getGlyph();
                i.getContext() || i.setContext(e), i.setStave(t), i.setYShift(t.getYForLine(2) - t.getYForGlyphs()), i.renderToStave(this.getAbsoluteX());
            }
        }
        class Si extends R {
            static get CATEGORY() {
                return x.VibratoBracket;
            }
            constructor(t){
                super(), t.start && (this.start = t.start), t.stop && (this.stop = t.stop), this.line = 1, this.render_options = {
                    harsh: !1,
                    wave_height: 6,
                    wave_width: 4,
                    wave_girth: 2,
                    vibrato_width: 0
                };
            }
            setLine(t) {
                return this.line = t, this;
            }
            setHarsh(t) {
                return this.render_options.harsh = t, this;
            }
            draw() {
                const t = this.checkContext();
                this.setRendered();
                const e = this.start && this.start.checkStave().getYForTopText(this.line) || this.stop && this.stop.checkStave().getYForTopText(this.line) || 0, i = this.start && this.start.getAbsoluteX() || this.stop && this.stop.checkStave().getTieStartX() || 0, b = this.stop && this.stop.getAbsoluteX() - this.stop.getWidth() - 5 || this.start && this.start.checkStave().getTieEndX() - 10 || 0;
                this.render_options.vibrato_width = b - i, function(...t) {
                    Si.DEBUG && u("Vex.Flow.VibratoBracket", t);
                }("Rendering VibratoBracket: start_x:", i, "stop_x:", b, "y:", e), he.renderVibrato(t, i, e, this.render_options);
            }
        }
        function Ti(...t) {
            vi.DEBUG && u("Vex.Flow.Factory", t);
        }
        Si.DEBUG = !1;
        class vi {
            static newFromElementId(t, e = 500, i = 200) {
                return new vi({
                    renderer: {
                        elementId: t,
                        width: e,
                        height: i
                    }
                });
            }
            constructor(t = {}){
                Ti("New factory: ", t), this.options = {
                    stave: {
                        space: 10
                    },
                    renderer: {
                        elementId: "",
                        width: 500,
                        height: 200,
                        background: "#FFF"
                    },
                    font: vi.TEXT_FONT
                }, this.setOptions(t);
            }
            reset() {
                this.renderQ = [], this.systems = [], this.staves = [], this.voices = [], this.stave = void 0;
            }
            setOptions(t) {
                this.options = Object.assign(Object.assign({}, this.options), t), this.initRenderer(), this.reset();
            }
            initRenderer() {
                const { elementId: t, width: e, height: i, background: b } = this.options.renderer;
                if (null == t) return;
                if ("" == t) throw Ti(this), new g("renderer.elementId not set in FactoryOptions");
                let a = this.options.renderer.backend;
                if (void 0 === a) a = Jt(document.getElementById(t)) ? le.Backends.CANVAS : le.Backends.SVG;
                this.context = le.buildContext(t, a, e, i, b);
            }
            getContext() {
                return this.context;
            }
            setContext(t) {
                return this.context = t, this;
            }
            getStave() {
                return this.stave;
            }
            getVoices() {
                return this.voices;
            }
            Stave(t) {
                const e = this.options.stave.space, i = Object.assign({
                    x: 0,
                    y: 0,
                    width: this.options.renderer.width - 1 * e,
                    options: {
                        spacing_between_lines_px: 1 * e
                    }
                }, t), b = new ze(i.x, i.y, i.width, i.options);
                return this.staves.push(b), b.setContext(this.context), this.stave = b, b;
            }
            TabStave(t) {
                const e = this.options.stave.space, i = Object.assign({
                    x: 0,
                    y: 0,
                    width: this.options.renderer.width - 1 * e,
                    options: {
                        spacing_between_lines_px: 1.3 * e
                    }
                }, t), b = new _i(i.x, i.y, i.width, i.options);
                return this.staves.push(b), b.setContext(this.context), this.stave = b, b;
            }
            StaveNote(t) {
                const e = new It(t);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            GlyphNote(t, e, i) {
                const b = new ei(t, e, i);
                return this.stave && b.setStave(this.stave), b.setContext(this.context), this.renderQ.push(b), b;
            }
            RepeatNote(t, e, i) {
                const b = new ri(t, e, i);
                return this.stave && b.setStave(this.stave), b.setContext(this.context), this.renderQ.push(b), b;
            }
            GhostNote(t) {
                const e = new ti(t);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            TextNote(t) {
                const e = new pe(t);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            BarNote(t = {}) {
                const e = new At(t.type);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            ClefNote(t) {
                const e = Object.assign({
                    type: "treble",
                    options: {
                        size: "default",
                        annotation: void 0
                    }
                }, t), i = new Le(e.type, e.options.size, e.options.annotation);
                return this.stave && i.setStave(this.stave), i.setContext(this.context), this.renderQ.push(i), i;
            }
            TimeSigNote(t) {
                const e = Object.assign({
                    time: "4/4"
                }, t), i = new fi(e.time);
                return this.stave && i.setStave(this.stave), i.setContext(this.context), this.renderQ.push(i), i;
            }
            KeySigNote(t) {
                const e = new bi(t.key, t.cancelKey, t.alterKey);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            TabNote(t) {
                const e = new di(t);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), this.renderQ.push(e), e;
            }
            GraceNote(t) {
                const e = new ii(t);
                return this.stave && e.setStave(this.stave), e.setContext(this.context), e;
            }
            GraceNoteGroup(t) {
                const e = new jt(t.notes, t.slur);
                return e.setContext(this.context), e;
            }
            Accidental(t) {
                const e = new bt(t.type);
                return e.setContext(this.context), e;
            }
            Annotation(t) {
                const e = Object.assign({
                    text: "p",
                    hJustify: ht.CENTER,
                    vJustify: mt.BOTTOM
                }, t), i = new ct(e.text);
                return i.setJustification(e.hJustify), i.setVerticalJustification(e.vJustify), i.setFont(e.font), i.setContext(this.context), i;
            }
            ChordSymbol(t) {
                const e = Object.assign({
                    vJustify: "top",
                    hJustify: "center",
                    kerning: !0,
                    reportWidth: !0
                }, t), i = new Mt;
                return i.setHorizontal(e.hJustify), i.setVertical(e.vJustify), i.setEnableKerning(e.kerning), i.setReportWidth(e.reportWidth), "string" == typeof e.fontFamily && "number" == typeof e.fontSize ? "string" == typeof e.fontWeight ? i.setFont(e.fontFamily, e.fontSize, e.fontWeight) : i.setFont(e.fontFamily, e.fontSize, "") : "number" == typeof e.fontSize && i.setFontSize(e.fontSize), i.setContext(this.context), i;
            }
            Articulation(t) {
                var e;
                const i = new ut(null !== (e = null == t ? void 0 : t.type) && void 0 !== e ? e : "a.");
                return null != (null == t ? void 0 : t.position) && i.setPosition(t.position), null != (null == t ? void 0 : t.betweenLines) && i.setBetweenLines(t.betweenLines), i.setContext(this.context), i;
            }
            Ornament(t, e) {
                const i = Object.assign({
                    type: t,
                    position: 0,
                    accidental: ""
                }, e), b = new Kt(t);
                return b.setPosition(i.position), i.upperAccidental && b.setUpperAccidental(i.upperAccidental), i.lowerAccidental && b.setLowerAccidental(i.lowerAccidental), void 0 !== i.delayed && b.setDelayed(i.delayed), b.setContext(this.context), b;
            }
            TextDynamics(t) {
                const e = Object.assign({
                    text: "p",
                    duration: "q",
                    dots: 0,
                    line: 0
                }, t), i = new ui({
                    text: e.text,
                    line: e.line,
                    duration: e.duration,
                    dots: e.dots
                });
                return this.stave && i.setStave(this.stave), i.setContext(this.context), this.renderQ.push(i), i;
            }
            Fingering(t) {
                const e = Object.assign({
                    number: "0",
                    position: "left"
                }, t), i = new Rt(e.number);
                return i.setPosition(e.position), i.setContext(this.context), i;
            }
            StringNumber(t, e = !0) {
                const i = new oe(t.number);
                return i.setPosition(t.position), i.setContext(this.context), i.setDrawCircle(e), i;
            }
            TickContext() {
                return new Ce;
            }
            ModifierContext() {
                return new ce;
            }
            MultiMeasureRest(t) {
                const e = p(t.number_of_measures, "NoNumberOfMeasures"), i = new ni(e, t);
                return i.setContext(this.context), this.renderQ.push(i), i;
            }
            Voice(t) {
                const e = Object.assign({
                    time: "4/4"
                }, t), i = new Xt(e.time);
                return this.voices.push(i), i;
            }
            StaveConnector(t) {
                const e = new De(t.top_stave, t.bottom_stave);
                return e.setType(t.type).setContext(this.context), this.renderQ.push(e), e;
            }
            Formatter(t) {
                return new Pe(t);
            }
            Tuplet(t) {
                const e = Object.assign({
                    notes: [],
                    options: {}
                }, t), i = new Ae(e.notes, e.options).setContext(this.context);
                return this.renderQ.push(i), i;
            }
            Beam(t) {
                var e, i, b, a, n;
                const s = new Re(t.notes, null === (e = t.options) || void 0 === e ? void 0 : e.autoStem).setContext(this.context);
                return s.breakSecondaryAt(null !== (b = null === (i = t.options) || void 0 === i ? void 0 : i.secondaryBeamBreaks) && void 0 !== b ? b : []), (null === (a = t.options) || void 0 === a ? void 0 : a.partialBeamDirections) && Object.entries(null === (n = t.options) || void 0 === n ? void 0 : n.partialBeamDirections).forEach(([t, e])=>{
                    s.setPartialBeamSideAt(Number(t), e);
                }), this.renderQ.push(s), s;
            }
            Curve(t) {
                const e = new Ie(t.from, t.to, t.options).setContext(this.context);
                return this.renderQ.push(e), e;
            }
            StaveTie(t) {
                var e;
                const i = new Gt({
                    first_note: t.from,
                    last_note: t.to,
                    first_indices: t.first_indices,
                    last_indices: t.last_indices
                }, t.text);
                return (null === (e = t.options) || void 0 === e ? void 0 : e.direction) && i.setDirection(t.options.direction), i.setContext(this.context), this.renderQ.push(i), i;
            }
            StaveLine(t) {
                var e, i;
                const b = new mi({
                    first_note: t.from,
                    last_note: t.to,
                    first_indices: t.first_indices,
                    last_indices: t.last_indices
                });
                return (null === (e = t.options) || void 0 === e ? void 0 : e.text) && b.setText(t.options.text), (null === (i = t.options) || void 0 === i ? void 0 : i.font) && b.setFont(t.options.font), b.setContext(this.context), this.renderQ.push(b), b;
            }
            VibratoBracket(t) {
                const e = new Si({
                    start: t.from,
                    stop: t.to
                });
                return t.options.line && e.setLine(t.options.line), t.options.harsh && e.setHarsh(t.options.harsh), e.setContext(this.context), this.renderQ.push(e), e;
            }
            TextBracket(t) {
                const e = new yi({
                    start: t.from,
                    stop: t.to,
                    text: t.text,
                    superscript: t.options.superscript,
                    position: t.options.position
                });
                return t.options.line && e.setLine(t.options.line), t.options.font && e.setFont(t.options.font), e.setContext(this.context), this.renderQ.push(e), e;
            }
            System(t = {}) {
                t.factory = this;
                const e = new ci(t).setContext(this.context);
                return this.systems.push(e), e;
            }
            EasyScore(t = {}) {
                return t.factory = this, new Qe(t);
            }
            PedalMarking(t) {
                const e = Object.assign({
                    notes: [],
                    options: {
                        style: "mixed"
                    }
                }, t), i = new li(e.notes);
                return i.setType(li.typeString[e.options.style]), i.setContext(this.context), this.renderQ.push(i), i;
            }
            NoteSubGroup(t) {
                const e = Object.assign({
                    notes: []
                }, t), i = new Vt(e.notes);
                return i.setContext(this.context), i;
            }
            draw() {
                const t = this.context;
                this.systems.forEach((e)=>e.setContext(t).format()), this.staves.forEach((e)=>e.setContext(t).draw()), this.voices.forEach((e)=>e.setContext(t).draw()), this.renderQ.forEach((e)=>{
                    e.isRendered() || e.setContext(t).draw();
                }), this.systems.forEach((e)=>e.setContext(t).draw()), this.reset();
            }
        }
        vi.DEBUG = !1, vi.TEXT_FONT = Object.assign({}, R.TEXT_FONT);
        class wi extends di {
            static get CATEGORY() {
                return x.GraceTabNote;
            }
            constructor(t){
                super(t, !1), this.render_options = Object.assign(Object.assign({}, this.render_options), {
                    y_shift: .3,
                    scale: .6,
                    font: `7.5pt ${F.SANS_SERIF}`
                }), this.updateWidth();
            }
        }
        class zi {
            constructor(t){
                this.music = new et, this.setKey(t);
            }
            setKey(t) {
                return this.key = t, this.reset(), this;
            }
            getKey() {
                return this.key;
            }
            reset() {
                this.keyParts = this.music.getKeyParts(this.key), this.keyString = this.keyParts.root, this.keyParts.accidental && (this.keyString += this.keyParts.accidental);
                if (!et.scaleTypes[this.keyParts.type]) throw new g("BadArguments", `Unsupported key type: ${this.key}`);
                this.scale = this.music.getScaleTones(this.music.getNoteValue(this.keyString), et.scaleTypes[this.keyParts.type]), this.scaleMap = {}, this.scaleMapByValue = {}, this.originalScaleMapByValue = {};
                const t = et.root_indices[this.keyParts.root];
                for(let e = 0; e < et.roots.length; ++e){
                    const i = (t + e) % et.roots.length, b = et.roots[i], a = this.music.getRelativeNoteName(b, this.scale[e]);
                    this.scaleMap[b] = a, this.scaleMapByValue[this.scale[e]] = a, this.originalScaleMapByValue[this.scale[e]] = a;
                }
                return this;
            }
            getAccidental(t) {
                const e = this.music.getKeyParts(t).root, i = this.music.getNoteParts(this.scaleMap[e]);
                return {
                    note: this.scaleMap[e],
                    accidental: i.accidental
                };
            }
            selectNote(t) {
                t = t.toLowerCase();
                const e = this.music.getNoteParts(t), i = this.scaleMap[e.root], b = this.music.getNoteParts(i);
                if (i === t) return {
                    note: i,
                    accidental: e.accidental,
                    change: !1
                };
                const a = this.scaleMapByValue[this.music.getNoteValue(t)];
                if (null != a) return {
                    note: a,
                    accidental: this.music.getNoteParts(a).accidental,
                    change: !1
                };
                const n = this.originalScaleMapByValue[this.music.getNoteValue(t)];
                return null != n ? (this.scaleMap[b.root] = n, delete this.scaleMapByValue[this.music.getNoteValue(i)], this.scaleMapByValue[this.music.getNoteValue(t)] = n, {
                    note: n,
                    accidental: this.music.getNoteParts(n).accidental,
                    change: !0
                }) : b.root === t ? (delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[e.root])], this.scaleMapByValue[this.music.getNoteValue(b.root)] = b.root, this.scaleMap[b.root] = b.root, {
                    note: b.root,
                    accidental: void 0,
                    change: !0
                }) : (delete this.scaleMapByValue[this.music.getNoteValue(this.scaleMap[e.root])], this.scaleMapByValue[this.music.getNoteValue(t)] = t, delete this.scaleMap[b.root], this.scaleMap[b.root] = t, {
                    note: t,
                    accidental: e.accidental,
                    change: !0
                });
            }
        }
        class Bi extends R {
            static get CATEGORY() {
                return x.StaveHairpin;
            }
            static FormatByTicksAndDraw(t, e, i, b, a, n) {
                var s, l;
                const o = e.pixelsPerTick;
                if (null == o) throw new g("BadArguments", "A valid Formatter must be provide to draw offsets by ticks.");
                const r = o * (null !== (s = n.left_shift_ticks) && void 0 !== s ? s : 0), h = o * (null !== (l = n.right_shift_ticks) && void 0 !== l ? l : 0), m = {
                    height: n.height,
                    y_shift: n.y_shift,
                    left_shift_px: r,
                    right_shift_px: h,
                    right_shift_ticks: 0,
                    left_shift_ticks: 0
                };
                new Bi({
                    first_note: i.first_note,
                    last_note: i.last_note
                }, b).setContext(t).setRenderOptions(m).setPosition(a).draw();
            }
            constructor(t, e){
                super(), this.setNotes(t), this.hairpin = e, this.position = tt.Position.BELOW, this.render_options = {
                    height: 10,
                    y_shift: 0,
                    left_shift_px: 0,
                    right_shift_px: 0,
                    right_shift_ticks: 0,
                    left_shift_ticks: 0
                };
            }
            setPosition(t) {
                return t !== tt.Position.ABOVE && t !== tt.Position.BELOW || (this.position = t), this;
            }
            setRenderOptions(t) {
                return null != t.height && null != t.y_shift && null != t.left_shift_px && null != t.right_shift_px && (this.render_options = t), this;
            }
            setNotes(t) {
                if (!t.first_note && !t.last_note) throw new g("BadArguments", "Hairpin needs to have either first_note or last_note set.");
                return this.notes = t, this.first_note = t.first_note, this.last_note = t.last_note, this;
            }
            renderHairpin(t) {
                const e = this.checkContext();
                let i = this.render_options.y_shift + 20, b = t.first_y;
                this.position === tt.Position.ABOVE && (i = 30 - i, b = t.first_y - t.staff_height);
                const a = this.render_options.left_shift_px, n = this.render_options.right_shift_px;
                switch(e.beginPath(), this.hairpin){
                    case Bi.type.CRESC:
                        e.moveTo(t.last_x + n, b + i), e.lineTo(t.first_x + a, b + this.render_options.height / 2 + i), e.lineTo(t.last_x + n, b + this.render_options.height + i);
                        break;
                    case Bi.type.DECRESC:
                        e.moveTo(t.first_x + a, b + i), e.lineTo(t.last_x + n, b + this.render_options.height / 2 + i), e.lineTo(t.first_x + a, b + this.render_options.height + i);
                }
                e.stroke(), e.closePath();
            }
            draw() {
                this.checkContext(), this.setRendered();
                const t = this.first_note, e = this.last_note;
                if (!t || !e) throw new g("NoNote", "Notes required to draw");
                const i = t.getModifierStartXY(this.position, 0), b = e.getModifierStartXY(this.position, 0);
                this.renderHairpin({
                    first_x: i.x,
                    last_x: b.x,
                    first_y: t.checkStave().getY() + t.checkStave().getHeight(),
                    last_y: e.checkStave().getY() + e.checkStave().getHeight(),
                    staff_height: t.checkStave().getHeight()
                });
            }
        }
        Bi.type = {
            CRESC: 1,
            DECRESC: 2
        };
        class Di extends Ht {
            static get CATEGORY() {
                return x.TabSlide;
            }
            static get SLIDE_UP() {
                return 1;
            }
            static get SLIDE_DOWN() {
                return -1;
            }
            static createSlideUp(t) {
                return new Di(t, Di.SLIDE_UP);
            }
            static createSlideDown(t) {
                return new Di(t, Di.SLIDE_DOWN);
            }
            constructor(t, e){
                if (super(t, "sl."), !e) {
                    let i = t.first_note.getPositions()[0].fret;
                    "string" == typeof i && (i = parseInt(i, 10));
                    let b = t.last_note.getPositions()[0].fret;
                    "string" == typeof b && (b = parseInt(b, 10)), e = isNaN(i) || isNaN(b) ? Di.SLIDE_UP : i > b ? Di.SLIDE_DOWN : Di.SLIDE_UP;
                }
                this.direction = e, this.render_options.cp1 = 11, this.render_options.cp2 = 14, this.render_options.y_shift = .5, this.resetFont();
            }
            renderTie(t) {
                if (0 === t.first_ys.length || 0 === t.last_ys.length) throw new g("BadArguments", "No Y-values to render");
                const e = this.checkContext(), i = t.first_x_px, b = t.first_ys, a = t.last_x_px, n = t.direction;
                if (n !== Di.SLIDE_UP && n !== Di.SLIDE_DOWN) throw new g("BadSlide", "Invalid slide direction");
                const s = this.notes.first_indices;
                for(let t = 0; t < s.length; ++t){
                    const l = b[s[t]] + this.render_options.y_shift;
                    if (isNaN(l)) throw new g("BadArguments", "Bad indices for slide rendering.");
                    e.beginPath(), e.moveTo(i, l + 3 * n), e.lineTo(a, l - 3 * n), e.closePath(), e.stroke();
                }
                this.setRendered();
            }
        }
        Di.TEXT_FONT = {
            family: F.SERIF,
            size: 10,
            weight: E.BOLD,
            style: P.ITALIC
        };
        class Ci extends tt {
            static get CATEGORY() {
                return x.Tremolo;
            }
            constructor(t){
                super(), this.num = t, this.position = tt.Position.CENTER, this.code = "tremolo1", this.y_spacing_scale = 1, this.extra_stroke_scale = 1;
            }
            draw() {
                var t;
                const e = this.checkContext(), i = this.checkAttachedNote();
                this.setRendered();
                const b = i.getStemDirection();
                let a = i.getModifierStartXY(this.position, this.index).x;
                const n = o(i), s = n ? ii.SCALE : 1, l = "tremolo." + (n ? "grace" : "default"), r = V.currentMusicFont();
                let h = r.lookupMetric(`${l}.spacing`) * b;
                h *= this.y_spacing_scale;
                const m = this.num * h;
                let c = i.getStemExtents().baseY - m;
                c += b < 0 ? r.lookupMetric(`${l}.offsetYStemDown`) * s : r.lookupMetric(`${l}.offsetYStemUp`) * s;
                const d = null !== (t = r.lookupMetric(`${l}.point`)) && void 0 !== t ? t : vt.getPoint(n ? "grace" : "default");
                a += r.lookupMetric(`${l}.offsetXStem${b === at.UP ? "Up" : "Down"}`);
                for(let t = 0; t < this.num; ++t)Z.renderGlyph(e, a, c, d, this.code, {
                    category: l,
                    scale: this.extra_stroke_scale
                }), c += h;
            }
        }
        class Ei {
            static get names() {
                return {
                    standard: "E/5,B/4,G/4,D/4,A/3,E/3",
                    dagdad: "D/5,A/4,G/4,D/4,A/3,D/3",
                    dropd: "E/5,B/4,G/4,D/4,A/3,D/3",
                    eb: "Eb/5,Bb/4,Gb/4,Db/4,Ab/3,Db/3",
                    standardBanjo: "D/5,B/4,G/4,D/4,G/5"
                };
            }
            constructor(t = "E/5,B/4,G/4,D/4,A/3,E/3,B/2,E/2"){
                this.tuningValues = [], this.setTuning(t);
            }
            noteToInteger(t) {
                var e;
                return null !== (e = V.keyProperties(t).int_value) && void 0 !== e ? e : -1;
            }
            setTuning(t) {
                Ei.names[t] && (t = Ei.names[t]), this.tuningValues = [];
                const e = t.split(/\s*,\s*/);
                if (0 === e.length) throw new g("BadArguments", `Invalid tuning string: ${t}`);
                for(let t = 0; t < e.length; ++t)this.tuningValues[t] = this.noteToInteger(e[t]);
            }
            getValueForString(t) {
                const e = Number(t);
                if (e < 1 || e > this.tuningValues.length) throw new g("BadArguments", `String number must be between 1 and ${this.tuningValues.length}:${t}`);
                return this.tuningValues[e - 1];
            }
            getValueForFret(t, e) {
                const i = this.getValueForString(e), b = Number(t);
                if (b < 0) throw new g("BadArguments", `Fret number must be 0 or higher: ${t}`);
                return i + b;
            }
            getNoteForFret(t, e) {
                const i = this.getValueForFret(t, e), b = Math.floor(i / 12), a = i % 12;
                return `${V.integerToNote(a)}/${b}`;
            }
        }
        var Pi = function(t, e, i, b) {
            return new (i || (i = Promise))(function(a, n) {
                function s(t) {
                    try {
                        o(b.next(t));
                    } catch (t) {
                        n(t);
                    }
                }
                function l(t) {
                    try {
                        o(b.throw(t));
                    } catch (t) {
                        n(t);
                    }
                }
                function o(t) {
                    var e;
                    t.done ? a(t.value) : (e = t.value, e instanceof i ? e : new i(function(t) {
                        t(e);
                    })).then(s, l);
                }
                o((b = b.apply(t, e || [])).next());
            });
        };
        class ki {
            static get BUILD() {
                return {
                    VERSION: "4.2.5",
                    ID: "5b5b43b18254cc5cf607a0977823900a375b48ed",
                    DATE: "2024-05-12T08:56:23.690Z"
                };
            }
            static setMusicFont(...t) {
                const e = t.map((t)=>F.load(t));
                return V.MUSIC_FONT_STACK = e, Z.MUSIC_FONT_STACK = e.slice(), Z.CURRENT_CACHE_KEY = t.join(","), e;
            }
            static fetchMusicFont(t, e) {
                return Pi(this, void 0, void 0, function*() {});
            }
            static getMusicFont() {
                return V.MUSIC_FONT_STACK.map((t)=>t.getName());
            }
            static getMusicFontStack() {
                return V.MUSIC_FONT_STACK;
            }
            static get RENDER_PRECISION_PLACES() {
                return V.RENDER_PRECISION_PLACES;
            }
            static set RENDER_PRECISION_PLACES(t) {
                V.RENDER_PRECISION_PLACES = t;
            }
            static get SOFTMAX_FACTOR() {
                return V.SOFTMAX_FACTOR;
            }
            static set SOFTMAX_FACTOR(t) {
                V.SOFTMAX_FACTOR = t;
            }
            static get NOTATION_FONT_SCALE() {
                return V.NOTATION_FONT_SCALE;
            }
            static set NOTATION_FONT_SCALE(t) {
                V.NOTATION_FONT_SCALE = t;
            }
            static get TABLATURE_FONT_SCALE() {
                return V.TABLATURE_FONT_SCALE;
            }
            static set TABLATURE_FONT_SCALE(t) {
                V.TABLATURE_FONT_SCALE = t;
            }
            static get RESOLUTION() {
                return V.RESOLUTION;
            }
            static set RESOLUTION(t) {
                V.RESOLUTION = t;
            }
            static get SLASH_NOTEHEAD_WIDTH() {
                return V.SLASH_NOTEHEAD_WIDTH;
            }
            static set SLASH_NOTEHEAD_WIDTH(t) {
                V.SLASH_NOTEHEAD_WIDTH = t;
            }
            static get STAVE_LINE_DISTANCE() {
                return V.STAVE_LINE_DISTANCE;
            }
            static set STAVE_LINE_DISTANCE(t) {
                V.STAVE_LINE_DISTANCE = t;
            }
            static get STAVE_LINE_THICKNESS() {
                return V.STAVE_LINE_THICKNESS;
            }
            static set STAVE_LINE_THICKNESS(t) {
                V.STAVE_LINE_THICKNESS = t;
            }
            static get STEM_HEIGHT() {
                return V.STEM_HEIGHT;
            }
            static set STEM_HEIGHT(t) {
                V.STEM_HEIGHT = t;
            }
            static get STEM_WIDTH() {
                return V.STEM_WIDTH;
            }
            static set STEM_WIDTH(t) {
                V.STEM_WIDTH = t;
            }
            static get TIME4_4() {
                return V.TIME4_4;
            }
            static get accidentalMap() {
                return V.accidentalMap;
            }
            static get unicode() {
                return V.unicode;
            }
            static keySignature(t) {
                return V.keySignature(t);
            }
            static hasKeySignature(t) {
                return V.hasKeySignature(t);
            }
            static getKeySignatures() {
                return V.getKeySignatures();
            }
            static clefProperties(t) {
                return V.clefProperties(t);
            }
            static keyProperties(t, e, i) {
                return V.keyProperties(t, e, i);
            }
            static durationToTicks(t) {
                return V.durationToTicks(t);
            }
        }
        ki.Accidental = bt, ki.Annotation = ct, ki.Articulation = ut, ki.Barline = kt, ki.BarNote = At, ki.Beam = Re, ki.Bend = Nt, ki.BoundingBox = D, ki.BoundingBoxComputation = C, ki.CanvasContext = Qt, ki.ChordSymbol = Mt, ki.Clef = de, ki.ClefNote = Le, ki.Crescendo = We, ki.Curve = Ie, ki.Dot = Ot, ki.EasyScore = Qe, ki.Element = R, ki.Factory = vi, ki.Font = F, ki.Formatter = Pe, ki.Fraction = z, ki.FretHandFinger = Rt, ki.GhostNote = ti, ki.Glyph = Z, ki.GlyphNote = ei, ki.GraceNote = ii, ki.GraceNoteGroup = jt, ki.GraceTabNote = wi, ki.KeyManager = zi, ki.KeySignature = _e, ki.KeySigNote = bi, ki.Modifier = tt, ki.ModifierContext = ce, ki.MultiMeasureRest = ni, ki.Music = et, ki.Note = vt, ki.NoteHead = Lt, ki.NoteSubGroup = Vt, ki.Ornament = Kt, ki.Parenthesis = $t, ki.Parser = Ye, ki.PedalMarking = li, ki.Registry = O, ki.RenderContext = ft, ki.Renderer = le, ki.RepeatNote = ri, ki.Repetition = xe, ki.Stave = ze, ki.StaveConnector = De, ki.StaveHairpin = Bi, ki.StaveLine = mi, ki.StaveModifier = Pt, ki.StaveNote = It, ki.StaveTempo = ye, ki.StaveText = ue, ki.StaveTie = Gt, ki.Stem = at, ki.StringNumber = oe, ki.Stroke = re, ki.SVGContext = ie, ki.System = ci, ki.TabNote = di, ki.TabSlide = Di, ki.TabStave = _i, ki.TabTie = Ht, ki.TextBracket = yi, ki.TextDynamics = ui, ki.TextFormatter = rt, ki.TextNote = pe, ki.TickContext = Ce, ki.TimeSignature = Te, ki.TimeSigNote = fi, ki.Tremolo = Ci, ki.Tuning = Ei, ki.Tuplet = Ae, ki.Vibrato = he, ki.VibratoBracket = Si, ki.Voice = Xt, ki.Volta = fe, ki.AnnotationHorizontalJustify = ht, ki.AnnotationVerticalJustify = mt, ki.ChordSymbolHorizontalJustify = Bt, ki.ChordSymbolVerticalJustify = Dt, ki.SymbolTypes = Ct, ki.SymbolModifiers = Et, ki.CurvePosition = Ue, ki.FontWeight = E, ki.FontStyle = P, ki.ModifierPosition = J, ki.RendererBackends = be, ki.RendererLineEndType = ae, ki.BarlineType = zt, ki.StaveModifierPosition = wt, ki.VoltaType = se, ki.TextBracketPosition = gi, ki.TextJustification = ne, ki.VoiceMode = Yt;
        const Ai = {
            glyphs: {
                bracketTop: {
                    x_min: 0,
                    x_max: 469,
                    y_min: 0,
                    y_max: 295,
                    ha: 295,
                    o: "m 0 0 l 180 0 b 674 390 410 43 616 150 b 675 405 675 396 675 400 b 664 425 675 416 671 422 b 628 405 651 425 635 415 b 157 179 613 389 432 199 l 12 179 b 0 168 3 179 0 177 z"
                },
                bracketBottom: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -295,
                    y_max: 0,
                    ha: 295,
                    o: "m 0 -168 b 12 -179 0 -177 3 -179 l 157 -179 b 628 -405 432 -199 613 -389 b 664 -425 635 -415 651 -425 b 675 -405 671 -422 675 -416 b 674 -390 675 -400 675 -396 b 180 0 616 -150 410 -43 l 0 0 z"
                },
                barlineTick: {
                    x_min: 0,
                    x_max: 36,
                    y_min: 868,
                    y_max: 1120,
                    ha: 252,
                    o: "m 52 1250 l 52 1613 l 0 1613 l 0 1250 z"
                },
                breathMarkTick: {
                    x_min: 0,
                    x_max: 500,
                    y_min: 0,
                    y_max: 502,
                    ha: 502,
                    o: "m 9 367 b 0 374 6 372 3 374 b 9 334 0 367 0 343 b 179 19 40 312 164 121 b 192 0 179 3 186 0 b 210 19 197 0 207 6 b 698 701 245 197 507 658 b 720 714 714 704 720 711 b 698 723 720 720 711 723 b 197 186 455 714 210 202 b 186 176 194 179 189 176 b 176 186 179 176 176 186 b 9 367 143 266 27 359 z"
                },
                segno: {
                    x_min: 4,
                    x_max: 550,
                    y_min: -27,
                    y_max: 759,
                    ha: 786,
                    o: "m 194 958 b 217 939 203 958 213 955 l 220 929 b 325 805 230 890 252 805 b 425 901 384 805 425 840 b 413 969 425 923 420 946 b 220 1060 390 1035 294 1060 b 6 793 120 1060 6 936 b 29 687 6 759 13 723 b 295 449 75 582 284 454 b 304 438 301 446 304 444 b 295 415 304 432 301 425 b 78 22 285 395 78 22 b 73 3 75 16 73 9 b 114 -39 73 -20 91 -39 b 150 -17 128 -39 143 -30 b 377 395 150 -17 373 386 b 395 402 377 393 389 402 b 704 176 416 397 704 312 b 621 75 704 120 670 82 l 616 73 b 562 138 586 73 562 94 l 562 154 b 485 249 562 209 526 249 b 468 246 480 249 474 248 b 366 153 415 233 366 210 b 540 -12 366 65 455 -12 b 600 -1 559 -12 579 -9 b 792 251 716 37 792 131 b 789 292 792 264 791 278 b 523 588 768 451 540 579 b 498 611 505 598 498 603 b 501 619 498 613 500 616 b 732 1032 508 631 732 1032 b 737 1053 736 1040 737 1045 b 697 1093 737 1076 719 1093 b 661 1073 683 1093 668 1086 b 423 647 661 1073 432 660 b 410 635 419 639 416 635 b 396 639 406 635 402 636 b 128 792 383 644 166 727 b 108 868 120 808 108 838 b 186 958 108 907 125 948 z m 598 671 b 680 589 598 626 635 589 b 762 671 726 589 762 626 b 680 753 762 717 726 753 b 598 671 635 753 598 717 z m 202 380 b 120 462 202 425 166 462 b 37 380 75 462 37 425 b 120 298 37 334 75 298 b 202 380 166 298 202 334 z"
                },
                coda: {
                    x_min: -4,
                    x_max: 955,
                    y_min: -158,
                    y_max: 898,
                    ha: 1056,
                    o: "m 1349 576 l 1178 576 b 729 1083 1164 847 962 1064 l 729 1269 b 694 1293 729 1287 713 1293 b 660 1269 675 1293 660 1287 l 660 1083 b 210 576 426 1064 226 848 l 20 576 b -6 541 0 576 -6 560 b 20 507 -6 523 0 507 l 210 507 b 660 0 226 238 426 19 l 660 -202 b 694 -228 660 -222 675 -228 b 729 -202 713 -228 729 -222 l 729 0 b 1178 507 962 19 1164 238 l 1349 507 b 1375 541 1369 507 1375 523 b 1349 576 1375 560 1369 576 z m 940 576 l 729 576 l 729 1002 b 940 576 930 985 940 809 z m 660 1002 l 660 576 l 455 576 b 660 1002 455 809 455 985 z m 455 507 l 660 507 l 660 69 b 455 507 474 91 456 285 z m 729 69 l 729 507 l 940 507 b 729 69 936 287 909 91 z"
                },
                gClef: {
                    x_min: 0,
                    x_max: 671,
                    y_min: -658,
                    y_max: 1098,
                    ha: 1756,
                    o: "m 541 598 b 550 625 539 615 541 616 b 824 1174 706 770 824 953 b 730 1509 824 1299 789 1423 b 655 1581 708 1541 671 1581 b 562 1512 635 1581 590 1544 b 420 1064 455 1394 420 1214 b 441 828 420 981 431 887 b 428 793 444 811 445 808 b 0 125 220 622 0 416 b 524 -363 0 -125 171 -363 b 624 -354 557 -363 595 -360 b 645 -367 639 -351 642 -350 b 684 -657 662 -464 684 -589 b 455 -896 684 -870 540 -896 b 340 -854 377 -896 340 -873 b 386 -829 340 -844 353 -840 b 482 -694 431 -816 482 -778 b 344 -547 482 -615 432 -547 b 190 -713 248 -547 190 -624 b 464 -948 190 -806 246 -948 b 747 -660 560 -948 747 -904 b 706 -351 747 -577 721 -441 b 724 -327 703 -334 704 -336 b 966 16 870 -269 966 -147 b 619 363 966 200 831 363 b 577 389 582 363 582 363 z m 677 1358 b 763 1240 724 1358 763 1319 b 513 851 763 1080 626 950 b 494 863 503 842 497 844 b 485 995 488 900 485 949 b 677 1358 485 1220 589 1358 z m 520 377 b 498 343 524 350 524 351 b 289 63 372 300 289 186 b 455 -192 289 -66 357 -158 b 494 -200 467 -196 484 -200 b 511 -184 505 -200 511 -193 b 490 -166 511 -174 500 -170 b 386 -12 429 -140 386 -78 b 530 157 386 71 442 132 b 559 145 553 163 556 161 l 631 -284 b 611 -304 634 -300 632 -300 b 530 -311 588 -308 559 -311 b 115 29 278 -311 115 -171 b 249 363 115 114 130 228 b 469 567 336 459 402 513 b 490 562 484 579 487 577 z m 619 148 b 635 168 616 166 618 170 b 848 -66 752 158 848 60 b 713 -271 848 -157 793 -230 b 690 -262 696 -279 693 -279 z"
                },
                cClef: {
                    x_min: 0,
                    x_max: 699,
                    y_min: -506,
                    y_max: 506,
                    ha: 1012,
                    o: "m 331 694 b 301 724 331 714 321 724 l 300 724 b 269 694 279 724 269 714 l 269 -694 b 300 -724 269 -714 279 -724 l 301 -724 b 331 -694 321 -724 331 -714 l 331 -63 b 344 -55 331 -52 338 -53 b 472 -265 382 -65 442 -102 b 500 -301 477 -288 485 -301 b 530 -262 516 -301 523 -287 b 684 -128 549 -199 582 -128 b 804 -409 778 -128 804 -220 b 651 -683 804 -598 770 -683 b 528 -644 631 -683 528 -674 b 567 -622 528 -636 552 -628 b 625 -528 596 -612 625 -583 b 527 -429 625 -465 583 -429 b 416 -547 465 -429 416 -471 b 667 -729 416 -638 495 -729 b 1007 -413 903 -729 1007 -563 b 706 -76 1007 -215 897 -76 b 618 -89 664 -76 636 -84 b 576 -88 603 -94 589 -96 b 524 0 556 -75 524 -29 b 576 88 524 29 556 75 b 618 89 589 96 603 94 b 706 76 636 84 664 76 b 1007 413 897 76 1007 215 b 667 729 1007 563 903 729 b 416 547 495 729 416 638 b 527 429 416 471 465 429 b 625 528 583 429 625 465 b 567 622 625 583 596 612 b 528 644 552 628 528 636 b 651 683 528 674 631 683 b 804 409 770 683 804 598 b 684 128 804 220 778 128 b 530 262 582 128 549 199 b 500 301 523 287 516 301 b 472 265 485 301 477 288 b 344 55 442 102 382 65 b 331 63 338 53 331 52 z m 30 724 b 0 694 10 724 0 714 l 0 -694 b 30 -724 0 -714 10 -724 l 154 -724 b 184 -694 174 -724 184 -714 l 184 694 b 154 724 184 714 174 724 z"
                },
                fClef: {
                    x_min: -5,
                    x_max: 684,
                    y_min: -635,
                    y_max: 262,
                    ha: 897,
                    o: "m 363 377 b 0 56 112 377 0 194 b 177 -158 0 -59 60 -158 b 330 -6 268 -158 330 -95 b 192 144 330 86 262 144 b 120 134 153 144 138 134 b 96 160 101 134 96 145 b 330 323 96 217 183 323 b 549 -53 482 323 549 173 b 14 -871 549 -455 350 -680 b -7 -897 1 -878 -7 -886 b 12 -914 -7 -906 -1 -914 b 36 -907 19 -914 27 -912 b 765 -40 390 -734 765 -478 b 363 377 765 210 612 377 z m 906 259 b 827 180 861 259 827 225 b 906 101 827 135 861 101 b 985 180 950 101 985 135 b 906 259 985 225 950 259 z m 907 -102 b 829 -180 863 -102 829 -135 b 907 -258 829 -225 863 -258 b 985 -180 952 -258 985 -225 b 907 -102 985 -135 952 -102 z"
                },
                unpitchedPercussionClef1: {
                    x_min: 0,
                    x_max: 382,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 230 -338 l 230 338 b 210 360 230 350 222 360 l 20 360 b 0 338 9 360 0 350 l 0 -338 b 20 -360 0 -350 9 -360 l 210 -360 b 230 -338 222 -360 230 -350 z m 550 338 b 530 360 550 350 541 360 l 340 360 b 320 338 328 360 320 350 l 320 -338 b 340 -360 320 -350 328 -360 l 530 -360 b 550 -338 541 -360 550 -350 z"
                },
                "6stringTabClef": {
                    x_min: -3,
                    x_max: 408,
                    y_min: -748,
                    y_max: 764,
                    ha: 1512,
                    o: "m 557 1024 l 557 1100 l 26 1100 l 26 1024 l 249 1024 l 249 422 l 336 422 l 336 1024 z m 588 -328 l 350 348 l 238 348 l -4 -328 l 88 -328 l 160 -125 l 420 -125 l 491 -328 z m 397 -52 l 181 -52 l 292 256 z m 544 -883 b 420 -719 544 -802 507 -752 b 514 -572 482 -690 514 -639 b 314 -399 514 -472 442 -399 l 39 -399 l 39 -1077 l 344 -1077 b 544 -883 467 -1077 544 -995 z m 428 -583 b 292 -691 428 -652 389 -691 l 125 -691 l 125 -475 l 292 -475 b 428 -583 389 -475 428 -514 z m 458 -884 b 337 -1001 458 -949 418 -1001 l 125 -1001 l 125 -768 l 337 -768 b 458 -884 418 -768 458 -818 z"
                },
                timeSig0: {
                    x_min: 20,
                    x_max: 450,
                    y_min: -250,
                    y_max: 251,
                    ha: 501,
                    o: "m 648 0 b 338 361 648 200 510 361 b 29 0 167 361 29 200 b 338 -360 29 -199 167 -360 b 648 0 510 -360 648 -199 z m 338 317 b 446 10 397 317 446 180 b 338 -295 446 -158 397 -295 b 230 10 278 -295 230 -158 b 338 317 230 180 278 317 z"
                },
                timeSig1: {
                    x_min: 20,
                    x_max: 314,
                    y_min: -250,
                    y_max: 251,
                    ha: 501,
                    o: "m 35 19 b 29 0 35 19 29 10 b 45 -20 29 -7 33 -16 b 58 -23 50 -22 56 -23 b 78 -10 72 -23 78 -10 b 156 117 78 -10 140 89 b 170 131 161 127 167 131 b 179 111 176 131 179 120 l 179 -261 b 115 -315 179 -294 145 -315 b 91 -337 105 -315 91 -320 b 122 -360 91 -353 104 -360 l 429 -360 b 452 -337 452 -360 452 -337 b 431 -315 452 -337 452 -315 b 384 -265 410 -315 384 -289 l 384 328 b 356 361 384 351 376 360 b 281 356 336 361 300 356 b 206 360 253 356 228 357 b 199 361 203 360 200 361 b 173 334 184 361 179 347 z"
                },
                timeSig2: {
                    x_min: 20,
                    x_max: 426,
                    y_min: -257,
                    y_max: 254,
                    ha: 511,
                    o: "m 606 -131 b 589 -111 606 -114 599 -111 b 570 -127 577 -111 573 -117 l 569 -128 b 513 -192 554 -164 543 -192 b 488 -187 505 -192 498 -190 b 445 -171 469 -180 459 -179 b 289 -137 416 -160 348 -137 b 236 -145 271 -137 252 -140 b 422 -42 268 -94 390 -50 b 613 147 523 -14 613 27 b 330 366 613 300 464 366 b 69 275 229 366 140 357 b 29 170 45 245 29 209 b 42 108 29 150 33 130 b 160 29 63 63 108 29 b 261 156 248 29 261 120 b 161 275 261 242 161 246 b 275 330 164 295 190 330 b 405 192 403 330 405 233 b 193 -102 405 60 297 -39 b 33 -317 114 -153 58 -223 l 32 -321 b 69 -370 32 -340 48 -370 b 203 -282 101 -370 118 -282 b 410 -360 261 -282 282 -360 b 606 -131 472 -360 583 -354 z"
                },
                timeSig3: {
                    x_min: 20,
                    x_max: 401,
                    y_min: -251,
                    y_max: 249,
                    ha: 500,
                    o: "m 307 357 b 301 357 305 357 304 357 l 291 359 b 285 359 289 359 287 359 b 37 200 161 359 37 276 b 154 84 37 153 65 89 l 161 84 b 256 177 225 84 256 130 l 256 189 b 209 248 252 242 216 245 b 180 268 202 251 180 248 l 180 274 b 240 310 183 298 228 310 b 374 199 363 310 374 233 l 374 189 b 199 36 374 82 289 40 b 164 12 184 35 164 27 b 200 -6 164 -6 189 -6 b 379 -137 366 -6 379 -118 b 269 -307 379 -289 301 -307 b 256 -305 264 -307 258 -305 b 216 -282 245 -304 217 -304 l 216 -275 b 249 -180 216 -243 248 -222 b 145 -76 249 -120 207 -76 b 130 -78 140 -76 135 -76 b 60 -115 105 -82 78 -96 b 29 -203 36 -137 29 -171 b 275 -361 32 -315 134 -359 l 288 -361 b 577 -161 431 -361 577 -288 l 577 -151 b 537 -50 575 -109 564 -82 b 503 -20 528 -39 517 -29 l 472 -3 l 425 10 b 410 17 418 12 413 12 b 409 24 409 20 409 22 b 415 37 409 30 410 36 b 459 50 431 42 446 43 b 547 181 517 78 547 115 b 307 357 547 314 367 353 z"
                },
                timeSig4: {
                    x_min: 20,
                    x_max: 450,
                    y_min: -250,
                    y_max: 251,
                    ha: 501,
                    o: "m 521 -107 l 521 202 b 504 226 521 213 520 226 b 475 213 491 226 484 223 l 338 48 b 325 14 333 40 325 32 l 325 -107 l 131 -107 b 481 336 246 -9 477 318 l 482 340 b 461 361 482 353 472 361 b 363 359 448 361 389 359 b 261 361 337 359 272 361 b 228 334 248 361 228 357 b 43 -105 228 156 86 -45 l 35 -117 b 35 -118 35 -117 35 -118 l 33 -120 b 29 -137 30 -127 29 -132 b 58 -161 29 -151 40 -161 l 325 -161 l 325 -252 b 268 -302 325 -291 294 -302 b 235 -330 245 -302 235 -315 b 262 -360 235 -344 240 -360 l 569 -360 b 598 -330 583 -360 598 -350 b 566 -301 598 -310 580 -301 b 521 -246 552 -301 521 -292 l 521 -161 l 626 -161 b 648 -134 641 -161 648 -151 b 626 -107 648 -117 642 -107 z"
                },
                timeSig5: {
                    x_min: 20,
                    x_max: 383,
                    y_min: -251,
                    y_max: 246,
                    ha: 497,
                    o: "m 109 85 b 117 179 109 85 115 166 b 138 197 118 190 125 197 l 144 197 b 285 184 158 194 226 184 b 492 323 485 184 492 300 b 472 353 492 341 488 353 b 295 340 454 353 341 340 b 101 354 249 340 125 351 b 66 330 75 354 68 341 l 50 10 l 50 7 b 79 -14 50 -12 65 -14 b 111 14 94 -14 95 -1 b 209 62 125 29 160 62 b 357 -125 258 62 357 35 b 235 -304 357 -284 272 -304 b 202 -300 223 -304 212 -304 b 184 -279 194 -295 186 -289 b 202 -259 184 -269 194 -264 b 256 -163 235 -239 256 -203 b 144 -50 256 -99 206 -50 b 30 -157 66 -50 35 -107 b 29 -183 29 -166 29 -174 b 284 -361 29 -302 107 -361 b 552 -125 456 -361 552 -255 b 314 112 552 6 445 112 b 122 71 230 112 168 98 b 115 69 120 69 117 69 b 109 79 109 69 109 75 z"
                },
                timeSig6: {
                    x_min: 20,
                    x_max: 414,
                    y_min: -249,
                    y_max: 251,
                    ha: 500,
                    o: "m 439 120 b 554 229 500 120 554 167 b 553 245 554 235 554 239 b 348 361 539 337 426 361 b 85 209 239 360 137 307 b 29 4 53 148 29 72 l 29 -1 b 73 -200 30 -68 42 -143 b 324 -359 132 -307 203 -359 b 513 -307 389 -359 461 -348 b 596 -137 563 -266 596 -202 b 379 72 596 -24 490 72 b 248 22 333 72 285 55 b 239 19 245 19 242 19 b 226 53 230 19 226 30 b 346 327 230 320 315 327 b 393 305 374 327 393 320 b 357 251 393 285 366 268 b 347 209 350 238 347 223 b 369 150 347 187 354 166 b 439 120 379 131 420 120 z m 320 3 b 405 -158 366 3 405 -69 b 320 -320 405 -248 366 -320 b 236 -158 274 -320 236 -248 b 320 3 236 -69 274 3 z"
                },
                timeSig7: {
                    x_min: 20,
                    x_max: 421,
                    y_min: -250,
                    y_max: 249,
                    ha: 499,
                    o: "m 606 294 b 582 351 606 333 606 351 b 552 336 580 351 557 346 b 485 236 541 318 521 236 b 262 359 449 236 382 359 b 137 307 179 359 157 325 b 98 281 117 288 108 282 b 60 315 86 281 68 301 b 43 325 58 321 50 325 b 29 308 36 325 29 321 l 29 71 b 45 48 29 71 30 48 b 66 76 56 48 60 60 b 164 196 81 112 99 196 b 374 88 222 196 291 88 b 446 118 415 88 435 109 b 459 124 451 121 456 124 b 469 111 465 124 468 120 b 272 -112 469 71 359 -10 b 173 -315 217 -176 173 -259 b 200 -360 173 -346 173 -360 b 294 -347 226 -360 258 -347 b 412 -360 330 -347 397 -360 b 435 -307 426 -360 435 -348 b 606 288 435 -66 606 140 z"
                },
                timeSig8: {
                    x_min: 20,
                    x_max: 416,
                    y_min: -259,
                    y_max: 259,
                    ha: 518,
                    o: "m 481 52 b 567 204 533 85 567 132 b 317 373 567 351 356 373 b 36 176 150 373 36 297 b 161 -16 36 76 92 23 b 29 -190 86 -52 29 -99 b 301 -373 29 -315 158 -373 b 599 -117 445 -373 599 -311 b 481 52 599 -30 549 17 z m 406 85 b 168 240 291 125 168 150 b 314 331 168 301 251 331 b 482 207 360 331 482 308 b 406 85 482 150 454 112 z m 295 -325 b 111 -183 199 -325 111 -276 b 225 -48 111 -125 161 -72 b 436 -219 330 -94 436 -124 b 295 -325 436 -276 392 -325 z"
                },
                timeSig9: {
                    x_min: 20,
                    x_max: 414,
                    y_min: -249,
                    y_max: 251,
                    ha: 500,
                    o: "m 186 -117 b 71 -226 125 -117 71 -164 b 72 -242 71 -232 71 -236 b 276 -359 86 -334 199 -359 b 540 -206 386 -357 488 -304 b 596 -1 572 -145 596 -69 l 596 4 b 552 203 595 71 583 145 b 301 361 492 310 422 361 b 112 310 236 361 164 351 b 29 140 62 269 29 204 b 246 -69 29 27 135 -69 b 377 -19 292 -69 340 -52 b 386 -16 380 -16 383 -16 b 399 -50 395 -16 399 -27 b 279 -324 395 -317 310 -324 b 232 -302 251 -324 232 -317 b 268 -248 232 -282 259 -265 b 278 -206 275 -235 278 -220 b 256 -147 278 -184 271 -163 b 186 -117 246 -128 204 -117 z m 305 0 b 220 161 259 0 220 72 b 305 323 220 251 259 323 b 389 161 351 323 389 251 b 305 0 389 72 351 0 z"
                },
                timeSigCommon: {
                    x_min: 5,
                    x_max: 424,
                    y_min: -249,
                    y_max: 251,
                    ha: 500,
                    o: "m 336 361 b 7 -14 131 361 7 180 b 101 -262 7 -108 42 -190 b 321 -359 156 -328 235 -359 b 611 -88 573 -359 611 -130 b 589 -56 611 -56 595 -56 b 567 -82 577 -56 567 -58 b 363 -311 567 -268 409 -311 b 184 40 246 -311 184 -197 b 372 327 184 278 294 327 b 477 278 446 327 477 292 b 451 246 477 265 472 246 b 360 140 393 246 360 184 b 471 32 360 58 431 32 b 580 156 471 32 580 36 b 336 361 580 344 363 361 z"
                },
                timeSigCutCommon: {
                    x_min: 0,
                    x_max: 418,
                    y_min: -359,
                    y_max: 361,
                    ha: 720,
                    o: "m 573 -58 b 559 -82 567 -58 559 -60 b 354 -310 559 -266 400 -310 b 317 -305 340 -310 328 -308 b 302 -284 311 -304 302 -295 l 302 287 b 338 323 302 297 328 321 b 363 324 347 324 356 324 b 468 275 436 324 468 289 b 442 243 468 264 464 243 b 351 137 384 243 351 181 b 462 30 351 56 422 30 b 572 154 462 30 572 35 b 318 357 572 295 441 357 b 302 390 310 359 302 383 l 302 495 b 276 520 302 507 292 520 b 252 495 265 520 252 507 l 252 369 b 235 346 252 359 238 346 l 196 331 b 0 -14 66 275 0 122 b 225 -346 0 -150 86 -310 b 252 -382 235 -350 252 -369 l 252 -492 b 276 -517 252 -505 265 -517 b 302 -492 292 -517 302 -505 l 302 -379 b 318 -359 302 -370 308 -363 b 602 -85 563 -354 602 -130 b 579 -58 600 -58 586 -58 z m 252 -235 b 243 -252 252 -248 248 -252 b 236 -248 240 -252 238 -251 b 177 37 197 -193 177 -96 b 232 259 177 147 200 215 b 236 262 233 262 235 262 b 252 239 243 262 252 251 z"
                },
                timeSigPlus: {
                    x_min: -1,
                    x_max: 499,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 432 53 b 413 79 420 53 413 65 l 413 340 b 392 360 413 350 405 360 l 325 360 b 305 340 312 360 305 350 l 305 79 b 284 53 305 66 292 53 l 19 53 b -1 33 9 53 -1 46 l -1 -33 b 19 -55 -1 -46 9 -55 l 284 -55 b 305 -75 298 -55 305 -68 l 305 -340 b 325 -360 305 -350 312 -360 l 392 -360 b 413 -340 405 -360 413 -350 l 413 -78 b 433 -55 413 -63 423 -55 l 698 -55 b 719 -33 708 -55 719 -46 l 719 33 b 698 53 719 46 708 53 z"
                },
                timeSigPlusSmall: {
                    x_min: -1,
                    x_max: 255,
                    y_min: -133,
                    y_max: 123,
                    ha: 256,
                    o: "m 220 20 b 210 33 215 20 210 26 l 210 166 b 200 177 210 171 206 177 l 166 177 b 156 166 160 177 156 171 l 156 33 b 145 20 156 27 150 20 l 10 20 b -1 10 4 20 -1 16 l -1 -24 b 10 -35 -1 -30 4 -35 l 145 -35 b 156 -46 153 -35 156 -42 l 156 -180 b 166 -192 156 -186 160 -192 l 200 -192 b 210 -180 206 -192 210 -186 l 210 -48 b 222 -35 210 -39 216 -35 l 356 -35 b 367 -24 361 -35 367 -30 l 367 10 b 356 20 367 16 361 20 z"
                },
                timeSigMinus: {
                    x_min: 0,
                    x_max: 448,
                    y_min: -35,
                    y_max: 40,
                    ha: 75,
                    o: "m 645 39 b 619 58 645 49 634 58 l 27 58 b 0 39 12 58 0 49 l 0 -32 b 27 -50 0 -42 12 -50 l 619 -50 b 645 -32 634 -50 645 -42 z"
                },
                timeSigParensRight: {
                    x_min: 0,
                    x_max: 184,
                    y_min: -489,
                    y_max: 491,
                    ha: 980,
                    o: "m 0 -696 b 3 -704 0 -698 1 -704 b 7 -703 4 -704 6 -704 b 265 1 187 -530 265 -282 b 12 701 265 289 187 531 b 4 707 12 701 6 707 b 0 696 1 707 0 703 l 0 665 b 4 644 0 665 0 651 b 167 1 112 503 167 315 b 6 -641 167 -311 109 -497 b 0 -658 3 -644 0 -651 z"
                },
                timeSigParensRightSmall: {
                    x_min: 0,
                    x_max: 110,
                    y_min: -251,
                    y_max: 249,
                    ha: 500,
                    o: "m 0 -356 b 3 -361 0 -357 1 -361 b 158 0 112 -272 158 -145 b 4 359 158 147 109 272 b 0 353 3 359 0 357 l 0 338 b 3 327 0 338 0 330 b 91 0 60 246 91 160 b 4 -328 91 -160 62 -249 b 0 -337 3 -330 0 -333 z"
                },
                timeSigParensLeft: {
                    x_min: 0,
                    x_max: 184,
                    y_min: -489,
                    y_max: 491,
                    ha: 980,
                    o: "m 265 -658 b 259 -641 265 -651 262 -644 b 98 1 156 -497 98 -311 b 261 644 98 315 153 503 b 265 665 265 651 265 665 l 265 696 b 261 707 265 703 264 707 b 253 701 259 707 253 701 b 0 1 78 531 0 289 b 258 -703 0 -282 78 -530 b 262 -704 259 -704 261 -704 b 265 -696 264 -704 265 -698 z"
                },
                timeSigParensLeftSmall: {
                    x_min: 0,
                    x_max: 110,
                    y_min: -251,
                    y_max: 249,
                    ha: 500,
                    o: "m 158 -337 b 154 -328 158 -333 156 -330 b 68 0 96 -249 68 -160 b 156 327 68 160 98 246 b 158 338 158 330 158 338 l 158 353 b 154 359 158 357 156 359 b 0 0 49 272 0 147 b 156 -361 0 -145 46 -272 b 158 -356 157 -361 158 -357 z"
                },
                noteheadDoubleWhole: {
                    x_min: 0,
                    x_max: 599,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 13 223 b 0 212 4 223 0 217 l 0 -213 b 13 -223 0 -219 4 -223 l 32 -223 b 45 -213 39 -223 45 -219 l 45 212 b 32 223 45 217 39 223 z m 96 223 b 82 212 88 223 82 217 l 82 -213 b 96 -223 82 -219 88 -223 l 114 -223 b 128 -213 121 -223 128 -219 l 128 212 b 114 223 128 217 121 223 z m 747 223 b 733 212 740 223 733 217 l 733 -213 b 747 -223 733 -219 740 -223 l 766 -223 b 780 -213 773 -223 780 -219 l 780 212 b 766 223 780 217 773 223 z m 829 223 b 815 212 824 223 815 217 l 815 -213 b 829 -223 815 -219 824 -223 l 848 -223 b 863 -213 857 -223 863 -219 l 863 212 b 848 223 863 217 857 223 z m 438 180 b 130 1 248 180 130 101 b 423 -180 130 -92 210 -180 b 733 1 657 -180 733 -98 b 438 180 733 104 572 180 z m 469 -145 b 331 -71 409 -145 369 -112 b 284 58 305 -37 284 12 b 400 147 284 131 333 147 b 577 -45 498 147 577 42 b 469 -145 577 -115 533 -145 z"
                },
                noteheadWhole: {
                    x_min: 0,
                    x_max: 422,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 311 180 b 0 3 120 180 0 101 b 297 -180 0 -94 82 -180 b 608 3 533 -180 608 -98 b 311 180 608 105 445 180 z m 160 91 b 274 148 176 141 229 148 b 452 -45 373 148 452 42 b 386 -141 452 -89 433 -130 b 341 -147 372 -145 356 -147 b 206 -72 289 -147 236 -112 b 156 56 177 -39 156 10 b 160 91 156 68 157 79 z"
                },
                noteheadHalf: {
                    x_min: 0,
                    x_max: 295,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 140 -180 b 425 60 377 -180 425 13 b 282 180 425 134 366 180 b 0 -60 68 180 0 14 b 140 -180 0 -137 60 -180 z m 108 -125 b 50 -92 78 -125 60 -109 b 42 -63 46 -84 42 -73 b 318 121 42 7 251 121 b 372 91 346 121 361 108 b 380 63 376 82 380 73 b 108 -125 380 1 177 -125 z"
                },
                noteheadBlack: {
                    x_min: 0,
                    x_max: 295,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 140 -180 b 425 60 268 -180 425 -62 b 285 180 425 134 367 180 b 0 -60 127 180 0 63 b 140 -180 0 -135 62 -180 z"
                },
                noteheadXDoubleWhole: {
                    x_min: 0,
                    x_max: 546,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 43 213 b 30 223 43 217 39 223 l 13 223 b 0 213 6 223 0 217 l 0 -215 b 13 -223 0 -219 6 -223 l 30 -223 b 43 -215 39 -223 43 -219 z m 704 213 b 693 223 704 217 698 223 l 672 223 b 660 213 667 223 660 217 l 660 163 b 634 180 655 173 645 180 l 505 180 b 484 173 498 180 490 177 l 393 95 l 300 173 b 279 180 294 177 287 180 l 151 180 b 125 163 141 180 130 173 l 125 213 b 112 223 125 217 118 223 l 94 223 b 82 213 86 223 82 217 l 82 -215 b 94 -223 82 -219 86 -223 l 112 -223 b 125 -215 118 -223 125 -219 l 125 -163 b 151 -180 130 -173 140 -180 l 279 -180 b 300 -171 287 -180 294 -177 l 393 -95 l 485 -171 b 505 -180 491 -177 498 -180 l 632 -180 b 660 -163 645 -180 655 -173 l 660 -215 b 672 -223 660 -219 667 -223 l 693 -223 b 704 -215 698 -223 704 -219 z m 786 213 b 772 223 786 217 780 223 l 755 223 b 740 213 747 223 740 217 l 740 -215 b 755 -223 740 -219 747 -223 l 772 -223 b 786 -215 780 -223 786 -219 z m 507 -141 l 393 -45 l 276 -141 l 207 -141 l 364 0 l 207 141 l 276 141 l 393 45 l 507 141 l 577 141 l 420 0 l 577 -141 z m 660 -132 l 518 0 l 660 132 z m 125 131 l 266 0 l 125 -131 z"
                },
                noteheadXWhole: {
                    x_min: 0,
                    x_max: 377,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 272 -95 l 364 -171 b 384 -180 370 -177 377 -180 l 511 -180 b 543 -148 528 -180 543 -164 b 531 -124 543 -140 539 -131 l 412 0 l 531 124 b 541 148 539 131 541 140 b 513 180 541 164 528 180 l 384 180 b 364 171 377 180 370 177 l 272 94 l 179 171 b 158 180 173 177 166 180 l 30 180 b 0 148 16 180 0 164 b 12 124 0 140 4 131 l 132 0 l 12 -124 b 1 -148 4 -131 1 -140 b 32 -180 1 -164 14 -180 l 158 -180 b 179 -171 166 -180 173 -177 z m 386 -141 l 272 -45 l 157 -141 l 88 -141 l 245 0 l 88 141 l 157 141 l 272 45 l 386 141 l 456 141 l 300 0 l 456 -141 z"
                },
                noteheadXHalf: {
                    x_min: 0,
                    x_max: 334,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 295 180 b 271 170 287 180 278 177 l 209 98 l 115 171 b 95 180 109 177 104 180 l 36 180 b 4 148 19 180 4 164 b 14 124 4 140 7 132 l 140 22 l 7 -127 b 0 -148 3 -131 0 -138 b 32 -180 0 -166 14 -180 l 184 -180 b 209 -170 193 -180 203 -177 l 271 -99 l 363 -171 b 384 -180 370 -176 377 -180 l 445 -180 b 478 -147 461 -180 478 -163 b 465 -125 478 -138 474 -131 l 341 -22 l 474 127 b 481 148 480 131 481 138 b 448 180 481 166 468 180 z m 36 148 l 95 148 l 233 33 l 334 148 l 410 148 l 274 -6 l 445 -148 l 384 -148 l 248 -35 l 147 -148 l 71 -148 l 206 4 z"
                },
                noteheadXBlack: {
                    x_min: 0,
                    x_max: 290,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 410 -143 l 239 0 l 410 144 b 418 160 415 147 418 154 b 399 180 418 171 408 180 b 389 177 396 180 392 179 l 207 26 l 29 177 b 17 180 26 179 22 180 b 0 161 7 180 0 170 b 7 144 0 156 3 148 l 179 0 l 7 -143 b 0 -158 1 -147 0 -153 b 19 -180 0 -170 7 -180 b 29 -176 23 -180 26 -179 l 207 -24 l 389 -176 b 399 -180 392 -179 396 -180 b 418 -160 410 -180 418 -168 b 410 -143 418 -153 415 -147 z"
                },
                noteheadCircleXDoubleWhole: {
                    x_min: 0,
                    x_max: 422,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 576 223 b 563 213 570 223 563 219 l 563 -215 b 576 -223 563 -219 570 -223 l 595 -223 b 608 -215 602 -223 608 -219 l 608 213 b 595 223 608 219 602 223 z m 497 223 b 484 213 491 223 484 219 l 484 -215 b 497 -223 484 -219 491 -223 l 516 -223 b 528 -215 523 -223 528 -219 l 528 213 b 516 223 528 219 523 223 z m 94 223 b 81 213 86 223 81 219 l 81 -215 b 94 -223 81 -219 86 -223 l 111 -223 b 124 -215 118 -223 124 -219 l 124 213 b 111 223 124 219 118 223 z m 13 223 b 0 213 6 223 0 219 l 0 -215 b 13 -223 0 -219 6 -223 l 30 -223 b 45 -215 37 -223 45 -219 l 45 213 b 30 223 45 219 37 223 z m 304 180 b 127 0 206 180 127 101 b 304 -180 127 -99 206 -180 b 482 0 405 -180 482 -99 b 304 180 482 101 405 180 z m 305 32 l 225 112 b 304 140 248 130 275 140 b 387 112 336 140 364 130 z m 278 1 l 193 -82 b 216 0 199 -59 216 -30 b 194 85 216 33 203 50 z m 334 1 l 418 84 b 389 0 402 50 389 23 b 418 -81 389 -30 409 -60 z m 305 -27 l 389 -109 b 304 -138 364 -128 336 -138 b 222 -109 274 -138 246 -128 z"
                },
                noteheadCircleXWhole: {
                    x_min: 0,
                    x_max: 249,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 179 180 b 0 0 81 180 0 101 b 179 -180 0 -99 81 -180 b 359 0 278 -180 359 -99 b 179 180 359 101 278 180 z m 180 32 l 99 112 b 179 140 121 130 150 140 b 262 112 210 140 238 130 z m 151 1 l 68 -82 b 86 0 73 -59 86 -30 b 68 85 86 33 78 50 z m 209 1 l 291 84 b 269 0 276 50 269 32 b 291 -79 269 -26 282 -58 z m 180 -27 l 264 -111 b 179 -138 239 -128 210 -138 b 96 -111 148 -138 120 -128 z"
                },
                noteheadCircleXHalf: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 179 180 b 0 0 81 180 0 101 b 179 -180 0 -99 81 -180 b 360 0 278 -180 360 -99 b 179 180 360 101 278 180 z m 186 37 l 131 92 b 220 124 153 109 189 124 b 262 112 236 124 249 121 z m 215 7 l 291 84 b 304 42 300 71 304 58 b 271 -49 304 10 288 -26 z m 145 -6 l 68 -82 b 56 -42 59 -71 56 -58 b 89 52 56 -9 72 27 z m 174 -33 l 230 -89 b 140 -124 206 -108 171 -124 b 96 -111 122 -124 109 -121 z"
                },
                noteheadCircleX: {
                    x_min: 0,
                    x_max: 249,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 179 180 b 0 0 81 180 0 99 b 179 -180 0 -99 81 -180 b 359 0 278 -180 359 -99 b 179 180 359 99 278 180 z m 261 112 l 180 30 l 98 112 b 179 138 121 128 148 138 b 261 112 210 138 238 128 z m 317 0 b 292 -82 317 -30 308 -59 l 209 1 l 291 84 b 317 0 307 60 317 30 z m 40 0 b 69 84 40 32 50 60 l 151 1 l 68 -84 b 40 0 49 -60 40 -30 z m 95 -111 l 180 -27 l 262 -111 b 179 -138 239 -128 210 -138 b 95 -111 148 -138 120 -128 z"
                },
                noteheadCircledDoubleWhole: {
                    x_min: 0,
                    x_max: 603,
                    y_min: -218,
                    y_max: 213,
                    ha: 431,
                    o: "m 770 223 l 752 223 b 737 213 744 223 737 219 l 737 59 b 435 307 710 203 582 307 b 128 48 281 307 156 197 l 128 213 b 115 223 128 219 122 223 l 96 223 b 84 213 89 223 84 219 l 84 -215 b 96 -223 84 -220 89 -223 l 115 -223 b 128 -215 122 -223 128 -220 l 128 -56 b 435 -314 156 -206 282 -314 b 654 -223 517 -314 595 -282 b 737 -66 697 -180 726 -125 l 737 -215 b 752 -223 737 -220 744 -223 l 770 -223 b 785 -215 778 -223 785 -220 l 785 213 b 770 223 785 219 778 223 z m 435 274 b 698 85 556 274 661 194 b 439 180 641 143 534 180 b 176 99 320 180 228 148 b 435 274 217 203 318 274 z m 32 223 l 13 223 b 0 213 6 223 0 219 l 0 -215 b 13 -223 0 -220 6 -223 l 32 -223 b 45 -215 40 -223 45 -220 l 45 213 b 32 223 45 219 40 223 z m 852 223 l 835 223 b 819 213 828 223 819 219 l 819 -215 b 835 -223 819 -220 828 -223 l 852 -223 b 868 -215 861 -223 868 -220 l 868 213 b 852 223 868 219 861 223 z m 580 -46 b 514 -143 580 -91 562 -131 b 472 -148 501 -147 487 -148 b 364 -105 433 -148 395 -131 l 334 -73 b 285 58 307 -39 285 10 b 289 91 285 69 287 79 b 403 145 305 140 357 145 b 580 -46 501 145 580 42 z m 435 -282 b 176 -108 318 -282 217 -209 b 425 -180 222 -151 301 -180 b 691 -109 563 -180 647 -153 b 435 -282 651 -210 550 -282 z"
                },
                noteheadCircledWhole: {
                    x_min: 0,
                    x_max: 437,
                    y_min: -225,
                    y_max: 211,
                    ha: 436,
                    o: "m 314 304 b 0 -10 140 304 0 164 b 314 -324 0 -183 141 -324 b 629 -10 487 -324 629 -183 b 314 304 629 164 488 304 z m 314 275 b 588 73 441 275 549 193 b 321 180 536 137 420 180 b 48 88 190 180 95 143 b 314 275 85 199 199 275 z m 393 -141 b 350 -147 379 -145 364 -147 b 314 -141 337 -147 325 -145 b 167 55 235 -120 167 -26 b 173 91 167 66 168 79 b 284 145 187 138 239 145 b 459 -48 382 145 459 39 b 393 -141 459 -91 438 -131 z m 314 -294 b 40 -86 187 -294 75 -207 b 305 -180 81 -141 164 -180 b 588 -86 464 -180 550 -143 b 314 -294 554 -209 442 -294 z"
                },
                noteheadCircledHalf: {
                    x_min: -18,
                    x_max: 311,
                    y_min: -162,
                    y_max: 167,
                    ha: 329,
                    o: "m 212 240 b -26 3 81 240 -26 134 b 212 -233 -26 -127 81 -233 b 448 3 341 -233 448 -127 b 212 240 448 134 341 240 z m 212 220 b 363 160 271 220 324 197 b 281 180 341 173 312 180 b 0 -52 76 180 6 26 b -6 3 -4 -35 -6 -16 b 212 220 -6 122 92 220 z m 50 -92 b 42 -63 46 -84 42 -73 b 173 63 42 -33 73 7 b 317 120 243 105 288 120 b 369 89 344 120 359 107 b 377 62 374 81 377 72 b 248 -66 377 33 348 -1 b 108 -125 183 -109 138 -125 b 50 -92 78 -125 60 -109 z m 212 -215 b 84 -171 164 -215 120 -199 b 138 -180 101 -179 120 -180 b 422 56 372 -180 420 7 b 429 3 426 40 429 22 b 212 -215 429 -117 333 -215 z"
                },
                noteheadCircledBlack: {
                    x_min: -21,
                    x_max: 321,
                    y_min: -171,
                    y_max: 167,
                    ha: 338,
                    o: "m 216 240 b -30 -3 82 240 -30 131 b 216 -246 -30 -137 82 -246 b 462 -3 351 -246 462 -137 b 216 240 462 131 351 240 z m 216 220 b 372 160 276 220 331 197 b 284 180 348 174 317 180 b 0 -59 127 180 0 65 l 0 -66 b -10 -3 -6 -45 -10 -24 b 216 220 -10 120 92 220 z m 216 -226 b 56 -158 153 -226 96 -200 b 140 -180 79 -171 107 -180 b 425 60 268 -180 425 -60 b 422 88 425 71 425 79 b 442 -3 435 60 442 29 b 216 -226 442 -125 341 -226 z"
                },
                noteheadDoubleWholeSquare: {
                    x_min: 0,
                    x_max: 416,
                    y_min: -190,
                    y_max: 198,
                    ha: 388,
                    o: "m 563 217 b 528 180 563 192 544 180 l 62 180 b 36 215 52 180 36 192 l 36 268 b 17 285 36 278 27 285 b 0 268 7 285 0 278 l 0 -255 b 17 -274 0 -264 7 -274 b 36 -255 27 -274 36 -264 l 36 -213 b 66 -180 36 -197 53 -180 l 528 -180 b 563 -209 549 -180 563 -196 l 563 -255 b 580 -274 563 -264 570 -274 b 599 -255 590 -274 599 -264 l 599 268 b 580 285 599 278 590 285 b 563 268 570 285 563 278 z m 36 23 b 111 71 36 55 58 71 l 487 71 b 563 30 533 71 563 53 l 563 -22 b 487 -68 563 -53 533 -68 l 117 -68 b 36 -22 66 -68 36 -49 z"
                },
                noteheadSquareWhite: {
                    x_min: 0,
                    x_max: 313,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 451 -180 l 451 180 l 0 180 l 0 -180 z m 40 -138 l 40 140 l 410 140 l 410 -138 z"
                },
                noteheadSquareBlack: {
                    x_min: 0,
                    x_max: 313,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 451 -180 l 451 180 l 0 180 l 0 -180 z"
                },
                noteheadTriangleDownDoubleWhole: {
                    x_min: 0,
                    x_max: 483,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 696 213 b 681 223 696 219 690 223 l 662 223 b 648 213 655 223 648 219 l 648 -213 b 662 -223 648 -217 655 -223 l 681 -223 b 696 -213 690 -223 696 -217 z m 619 213 b 605 223 619 219 613 223 l 588 223 b 573 213 580 223 573 219 l 573 174 b 562 180 570 177 566 180 l 134 180 b 122 174 130 180 125 177 l 122 213 b 108 223 122 219 117 223 l 91 223 b 76 213 84 223 76 219 l 76 -213 b 91 -223 76 -217 84 -223 l 108 -223 b 122 -213 117 -223 122 -217 l 122 154 l 334 -173 b 346 -180 337 -177 341 -180 b 357 -173 351 -180 354 -177 l 573 154 l 573 -213 b 588 -223 573 -217 580 -223 l 605 -223 b 619 -213 613 -223 619 -217 z m 32 -223 b 46 -213 40 -223 46 -217 l 46 213 b 32 223 46 219 40 223 l 14 223 b 0 213 7 223 0 219 l 0 -213 b 14 -223 0 -217 7 -223 z m 428 98 b 346 -107 428 17 377 -53 b 265 96 315 -55 265 17 b 289 137 265 109 275 137 l 406 137 b 428 98 419 137 428 111 z"
                },
                noteheadTriangleDownWhole: {
                    x_min: 0,
                    x_max: 319,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 14 180 b 0 166 6 180 0 173 b 1 158 0 163 1 160 l 216 -173 b 228 -180 219 -177 225 -180 b 239 -173 233 -180 238 -177 l 458 158 b 459 166 458 160 459 163 b 445 180 459 173 454 180 z m 288 137 b 310 98 301 137 310 111 b 228 -108 310 17 259 -55 b 145 96 197 -56 145 17 b 170 137 145 109 157 137 z"
                },
                noteheadTriangleDownHalf: {
                    x_min: 0,
                    x_max: 285,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 196 -180 b 209 -173 200 -180 206 -177 l 408 157 b 410 166 409 160 410 163 b 396 180 410 173 403 180 l 14 180 b 0 166 4 180 0 173 b 1 158 0 163 0 161 l 183 -173 b 196 -180 184 -174 190 -180 z m 164 138 l 295 138 l 179 -76 l 114 37 z"
                },
                noteheadTriangleDownBlack: {
                    x_min: 0,
                    x_max: 292,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 207 -180 l 420 180 l 0 180 z"
                },
                noteheadTriangleUpDoubleWhole: {
                    x_min: 0,
                    x_max: 483,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 696 213 b 681 223 696 217 690 223 l 662 223 b 648 213 655 223 648 217 l 648 -213 b 662 -223 648 -219 655 -223 l 681 -223 b 696 -213 690 -223 696 -219 z m 619 213 b 605 223 619 217 613 223 l 588 223 b 573 213 580 223 573 217 l 573 -154 l 357 173 b 346 180 354 177 351 180 b 334 173 341 180 337 177 l 122 -154 l 122 213 b 108 223 122 217 117 223 l 91 223 b 76 213 84 223 76 217 l 76 -213 b 91 -223 76 -219 84 -223 l 108 -223 b 122 -213 117 -223 122 -219 l 122 -174 b 134 -180 125 -177 130 -180 l 562 -180 b 573 -174 566 -180 570 -177 l 573 -213 b 588 -223 573 -219 580 -223 l 605 -223 b 619 -213 613 -223 619 -219 z m 32 223 l 14 223 b 0 213 7 223 0 217 l 0 -213 b 14 -223 0 -219 7 -223 l 32 -223 b 46 -213 40 -223 46 -219 l 46 213 b 32 223 46 217 40 223 z m 428 -98 b 406 -137 428 -111 419 -137 l 289 -137 b 265 -96 275 -137 265 -109 b 346 107 265 -17 315 55 b 428 -98 377 53 428 -17 z"
                },
                noteheadTriangleUpWhole: {
                    x_min: 0,
                    x_max: 319,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 445 -180 b 459 -166 454 -180 459 -173 b 458 -158 459 -163 458 -160 l 239 173 b 228 180 238 177 233 180 b 216 173 225 180 219 177 l 1 -158 b 0 -166 1 -160 0 -163 b 14 -180 0 -173 6 -180 z m 170 -137 b 145 -96 157 -137 145 -109 b 228 108 145 -17 197 56 b 310 -98 259 55 310 -17 b 288 -137 310 -111 301 -137 z"
                },
                noteheadTriangleUpHalf: {
                    x_min: 0,
                    x_max: 285,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 215 180 b 202 173 210 180 204 177 l 3 -157 b 0 -166 1 -160 0 -163 b 14 -180 0 -173 7 -180 l 396 -180 b 410 -166 406 -180 410 -173 b 409 -158 410 -163 410 -161 l 228 173 b 215 180 226 174 220 180 z m 246 -138 l 115 -138 l 232 76 l 297 -37 z"
                },
                noteheadTriangleUpBlack: {
                    x_min: 0,
                    x_max: 293,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 422 -180 l 207 180 l 0 -180 z"
                },
                noteheadSlashedDoubleWhole1: {
                    x_min: 0,
                    x_max: 596,
                    y_min: -179,
                    y_max: 168,
                    ha: 347,
                    o: "m 618 135 l 697 206 b 704 222 703 210 704 216 b 698 236 704 226 703 232 b 683 242 694 239 688 242 b 670 238 677 242 674 240 l 575 153 b 435 180 531 168 481 180 b 128 0 246 180 128 98 b 236 -148 128 -58 160 -114 l 153 -222 b 145 -238 148 -226 145 -232 b 151 -252 145 -242 148 -248 b 167 -258 156 -256 161 -258 b 181 -253 171 -258 177 -256 l 282 -164 b 420 -180 320 -173 366 -180 b 729 0 654 -180 729 -98 b 618 135 729 55 681 104 z m 114 223 l 95 223 b 82 212 88 223 82 217 l 82 -215 b 95 -223 82 -219 88 -223 l 114 -223 b 127 -215 121 -223 127 -219 l 127 212 b 114 223 127 217 121 223 z m 32 223 l 13 223 b 0 212 6 223 0 217 l 0 -215 b 13 -223 0 -219 6 -223 l 32 -223 b 45 -215 39 -223 45 -219 l 45 212 b 32 223 45 217 39 223 z m 844 223 l 825 223 b 811 212 819 223 811 217 l 811 -215 b 825 -223 811 -219 819 -223 l 844 -223 b 858 -215 851 -223 858 -219 l 858 212 b 844 223 858 217 851 223 z m 763 223 l 743 223 b 730 212 736 223 730 217 l 730 -215 b 743 -223 730 -219 736 -223 l 763 -223 b 776 -215 769 -223 776 -219 l 776 212 b 763 223 776 217 769 223 z m 282 56 b 285 89 282 68 284 79 b 399 144 301 137 354 144 b 510 95 441 144 480 124 l 327 -68 b 282 56 301 -35 282 13 z m 572 -72 b 508 -141 564 -108 544 -132 b 467 -147 495 -145 481 -147 b 360 -104 428 -147 389 -128 l 356 -98 l 537 63 b 575 -46 560 30 575 -9 b 572 -72 575 -55 573 -65 z"
                },
                noteheadSlashedWhole1: {
                    x_min: -22,
                    x_max: 433,
                    y_min: -157,
                    y_max: 148,
                    ha: 305,
                    o: "m 484 140 b 308 180 431 166 367 180 b 0 1 118 180 0 99 b 73 -128 0 -48 22 -95 l -22 -190 b -32 -206 -27 -194 -32 -200 b -27 -217 -32 -210 -30 -215 b -12 -226 -23 -223 -17 -226 b 0 -223 -7 -226 -4 -225 l 112 -150 b 294 -180 157 -168 217 -180 b 602 1 526 -180 602 -98 b 523 118 602 48 570 86 l 613 177 b 624 193 619 181 624 187 b 619 204 624 197 622 200 b 603 213 615 209 609 213 b 592 209 599 213 596 212 z m 190 -52 b 154 56 170 -20 154 19 b 160 91 154 68 156 79 b 271 147 174 138 226 147 b 396 82 321 147 364 121 z m 419 50 b 446 -48 436 19 446 -14 b 337 -147 446 -120 402 -147 b 301 -141 327 -147 314 -144 b 235 -104 276 -134 253 -120 b 215 -84 226 -98 220 -91 z"
                },
                noteheadSlashedHalf1: {
                    x_min: -67,
                    x_max: 386,
                    y_min: -142,
                    y_max: 160,
                    ha: 302,
                    o: "m 552 222 b 536 230 549 228 543 230 b 524 228 533 230 528 230 l 389 140 b 281 180 364 164 327 180 b 0 -60 65 180 0 13 b 7 -105 0 -78 3 -92 l -88 -167 b -96 -184 -94 -171 -96 -177 b -94 -194 -96 -187 -95 -192 b -76 -204 -89 -202 -84 -204 b -66 -202 -73 -204 -69 -203 l 29 -140 b 137 -180 55 -167 92 -180 b 420 59 374 -180 420 13 b 412 107 420 76 419 92 l 546 194 b 556 210 552 197 556 204 b 552 222 556 213 554 217 z m 315 120 b 347 112 328 120 338 117 l 46 -82 b 42 -63 43 -76 42 -69 b 315 120 42 6 248 120 z m 108 -124 b 69 -114 91 -124 79 -120 l 372 81 b 376 63 374 75 376 69 b 108 -124 376 0 174 -124 z"
                },
                noteheadSlashedBlack1: {
                    x_min: -80,
                    x_max: 375,
                    y_min: -165,
                    y_max: 167,
                    ha: 332,
                    o: "m 518 240 b 507 236 514 240 510 239 l 384 148 b 284 180 359 168 324 180 b 0 -62 127 180 0 63 b 13 -115 0 -82 4 -99 l -107 -202 b -115 -217 -111 -204 -115 -212 b -111 -229 -115 -222 -114 -225 b -95 -238 -108 -235 -101 -238 b -84 -235 -91 -238 -86 -236 l 39 -148 b 140 -180 63 -170 99 -180 b 425 59 268 -180 425 -62 b 410 117 425 81 420 101 l 530 203 b 540 219 536 207 540 213 b 518 240 540 229 528 240 z"
                },
                noteheadSlashedDoubleWhole2: {
                    x_min: 0,
                    x_max: 596,
                    y_min: -178,
                    y_max: 169,
                    ha: 347,
                    o: "m 729 0 b 435 180 729 102 569 180 b 278 156 374 180 321 170 l 184 239 b 170 243 181 242 176 243 b 154 238 166 243 158 240 b 150 223 151 233 150 228 b 156 207 150 217 153 212 l 233 138 b 128 0 167 107 128 56 b 420 -180 128 -94 210 -180 b 575 -164 482 -180 533 -174 l 672 -252 b 687 -256 677 -255 681 -256 b 703 -251 691 -256 698 -255 b 707 -236 706 -246 707 -240 b 701 -220 707 -230 706 -225 l 619 -150 b 729 0 700 -117 729 -62 z m 114 223 l 95 223 b 82 213 88 223 82 217 l 82 -213 b 95 -223 82 -219 88 -223 l 114 -223 b 127 -213 121 -223 127 -219 l 127 213 b 114 223 127 217 121 223 z m 32 223 l 13 223 b 0 213 6 223 0 217 l 0 -213 b 13 -223 0 -219 6 -223 l 32 -223 b 45 -213 39 -223 45 -219 l 45 213 b 32 223 45 217 39 223 z m 844 223 l 825 223 b 811 213 819 223 811 217 l 811 -213 b 825 -223 811 -219 819 -223 l 844 -223 b 858 -213 851 -223 858 -219 l 858 213 b 844 223 858 217 851 223 z m 763 223 l 743 223 b 730 213 736 223 730 217 l 730 -213 b 743 -223 730 -219 736 -223 l 763 -223 b 776 -213 769 -223 776 -219 l 776 213 b 763 223 776 217 769 223 z m 312 124 b 399 144 336 141 369 144 b 575 -46 495 144 575 40 b 563 -98 575 -65 570 -81 z m 508 -141 b 467 -147 495 -145 481 -147 b 360 -104 428 -147 389 -128 b 330 -72 350 -95 340 -82 b 282 56 304 -37 282 10 b 285 89 282 68 284 79 b 536 -130 287 89 304 75 z"
                },
                noteheadSlashedWhole2: {
                    x_min: -18,
                    x_max: 436,
                    y_min: -154,
                    y_max: 151,
                    ha: 305,
                    o: "m 531 -128 b 602 1 582 -96 602 -49 b 308 180 602 104 441 180 b 114 144 230 180 164 166 l 4 215 b -6 217 1 217 -3 217 b -22 209 -13 217 -19 215 b -26 197 -24 204 -26 200 b -16 181 -26 192 -22 184 l 75 121 b 0 1 27 91 0 49 b 294 -180 0 -94 82 -180 b 491 -150 379 -180 444 -168 l 598 -219 b 608 -222 600 -222 605 -222 b 624 -213 615 -222 621 -219 b 628 -202 626 -209 628 -206 b 618 -186 628 -196 624 -189 z m 168 108 b 271 147 190 141 233 147 b 446 -48 369 147 446 40 b 445 -72 446 -56 446 -63 z m 154 69 l 429 -109 b 382 -141 419 -125 402 -135 b 337 -147 367 -144 351 -147 b 301 -141 327 -147 314 -144 b 235 -104 276 -134 253 -120 b 203 -72 223 -94 213 -82 b 154 58 177 -39 154 12 z"
                },
                noteheadSlashedHalf2: {
                    x_min: -73,
                    x_max: 380,
                    y_min: -134,
                    y_max: 168,
                    ha: 302,
                    o: "m 537 -156 l 383 -58 b 422 60 413 -9 422 39 b 281 180 422 134 364 180 b 101 127 203 180 144 157 l -75 239 b -85 242 -78 242 -82 242 b -102 233 -92 242 -98 239 b -105 222 -104 229 -105 225 b -95 206 -105 216 -102 209 l 69 99 b 0 -59 19 46 0 -20 b 138 -180 0 -135 60 -180 b 359 -88 248 -180 317 -138 l 516 -190 b 527 -193 520 -192 524 -193 b 543 -183 534 -193 540 -190 b 547 -173 546 -180 547 -176 b 537 -156 547 -166 543 -160 z m 367 92 b 377 63 374 82 377 73 b 318 -14 377 43 361 20 l 184 72 b 317 121 248 108 289 121 b 367 92 344 121 357 109 z m 248 -66 b 108 -124 181 -108 138 -124 b 50 -92 78 -124 60 -109 b 42 -63 46 -84 42 -73 b 145 49 42 -35 68 0 l 285 -40 b 248 -66 274 -49 261 -56 z"
                },
                noteheadSlashedBlack2: {
                    x_min: -79,
                    x_max: 376,
                    y_min: -164,
                    y_max: 168,
                    ha: 332,
                    o: "m 531 -200 l 363 -78 b 425 59 402 -37 425 10 b 285 180 425 132 367 180 b 92 114 210 180 144 154 l -81 238 b -94 242 -85 240 -89 242 b -111 232 -99 242 -107 238 b -114 220 -112 229 -114 225 b -105 204 -114 215 -111 207 l 62 85 b 0 -62 23 43 0 -9 b 140 -180 0 -137 62 -180 b 331 -108 204 -180 275 -153 l 507 -233 b 520 -236 511 -236 517 -236 b 537 -228 527 -236 533 -233 b 541 -216 540 -225 541 -220 b 531 -200 541 -210 537 -203 z"
                },
                noteheadDiamondDoubleWhole: {
                    x_min: 0,
                    x_max: 432,
                    y_min: -155,
                    y_max: 155,
                    ha: 310,
                    o: "m 592 223 b 580 215 585 223 580 219 l 580 -215 b 592 -223 580 -219 585 -223 l 608 -223 b 622 -215 615 -223 622 -219 l 622 215 b 608 223 622 219 615 223 z m 517 223 b 504 215 510 223 504 219 l 504 -215 b 517 -223 504 -219 510 -223 l 533 -223 b 544 -215 540 -223 544 -219 l 544 215 b 533 223 544 219 540 223 z m 246 179 b 240 180 243 179 242 180 b 232 176 236 180 233 179 l 118 22 b 117 17 117 20 117 19 l 117 215 b 104 223 117 219 111 223 l 88 223 b 75 215 81 223 75 219 l 75 -215 b 88 -223 75 -219 81 -223 l 104 -223 b 117 -215 111 -223 117 -219 l 117 14 l 118 14 b 122 7 118 12 120 10 l 374 -179 b 382 -180 376 -180 379 -180 b 390 -177 384 -180 387 -180 l 503 -23 l 503 -17 b 500 -9 503 -13 503 -10 z m 12 223 b 0 215 4 223 0 219 l 0 -215 b 12 -223 0 -219 4 -223 l 29 -223 b 40 -215 36 -223 40 -219 l 40 215 b 29 223 40 219 36 223 z m 183 39 b 179 46 181 39 179 43 b 229 112 226 112 228 112 b 236 109 229 112 233 111 l 436 -39 b 439 -46 438 -39 439 -42 b 390 -112 393 -111 392 -112 b 383 -109 389 -112 386 -111 z"
                },
                noteheadDiamondWhole: {
                    x_min: 0,
                    x_max: 270,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 386 -23 b 389 -16 387 -20 389 -19 b 383 -7 389 -13 386 -9 l 130 179 b 122 180 128 180 125 180 b 115 177 120 180 117 180 l 3 23 b 0 17 1 20 0 19 b 4 7 0 16 3 10 l 258 -179 b 264 -180 261 -179 262 -180 b 272 -176 268 -180 271 -179 z m 66 40 b 62 48 65 42 62 45 l 109 111 b 112 112 109 112 111 112 b 118 111 115 112 117 111 l 320 -37 b 324 -46 323 -39 324 -42 b 275 -111 278 -111 276 -111 b 268 -108 272 -111 271 -109 z"
                },
                noteheadDiamondHalf: {
                    x_min: 0,
                    x_max: 251,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 359 -7 b 361 0 360 -6 361 -3 b 359 7 361 3 360 4 l 189 177 b 180 180 186 179 183 180 b 174 177 179 180 176 179 l 4 7 b 0 0 1 4 0 3 b 4 -7 0 -3 1 -6 l 174 -177 b 180 -180 176 -180 179 -180 b 189 -177 183 -180 186 -180 z m 266 26 b 138 -71 266 -12 176 -71 b 96 -50 121 -71 108 -63 b 88 -24 89 -43 88 -32 b 215 73 88 13 177 73 b 266 26 238 73 266 50 z"
                },
                noteheadDiamondBlack: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 357 -6 b 360 1 359 -4 360 -1 b 357 9 360 4 359 7 l 189 177 b 180 180 187 179 184 180 b 171 177 177 180 173 179 l 3 9 b 0 1 0 6 0 4 b 4 -7 0 -1 1 -4 l 173 -177 b 180 -180 176 -180 177 -180 b 187 -177 181 -180 184 -180 z"
                },
                noteheadParenthesis: {
                    x_min: -73,
                    x_max: 368,
                    y_min: -180,
                    y_max: 182,
                    ha: 362,
                    o: "m 52 -249 b -30 -144 3 -212 -14 -190 b -52 4 -45 -102 -52 -56 b 52 252 -52 118 -36 179 l 46 262 b -105 3 -49 197 -105 124 b 45 -259 -105 -109 -48 -200 z m 382 -259 b 530 3 474 -202 530 -108 b 379 262 530 122 474 200 l 373 252 b 478 4 462 180 478 118 b 456 -144 478 -56 471 -102 b 373 -249 439 -190 422 -212 z"
                },
                noteheadParenthesisRight: {
                    x_min: -36,
                    x_max: 73,
                    y_min: -181,
                    y_max: 181,
                    ha: 362,
                    o: "m -43 -261 b 105 1 49 -203 105 -109 b -46 261 105 121 49 199 l -52 251 b 53 3 37 179 53 117 b 32 -145 53 -58 46 -104 b -52 -251 14 -192 -3 -213 z"
                },
                noteheadParenthesisLeft: {
                    x_min: 0,
                    x_max: 109,
                    y_min: -181,
                    y_max: 181,
                    ha: 362,
                    o: "m 157 -251 b 75 -145 108 -213 91 -192 b 53 3 60 -104 53 -58 b 157 251 53 117 69 177 l 151 261 b 0 1 56 196 0 122 b 150 -261 0 -111 58 -202 z"
                },
                noteheadMoonBlack: {
                    x_min: 0,
                    x_max: 315,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 228 -180 b 454 0 343 -180 454 -130 l 454 180 l 0 180 l 0 0 b 228 -180 0 -131 112 -180 z"
                },
                noteheadTriangleLeftBlack: {
                    x_min: 0,
                    x_max: 339,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 488 -180 l 0 180 l 0 -180 z"
                },
                noteheadTriangleRightBlack: {
                    x_min: 0,
                    x_max: 339,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 488 180 l 0 -180 l 488 -180 z"
                },
                noteheadTriangleRoundDownBlack: {
                    x_min: 0,
                    x_max: 278,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 200 -180 l 400 112 l 383 124 b 199 180 327 161 264 180 b 16 124 135 180 73 161 l 0 112 z"
                },
                augmentationDot: {
                    x_min: 0,
                    x_max: 100,
                    y_min: -50,
                    y_max: 50,
                    ha: 100,
                    o: "m 144 0 b 72 72 144 40 112 72 b 0 0 32 72 0 40 b 72 -72 0 -40 32 -72 b 144 0 112 -72 144 -40 z"
                },
                tremolo1: {
                    x_min: -150,
                    x_max: 150,
                    y_min: -93,
                    y_max: 94,
                    ha: 187,
                    o: "m 216 -45 l 216 135 l -216 46 l -216 -134 z"
                },
                flag8thUp: {
                    x_min: 0,
                    x_max: 264,
                    y_min: -810,
                    y_max: 9,
                    ha: 819,
                    o: "m 343 -1138 b 380 -888 343 -1138 380 -1001 b 215 -395 380 -708 305 -539 b 58 -19 141 -281 81 -157 b 27 13 53 4 42 13 b 0 -9 12 13 0 9 l 0 -353 b 284 -688 95 -370 232 -566 b 318 -904 305 -737 318 -819 b 284 -1102 318 -969 308 -1037 b 279 -1123 281 -1110 279 -1117 b 302 -1165 279 -1146 294 -1159 b 343 -1138 311 -1171 336 -1162 z"
                },
                flag8thDown: {
                    x_min: 0,
                    x_max: 306,
                    y_min: -14,
                    y_max: 808,
                    ha: 822,
                    o: "m 346 1094 b 376 897 366 1034 376 962 b 318 642 376 812 340 691 b 0 340 265 521 193 405 l 0 1 b 23 -20 0 -13 12 -20 b 58 12 36 -20 55 -12 b 262 387 82 148 189 274 b 441 881 353 530 441 701 b 400 1142 441 994 412 1096 b 377 1164 396 1158 387 1164 b 346 1094 356 1164 331 1136 z"
                },
                flag16thUp: {
                    x_min: 0,
                    x_max: 279,
                    y_min: -813,
                    y_max: 2,
                    ha: 815,
                    o: "m 392 -1146 b 402 -988 397 -1139 402 -1057 l 402 -956 b 360 -783 402 -896 386 -837 b 359 -770 360 -779 359 -776 b 360 -760 359 -768 359 -765 b 396 -577 364 -752 396 -665 b 392 -526 396 -559 395 -543 b 236 -275 377 -428 340 -387 b 53 -16 158 -192 78 -168 b 24 3 50 0 33 3 b 0 -12 16 3 0 -1 l 0 -570 l 7 -570 b 298 -778 96 -573 199 -576 b 344 -992 331 -847 344 -917 b 333 -1120 344 -1034 340 -1077 b 331 -1133 331 -1126 331 -1129 b 363 -1171 331 -1152 343 -1171 b 392 -1146 373 -1171 383 -1165 z m 301 -661 b 223 -562 278 -625 253 -596 b 59 -331 156 -484 89 -449 b 58 -327 58 -330 58 -328 b 78 -312 58 -321 66 -312 l 89 -312 b 302 -464 177 -312 255 -393 b 341 -592 328 -501 341 -546 b 340 -621 341 -602 341 -611 b 330 -658 337 -632 337 -647 b 311 -667 328 -662 318 -667 b 301 -661 307 -667 304 -665 z"
                },
                flag16thDown: {
                    x_min: 0,
                    x_max: 291,
                    y_min: -9,
                    y_max: 812,
                    ha: 821,
                    o: "m 346 1132 b 312 768 367 1011 367 880 b 7 559 213 566 96 562 l 0 559 l 0 1 b 24 -13 0 -6 10 -13 b 53 6 35 -13 50 -10 b 406 516 88 228 372 289 b 410 567 409 531 410 549 b 374 750 410 655 379 742 b 373 760 373 753 373 756 b 374 773 373 766 374 769 b 405 1138 426 881 428 1022 b 370 1169 397 1171 387 1169 b 346 1132 353 1168 341 1156 z m 325 657 b 344 647 333 657 343 652 b 354 611 351 636 351 622 b 356 582 356 600 356 590 b 317 454 356 534 343 491 b 89 302 269 383 177 302 l 78 302 b 58 317 66 302 58 310 b 59 321 58 318 58 320 b 238 552 89 439 170 472 b 315 651 268 585 292 613 b 325 657 318 655 321 657 z"
                },
                flag32ndUp: {
                    x_min: 0,
                    x_max: 261,
                    y_min: -812,
                    y_max: 149,
                    ha: 961,
                    o: "m 374 -969 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 366 -289 369 -315 369 -302 b 220 -58 350 -202 317 -163 b 46 187 148 20 71 43 b 20 215 45 200 35 215 b 0 197 12 215 0 207 l 0 -609 l 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 315 -657 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 56 -390 147 -527 88 -495 b 73 -367 53 -380 60 -367 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 z"
                },
                flag32ndDown: {
                    x_min: 0,
                    x_max: 273,
                    y_min: -172,
                    y_max: 812,
                    ha: 984,
                    o: "m 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -229 b 20 -248 0 -242 9 -248 b 48 -219 35 -248 46 -232 b 229 36 72 -69 154 -46 b 380 278 330 145 364 186 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 356 783 356 782 356 783 l 351 791 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 z m 56 386 b 217 609 86 501 153 533 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 z m 330 350 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 z"
                },
                flag64thUp: {
                    x_min: 0,
                    x_max: 261,
                    y_min: -812,
                    y_max: 347,
                    ha: 1159,
                    o: "m 374 -969 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 337 -203 369 -287 359 -242 b 369 -43 350 -167 369 -104 b 366 -4 369 -30 367 -17 b 220 228 350 84 317 122 b 46 472 148 305 71 328 b 20 500 45 485 32 500 b 0 482 10 500 0 492 l 0 -609 l 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 z m 300 24 b 321 -45 315 -4 321 -26 b 317 -75 321 -56 318 -65 l 298 -145 b 220 -58 278 -121 253 -94 b 58 187 148 20 82 43 b 56 193 58 189 58 192 b 300 24 138 193 220 157 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 315 -657 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 55 -386 147 -527 84 -497 b 73 -367 52 -376 63 -367 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 z"
                },
                flag64thDown: {
                    x_min: 0,
                    x_max: 273,
                    y_min: -376,
                    y_max: 812,
                    ha: 1188,
                    o: "m 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -523 b 20 -541 0 -534 9 -541 b 48 -513 35 -541 46 -526 b 229 -258 72 -363 154 -340 b 380 -16 330 -148 364 -108 b 384 27 383 -1 384 13 b 351 189 384 88 366 151 b 380 278 366 216 374 243 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 356 783 356 782 356 783 l 351 791 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 z m 56 386 b 217 609 86 501 153 533 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 z m 330 350 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 z m 330 56 b 334 26 331 46 334 37 b 311 -46 334 7 328 -16 b 56 -222 229 -184 137 -222 b 229 36 75 -86 145 -55 b 311 128 264 73 289 102 z"
                },
                flag128thUp: {
                    x_min: 0,
                    x_max: 261,
                    y_min: -812,
                    y_max: 533,
                    ha: 1345,
                    o: "m 374 -969 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 337 -203 369 -287 359 -242 b 369 -43 350 -167 369 -104 b 366 -4 369 -30 367 -17 b 341 75 360 26 353 50 b 369 222 354 111 369 167 b 366 264 369 236 369 251 b 220 495 350 351 317 390 b 46 740 148 573 71 596 b 22 768 45 753 35 768 b 0 750 10 768 0 760 l 0 -609 l 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 z m 300 292 b 321 223 315 264 321 242 b 317 193 321 212 318 203 b 301 135 314 180 308 158 b 220 228 281 161 255 190 b 55 461 151 304 79 327 b 300 292 134 461 220 426 z m 300 24 b 321 -45 315 -4 321 -26 b 317 -75 321 -56 318 -65 l 298 -145 b 220 -58 278 -121 253 -94 b 56 187 148 20 81 43 b 55 193 56 189 56 192 b 300 24 137 193 220 157 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 315 -657 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 55 -386 147 -527 84 -497 b 73 -367 53 -376 62 -367 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 z"
                },
                flag128thDown: {
                    x_min: 0,
                    x_max: 273,
                    y_min: -580,
                    y_max: 812,
                    ha: 1392,
                    o: "m 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -816 b 20 -835 0 -828 7 -835 b 48 -806 33 -835 46 -819 b 229 -552 72 -657 154 -634 b 380 -310 330 -442 364 -402 b 384 -266 383 -295 384 -281 b 351 -105 384 -206 366 -143 b 384 27 372 -66 384 -16 b 351 189 384 88 366 151 b 380 278 366 216 374 243 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 356 783 356 782 356 783 l 351 791 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 z m 56 386 b 217 609 86 501 153 533 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 z m 330 350 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 z m 330 56 b 334 26 331 46 334 37 b 311 -46 334 7 328 -16 b 56 -222 229 -184 137 -222 b 229 36 75 -86 145 -55 b 311 128 264 73 289 102 z m 330 -238 b 334 -268 331 -248 334 -256 b 311 -340 334 -287 328 -310 b 56 -516 229 -478 137 -516 b 229 -258 75 -380 145 -348 b 311 -166 264 -220 289 -192 z"
                },
                accidentalFlat: {
                    x_min: 0,
                    x_max: 226,
                    y_min: -175,
                    y_max: 439,
                    ha: 614,
                    o: "m 17 -245 b 30 -252 22 -251 26 -252 b 39 -249 35 -252 39 -249 b 153 -161 82 -225 117 -186 b 325 82 281 -72 325 16 b 196 220 325 164 262 216 b 117 196 171 220 137 209 b 85 176 108 189 92 176 b 78 177 82 176 81 176 b 62 202 68 181 62 192 b 72 608 63 233 72 579 b 45 632 72 624 59 632 b 0 592 24 632 1 618 b 17 -245 0 592 6 -230 z m 68 -117 b 63 27 68 -117 63 -30 b 66 73 63 50 65 68 b 167 144 76 102 134 144 b 226 60 209 144 226 96 b 98 -134 226 -17 160 -95 b 84 -138 92 -137 88 -138 b 68 -117 71 -138 68 -124 z"
                },
                accidentalNatural: {
                    x_min: 0,
                    x_max: 168,
                    y_min: -335,
                    y_max: 341,
                    ha: 676,
                    o: "m 203 261 b 197 259 200 261 199 259 b 68 226 197 259 105 226 b 53 233 59 226 53 228 l 53 474 b 36 491 53 484 45 491 l 17 491 b 0 474 7 491 0 484 l 0 -268 b 13 -281 0 -276 4 -281 l 16 -279 b 22 -278 17 -279 20 -279 b 164 -235 42 -269 122 -235 b 189 -251 179 -235 189 -239 l 189 -465 b 206 -482 189 -475 196 -482 l 225 -482 b 242 -465 233 -482 242 -475 l 242 258 b 230 269 242 265 236 269 b 225 268 229 269 226 269 z m 53 56 b 176 114 53 76 141 114 b 189 107 184 114 189 112 l 189 -42 b 71 -101 189 -68 107 -101 b 53 -92 60 -101 53 -98 z"
                },
                accidentalSharp: {
                    x_min: 0,
                    x_max: 249,
                    y_min: -348,
                    y_max: 350,
                    ha: 698,
                    o: "m 341 170 b 359 194 351 174 359 186 l 359 297 b 348 308 359 304 354 308 b 341 307 346 308 344 308 b 305 294 341 307 312 295 b 285 312 295 294 285 301 l 285 488 b 265 504 285 497 276 504 b 242 488 251 504 242 497 l 242 301 b 223 259 240 287 236 268 b 132 223 206 249 157 229 b 115 252 120 223 115 240 l 115 425 b 95 441 115 433 105 441 b 72 425 81 441 72 433 l 72 230 b 55 192 72 210 63 196 b 17 176 46 187 17 176 b 0 153 7 173 0 161 l 0 50 b 13 37 0 42 4 37 l 16 39 b 50 53 17 39 39 48 l 52 55 b 72 29 63 55 72 40 l 72 -114 b 56 -147 72 -130 65 -143 b 17 -163 48 -150 17 -163 b 0 -186 7 -166 0 -177 l 0 -288 b 13 -301 0 -297 4 -301 l 16 -300 b 50 -287 17 -300 37 -291 b 55 -285 52 -285 53 -285 b 72 -308 65 -285 72 -301 l 72 -485 b 91 -501 72 -494 81 -501 b 115 -485 105 -501 115 -494 l 115 -285 b 130 -253 115 -266 122 -256 l 217 -217 b 219 -217 217 -217 219 -217 l 222 -216 b 242 -242 235 -216 242 -233 l 242 -422 b 261 -438 242 -431 251 -438 b 285 -422 276 -438 285 -431 l 285 -217 b 301 -184 285 -206 291 -189 b 341 -168 311 -180 341 -168 b 359 -144 351 -164 359 -153 l 359 -42 b 348 -30 359 -35 354 -30 b 341 -32 346 -30 344 -30 l 304 -46 b 285 -20 295 -46 285 -37 l 285 114 b 304 156 285 124 292 151 z m 242 -65 b 132 -122 233 -94 166 -122 b 115 -115 124 -122 117 -120 b 111 -43 112 -109 111 -78 b 115 63 111 1 112 52 b 220 118 118 88 184 118 b 242 109 230 118 239 115 b 248 27 245 102 248 66 b 242 -65 248 -12 245 -52 z"
                },
                accidentalDoubleSharp: {
                    x_min: 0,
                    x_max: 247,
                    y_min: -125,
                    y_max: 127,
                    ha: 252,
                    o: "m 274 -46 b 206 1 258 -37 206 -9 b 274 50 206 22 253 43 b 278 50 275 50 276 50 l 287 49 b 346 63 304 49 331 52 b 356 115 353 71 356 92 b 292 183 356 174 351 183 b 233 173 266 183 240 180 b 226 117 228 168 226 143 b 179 49 219 101 196 49 b 130 117 158 49 135 96 b 118 173 130 141 125 167 b 66 183 112 180 89 183 b 7 173 42 183 16 180 b 0 120 3 170 0 145 b 7 63 0 94 3 68 b 68 49 17 55 43 49 b 82 50 73 49 78 50 b 150 3 98 42 150 13 b 84 -46 150 -16 104 -39 l 69 -46 b 7 -56 43 -46 16 -49 b 0 -111 3 -60 0 -85 b 7 -166 0 -137 3 -163 b 65 -180 17 -174 40 -180 b 118 -166 86 -180 109 -176 b 130 -111 127 -158 130 -134 b 132 -105 130 -109 131 -107 b 177 -45 141 -85 158 -45 b 226 -111 196 -45 220 -91 b 233 -166 226 -137 228 -161 b 291 -180 243 -174 266 -180 b 356 -114 346 -180 356 -166 b 346 -56 356 -89 351 -63 b 288 -46 338 -49 312 -46 z"
                },
                accidentalDoubleFlat: {
                    x_min: 0,
                    x_max: 411,
                    y_min: -175,
                    y_max: 437,
                    ha: 612,
                    o: "m 452 217 b 384 194 426 217 408 207 b 350 176 374 189 363 176 b 343 177 347 176 344 176 b 328 202 333 180 328 190 b 337 606 328 232 337 579 b 310 629 337 622 324 629 b 265 592 291 629 268 616 b 269 194 265 592 266 395 b 196 217 248 209 223 217 l 187 217 b 120 194 160 217 143 207 b 85 176 108 189 98 176 b 78 177 82 176 81 176 b 62 202 68 180 62 190 b 72 606 62 232 72 579 b 45 629 72 622 59 629 b 0 592 24 629 1 616 b 17 -245 0 592 7 -232 b 30 -252 22 -251 26 -252 b 39 -249 35 -252 39 -249 b 153 -161 84 -226 120 -186 b 274 -50 206 -124 246 -85 b 284 -245 276 -158 279 -240 b 295 -252 288 -251 292 -252 b 304 -249 300 -252 304 -249 b 416 -163 348 -226 383 -186 b 592 82 546 -72 592 16 b 461 217 592 163 528 216 z m 96 -134 b 84 -138 92 -137 86 -138 b 68 -115 72 -138 68 -124 b 63 26 68 -115 63 -30 b 66 72 63 49 65 66 b 168 144 75 101 134 144 b 226 59 212 144 226 95 b 96 -134 226 -22 161 -94 z m 361 -134 b 348 -138 356 -137 351 -138 b 333 -115 337 -138 333 -124 b 328 39 333 -115 328 -16 b 330 72 328 55 328 68 b 433 144 338 101 399 144 b 468 130 448 144 459 140 b 490 59 481 112 490 88 b 361 -134 490 -22 426 -94 z"
                },
                accidentalParensLeft: {
                    x_min: 0,
                    x_max: 141,
                    y_min: -248,
                    y_max: 247,
                    ha: 495,
                    o: "m 203 331 l 203 351 b 202 356 203 354 203 356 b 0 0 60 281 0 140 b 199 -357 0 -144 60 -269 b 203 -354 200 -357 203 -356 l 203 -333 b 200 -327 203 -330 202 -328 b 86 0 118 -253 86 -160 b 200 324 86 158 120 251 b 203 331 202 325 203 327 z"
                },
                accidentalParensRight: {
                    x_min: 0,
                    x_max: 141,
                    y_min: -248,
                    y_max: 247,
                    ha: 495,
                    o: "m 0 331 b 3 324 0 327 1 325 b 117 0 84 251 117 158 b 3 -327 117 -160 85 -253 b 0 -333 1 -328 0 -330 l 0 -354 b 4 -357 0 -356 3 -357 b 203 0 143 -269 203 -144 b 1 356 203 140 143 281 b 0 351 0 356 0 354 z"
                },
                accidentalQuarterToneFlatStein: {
                    x_min: 1,
                    x_max: 227,
                    y_min: -175,
                    y_max: 439,
                    ha: 614,
                    o: "m 310 -245 b 327 592 321 -230 327 592 b 282 632 325 618 302 632 b 255 608 268 632 255 624 b 265 202 255 579 264 233 b 249 177 265 192 259 181 b 242 176 246 176 245 176 b 210 196 235 176 219 189 b 131 220 190 209 156 220 b 1 85 65 216 1 164 b 174 -161 1 16 46 -72 b 288 -249 210 -186 245 -225 b 297 -252 288 -249 292 -252 b 310 -245 301 -252 305 -251 z m 259 -117 b 243 -138 259 -124 256 -138 b 229 -134 239 -138 235 -137 b 101 60 167 -95 101 -17 b 160 144 101 96 118 144 b 261 73 193 144 251 102 b 264 27 262 68 264 50 b 259 -117 264 -30 259 -117 z"
                },
                accidentalThreeQuarterTonesFlatZimmermann: {
                    x_min: 1,
                    x_max: 466,
                    y_min: -175,
                    y_max: 439,
                    ha: 614,
                    o: "m 363 -245 b 376 -252 367 -251 372 -252 b 384 -249 380 -252 384 -249 b 497 -161 428 -226 464 -186 b 671 84 625 -72 671 16 b 541 220 671 164 606 217 b 513 217 531 220 523 219 b 464 196 495 212 480 206 b 431 176 452 189 442 176 b 423 177 428 176 426 176 b 408 202 413 180 408 190 l 419 608 b 392 632 419 625 406 632 b 346 592 372 632 347 618 b 363 -245 346 592 351 -230 z m 289 -249 b 297 -252 289 -249 292 -252 b 310 -245 300 -252 305 -251 b 328 592 321 -230 328 592 b 282 631 327 618 302 631 b 255 608 268 631 255 624 l 266 202 b 251 177 266 190 261 180 b 243 176 248 176 246 176 b 210 196 232 176 222 189 b 164 216 196 204 180 210 l 163 217 b 132 220 151 219 143 220 b 1 84 65 217 1 163 b 177 -163 1 16 48 -72 b 289 -249 210 -186 245 -226 z m 262 72 b 265 26 264 66 265 49 b 261 -115 265 -30 261 -115 b 245 -138 261 -124 258 -138 b 230 -134 240 -138 236 -137 b 102 60 166 -92 102 -20 b 124 128 102 88 111 112 b 161 144 134 138 147 144 b 199 134 173 144 184 141 b 262 72 219 122 256 92 z m 413 -115 b 409 26 413 -115 409 -30 b 412 72 409 49 410 66 b 514 144 420 102 480 144 b 570 60 557 144 570 96 b 442 -134 570 -23 508 -91 b 429 -138 436 -137 433 -138 b 413 -115 418 -138 413 -124 z"
                },
                accidentalQuarterToneSharpStein: {
                    x_min: 0,
                    x_max: 179,
                    y_min: -353,
                    y_max: 307,
                    ha: 660,
                    o: "m 258 240 b 246 252 258 248 252 252 b 240 251 245 252 242 252 b 168 225 240 251 171 225 b 150 253 156 225 150 240 l 150 426 b 130 442 150 435 141 442 b 105 418 108 442 105 429 l 105 230 b 91 193 105 219 101 202 b 17 161 65 183 42 171 b 0 138 9 158 0 147 l 0 36 b 13 23 0 27 4 23 l 16 24 b 86 53 17 24 73 49 l 88 55 b 107 30 98 55 107 42 l 107 -114 b 92 -145 107 -130 101 -143 l 17 -177 b 0 -200 9 -180 0 -192 l 0 -302 b 13 -315 0 -311 4 -315 l 16 -314 b 85 -285 17 -314 72 -291 b 105 -312 92 -282 105 -301 l 105 -492 b 125 -508 105 -501 114 -508 b 150 -484 147 -508 150 -498 l 150 -285 b 151 -274 150 -281 150 -278 b 164 -253 153 -265 158 -256 b 240 -225 176 -251 240 -225 b 258 -202 249 -222 258 -210 l 258 -99 b 245 -86 258 -91 253 -86 l 242 -88 b 240 -88 242 -88 240 -88 l 240 -86 b 168 -115 240 -86 174 -114 b 148 -91 158 -115 148 -107 l 148 43 b 167 85 148 55 156 81 b 240 114 180 91 240 114 b 258 138 249 118 258 128 z"
                },
                accidentalThreeQuarterTonesSharpStein: {
                    x_min: 3,
                    x_max: 317,
                    y_min: -347,
                    y_max: 369,
                    ha: 716,
                    o: "m 456 324 b 448 336 456 330 454 336 b 393 317 445 336 400 320 b 389 315 392 315 390 315 b 383 325 386 315 383 318 l 383 508 b 360 531 383 528 379 531 b 337 508 341 531 337 527 l 337 318 b 325 291 337 300 334 294 b 268 268 320 288 287 276 b 253 281 256 268 253 274 l 253 464 b 230 487 253 484 249 487 b 207 464 212 487 207 482 l 207 264 b 194 240 207 253 204 245 l 132 217 b 131 217 132 217 132 217 l 130 216 b 118 229 122 216 118 220 l 118 420 b 95 444 118 439 114 444 b 72 420 76 444 72 439 l 72 212 b 60 190 72 197 68 193 l 16 173 b 4 161 9 170 4 167 l 4 50 b 13 39 4 45 9 39 b 58 55 16 39 46 49 b 63 56 60 56 62 56 b 72 42 71 56 72 50 l 72 -125 b 58 -150 72 -137 65 -147 l 16 -166 b 4 -177 9 -168 4 -171 l 4 -289 b 14 -301 4 -295 9 -301 b 53 -287 16 -301 40 -291 b 62 -285 56 -285 59 -285 b 72 -298 69 -285 72 -289 l 72 -477 b 95 -500 72 -495 76 -500 b 118 -477 114 -500 118 -495 l 118 -278 b 127 -259 118 -269 121 -261 l 196 -232 b 207 -243 204 -232 207 -235 l 207 -432 b 230 -455 207 -452 212 -455 b 253 -432 249 -455 253 -451 l 253 -228 b 268 -204 253 -216 259 -207 l 320 -186 b 328 -183 323 -184 325 -183 b 337 -194 334 -183 337 -187 l 337 -387 b 360 -410 337 -408 341 -410 b 383 -387 379 -410 383 -406 l 383 -174 b 395 -157 383 -166 390 -158 l 445 -138 b 456 -127 452 -135 456 -132 l 456 -14 b 448 -3 456 -10 454 -3 b 397 -22 445 -3 408 -17 l 396 -23 b 383 -6 387 -23 383 -16 l 383 163 b 392 181 383 173 384 179 b 445 202 397 183 445 202 b 456 213 452 203 456 207 z m 337 -45 b 266 -78 333 -56 287 -78 b 258 -75 262 -78 259 -76 b 253 19 255 -71 253 -27 b 258 130 253 69 255 122 b 333 163 264 141 315 163 b 337 161 334 163 337 161 b 341 78 340 157 341 120 b 337 -45 341 24 340 -37 z m 118 -127 b 114 -48 114 -121 114 -86 b 118 78 114 6 115 68 b 200 114 122 91 180 114 b 207 111 204 114 206 112 b 212 22 210 107 212 66 b 207 -94 212 -29 210 -85 b 127 -130 203 -108 148 -130 b 118 -127 122 -130 120 -128 z"
                },
                accidentalBuyukMucennebFlat: {
                    x_min: 1,
                    x_max: 287,
                    y_min: -174,
                    y_max: 438,
                    ha: 612,
                    o: "m 379 452 b 370 464 379 458 377 464 b 164 389 366 464 170 392 b 156 396 163 389 156 393 b 157 436 157 409 157 428 b 167 452 157 445 161 449 b 366 526 173 455 366 526 b 379 540 374 528 379 534 l 379 611 b 370 622 379 616 377 622 b 170 550 366 622 174 552 b 160 557 163 550 160 554 b 161 608 160 585 161 602 b 134 631 161 624 148 631 b 89 590 114 631 91 616 l 89 528 b 81 517 89 526 88 518 b 16 491 76 514 16 491 b 1 480 6 490 1 485 l 1 406 b 13 395 1 400 4 395 l 14 396 b 79 419 16 396 72 415 b 89 412 86 419 89 415 b 91 376 89 399 89 386 b 82 359 91 364 89 361 b 16 331 76 356 16 331 b 1 321 6 331 1 328 l 1 248 b 13 236 1 242 4 236 b 79 262 16 236 71 258 b 92 251 89 262 92 256 b 107 -242 95 23 101 -236 b 120 -251 111 -249 115 -251 b 128 -248 124 -251 128 -248 b 240 -160 171 -225 207 -184 b 413 84 367 -71 413 16 b 284 220 413 166 350 216 b 207 196 259 220 229 209 b 170 176 196 190 184 176 l 168 177 b 151 203 157 181 151 192 b 153 269 151 210 151 236 b 163 292 153 275 153 289 b 366 367 173 297 366 367 b 379 383 374 370 379 376 z m 186 -132 b 173 -137 180 -135 176 -137 b 157 -114 161 -137 157 -122 b 153 35 157 -114 153 -22 b 154 73 153 53 153 68 b 219 135 160 92 197 124 b 255 144 232 141 243 144 b 292 130 269 144 282 140 b 314 62 305 114 314 91 b 186 -132 314 -17 251 -94 z"
                },
                accidentalBuyukMucennebSharp: {
                    x_min: 0,
                    x_max: 341,
                    y_min: -350,
                    y_max: 348,
                    ha: 698,
                    o: "m 403 167 b 420 192 413 171 420 183 l 420 294 b 410 305 420 301 416 305 b 403 304 408 305 406 305 b 367 291 403 304 374 292 b 347 310 357 291 347 298 l 347 485 b 327 501 347 494 338 501 b 304 485 312 501 304 494 l 304 298 b 285 256 302 284 298 265 b 194 220 268 246 219 226 b 177 249 181 220 177 238 l 177 422 b 157 438 177 431 167 438 b 134 422 143 438 134 431 l 134 228 b 117 189 134 207 125 193 b 79 173 108 184 79 173 b 62 150 69 170 62 158 l 62 48 b 75 35 62 39 66 35 l 78 36 b 111 50 79 36 101 45 b 127 55 117 52 122 55 b 132 50 130 55 132 53 l 132 29 b 128 22 132 26 132 23 b 17 -20 125 20 17 -20 b 0 -35 7 -23 0 -26 l 0 -130 b 13 -144 0 -137 4 -144 b 127 -104 17 -144 120 -107 l 128 -102 b 134 -109 134 -102 134 -107 l 134 -127 b 122 -147 134 -138 132 -143 b 79 -166 114 -151 79 -166 b 62 -189 69 -168 62 -180 l 62 -291 b 75 -304 62 -300 66 -304 l 78 -302 b 112 -289 79 -302 99 -294 b 117 -288 114 -288 115 -288 b 134 -311 127 -288 134 -304 l 134 -488 b 153 -504 134 -497 143 -504 b 177 -488 167 -504 177 -497 l 177 -288 b 192 -256 177 -269 184 -259 l 279 -220 b 281 -220 279 -220 281 -220 l 284 -219 b 304 -245 297 -219 304 -236 l 304 -425 b 323 -441 304 -433 312 -441 b 347 -425 338 -441 347 -433 l 347 -220 b 363 -187 347 -209 353 -192 b 403 -171 373 -183 403 -171 b 420 -147 413 -167 420 -156 l 420 -45 b 410 -33 420 -37 416 -33 b 403 -35 408 -33 406 -33 l 366 -49 b 353 -53 360 -52 356 -53 b 347 -40 348 -53 347 -49 l 347 -26 b 351 -19 347 -23 347 -20 l 474 27 b 491 46 485 30 491 37 l 491 137 b 478 153 491 143 488 153 l 475 150 b 474 150 475 150 474 150 l 474 151 b 351 105 474 151 354 107 b 347 109 348 105 347 107 b 346 128 347 117 346 127 b 366 153 346 143 348 145 z m 177 72 b 301 122 196 89 262 122 b 305 111 305 122 305 117 b 307 94 305 105 305 96 b 304 88 307 92 307 89 b 179 40 284 81 180 42 b 174 43 177 40 174 42 b 177 72 176 50 174 69 z m 305 -65 b 184 -121 301 -85 210 -121 b 177 -118 180 -121 179 -120 b 173 -92 174 -115 174 -105 b 179 -84 173 -86 174 -85 b 302 -37 180 -84 279 -46 b 307 -42 304 -37 307 -40 b 305 -65 307 -52 307 -59 z"
                },
                accidentalBakiyeFlat: {
                    x_min: -1,
                    x_max: 286,
                    y_min: -175,
                    y_max: 439,
                    ha: 614,
                    o: "m 377 454 b 369 467 377 458 376 467 b 363 465 367 467 364 467 b 161 390 363 465 167 393 b 153 399 154 390 153 395 b 157 608 154 494 157 593 b 130 632 157 624 144 632 b 86 592 111 632 88 618 b 88 377 86 592 86 501 b 76 356 88 373 88 360 l 12 331 b -1 320 3 330 -1 327 l -1 248 b 9 236 -1 242 1 236 b 81 264 12 236 78 261 b 89 258 86 264 89 261 b 104 -245 92 30 96 -236 b 115 -252 108 -251 112 -252 b 124 -249 120 -252 124 -249 b 239 -161 167 -226 203 -186 b 412 84 367 -72 412 17 b 282 220 412 166 348 216 b 255 216 274 220 264 219 b 203 196 238 212 222 206 b 171 177 193 189 177 177 b 163 179 168 177 166 177 b 147 202 153 181 147 192 b 147 216 147 204 147 209 l 150 262 b 150 276 150 269 150 275 b 158 291 150 287 154 289 b 363 370 163 292 363 370 b 377 384 373 373 377 379 z m 181 -134 b 167 -138 176 -137 171 -138 b 153 -117 156 -138 153 -125 b 148 27 153 -117 148 -30 b 151 73 148 50 150 68 b 255 144 161 105 219 144 b 312 62 298 144 312 99 b 181 -134 312 -19 249 -96 z"
                },
                accidentalKomaSharp: {
                    x_min: 0,
                    x_max: 229,
                    y_min: -337,
                    y_max: 322,
                    ha: 659,
                    o: "m 312 151 b 330 176 323 156 330 166 l 330 278 b 320 289 330 285 327 289 b 312 288 318 289 315 289 b 200 246 312 288 203 248 b 181 275 187 246 181 264 l 181 448 b 163 464 181 456 173 464 b 138 441 140 464 138 452 l 138 253 b 122 215 137 240 132 225 b 17 177 92 203 45 177 b 0 153 7 173 0 163 l 0 50 b 10 39 0 43 4 39 b 17 40 13 39 14 39 l 128 81 b 138 52 138 81 138 63 l 138 -91 b 124 -124 138 -107 132 -120 b 17 -167 115 -127 17 -167 b 0 -192 7 -171 0 -181 l 0 -294 b 10 -305 0 -301 4 -305 b 17 -304 13 -305 14 -305 b 128 -261 17 -304 117 -264 l 130 -259 b 138 -276 137 -259 138 -268 l 138 -469 b 157 -485 138 -478 147 -485 b 181 -462 179 -485 181 -475 l 181 -262 b 183 -252 181 -258 181 -255 b 197 -232 186 -243 190 -235 b 312 -187 207 -228 312 -187 b 330 -163 323 -183 330 -173 l 330 -60 b 320 -49 330 -53 327 -49 b 312 -50 318 -49 315 -49 l 200 -94 b 193 -95 197 -95 194 -95 b 181 -68 183 -95 181 -85 l 181 66 b 200 108 181 92 189 104 z"
                },
                accidentalKucukMucennebSharp: {
                    x_min: -1,
                    x_max: 339,
                    y_min: -338,
                    y_max: 321,
                    ha: 659,
                    o: "m 264 92 b 271 102 264 98 265 99 l 395 150 b 412 174 405 154 412 164 l 412 276 b 402 288 412 284 409 288 b 395 287 400 288 397 288 b 282 245 395 287 285 246 b 264 274 269 245 264 262 l 264 446 b 245 462 264 455 255 462 b 220 439 222 462 220 451 l 220 252 b 204 213 219 239 215 223 b 99 176 174 202 127 176 b 82 151 89 171 82 161 l 82 49 b 92 37 82 42 86 37 b 99 39 95 37 96 37 l 210 79 b 216 81 212 81 215 81 b 220 78 219 81 220 79 l 220 56 b 216 46 220 52 220 48 b 16 -29 210 45 16 -29 b -1 -45 4 -32 -1 -36 l -1 -138 b 12 -154 -1 -145 3 -154 l 215 -79 b 220 -84 219 -79 220 -81 l 220 -105 b 210 -122 220 -115 219 -120 b 99 -168 202 -127 99 -168 b 82 -193 89 -173 82 -183 l 82 -295 b 92 -307 82 -302 86 -307 b 99 -305 95 -307 96 -307 b 210 -262 99 -305 199 -265 l 212 -261 b 220 -278 219 -261 220 -269 l 220 -471 b 239 -487 220 -480 229 -487 b 264 -464 261 -487 264 -477 l 264 -264 b 265 -253 264 -259 264 -256 b 279 -233 268 -245 272 -236 b 395 -189 289 -229 395 -189 b 412 -164 405 -184 412 -174 l 412 -62 b 402 -50 412 -55 409 -50 b 395 -52 400 -50 397 -50 l 278 -96 b 264 -86 268 -96 264 -94 l 264 -68 b 269 -59 264 -62 265 -60 b 471 17 274 -58 471 17 b 488 36 484 22 488 27 l 488 127 b 475 144 488 134 487 144 l 472 141 b 471 141 472 141 471 141 l 471 143 b 272 68 471 143 282 71 l 269 66 b 264 71 264 66 264 69 z"
                },
                accidentalKoron: {
                    x_min: 0,
                    x_max: 300,
                    y_min: -472,
                    y_max: 157,
                    ha: 629,
                    o: "m 432 -4 b 415 10 432 1 418 9 l 4 226 b 0 223 1 226 0 225 l 0 -672 b 7 -680 0 -677 3 -680 l 45 -680 b 52 -672 49 -680 52 -677 l 52 -193 l 415 -22 b 432 -4 418 -20 432 -13 z m 52 -137 l 52 144 l 327 -7 z"
                },
                accidentalSori: {
                    x_min: 0,
                    x_max: 421,
                    y_min: -318,
                    y_max: 328,
                    ha: 646,
                    o: "m 606 10 b 589 23 606 16 592 22 l 382 109 l 382 465 b 374 472 382 469 379 472 l 337 472 b 330 465 333 472 330 469 l 330 132 l 183 194 l 183 425 b 176 432 183 429 180 432 l 138 432 b 131 425 134 432 131 429 l 131 216 l 3 269 b 0 265 0 269 0 266 l 0 223 b 3 213 0 216 0 215 l 131 160 l 131 -150 l 3 -203 b 0 -212 0 -204 0 -206 l 0 -255 b 3 -259 0 -258 1 -259 l 131 -204 l 131 -451 b 138 -458 131 -455 134 -458 l 176 -458 b 183 -451 180 -458 183 -455 l 183 -183 l 330 -120 l 330 -410 b 337 -418 330 -415 333 -418 l 374 -418 b 382 -410 379 -418 382 -415 l 382 -98 l 589 -9 b 606 10 592 -9 606 0 z m 183 -128 l 183 138 l 330 76 l 330 -66 z m 382 -45 l 382 55 l 501 6 z"
                },
                articAccentAbove: {
                    x_min: 0,
                    x_max: 339,
                    y_min: 1,
                    y_max: 245,
                    ha: 244,
                    o: "m 469 151 b 488 177 488 156 488 166 b 469 203 488 189 488 197 l 37 350 b 24 353 32 351 26 353 b 3 333 12 353 7 344 b 0 318 1 327 0 323 b 20 298 0 311 4 304 b 346 187 20 298 331 193 b 356 177 353 186 356 181 b 344 167 356 173 353 170 b 20 58 328 163 20 58 b 0 36 4 50 0 43 b 3 23 0 32 1 27 b 23 1 7 13 13 1 b 29 3 24 1 27 1 z"
                },
                articAccentBelow: {
                    x_min: 0,
                    x_max: 339,
                    y_min: -244,
                    y_max: 0,
                    ha: 244,
                    o: "m 469 -202 b 488 -176 488 -197 488 -187 b 469 -150 488 -164 488 -156 l 37 -3 b 24 0 32 -1 26 0 b 3 -20 12 0 7 -9 b 0 -35 1 -26 0 -30 b 20 -55 0 -42 4 -49 b 346 -166 20 -55 331 -160 b 356 -176 353 -167 356 -171 b 344 -186 356 -180 353 -183 b 20 -295 328 -190 20 -295 b 0 -317 4 -302 0 -310 b 3 -330 0 -321 1 -325 b 23 -351 7 -340 13 -351 b 29 -350 24 -351 27 -351 z"
                },
                articTenutoAbove: {
                    x_min: -1,
                    x_max: 338,
                    y_min: 0,
                    y_max: 48,
                    ha: 48,
                    o: "m 452 0 b 487 35 485 0 487 16 b 452 69 487 53 487 69 l 33 69 b -1 35 -1 69 -1 53 b 33 0 -1 16 -1 0 z"
                },
                articTenutoBelow: {
                    x_min: -1,
                    x_max: 338,
                    y_min: -48,
                    y_max: 0,
                    ha: 48,
                    o: "m 452 -69 b 487 -35 485 -69 487 -53 b 452 0 487 -16 487 0 l 33 0 b -1 -35 -1 0 -1 -16 b 33 -69 -1 -53 -1 -69 z"
                },
                articStaccatoAbove: {
                    x_min: 0,
                    x_max: 84,
                    y_min: 0,
                    y_max: 84,
                    ha: 84,
                    o: "m 121 60 b 60 121 121 94 94 121 b 0 60 27 121 0 94 b 60 0 0 27 27 0 b 121 60 94 0 121 27 z"
                },
                articStaccatoBelow: {
                    x_min: 0,
                    x_max: 84,
                    y_min: -84,
                    y_max: 0,
                    ha: 84,
                    o: "m 121 -60 b 60 0 121 -27 94 0 b 0 -60 27 0 0 -27 b 60 -121 0 -94 27 -121 b 121 -60 94 -121 121 -94 z"
                },
                articStaccatissimoAbove: {
                    x_min: 1,
                    x_max: 100,
                    y_min: -2,
                    y_max: 293,
                    ha: 295,
                    o: "m 72 422 b 1 390 35 422 3 409 b 72 -3 1 369 39 -3 b 144 389 108 -3 144 356 b 72 422 144 410 111 422 z"
                },
                articStaccatissimoBelow: {
                    x_min: 1,
                    x_max: 100,
                    y_min: -295,
                    y_max: 0,
                    ha: 295,
                    o: "m 72 -425 b 144 -392 111 -425 144 -413 b 72 0 144 -359 108 0 b 1 -393 39 0 1 -372 b 72 -425 3 -412 35 -425 z"
                },
                articMarcatoAbove: {
                    x_min: -1,
                    x_max: 235,
                    y_min: -1,
                    y_max: 253,
                    ha: 254,
                    o: "m 181 356 b 167 364 177 361 173 364 b 153 356 157 364 153 356 l 0 23 b -1 16 -1 20 -1 19 b 9 0 -1 9 1 1 b 16 -1 10 -1 14 -1 b 32 9 22 -1 29 1 b 112 186 32 9 109 180 b 118 190 114 189 115 190 b 127 186 121 190 124 189 b 209 9 128 180 209 9 b 225 0 213 3 219 0 l 323 0 b 338 16 333 1 338 7 b 337 23 338 19 338 22 z"
                },
                articMarcatoBelow: {
                    x_min: -1,
                    x_max: 235,
                    y_min: -254,
                    y_max: 0,
                    ha: 254,
                    o: "m 156 -357 b 170 -366 160 -363 164 -366 b 184 -357 180 -366 184 -357 l 337 -24 b 338 -17 338 -22 338 -20 b 328 -1 338 -10 336 -3 b 321 0 327 0 323 0 b 305 -10 315 0 308 -3 b 225 -187 305 -10 228 -181 b 219 -192 223 -190 222 -192 b 210 -187 216 -192 213 -190 b 128 -10 209 -181 128 -10 b 112 -1 124 -4 118 -1 l 14 -1 b -1 -17 4 -3 -1 -9 b 0 -24 -1 -20 -1 -23 z"
                },
                fermataAbove: {
                    x_min: 3,
                    x_max: 605,
                    y_min: -3,
                    y_max: 329,
                    ha: 332,
                    o: "m 435 318 b 818 36 742 318 804 91 b 821 26 819 32 819 27 b 851 -4 831 6 837 -4 b 871 16 864 -4 871 1 b 870 30 871 20 871 24 b 438 474 780 471 480 474 b 6 30 392 474 94 471 b 4 14 4 24 4 19 b 23 -4 4 0 12 -4 b 52 26 36 -4 43 6 b 56 39 53 27 55 33 b 435 318 73 98 138 318 z m 516 75 b 436 153 516 117 480 153 b 359 75 395 153 359 117 b 436 -4 359 32 395 -4 b 516 75 480 -4 516 32 z"
                },
                fermataBelow: {
                    x_min: 3,
                    x_max: 605,
                    y_min: -332,
                    y_max: 0,
                    ha: 332,
                    o: "m 435 -323 b 56 -43 138 -323 73 -102 b 52 -30 55 -37 53 -32 b 23 0 43 -10 36 0 b 4 -19 12 0 4 -4 b 6 -35 4 -23 4 -29 b 438 -478 94 -475 392 -478 b 870 -35 480 -478 780 -475 b 871 -20 871 -29 871 -24 b 851 0 871 -6 864 0 b 821 -30 837 0 831 -10 b 818 -40 819 -32 819 -36 b 435 -323 804 -95 742 -323 z m 516 -79 b 436 0 516 -36 480 0 b 359 -79 395 0 359 -36 b 436 -157 359 -121 395 -157 b 516 -79 480 -157 516 -121 z"
                },
                fermataLongAbove: {
                    x_min: 0,
                    x_max: 603,
                    y_min: -1,
                    y_max: 333,
                    ha: 334,
                    o: "m 72 480 b 0 441 32 480 0 462 l 0 19 b 35 0 0 9 16 0 b 71 19 55 0 71 9 l 71 289 b 433 315 71 307 252 315 b 798 289 615 315 798 307 l 798 19 b 832 0 798 9 814 0 b 868 19 852 0 868 9 l 868 441 b 796 480 868 462 837 480 z m 513 78 b 433 156 513 121 478 156 b 356 78 390 156 356 121 b 433 -1 356 35 390 -1 b 513 78 478 -1 513 35 z"
                },
                fermataLongBelow: {
                    x_min: 0,
                    x_max: 603,
                    y_min: -333,
                    y_max: 1,
                    ha: 334,
                    o: "m 513 -78 b 433 1 513 -35 478 1 b 356 -78 390 1 356 -35 b 433 -156 356 -121 390 -156 b 513 -78 478 -156 513 -121 z m 796 -480 b 868 -441 837 -480 868 -462 l 868 -19 b 832 0 868 -9 852 0 b 798 -19 814 0 798 -9 l 798 -289 b 433 -315 798 -307 615 -315 b 71 -289 252 -315 71 -307 l 71 -19 b 35 0 71 -9 55 0 b 0 -19 16 0 0 -9 l 0 -441 b 72 -480 0 -462 32 -480 z"
                },
                fermataVeryLongAbove: {
                    x_min: 0,
                    x_max: 715,
                    y_min: 0,
                    y_max: 408,
                    ha: 408,
                    o: "m 76 588 b 0 546 35 588 0 569 l 0 22 b 37 1 0 10 17 1 b 75 22 59 1 75 10 l 75 431 b 514 458 75 449 294 458 b 955 431 734 458 955 449 l 955 22 b 991 1 955 10 971 1 b 1030 22 1012 1 1030 10 l 1030 546 b 953 588 1030 569 995 588 z m 215 389 b 138 347 171 389 138 370 l 138 22 b 174 1 138 10 154 1 b 213 22 196 1 213 10 l 213 217 b 514 245 213 235 363 245 b 816 217 665 245 816 235 l 816 22 b 854 1 816 10 834 1 b 891 22 876 1 891 10 l 891 347 b 815 389 891 370 858 389 z m 606 84 b 521 167 606 130 569 167 b 439 84 475 167 439 130 b 521 0 439 39 475 0 b 606 84 569 0 606 39 z"
                },
                fermataVeryLongBelow: {
                    x_min: 0,
                    x_max: 715,
                    y_min: -408,
                    y_max: 0,
                    ha: 408,
                    o: "m 606 -84 b 521 0 606 -39 569 0 b 439 -84 475 0 439 -39 b 521 -167 439 -130 475 -167 b 606 -84 569 -167 606 -130 z m 815 -389 b 891 -347 858 -389 891 -370 l 891 -22 b 854 -1 891 -10 876 -1 b 816 -22 834 -1 816 -10 l 816 -217 b 514 -245 816 -235 665 -245 b 213 -217 363 -245 213 -235 l 213 -22 b 174 -1 213 -10 196 -1 b 138 -22 154 -1 138 -10 l 138 -347 b 215 -389 138 -370 171 -389 z m 953 -588 b 1030 -546 995 -588 1030 -569 l 1030 -22 b 991 -1 1030 -10 1012 -1 b 955 -22 971 -1 955 -10 l 955 -431 b 514 -458 955 -449 734 -458 b 75 -431 294 -458 75 -449 l 75 -22 b 37 -1 75 -10 59 -1 b 0 -22 17 -1 0 -10 l 0 -546 b 76 -588 0 -569 35 -588 z"
                },
                fermataVeryShortAbove: {
                    x_min: 0,
                    x_max: 726,
                    y_min: 0,
                    y_max: 449,
                    ha: 449,
                    o: "m 46 0 b 59 7 50 0 52 4 b 516 517 120 59 507 517 b 975 4 527 517 920 52 b 988 0 979 1 988 0 l 1041 0 b 1045 6 1041 0 1045 1 b 1043 13 1045 7 1045 10 b 516 647 962 91 536 647 b 3 13 504 647 91 98 b 0 7 0 10 0 9 b 6 0 0 3 6 0 z m 238 0 b 248 6 240 0 242 3 b 516 236 292 43 494 236 b 786 3 539 236 746 37 b 796 0 789 1 796 0 l 865 0 b 870 4 865 0 870 1 b 867 10 870 6 868 9 b 516 409 806 68 531 409 b 166 10 497 409 229 73 b 163 4 164 9 163 6 b 167 0 163 1 167 0 z m 592 91 b 516 167 592 132 557 167 b 438 91 472 167 438 132 b 516 13 438 48 472 13 b 592 91 557 13 592 48 z"
                },
                fermataVeryShortBelow: {
                    x_min: 0,
                    x_max: 726,
                    y_min: -449,
                    y_max: 0,
                    ha: 449,
                    o: "m 167 0 b 163 -4 167 0 163 -1 b 166 -10 163 -6 164 -9 b 516 -409 229 -73 497 -409 b 867 -10 531 -409 806 -68 b 870 -4 868 -9 870 -6 b 865 0 870 -1 865 0 l 796 0 b 786 -3 796 0 789 -1 b 516 -236 746 -37 539 -236 b 248 -6 494 -236 292 -43 b 238 0 242 -3 240 0 z m 6 0 b 0 -7 6 0 0 -3 b 3 -13 0 -9 0 -10 b 516 -647 91 -98 504 -647 b 1043 -13 536 -647 962 -91 b 1045 -6 1045 -10 1045 -7 b 1041 0 1045 -1 1041 0 l 988 0 b 975 -4 988 0 979 -1 b 516 -517 920 -52 527 -517 b 59 -7 507 -517 120 -59 b 46 0 52 -4 50 0 z m 592 -91 b 516 -13 592 -48 557 -13 b 438 -91 472 -13 438 -48 b 516 -167 438 -132 472 -167 b 592 -91 557 -167 592 -132 z"
                },
                fermataShortAbove: {
                    x_min: 0,
                    x_max: 604,
                    y_min: 0,
                    y_max: 341,
                    ha: 341,
                    o: "m 78 0 b 88 6 81 0 82 3 b 435 328 134 45 412 328 b 783 3 458 328 742 39 b 793 0 786 1 793 0 l 865 0 b 870 4 865 0 870 1 b 867 10 870 6 868 9 b 435 491 805 69 474 491 b 3 10 397 491 69 75 b 0 4 1 9 0 6 b 4 0 0 1 4 0 z m 513 94 b 433 171 513 135 477 171 b 354 94 390 171 354 135 b 433 13 354 49 390 13 b 513 94 477 13 513 49 z"
                },
                fermataShortBelow: {
                    x_min: 0,
                    x_max: 604,
                    y_min: -341,
                    y_max: 0,
                    ha: 341,
                    o: "m 4 0 b 0 -4 4 0 0 -1 b 3 -10 0 -6 1 -9 b 435 -491 69 -75 397 -491 b 867 -10 474 -491 805 -69 b 870 -4 868 -9 870 -6 b 865 0 870 -1 865 0 l 793 0 b 783 -3 793 0 786 -1 b 435 -328 742 -39 458 -328 b 88 -6 412 -328 134 -45 b 78 0 82 -3 81 0 z m 513 -94 b 433 -13 513 -49 477 -13 b 354 -94 390 -13 354 -49 b 433 -171 354 -135 390 -171 b 513 -94 477 -171 513 -135 z"
                },
                breathMarkComma: {
                    x_min: 1,
                    x_max: 152,
                    y_min: 2,
                    y_max: 251,
                    ha: 249,
                    o: "m 104 361 b 1 271 42 361 1 321 b 82 190 1 222 35 190 b 122 160 118 190 122 160 b 125 144 124 154 125 150 b 102 88 125 124 115 105 b 37 32 78 56 40 35 b 26 17 32 29 26 26 l 27 16 b 37 3 29 6 33 3 b 181 102 85 3 158 66 b 219 239 210 147 219 197 l 219 249 b 104 361 219 317 170 361 z"
                },
                breathMarkUpbow: {
                    x_min: 1,
                    x_max: 249,
                    y_min: 1,
                    y_max: 495,
                    ha: 494,
                    o: "m 181 1 b 206 22 193 1 203 10 l 359 683 l 359 688 b 338 713 359 700 351 710 l 333 713 b 308 694 321 713 311 706 l 180 140 l 53 694 b 27 713 49 706 39 713 l 22 713 b 1 690 10 710 1 700 b 3 683 1 687 1 685 l 154 22 b 181 1 157 10 167 1 z"
                },
                caesura: {
                    x_min: 0,
                    x_max: 384,
                    y_min: -1,
                    y_max: 532,
                    ha: 533,
                    o: "m 40 -1 b 78 26 58 -1 72 9 l 321 713 b 323 726 323 717 323 721 b 282 766 323 747 304 766 b 245 739 265 766 251 756 l 3 52 b 0 37 1 48 0 42 b 27 1 0 22 10 7 b 40 -1 32 -1 36 -1 z m 308 26 l 552 713 b 553 726 553 717 553 721 b 513 766 553 747 534 766 b 475 739 495 766 481 756 l 232 52 b 230 39 230 48 230 43 b 258 1 230 23 240 7 b 271 -1 262 -1 266 -1 b 308 26 287 -1 302 9 z"
                },
                caesuraCurved: {
                    x_min: 0,
                    x_max: 373,
                    y_min: 0,
                    y_max: 530,
                    ha: 530,
                    o: "m 491 763 b 445 719 468 763 446 744 b 252 98 432 507 340 295 l 226 39 b 223 27 225 35 223 32 b 252 0 223 13 233 0 b 276 16 262 0 272 6 b 537 716 386 230 537 478 b 491 763 537 742 518 763 z m 29 0 b 53 16 39 0 48 6 l 82 69 b 314 716 187 264 314 498 b 268 763 314 742 295 763 b 222 719 245 763 223 744 b 29 98 209 507 117 295 l 3 39 b 0 29 1 36 0 33 b 29 0 0 14 12 0 z"
                },
                restMaxima: {
                    x_min: 0,
                    x_max: 381,
                    y_min: -249,
                    y_max: 250,
                    ha: 499,
                    o: "m 180 -330 l 180 331 b 156 360 180 356 170 360 l 23 360 b 0 331 10 360 0 356 l 0 -330 b 23 -359 0 -354 10 -359 l 156 -359 b 180 -330 170 -359 180 -354 z m 549 -330 l 549 331 b 524 360 549 356 539 360 l 392 360 b 369 331 379 360 369 356 l 369 -330 b 392 -359 369 -354 379 -359 l 524 -359 b 549 -330 539 -359 549 -354 z"
                },
                restDoubleWhole: {
                    x_min: 0,
                    x_max: 125,
                    y_min: 0,
                    y_max: 250,
                    ha: 250,
                    o: "m 180 22 l 180 338 b 156 360 180 350 170 360 l 23 360 b 0 338 10 360 0 350 l 0 22 b 23 0 0 10 10 0 l 156 0 b 180 22 170 0 180 10 z"
                },
                restWhole: {
                    x_min: 0,
                    x_max: 282,
                    y_min: -135,
                    y_max: 9,
                    ha: 144,
                    o: "m 406 -157 l 406 -24 b 369 13 406 -3 389 13 l 37 13 b 0 -24 16 13 0 -3 l 0 -157 b 37 -194 0 -177 16 -194 l 369 -194 b 406 -157 389 -194 406 -177 z"
                },
                restWholeLegerLine: {
                    x_min: -117,
                    x_max: 399,
                    y_min: -135,
                    y_max: 20,
                    ha: 155,
                    o: "m -143 29 b -168 3 -157 29 -168 17 b -143 -23 -168 -12 -157 -23 l 0 -23 l 0 -157 b 37 -194 0 -177 16 -194 l 369 -194 b 406 -157 389 -194 406 -177 l 406 -24 b 549 -23 406 -23 406 -23 b 575 3 563 -23 575 -12 b 549 29 575 17 563 29 z"
                },
                restHalf: {
                    x_min: 0,
                    x_max: 282,
                    y_min: -2,
                    y_max: 142,
                    ha: 144,
                    o: "m 406 35 l 406 167 b 369 204 406 189 389 204 l 37 204 b 0 167 16 204 0 189 l 0 35 b 37 -3 0 14 16 -3 l 369 -3 b 406 35 389 -3 406 14 z"
                },
                restHalfLegerLine: {
                    x_min: -117,
                    x_max: 399,
                    y_min: -13,
                    y_max: 142,
                    ha: 155,
                    o: "m 549 -19 b 575 7 563 -19 575 -7 b 549 33 575 22 563 33 b 406 35 406 33 406 33 l 406 167 b 369 204 406 187 389 204 l 37 204 b 0 167 16 204 0 187 l 0 33 l -143 33 b -168 7 -157 33 -168 22 b -143 -19 -168 -7 -157 -19 z"
                },
                restQuarter: {
                    x_min: 1,
                    x_max: 270,
                    y_min: -375,
                    y_max: 373,
                    ha: 748,
                    o: "m 112 -55 b 174 -141 135 -84 156 -111 b 183 -161 177 -147 183 -158 b 181 -167 183 -163 183 -166 b 166 -174 179 -173 173 -174 b 143 -170 160 -174 148 -171 b 137 -170 141 -170 138 -170 l 125 -166 b 1 -304 50 -166 1 -233 b 168 -527 1 -376 63 -446 b 206 -540 180 -536 194 -540 b 228 -531 216 -540 226 -537 b 230 -521 229 -527 230 -524 b 207 -487 230 -508 219 -497 b 170 -435 189 -487 173 -448 b 164 -397 166 -423 164 -410 b 255 -292 164 -338 194 -292 b 369 -317 297 -292 344 -308 l 370 -318 b 382 -320 376 -320 379 -320 b 389 -314 386 -320 389 -318 b 336 -232 389 -297 351 -249 b 236 -32 281 -166 236 -112 b 236 -27 236 -30 236 -29 l 238 -17 b 238 -13 238 -16 238 -14 b 333 199 243 71 295 140 b 338 220 337 206 338 213 b 333 248 338 235 333 248 b 95 526 333 248 120 501 b 69 537 88 533 78 537 b 40 507 55 537 40 527 b 46 484 40 500 42 492 b 134 291 52 468 134 395 b 48 108 134 238 112 176 b 27 66 33 94 27 78 b 42 32 27 46 42 32 z"
                },
                rest8th: {
                    x_min: 0,
                    x_max: 247,
                    y_min: -251,
                    y_max: 174,
                    ha: 425,
                    o: "m 193 154 b 96 251 193 207 150 251 b 0 154 43 251 0 207 b 39 81 0 124 17 98 b 117 56 62 65 89 56 b 173 66 137 56 157 60 b 225 88 193 72 206 78 b 232 89 228 89 230 89 b 239 76 238 89 239 84 b 238 60 239 72 239 66 b 104 -343 233 39 130 -248 b 145 -361 104 -360 137 -361 b 196 -347 161 -361 181 -359 b 341 161 200 -344 341 161 b 356 217 347 187 354 210 b 338 240 356 232 341 239 b 323 235 336 240 331 240 b 193 140 312 226 240 140 z"
                },
                rest16th: {
                    x_min: 0,
                    x_max: 320,
                    y_min: -500,
                    y_max: 179,
                    ha: 679,
                    o: "m 300 160 b 202 258 300 215 256 258 b 104 160 148 258 104 215 b 219 62 104 101 164 62 b 331 94 258 62 298 75 b 341 96 336 95 338 96 b 348 86 346 96 348 94 b 265 -173 348 63 275 -151 b 194 -217 253 -200 215 -217 b 196 -203 196 -212 196 -207 b 98 -105 196 -148 151 -105 b 0 -203 43 -105 0 -148 b 115 -301 0 -262 60 -301 b 223 -271 153 -301 190 -288 b 229 -279 226 -271 229 -274 l 228 -281 b 228 -282 228 -282 228 -282 l 91 -690 b 91 -691 91 -690 91 -691 l 89 -693 b 134 -720 89 -706 102 -720 b 189 -687 176 -720 183 -703 l 356 -138 b 420 81 393 -16 420 81 b 459 226 420 81 456 207 b 461 232 459 229 461 230 b 446 248 461 240 449 246 b 431 242 439 248 435 245 b 300 145 420 233 348 147 z"
                },
                rest32nd: {
                    x_min: 0,
                    x_max: 363,
                    y_min: -500,
                    y_max: 426,
                    ha: 926,
                    o: "m 508 603 b 492 598 501 603 497 600 b 361 503 482 590 410 503 l 361 516 b 264 613 361 570 318 613 b 166 516 210 613 166 570 b 206 444 166 487 183 461 b 246 423 217 433 232 428 b 284 418 258 420 269 418 b 393 449 321 418 360 432 b 399 451 395 451 397 451 b 415 426 409 451 415 436 l 413 423 b 413 422 413 423 413 422 l 357 192 b 279 140 350 168 302 140 b 281 153 281 144 281 148 b 183 251 281 207 236 251 b 85 153 128 251 85 207 b 125 81 85 124 102 98 b 164 60 137 71 150 65 b 203 55 176 58 189 55 b 311 86 240 55 278 69 b 315 88 312 88 314 88 b 325 69 323 88 325 76 l 268 -167 b 194 -217 261 -197 216 -216 b 196 -203 196 -212 196 -207 b 98 -105 196 -148 153 -105 b 0 -203 45 -105 0 -148 b 115 -301 0 -262 60 -301 b 228 -269 154 -301 194 -288 b 232 -268 229 -268 230 -268 b 240 -276 236 -268 240 -272 b 138 -688 240 -282 141 -678 b 137 -697 137 -691 137 -694 b 176 -720 137 -708 145 -720 b 232 -690 222 -720 226 -706 b 484 436 236 -672 484 436 b 521 582 484 436 518 564 b 523 588 521 585 523 586 b 508 603 523 600 511 603 z"
                },
                rest64th: {
                    x_min: 0,
                    x_max: 423,
                    y_min: -753,
                    y_max: 430,
                    ha: 1183,
                    o: "m 596 609 b 580 603 589 609 585 606 b 448 507 569 595 497 507 b 449 521 449 511 449 516 b 351 619 449 575 405 619 b 253 521 297 619 253 575 b 372 422 253 461 317 422 b 481 454 410 422 446 438 b 491 456 484 455 488 456 b 504 441 498 456 504 451 b 501 426 504 436 503 432 b 445 202 500 422 451 217 b 359 144 435 174 383 144 l 359 158 b 261 256 359 212 315 256 b 163 158 207 256 163 212 b 243 65 163 112 202 78 b 279 60 255 62 266 60 b 397 91 320 60 360 73 b 403 92 400 92 402 92 b 412 79 409 92 412 86 b 410 72 412 76 412 75 b 351 -161 408 59 356 -150 b 281 -212 340 -199 301 -212 l 281 -197 b 183 -99 281 -144 238 -99 b 85 -197 130 -99 85 -144 b 125 -271 85 -228 102 -253 b 166 -291 138 -279 151 -287 b 204 -297 177 -294 192 -297 b 262 -287 225 -297 245 -292 b 305 -265 282 -279 287 -274 b 310 -264 307 -264 308 -264 b 318 -284 317 -264 318 -275 b 317 -295 318 -288 317 -294 b 259 -524 315 -302 265 -508 b 194 -567 251 -554 213 -567 b 196 -554 196 -563 196 -559 b 98 -456 196 -500 153 -456 b 0 -554 45 -456 0 -500 b 40 -626 0 -583 17 -609 b 118 -652 60 -644 92 -652 b 210 -629 145 -652 186 -642 b 216 -628 213 -628 215 -628 b 228 -647 226 -628 228 -639 l 226 -651 b 226 -652 226 -651 226 -652 l 122 -1054 b 121 -1064 121 -1058 121 -1061 b 167 -1084 121 -1077 134 -1084 b 215 -1060 202 -1084 209 -1076 b 402 -278 217 -1047 229 -1021 b 436 -135 403 -278 431 -161 l 570 441 b 609 588 570 441 605 569 b 596 609 609 603 602 608 z"
                },
                rest128th: {
                    x_min: 0,
                    x_max: 485,
                    y_min: -750,
                    y_max: 689,
                    ha: 1439,
                    o: "m 537 894 b 439 992 537 949 494 992 b 341 894 386 992 341 949 b 382 822 341 865 359 840 b 459 796 402 805 433 796 b 518 806 480 796 501 801 l 520 808 b 569 828 539 814 552 819 b 580 831 572 829 577 831 b 598 812 589 831 598 825 b 596 801 598 809 598 805 b 540 575 590 773 546 595 b 448 510 534 553 475 510 l 448 524 b 350 622 448 577 405 622 b 252 524 297 622 252 577 b 292 451 252 494 269 468 b 369 426 318 433 337 426 b 429 435 389 426 412 429 b 494 464 449 442 475 455 b 498 465 495 465 497 465 b 505 446 504 465 505 456 b 503 426 505 439 504 432 l 446 202 b 366 144 439 173 389 144 l 366 158 b 268 256 366 212 323 256 b 170 158 215 256 170 212 b 289 59 170 98 235 59 b 347 69 310 59 330 63 b 397 91 367 76 379 82 b 406 94 400 92 403 94 b 415 79 412 94 415 88 b 412 63 415 75 413 69 b 357 -157 408 42 364 -134 b 281 -212 346 -196 302 -212 b 282 -197 281 -207 282 -203 b 184 -99 282 -144 238 -99 b 86 -197 130 -99 86 -144 b 204 -297 86 -258 150 -297 b 262 -287 225 -297 245 -292 b 312 -265 282 -279 294 -274 b 318 -264 314 -264 317 -264 b 327 -275 324 -264 327 -269 b 266 -517 324 -287 278 -490 b 200 -569 248 -566 220 -567 l 196 -554 b 98 -456 196 -500 153 -456 b 0 -554 45 -456 0 -500 b 118 -652 0 -615 63 -652 b 177 -642 138 -652 160 -648 l 179 -641 b 229 -621 197 -635 210 -629 l 230 -619 b 239 -626 236 -619 239 -622 b 238 -632 239 -628 239 -631 b 131 -1057 235 -642 134 -1050 b 173 -1080 131 -1071 140 -1080 b 230 -1057 219 -1080 225 -1074 l 658 815 b 697 960 658 815 694 942 b 698 966 697 963 698 965 b 684 982 698 975 687 981 b 668 976 677 982 672 979 b 537 880 658 969 586 881 z"
                },
                dynamicPiano: {
                    x_min: -89,
                    x_max: 366,
                    y_min: -142,
                    y_max: 274,
                    ha: 416,
                    o: "m 395 395 b 292 357 350 395 318 380 b 262 328 272 340 268 328 b 246 363 255 328 259 338 b 177 393 236 380 215 393 b 1 251 92 393 46 333 b -9 223 -6 238 -9 230 b 7 207 -9 213 -1 207 b 30 229 17 207 23 216 b 127 338 72 301 101 338 b 143 321 138 338 143 331 b 134 285 143 310 138 295 l -43 -154 b -65 -168 -48 -166 -50 -168 l -109 -168 b -128 -187 -122 -168 -128 -174 b -111 -204 -128 -199 -122 -204 l 167 -204 b 186 -186 180 -204 186 -199 b 168 -168 186 -174 180 -168 l 111 -168 b 98 -164 102 -168 98 -168 b 101 -154 98 -163 99 -158 l 166 7 b 179 24 168 14 171 24 b 213 -1 186 24 190 10 b 276 -14 233 -12 252 -14 b 527 266 415 -14 527 130 b 395 395 527 350 475 395 z m 356 341 b 389 288 380 341 389 320 b 243 35 389 217 312 35 b 207 81 219 35 207 50 b 235 180 207 111 219 140 l 264 251 b 356 341 284 300 321 341 z"
                },
                dynamicMezzo: {
                    x_min: -20,
                    x_max: 446,
                    y_min: -10,
                    y_max: 274,
                    ha: 284,
                    o: "m 528 395 b 431 350 487 395 454 374 b 409 330 416 336 415 330 b 397 360 402 330 406 341 b 334 395 389 379 370 395 b 236 350 292 395 259 374 b 215 330 222 336 220 330 b 203 360 207 330 212 340 b 147 393 194 379 174 393 b -19 251 71 393 26 331 b -29 223 -26 238 -29 230 b -13 207 -29 213 -22 207 b 9 226 -3 207 1 215 b 107 338 52 300 81 338 b 122 321 118 338 122 331 b 114 285 122 310 118 295 l 9 24 b 4 9 6 17 4 13 b 20 0 4 3 9 0 l 91 0 b 114 17 104 0 108 3 l 207 251 b 287 323 225 292 255 323 b 308 302 304 323 308 314 b 294 249 308 285 302 269 b 203 24 294 248 292 248 b 199 9 200 17 199 13 b 215 0 199 3 203 0 l 285 0 b 308 17 298 0 302 3 l 402 251 b 481 323 419 292 449 323 b 503 302 498 323 503 314 b 413 43 503 252 413 104 b 478 -14 413 6 436 -14 b 629 102 533 -14 583 26 b 642 132 638 117 642 125 b 629 145 642 141 636 145 b 608 127 619 145 615 138 b 534 49 580 84 553 49 b 523 62 526 49 523 53 b 606 317 523 112 606 238 b 528 395 606 353 588 395 z"
                },
                dynamicForte: {
                    x_min: -141,
                    x_max: 364,
                    y_min: -152,
                    y_max: 444,
                    ha: 596,
                    o: "m 23 380 b 0 357 7 380 0 373 b 22 336 0 343 7 336 l 105 336 b 117 330 114 336 117 336 b 114 315 117 327 115 323 l 23 0 b -101 -187 -17 -141 -43 -187 b -127 -174 -120 -187 -127 -181 b -92 -156 -127 -163 -114 -170 b -63 -102 -75 -144 -63 -125 b -128 -43 -63 -65 -89 -43 b -203 -122 -171 -43 -203 -78 b -95 -219 -203 -186 -156 -219 b 161 17 14 -219 82 -145 b 269 317 203 105 235 194 l 271 318 b 289 336 271 323 282 336 l 383 336 b 406 359 399 336 406 343 b 384 380 406 373 399 380 l 298 380 b 284 387 288 380 284 380 b 287 405 284 392 285 396 b 419 606 315 530 347 606 b 442 595 431 606 442 603 b 419 580 442 586 435 588 b 389 526 400 572 389 552 b 454 465 389 485 418 465 b 524 543 491 465 524 490 b 400 639 524 596 491 639 b 135 402 261 639 183 540 b 107 380 128 380 127 380 z"
                },
                dynamicRinforzando: {
                    x_min: -20,
                    x_max: 277,
                    y_min: 0,
                    y_max: 274,
                    ha: 274,
                    o: "m 324 395 b 235 350 287 395 256 374 b 215 330 222 336 220 330 b 203 360 207 330 213 337 b 145 393 194 379 174 393 b -19 251 75 393 27 337 b -29 223 -26 238 -29 230 b -13 207 -29 213 -22 207 b 9 226 -3 207 3 215 b 107 338 52 301 81 338 b 122 321 118 338 122 331 b 114 285 122 310 118 295 l 9 24 b 4 9 6 17 4 13 b 20 0 4 3 9 0 l 91 0 b 114 17 104 0 108 3 l 207 251 b 304 351 226 298 272 351 b 318 343 312 351 318 348 b 287 285 318 330 287 325 b 338 239 287 256 308 239 b 399 318 373 239 399 268 b 324 395 399 360 377 395 z"
                },
                dynamicSforzando: {
                    x_min: 0,
                    x_max: 229,
                    y_min: -10,
                    y_max: 273,
                    ha: 283,
                    o: "m 212 393 b 68 274 127 393 68 350 b 145 161 68 223 95 196 b 200 85 187 132 200 114 b 127 20 200 53 173 20 b 66 42 91 20 66 32 b 91 56 66 49 75 46 b 111 98 104 65 111 79 b 59 145 111 127 86 145 b 0 78 24 145 0 117 b 125 -14 0 30 49 -14 b 291 120 219 -14 291 36 b 220 232 291 160 276 190 b 151 314 168 271 151 287 b 213 361 151 337 168 361 b 258 346 238 361 258 356 b 240 333 258 340 251 340 b 226 298 232 325 226 314 b 276 252 226 269 248 252 b 330 307 311 252 330 279 b 212 393 330 360 285 393 z"
                },
                dynamicZ: {
                    x_min: -30,
                    x_max: 244,
                    y_min: -10,
                    y_max: 268,
                    ha: 278,
                    o: "m 333 386 b 298 377 321 386 314 382 b 239 370 282 373 259 370 b 94 383 153 370 111 383 b 68 364 79 383 72 377 l 33 264 b 29 242 30 255 29 248 b 45 228 29 232 36 228 b 66 249 55 228 60 236 l 81 279 b 96 297 85 288 88 297 b 168 292 102 297 127 292 b 223 302 194 292 215 302 b 196 269 229 302 197 271 l -26 45 b -43 16 -37 33 -43 27 b -24 -1 -43 6 -36 -1 b 4 16 -12 -1 -3 10 b 39 30 16 24 27 30 b 179 -14 79 30 108 -14 b 297 102 259 -14 297 43 b 245 166 297 147 271 166 b 197 115 219 166 197 145 b 236 72 197 88 216 72 b 259 79 251 72 255 79 b 264 75 262 79 264 78 b 258 60 264 72 261 66 b 229 45 252 50 242 45 b 117 95 186 45 173 95 b 85 86 98 95 89 86 b 102 111 85 86 95 104 l 333 338 b 351 370 344 350 351 359 b 333 386 351 380 343 386 z"
                },
                ornamentTrill: {
                    x_min: 0,
                    x_max: 521,
                    y_min: -10,
                    y_max: 390,
                    ha: 400,
                    o: "m 383 562 b 364 557 377 562 369 559 l 294 534 b 269 511 281 530 275 526 l 217 384 b 206 367 212 370 210 367 b 179 380 200 367 192 374 b 118 393 158 389 140 393 b 0 292 50 393 0 353 b 95 210 0 248 30 210 b 140 213 112 210 131 213 b 144 209 143 213 144 212 b 140 194 144 206 143 202 l 124 156 b 96 58 108 117 96 88 b 179 -14 96 17 124 -14 b 325 153 253 -14 325 46 b 307 251 325 187 320 219 b 302 265 304 258 302 261 b 334 294 302 274 311 281 l 343 298 b 455 348 393 328 428 348 b 474 327 468 348 474 344 b 465 285 474 312 469 295 l 360 24 b 356 9 357 17 356 13 b 372 0 356 3 360 0 l 442 0 b 465 17 455 0 459 3 l 559 251 b 655 351 577 298 624 351 b 670 343 664 351 670 348 b 638 285 670 330 638 325 b 690 239 638 256 660 239 b 750 318 724 239 750 268 b 675 395 750 360 729 395 b 586 350 638 395 608 374 b 566 330 573 336 572 330 b 553 361 559 330 564 340 b 490 393 543 380 521 393 b 347 348 432 393 377 364 b 312 333 328 338 320 333 b 308 337 310 333 308 334 b 315 359 308 343 312 351 l 387 537 b 392 553 390 544 392 549 b 383 562 392 559 389 562 z m 118 360 b 192 325 134 360 192 347 b 186 307 192 321 189 314 l 180 292 b 148 265 173 274 167 269 b 98 258 130 261 112 258 b 39 301 50 258 39 281 b 118 360 39 327 60 360 z m 272 240 b 292 151 285 240 292 164 b 212 30 292 88 253 30 b 196 48 200 30 196 37 b 207 92 196 59 202 78 b 264 230 207 94 209 94 b 272 240 266 238 268 240 z"
                },
                ornamentTurn: {
                    x_min: 0,
                    x_max: 460,
                    y_min: 0,
                    y_max: 218,
                    ha: 218,
                    o: "m 534 314 b 454 251 490 314 454 294 b 505 199 454 219 475 199 b 579 232 547 199 549 232 b 626 164 603 232 626 202 b 533 72 626 102 583 72 b 377 180 487 72 439 111 b 150 312 307 258 243 312 b 0 148 55 312 0 240 b 128 0 0 45 66 0 b 209 63 173 0 209 20 b 157 115 209 95 187 115 b 84 82 115 115 114 82 b 36 150 59 82 36 112 b 130 242 36 212 79 242 b 285 134 176 242 223 203 b 513 1 356 56 419 1 b 662 166 608 1 662 73 b 534 314 662 269 596 314 z"
                },
                ornamentTurnSlash: {
                    x_min: 0,
                    x_max: 460,
                    y_min: -90,
                    y_max: 306,
                    ha: 396,
                    o: "m 333 441 b 310 418 315 441 310 433 l 310 274 b 302 252 310 258 308 252 b 261 278 294 252 287 262 b 150 311 228 298 192 311 b 0 147 55 311 0 239 b 128 -1 0 43 66 -1 b 209 62 173 -1 209 19 b 157 114 209 94 187 114 b 84 81 115 114 114 81 b 36 148 59 81 36 111 b 130 240 36 210 79 240 b 285 128 176 240 222 197 b 307 79 304 108 307 105 l 307 -107 b 330 -130 307 -122 312 -130 b 353 -107 347 -130 353 -122 l 353 37 b 360 59 353 53 353 59 b 402 33 369 59 376 49 b 513 0 435 13 471 0 b 662 164 608 0 662 72 b 534 312 662 268 596 312 b 454 249 490 312 454 292 b 505 197 454 217 475 197 b 579 230 547 197 549 230 b 626 163 603 230 626 200 b 533 71 626 101 583 71 b 377 183 487 71 441 114 b 356 232 359 203 356 206 l 356 418 b 333 441 356 433 350 441 z"
                },
                ornamentMordent: {
                    x_min: 1,
                    x_max: 729,
                    y_min: -73,
                    y_max: 319,
                    ha: 392,
                    o: "m 546 265 l 546 459 l 501 459 l 501 216 l 459 167 b 439 167 454 160 445 160 b 302 327 387 228 310 317 b 258 353 291 338 282 351 b 226 340 245 353 238 348 l 20 107 b 1 73 12 98 1 84 b 30 59 1 65 9 59 b 88 94 53 59 73 79 b 144 143 107 109 124 127 b 176 161 158 154 168 161 b 197 144 183 161 189 156 l 323 10 b 351 0 328 3 340 0 b 377 9 361 0 372 3 b 498 114 392 17 475 94 l 498 -105 l 544 -105 l 544 153 b 562 160 550 157 556 160 b 585 144 569 160 576 156 b 710 10 590 135 697 24 b 737 0 716 3 727 0 b 765 9 749 0 759 3 b 1030 295 776 17 1011 274 l 1032 300 b 1050 328 1041 308 1050 318 b 1012 353 1050 343 1024 353 b 986 343 1002 353 994 348 b 854 190 971 330 871 206 b 828 176 842 180 835 176 b 802 190 818 176 809 183 b 681 333 791 202 696 320 b 645 353 668 344 657 353 b 613 340 634 353 626 350 b 580 304 600 330 590 315 z"
                },
                ornamentShortTrill: {
                    x_min: 0,
                    x_max: 725,
                    y_min: 0,
                    y_max: 245,
                    ha: 245,
                    o: "m 429 167 l 301 325 b 256 353 291 338 282 350 b 225 340 246 353 238 350 b 16 105 158 268 88 186 b 0 72 9 96 0 86 b 29 58 0 63 7 58 b 71 76 42 58 55 62 l 158 154 b 174 160 163 158 168 160 b 197 143 181 160 187 154 b 321 10 203 135 310 24 b 350 0 327 3 338 0 b 377 7 361 0 372 3 l 533 148 b 554 160 543 158 550 160 b 577 143 562 160 566 156 b 703 10 585 135 690 24 b 732 0 708 3 720 0 b 759 7 743 0 753 3 b 1024 294 769 16 1005 272 b 1044 327 1032 305 1044 321 b 1005 353 1044 341 1018 353 b 979 343 996 353 988 348 b 848 189 963 330 864 204 b 821 174 837 179 828 174 b 796 189 811 174 804 181 b 674 331 783 202 688 318 b 641 351 662 343 651 351 b 606 340 628 351 619 350 b 573 304 593 328 583 315 b 444 167 533 259 491 213 b 429 167 439 161 433 161 z"
                },
                ornamentTremblement: {
                    x_min: 1,
                    x_max: 985,
                    y_min: 0,
                    y_max: 244,
                    ha: 244,
                    o: "m 678 325 b 634 351 667 338 657 350 b 602 338 621 351 613 348 l 448 167 b 439 167 446 164 441 164 l 302 325 b 258 351 291 338 281 350 b 228 338 245 351 238 348 b 193 304 215 328 204 315 l 19 107 b 1 72 13 96 1 76 b 30 58 1 63 9 58 b 89 92 52 58 73 78 l 144 141 b 148 144 145 143 147 143 b 176 160 160 153 170 160 b 199 143 183 160 189 154 b 324 10 204 134 311 23 b 351 0 330 3 340 0 b 379 7 363 0 373 3 l 530 148 b 552 160 536 154 546 160 b 575 143 559 160 564 154 b 698 10 580 134 687 23 b 727 0 704 3 716 0 b 755 7 739 0 749 3 l 907 147 b 930 160 922 158 923 160 b 952 143 937 160 943 154 l 1077 10 b 1107 0 1084 3 1096 0 b 1133 7 1117 0 1128 3 b 1398 294 1143 16 1380 272 b 1418 327 1407 305 1418 321 b 1381 351 1418 343 1394 351 b 1354 341 1371 351 1362 348 b 1223 189 1338 328 1238 204 b 1195 174 1211 179 1202 174 b 1171 189 1185 174 1178 181 b 1048 331 1158 200 1063 318 b 1012 351 1035 343 1024 351 b 981 338 1002 351 994 350 b 948 304 968 328 958 315 b 827 166 907 258 865 212 b 815 166 824 163 818 163 b 678 325 760 226 732 264 z"
                },
                ornamentPrecompAppoggTrill: {
                    x_min: 0,
                    x_max: 1119,
                    y_min: 0,
                    y_max: 481,
                    ha: 481,
                    o: "m 1015 163 b 873 328 963 223 880 318 b 828 354 860 344 847 353 b 796 341 816 354 809 351 b 763 305 783 331 773 317 b 642 168 721 261 681 215 b 636 163 641 167 639 164 b 494 328 585 223 501 318 b 449 354 481 344 468 353 b 418 341 438 354 431 351 b 384 305 405 331 395 317 b 264 168 343 261 302 215 l 242 144 b 144 88 232 124 171 88 b 79 197 81 88 79 189 l 79 648 b 60 693 79 683 71 693 b 52 691 58 693 55 693 b 0 616 3 672 0 625 l 0 207 b 121 0 0 40 68 0 b 249 68 168 0 232 53 b 279 94 262 75 271 86 b 336 144 298 111 315 128 b 367 163 350 156 360 163 b 389 145 374 163 380 157 b 514 12 395 137 501 26 b 543 1 520 4 531 1 b 569 9 553 1 563 4 b 636 73 576 14 605 43 l 658 94 b 714 144 677 111 694 128 b 746 163 729 156 739 163 b 768 145 753 163 759 157 b 893 12 773 137 880 26 b 922 1 899 4 910 1 b 948 9 932 1 942 4 l 1012 71 b 1037 94 1022 78 1030 86 b 1092 144 1054 111 1073 128 b 1123 161 1106 156 1115 161 b 1146 145 1130 161 1136 157 b 1270 12 1152 137 1259 26 b 1299 1 1276 4 1287 1 b 1326 9 1310 1 1320 4 b 1591 297 1336 19 1572 275 b 1611 328 1600 307 1611 320 b 1574 354 1611 343 1585 354 b 1548 344 1565 354 1555 350 b 1416 192 1532 331 1431 206 b 1388 177 1404 181 1395 177 b 1365 190 1380 177 1371 184 b 1243 333 1352 203 1256 321 b 1205 354 1228 346 1217 354 b 1174 341 1195 354 1187 351 b 1140 305 1161 330 1152 317 z"
                },
                ornamentPrecompSlideTrillDAnglebert: {
                    x_min: 2,
                    x_max: 1150,
                    y_min: -367,
                    y_max: 245,
                    ha: 612,
                    o: "m 1058 160 b 916 327 1007 220 923 317 b 871 353 903 343 890 351 b 840 340 860 353 852 350 b 806 304 827 330 816 315 b 685 167 765 259 724 213 l 680 160 l 615 235 b 419 344 582 275 523 344 b 3 -144 258 344 3 26 b 4 -168 3 -153 3 -160 b 246 -482 24 -315 99 -422 b 458 -528 340 -521 410 -528 b 514 -526 485 -528 504 -526 b 552 -508 531 -526 552 -517 b 514 -497 552 -503 541 -498 l 503 -497 b 194 -390 432 -494 298 -488 b 69 -151 194 -390 69 -279 b 184 96 69 -60 128 27 b 328 183 202 118 258 183 b 477 96 413 183 454 118 b 559 10 510 62 552 19 b 588 0 566 3 576 0 b 613 7 598 0 609 3 b 723 112 622 14 681 73 b 789 161 733 122 776 161 b 811 144 796 161 802 156 b 936 10 816 135 923 24 b 965 0 942 3 953 0 b 991 7 975 0 985 3 b 1051 66 996 12 1022 37 b 1081 92 1063 73 1073 84 b 1136 143 1099 109 1117 127 b 1168 160 1151 154 1159 160 b 1191 144 1175 160 1181 156 b 1315 10 1197 135 1303 24 b 1344 0 1320 3 1332 0 b 1371 7 1355 0 1365 3 b 1636 295 1381 17 1617 274 b 1656 327 1644 305 1656 318 b 1619 353 1656 341 1630 353 b 1593 343 1610 353 1600 348 b 1460 190 1577 330 1476 204 b 1433 176 1449 180 1440 176 b 1410 189 1424 176 1416 183 b 1287 331 1397 202 1300 320 b 1250 353 1273 344 1261 353 b 1218 340 1240 353 1231 350 b 1185 304 1205 328 1197 315 z"
                },
                ornamentPrecompSlideTrillBach: {
                    x_min: 0,
                    x_max: 1048,
                    y_min: -367,
                    y_max: 331,
                    ha: 698,
                    o: "m 1038 477 l 979 477 l 979 238 l 912 160 b 769 327 858 220 775 317 b 724 353 756 343 743 351 b 693 340 713 353 706 350 b 660 304 680 330 670 315 b 539 167 618 259 577 213 b 533 161 536 166 534 163 b 390 327 480 220 396 317 b 346 353 377 343 364 351 l 340 353 b 308 340 330 353 321 350 b 275 304 295 330 285 315 b 117 122 220 243 168 186 b 0 -144 68 62 0 -48 b 1 -168 0 -153 0 -160 b 243 -482 22 -315 96 -422 b 455 -528 337 -521 408 -528 b 511 -526 482 -528 501 -526 b 549 -508 528 -526 549 -517 b 511 -497 549 -503 539 -498 l 500 -497 b 192 -390 429 -494 295 -488 b 68 -177 192 -390 84 -298 b 66 -151 66 -168 66 -160 b 189 105 66 -58 127 35 b 232 143 203 118 216 131 b 264 161 246 154 256 161 b 285 144 271 161 276 156 b 410 10 291 135 397 24 b 439 0 416 3 428 0 b 465 7 449 0 459 3 l 531 72 b 554 92 540 78 547 86 b 611 143 573 109 590 127 b 642 161 625 154 635 161 b 664 144 649 161 655 156 b 789 10 670 135 776 24 b 818 0 795 3 806 0 b 844 7 828 0 838 3 b 904 66 850 12 876 37 b 935 92 916 73 924 84 b 979 134 949 107 963 121 l 979 -88 l 1037 -88 l 1037 151 l 1044 144 b 1168 10 1050 135 1156 24 b 1197 0 1174 3 1185 0 b 1224 7 1208 0 1218 3 b 1489 295 1234 17 1470 274 b 1509 327 1498 305 1509 318 b 1472 353 1509 341 1483 353 b 1446 343 1463 353 1453 348 b 1313 190 1430 330 1329 204 b 1286 176 1302 180 1293 176 b 1263 189 1277 176 1269 183 b 1140 331 1250 202 1153 320 b 1103 353 1126 344 1115 353 b 1071 340 1093 353 1084 350 b 1038 304 1058 328 1050 315 z"
                },
                ornamentPrecompTrillSuffixDandrieu: {
                    x_min: 0,
                    x_max: 949,
                    y_min: 0,
                    y_max: 381,
                    ha: 381,
                    o: "m 1367 314 b 1250 521 1367 419 1318 482 b 1107 549 1211 537 1145 549 b 1083 546 1096 549 1087 549 b 1066 528 1071 540 1066 534 b 1079 520 1066 524 1070 520 b 1323 351 1187 517 1323 487 b 1201 171 1323 269 1260 219 b 1194 166 1201 171 1198 168 b 1056 327 1142 226 1063 317 b 1011 353 1043 343 1030 351 b 979 340 999 353 992 350 b 946 304 966 330 956 315 b 825 167 904 259 864 213 l 821 161 b 678 327 768 222 685 317 b 634 353 665 343 652 351 b 602 340 622 353 615 350 b 569 304 589 330 579 315 b 448 167 527 259 487 213 l 444 161 b 301 327 390 222 308 317 b 256 353 288 343 275 351 b 225 340 245 353 238 350 b 192 304 212 330 202 315 b 71 167 150 259 109 213 b 17 105 52 147 36 127 b 0 73 10 98 0 84 b 29 58 0 65 7 58 b 86 92 56 59 72 79 b 143 143 105 109 122 127 b 174 161 157 154 167 161 b 196 144 181 161 187 156 b 321 10 202 135 308 24 b 350 0 327 3 338 0 b 376 7 360 0 370 3 b 485 112 384 14 444 73 b 552 161 495 122 539 161 b 573 144 559 161 564 156 b 698 10 579 135 685 24 b 727 0 704 3 716 0 b 753 7 737 0 747 3 b 863 112 762 14 821 73 b 929 161 873 122 916 161 b 950 144 936 161 942 156 b 1076 10 956 135 1063 24 b 1104 0 1081 3 1093 0 b 1130 7 1115 0 1125 3 b 1236 108 1139 14 1195 69 b 1367 314 1297 160 1367 233 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefix: {
                    x_min: 0,
                    x_max: 1278,
                    y_min: 0,
                    y_max: 247,
                    ha: 247,
                    o: "m 1801 356 b 1776 346 1793 356 1783 351 b 1642 192 1760 333 1659 206 b 1614 177 1630 181 1621 177 b 1591 190 1606 177 1597 184 b 1469 334 1578 203 1482 323 b 1430 356 1453 347 1441 356 b 1398 343 1420 356 1411 353 b 1365 307 1385 331 1377 318 l 1240 164 b 1097 330 1187 226 1104 320 b 1053 356 1084 346 1071 354 b 1021 343 1041 356 1034 353 b 988 307 1008 333 998 318 b 865 168 946 262 904 216 l 861 163 b 717 330 808 223 724 320 b 672 356 704 346 691 354 b 641 343 661 356 654 353 b 608 307 628 333 618 318 b 485 168 566 262 524 216 l 455 134 b 284 46 409 88 351 46 b 16 285 148 46 32 265 b 3 295 9 292 4 295 b 0 291 1 295 0 292 b 1 285 0 288 1 285 b 308 0 42 190 157 0 b 530 120 415 1 482 63 b 559 144 539 128 549 137 b 590 163 573 156 583 163 b 612 145 598 163 603 157 b 739 10 618 137 724 24 b 768 0 744 3 756 0 b 793 7 778 0 788 3 b 903 114 802 14 861 75 l 939 144 b 971 163 953 156 963 163 b 992 145 978 163 984 157 b 1119 10 998 137 1106 24 b 1148 0 1125 3 1136 0 b 1174 7 1158 0 1168 3 b 1284 114 1182 14 1241 75 b 1316 144 1282 115 1312 141 b 1348 161 1331 156 1339 161 b 1371 145 1355 161 1361 157 b 1496 10 1377 137 1485 24 b 1525 0 1502 3 1513 0 b 1552 7 1536 0 1547 3 b 1819 298 1562 17 1800 276 b 1840 330 1829 308 1840 320 b 1832 344 1840 334 1837 340 b 1801 356 1820 351 1810 356 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefixTurn: {
                    x_min: 0,
                    x_max: 1277,
                    y_min: -62,
                    y_max: 333,
                    ha: 395,
                    o: "m 1273 202 l 1273 480 l 1230 480 l 1230 174 l 1097 328 b 1053 354 1084 344 1071 353 b 1021 341 1041 354 1034 351 b 988 305 1008 331 998 317 b 865 167 945 261 904 215 l 861 161 b 717 328 808 222 724 318 b 672 354 704 344 691 353 b 641 341 661 354 654 351 b 608 305 628 331 618 317 b 485 167 564 261 524 215 b 455 132 474 156 465 144 b 284 45 410 88 350 45 b 14 284 148 45 30 264 b 3 294 9 291 4 294 b 0 289 1 294 0 291 b 1 284 0 287 1 284 b 308 -1 42 189 157 -1 b 530 118 415 0 481 62 b 557 143 539 127 547 135 b 590 161 572 154 582 161 b 612 144 598 161 603 156 b 737 9 618 135 724 24 b 768 -1 743 1 755 -1 b 793 6 778 -1 788 1 b 903 112 802 13 861 73 l 937 143 b 971 161 953 154 963 161 b 992 144 978 161 984 156 b 1117 9 998 135 1104 24 b 1148 -1 1123 1 1136 -1 b 1174 6 1158 -1 1168 1 l 1230 60 l 1230 -89 l 1273 -89 l 1273 102 l 1283 112 b 1348 160 1295 125 1332 160 b 1371 144 1355 160 1361 156 b 1496 9 1377 135 1483 24 b 1525 -1 1502 1 1513 -1 b 1552 6 1536 -1 1547 1 b 1819 297 1562 16 1800 275 b 1839 328 1827 307 1839 320 b 1801 354 1839 343 1813 354 b 1776 344 1793 354 1783 350 b 1642 190 1760 331 1657 206 b 1614 176 1630 180 1621 176 b 1591 189 1606 176 1597 183 b 1467 333 1578 203 1480 321 b 1430 354 1453 346 1441 354 b 1398 341 1420 354 1411 351 b 1365 305 1385 330 1377 317 z"
                },
                ornamentPrecompTrillLowerSuffix: {
                    x_min: 0,
                    x_max: 859,
                    y_min: -222,
                    y_max: 246,
                    ha: 468,
                    o: "m 1164 217 b 1031 351 1138 259 1063 351 b 1011 337 1020 351 1024 347 b 828 167 952 291 886 217 l 824 164 b 683 328 772 225 690 318 b 638 354 670 344 657 353 b 606 341 626 354 619 351 b 573 305 593 331 583 317 b 451 167 530 261 490 215 l 446 161 b 302 328 393 222 310 318 b 258 354 289 344 276 353 b 226 341 246 354 239 351 b 193 305 213 331 203 317 b 71 167 150 261 109 215 b 17 105 52 147 36 127 b 0 73 10 98 0 84 b 29 58 0 65 7 58 b 86 92 56 59 72 79 b 143 143 105 109 122 127 b 176 161 157 154 168 161 b 197 144 183 161 189 156 b 323 9 203 135 310 23 b 353 -1 328 1 340 -1 b 379 6 363 -1 373 1 b 488 112 387 13 446 73 l 523 143 b 556 161 539 154 549 161 b 577 144 563 161 569 156 b 703 9 583 135 690 23 b 733 -1 708 1 721 -1 b 759 6 743 -1 753 1 b 868 112 768 13 827 73 b 955 183 878 122 943 183 b 1081 107 965 183 1031 153 b 1156 -89 1128 63 1156 6 l 1156 -102 b 948 -297 1156 -204 1048 -297 b 806 -271 904 -297 850 -282 l 792 -266 b 801 -288 792 -268 795 -282 b 948 -320 809 -297 880 -320 b 1237 -50 1092 -320 1237 -199 b 1164 217 1237 75 1218 122 z"
                },
                brassScoop: {
                    x_min: 1,
                    x_max: 320,
                    y_min: -373,
                    y_max: 13,
                    ha: 386,
                    o: "m 35 -537 b 461 -12 194 -518 461 -289 b 438 19 461 13 451 19 b 410 -9 425 19 413 9 b 35 -425 357 -366 92 -403 b 1 -482 13 -433 1 -438 l 1 -505 b 26 -537 1 -526 3 -537 z"
                },
                brassDoitMedium: {
                    x_min: 0,
                    x_max: 489,
                    y_min: -40,
                    y_max: 346,
                    ha: 386,
                    o: "m 33 -58 b 704 468 255 -58 683 186 b 681 498 704 494 693 498 b 654 471 668 498 658 488 b 33 55 550 118 91 76 b 0 -3 12 46 0 42 l 0 -26 b 24 -58 0 -46 1 -58 z"
                },
                brassFallLipShort: {
                    x_min: 1,
                    x_max: 293,
                    y_min: -345,
                    y_max: 42,
                    ha: 387,
                    o: "m 22 60 b 1 35 4 60 1 52 l 1 6 b 26 -50 3 -40 10 -43 b 32 -52 27 -50 30 -50 b 376 -469 85 -73 327 -111 b 400 -497 379 -487 387 -497 b 422 -467 412 -497 422 -491 b 32 60 422 -187 177 40 z"
                },
                brassLiftMedium: {
                    x_min: 0,
                    x_max: 811,
                    y_min: 0,
                    y_max: 852,
                    ha: 852,
                    o: "m 1138 1220 b 1135 1225 1135 1223 1135 1224 b 1129 1227 1133 1227 1130 1227 b 1117 1207 1122 1227 1117 1212 l 1117 1201 b 1109 1164 1117 1187 1117 1172 b 1100 1156 1107 1161 1104 1158 b 959 1104 1058 1128 995 1140 b 929 1032 936 1081 929 1056 b 932 1007 929 1024 930 1015 b 923 976 932 995 930 985 l 914 971 b 773 919 873 942 809 955 b 743 847 750 896 743 870 b 746 821 743 838 744 829 b 737 791 746 809 744 799 l 729 783 b 588 733 687 756 624 769 b 557 661 564 710 557 684 b 560 635 557 652 559 644 b 552 605 560 624 559 612 l 543 598 b 402 547 501 570 438 583 b 372 475 379 524 372 498 b 374 449 372 467 373 458 b 366 419 374 438 373 426 l 357 412 b 216 361 315 384 252 397 b 186 289 193 338 186 312 b 189 264 186 281 187 272 b 180 233 189 252 187 240 b 171 226 177 232 174 229 b 30 176 130 199 66 212 b 0 104 7 153 0 128 b 33 0 0 88 14 0 b 49 17 40 0 49 10 b 71 63 52 35 56 49 b 212 115 102 95 154 59 b 239 186 230 134 239 160 b 236 210 239 194 238 202 b 256 249 239 225 243 236 b 397 301 288 281 340 245 b 425 372 416 320 425 346 b 422 396 425 380 423 387 b 442 435 425 410 429 422 b 583 487 474 467 526 431 b 611 557 602 505 611 531 b 608 582 611 566 609 573 b 628 621 611 596 615 608 b 769 672 660 652 711 618 b 796 743 788 691 796 717 b 793 768 796 752 795 759 b 814 806 796 782 801 793 b 955 858 845 838 897 804 b 982 929 973 877 982 903 b 979 953 982 937 981 945 b 999 992 982 968 986 979 b 1140 1045 1031 1024 1083 989 b 1168 1116 1161 1066 1168 1090 b 1138 1220 1168 1162 1145 1207 z"
                },
                brassFallRoughMedium: {
                    x_min: 0,
                    x_max: 811,
                    y_min: 0,
                    y_max: 852,
                    ha: 852,
                    o: "m 30 1220 b 0 1116 23 1207 0 1162 b 27 1045 0 1090 7 1066 b 168 992 85 989 137 1024 b 189 953 181 979 186 968 b 186 929 187 945 186 937 b 213 858 186 903 194 877 b 354 806 271 804 323 838 b 374 768 367 793 372 782 b 372 743 373 759 372 752 b 399 672 372 717 380 691 b 540 621 456 618 508 652 b 560 582 553 608 557 596 b 557 557 559 573 557 566 b 585 487 557 531 566 505 b 726 435 642 431 694 467 b 746 396 739 422 743 410 b 743 372 744 387 743 380 b 770 301 743 346 752 320 b 912 249 828 245 880 281 b 932 210 924 236 929 225 b 929 186 930 202 929 194 b 956 115 929 160 937 134 b 1097 63 1014 59 1066 95 b 1119 17 1112 49 1116 35 b 1135 0 1119 10 1128 0 b 1168 104 1153 0 1168 91 b 1138 176 1168 128 1161 153 b 996 226 1102 212 1038 199 b 988 233 994 229 991 232 b 979 264 981 240 979 252 b 982 289 981 272 982 281 b 952 361 982 312 975 338 b 811 412 916 397 852 384 l 802 419 b 793 449 795 426 793 438 b 796 475 795 458 796 467 b 766 547 796 498 789 524 b 625 598 730 583 667 570 l 616 605 b 608 635 609 612 608 624 b 611 661 609 644 611 652 b 580 733 611 684 603 710 b 439 783 544 769 481 756 l 431 791 b 422 821 423 799 422 809 b 425 847 423 829 425 838 b 395 919 425 870 418 896 b 253 971 359 955 295 942 l 245 976 b 236 1007 238 985 236 995 b 239 1032 238 1015 239 1024 b 209 1104 239 1056 232 1081 b 68 1156 173 1140 109 1128 b 59 1164 63 1158 60 1161 b 50 1201 50 1172 50 1187 l 50 1207 b 39 1227 50 1212 46 1227 b 33 1225 37 1227 35 1227 b 30 1220 33 1224 33 1223 z"
                },
                brassBend: {
                    x_min: 0,
                    x_max: 392,
                    y_min: 0,
                    y_max: 282,
                    ha: 282,
                    o: "m 282 0 b 552 72 369 0 456 23 b 564 92 560 75 564 84 l 564 383 b 541 406 564 395 554 406 b 518 383 528 406 518 395 l 518 107 b 282 46 435 65 357 46 b 46 107 207 46 130 65 l 46 383 b 23 406 46 395 36 406 b 0 383 10 406 0 395 l 0 92 b 13 72 0 84 4 75 b 282 0 108 23 196 0 z"
                },
                brassMuteClosed: {
                    x_min: 0,
                    x_max: 272,
                    y_min: 0,
                    y_max: 272,
                    ha: 272,
                    o: "m 392 219 l 219 219 l 219 392 l 173 392 l 173 219 l 0 219 l 0 173 l 173 173 l 173 0 l 219 0 l 219 173 l 392 173 z"
                },
                brassMuteOpen: {
                    x_min: 0,
                    x_max: 304,
                    y_min: 0,
                    y_max: 304,
                    ha: 304,
                    o: "m 219 0 b 438 219 340 0 438 98 b 219 438 438 340 340 438 b 0 219 98 438 0 340 b 219 0 0 98 98 0 z m 219 392 b 392 219 314 392 392 314 b 219 46 392 124 314 46 b 46 219 124 46 46 124 b 219 392 46 314 124 392 z"
                },
                brassFlip: {
                    x_min: 0,
                    x_max: 379,
                    y_min: 0,
                    y_max: 282,
                    ha: 282,
                    o: "m 523 0 b 541 9 530 0 536 3 b 546 22 544 13 546 17 b 536 42 546 29 541 36 l 36 402 b 23 406 33 405 27 406 b 0 383 12 406 0 395 l 0 23 b 23 0 0 10 10 0 b 46 23 36 0 46 10 l 46 337 l 508 4 b 523 0 513 1 517 0 z"
                },
                brassJazzTurn: {
                    x_min: 0,
                    x_max: 620,
                    y_min: 0,
                    y_max: 245,
                    ha: 245,
                    o: "m 792 190 b 765 176 780 179 772 176 b 740 190 755 176 747 183 b 629 325 727 202 644 312 b 593 347 616 338 605 347 b 562 334 583 346 575 344 b 528 298 549 323 539 310 l 406 176 b 389 168 406 176 399 168 b 374 176 384 168 379 170 b 245 325 360 192 245 325 b 200 353 232 343 219 351 b 168 340 190 353 181 350 l 17 156 b 0 121 10 147 0 132 b 16 107 0 114 4 108 b 84 143 26 107 76 137 b 118 160 92 150 108 160 b 141 143 125 160 131 154 b 265 10 147 135 253 24 b 294 0 271 3 282 0 b 321 7 305 0 315 3 b 498 160 321 7 478 158 b 521 143 505 160 513 154 b 647 10 528 135 635 24 b 675 0 652 3 664 0 b 703 7 687 0 697 3 b 874 186 713 16 855 164 b 893 220 881 196 893 212 b 873 245 890 235 883 243 b 796 194 847 245 815 213 z"
                },
                brassSmear: {
                    x_min: 1,
                    x_max: 306,
                    y_min: 0,
                    y_max: 170,
                    ha: 170,
                    o: "m 193 79 b 308 0 219 50 264 0 b 439 117 396 0 438 102 b 439 120 439 118 439 118 l 441 125 b 441 128 441 127 441 127 b 433 141 441 135 439 141 b 416 130 429 141 423 137 b 343 94 390 107 370 94 b 269 153 315 94 294 121 l 265 158 b 144 245 239 190 180 245 b 6 134 62 245 10 143 b 1 114 3 125 1 118 b 7 107 1 108 4 107 b 36 122 13 107 22 112 b 92 151 55 137 65 151 b 183 89 125 151 161 112 b 189 84 184 88 187 86 z"
                },
                stringsDownBow: {
                    x_min: 0,
                    x_max: 312,
                    y_min: 0,
                    y_max: 318,
                    ha: 318,
                    o: "m 37 458 b 0 420 17 458 0 441 l 0 17 b 17 0 0 7 9 0 l 37 0 b 55 17 46 0 55 7 l 55 253 b 225 278 55 269 140 278 b 395 253 310 278 395 269 l 395 17 b 413 0 395 7 403 0 l 432 0 b 449 17 441 0 449 7 l 449 420 b 412 458 449 441 432 458 z"
                },
                stringsUpBow: {
                    x_min: 1,
                    x_max: 249,
                    y_min: 1,
                    y_max: 495,
                    ha: 494,
                    o: "m 181 1 b 206 22 193 1 203 10 l 359 683 l 359 688 b 338 713 359 700 351 710 l 333 713 b 308 694 321 713 311 706 l 180 140 l 53 694 b 27 713 49 706 39 713 l 22 713 b 1 690 10 710 1 700 b 3 683 1 687 1 685 l 154 22 b 181 1 157 10 167 1 z"
                },
                stringsHarmonic: {
                    x_min: 0,
                    x_max: 200,
                    y_min: 0,
                    y_max: 200,
                    ha: 200,
                    o: "m 288 144 b 144 288 288 225 223 288 b 0 144 65 288 0 225 b 144 0 0 65 65 0 b 288 144 223 0 288 65 z m 144 249 b 249 144 203 249 249 203 b 144 39 249 86 203 39 b 39 144 86 39 39 86 b 144 249 39 203 86 249 z"
                },
                pluckedSnapPizzicatoAbove: {
                    x_min: 0,
                    x_max: 200,
                    y_min: 0,
                    y_max: 300,
                    ha: 300,
                    o: "m 0 144 b 144 0 0 63 65 0 b 288 144 223 0 288 63 b 167 285 288 215 235 275 l 167 432 l 121 432 l 121 285 b 0 144 52 275 0 215 z m 121 246 l 121 144 l 167 144 l 167 246 b 249 144 213 236 249 193 b 144 39 249 85 202 39 b 39 144 85 39 39 85 b 121 246 39 193 73 236 z"
                },
                pluckedSnapPizzicatoBelow: {
                    x_min: 0,
                    x_max: 200,
                    y_min: 0,
                    y_max: 300,
                    ha: 300,
                    o: "m 288 288 b 144 432 288 369 223 432 b 0 288 65 432 0 369 b 121 145 0 216 52 157 l 121 0 l 167 0 l 167 145 b 288 288 235 157 288 216 z m 167 186 l 167 288 l 121 288 l 121 186 b 39 288 75 196 39 238 b 144 393 39 347 86 393 b 249 288 203 393 249 347 b 167 186 249 238 215 196 z"
                },
                pluckedLeftHandPizzicato: {
                    x_min: 0,
                    x_max: 272,
                    y_min: 0,
                    y_max: 272,
                    ha: 272,
                    o: "m 392 219 l 219 219 l 219 392 l 173 392 l 173 219 l 0 219 l 0 173 l 173 173 l 173 0 l 219 0 l 219 173 l 392 173 z"
                },
                keyboardPedalPed: {
                    x_min: 0,
                    x_max: 1019,
                    y_min: -8,
                    y_max: 555,
                    ha: 563,
                    o: "m 413 799 b 179 749 327 798 261 789 b 0 517 107 713 0 632 b 122 376 0 454 37 376 b 240 540 189 376 240 452 b 225 586 240 579 233 586 b 204 549 213 586 212 573 b 138 480 199 527 181 480 b 85 549 96 480 85 517 l 85 554 b 353 762 89 690 230 762 b 373 752 364 762 373 760 b 351 708 373 740 360 723 b 274 546 330 675 274 585 b 353 416 274 508 333 444 b 412 304 372 390 412 351 b 382 228 412 275 403 256 b 334 190 363 202 361 200 b 147 29 271 167 147 88 b 196 -12 147 4 171 -12 b 343 108 239 -12 279 33 l 363 132 b 387 150 370 141 376 150 b 543 -4 445 150 467 -4 b 631 42 567 -4 586 0 l 668 78 b 685 89 674 84 680 89 b 696 75 688 89 690 86 b 809 -9 717 29 753 -9 b 946 66 854 -9 894 13 b 988 107 971 92 981 107 b 1002 89 994 107 996 99 b 1152 -4 1030 36 1077 -4 b 1329 248 1238 -4 1329 82 b 792 717 1329 556 1047 665 b 766 720 785 719 775 720 b 747 703 752 720 747 711 b 780 680 747 693 756 685 b 1223 222 1028 621 1223 504 b 1152 39 1223 122 1205 39 b 1073 229 1104 39 1073 132 b 1132 423 1073 314 1086 377 b 1142 442 1140 432 1142 436 b 1126 458 1142 451 1136 458 b 1093 446 1119 458 1109 455 b 975 216 1022 408 975 337 l 975 190 b 943 121 975 160 972 150 b 852 69 899 76 877 69 b 776 148 816 69 786 117 b 773 163 775 154 773 158 b 786 177 773 167 776 170 l 801 187 b 937 366 867 235 937 284 b 844 454 937 422 900 454 b 665 217 711 454 665 331 b 671 153 665 197 667 176 l 671 147 b 662 134 671 143 670 140 b 605 111 639 118 625 111 b 521 160 572 111 546 135 b 451 203 497 184 474 197 b 426 212 435 207 426 206 b 436 230 426 216 429 220 b 510 389 464 269 510 340 b 429 521 510 435 480 462 b 369 629 387 570 369 599 b 402 720 369 648 384 691 b 462 763 425 759 446 763 b 611 624 540 763 611 704 b 564 575 611 592 590 575 b 501 602 540 575 520 582 b 474 622 492 611 487 622 b 459 603 465 622 459 615 b 603 471 459 570 510 471 b 711 588 670 471 711 524 b 422 799 711 742 554 799 z m 815 403 b 848 343 838 403 848 383 b 780 226 848 295 824 261 b 765 217 773 220 768 217 b 759 228 762 217 759 220 b 756 282 757 245 756 262 b 815 403 756 346 772 403 z m 1405 124 b 1344 62 1369 124 1344 98 b 1405 0 1344 26 1369 0 b 1467 62 1441 0 1467 26 b 1405 124 1467 98 1441 124 z"
                },
                keyboardPedalUp: {
                    x_min: 0,
                    x_max: 450,
                    y_min: 0,
                    y_max: 450,
                    ha: 450,
                    o: "m 582 396 b 516 367 554 396 533 384 b 465 340 495 347 487 340 l 458 340 b 412 377 432 340 412 348 b 432 409 412 387 419 396 l 438 415 b 490 429 451 428 464 429 b 575 501 534 429 575 452 b 501 575 575 541 541 575 b 429 490 452 575 429 534 b 415 438 429 464 428 451 l 409 432 b 377 412 396 419 387 412 b 340 458 348 412 340 432 l 340 465 b 367 516 340 487 347 495 b 396 582 384 533 396 554 b 324 648 396 625 363 648 b 252 582 285 648 252 625 b 281 516 252 554 264 533 b 308 465 301 495 308 487 l 308 458 b 271 412 308 432 300 412 b 239 432 261 412 252 419 l 233 438 b 219 490 220 451 219 464 b 147 575 219 534 196 575 b 73 501 107 575 73 541 b 158 429 73 452 114 429 b 210 415 184 429 197 428 l 216 409 b 236 377 229 396 236 387 b 190 340 236 348 216 340 l 183 340 b 132 367 161 340 153 347 b 66 396 115 384 94 396 b 0 324 23 396 0 363 b 66 252 0 285 23 252 b 132 281 94 252 115 264 b 183 308 153 301 161 308 l 190 308 b 236 271 216 308 236 300 b 216 239 236 261 229 252 l 210 233 b 158 219 197 220 184 219 b 73 147 114 219 73 196 b 147 73 73 107 107 73 b 219 158 196 73 219 114 b 233 210 219 184 220 197 l 239 216 b 271 236 252 229 261 236 b 308 190 300 236 308 216 l 308 183 b 281 132 308 161 301 153 b 252 66 264 115 252 94 b 324 0 252 23 285 0 b 396 66 363 0 396 23 b 367 132 396 94 384 115 b 340 183 347 153 340 161 l 340 190 b 377 236 340 216 348 236 b 409 216 387 236 396 229 l 415 210 b 429 158 428 197 429 184 b 501 73 429 114 452 73 b 575 147 541 73 575 107 b 490 219 575 196 534 219 b 438 233 464 219 451 220 l 432 239 b 412 271 419 252 412 261 b 458 308 412 300 432 308 l 465 308 b 516 281 487 308 495 301 b 582 252 533 264 554 252 b 648 324 625 252 648 285 b 582 396 648 363 625 396 z m 324 271 b 271 324 291 271 271 291 b 324 377 271 357 291 377 b 377 324 357 377 377 357 b 324 271 377 291 357 271 z"
                },
                pictChokeCymbal: {
                    x_min: 1,
                    x_max: 152,
                    y_min: 2,
                    y_max: 251,
                    ha: 249,
                    o: "m 104 361 b 1 271 42 361 1 321 b 82 190 1 222 35 190 b 122 160 118 190 122 160 b 125 144 124 154 125 150 b 102 88 125 124 115 105 b 37 32 78 56 40 35 b 26 17 32 29 26 26 l 27 16 b 37 3 29 6 33 3 b 181 102 85 3 158 66 b 219 239 210 147 219 197 l 219 249 b 104 361 219 317 170 361 z"
                },
                wiggleArpeggiatoUp: {
                    x_min: -33,
                    x_max: 292,
                    y_min: 0,
                    y_max: 119,
                    ha: 119,
                    o: "m 130 171 b -39 68 16 171 -14 91 b -48 53 -45 62 -48 58 b -29 42 -48 46 -39 42 b -10 46 -23 42 -16 43 b 56 63 12 56 29 63 b 248 0 121 63 135 0 b 419 127 361 0 410 104 b 420 132 420 130 420 131 b 412 140 420 137 416 140 b 386 130 403 140 392 134 b 334 107 367 117 353 107 b 318 108 330 107 324 107 b 240 138 289 112 265 128 b 130 171 209 153 168 171 z"
                },
                arrowheadBlackUp: {
                    x_min: 0,
                    x_max: 228,
                    y_min: 0,
                    y_max: 299,
                    ha: 299,
                    o: "m 166 431 b 0 20 111 274 0 30 b 16 0 0 12 6 0 l 17 1 b 166 50 43 16 160 50 b 310 1 171 50 289 13 l 311 0 b 328 20 321 0 328 12 b 166 431 328 30 220 274 z"
                },
                arrowheadBlackDown: {
                    x_min: 0,
                    x_max: 228,
                    y_min: 0,
                    y_max: 299,
                    ha: 299,
                    o: "m 166 0 b 328 410 220 157 328 400 b 311 431 328 419 321 431 l 310 429 b 166 380 289 418 171 380 b 17 429 160 380 43 415 l 16 431 b 0 410 6 431 0 419 b 166 0 0 400 111 157 z"
                },
                arpeggiatoUp: {
                    x_min: 1,
                    x_max: 229,
                    y_min: 7,
                    y_max: 1511,
                    ha: 1504,
                    o: "m 219 1848 l 330 1848 l 164 2176 l 1 1848 l 121 1848 b 92 1778 115 1822 101 1800 l 89 1773 b 59 1668 75 1741 59 1702 b 96 1555 59 1614 76 1580 b 99 1551 98 1554 99 1551 l 102 1547 b 124 1496 115 1531 124 1515 b 122 1482 124 1492 124 1488 b 92 1404 118 1453 102 1428 b 59 1293 78 1372 59 1332 b 105 1172 59 1234 81 1198 b 124 1120 118 1155 124 1143 l 122 1113 b 122 1110 122 1113 122 1112 b 92 1032 118 1081 102 1057 b 59 922 78 1001 59 960 b 115 792 59 855 86 816 b 124 760 121 782 124 773 b 122 744 124 756 124 750 b 92 667 118 716 102 693 b 59 556 78 635 59 595 b 108 433 59 495 82 458 b 124 389 117 420 124 408 b 122 374 124 384 124 379 b 92 298 118 346 102 323 l 89 292 b 59 186 75 261 59 222 b 163 19 59 73 140 42 b 177 10 168 13 173 10 b 189 29 184 10 189 19 b 184 48 189 35 187 42 b 167 114 174 69 167 85 b 230 305 167 179 229 193 b 181 423 230 357 209 396 b 167 484 173 442 167 458 b 230 675 167 547 229 563 b 179 796 230 729 206 769 b 167 850 171 812 167 827 b 230 1040 167 913 229 929 b 183 1158 230 1092 209 1130 b 167 1220 173 1178 167 1194 b 230 1411 167 1284 229 1300 b 186 1526 230 1462 210 1499 b 167 1594 176 1529 167 1584 b 230 1786 167 1659 229 1673 b 219 1848 230 1809 226 1829 z"
                },
                arpeggiatoDown: {
                    x_min: 1,
                    x_max: 229,
                    y_min: -4,
                    y_max: 1500,
                    ha: 1504,
                    o: "m 219 323 b 230 384 226 341 230 361 b 167 576 229 497 167 511 b 186 644 167 586 176 641 b 230 759 210 671 230 708 b 167 950 229 870 167 886 b 183 1012 167 976 173 992 b 230 1130 209 1040 230 1079 b 167 1320 229 1241 167 1257 b 179 1374 167 1344 171 1358 b 230 1495 206 1401 230 1441 b 167 1686 229 1607 167 1623 b 181 1747 167 1712 173 1728 b 230 1865 209 1774 230 1813 b 167 2056 229 1977 167 1992 b 184 2123 167 2085 174 2101 b 189 2141 187 2128 189 2136 b 177 2160 189 2151 184 2160 b 163 2151 173 2160 168 2157 b 59 1984 140 2128 59 2097 b 89 1878 59 1948 75 1909 l 92 1872 b 122 1796 102 1848 118 1824 b 124 1781 124 1791 124 1786 b 108 1737 124 1763 117 1750 b 59 1614 82 1712 59 1675 b 92 1503 59 1575 78 1535 b 122 1426 102 1477 118 1454 b 124 1410 124 1420 124 1414 b 115 1378 124 1397 121 1388 b 59 1248 86 1354 59 1315 b 92 1138 59 1210 78 1169 b 122 1060 102 1113 118 1089 b 122 1057 122 1058 122 1058 l 124 1050 b 105 998 124 1027 118 1015 b 59 877 81 972 59 936 b 92 766 59 838 78 798 b 122 688 102 742 118 717 b 124 674 124 683 124 678 b 102 624 124 655 115 639 l 99 619 b 96 615 99 619 98 616 b 59 503 76 590 59 556 b 89 397 59 468 75 429 l 92 392 b 121 323 101 370 115 348 l 1 323 l 164 -6 l 330 323 z"
                },
                repeat1Bar: {
                    x_min: 0,
                    x_max: 532,
                    y_min: -250,
                    y_max: 279,
                    ha: 529,
                    o: "m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z m 89 288 b 0 197 40 288 0 248 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 z m 675 -71 b 586 -161 626 -71 586 -111 b 675 -251 586 -210 626 -251 b 766 -161 726 -251 766 -210 b 675 -71 766 -111 726 -71 z"
                },
                repeat2Bars: {
                    x_min: 0,
                    x_max: 762,
                    y_min: -250,
                    y_max: 279,
                    ha: 529,
                    o: "m 1090 380 b 1097 395 1094 386 1097 390 b 1089 402 1097 399 1094 402 l 936 402 b 910 380 927 402 920 393 l 336 -340 b 331 -350 333 -343 331 -347 b 343 -360 331 -356 336 -360 l 485 -360 b 516 -340 498 -360 508 -348 z m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z m 89 288 b 0 197 40 288 0 248 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 z m 1007 -71 b 917 -161 958 -71 917 -111 b 1007 -251 917 -210 958 -251 b 1097 -161 1057 -251 1097 -210 b 1007 -71 1097 -111 1057 -71 z"
                },
                repeat4Bars: {
                    x_min: 0,
                    x_max: 1232,
                    y_min: -250,
                    y_max: 279,
                    ha: 529,
                    o: "m 1767 380 b 1774 395 1771 386 1774 390 b 1765 402 1774 399 1771 402 l 1613 402 b 1587 380 1604 402 1597 393 l 1012 -340 b 1008 -350 1009 -343 1008 -347 b 1020 -360 1008 -356 1012 -360 l 1162 -360 b 1192 -340 1175 -360 1185 -348 z m 1436 380 b 1443 395 1440 386 1443 390 b 1434 402 1443 399 1440 402 l 1282 402 b 1256 380 1273 402 1266 393 l 681 -340 b 677 -350 678 -343 677 -347 b 688 -360 677 -356 681 -360 l 831 -360 b 861 -340 844 -360 854 -348 z m 1090 380 b 1097 395 1094 386 1097 390 b 1089 402 1097 399 1094 402 l 936 402 b 910 380 927 402 920 393 l 336 -340 b 331 -350 333 -343 331 -347 b 343 -360 331 -356 336 -360 l 485 -360 b 516 -340 498 -360 508 -348 z m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z m 89 288 b 0 197 40 288 0 248 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 z m 1683 -71 b 1594 -161 1634 -71 1594 -111 b 1683 -251 1594 -210 1634 -251 b 1774 -161 1734 -251 1774 -210 b 1683 -71 1774 -111 1734 -71 z"
                },
                repeatBarSlash: {
                    x_min: 0,
                    x_max: 532,
                    y_min: -250,
                    y_max: 279,
                    ha: 529,
                    o: "m 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 z"
                },
                csymDiminished: {
                    x_min: 0,
                    x_max: 473,
                    y_min: 0,
                    y_max: 473,
                    ha: 473,
                    o: "m 341 681 b 0 341 153 681 0 530 b 341 0 0 153 153 0 b 681 341 530 0 681 153 b 341 681 681 530 530 681 z m 341 618 b 618 341 495 618 618 495 b 341 63 618 189 494 63 b 63 341 187 63 63 187 b 341 618 63 494 189 618 z"
                },
                csymHalfDiminished: {
                    x_min: -16,
                    x_max: 488,
                    y_min: -15,
                    y_max: 489,
                    ha: 504,
                    o: "m 703 660 l 658 704 l 557 603 b 340 681 498 652 422 681 b -1 341 151 681 -1 530 b 78 124 -1 259 29 183 l -23 23 l 22 -22 l 122 79 b 340 0 181 30 258 0 b 680 341 528 0 680 153 b 602 559 680 423 651 500 z m 62 341 b 340 618 62 494 187 618 b 513 559 403 618 464 598 l 122 168 b 62 341 84 217 62 278 z m 616 341 b 340 63 616 189 492 63 b 167 124 276 63 216 85 l 557 514 b 616 341 596 465 616 405 z"
                },
                csymAugmented: {
                    x_min: 0,
                    x_max: 395,
                    y_min: 1,
                    y_max: 396,
                    ha: 395,
                    o: "m 569 318 l 317 318 l 317 570 l 253 570 l 253 318 l 0 318 l 0 255 l 253 255 l 253 1 l 317 1 l 317 255 l 569 255 z"
                },
                csymMajorSeventh: {
                    x_min: 0,
                    x_max: 558,
                    y_min: 1,
                    y_max: 477,
                    ha: 476,
                    o: "m 402 687 l 0 1 l 804 1 z m 402 562 l 693 65 l 111 65 z"
                },
                csymMinor: {
                    x_min: 0,
                    x_max: 325,
                    y_min: 216,
                    y_max: 260,
                    ha: 44,
                    o: "m 468 374 l 0 374 l 0 311 l 468 311 z"
                },
                csymParensLeftTall: {
                    x_min: 1,
                    x_max: 185,
                    y_min: 0,
                    y_max: 997,
                    ha: 997,
                    o: "m 266 48 b 261 65 266 55 264 62 b 92 719 157 212 92 400 b 262 1371 92 1037 154 1228 b 266 1394 266 1378 266 1394 l 266 1424 b 264 1436 266 1431 266 1436 b 259 1434 262 1436 259 1434 b 1 719 84 1261 1 1011 b 259 1 1 429 79 177 b 264 0 261 0 262 0 b 266 9 265 0 266 6 z"
                },
                csymParensRightTall: {
                    x_min: -20,
                    x_max: 164,
                    y_min: 0,
                    y_max: 997,
                    ha: 997,
                    o: "m -29 9 b -26 0 -29 6 -27 0 b -22 1 -24 0 -23 0 b 236 719 158 177 236 429 b -22 1434 236 1011 154 1261 b -26 1436 -22 1434 -24 1436 b -29 1424 -29 1436 -29 1431 l -29 1394 b -24 1371 -29 1394 -29 1378 b 145 719 84 1228 145 1037 b -23 65 145 400 81 212 b -29 48 -26 62 -29 55 z"
                },
                csymBracketLeftTall: {
                    x_min: 0,
                    x_max: 155,
                    y_min: 0,
                    y_max: 1e3,
                    ha: 1e3,
                    o: "m 217 0 b 223 9 220 0 223 4 l 223 37 b 217 46 223 42 220 46 l 92 46 l 92 1394 l 217 1394 b 223 1403 220 1394 223 1398 l 223 1431 b 217 1440 223 1436 220 1440 l 6 1440 b 0 1436 3 1440 0 1439 l 0 4 b 6 0 0 1 3 0 z"
                },
                csymBracketRightTall: {
                    x_min: 1,
                    x_max: 156,
                    y_min: 0,
                    y_max: 1e3,
                    ha: 1e3,
                    o: "m 219 0 b 225 4 222 0 225 1 l 225 1436 b 219 1440 225 1439 222 1440 l 7 1440 b 1 1431 4 1440 1 1436 l 1 1403 b 7 1394 1 1398 4 1394 l 132 1394 l 132 46 l 7 46 b 1 37 4 46 1 42 l 1 9 b 7 0 1 4 4 0 z"
                },
                csymParensLeftVeryTall: {
                    x_min: 0,
                    x_max: 122,
                    y_min: 0,
                    y_max: 993,
                    ha: 993,
                    o: "m 176 32 b 171 49 176 39 174 46 b 60 716 104 194 60 399 b 173 1382 60 1032 101 1241 b 176 1405 176 1390 176 1405 l 176 1427 b 173 1430 176 1428 174 1430 b 0 716 40 1297 0 978 b 170 3 0 428 50 179 b 171 0 170 1 170 0 b 176 6 173 0 176 4 z"
                },
                csymParensRightVeryTall: {
                    x_min: -15,
                    x_max: 107,
                    y_min: 0,
                    y_max: 993,
                    ha: 993,
                    o: "m -22 6 b -17 0 -22 4 -19 0 b -16 3 -16 0 -16 1 b 154 716 104 179 154 428 b -19 1430 154 978 114 1297 b -22 1427 -20 1430 -22 1428 l -22 1405 b -19 1382 -22 1405 -22 1390 b 94 716 53 1241 94 1032 b -17 49 94 399 50 194 b -22 32 -20 46 -22 39 z"
                },
                csymDiagonalArrangementSlash: {
                    x_min: 0,
                    x_max: 999,
                    y_min: 0,
                    y_max: 1e3,
                    ha: 1e3,
                    o: "m 1439 1380 l 1377 1440 l 0 60 l 62 0 z"
                },
                accSagittal5v7KleismaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -35 b 135 -112 68 -86 99 -112 b 225 68 194 -112 225 -53 l 180 68 b 144 -4 180 20 168 -4 b 122 0 138 -4 131 -3 b 23 248 86 14 52 96 l 0 248 z"
                },
                accSagittal5v7KleismaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 b 122 0 52 -96 86 -14 b 144 4 131 3 138 4 b 180 -68 168 4 180 -20 l 225 -68 b 135 112 225 53 194 112 b 45 35 99 112 68 86 l 45 517 l 0 517 z"
                },
                accSagittal5CommaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 225 -517 l 225 248 l 203 248 l 0 -112 l 0 -284 l 180 33 l 180 -517 z"
                },
                accSagittal5CommaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 180 517 l 180 -33 l 0 284 l 0 112 l 203 -248 l 225 -248 l 225 517 z"
                },
                accSagittal7CommaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 248 l 0 -517 l 45 -517 l 45 112 l 89 112 b 180 -68 150 112 180 53 l 180 -248 l 225 -248 l 225 68 b 135 248 225 187 194 248 z"
                },
                accSagittal7CommaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 135 -248 b 225 -68 194 -248 225 -187 l 225 248 l 180 248 l 180 68 b 89 -112 180 -53 150 -112 l 45 -112 l 45 517 l 0 517 l 0 -248 z"
                },
                accSagittal25SmallDiesisUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -157 l 0 -259 l 315 -89 l 315 -517 l 360 -517 l 360 248 l 337 248 l 0 68 l 0 -33 l 315 135 l 315 10 z"
                },
                accSagittal25SmallDiesisDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 315 -10 l 315 -135 l 0 33 l 0 -68 l 337 -248 l 360 -248 l 360 517 l 315 517 l 315 89 l 0 259 l 0 157 z"
                },
                accSagittal35MediumDiesisUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -68 330 112 360 53 l 360 -248 l 405 -248 l 405 68 b 315 248 405 187 374 248 l 203 248 l 0 -112 z"
                },
                accSagittal35MediumDiesisDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 203 -248 l 315 -248 b 405 -68 374 -248 405 -187 l 405 248 l 360 248 l 360 68 b 271 -112 360 -53 330 -112 l 225 -112 l 225 517 l 180 517 l 180 -33 l 0 284 z"
                },
                accSagittal11MediumDiesisUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 225 53 l 225 -517 l 271 -517 l 271 53 l 495 -248 l 495 -89 l 248 248 l 0 -89 l 0 -248 z"
                },
                accSagittal11MediumDiesisDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 248 l 0 89 l 248 -248 l 495 89 l 495 248 l 271 -53 l 271 517 l 225 517 l 225 -53 z"
                },
                accSagittal11LargeDiesisUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 112 l 315 112 b 449 -68 405 112 449 53 l 449 -248 l 495 -248 l 495 68 b 360 248 495 187 449 248 l 135 248 b 0 68 45 248 0 187 z"
                },
                accSagittal11LargeDiesisDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 135 -248 0 -187 45 -248 l 360 -248 b 495 -68 449 -248 495 -187 l 495 248 l 449 248 l 449 68 b 315 -112 449 -53 405 -112 l 271 -112 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittal35LargeDiesisUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 135 -248 0 -187 45 -248 l 248 -248 l 540 112 l 540 274 l 271 -58 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittal35LargeDiesisDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 135 -248 0 -187 45 -248 l 248 -248 l 540 112 l 540 274 l 269 -58 l 269 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittalSharp25SDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 112 -112 0 -53 36 -112 l 135 -112 l 135 -517 l 180 -517 l 180 -89 b 248 26 206 -65 229 -27 b 315 -89 264 -27 287 -65 l 315 -517 l 360 -517 l 360 -112 l 383 -112 b 495 68 458 -112 495 -53 l 449 68 b 399 -4 449 20 433 -4 b 248 248 297 -4 261 171 b 122 0 216 96 176 14 b 94 -4 112 -3 102 -4 b 45 68 60 -4 45 20 z"
                },
                accSagittalFlat25SUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 94 4 45 -20 60 4 b 122 0 102 4 112 3 b 248 -248 176 -14 216 -96 b 399 4 261 -171 297 4 b 449 -68 433 4 449 -20 l 495 -68 b 383 112 495 53 458 112 l 360 112 l 360 517 l 315 517 l 315 89 b 248 -26 287 65 264 27 b 180 89 229 27 206 65 l 180 517 l 135 517 l 135 112 l 112 112 b 0 -68 36 112 0 53 z"
                },
                accSagittalSharp7CDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 112 l 89 112 b 180 104 124 112 154 109 l 180 -517 l 225 -517 l 225 89 b 315 -68 285 60 315 9 l 315 -248 l 360 -248 l 360 68 b 135 248 360 187 285 248 l 0 248 z"
                },
                accSagittalFlat7CUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 135 -248 b 360 -68 285 -248 360 -187 l 360 248 l 315 248 l 315 68 b 225 -89 315 -9 285 -60 l 225 517 l 180 517 l 180 -104 b 89 -112 154 -109 124 -112 l 45 -112 l 45 517 l 0 517 z"
                },
                accSagittalSharp5CDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -517 l 45 71 l 180 -56 l 180 -517 l 225 -517 l 225 -98 l 405 -268 l 405 -112 l 23 248 l 0 248 l 0 -517 z"
                },
                accSagittalFlat5CUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 517 l 0 -248 l 23 -248 l 405 112 l 405 268 l 225 98 l 225 517 l 180 517 l 180 56 l 45 -71 l 45 517 z"
                },
                accSagittalSharp5v7kDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -276 l 135 -82 l 135 -517 l 180 -517 l 180 -17 l 271 112 l 315 112 l 315 -517 l 360 -517 l 360 107 b 449 -68 420 89 449 30 l 449 -248 l 495 -248 l 495 68 b 360 248 495 189 449 248 l 248 248 z"
                },
                accSagittalFlat5v7kUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 248 -248 l 360 -248 b 495 -68 449 -248 495 -189 l 495 248 l 449 248 l 449 68 b 360 -107 449 -30 420 -89 l 360 517 l 315 517 l 315 -112 l 271 -112 l 180 17 l 180 517 l 135 517 l 135 82 l 0 276 l 0 112 z"
                },
                accSagittalSharp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 180 -53 l 180 -517 l 225 -517 l 225 0 l 292 85 l 360 0 l 360 -517 l 405 -517 l 405 -53 l 585 -274 l 585 -112 l 292 248 l 0 -112 l 0 -274 z"
                },
                accSagittalFlat: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 274 l 0 112 l 292 -248 l 585 112 l 585 274 l 405 53 l 405 517 l 360 517 l 360 0 l 292 -85 l 225 0 l 225 517 l 180 517 l 180 53 z"
                },
                accSagittalSharp5v7kUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -361,
                    y_max: 172,
                    ha: 533,
                    o: "m 45 -517 l 45 -10 b 135 -92 68 -48 98 -75 l 135 -520 l 180 -520 l 180 -108 b 248 -115 203 -112 225 -115 b 271 -112 256 -115 264 -115 l 271 -517 l 315 -517 l 315 -107 b 449 68 405 -89 449 -30 l 405 68 b 297 -4 405 19 369 -4 b 23 248 131 -4 56 85 l 0 248 l 0 -517 z"
                },
                accSagittalFlat5v7kDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 361,
                    ha: 533,
                    o: "m 0 517 l 0 -248 l 23 -248 b 297 4 56 -85 131 4 b 405 -68 369 4 405 -19 l 449 -68 b 315 107 449 30 405 89 l 315 517 l 271 517 l 271 112 b 248 115 264 115 256 115 b 180 108 225 115 203 112 l 180 520 l 135 520 l 135 92 b 45 10 98 75 68 48 l 45 517 z"
                },
                accSagittalSharp5CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -266 l 135 -153 l 135 -517 l 180 -517 l 180 -115 l 271 -39 l 271 -517 l 315 -517 l 315 0 l 405 75 l 405 -517 l 449 -517 l 449 248 l 428 248 l 0 -112 z"
                },
                accSagittalFlat5CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 428 -248 l 449 -248 l 449 517 l 405 517 l 405 -75 l 315 0 l 315 517 l 271 517 l 271 39 l 180 115 l 180 517 l 135 517 l 135 153 l 0 266 z"
                },
                accSagittalSharp7CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 112 l 135 112 l 135 -517 l 180 -517 l 180 108 b 271 89 213 105 243 99 l 271 -517 l 315 -517 l 315 73 b 405 -68 374 45 405 -3 l 405 -248 l 449 -248 l 449 68 b 135 248 449 187 346 248 l 0 248 z"
                },
                accSagittalFlat7CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 135 -248 b 449 -68 346 -248 449 -187 l 449 248 l 405 248 l 405 68 b 315 -73 405 3 374 -45 l 315 517 l 271 517 l 271 -89 b 180 -108 243 -99 213 -105 l 180 517 l 135 517 l 135 -112 l 45 -112 l 45 517 l 0 517 z"
                },
                accSagittalSharp25SUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -30 l 495 143 l 495 14 l 0 -157 l 0 -255 l 225 -177 l 225 -517 l 271 -517 l 271 -161 l 360 -130 l 360 -517 l 405 -517 l 405 -115 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 517 248 l 0 68 z"
                },
                accSagittalFlat25SDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 l 517 -248 l 540 -248 l 540 517 l 495 517 l 495 84 l 405 115 l 405 517 l 360 517 l 360 130 l 271 161 l 271 517 l 225 517 l 225 177 l 0 255 l 0 157 l 495 -14 l 495 -143 l 0 30 z"
                },
                accSagittalSharp35MUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -274 l 135 -108 l 135 -517 l 180 -517 l 180 -53 l 271 58 l 271 -517 l 315 -517 l 315 112 l 360 112 b 405 109 376 112 390 112 l 405 -517 l 449 -517 l 449 96 b 540 -68 510 72 540 17 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 z"
                },
                accSagittalFlat35MDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 292 -248 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 449 -96 540 -17 510 -72 l 449 517 l 405 517 l 405 -109 b 360 -112 390 -112 376 -112 l 315 -112 l 315 517 l 271 517 l 271 -58 l 180 53 l 180 517 l 135 517 l 135 108 l 0 274 l 0 112 z"
                },
                accSagittalSharp11MUp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -271 l 180 -79 l 180 -517 l 225 -517 l 225 -30 l 315 65 l 315 -517 l 360 -517 l 360 65 l 449 -30 l 449 -517 l 495 -517 l 495 -79 l 675 -271 l 675 -112 l 337 248 z"
                },
                accSagittalFlat11MDown: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 337 -248 l 675 112 l 675 271 l 495 79 l 495 517 l 449 517 l 449 30 l 360 -65 l 360 517 l 315 517 l 315 -65 l 225 30 l 225 517 l 180 517 l 180 79 l 0 271 l 0 112 z"
                },
                accSagittalSharp11LUp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 112 l 449 112 l 449 -517 l 495 -517 l 495 104 b 631 -68 585 82 631 26 l 631 -248 l 675 -248 l 675 68 b 449 248 675 187 600 248 l 225 248 b 0 68 75 248 0 187 z"
                },
                accSagittalFlat11LDown: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 225 -248 0 -187 75 -248 l 449 -248 b 675 -68 600 -248 675 -187 l 675 248 l 631 248 l 631 68 b 495 -104 631 -26 585 -82 l 495 517 l 449 517 l 449 -112 l 360 -112 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
                },
                accSagittalSharp35LUp: {
                    x_min: 0,
                    x_max: 500,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 71 l 452 -17 l 452 -517 l 495 -517 l 495 -56 l 720 -268 l 720 -112 l 337 248 l 225 248 b 0 68 75 248 0 187 z"
                },
                accSagittalFlat35LDown: {
                    x_min: 0,
                    x_max: 500,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 225 -248 0 -187 75 -248 l 337 -248 l 720 112 l 720 268 l 495 56 l 495 517 l 452 517 l 452 17 l 360 -71 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
                },
                accSagittalDoubleSharp25SDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 135 -112 0 -53 45 -112 b 243 -62 180 -112 215 -95 l 89 -503 l 143 -517 l 292 -82 l 445 -517 l 495 -503 l 343 -62 b 449 -112 372 -95 408 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 315 148 b 112 -4 274 148 236 -4 b 45 68 68 -4 45 20 z"
                },
                accSagittalDoubleFlat25SUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 112 4 45 -20 68 4 b 292 -248 236 4 274 -148 b 475 4 315 -148 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 b 343 62 408 112 372 95 l 495 503 l 445 517 l 292 82 l 143 517 l 89 503 l 243 62 b 135 112 215 95 180 112 b 0 -68 45 112 0 53 z"
                },
                accSagittalDoubleSharp7CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -503 l 52 -517 l 203 -82 l 354 -517 l 405 -503 l 230 0 l 271 108 b 495 -68 420 92 495 35 l 495 -248 l 540 -248 l 540 68 b 225 248 540 187 435 248 l 89 248 l 89 112 l 135 112 l 174 0 z m 213 112 l 203 82 l 192 112 z"
                },
                accSagittalDoubleFlat7CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 174 0 l 135 -112 l 89 -112 l 89 -248 l 225 -248 b 540 -68 435 -248 540 -187 l 540 248 l 495 248 l 495 68 b 271 -108 495 -35 420 -92 l 230 0 l 405 503 l 354 517 l 203 82 l 52 517 l 0 503 z m 192 -112 l 203 -82 l 213 -112 z"
                },
                accSagittalDoubleSharp5CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 405 -503 l 230 0 l 232 4 l 585 -264 l 585 -112 l 112 248 l 89 248 l 89 112 l 151 68 l 174 0 l 0 -503 l 52 -517 l 203 -82 l 354 -517 z"
                },
                accSagittalDoubleFlat5CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 354 517 l 203 82 l 52 517 l 0 503 l 174 0 l 151 -68 l 89 -112 l 89 -248 l 112 -248 l 585 112 l 585 264 l 232 -4 l 230 0 l 405 503 z"
                },
                accSagittalDoubleSharp5v7kDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -274 l 252 35 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 360 112 b 540 -68 480 112 540 53 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 l 0 -112 z"
                },
                accSagittalDoubleFlat5v7kUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 292 -248 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 360 -112 540 -53 480 -112 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 252 -35 l 0 274 z"
                },
                accSagittalDoubleSharp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 540 -503 l 366 0 l 380 45 l 675 -271 l 675 -112 l 337 248 l 0 -112 l 0 -271 l 295 45 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 z"
                },
                accSagittalDoubleFlat: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 488 517 l 337 82 l 186 517 l 135 503 l 310 0 l 295 -45 l 0 271 l 0 112 l 337 -248 l 675 112 l 675 271 l 380 -45 l 366 0 l 540 503 z"
                },
                accSagittal7v11KleismaUp: {
                    x_min: 0,
                    x_max: 219,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 68 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 -45 b 248 -112 200 -89 225 -112 b 315 68 292 -112 315 -53 l 271 68 b 248 -4 271 20 264 -4 b 236 0 245 -4 240 -3 b 157 248 213 14 187 96 b 78 0 127 96 101 14 b 65 -4 73 -3 68 -4 b 45 68 50 -4 45 20 l 0 68 b 68 -112 0 -53 23 -112 z"
                },
                accSagittal7v11KleismaDown: {
                    x_min: 0,
                    x_max: 219,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 68 112 b 0 -68 23 112 0 53 l 45 -68 b 65 4 45 -20 50 4 b 78 0 68 4 73 3 b 157 -248 101 -14 127 -96 b 236 0 187 -96 213 -14 b 248 4 240 3 245 4 b 271 -68 264 4 271 -20 l 315 -68 b 248 112 315 53 292 112 b 180 45 225 112 200 89 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 z"
                },
                accSagittal17CommaUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 -40 b 315 -118 248 -92 279 -118 b 405 62 374 -118 405 -59 l 360 62 b 324 -10 360 14 348 -10 b 302 -6 318 -10 311 -9 b 206 217 268 9 235 84 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
                },
                accSagittal17CommaDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 206 -217 b 302 6 235 -84 268 -9 b 324 10 311 9 318 10 b 360 -62 348 10 360 -14 l 405 -62 b 315 118 405 59 374 118 b 225 40 279 118 248 92 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
                },
                accSagittal55CommaUp: {
                    x_min: 0,
                    x_max: 219,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 248 l 0 -517 l 45 -517 l 45 58 l 315 -274 l 315 -112 l 23 248 z"
                },
                accSagittal55CommaDown: {
                    x_min: 0,
                    x_max: 219,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 23 -248 l 315 112 l 315 274 l 45 -58 l 45 517 l 0 517 l 0 -248 z"
                },
                accSagittal7v11CommaUp: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 248 l 135 248 b 0 68 45 248 0 187 z"
                },
                accSagittal7v11CommaDown: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 135 -248 0 -187 45 -248 l 271 -248 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittal5v11SmallDiesisUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 73 l 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 -40 b 360 -118 295 -92 325 -118 b 449 62 420 -118 449 -59 l 405 62 b 369 -10 405 14 393 -10 b 348 -6 363 -10 356 -9 b 251 217 312 9 279 84 l 248 248 l 135 248 b 0 73 45 248 0 189 z"
                },
                accSagittal5v11SmallDiesisDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -73 b 135 -248 0 -189 45 -248 l 248 -248 l 251 -217 b 348 6 279 -84 312 -9 b 369 10 356 9 363 10 b 405 -62 393 10 405 -14 l 449 -62 b 360 118 449 59 420 118 b 271 40 325 118 295 92 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittalSharp5v11SDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 242 37 203 -23 225 -3 b 315 -89 262 -23 285 -63 l 315 -517 l 360 -517 l 360 -112 l 383 -112 b 495 68 458 -112 495 -53 l 449 68 b 399 -4 449 20 433 -4 b 248 248 297 -4 261 171 b 157 68 222 127 192 68 l 89 68 b 0 -203 30 68 0 -23 z"
                },
                accSagittalFlat5v11SUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 89 -68 0 23 30 -68 l 157 -68 b 248 -248 192 -68 222 -127 b 399 4 261 -171 297 4 b 449 -68 433 4 449 -20 l 495 -68 b 383 112 495 53 458 112 l 360 112 l 360 517 l 315 517 l 315 89 b 242 -37 285 63 262 23 b 180 23 225 3 203 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 84 z"
                },
                accSagittalSharp7v11CDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 89 -112 l 89 -517 l 135 -517 l 135 -95 b 206 37 163 -73 187 -30 b 271 -23 225 -3 248 -23 l 271 -517 l 315 -517 l 315 -23 l 383 -23 b 449 -203 428 -23 449 -84 l 495 -203 b 405 68 495 -23 465 68 l 292 68 b 203 248 258 68 228 127 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 20 l 0 68 b 89 -112 0 -52 30 -112 z"
                },
                accSagittalFlat7v11CUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 112 b 0 -68 30 112 0 52 l 45 -68 b 81 3 45 -20 56 3 b 101 0 86 3 94 0 b 203 -248 138 -16 173 -98 b 292 -68 228 -127 258 -68 l 405 -68 b 495 203 465 -68 495 23 l 449 203 b 383 23 449 84 428 23 l 315 23 l 315 517 l 271 517 l 271 23 b 206 -37 248 23 225 3 b 135 95 187 30 163 73 l 135 517 l 89 517 z"
                },
                accSagittalSharp55CDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -271 l 135 -125 l 135 -517 l 180 -517 l 180 -78 l 315 65 l 315 -517 l 360 -517 l 360 248 l 337 248 l 0 -112 z"
                },
                accSagittalFlat55CUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 337 -248 l 360 -248 l 360 517 l 315 517 l 315 -65 l 180 78 l 180 517 l 135 517 l 135 125 l 0 271 z"
                },
                accSagittalSharp17CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -248 l 45 -68 b 180 109 45 36 89 95 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -89 292 13 321 -55 l 360 -517 l 405 -517 l 405 -112 l 428 -112 b 540 68 504 -112 540 -53 l 495 68 b 445 -4 495 20 480 -4 b 292 248 343 -4 307 171 l 180 248 b 0 68 60 248 0 187 l 0 -248 z"
                },
                accSagittalFlat17CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 248 l 0 -68 b 180 -248 0 -187 60 -248 l 292 -248 b 445 4 307 -171 343 4 b 495 -68 480 4 495 -20 l 540 -68 b 428 112 540 53 504 112 l 405 112 l 405 517 l 360 517 l 360 89 b 271 -112 321 55 292 -13 l 225 -112 l 225 517 l 180 517 l 180 -109 b 45 68 89 -95 45 -36 l 45 248 z"
                },
                accSagittalSharp7v11kDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -32 l 405 138 l 405 13 l 0 -157 l 0 -256 l 225 -161 l 225 -517 l 271 -517 l 271 -144 l 405 -86 l 405 -517 l 449 -517 l 449 248 l 428 248 l 0 68 z"
                },
                accSagittalFlat7v11kUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 l 428 -248 l 449 -248 l 449 517 l 405 517 l 405 86 l 271 144 l 271 517 l 225 517 l 225 161 l 0 256 l 0 157 l 405 -13 l 405 -138 l 0 32 z"
                },
                accSagittalSharp7v11kUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 135 -112 l 135 -517 l 180 -517 l 180 -105 b 271 -23 217 -94 248 -65 l 271 -517 l 315 -517 l 315 -23 b 405 -105 337 -65 369 -94 l 405 -517 l 449 -517 l 449 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 315 148 b 112 -4 274 148 236 -4 b 45 68 68 -4 45 20 l 0 68 b 135 -112 0 -53 45 -112 z"
                },
                accSagittalFlat7v11kDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 135 112 b 0 -68 45 112 0 53 l 45 -68 b 112 4 45 -20 68 4 b 292 -248 236 4 274 -148 b 475 4 315 -148 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 l 449 517 l 405 517 l 405 105 b 315 23 369 94 337 65 l 315 517 l 271 517 l 271 23 b 180 105 248 65 217 94 l 180 517 l 135 517 z"
                },
                accSagittalSharp17CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 -23 b 405 -105 337 -65 369 -94 l 405 -517 l 449 -517 l 449 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 312 150 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalFlat17CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 b 475 4 312 -150 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 l 449 517 l 405 517 l 405 105 b 315 23 369 94 337 65 l 315 517 l 271 517 l 271 -14 b 203 23 251 10 229 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalSharp55CUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -517 l 45 78 l 135 10 l 135 -517 l 180 -517 l 180 -23 l 271 -92 l 271 -517 l 315 -517 l 315 -127 l 495 -264 l 495 -112 l 23 248 l 0 248 l 0 -517 z"
                },
                accSagittalFlat55CDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 517 l 0 -248 l 23 -248 l 495 112 l 495 264 l 315 127 l 315 517 l 271 517 l 271 92 l 180 23 l 180 517 l 135 517 l 135 -10 l 45 -78 l 45 517 z"
                },
                accSagittalSharp7v11CUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 86 45 6 89 58 l 180 -517 l 225 -517 l 225 98 b 315 109 252 104 282 108 l 315 -517 l 360 -517 l 360 112 l 449 112 l 449 -517 l 495 -517 l 495 248 l 360 248 b 0 68 121 248 0 189 z"
                },
                accSagittalFlat7v11CDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 360 -248 0 -189 121 -248 l 495 -248 l 495 517 l 449 517 l 449 -112 l 360 -112 l 360 517 l 315 517 l 315 -109 b 225 -98 282 -108 252 -104 l 225 517 l 180 517 l 180 -86 b 45 68 89 -58 45 -6 l 45 248 l 0 248 z"
                },
                accSagittalSharp5v11SUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 -23 b 449 -105 383 -65 415 -94 l 449 -517 l 495 -517 l 495 -112 b 631 68 585 -112 631 -53 l 585 68 b 520 -4 585 20 563 -4 b 337 248 396 -4 360 150 l 225 248 b 0 68 76 248 0 187 z"
                },
                accSagittalFlat5v11SDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 225 -248 0 -187 76 -248 l 337 -248 b 520 4 360 -150 396 4 b 585 -68 563 4 585 -20 l 631 -68 b 495 112 631 53 585 112 l 495 517 l 449 517 l 449 105 b 360 23 415 94 383 65 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
                },
                accSagittalDoubleSharp5v11SDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 341 -60 b 449 -112 370 -95 405 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 312 150 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalDoubleFlat5v11SUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 b 475 4 312 -150 350 4 b 540 -68 517 4 540 -20 l 585 -68 b 449 112 585 53 540 112 b 341 60 405 112 370 95 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 262 -4 b 203 23 245 13 225 23 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalDoubleSharp7v11CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 112 -112 b 193 -73 143 -112 170 -99 l 45 -501 l 95 -517 l 248 -81 l 397 -517 l 449 -503 l 275 0 l 278 4 b 337 -23 295 -13 315 -23 l 405 -23 b 495 -203 465 -23 495 -84 l 540 -203 b 428 68 540 -23 503 68 l 360 68 b 248 248 310 68 271 127 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 112 -112 0 -52 36 -112 z"
                },
                accSagittalDoubleFlat7v11CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 112 112 b 0 -68 36 112 0 52 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 b 360 -68 271 -127 310 -68 l 428 -68 b 540 203 503 -68 540 23 l 495 203 b 405 23 495 84 465 23 l 337 23 b 278 -4 315 23 295 13 l 275 0 l 449 503 l 397 517 l 248 81 l 95 517 l 45 501 l 193 73 b 112 112 170 99 143 112 z"
                },
                accSagittalDoubleSharp55CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 428 248 l 0 -112 l 0 -266 l 307 -7 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 386 59 l 449 112 l 449 248 z"
                },
                accSagittalDoubleFlat55CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 449 -248 l 449 -112 l 386 -59 l 366 0 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 307 7 l 0 266 l 0 112 l 428 -248 z"
                },
                accSagittalDoubleSharp17CDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -248 l 45 -68 b 271 112 45 53 120 112 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 387 -62 b 495 -112 416 -95 452 -112 b 631 68 585 -112 631 -53 l 585 68 b 520 -4 585 20 563 -4 b 337 248 396 -4 360 150 l 225 248 b 0 68 76 248 0 187 l 0 -248 z"
                },
                accSagittalDoubleFlat17CUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 248 l 0 -68 b 225 -248 0 -187 76 -248 l 337 -248 b 520 4 360 -150 396 4 b 585 -68 563 4 585 -20 l 631 -68 b 495 112 631 53 585 112 b 387 62 452 112 416 95 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 310 0 l 271 -112 b 45 68 120 -112 45 -53 l 45 248 z"
                },
                accSagittalDoubleSharp7v11kDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -30 l 366 96 l 399 0 l 392 -23 l 0 -157 l 0 -255 l 353 -135 l 225 -503 l 276 -517 l 428 -82 l 579 -517 l 631 -503 l 455 0 l 507 145 l 540 157 l 540 248 l 517 248 z m 416 115 l 442 124 l 428 82 z"
                },
                accSagittalDoubleFlat7v11kUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 517 -248 l 540 -248 l 540 -157 l 507 -145 l 455 0 l 631 503 l 579 517 l 428 82 l 276 517 l 225 503 l 353 135 l 0 255 l 0 157 l 392 23 l 399 0 l 366 -96 l 0 30 l 0 -68 z m 428 -82 l 442 -124 l 416 -115 z"
                },
                accSagittal23CommaUp: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -4 b 68 -23 53 -17 60 -23 l 180 -23 b 225 -203 210 -23 225 -82 l 271 -203 b 206 68 271 -23 248 68 l 89 68 b 23 248 71 68 48 127 l 0 248 z"
                },
                accSagittal23CommaDown: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 b 89 -68 48 -127 71 -68 l 206 -68 b 271 203 248 -68 271 23 l 225 203 b 180 23 225 82 210 23 l 68 23 b 45 4 60 23 53 17 l 45 517 l 0 517 z"
                },
                accSagittal5v19CommaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 248 l 203 248 b 86 112 151 157 112 112 b 45 157 59 112 45 127 l 0 157 b 76 23 0 72 26 27 l 0 -112 z"
                },
                accSagittal5v19CommaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 76 -23 b 0 -157 26 -27 0 -72 l 45 -157 b 86 -112 45 -127 59 -112 b 203 -248 112 -112 151 -157 l 225 -248 l 225 517 l 180 517 l 180 -33 l 0 284 z"
                },
                accSagittal5v23SmallDiesisUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 -4 b 248 -23 233 -17 240 -23 l 360 -23 b 405 -203 390 -23 405 -82 l 449 -203 b 386 68 449 -23 428 68 l 271 68 b 203 248 251 68 228 127 l 0 -112 z"
                },
                accSagittal5v23SmallDiesisDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 203 -248 b 271 -68 228 -127 251 -68 l 386 -68 b 449 203 428 -68 449 23 l 405 203 b 360 23 405 82 390 23 l 248 23 b 225 4 240 23 233 17 l 225 517 l 180 517 l 180 -33 l 0 284 z"
                },
                accSagittalSharp5v23SDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 6 b 89 -23 59 -13 73 -23 l 180 -23 l 180 -517 l 225 -517 l 225 -23 l 292 -23 b 360 -203 337 -23 360 -84 l 405 -203 b 315 68 405 -23 374 68 l 112 68 b 23 248 78 68 48 127 l 0 248 z"
                },
                accSagittalFlat5v23SUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 b 112 -68 48 -127 78 -68 l 315 -68 b 405 203 374 -68 405 23 l 360 203 b 292 23 360 84 337 23 l 225 23 l 225 517 l 180 517 l 180 23 l 89 23 b 45 -6 73 23 59 13 l 45 517 l 0 517 z"
                },
                accSagittalSharp5v19CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 89 -112 0 -52 30 -112 l 89 -517 l 135 -517 l 135 -95 b 225 112 173 -65 203 4 l 271 112 l 271 -517 l 315 -517 l 315 107 b 405 -68 374 89 405 30 l 405 -248 l 449 -248 l 449 68 b 315 248 449 189 405 248 l 203 248 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 23 z"
                },
                accSagittalFlat5v19CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 81 3 45 -23 56 3 b 101 0 86 3 94 0 b 203 -248 138 -16 173 -98 l 315 -248 b 449 -68 405 -248 449 -189 l 449 248 l 405 248 l 405 68 b 315 -107 405 -30 374 -89 l 315 517 l 271 517 l 271 -112 l 225 -112 b 135 95 203 -4 173 65 l 135 517 l 89 517 l 89 112 b 0 -68 30 112 0 52 z"
                },
                accSagittalSharp23CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 135 -82 l 135 -517 l 180 -517 l 180 -17 l 239 68 b 315 -23 261 7 287 -23 l 315 -517 l 360 -517 l 360 -23 l 428 -23 b 495 -203 472 -23 495 -84 l 540 -203 b 449 68 540 -23 510 68 l 337 68 b 248 248 302 68 271 127 l 0 -112 l 0 -276 z"
                },
                accSagittalFlat23CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 276 l 0 112 l 248 -248 b 337 -68 271 -127 302 -68 l 449 -68 b 540 203 510 -68 540 23 l 495 203 b 428 23 495 84 472 23 l 360 23 l 360 517 l 315 517 l 315 23 b 239 -68 287 23 261 -7 l 180 17 l 180 517 l 135 517 l 135 82 z"
                },
                accSagittalSharp23CUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 14 b 112 -23 63 -10 86 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 360 -23 b 449 -203 420 -23 449 -84 l 495 -203 b 383 68 495 -23 458 68 l 135 68 b 23 248 85 68 48 127 l 0 248 z"
                },
                accSagittalFlat23CDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 b 135 -68 48 -127 85 -68 l 383 -68 b 495 203 458 -68 495 23 l 449 203 b 360 23 449 84 420 23 l 315 23 l 315 517 l 271 517 l 271 23 l 180 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 -14 86 23 63 10 l 45 517 l 0 517 z"
                },
                accSagittalSharp5v19CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -266 l 135 -153 l 135 -517 l 180 -517 l 180 -115 l 271 -39 l 271 -517 l 315 -517 l 315 0 l 405 75 l 405 -517 l 449 -517 l 449 248 l 428 248 b 130 68 285 127 186 68 b 45 157 73 68 45 98 l 0 157 b 112 -20 0 53 37 -6 z"
                },
                accSagittalFlat5v19CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 112 20 b 0 -157 37 6 0 -53 l 45 -157 b 130 -68 45 -98 73 -68 b 428 -248 186 -68 285 -127 l 449 -248 l 449 517 l 405 517 l 405 -75 l 315 0 l 315 517 l 271 517 l 271 39 l 180 115 l 180 517 l 135 517 l 135 153 l 0 266 l 0 112 z"
                },
                accSagittalSharp5v23SUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 135 -108 l 135 -517 l 180 -517 l 180 -53 l 271 58 l 271 -517 l 315 -517 l 315 14 b 383 -23 334 -10 357 -23 l 405 -23 l 405 -517 l 449 -517 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 405 68 b 292 248 356 68 318 127 l 0 -112 l 0 -274 z"
                },
                accSagittalFlat5v23SDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 274 l 0 112 l 292 -248 b 405 -68 318 -127 356 -68 l 472 -68 b 585 203 547 -68 585 23 l 540 203 b 449 23 540 84 510 23 l 449 517 l 405 517 l 405 23 l 383 23 b 315 -14 357 23 334 10 l 315 517 l 271 517 l 271 -58 l 180 53 l 180 517 l 135 517 l 135 108 z"
                },
                accSagittalDoubleSharp5v23SDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 52 -517 l 203 -81 l 354 -517 l 405 -503 l 239 -23 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 225 68 b 112 248 176 68 138 127 l 89 248 l 89 112 b 170 -14 109 45 135 0 l 0 -501 z"
                },
                accSagittalDoubleFlat5v23SUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 501 l 170 14 b 89 -112 135 0 109 -45 l 89 -248 l 112 -248 b 225 -68 138 -127 176 -68 l 472 -68 b 585 203 547 -68 585 23 l 540 203 b 449 23 540 84 510 23 l 239 23 l 405 503 l 354 517 l 203 81 l 52 517 z"
                },
                accSagittalDoubleSharp5v19CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 112 -112 0 -52 36 -112 b 193 -73 143 -112 170 -99 l 45 -501 l 95 -517 l 248 -81 l 397 -517 l 449 -501 l 275 0 l 315 112 b 495 -68 435 112 495 53 l 495 -248 l 540 -248 l 540 68 b 360 248 540 189 480 248 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 z"
                },
                accSagittalDoubleFlat5v19CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 l 360 -248 b 540 -68 480 -248 540 -189 l 540 248 l 495 248 l 495 68 b 315 -112 495 -53 435 -112 l 275 0 l 449 501 l 397 517 l 248 81 l 95 517 l 45 501 l 193 73 b 112 112 170 99 143 112 b 0 -68 36 112 0 52 z"
                },
                accSagittalDoubleSharp23CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 252 35 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 323 4 b 383 -23 340 -13 360 -23 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 405 68 b 292 248 356 68 318 127 l 0 -112 l 0 -274 z"
                },
                accSagittalDoubleFlat23CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 274 l 0 112 l 292 -248 b 405 -68 318 -127 356 -68 l 472 -68 b 585 203 547 -68 585 23 l 540 203 b 449 23 540 84 510 23 l 383 23 b 323 -4 360 23 340 13 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 252 -35 z"
                },
                accSagittal19SchismaUp: {
                    x_min: 0,
                    x_max: 125,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 68 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 248 l 157 248 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 l 0 68 b 68 -112 0 -52 23 -112 z"
                },
                accSagittal19SchismaDown: {
                    x_min: 0,
                    x_max: 125,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 68 112 b 0 -68 23 112 0 52 l 45 -68 b 68 3 45 -20 52 3 b 79 0 68 3 73 0 b 157 -248 101 -16 127 -98 l 180 -248 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 z"
                },
                accSagittal17KleismaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 248 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
                },
                accSagittal17KleismaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 225 -248 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
                },
                accSagittal143CommaUp: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -203 l 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 248 l 203 248 b 135 68 177 127 154 68 l 105 68 b 45 157 65 68 45 98 l 0 157 b 23 20 0 95 7 50 b 0 -203 7 -23 0 -98 z"
                },
                accSagittal143CommaDown: {
                    x_min: 0,
                    x_max: 156,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 23 -20 0 98 7 23 b 0 -157 7 -50 0 -95 l 45 -157 b 105 -68 45 -98 65 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 225 -248 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
                },
                accSagittal11v49CommaUp: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -292 b 89 -157 45 -203 60 -157 l 203 -157 b 225 -143 210 -157 217 -153 l 225 -517 l 271 -517 l 271 248 l 248 248 b 180 157 233 187 210 157 l 68 157 b 0 -68 23 157 0 82 l 45 -68 b 89 68 45 23 60 68 l 203 68 b 225 84 209 68 216 72 l 225 -36 b 180 -68 213 -58 199 -68 l 68 -68 b 0 -292 23 -68 0 -143 z"
                },
                accSagittal11v49CommaDown: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 292 b 68 68 0 143 23 68 l 180 68 b 225 36 199 68 213 58 l 225 -84 b 203 -68 216 -72 209 -68 l 89 -68 b 45 68 60 -68 45 -23 l 0 68 b 68 -157 0 -82 23 -157 l 180 -157 b 248 -248 210 -157 233 -187 l 271 -248 l 271 517 l 225 517 l 225 143 b 203 157 217 153 210 157 l 89 157 b 45 292 60 157 45 203 z"
                },
                accSagittal19CommaUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 68 -112 0 -52 23 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 -4 b 203 -23 187 -17 196 -23 l 315 -23 b 360 -203 346 -23 360 -82 l 405 -203 b 341 68 405 -23 383 68 l 225 68 b 157 248 206 68 183 127 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 z"
                },
                accSagittal19CommaDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 68 3 45 -20 52 3 b 79 0 68 3 73 0 b 157 -248 101 -16 127 -98 b 225 -68 183 -127 206 -68 l 341 -68 b 405 203 383 -68 405 23 l 360 203 b 315 23 360 82 346 23 l 203 23 b 180 4 196 23 187 17 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 b 0 -68 23 112 0 52 z"
                },
                accSagittal7v19CommaUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 68 -112 0 -52 23 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 112 l 225 112 b 315 -68 285 112 315 53 l 315 -248 l 360 -248 l 360 68 b 271 248 360 187 330 248 l 157 248 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 z"
                },
                accSagittal7v19CommaDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 68 3 45 -20 52 3 b 79 0 68 3 73 0 b 157 -248 101 -16 127 -98 l 271 -248 b 360 -68 330 -248 360 -187 l 360 248 l 315 248 l 315 68 b 225 -112 315 -53 285 -112 l 180 -112 l 180 517 l 135 517 l 135 45 b 68 112 112 89 89 112 b 0 -68 23 112 0 52 z"
                },
                accSagittal49SmallDiesisUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -203 l 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -68 330 112 360 53 l 360 -248 l 405 -248 l 405 68 b 315 248 405 187 374 248 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
                },
                accSagittal49SmallDiesisDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 315 -248 b 405 -68 374 -248 405 -187 l 405 248 l 360 248 l 360 68 b 271 -112 360 -53 330 -112 l 225 -112 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
                },
                accSagittal23SmallDiesisUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 58 l 495 -274 l 495 -112 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z"
                },
                accSagittal23SmallDiesisDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -68 0 23 23 -68 l 135 -68 b 203 -248 154 -68 177 -127 l 495 112 l 495 274 l 225 -58 l 225 517 l 180 517 l 180 4 b 157 23 173 17 164 23 l 89 23 b 45 203 60 23 45 82 z"
                },
                accSagittal5v13MediumDiesisUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -259 l 315 -89 l 315 -517 l 360 -517 l 360 248 l 337 248 b 128 180 253 203 184 180 b 45 248 73 180 45 203 l 0 248 b 52 95 0 170 17 120 l 0 68 l 0 -33 l 315 135 l 315 10 l 0 -157 z"
                },
                accSagittal5v13MediumDiesisDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 157 l 315 -10 l 315 -135 l 0 33 l 0 -68 l 52 -95 b 0 -248 17 -120 0 -170 l 45 -248 b 128 -180 45 -203 73 -180 b 337 -248 184 -180 253 -203 l 360 -248 l 360 517 l 315 517 l 315 89 l 0 259 z"
                },
                accSagittal11v19MediumDiesisUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 -4 b 292 -23 278 -17 285 -23 l 405 -23 b 449 -203 435 -23 449 -82 l 495 -203 b 431 68 495 -23 472 68 l 315 68 b 248 248 295 68 271 127 l 135 248 b 0 68 45 248 0 187 l 0 -248 z"
                },
                accSagittal11v19MediumDiesisDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 248 l 0 -68 b 135 -248 0 -187 45 -248 l 248 -248 b 315 -68 271 -127 295 -68 l 431 -68 b 495 203 472 -68 495 23 l 449 203 b 405 23 449 82 435 23 l 292 23 b 271 4 285 23 278 17 l 271 517 l 225 517 l 225 -112 l 180 -112 b 45 68 89 -112 45 -53 l 45 248 z"
                },
                accSagittal49MediumDiesisUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -68 l 0 -248 l 45 -248 l 315 -94 l 315 -517 l 360 -517 l 360 248 l 225 248 b 0 -68 75 248 0 143 z m 45 -68 b 225 112 45 53 105 112 l 315 112 l 315 10 l 45 -145 z"
                },
                accSagittal49MediumDiesisDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 68 b 225 -248 0 -143 75 -248 l 360 -248 l 360 517 l 315 517 l 315 94 l 45 248 l 0 248 z m 45 145 l 315 -10 l 315 -112 l 225 -112 b 45 68 105 -112 45 -53 z"
                },
                accSagittal5v49MediumDiesisUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -89 l 0 -248 l 225 53 l 225 -517 l 271 -517 l 271 53 l 495 -248 l 495 -89 l 248 248 b 89 89 170 143 118 89 b 45 157 60 89 45 112 l 0 157 b 68 3 0 68 23 16 z"
                },
                accSagittal5v49MediumDiesisDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 68 -3 b 0 -157 23 -16 0 -68 l 45 -157 b 89 -89 45 -112 60 -89 b 248 -248 118 -89 170 -143 l 495 89 l 495 248 l 271 -53 l 271 517 l 225 517 l 225 -53 l 0 248 l 0 89 z"
                },
                accSagittal49LargeDiesisUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -89 l 360 -248 l 405 -248 l 405 -68 b 180 248 405 143 330 248 l 0 248 z m 45 12 l 45 112 l 180 112 b 360 -68 300 112 360 53 l 360 -147 z"
                },
                accSagittal49LargeDiesisDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 180 -248 b 405 68 330 -248 405 -143 l 405 248 l 360 248 l 45 89 l 45 517 l 0 517 z m 360 147 l 360 68 b 180 -112 360 -53 300 -112 l 45 -112 l 45 -12 z"
                },
                accSagittal11v19LargeDiesisUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -86 l 449 -256 l 449 -157 l 45 13 l 45 138 l 449 -30 l 449 68 l 23 248 l 0 248 z"
                },
                accSagittal11v19LargeDiesisDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 l 449 -68 l 449 30 l 45 -138 l 45 -13 l 449 157 l 449 256 l 45 86 l 45 517 l 0 517 z"
                },
                accSagittal5v13LargeDiesisUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 b 89 -112 0 -52 30 -112 b 180 -35 125 -112 157 -86 l 180 -517 l 225 -517 l 225 -86 l 631 -256 l 631 -157 l 225 13 l 225 138 l 631 -30 l 631 68 l 203 248 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 20 z"
                },
                accSagittal5v13LargeDiesisDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -68 b 81 3 45 -20 56 3 b 101 0 86 3 94 0 b 203 -248 138 -16 173 -98 l 631 -68 l 631 30 l 225 -138 l 225 -13 l 631 157 l 631 256 l 225 86 l 225 517 l 180 517 l 180 35 b 89 112 157 86 125 112 b 0 -68 30 112 0 52 z"
                },
                accSagittalSharp23SDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -203 l 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 b 315 6 287 -23 301 -13 l 315 -517 l 360 -517 l 360 248 l 337 248 b 248 68 312 127 282 68 l 194 68 b 89 157 125 68 89 98 l 45 157 b 60 59 45 118 50 85 b 0 -203 20 30 0 -56 z"
                },
                accSagittalFlat23SUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 60 -59 0 56 20 -30 b 45 -157 50 -85 45 -118 l 89 -157 b 194 -68 89 -98 125 -68 l 248 -68 b 337 -248 282 -68 312 -127 l 360 -248 l 360 517 l 315 517 l 315 -6 b 271 23 301 13 287 23 l 180 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 84 z"
                },
                accSagittalSharp49SDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -292 l 45 -292 b 112 -157 45 -203 68 -157 l 135 -157 l 135 -517 l 180 -517 l 180 -157 l 271 -157 b 315 -135 285 -157 300 -150 l 315 -517 l 360 -517 l 360 248 l 337 248 b 248 157 323 187 292 157 l 89 157 b 0 -68 30 157 0 82 l 45 -68 b 112 68 45 23 68 68 l 271 68 b 315 89 284 68 300 75 l 315 -32 b 248 -68 298 -56 275 -68 l 89 -68 b 0 -292 29 -68 0 -143 z"
                },
                accSagittalFlat49SUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 292 b 89 68 0 143 29 68 l 248 68 b 315 32 275 68 298 56 l 315 -89 b 271 -68 300 -75 284 -68 l 112 -68 b 45 68 68 -68 45 -23 l 0 68 b 89 -157 0 -82 30 -157 l 248 -157 b 337 -248 292 -157 323 -187 l 360 -248 l 360 517 l 315 517 l 315 135 b 271 157 300 150 285 157 l 180 157 l 180 517 l 135 517 l 135 157 l 112 157 b 45 292 68 157 45 203 z"
                },
                accSagittalSharp7v19CDown: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -271 l 135 -125 l 135 -517 l 180 -517 l 180 -78 l 315 65 l 315 -517 l 360 -517 l 360 248 l 337 248 b 118 89 239 143 166 89 b 45 157 68 89 45 112 l 0 157 b 89 -20 0 53 29 -6 z"
                },
                accSagittalFlat7v19CUp: {
                    x_min: 0,
                    x_max: 250,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 20 b 0 -157 29 6 0 -53 l 45 -157 b 118 -89 45 -112 68 -89 b 337 -248 166 -89 239 -143 l 360 -248 l 360 517 l 315 517 l 315 -65 l 180 78 l 180 517 l 135 517 l 135 125 l 0 271 l 0 112 z"
                },
                accSagittalSharp19CDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 180 96 45 17 89 72 l 180 -517 l 225 -517 l 225 107 b 315 112 252 112 282 112 l 360 112 l 360 -517 l 405 -517 l 405 248 l 271 248 b 0 68 89 248 0 187 z"
                },
                accSagittalFlat19CUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 271 -248 0 -187 89 -248 l 405 -248 l 405 517 l 360 517 l 360 -112 l 315 -112 b 225 -107 282 -112 252 -112 l 225 517 l 180 517 l 180 -96 b 45 68 89 -72 45 -17 l 45 248 l 0 248 z"
                },
                accSagittalSharp11v49CDown: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 112 -23 45 -82 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 271 112 215 -23 245 23 l 315 112 l 315 -517 l 360 -517 l 360 107 b 449 -68 420 89 449 30 l 449 -248 l 495 -248 l 495 68 b 360 248 495 189 449 248 l 248 248 b 157 68 222 128 192 68 l 89 68 b 0 -203 30 68 0 -23 z"
                },
                accSagittalFlat11v49CUp: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 89 -68 0 23 30 -68 l 157 -68 b 248 -248 192 -68 222 -128 l 360 -248 b 495 -68 449 -248 495 -189 l 495 248 l 449 248 l 449 68 b 360 -107 449 -30 420 -89 l 360 517 l 315 517 l 315 -112 l 271 -112 b 180 23 245 -23 215 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 82 z"
                },
                accSagittalSharp143CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 259 76 210 -23 236 10 l 315 17 l 315 -517 l 360 -517 l 360 -30 l 585 -271 l 585 -112 l 248 248 b 157 68 222 127 192 68 l 89 68 b 0 -203 30 68 0 -23 z"
                },
                accSagittalFlat143CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 89 -68 0 23 30 -68 l 157 -68 b 248 -248 192 -68 222 -127 l 585 112 l 585 271 l 360 30 l 360 517 l 315 517 l 315 -17 l 259 -76 b 180 23 236 -10 210 23 l 180 517 l 135 517 l 135 23 l 112 23 b 45 203 68 23 45 84 z"
                },
                accSagittalSharp17kDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -157 l 0 -256 l 225 -161 l 225 -517 l 271 -517 l 271 -144 l 405 -86 l 405 -517 l 449 -517 l 449 248 l 428 248 b 145 171 305 196 210 171 b 45 248 78 171 45 196 l 0 248 b 79 101 0 170 26 121 l 0 68 l 0 -32 l 405 138 l 405 13 z"
                },
                accSagittalFlat17kUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 405 -13 l 405 -138 l 0 32 l 0 -68 l 79 -101 b 0 -248 26 -121 0 -170 l 45 -248 b 145 -171 45 -196 78 -171 b 428 -248 210 -171 305 -196 l 449 -248 l 449 517 l 405 517 l 405 86 l 271 144 l 271 517 l 225 517 l 225 161 l 0 256 l 0 157 z"
                },
                accSagittalSharp19sDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 180 109 45 36 89 95 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -23 295 23 325 -23 l 360 -517 l 405 -517 l 405 -23 l 472 -23 b 540 -203 517 -23 540 -84 l 585 -203 b 495 68 585 -23 554 68 l 383 68 b 292 248 348 68 318 127 l 180 248 b 0 68 60 248 0 187 z"
                },
                accSagittalFlat19sUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 180 -248 0 -187 60 -248 l 292 -248 b 383 -68 318 -127 348 -68 l 495 -68 b 585 203 554 -68 585 23 l 540 203 b 472 23 540 84 517 23 l 405 23 l 405 517 l 360 517 l 360 23 b 271 -112 325 23 295 -23 l 225 -112 l 225 517 l 180 517 l 180 -109 b 45 68 89 -95 45 -36 l 45 248 l 0 248 z"
                },
                accSagittalSharp19sUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 89 -96 l 89 -517 l 135 -517 l 135 -108 b 180 -112 148 -112 163 -112 b 225 -108 196 -112 210 -112 l 225 -517 l 271 -517 l 271 -94 b 360 -12 305 -78 337 -50 l 360 -517 l 405 -517 l 405 248 l 383 248 b 190 0 353 98 288 16 b 138 -3 171 0 153 -3 b 45 68 75 -3 45 20 l 0 68 b 89 -96 0 -17 30 -72 z"
                },
                accSagittalFlat19sDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 96 b 0 -68 30 72 0 17 l 45 -68 b 138 3 45 -20 75 3 b 190 0 153 3 171 0 b 383 -248 288 -16 353 -98 l 405 -248 l 405 517 l 360 517 l 360 12 b 271 94 337 50 305 78 l 271 517 l 225 517 l 225 108 b 180 112 210 112 196 112 b 135 108 163 112 148 112 l 135 517 l 89 517 z"
                },
                accSagittalSharp17kUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 337 -23 b 405 14 363 -23 386 -10 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 68 402 127 364 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalFlat17kDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 315 -68 b 428 -248 364 -68 402 -127 l 449 -248 l 449 517 l 405 517 l 405 -14 b 337 23 386 10 363 23 l 315 23 l 315 517 l 271 517 l 271 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalSharp143CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 337 -23 b 405 14 363 -23 386 -10 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 68 402 127 364 68 l 240 68 b 89 157 140 68 89 98 l 45 157 b 68 53 45 115 52 81 b 0 -203 23 23 0 -63 z"
                },
                accSagittalFlat143CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -53 0 63 23 -23 b 45 -157 52 -81 45 -115 l 89 -157 b 240 -68 89 -98 140 -68 l 315 -68 b 428 -248 364 -68 402 -127 l 449 -248 l 449 517 l 405 517 l 405 -14 b 337 23 386 10 363 23 l 315 23 l 315 517 l 271 517 l 271 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalSharp11v49CUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -68 b 135 68 45 23 76 68 l 337 68 b 405 95 363 68 386 76 l 405 -27 b 315 -68 386 -55 356 -68 l 112 -68 b 0 -292 37 -68 0 -143 l 45 -292 b 135 -157 45 -203 75 -157 l 135 -517 l 180 -517 l 180 -157 l 271 -157 l 271 -517 l 315 -517 l 315 -157 l 337 -157 b 405 -130 360 -157 383 -148 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 157 413 187 376 157 l 112 157 b 0 -68 37 157 0 82 z"
                },
                accSagittalFlat11v49CDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 68 b 112 -157 0 -82 37 -157 l 315 -157 b 428 -248 376 -157 413 -187 l 449 -248 l 449 517 l 405 517 l 405 130 b 337 157 383 148 360 157 l 315 157 l 315 517 l 271 517 l 271 157 l 180 157 l 180 517 l 135 517 l 135 157 b 45 292 75 157 45 203 l 0 292 b 112 68 0 143 37 68 l 315 68 b 405 27 356 68 386 55 l 405 -95 b 337 -68 386 -76 363 -68 l 135 -68 b 45 68 76 -68 45 -23 z"
                },
                accSagittalSharp19CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 14 b 337 -23 289 -10 311 -23 l 360 -23 l 360 -517 l 405 -517 l 405 -23 b 495 -203 465 -23 495 -82 l 540 -203 b 428 68 540 -23 503 68 l 360 68 b 248 248 310 68 271 128 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z"
                },
                accSagittalFlat19CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 109 b 0 -68 30 98 0 39 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 b 360 -68 271 -128 310 -68 l 428 -68 b 540 203 503 -68 540 23 l 495 203 b 405 23 495 82 465 23 l 405 517 l 360 517 l 360 23 l 337 23 b 271 -14 311 23 289 10 l 271 517 l 225 517 l 225 27 b 135 109 200 75 170 102 l 135 517 l 89 517 z"
                },
                accSagittalSharp7v19CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 112 l 315 112 b 360 109 331 112 346 112 l 360 -517 l 405 -517 l 405 98 b 495 -68 465 73 495 19 l 495 -248 l 540 -248 l 540 68 b 360 248 540 189 480 248 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z"
                },
                accSagittalFlat7v19CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 109 b 0 -68 30 98 0 39 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 l 360 -248 b 540 -68 480 -248 540 -189 l 540 248 l 495 248 l 495 68 b 405 -98 495 -19 465 -73 l 405 517 l 360 517 l 360 -109 b 315 -112 346 -112 331 -112 l 271 -112 l 271 517 l 225 517 l 225 27 b 135 109 200 75 170 102 l 135 517 l 89 517 z"
                },
                accSagittalSharp49SUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 112 l 360 112 b 405 109 376 112 390 112 l 405 -517 l 449 -517 l 449 96 b 540 -68 510 72 540 17 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalFlat49SDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 449 -96 540 -17 510 -72 l 449 517 l 405 517 l 405 -109 b 360 -112 390 -112 376 -112 l 315 -112 l 315 517 l 271 517 l 271 -14 b 203 23 251 10 229 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalSharp23SUp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 71 l 405 -14 l 405 -517 l 449 -517 l 449 -56 l 675 -268 l 675 -112 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalFlat23SDown: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 675 112 l 675 268 l 449 56 l 449 517 l 405 517 l 405 14 l 315 -71 l 315 517 l 271 517 l 271 -14 b 203 23 251 10 229 23 l 180 23 l 180 517 l 135 517 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalSharp5v13MUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 495 141 l 495 14 l 0 -157 l 0 -256 l 225 -180 l 225 -517 l 271 -517 l 271 -161 l 360 -130 l 360 -517 l 405 -517 l 405 -115 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 517 248 b 167 168 366 194 248 168 b 45 248 85 168 45 194 l 0 248 b 95 99 0 170 30 120 l 0 68 l 0 -30 z"
                },
                accSagittalFlat5v13MDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 30 l 0 -68 l 95 -99 b 0 -248 30 -120 0 -170 l 45 -248 b 167 -168 45 -194 85 -168 b 517 -248 248 -168 366 -194 l 540 -248 l 540 517 l 495 517 l 495 84 l 405 115 l 405 517 l 360 517 l 360 130 l 271 161 l 271 517 l 225 517 l 225 180 l 0 256 l 0 157 l 495 -14 l 495 -141 z"
                },
                accSagittalSharp11v19MUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 315 112 l 315 -517 l 360 -517 l 360 14 b 428 -23 379 -10 402 -23 l 449 -23 l 449 -517 l 495 -517 l 495 -23 b 585 -203 554 -23 585 -84 l 631 -203 b 517 68 631 -23 593 68 l 449 68 b 337 248 400 68 363 127 l 225 248 b 0 68 75 248 0 187 z"
                },
                accSagittalFlat11v19MDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 225 -248 0 -187 75 -248 l 337 -248 b 449 -68 363 -127 400 -68 l 517 -68 b 631 203 593 -68 631 23 l 585 203 b 495 23 585 84 554 23 l 495 517 l 449 517 l 449 23 l 428 23 b 360 -14 402 23 379 10 l 360 517 l 315 517 l 315 -112 l 225 -112 l 225 517 l 180 517 l 180 -104 b 45 68 89 -82 45 -26 l 45 248 l 0 248 z"
                },
                accSagittalSharp49MUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 225 -180 l 225 -517 l 271 -517 l 271 -166 l 360 -132 l 360 -517 l 405 -517 l 405 -117 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 360 248 b 0 -68 120 248 0 143 z m 45 -145 l 45 -68 b 360 112 45 53 150 112 l 495 112 l 495 14 z"
                },
                accSagittalFlat49MDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 68 b 360 -248 0 -143 120 -248 l 540 -248 l 540 517 l 495 517 l 495 84 l 405 117 l 405 517 l 360 517 l 360 132 l 271 166 l 271 517 l 225 517 l 225 180 l 45 248 l 0 248 z m 495 -14 l 495 -112 l 360 -112 b 45 68 150 -112 45 -53 l 45 145 z"
                },
                accSagittalSharp5v49MUp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -271 l 180 -79 l 180 -517 l 225 -517 l 225 -30 l 315 65 l 315 -517 l 360 -517 l 360 65 l 449 -30 l 449 -517 l 495 -517 l 495 -79 l 675 -271 l 675 -112 l 337 248 b 118 89 239 143 166 89 b 45 157 68 89 45 112 l 0 157 b 107 0 0 62 36 10 l 0 -112 z"
                },
                accSagittalFlat5v49MDown: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 112 l 107 0 b 0 -157 36 -10 0 -62 l 45 -157 b 118 -89 45 -112 68 -89 b 337 -248 166 -89 239 -143 l 675 112 l 675 271 l 495 79 l 495 517 l 449 517 l 449 30 l 360 -65 l 360 517 l 315 517 l 315 -65 l 225 30 l 225 517 l 180 517 l 180 79 l 0 271 z"
                },
                accSagittalSharp49LUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -82 l 135 -112 l 135 -517 l 180 -517 l 180 -127 l 271 -157 l 271 -517 l 315 -517 l 315 -173 l 540 -248 l 585 -248 l 585 -68 b 180 248 585 143 449 248 l 0 248 z m 45 112 l 180 112 b 540 -68 420 112 540 53 l 540 -145 l 45 16 z"
                },
                accSagittalFlat49LDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 180 -248 b 585 68 449 -248 585 -143 l 585 248 l 540 248 l 315 173 l 315 517 l 271 517 l 271 157 l 180 127 l 180 517 l 135 517 l 135 112 l 45 82 l 45 517 l 0 517 z m 45 -16 l 540 145 l 540 68 b 180 -112 540 -53 420 -112 l 45 -112 z"
                },
                accSagittalSharp11v19LUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -517 l 45 -517 l 45 -81 l 135 -108 l 135 -517 l 180 -517 l 180 -121 l 271 -148 l 271 -517 l 315 -517 l 315 -161 l 631 -255 l 631 -157 l 45 16 l 45 144 l 631 -30 l 631 68 l 23 248 l 0 248 z"
                },
                accSagittalFlat11v19LDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -248 l 23 -248 l 631 -68 l 631 30 l 45 -144 l 45 -16 l 631 157 l 631 255 l 315 161 l 315 517 l 271 517 l 271 148 l 180 121 l 180 517 l 135 517 l 135 108 l 45 81 l 45 517 l 0 517 z"
                },
                accSagittalSharp5v13LUp: {
                    x_min: 0,
                    x_max: 500,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 -85 l 360 -120 l 360 -517 l 405 -517 l 405 -135 l 720 -256 l 720 -157 l 271 14 l 271 141 l 720 -30 l 720 68 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z"
                },
                accSagittalFlat5v13LDown: {
                    x_min: 0,
                    x_max: 500,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 89 109 b 0 -68 30 98 0 39 l 45 -68 b 95 3 45 -20 60 3 b 122 0 104 3 112 0 b 248 -248 176 -16 217 -98 l 720 -68 l 720 30 l 271 -141 l 271 -14 l 720 157 l 720 256 l 405 135 l 405 517 l 360 517 l 360 120 l 271 85 l 271 517 l 225 517 l 225 27 b 135 109 200 75 170 102 l 135 517 l 89 517 z"
                },
                accSagittalDoubleSharp23SDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -203 l 45 -203 b 135 -23 45 -82 76 -23 l 301 -23 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 370 -14 b 449 112 423 10 449 53 l 449 248 l 428 248 b 315 68 402 127 364 68 l 240 68 b 89 157 140 68 89 98 l 45 157 b 68 53 45 115 52 81 b 0 -203 23 23 0 -63 z"
                },
                accSagittalDoubleFlat23SUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 68 -53 0 63 23 -23 b 45 -157 52 -81 45 -115 l 89 -157 b 240 -68 89 -98 140 -68 l 315 -68 b 428 -248 364 -68 402 -127 l 449 -248 l 449 -112 b 370 14 449 -53 423 -10 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 301 23 l 135 23 b 45 203 76 23 45 82 z"
                },
                accSagittalDoubleSharp49SDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -292 l 45 -292 b 112 -157 45 -203 68 -157 l 256 -157 l 135 -503 l 187 -517 l 337 -82 l 490 -517 l 540 -503 l 366 0 l 396 89 b 449 157 416 102 435 125 l 449 248 l 428 248 b 315 157 413 187 376 157 l 112 157 b 0 -68 39 157 0 82 l 45 -68 b 135 68 45 23 76 68 l 287 68 l 311 0 l 288 -68 l 89 -68 b 0 -292 32 -68 0 -144 z"
                },
                accSagittalDoubleFlat49SUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 292 b 89 68 0 144 32 68 l 288 68 l 311 0 l 287 -68 l 135 -68 b 45 68 76 -68 45 -23 l 0 68 b 112 -157 0 -82 39 -157 l 315 -157 b 428 -248 376 -157 413 -187 l 449 -248 l 449 -157 b 396 -89 435 -125 416 -102 l 366 0 l 540 503 l 490 517 l 337 82 l 187 517 l 135 503 l 256 157 l 112 157 b 45 292 68 157 45 203 z"
                },
                accSagittalDoubleSharp7v19CDown: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -112 l 0 -266 l 307 -7 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 386 59 l 449 112 l 449 248 l 428 248 b 130 68 285 127 186 68 b 45 157 73 68 45 98 l 0 157 b 112 -20 0 53 37 -6 z"
                },
                accSagittalDoubleFlat7v19CUp: {
                    x_min: 0,
                    x_max: 375,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 112 20 b 0 -157 37 6 0 -53 l 45 -157 b 130 -68 45 -98 73 -68 b 428 -248 186 -68 285 -127 l 449 -248 l 449 -112 l 386 -59 l 366 0 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 307 7 l 0 266 l 0 112 z"
                },
                accSagittalDoubleSharp19CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 68 l 0 -248 l 45 -248 l 45 -68 b 315 109 45 36 135 95 l 354 0 l 180 -503 l 232 -517 l 383 -82 l 534 -517 l 585 -503 l 410 0 l 449 112 l 495 112 l 495 248 l 360 248 b 0 68 120 248 0 187 z m 372 112 l 393 112 l 383 82 z"
                },
                accSagittalDoubleFlat19CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 360 -248 0 -187 120 -248 l 495 -248 l 495 -112 l 449 -112 l 410 0 l 585 503 l 534 517 l 383 82 l 232 517 l 180 503 l 354 0 l 315 -109 b 45 68 135 -95 45 -36 l 45 248 l 0 248 z m 383 -82 l 393 -112 l 372 -112 z"
                },
                accSagittalDoubleSharp11v49CDown: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 360 112 b 540 -68 480 112 540 53 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalDoubleFlat11v49CUp: {
                    x_min: 0,
                    x_max: 406,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 405 -248 b 585 -68 526 -248 585 -187 l 585 248 l 540 248 l 540 68 b 360 -112 540 -53 480 -112 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 262 -4 b 203 23 245 13 225 23 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalDoubleSharp143CDown: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 337 49 l 675 -268 l 675 -112 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z"
                },
                accSagittalDoubleFlat143CUp: {
                    x_min: 0,
                    x_max: 469,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 203 b 112 -68 0 23 37 -68 l 180 -68 b 292 -248 230 -68 268 -127 l 675 112 l 675 268 l 337 -49 l 321 0 l 495 503 l 444 517 l 292 82 l 141 517 l 89 503 l 265 0 l 262 -4 b 203 23 245 13 225 23 l 135 23 b 45 203 75 23 45 84 z"
                },
                accSagittalDoubleSharp17kDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 248 b 95 101 0 170 30 121 l 0 68 l 0 -30 l 364 96 l 399 0 l 390 -23 l 0 -157 l 0 -255 l 353 -135 l 225 -503 l 275 -517 l 428 -82 l 577 -517 l 631 -503 l 455 0 l 507 145 l 540 157 l 540 248 l 517 248 b 167 168 366 194 248 168 b 45 248 85 168 45 194 z m 416 115 l 442 124 l 428 82 z"
                },
                accSagittalDoubleFlat17kUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 45 -248 b 167 -168 45 -194 85 -168 b 517 -248 248 -168 366 -194 l 540 -248 l 540 -157 l 507 -145 l 455 0 l 631 503 l 577 517 l 428 82 l 275 517 l 225 503 l 353 135 l 0 255 l 0 157 l 390 23 l 399 0 l 364 -96 l 0 30 l 0 -68 l 95 -101 b 0 -248 30 -121 0 -170 z m 428 -82 l 442 -124 l 416 -115 z"
                },
                accSagittalDoubleSharp19sDown: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 -248 l 45 -248 l 45 -68 b 271 112 45 53 120 112 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 367 4 b 428 -23 386 -13 405 -23 l 495 -23 b 585 -203 554 -23 585 -84 l 631 -203 b 517 68 631 -23 593 68 l 449 68 b 337 248 400 68 363 127 l 225 248 b 0 68 75 248 0 187 z"
                },
                accSagittalDoubleFlat19sUp: {
                    x_min: 0,
                    x_max: 438,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 0 -68 b 225 -248 0 -187 75 -248 l 337 -248 b 449 -68 363 -127 400 -68 l 517 -68 b 631 203 593 -68 631 23 l 585 203 b 495 23 585 84 554 23 l 428 23 b 367 -4 405 23 386 13 l 366 0 l 540 503 l 488 517 l 337 82 l 186 517 l 135 503 l 310 0 l 271 -112 b 45 68 120 -112 45 -53 l 45 248 l 0 248 z"
                },
                accSagittalShaftUp: {
                    x_min: 0,
                    x_max: 31,
                    y_min: -359,
                    y_max: 172,
                    ha: 531,
                    o: "m 0 112 l 0 -517 l 45 -517 l 45 112 l 23 248 z"
                },
                accSagittalShaftDown: {
                    x_min: 0,
                    x_max: 31,
                    y_min: -172,
                    y_max: 359,
                    ha: 531,
                    o: "m 23 -248 l 45 -112 l 45 517 l 0 517 l 0 -112 z"
                },
                accSagittalAcute: {
                    x_min: 0,
                    x_max: 125,
                    y_min: -62,
                    y_max: 125,
                    ha: 187,
                    o: "m 0 0 l 0 -89 l 180 89 l 180 180 z"
                },
                accSagittalGrave: {
                    x_min: 0,
                    x_max: 125,
                    y_min: -125,
                    y_max: 62,
                    ha: 187,
                    o: "m 180 -180 l 180 -89 l 0 89 l 0 0 z"
                },
                accSagittal1MinaUp: {
                    x_min: -7,
                    x_max: 124,
                    y_min: 16,
                    y_max: 106,
                    ha: 90,
                    o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 134 150 179 112 163 135 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
                },
                accSagittal1MinaDown: {
                    x_min: -7,
                    x_max: 124,
                    y_min: -106,
                    y_max: -16,
                    ha: 90,
                    o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 179 -23 163 -135 179 -112 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
                },
                accSagittal2MinasUp: {
                    x_min: -7,
                    x_max: 218,
                    y_min: 16,
                    y_max: 106,
                    ha: 90,
                    o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 207 65 179 23 200 55 b 252 107 223 86 240 107 b 271 23 264 107 272 86 l 314 23 b 269 150 314 112 298 135 b 203 130 252 158 220 150 b 173 92 190 115 181 104 b 134 150 167 127 154 140 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
                },
                accSagittal2MinasDown: {
                    x_min: -7,
                    x_max: 218,
                    y_min: -106,
                    y_max: -16,
                    ha: 90,
                    o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 173 -92 154 -140 167 -127 b 203 -130 181 -104 190 -115 b 269 -150 220 -150 252 -158 b 314 -23 298 -135 314 -112 l 271 -23 b 252 -107 272 -86 264 -107 b 207 -65 240 -107 223 -86 b 179 -23 200 -55 179 -23 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
                },
                accSagittal1TinaUp: {
                    x_min: 0,
                    x_max: 93,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 134 154 l 91 154 b 81 76 91 101 91 86 b 0 68 73 69 48 68 l 0 23 b 134 154 122 23 134 36 z"
                },
                accSagittal1TinaDown: {
                    x_min: 0,
                    x_max: 93,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 134 -154 b 0 -23 134 -36 122 -23 l 0 -68 b 81 -76 48 -68 73 -69 b 91 -154 91 -86 91 -101 z"
                },
                accSagittal2TinasUp: {
                    x_min: 0,
                    x_max: 94,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 135 68 b 89 154 94 68 89 124 l 46 154 b 36 92 45 131 42 105 b 0 68 32 82 23 68 l 0 23 b 68 63 29 23 53 40 b 135 23 84 39 104 23 z"
                },
                accSagittal2TinasDown: {
                    x_min: 0,
                    x_max: 94,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 135 -23 b 68 -63 104 -23 84 -39 b 0 -23 53 -40 29 -23 l 0 -68 b 36 -92 23 -68 32 -82 b 46 -154 42 -105 45 -131 l 89 -154 b 135 -68 89 -124 94 -68 z"
                },
                accSagittal3TinasUp: {
                    x_min: -7,
                    x_max: 124,
                    y_min: 16,
                    y_max: 106,
                    ha: 90,
                    o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 134 150 179 112 163 135 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
                },
                accSagittal3TinasDown: {
                    x_min: -7,
                    x_max: 124,
                    y_min: -106,
                    y_max: -16,
                    ha: 90,
                    o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 179 -23 163 -135 179 -112 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
                },
                accSagittal4TinasUp: {
                    x_min: 0,
                    x_max: 187,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 0 68 l 0 23 b 143 45 105 23 124 26 b 203 107 153 55 183 107 b 226 23 216 107 226 86 l 269 23 b 225 150 269 112 253 135 b 160 132 207 158 181 153 b 115 81 138 112 124 88 b 0 68 104 71 94 68 z"
                },
                accSagittal4TinasDown: {
                    x_min: 0,
                    x_max: 187,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 0 -68 b 115 -81 94 -68 104 -71 b 160 -132 124 -88 138 -112 b 225 -150 181 -153 207 -158 b 269 -23 253 -135 269 -112 l 226 -23 b 203 -107 226 -86 216 -107 b 143 -45 183 -107 153 -55 b 0 -23 124 -26 105 -23 z"
                },
                accSagittal5TinasUp: {
                    x_min: 0,
                    x_max: 218,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 135 23 b 187 45 156 23 168 26 b 249 107 197 55 228 107 b 271 23 262 107 271 86 l 314 23 b 269 150 314 112 298 135 b 204 132 252 158 226 153 b 160 81 183 112 168 88 b 135 68 148 71 147 68 b 89 154 94 68 89 124 l 46 154 b 36 92 45 131 42 105 b 0 68 32 82 23 68 l 0 23 b 68 63 29 23 53 40 b 135 23 84 39 104 23 z"
                },
                accSagittal5TinasDown: {
                    x_min: 0,
                    x_max: 218,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 135 -23 b 68 -63 104 -23 84 -39 b 0 -23 53 -40 29 -23 l 0 -68 b 36 -92 23 -68 32 -82 b 46 -154 42 -105 45 -131 l 89 -154 b 135 -68 89 -124 94 -68 b 160 -81 147 -68 148 -71 b 204 -132 168 -88 183 -112 b 269 -150 226 -153 252 -158 b 314 -23 298 -135 314 -112 l 271 -23 b 249 -107 271 -86 262 -107 b 187 -45 228 -107 197 -55 b 135 -23 168 -26 156 -23 z"
                },
                accSagittal6TinasUp: {
                    x_min: -7,
                    x_max: 218,
                    y_min: 16,
                    y_max: 106,
                    ha: 90,
                    o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 207 65 179 23 200 55 b 252 107 223 86 240 107 b 271 23 264 107 272 86 l 314 23 b 269 150 314 112 298 135 b 203 130 252 158 220 150 b 173 92 190 115 181 104 b 134 150 167 127 154 140 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
                },
                accSagittal6TinasDown: {
                    x_min: -7,
                    x_max: 218,
                    y_min: -106,
                    y_max: -16,
                    ha: 90,
                    o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 173 -92 154 -140 167 -127 b 203 -130 181 -104 190 -115 b 269 -150 220 -150 252 -158 b 314 -23 298 -135 314 -112 l 271 -23 b 252 -107 272 -86 264 -107 b 207 -65 240 -107 223 -86 b 179 -23 200 -55 179 -23 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
                },
                accSagittal7TinasUp: {
                    x_min: 0,
                    x_max: 281,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 0 68 l 0 23 b 143 45 105 23 124 26 b 203 107 153 55 183 107 b 226 23 216 107 226 86 l 269 23 b 298 65 269 23 291 55 b 343 107 314 86 331 107 b 361 23 354 107 363 86 l 405 23 b 360 150 405 112 389 135 b 294 130 343 158 311 150 b 264 92 281 115 272 104 b 225 150 258 127 245 140 b 160 132 207 158 181 153 b 115 81 138 112 124 88 b 0 68 104 71 94 68 z"
                },
                accSagittal7TinasDown: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 0 -68 b 115 -81 94 -68 104 -71 b 160 -132 124 -88 138 -112 b 225 -150 181 -153 207 -158 b 264 -92 245 -140 258 -127 b 294 -130 272 -104 281 -115 b 360 -150 311 -150 343 -158 b 405 -23 389 -135 405 -112 l 361 -23 b 343 -107 363 -86 354 -107 b 298 -65 331 -107 314 -86 b 269 -23 291 -55 269 -23 l 226 -23 b 203 -107 226 -86 216 -107 b 143 -45 183 -107 153 -55 b 0 -23 124 -26 105 -23 z"
                },
                accSagittal8TinasUp: {
                    x_min: 0,
                    x_max: 312,
                    y_min: 16,
                    y_max: 107,
                    ha: 91,
                    o: "m 135 23 b 187 45 156 23 168 26 b 249 107 197 55 228 107 b 271 23 262 107 271 86 l 314 23 b 343 65 314 23 336 55 b 387 107 359 86 376 107 b 406 23 399 107 408 86 l 449 23 b 405 150 449 112 433 135 b 338 130 387 158 356 150 b 308 92 325 115 317 104 b 269 150 302 127 289 140 b 204 132 252 158 226 153 b 160 81 183 112 168 88 b 135 68 148 71 147 68 b 89 154 94 68 89 124 l 46 154 b 36 92 45 131 42 105 b 0 68 32 82 23 68 l 0 23 b 68 63 29 23 53 40 b 135 23 84 39 104 23 z"
                },
                accSagittal8TinasDown: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -107,
                    y_max: -16,
                    ha: 91,
                    o: "m 135 -23 b 68 -63 104 -23 84 -39 b 0 -23 53 -40 29 -23 l 0 -68 b 36 -92 23 -68 32 -82 b 46 -154 42 -105 45 -131 l 89 -154 b 135 -68 89 -124 94 -68 b 160 -81 147 -68 148 -71 b 204 -132 168 -88 183 -112 b 269 -150 226 -153 252 -158 b 308 -92 289 -140 302 -127 b 338 -130 317 -104 325 -115 b 405 -150 356 -150 387 -158 b 449 -23 433 -135 449 -112 l 406 -23 b 387 -107 408 -86 399 -107 b 343 -65 376 -107 359 -86 b 314 -23 336 -55 314 -23 l 271 -23 b 249 -107 271 -86 262 -107 b 187 -45 228 -107 197 -55 b 135 -23 168 -26 156 -23 z"
                },
                accSagittal9TinasUp: {
                    x_min: -7,
                    x_max: 312,
                    y_min: 16,
                    y_max: 106,
                    ha: 90,
                    o: "m -10 23 l 43 23 b 72 65 43 23 65 55 b 117 107 88 86 105 107 b 135 23 128 107 137 86 l 179 23 b 207 65 179 23 200 55 b 252 107 223 86 240 107 b 271 23 264 107 272 86 l 314 23 b 343 65 314 23 336 55 b 387 107 359 86 376 107 b 406 23 399 107 408 86 l 449 23 b 405 150 449 112 433 135 b 338 130 387 158 356 150 b 308 92 325 115 317 104 b 269 150 302 127 289 140 b 203 130 252 158 220 150 b 173 92 190 115 181 104 b 134 150 167 127 154 140 b 68 130 117 158 85 150 b -10 23 43 101 13 58 z"
                },
                accSagittal9TinasDown: {
                    x_min: -7,
                    x_max: 312,
                    y_min: -106,
                    y_max: -16,
                    ha: 90,
                    o: "m -10 -23 b 68 -130 13 -58 43 -101 b 134 -150 85 -150 117 -158 b 173 -92 154 -140 167 -127 b 203 -130 181 -104 190 -115 b 269 -150 220 -150 252 -158 b 308 -92 289 -140 302 -127 b 338 -130 317 -104 325 -115 b 405 -150 356 -150 387 -158 b 449 -23 433 -135 449 -112 l 406 -23 b 387 -107 408 -86 399 -107 b 343 -65 376 -107 359 -86 b 314 -23 336 -55 314 -23 l 271 -23 b 252 -107 272 -86 264 -107 b 207 -65 240 -107 223 -86 b 179 -23 200 -55 179 -23 l 135 -23 b 117 -107 137 -86 128 -107 b 72 -65 105 -107 88 -86 b 43 -23 65 -55 43 -23 z"
                },
                accSagittalFractionalTinaUp: {
                    x_min: -3,
                    x_max: 35,
                    y_min: 73,
                    y_max: 111,
                    ha: 38,
                    o: "m -4 132 b 23 105 -4 118 9 105 b 50 132 37 105 50 118 b 23 160 50 147 37 160 b -4 132 9 160 -4 147 z"
                },
                accSagittalFractionalTinaDown: {
                    x_min: -3,
                    x_max: 35,
                    y_min: -111,
                    y_max: -73,
                    ha: 38,
                    o: "m -4 -132 b 23 -160 -4 -147 9 -160 b 50 -132 37 -160 50 -147 b 23 -105 50 -118 37 -105 b -4 -132 9 -105 -4 -118 z"
                },
                accidentalNarrowReversedFlat: {
                    x_min: 0,
                    x_max: 164,
                    y_min: -194,
                    y_max: 421,
                    ha: 615,
                    o: "m 236 -279 l 236 606 l 192 606 l 192 179 b 85 243 150 222 114 243 b 0 84 23 243 0 134 b 112 -158 0 3 37 -78 z m 192 112 l 192 -163 l 135 -98 b 82 40 101 -50 82 -3 b 138 144 82 73 96 144 b 192 112 153 144 170 132 z"
                },
                accidentalNarrowReversedFlatAndFlat: {
                    x_min: 0,
                    x_max: 414,
                    y_min: -194,
                    y_max: 421,
                    ha: 615,
                    o: "m 281 606 l 281 -268 l 438 -158 b 596 84 547 -82 596 3 b 475 243 596 154 556 243 b 325 179 435 243 384 222 l 325 606 z m 235 -279 l 235 606 l 190 606 l 190 179 b 85 243 148 222 114 243 b 12 158 52 243 27 215 b 0 84 3 134 0 108 b 112 -158 0 3 37 -78 z m 325 111 b 410 144 359 132 386 144 b 498 36 462 144 498 84 b 413 -107 498 -9 469 -58 l 325 -173 z m 192 112 l 192 -163 l 135 -98 b 81 40 99 -50 81 -3 b 91 94 81 59 84 76 b 137 144 102 127 118 144 b 192 112 153 144 170 132 z"
                },
                accidentalWilsonPlus: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -203,
                    y_max: 203,
                    ha: 406,
                    o: "m 405 268 l 225 98 l 225 292 l 180 292 l 180 56 l 0 -112 l 0 -268 l 180 -98 l 180 -292 l 225 -292 l 225 -56 l 405 112 z"
                },
                accidentalWilsonMinus: {
                    x_min: 0,
                    x_max: 281,
                    y_min: -186,
                    y_max: 186,
                    ha: 372,
                    o: "m 0 112 l 405 -268 l 405 -112 l 0 268 z"
                }
            },
            fontFamily: "Bravura",
            resolution: 1e3,
            generatedOn: "2022-12-18T09:06:51.407Z"
        }, Ni = {
            smufl: !0,
            stave: {
                padding: 12,
                endPaddingMax: 10,
                endPaddingMin: 5,
                unalignedNotePadding: 10
            },
            accidental: {
                noteheadAccidentalPadding: 1,
                leftPadding: 2,
                accidentalSpacing: 3
            },
            chordSymbol: {
                global: {
                    superscriptOffset: -400,
                    subscriptOffset: 300,
                    kerningOffset: -250,
                    lowerKerningText: [
                        "D",
                        "F",
                        "P",
                        "T",
                        "V",
                        "Y"
                    ],
                    upperKerningText: [
                        "A",
                        "L"
                    ],
                    spacing: 100,
                    superSubRatio: .66
                },
                glyphs: {
                    csymDiminished: {
                        leftSideBearing: -32,
                        advanceWidth: 506,
                        yOffset: 0
                    },
                    csymHalfDiminished: {
                        leftSideBearing: -32,
                        advanceWidth: 506,
                        yOffset: 0
                    },
                    csymAugmented: {
                        leftSideBearing: 0,
                        advanceWidth: 530,
                        yOffset: 0
                    },
                    csymParensLeftTall: {
                        leftSideBearing: -20,
                        advanceWidth: 184,
                        yOffset: 250
                    },
                    csymParensRightTall: {
                        leftSideBearing: 0,
                        advanceWidth: 189,
                        yOffset: 250
                    },
                    csymBracketLeftTall: {
                        leftSideBearing: 0,
                        advanceWidth: 328,
                        yOffset: 0
                    },
                    csymBracketRightTall: {
                        leftSideBearing: 1,
                        advanceWidth: 600,
                        yOffset: 0
                    },
                    csymParensLeftVeryTall: {
                        leftSideBearing: 50,
                        advanceWidth: 121,
                        yOffset: 350
                    },
                    csymParensRightVeryTall: {
                        leftSideBearing: 0,
                        advanceWidth: 111,
                        yOffset: 350
                    },
                    csymDiagonalArrangementSlash: {
                        leftSideBearing: 250,
                        advanceWidth: 990,
                        yOffset: 300
                    },
                    csymMinor: {
                        leftSideBearing: 0,
                        advanceWidth: 482,
                        yOffset: 0
                    },
                    csymMajorSeventh: {
                        leftSideBearing: 200,
                        yOffset: 0,
                        advanceWidth: 600
                    },
                    accidentalSharp: {
                        leftSideBearing: 20,
                        advanceWidth: 250,
                        yOffset: -302
                    },
                    accidentalFlat: {
                        leftSideBearing: -20,
                        advanceWidth: 226,
                        yOffset: -184
                    }
                }
            },
            clef_default: {
                width: 26,
                annotations: {
                    "8va": {
                        treble: {
                            line: -2,
                            shiftX: 12
                        }
                    },
                    "8vb": {
                        treble: {
                            line: 6.5,
                            shiftX: 10
                        },
                        bass: {
                            line: 4,
                            shiftX: 1
                        }
                    }
                }
            },
            clef_small: {
                width: 20,
                annotations: {
                    "8va": {
                        treble: {
                            line: -0.2,
                            shiftX: 8
                        }
                    },
                    "8vb": {
                        treble: {
                            line: 5.3,
                            shiftX: 6
                        },
                        bass: {
                            line: 3.1,
                            shiftX: .5
                        }
                    }
                }
            },
            ornament: {
                brassScoop: {
                    xOffset: -12,
                    yOffset: 0,
                    stemUpYOffset: 0,
                    reportedWidth: 20
                },
                brassDoitMedium: {
                    xOffset: 16,
                    yOffset: 0,
                    stemUpYOffset: 0,
                    reportedWidth: 22
                },
                brassFallLipShort: {
                    xOffset: 16,
                    yOffset: 0,
                    stemUpYOffset: 0,
                    reportedWidth: 15
                },
                brassLiftMedium: {
                    xOffset: 16,
                    yOffset: 5,
                    stemUpYOffset: 0,
                    reportedWidth: 5
                },
                brassFallRoughMedium: {
                    xOffset: 16,
                    yOffset: 28,
                    stemUpYOffset: 0,
                    reportedWidth: 5
                },
                brassBend: {
                    xOffset: 2,
                    yOffset: -8,
                    stemUpYOffset: 25,
                    reportedWidth: 5
                },
                brassMuteClosed: {
                    xOffset: 3,
                    yOffset: -8,
                    stemUpYOffset: 25,
                    reportedWidth: 5
                },
                brassMuteOpen: {
                    xOffset: 3,
                    yOffset: -7,
                    stemUpYOffset: 25,
                    reportedWidth: 5
                },
                brassFlip: {
                    xOffset: 10,
                    yOffset: 0,
                    stemUpYOffset: 7,
                    reportedWidth: 10
                },
                brassJazzTurn: {
                    xOffset: 0,
                    yOffset: 0,
                    stemUpYOffset: 8,
                    reportedWidth: 31
                },
                brassSmear: {
                    xOffset: 10,
                    yOffset: 0,
                    stemUpYOffset: 8,
                    reportedWidth: 5
                }
            },
            parenthesis: {
                default: {
                    width: 7
                },
                gracenote: {
                    width: 3
                }
            },
            pedalMarking: {},
            digits: {
                shiftLine: -1,
                shiftY: -6
            },
            articulation: {
                articStaccatissimoAbove: {
                    padding: 2
                },
                articStaccatissimoBelow: {
                    padding: 2
                }
            },
            tremolo: {
                default: {
                    spacing: 7,
                    offsetYStemUp: -8,
                    offsetYStemDown: 8,
                    offsetXStemUp: 11,
                    offsetXStemDown: 1
                },
                grace: {
                    spacing: 4.2,
                    offsetYStemUp: -4.8,
                    offsetYStemDown: 4.8,
                    offsetXStemUp: 7,
                    offsetXStemDown: 1
                }
            },
            staveRepetition: {
                symbolText: {
                    offsetX: 12,
                    offsetY: 25,
                    spacing: 5
                },
                coda: {
                    offsetY: 25
                },
                segno: {
                    offsetY: 10
                }
            },
            noteHead: {
                minPadding: 2
            },
            stem: {
                heightAdjustmentForFlag: -3,
                noteHead: {
                    noteheadTriangleUpHalf: {
                        offsetYBaseStemUp: 5,
                        offsetYBaseStemDown: 4
                    },
                    noteheadTriangleUpBlack: {
                        offsetYBaseStemUp: 5,
                        offsetYBaseStemDown: 4
                    },
                    noteheadTriangleUpWhole: {
                        offsetYBaseStemUp: 5,
                        offsetYBaseStemDown: 4
                    },
                    noteheadXHalf: {
                        offsetYBaseStemUp: -4,
                        offsetYBaseStemDown: 4
                    },
                    noteheadXBlack: {
                        offsetYBaseStemUp: -4,
                        offsetYBaseStemDown: 4
                    },
                    noteheadXWhole: {
                        offsetYBaseStemUp: -4,
                        offsetYBaseStemDown: 4
                    },
                    noteheadHalf: {
                        offsetYBaseStemUp: -2.55,
                        offsetYBaseStemDown: 2.65
                    },
                    noteheadBlack: {
                        offsetYBaseStemUp: -2,
                        offsetYBaseStemDown: 2
                    },
                    noteheadSquareWhite: {
                        offsetYBaseStemDown: -5,
                        offsetYBaseStemUp: 5
                    }
                }
            },
            stringNumber: {
                verticalPadding: 8,
                stemPadding: 2,
                leftPadding: 5,
                rightPadding: 6
            },
            tuplet: {
                noteHeadOffset: 20,
                stemOffset: 10,
                bottomLine: 4,
                topModifierOffset: 15
            },
            glyphs: {
                coda: {
                    shiftX: -7,
                    shiftY: 8
                },
                segno: {
                    shiftX: -7
                },
                flag: {
                    shiftX: -0.75,
                    staveTempo: {
                        shiftX: -1
                    }
                },
                clef_default: {},
                clef_small: {
                    gClef: {
                        shiftY: 1.5
                    }
                },
                clefNote_default: {},
                clefNote_small: {},
                stroke_straight: {
                    arrowheadBlackDown: {
                        shiftX: -4.5
                    },
                    arrowheadBlackUp: {
                        shiftX: -0.85
                    }
                },
                stroke_wiggly: {
                    arrowheadBlackDown: {
                        shiftX: -1,
                        shiftY: 1
                    },
                    arrowheadBlackUp: {
                        shiftX: -1,
                        shiftY: 1
                    }
                },
                textNote: {
                    breathMarkTick: {
                        shiftY: 9
                    },
                    breathMarkComma: {},
                    segno: {
                        shiftX: -7,
                        shiftY: 8
                    },
                    coda: {
                        shiftX: -7,
                        shiftY: 8
                    },
                    ornamentTrill: {
                        shiftX: -8,
                        shiftY: 8
                    },
                    ornamentTurn: {},
                    ornamentTurnSlash: {},
                    ornamentMordent: {
                        shiftX: -8
                    },
                    ornamentShortTrill: {
                        shiftX: -8
                    }
                },
                noteHead: {},
                chordSymbol: {
                    scale: .8
                }
            }
        };
        const Fi = {
            resolution: 1e3,
            fontFamily: "VexFlowCustom",
            glyphs: {
                vexAccidentalMicrotonal1: {
                    x_min: -171.5,
                    x_max: 483.1875,
                    ha: 493,
                    o: "m -8 631 b -1 632 -6 632 -4 632 b 19 620 8 632 16 628 b 20 495 20 616 20 616 b 20 373 20 427 20 373 b 115 410 20 373 63 390 l 210 448 l 210 531 b 212 620 210 614 210 616 b 231 632 215 628 223 632 b 246 627 236 632 242 631 b 251 541 251 620 251 628 l 251 463 l 315 489 b 387 514 368 509 381 514 b 393 513 390 514 392 514 b 406 494 402 510 406 502 b 397 476 406 487 404 480 b 323 446 396 474 363 462 l 251 417 l 251 283 l 251 148 l 254 151 b 370 199 291 183 332 199 b 415 191 385 199 400 197 b 483 84 458 176 483 134 b 461 0 483 58 476 29 b 332 -142 439 -40 411 -72 l 255 -215 b 231 -229 240 -229 239 -229 b 216 -223 224 -229 220 -227 b 210 -158 210 -217 210 -223 b 210 -120 210 -148 210 -136 l 210 -29 l 205 -34 b 100 -142 182 -65 159 -88 l 23 -215 b -1 -229 9 -229 6 -229 b -19 -217 -9 -229 -16 -224 l -20 -215 l -21 48 l -21 310 l -83 287 b -152 262 -133 266 -145 262 b -157 263 -153 262 -155 262 b -171 283 -166 266 -171 274 b -161 301 -171 290 -167 297 b -91 328 -160 302 -129 315 l -21 356 l -21 487 l -20 617 l -19 621 b -8 631 -17 626 -12 630 m 210 288 b 210 401 210 351 210 401 b 114 365 209 401 167 384 l 20 327 l 20 238 l 20 148 l 21 151 b 140 199 59 183 102 199 b 206 180 164 199 187 192 l 209 177 b 209 177 209 177 209 177 b 210 288 210 177 210 199 m 110 131 b 96 133 106 133 100 133 b 89 133 93 133 91 133 b 24 87 63 129 40 113 l 20 80 l 20 -37 l 20 -156 l 23 -152 b 144 81 96 -72 144 20 l 144 83 b 110 131 144 113 134 126 m 341 131 b 328 133 337 133 332 133 b 322 133 326 133 323 133 b 257 87 296 129 273 113 l 251 80 l 251 -37 l 251 -156 l 255 -152 b 375 81 328 -72 375 20 l 375 83 b 341 131 375 113 367 126 "
                },
                vexAccidentalMicrotonal3: {
                    x_min: 0,
                    x_max: 430.75,
                    ha: 360,
                    o: "m -146 537 b -138 538 -143 538 -141 538 b -118 525 -129 538 -121 533 b -117 390 -117 522 -117 521 b -115 259 -117 268 -117 259 b -115 259 -115 259 -115 259 b -59 272 -104 263 -62 272 b -39 259 -50 272 -42 267 b -37 209 -38 257 -37 233 b -39 159 -37 185 -38 162 b -85 138 -43 149 -44 149 l -117 131 l -117 21 b -115 -88 -117 -80 -117 -88 b -115 -88 -115 -88 -115 -88 b -59 -75 -104 -84 -62 -75 b -44 -81 -52 -75 -48 -77 b -38 -124 -38 -87 -38 -85 b -38 -138 -38 -124 -38 -138 b -38 -152 -38 -138 -38 -152 b -44 -195 -38 -191 -38 -190 b -85 -209 -48 -200 -48 -200 l -117 -217 l -117 -349 b -118 -486 -117 -481 -117 -482 b -138 -499 -121 -494 -129 -499 b -153 -493 -143 -499 -149 -497 b -159 -415 -158 -487 -159 -496 b -159 -355 -159 -398 -159 -379 b -159 -227 -159 -284 -159 -227 b -205 -238 -159 -227 -180 -232 b -250 -249 -230 -244 -250 -249 b -251 -386 -251 -249 -251 -311 b -252 -525 -251 -521 -251 -522 b -272 -538 -255 -534 -264 -538 b -287 -532 -277 -538 -283 -536 b -293 -452 -292 -527 -293 -536 b -293 -391 -293 -436 -293 -415 b -294 -260 -293 -269 -293 -260 b -294 -260 -294 -260 -294 -260 b -348 -272 -306 -264 -345 -272 b -368 -259 -357 -272 -365 -267 b -369 -209 -369 -257 -369 -233 b -368 -159 -369 -185 -369 -162 b -323 -139 -364 -149 -362 -148 l -293 -131 l -293 -22 b -294 87 -293 80 -293 87 b -294 87 -294 87 -294 87 b -348 75 -306 84 -345 75 b -368 88 -357 75 -365 80 b -369 138 -369 91 -369 114 b -368 188 -369 162 -369 186 b -323 209 -364 198 -362 199 l -293 216 l -293 349 b -292 486 -293 481 -293 482 b -272 499 -288 494 -280 499 b -257 493 -266 499 -261 497 b -251 414 -251 487 -251 496 b -251 354 -251 398 -251 378 b -251 226 -251 284 -251 226 b -205 238 -250 226 -230 231 b -159 249 -180 244 -159 249 b -159 385 -159 249 -159 310 b -157 525 -159 521 -159 522 b -146 537 -156 530 -151 535 z m -159 11 b -159 120 -159 98 -159 120 l -159 120 b -175 116 -160 120 -167 119 b -221 105 -184 114 -204 109 l -251 98 l -251 -12 b -251 -121 -251 -72 -251 -121 b -205 -110 -250 -121 -230 -116 b -159 -99 -180 -104 -159 -99 b -159 11 -159 -99 -159 -49 z m 89 517 b 97 519 92 518 94 519 b 117 505 106 519 114 513 b 119 376 119 502 119 501 l 119 249 l 145 258 b 176 267 169 266 172 267 b 177 267 176 267 177 267 b 196 255 186 267 192 263 l 197 252 l 197 205 b 197 181 197 195 197 187 b 193 149 197 153 197 153 b 152 131 190 144 187 143 l 119 120 l 119 10 b 119 -100 119 -62 119 -100 b 145 -91 120 -100 131 -96 b 173 -82 159 -86 171 -82 b 176 -81 174 -81 175 -81 b 196 -94 185 -81 193 -87 b 198 -151 197 -97 198 -125 b 197 -194 198 -172 197 -192 b 153 -218 193 -203 192 -204 l 119 -230 l 119 -367 l 118 -504 l 117 -507 b 97 -519 113 -514 105 -519 b 82 -512 92 -519 87 -517 b 76 -434 77 -507 76 -516 b 76 -374 76 -418 76 -398 b 76 -245 76 -303 76 -245 b 52 -254 76 -245 65 -249 b 19 -263 34 -260 25 -263 b 6 -257 13 -263 10 -261 b 0 -214 0 -251 0 -253 b 0 -200 0 -210 0 -205 b 0 -188 0 -196 0 -192 b 6 -143 0 -147 0 -149 b 46 -126 10 -139 10 -139 l 76 -115 l 76 -5 b 76 106 76 56 76 106 b 51 98 76 106 64 102 b 18 89 34 92 25 89 b 6 95 13 89 10 91 b 0 139 0 101 0 99 b 0 153 0 143 0 148 b 0 179 0 163 0 172 b 44 225 0 215 3 211 l 76 236 l 76 369 b 78 505 76 501 76 502 b 89 517 80 510 85 515 z "
                },
                vexAccidentalMicrotonal4: {
                    x_min: 0,
                    x_max: 430.75,
                    ha: 360,
                    o: "m 283 633 b 291 634 286 634 289 634 b 311 621 300 634 308 629 b 313 505 313 618 313 617 b 313 393 313 443 313 393 b 378 425 313 393 343 407 l 443 458 l 448 458 b 449 458 449 458 449 458 b 471 437 462 458 471 448 b 469 429 471 434 470 432 b 387 382 466 421 469 423 l 313 344 l 313 247 l 313 150 l 315 152 b 433 201 353 184 394 201 b 479 193 448 201 464 198 b 549 86 524 177 549 135 b 526 1 549 59 541 29 b 395 -143 504 -39 475 -71 b 316 -214 351 -182 341 -191 b 292 -229 302 -228 300 -229 b 272 -216 283 -229 275 -224 b 271 55 271 -212 271 -212 b 270 323 271 203 270 323 b 205 291 270 323 241 308 l 140 258 l 135 258 b 134 258 135 258 134 258 b 112 279 121 258 112 267 b 114 287 112 281 113 284 b 196 334 117 295 114 293 l 271 371 l 271 495 b 272 621 271 617 271 618 b 283 633 274 626 279 631 z m 404 133 b 391 134 400 134 395 134 b 384 134 388 134 386 134 b 318 88 358 130 335 114 l 313 81 l 313 -37 l 313 -156 l 316 -152 b 439 83 391 -71 439 22 l 439 84 b 404 133 439 115 430 128 z m -8 633 l -8 633 b 0 634 -6 634 -3 634 b 20 621 8 634 17 629 b 21 384 21 618 21 617 l 21 150 l 24 152 b 141 201 62 184 102 201 b 187 193 157 201 172 198 b 257 86 232 177 257 135 b 234 1 257 59 250 29 b 103 -143 212 -39 183 -71 b 24 -214 60 -182 49 -191 b 0 -229 10 -228 8 -229 b -20 -216 -9 -229 -17 -224 l -21 -212 l -21 203 l -21 618 l -20 621 b -8 633 -18 626 -13 631 z m 113 133 l 113 133 b 99 134 109 134 103 134 b 93 134 97 134 94 134 b 26 88 66 130 43 114 l 21 81 l 21 -37 l 21 -156 l 25 -152 b 148 83 99 -71 148 22 l 148 84 b 113 133 148 115 138 128 z "
                },
                vexNoteHeadRectBlack: {
                    x_min: 0,
                    x_max: 430.75,
                    ha: 360,
                    o: "m 0 150 l 0 -150 l 430 -150 l 430 150 l 0 150 "
                },
                vexNoteHeadRectWhite: {
                    x_min: 0,
                    x_max: 430.75,
                    ha: 360,
                    o: "m 0 150 l 0 -150 l 430 -150 l 430 150 l 0 150 l 50 100 l 380 100 l 380 -100 l 50 -100 l 50 100"
                },
                vexWiggleArpeggioUp: {
                    x_min: 58.53125,
                    x_max: 228.671875,
                    ha: 294,
                    o: "m 138 371 b 142 373 140 371 141 373 b 178 342 149 373 156 366 b 228 251 217 297 228 278 b 228 244 228 248 228 247 b 176 147 227 212 212 184 b 123 73 152 122 132 93 b 121 62 122 70 121 66 b 145 13 121 48 129 31 b 153 -2 151 6 153 1 b 149 -9 153 -5 152 -6 b 144 -11 148 -11 145 -11 b 129 -1 140 -11 136 -8 b 61 87 89 37 68 68 b 58 113 59 95 58 105 b 110 215 58 144 74 177 b 163 287 134 240 155 269 b 166 299 166 291 166 295 b 141 348 166 313 157 330 b 133 360 134 356 133 358 b 133 363 133 362 133 362 b 138 371 133 367 136 370 "
                }
            }
        };
        const Mi = {
            glyphs: {
                bracketTop: {
                    x_min: 0,
                    x_max: 412,
                    y_min: -18,
                    y_max: 223,
                    ha: 241,
                    o: "m 569 315 b 583 321 575 319 579 321 b 591 316 586 321 589 319 b 593 310 592 314 593 312 b 579 289 593 306 589 301 b 385 111 517 219 449 156 b 372 101 379 106 373 102 b 244 28 340 78 285 46 b 21 -26 168 -6 88 -26 b 2 -21 6 -26 5 -25 b 0 47 1 -19 0 14 b 2 114 0 79 1 112 b 29 120 5 119 6 119 b 569 315 209 124 395 191 z"
                },
                bracketBottom: {
                    x_min: 0,
                    x_max: 412,
                    y_min: -223,
                    y_max: 18,
                    ha: 241,
                    o: "m 5 24 b 21 26 7 25 12 26 b 63 23 32 26 47 25 b 342 -81 155 13 249 -22 b 388 -113 353 -89 382 -108 b 400 -122 389 -114 395 -118 b 578 -289 459 -166 522 -225 b 593 -310 589 -301 593 -306 b 591 -316 593 -312 592 -314 b 583 -321 588 -319 586 -321 b 568 -315 579 -321 575 -319 b 29 -120 395 -191 209 -124 b 1 -114 5 -119 5 -119 b 0 -47 0 -112 0 -111 b 0 -22 0 -37 0 -29 b 5 24 0 25 0 21 z"
                },
                barlineTick: {
                    x_min: -59,
                    x_max: 59,
                    y_min: -139,
                    y_max: 139,
                    ha: 279,
                    o: "m 24 200 b 34 201 26 200 30 201 b 51 198 40 201 47 200 b 84 152 72 191 84 174 b 84 149 84 151 84 150 b 68 103 84 139 83 137 b -64 -195 3 -44 -63 -194 b -74 -201 -66 -199 -70 -201 b -83 -195 -77 -201 -81 -199 b -84 -191 -84 -194 -84 -193 b -78 -155 -84 -186 -83 -177 b -25 104 -45 8 -35 53 b -11 167 -18 136 -12 164 b 24 200 -6 183 6 195 z"
                },
                breathMarkTick: {
                    x_min: -151,
                    x_max: 272,
                    y_min: 0,
                    y_max: 429,
                    ha: 429,
                    o: "m 367 613 b 382 618 373 616 378 618 b 392 607 388 618 392 614 b 376 592 392 601 390 599 b 309 546 354 580 331 565 b 46 47 185 439 88 256 b 0 0 39 14 26 0 b -44 39 -23 0 -36 12 b -203 270 -68 118 -125 202 b -217 288 -213 279 -217 284 b -215 294 -217 290 -217 292 b -208 299 -213 297 -211 299 b -193 293 -204 299 -199 297 b -19 144 -124 249 -66 199 b -14 138 -16 141 -14 138 b -9 149 -14 138 -11 143 b 367 613 72 359 220 541 z"
                },
                segno: {
                    x_min: 7,
                    x_max: 493,
                    y_min: -50,
                    y_max: 650,
                    ha: 699,
                    o: "m 218 934 b 237 935 224 935 231 935 b 394 820 306 935 371 889 b 398 794 397 811 398 802 b 333 730 398 758 372 730 b 269 777 302 730 280 746 b 183 851 254 823 219 851 b 158 846 175 851 166 849 b 120 786 133 835 120 815 b 122 766 120 780 121 773 b 347 511 138 672 227 570 b 368 500 356 506 366 501 l 371 499 l 372 501 b 485 672 373 502 404 550 b 560 786 506 704 540 755 b 617 873 581 818 607 857 b 645 910 639 906 640 907 b 660 915 650 914 655 915 b 687 888 674 915 687 904 b 687 886 687 887 687 887 b 665 844 687 878 687 878 b 610 761 655 830 631 792 b 462 537 551 672 501 595 b 425 480 443 508 426 482 l 422 476 l 431 472 b 628 269 521 423 591 352 b 658 136 649 225 658 179 b 518 -68 658 36 606 -48 b 484 -71 507 -70 495 -71 b 327 43 415 -71 351 -26 b 322 70 324 52 322 61 b 387 134 322 106 348 134 b 451 86 419 134 440 118 b 537 13 466 41 501 13 b 563 18 545 13 554 15 b 600 78 587 29 600 49 b 598 98 600 84 599 91 b 374 353 582 192 493 293 b 352 363 364 358 354 363 l 349 365 l 348 363 b 235 192 347 361 315 313 b 160 77 214 160 180 109 b 103 -9 139 46 113 7 b 75 -47 81 -42 80 -43 b 60 -51 70 -50 65 -51 b 33 -24 46 -51 33 -40 b 33 -22 33 -23 33 -23 b 55 19 33 -14 33 -14 b 259 329 84 63 162 181 b 297 386 279 360 296 385 l 298 388 l 290 392 b 92 594 200 441 130 512 b 62 728 71 639 62 685 b 218 934 62 834 121 922 z m 630 616 b 643 618 634 617 639 618 b 699 589 665 618 687 607 b 709 552 706 578 709 565 b 699 515 709 539 706 526 b 644 486 686 496 665 486 b 596 507 626 486 609 493 b 578 551 584 520 578 536 b 630 616 578 581 598 609 z m 62 376 b 75 378 67 377 71 378 b 124 357 93 378 112 370 b 142 312 136 344 142 328 b 131 275 142 299 138 286 b 76 246 118 256 97 246 b 28 267 59 246 41 253 b 11 311 16 280 11 296 b 62 376 11 341 30 369 z"
                },
                coda: {
                    x_min: 22,
                    x_max: 478,
                    y_min: -31,
                    y_max: 531,
                    ha: 563,
                    o: "m 350 764 b 359 765 352 765 355 765 b 367 764 362 765 365 765 b 381 753 373 762 378 758 b 386 706 386 746 386 747 b 387 670 386 672 386 670 b 448 647 396 670 430 657 b 597 395 532 601 587 507 l 598 386 l 632 386 b 677 382 670 386 670 386 b 689 359 685 376 689 367 b 677 336 689 350 685 341 b 632 331 670 331 670 331 l 598 331 l 597 322 b 396 50 585 186 504 77 b 387 48 392 49 388 48 b 386 12 386 48 386 46 l 386 8 b 380 -36 386 -29 386 -28 b 359 -45 375 -42 367 -45 b 338 -36 351 -45 342 -42 b 331 8 331 -28 331 -29 l 331 12 b 330 48 331 46 331 48 b 269 70 321 48 288 60 b 120 322 186 117 130 210 l 119 331 l 86 331 b 43 336 50 331 50 331 b 31 359 35 341 31 350 b 50 385 31 370 38 381 b 86 386 53 386 60 386 l 119 386 l 120 395 b 269 647 130 508 186 601 b 330 670 288 657 321 670 b 331 706 331 670 331 672 b 332 746 331 736 332 744 b 350 764 335 754 342 762 z m 331 502 b 331 617 331 565 331 617 b 310 599 329 617 317 607 b 229 393 266 555 235 477 l 229 386 l 280 386 l 331 386 z m 393 613 b 386 617 390 615 387 617 b 386 502 386 617 386 565 l 386 386 l 437 386 l 488 386 l 488 393 b 393 613 482 486 443 575 z m 331 216 l 331 331 l 280 331 l 229 331 l 229 324 b 310 118 235 241 266 162 b 331 100 317 111 329 100 b 331 216 331 100 331 152 z m 488 324 l 488 331 l 437 331 l 386 331 l 386 216 b 386 100 386 152 386 100 b 408 118 388 100 400 111 b 488 324 452 162 482 241 z"
                },
                gClef: {
                    x_min: 0,
                    x_max: 623,
                    y_min: -632,
                    y_max: 1082,
                    ha: 1713,
                    o: "m 521 1558 b 524 1558 522 1558 523 1558 b 579 1515 537 1558 556 1543 b 718 1118 662 1415 718 1254 b 717 1089 718 1108 718 1098 b 505 667 707 930 639 793 b 470 633 493 655 477 640 l 456 620 l 483 495 b 510 369 498 426 510 369 b 510 369 510 369 510 369 b 519 370 511 369 514 370 b 558 372 525 371 542 372 b 590 371 572 372 585 371 b 897 45 760 350 885 217 b 898 22 897 38 898 30 b 666 -316 898 -120 805 -256 b 657 -320 661 -318 657 -320 b 675 -403 657 -320 665 -357 b 695 -500 685 -448 694 -491 b 704 -596 701 -534 704 -566 b 642 -796 704 -677 683 -744 b 407 -909 582 -871 495 -909 b 176 -804 323 -909 238 -874 b 137 -704 150 -774 137 -739 b 168 -612 137 -672 147 -640 b 291 -550 198 -571 245 -550 b 405 -604 333 -550 376 -568 b 437 -694 427 -632 437 -663 b 305 -834 437 -764 384 -831 l 294 -835 l 298 -836 b 405 -861 330 -853 367 -861 b 539 -823 453 -861 501 -848 b 655 -596 617 -774 655 -699 b 644 -490 655 -564 651 -528 b 611 -336 640 -471 611 -336 b 611 -336 611 -336 611 -336 b 598 -339 610 -336 605 -337 b 536 -349 579 -343 558 -347 b 498 -350 529 -350 514 -350 b 449 -349 478 -350 457 -350 b 0 149 189 -320 0 -110 b 102 460 0 264 33 364 b 342 742 175 562 250 650 l 374 774 l 360 839 b 342 922 352 874 344 912 b 321 1024 329 983 323 1013 b 312 1124 315 1057 312 1091 b 477 1523 312 1275 371 1420 b 521 1558 501 1546 513 1556 z m 591 1349 b 574 1351 586 1350 580 1351 b 471 1297 542 1351 506 1332 b 376 1044 410 1236 376 1145 b 383 967 376 1019 378 993 b 415 814 385 956 414 814 b 415 814 415 814 415 814 b 460 860 416 814 450 848 b 644 1242 578 991 644 1132 b 639 1295 644 1261 643 1278 b 591 1349 632 1327 618 1342 z m 418 565 b 415 577 417 571 416 577 b 290 431 412 577 327 479 b 160 220 210 331 182 284 b 135 74 143 172 135 122 b 209 -162 135 -11 160 -94 b 495 -314 278 -259 385 -314 b 550 -310 514 -314 532 -313 b 602 -296 570 -306 602 -298 b 574 -164 602 -295 590 -236 b 522 81 559 -92 535 18 b 497 196 508 144 497 196 b 497 196 497 196 497 196 b 457 179 493 196 469 186 b 358 16 391 144 358 79 b 438 -128 358 -40 384 -95 b 455 -151 449 -135 455 -143 b 448 -165 455 -156 452 -160 b 434 -172 444 -169 440 -172 b 401 -159 427 -172 417 -168 b 256 82 305 -110 256 -15 b 386 322 256 172 299 264 b 462 358 408 337 453 358 b 462 359 462 358 462 358 b 462 360 462 359 462 359 b 418 565 462 362 422 547 z m 581 203 b 558 204 576 204 565 204 l 545 204 l 546 202 b 589 -1 546 201 565 109 b 634 -214 613 -112 633 -208 b 642 -251 636 -220 639 -237 l 648 -277 l 651 -275 b 776 -137 710 -241 752 -195 b 795 -42 789 -106 795 -73 b 581 203 795 78 707 188 z"
                },
                cClef: {
                    x_min: 0,
                    x_max: 643,
                    y_min: -508,
                    y_max: 508,
                    ha: 1016,
                    o: "m 0 0 l 0 731 l 87 731 l 175 731 l 175 0 l 175 -731 l 87 -731 l 0 -731 z m 240 0 l 240 731 l 262 731 l 284 731 l 284 382 l 284 32 l 291 38 b 374 145 318 61 351 104 b 439 314 402 196 423 251 b 458 341 444 338 447 341 b 475 319 470 341 474 335 b 647 120 483 206 560 120 b 665 122 653 120 659 121 b 771 330 741 132 766 181 b 772 404 772 357 772 381 b 707 662 772 557 753 630 b 615 687 684 679 651 687 b 517 666 582 687 548 680 b 504 660 509 663 504 660 b 504 660 504 660 504 660 b 578 578 545 658 578 621 b 578 575 578 577 578 576 b 492 494 576 524 534 494 b 419 534 465 494 437 506 b 403 584 408 550 403 567 b 434 651 403 608 413 632 b 616 721 485 698 550 721 b 884 565 720 721 826 665 b 925 406 912 515 925 460 b 719 99 925 272 846 140 b 648 87 694 91 671 87 b 543 122 610 87 576 99 b 536 126 540 124 536 126 b 535 126 535 126 535 126 b 497 63 535 126 518 98 l 459 0 l 497 -63 b 535 -126 518 -98 535 -126 b 536 -126 535 -126 535 -126 b 543 -122 536 -126 540 -124 b 648 -87 575 -99 610 -87 b 677 -89 657 -87 667 -88 b 924 -382 811 -110 913 -230 b 925 -407 925 -391 925 -399 b 639 -720 925 -570 803 -706 b 615 -721 631 -720 623 -721 b 430 -647 545 -721 478 -694 b 403 -585 412 -629 403 -607 b 492 -494 403 -538 439 -494 b 497 -494 493 -494 495 -494 b 578 -578 545 -496 578 -536 b 564 -625 578 -594 574 -610 b 504 -660 551 -644 525 -659 b 504 -660 504 -660 504 -660 b 517 -666 504 -660 509 -663 b 615 -687 548 -680 582 -687 b 707 -662 651 -687 684 -679 b 772 -404 753 -630 772 -557 b 771 -330 772 -381 772 -357 b 665 -122 766 -181 741 -132 b 647 -120 659 -121 653 -120 b 475 -319 560 -120 483 -206 b 458 -341 474 -335 470 -341 b 439 -314 447 -341 444 -338 b 374 -145 423 -251 402 -196 b 291 -38 351 -104 317 -61 l 284 -32 l 284 -382 l 284 -731 l 262 -731 l 240 -731 z"
                },
                fClef: {
                    x_min: 0,
                    x_max: 661,
                    y_min: -545,
                    y_max: 254,
                    ha: 798,
                    o: "m 326 364 b 356 365 336 365 346 365 b 647 278 464 365 575 332 b 788 -2 740 207 788 112 b 785 -51 788 -18 787 -34 b 161 -747 750 -356 500 -634 b 16 -784 110 -764 31 -784 b 0 -768 7 -784 0 -778 b 24 -747 0 -758 3 -755 b 601 -72 353 -625 575 -364 b 603 -10 602 -51 603 -30 b 469 298 603 133 556 243 b 346 332 432 321 389 332 b 100 185 248 332 146 277 b 89 161 97 178 89 162 b 89 161 89 161 89 161 b 95 164 90 161 92 162 b 169 185 118 179 144 185 b 308 74 232 185 293 142 b 311 42 310 63 311 53 b 167 -101 311 -36 248 -101 b 147 -99 161 -101 154 -100 b 9 79 65 -88 9 -15 l 9 79 b 326 364 9 228 148 353 z m 888 225 b 894 225 889 225 891 225 b 914 223 901 225 910 224 b 952 171 940 214 952 192 b 914 118 952 149 939 127 b 898 116 910 117 904 116 b 881 118 892 116 886 117 b 843 170 856 127 843 149 b 888 225 843 195 859 219 z m 888 -116 b 894 -116 889 -116 891 -116 b 914 -118 901 -116 910 -117 b 952 -170 940 -127 952 -149 b 914 -223 952 -192 939 -214 b 898 -225 910 -224 904 -225 b 881 -223 892 -225 886 -224 b 843 -171 856 -214 843 -193 b 888 -116 843 -146 859 -122 z"
                },
                unpitchedPercussionClef1: {
                    x_min: -4,
                    x_max: 337,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m -6 0 l -6 360 l 75 360 l 157 360 l 157 0 l 157 -360 l 75 -360 l -6 -360 z m 321 0 l 321 360 l 403 360 l 485 360 l 485 0 l 485 -360 l 403 -360 l 321 -360 z"
                },
                "6stringTabClef": {
                    x_min: 0,
                    x_max: 501,
                    y_min: -735,
                    y_max: 753,
                    ha: 1487,
                    o: "m 633 1083 b 639 1084 635 1084 637 1084 b 669 1072 650 1084 661 1079 b 681 1043 677 1063 681 1053 b 657 1004 681 1028 673 1013 b 467 964 609 980 535 964 l 452 964 l 452 959 b 456 874 455 932 456 903 b 418 611 456 781 443 686 b 245 415 380 495 327 435 b 195 409 228 411 214 409 b 147 412 182 409 167 410 b 110 453 124 414 110 433 b 122 482 110 464 114 474 b 151 494 130 490 141 494 b 184 478 163 494 175 489 b 194 475 186 476 190 475 b 224 486 202 475 213 479 b 283 575 246 500 263 527 b 335 871 317 657 335 760 b 331 967 335 903 334 935 l 330 980 l 321 982 b 260 992 301 989 280 992 b 139 927 206 992 160 968 b 90 895 128 906 109 895 b 42 933 70 895 49 908 b 40 947 40 937 40 942 b 105 1020 40 972 61 996 b 263 1058 150 1045 207 1058 b 350 1047 293 1058 323 1054 b 465 1030 389 1036 429 1030 b 612 1073 526 1030 579 1045 b 633 1083 618 1078 625 1082 z m 441 376 b 448 376 443 376 445 376 b 470 374 456 376 465 375 b 511 321 494 366 509 346 b 534 155 515 283 525 210 b 621 -190 556 21 589 -109 b 668 -253 632 -220 651 -245 l 672 -254 l 676 -253 b 687 -252 680 -252 683 -252 b 721 -287 707 -252 721 -269 b 705 -316 721 -298 716 -309 b 676 -321 699 -320 689 -321 b 650 -319 668 -321 659 -321 b 506 -206 588 -312 533 -269 b 444 0 487 -163 460 -72 b 441 8 443 4 441 8 b 441 8 441 8 441 8 b 436 -3 441 7 438 2 b 381 -99 422 -33 400 -72 b 375 -109 377 -105 375 -107 b 381 -114 375 -111 377 -112 b 435 -133 398 -126 415 -132 b 452 -138 446 -134 448 -134 b 457 -150 455 -141 457 -145 b 446 -166 457 -156 453 -163 b 406 -174 434 -171 420 -174 b 344 -160 385 -174 363 -169 l 337 -156 l 334 -159 b 49 -314 250 -255 145 -311 b 39 -315 45 -315 42 -315 b 10 -305 23 -315 18 -312 b 0 -281 3 -298 0 -290 b 34 -247 0 -264 14 -247 b 40 -248 36 -247 38 -247 b 46 -248 42 -248 44 -248 b 144 -208 69 -248 108 -233 b 390 306 283 -115 381 90 b 394 334 391 320 392 328 b 441 376 401 356 419 372 z m 376 -371 b 408 -371 383 -371 395 -371 b 451 -372 425 -371 444 -371 b 529 -388 482 -376 502 -380 b 689 -546 621 -417 689 -484 b 563 -696 689 -599 639 -658 l 552 -701 l 561 -705 b 700 -882 646 -748 700 -818 b 699 -896 700 -887 700 -892 b 503 -1054 689 -974 608 -1039 b 451 -1058 486 -1057 468 -1058 b 272 -1010 389 -1058 329 -1042 b 248 -972 257 -1001 248 -987 b 249 -963 248 -969 248 -966 l 250 -959 l 249 -960 b 241 -966 248 -961 244 -964 b 124 -1015 208 -992 168 -1009 b 90 -1017 118 -1016 104 -1017 b 48 -1015 72 -1017 52 -1016 b 19 -977 30 -1009 19 -993 b 31 -949 19 -967 23 -957 b 59 -937 39 -941 49 -937 b 85 -947 68 -937 77 -941 l 88 -951 l 94 -951 b 210 -845 134 -951 183 -906 b 220 -821 212 -840 216 -830 b 286 -526 264 -724 286 -623 b 283 -469 286 -507 285 -488 b 282 -459 283 -463 282 -459 b 282 -459 282 -459 282 -459 b 256 -469 281 -459 266 -464 b 141 -563 201 -491 160 -526 b 94 -592 130 -583 112 -592 b 43 -540 68 -592 43 -573 b 88 -476 43 -518 51 -505 b 376 -371 158 -418 261 -381 z m 432 -437 b 411 -437 427 -437 418 -437 l 399 -437 l 400 -440 b 406 -505 402 -448 405 -478 b 407 -527 407 -512 407 -520 b 334 -840 407 -628 382 -737 b 284 -925 315 -881 304 -901 b 280 -930 281 -928 280 -929 b 281 -930 280 -930 280 -930 b 284 -930 281 -930 282 -930 b 291 -929 286 -929 288 -929 b 320 -941 300 -929 310 -933 b 452 -991 362 -975 405 -991 l 452 -991 b 580 -883 531 -991 580 -941 b 538 -791 580 -852 566 -820 b 421 -733 508 -761 470 -742 b 392 -715 405 -730 397 -724 b 388 -698 389 -709 388 -703 b 420 -665 388 -681 401 -667 b 567 -563 490 -658 555 -613 b 569 -546 568 -557 569 -552 b 432 -437 569 -493 510 -444 z"
                },
                timeSig0: {
                    x_min: 0,
                    x_max: 380,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 249 313 b 272 314 256 314 264 314 b 428 259 325 314 385 293 b 547 0 505 196 547 105 b 544 -49 547 -16 546 -32 b 273 -314 526 -197 407 -314 b 32 -149 175 -314 81 -250 b 0 0 11 -105 0 -53 b 32 150 0 53 11 106 b 249 313 78 242 158 302 z m 293 279 b 273 281 286 280 280 281 b 203 251 242 281 216 270 b 170 -3 185 224 170 102 b 172 -59 170 -23 171 -42 b 203 -251 178 -163 189 -231 b 273 -281 216 -270 243 -281 b 306 -277 284 -281 295 -280 b 366 -160 344 -267 356 -243 b 376 0 373 -103 376 -51 b 366 160 376 51 373 103 b 293 279 355 250 341 272 z m 273 -360 l 275 -360 l 272 -360 z m 273 340 l 275 340 l 272 340 z"
                },
                timeSig1: {
                    x_min: 0,
                    x_max: 254,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 135 302 b 210 303 137 303 141 303 b 235 303 219 303 228 303 b 290 298 290 303 286 303 b 295 70 295 293 295 314 b 300 -219 295 -201 295 -202 b 352 -269 307 -239 324 -255 b 366 -287 361 -274 366 -280 b 361 -298 366 -291 364 -295 b 266 -303 357 -303 367 -303 b 210 -303 250 -303 232 -303 b 154 -303 188 -303 170 -303 b 59 -298 53 -303 63 -303 b 54 -287 55 -295 54 -291 b 68 -269 54 -280 59 -274 b 120 -219 96 -255 113 -239 b 125 -50 124 -205 125 -193 b 125 24 125 -29 125 -4 l 125 189 l 120 181 b 90 136 116 176 103 156 b 48 72 77 116 58 87 b 16 38 26 38 26 38 b 0 54 6 38 0 45 b 0 56 0 55 0 55 l 0 60 l 64 178 b 135 302 128 296 130 299 z m 183 -360 l 184 -360 l 182 -360 z m 183 340 l 184 340 l 182 340 z"
                },
                timeSig2: {
                    x_min: 0,
                    x_max: 337,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 210 313 b 232 314 217 314 224 314 b 317 303 261 314 293 310 b 459 147 407 277 459 217 b 441 77 459 124 453 101 b 258 -67 409 10 349 -37 b 76 -181 173 -95 117 -130 l 73 -185 l 77 -182 b 226 -128 121 -146 174 -128 b 322 -152 260 -128 293 -136 b 378 -173 346 -165 359 -170 b 395 -174 383 -174 389 -174 b 454 -149 421 -174 446 -164 b 470 -139 457 -142 464 -139 b 486 -155 478 -139 486 -145 b 462 -217 486 -165 474 -197 b 319 -313 428 -276 373 -313 l 318 -313 b 273 -300 296 -313 290 -311 b 133 -256 226 -271 178 -256 b 93 -260 119 -256 106 -257 b 32 -294 68 -265 41 -280 b 15 -303 28 -300 21 -303 b 1 -292 9 -303 3 -299 b 0 -284 0 -291 0 -288 b 6 -234 0 -271 3 -249 b 180 -36 28 -147 90 -75 b 303 122 246 -7 290 50 b 305 146 305 130 305 138 b 272 225 305 177 294 204 b 185 259 249 248 220 259 b 163 257 178 259 170 258 b 152 256 155 257 152 256 b 155 253 152 255 153 254 b 191 188 180 238 191 213 b 138 112 191 156 173 124 b 112 108 129 109 120 108 b 29 191 67 108 29 146 b 33 214 29 199 30 206 b 210 313 46 263 122 305 z m 243 -360 l 244 -360 l 241 -360 z m 243 340 l 244 340 l 241 340 z"
                },
                timeSig3: {
                    x_min: 0,
                    x_max: 302,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 179 313 b 209 314 189 314 199 314 b 429 163 327 314 429 247 b 282 29 429 110 369 56 l 272 26 l 275 25 b 430 -111 354 -1 413 -53 b 435 -147 433 -123 435 -136 b 268 -308 435 -222 369 -288 b 211 -314 249 -312 230 -314 b 24 -241 140 -314 72 -288 b 0 -185 7 -224 0 -204 b 82 -100 0 -142 35 -100 b 97 -101 87 -100 92 -100 b 162 -180 140 -109 162 -145 b 113 -251 162 -209 146 -239 b 110 -253 111 -252 110 -252 b 120 -256 110 -253 113 -254 b 164 -261 136 -260 150 -261 b 248 -228 197 -261 226 -250 b 281 -145 270 -206 281 -178 b 278 -112 281 -135 280 -123 b 157 10 264 -42 215 7 b 135 27 141 11 135 16 b 157 44 135 39 141 43 b 272 137 210 47 257 85 b 276 162 275 145 276 154 b 194 256 276 206 244 245 b 167 258 188 258 178 258 b 124 255 152 258 136 257 l 119 254 l 123 252 b 162 186 149 238 162 212 b 108 110 162 154 144 121 b 83 105 100 107 91 105 b 0 189 37 105 0 144 b 8 224 0 200 3 212 b 179 313 28 266 103 305 z m 217 -360 l 219 -360 l 216 -360 z m 217 340 l 219 340 l 216 340 z"
                },
                timeSig4: {
                    x_min: 0,
                    x_max: 345,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 184 302 b 304 303 186 303 247 303 b 403 302 354 303 401 303 b 412 286 409 299 412 294 b 392 256 412 280 411 278 b 260 108 374 236 318 173 b 222 67 243 89 226 71 b 165 3 218 62 193 34 b 90 -82 138 -28 104 -66 b 65 -111 77 -97 65 -110 b 64 -111 64 -111 64 -111 b 160 -112 64 -112 74 -112 l 257 -112 l 257 -43 b 259 27 257 24 257 25 b 307 82 259 28 281 53 b 373 156 332 110 362 144 b 409 188 402 189 401 188 b 425 179 416 188 422 185 b 426 32 426 176 426 171 l 426 -112 l 452 -112 b 481 -113 476 -112 477 -112 b 494 -134 489 -116 494 -125 b 488 -149 494 -139 492 -145 b 452 -156 482 -155 481 -156 l 426 -156 l 426 -162 b 427 -183 427 -165 427 -175 b 484 -269 428 -227 441 -248 b 497 -287 493 -274 497 -280 b 493 -298 497 -291 496 -295 b 397 -303 488 -303 499 -303 b 341 -303 382 -303 363 -303 b 285 -303 320 -303 301 -303 b 190 -298 184 -303 195 -303 b 185 -287 187 -295 185 -291 b 199 -269 185 -280 190 -274 b 256 -183 242 -248 255 -227 b 256 -162 256 -175 256 -165 l 257 -156 l 135 -156 b 90 -156 117 -156 102 -156 b 5 -151 2 -156 9 -155 b 0 -140 2 -148 0 -144 b 9 -122 0 -135 3 -129 b 174 272 110 -9 170 134 b 184 302 175 295 176 298 z m 249 -360 l 250 -360 l 247 -360 z m 249 340 l 250 340 l 247 340 z"
                },
                timeSig5: {
                    x_min: 0,
                    x_max: 302,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 51 302 b 57 303 53 302 55 303 b 71 300 61 303 65 302 b 224 275 117 283 170 275 b 391 300 279 275 336 283 b 406 303 398 302 402 303 b 417 298 411 303 414 301 b 421 288 420 295 421 292 b 411 260 421 282 418 274 b 278 157 378 194 340 165 b 226 154 262 155 244 154 b 78 175 177 154 124 161 b 66 179 72 177 66 179 b 56 64 66 178 56 68 b 56 64 56 64 56 64 b 56 64 56 64 56 64 b 63 67 57 64 60 65 b 159 96 89 81 124 92 b 201 98 168 97 185 98 b 227 97 212 98 222 98 b 434 -104 351 80 434 -1 l 434 -105 b 239 -312 434 -208 353 -294 b 212 -314 230 -313 221 -314 b 23 -229 148 -314 76 -282 b 0 -174 7 -213 0 -193 b 82 -89 0 -131 35 -89 b 97 -90 87 -89 92 -89 b 162 -168 140 -98 162 -133 b 108 -242 162 -199 145 -230 l 102 -244 l 109 -247 b 159 -259 127 -255 143 -259 b 215 -241 178 -259 197 -253 b 281 -99 258 -212 281 -161 b 277 -51 281 -84 280 -68 b 211 62 267 6 241 51 l 205 64 l 189 64 b 57 24 142 64 96 50 b 37 14 43 14 42 14 b 20 30 26 14 20 20 b 43 293 20 41 42 290 b 51 302 44 297 48 300 z m 222 -276 b 222 -276 222 -276 222 -276 b 218 -277 221 -276 221 -276 b 216 -279 217 -278 216 -279 b 216 -279 216 -279 216 -279 b 222 -276 217 -279 222 -276 z m 217 -360 l 219 -360 l 216 -360 z m 217 340 l 219 340 l 216 340 z"
                },
                timeSig6: {
                    x_min: 0,
                    x_max: 349,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 272 313 b 295 314 278 314 286 314 b 350 308 314 314 336 312 b 473 226 402 295 458 259 b 481 191 479 215 481 203 b 399 108 481 147 444 108 b 373 112 390 108 382 109 b 319 187 337 124 319 156 b 372 260 319 218 337 249 b 378 263 375 262 378 263 b 378 263 378 263 378 263 b 347 275 378 264 358 271 b 305 280 333 278 319 280 b 220 242 270 280 239 267 b 178 110 201 217 187 173 b 170 31 175 88 170 41 b 170 29 170 30 170 29 b 170 29 170 29 170 29 b 180 32 171 29 175 30 b 273 52 213 45 243 52 b 364 33 302 52 332 45 b 487 -64 422 11 466 -24 b 502 -128 497 -83 502 -105 b 479 -208 502 -156 494 -185 b 272 -314 439 -268 345 -314 b 239 -310 260 -314 249 -313 b 9 -77 129 -284 35 -188 b 0 6 3 -53 0 -23 b 5 65 0 26 2 47 b 272 313 27 193 137 296 z m 290 17 b 273 19 284 18 279 19 b 227 2 254 19 236 13 b 198 -122 209 -17 198 -69 b 201 -175 198 -140 199 -158 b 274 -280 214 -258 229 -280 l 274 -280 b 341 -193 315 -280 329 -262 b 349 -123 346 -166 349 -145 b 344 -66 349 -105 347 -87 b 290 17 334 -9 321 12 z m 251 -360 l 253 -360 l 250 -360 z m 251 340 l 253 340 l 250 340 z"
                },
                timeSig7: {
                    x_min: 0,
                    x_max: 326,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 162 314 b 179 315 168 315 174 315 b 333 260 232 315 290 294 b 361 249 343 252 350 249 b 370 250 364 249 367 249 b 435 291 395 253 417 267 b 453 303 442 299 447 303 b 460 302 455 303 457 303 b 469 288 466 299 469 296 b 456 233 469 279 465 263 b 369 16 433 146 396 56 b 290 -268 322 -53 293 -159 b 280 -302 289 -295 289 -298 b 192 -303 278 -303 235 -303 b 105 -302 150 -303 107 -303 b 96 -281 98 -298 96 -294 b 96 -280 96 -280 96 -280 b 178 -54 96 -212 128 -124 b 279 57 207 -12 235 18 b 399 198 335 107 368 146 b 404 207 402 204 404 206 b 403 207 404 207 404 207 b 400 205 403 207 402 206 b 258 155 357 172 306 155 b 132 201 212 155 167 171 b 90 222 117 215 103 222 b 58 201 78 222 67 215 b 33 141 49 187 41 168 b 16 128 30 133 23 128 b 1 138 10 128 4 131 b 0 216 0 140 0 178 b 1 293 0 253 0 291 b 15 303 4 300 9 303 b 30 298 20 303 25 301 b 52 289 37 292 43 289 b 96 300 62 289 75 293 b 162 314 124 309 140 312 z m 234 -360 l 236 -360 l 233 -360 z m 234 340 l 236 340 l 233 340 z"
                },
                timeSig8: {
                    x_min: 0,
                    x_max: 360,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 246 314 b 260 314 252 314 258 314 b 261 314 261 314 261 314 b 275 313 263 314 269 314 b 399 276 317 312 363 298 b 486 136 456 242 486 189 b 441 29 486 99 471 61 l 435 23 l 441 19 b 518 -119 492 -16 518 -67 b 483 -217 518 -153 507 -187 b 259 -314 435 -279 349 -314 b 138 -291 218 -314 176 -307 b 0 -118 48 -256 0 -187 b 76 18 0 -69 25 -20 l 83 23 l 77 30 b 32 137 48 61 32 99 b 42 189 32 155 36 172 b 246 314 70 260 152 310 z m 282 267 b 260 269 276 269 268 269 b 228 266 249 269 237 268 b 168 214 192 258 168 235 b 171 202 168 210 169 206 b 354 62 190 162 270 101 l 359 60 l 362 65 b 380 136 375 88 380 112 b 282 267 380 196 342 254 z m 148 -20 b 139 -16 144 -18 139 -16 b 139 -16 139 -16 139 -16 b 119 -36 137 -16 124 -29 b 91 -118 100 -62 91 -90 b 188 -255 91 -174 126 -229 b 257 -269 210 -265 234 -269 b 356 -229 298 -269 336 -255 b 368 -196 364 -218 368 -208 b 350 -151 368 -183 362 -168 b 166 -28 317 -101 256 -61 b 148 -20 161 -26 153 -23 z m 259 -360 l 261 -360 l 258 -360 z m 259 340 l 261 340 l 258 340 z"
                },
                timeSig9: {
                    x_min: 0,
                    x_max: 349,
                    y_min: -250,
                    y_max: 236,
                    ha: 486,
                    o: "m 208 313 b 227 314 214 314 220 314 b 332 284 259 314 295 304 b 497 61 420 236 480 155 b 503 -4 501 42 503 19 b 498 -65 503 -26 501 -47 b 279 -303 479 -176 393 -269 b 204 -314 253 -310 228 -314 b 98 -287 166 -314 130 -305 b 25 -216 58 -265 33 -241 b 22 -191 23 -208 22 -199 b 104 -108 22 -146 59 -108 b 130 -112 112 -108 121 -109 b 184 -187 166 -124 184 -156 b 131 -260 184 -218 166 -249 b 125 -263 128 -262 125 -263 b 125 -263 125 -263 125 -263 b 156 -275 125 -264 144 -271 b 197 -280 170 -278 184 -280 b 279 -247 231 -280 260 -269 b 324 -117 300 -223 313 -182 b 333 -31 328 -93 333 -42 b 332 -29 333 -30 333 -29 b 332 -29 332 -29 332 -29 b 323 -32 332 -29 328 -30 b 230 -52 289 -45 260 -52 b 173 -44 211 -52 192 -49 b 23 50 108 -27 51 9 b 0 128 8 74 0 101 b 34 222 0 161 11 194 b 208 313 70 266 142 304 z m 248 278 b 231 281 243 280 237 281 b 195 272 217 281 203 277 b 156 156 176 259 163 221 b 154 124 154 146 154 135 b 183 -2 154 72 166 16 b 230 -19 194 -13 212 -19 b 276 -2 248 -19 266 -13 b 305 122 294 17 305 69 b 301 175 305 140 304 158 b 248 278 290 246 278 270 z m 251 -360 l 253 -360 l 250 -360 z m 251 340 l 253 340 l 250 340 z"
                },
                timeSigCommon: {
                    x_min: 0,
                    x_max: 409,
                    y_min: -233,
                    y_max: 233,
                    ha: 466,
                    o: "m 315 334 b 343 336 324 335 334 336 b 558 227 431 336 512 296 b 575 174 570 210 575 192 b 475 74 575 122 533 74 b 472 74 474 74 473 74 b 380 167 417 76 380 120 b 402 225 380 187 387 207 b 469 256 418 244 444 256 b 484 254 474 256 479 255 b 487 254 485 254 487 254 b 488 254 488 254 488 254 b 479 260 488 254 485 256 b 346 302 439 289 398 302 l 345 302 b 154 -3 205 302 154 220 b 154 -3 154 -3 154 -3 b 316 -302 154 -225 195 -300 b 321 -302 318 -302 320 -302 b 556 -108 438 -302 536 -221 b 573 -87 558 -92 562 -87 b 589 -105 584 -87 589 -93 b 582 -144 589 -114 587 -127 b 393 -327 556 -233 484 -302 b 321 -336 371 -333 346 -336 b 248 -327 296 -336 271 -333 b 7 -69 125 -296 32 -196 b 0 -1 2 -46 0 -24 b 315 334 0 170 131 317 z"
                },
                timeSigCutCommon: {
                    x_min: 0,
                    x_max: 409,
                    y_min: -394,
                    y_max: 394,
                    ha: 788,
                    o: "m 308 566 b 316 568 311 567 314 568 b 337 554 325 568 334 562 b 338 446 338 550 338 549 l 338 341 l 355 341 b 558 232 437 339 514 298 b 575 179 570 216 575 197 b 475 79 575 128 533 79 b 472 79 474 79 473 79 b 380 172 417 81 380 126 b 402 231 380 192 387 213 b 469 261 418 250 444 261 b 484 260 474 261 479 261 b 487 259 485 259 487 259 b 488 259 488 259 488 259 b 479 266 488 260 485 262 b 354 307 442 292 400 306 l 338 308 l 338 6 l 338 -297 l 340 -296 b 347 -296 341 -296 344 -296 b 555 -103 449 -288 538 -205 b 573 -82 558 -87 562 -82 b 589 -100 584 -82 589 -87 b 582 -138 589 -109 587 -121 b 374 -326 554 -234 473 -307 b 342 -330 366 -327 356 -328 l 338 -330 l 338 -440 b 339 -489 338 -460 339 -476 b 332 -561 339 -563 338 -555 b 317 -568 328 -566 322 -568 b 296 -554 308 -568 299 -563 b 295 -440 295 -550 295 -549 l 295 -330 l 293 -329 b 282 -328 291 -329 287 -328 b 7 -63 146 -310 35 -203 b 0 4 2 -41 0 -18 b 259 331 0 156 103 291 b 294 338 269 333 292 338 b 295 444 295 338 295 385 b 296 554 295 549 295 550 b 308 566 298 559 303 564 z m 295 4 b 294 303 295 288 295 303 b 284 301 293 303 288 302 b 154 3 190 276 154 192 l 154 2 b 291 -295 154 -204 190 -283 l 295 -295 z"
                },
                timeSigPlus: {
                    x_min: 0,
                    x_max: 235,
                    y_min: -118,
                    y_max: 118,
                    ha: 235,
                    o: "m 159 168 b 169 169 162 169 166 169 b 198 153 180 169 192 163 b 202 97 202 146 202 147 l 202 87 l 202 33 l 257 33 l 267 33 b 322 29 317 33 315 33 b 339 0 333 22 339 11 b 323 -28 339 -11 333 -22 b 266 -33 315 -33 317 -33 l 257 -33 l 202 -33 l 202 -87 l 202 -97 b 198 -153 202 -148 202 -146 b 169 -169 191 -164 180 -169 b 141 -153 158 -169 147 -164 b 137 -97 137 -146 137 -147 l 137 -87 l 137 -33 l 82 -33 l 72 -33 b 16 -28 22 -33 23 -33 b 0 0 5 -22 0 -11 b 16 28 0 11 5 22 b 72 33 23 33 22 33 l 82 33 l 137 33 l 137 87 l 137 97 b 141 153 137 148 137 146 b 159 168 145 160 151 165 z"
                },
                timeSigPlusSmall: {
                    x_min: 0,
                    x_max: 235,
                    y_min: -118,
                    y_max: 118,
                    ha: 235,
                    o: "m 159 168 b 169 169 162 169 166 169 b 198 153 180 169 192 163 b 202 97 202 146 202 147 l 202 87 l 202 33 l 257 33 l 267 33 b 322 29 317 33 315 33 b 339 0 333 22 339 11 b 323 -28 339 -11 333 -22 b 266 -33 315 -33 317 -33 l 257 -33 l 202 -33 l 202 -87 l 202 -97 b 198 -153 202 -148 202 -146 b 169 -169 191 -164 180 -169 b 141 -153 158 -169 147 -164 b 137 -97 137 -146 137 -147 l 137 -87 l 137 -33 l 82 -33 l 72 -33 b 16 -28 22 -33 23 -33 b 0 0 5 -22 0 -11 b 16 28 0 11 5 22 b 72 33 23 33 22 33 l 82 33 l 137 33 l 137 87 l 137 97 b 141 153 137 148 137 146 b 159 168 145 160 151 165 z"
                },
                timeSigMinus: {
                    x_min: 0,
                    x_max: 235,
                    y_min: -23,
                    y_max: 23,
                    ha: 46,
                    o: "m 23 32 b 177 33 26 32 103 33 b 315 32 246 33 312 32 b 338 0 331 27 338 14 b 315 -32 338 -14 331 -27 b 169 -33 312 -33 241 -33 b 23 -32 98 -33 26 -33 b 0 0 8 -27 0 -14 b 23 32 0 13 8 26 z"
                },
                timeSigParensRight: {
                    x_min: 19,
                    x_max: 122,
                    y_min: -267,
                    y_max: 267,
                    ha: 535,
                    o: "m 36 384 b 44 385 38 385 41 385 b 65 367 52 385 55 383 b 176 0 139 251 176 126 b 65 -367 176 -125 139 -250 b 44 -385 56 -380 51 -385 b 36 -383 42 -385 39 -384 b 27 -370 30 -380 27 -377 b 33 -349 27 -365 29 -359 b 99 0 77 -242 99 -121 b 33 350 99 122 77 243 b 27 371 29 359 27 366 b 36 384 27 377 30 381 z"
                },
                timeSigParensRightSmall: {
                    x_min: 19,
                    x_max: 122,
                    y_min: -267,
                    y_max: 267,
                    ha: 535,
                    o: "m 36 384 b 44 385 38 385 41 385 b 65 367 52 385 55 383 b 176 0 139 251 176 126 b 65 -367 176 -125 139 -250 b 44 -385 56 -380 51 -385 b 36 -383 42 -385 39 -384 b 27 -370 30 -380 27 -377 b 33 -349 27 -365 29 -359 b 99 0 77 -242 99 -121 b 33 350 99 122 77 243 b 27 371 29 359 27 366 b 36 384 27 377 30 381 z"
                },
                timeSigParensLeft: {
                    x_min: -122,
                    x_max: -19,
                    y_min: -267,
                    y_max: 267,
                    ha: 534,
                    o: "m -51 383 b -44 385 -49 384 -46 385 b -29 375 -38 385 -31 381 b -27 369 -28 373 -27 372 b -33 349 -27 365 -29 360 b -98 54 -71 259 -91 167 b -99 0 -98 44 -99 22 b -98 -54 -99 -22 -98 -45 b -33 -349 -91 -167 -71 -259 b -27 -368 -28 -363 -27 -365 b -44 -385 -27 -378 -34 -385 b -65 -367 -52 -385 -55 -383 b -176 0 -139 -251 -176 -125 b -65 367 -176 125 -139 251 b -51 383 -57 379 -55 381 z"
                },
                timeSigParensLeftSmall: {
                    x_min: -122,
                    x_max: -19,
                    y_min: -267,
                    y_max: 267,
                    ha: 534,
                    o: "m -51 383 b -44 385 -49 384 -46 385 b -29 375 -38 385 -31 381 b -27 369 -28 373 -27 372 b -33 349 -27 365 -29 360 b -98 54 -71 259 -91 167 b -99 0 -98 44 -99 22 b -98 -54 -99 -22 -98 -45 b -33 -349 -91 -167 -71 -259 b -27 -368 -28 -363 -27 -365 b -44 -385 -27 -378 -34 -385 b -65 -367 -52 -385 -55 -383 b -176 0 -139 -251 -176 -125 b -65 367 -176 125 -139 251 b -51 383 -57 379 -55 381 z"
                },
                noteheadDoubleWhole: {
                    x_min: 0,
                    x_max: 663,
                    y_min: -174,
                    y_max: 174,
                    ha: 349,
                    o: "m 19 250 b 27 251 21 251 24 251 b 36 250 31 251 34 251 b 50 239 41 248 47 244 b 55 93 54 233 55 247 b 55 0 55 67 55 37 b 55 -93 55 -37 55 -67 b 50 -239 55 -247 54 -233 b 28 -251 45 -247 36 -251 b 1 -232 16 -251 5 -244 b 0 4 0 -230 0 -112 b 1 232 0 117 0 230 b 19 250 4 240 11 247 z m 117 250 b 126 251 119 251 122 251 b 134 250 129 251 132 251 b 152 232 142 247 149 240 b 153 128 153 229 153 214 b 154 31 153 48 153 31 b 154 31 154 31 154 31 b 417 191 176 112 281 176 b 478 194 437 193 458 194 b 801 31 636 194 776 127 b 801 31 801 31 801 31 b 802 128 802 31 802 48 b 805 237 802 235 802 232 b 830 251 811 246 821 251 b 852 239 839 251 847 247 b 857 93 857 233 857 247 b 857 0 857 67 857 37 b 857 -93 857 -37 857 -67 b 852 -239 857 -247 857 -233 b 830 -251 847 -247 838 -251 b 807 -239 821 -251 812 -247 b 802 -128 802 -232 802 -239 b 801 -31 802 -48 802 -31 b 801 -31 801 -31 801 -31 b 539 -191 779 -112 675 -176 b 477 -194 518 -193 498 -194 b 154 -31 319 -194 180 -127 b 154 -31 154 -31 154 -31 b 153 -128 153 -31 153 -48 b 148 -239 153 -239 153 -232 b 126 -251 143 -247 134 -251 b 99 -232 114 -251 103 -244 b 98 4 99 -230 98 -112 b 99 232 98 117 99 230 b 117 250 102 240 109 247 z m 458 168 b 439 169 452 169 445 169 b 332 44 375 169 332 116 b 344 -25 332 22 336 -1 b 517 -169 377 -116 452 -169 b 613 -101 558 -169 595 -148 b 623 -44 620 -83 623 -64 b 458 168 623 50 549 154 z m 919 250 b 928 251 921 251 924 251 b 936 250 931 251 934 251 b 951 239 942 248 947 244 b 955 93 955 233 955 247 b 955 0 955 67 955 36 b 955 -93 955 -37 955 -67 b 951 -239 955 -247 955 -233 b 928 -251 945 -247 937 -251 b 902 -232 917 -251 905 -244 b 900 4 901 -230 900 -112 b 901 232 900 117 901 230 b 919 250 904 240 911 247 z"
                },
                noteheadWhole: {
                    x_min: 0,
                    x_max: 455,
                    y_min: -135,
                    y_max: 135,
                    ha: 269,
                    o: "m 291 193 b 326 194 303 194 315 194 b 649 38 482 194 619 129 b 655 0 653 25 655 12 b 327 -194 655 -106 513 -194 b 0 0 144 -194 0 -109 b 291 193 0 100 124 182 z m 308 168 b 289 169 301 169 295 169 b 181 44 224 169 181 116 b 194 -26 181 22 185 -1 b 366 -169 226 -116 302 -169 b 463 -101 408 -169 445 -148 b 473 -45 470 -83 473 -64 b 308 168 473 50 398 154 z"
                },
                noteheadHalf: {
                    x_min: 0,
                    x_max: 316,
                    y_min: -135,
                    y_max: 135,
                    ha: 269,
                    o: "m 270 193 b 281 194 272 194 276 194 b 322 192 294 194 315 193 b 455 53 411 178 455 120 b 307 -156 455 -20 405 -104 b 166 -194 260 -182 211 -194 b 3 -81 84 -194 17 -153 b 0 -52 1 -72 0 -62 b 270 193 0 62 123 178 z m 388 139 b 372 141 383 140 378 141 b 99 -26 307 141 174 61 b 50 -116 68 -62 50 -96 b 60 -136 50 -125 53 -132 b 83 -141 66 -139 74 -141 b 367 40 152 -141 296 -52 b 405 115 392 72 405 98 b 388 139 405 127 399 135 z"
                },
                noteheadBlack: {
                    x_min: 0,
                    x_max: 316,
                    y_min: -135,
                    y_max: 135,
                    ha: 269,
                    o: "m 270 193 b 281 194 272 194 276 194 b 322 192 294 194 315 193 b 455 53 411 178 455 120 b 307 -156 455 -20 405 -104 b 166 -194 260 -182 211 -194 b 3 -81 84 -194 17 -153 b 0 -52 1 -72 0 -62 b 270 193 0 62 123 178 z"
                },
                noteheadXWhole: {
                    x_min: 0,
                    x_max: 440,
                    y_min: -133,
                    y_max: 133,
                    ha: 265,
                    o: "m 67 190 b 82 191 71 191 76 191 b 97 190 88 191 94 191 b 216 138 108 188 116 184 l 317 91 l 417 138 b 548 191 529 190 532 191 b 551 191 549 191 550 191 b 634 109 601 191 634 151 b 611 52 634 89 627 69 b 549 17 601 41 597 39 b 513 0 529 8 513 0 b 549 -17 513 0 529 -8 b 611 -52 597 -39 601 -41 b 634 -109 627 -69 634 -89 b 551 -191 634 -151 601 -191 b 548 -191 550 -191 549 -191 b 417 -138 532 -191 529 -190 l 317 -91 l 216 -138 b 86 -191 105 -190 102 -191 b 83 -191 85 -191 84 -191 b 0 -109 33 -191 0 -151 b 23 -52 0 -89 7 -69 b 85 -17 33 -41 37 -39 b 121 0 105 -8 121 0 b 85 17 121 0 105 8 b 23 52 37 39 33 41 b 0 109 7 69 0 89 b 67 190 0 146 26 182 z m 91 141 b 82 142 88 142 85 142 b 49 109 63 142 49 126 b 59 86 49 101 52 92 b 159 37 64 81 55 85 b 238 0 202 17 238 0 b 159 -37 238 0 202 -17 b 59 -86 55 -85 64 -81 b 49 -109 52 -92 49 -101 b 82 -142 49 -126 62 -142 l 82 -142 b 206 -88 91 -142 91 -141 b 317 -37 267 -60 317 -37 b 428 -88 317 -37 367 -60 b 551 -142 542 -141 543 -142 l 552 -142 b 584 -109 572 -142 584 -126 b 574 -86 584 -101 581 -92 b 475 -37 569 -81 578 -85 b 396 0 431 -17 396 0 b 475 37 396 0 431 17 b 574 86 578 85 569 81 b 584 109 581 92 584 101 b 552 142 584 126 572 142 l 551 142 b 428 88 543 142 542 141 b 317 37 367 60 317 37 b 206 88 317 37 267 60 b 91 141 145 117 93 140 z"
                },
                noteheadXHalf: {
                    x_min: 0,
                    x_max: 300,
                    y_min: -133,
                    y_max: 133,
                    ha: 265,
                    o: "m 60 189 b 76 191 65 190 71 191 b 118 179 91 191 106 187 b 169 138 121 177 144 159 l 216 100 l 262 138 b 325 185 312 179 314 181 b 355 191 335 189 345 191 b 431 115 397 191 431 156 b 426 86 431 105 430 96 b 372 29 419 69 415 64 b 337 0 353 14 337 0 b 372 -29 337 0 353 -14 b 426 -86 415 -64 419 -69 b 431 -115 430 -96 431 -105 b 355 -191 431 -156 397 -191 b 325 -185 345 -191 335 -189 b 262 -138 314 -181 312 -179 l 216 -100 l 169 -138 b 106 -185 120 -179 117 -181 b 76 -191 96 -189 86 -191 b 0 -115 35 -191 0 -156 b 6 -86 0 -105 2 -96 b 59 -29 12 -69 17 -64 b 94 0 78 -14 94 0 b 59 29 94 0 78 14 b 20 63 40 45 22 61 b 0 114 6 78 0 97 b 60 189 0 148 23 181 z m 88 140 b 77 142 85 141 81 142 b 56 133 69 142 61 139 b 49 115 51 128 49 121 b 55 98 49 109 51 103 b 114 48 56 96 82 74 b 171 0 146 22 171 0 b 114 -48 171 0 146 -22 b 55 -98 82 -74 56 -96 b 49 -114 51 -103 49 -109 b 65 -140 49 -125 55 -135 b 77 -142 68 -141 72 -142 b 88 -140 81 -142 85 -141 b 154 -87 91 -138 114 -120 b 216 -36 188 -59 216 -36 b 278 -87 216 -36 244 -59 b 343 -140 318 -120 341 -138 b 355 -142 346 -141 350 -142 b 367 -140 359 -142 364 -141 b 382 -114 377 -135 382 -125 b 377 -98 382 -109 381 -103 b 317 -48 376 -96 349 -74 b 260 0 286 -22 260 0 b 317 48 260 0 286 22 b 377 98 349 74 376 96 b 382 114 381 103 382 109 b 367 140 382 125 377 135 b 355 142 364 141 359 142 b 343 140 350 142 346 141 b 278 87 341 138 318 120 b 216 36 244 59 216 36 b 154 87 216 36 188 59 b 88 140 112 121 91 138 z"
                },
                noteheadXBlack: {
                    x_min: 0,
                    x_max: 300,
                    y_min: -133,
                    y_max: 133,
                    ha: 265,
                    o: "m 24 190 b 32 191 26 191 29 191 b 46 189 37 191 43 190 b 135 114 52 186 50 187 b 216 44 179 76 216 44 b 296 114 216 44 252 76 b 396 191 392 197 384 190 b 398 191 397 191 398 191 b 432 158 418 191 432 175 b 422 135 432 150 429 142 b 343 66 420 133 384 102 b 267 0 301 30 267 0 b 343 -66 267 0 301 -30 b 422 -135 384 -102 420 -133 b 432 -158 429 -142 432 -150 b 398 -191 432 -175 418 -191 b 396 -191 398 -191 397 -191 b 296 -114 384 -190 392 -197 b 216 -44 252 -76 216 -44 b 135 -114 216 -44 179 -76 b 35 -191 40 -197 48 -190 b 33 -191 35 -191 34 -191 b 0 -158 13 -191 0 -175 b 10 -135 0 -150 3 -142 b 89 -66 12 -133 48 -102 b 164 0 131 -30 164 0 b 89 66 164 0 131 30 b 10 135 48 102 12 133 b 0 158 3 142 0 150 b 24 190 0 172 9 186 z"
                },
                noteheadCircleX: {
                    x_min: 0,
                    x_max: 357,
                    y_min: -178,
                    y_max: 178,
                    ha: 357,
                    o: "m 242 256 b 256 257 249 257 253 257 b 270 256 260 257 263 257 b 514 0 412 248 514 131 b 496 -95 514 -31 508 -63 b 255 -257 454 -200 355 -257 b 61 -166 184 -257 112 -228 b 0 -2 19 -117 0 -58 b 242 256 0 126 96 248 z m 267 190 b 257 191 262 190 259 191 b 245 190 254 191 251 190 b 153 159 212 188 179 177 l 147 156 l 202 101 l 257 46 l 311 101 l 366 156 l 361 159 b 267 190 334 177 302 188 z m 155 -55 l 210 0 l 155 54 l 101 109 l 97 104 b 66 0 77 74 66 37 b 71 -44 66 -15 68 -30 b 97 -105 77 -66 86 -87 l 101 -110 z m 416 104 b 413 109 414 107 413 109 b 358 54 413 109 388 84 l 304 0 l 358 -55 l 413 -110 l 416 -105 b 447 0 437 -74 447 -37 b 416 104 447 36 437 73 z m 312 -102 b 257 -47 282 -72 257 -47 b 202 -102 257 -47 232 -72 l 147 -156 l 153 -160 b 257 -191 183 -180 220 -191 b 361 -160 294 -191 330 -180 l 366 -156 z"
                },
                noteheadTriangleUpWhole: {
                    x_min: 0,
                    x_max: 462,
                    y_min: -149,
                    y_max: 149,
                    ha: 297,
                    o: "m 326 213 b 333 214 327 214 330 214 b 355 194 342 214 344 212 b 647 -174 447 44 562 -101 b 659 -184 652 -178 657 -182 b 666 -198 664 -188 666 -193 b 650 -214 666 -207 660 -214 b 598 -200 645 -214 641 -213 b 333 -161 514 -174 423 -161 b 68 -200 242 -161 152 -174 b 16 -214 25 -213 20 -214 b 0 -198 7 -214 0 -208 b 12 -179 0 -190 1 -189 b 311 194 100 -106 216 40 b 326 213 320 208 322 211 z m 338 141 b 333 153 336 147 333 153 b 327 141 333 153 330 147 b 190 -130 285 41 232 -63 b 185 -138 187 -134 185 -138 b 185 -138 185 -138 185 -138 b 185 -138 185 -138 185 -138 b 195 -137 187 -138 190 -138 b 224 -134 201 -136 214 -135 b 333 -128 260 -130 296 -128 b 410 -131 359 -128 384 -129 b 470 -137 425 -132 454 -135 b 480 -138 475 -138 479 -138 b 481 -138 481 -138 481 -138 b 481 -138 481 -138 481 -138 b 478 -133 481 -138 479 -135 b 338 141 436 -67 381 40 z"
                },
                noteheadTriangleUpHalf: {
                    x_min: 0,
                    x_max: 323,
                    y_min: -149,
                    y_max: 149,
                    ha: 298,
                    o: "m 225 213 b 232 214 227 214 230 214 b 253 191 242 214 245 212 b 447 -169 316 42 385 -85 b 465 -198 461 -187 465 -193 b 463 -204 465 -200 464 -202 b 450 -214 461 -211 457 -214 b 431 -208 446 -214 439 -212 b 233 -162 368 -178 300 -162 b 33 -208 165 -162 97 -178 b 15 -214 25 -212 19 -214 b 5 -209 11 -214 8 -213 b 0 -199 2 -206 0 -203 b 9 -181 0 -194 3 -188 b 213 194 67 -109 149 42 b 225 213 218 208 220 211 z m 280 51 b 264 85 274 62 267 78 l 258 98 l 248 83 b 93 -135 201 9 143 -73 b 87 -143 90 -139 87 -143 b 87 -144 87 -144 87 -144 b 87 -144 87 -144 87 -144 b 94 -141 87 -144 90 -142 b 297 -98 162 -113 233 -98 b 354 -102 317 -98 336 -99 b 363 -104 359 -103 363 -104 b 363 -104 363 -104 363 -104 b 360 -97 363 -103 361 -101 b 280 51 337 -60 304 2 z"
                },
                noteheadTriangleUpBlack: {
                    x_min: 0,
                    x_max: 322,
                    y_min: -149,
                    y_max: 149,
                    ha: 297,
                    o: "m 224 213 b 232 214 226 213 229 214 b 250 197 241 214 244 211 b 277 135 269 152 270 149 b 288 111 280 127 285 117 b 336 12 296 92 330 23 b 344 -3 336 12 340 5 b 376 -60 360 -32 363 -38 b 452 -177 406 -112 430 -148 b 463 -198 463 -191 463 -191 b 447 -214 463 -208 458 -214 l 447 -214 l 441 -214 l 430 -208 b 232 -163 368 -178 300 -163 b 33 -208 163 -163 95 -178 l 22 -214 l 16 -214 l 16 -214 b 0 -198 6 -214 0 -208 b 11 -177 0 -191 0 -191 b 75 -81 29 -154 52 -120 b 119 -3 93 -52 102 -36 b 127 12 123 5 127 12 b 176 111 133 23 167 92 b 186 135 178 117 183 127 b 213 197 193 149 194 152 b 224 213 218 207 220 210 z"
                },
                noteheadDiamondWhole: {
                    x_min: 0,
                    x_max: 462,
                    y_min: -138,
                    y_max: 138,
                    ha: 277,
                    o: "m 326 198 b 333 199 328 199 330 199 b 350 189 340 199 342 198 b 638 20 417 112 517 53 b 654 16 645 19 652 17 b 666 0 662 14 666 7 b 654 -16 666 -7 662 -14 b 638 -20 652 -17 645 -19 b 352 -186 518 -53 419 -110 b 333 -199 342 -198 340 -199 b 316 -189 326 -199 324 -198 b 28 -20 249 -112 149 -53 b 12 -16 21 -19 14 -17 b 0 0 4 -14 0 -7 b 12 16 0 7 4 14 b 28 20 14 17 21 19 b 316 189 149 53 249 112 b 326 198 321 194 324 197 z m 338 143 b 333 149 335 146 333 149 b 328 143 333 149 331 146 b 172 4 290 85 233 35 b 165 0 168 2 165 0 b 172 -4 165 0 168 -2 b 328 -143 233 -35 290 -85 b 333 -149 331 -147 332 -149 b 335 -146 334 -149 334 -148 b 494 -4 370 -91 432 -35 b 501 0 498 -2 501 0 b 494 4 501 0 498 2 b 338 143 433 35 376 85 z"
                },
                noteheadDiamondHalf: {
                    x_min: 0,
                    x_max: 322,
                    y_min: -138,
                    y_max: 138,
                    ha: 277,
                    o: "m 225 198 b 232 199 227 199 229 199 b 251 183 240 199 243 197 b 445 19 295 109 362 52 b 464 0 461 13 464 10 b 447 -18 464 -9 460 -13 b 251 -183 365 -49 294 -109 b 232 -199 243 -197 240 -199 b 213 -183 224 -199 221 -197 b 19 -19 169 -109 102 -52 b 0 0 3 -13 0 -10 b 17 18 0 9 3 13 b 213 183 99 50 169 109 b 225 198 218 193 221 196 z m 255 119 b 251 122 253 121 252 122 b 244 114 250 122 249 120 b 98 -17 208 61 151 10 l 95 -19 l 98 -21 b 211 -120 138 -44 176 -78 b 213 -123 212 -122 212 -123 b 213 -122 213 -123 213 -122 b 366 17 244 -72 311 -11 l 369 19 l 366 21 b 255 119 327 44 283 82 z"
                },
                noteheadDiamondBlack: {
                    x_min: 0,
                    x_max: 322,
                    y_min: -138,
                    y_max: 138,
                    ha: 277,
                    o: "m 225 198 b 232 199 227 199 229 199 b 253 180 241 199 243 197 b 444 19 297 107 363 52 b 464 0 461 13 464 10 b 444 -19 464 -10 461 -13 b 253 -180 363 -52 297 -107 b 232 -199 243 -197 241 -199 b 211 -180 223 -199 221 -197 b 19 -19 167 -107 101 -52 b 0 0 3 -13 0 -10 b 19 19 0 10 3 13 b 211 180 101 52 167 107 b 225 198 219 194 221 196 z"
                },
                augmentationDot: {
                    x_min: -63,
                    x_max: 63,
                    y_min: -63,
                    y_max: 63,
                    ha: 126,
                    o: "m -18 89 b 0 90 -12 90 -6 90 b 90 0 49 90 90 49 b 89 -18 90 -6 90 -12 b -1 -90 79 -64 39 -90 b -70 -57 -26 -90 -52 -80 b -90 -1 -84 -40 -90 -20 b -18 89 -90 40 -63 79 z"
                },
                tremolo1: {
                    x_min: -252,
                    x_max: 216,
                    y_min: -185,
                    y_max: 148,
                    ha: 333,
                    o: "m 265 211 b 275 213 269 212 272 213 b 311 175 295 213 311 194 b 301 151 311 166 308 158 b 243 110 297 147 295 145 b 175 64 224 97 194 77 b 107 18 156 52 126 31 b 40 -27 89 6 58 -15 b -28 -73 21 -40 -9 -60 b -95 -119 -46 -86 -77 -106 b -162 -164 -113 -131 -144 -152 b -230 -210 -181 -177 -211 -197 b -285 -247 -249 -223 -274 -240 b -310 -263 -297 -255 -308 -263 b -326 -267 -315 -266 -321 -267 b -363 -230 -346 -267 -363 -250 b -357 -212 -363 -224 -361 -218 b -309 -174 -353 -205 -350 -202 b -203 -103 -287 -160 -240 -128 b -68 -11 -167 -78 -106 -37 b 67 80 -30 14 31 55 b 194 166 104 105 161 143 b 265 211 255 207 259 210 z"
                },
                flag8thUp: {
                    x_min: -17,
                    x_max: 234,
                    y_min: -745,
                    y_max: -4,
                    ha: 741,
                    o: "m -25 -167 l -25 -5 l -21 -5 b 1 -29 -9 -5 -3 -12 b 183 -326 32 -144 91 -241 b 336 -686 285 -421 336 -551 b 219 -1028 336 -802 298 -923 b 172 -1072 191 -1065 183 -1072 b 150 -1052 158 -1072 150 -1063 b 158 -1032 150 -1046 153 -1039 b 284 -707 241 -935 284 -818 b 185 -446 284 -610 251 -517 b -24 -328 144 -402 72 -361 b -25 -167 -24 -328 -25 -295 z"
                },
                flag8thDown: {
                    x_min: -15,
                    x_max: 271,
                    y_min: 4,
                    y_max: 745,
                    ha: 741,
                    o: "m 242 1071 b 252 1073 246 1072 249 1073 b 277 1051 260 1073 267 1066 b 390 687 352 938 390 810 b 343 464 390 609 374 533 b 248 331 319 413 285 365 b 60 125 166 256 110 194 b 0 21 35 90 10 47 b -19 5 -4 11 -12 5 l -22 5 l -22 167 l -22 328 l -17 328 b 105 350 13 328 69 338 b 334 722 241 396 334 547 b 240 1027 334 826 301 934 b 229 1050 230 1041 229 1044 b 242 1071 229 1060 234 1068 z"
                },
                flag16thUp: {
                    x_min: -17,
                    x_max: 234,
                    y_min: -847,
                    y_max: -4,
                    ha: 843,
                    o: "m -25 -151 l -25 -5 l -21 -5 b 0 -23 -11 -5 -5 -11 b 208 -289 31 -96 103 -189 b 336 -592 292 -369 336 -477 b 311 -740 336 -641 328 -691 l 308 -751 l 312 -762 b 336 -906 328 -808 336 -857 b 241 -1185 336 -1004 304 -1103 b 202 -1220 218 -1215 213 -1220 b 180 -1198 188 -1220 180 -1210 b 187 -1181 180 -1193 182 -1187 b 286 -923 252 -1106 286 -1015 b 283 -873 286 -906 285 -890 b 278 -844 281 -861 279 -849 b 274 -830 277 -842 276 -836 b 152 -651 255 -758 210 -692 b -10 -612 119 -628 51 -612 b -22 -611 -16 -612 -21 -612 l -25 -611 l -25 -465 l -25 -319 l -21 -319 b 0 -336 -11 -319 -5 -325 b 207 -602 31 -410 105 -504 b 275 -685 235 -628 260 -658 b 277 -688 276 -687 277 -688 b 280 -680 278 -688 279 -685 b 286 -609 284 -657 286 -633 b 280 -541 286 -586 284 -563 b 278 -530 280 -537 279 -532 b 274 -516 277 -528 276 -522 b 152 -337 255 -444 210 -378 b -10 -298 119 -315 51 -298 b -22 -298 -16 -298 -21 -298 l -25 -297 z"
                },
                flag16thDown: {
                    x_min: -15,
                    x_max: 267,
                    y_min: 4,
                    y_max: 745,
                    ha: 741,
                    o: "m 319 1071 b 328 1073 322 1072 325 1073 b 350 1054 337 1073 344 1067 b 384 901 373 1008 384 955 b 360 766 384 856 376 810 l 356 756 l 360 745 b 384 615 376 703 384 659 b 273 336 384 516 346 416 b 217 282 258 319 241 302 b -1 19 125 204 42 104 b -19 5 -5 11 -13 5 l -22 5 l -22 146 l -22 287 l -12 288 b 212 369 90 304 162 330 b 339 620 294 433 339 524 b 330 691 339 644 336 668 l 329 699 l 323 690 b 217 569 296 645 265 610 b -1 305 125 491 42 390 b -19 292 -5 297 -13 292 l -22 292 l -22 433 l -22 573 l -12 575 b 194 643 78 589 147 611 b 339 908 286 704 339 806 b 313 1030 339 950 330 991 b 306 1050 306 1045 306 1045 b 319 1071 306 1060 311 1068 z"
                },
                flag32ndUp: {
                    x_min: -17,
                    x_max: 233,
                    y_min: -1005,
                    y_max: 96,
                    ha: 1101,
                    o: "m -25 -6 l -25 139 l -21 139 b 1 121 -11 139 -6 134 b 172 -93 31 61 97 -21 b 201 -121 182 -103 195 -115 b 328 -375 266 -184 311 -274 b 335 -464 333 -404 335 -434 b 317 -612 335 -513 329 -564 l 313 -626 l 315 -632 b 328 -689 320 -647 325 -670 b 335 -778 333 -717 335 -747 b 317 -926 335 -827 329 -878 l 313 -940 l 315 -946 b 328 -1002 320 -961 325 -984 b 335 -1092 333 -1032 335 -1062 b 280 -1346 335 -1177 316 -1264 b 228 -1441 265 -1380 236 -1432 b 213 -1447 224 -1445 218 -1447 b 191 -1425 202 -1447 191 -1438 b 198 -1406 191 -1419 192 -1416 b 284 -1118 254 -1317 284 -1215 b 281 -1072 284 -1103 283 -1087 b 118 -798 269 -948 207 -844 b 6 -778 93 -785 60 -779 l -25 -778 l -25 -634 l -25 -489 l -21 -489 b 1 -507 -11 -489 -6 -494 b 172 -720 31 -567 97 -649 b 275 -848 229 -774 249 -800 l 281 -858 l 282 -849 b 284 -806 283 -834 284 -820 b 118 -484 284 -663 220 -537 b 6 -465 93 -471 60 -465 l -25 -464 l -25 -320 l -25 -175 l -21 -175 b 1 -193 -11 -175 -6 -180 b 172 -406 31 -253 97 -335 b 275 -534 229 -460 249 -486 l 281 -544 l 282 -535 b 284 -492 283 -521 284 -506 b 118 -170 284 -349 220 -223 b 6 -151 93 -157 60 -151 l -25 -151 z"
                },
                flag32ndDown: {
                    x_min: -15,
                    x_max: 270,
                    y_min: -96,
                    y_max: 895,
                    ha: 991,
                    o: "m 292 1287 b 300 1288 294 1288 297 1288 b 309 1287 303 1288 306 1288 b 374 1151 324 1281 359 1209 b 388 1039 383 1115 388 1077 b 368 904 388 993 381 947 l 365 896 l 368 886 b 374 864 370 881 372 871 b 388 752 383 828 388 790 b 368 618 388 706 381 660 l 365 609 l 368 599 b 374 578 370 594 372 584 b 388 467 384 541 388 504 b 236 128 388 339 334 215 b 201 99 226 119 226 119 b 0 -122 110 27 36 -55 b -19 -139 -5 -133 -12 -139 l -22 -139 l -22 0 l -22 138 l -16 138 b 200 215 66 150 144 178 b 340 485 287 273 340 376 b 336 531 340 501 339 516 l 335 540 l 333 537 b 236 415 306 488 275 449 b 201 385 226 406 226 405 b 0 164 110 313 36 231 b -19 148 -5 153 -12 148 l -22 148 l -22 286 l -22 424 l -16 425 b 200 501 66 437 144 464 b 340 772 287 559 340 663 b 336 818 340 787 339 803 l 335 827 l 333 823 b 236 701 306 774 275 735 b 201 672 226 692 226 692 b 0 451 110 600 36 518 b -19 434 -5 440 -12 434 l -22 434 l -22 572 l -22 711 l -16 711 b 219 802 77 725 165 759 b 339 1058 298 865 339 959 b 286 1246 339 1122 322 1187 b 278 1267 279 1258 278 1260 b 292 1287 278 1276 284 1284 z"
                },
                flag64thUp: {
                    x_min: -17,
                    x_max: 233,
                    y_min: -933,
                    y_max: 296,
                    ha: 1230,
                    o: "m -25 282 l -25 427 l -21 427 b 2 404 -9 427 -4 421 b 148 203 25 333 72 268 b 313 -42 230 134 277 64 b 335 -182 328 -86 335 -134 b 309 -332 335 -233 327 -284 l 307 -339 l 312 -354 b 335 -496 328 -399 335 -447 b 309 -646 335 -547 327 -598 l 307 -653 l 312 -668 b 335 -809 328 -713 335 -761 b 309 -960 335 -860 327 -911 l 307 -966 l 312 -981 b 335 -1122 328 -1027 335 -1075 b 288 -1325 335 -1191 320 -1260 b 265 -1344 281 -1340 276 -1344 b 243 -1322 252 -1344 243 -1335 b 251 -1300 243 -1317 243 -1316 b 289 -1125 276 -1244 289 -1184 b 173 -854 289 -1018 248 -915 b 34 -798 127 -816 83 -798 b -9 -802 20 -798 5 -800 b -21 -804 -14 -803 -20 -804 l -25 -804 l -25 -659 l -25 -515 l -21 -515 b 2 -537 -9 -515 -4 -520 b 148 -738 25 -609 72 -673 b 274 -892 204 -785 247 -838 b 279 -900 277 -898 279 -900 b 280 -898 280 -900 280 -899 b 282 -886 280 -897 281 -892 b 289 -811 287 -861 289 -836 b 173 -540 289 -703 246 -600 b 34 -484 127 -502 83 -484 b -9 -489 20 -484 5 -486 b -21 -490 -14 -489 -20 -490 l -25 -490 l -25 -346 l -25 -201 l -21 -201 b 2 -224 -9 -201 -4 -207 b 148 -424 25 -295 72 -360 b 274 -578 204 -471 247 -524 b 279 -586 277 -584 279 -586 b 280 -584 280 -586 280 -585 b 282 -573 280 -583 281 -578 b 289 -497 287 -548 289 -522 b 173 -226 289 -389 246 -286 b 34 -171 127 -188 83 -171 b -9 -175 20 -171 5 -172 b -21 -176 -14 -176 -20 -176 l -25 -176 l -25 -32 l -25 113 l -21 113 b 2 90 -9 113 -4 107 b 148 -110 25 19 72 -46 b 274 -264 204 -158 247 -210 b 279 -272 277 -270 279 -272 b 280 -270 280 -272 280 -272 b 282 -259 280 -269 281 -264 b 289 -184 287 -234 289 -208 b 173 88 289 -75 246 28 b 34 143 127 125 83 143 b -9 139 20 143 5 142 b -21 137 -14 138 -20 137 l -25 137 z"
                },
                flag64thDown: {
                    x_min: -15,
                    x_max: 271,
                    y_min: -296,
                    y_max: 820,
                    ha: 1116,
                    o: "m 272 1179 b 281 1181 275 1180 278 1181 b 297 1174 286 1181 292 1178 b 359 1098 322 1154 344 1127 b 390 972 380 1059 390 1016 b 357 836 390 926 379 879 l 351 825 l 353 823 b 359 812 354 822 357 817 b 390 685 380 773 390 729 b 357 549 390 639 379 593 l 351 539 l 353 536 b 359 526 354 535 357 530 b 390 399 380 486 390 443 b 357 263 390 353 379 306 l 351 252 l 353 250 b 390 113 374 218 390 162 b 390 113 390 113 390 113 b 246 -148 390 9 339 -84 b -1 -411 129 -228 30 -334 b -18 -426 -4 -420 -11 -426 l -22 -427 l -22 -291 l -22 -156 l -13 -155 b 156 -124 51 -152 115 -140 b 338 126 266 -80 338 23 b 326 195 338 150 334 173 b 321 207 324 204 323 207 b 318 203 321 207 319 205 b 246 139 299 180 276 159 b -1 -125 129 59 30 -48 b -18 -140 -4 -134 -11 -139 l -22 -140 l -22 -5 l -22 131 l -13 131 b 156 163 51 134 115 146 b 338 413 266 206 338 310 b 326 482 338 436 334 459 b 321 493 324 490 323 493 b 318 489 321 493 319 492 b 246 425 299 466 276 446 b -1 162 129 345 30 239 b -18 147 -4 153 -11 147 l -22 146 l -22 282 l -22 417 l -13 418 b 156 449 51 421 115 433 b 338 699 266 493 338 596 b 326 768 338 723 334 746 b 321 780 324 777 323 780 b 318 776 320 780 319 778 b 246 712 299 753 276 732 b -1 448 129 632 30 525 b -19 433 -4 439 -11 434 l -22 433 l -22 568 l -22 704 l -13 704 b 156 736 51 707 115 719 b 338 985 264 778 337 879 l 338 985 b 272 1137 338 1045 313 1103 b 259 1159 262 1146 259 1150 b 272 1179 259 1168 265 1176 z"
                },
                flag128thUp: {
                    x_min: -17,
                    x_max: 231,
                    y_min: -987,
                    y_max: 496,
                    ha: 1484,
                    o: "m -25 582 l -25 715 l -21 715 b 3 693 -11 715 -6 710 b 150 501 30 639 82 570 b 237 396 191 459 212 434 b 333 93 300 302 333 195 b 311 -46 333 45 326 -2 b 307 -60 308 -54 307 -57 b 310 -72 307 -63 308 -65 b 332 -220 325 -121 332 -171 b 311 -359 332 -269 325 -316 b 307 -374 308 -368 307 -371 b 310 -386 307 -377 308 -379 b 332 -534 325 -434 332 -485 b 311 -673 332 -583 325 -630 b 307 -688 308 -682 307 -685 b 310 -700 307 -690 308 -693 b 332 -848 325 -748 332 -799 b 311 -987 332 -896 325 -944 b 307 -1001 308 -995 307 -998 b 310 -1013 307 -1004 308 -1007 b 333 -1161 325 -1062 333 -1113 b 268 -1391 333 -1246 311 -1326 b 235 -1422 251 -1417 246 -1422 b 213 -1402 221 -1422 213 -1413 b 220 -1382 213 -1396 215 -1389 b 286 -1176 265 -1322 286 -1250 b 163 -883 286 -1073 244 -966 b -16 -806 122 -841 54 -812 b -23 -805 -19 -806 -22 -806 l -25 -805 l -25 -673 l -25 -541 l -21 -541 b 3 -562 -11 -541 -6 -545 b 150 -754 30 -617 82 -685 b 273 -921 209 -814 242 -860 l 280 -933 l 281 -927 b 287 -861 285 -906 287 -884 b 163 -569 287 -756 243 -650 b -16 -492 122 -527 54 -498 b -23 -492 -19 -492 -22 -492 l -25 -491 l -25 -359 l -25 -227 l -21 -227 b 3 -248 -11 -227 -6 -231 b 150 -441 30 -303 82 -372 b 273 -608 209 -500 242 -546 l 280 -620 l 281 -614 b 287 -548 285 -592 287 -570 b 163 -255 287 -442 243 -336 b -16 -179 122 -213 54 -184 b -23 -178 -19 -178 -22 -178 l -25 -178 l -25 -45 l -25 87 l -21 87 b 3 66 -11 87 -6 83 b 150 -127 30 11 82 -58 b 273 -294 209 -186 242 -232 l 280 -306 l 281 -300 b 287 -234 285 -278 287 -256 b 163 59 287 -129 243 -23 b -16 135 122 100 54 129 b -23 136 -19 135 -22 136 l -25 136 l -25 268 l -25 401 l -21 401 b 3 379 -11 401 -6 397 b 150 187 30 325 82 256 b 273 20 209 127 242 82 l 280 8 l 281 14 b 287 80 285 36 287 58 b 163 372 287 185 243 291 b -16 449 122 414 54 443 b -23 450 -19 449 -22 449 l -25 450 z"
                },
                flag128thDown: {
                    x_min: -15,
                    x_max: 270,
                    y_min: -496,
                    y_max: 870,
                    ha: 1366,
                    o: "m 292 1251 b 301 1253 295 1252 298 1253 b 325 1235 309 1253 316 1247 b 389 1031 368 1174 389 1103 b 364 898 389 986 381 941 l 359 888 l 364 876 b 389 745 381 834 389 789 b 364 612 389 700 381 654 l 359 601 l 364 589 b 389 458 381 547 389 503 b 364 325 389 413 381 368 l 359 315 l 364 303 b 389 172 381 261 389 216 b 364 39 389 127 381 81 l 359 28 l 364 16 b 390 -115 381 -26 390 -71 b 260 -391 390 -219 344 -320 b 0 -698 135 -495 36 -613 b -19 -715 -5 -709 -11 -715 l -22 -715 l -22 -582 l -21 -449 l -14 -447 b 124 -400 25 -439 79 -420 b 213 -349 168 -379 189 -367 b 340 -101 294 -288 340 -196 b 332 -36 340 -79 337 -57 b 330 -27 331 -30 331 -27 b 326 -31 329 -27 328 -29 b 260 -104 309 -57 286 -82 b 0 -412 135 -209 36 -326 b -19 -428 -5 -422 -11 -428 l -22 -428 l -22 -295 l -21 -162 l -14 -161 b 124 -113 25 -153 79 -134 b 213 -63 168 -92 189 -81 b 340 186 294 -2 340 91 b 332 251 340 207 337 229 b 330 259 331 257 331 259 b 326 255 329 259 328 258 b 260 182 309 229 286 204 b 0 -125 135 78 36 -40 b -19 -142 -5 -136 -11 -142 l -22 -142 l -22 -9 l -21 124 l -14 126 b 124 173 25 134 79 152 b 213 224 168 194 189 206 b 340 472 294 285 340 377 b 332 537 340 494 337 516 b 330 546 331 543 331 546 b 326 542 329 546 328 544 b 255 465 307 514 286 491 b 0 161 135 364 35 245 b -19 145 -4 151 -11 145 l -22 145 l -22 278 l -21 411 l -14 412 b 124 460 25 420 79 439 b 213 510 168 481 189 492 b 340 759 294 571 340 664 b 332 824 340 780 337 802 b 330 832 331 830 331 832 b 326 828 329 832 328 831 b 255 751 308 801 286 777 b 0 448 135 650 35 532 b -19 431 -4 437 -11 431 l -22 431 l -22 564 l -21 697 l -14 699 b 124 746 25 707 79 725 b 213 797 168 767 189 779 b 340 1046 295 859 340 953 b 285 1213 340 1105 322 1163 b 278 1232 281 1220 278 1226 b 292 1251 278 1241 283 1248 z"
                },
                accidentalFlat: {
                    x_min: -15,
                    x_max: 185,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 398 22 640 22 640 l 22 155 l 24 158 b 146 208 64 191 106 208 b 194 200 163 208 179 205 b 267 89 241 183 267 140 b 243 1 267 61 259 30 b 107 -148 220 -41 190 -73 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 l -22 -220 l -22 210 l -22 640 l -20 644 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z"
                },
                accidentalNatural: {
                    x_min: 0,
                    x_max: 176,
                    y_min: -334,
                    y_max: 334,
                    ha: 667,
                    o: "m 13 479 b 21 480 16 480 19 480 b 42 467 30 480 39 475 b 44 339 44 463 44 462 b 44 214 44 250 44 214 b 136 237 45 214 86 224 b 234 259 209 255 227 259 b 240 258 237 259 238 259 b 252 246 245 256 251 251 l 254 242 l 254 -111 l 254 -463 l 252 -467 b 232 -480 249 -475 241 -480 b 216 -474 226 -480 221 -478 b 210 -392 211 -468 210 -477 b 210 -336 210 -377 210 -358 b 209 -209 210 -245 210 -209 b 117 -231 209 -209 168 -219 b 19 -254 45 -249 27 -254 b 13 -252 17 -254 15 -253 b 1 -240 8 -251 3 -245 l 0 -237 l 0 113 l 0 463 l 1 467 b 13 479 3 472 8 477 z m 210 23 b 210 74 210 44 210 61 b 209 121 210 118 210 121 l 209 121 b 126 101 208 121 171 112 l 44 81 l 44 -18 b 44 -62 44 -35 44 -50 b 44 -116 44 -104 44 -116 b 128 -96 45 -116 82 -107 l 210 -75 z"
                },
                accidentalSharp: {
                    x_min: 0,
                    x_max: 239,
                    y_min: -388,
                    y_max: 388,
                    ha: 775,
                    o: "m 232 557 b 240 558 234 558 237 558 b 261 545 249 558 258 553 b 262 405 262 541 262 540 b 263 269 262 278 262 269 b 263 269 263 269 263 269 b 322 282 275 273 319 282 b 343 269 331 282 340 277 b 344 217 344 266 344 241 b 343 165 344 192 344 168 b 295 144 339 155 337 154 l 262 136 l 262 22 b 263 -91 262 -83 262 -91 b 263 -91 263 -91 263 -91 b 322 -78 275 -88 319 -78 b 338 -84 329 -78 333 -80 b 344 -129 344 -90 344 -88 b 344 -143 344 -133 344 -138 b 344 -157 344 -148 344 -153 b 338 -203 344 -198 344 -197 b 295 -217 333 -207 333 -207 l 262 -225 l 262 -362 b 261 -504 262 -499 262 -500 b 240 -517 258 -512 249 -517 b 225 -511 235 -517 229 -515 b 218 -430 219 -505 218 -514 b 218 -368 218 -413 218 -393 b 218 -235 218 -295 218 -235 b 171 -247 218 -235 197 -241 b 123 -259 145 -253 123 -259 b 123 -400 123 -259 123 -322 b 122 -545 123 -540 123 -541 b 101 -558 118 -553 110 -558 b 86 -552 95 -558 90 -556 b 79 -469 80 -546 79 -556 b 79 -405 79 -452 79 -431 b 78 -270 79 -279 79 -270 b 78 -270 78 -270 78 -270 b 22 -282 65 -273 25 -282 b 2 -269 13 -282 5 -277 b 0 -217 1 -266 0 -242 b 2 -165 0 -192 1 -168 b 48 -144 5 -155 7 -154 l 79 -136 l 79 -23 b 78 90 79 83 79 90 b 78 90 78 90 78 90 b 22 78 65 87 25 78 b 2 91 13 78 5 83 b 0 143 1 94 0 119 b 2 195 0 168 1 192 b 48 216 5 205 7 206 l 79 224 l 79 362 b 81 504 79 499 79 500 b 101 517 84 512 93 517 b 117 511 107 517 112 515 b 123 430 123 505 123 515 b 123 367 123 413 123 392 b 123 235 123 294 123 235 b 171 246 123 235 145 240 b 218 258 197 253 218 258 b 218 399 218 258 218 322 b 220 545 218 540 218 541 b 232 557 222 549 227 555 z m 218 11 b 218 125 218 102 218 125 l 218 125 b 201 121 217 125 210 123 b 154 109 193 119 171 113 l 123 102 l 123 -12 b 123 -126 123 -74 123 -126 b 171 -114 123 -126 145 -120 b 218 -102 197 -107 218 -102 b 218 11 218 -102 218 -51 z"
                },
                accidentalDoubleSharp: {
                    x_min: 0,
                    x_max: 271,
                    y_min: -135,
                    y_max: 135,
                    ha: 271,
                    o: "m 0 130 l 0 195 l 65 195 l 131 195 l 131 145 l 131 96 l 163 64 l 195 32 l 227 64 l 259 96 l 259 145 l 259 195 l 325 195 l 390 195 l 390 130 l 390 64 l 341 64 l 291 64 l 259 32 l 227 0 l 259 -32 l 291 -64 l 341 -64 l 390 -64 l 390 -130 l 390 -195 l 325 -195 l 259 -195 l 259 -145 l 259 -96 l 227 -64 l 195 -32 l 163 -64 l 131 -96 l 131 -145 l 131 -195 l 65 -195 l 0 -195 l 0 -130 l 0 -64 l 50 -64 l 99 -64 l 131 -32 l 163 0 l 131 32 l 99 64 l 50 64 l 0 64 z"
                },
                accidentalDoubleFlat: {
                    x_min: -15,
                    x_max: 356,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 398 22 640 22 640 l 22 155 l 24 158 b 149 208 64 191 109 208 b 220 187 175 208 200 201 l 223 184 l 224 413 l 224 642 l 226 645 b 246 657 229 653 237 657 b 266 644 254 657 263 653 b 267 398 267 640 267 640 l 267 155 l 270 158 b 392 208 309 191 351 208 b 440 200 408 208 424 205 b 512 89 486 183 512 140 b 488 1 512 61 505 30 b 352 -148 466 -41 436 -73 b 271 -222 307 -188 297 -198 b 246 -237 256 -236 254 -237 b 230 -231 239 -237 234 -236 b 224 -164 224 -225 224 -232 b 224 -125 224 -153 224 -140 l 224 -29 l 218 -36 b 107 -148 194 -67 170 -91 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 l -22 -220 l -22 210 l -22 640 l -20 644 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z m 364 137 b 347 139 360 138 352 139 b 342 139 345 139 343 139 b 272 92 315 135 290 118 l 267 84 l 267 -39 l 267 -161 l 271 -157 b 399 88 349 -73 399 24 b 397 107 399 95 398 101 b 364 137 394 122 382 134 z"
                },
                accidentalParensLeft: {
                    x_min: -122,
                    x_max: -19,
                    y_min: -267,
                    y_max: 267,
                    ha: 534,
                    o: "m -51 383 b -44 385 -49 384 -46 385 b -29 375 -38 385 -31 381 b -27 369 -28 373 -27 372 b -33 349 -27 365 -29 360 b -98 54 -71 259 -91 167 b -99 0 -98 44 -99 22 b -98 -54 -99 -22 -98 -45 b -33 -349 -91 -167 -71 -259 b -27 -368 -28 -363 -27 -365 b -44 -385 -27 -378 -34 -385 b -65 -367 -52 -385 -55 -383 b -176 0 -139 -251 -176 -125 b -65 367 -176 125 -139 251 b -51 383 -57 379 -55 381 z"
                },
                accidentalParensRight: {
                    x_min: 19,
                    x_max: 122,
                    y_min: -267,
                    y_max: 267,
                    ha: 535,
                    o: "m 36 384 b 44 385 38 385 41 385 b 65 367 52 385 55 383 b 176 0 139 251 176 126 b 65 -367 176 -125 139 -250 b 44 -385 56 -380 51 -385 b 36 -383 42 -385 39 -384 b 27 -370 30 -380 27 -377 b 33 -349 27 -365 29 -359 b 99 0 77 -242 99 -121 b 33 350 99 122 77 243 b 27 371 29 359 27 366 b 36 384 27 377 30 381 z"
                },
                accidentalQuarterToneFlatStein: {
                    x_min: 0,
                    x_max: 200,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m 258 656 b 266 658 261 657 264 658 b 287 644 275 658 284 652 l 289 640 l 289 210 l 289 -220 l 287 -224 b 267 -237 284 -232 276 -237 b 241 -222 258 -237 256 -236 b 163 -151 216 -199 200 -183 b 24 2 78 -75 47 -41 b 0 88 8 31 0 61 b 73 200 0 140 26 183 b 120 208 88 205 104 208 b 242 158 161 208 203 191 l 245 155 l 245 398 b 246 644 245 640 245 640 b 258 656 248 649 253 654 z m 179 137 b 159 139 174 138 165 139 b 155 139 157 139 156 139 b 115 107 131 134 118 124 b 113 88 114 101 113 95 b 241 -157 113 24 163 -73 l 245 -161 l 245 -39 l 245 84 l 240 92 b 179 137 224 116 203 131 z"
                },
                accidentalThreeQuarterTonesFlatZimmermann: {
                    x_min: 0,
                    x_max: 446,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m 258 656 b 266 658 261 657 264 658 b 287 644 275 658 284 652 l 289 640 l 289 210 l 289 -220 l 287 -224 b 267 -237 284 -232 276 -237 b 241 -222 258 -237 256 -236 b 163 -151 216 -199 200 -183 b 24 2 78 -75 47 -41 b 0 88 8 31 0 61 b 73 200 0 140 26 183 b 120 208 88 205 104 208 b 242 158 161 208 203 191 l 245 155 l 245 398 b 246 644 245 640 245 640 b 258 656 248 649 253 654 z m 179 137 b 159 139 174 138 165 139 b 155 139 157 139 156 139 b 115 107 131 134 118 124 b 113 88 114 101 113 95 b 241 -157 113 24 163 -73 l 245 -161 l 245 -39 l 245 84 l 240 92 b 179 137 224 116 203 131 z m 367 656 b 375 658 370 657 373 658 b 396 644 384 658 393 652 b 398 398 398 640 398 640 l 398 155 l 400 158 b 522 208 440 191 482 208 b 570 200 538 208 554 205 b 643 89 617 183 643 140 b 619 1 643 61 635 30 b 483 -148 596 -41 566 -73 b 401 -222 438 -188 427 -198 b 376 -237 386 -236 384 -237 b 355 -224 366 -237 358 -232 l 354 -220 l 354 210 l 354 640 l 355 644 b 367 656 357 649 362 654 z m 495 137 b 477 139 491 138 482 139 b 472 139 475 139 473 139 b 403 92 445 135 420 118 l 398 84 l 398 -39 l 398 -161 l 401 -157 b 529 88 479 -73 529 24 b 528 107 529 95 529 101 b 495 137 525 122 512 134 z"
                },
                accidentalQuarterToneSharpStein: {
                    x_min: 0,
                    x_max: 142,
                    y_min: -373,
                    y_max: 373,
                    ha: 747,
                    o: "m 92 536 b 101 538 95 537 98 538 b 122 524 110 538 118 532 b 123 390 123 520 123 519 l 123 259 l 151 268 b 182 277 175 276 178 277 b 184 277 183 277 183 277 b 203 265 193 276 199 272 l 204 262 l 205 213 b 205 187 205 202 205 194 b 201 154 205 159 204 159 b 158 136 197 149 194 148 l 123 125 l 123 10 b 124 -104 123 -64 123 -104 b 150 -94 124 -104 136 -100 b 179 -85 164 -89 177 -85 b 183 -84 181 -84 182 -84 b 203 -98 192 -84 200 -90 b 205 -157 204 -101 205 -130 b 204 -201 205 -179 205 -199 b 158 -226 200 -211 199 -212 l 123 -239 l 123 -380 l 123 -522 l 121 -525 b 101 -538 117 -533 109 -538 b 85 -531 95 -538 90 -536 b 79 -450 80 -526 79 -535 b 79 -387 79 -433 79 -413 b 79 -254 79 -314 79 -254 b 54 -263 79 -254 67 -258 b 19 -273 36 -270 26 -273 b 6 -267 14 -273 10 -271 b 0 -222 0 -261 0 -263 b 0 -207 0 -217 0 -213 b 0 -195 0 -203 0 -199 b 6 -148 0 -152 0 -154 b 47 -131 10 -144 10 -144 l 79 -120 l 79 -5 b 79 110 79 58 79 110 b 53 101 79 110 67 106 b 19 93 35 95 25 93 b 6 99 14 93 10 95 b 0 144 0 105 0 103 b 0 158 0 148 0 153 b 0 185 0 169 0 178 b 45 233 0 222 3 219 l 79 244 l 79 382 b 81 524 79 519 79 520 b 92 536 82 529 88 534 z"
                },
                accidentalThreeQuarterTonesSharpStein: {
                    x_min: 0,
                    x_max: 335,
                    y_min: -391,
                    y_max: 391,
                    ha: 782,
                    o: "m 373 562 b 379 563 375 563 377 563 b 399 551 388 563 395 559 l 401 548 l 401 410 l 401 272 l 403 273 b 432 278 403 273 417 275 b 463 282 448 281 457 282 b 477 276 470 282 473 280 b 483 241 482 271 483 271 b 483 216 483 234 483 226 l 483 167 l 481 164 b 471 153 479 160 475 155 b 402 140 469 152 405 140 b 401 25 401 140 401 88 l 401 -91 l 403 -90 b 432 -85 403 -90 417 -88 b 463 -80 448 -82 457 -80 b 477 -87 470 -80 473 -83 b 483 -122 482 -92 483 -91 b 483 -147 483 -128 483 -137 l 483 -196 l 481 -199 b 471 -209 479 -203 475 -207 b 402 -223 469 -210 405 -223 b 401 -359 401 -223 401 -284 l 401 -496 l 399 -500 b 379 -512 395 -507 388 -512 b 359 -500 371 -512 363 -507 l 357 -496 l 357 -363 b 356 -231 357 -240 357 -231 b 356 -231 356 -231 356 -231 b 309 -240 356 -232 334 -235 l 262 -249 l 262 -384 b 262 -448 262 -410 262 -431 b 256 -531 262 -535 261 -526 b 240 -538 251 -536 246 -538 b 220 -525 232 -538 224 -533 l 219 -522 l 218 -389 l 218 -257 l 171 -265 b 123 -274 144 -270 123 -274 b 123 -411 123 -274 123 -336 l 122 -548 l 121 -551 b 101 -563 116 -559 109 -563 b 81 -551 93 -563 85 -559 l 79 -548 l 79 -415 b 79 -282 79 -342 79 -282 b 52 -287 78 -282 66 -285 b 20 -292 36 -290 26 -292 b 6 -286 13 -292 10 -290 b 0 -241 0 -280 0 -282 b 0 -226 0 -236 0 -232 b 0 -212 0 -221 0 -216 b 6 -167 0 -171 0 -173 b 48 -155 11 -162 13 -162 l 79 -150 l 79 -35 b 79 80 79 29 79 80 b 52 76 78 80 66 78 b 20 71 36 73 26 71 b 6 77 13 71 10 73 b 0 122 0 83 0 81 b 0 136 0 126 0 131 b 0 151 0 142 0 146 b 6 196 0 192 0 190 b 48 207 11 201 13 201 l 79 213 l 79 354 l 79 496 l 81 500 b 101 512 85 508 93 512 b 121 500 109 512 116 508 l 122 497 l 123 359 l 123 221 l 171 230 b 218 239 197 235 218 239 b 218 380 218 239 218 302 b 220 524 218 519 218 520 b 240 538 223 533 231 538 b 256 531 246 538 251 536 b 262 448 261 526 262 535 b 262 384 262 431 262 410 b 263 247 262 295 262 247 b 310 255 263 247 284 251 b 357 264 335 260 357 264 b 358 406 357 264 357 328 l 358 548 l 359 551 b 373 562 362 557 367 561 z m 357 16 b 357 132 357 108 357 132 l 357 132 b 309 123 356 132 335 128 l 262 114 l 262 -1 b 263 -116 262 -76 262 -116 b 310 -107 263 -116 284 -112 b 357 -99 335 -103 357 -99 b 357 16 357 -99 357 -48 z m 218 -124 b 218 -56 218 -124 218 -96 b 218 -9 218 -42 218 -26 l 218 106 l 171 97 b 123 88 145 93 123 89 b 123 21 123 88 123 61 b 123 -27 123 6 123 -10 l 123 -142 l 170 -133 b 218 -124 196 -128 218 -124 z"
                },
                accidentalBuyukMucennebFlat: {
                    x_min: -125,
                    x_max: 185,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 575 22 640 22 639 b 23 510 22 524 22 510 b 23 510 23 510 23 510 b 164 557 49 520 160 557 b 186 534 177 557 186 546 b 176 516 186 527 183 520 b 98 489 175 515 140 503 l 22 463 l 22 405 b 22 378 22 394 22 386 b 23 347 22 354 22 347 b 23 347 23 347 23 347 b 164 393 49 356 160 393 b 186 371 177 393 186 382 b 176 352 186 364 183 357 b 98 325 175 352 140 339 l 22 300 l 22 228 l 22 155 l 24 158 b 146 208 64 191 106 208 b 194 200 163 208 179 205 b 267 89 241 183 267 140 b 243 1 267 61 259 30 b 107 -148 220 -41 190 -73 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 b -22 32 -22 -220 -22 -220 b -22 284 -22 171 -22 284 b -88 262 -23 284 -52 274 b -160 240 -141 245 -154 240 b -167 241 -163 240 -164 241 b -180 262 -175 245 -180 254 b -169 281 -180 270 -176 278 b -30 329 -168 282 -92 308 l -22 332 l -22 390 b -22 448 -22 422 -22 448 b -88 426 -23 448 -52 438 b -160 404 -141 408 -154 404 b -167 405 -163 404 -164 404 b -180 426 -175 408 -180 417 b -169 445 -180 434 -176 441 b -30 493 -168 446 -92 472 l -22 495 l -22 568 b -20 644 -22 639 -22 641 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z"
                },
                accidentalBuyukMucennebSharp: {
                    x_min: 0,
                    x_max: 284,
                    y_min: -388,
                    y_max: 388,
                    ha: 775,
                    o: "m 264 557 b 272 558 267 558 269 558 b 293 545 281 558 290 553 b 294 435 294 541 294 540 b 295 329 294 337 294 329 b 296 329 296 329 296 329 b 355 342 308 333 351 342 b 375 329 364 342 372 337 b 376 277 376 326 376 302 b 375 225 376 252 376 228 b 327 204 371 215 369 214 l 294 196 l 294 142 b 295 89 294 94 294 89 b 296 89 295 89 296 89 b 389 110 314 94 384 110 b 389 110 389 110 389 110 b 407 98 397 110 403 105 l 409 95 l 409 45 b 409 25 409 37 409 30 b 404 -13 409 -11 408 -8 b 345 -32 400 -18 398 -19 b 295 -44 317 -39 295 -44 b 294 -98 294 -44 294 -68 b 295 -151 294 -147 294 -151 b 296 -151 295 -151 296 -151 b 355 -138 308 -148 351 -138 b 375 -151 364 -138 372 -143 b 376 -203 376 -154 376 -179 b 375 -255 376 -228 376 -252 b 327 -277 371 -265 369 -266 l 294 -285 l 294 -392 b 293 -504 294 -499 294 -500 b 272 -517 290 -512 281 -517 b 257 -511 267 -517 261 -515 b 251 -443 251 -505 251 -512 b 251 -398 251 -430 251 -416 b 250 -295 251 -341 251 -295 b 203 -307 250 -295 229 -301 b 156 -319 177 -313 156 -319 b 155 -430 155 -319 155 -369 b 154 -545 155 -540 155 -541 b 133 -558 151 -553 142 -558 b 118 -552 128 -558 122 -556 b 112 -482 112 -546 112 -553 b 112 -435 112 -469 112 -454 b 110 -330 112 -337 111 -330 b 110 -330 110 -330 110 -330 b 54 -342 98 -333 58 -342 b 34 -329 45 -342 37 -337 b 32 -277 33 -326 32 -302 b 34 -225 32 -252 33 -228 b 80 -204 38 -215 39 -214 l 112 -196 l 112 -143 b 111 -90 112 -94 111 -90 b 110 -90 110 -90 110 -90 b 20 -110 89 -96 25 -110 b 20 -110 20 -110 20 -110 b 2 -98 12 -110 5 -105 l 0 -95 l 0 -45 b 0 -25 0 -37 0 -30 b 5 13 0 11 0 8 b 62 32 9 18 10 19 b 111 44 89 38 111 44 b 112 97 111 44 112 68 b 111 150 112 146 111 150 b 110 150 110 150 110 150 b 54 138 98 147 58 138 b 34 151 45 138 37 143 b 32 203 33 154 32 179 b 34 255 32 228 33 252 b 80 276 38 265 39 266 l 112 284 l 112 392 b 113 504 112 499 112 500 b 133 517 116 512 125 517 b 149 511 139 517 145 515 b 155 443 155 505 155 512 b 155 397 155 430 155 415 b 155 295 155 341 155 295 b 203 306 156 295 177 300 b 250 318 229 313 250 318 b 251 429 251 318 251 368 b 252 545 251 540 251 541 b 264 557 254 549 259 555 z m 251 131 b 250 185 251 174 250 185 l 250 185 b 233 181 249 185 242 183 b 186 169 225 179 204 173 l 155 162 l 155 108 b 155 55 155 79 155 55 b 203 66 156 55 177 60 b 250 78 229 73 250 78 b 251 131 251 78 251 102 z m 251 -109 b 250 -55 251 -67 250 -55 l 250 -55 b 233 -59 249 -55 242 -57 b 186 -71 225 -62 204 -67 l 155 -79 l 155 -132 b 155 -186 155 -161 155 -186 b 203 -174 156 -186 177 -180 b 250 -162 229 -168 250 -162 b 251 -109 251 -162 251 -138 z"
                },
                accidentalBakiyeFlat: {
                    x_min: -129,
                    x_max: 185,
                    y_min: -165,
                    y_max: 457,
                    ha: 622,
                    o: "m -9 656 b 0 658 -6 657 -3 658 b 20 644 9 658 17 652 b 22 524 22 640 22 639 b 22 407 22 460 22 407 b 90 441 22 407 53 422 l 157 474 l 163 475 b 164 475 163 475 163 475 b 186 453 177 475 186 465 b 184 445 186 450 185 447 b 99 396 181 436 184 438 l 22 357 l 22 256 l 22 155 l 24 158 b 146 208 64 191 106 208 b 194 200 163 208 179 205 b 267 89 241 183 267 140 b 243 1 267 61 259 30 b 107 -148 220 -41 190 -73 b 25 -222 62 -188 51 -198 b 0 -237 10 -236 9 -237 b -20 -224 -9 -237 -17 -232 b -22 57 -22 -220 -22 -220 b -22 335 -22 210 -22 335 b -90 301 -22 335 -53 320 l -157 268 l -163 268 b -164 268 -163 268 -163 268 b -186 289 -177 268 -186 277 b -184 298 -186 292 -185 295 b -99 347 -181 306 -184 304 l -22 385 l -22 513 b -20 644 -22 639 -22 640 b -9 656 -19 649 -13 654 z m 119 137 b 101 139 115 138 107 139 b 97 139 99 139 98 139 b 27 92 69 135 45 118 l 22 84 l 22 -39 l 22 -161 l 26 -157 b 153 88 104 -73 153 24 b 152 107 153 95 153 101 b 119 137 149 122 136 134 z"
                },
                accidentalKomaSharp: {
                    x_min: 0,
                    x_max: 142,
                    y_min: -373,
                    y_max: 373,
                    ha: 747,
                    o: "m 92 536 b 101 538 95 537 98 538 b 122 524 110 538 118 532 b 123 390 123 520 123 519 l 123 259 l 151 268 b 182 277 175 276 178 277 b 184 277 183 277 183 277 b 203 265 193 276 199 272 l 204 262 l 205 213 b 205 187 205 202 205 194 b 201 154 205 159 204 159 b 158 136 197 149 194 148 l 123 125 l 123 10 b 124 -104 123 -64 123 -104 b 150 -94 124 -104 136 -100 b 179 -85 164 -89 177 -85 b 183 -84 181 -84 182 -84 b 203 -98 192 -84 200 -90 b 205 -157 204 -101 205 -130 b 204 -201 205 -179 205 -199 b 158 -226 200 -211 199 -212 l 123 -239 l 123 -380 l 123 -522 l 121 -525 b 101 -538 117 -533 109 -538 b 85 -531 95 -538 90 -536 b 79 -450 80 -526 79 -535 b 79 -387 79 -433 79 -413 b 79 -254 79 -314 79 -254 b 54 -263 79 -254 67 -258 b 19 -273 36 -270 26 -273 b 6 -267 14 -273 10 -271 b 0 -222 0 -261 0 -263 b 0 -207 0 -217 0 -213 b 0 -195 0 -203 0 -199 b 6 -148 0 -152 0 -154 b 47 -131 10 -144 10 -144 l 79 -120 l 79 -5 b 79 110 79 58 79 110 b 53 101 79 110 67 106 b 19 93 35 95 25 93 b 6 99 14 93 10 95 b 0 144 0 105 0 103 b 0 158 0 148 0 153 b 0 185 0 169 0 178 b 45 233 0 222 3 219 l 79 244 l 79 382 b 81 524 79 519 79 520 b 92 536 82 529 88 534 z"
                },
                accidentalKucukMucennebSharp: {
                    x_min: 0,
                    x_max: 188,
                    y_min: -373,
                    y_max: 373,
                    ha: 747,
                    o: "m 127 536 b 135 538 129 537 132 538 b 156 524 144 538 153 532 b 157 420 157 520 157 519 l 157 319 l 185 328 b 216 337 209 336 212 337 b 218 337 217 337 217 337 b 237 325 227 336 233 332 l 239 322 l 239 273 b 239 247 239 262 239 254 b 235 214 239 219 238 219 b 192 196 231 209 229 208 l 157 185 l 157 129 b 158 75 157 86 157 75 b 158 75 158 75 158 75 b 202 89 158 75 178 81 l 245 103 l 250 103 b 268 91 258 102 265 98 l 270 88 l 270 39 b 270 13 270 28 270 20 b 266 -20 270 -15 270 -15 b 208 -43 262 -25 261 -25 l 157 -60 l 157 -112 b 157 -127 157 -117 157 -122 b 158 -164 157 -151 157 -164 b 184 -154 158 -164 170 -160 b 214 -145 198 -149 212 -145 b 217 -144 215 -144 216 -144 b 238 -158 226 -144 235 -150 b 239 -217 239 -161 239 -190 b 238 -261 239 -239 239 -259 b 192 -286 235 -271 233 -272 l 157 -299 l 157 -410 b 155 -525 157 -522 157 -522 b 135 -538 152 -533 143 -538 b 120 -531 130 -538 124 -536 b 113 -463 114 -525 113 -532 b 113 -417 113 -450 113 -435 b 113 -314 113 -361 113 -314 b 88 -323 113 -314 102 -318 b 53 -333 70 -330 60 -333 b 41 -327 48 -333 45 -331 b 34 -282 35 -321 34 -323 b 34 -267 34 -277 34 -273 b 34 -255 34 -263 34 -259 b 40 -208 34 -212 35 -214 b 81 -191 44 -204 44 -204 l 113 -180 l 113 -127 b 113 -75 113 -86 113 -75 b 113 -75 113 -75 113 -75 b 69 -89 112 -75 92 -81 l 26 -103 l 21 -103 b 1 -89 12 -102 4 -97 b 0 -43 0 -86 0 -65 b 2 15 0 -16 1 12 b 63 43 5 24 4 24 l 113 60 l 113 115 b 113 130 113 120 113 125 b 113 170 113 153 113 170 b 87 161 113 170 101 166 b 53 153 69 156 60 153 b 41 159 48 153 45 155 b 34 204 35 165 34 163 b 34 218 34 208 34 213 b 34 245 34 229 34 238 b 79 293 34 282 38 279 l 113 304 l 113 412 b 115 524 113 519 113 520 b 127 536 117 529 122 534 z"
                },
                articAccentAbove: {
                    x_min: -256,
                    x_max: 19,
                    y_min: -114,
                    y_max: 114,
                    ha: 227,
                    o: "m -350 163 b -341 164 -348 163 -344 164 b -333 163 -338 164 -335 163 b -312 151 -330 162 -327 160 b -9 30 -231 99 -122 56 b 13 24 8 27 11 26 b 28 0 23 18 28 9 b 3 -28 28 -12 19 -24 b -19 -33 -1 -29 -11 -31 b -315 -153 -129 -58 -238 -102 b -341 -164 -331 -163 -333 -164 b -369 -136 -357 -164 -369 -151 b -364 -121 -369 -131 -367 -126 b -346 -107 -361 -117 -358 -114 b -135 -8 -285 -67 -213 -34 b -111 0 -122 -4 -111 0 b -135 8 -111 0 -122 4 b -346 107 -213 34 -285 67 b -364 121 -358 114 -361 116 b -368 136 -367 126 -368 131 b -350 163 -368 148 -361 159 z"
                },
                articAccentBelow: {
                    x_min: -256,
                    x_max: 19,
                    y_min: -114,
                    y_max: 114,
                    ha: 227,
                    o: "m -350 163 b -341 164 -348 163 -344 164 b -333 163 -338 164 -335 163 b -312 151 -330 162 -327 160 b -9 30 -231 99 -122 56 b 13 24 8 27 11 26 b 28 0 23 18 28 9 b 3 -28 28 -12 19 -24 b -19 -33 -1 -29 -11 -31 b -315 -153 -129 -58 -238 -102 b -341 -164 -331 -163 -333 -164 b -369 -136 -357 -164 -369 -151 b -364 -121 -369 -131 -367 -126 b -346 -107 -361 -117 -358 -114 b -135 -8 -285 -67 -213 -34 b -111 0 -122 -4 -111 0 b -135 8 -111 0 -122 4 b -346 107 -213 34 -285 67 b -364 121 -358 114 -361 116 b -368 136 -367 126 -368 131 b -350 163 -368 148 -361 159 z"
                },
                articTenutoAbove: {
                    x_min: -154,
                    x_max: 154,
                    y_min: -15,
                    y_max: 15,
                    ha: 30,
                    o: "m -208 20 b 2 22 -205 21 -101 22 b 208 20 104 22 205 21 b 221 0 216 17 221 9 b 215 -16 221 -6 219 -11 b 101 -22 209 -21 225 -22 b 0 -22 75 -22 41 -22 b -101 -22 -41 -22 -75 -22 b -215 -16 -225 -22 -209 -21 b -221 0 -219 -11 -221 -6 b -208 20 -221 8 -216 17 z"
                },
                articTenutoBelow: {
                    x_min: -154,
                    x_max: 154,
                    y_min: -15,
                    y_max: 15,
                    ha: 30,
                    o: "m -208 20 b 2 22 -205 21 -101 22 b 208 20 104 22 205 21 b 221 0 216 17 221 9 b 215 -16 221 -6 219 -11 b 101 -22 209 -21 225 -22 b 0 -22 75 -22 41 -22 b -101 -22 -41 -22 -75 -22 b -215 -16 -225 -22 -209 -21 b -221 0 -219 -11 -221 -6 b -208 20 -221 8 -216 17 z"
                },
                articStaccatoAbove: {
                    x_min: -49,
                    x_max: 49,
                    y_min: -49,
                    y_max: 49,
                    ha: 99,
                    o: "m -13 70 b -1 71 -9 71 -5 71 b 59 40 23 71 46 59 b 71 0 67 28 71 14 b 40 -59 71 -23 60 -46 b 0 -71 28 -67 14 -71 b -59 -40 -23 -71 -46 -60 b -71 0 -67 -28 -71 -14 b -13 70 -71 32 -48 64 z"
                },
                articStaccatoBelow: {
                    x_min: -49,
                    x_max: 49,
                    y_min: -49,
                    y_max: 49,
                    ha: 99,
                    o: "m -13 70 b -1 71 -9 71 -5 71 b 59 40 23 71 46 59 b 71 0 67 28 71 14 b 40 -59 71 -23 60 -46 b 0 -71 28 -67 14 -71 b -59 -40 -23 -71 -46 -60 b -71 0 -67 -28 -71 -14 b -13 70 -71 32 -48 64 z"
                },
                articStaccatissimoAbove: {
                    x_min: -53,
                    x_max: 53,
                    y_min: 0,
                    y_max: 184,
                    ha: 184,
                    o: "m -76 263 l -77 265 l 0 265 l 77 265 l 76 263 b 0 0 75 259 0 0 b -76 263 0 0 -75 259 z"
                },
                articStaccatissimoBelow: {
                    x_min: -53,
                    x_max: 53,
                    y_min: -184,
                    y_max: 0,
                    ha: 184,
                    o: "m -38 -131 b 0 0 -17 -59 0 0 b 76 -263 0 0 75 -259 l 77 -265 l 0 -265 l -77 -265 l -76 -263 b -38 -131 -76 -262 -59 -203 z"
                },
                articMarcatoAbove: {
                    x_min: -114,
                    x_max: 114,
                    y_min: -256,
                    y_max: 19,
                    ha: 275,
                    o: "m -9 26 b 0 28 -6 27 -3 28 b 28 3 13 28 24 18 b 33 -19 29 -1 31 -11 b 153 -315 58 -129 102 -238 b 164 -341 163 -331 164 -333 b 136 -368 164 -357 152 -368 b 107 -346 124 -368 118 -364 b 8 -135 67 -285 34 -213 b 0 -111 4 -122 0 -111 b -8 -135 0 -111 -4 -122 b -107 -346 -34 -213 -67 -285 b -136 -368 -118 -364 -124 -368 b -164 -341 -152 -368 -164 -357 b -151 -312 -164 -333 -163 -332 b -30 -9 -99 -231 -56 -122 b -21 18 -26 11 -26 12 b -9 26 -19 21 -13 25 z"
                },
                articMarcatoBelow: {
                    x_min: -114,
                    x_max: 114,
                    y_min: -19,
                    y_max: 256,
                    ha: 275,
                    o: "m -145 367 b -136 369 -142 368 -139 369 b -107 346 -125 369 -117 362 b -8 135 -67 285 -34 213 b 0 111 -4 122 0 111 b 8 135 0 111 4 122 b 107 346 34 213 67 285 b 121 364 114 358 117 361 b 136 369 126 367 131 369 b 164 341 151 369 164 357 b 153 315 164 333 163 331 b 30 9 101 235 56 124 b 21 -18 26 -11 26 -12 b 0 -27 16 -24 8 -27 b -21 -18 -8 -27 -16 -24 b -30 9 -26 -12 -26 -11 b -151 312 -56 122 -99 231 b -164 341 -163 332 -164 333 b -145 367 -164 353 -156 364 z"
                },
                fermataAbove: {
                    x_min: -324,
                    x_max: 324,
                    y_min: 0,
                    y_max: 353,
                    ha: 353,
                    o: "m -33 507 b 0 508 -22 508 -11 508 b 459 112 228 508 419 345 b 467 31 464 85 467 51 b 465 14 467 22 466 16 b 445 0 462 5 453 0 b 429 7 439 0 433 2 b 422 32 424 12 423 15 b 0 365 414 221 231 365 b -63 362 -33 365 -39 365 b -422 32 -265 338 -415 200 b -429 7 -423 15 -424 12 b -445 0 -433 2 -439 0 b -465 14 -453 0 -462 5 b -467 31 -466 16 -467 22 b -459 112 -467 51 -464 85 b -33 507 -422 332 -249 492 z m -15 196 b 0 197 -10 197 -5 197 b 74 163 27 197 56 184 b 98 99 91 145 98 121 b 55 17 98 67 83 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -65 187 z"
                },
                fermataBelow: {
                    x_min: -324,
                    x_max: 324,
                    y_min: -353,
                    y_max: 0,
                    ha: 353,
                    o: "m -453 -2 b -445 0 -451 -1 -448 0 b -429 -7 -439 0 -433 -3 b -422 -33 -424 -12 -423 -15 b 0 -365 -414 -221 -231 -365 b 63 -362 33 -365 39 -365 b 422 -33 265 -338 415 -201 b 429 -7 423 -15 424 -12 b 445 0 433 -2 439 0 b 465 -14 453 0 462 -5 b 467 -31 466 -17 467 -23 b 463 -87 467 -46 465 -68 b 35 -507 434 -319 259 -490 b -1 -508 23 -508 11 -508 b -459 -112 -228 -508 -419 -345 b -467 -31 -464 -85 -467 -51 b -465 -14 -467 -23 -466 -17 b -453 -2 -463 -9 -458 -4 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
                },
                fermataLongAbove: {
                    x_min: -286,
                    x_max: 286,
                    y_min: 0,
                    y_max: 364,
                    ha: 364,
                    o: "m -399 523 b 0 524 -395 524 -392 524 l 395 524 l 399 523 b 411 511 404 521 409 516 b 412 262 412 507 412 507 b 412 141 412 213 412 173 b 406 7 412 -8 412 12 b 390 0 402 2 396 0 b 382 2 387 0 385 1 b 370 14 377 4 372 9 b 368 183 368 17 368 18 l 368 350 l 0 350 l -368 350 l -368 183 b -370 14 -368 18 -368 17 b -390 0 -373 5 -381 0 b -411 14 -399 0 -407 5 b -412 262 -412 17 -412 139 b -411 511 -412 385 -412 508 b -399 523 -409 516 -403 521 z m -15 196 b 0 197 -10 197 -5 197 b 75 163 27 197 56 184 b 98 99 91 145 98 121 b 56 17 98 67 84 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -64 187 z"
                },
                fermataLongBelow: {
                    x_min: -286,
                    x_max: 286,
                    y_min: -364,
                    y_max: 0,
                    ha: 364,
                    o: "m -399 -2 b -391 0 -396 -1 -393 0 b -370 -14 -382 0 -373 -6 b -368 -184 -368 -18 -368 -18 l -368 -350 l 0 -350 l 368 -350 l 368 -184 b 370 -14 368 -18 368 -18 b 390 0 373 -5 382 0 b 411 -14 399 0 407 -5 b 412 -262 412 -17 412 -140 b 411 -511 412 -385 412 -508 b 399 -523 409 -516 404 -521 l 395 -524 l 0 -524 l -395 -524 l -399 -523 b -411 -511 -404 -521 -409 -516 b -412 -262 -412 -508 -412 -385 b -411 -14 -412 -140 -412 -17 b -399 -2 -409 -9 -404 -4 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
                },
                fermataVeryLongAbove: {
                    x_min: -286,
                    x_max: 286,
                    y_min: 0,
                    y_max: 438,
                    ha: 438,
                    o: "m -399 629 b 0 631 -395 631 -392 631 l 395 631 l 399 629 b 411 617 404 627 409 622 b 412 315 412 614 412 465 b 411 14 412 166 412 17 b 390 0 407 5 399 0 b 370 14 382 0 373 5 b 368 237 368 17 368 18 l 368 456 l 0 456 l -368 456 l -368 237 b -370 14 -368 18 -368 17 b -390 0 -373 5 -382 0 b -411 14 -399 0 -407 5 b -412 315 -412 17 -412 166 b -411 617 -412 465 -412 614 b -399 629 -409 622 -404 627 z m -290 384 b 3 385 -287 385 -141 385 b 289 384 145 385 287 385 b 301 372 294 382 300 377 b 303 193 303 369 303 281 b 301 14 303 105 303 17 b 281 0 298 5 290 0 b 265 7 275 0 270 2 b 259 80 260 12 259 4 b 259 130 259 94 259 111 l 259 243 l 0 243 l -259 243 l -259 130 b -259 80 -259 111 -259 94 b -265 7 -259 4 -260 12 b -281 0 -270 2 -275 0 b -301 14 -290 0 -298 5 b -303 193 -303 17 -303 105 b -301 372 -303 281 -303 369 b -290 384 -300 376 -294 382 z m -15 196 b 0 197 -10 197 -5 197 b 74 163 27 197 56 184 b 98 99 91 145 98 121 b 55 17 98 67 83 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -65 187 z"
                },
                fermataVeryLongBelow: {
                    x_min: -286,
                    x_max: 286,
                    y_min: -438,
                    y_max: 0,
                    ha: 438,
                    o: "m -399 -2 b -391 0 -396 -1 -393 0 b -370 -14 -382 0 -373 -6 b -368 -237 -368 -18 -368 -18 l -368 -456 l 0 -456 l 368 -456 l 368 -237 b 370 -14 368 -18 368 -18 b 390 0 373 -5 382 0 b 411 -14 399 0 407 -5 b 412 -316 412 -17 412 -166 b 411 -617 412 -465 412 -614 b 399 -629 409 -622 404 -628 l 395 -631 l 0 -631 l -395 -631 l -399 -629 b -411 -617 -404 -628 -409 -622 b -412 -316 -412 -614 -412 -465 b -411 -14 -412 -166 -412 -17 b -399 -2 -409 -9 -404 -4 z m -290 -2 b -281 0 -287 -1 -284 0 b -261 -14 -272 0 -264 -6 b -259 -130 -259 -18 -259 -19 l -259 -243 l 0 -243 l 259 -243 l 259 -130 b 259 -81 259 -111 259 -94 b 265 -7 259 -5 260 -13 b 281 0 270 -2 275 0 b 301 -14 290 0 298 -5 b 303 -193 303 -17 303 -105 b 301 -372 303 -281 303 -369 b 289 -384 300 -377 294 -382 b 0 -385 287 -385 143 -385 b -289 -384 -143 -385 -287 -385 b -301 -372 -294 -382 -300 -377 b -303 -193 -303 -369 -303 -281 b -301 -14 -303 -105 -303 -17 b -290 -2 -300 -9 -294 -4 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
                },
                fermataVeryShortAbove: {
                    x_min: -351,
                    x_max: 351,
                    y_min: 0,
                    y_max: 571,
                    ha: 571,
                    o: "m -9 820 b 0 822 -6 821 -3 822 b 8 820 3 822 6 821 b 35 785 15 818 17 815 b 68 733 45 770 59 747 b 98 684 76 720 90 698 b 146 606 107 670 128 635 b 193 532 164 578 185 544 b 227 477 200 519 216 495 b 313 337 277 396 301 358 b 362 260 321 325 343 290 b 406 188 380 230 400 197 b 436 140 412 179 425 157 b 505 25 500 37 505 30 b 505 22 505 24 505 23 b 491 2 505 13 499 5 b 450 0 488 1 469 0 b 409 2 431 0 412 1 b 382 37 403 4 400 7 b 350 89 373 52 358 75 b 319 138 342 102 328 124 b 271 216 311 152 289 187 b 225 290 253 244 232 278 b 191 345 217 302 202 327 b 104 485 142 424 117 464 b 8 639 73 534 24 613 b -21 686 -2 655 -15 676 b -33 704 -27 696 -33 704 b -44 686 -33 704 -38 696 b -73 639 -51 676 -64 655 b -170 485 -89 614 -133 543 b -203 430 -177 472 -192 448 b -290 290 -253 351 -277 311 b -337 216 -298 278 -319 244 b -385 138 -355 187 -376 152 b -415 89 -393 124 -407 102 b -448 37 -424 75 -438 52 b -474 2 -466 7 -468 4 b -483 0 -477 1 -480 0 b -505 22 -495 0 -505 9 b -505 25 -505 23 -505 24 b -436 140 -505 30 -500 37 b -406 188 -425 157 -412 179 b -362 260 -400 197 -380 230 b -313 337 -343 290 -321 325 b -227 477 -301 358 -277 396 b -193 532 -216 495 -200 519 b -146 606 -185 544 -164 578 b -98 684 -128 635 -107 670 b -68 733 -90 697 -76 720 b -35 785 -59 747 -45 770 b -9 820 -17 814 -14 818 z m -36 506 b -28 508 -33 507 -30 508 b -12 502 -22 508 -16 506 b 280 30 -8 498 278 36 b 281 22 281 28 281 25 b 268 2 281 14 276 5 b 226 0 265 1 246 0 b 185 2 207 0 188 1 b 58 199 178 4 182 -1 b -60 389 -7 304 -60 389 b -178 199 -60 389 -114 304 b -305 2 -302 -1 -298 4 b -314 0 -308 1 -311 0 b -336 22 -326 0 -336 10 b -334 30 -336 25 -335 27 b -43 502 -332 36 -46 498 b -36 506 -41 504 -38 506 z m -56 196 b -41 197 -51 197 -46 197 b 33 163 -14 197 15 184 b 57 99 50 145 57 121 b 15 17 57 67 43 36 b -41 0 -3 5 -22 0 b -139 99 -92 0 -139 40 b -56 196 -139 148 -105 187 z"
                },
                fermataVeryShortBelow: {
                    x_min: -351,
                    x_max: 351,
                    y_min: -571,
                    y_max: 0,
                    ha: 571,
                    o: "m 9 -820 b 0 -822 6 -821 3 -822 b -8 -820 -3 -822 -6 -821 b -35 -785 -15 -818 -17 -815 b -68 -733 -45 -770 -59 -747 b -98 -684 -76 -720 -90 -698 b -146 -606 -107 -670 -128 -635 b -193 -532 -164 -578 -185 -544 b -227 -477 -200 -519 -216 -495 b -313 -337 -277 -396 -301 -358 b -362 -260 -321 -325 -343 -290 b -406 -188 -380 -230 -400 -197 b -436 -140 -412 -179 -425 -157 b -505 -25 -500 -37 -505 -30 b -505 -22 -505 -24 -505 -23 b -491 -2 -505 -13 -499 -5 b -450 0 -488 -1 -469 0 b -409 -2 -431 0 -412 -1 b -382 -37 -403 -4 -400 -7 b -350 -89 -373 -52 -358 -75 b -319 -138 -342 -102 -328 -124 b -271 -216 -311 -152 -289 -187 b -225 -290 -253 -244 -232 -278 b -191 -345 -217 -302 -202 -327 b -104 -485 -142 -424 -117 -464 b -8 -639 -73 -534 -24 -613 b 21 -686 2 -655 15 -676 b 33 -704 27 -696 33 -704 b 44 -686 33 -704 38 -696 b 73 -639 51 -676 64 -655 b 170 -485 89 -614 133 -543 b 203 -430 177 -472 192 -448 b 290 -290 253 -351 277 -311 b 337 -216 298 -278 319 -244 b 385 -138 355 -187 376 -152 b 415 -89 393 -124 407 -102 b 448 -37 424 -75 438 -52 b 474 -2 466 -7 468 -4 b 483 0 477 -1 480 0 b 505 -22 495 0 505 -9 b 505 -25 505 -23 505 -24 b 436 -140 505 -30 500 -37 b 406 -188 425 -157 412 -179 b 362 -260 400 -197 380 -230 b 313 -337 343 -290 321 -325 b 227 -477 301 -358 277 -396 b 193 -532 216 -495 200 -519 b 146 -606 185 -544 164 -578 b 98 -684 128 -635 107 -670 b 68 -733 90 -697 76 -720 b 35 -785 59 -747 45 -770 b 9 -820 17 -814 14 -818 z m 36 -506 b 28 -508 33 -507 30 -508 b 12 -502 22 -508 16 -506 b -280 -30 8 -498 -278 -36 b -281 -22 -281 -28 -281 -25 b -268 -2 -281 -14 -276 -5 b -226 0 -265 -1 -246 0 b -185 -2 -207 0 -188 -1 b -58 -199 -178 -4 -182 1 b 60 -389 7 -304 60 -389 b 178 -199 60 -389 114 -304 b 305 -2 302 1 298 -4 b 314 0 308 -1 311 0 b 336 -22 326 0 336 -10 b 334 -30 336 -25 335 -27 b 43 -502 332 -36 46 -498 b 36 -506 41 -504 38 -506 z m 56 -196 b 41 -197 51 -197 46 -197 b -33 -163 14 -197 -15 -184 b -57 -99 -50 -145 -57 -121 b -15 -17 -57 -67 -43 -36 b 41 0 3 -5 22 0 b 139 -99 92 0 139 -40 b 56 -196 139 -148 105 -187 z"
                },
                fermataShortAbove: {
                    x_min: -286,
                    x_max: 286,
                    y_min: 0,
                    y_max: 469,
                    ha: 469,
                    o: "m -9 674 b 0 676 -6 675 -3 676 b 15 670 6 676 11 674 b 74 576 17 667 37 637 b 233 319 105 526 176 410 b 373 92 290 227 353 125 b 411 30 393 59 410 31 b 412 23 412 27 412 25 b 398 2 412 14 407 5 b 357 0 396 1 376 0 b 316 2 338 0 319 1 b 250 100 309 4 309 4 b 91 357 220 150 148 266 b -22 541 35 449 -17 532 b -33 558 -28 550 -33 558 b -42 544 -33 558 -37 551 b -137 389 -47 536 -89 467 b -240 223 -185 312 -231 237 b -382 2 -387 -16 -374 4 b -390 0 -385 1 -387 0 b -412 22 -402 0 -412 9 l -412 22 b -375 90 -412 29 -412 29 b -253 286 -285 236 -269 261 b -182 402 -244 301 -212 354 b -34 641 -127 491 -64 593 b -9 674 -17 668 -15 672 z m -15 196 b -1 197 -10 197 -5 197 b 74 163 27 197 56 184 b 98 99 90 145 98 121 b 55 17 98 67 83 36 b 0 0 38 5 19 0 b -98 99 -51 0 -98 40 b -15 196 -98 148 -65 187 z"
                },
                fermataShortBelow: {
                    x_min: -286,
                    x_max: 286,
                    y_min: -469,
                    y_max: 0,
                    ha: 469,
                    o: "m -399 -2 b -390 0 -396 -1 -393 0 b -375 -6 -385 0 -379 -3 b -316 -100 -373 -9 -353 -39 b -157 -358 -285 -150 -214 -266 b -43 -541 -100 -449 -49 -532 b -33 -558 -38 -550 -33 -558 b -24 -544 -32 -558 -28 -552 b 20 -473 -19 -536 1 -505 b 72 -390 39 -442 62 -405 b 143 -274 81 -375 113 -322 b 291 -35 198 -185 261 -83 b 316 -2 308 -8 310 -4 b 357 0 319 -1 338 0 b 399 -2 377 0 396 -1 b 412 -23 407 -5 412 -14 b 411 -30 412 -25 412 -27 b 392 -62 410 -31 402 -46 b 355 -122 382 -78 365 -105 b 253 -287 345 -138 299 -212 b 152 -451 207 -361 162 -435 b 76 -573 142 -467 108 -522 b 4 -676 16 -671 13 -676 b 0 -676 3 -676 1 -676 b -4 -676 -1 -676 -3 -676 b -74 -576 -13 -676 -16 -671 b -233 -319 -105 -526 -176 -411 b -373 -92 -290 -227 -353 -125 b -411 -30 -393 -59 -410 -31 b -412 -23 -412 -27 -412 -25 b -399 -2 -412 -14 -407 -5 z m -15 -1 b 0 0 -10 0 -5 0 b 82 -43 31 0 64 -17 b 99 -98 93 -61 99 -80 b 0 -197 99 -150 58 -197 b -99 -98 -58 -197 -99 -150 b -82 -43 -99 -80 -93 -61 b -15 -1 -67 -21 -43 -6 z"
                },
                breathMarkComma: {
                    x_min: 0,
                    x_max: 168,
                    y_min: -155,
                    y_max: 155,
                    ha: 311,
                    o: "m 96 223 b 107 224 100 224 103 224 b 236 104 164 224 218 174 b 242 55 240 88 242 71 b 66 -209 242 -42 175 -144 b 33 -224 48 -219 39 -224 b 25 -219 30 -224 28 -222 b 23 -213 24 -216 23 -215 b 36 -199 23 -208 28 -204 b 130 -56 96 -166 130 -110 b 111 8 130 -34 124 -12 l 110 10 l 100 11 b 6 82 58 12 19 42 b 0 117 2 94 0 105 b 96 223 0 170 40 217 z"
                },
                breathMarkUpbow: {
                    x_min: -125,
                    x_max: 125,
                    y_min: 0,
                    y_max: 409,
                    ha: 409,
                    o: "m -171 588 b -130 589 -168 589 -166 589 l -123 589 b -83 585 -87 589 -88 589 b -23 385 -80 581 -84 594 b 34 193 8 280 34 193 b 91 385 34 193 60 280 b 149 580 122 491 148 579 b 164 590 151 586 157 590 b 179 580 170 590 176 586 b 180 577 179 579 180 579 b 99 292 180 569 169 533 b 13 6 18 16 15 6 b 13 6 13 6 13 6 b 12 5 13 6 13 6 b 0 0 9 2 5 0 b -16 11 -7 0 -13 4 b -180 573 -25 41 -180 570 b -171 588 -180 580 -177 586 z"
                },
                caesura: {
                    x_min: 0,
                    x_max: 457,
                    y_min: -202,
                    y_max: 303,
                    ha: 504,
                    o: "m 423 434 b 431 436 426 435 428 436 b 453 414 443 436 453 426 b 452 406 453 411 453 409 b 37 -284 450 401 41 -281 b 23 -290 33 -289 28 -290 b 0 -268 11 -290 0 -281 b 1 -261 0 -266 0 -263 b 416 430 3 -256 413 427 b 423 434 418 431 421 433 z m 627 434 b 636 436 630 435 633 436 b 658 414 648 436 658 426 b 657 406 658 411 658 409 b 242 -284 655 401 245 -281 b 227 -290 238 -289 232 -290 b 205 -268 216 -290 205 -281 b 206 -261 205 -266 205 -263 b 621 430 208 -256 618 427 b 627 434 623 431 625 433 z"
                },
                caesuraCurved: {
                    x_min: 0,
                    x_max: 370,
                    y_min: -207,
                    y_max: 310,
                    ha: 517,
                    o: "m 291 447 b 296 447 293 447 294 447 b 328 410 314 447 328 431 b 328 403 328 408 328 406 b 325 384 328 401 326 392 b 44 -284 299 206 196 -38 b 22 -298 38 -293 30 -298 b 7 -291 16 -298 11 -296 b 0 -278 2 -287 0 -283 b 11 -251 0 -272 3 -264 b 262 409 146 -12 245 246 b 291 447 264 433 273 444 z m 496 447 b 501 447 498 447 499 447 b 533 410 519 447 533 431 b 533 403 533 408 533 406 b 530 384 532 401 531 392 b 248 -284 504 206 401 -38 b 226 -298 242 -293 234 -298 b 211 -291 221 -298 216 -296 b 205 -278 207 -287 205 -283 b 215 -251 205 -272 208 -264 b 466 409 351 -12 449 246 b 496 447 469 433 477 444 z"
                },
                restMaxima: {
                    x_min: 0,
                    x_max: 853,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 0 0 l 0 360 l 205 360 l 409 360 l 409 0 l 409 -360 l 205 -360 l 0 -360 z m 819 0 l 819 360 l 1023 360 l 1228 360 l 1228 0 l 1228 -360 l 1023 -360 l 819 -360 z"
                },
                restDoubleWhole: {
                    x_min: 0,
                    x_max: 284,
                    y_min: 0,
                    y_max: 250,
                    ha: 250,
                    o: "m 0 180 l 0 360 l 205 360 l 409 360 l 409 180 l 409 0 l 205 0 l 0 0 z"
                },
                restWhole: {
                    x_min: 0,
                    x_max: 330,
                    y_min: -125,
                    y_max: 0,
                    ha: 125,
                    o: "m 0 -90 l 0 0 l 237 0 l 475 0 l 475 -90 l 475 -180 l 237 -180 l 0 -180 z"
                },
                restWholeLegerLine: {
                    x_min: 0,
                    x_max: 542,
                    y_min: -125,
                    y_max: 11,
                    ha: 137,
                    o: "m 9 15 b 427 17 11 16 226 17 b 771 15 603 17 769 16 b 780 0 777 13 780 6 b 771 -15 780 -6 777 -13 b 698 -16 768 -16 760 -16 l 628 -16 l 628 -98 l 628 -180 l 390 -180 l 153 -180 l 153 -98 l 153 -16 l 83 -16 b 10 -15 21 -16 12 -16 b 0 0 3 -13 0 -6 b 9 15 0 6 3 12 z"
                },
                restHalf: {
                    x_min: 0,
                    x_max: 330,
                    y_min: 0,
                    y_max: 125,
                    ha: 125,
                    o: "m 0 90 l 0 180 l 237 180 l 475 180 l 475 90 l 475 0 l 237 0 l 0 0 z"
                },
                restHalfLegerLine: {
                    x_min: 0,
                    x_max: 542,
                    y_min: -11,
                    y_max: 125,
                    ha: 137,
                    o: "m 153 98 l 153 180 l 390 180 l 628 180 l 628 98 l 628 16 l 698 16 b 771 15 760 16 769 16 b 781 0 777 13 781 6 b 771 -15 781 -6 777 -13 b 427 -17 769 -16 603 -17 b 9 -15 226 -17 11 -16 b 0 0 3 -12 0 -6 b 4 12 0 4 1 8 b 58 16 9 16 5 16 b 83 16 65 16 73 16 l 153 16 z"
                },
                restQuarter: {
                    x_min: 0,
                    x_max: 221,
                    y_min: -365,
                    y_max: 365,
                    ha: 730,
                    o: "m 50 524 b 56 526 52 525 54 526 b 74 516 62 526 67 523 b 96 497 78 513 88 504 b 118 478 105 489 115 481 b 181 423 143 456 154 447 b 311 305 302 317 311 310 b 310 302 311 304 310 303 b 310 299 310 301 310 300 b 298 278 310 295 310 294 b 234 132 268 233 245 181 b 222 39 226 100 222 69 b 306 -177 222 -46 251 -123 b 319 -198 318 -190 319 -191 b 303 -214 319 -208 313 -214 b 291 -212 299 -214 295 -213 b 260 -208 281 -209 270 -208 b 155 -260 221 -208 181 -227 b 122 -353 133 -287 122 -320 b 185 -490 122 -400 143 -450 b 197 -510 193 -498 197 -505 b 191 -521 197 -514 195 -517 b 181 -526 188 -524 185 -526 b 136 -495 173 -526 161 -517 b 0 -270 48 -420 0 -340 l 0 -270 l 0 -253 l 2 -243 b 157 -146 19 -182 78 -146 b 217 -152 176 -146 196 -148 l 228 -155 l 226 -152 b 124 -62 223 -150 168 -101 b 19 37 23 27 19 31 b 19 39 19 38 19 39 l 19 40 b 29 59 19 46 19 47 b 117 312 87 138 117 229 b 53 489 117 382 96 446 b 41 509 42 500 41 503 b 50 524 41 516 44 521 z"
                },
                rest8th: {
                    x_min: 0,
                    x_max: 258,
                    y_min: -197,
                    y_max: 219,
                    ha: 416,
                    o: "m 98 315 b 110 316 102 315 106 316 b 177 293 132 316 159 307 b 218 207 204 271 218 239 b 191 137 218 182 209 157 l 187 132 l 193 134 b 326 260 251 150 302 198 b 331 270 328 264 330 269 b 349 279 336 276 343 279 b 371 257 360 279 371 270 b 213 -273 371 253 216 -267 b 194 -283 209 -280 202 -283 b 173 -270 185 -283 176 -279 b 172 -265 172 -268 172 -268 b 230 -62 172 -257 180 -228 b 289 134 263 46 289 134 b 289 134 289 134 289 134 b 280 128 289 134 285 131 b 149 84 241 98 194 84 b 39 121 108 84 69 96 b 0 204 13 142 0 173 b 31 282 0 232 10 260 b 98 315 48 300 69 311 z"
                },
                rest16th: {
                    x_min: 0,
                    x_max: 331,
                    y_min: -443,
                    y_max: 219,
                    ha: 662,
                    o: "m 205 315 b 216 316 208 315 212 316 b 283 293 239 316 265 307 b 324 207 310 271 324 239 b 298 137 324 182 316 157 l 293 132 l 299 134 b 433 260 358 150 409 198 b 438 270 434 264 437 269 b 455 279 443 276 449 279 b 477 257 467 279 477 270 b 213 -627 477 253 216 -621 b 194 -638 209 -635 202 -638 b 173 -625 185 -638 176 -634 b 172 -620 172 -623 172 -622 b 230 -417 172 -612 180 -583 b 289 -221 263 -309 289 -221 b 289 -221 289 -221 289 -221 b 280 -227 289 -221 285 -223 b 149 -271 241 -256 194 -271 b 39 -234 108 -271 69 -259 b 0 -150 13 -213 0 -182 b 31 -73 0 -123 10 -95 b 110 -39 52 -50 81 -39 b 207 -100 149 -39 188 -60 b 218 -147 214 -114 218 -131 b 191 -218 218 -173 209 -199 l 187 -223 l 193 -221 b 326 -96 251 -205 302 -157 b 395 134 328 -91 395 133 b 395 134 395 134 395 134 b 387 128 395 134 391 131 b 256 84 347 98 301 84 b 145 121 215 84 175 96 b 106 204 119 142 106 173 b 137 282 106 232 116 260 b 205 315 155 300 176 311 z"
                },
                rest32nd: {
                    x_min: 0,
                    x_max: 405,
                    y_min: -443,
                    y_max: 466,
                    ha: 909,
                    o: "m 311 670 b 322 670 315 670 318 670 b 390 647 345 670 371 662 b 431 562 417 626 431 594 b 404 492 431 536 422 511 l 400 487 l 406 488 b 539 614 464 504 515 552 b 544 625 541 619 543 623 b 562 633 549 631 555 633 b 584 612 573 633 584 625 b 213 -627 584 607 216 -621 b 194 -638 209 -635 202 -638 b 173 -625 185 -638 176 -634 b 172 -620 172 -623 172 -622 b 230 -417 172 -612 180 -583 b 289 -221 263 -309 289 -221 b 289 -221 289 -221 289 -221 b 280 -227 289 -221 285 -223 b 149 -271 241 -256 194 -271 b 39 -234 108 -271 69 -259 b 0 -150 13 -213 0 -182 b 31 -73 0 -123 10 -95 b 110 -39 52 -50 81 -39 b 207 -100 149 -39 188 -60 b 218 -147 214 -114 218 -131 b 191 -218 218 -173 209 -199 l 187 -223 l 193 -221 b 326 -96 251 -205 302 -157 b 395 134 328 -91 395 133 b 395 134 395 134 395 134 b 387 128 395 134 391 131 b 256 84 347 98 301 84 b 145 121 215 84 175 96 b 106 204 119 142 106 173 b 137 282 106 232 116 260 b 216 315 159 304 187 315 b 314 255 255 315 295 294 b 324 208 321 240 324 224 b 298 137 324 182 315 156 l 293 132 l 299 134 b 432 258 357 149 409 198 b 502 489 434 264 502 487 b 502 489 502 489 502 489 b 493 483 502 489 498 486 b 362 438 454 453 407 438 b 251 475 321 438 282 451 b 213 559 226 496 213 528 b 243 636 213 587 223 615 b 311 670 261 655 282 665 z"
                },
                rest64th: {
                    x_min: 0,
                    x_max: 479,
                    y_min: -689,
                    y_max: 466,
                    ha: 1155,
                    o: "m 417 670 b 429 670 421 670 425 670 b 496 647 451 670 478 662 b 537 562 523 626 537 594 b 510 492 537 536 529 511 l 506 487 l 512 488 b 646 614 570 504 621 552 b 651 625 647 619 650 623 b 668 633 655 631 662 633 b 690 612 679 633 690 625 b 213 -982 690 607 216 -976 b 194 -993 209 -989 202 -993 b 173 -979 185 -993 176 -988 b 172 -974 172 -978 172 -977 b 230 -771 172 -966 180 -938 b 289 -575 263 -664 289 -575 b 289 -575 289 -575 289 -575 b 280 -582 289 -575 285 -578 b 149 -626 241 -611 194 -626 b 39 -589 108 -626 69 -613 b 0 -505 13 -568 0 -537 b 31 -428 0 -477 10 -449 b 110 -394 52 -405 81 -394 b 207 -454 149 -394 188 -415 b 218 -502 214 -469 218 -485 b 191 -572 218 -528 209 -553 l 187 -577 l 193 -576 b 326 -451 251 -560 302 -512 b 395 -221 328 -446 395 -222 b 395 -221 395 -221 395 -221 b 387 -227 395 -221 391 -223 b 256 -271 347 -256 301 -271 b 145 -234 215 -271 175 -259 b 106 -150 119 -213 106 -182 b 137 -73 106 -123 116 -95 b 216 -39 159 -50 187 -39 b 314 -100 255 -39 295 -60 b 324 -147 321 -114 324 -131 b 298 -218 324 -173 315 -199 l 293 -223 l 299 -221 b 432 -96 357 -205 409 -157 b 502 134 434 -91 502 133 b 502 134 502 134 502 134 b 493 128 502 134 498 131 b 362 84 454 98 407 84 b 251 121 321 84 282 96 b 213 204 226 142 213 173 b 243 282 213 232 223 260 b 322 315 265 304 294 315 b 420 255 362 315 401 294 b 431 208 427 240 431 224 b 404 137 431 182 422 156 l 400 132 l 406 134 b 539 258 463 149 515 198 b 608 489 541 264 608 487 b 608 489 608 489 608 489 b 599 483 608 489 604 486 b 468 438 560 453 513 438 b 358 475 428 438 388 451 b 319 559 332 496 319 528 b 350 636 319 587 329 615 b 417 670 368 655 388 665 z"
                },
                rest128th: {
                    x_min: 0,
                    x_max: 553,
                    y_min: -689,
                    y_max: 712,
                    ha: 1401,
                    o: "m 524 1024 b 535 1025 527 1025 531 1025 b 603 1002 558 1025 584 1016 b 644 916 630 981 644 949 b 617 846 644 891 635 866 l 612 841 l 619 843 b 752 969 677 859 728 907 b 757 979 754 973 756 978 b 775 988 762 985 768 988 b 797 966 786 988 797 980 b 213 -982 797 962 216 -976 b 194 -993 209 -989 202 -993 b 173 -979 185 -993 176 -988 b 172 -974 172 -978 172 -977 b 230 -771 172 -966 180 -938 b 289 -575 263 -664 289 -575 b 289 -575 289 -575 289 -575 b 280 -582 289 -575 285 -578 b 149 -626 241 -611 194 -626 b 39 -589 108 -626 69 -613 b 0 -505 13 -568 0 -537 b 31 -428 0 -477 10 -449 b 110 -394 52 -405 81 -394 b 207 -454 149 -394 188 -415 b 218 -502 214 -469 218 -485 b 191 -572 218 -528 209 -553 l 187 -577 l 193 -576 b 326 -451 251 -560 302 -512 b 395 -221 328 -446 395 -222 b 395 -221 395 -221 395 -221 b 387 -227 395 -221 391 -223 b 256 -271 347 -256 301 -271 b 145 -234 215 -271 175 -259 b 106 -150 119 -213 106 -182 b 137 -73 106 -123 116 -95 b 216 -39 159 -50 187 -39 b 314 -100 255 -39 295 -60 b 324 -147 321 -114 324 -131 b 298 -218 324 -173 315 -199 l 293 -223 l 299 -221 b 432 -96 357 -205 409 -157 b 502 134 434 -91 502 133 b 502 134 502 134 502 134 b 493 128 502 134 498 131 b 362 84 454 98 407 84 b 251 121 321 84 282 96 b 213 204 226 142 213 173 b 243 282 213 232 223 260 b 322 315 265 304 294 315 b 420 255 362 315 401 294 b 431 208 427 240 431 224 b 404 137 431 182 422 156 l 400 132 l 406 134 b 539 258 463 149 515 198 b 608 489 541 264 608 487 b 608 489 608 489 608 489 b 599 483 608 489 604 486 b 468 438 560 453 513 438 b 358 475 428 438 388 451 b 319 559 332 496 319 528 b 350 636 319 587 329 615 b 429 670 372 659 400 670 b 526 610 468 670 507 649 b 537 563 534 595 537 579 b 511 492 537 536 528 511 l 506 487 l 512 488 b 645 613 570 504 621 553 b 715 843 647 618 715 842 b 715 843 715 843 715 843 b 706 837 714 843 711 841 b 575 793 667 808 620 793 b 464 830 534 793 495 805 b 426 914 439 851 426 882 b 456 991 426 941 436 969 b 524 1024 474 1010 495 1020 z"
                },
                dynamicPiano: {
                    x_min: -39,
                    x_max: 378,
                    y_min: -178,
                    y_max: 277,
                    ha: 455,
                    o: "m 197 399 b 208 399 201 399 205 399 b 305 314 255 399 298 362 l 306 308 l 312 315 b 405 382 339 346 376 373 b 430 386 413 385 421 386 b 494 362 451 386 474 378 b 544 249 526 336 544 296 b 377 -30 544 116 475 1 b 334 -37 362 -34 347 -37 b 291 -25 316 -37 300 -33 b 281 -17 289 -23 285 -20 b 240 43 262 -1 248 20 b 237 52 238 47 237 52 b 237 53 237 52 237 53 b 198 -74 236 53 229 30 b 159 -207 166 -181 159 -202 b 160 -209 159 -208 160 -208 b 194 -221 165 -213 179 -218 b 206 -224 198 -222 204 -224 b 217 -240 213 -226 217 -233 b 208 -255 217 -246 214 -252 b 81 -257 206 -256 144 -257 b -46 -255 18 -257 -44 -256 b -56 -240 -52 -252 -56 -246 b -51 -229 -56 -236 -54 -232 b -33 -222 -48 -225 -46 -225 b 29 -191 9 -213 24 -206 b 174 291 34 -177 173 286 b 176 303 174 294 175 299 b 178 317 177 308 178 313 b 163 336 178 329 173 336 b 157 336 161 336 159 336 b 70 239 124 326 90 288 b 56 224 65 225 63 224 b 46 233 49 224 46 227 b 49 248 46 237 47 242 b 149 376 70 302 105 347 b 161 385 154 379 160 383 b 197 399 168 391 184 397 z m 399 318 b 389 320 396 320 393 320 b 318 285 370 320 340 306 b 302 263 306 273 304 270 b 297 253 301 260 299 256 b 273 176 296 250 288 226 l 251 104 l 252 97 b 266 51 253 81 258 64 b 296 29 274 39 288 29 b 298 29 297 29 297 29 b 309 34 299 30 304 32 b 429 230 370 62 420 144 b 431 256 430 240 431 249 b 399 318 431 289 421 307 z"
                },
                dynamicMezzo: {
                    x_min: 35,
                    x_max: 493,
                    y_min: -19,
                    y_max: 272,
                    ha: 291,
                    o: "m 191 390 b 206 392 196 391 201 392 b 282 350 235 392 265 376 b 291 331 285 345 291 333 b 292 330 291 330 292 330 b 297 337 292 330 294 331 b 329 371 306 350 317 362 b 339 380 332 374 336 377 b 376 392 347 388 361 392 b 434 372 395 392 418 385 b 463 331 447 362 461 341 b 464 330 463 330 463 330 b 469 337 464 330 466 331 b 501 371 478 350 489 362 b 511 380 504 374 508 377 b 548 392 519 388 533 392 b 606 372 567 392 589 385 b 641 295 628 354 641 323 b 633 260 641 282 639 270 b 576 69 631 256 576 72 b 574 59 576 68 575 63 b 573 47 573 55 573 51 b 585 25 573 35 577 25 b 586 26 585 25 585 25 b 684 127 621 30 664 74 b 699 145 690 143 692 145 b 709 135 706 145 709 142 b 696 98 709 128 705 116 b 595 -12 672 47 640 12 b 582 -20 590 -15 584 -19 b 552 -27 573 -25 563 -27 b 481 18 524 -27 495 -10 b 470 63 474 31 470 47 b 478 98 470 76 473 88 b 535 289 480 102 535 285 b 537 298 535 290 536 294 b 538 311 538 303 538 307 b 522 339 538 324 533 333 b 516 341 519 340 517 341 b 507 337 514 341 512 340 b 468 282 491 329 470 300 b 462 261 467 276 464 264 b 422 133 461 259 444 203 b 380 2 383 1 384 4 l 378 0 l 333 0 b 321 0 329 0 324 0 b 283 5 284 0 286 0 b 282 8 282 6 282 7 b 322 149 282 15 288 37 b 363 289 344 224 363 287 b 365 299 364 292 364 296 b 367 311 366 303 367 307 b 350 339 367 324 361 333 b 344 341 347 340 346 341 b 336 337 342 341 340 340 b 296 282 319 329 298 300 b 290 261 295 276 292 264 b 251 133 289 259 272 203 b 208 2 211 1 212 4 l 206 0 l 161 0 b 149 0 157 0 152 0 b 111 5 112 0 114 0 b 110 8 110 6 110 7 b 150 149 110 15 116 37 b 191 289 172 224 191 287 b 193 299 192 292 193 296 b 195 311 194 303 195 307 b 179 338 195 323 189 333 b 171 340 176 339 174 340 b 150 333 166 340 160 338 b 75 240 120 318 92 283 b 60 224 69 225 67 224 b 50 233 53 224 50 227 b 53 248 50 237 51 242 b 162 378 75 306 117 355 b 170 383 164 379 168 381 b 191 390 176 386 183 389 z"
                },
                dynamicForte: {
                    x_min: -87,
                    x_max: 440,
                    y_min: -182,
                    y_max: 415,
                    ha: 597,
                    o: "m 486 597 b 491 597 487 597 489 597 b 515 596 499 597 512 597 b 528 595 517 596 523 595 b 631 522 576 591 622 559 b 633 506 632 516 633 511 b 559 433 633 466 598 433 b 532 439 550 433 541 435 b 493 499 506 450 493 475 b 518 548 493 517 501 536 b 519 550 519 549 519 549 b 519 550 519 550 519 550 b 496 537 518 550 504 542 b 371 353 445 503 399 436 b 367 341 369 347 367 341 b 407 341 367 341 385 341 b 414 341 410 341 412 341 b 459 335 452 341 451 341 b 468 314 465 330 468 322 b 459 293 468 306 465 298 b 411 286 451 287 453 286 b 399 286 407 286 404 286 l 353 286 l 351 279 b 174 -146 320 120 253 -41 b -24 -262 120 -218 45 -262 b -28 -262 -25 -262 -26 -262 b -125 -165 -83 -260 -125 -217 b -122 -140 -125 -157 -124 -148 b -53 -89 -113 -106 -83 -89 b 17 -142 -23 -89 8 -107 b 19 -158 18 -147 19 -153 b -13 -214 19 -181 7 -202 b -16 -217 -15 -216 -16 -216 b -16 -217 -16 -217 -16 -217 b -10 -215 -15 -217 -13 -216 b 80 -130 25 -205 58 -173 b 102 -74 88 -115 93 -102 b 186 245 126 -3 146 72 b 196 285 191 267 196 285 b 196 285 196 285 196 285 b 151 286 196 286 192 286 b 98 290 103 286 102 287 b 83 314 88 296 83 305 b 98 338 83 323 88 332 b 157 341 102 341 102 341 l 211 341 l 215 353 b 486 597 264 491 372 588 z"
                },
                dynamicRinforzando: {
                    x_min: 58,
                    x_max: 357,
                    y_min: 0,
                    y_max: 275,
                    ha: 275,
                    o: "m 383 395 b 401 396 389 395 395 396 b 508 352 446 396 495 377 b 515 327 513 344 515 336 b 490 285 515 310 506 293 b 465 278 482 280 474 278 b 423 301 450 278 434 286 b 365 332 408 322 386 332 b 299 281 335 332 307 314 b 296 272 298 277 297 273 b 294 266 295 271 294 269 b 291 260 293 264 292 261 b 252 133 290 259 273 201 b 210 2 213 1 214 4 l 207 0 l 163 0 b 150 0 158 0 154 0 b 112 5 113 0 115 0 b 111 8 112 6 111 7 b 152 149 111 15 118 37 b 193 289 174 225 192 287 b 195 300 193 292 194 296 b 197 315 196 305 197 310 b 175 344 197 331 189 342 b 170 344 173 344 172 344 b 109 316 149 344 127 334 b 95 306 100 306 99 306 b 84 316 88 306 84 310 b 87 325 84 319 85 322 b 149 372 99 341 127 363 b 211 388 168 381 197 388 b 215 388 213 388 214 388 b 283 349 245 385 267 372 b 285 345 284 347 285 345 b 285 345 285 345 285 345 b 291 350 286 345 288 347 b 383 395 316 374 349 390 z"
                },
                dynamicSforzando: {
                    x_min: 52,
                    x_max: 278,
                    y_min: -22,
                    y_max: 270,
                    ha: 292,
                    o: "m 259 388 b 271 388 263 388 267 388 b 370 362 305 388 338 379 b 396 338 385 354 391 348 b 401 315 399 331 401 323 b 359 261 401 290 384 266 b 349 260 356 260 352 260 b 300 306 322 260 300 282 b 305 327 300 313 302 320 b 308 332 307 330 308 332 b 308 332 308 332 308 332 b 287 334 308 334 297 334 b 269 333 279 334 272 334 b 220 300 245 329 226 316 b 219 295 219 299 219 297 b 273 232 219 278 243 249 b 301 215 289 223 295 219 b 373 95 347 181 373 136 b 361 49 373 79 369 63 b 219 -32 332 -4 277 -32 b 101 7 179 -32 138 -19 b 75 51 84 19 75 34 b 85 82 75 61 78 71 b 129 106 94 98 112 106 b 164 92 142 106 154 102 b 178 59 173 83 178 71 b 170 34 178 50 175 42 l 166 29 l 168 28 b 203 22 178 24 190 22 b 226 25 211 22 219 23 b 275 68 253 31 275 52 b 274 75 275 70 274 73 b 217 132 264 98 249 114 b 122 262 161 163 127 210 b 122 270 122 265 122 267 b 259 388 122 329 184 384 z"
                },
                dynamicZ: {
                    x_min: 23,
                    x_max: 309,
                    y_min: 2,
                    y_max: 250,
                    ha: 248,
                    o: "m 124 360 b 222 360 125 360 168 360 b 435 359 312 360 434 360 b 445 344 442 356 445 350 b 440 331 445 339 444 335 b 314 227 438 330 382 283 b 190 124 247 172 191 125 l 188 123 l 201 123 b 205 123 202 123 204 123 b 268 101 231 123 249 117 b 320 79 284 88 305 79 b 326 80 322 79 324 79 b 340 93 330 81 334 84 b 342 97 341 96 342 97 b 342 98 342 98 342 98 b 340 97 342 98 341 97 b 330 96 336 96 333 96 b 294 134 311 96 294 113 b 295 142 294 136 294 139 b 340 176 299 163 320 176 b 371 163 351 176 363 172 b 383 124 380 154 383 139 b 359 60 383 100 375 74 b 322 30 350 51 329 35 b 239 3 295 12 266 3 b 179 21 218 3 197 9 b 117 39 161 33 138 39 b 86 35 106 39 95 38 b 67 23 79 32 76 31 b 49 14 58 15 55 14 b 33 30 39 14 33 21 b 38 42 33 34 34 38 b 73 72 41 46 60 62 b 303 262 80 77 299 258 b 303 262 303 262 303 262 b 246 263 303 262 277 263 b 146 261 203 263 150 262 b 102 239 131 259 117 252 b 88 231 94 232 92 231 b 85 230 87 230 86 230 b 69 246 76 230 69 237 l 69 247 l 69 252 l 92 302 b 116 355 104 330 115 354 b 124 360 118 357 122 359 z"
                },
                ornamentTrill: {
                    x_min: -249,
                    x_max: 249,
                    y_min: 0,
                    y_max: 376,
                    ha: 376,
                    o: "m -92 502 b -29 542 -33 541 -33 542 b -21 534 -25 542 -21 539 b -70 366 -21 532 -65 383 l -71 364 l -47 364 b 125 383 13 366 71 372 b 149 387 136 386 143 387 b 167 382 156 387 160 385 b 181 370 171 380 179 373 b 182 370 181 370 181 370 b 230 380 185 370 195 372 b 304 394 286 393 290 394 b 305 394 305 394 305 394 b 357 353 330 394 349 379 b 359 336 358 349 359 342 b 354 314 359 326 357 316 b 257 291 352 312 263 291 b 257 291 257 291 257 291 b 250 299 252 292 250 294 b 251 305 250 301 250 303 b 251 314 251 308 251 311 b 234 350 251 329 245 343 l 230 353 l 224 349 b 169 287 202 334 183 313 b 127 156 163 276 166 286 b 88 37 92 43 91 39 b -8 15 84 35 -4 15 b -8 15 -8 15 -8 15 b -14 22 -12 16 -14 17 b -8 47 -14 26 -12 33 b -2 69 -5 59 -2 69 b -2 69 -2 69 -2 69 b -45 44 -2 69 -22 58 b -122 4 -102 10 -105 9 b -151 0 -132 1 -142 0 b -256 105 -208 0 -256 46 b -255 119 -256 110 -256 114 b -223 231 -254 129 -256 121 b -195 325 -208 282 -195 325 b -195 325 -195 325 -195 325 b -198 325 -196 325 -196 325 b -274 324 -206 325 -237 325 b -340 324 -310 324 -329 324 b -354 325 -351 324 -353 324 b -359 332 -357 326 -359 329 b -356 338 -359 334 -358 336 b -308 351 -355 340 -353 340 l -261 361 l -222 362 l -182 363 l -168 411 b -152 461 -160 438 -153 460 b -92 502 -152 462 -125 480 z m 62 348 b 57 349 60 349 59 349 b 40 346 55 349 51 348 b -62 330 8 339 -30 333 b -83 321 -84 329 -82 330 b -115 211 -83 318 -93 283 b -148 88 -149 94 -148 99 b -148 87 -148 88 -148 88 b -123 53 -148 67 -137 53 b -113 55 -120 53 -117 54 b 18 133 -111 57 17 132 b 46 227 19 134 46 225 b 53 251 46 231 48 239 b 78 334 57 261 78 331 b 62 348 78 340 71 347 z"
                },
                ornamentTurn: {
                    x_min: -310,
                    x_max: 310,
                    y_min: -143,
                    y_max: 143,
                    ha: 286,
                    o: "m -272 205 b -264 206 -270 206 -267 206 b -202 198 -249 206 -221 202 b 44 48 -119 177 -37 127 b 261 -91 117 -24 191 -71 b 307 -100 285 -97 297 -100 b 318 -99 311 -100 314 -99 b 401 2 362 -92 396 -51 b 402 11 401 5 402 8 b 321 87 402 58 366 87 b 258 70 301 87 279 81 b 221 60 246 63 233 60 b 157 125 186 60 157 86 b 213 194 157 158 175 179 b 277 206 234 202 256 206 b 437 90 348 206 413 162 b 447 24 444 69 447 47 b 365 -163 447 -46 416 -120 b 257 -206 331 -192 297 -206 b 178 -192 233 -206 207 -201 b -47 -48 101 -168 28 -121 b -250 86 -116 20 -180 62 b -312 99 -275 94 -295 99 b -361 83 -331 99 -346 94 b -402 6 -388 65 -402 36 b -349 -77 -402 -28 -384 -62 b -314 -85 -337 -82 -326 -85 b -260 -70 -297 -85 -280 -80 b -224 -60 -247 -63 -235 -60 b -188 -71 -211 -60 -199 -64 b -160 -126 -169 -84 -160 -105 b -189 -181 -160 -147 -169 -168 b -272 -204 -211 -195 -242 -204 b -293 -202 -279 -204 -286 -203 b -447 -6 -385 -189 -447 -103 b -435 68 -447 18 -443 43 b -280 204 -411 141 -349 196 b -272 205 -277 205 -273 205 z"
                },
                ornamentTurnSlash: {
                    x_min: -310,
                    x_max: 310,
                    y_min: -201,
                    y_max: 201,
                    ha: 402,
                    o: "m -10 288 b -2 289 -7 289 -4 289 b 19 276 8 289 16 284 b 21 171 21 272 21 271 l 21 71 l 43 49 b 261 -90 120 -26 191 -71 b 307 -100 285 -97 297 -100 b 318 -99 311 -100 314 -99 b 401 2 362 -91 396 -50 b 402 12 402 5 402 8 b 321 87 402 58 367 87 b 258 70 301 87 280 82 b 221 60 246 63 233 60 b 157 125 187 60 157 86 b 214 194 157 158 175 180 b 277 206 235 202 256 206 b 431 106 342 206 402 169 b 447 24 442 82 447 54 b 443 -24 447 9 446 -7 b 258 -206 423 -127 344 -206 b 257 -206 258 -206 258 -206 b 23 -109 190 -205 102 -169 l 21 -107 l 21 -190 b 21 -223 21 -203 21 -214 b 14 -283 21 -282 20 -277 b -1 -289 10 -287 5 -289 b -22 -276 -10 -289 -18 -284 b -23 -171 -23 -272 -23 -271 l -23 -71 l -46 -49 b -250 86 -119 22 -179 62 b -312 99 -275 95 -295 99 b -360 84 -330 99 -345 94 b -401 7 -388 66 -401 36 b -349 -77 -401 -28 -383 -62 b -314 -85 -337 -82 -326 -85 b -260 -69 -297 -85 -279 -80 b -223 -60 -247 -63 -235 -60 b -177 -81 -206 -60 -190 -67 b -159 -125 -165 -93 -159 -109 b -188 -180 -159 -147 -169 -168 b -268 -203 -212 -196 -240 -203 b -376 -165 -306 -203 -345 -190 b -447 -7 -425 -124 -447 -65 b -293 202 -447 86 -390 180 b -260 206 -283 204 -272 206 b -25 109 -194 206 -105 170 l -23 107 l -23 189 b -22 276 -23 271 -23 272 b -10 288 -20 281 -15 286 z"
                },
                ornamentMordent: {
                    x_min: -296,
                    x_max: 296,
                    y_min: -215,
                    y_max: 198,
                    ha: 413,
                    o: "m -11 284 b -3 285 -9 285 -6 285 b 17 273 5 285 14 280 b 19 164 19 270 19 269 l 19 59 l 68 118 b 118 179 98 155 117 178 b 131 182 122 181 127 182 b 143 179 136 182 140 181 b 307 18 145 177 232 92 l 326 -1 l 356 36 b 404 81 393 81 393 81 l 404 81 b 426 59 417 81 426 71 b 424 50 426 56 426 53 b 236 -179 421 44 241 -176 b 224 -182 233 -181 228 -182 b 211 -178 219 -182 215 -181 b 119 -89 210 -178 169 -137 b 29 0 70 -40 30 0 b 29 0 29 0 29 0 b 24 -6 29 0 27 -3 l 19 -12 l 19 -152 b 19 -218 19 -179 19 -200 b 13 -303 19 -308 19 -298 b -3 -310 9 -308 3 -310 b -23 -297 -11 -310 -19 -305 b -25 -180 -24 -294 -24 -294 l -25 -66 l -70 -121 b -118 -178 -99 -156 -116 -177 b -131 -182 -122 -181 -127 -182 b -144 -178 -135 -182 -140 -181 b -307 -18 -145 -177 -233 -91 l -326 1 l -356 -36 b -404 -81 -393 -81 -393 -81 l -404 -81 b -426 -59 -417 -81 -426 -71 b -424 -50 -426 -56 -426 -53 b -236 179 -421 -44 -241 176 b -224 182 -233 181 -228 182 b -211 179 -219 182 -215 181 b -48 18 -209 177 -116 86 l -29 0 l -27 2 l -25 5 l -25 137 b -23 272 -25 267 -25 268 b -11 284 -21 277 -16 282 z"
                },
                ornamentShortTrill: {
                    x_min: -296,
                    x_max: 296,
                    y_min: -127,
                    y_max: 127,
                    ha: 253,
                    o: "m -231 181 b -225 182 -229 182 -227 182 b -211 179 -220 182 -215 181 b -119 89 -210 178 -169 137 b -29 0 -70 40 -30 0 b 44 88 -29 0 4 40 b 118 179 89 144 117 178 b 131 182 122 181 127 182 b 143 179 136 182 140 181 b 307 18 145 177 232 92 l 326 -1 l 356 36 b 404 81 393 81 393 81 l 404 81 b 426 59 417 81 426 71 b 424 50 426 56 426 53 b 236 -179 421 44 241 -176 b 224 -182 233 -181 228 -182 b 211 -178 219 -182 215 -181 b 119 -89 210 -178 169 -137 b 29 0 70 -40 30 0 b -44 -88 29 0 -4 -40 b -118 -179 -89 -144 -117 -178 b -131 -182 -122 -181 -127 -182 b -144 -178 -135 -182 -140 -181 b -307 -18 -145 -177 -233 -91 l -326 1 l -356 -36 b -404 -81 -393 -81 -393 -81 l -404 -81 b -426 -59 -417 -81 -426 -71 b -424 -50 -426 -56 -426 -53 b -236 179 -421 -44 -241 176 b -231 181 -235 179 -233 181 z"
                },
                ornamentTremblement: {
                    x_min: -419,
                    x_max: 419,
                    y_min: -127,
                    y_max: 127,
                    ha: 253,
                    o: "m -409 181 b -402 182 -407 182 -404 182 b -389 179 -397 182 -392 181 b -297 89 -387 178 -346 137 b -207 0 -248 40 -207 0 l -207 0 b -134 88 -206 0 -174 40 b -59 179 -88 144 -61 178 b -46 182 -55 181 -51 182 b -34 179 -42 182 -37 181 b 58 89 -33 178 9 137 b 148 0 107 40 148 0 l 148 0 b 221 88 148 0 181 40 b 296 179 267 144 294 178 b 308 182 300 181 304 182 b 321 179 313 182 317 181 b 485 18 323 177 409 92 l 503 -1 l 533 36 b 581 81 570 81 570 81 l 582 81 b 604 59 594 81 604 71 b 602 50 604 56 603 53 b 414 -179 599 44 418 -176 b 401 -182 410 -181 406 -182 b 388 -178 397 -182 392 -181 b 297 -89 387 -178 346 -137 b 207 0 248 -40 207 0 l 207 0 b 134 -88 206 0 174 -40 b 59 -179 88 -144 61 -178 b 46 -182 55 -181 51 -182 b 34 -178 42 -182 37 -181 b -58 -89 33 -178 -9 -137 b -148 0 -107 -40 -148 0 l -148 0 b -221 -88 -148 0 -181 -40 b -296 -179 -267 -144 -294 -178 b -308 -182 -300 -181 -304 -182 b -321 -178 -313 -182 -317 -181 b -485 -18 -323 -177 -411 -91 l -503 1 l -533 -36 b -581 -81 -570 -81 -570 -81 l -582 -81 b -604 -59 -594 -81 -604 -71 b -602 -50 -604 -56 -603 -53 b -414 179 -599 -44 -418 176 b -409 181 -412 179 -410 181 z"
                },
                ornamentPrecompAppoggTrill: {
                    x_min: -419,
                    x_max: 419,
                    y_min: -127,
                    y_max: 255,
                    ha: 381,
                    o: "m -591 365 b -582 367 -588 366 -585 367 b -561 352 -573 367 -564 361 b -560 176 -560 351 -560 303 l -559 2 l -527 41 b -456 128 -509 63 -477 102 b -414 177 -435 154 -416 176 b -400 182 -411 181 -405 182 b -388 179 -396 182 -392 181 b -296 89 -387 178 -346 137 b -206 0 -247 40 -207 0 b -133 88 -206 0 -173 40 b -59 179 -88 144 -60 178 b -46 182 -55 181 -50 182 b -33 179 -41 182 -37 181 b 58 89 -32 178 9 137 b 148 0 108 40 148 0 l 148 0 b 221 88 149 0 182 40 b 296 179 267 144 295 178 b 309 182 300 181 304 182 b 321 179 313 182 318 181 b 485 18 323 177 410 92 l 503 -1 l 533 36 b 581 81 570 81 571 81 l 582 81 b 604 59 595 81 604 71 b 602 50 604 56 603 53 b 414 -179 599 44 419 -176 b 402 -182 410 -181 406 -182 b 389 -178 397 -182 393 -181 b 297 -89 388 -178 346 -137 b 207 0 248 -40 207 0 l 207 0 b 134 -88 207 0 174 -40 b 59 -179 89 -144 61 -178 b 47 -182 56 -181 51 -182 b 34 -178 42 -182 38 -181 b -58 -89 33 -178 -8 -137 b -148 0 -107 -40 -147 0 b -220 -88 -148 0 -181 -40 b -295 -179 -266 -144 -294 -178 b -308 -182 -299 -181 -303 -182 b -321 -178 -312 -182 -317 -181 b -484 -18 -322 -177 -426 -76 l -503 1 l -535 -38 b -570 -79 -558 -67 -567 -77 b -582 -83 -573 -81 -578 -83 b -602 -70 -590 -83 -598 -78 l -604 -67 l -604 141 l -604 349 l -603 353 b -591 365 -601 358 -596 363 z"
                },
                ornamentPrecompSlideTrillDAnglebert: {
                    x_min: -433,
                    x_max: 433,
                    y_min: -243,
                    y_max: 127,
                    ha: 370,
                    o: "m -388 181 b -382 182 -386 182 -384 182 b -368 179 -377 182 -372 181 b -277 89 -367 178 -326 137 b -187 0 -227 40 -187 0 l -187 0 b -114 88 -186 0 -153 40 b -39 179 -68 144 -40 178 b -26 182 -35 181 -30 182 b -14 179 -22 182 -17 181 b 78 89 -12 178 29 137 b 168 0 127 40 168 0 b 241 88 169 0 201 40 b 316 179 287 144 314 178 b 329 182 320 181 324 182 b 341 179 333 182 337 181 b 505 18 343 177 430 92 l 523 -1 l 553 36 b 601 81 590 81 590 81 l 602 81 b 624 59 614 81 624 71 b 622 50 624 56 623 53 b 434 -179 619 44 439 -176 b 421 -182 430 -181 426 -182 b 409 -178 417 -182 412 -181 b 317 -89 407 -178 366 -137 b 227 0 268 -40 227 0 b 154 -88 227 0 194 -40 b 79 -179 108 -144 81 -178 b 67 -182 75 -181 71 -182 b 54 -178 62 -182 58 -181 b -38 -89 53 -178 12 -137 b -128 0 -87 -40 -127 0 b -201 -88 -128 0 -161 -40 b -276 -179 -246 -144 -274 -178 b -288 -182 -279 -181 -284 -182 b -301 -178 -293 -182 -297 -181 b -393 -88 -302 -178 -343 -137 b -483 0 -442 -40 -483 0 b -483 0 -483 0 -483 0 b -505 -27 -484 0 -497 -15 b -579 -235 -554 -92 -579 -166 b -567 -315 -579 -263 -575 -290 b -564 -330 -565 -320 -564 -325 b -585 -351 -564 -342 -572 -351 b -610 -326 -598 -351 -604 -345 b -624 -235 -619 -297 -624 -267 b -547 -8 -624 -159 -597 -79 b -492 60 -538 4 -533 10 b -426 140 -472 84 -443 120 b -388 181 -396 176 -394 179 z"
                },
                ornamentPrecompSlideTrillBach: {
                    x_min: -433,
                    x_max: 433,
                    y_min: -243,
                    y_max: 198,
                    ha: 442,
                    o: "m 186 284 b 194 285 189 285 192 285 b 215 273 203 285 211 280 b 217 164 216 270 216 269 l 217 59 l 265 118 b 316 179 295 155 314 178 b 329 182 320 181 324 182 b 341 179 333 182 337 181 b 505 18 343 177 430 92 l 523 -1 l 553 36 b 601 81 590 81 590 81 l 602 81 b 624 59 614 81 624 71 b 622 50 624 56 623 53 b 434 -179 619 44 439 -176 b 421 -182 430 -181 426 -182 b 409 -178 417 -182 412 -181 b 317 -89 407 -178 366 -137 b 227 0 268 -40 227 0 b 227 0 227 0 227 0 b 222 -6 227 0 224 -3 l 217 -12 l 217 -152 b 217 -218 217 -179 217 -200 b 210 -303 217 -308 216 -298 b 195 -310 206 -308 201 -310 b 175 -297 187 -310 178 -305 b 173 -180 173 -294 173 -294 l 173 -66 l 127 -121 b 79 -178 99 -156 81 -177 b 67 -182 76 -181 71 -182 b 54 -178 62 -182 58 -181 b -38 -89 53 -178 12 -137 b -128 0 -87 -40 -127 0 b -201 -88 -128 0 -161 -40 b -276 -179 -246 -144 -274 -178 b -288 -182 -279 -181 -284 -182 b -301 -178 -293 -182 -297 -181 b -393 -88 -302 -178 -343 -137 b -483 0 -442 -40 -483 0 b -483 0 -483 0 -483 0 b -505 -27 -484 0 -497 -15 b -579 -235 -554 -92 -579 -166 b -567 -315 -579 -263 -575 -290 b -564 -330 -565 -320 -564 -325 b -586 -351 -564 -342 -572 -351 b -610 -326 -598 -351 -604 -345 b -624 -235 -619 -297 -624 -267 b -547 -8 -624 -159 -597 -79 b -492 60 -538 4 -533 10 b -426 140 -472 84 -443 120 b -393 179 -408 162 -395 178 b -381 182 -390 181 -385 182 b -368 179 -376 182 -372 181 b -277 89 -367 178 -326 137 b -187 0 -227 40 -187 0 l -187 0 b -114 88 -186 0 -153 40 b -39 179 -68 144 -40 178 b -26 182 -35 181 -30 182 b -14 179 -22 182 -17 181 b 150 18 -12 177 81 86 l 168 0 l 171 2 l 173 5 l 173 137 b 174 272 173 267 173 268 b 186 284 176 277 181 282 z"
                },
                ornamentPrecompTrillSuffixDandrieu: {
                    x_min: -433,
                    x_max: 433,
                    y_min: -127,
                    y_max: 244,
                    ha: 370,
                    o: "m 577 349 b 585 351 580 350 582 351 b 601 345 591 351 597 349 b 624 229 613 332 624 275 b 622 204 624 220 623 211 b 559 27 615 139 595 83 b 492 -60 546 6 541 0 b 426 -140 472 -84 443 -120 b 393 -179 408 -162 395 -178 b 381 -182 390 -181 385 -182 b 368 -178 376 -182 372 -181 b 277 -89 367 -178 326 -137 b 187 0 227 -40 187 0 l 187 0 b 114 -88 186 0 153 -40 b 39 -179 68 -144 40 -178 b 26 -182 35 -181 31 -182 b 13 -178 22 -182 17 -181 b -78 -89 12 -178 -29 -137 b -168 0 -127 -40 -168 0 b -241 -88 -169 0 -201 -40 b -316 -179 -287 -144 -314 -178 b -329 -182 -320 -181 -324 -182 b -341 -178 -333 -182 -337 -181 b -505 -18 -343 -177 -431 -91 l -523 1 l -553 -36 b -601 -81 -590 -81 -590 -81 l -602 -81 b -624 -59 -614 -81 -624 -71 b -622 -50 -624 -56 -623 -53 b -434 179 -619 -44 -439 176 b -421 182 -430 181 -426 182 b -409 179 -417 182 -412 181 b -317 89 -408 178 -366 137 b -227 0 -268 40 -227 0 b -154 88 -227 0 -194 40 b -79 179 -108 144 -81 178 b -66 182 -75 181 -71 182 b -54 179 -62 182 -58 181 b 38 89 -53 178 -12 137 b 128 0 87 40 127 0 b 201 88 128 0 161 40 b 276 179 246 144 274 178 b 288 182 279 181 284 182 b 301 179 293 182 297 181 b 393 88 302 178 343 137 b 483 0 442 40 483 0 b 483 0 483 0 483 0 b 505 27 484 0 497 15 b 579 235 554 92 579 166 b 567 315 579 263 575 290 b 564 330 565 321 564 326 b 577 349 564 339 568 346 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefix: {
                    x_min: -439,
                    x_max: 439,
                    y_min: -127,
                    y_max: 236,
                    ha: 363,
                    o: "m -564 338 b -555 340 -561 339 -558 340 b -534 318 -544 340 -534 331 b -534 317 -534 318 -534 317 b -541 296 -534 311 -534 311 b -588 116 -572 236 -588 175 b -583 62 -588 98 -586 80 b -554 -21 -578 34 -566 -2 l -552 -24 l -511 26 b -430 126 -488 54 -452 99 b -386 177 -407 153 -388 176 b -372 182 -382 181 -377 182 b -360 179 -368 182 -364 181 b -268 89 -359 178 -318 137 b -178 0 -219 40 -179 0 b -105 88 -178 0 -145 40 b -30 179 -60 144 -32 178 b -18 182 -27 181 -22 182 b -5 179 -13 182 -9 181 b 86 89 -4 178 37 137 b 176 0 136 40 176 0 l 176 0 b 249 88 177 0 210 40 b 324 179 295 144 323 178 b 337 182 328 181 333 182 b 349 179 341 182 346 181 b 513 18 351 177 438 92 l 532 -1 l 562 36 b 610 81 599 81 599 81 l 610 81 b 632 59 623 81 632 71 b 630 50 632 56 631 53 b 442 -179 627 44 447 -176 b 430 -182 438 -181 434 -182 b 417 -178 425 -182 421 -181 b 325 -89 416 -178 375 -137 b 235 0 276 -40 236 0 l 235 0 b 162 -88 235 0 202 -40 b 87 -179 117 -144 89 -178 b 75 -182 84 -181 79 -182 b 62 -178 70 -182 66 -181 b -29 -89 61 -178 20 -137 b -119 0 -79 -40 -119 0 b -192 -88 -120 0 -153 -40 b -267 -179 -238 -144 -266 -178 b -280 -182 -271 -181 -275 -182 b -293 -178 -284 -182 -289 -181 b -456 -18 -294 -177 -398 -76 l -475 1 l -507 -38 b -554 -83 -543 -82 -543 -83 l -554 -83 b -576 -68 -562 -83 -568 -79 b -632 115 -613 -19 -632 46 b -593 292 -632 173 -619 233 b -564 338 -579 323 -571 335 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefixTurn: {
                    x_min: -439,
                    x_max: 439,
                    y_min: -215,
                    y_max: 236,
                    ha: 451,
                    o: "m -564 338 b -555 340 -561 339 -558 340 b -534 318 -544 340 -534 331 b -534 317 -534 318 -534 317 b -541 296 -534 311 -534 311 b -588 116 -572 236 -588 175 b -583 62 -588 98 -586 80 b -554 -21 -578 34 -566 -2 l -552 -24 l -511 26 b -430 126 -488 54 -452 99 b -386 177 -407 153 -388 176 b -372 182 -382 181 -377 182 b -360 179 -368 182 -364 181 b -268 89 -359 178 -318 137 b -178 0 -219 40 -179 0 b -105 88 -178 0 -145 40 b -30 179 -60 144 -32 178 b -18 182 -27 181 -22 182 b -5 179 -13 182 -9 181 b 158 18 -4 177 89 86 l 177 0 l 179 2 l 181 5 l 181 137 b 183 272 181 267 181 268 b 203 285 186 280 195 285 b 218 279 209 285 214 283 b 225 164 225 273 225 284 l 225 59 l 274 118 b 324 179 304 155 323 178 b 337 182 328 181 333 182 b 349 179 341 182 346 181 b 513 18 351 177 438 92 l 532 -1 l 562 36 b 610 81 599 81 599 81 l 610 81 b 632 59 623 81 632 71 b 630 50 632 56 631 53 b 442 -179 627 44 447 -176 b 430 -182 438 -181 434 -182 b 417 -178 425 -182 421 -181 b 325 -89 416 -178 375 -137 b 235 0 276 -40 236 0 b 235 0 235 0 235 0 b 230 -6 235 0 232 -3 l 225 -12 l 225 -152 b 225 -218 225 -179 225 -200 b 219 -303 225 -308 224 -298 b 203 -310 214 -308 209 -310 b 183 -297 195 -310 187 -305 b 181 -180 182 -294 182 -294 l 181 -66 l 136 -121 b 88 -178 107 -156 89 -177 b 75 -182 84 -181 79 -182 b 62 -178 70 -182 66 -181 b -29 -89 61 -178 20 -137 b -119 0 -79 -40 -119 0 b -192 -88 -120 0 -153 -40 b -267 -179 -238 -144 -266 -178 b -280 -182 -271 -181 -275 -182 b -293 -178 -284 -182 -289 -181 b -456 -18 -294 -177 -398 -76 l -475 1 l -507 -38 b -554 -83 -543 -82 -543 -83 l -554 -83 b -576 -68 -562 -83 -568 -79 b -632 115 -613 -19 -632 46 b -593 292 -632 173 -619 233 b -564 338 -579 323 -571 335 z"
                },
                ornamentPrecompTrillLowerSuffix: {
                    x_min: -439,
                    x_max: 439,
                    y_min: -236,
                    y_max: 127,
                    ha: 362,
                    o: "m -437 181 b -430 182 -435 182 -433 182 b -417 179 -426 182 -420 181 b -325 89 -416 178 -375 137 b -235 0 -276 40 -235 0 l -235 0 b -162 88 -235 0 -202 40 b -87 179 -117 144 -89 178 b -75 182 -84 181 -79 182 b -62 179 -70 182 -66 181 b 29 89 -61 178 -20 137 b 119 0 79 40 119 0 b 192 88 120 0 153 40 b 267 179 238 144 266 178 b 280 182 271 181 276 182 b 292 179 284 182 289 181 b 456 18 294 177 396 77 l 475 -1 l 507 38 b 554 83 543 82 543 83 l 554 83 b 576 68 563 83 568 79 b 632 -116 613 19 632 -46 b 607 -257 632 -162 624 -210 b 571 -334 596 -287 578 -327 b 556 -340 567 -338 561 -340 b 535 -326 547 -340 538 -335 b 533 -319 534 -323 533 -321 b 541 -296 533 -314 536 -308 b 588 -117 572 -236 588 -175 b 579 -40 588 -91 585 -65 b 554 21 573 -19 563 7 l 552 24 l 511 -26 b 430 -126 488 -54 452 -99 b 386 -177 407 -153 388 -176 b 373 -182 382 -181 377 -182 b 360 -178 368 -182 364 -181 b 268 -89 359 -178 318 -137 b 178 0 219 -40 179 0 l 178 0 b 105 -88 178 0 145 -40 b 30 -179 60 -144 32 -178 b 18 -182 27 -181 22 -182 b 5 -178 13 -182 9 -181 b -86 -89 4 -178 -37 -137 b -176 0 -136 -40 -176 0 l -176 0 b -249 -88 -177 0 -210 -40 b -324 -179 -295 -144 -323 -178 b -337 -182 -328 -181 -332 -182 b -349 -178 -341 -182 -346 -181 b -513 -18 -351 -177 -439 -91 l -532 1 l -562 -36 b -610 -81 -599 -81 -599 -81 l -610 -81 b -632 -59 -623 -81 -632 -71 b -630 -50 -632 -56 -631 -53 b -442 179 -627 -44 -447 176 b -437 181 -441 179 -438 181 z"
                },
                stringsDownBow: {
                    x_min: -168,
                    x_max: 168,
                    y_min: 0,
                    y_max: 353,
                    ha: 353,
                    o: "m -228 506 b 3 508 -225 507 -111 508 b 228 506 114 508 225 507 b 240 494 233 504 238 499 b 242 254 241 491 242 373 b 240 14 242 135 241 16 b 220 0 237 5 228 0 b 204 6 214 0 208 2 b 198 89 198 12 198 3 b 198 145 198 104 198 123 l 198 273 l 0 273 l -198 273 l -198 145 b -198 89 -198 123 -198 104 b -204 6 -198 3 -198 12 b -220 0 -208 2 -214 0 b -240 14 -228 0 -237 5 b -242 254 -241 16 -242 135 b -240 494 -242 373 -241 491 b -228 506 -238 499 -233 504 z"
                },
                stringsUpBow: {
                    x_min: -110,
                    x_max: 110,
                    y_min: 0,
                    y_max: 277,
                    ha: 277,
                    o: "m -144 397 b -137 398 -142 398 -140 398 b -117 387 -129 398 -120 394 b -58 234 -116 385 -90 317 b 0 84 -26 152 0 84 b 58 234 0 84 26 152 b 117 387 90 317 116 385 b 136 398 121 395 128 398 b 158 376 147 398 158 390 l 158 370 l 89 191 b 20 11 51 93 20 12 b 0 0 16 4 8 0 b -19 11 -8 0 -16 4 b -158 375 -25 21 -158 370 b -158 376 -158 375 -158 376 b -144 397 -158 386 -153 394 z"
                },
                stringsHarmonic: {
                    x_min: -82,
                    x_max: 82,
                    y_min: -82,
                    y_max: 82,
                    ha: 163,
                    o: "m -19 116 b 1 118 -12 117 -6 118 b 118 0 65 118 118 63 b 114 -30 118 -10 116 -20 b -1 -118 100 -85 50 -118 b -83 -83 -30 -118 -60 -107 b -118 -1 -107 -60 -118 -30 b -19 116 -118 53 -81 105 z m 14 99 b 0 100 9 100 4 100 b -101 0 -57 100 -101 53 b -90 -45 -101 -15 -97 -30 b 0 -100 -71 -82 -36 -100 b 90 -45 36 -100 71 -82 b 101 -1 97 -30 101 -15 b 14 99 101 47 65 92 z"
                },
                pluckedSnapPizzicatoAbove: {
                    x_min: -110,
                    x_max: 110,
                    y_min: -110,
                    y_max: 205,
                    ha: 315,
                    o: "m -9 293 b 0 295 -6 294 -3 295 b 20 281 9 295 17 290 b 22 217 22 278 22 276 l 22 157 l 25 157 b 153 40 85 148 138 100 b 158 0 157 26 158 13 b 40 -153 158 -71 111 -135 b 0 -158 26 -157 13 -158 b -154 -40 -71 -158 -136 -111 b -158 -1 -157 -27 -158 -14 b -25 157 -158 76 -102 146 l -22 157 l -22 217 b -21 281 -22 276 -22 278 b -9 293 -19 286 -13 291 z m -22 54 b -23 112 -22 108 -22 112 b -23 112 -23 112 -23 112 b -81 80 -37 111 -65 96 b -114 1 -104 57 -114 29 b 0 -114 -114 -58 -69 -114 b 114 1 68 -114 114 -58 b 80 80 114 29 104 57 b 22 112 65 96 35 112 b 22 54 22 112 22 92 b 20 -8 22 -3 22 -5 b 0 -22 17 -17 9 -22 b -16 -16 -6 -22 -11 -20 b -22 34 -22 -10 -22 -12 b -22 54 -22 40 -22 46 z"
                },
                pluckedSnapPizzicatoBelow: {
                    x_min: -110,
                    x_max: 110,
                    y_min: -205,
                    y_max: 110,
                    ha: 315,
                    o: "m 9 -293 b 0 -295 6 -294 3 -295 b -20 -281 -9 -295 -17 -290 b -22 -217 -22 -278 -22 -276 l -22 -157 l -25 -157 b -153 -40 -85 -148 -138 -100 b -158 0 -157 -26 -158 -13 b -40 153 -158 71 -111 135 b 0 158 -26 157 -13 158 b 154 40 71 158 136 111 b 158 1 157 27 158 14 b 25 -157 158 -76 102 -146 l 22 -157 l 22 -217 b 21 -281 22 -276 22 -278 b 9 -293 19 -286 13 -291 z m 22 -54 b 23 -112 22 -108 22 -112 b 23 -112 23 -112 23 -112 b 81 -80 37 -111 65 -96 b 114 -1 104 -57 114 -29 b 0 114 114 58 69 114 b -114 -1 -68 114 -114 58 b -80 -80 -114 -29 -104 -57 b -22 -112 -65 -96 -35 -112 b -22 -54 -22 -112 -22 -92 b -20 8 -22 3 -22 5 b 0 22 -17 17 -9 22 b 16 16 6 22 11 20 b 22 -34 22 10 22 12 b 22 -54 22 -40 22 -46 z"
                },
                pluckedLeftHandPizzicato: {
                    x_min: -155,
                    x_max: 155,
                    y_min: -157,
                    y_max: 157,
                    ha: 315,
                    o: "m -9 225 b 0 227 -6 226 -3 227 b 20 213 9 227 17 221 b 22 116 22 209 22 208 l 22 22 l 114 22 b 152 22 129 22 141 22 b 218 16 218 22 212 21 b 224 0 222 11 224 6 b 210 -20 224 -9 219 -17 b 114 -22 207 -22 205 -22 l 22 -22 l 22 -116 b 22 -154 22 -131 22 -143 b 16 -220 22 -221 21 -214 b 0 -227 11 -225 6 -227 b -20 -213 -9 -227 -17 -222 b -22 -116 -22 -209 -22 -208 l -22 -22 l -114 -22 b -210 -20 -205 -22 -207 -22 b -224 0 -219 -17 -224 -9 b -218 16 -224 6 -222 11 b -152 22 -212 21 -218 22 b -114 22 -141 22 -129 22 l -22 22 l -22 116 b -20 213 -22 208 -22 209 b -9 225 -19 218 -13 223 z"
                },
                keyboardPedalPed: {
                    x_min: 0,
                    x_max: 782,
                    y_min: -1,
                    y_max: 500,
                    ha: 501,
                    o: "m 309 719 b 335 720 318 720 327 720 b 521 650 409 720 473 696 b 582 517 561 610 582 560 b 528 423 582 476 564 441 b 483 411 513 415 498 411 b 392 480 443 411 406 437 b 384 516 386 496 384 508 b 400 535 384 529 389 535 b 417 520 409 535 414 530 b 458 494 421 503 438 494 b 498 507 472 494 486 498 b 520 552 513 517 520 533 b 469 645 520 582 502 619 b 349 687 437 670 389 687 l 344 687 l 335 671 b 286 544 299 609 286 577 b 286 543 286 544 286 543 b 341 449 286 511 298 491 b 371 411 359 430 364 424 b 385 358 380 394 385 377 b 378 317 385 345 383 331 b 302 165 365 271 336 212 b 298 159 300 162 298 159 b 298 159 298 159 298 159 b 305 160 299 159 302 159 b 336 162 315 161 326 162 b 486 106 392 162 445 143 l 492 101 l 512 117 b 533 134 523 126 532 133 b 534 136 534 135 534 135 b 533 144 534 138 534 140 b 530 188 531 159 530 174 b 571 320 530 238 544 283 b 657 390 587 342 634 380 b 686 397 666 395 676 397 b 763 335 721 397 755 372 b 766 315 765 328 766 321 b 740 251 766 291 756 267 b 699 219 736 247 702 221 b 636 172 697 218 662 192 b 614 153 618 158 614 154 b 614 153 614 153 614 153 b 645 91 621 129 636 100 b 694 73 657 78 675 73 b 797 123 728 73 769 91 l 800 127 l 799 134 b 795 176 796 148 795 162 b 947 403 795 266 851 351 b 950 405 949 404 950 405 b 944 414 950 407 948 409 b 659 583 875 496 774 556 b 636 603 641 587 636 591 b 654 620 636 614 642 620 b 666 619 658 620 662 620 b 1113 282 884 577 1062 442 b 1126 198 1122 253 1126 225 b 954 -1 1126 87 1054 -1 b 930 1 946 -1 938 0 b 817 83 883 7 841 37 b 815 87 816 85 815 87 b 808 79 814 87 812 84 b 664 0 772 29 717 0 b 620 7 649 0 634 2 b 546 92 584 19 565 40 l 544 99 l 540 97 b 480 49 539 95 512 74 b 414 1 419 0 420 1 l 414 1 b 396 17 404 1 399 5 b 284 110 381 72 333 110 b 266 108 278 110 272 110 l 258 107 l 247 94 b 164 2 213 53 169 4 b 156 0 161 0 159 0 b 139 17 147 0 139 8 b 140 23 139 19 140 21 b 144 34 141 24 142 29 b 234 137 158 79 189 114 b 260 164 244 143 244 142 b 319 290 300 217 319 259 b 281 349 319 312 313 322 b 223 453 250 376 229 414 b 222 472 223 459 222 466 b 296 673 222 522 246 587 l 303 685 l 300 685 b 290 684 299 685 294 684 b 60 496 171 668 77 591 b 59 477 59 490 59 483 b 76 426 59 453 66 431 b 100 420 84 422 92 420 b 162 487 131 420 160 448 b 179 507 163 502 168 507 b 196 479 192 507 196 501 b 196 478 196 478 196 478 b 88 335 195 397 151 338 b 83 335 86 335 84 335 b 0 443 31 335 0 375 l 0 443 b 309 719 0 583 138 706 z m 981 361 b 976 368 978 366 977 368 b 968 362 974 368 972 366 b 872 175 908 318 872 247 b 877 131 872 160 874 145 b 943 34 887 82 914 43 b 949 34 945 34 947 34 b 1018 127 973 34 1004 75 b 1027 198 1024 151 1027 174 b 981 361 1027 253 1011 309 z m 665 338 b 657 339 662 339 660 339 b 641 336 652 339 647 338 b 614 293 635 333 622 312 b 602 221 607 274 602 246 b 604 198 602 213 603 205 b 606 191 605 193 605 191 b 608 193 606 191 607 192 b 666 238 613 197 642 219 b 695 264 690 256 691 257 b 702 290 700 272 702 281 b 665 338 702 312 688 334 z"
                },
                keyboardPedalUp: {
                    x_min: 0,
                    x_max: 435,
                    y_min: 65,
                    y_max: 500,
                    ha: 435,
                    o: "m 300 719 b 311 720 303 720 307 720 b 332 718 319 720 327 719 b 379 654 361 709 379 685 b 354 601 379 632 374 620 b 331 558 338 585 331 572 b 336 536 331 551 333 544 b 374 512 344 521 358 512 b 389 514 379 512 384 513 b 422 575 414 523 422 538 b 474 646 422 614 441 639 b 489 648 479 647 484 648 b 555 581 527 648 555 615 b 535 535 555 565 549 549 b 479 515 520 520 508 516 b 450 512 462 515 458 514 b 418 468 429 505 418 487 b 438 433 418 455 425 441 b 464 424 447 427 455 424 b 509 449 477 424 491 432 b 557 473 526 466 538 472 b 561 473 558 473 560 473 b 627 407 599 473 627 442 b 620 378 627 397 625 387 b 561 341 609 354 588 341 l 560 341 b 508 365 538 341 527 346 b 465 390 491 383 478 390 b 457 389 462 390 460 390 b 418 347 433 384 418 367 b 424 325 418 340 420 332 b 479 299 433 306 446 300 b 535 279 509 298 520 294 b 555 233 549 266 555 249 b 489 166 555 199 527 166 b 474 167 484 166 480 166 b 422 239 441 175 422 200 b 393 298 422 273 414 289 b 374 302 386 301 380 302 b 332 266 354 302 337 288 b 331 255 331 262 331 258 b 355 213 331 242 338 230 b 379 160 374 193 379 182 l 379 160 b 313 93 379 120 348 93 b 272 108 299 93 285 98 b 247 160 256 121 247 140 b 259 198 247 173 251 187 b 272 213 260 200 266 206 b 296 255 289 230 296 242 b 295 266 296 258 296 262 b 253 302 290 288 273 302 b 234 298 247 302 241 301 b 205 239 213 289 205 273 b 153 167 205 200 186 175 b 138 166 148 166 143 166 b 73 232 101 166 73 197 b 82 267 73 244 76 256 b 148 299 95 289 113 298 b 182 304 168 299 171 300 b 197 315 189 307 192 309 b 209 346 205 325 209 336 b 179 386 209 364 198 379 b 162 390 173 389 167 390 b 119 365 148 390 136 382 b 104 352 113 360 107 354 b 67 341 92 344 79 341 b 2 390 38 341 10 359 b 0 407 1 396 0 401 b 66 473 0 443 30 473 b 83 471 72 473 77 473 b 118 449 96 468 104 463 b 161 424 136 432 149 424 b 163 424 161 424 162 424 b 209 467 191 427 209 445 b 203 489 209 474 207 482 b 148 515 193 509 180 515 b 92 535 119 516 107 520 b 72 581 78 549 72 565 b 138 648 72 615 100 648 b 153 646 143 648 148 647 b 205 575 186 639 205 614 b 238 514 205 538 213 523 b 253 512 243 513 248 512 b 291 536 269 512 283 521 b 296 558 294 544 296 551 b 273 601 296 572 289 584 b 254 624 261 612 258 616 b 247 654 249 634 247 644 b 300 719 247 684 268 712 z m 327 475 b 313 476 322 476 318 476 b 244 407 274 476 244 443 b 252 376 244 396 247 386 b 313 338 265 350 289 338 b 375 376 338 338 362 350 b 383 407 380 386 383 396 b 327 475 383 438 361 468 z"
                },
                pictChokeCymbal: {
                    x_min: 0,
                    x_max: 168,
                    y_min: -155,
                    y_max: 155,
                    ha: 311,
                    o: "m 96 223 b 107 224 100 224 103 224 b 236 104 164 224 218 174 b 242 55 240 88 242 71 b 66 -209 242 -42 175 -144 b 33 -224 48 -219 39 -224 b 25 -219 30 -224 28 -222 b 23 -213 24 -216 23 -215 b 36 -199 23 -208 28 -204 b 130 -56 96 -166 130 -110 b 111 8 130 -34 124 -12 l 110 10 l 100 11 b 6 82 58 12 19 42 b 0 117 2 94 0 105 b 96 223 0 170 40 217 z"
                },
                wiggleArpeggiatoUp: {
                    x_min: -8,
                    x_max: 269,
                    y_min: 0,
                    y_max: 126,
                    ha: 126,
                    o: "m 103 180 b 118 181 108 181 113 181 b 223 126 151 181 184 164 b 299 69 250 100 280 78 b 311 67 303 68 307 67 b 359 90 325 67 342 75 b 376 102 372 101 372 102 l 376 102 b 388 91 383 102 388 96 b 385 84 388 88 387 86 b 322 25 379 76 342 42 b 258 0 301 8 280 0 b 153 56 226 0 192 18 b 78 112 127 81 97 103 b 65 114 74 114 70 114 b 17 91 51 114 35 106 b 1 80 5 80 5 80 l 0 80 b -11 91 -7 80 -11 85 b -9 97 -11 93 -10 95 b 55 156 -3 105 34 140 b 103 180 71 170 88 178 z"
                },
                arrowheadBlackUp: {
                    x_min: 11,
                    x_max: 239,
                    y_min: -6,
                    y_max: 269,
                    ha: 275,
                    o: "m 171 386 b 179 387 174 387 176 387 b 201 378 187 387 196 384 b 212 345 206 372 206 372 b 333 45 237 235 282 123 b 344 19 343 29 344 27 b 317 -8 344 2 332 -8 b 299 -3 312 -8 305 -7 b 180 30 262 19 221 30 b 74 4 144 30 108 21 b 61 -3 70 2 64 -1 b 43 -8 55 -7 48 -8 b 16 19 28 -8 16 2 b 27 45 16 27 17 29 b 148 344 78 123 122 233 b 159 378 155 373 154 372 b 171 386 161 381 167 385 z"
                },
                arrowheadBlackDown: {
                    x_min: 11,
                    x_max: 239,
                    y_min: 6,
                    y_max: 281,
                    ha: 275,
                    o: "m 35 403 b 43 405 37 404 40 405 b 62 398 49 405 55 403 b 79 390 65 396 73 392 b 180 367 111 374 145 367 b 298 398 221 367 262 377 b 318 404 305 402 312 404 b 344 377 332 404 344 394 b 333 351 344 369 343 367 b 212 51 282 273 237 161 b 204 23 207 28 206 26 b 180 8 199 13 189 8 b 156 23 171 8 162 13 b 150 44 154 25 153 28 b 27 351 125 158 80 271 b 16 377 17 367 16 369 b 35 403 16 389 24 400 z"
                }
            },
            fontFamily: "GonvilleSmufl",
            resolution: 1e3,
            generatedOn: "2023-04-20T22:11:26.009Z"
        };
        const Oi = {
            glyphs: {
                bracketTop: {
                    x_min: 0,
                    x_max: 491,
                    y_min: 0,
                    y_max: 279,
                    ha: 279,
                    o: "m 697 399 b 687 402 694 400 690 402 b 671 395 681 402 674 400 b 249 168 668 390 524 168 l 20 168 b 0 150 9 168 0 161 l 0 20 l 0 0 l 176 0 b 706 374 619 0 704 370 b 707 382 706 376 707 379 b 697 399 707 389 703 395 z"
                },
                bracketBottom: {
                    x_min: 0,
                    x_max: 491,
                    y_min: -279,
                    y_max: 0,
                    ha: 279,
                    o: "m 697 -399 b 707 -382 703 -395 707 -389 b 706 -374 707 -379 706 -376 b 176 0 704 -370 619 0 l 0 0 l 0 -20 l 0 -150 b 20 -168 0 -161 9 -168 l 249 -168 b 671 -395 524 -168 668 -390 b 687 -402 674 -400 681 -402 b 697 -399 690 -402 694 -400 z"
                },
                segno: {
                    x_min: 0,
                    x_max: 654,
                    y_min: 0,
                    y_max: 869,
                    ha: 869,
                    o: "m 546 690 l 838 1207 b 841 1215 840 1210 841 1212 b 832 1233 841 1221 837 1230 l 809 1248 b 798 1251 806 1250 801 1251 b 780 1241 792 1251 783 1247 l 487 721 l 217 860 b 99 995 147 897 99 924 b 236 1165 99 1120 179 1165 b 343 1073 288 1165 325 1130 b 454 988 357 1022 405 988 b 477 991 461 988 469 989 b 541 1076 526 1002 541 1045 b 540 1089 541 1080 541 1084 b 294 1225 534 1116 514 1225 b 0 939 72 1225 0 1053 b 125 706 0 825 42 753 l 397 563 l 104 45 b 102 35 102 42 102 37 b 111 19 102 29 107 22 l 132 3 b 144 0 135 1 141 0 b 148 0 145 0 147 0 b 161 10 153 1 158 6 l 456 531 l 704 403 b 842 256 780 361 842 318 b 706 86 842 131 763 86 b 599 177 654 86 616 120 b 488 262 585 228 537 262 b 465 259 481 262 472 261 b 402 177 418 248 402 206 b 403 163 402 171 402 167 b 649 26 409 135 429 26 b 942 312 871 26 942 199 b 821 549 942 426 901 507 z m 52 444 b 118 416 69 426 95 416 b 183 444 141 416 166 426 b 210 508 200 461 210 485 b 183 573 210 531 200 556 b 118 600 166 590 141 600 b 52 573 95 600 69 590 b 24 508 35 556 24 531 b 52 444 24 485 35 461 z m 760 730 b 825 703 778 713 802 703 b 890 730 848 703 873 713 b 917 795 907 747 917 772 b 890 861 917 818 907 844 b 825 888 873 878 848 888 b 760 861 802 888 778 878 b 733 795 743 844 733 818 b 760 730 733 772 743 747 z"
                },
                coda: {
                    x_min: 0,
                    x_max: 745,
                    y_min: -113,
                    y_max: 735,
                    ha: 848,
                    o: "m 924 467 b 560 896 916 697 757 881 l 560 1038 b 540 1058 560 1050 552 1058 l 524 1058 b 505 1038 513 1058 505 1050 l 505 896 b 150 467 311 877 158 693 l 20 467 b 0 446 9 467 0 458 l 0 432 b 20 412 0 420 9 412 l 150 412 b 505 0 166 193 317 17 l 505 -143 b 524 -163 505 -154 513 -163 l 540 -163 b 560 -143 552 -163 560 -154 l 560 0 b 923 412 753 13 907 190 l 1054 412 b 1073 432 1066 412 1073 420 l 1073 446 b 1054 467 1073 458 1066 467 z m 560 467 l 560 852 b 773 467 716 837 773 671 z m 505 467 l 301 467 b 505 851 301 668 357 831 z m 505 412 l 505 45 b 301 412 366 65 301 219 z m 560 412 l 772 412 b 560 45 772 215 706 60 z"
                },
                gClef: {
                    x_min: 0,
                    x_max: 640,
                    y_min: -666,
                    y_max: 1112,
                    ha: 1778,
                    o: "m 809 -30 b 665 -279 809 -132 768 -238 b 586 186 635 -107 596 122 b 809 -30 716 186 809 98 z m 605 -297 b 521 -305 576 -302 549 -305 b 140 56 315 -305 140 -161 b 390 498 140 232 264 389 b 459 562 415 520 438 540 b 492 357 472 484 482 416 b 272 45 361 318 272 180 b 467 -194 272 -56 351 -194 b 491 -176 478 -194 491 -189 b 459 -144 491 -163 477 -156 b 372 -1 403 -109 372 -72 b 521 177 372 86 436 157 z m 478 1184 b 632 1392 491 1241 557 1392 b 688 1223 654 1392 688 1322 b 478 863 688 1073 577 960 b 462 1037 469 920 462 976 b 478 1184 462 1090 467 1139 z m 176 -739 b 444 -959 176 -834 249 -959 b 622 -910 511 -959 570 -942 b 720 -670 700 -855 720 -760 b 697 -467 720 -613 711 -549 b 675 -338 693 -438 684 -395 b 922 3 816 -292 922 -145 b 557 367 922 220 768 367 b 516 619 543 454 528 539 b 773 1188 668 779 773 959 b 710 1477 773 1319 733 1426 b 608 1601 675 1551 634 1601 b 505 1528 598 1601 553 1584 b 387 1113 413 1418 387 1234 b 419 804 387 1035 395 965 b 312 701 418 802 343 726 b 0 117 181 579 0 405 b 503 -364 0 -153 235 -364 b 616 -354 544 -364 583 -360 b 660 -670 644 -492 660 -593 b 438 -899 660 -819 583 -899 b 370 -891 403 -899 373 -891 b 366 -887 369 -890 366 -888 b 373 -881 366 -884 369 -883 b 508 -721 441 -871 508 -814 b 341 -562 508 -644 449 -562 b 176 -739 240 -562 176 -644 z"
                },
                cClef: {
                    x_min: 0,
                    x_max: 627,
                    y_min: -480,
                    y_max: 482,
                    ha: 962,
                    o: "m 19 675 b 0 657 9 675 0 667 l 0 -654 b 19 -672 0 -664 9 -672 l 122 -672 b 141 -654 132 -672 141 -664 l 141 657 b 122 675 141 667 132 675 z m 903 -376 b 619 -58 903 -197 808 -58 b 505 -95 586 -58 562 -60 b 426 1 503 -89 474 -32 b 505 98 474 35 503 92 b 641 60 560 65 579 60 b 903 379 816 60 903 223 b 580 694 903 580 755 694 b 318 517 472 694 318 649 b 438 400 318 446 367 400 b 546 510 501 400 546 446 b 425 615 546 589 494 615 b 547 651 458 638 503 651 b 723 400 698 651 723 530 b 593 128 723 289 720 128 b 438 279 467 128 441 265 b 418 300 438 281 438 300 b 396 279 397 300 396 281 b 264 29 383 200 344 62 l 264 657 b 246 675 264 667 256 675 b 228 657 236 675 228 667 l 228 -654 b 246 -672 228 -664 236 -672 b 264 -654 256 -672 264 -664 l 264 -26 b 396 -278 348 -60 380 -197 b 418 -297 396 -279 397 -297 b 438 -278 438 -297 438 -279 b 593 -125 441 -262 467 -125 b 723 -397 720 -125 723 -287 b 547 -648 723 -527 698 -648 b 425 -612 503 -648 458 -635 b 441 -613 426 -612 432 -613 b 546 -507 504 -613 546 -569 b 438 -397 546 -444 501 -397 b 318 -514 367 -397 318 -444 b 580 -691 318 -647 472 -691 b 903 -376 755 -691 903 -577 z"
                },
                fClef: {
                    x_min: 0,
                    x_max: 664,
                    y_min: -617,
                    y_max: 251,
                    ha: 868,
                    o: "m 366 361 b 167 298 256 361 168 298 b 37 112 84 236 50 163 b 27 36 30 86 27 60 b 46 -58 27 1 33 -30 b 140 -138 63 -96 96 -124 b 194 -147 157 -144 176 -147 b 287 -122 226 -147 259 -138 b 359 10 331 -98 359 -46 b 289 134 359 60 333 107 b 206 160 259 154 230 160 b 160 153 189 160 173 157 b 109 122 145 147 121 132 b 147 215 114 150 131 192 b 219 279 163 238 194 266 b 351 308 255 300 301 308 b 570 -52 498 308 570 190 b 477 -399 570 -186 520 -314 b 310 -635 429 -494 366 -585 b 17 -837 160 -772 19 -837 b 0 -864 17 -837 0 -847 b 1 -871 0 -867 1 -868 b 27 -888 6 -886 19 -888 b 35 -887 29 -888 33 -887 b 331 -717 36 -887 200 -819 b 528 -544 405 -664 471 -606 b 661 -367 580 -488 625 -428 b 760 -50 724 -259 760 -147 b 670 239 760 69 729 168 b 366 361 602 320 500 361 z m 818 179 b 887 107 818 138 850 107 b 956 179 924 107 956 138 b 887 252 956 219 924 252 b 818 179 850 252 818 219 z m 818 -177 b 887 -251 818 -217 850 -251 b 956 -177 924 -251 956 -217 b 887 -104 956 -137 924 -104 b 818 -177 850 -104 818 -137 z"
                },
                unpitchedPercussionClef1: {
                    x_min: 0,
                    x_max: 352,
                    y_min: -252,
                    y_max: 252,
                    ha: 504,
                    o: "m 19 363 b 0 344 9 363 0 354 l 0 -344 b 19 -363 0 -354 9 -363 l 177 -363 b 196 -344 187 -363 196 -354 l 196 344 b 177 363 196 354 187 363 z m 330 363 b 311 344 320 363 311 354 l 311 -344 b 330 -363 311 -354 320 -363 l 488 -363 b 507 -344 498 -363 507 -354 l 507 344 b 488 363 507 354 498 363 z"
                },
                "6stringTabClef": {
                    x_min: 0,
                    x_max: 439,
                    y_min: -743,
                    y_max: 746,
                    ha: 1489,
                    o: "m 52 1074 l 52 958 l 249 958 l 249 419 l 387 419 l 387 958 l 583 958 l 583 1074 z m 0 -333 l 145 -333 l 192 -196 l 436 -196 l 481 -333 l 632 -333 l 396 334 l 238 334 z m 315 181 l 400 -81 l 229 -81 z m 566 -474 b 393 -402 531 -428 475 -403 l 71 -402 l 71 -1070 l 372 -1070 b 374 -1070 373 -1070 373 -1070 b 465 -1061 405 -1070 435 -1067 b 541 -1027 494 -1056 520 -1043 b 588 -975 560 -1012 575 -995 b 618 -868 608 -943 618 -907 b 592 -770 618 -829 609 -798 b 514 -711 575 -743 549 -724 b 566 -674 537 -700 554 -688 b 596 -576 586 -649 596 -616 b 566 -474 596 -536 586 -503 z m 348 -518 b 428 -528 380 -518 408 -521 b 464 -590 452 -539 464 -559 b 436 -649 464 -619 455 -638 b 366 -665 418 -661 395 -665 l 203 -665 l 203 -518 z m 367 -776 b 435 -788 396 -776 419 -780 b 477 -858 464 -801 477 -824 b 433 -942 477 -900 462 -927 b 366 -953 418 -949 395 -953 l 203 -953 l 203 -776 z"
                },
                timeSig0: {
                    x_min: 15,
                    x_max: 389,
                    y_min: -254,
                    y_max: 255,
                    ha: 509,
                    o: "m 291 367 b 22 0 138 367 22 209 b 291 -366 22 -209 138 -366 b 560 0 444 -366 560 -209 b 291 367 560 209 444 367 z m 376 -200 b 291 -308 376 -252 353 -308 b 206 -200 229 -308 206 -252 l 206 200 b 291 308 206 252 229 308 b 376 200 353 308 376 252 z"
                },
                timeSig1: {
                    x_min: 15,
                    x_max: 336,
                    y_min: -243,
                    y_max: 245,
                    ha: 488,
                    o: "m 359 -284 l 359 336 b 341 353 359 346 351 353 l 199 353 b 190 350 196 353 193 351 b 184 344 189 348 186 346 l 23 65 b 22 56 22 62 22 59 b 30 42 22 50 26 45 l 58 26 b 66 23 60 24 63 23 b 81 32 72 23 78 27 l 183 207 l 183 -284 l 73 -284 b 56 -301 63 -284 56 -291 l 56 -333 b 73 -350 56 -343 63 -350 l 468 -350 b 484 -333 478 -350 484 -343 l 484 -301 b 468 -284 484 -291 478 -284 z"
                },
                timeSig2: {
                    x_min: 15,
                    x_max: 377,
                    y_min: -243,
                    y_max: 245,
                    ha: 488,
                    o: "m 492 -56 b 382 -192 481 -88 452 -192 b 190 -134 288 -192 268 -134 b 153 -138 179 -134 167 -135 b 341 -36 153 -138 189 -84 b 533 173 494 12 533 86 b 288 353 533 233 505 353 b 30 156 71 353 30 222 b 138 49 30 96 79 49 b 245 156 197 49 245 96 b 179 255 245 196 216 240 b 168 271 174 256 168 264 b 202 297 168 279 176 289 b 251 304 209 300 229 304 b 311 288 271 304 294 300 b 348 180 338 271 348 245 b 65 -150 348 12 148 -24 b 22 -278 65 -150 22 -210 b 73 -350 22 -346 56 -350 b 121 -305 96 -350 121 -331 b 117 -287 121 -300 120 -294 b 105 -239 108 -266 105 -251 b 107 -226 105 -235 105 -230 b 154 -203 108 -217 120 -203 b 238 -289 196 -203 212 -252 b 350 -350 264 -327 304 -350 b 484 -264 396 -350 458 -317 b 543 -63 510 -210 543 -102 b 518 -36 543 -45 531 -36 b 492 -56 508 -36 498 -42 z"
                },
                timeSig3: {
                    x_min: 15,
                    x_max: 364,
                    y_min: -244,
                    y_max: 244,
                    ha: 488,
                    o: "m 392 23 b 514 168 507 68 514 143 b 514 176 514 171 514 174 b 262 351 514 189 510 351 b 22 176 14 351 22 176 l 23 176 l 22 173 b 115 81 22 121 63 81 b 207 173 167 81 207 121 b 135 264 207 215 176 255 b 140 268 137 265 138 266 b 215 289 160 282 187 289 b 340 176 275 289 340 253 b 255 69 340 85 272 72 b 140 60 238 66 157 60 b 121 40 122 60 121 40 l 121 12 b 140 -6 121 12 124 -4 b 243 -14 164 -7 197 -7 b 340 -167 307 -23 340 -66 b 215 -289 340 -264 275 -289 b 121 -266 174 -289 137 -278 b 207 -174 168 -264 207 -222 b 115 -81 207 -122 167 -81 b 22 -174 63 -81 22 -122 b 22 -180 22 -174 22 -177 b 78 -298 22 -199 26 -251 b 236 -351 134 -350 204 -351 b 524 -147 374 -351 524 -304 b 389 23 524 -42 452 3 z"
                },
                timeSig4: {
                    x_min: 14,
                    x_max: 442,
                    y_min: -248,
                    y_max: 249,
                    ha: 497,
                    o: "m 300 -183 l 300 -289 l 180 -289 b 160 -310 170 -289 160 -298 l 160 -337 b 180 -357 160 -348 170 -357 l 616 -357 b 636 -337 628 -357 636 -348 l 636 -310 b 616 -289 636 -298 628 -289 l 487 -289 l 487 -183 l 616 -183 b 636 -161 628 -183 636 -173 l 636 -134 b 616 -114 636 -124 628 -114 l 487 -114 l 487 115 b 477 134 487 124 482 131 l 459 143 b 452 144 456 144 455 144 b 449 144 451 144 451 144 b 436 140 445 144 439 143 l 305 20 b 300 4 301 16 300 10 l 300 -114 l 132 -114 b 464 287 132 -114 294 59 b 471 307 469 294 471 301 b 467 321 471 314 468 320 l 435 353 b 420 359 431 356 426 359 b 206 359 412 359 217 359 b 187 341 196 359 189 350 b 143 118 187 341 180 235 b 24 -124 105 1 62 -71 b 20 -140 24 -124 20 -131 b 22 -148 20 -143 20 -145 b 36 -174 26 -158 36 -174 b 52 -183 36 -174 39 -183 z"
                },
                timeSig5: {
                    x_min: 15,
                    x_max: 362,
                    y_min: -244,
                    y_max: 246,
                    ha: 490,
                    o: "m 39 314 b 46 170 39 314 46 245 b 46 151 46 164 46 157 b 39 -24 45 71 39 -24 b 39 -29 39 -24 39 -26 b 49 -48 39 -35 40 -46 b 99 -59 62 -50 92 -58 b 107 -59 102 -59 104 -59 b 121 -49 112 -59 118 -58 b 235 45 128 -30 144 45 b 356 -112 337 45 356 -43 b 238 -292 356 -184 333 -288 b 226 -292 233 -292 230 -292 b 166 -282 193 -292 174 -288 b 158 -274 161 -281 158 -276 b 164 -264 158 -269 160 -266 b 222 -168 177 -255 222 -239 b 117 -71 222 -98 173 -71 b 22 -171 60 -71 22 -122 b 111 -318 22 -220 36 -275 b 252 -351 147 -338 199 -351 b 456 -275 325 -351 405 -328 b 521 -109 503 -228 521 -167 b 433 79 521 -32 487 43 b 271 124 397 104 336 124 b 131 84 223 124 173 112 b 125 82 130 82 127 82 b 115 92 120 82 115 86 l 115 183 b 131 199 115 192 122 199 l 132 199 b 252 192 154 197 202 192 b 372 209 295 192 340 196 b 474 320 439 236 462 289 b 477 334 475 324 477 330 b 451 354 477 346 469 354 b 431 351 445 354 439 353 b 252 328 360 334 305 328 b 88 343 200 328 150 334 b 71 344 88 343 81 344 b 39 320 56 344 39 340 b 39 314 39 317 39 315 z"
                },
                timeSig6: {
                    x_min: 15,
                    x_max: 387,
                    y_min: -244,
                    y_max: 245,
                    ha: 489,
                    o: "m 356 69 b 216 22 268 69 236 43 b 209 98 212 52 209 75 b 216 167 209 121 212 141 b 338 287 225 220 261 287 b 410 259 374 287 396 275 b 356 174 380 246 356 207 b 448 82 356 122 396 82 b 541 174 500 82 541 122 l 541 177 b 541 179 541 177 541 177 b 533 225 541 192 539 213 b 310 353 514 276 454 353 b 58 163 180 353 86 229 b 22 -23 43 128 22 58 b 131 -285 22 -111 46 -210 b 318 -351 215 -348 268 -351 b 557 -125 369 -351 557 -292 b 356 69 557 16 446 69 z m 302 -291 b 216 -145 255 -291 216 -226 b 302 1 216 -65 255 1 b 390 -145 350 1 390 -65 b 302 -291 390 -226 350 -291 z"
                },
                timeSig7: {
                    x_min: 15,
                    x_max: 366,
                    y_min: -250,
                    y_max: 251,
                    ha: 501,
                    o: "m 233 -177 b 160 -336 202 -225 160 -282 b 180 -360 160 -351 164 -360 b 264 -351 203 -360 217 -354 b 278 -350 268 -351 274 -350 b 369 -360 320 -350 359 -360 b 405 -331 382 -360 406 -344 b 405 -327 405 -330 405 -328 b 396 -226 405 -324 396 -279 b 408 -130 396 -196 399 -161 b 503 151 425 -62 471 60 b 527 308 518 196 527 275 b 526 341 527 321 527 327 b 510 361 524 356 518 361 b 484 361 503 361 491 361 b 467 341 477 361 467 356 b 406 228 467 327 464 228 b 235 351 346 228 328 351 b 86 252 145 351 91 261 l 86 321 b 71 337 86 330 79 337 l 37 337 b 22 321 29 337 22 330 l 22 55 b 37 39 22 46 29 39 l 71 39 b 86 55 79 39 86 46 l 86 101 b 158 179 86 134 108 179 b 328 124 209 179 213 124 b 425 143 357 124 410 128 b 233 -177 413 120 266 -130 z"
                },
                timeSig8: {
                    x_min: 15,
                    x_max: 393,
                    y_min: -248,
                    y_max: 246,
                    ha: 494,
                    o: "m 467 26 b 547 166 514 62 547 108 b 294 354 547 269 433 354 b 40 166 154 354 40 269 b 122 13 40 108 55 56 b 22 -147 58 -24 22 -78 b 294 -357 22 -264 144 -357 b 566 -147 444 -357 566 -264 b 467 26 566 -78 541 -13 z m 294 -276 b 122 -145 202 -276 122 -226 b 197 -26 122 -49 197 -26 b 435 -187 295 -59 435 -108 b 294 -276 435 -226 384 -276 z m 386 65 b 180 209 288 96 180 144 b 294 288 180 265 232 288 b 444 180 383 288 444 246 b 386 65 444 111 412 78 z"
                },
                timeSig9: {
                    x_min: 15,
                    x_max: 387,
                    y_min: -244,
                    y_max: 245,
                    ha: 489,
                    o: "m 223 -68 b 363 -20 311 -68 343 -42 b 370 -96 367 -50 370 -73 b 363 -166 370 -120 367 -140 b 240 -285 354 -219 318 -285 b 168 -258 204 -285 183 -274 b 223 -173 199 -245 223 -206 b 131 -81 223 -121 183 -81 b 37 -173 79 -81 37 -121 l 37 -176 b 37 -177 37 -176 37 -176 b 46 -223 37 -190 40 -212 b 269 -351 65 -275 125 -351 b 521 -161 399 -351 492 -228 b 557 24 536 -127 557 -56 b 448 287 557 112 533 212 b 261 353 364 350 311 353 b 22 127 210 353 22 294 b 223 -68 22 -14 132 -68 z m 276 294 b 363 147 324 294 363 228 b 276 1 363 66 324 1 b 189 147 229 1 189 66 b 276 294 189 228 229 294 z"
                },
                timeSigCommon: {
                    x_min: 0,
                    x_max: 463,
                    y_min: -256,
                    y_max: 258,
                    ha: 514,
                    o: "m 468 258 b 406 147 432 235 406 193 b 408 130 406 141 406 135 b 521 17 415 71 462 24 b 537 17 526 17 533 17 b 667 147 609 17 667 75 b 667 156 667 147 667 151 b 664 177 667 161 665 171 b 350 372 651 239 595 372 b 0 17 36 372 0 111 b 382 -369 0 -154 22 -369 b 641 -131 524 -369 635 -285 b 629 -120 641 -124 636 -120 l 611 -120 b 599 -131 605 -120 599 -125 b 382 -323 593 -251 508 -323 b 196 -128 256 -323 196 -255 l 196 147 b 356 320 196 228 228 320 b 469 271 423 320 454 295 b 471 264 471 268 471 266 b 468 258 471 262 471 259 z"
                },
                timeSigCutCommon: {
                    x_min: 0,
                    x_max: 463,
                    y_min: -376,
                    y_max: 388,
                    ha: 764,
                    o: "m 611 -120 b 599 -131 605 -120 599 -125 b 382 -323 593 -251 508 -323 b 369 -323 377 -323 373 -323 l 369 320 b 469 269 428 317 455 292 b 471 264 471 266 471 265 b 468 258 471 261 471 259 b 406 147 432 235 406 193 b 408 130 406 141 406 135 b 523 17 415 71 464 24 b 537 17 527 17 533 17 b 667 147 609 17 667 75 b 667 156 667 147 667 151 b 664 177 667 161 665 171 b 369 370 651 236 598 364 l 369 543 b 353 559 369 552 361 559 l 314 559 b 298 543 305 559 298 552 l 298 369 b 0 17 32 341 0 105 b 298 -364 0 -140 17 -334 l 298 -526 b 314 -541 298 -534 305 -541 l 353 -541 b 369 -526 361 -541 369 -534 l 369 -369 b 382 -369 373 -369 377 -369 b 641 -131 524 -369 635 -285 b 629 -120 641 -124 636 -120 z m 196 147 b 298 312 196 215 216 289 l 298 -310 b 196 -128 229 -285 196 -223 z"
                },
                timeSigPlus: {
                    x_min: 0,
                    x_max: 408,
                    y_min: -204,
                    y_max: 204,
                    ha: 408,
                    o: "m 327 33 l 327 275 b 308 294 327 285 318 294 l 279 294 b 261 275 269 294 261 285 l 261 33 l 19 33 b 0 14 9 33 0 24 l 0 -13 b 19 -33 0 -23 9 -33 l 261 -33 l 261 -274 b 279 -294 261 -284 269 -294 l 308 -294 b 327 -274 318 -294 327 -284 l 327 -33 l 567 -33 b 588 -13 577 -33 588 -23 l 588 14 b 567 33 588 24 577 33 z"
                },
                noteheadDoubleWhole: {
                    x_min: 0,
                    x_max: 538,
                    y_min: -178,
                    y_max: 179,
                    ha: 357,
                    o: "m 33 258 b 20 258 27 258 26 258 b 0 238 9 258 0 249 b 0 -236 0 226 0 -226 b 20 -256 0 -246 9 -256 b 33 -256 26 -256 27 -256 b 53 -236 43 -256 53 -245 b 53 238 53 -228 53 226 b 33 258 53 249 45 258 z m 649 258 b 636 258 644 258 642 258 b 616 238 625 258 616 249 b 616 125 616 235 616 187 b 389 196 573 167 500 196 b 160 125 276 196 203 167 b 160 238 160 187 160 235 b 140 258 160 249 151 258 b 127 258 134 258 132 258 b 107 238 115 258 107 249 b 107 -236 107 226 107 -226 b 127 -256 107 -246 115 -256 b 140 -256 132 -256 134 -256 b 160 -236 150 -256 160 -245 b 160 -122 160 -233 160 -186 b 389 -194 203 -166 276 -194 b 616 -122 500 -194 573 -166 b 616 -236 616 -186 616 -233 b 636 -256 616 -246 625 -256 b 649 -256 642 -256 644 -256 b 670 -236 660 -256 670 -245 b 670 238 670 -228 670 226 b 649 258 670 249 661 258 z m 462 -140 b 400 -148 445 -144 422 -148 b 314 -101 360 -148 333 -135 b 268 68 295 -65 269 29 b 268 76 268 71 268 73 b 314 141 268 109 282 130 b 377 150 331 145 354 150 b 462 102 416 150 442 140 b 510 -66 482 63 510 -29 b 462 -140 510 -104 497 -128 z m 755 258 b 742 258 749 258 747 258 b 721 238 730 258 721 249 b 721 -236 721 226 721 -226 b 742 -256 721 -246 730 -256 b 755 -256 747 -256 749 -256 b 775 -236 765 -256 775 -245 b 775 238 775 -228 775 226 b 755 258 775 249 766 258 z"
                },
                noteheadWhole: {
                    x_min: 0,
                    x_max: 373,
                    y_min: -134,
                    y_max: 136,
                    ha: 270,
                    o: "m 269 196 b 0 1 71 196 0 95 b 269 -193 0 -92 71 -193 b 537 1 468 -193 537 -92 b 269 196 537 95 468 196 z m 343 -138 b 281 -147 325 -144 302 -147 b 194 -99 240 -147 213 -135 b 148 68 176 -63 150 29 b 194 141 145 107 160 130 b 256 150 212 147 235 150 b 343 102 297 150 323 141 b 389 -65 363 63 389 -29 b 343 -138 389 -102 377 -128 z"
                },
                noteheadHalf: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -133,
                    y_max: 132,
                    ha: 265,
                    o: "m 307 190 b 0 -60 167 190 0 73 b 161 -192 0 -122 45 -192 b 468 58 311 -192 468 -69 b 307 190 468 143 396 190 z m 268 -63 b 108 -124 264 -66 158 -124 b 50 -72 60 -124 50 -85 b 200 62 50 -12 194 59 b 360 122 206 65 308 122 b 418 71 395 122 418 102 b 268 -63 418 9 272 -60 z"
                },
                noteheadBlack: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -133,
                    y_max: 132,
                    ha: 265,
                    o: "m 0 -60 b 161 -192 0 -122 45 -192 b 468 58 311 -192 468 -69 b 307 190 468 143 396 190 b 0 -60 167 190 0 72 z"
                },
                noteheadXBlack: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -132,
                    y_max: 132,
                    ha: 264,
                    o: "m 461 138 b 468 153 465 141 468 147 l 468 154 b 462 167 468 160 465 164 l 445 184 b 431 190 441 187 436 190 b 418 186 426 190 420 189 l 235 40 l 50 186 b 37 190 48 189 42 190 b 24 184 32 190 29 187 l 6 167 b 0 153 3 164 0 158 b 7 138 0 147 3 141 l 183 0 l 7 -138 b 0 -153 3 -141 0 -147 b 6 -166 0 -157 3 -163 l 23 -184 b 37 -190 26 -189 32 -190 b 50 -186 42 -190 48 -189 l 235 -40 l 418 -186 b 431 -190 420 -189 426 -190 b 445 -184 436 -190 442 -189 l 462 -166 b 468 -153 465 -163 468 -157 b 461 -138 468 -147 465 -141 l 285 0 z"
                },
                noteheadCircleX: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -162,
                    y_max: 163,
                    ha: 325,
                    o: "m 265 0 l 395 105 b 426 0 415 75 426 39 b 387 -115 426 -43 412 -84 z m 233 -27 l 360 -145 b 235 -192 327 -174 282 -192 b 99 -137 183 -192 134 -171 z m 202 1 l 73 -105 b 42 0 53 -75 42 -39 b 81 115 42 43 56 84 z m 235 29 l 108 145 b 233 193 141 174 186 193 b 369 138 285 193 334 173 z m 233 235 b 0 0 104 235 0 130 b 233 -233 0 -130 104 -233 b 468 0 363 -233 468 -130 b 233 235 468 130 363 235 z"
                },
                noteheadDoubleWholeSquare: {
                    x_min: 0,
                    x_max: 432,
                    y_min: -179,
                    y_max: 177,
                    ha: 356,
                    o: "m 590 255 b 570 235 579 255 570 246 l 570 203 l 53 203 l 53 235 b 33 255 53 246 45 255 l 20 255 b 0 235 9 255 0 246 l 0 -230 b 20 -251 0 -242 9 -251 l 33 -251 b 53 -230 45 -251 53 -242 l 53 -200 l 570 -200 l 570 -238 b 590 -258 570 -249 579 -258 l 603 -258 b 622 -238 615 -258 622 -249 l 622 235 b 603 255 622 246 615 255 z m 570 -101 l 53 -101 l 53 105 l 570 105 z"
                },
                noteheadSquareWhite: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 395 128 l 395 -128 l 52 -128 l 52 128 z m 446 180 l 0 180 l 0 -180 l 446 -180 z"
                },
                noteheadSquareBlack: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 446 180 l 0 180 l 0 -180 l 446 -180 z"
                },
                noteheadTriangleUpBlack: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -136,
                    y_max: 122,
                    ha: 258,
                    o: "m 223 176 l 0 -196 l 446 -196 z"
                },
                noteheadSlashedDoubleWhole1: {
                    x_min: -66,
                    x_max: 456,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 652 298 b 638 305 649 304 644 305 b 626 301 634 305 629 304 l 560 248 b 543 256 557 253 550 256 b 530 256 537 256 536 256 b 510 236 518 256 510 248 b 510 204 510 235 510 223 l 455 161 b 281 194 413 181 356 194 b 53 124 168 194 96 166 b 53 236 53 186 53 233 b 29 256 53 253 42 256 b 20 256 26 256 23 256 b 0 236 9 256 0 248 b 0 -204 0 228 0 -98 l -88 -272 b -95 -288 -92 -276 -95 -282 b -91 -300 -95 -291 -94 -295 b -76 -307 -86 -304 -82 -307 b -65 -302 -72 -307 -68 -305 l 3 -248 b 20 -258 6 -253 12 -258 b 53 -238 33 -258 52 -255 b 53 -206 53 -236 53 -225 l 107 -161 b 281 -196 148 -183 206 -196 b 510 -124 393 -196 465 -166 b 510 -238 510 -187 510 -235 b 530 -258 510 -248 518 -258 b 563 -238 543 -258 563 -255 b 563 204 563 -229 563 98 l 649 272 b 657 288 655 276 657 282 b 652 298 657 291 655 295 z m 160 75 b 269 148 160 138 219 148 b 356 101 310 148 334 140 b 363 85 357 96 360 91 l 189 -56 b 160 66 174 -14 161 40 b 160 75 160 69 160 72 z m 53 -163 b 53 -124 53 -151 53 -138 b 76 -144 60 -131 68 -138 z m 402 -68 b 292 -148 402 -138 351 -148 b 207 -101 252 -150 226 -137 b 199 -84 204 -96 202 -91 l 373 56 b 402 -68 389 13 402 -40 z m 510 124 b 485 144 503 131 494 137 l 510 163 b 510 124 510 151 510 137 z"
                },
                noteheadSlashedWhole1: {
                    x_min: -75,
                    x_max: 448,
                    y_min: -211,
                    y_max: 214,
                    ha: 425,
                    o: "m 641 301 b 625 308 636 305 631 308 b 613 304 621 307 618 307 l 439 160 b 269 196 399 181 343 196 b 0 1 71 196 0 95 b 69 -138 0 -49 20 -101 l -101 -271 b -108 -287 -105 -275 -108 -281 b -104 -298 -107 -291 -107 -294 b -88 -304 -99 -302 -94 -304 b -76 -301 -85 -304 -81 -304 l 98 -157 b 269 -193 138 -179 194 -193 b 537 1 468 -193 537 -92 b 468 141 537 52 517 104 l 638 274 b 645 289 642 278 645 284 b 641 301 644 292 644 297 z m 148 68 b 148 78 148 72 148 75 b 194 141 148 111 163 131 b 256 150 212 147 235 150 b 343 102 297 150 323 141 b 350 86 346 98 348 92 l 177 -55 b 148 68 163 -12 150 42 z m 389 -65 b 343 -138 389 -102 377 -128 b 281 -147 325 -144 302 -147 b 194 -99 240 -147 213 -135 b 187 -82 192 -95 190 -89 l 279 -6 l 361 58 b 389 -65 376 16 389 -39 z"
                },
                noteheadSlashedHalf1: {
                    x_min: -98,
                    x_max: 424,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 606 298 b 592 305 602 302 598 305 b 580 301 588 305 583 304 l 412 163 b 307 190 383 180 347 190 b 153 148 258 190 204 176 b 0 -60 58 98 0 13 b 14 -120 0 -81 4 -101 b 32 -143 20 -128 26 -135 l -134 -274 b -141 -288 -138 -276 -141 -282 b -137 -300 -141 -292 -140 -297 b -122 -307 -134 -304 -128 -307 b -111 -302 -118 -307 -114 -305 l 56 -164 b 161 -192 85 -181 121 -192 b 315 -151 210 -192 264 -179 b 468 58 410 -101 468 -16 b 454 117 468 78 464 98 b 436 141 449 125 444 134 l 603 272 b 611 287 608 275 611 281 b 606 298 611 291 609 295 z m 56 -98 b 49 -73 52 -91 49 -82 b 75 -23 49 -58 59 -39 b 199 60 99 1 147 32 b 337 118 251 89 302 111 b 359 121 344 120 351 121 b 361 121 360 121 360 121 l 225 9 l 69 -114 b 56 -98 65 -109 60 -104 z m 410 94 b 416 69 415 86 416 78 b 392 19 416 53 408 36 b 266 -65 367 -6 318 -36 b 128 -122 215 -94 163 -115 b 107 -125 121 -124 114 -125 b 104 -125 107 -125 105 -125 l 245 -9 l 396 111 b 410 94 402 107 408 101 z"
                },
                noteheadSlashedBlack1: {
                    x_min: -98,
                    x_max: 424,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 606 298 b 592 305 602 302 598 305 b 580 301 588 305 583 304 l 412 161 b 307 190 383 180 347 190 b 0 -60 167 190 0 72 b 32 -144 0 -89 10 -120 l -134 -274 b -141 -288 -138 -278 -141 -284 b -137 -301 -141 -292 -140 -297 b -122 -307 -134 -305 -128 -307 b -111 -304 -118 -307 -114 -307 l 56 -164 b 161 -192 82 -181 117 -192 b 468 58 311 -192 468 -71 b 436 141 468 91 456 120 l 603 271 b 611 285 608 275 611 281 b 606 298 611 289 609 294 z"
                },
                noteheadSlashedDoubleWhole2: {
                    x_min: -66,
                    x_max: 456,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 563 -204 b 563 236 563 -98 563 228 b 543 256 563 249 554 256 b 530 256 537 256 536 256 b 510 236 518 256 510 248 b 510 124 510 233 510 187 b 281 194 467 166 393 194 b 107 161 207 194 150 181 l 53 204 b 53 236 53 223 53 235 b 33 256 53 249 45 256 b 20 256 27 256 26 256 b 3 246 12 256 6 253 l -63 301 b -76 305 -68 304 -72 305 b -91 298 -81 305 -86 304 b -95 287 -94 295 -95 291 b -88 272 -95 281 -92 276 l 0 204 b 0 -238 0 98 0 -229 b 20 -258 0 -248 9 -258 b 33 -258 26 -258 27 -258 b 53 -238 43 -258 53 -246 b 53 -124 53 -235 53 -187 b 281 -196 96 -166 170 -196 b 456 -161 356 -196 413 -183 l 510 -206 b 510 -238 510 -225 510 -236 b 530 -258 510 -248 518 -258 b 543 -258 536 -258 537 -258 b 560 -246 549 -258 556 -252 l 626 -302 b 638 -307 631 -305 634 -307 b 654 -300 645 -307 649 -304 b 657 -288 655 -295 657 -292 b 651 -272 657 -282 655 -276 z m 207 140 b 269 148 225 144 248 148 b 356 101 310 148 336 140 b 402 -68 376 62 402 -30 b 402 -78 402 -71 402 -75 l 292 9 l 168 109 b 207 140 176 124 189 134 z m 78 144 b 53 124 69 137 60 131 b 53 163 53 137 53 150 z m 356 -141 b 294 -148 338 -145 315 -148 b 207 -101 253 -148 226 -137 b 161 66 189 -66 163 27 b 160 72 161 69 160 71 b 161 78 160 75 160 76 l 271 -9 l 395 -109 b 356 -141 387 -124 374 -134 z m 485 -144 b 510 -124 494 -138 503 -131 b 510 -163 510 -138 510 -151 z"
                },
                noteheadSlashedWhole2: {
                    x_min: -75,
                    x_max: 448,
                    y_min: -212,
                    y_max: 214,
                    ha: 426,
                    o: "m 468 -138 b 537 1 517 -101 537 -49 b 269 196 537 95 468 196 b 98 160 196 196 140 181 l -76 304 b -88 308 -81 307 -84 307 b -104 301 -94 308 -99 305 b -108 289 -107 297 -107 292 b -101 274 -108 284 -105 278 l 69 141 b 0 1 20 104 0 52 b 269 -193 0 -92 71 -193 b 441 -157 343 -193 399 -179 l 613 -301 b 625 -305 618 -304 622 -305 b 641 -298 631 -305 636 -302 b 645 -287 644 -294 644 -291 b 638 -271 645 -281 642 -275 z m 194 141 b 256 150 212 147 235 150 b 343 102 297 150 323 141 b 389 -65 363 63 389 -29 b 389 -76 389 -69 389 -73 l 279 10 l 156 112 b 194 141 163 125 176 135 z m 343 -138 b 281 -147 325 -144 302 -147 b 194 -99 240 -147 213 -135 b 148 68 176 -63 150 29 b 148 76 148 71 148 73 b 148 81 148 78 148 79 l 258 -6 l 382 -108 b 343 -138 374 -122 361 -132 z"
                },
                noteheadSlashedHalf2: {
                    x_min: -98,
                    x_max: 424,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 386 -102 b 468 58 438 -55 468 4 b 454 117 468 78 464 98 b 307 190 428 164 373 190 b 153 148 258 190 204 176 b 108 120 137 140 122 130 l -111 301 b -122 305 -114 304 -118 305 b -137 298 -128 305 -134 302 b -141 287 -140 295 -141 291 b -134 272 -141 281 -138 275 l 85 101 b 0 -60 32 53 0 -7 b 14 -120 0 -81 4 -101 b 161 -192 40 -167 95 -192 b 315 -151 210 -192 264 -179 b 361 -122 333 -143 347 -132 l 580 -302 b 592 -307 583 -305 588 -307 b 606 -300 598 -307 602 -304 b 611 -288 609 -297 611 -292 b 603 -274 611 -282 608 -276 z m 199 60 b 337 118 251 89 302 111 b 359 121 344 120 351 121 b 410 94 382 121 400 112 b 416 69 415 86 416 78 b 392 19 416 53 408 36 b 308 -42 374 0 343 -20 l 245 7 l 189 55 b 199 60 192 56 196 58 z m 266 -65 b 128 -122 215 -94 163 -115 b 107 -125 121 -124 114 -125 b 56 -98 84 -125 66 -117 b 49 -73 52 -91 49 -82 b 75 -23 49 -58 59 -39 b 163 39 94 -4 125 17 l 225 -9 l 282 -56 b 266 -65 276 -59 272 -62 z"
                },
                noteheadSlashedBlack2: {
                    x_min: -98,
                    x_max: 424,
                    y_min: -213,
                    y_max: 212,
                    ha: 425,
                    o: "m 384 -102 b 468 58 435 -58 468 0 b 307 190 468 143 396 190 b 108 121 239 190 167 163 l -111 301 b -124 305 -115 304 -120 305 b -138 298 -128 305 -134 302 b -141 289 -140 295 -141 292 b -141 287 -141 288 -143 288 b -135 272 -141 281 -140 275 l 84 101 b 0 -60 35 56 0 0 b 161 -192 0 -122 45 -192 b 361 -122 232 -192 304 -164 l 579 -302 b 590 -307 583 -305 588 -307 b 606 -300 596 -307 602 -304 b 611 -288 609 -297 611 -292 b 603 -274 609 -282 608 -276 z"
                },
                noteheadDiamondDoubleWhole: {
                    x_min: 0,
                    x_max: 373,
                    y_min: -178,
                    y_max: 179,
                    ha: 357,
                    o: "m 504 258 b 484 238 494 258 484 248 l 484 46 b 282 187 415 95 285 186 b 268 192 279 190 275 192 b 255 187 262 192 258 190 l 52 45 l 52 238 b 33 258 52 248 43 258 l 20 258 b 0 238 9 258 0 248 l 0 -236 b 20 -256 0 -248 9 -256 l 33 -256 b 52 -236 43 -256 52 -248 l 52 -45 l 249 -181 b 268 -190 258 -189 264 -190 b 282 -186 274 -190 279 -189 b 484 -43 285 -184 413 -94 l 484 -236 b 504 -256 484 -248 494 -256 l 517 -256 b 537 -236 528 -256 537 -248 l 537 238 b 517 258 537 248 528 258 z m 220 -115 l 102 -33 l 317 117 l 435 35 z"
                },
                noteheadDiamondWhole: {
                    x_min: 0,
                    x_max: 373,
                    y_min: -133,
                    y_max: 132,
                    ha: 265,
                    o: "m 282 -187 b 530 -13 285 -186 530 -13 b 537 0 534 -10 537 -6 b 530 13 537 4 534 10 b 282 186 530 13 287 183 b 268 190 279 189 275 190 b 255 186 262 190 258 189 l 7 12 b 0 -1 3 9 0 4 b 4 -13 0 -6 1 -10 l 249 -183 b 268 -192 258 -190 264 -192 b 282 -187 274 -192 279 -190 z m 220 -117 l 102 -35 l 317 115 l 435 33 z"
                },
                noteheadDiamondHalf: {
                    x_min: 0,
                    x_max: 335,
                    y_min: -132,
                    y_max: 133,
                    ha: 265,
                    o: "m 475 -13 b 482 0 480 -10 482 -6 b 475 13 482 4 480 10 l 253 187 b 240 192 251 190 246 192 b 229 187 236 192 232 190 l 7 13 b 0 0 3 10 0 6 b 7 -13 0 -4 3 -10 l 229 -186 b 240 -190 232 -189 236 -190 b 253 -186 246 -190 251 -189 z m 284 -115 l 92 33 l 199 117 l 390 -33 z"
                },
                noteheadDiamondBlack: {
                    x_min: 0,
                    x_max: 335,
                    y_min: -132,
                    y_max: 133,
                    ha: 265,
                    o: "m 475 -14 b 482 -1 480 -10 482 -6 b 475 13 482 4 480 10 l 253 187 b 240 192 251 190 246 192 b 229 187 236 192 232 190 l 7 13 b 0 0 3 10 0 4 b 7 -14 0 -6 3 -10 l 229 -186 b 240 -190 232 -189 236 -190 b 253 -186 246 -190 251 -189 z"
                },
                noteheadParenthesisRight: {
                    x_min: 0,
                    x_max: 75,
                    y_min: -209,
                    y_max: 212,
                    ha: 421,
                    o: "m 10 305 b 4 302 7 304 6 304 b 0 295 1 301 0 298 b 1 289 0 294 0 292 b 68 -10 1 288 68 160 b 1 -288 68 -95 50 -192 b 0 -292 0 -289 0 -291 b 4 -300 0 -295 1 -298 b 12 -301 7 -301 9 -302 b 17 -298 14 -301 16 -300 b 108 0 22 -292 108 -174 b 17 301 108 174 22 295 b 10 305 16 304 13 305 z"
                },
                noteheadParenthesisLeft: {
                    x_min: 0,
                    x_max: 75,
                    y_min: -212,
                    y_max: 209,
                    ha: 421,
                    o: "m 98 -305 b 104 -302 101 -304 102 -304 b 108 -295 107 -301 108 -298 b 107 -289 108 -294 108 -292 b 40 10 107 -288 40 -160 b 107 288 40 95 58 192 b 108 292 108 289 108 291 b 104 300 108 295 107 298 b 96 301 101 301 99 302 b 91 298 94 301 92 300 b 0 0 86 292 0 174 b 91 -301 0 -174 86 -295 b 98 -305 92 -304 95 -305 z"
                },
                noteheadMoonBlack: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 0 180 l 0 0 b 223 -180 0 -99 99 -180 b 446 0 347 -180 446 -99 l 446 180 z"
                },
                noteheadTriangleLeftBlack: {
                    x_min: 0,
                    x_max: 339,
                    y_min: -136,
                    y_max: 122,
                    ha: 258,
                    o: "m 0 176 l 0 -196 l 488 -196 z"
                },
                noteheadTriangleRightBlack: {
                    x_min: 0,
                    x_max: 339,
                    y_min: -136,
                    y_max: 122,
                    ha: 258,
                    o: "m 488 176 l 0 -196 l 488 -196 z"
                },
                noteheadTriangleRoundDownBlack: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -136,
                    y_max: 122,
                    ha: 258,
                    o: "m 226 -196 l 446 63 b 226 176 446 63 384 176 b 0 63 68 176 0 63 z"
                },
                augmentationDot: {
                    x_min: 0,
                    x_max: 100,
                    y_min: -50,
                    y_max: 50,
                    ha: 100,
                    o: "m 0 0 b 72 -72 0 -40 32 -72 b 144 0 112 -72 144 -40 b 72 72 144 40 112 72 b 0 0 32 72 0 40 z"
                },
                tremolo1: {
                    x_min: 0,
                    x_max: 290,
                    y_min: -93,
                    y_max: 96,
                    ha: 189,
                    o: "m 0 48 l 0 -134 l 418 -43 l 418 138 z"
                },
                flag8thUp: {
                    x_min: 0,
                    x_max: 289,
                    y_min: -817,
                    y_max: 12,
                    ha: 829,
                    o: "m 0 -327 b 12 -343 0 -331 1 -338 b 291 -600 73 -363 197 -441 b 359 -827 317 -645 359 -707 b 294 -1140 359 -930 331 -1037 b 289 -1162 291 -1149 288 -1156 b 297 -1175 289 -1168 291 -1172 b 304 -1176 300 -1176 302 -1176 b 327 -1161 314 -1176 321 -1171 b 416 -798 395 -1041 418 -888 b 416 -780 416 -791 416 -786 b 302 -458 409 -595 302 -458 b 131 -220 307 -458 170 -281 b 50 -50 78 -138 53 -56 b 36 6 49 -46 36 6 b 19 17 35 12 27 17 b 0 -1 9 17 0 9 z"
                },
                flag8thDown: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -12,
                    y_max: 817,
                    ha: 829,
                    o: "m 0 1 b 19 -17 0 -9 9 -17 b 36 -6 26 -17 35 -12 b 50 50 36 -4 49 46 b 117 196 52 56 65 111 b 331 458 173 289 259 357 b 445 780 402 559 445 654 b 338 1161 445 912 415 1021 b 317 1176 334 1171 325 1176 b 310 1175 314 1176 311 1176 b 300 1158 302 1172 300 1166 b 304 1140 300 1153 301 1146 b 384 827 361 1007 384 930 b 317 600 384 707 343 645 b 12 343 223 441 72 363 b 0 327 1 338 0 331 z"
                },
                flag16thUp: {
                    x_min: 0,
                    x_max: 279,
                    y_min: -820,
                    y_max: 12,
                    ha: 832,
                    o: "m 301 -681 b 148 -514 262 -631 219 -585 b 56 -372 92 -458 66 -409 b 52 -343 55 -364 53 -354 b 271 -510 125 -343 219 -442 b 340 -696 327 -583 340 -641 b 337 -739 340 -710 338 -724 b 301 -681 325 -716 312 -697 z m 0 -549 b 22 -563 0 -553 12 -559 b 258 -776 59 -576 171 -648 b 318 -950 307 -850 318 -901 b 317 -975 318 -959 318 -966 b 285 -1140 317 -1009 307 -1083 b 279 -1164 284 -1148 279 -1156 b 289 -1179 279 -1169 282 -1175 b 297 -1181 292 -1181 294 -1181 b 318 -1161 307 -1181 312 -1169 b 382 -962 344 -1120 382 -1043 b 374 -855 382 -920 379 -886 b 402 -678 389 -802 402 -749 b 333 -471 402 -603 382 -536 b 137 -228 265 -382 192 -307 b 42 0 82 -148 42 0 b 22 17 39 10 37 17 b 0 0 4 17 0 10 z"
                },
                flag16thDown: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -26,
                    y_max: 803,
                    ha: 829,
                    o: "m 53 346 b 56 363 55 353 56 359 b 163 517 66 399 78 452 b 384 732 246 582 346 662 b 317 503 382 621 354 552 b 53 346 229 395 122 364 z m 0 -14 b 22 -37 0 -26 10 -37 b 43 -14 33 -37 40 -26 b 167 232 65 134 109 177 b 445 683 243 305 445 416 b 432 837 445 730 441 783 b 441 919 438 855 441 881 b 327 1149 441 1032 374 1112 b 304 1156 321 1153 312 1156 b 287 1152 298 1156 292 1155 b 279 1145 281 1149 279 1148 b 294 1129 279 1140 288 1135 b 382 930 344 1076 382 1027 b 374 876 382 912 380 893 l 373 871 b 373 871 373 871 373 871 b 327 789 366 842 350 815 b 22 598 226 672 86 612 b 0 559 12 593 0 562 z"
                },
                flag32ndUp: {
                    x_min: 0,
                    x_max: 279,
                    y_min: -821,
                    y_max: 186,
                    ha: 1007,
                    o: "m 301 -683 b 148 -516 262 -632 219 -588 b 56 -373 92 -459 66 -410 b 50 -343 55 -366 53 -354 b 271 -500 125 -343 219 -432 b 340 -687 327 -575 340 -632 b 337 -739 340 -704 338 -721 b 301 -683 325 -716 312 -698 z m 271 -259 b 340 -446 327 -333 340 -392 b 338 -469 340 -455 338 -462 b 333 -461 337 -467 334 -464 b 91 -192 265 -372 145 -271 b 50 -92 69 -160 58 -124 b 271 -259 124 -92 219 -192 z m 0 -550 b 22 -564 0 -554 12 -560 b 258 -778 59 -577 171 -649 b 318 -952 307 -851 318 -903 b 317 -976 318 -960 318 -968 b 285 -1142 317 -1011 307 -1084 b 279 -1165 284 -1149 279 -1158 b 289 -1181 279 -1171 282 -1176 b 297 -1182 292 -1182 294 -1182 b 318 -1162 307 -1182 312 -1171 b 382 -963 344 -1122 382 -1044 b 374 -857 382 -922 379 -887 b 402 -668 389 -802 402 -740 b 386 -563 402 -632 396 -596 b 402 -441 395 -526 402 -487 b 402 -428 402 -436 402 -432 b 333 -220 402 -353 382 -285 b 137 23 265 -131 192 -56 b 42 251 82 102 42 251 b 22 268 39 261 37 268 b 0 251 4 268 0 261 z"
                },
                flag32ndDown: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -216,
                    y_max: 803,
                    ha: 1019,
                    o: "m 50 73 b 91 171 58 105 71 141 b 347 402 145 251 272 317 b 384 454 361 418 374 435 b 324 239 384 347 361 287 b 50 73 235 130 122 94 z m 163 517 b 366 693 248 589 327 642 b 382 716 372 700 377 708 b 383 693 383 708 383 700 b 314 505 383 621 359 562 b 53 343 258 436 179 390 b 56 363 55 351 56 359 b 163 517 66 400 81 449 z m 0 -288 b 22 -311 0 -298 10 -311 b 43 -288 33 -311 40 -300 b 167 -40 65 -138 109 -95 b 445 409 243 32 445 143 b 431 577 445 462 439 520 b 441 651 435 602 439 626 b 441 675 441 658 441 667 b 441 687 441 680 441 684 b 425 808 441 730 433 772 b 441 919 435 840 441 876 b 327 1149 441 1032 374 1112 b 305 1156 321 1153 314 1156 b 287 1152 300 1156 292 1155 b 279 1145 281 1149 279 1148 b 294 1129 279 1140 288 1136 b 382 930 344 1076 382 1027 b 327 789 382 877 364 832 b 22 598 226 672 86 612 b 0 559 12 593 0 562 z"
                },
                flag64thUp: {
                    x_min: 0,
                    x_max: 279,
                    y_min: -822,
                    y_max: 373,
                    ha: 1195,
                    o: "m 333 -461 b 91 -192 265 -372 145 -271 b 50 -92 69 -161 58 -125 b 271 -251 125 -92 219 -183 b 340 -438 327 -324 340 -383 b 338 -469 340 -448 338 -459 b 333 -461 337 -467 334 -464 z m 301 -683 b 148 -517 262 -632 219 -588 b 56 -374 92 -461 66 -410 b 50 -343 55 -366 53 -356 b 271 -501 125 -343 219 -433 b 340 -688 327 -575 340 -634 b 337 -739 340 -706 338 -721 b 301 -683 325 -717 312 -698 z m 271 10 b 340 -176 327 -63 340 -121 b 337 -217 340 -190 338 -204 b 333 -212 336 -216 334 -213 b 91 65 265 -122 145 -16 b 48 177 66 101 53 143 l 50 177 b 271 10 124 177 217 78 z m 0 -552 b 22 -564 0 -554 12 -562 b 258 -778 59 -579 171 -649 b 318 -952 307 -851 317 -903 b 317 -976 318 -960 318 -968 b 285 -1142 317 -1012 307 -1084 b 279 -1165 284 -1149 279 -1158 b 289 -1181 279 -1172 282 -1178 b 297 -1184 292 -1182 295 -1184 b 318 -1164 307 -1182 312 -1172 b 382 -963 344 -1122 382 -1044 b 374 -857 382 -923 379 -887 b 402 -668 389 -804 402 -740 b 386 -563 402 -632 396 -596 b 402 -432 395 -523 402 -480 b 402 -418 402 -428 402 -423 b 383 -304 402 -379 396 -341 b 402 -170 393 -264 402 -222 b 402 -158 402 -166 402 -163 b 333 49 402 -84 382 -16 b 137 292 265 138 192 213 b 42 520 82 372 42 520 b 22 537 39 530 37 537 b 0 520 4 537 0 530 z"
                },
                flag64thDown: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -403,
                    y_max: 804,
                    ha: 1207,
                    o: "m 52 -196 b 91 -102 59 -166 71 -131 b 347 128 145 -23 272 45 b 384 180 361 145 374 163 b 324 -30 384 76 361 16 b 52 -196 235 -140 124 -176 z m 163 517 b 366 693 248 589 327 644 b 382 717 372 701 377 708 b 383 693 383 708 383 701 b 314 505 383 621 359 562 b 53 343 258 438 179 390 b 56 363 55 351 56 359 b 163 517 66 400 81 449 z m 314 232 b 50 69 258 163 179 117 b 91 171 56 102 69 140 b 347 402 145 251 272 318 b 382 449 360 416 372 432 b 383 420 383 439 383 429 b 314 232 383 348 359 288 z m 0 -557 b 22 -580 0 -567 10 -580 b 43 -557 33 -580 40 -567 b 167 -310 65 -408 109 -364 b 445 140 243 -238 445 -125 b 431 307 445 192 439 249 b 441 377 436 331 439 354 b 441 406 441 387 441 397 b 441 418 441 410 441 413 b 423 546 441 464 432 507 b 441 651 432 582 438 618 b 441 675 441 660 441 667 b 441 688 441 680 441 684 b 425 808 441 730 433 772 b 441 919 435 840 441 876 b 327 1149 441 1032 374 1112 b 305 1158 321 1153 314 1156 b 287 1152 300 1158 292 1156 b 279 1145 281 1151 279 1148 b 294 1129 279 1140 288 1136 b 382 930 344 1076 382 1027 b 327 789 382 877 364 832 b 22 598 226 672 86 612 b 0 559 12 593 0 563 z"
                },
                flag128thUp: {
                    x_min: 0,
                    x_max: 279,
                    y_min: -821,
                    y_max: 573,
                    ha: 1394,
                    o: "m 0 -550 b 22 -563 0 -553 12 -560 b 258 -776 59 -576 171 -648 b 318 -950 307 -850 318 -901 b 317 -975 318 -959 318 -966 b 285 -1140 317 -1011 307 -1083 b 279 -1164 284 -1148 279 -1156 b 289 -1179 279 -1171 282 -1176 b 297 -1182 292 -1181 294 -1181 b 318 -1162 307 -1182 312 -1169 b 382 -962 344 -1120 382 -1043 b 374 -857 382 -922 379 -887 b 402 -668 389 -802 402 -740 b 383 -554 402 -629 396 -590 b 402 -399 396 -503 402 -452 b 382 -284 402 -359 396 -321 b 402 -125 396 -230 402 -180 b 383 -14 402 -86 396 -49 b 402 130 396 35 402 81 b 333 348 402 204 382 284 b 137 592 265 438 192 513 b 42 808 82 671 46 793 b 22 825 39 818 37 825 b 0 808 4 825 0 818 z m 271 310 b 340 111 328 235 340 170 b 338 73 340 98 338 86 b 333 81 336 76 334 79 b 91 357 265 170 145 276 b 48 469 66 393 53 435 l 50 469 b 271 310 124 469 217 377 z m 301 -681 b 148 -523 262 -631 219 -593 b 56 -383 92 -465 66 -420 b 49 -343 55 -374 52 -359 l 50 -343 b 271 -500 124 -343 217 -432 b 340 -688 327 -575 340 -634 b 337 -737 340 -706 338 -721 b 301 -681 325 -716 312 -697 z m 333 -461 b 91 -192 265 -372 145 -271 b 48 -73 66 -154 53 -111 l 48 -73 l 50 -73 b 271 -232 124 -73 217 -163 b 340 -419 327 -305 340 -364 b 337 -468 340 -435 338 -452 b 333 -461 336 -465 334 -464 z m 333 -192 b 91 84 265 -102 145 4 b 48 200 65 121 53 164 l 48 200 l 50 200 b 271 42 124 200 217 109 b 340 -147 327 -32 340 -92 b 337 -197 340 -164 338 -181 b 333 -192 336 -196 334 -194 z"
                },
                flag128thDown: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -591,
                    y_max: 803,
                    ha: 1394,
                    o: "m 0 -828 b 22 -851 0 -838 10 -851 b 43 -828 33 -851 40 -840 b 167 -580 65 -678 109 -635 b 445 -131 243 -508 445 -397 b 431 36 445 -79 439 -22 b 441 108 436 60 439 85 b 441 137 441 117 441 127 b 441 147 441 140 441 144 b 423 275 441 193 432 236 b 441 377 433 310 438 344 b 441 406 441 387 441 396 b 441 418 441 410 441 413 b 423 546 441 464 432 507 b 441 649 432 582 438 616 b 441 675 441 658 441 667 b 441 687 441 680 441 684 b 425 808 441 730 433 772 b 441 919 435 840 441 876 b 327 1149 441 1032 374 1112 b 304 1156 321 1153 312 1156 b 287 1152 298 1156 292 1155 b 279 1145 281 1149 279 1148 b 294 1129 279 1140 288 1135 b 382 930 344 1076 382 1027 b 327 789 382 877 364 832 b 22 598 226 672 86 612 b 0 559 12 593 0 562 z m 314 -37 b 50 -200 258 -107 179 -153 b 91 -102 58 -168 71 -132 b 347 128 145 -23 272 45 b 382 176 360 143 372 160 b 383 151 383 167 383 160 b 314 -37 383 79 359 19 z m 314 232 b 50 69 258 163 179 117 b 91 171 56 101 69 138 b 347 402 145 251 272 317 b 382 449 360 416 372 432 b 383 420 383 439 383 429 b 314 232 383 347 359 288 z m 163 517 b 366 693 248 589 327 642 b 382 716 372 700 377 708 b 383 693 383 708 383 700 b 314 505 382 621 359 560 b 53 343 258 436 179 390 b 56 363 55 350 56 357 b 163 517 66 399 81 449 z m 52 -467 b 91 -372 59 -435 71 -402 b 347 -141 145 -292 272 -225 b 384 -89 361 -125 374 -108 b 324 -301 382 -194 361 -255 b 52 -467 235 -410 122 -446 z"
                },
                accidentalFlat: {
                    x_min: 0,
                    x_max: 203,
                    y_min: -176,
                    y_max: 453,
                    ha: 629,
                    o: "m 289 114 b 173 223 281 170 246 223 b 52 170 101 223 59 179 l 58 632 b 37 652 58 644 49 652 l 20 652 b 0 632 9 652 0 644 l 7 -233 b 27 -253 7 -245 16 -253 b 39 -251 30 -253 36 -252 b 216 -114 45 -248 138 -202 b 292 78 271 -52 292 19 b 289 114 292 91 291 102 z m 190 58 b 148 -85 190 36 184 -30 b 48 -183 124 -122 75 -161 l 52 98 b 134 153 55 111 76 153 b 190 73 186 153 190 104 b 190 58 190 66 190 62 z"
                },
                accidentalNatural: {
                    x_min: 0,
                    x_max: 171,
                    y_min: -323,
                    y_max: 325,
                    ha: 648,
                    o: "m 239 264 b 228 268 236 266 232 268 b 222 266 226 268 223 266 l 40 216 l 40 468 l 0 468 l 0 -245 b 20 -264 0 -256 9 -264 b 26 -264 22 -264 24 -264 l 207 -213 l 207 -465 l 246 -465 b 246 248 246 -226 246 1 b 239 264 246 253 243 261 z m 40 -140 l 40 96 l 207 144 l 207 -94 z"
                },
                accidentalSharp: {
                    x_min: 0,
                    x_max: 244,
                    y_min: -333,
                    y_max: 334,
                    ha: 667,
                    o: "m 336 151 b 351 171 344 153 351 163 l 351 256 b 331 276 351 268 343 276 b 328 276 330 276 330 276 l 281 266 l 281 481 l 240 481 l 240 258 l 112 232 l 112 435 l 72 435 l 72 223 l 16 212 b 0 192 7 210 0 200 l 0 189 l 0 105 l 0 108 b 20 88 0 96 9 88 b 24 88 22 88 23 88 l 72 98 l 72 -140 l 16 -151 b 0 -171 7 -153 0 -163 l 0 -255 b 20 -275 0 -266 9 -275 b 24 -275 22 -275 23 -275 l 72 -265 l 72 -480 l 112 -480 l 112 -256 l 240 -230 l 240 -433 l 281 -433 l 281 -222 l 336 -212 b 351 -192 344 -210 351 -200 l 351 -107 b 331 -86 351 -95 343 -86 b 328 -86 330 -86 330 -86 l 281 -96 l 281 141 z m 112 107 l 240 132 l 240 -105 l 112 -132 z"
                },
                accidentalDoubleSharp: {
                    x_min: 0,
                    x_max: 275,
                    y_min: -137,
                    y_max: 138,
                    ha: 275,
                    o: "m 360 73 l 376 73 b 396 94 387 73 396 82 l 396 179 b 376 199 396 190 387 199 l 291 199 b 271 179 279 199 271 190 l 271 161 l 271 102 l 200 30 l 196 30 l 124 102 l 124 179 b 105 199 124 190 117 199 l 20 199 b 0 179 9 199 0 190 l 0 94 b 20 73 0 82 9 73 l 35 73 l 36 73 l 96 73 l 167 3 l 167 -1 l 96 -73 l 36 -73 l 35 -73 l 20 -73 b 0 -92 9 -73 0 -81 l 0 -177 b 20 -197 0 -189 9 -197 l 105 -197 b 124 -177 117 -197 124 -189 l 124 -101 l 196 -32 l 200 -32 l 271 -101 l 271 -161 l 271 -163 l 271 -177 b 291 -197 271 -189 279 -197 l 376 -197 b 396 -177 387 -197 396 -189 l 396 -92 b 376 -73 396 -81 387 -73 l 361 -73 l 360 -73 l 300 -73 l 228 -1 l 228 1 l 300 73 z"
                },
                accidentalDoubleFlat: {
                    x_min: 0,
                    x_max: 371,
                    y_min: -176,
                    y_max: 453,
                    ha: 629,
                    o: "m 531 115 b 415 223 523 171 488 223 b 294 171 343 223 301 180 l 300 632 b 279 652 300 644 291 652 l 262 652 b 242 632 251 652 242 644 l 246 199 b 173 223 228 213 204 223 b 52 170 101 223 59 179 l 58 632 b 37 652 58 644 49 652 l 20 652 b 0 632 9 652 0 644 l 7 -233 b 27 -253 7 -245 16 -253 b 39 -249 30 -253 36 -251 b 216 -114 45 -246 138 -202 b 248 -69 226 -102 239 -82 l 249 -233 b 269 -253 249 -245 258 -253 b 281 -249 272 -253 278 -251 b 458 -112 287 -246 380 -200 b 534 79 513 -50 534 20 b 531 115 534 92 533 104 z m 190 58 b 148 -85 190 36 184 -30 b 48 -183 124 -122 75 -161 l 52 98 b 134 153 55 111 76 153 b 190 73 186 153 190 104 b 190 58 190 66 190 62 z m 432 58 b 390 -85 432 36 426 -30 b 289 -183 366 -122 317 -161 l 294 98 b 376 153 297 111 318 153 b 432 73 428 153 432 104 b 432 58 432 66 432 62 z"
                },
                accidentalParensLeft: {
                    x_min: 0,
                    x_max: 75,
                    y_min: -212,
                    y_max: 209,
                    ha: 421,
                    o: "m 98 -305 b 104 -302 101 -304 102 -304 b 108 -295 107 -301 108 -298 b 107 -289 108 -294 108 -292 b 40 10 107 -288 40 -160 b 107 288 40 95 58 192 b 108 292 108 289 108 291 b 104 300 108 295 107 298 b 96 301 101 301 99 302 b 91 298 94 301 92 300 b 0 0 86 292 0 174 b 91 -301 0 -174 86 -295 b 98 -305 92 -304 95 -305 z"
                },
                accidentalParensRight: {
                    x_min: 0,
                    x_max: 75,
                    y_min: -209,
                    y_max: 212,
                    ha: 421,
                    o: "m 10 305 b 4 302 7 304 6 304 b 0 295 1 301 0 298 b 1 289 0 294 0 292 b 68 -10 1 288 68 160 b 1 -288 68 -95 50 -192 b 0 -292 0 -289 0 -291 b 4 -300 0 -295 1 -298 b 12 -301 7 -301 9 -302 b 17 -298 14 -301 16 -300 b 108 0 22 -292 108 -174 b 17 301 108 174 22 295 b 10 305 16 304 13 305 z"
                },
                accidentalQuarterToneFlatStein: {
                    x_min: 0,
                    x_max: 193,
                    y_min: -176,
                    y_max: 452,
                    ha: 628,
                    o: "m 0 84 b 107 -145 0 -26 65 -105 b 245 -249 166 -202 245 -249 b 253 -253 248 -251 249 -253 b 272 -235 264 -253 272 -245 l 278 632 b 259 651 278 642 269 651 l 248 651 b 229 632 238 651 229 642 l 232 174 b 125 217 223 186 192 217 b 0 84 53 217 0 173 z m 148 154 b 232 102 212 154 232 115 b 233 107 232 99 233 102 l 235 -179 b 134 -72 207 -156 160 -111 b 92 58 98 -17 92 36 b 92 75 92 62 92 68 b 148 154 92 105 96 154 z"
                },
                accidentalThreeQuarterTonesFlatZimmermann: {
                    x_min: 0,
                    x_max: 422,
                    y_min: -176,
                    y_max: 452,
                    ha: 628,
                    o: "m 608 84 b 482 217 608 173 554 217 b 376 174 416 217 384 186 l 379 632 b 360 651 379 642 370 651 l 348 651 b 330 632 338 651 330 642 l 336 -235 b 354 -253 336 -245 344 -253 b 363 -249 359 -253 360 -251 b 501 -145 363 -249 442 -202 b 608 84 543 -105 608 -26 z m 459 154 b 516 75 511 154 516 105 b 516 58 516 68 516 62 b 474 -72 516 36 510 -17 b 373 -179 448 -111 400 -156 l 374 107 b 376 102 374 102 376 99 b 459 154 376 115 396 154 z m 0 84 b 107 -145 0 -26 65 -105 b 245 -249 166 -202 245 -249 b 253 -253 248 -251 249 -253 b 272 -235 264 -253 272 -245 l 278 632 b 259 651 278 642 269 651 l 248 651 b 229 632 238 651 229 642 l 232 174 b 125 217 223 186 192 217 b 0 84 53 217 0 173 z m 148 154 b 232 102 212 154 232 115 b 233 107 232 99 233 102 l 235 -179 b 134 -72 207 -156 160 -111 b 92 58 98 -17 92 36 b 92 75 92 62 92 68 b 148 154 92 105 96 154 z"
                },
                accidentalQuarterToneSharpStein: {
                    x_min: 0,
                    x_max: 180,
                    y_min: -316,
                    y_max: 320,
                    ha: 636,
                    o: "m 243 144 b 259 164 252 145 259 156 l 259 249 b 239 269 259 261 251 269 b 235 268 238 269 236 268 l 150 251 l 150 461 l 109 461 l 109 242 l 16 222 b 0 203 7 220 0 212 l 0 120 b 20 99 0 108 9 99 b 24 99 22 99 23 99 l 109 117 l 109 -121 l 16 -141 b 0 -160 7 -143 0 -151 l 0 -243 b 20 -264 0 -255 9 -264 b 24 -264 22 -264 23 -264 l 109 -246 l 109 -455 l 150 -455 l 150 -238 l 243 -219 b 259 -199 252 -217 259 -207 l 259 -114 b 239 -95 259 -102 251 -95 b 235 -95 238 -95 236 -95 l 150 -112 l 150 125 z"
                },
                accidentalThreeQuarterTonesSharpStein: {
                    x_min: 0,
                    x_max: 290,
                    y_min: -328,
                    y_max: 339,
                    ha: 667,
                    o: "m 400 158 b 416 179 409 160 416 170 l 416 264 b 397 284 416 275 409 284 b 393 284 396 284 395 284 l 348 274 l 348 488 l 308 488 l 308 265 l 223 248 l 223 465 l 184 465 l 184 240 l 108 225 l 108 442 l 69 442 l 69 216 l 16 204 b 0 186 7 203 0 194 l 0 102 b 20 82 0 91 9 82 b 24 82 22 82 23 82 l 69 92 l 69 -147 l 16 -158 b 0 -177 7 -160 0 -168 l 0 -261 b 20 -281 0 -272 9 -281 b 24 -281 22 -281 23 -281 l 69 -272 l 69 -472 l 108 -472 l 108 -264 l 184 -248 l 184 -451 l 223 -451 l 223 -240 l 308 -223 l 308 -426 l 348 -426 l 348 -215 l 400 -204 b 418 -184 409 -203 418 -193 l 418 -99 b 397 -79 418 -88 409 -79 b 393 -79 396 -79 395 -79 l 348 -89 l 348 148 z m 184 -122 l 108 -138 l 108 99 l 184 115 z m 223 122 l 308 140 l 308 -98 l 223 -115 z"
                },
                accidentalBuyukMucennebFlat: {
                    x_min: 0,
                    x_max: 277,
                    y_min: -176,
                    y_max: 454,
                    ha: 630,
                    o: "m 396 115 b 279 225 387 173 354 225 b 158 171 204 225 164 179 l 160 317 l 336 419 l 336 482 l 161 380 l 161 488 l 336 590 l 336 654 l 163 552 l 164 634 b 144 654 164 645 156 654 l 127 654 b 107 634 115 654 107 645 l 108 520 l 0 456 l 0 393 l 108 456 l 109 350 l 0 285 l 0 222 l 109 287 l 114 -235 b 134 -253 114 -246 122 -253 b 145 -251 138 -253 141 -252 b 323 -114 145 -251 242 -204 b 399 79 377 -52 399 20 b 396 115 399 92 397 104 z m 297 58 b 255 -85 297 36 291 -30 b 154 -184 230 -122 181 -163 l 158 96 b 240 153 161 109 181 153 b 297 73 292 153 297 104 b 297 58 297 66 297 62 z"
                },
                accidentalBuyukMucennebSharp: {
                    x_min: 0,
                    x_max: 348,
                    y_min: -332,
                    y_max: 334,
                    ha: 666,
                    o: "m 494 121 b 482 125 491 122 485 125 b 478 125 481 125 480 125 l 354 91 l 354 148 l 412 164 b 425 183 419 166 425 176 l 425 268 b 408 287 425 278 418 287 b 402 285 406 287 403 285 l 354 272 l 354 481 l 317 481 l 317 262 l 186 226 l 186 436 l 148 436 l 148 216 l 89 200 b 76 183 82 199 76 190 l 76 98 b 84 84 76 92 79 86 b 95 81 86 82 92 81 b 99 81 96 81 98 81 l 148 94 l 148 35 l 14 -1 b 0 -20 7 -3 0 -13 l 0 -104 b 7 -118 0 -109 3 -115 b 19 -122 10 -120 16 -122 b 23 -121 20 -122 22 -121 l 148 -88 l 148 -147 l 89 -163 b 76 -180 82 -164 76 -173 l 76 -181 l 76 -265 b 95 -282 76 -275 85 -282 b 99 -282 96 -282 98 -282 l 148 -269 l 148 -478 l 186 -478 l 186 -259 l 317 -225 l 317 -433 l 354 -433 l 354 -215 l 412 -199 b 425 -181 419 -197 425 -189 l 425 -95 b 418 -81 425 -89 422 -84 b 406 -76 415 -79 409 -76 b 402 -78 405 -76 403 -78 l 354 -91 l 354 -32 l 488 4 b 501 22 495 6 501 14 l 501 107 b 494 121 501 112 498 118 z m 317 138 l 317 81 l 186 45 l 186 104 z m 186 -137 l 186 -78 l 317 -42 l 317 -101 z"
                },
                accidentalBakiyeFlat: {
                    x_min: 0,
                    x_max: 277,
                    y_min: -176,
                    y_max: 454,
                    ha: 630,
                    o: "m 396 115 b 279 225 387 173 354 225 b 158 171 204 225 164 179 l 161 348 l 336 452 l 336 516 l 161 413 l 164 634 b 144 654 164 645 156 654 l 127 654 b 107 634 115 654 107 645 l 109 382 l 0 318 l 0 255 l 109 318 l 114 -235 b 134 -253 114 -246 122 -253 b 145 -251 138 -253 143 -252 b 323 -114 145 -251 242 -204 b 399 79 377 -52 399 20 b 396 115 399 92 397 104 z m 297 58 b 255 -85 297 36 291 -30 b 156 -184 230 -122 183 -163 l 158 96 b 240 153 161 109 181 153 b 297 73 292 153 297 104 b 297 58 297 66 297 62 z"
                },
                accidentalKucukMucennebSharp: {
                    x_min: 0,
                    x_max: 348,
                    y_min: -316,
                    y_max: 318,
                    ha: 634,
                    o: "m 494 121 b 482 125 491 124 487 125 b 478 124 481 125 480 124 l 269 68 l 269 127 l 412 164 b 425 181 420 167 425 173 l 425 266 b 418 282 425 272 422 279 b 406 285 415 285 410 285 b 402 285 405 285 403 285 l 269 249 l 269 458 l 232 458 l 232 239 l 89 200 b 76 181 81 197 76 190 l 76 98 b 84 84 76 92 79 86 b 95 79 86 81 91 79 b 99 81 96 79 98 81 l 232 115 l 232 58 l 14 -3 b 0 -20 6 -6 0 -12 l 0 -104 b 7 -118 0 -109 3 -115 b 19 -122 10 -121 14 -122 b 23 -122 20 -122 22 -122 l 232 -66 l 232 -124 l 89 -163 b 76 -180 81 -166 76 -171 l 76 -264 b 84 -279 76 -269 79 -276 b 95 -282 86 -282 91 -282 b 99 -282 96 -282 98 -282 l 232 -246 l 232 -455 l 269 -455 l 269 -236 l 412 -199 b 425 -180 420 -196 425 -189 l 425 -95 b 418 -81 425 -89 422 -84 b 406 -76 415 -78 410 -76 b 402 -78 405 -76 403 -78 l 269 -114 l 269 -55 l 487 4 b 501 22 495 7 501 13 l 501 107 b 494 121 501 112 498 118 z"
                },
                articAccentAbove: {
                    x_min: 0,
                    x_max: 361,
                    y_min: 0,
                    y_max: 235,
                    ha: 235,
                    o: "m 26 337 b 20 338 24 337 22 338 b 0 318 9 338 0 330 l 0 285 b 14 266 0 276 7 269 l 323 170 l 14 72 b 0 53 7 69 0 62 l 0 20 b 20 0 0 9 9 0 b 26 1 22 0 24 1 l 505 150 b 520 170 513 153 520 161 b 505 189 520 179 513 186 z"
                },
                articAccentBelow: {
                    x_min: 0,
                    x_max: 361,
                    y_min: -235,
                    y_max: 0,
                    ha: 235,
                    o: "m 26 -1 b 20 0 24 -1 22 0 b 0 -20 9 0 0 -9 l 0 -53 b 14 -72 0 -62 7 -69 l 323 -168 l 14 -266 b 0 -285 7 -269 0 -276 l 0 -318 b 20 -338 0 -330 9 -338 b 26 -337 22 -338 24 -337 l 505 -189 b 520 -168 513 -186 520 -177 b 505 -150 520 -160 513 -153 z"
                },
                articTenutoAbove: {
                    x_min: 0,
                    x_max: 316,
                    y_min: 0,
                    y_max: 46,
                    ha: 46,
                    o: "m 20 66 b 0 46 9 66 0 58 l 0 20 b 20 0 0 9 9 0 l 435 0 b 455 20 446 0 455 9 l 455 46 b 435 66 455 58 446 66 z"
                },
                articTenutoBelow: {
                    x_min: 0,
                    x_max: 316,
                    y_min: -46,
                    y_max: 0,
                    ha: 46,
                    o: "m 20 0 b 0 -20 9 0 0 -9 l 0 -46 b 20 -66 0 -58 9 -66 l 435 -66 b 455 -46 446 -66 455 -58 l 455 -20 b 435 0 455 -9 446 0 z"
                },
                articStaccatoAbove: {
                    x_min: 0,
                    x_max: 78,
                    y_min: 0,
                    y_max: 78,
                    ha: 78,
                    o: "m 16 16 b 96 16 39 -6 73 -6 b 96 95 118 39 118 73 b 16 95 73 118 39 118 b 16 16 -6 73 -6 39 z"
                },
                articStaccatoBelow: {
                    x_min: 0,
                    x_max: 78,
                    y_min: -78,
                    y_max: 0,
                    ha: 78,
                    o: "m 16 -96 b 96 -96 39 -118 73 -118 b 96 -17 118 -73 118 -39 b 16 -17 73 6 39 6 b 16 -96 -6 -39 -6 -73 z"
                },
                articStaccatissimoAbove: {
                    x_min: 0,
                    x_max: 127,
                    y_min: 0,
                    y_max: 248,
                    ha: 248,
                    o: "m 163 357 b 150 353 154 357 150 353 l 99 300 b 92 295 96 297 95 295 b 85 300 89 295 88 297 l 35 353 b 22 357 35 353 30 357 b 0 338 13 357 0 351 b 73 22 0 323 73 22 b 92 0 75 16 78 0 b 111 22 107 0 109 16 b 183 338 111 22 183 323 b 163 357 183 351 171 357 z"
                },
                articStaccatissimoBelow: {
                    x_min: 0,
                    x_max: 127,
                    y_min: -248,
                    y_max: 0,
                    ha: 248,
                    o: "m 20 -357 b 33 -353 29 -357 33 -353 l 84 -300 b 91 -295 86 -297 88 -295 b 98 -300 94 -295 95 -297 l 148 -353 b 161 -357 148 -353 153 -357 b 183 -338 170 -357 183 -351 b 109 -22 183 -323 109 -22 b 91 0 108 -16 105 0 b 72 -22 76 0 73 -16 b 0 -338 72 -22 0 -323 b 20 -357 0 -351 12 -357 z"
                },
                articMarcatoAbove: {
                    x_min: 1,
                    x_max: 296,
                    y_min: 0,
                    y_max: 253,
                    ha: 253,
                    o: "m 36 10 l 173 239 l 298 10 b 317 0 301 4 310 0 l 408 0 b 426 20 419 0 426 9 b 425 30 426 23 426 27 l 230 356 b 213 364 226 361 222 363 b 196 356 207 364 199 361 l 1 30 z"
                },
                articMarcatoBelow: {
                    x_min: 0,
                    x_max: 295,
                    y_min: -253,
                    y_max: 0,
                    ha: 253,
                    o: "m 390 -10 l 253 -239 l 128 -10 b 109 0 125 -4 117 0 l 19 0 b 0 -20 7 0 0 -9 b 1 -30 0 -23 0 -27 l 196 -356 b 213 -364 200 -361 204 -363 b 230 -356 219 -364 228 -361 l 425 -30 z"
                },
                fermataAbove: {
                    x_min: 0,
                    x_max: 622,
                    y_min: 0,
                    y_max: 368,
                    ha: 368,
                    o: "m 778 374 b 448 530 642 521 523 530 b 120 374 373 530 255 521 b 0 65 49 297 0 143 b 20 19 0 37 6 19 b 161 265 60 19 40 143 b 445 373 268 372 410 373 b 448 373 446 373 446 373 b 451 373 449 373 449 373 b 734 265 485 373 628 372 b 876 19 855 143 835 19 b 896 65 890 19 896 36 b 778 374 896 143 848 298 z m 348 99 b 448 0 348 45 393 0 b 547 99 503 0 547 45 b 448 199 547 154 503 199 b 348 99 393 199 348 154 z"
                },
                fermataBelow: {
                    x_min: 0,
                    x_max: 622,
                    y_min: -368,
                    y_max: 0,
                    ha: 368,
                    o: "m 778 -374 b 896 -65 848 -298 896 -143 b 876 -19 896 -36 890 -19 b 734 -265 835 -19 855 -143 b 451 -373 628 -372 485 -373 b 448 -373 449 -373 449 -373 b 445 -373 446 -373 446 -373 b 161 -265 410 -373 268 -372 b 20 -19 40 -143 60 -19 b 0 -65 6 -19 0 -37 b 120 -374 0 -143 49 -297 b 448 -530 255 -521 373 -530 b 778 -374 523 -530 642 -521 z m 348 -99 b 448 -199 348 -154 393 -199 b 547 -99 503 -199 547 -154 b 448 0 547 -45 503 0 b 348 -99 393 0 348 -45 z"
                },
                fermataLongAbove: {
                    x_min: 0,
                    x_max: 623,
                    y_min: 0,
                    y_max: 368,
                    ha: 368,
                    o: "m 40 0 l 40 399 l 858 399 l 858 0 l 897 0 l 897 510 b 877 530 897 521 888 530 l 20 530 b 0 510 9 530 0 521 l 0 0 z m 350 148 b 449 49 350 94 395 49 b 547 148 504 49 547 94 b 449 248 547 203 504 248 b 350 148 395 248 350 203 z"
                },
                fermataLongBelow: {
                    x_min: 0,
                    x_max: 623,
                    y_min: -368,
                    y_max: 0,
                    ha: 368,
                    o: "m 0 -510 b 20 -530 0 -521 9 -530 l 877 -530 b 897 -510 888 -530 897 -521 l 897 0 l 858 0 l 858 -399 l 40 -399 l 40 0 l 0 0 z m 350 -148 b 449 -248 350 -203 395 -248 b 547 -148 504 -248 547 -203 b 449 -49 547 -94 504 -49 b 350 -148 395 -49 350 -94 z"
                },
                fermataVeryLongAbove: {
                    x_min: 0,
                    x_max: 842,
                    y_min: 0,
                    y_max: 549,
                    ha: 549,
                    o: "m 276 0 l 276 399 l 936 399 l 936 0 l 976 0 l 976 510 b 956 530 976 521 968 530 l 256 530 b 236 510 245 530 236 521 l 236 0 z m 507 148 b 606 49 507 94 552 49 b 706 148 661 49 706 94 b 606 248 706 203 661 248 b 507 148 552 248 507 203 z m 40 0 l 40 661 l 1172 661 l 1172 0 l 1212 0 l 1212 772 b 1192 791 1212 783 1204 791 l 20 791 b 0 772 9 791 0 783 l 0 0 z"
                },
                fermataVeryLongBelow: {
                    x_min: 0,
                    x_max: 842,
                    y_min: -549,
                    y_max: 0,
                    ha: 549,
                    o: "m 236 -510 b 256 -530 236 -521 245 -530 l 956 -530 b 976 -510 968 -530 976 -521 l 976 0 l 936 0 l 936 -399 l 276 -399 l 276 0 l 236 0 z m 507 -148 b 606 -248 507 -203 552 -248 b 706 -148 661 -248 706 -203 b 606 -49 706 -94 661 -49 b 507 -148 552 -49 507 -94 z m 0 -772 b 20 -791 0 -783 9 -791 l 1192 -791 b 1212 -772 1204 -791 1212 -783 l 1212 0 l 1172 0 l 1172 -661 l 40 -661 l 40 0 l 0 0 z"
                },
                fermataShortAbove: {
                    x_min: 0,
                    x_max: 642,
                    y_min: 0,
                    y_max: 454,
                    ha: 454,
                    o: "m 363 148 b 462 49 363 94 408 49 b 562 148 517 49 562 94 b 462 248 562 203 517 248 b 363 148 408 248 363 203 z m 477 645 b 461 654 474 649 467 654 b 445 645 455 654 448 649 l 4 32 b 0 20 3 29 0 23 b 20 0 0 9 9 0 l 82 0 b 98 9 88 0 95 4 l 461 514 l 827 9 b 842 0 829 4 837 0 l 904 0 b 924 20 916 0 924 9 b 920 32 924 23 922 29 z"
                },
                fermataShortBelow: {
                    x_min: 0,
                    x_max: 642,
                    y_min: -454,
                    y_max: 0,
                    ha: 454,
                    o: "m 363 -148 b 462 -248 363 -203 408 -248 b 562 -148 517 -248 562 -203 b 462 -49 562 -94 517 -49 b 363 -148 408 -49 363 -94 z m 920 -32 b 924 -20 922 -29 924 -23 b 904 0 924 -9 916 0 l 842 0 b 827 -9 837 0 829 -4 l 461 -514 l 98 -9 b 82 0 95 -4 88 0 l 20 0 b 0 -20 9 0 0 -9 b 4 -32 0 -23 3 -29 l 445 -645 b 461 -654 448 -649 455 -654 b 477 -645 467 -654 474 -649 z"
                },
                breathMarkComma: {
                    x_min: 0,
                    x_max: 191,
                    y_min: 0,
                    y_max: 321,
                    ha: 321,
                    o: "m 82 0 b 275 285 215 92 275 183 b 115 462 275 396 212 462 b 0 356 46 462 0 413 b 115 246 0 294 53 246 b 181 258 157 246 177 256 b 192 261 184 259 189 261 b 199 259 194 261 196 261 b 203 245 202 258 203 253 b 48 43 203 183 147 112 z"
                },
                caesura: {
                    x_min: 0,
                    x_max: 380,
                    y_min: 0,
                    y_max: 490,
                    ha: 490,
                    o: "m 285 706 b 285 706 285 706 285 706 b 271 696 279 706 274 701 l 1 22 b 0 16 0 20 0 17 b 16 0 0 7 7 0 l 50 0 b 65 10 56 0 62 4 l 334 684 b 336 690 334 685 336 688 b 320 706 336 698 328 706 z m 213 22 b 212 16 213 20 212 17 b 228 0 212 7 219 0 l 262 0 b 276 10 268 0 274 4 l 546 684 b 547 690 547 685 547 688 b 531 706 547 698 540 706 l 497 706 b 482 696 491 706 485 701 z"
                },
                caesuraCurved: {
                    x_min: 0,
                    x_max: 368,
                    y_min: 0,
                    y_max: 491,
                    ha: 491,
                    o: "m 262 707 b 245 693 253 707 246 701 b 1 26 233 603 177 348 b 0 17 0 23 0 20 b 16 0 0 9 6 0 b 30 7 22 0 27 3 b 318 687 259 341 304 602 b 318 690 318 688 318 688 b 301 707 318 698 310 707 z m 474 707 b 458 693 465 707 459 701 b 213 26 446 603 389 348 b 212 19 212 23 212 20 b 229 0 212 9 219 0 b 243 7 235 0 240 3 b 530 687 472 341 516 602 b 530 690 530 688 530 688 b 514 707 530 698 523 707 z"
                },
                restMaxima: {
                    x_min: 0,
                    x_max: 450,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 158 -360 b 180 -338 170 -360 180 -350 l 180 338 b 158 360 180 350 170 360 l 22 360 b 0 338 9 360 0 350 l 0 -338 b 22 -360 0 -350 9 -360 z m 626 -360 b 648 -338 638 -360 648 -350 l 648 338 b 626 360 648 350 638 360 l 490 360 b 468 338 477 360 468 350 l 468 -338 b 490 -360 468 -350 477 -360 z"
                },
                restDoubleWhole: {
                    x_min: 0,
                    x_max: 125,
                    y_min: -11,
                    y_max: 262,
                    ha: 273,
                    o: "m 158 -16 b 180 6 171 -16 180 -6 l 180 356 b 158 377 180 367 171 377 l 22 377 b 0 356 10 377 0 367 l 0 6 b 22 -16 0 -6 10 -16 z"
                },
                restWhole: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -131,
                    y_max: 5,
                    ha: 136,
                    o: "m 20 7 b 0 -13 9 7 0 -1 l 0 -168 b 20 -189 0 -180 9 -189 l 448 -189 b 468 -168 459 -189 468 -180 l 468 -13 b 448 7 468 -1 459 7 z"
                },
                restWholeLegerLine: {
                    x_min: -139,
                    x_max: 464,
                    y_min: -122,
                    y_max: 14,
                    ha: 136,
                    o: "m 449 20 l 19 20 l -200 20 l -200 -20 l 0 -20 l 0 -156 b 19 -176 0 -167 7 -176 l 449 -176 b 468 -156 461 -176 468 -167 l 468 -20 l 668 -20 l 668 20 z"
                },
                restHalf: {
                    x_min: 0,
                    x_max: 325,
                    y_min: -4,
                    y_max: 132,
                    ha: 136,
                    o: "m 0 14 b 20 -6 0 -6 0 -6 l 448 -6 b 468 14 468 -6 468 -6 l 468 170 b 448 190 468 190 468 190 l 20 190 b 0 170 0 190 0 190 z"
                },
                restHalfLegerLine: {
                    x_min: -139,
                    x_max: 464,
                    y_min: -14,
                    y_max: 122,
                    ha: 136,
                    o: "m 668 20 l 468 20 l 468 156 b 449 176 468 167 461 176 l 19 176 b 0 156 7 176 0 167 l 0 20 l -200 20 l -200 -20 l 19 -20 l 449 -20 l 668 -20 z"
                },
                restQuarter: {
                    x_min: 0,
                    x_max: 235,
                    y_min: -331,
                    y_max: 401,
                    ha: 732,
                    o: "m 331 -239 b 323 -229 330 -238 327 -235 l 157 -24 b 154 -16 156 -23 154 -19 b 157 -3 154 -12 156 -6 l 304 219 b 307 229 305 222 307 226 l 307 242 b 302 253 307 246 305 251 l 69 569 b 55 577 69 569 63 577 b 43 573 50 577 48 576 b 36 559 37 569 36 563 b 40 543 36 550 40 543 l 150 393 b 154 376 153 389 154 383 b 150 359 154 370 153 363 l 4 137 b 1 125 3 134 1 128 l 1 112 b 6 101 1 108 3 104 l 167 -99 b 131 -95 161 -98 148 -95 b 49 -124 107 -95 75 -101 b 0 -229 17 -153 0 -193 b 16 -285 0 -249 4 -269 b 154 -468 46 -331 154 -468 b 171 -477 154 -468 161 -477 b 180 -474 174 -477 177 -477 b 190 -456 187 -468 190 -462 b 186 -444 190 -451 187 -446 b 135 -353 181 -436 135 -353 b 125 -307 135 -353 125 -333 b 150 -246 125 -288 131 -265 b 206 -223 167 -229 187 -223 b 252 -236 225 -223 240 -229 l 308 -272 b 320 -275 308 -272 314 -275 b 334 -268 325 -275 330 -274 b 338 -255 337 -262 338 -259 b 334 -243 338 -251 337 -248 z"
                },
                rest8th: {
                    x_min: 0,
                    x_max: 276,
                    y_min: -255,
                    y_max: 204,
                    ha: 459,
                    o: "m 384 292 b 379 294 383 292 380 294 b 360 282 370 294 363 289 b 245 141 354 274 310 189 b 180 112 226 127 203 117 b 206 181 196 131 206 154 b 104 284 206 238 160 284 b 0 181 46 284 0 238 b 65 85 0 137 27 101 b 144 68 86 75 115 68 b 269 109 186 68 230 81 b 320 157 287 122 304 140 l 156 -356 l 194 -367 l 396 268 b 397 275 397 269 397 272 b 384 292 397 282 393 288 z"
                },
                rest16th: {
                    x_min: 1,
                    x_max: 344,
                    y_min: -507,
                    y_max: 204,
                    ha: 711,
                    o: "m 494 268 b 495 275 495 271 495 272 b 482 292 495 282 491 289 b 475 294 480 294 477 294 b 456 282 467 294 461 289 b 285 115 422 213 364 135 b 310 184 302 135 310 158 b 203 284 310 240 259 284 b 104 177 145 281 104 233 b 171 84 105 134 134 98 b 252 69 197 72 225 69 b 423 164 324 72 380 108 l 423 164 l 359 -65 b 183 -245 338 -132 256 -226 b 207 -176 199 -225 207 -200 b 102 -76 207 -118 158 -76 b 1 -183 45 -76 1 -125 b 69 -275 1 -226 32 -262 b 150 -289 96 -287 121 -289 b 321 -194 222 -287 278 -251 l 174 -720 l 213 -730 z"
                },
                rest32nd: {
                    x_min: 0,
                    x_max: 391,
                    y_min: -507,
                    y_max: 460,
                    ha: 967,
                    o: "m 217 71 b 408 171 348 71 402 161 l 354 -46 b 184 -240 323 -121 268 -217 b 204 -171 200 -220 204 -197 b 102 -76 204 -114 158 -76 b 0 -177 46 -76 0 -120 b 140 -288 0 -252 63 -288 b 320 -186 216 -288 276 -246 l 189 -721 l 228 -730 l 562 638 b 563 644 563 639 563 642 b 549 661 563 652 557 658 b 543 662 547 662 544 662 b 524 649 534 662 528 657 b 361 487 497 589 431 504 b 383 556 379 508 383 530 b 282 652 383 611 338 652 b 179 549 226 652 179 609 b 249 451 179 505 210 464 b 311 439 268 444 288 441 b 330 441 317 439 323 439 b 498 541 400 445 458 485 l 442 310 b 271 117 413 238 351 137 b 292 186 288 138 292 160 b 189 282 292 243 245 282 b 88 180 132 282 88 238 b 217 71 88 112 153 71 z"
                },
                rest64th: {
                    x_min: 0,
                    x_max: 423,
                    y_min: -758,
                    y_max: 464,
                    ha: 1222,
                    o: "m 207 -1083 l 246 -1092 b 608 644 282 -919 605 634 b 609 649 608 647 609 648 b 595 667 609 658 603 665 b 589 668 593 668 592 668 b 569 654 577 668 575 664 b 474 521 563 644 530 573 b 412 487 456 505 435 494 b 432 546 425 503 432 526 b 328 649 432 606 382 649 b 226 546 275 649 226 608 b 360 438 226 465 300 438 b 501 492 419 438 474 465 b 546 546 527 518 533 526 l 547 547 l 500 323 b 399 161 491 300 452 209 b 337 125 382 144 360 132 b 357 184 350 143 357 134 b 253 288 357 235 317 288 b 151 187 190 288 151 236 b 285 76 151 138 183 76 b 471 184 412 76 465 173 l 423 -45 b 324 -204 413 -69 374 -158 b 262 -240 305 -222 284 -233 b 281 -180 274 -223 281 -212 b 177 -78 281 -147 258 -78 b 75 -180 98 -78 75 -153 b 209 -289 75 -207 88 -289 b 395 -181 330 -289 389 -193 l 350 -397 b 248 -564 337 -449 285 -530 b 186 -599 229 -580 207 -592 b 204 -540 197 -583 204 -563 b 102 -438 204 -501 174 -438 b 0 -540 29 -438 0 -501 b 132 -648 0 -579 24 -648 b 320 -540 266 -648 315 -552 z"
                },
                rest128th: {
                    x_min: -1,
                    x_max: 475,
                    y_min: -759,
                    y_max: 717,
                    ha: 1476,
                    o: "m 677 1028 b 664 1032 672 1031 667 1032 b 644 1018 654 1032 649 1028 b 549 886 638 1008 605 937 b 487 851 531 870 510 858 b 507 910 500 868 507 890 b 403 1014 507 971 456 1014 b 301 910 350 1014 301 972 b 435 802 301 829 374 802 b 576 857 494 802 549 829 b 621 910 602 883 608 890 l 622 912 l 575 687 b 474 526 566 664 527 573 b 412 490 456 508 435 497 b 432 549 425 507 432 498 b 328 652 432 599 392 652 b 226 552 265 652 226 600 b 360 441 226 503 258 441 b 546 549 487 441 540 537 l 498 320 b 399 160 488 295 449 207 b 337 125 380 143 359 131 b 356 184 348 141 356 153 b 252 287 356 217 333 287 b 150 184 173 287 150 212 b 284 76 150 157 163 76 b 469 183 405 76 464 171 l 425 -33 b 323 -200 412 -85 360 -166 b 261 -235 304 -216 282 -228 b 279 -176 272 -219 279 -199 b 177 -72 279 -137 249 -72 b 75 -176 104 -72 75 -137 b 207 -284 75 -215 99 -284 b 395 -176 341 -284 390 -187 l 347 -409 b 248 -566 330 -461 282 -533 b 186 -600 229 -582 207 -593 b 204 -541 197 -583 204 -564 b 102 -438 204 -501 174 -438 b -1 -541 29 -438 -1 -503 b 132 -649 -1 -580 24 -649 b 318 -546 256 -649 307 -567 l 206 -1084 l 245 -1093 b 683 1008 281 -920 680 996 b 684 1015 683 1009 684 1014 b 677 1028 684 1020 683 1024 z"
                },
                dynamicPiano: {
                    x_min: -95,
                    x_max: 317,
                    y_min: -163,
                    y_max: 263,
                    ha: 426,
                    o: "m 186 -235 l 186 -206 l 78 -206 l 161 26 l 166 16 b 229 -29 166 16 180 -16 b 256 -32 238 -32 248 -32 b 445 166 336 -32 415 49 b 456 246 454 197 456 223 b 374 373 456 343 396 367 b 356 376 369 374 361 376 b 242 314 311 376 266 338 l 238 310 l 235 315 b 154 377 235 315 204 370 b 138 379 148 377 144 379 b 0 226 91 379 42 346 l 26 213 b 63 301 32 232 46 278 b 102 328 72 314 89 325 b 108 328 104 328 107 328 b 120 325 112 328 117 327 b 127 304 125 321 127 314 b 94 192 127 269 101 206 l -49 -206 l -137 -206 l -137 -235 z m 226 17 b 215 19 223 17 217 17 b 187 81 193 27 187 53 b 204 180 187 125 203 177 b 297 317 217 235 259 295 b 324 325 307 323 315 325 b 336 324 328 325 333 325 b 350 311 341 323 347 317 b 356 278 354 302 356 291 b 333 161 356 239 341 187 b 242 20 314 105 278 37 b 226 17 238 17 230 17 z"
                },
                dynamicMezzo: {
                    x_min: -7,
                    x_max: 374,
                    y_min: -2,
                    y_max: 251,
                    ha: 253,
                    o: "m 488 63 b 467 48 481 50 474 48 b 459 49 464 48 462 48 b 449 65 452 52 449 58 b 461 112 449 76 455 94 b 474 157 464 121 471 150 b 492 281 482 183 492 242 b 491 301 492 288 492 295 b 436 359 484 340 467 359 b 340 307 399 359 359 331 l 337 301 l 334 308 b 272 359 334 308 311 359 b 177 310 232 359 202 343 l 173 304 l 171 311 b 117 360 171 311 153 353 b 96 361 109 361 102 361 b 29 328 60 361 39 340 b -10 252 20 318 0 284 l 12 240 b 68 318 12 240 36 318 b 75 317 71 318 72 318 b 86 295 84 314 86 307 b 59 194 86 275 75 240 b 1 20 59 193 6 33 b 0 13 1 17 0 16 b 3 4 0 10 1 7 b 14 -1 6 1 9 -1 l 36 -1 b 91 -1 58 -1 86 -1 b 107 22 94 -1 101 -1 b 127 99 114 53 121 79 b 235 310 132 121 186 310 b 243 305 238 310 242 308 b 248 289 246 302 248 297 b 216 160 248 265 233 219 b 173 22 194 89 173 22 b 173 16 173 20 173 19 b 176 3 173 12 173 6 b 187 -1 179 0 183 -1 l 266 -1 b 282 16 272 -1 279 0 b 284 26 282 17 284 22 b 392 302 312 228 359 288 b 396 304 393 302 395 304 l 397 304 b 400 302 399 304 399 302 b 408 289 403 301 408 297 b 369 140 408 275 399 217 b 356 75 360 117 356 95 b 370 23 356 55 360 37 b 428 -3 382 6 408 -3 b 536 99 492 -3 517 49 b 539 108 537 102 537 105 l 514 120 b 488 63 514 120 498 81 z"
                },
                dynamicForte: {
                    x_min: -137,
                    x_max: 334,
                    y_min: -193,
                    y_max: 421,
                    ha: 614,
                    o: "m -122 -86 b -197 -161 -161 -86 -197 -122 b -81 -278 -197 -236 -147 -278 b 35 -228 -35 -278 -1 -264 b 202 173 98 -164 167 50 b 238 297 215 219 228 264 l 238 300 l 341 300 b 356 314 350 300 356 305 l 356 346 b 341 360 356 354 350 360 l 256 360 l 256 364 b 330 554 297 511 308 537 b 359 566 341 563 351 566 b 366 564 361 566 364 564 b 380 553 373 563 377 559 b 382 546 382 550 382 549 b 373 528 382 539 379 531 b 351 478 359 517 351 498 b 354 458 351 471 353 465 b 384 426 359 445 370 432 b 410 420 390 423 400 420 b 445 431 420 420 432 423 b 478 472 459 438 474 456 b 481 497 481 480 481 488 b 467 550 481 514 477 533 b 376 605 455 572 422 598 b 351 606 369 606 360 606 b 225 553 317 606 272 595 b 122 363 187 520 154 456 l 122 360 l 13 360 b -1 346 4 360 -1 354 l -1 314 b 13 300 -1 305 4 300 l 102 300 l 102 294 b 66 140 88 236 76 187 b 24 -35 55 86 42 32 l 20 -52 b -53 -235 -10 -170 -19 -212 b -78 -242 -60 -239 -69 -242 b -98 -235 -85 -242 -92 -239 b -105 -222 -102 -232 -105 -228 b -105 -219 -105 -220 -105 -220 b -94 -204 -104 -213 -101 -207 b -58 -144 -66 -193 -58 -167 b -122 -86 -58 -124 -71 -86 z"
                },
                dynamicRinforzando: {
                    x_min: -12,
                    x_max: 230,
                    y_min: 0,
                    y_max: 254,
                    ha: 254,
                    o: "m 272 364 b 200 341 239 364 212 348 b 168 310 187 333 177 321 l 164 304 b 109 363 164 304 151 353 b 88 366 102 364 95 366 b 22 331 52 366 32 343 b -17 255 13 321 -7 287 l 4 243 b 60 321 4 243 29 321 b 68 320 63 321 65 321 b 78 297 75 317 78 308 b 49 180 78 272 65 230 l 0 23 b 0 17 0 22 0 20 b 3 4 0 13 0 7 b 14 0 6 1 10 0 l 94 0 b 109 17 99 0 107 1 b 111 27 109 19 111 23 b 209 302 140 230 186 279 b 225 311 215 308 220 311 b 229 310 226 311 228 311 b 233 304 233 307 233 305 b 233 301 233 302 233 301 b 216 268 220 291 216 279 b 225 243 216 259 219 249 b 262 229 235 232 249 229 b 304 242 279 229 295 235 b 331 308 320 255 331 275 b 272 364 331 341 304 364 z"
                },
                dynamicSforzando: {
                    x_min: 0,
                    x_max: 208,
                    y_min: -5,
                    y_max: 263,
                    ha: 268,
                    o: "m 242 328 b 217 289 222 317 217 300 b 258 249 217 274 230 249 b 298 284 285 249 295 269 b 300 295 300 287 300 291 b 189 379 300 328 272 379 b 49 259 92 379 49 315 b 99 173 49 229 59 196 b 164 137 117 163 140 151 b 194 88 189 122 194 102 b 124 24 194 73 177 24 b 72 46 82 24 72 39 b 73 49 72 48 72 49 b 96 96 78 52 96 62 b 50 150 96 134 72 150 b 0 91 29 150 0 134 b 124 -7 0 26 49 -7 b 282 111 199 -7 282 24 b 171 239 282 197 207 219 b 128 292 135 259 128 268 b 193 347 128 317 156 347 b 242 328 230 347 242 328 z"
                },
                dynamicZ: {
                    x_min: -42,
                    x_max: 239,
                    y_min: -1,
                    y_max: 258,
                    ha: 259,
                    o: "m 229 292 b 235 288 232 292 233 291 b 236 284 236 285 236 285 b 233 278 236 281 235 279 b -42 55 232 276 -4 85 b -60 24 -56 43 -60 33 b -50 4 -60 12 -50 4 b -35 0 -45 1 -40 0 b 9 29 -14 0 1 19 b 50 69 17 43 26 69 b 89 35 75 69 81 50 b 170 -1 104 10 137 -1 b 243 22 197 -1 223 6 b 304 147 288 56 304 118 b 264 196 304 176 294 196 b 226 156 239 196 226 174 b 251 117 226 128 249 122 b 251 108 251 114 251 111 b 243 79 251 98 249 88 b 212 56 236 68 223 56 b 202 59 209 56 204 56 b 163 92 194 63 186 75 b 108 122 140 109 114 120 b 105 125 105 124 105 124 b 107 128 105 127 107 128 b 312 304 107 128 302 294 b 341 340 324 315 336 327 b 344 347 343 341 344 346 l 344 356 b 333 369 343 367 336 369 l 331 369 l 262 363 b 217 361 245 361 230 361 b 156 366 193 361 174 363 b 114 372 147 367 125 372 b 107 370 111 372 108 370 b 86 344 98 367 89 360 b 37 222 72 265 42 232 b 37 219 37 220 37 220 b 50 207 37 213 43 207 l 66 207 b 81 225 75 207 76 215 b 108 291 85 235 105 285 b 118 297 111 297 112 297 b 167 289 125 295 144 291 b 181 289 171 289 177 289 b 229 292 202 289 222 291 z"
                },
                ornamentTrill: {
                    x_min: -12,
                    x_max: 383,
                    y_min: 0,
                    y_max: 383,
                    ha: 383,
                    o: "m 464 396 b 376 359 408 396 376 359 l 364 370 b 346 377 357 377 346 377 l 197 377 l 246 528 b 246 531 246 530 246 531 b 226 552 246 541 236 552 l 213 552 b 199 544 209 552 202 547 b 124 482 196 541 130 487 b 117 471 118 478 117 471 b 84 377 117 471 102 431 l 3 377 b -17 360 -14 377 -17 360 l -17 341 b 3 324 -17 325 3 324 l 66 324 b 0 85 35 229 0 117 b 92 0 0 16 48 0 b 186 35 137 0 186 35 b 194 13 186 35 190 24 b 212 0 199 1 212 0 l 276 0 b 298 16 295 0 298 16 l 298 43 b 321 147 298 75 321 147 l 382 284 b 412 325 382 284 396 311 b 446 341 425 336 438 341 b 452 340 448 341 451 341 b 428 288 432 327 428 305 b 485 233 428 271 446 233 b 552 308 534 233 552 264 b 464 396 552 353 520 396 z m 222 143 b 147 78 210 104 171 78 b 137 79 143 78 140 78 b 121 115 125 85 121 99 b 137 190 121 148 137 190 l 180 324 l 275 324 b 279 320 279 324 279 320 b 222 143 279 320 235 187 z"
                },
                ornamentTurn: {
                    x_min: 0,
                    x_max: 456,
                    y_min: 0,
                    y_max: 232,
                    ha: 232,
                    o: "m 527 334 b 442 269 488 334 442 312 b 501 204 442 228 468 204 b 570 226 533 204 540 226 b 613 164 598 226 613 204 l 613 163 b 550 98 613 127 586 98 b 448 143 508 98 485 109 l 328 255 l 298 284 b 174 334 262 317 223 334 b 0 170 92 334 0 278 b 131 0 0 68 58 0 b 215 65 170 0 215 22 b 156 130 215 107 189 130 b 86 108 124 130 117 108 b 43 170 59 108 43 130 l 43 171 b 108 236 43 207 72 236 b 209 192 150 236 171 225 l 328 79 l 360 50 b 482 0 396 17 433 0 b 657 164 564 0 657 56 b 527 334 657 266 600 334 z"
                },
                ornamentTurnSlash: {
                    x_min: 0,
                    x_max: 456,
                    y_min: -80,
                    y_max: 313,
                    ha: 393,
                    o: "m 527 334 b 442 269 488 334 442 312 b 501 204 442 228 468 204 b 570 226 533 204 540 226 b 613 164 598 226 613 204 l 613 163 b 550 98 613 127 586 98 b 448 143 508 98 485 109 l 354 230 l 354 431 b 336 451 354 442 347 451 l 323 451 b 302 431 311 451 302 442 l 302 279 l 298 284 b 174 334 262 317 223 334 b 0 170 92 334 0 278 b 131 0 0 68 58 0 b 215 65 170 0 215 22 b 156 130 215 107 189 130 b 86 108 124 130 117 108 b 43 170 59 108 43 130 l 43 171 b 108 236 43 207 72 236 b 209 192 150 236 171 225 l 302 104 l 302 -96 b 323 -115 302 -108 311 -115 l 336 -115 b 354 -96 347 -115 354 -108 l 354 55 l 360 50 b 482 0 396 17 433 0 b 657 164 564 0 657 56 b 527 334 657 266 600 334 z"
                },
                ornamentMordent: {
                    x_min: 0,
                    x_max: 473,
                    y_min: -77,
                    y_max: 316,
                    ha: 393,
                    o: "m 647 302 l 562 166 l 446 347 b 429 357 444 353 435 357 b 413 347 423 357 416 353 l 363 262 l 363 435 b 343 455 363 446 354 455 l 331 455 b 311 435 320 455 311 446 l 311 173 l 310 171 l 203 347 b 186 357 200 353 192 357 b 168 347 180 357 171 353 l 0 69 l 35 48 l 120 189 l 226 10 b 243 0 229 4 238 0 b 261 10 249 0 258 4 l 311 95 l 311 -91 b 331 -111 311 -102 320 -111 l 343 -111 b 363 -91 354 -111 363 -102 l 363 184 l 366 189 l 478 10 b 495 0 481 4 490 0 b 513 10 501 0 510 4 l 681 281 z"
                },
                ornamentShortTrill: {
                    x_min: 0,
                    x_max: 473,
                    y_min: 0,
                    y_max: 248,
                    ha: 248,
                    o: "m 647 302 l 562 166 l 446 347 b 431 357 444 353 436 357 b 413 347 425 357 416 353 l 310 171 l 203 347 b 186 357 200 353 192 357 b 168 347 180 357 173 353 l 0 69 l 35 48 l 120 189 l 226 10 b 243 0 229 4 238 0 b 261 10 249 0 258 4 l 366 189 l 478 9 b 495 0 481 3 490 0 b 513 10 501 0 510 4 l 681 281 z"
                },
                ornamentTremblement: {
                    x_min: 0,
                    x_max: 654,
                    y_min: 0,
                    y_max: 248,
                    ha: 248,
                    o: "m 907 302 l 822 166 l 708 348 b 691 357 704 354 701 357 b 674 347 685 357 677 353 l 648 302 l 563 166 l 449 348 b 432 357 446 354 438 357 b 415 347 426 357 418 353 l 415 346 l 311 171 l 203 348 b 186 357 200 354 192 357 b 168 348 177 357 171 354 l 168 347 l 0 69 l 35 48 l 120 190 l 226 10 b 243 0 229 4 238 0 l 245 0 b 261 10 251 0 258 4 l 367 189 l 480 10 b 497 0 482 4 491 0 b 513 10 503 0 510 4 l 625 192 l 739 10 b 756 0 742 4 750 0 b 772 10 762 0 769 4 l 942 282 z"
                },
                ornamentPrecompAppoggTrill: {
                    x_min: 0,
                    x_max: 680,
                    y_min: 0,
                    y_max: 388,
                    ha: 388,
                    o: "m 860 170 l 746 353 b 729 361 743 359 737 361 b 713 351 723 361 716 357 l 685 307 l 600 170 l 487 353 b 481 359 485 356 484 357 b 469 361 478 360 472 361 b 452 351 464 361 455 357 l 348 176 l 240 353 b 223 361 238 359 229 361 b 206 353 215 361 209 359 l 40 76 l 40 541 b 20 559 39 552 30 559 b 0 541 10 559 1 552 l 0 26 b 19 1 0 16 9 4 b 26 0 20 1 24 0 b 48 13 35 0 43 6 l 72 52 l 157 194 l 265 14 b 282 4 268 9 276 4 b 298 14 288 4 295 9 l 405 193 l 517 14 b 534 4 520 9 528 4 b 550 14 540 4 547 9 l 664 196 l 776 14 b 793 4 779 9 788 4 b 811 14 799 4 808 9 l 979 287 l 945 307 z"
                },
                ornamentPrecompSlideTrillDAnglebert: {
                    x_min: 0,
                    x_max: 662,
                    y_min: -158,
                    y_max: 248,
                    ha: 406,
                    o: "m 834 166 l 720 348 b 704 357 717 354 713 357 b 687 348 697 357 690 353 l 661 302 l 660 302 l 575 166 l 461 348 b 455 354 459 350 456 353 b 444 357 452 356 448 357 b 428 347 438 357 431 353 l 323 171 l 215 347 b 213 350 215 348 215 350 b 213 350 213 350 213 350 l 213 351 l 212 351 l 212 353 l 210 353 l 210 353 l 209 354 b 207 354 209 354 207 354 b 197 357 206 356 200 357 b 197 357 197 357 197 357 b 194 357 196 357 196 357 b 180 347 187 357 183 353 l 180 346 l 69 164 b 0 -50 23 88 0 17 b 49 -219 0 -108 16 -163 b 66 -228 52 -223 59 -228 b 76 -225 69 -228 73 -226 b 86 -207 82 -222 86 -215 b 84 -197 86 -204 85 -200 b 40 -52 55 -150 40 -102 b 104 143 40 10 62 73 l 131 190 l 239 10 b 256 0 242 4 249 0 l 256 0 b 272 10 262 0 269 4 l 379 189 l 491 10 b 508 0 494 4 503 0 b 508 0 508 0 508 0 l 508 0 b 526 10 514 0 521 4 l 638 192 l 750 10 b 768 0 755 4 762 0 l 768 0 b 785 10 773 0 782 4 l 785 10 l 953 282 l 919 302 z"
                },
                ornamentPrecompSlideTrillBach: {
                    x_min: 0,
                    x_max: 662,
                    y_min: -158,
                    y_max: 321,
                    ha: 479,
                    o: "m 834 166 l 720 348 b 704 357 716 354 713 357 b 687 348 698 357 690 354 l 660 304 l 660 302 l 632 259 l 632 442 b 612 462 632 454 624 462 l 599 462 b 579 442 588 462 579 454 l 579 173 l 575 166 l 461 348 b 455 356 459 351 458 354 b 445 359 452 357 448 359 b 428 348 439 359 431 354 l 323 171 l 215 347 b 213 350 215 348 213 350 l 213 351 l 212 353 l 210 353 l 210 354 l 207 354 b 197 357 204 356 200 357 b 180 348 189 357 183 354 l 179 346 l 69 164 b 0 -49 23 88 0 19 b 49 -217 0 -107 17 -163 b 66 -228 52 -223 60 -228 b 76 -225 69 -228 73 -226 b 86 -207 82 -222 86 -213 b 84 -197 86 -204 85 -200 b 42 -50 56 -148 42 -101 b 104 144 42 12 62 75 l 131 190 l 239 10 b 256 0 242 4 251 0 b 274 10 262 0 271 4 l 379 190 l 491 10 b 508 0 494 4 503 0 b 526 10 514 0 523 4 l 579 98 l 579 -84 b 599 -104 579 -95 588 -104 l 612 -104 b 632 -84 624 -104 632 -95 l 632 183 l 638 192 l 750 10 b 768 0 753 4 762 0 b 785 10 773 0 782 4 l 953 282 l 919 302 z"
                },
                ornamentPrecompTrillSuffixDandrieu: {
                    x_min: 0,
                    x_max: 662,
                    y_min: 0,
                    y_max: 406,
                    ha: 406,
                    o: "m 904 575 b 887 585 901 580 893 585 b 877 582 884 585 880 583 b 867 564 871 579 867 570 b 870 554 867 562 868 557 b 912 408 897 505 912 458 b 850 213 912 346 891 282 l 822 167 l 714 348 b 697 357 711 354 703 357 b 680 348 691 357 683 354 l 575 168 l 462 348 b 445 357 459 354 451 357 b 428 348 439 357 431 354 l 315 167 l 203 348 b 186 357 200 354 192 357 b 168 348 180 357 171 354 l 0 76 l 35 55 l 120 192 l 233 10 b 249 0 238 4 240 0 b 266 10 255 0 264 4 l 294 55 l 379 192 l 492 9 b 498 3 494 6 495 4 b 508 0 501 1 505 0 b 526 10 514 0 523 4 l 631 186 l 737 13 b 746 3 739 10 743 4 b 756 0 749 1 753 0 b 773 9 762 0 770 3 l 884 193 b 953 406 930 269 953 338 b 904 575 953 464 936 520 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefix: {
                    x_min: 0,
                    x_max: 857,
                    y_min: 0,
                    y_max: 248,
                    ha: 248,
                    o: "m 383 140 b 413 189 399 166 412 187 b 520 10 423 171 516 16 b 537 0 523 4 530 0 b 554 10 543 0 550 4 b 660 189 557 16 649 171 b 772 10 671 173 766 19 b 791 0 778 1 785 0 b 806 10 796 0 802 4 b 919 192 809 16 907 174 l 1031 10 b 1048 0 1035 4 1043 0 l 1048 0 b 1066 10 1054 1 1063 4 l 1066 10 l 1234 282 l 1200 302 l 1115 166 l 1002 348 b 985 357 998 354 994 357 b 968 348 978 357 971 353 l 855 166 b 742 348 845 183 746 341 b 726 357 737 354 732 357 b 708 348 719 357 711 354 b 603 171 704 341 613 189 b 495 348 593 189 498 343 b 478 357 492 353 487 357 b 461 348 469 357 464 353 b 357 173 459 346 393 235 b 213 79 320 111 284 79 b 66 176 143 79 95 112 b 40 279 43 228 40 275 b 20 300 40 291 30 300 b 0 278 9 300 0 289 b 29 161 0 276 3 219 b 213 39 65 81 130 39 b 383 140 297 39 346 73 z"
                },
                ornamentPrecompTrillLowerSuffix: {
                    x_min: 0,
                    x_max: 565,
                    y_min: -171,
                    y_max: 249,
                    ha: 420,
                    o: "m 347 168 l 235 348 b 217 359 230 354 226 359 b 200 348 209 359 203 353 b 3 30 197 344 6 35 b 0 20 0 26 0 24 b 22 0 0 9 10 0 b 37 9 27 0 35 3 l 151 192 b 265 10 161 174 262 13 b 281 0 268 6 272 0 b 298 10 289 0 295 3 l 403 186 l 511 10 b 528 0 516 4 521 0 b 546 10 537 0 541 4 l 698 265 b 775 22 744 202 775 112 b 700 -215 775 -60 752 -144 b 696 -226 697 -219 696 -222 b 704 -243 696 -232 700 -239 b 717 -246 708 -246 713 -246 b 733 -239 723 -246 729 -243 b 814 20 789 -160 814 -69 b 711 312 814 132 773 242 b 696 320 707 317 700 320 b 680 310 691 320 684 318 b 595 168 671 297 602 181 l 488 348 b 471 359 484 354 478 359 b 454 348 464 359 456 353 b 347 168 449 343 357 186 z"
                },
                brassMuteClosed: {
                    x_min: 0,
                    x_max: 312,
                    y_min: 0,
                    y_max: 312,
                    ha: 312,
                    o: "m 22 256 b 0 225 7 256 0 240 b 22 193 0 209 7 193 l 193 193 l 193 22 b 225 0 193 7 209 0 b 256 22 240 0 256 7 l 256 193 l 428 193 b 449 225 442 193 449 209 b 428 256 449 240 442 256 l 256 256 l 256 428 b 225 449 256 442 240 449 b 193 428 209 449 193 442 l 193 256 z"
                },
                brassMuteOpen: {
                    x_min: 0,
                    x_max: 280,
                    y_min: 0,
                    y_max: 280,
                    ha: 280,
                    o: "m 202 403 b 0 202 91 403 0 312 b 202 0 0 91 91 0 b 403 202 312 0 403 91 b 202 403 403 312 312 403 z m 202 40 b 40 202 112 40 40 112 b 202 363 40 291 112 363 b 363 202 291 363 363 291 b 202 40 363 112 291 40 z"
                },
                stringsDownBow: {
                    x_min: 0,
                    x_max: 315,
                    y_min: 0,
                    y_max: 293,
                    ha: 293,
                    o: "m 40 0 l 40 291 l 413 291 l 413 0 l 454 0 l 454 402 b 433 422 454 413 445 422 l 20 422 b 0 402 9 422 0 402 l 0 0 z"
                },
                stringsUpBow: {
                    x_min: 0,
                    x_max: 262,
                    y_min: 0,
                    y_max: 343,
                    ha: 343,
                    o: "m 374 485 b 357 494 372 490 363 494 l 337 494 b 318 481 330 494 321 488 l 189 118 l 59 481 b 40 494 56 488 48 494 l 20 494 b 0 474 9 494 0 485 b 1 467 0 472 1 468 l 170 13 b 189 0 173 6 181 0 b 207 13 196 0 204 6 l 376 467 b 377 474 376 468 377 472 b 374 485 377 477 376 482 z"
                },
                stringsHarmonic: {
                    x_min: 0,
                    x_max: 181,
                    y_min: 0,
                    y_max: 181,
                    ha: 181,
                    o: "m 131 220 b 220 131 181 220 220 181 b 131 40 220 81 181 40 b 40 131 81 40 40 81 b 131 220 40 181 81 220 z m 131 261 b 0 131 59 261 0 203 b 131 0 0 59 59 0 b 261 131 203 0 261 59 b 131 261 261 203 203 261 z"
                },
                pluckedSnapPizzicatoAbove: {
                    x_min: 0,
                    x_max: 269,
                    y_min: 0,
                    y_max: 389,
                    ha: 389,
                    o: "m 213 540 b 194 560 213 552 204 560 b 174 540 183 560 174 552 l 174 386 b 0 193 76 376 0 294 b 194 0 0 86 86 0 b 387 193 301 0 387 86 b 213 386 387 294 311 376 z m 194 40 b 40 193 109 40 40 109 b 174 346 40 271 98 336 l 174 193 b 194 173 174 183 183 173 b 213 193 204 173 213 183 l 213 346 b 347 193 289 336 347 271 b 194 40 347 109 278 40 z"
                },
                pluckedSnapPizzicatoBelow: {
                    x_min: 0,
                    x_max: 269,
                    y_min: 0,
                    y_max: 389,
                    ha: 389,
                    o: "m 213 174 b 387 367 311 184 387 266 b 193 560 387 474 301 560 b 0 367 86 560 0 474 b 174 174 0 266 76 184 l 174 20 b 194 0 174 9 183 0 b 213 20 204 0 213 9 z m 194 520 b 347 367 278 520 347 452 b 213 215 347 289 289 225 l 213 367 b 194 387 213 377 204 387 b 174 367 183 387 174 377 l 174 215 b 40 367 98 225 40 289 b 194 520 40 452 109 520 z"
                },
                keyboardPedalPed: {
                    x_min: 0,
                    x_max: 981,
                    y_min: -10,
                    y_max: 545,
                    ha: 555,
                    o: "m 1354 12 b 1413 78 1385 12 1413 42 b 1354 145 1413 115 1385 145 b 1293 78 1320 145 1293 115 b 1354 12 1293 42 1320 12 z m 1092 88 b 1080 86 1089 86 1084 86 b 1004 203 1037 86 1004 137 b 1107 376 1004 360 1097 374 b 1149 209 1129 336 1149 287 b 1092 88 1149 117 1130 95 z m 752 393 b 795 344 779 393 795 372 b 770 285 795 325 788 304 b 693 203 737 249 697 207 b 688 264 690 225 688 245 b 752 393 688 347 714 393 z m 245 507 b 220 544 245 533 235 544 b 217 544 219 544 219 544 b 186 510 206 546 192 537 b 143 464 179 478 163 464 b 134 465 140 464 137 464 b 102 516 117 467 102 487 b 141 613 102 541 112 576 b 347 721 212 711 315 721 b 356 721 351 721 354 721 b 275 560 344 701 297 616 b 259 495 274 557 259 528 b 272 452 259 480 264 465 b 373 323 297 416 350 354 b 387 284 382 311 387 298 b 350 222 387 265 376 245 b 230 140 301 180 252 154 b 128 39 215 130 128 92 b 134 12 128 30 130 22 b 173 -14 144 -7 157 -14 b 264 40 204 -14 243 17 b 333 98 281 58 302 98 b 389 39 357 98 373 60 b 478 -10 416 1 435 -10 b 622 96 527 -10 559 43 b 740 -10 626 86 667 -10 b 929 95 827 -10 917 85 b 1086 -12 950 37 1018 -12 b 1120 -7 1097 -12 1109 -10 b 1264 213 1212 17 1264 111 b 1263 248 1264 225 1263 236 b 815 664 1228 544 907 647 b 785 668 805 665 795 668 b 779 668 783 668 782 668 b 757 654 769 668 760 665 b 757 649 757 652 757 651 b 786 618 759 629 783 619 b 818 606 796 613 808 611 b 1071 435 1007 534 1066 445 b 909 181 930 386 909 256 b 910 141 909 164 909 151 b 786 78 899 127 844 78 b 708 151 726 78 710 144 b 799 230 711 154 742 181 b 864 350 845 271 864 312 b 757 456 864 410 815 456 b 599 222 644 456 599 328 b 609 141 599 192 602 164 b 563 104 608 140 595 122 b 540 98 556 99 549 98 b 459 140 513 98 480 118 b 397 184 413 189 399 184 b 475 279 403 189 454 226 b 482 311 480 289 482 300 b 449 410 482 359 452 405 b 361 533 442 419 383 503 b 354 560 356 541 354 550 b 386 651 353 588 372 622 b 429 713 405 693 426 710 b 557 592 521 688 557 628 b 549 569 557 582 554 573 b 523 559 540 562 531 559 b 459 592 495 559 469 583 b 425 613 451 600 438 613 b 409 608 419 613 415 612 b 399 586 402 602 399 595 b 399 583 397 585 399 585 b 409 552 399 573 405 562 b 541 458 441 487 492 458 b 608 480 564 458 588 465 b 648 572 632 497 648 531 b 429 778 648 649 589 749 b 351 785 402 782 376 785 b 0 507 130 785 0 615 b 127 366 0 399 68 366 b 245 507 186 366 245 429 z"
                },
                keyboardPedalUp: {
                    x_min: 0,
                    x_max: 473,
                    y_min: 0,
                    y_max: 473,
                    ha: 473,
                    o: "m 99 99 b 164 69 120 79 143 69 b 199 82 177 69 190 73 b 210 114 206 89 210 102 b 206 137 210 122 209 130 b 200 160 203 145 200 154 b 210 179 200 166 203 171 l 245 215 b 285 213 255 225 272 219 l 287 213 l 288 212 b 318 183 301 206 318 196 l 318 134 b 291 102 318 112 308 112 b 258 58 274 92 258 76 b 340 0 258 26 294 0 b 423 58 386 0 423 26 b 390 102 423 76 408 92 b 361 134 373 112 361 112 l 361 183 b 392 212 361 196 379 206 b 395 213 393 212 393 213 b 436 215 408 219 426 225 l 471 179 b 480 161 478 171 480 167 b 474 137 480 154 477 147 b 471 115 472 130 471 122 b 482 82 471 102 474 91 b 517 69 491 73 504 69 b 582 99 539 69 562 79 b 612 164 602 120 612 143 b 599 199 612 177 608 190 b 567 210 592 206 579 210 b 544 206 559 210 552 209 b 521 200 536 203 528 200 b 501 210 514 200 508 203 l 467 245 b 468 285 456 255 462 272 l 468 287 b 469 288 468 287 469 287 b 498 318 475 301 485 318 l 547 318 b 579 291 569 318 569 308 b 624 258 589 274 605 258 b 681 340 655 258 681 294 b 624 423 681 386 655 423 b 579 390 605 423 589 408 b 547 361 569 373 569 361 l 498 361 b 469 392 485 361 475 379 b 468 395 469 393 468 393 b 467 436 462 408 456 426 l 501 471 b 520 480 508 478 514 480 b 544 474 527 480 534 477 b 566 471 552 472 559 471 b 599 482 579 471 590 474 b 612 516 608 491 612 503 b 582 580 612 536 602 560 b 516 612 562 600 537 612 b 482 599 503 612 491 608 b 471 566 474 590 471 579 b 474 544 471 559 472 552 b 480 520 477 534 480 527 b 471 501 480 514 478 508 l 436 467 b 395 468 426 456 408 462 b 392 469 393 468 393 469 b 361 498 379 475 361 485 l 361 547 b 390 579 361 569 373 569 b 423 624 408 589 423 605 b 340 681 423 655 386 681 b 258 624 294 681 258 655 b 291 579 258 605 274 589 b 318 547 308 569 318 569 l 318 498 b 288 469 318 485 301 475 l 287 468 l 285 468 b 245 467 272 462 255 456 l 210 501 b 200 521 203 508 200 514 b 206 544 200 528 203 536 b 210 567 209 552 210 559 b 199 599 210 579 206 592 b 164 612 190 608 177 612 b 99 582 143 612 120 602 b 69 517 79 562 69 539 b 82 482 69 504 73 491 b 115 471 91 474 102 471 b 137 474 122 471 130 472 b 161 480 147 477 154 480 b 180 471 167 480 173 478 l 215 436 b 213 395 225 426 219 408 b 212 392 213 393 212 393 b 183 361 206 379 196 361 l 134 361 b 102 390 112 361 112 373 b 58 423 92 408 76 423 b 0 340 26 423 0 386 b 58 258 0 294 26 258 b 102 291 76 258 92 274 b 134 318 112 308 112 318 l 183 318 b 212 288 196 318 206 301 b 213 287 212 287 213 288 l 213 285 b 215 245 219 272 225 255 l 179 210 b 160 200 171 203 166 200 b 137 206 154 200 145 203 b 114 210 130 209 122 210 b 82 199 102 210 89 206 b 69 164 73 190 69 177 b 99 99 69 143 79 120 z m 276 276 b 249 340 262 291 249 320 b 340 432 249 390 289 432 b 432 340 390 432 432 390 b 405 276 432 320 419 291 b 340 249 390 262 360 249 b 276 276 320 249 291 262 z"
                },
                wiggleArpeggiatoUp: {
                    x_min: -22,
                    x_max: 242,
                    y_min: 0,
                    y_max: 164,
                    ha: 164,
                    o: "m 343 122 b 323 143 343 122 334 132 b 308 148 318 147 312 148 b 298 144 304 148 301 147 b 282 128 295 141 291 137 b 274 124 279 125 276 124 b 265 128 268 124 265 128 b 158 220 265 128 173 207 b 112 236 143 232 127 236 b 43 206 82 236 55 219 l -26 137 b -32 125 -30 132 -32 130 b -26 112 -32 118 -26 112 b -6 92 -26 112 -17 102 b 7 86 -1 88 3 86 b 17 91 12 86 14 88 b 33 107 20 94 24 98 b 42 111 36 109 39 111 b 52 107 48 111 52 107 b 158 16 52 107 144 29 b 204 0 174 4 190 0 b 274 30 235 0 262 17 l 343 99 b 348 111 347 104 348 108 b 343 122 348 118 343 122 z"
                },
                repeat1Bar: {
                    x_min: 0,
                    x_max: 481,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 183 180 b 92 271 183 230 141 271 b 1 180 42 271 1 230 b 92 89 1 130 42 89 b 183 180 141 89 183 130 z m 693 360 l 511 360 l 0 -360 l 181 -360 z m 693 -181 b 602 -91 693 -131 651 -91 b 511 -181 552 -91 511 -131 b 602 -272 511 -232 552 -272 b 693 -181 651 -272 693 -232 z"
                },
                repeat2Bars: {
                    x_min: 0,
                    x_max: 735,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 1058 -181 b 968 -91 1058 -131 1017 -91 b 877 -181 917 -91 877 -131 b 968 -272 877 -232 917 -272 b 1058 -181 1017 -272 1058 -232 z m 183 180 b 92 271 183 230 141 271 b 1 180 42 271 1 230 b 92 89 1 130 42 89 b 183 180 141 89 183 130 z m 693 360 l 511 360 l 0 -360 l 181 -360 z m 1058 360 l 877 360 l 366 -360 l 547 -360 z"
                },
                repeat4Bars: {
                    x_min: 0,
                    x_max: 1243,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 183 180 b 92 271 183 230 141 271 b 1 180 42 271 1 230 b 92 89 1 130 42 89 b 183 180 141 89 183 130 z m 693 360 l 511 360 l 0 -360 l 181 -360 z m 1058 360 l 877 360 l 366 -360 l 547 -360 z m 1424 360 l 1243 360 l 732 -360 l 913 -360 z m 1790 360 l 1608 360 l 1097 -360 l 1279 -360 z m 1790 -181 b 1699 -91 1790 -131 1748 -91 b 1608 -181 1649 -91 1608 -131 b 1699 -272 1608 -232 1649 -272 b 1790 -181 1748 -272 1790 -232 z"
                },
                repeatBarSlash: {
                    x_min: 0,
                    x_max: 481,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 693 360 l 511 360 l 0 -360 l 181 -360 z"
                },
                csymDiminished: {
                    x_min: 0,
                    x_max: 501,
                    y_min: 0,
                    y_max: 501,
                    ha: 501,
                    o: "m 361 721 b 0 361 161 721 0 560 b 361 0 0 161 161 0 b 721 361 560 0 721 161 b 361 721 721 560 560 721 z m 557 164 b 361 82 505 111 435 82 b 164 164 287 82 216 111 b 82 361 111 216 82 287 b 164 557 82 436 111 505 b 361 639 216 611 287 639 b 557 557 436 639 505 611 b 639 361 611 505 639 436 b 557 164 639 287 609 216 z"
                },
                csymHalfDiminished: {
                    x_min: -1,
                    x_max: 502,
                    y_min: -1,
                    y_max: 502,
                    ha: 503,
                    o: "m 723 684 l 684 723 l 596 634 b 361 721 533 688 451 721 b 0 361 161 721 0 560 b 88 125 0 271 33 189 l -1 36 l 36 -1 l 125 88 b 361 0 189 33 271 0 b 721 361 560 0 721 161 b 634 596 721 451 688 533 z m 82 361 b 164 557 82 436 111 505 b 361 639 216 611 287 639 b 537 576 426 639 488 616 l 145 184 b 82 361 105 233 82 295 z m 639 361 b 557 164 639 287 609 216 b 361 82 505 111 435 82 b 184 145 295 82 233 105 l 576 537 b 639 361 616 488 639 426 z"
                },
                csymAugmented: {
                    x_min: 1,
                    x_max: 321,
                    y_min: 90,
                    y_max: 410,
                    ha: 320,
                    o: "m 462 400 l 272 400 l 272 590 l 192 590 l 192 400 l 1 400 l 1 320 l 192 320 l 192 130 l 272 130 l 272 320 l 462 320 z"
                },
                csymMajorSeventh: {
                    x_min: 0,
                    x_max: 500,
                    y_min: 10,
                    y_max: 490,
                    ha: 480,
                    o: "m 360 528 l 585 96 l 135 96 z m 360 706 l 0 14 l 720 14 z"
                },
                accidentalNarrowReversedFlat: {
                    x_min: 0,
                    x_max: 160,
                    y_min: -176,
                    y_max: 452,
                    ha: 628,
                    o: "m 0 84 b 101 -153 0 -26 65 -107 b 196 -249 153 -217 196 -249 b 206 -253 199 -251 202 -253 b 225 -235 216 -253 225 -245 l 230 632 b 212 651 230 642 222 651 l 199 651 b 180 632 189 651 180 642 l 184 204 b 125 217 184 204 171 217 b 0 84 53 217 0 173 z m 145 154 b 184 107 181 154 184 120 l 187 -179 b 114 -72 167 -158 132 -112 b 82 58 86 -13 82 36 b 145 154 82 79 82 154 z"
                },
                accidentalNarrowReversedFlatAndFlat: {
                    x_min: 0,
                    x_max: 416,
                    y_min: -176,
                    y_max: 452,
                    ha: 628,
                    o: "m 462 217 b 330 174 374 217 338 181 l 334 632 b 315 651 334 642 325 651 l 302 651 b 284 632 292 651 284 642 l 289 -235 b 308 -253 289 -245 298 -253 b 320 -249 312 -253 317 -251 b 492 -138 320 -249 433 -194 b 599 84 534 -98 599 -26 b 462 217 599 173 534 217 z m 501 58 b 459 -72 501 36 498 -19 b 327 -179 431 -111 359 -164 l 330 85 l 330 91 b 422 154 330 125 359 154 b 501 58 503 154 501 79 z m 0 84 b 101 -153 0 -26 65 -107 b 196 -249 153 -217 196 -249 b 206 -253 199 -251 202 -253 b 225 -235 216 -253 225 -245 l 230 632 b 212 651 230 642 222 651 l 199 651 b 180 632 189 651 180 642 l 184 204 b 125 217 184 204 171 217 b 0 84 53 217 0 173 z m 145 154 b 184 107 181 154 184 120 l 187 -179 b 114 -72 167 -158 132 -112 b 82 58 86 -13 82 36 b 145 154 82 79 82 154 z"
                }
            },
            fontFamily: "Leland",
            resolution: 1e3,
            generatedOn: "2022-12-19T23:52:37.756Z"
        };
        const Ri = {
            glyphs: {
                bracketTop: {
                    x_min: 0,
                    x_max: 508,
                    y_min: 0,
                    y_max: 370,
                    ha: 370,
                    o: "m 22 0 b 122 0 55 1 89 0 l 157 0 b 713 376 425 0 622 137 b 732 467 724 406 732 436 b 726 514 732 482 730 498 b 711 533 723 528 719 533 b 693 526 707 533 700 530 b 674 498 683 520 678 508 b 635 406 662 467 652 435 b 310 164 560 281 458 193 b 154 151 258 154 206 151 b 39 154 117 151 78 154 b 1 120 17 154 4 145 b 0 84 0 108 0 96 b 0 20 0 63 1 40 b 22 0 0 4 7 0 z"
                },
                bracketBottom: {
                    x_min: 0,
                    x_max: 496,
                    y_min: -393,
                    y_max: 0,
                    ha: 393,
                    o: "m 696 -566 b 711 -539 713 -566 708 -549 b 714 -521 713 -533 714 -527 b 713 -508 714 -517 713 -513 b 661 -327 706 -445 688 -384 b 392 -42 603 -203 513 -109 b 206 0 331 -7 266 0 b 160 -1 190 0 174 -1 b 26 -1 107 -1 66 -3 b 0 -19 12 -1 0 -4 l 0 -23 b 3 -50 1 -32 3 -42 b 1 -86 3 -62 1 -73 b 4 -118 1 -96 1 -108 b 45 -151 10 -145 23 -154 b 180 -143 89 -144 135 -145 b 621 -419 392 -135 523 -236 b 662 -539 641 -456 655 -497 b 696 -566 667 -557 680 -566 z"
                },
                barlineTick: {
                    x_min: 0,
                    x_max: 56,
                    y_min: 877,
                    y_max: 1122,
                    ha: 245,
                    o: "m 42 1263 b 66 1287 62 1261 66 1272 b 81 1583 65 1387 72 1485 b 35 1614 82 1610 53 1610 b 14 1591 17 1619 16 1604 b 0 1408 7 1525 0 1459 l 0 1292 b 42 1263 1 1263 23 1266 z"
                },
                breathMarkTick: {
                    x_min: 0,
                    x_max: 568,
                    y_min: 0,
                    y_max: 621,
                    ha: 621,
                    o: "m 258 0 b 278 39 276 0 274 24 b 279 56 279 45 279 50 l 279 73 b 278 117 279 88 278 102 b 281 148 278 127 279 138 b 536 600 312 330 387 487 b 744 719 600 651 670 690 b 815 779 775 730 808 740 b 818 824 818 793 818 808 b 815 868 818 838 818 852 b 796 894 814 881 808 894 b 779 888 791 894 786 893 b 719 864 760 878 739 871 b 372 602 580 806 459 724 b 229 252 298 498 251 383 b 220 268 225 262 222 264 b 209 302 217 279 213 291 b 75 527 181 387 143 467 b 16 563 58 543 39 573 b 0 539 3 557 0 549 b 12 492 0 524 9 507 b 56 400 19 459 22 425 b 163 269 104 367 138 323 b 238 36 197 194 216 115 b 258 0 242 22 243 0 z"
                },
                segno: {
                    x_min: 0,
                    x_max: 798,
                    y_min: -65,
                    y_max: 806,
                    ha: 871,
                    o: "m 16 -94 b 66 -69 39 -92 53 -85 b 177 59 102 -26 138 17 b 543 456 298 192 420 324 b 726 300 615 420 680 373 b 753 217 744 271 753 243 b 655 112 753 170 719 131 b 599 104 636 107 618 104 b 461 173 544 104 495 128 b 432 190 454 183 444 190 b 409 179 425 190 418 187 b 359 118 390 160 373 141 b 341 72 347 101 341 86 b 373 24 341 56 351 40 b 409 6 384 17 396 10 b 550 -13 454 -12 501 -14 b 599 -6 566 -12 583 -10 b 864 213 720 27 806 104 b 886 300 878 242 886 271 b 857 395 886 331 877 363 b 799 467 840 420 821 445 b 648 572 755 513 704 546 b 1110 1083 802 743 955 914 b 1140 1129 1123 1097 1136 1110 b 1149 1148 1142 1135 1149 1142 b 1145 1153 1149 1149 1148 1152 b 1123 1161 1139 1158 1130 1161 b 1109 1156 1119 1161 1113 1159 b 1089 1138 1102 1151 1094 1145 b 946 988 1040 1089 989 1041 b 595 602 834 855 711 732 l 590 598 l 549 615 b 432 793 462 647 432 723 b 534 888 432 851 474 888 b 671 834 588 888 631 864 b 710 818 684 824 696 818 b 724 821 714 818 719 819 b 809 883 757 834 788 852 b 816 901 814 890 816 896 b 802 923 816 910 812 916 b 706 984 770 945 742 971 b 593 1011 668 998 631 1011 b 516 991 567 1011 541 1005 b 333 799 433 949 380 876 b 302 693 312 765 302 729 b 330 589 302 658 311 624 b 469 488 360 533 415 511 b 485 482 475 487 480 485 b 266 249 412 405 338 327 b 121 88 217 196 170 141 b 9 -65 78 40 37 -7 b 0 -85 4 -72 0 -79 b 16 -94 0 -91 4 -94 z m 861 536 b 927 575 890 539 909 557 b 965 628 952 598 965 613 b 926 680 965 644 952 658 b 865 713 900 701 883 713 b 805 667 845 713 828 698 b 768 611 791 649 770 631 b 812 564 766 589 798 582 b 861 536 824 550 840 537 z m 251 350 b 363 436 285 348 353 403 b 354 456 366 448 360 452 b 271 518 327 477 298 497 b 243 528 261 526 252 528 b 210 513 232 528 222 523 b 157 454 190 494 176 472 b 141 428 147 444 141 436 b 158 406 141 420 147 413 b 216 361 180 393 197 376 b 245 350 225 356 235 350 z"
                },
                coda: {
                    x_min: 0,
                    x_max: 1380,
                    y_min: -196,
                    y_max: 1037,
                    ha: 1233,
                    o: "m 1028 -282 b 1057 -245 1045 -282 1053 -261 b 1060 -203 1060 -232 1060 -217 b 1063 9 1060 -132 1061 -62 b 1390 194 1192 22 1303 81 b 1531 543 1467 298 1512 415 b 1532 556 1531 547 1532 552 b 1904 559 1656 557 1780 559 b 1950 582 1920 559 1941 569 b 1987 674 1970 609 1987 638 b 1984 698 1987 681 1986 690 b 1950 700 1973 698 1961 700 l 1941 700 l 1545 696 b 1535 776 1545 723 1541 749 b 1103 1113 1477 996 1326 1107 b 1080 1115 1096 1115 1087 1115 b 1081 1322 1080 1184 1080 1253 b 1079 1467 1083 1371 1081 1418 b 1061 1493 1079 1476 1080 1493 l 1060 1493 b 1028 1467 1044 1490 1031 1485 b 1020 1403 1025 1446 1020 1424 b 1017 1110 1020 1305 1018 1208 l 962 1106 b 569 914 808 1087 671 1035 b 451 683 510 844 472 766 l 161 678 b 118 680 148 678 132 680 b 79 670 101 680 86 678 b 0 544 48 636 29 592 l 37 544 l 429 549 b 428 518 428 539 428 528 b 488 285 428 435 458 360 b 681 81 526 192 593 124 b 946 9 763 40 854 19 b 1008 6 966 7 988 6 b 1005 -137 1008 -42 1005 -89 b 1012 -243 1005 -173 1005 -209 b 1028 -282 1015 -258 1011 -282 z m 1074 690 b 1079 935 1077 772 1077 852 b 1326 855 1166 932 1250 909 b 1446 694 1385 814 1426 759 b 1269 693 1387 694 1328 693 b 1074 690 1204 693 1139 691 z m 577 684 b 766 874 618 763 678 828 b 989 932 837 912 913 923 b 1015 933 998 932 1007 933 b 1014 822 1015 896 1014 860 b 1011 688 1012 791 1012 743 z m 1067 184 b 1071 553 1070 307 1068 429 b 1439 556 1194 553 1316 554 b 1437 554 1439 554 1437 554 b 1341 337 1413 478 1387 402 b 1119 192 1286 261 1211 212 b 1067 184 1102 189 1084 186 z m 1008 180 b 660 264 886 181 770 212 b 524 471 570 305 524 374 b 528 524 524 488 526 505 l 533 549 b 792 552 619 550 706 550 b 1009 553 865 553 937 552 b 1008 180 1009 428 1008 288 z"
                },
                gClef: {
                    x_min: 0,
                    x_max: 664,
                    y_min: -559,
                    y_max: 1009,
                    ha: 1568,
                    o: "m 343 -805 b 366 -801 350 -805 357 -804 b 409 -773 383 -795 397 -786 b 582 -328 528 -648 577 -497 b 583 -294 582 -315 583 -294 b 612 -279 583 -294 603 -282 b 747 -197 660 -256 706 -230 b 949 143 857 -109 920 10 b 956 206 955 164 956 186 b 791 384 956 297 906 363 b 704 393 762 390 733 393 b 498 336 632 393 563 374 b 481 325 490 331 481 325 l 444 465 b 442 485 442 472 442 485 b 609 880 442 485 589 746 b 619 996 616 919 619 958 b 613 1084 619 1027 618 1056 b 534 1387 599 1188 560 1286 b 482 1453 527 1417 517 1453 b 422 1407 456 1453 438 1428 b 305 1063 348 1305 312 1188 b 304 1002 304 1043 304 1022 b 338 654 304 886 323 769 b 343 629 338 645 341 636 b 144 356 278 537 206 451 b 23 144 101 288 53 220 b 0 20 7 107 0 63 b 82 -210 0 -69 30 -160 b 207 -288 112 -239 160 -271 b 410 -328 274 -312 340 -328 b 474 -324 431 -328 452 -327 l 491 -321 b 491 -341 491 -321 492 -334 b 402 -585 475 -428 454 -513 b 294 -668 374 -622 348 -664 b 271 -693 278 -670 271 -680 b 274 -708 271 -698 272 -703 b 302 -775 282 -730 292 -753 b 343 -805 311 -795 325 -805 z m 400 717 b 382 922 389 786 382 854 b 481 1286 382 1047 408 1169 b 507 1125 498 1233 507 1179 b 500 1040 507 1097 504 1068 b 400 717 481 927 455 818 z m 252 -135 b 196 -121 232 -134 215 -127 b 117 -69 158 -108 127 -94 b 111 -32 112 -58 111 -45 b 117 19 111 -16 114 1 b 130 56 118 27 127 52 b 324 337 186 156 253 246 l 384 416 l 395 384 b 416 291 406 348 416 291 b 350 213 416 291 376 239 b 243 -42 278 143 243 55 b 251 -117 243 -66 246 -91 b 252 -135 252 -122 252 -127 z m 563 -91 b 510 168 552 3 530 78 b 513 192 508 179 508 186 b 624 202 550 199 586 202 b 730 192 660 202 694 199 b 850 141 773 183 816 176 b 858 134 852 138 855 135 b 595 -121 801 19 716 -68 l 569 -131 z m 410 -160 b 311 -147 360 -160 311 -147 b 307 -98 311 -147 307 -127 b 314 -33 307 -79 308 -56 b 429 131 328 36 377 85 b 441 138 433 135 438 138 b 449 122 446 138 448 132 b 490 -131 462 37 484 -46 b 490 -153 491 -140 490 -153 b 410 -160 490 -153 452 -163 z"
                },
                cClef: {
                    x_min: 0,
                    x_max: 731,
                    y_min: -543,
                    y_max: 543,
                    ha: 1086,
                    o: "m 131 -782 b 141 -755 138 -782 140 -773 b 147 -490 143 -667 145 -577 b 160 207 150 -258 153 -24 b 168 618 164 344 158 481 b 81 768 173 690 132 732 b 45 782 66 778 55 782 b 3 740 26 782 13 768 b 0 724 1 736 0 730 l 1 710 b 4 596 4 672 4 634 l 4 382 b 9 102 4 288 4 196 b 17 -301 13 -32 10 -166 l 17 -672 b 50 -736 17 -701 27 -720 b 109 -772 69 -749 91 -759 b 131 -782 120 -778 127 -782 z m 615 -770 b 881 -684 710 -770 801 -739 b 1020 -395 986 -612 1020 -510 b 1017 -334 1020 -374 1018 -354 b 769 -62 1007 -209 896 -75 b 746 -60 762 -60 755 -60 b 639 -73 710 -60 675 -69 b 524 -109 598 -79 560 -92 b 528 -36 526 -85 528 -60 b 527 -4 528 -26 528 -14 b 528 39 527 10 528 24 b 526 99 528 59 527 79 b 592 94 549 95 570 94 b 648 99 611 94 629 95 b 912 157 744 94 844 117 b 1053 377 1009 215 1053 284 b 1050 425 1053 393 1053 409 b 914 665 1037 521 986 602 b 717 753 855 717 791 753 b 626 734 688 753 658 747 l 462 665 b 347 500 374 628 347 580 b 350 449 347 484 348 468 b 392 419 353 428 367 416 b 492 438 425 425 459 428 b 541 498 524 448 541 468 b 540 514 541 503 541 508 b 537 546 537 524 537 536 b 573 639 537 580 550 611 b 606 657 582 649 593 657 l 609 657 b 716 622 647 652 684 647 b 834 372 801 556 834 469 b 831 323 834 356 832 338 b 743 187 825 266 795 217 b 710 176 732 180 720 176 b 694 179 704 176 700 177 b 527 223 638 193 582 206 b 495 229 516 228 505 229 b 454 220 481 229 468 225 b 395 189 432 213 415 200 b 363 180 384 186 374 181 b 348 168 356 179 348 176 b 340 161 343 167 340 164 b 347 150 340 157 343 154 b 356 147 348 148 353 147 b 364 92 361 130 363 111 b 369 -37 367 49 369 6 b 363 -154 369 -76 367 -115 b 357 -236 360 -183 357 -210 b 376 -264 357 -253 361 -259 b 456 -289 402 -284 429 -289 b 521 -282 478 -289 500 -285 b 549 -255 537 -279 546 -271 b 598 -177 556 -225 577 -202 b 622 -164 605 -168 613 -164 b 636 -167 626 -164 631 -166 b 749 -225 678 -177 714 -199 b 848 -405 814 -276 848 -337 b 824 -507 848 -436 840 -471 b 657 -657 792 -582 730 -625 b 608 -668 638 -664 622 -668 b 534 -602 572 -668 547 -645 b 513 -575 530 -589 523 -575 b 507 -576 510 -575 508 -575 b 478 -582 497 -580 488 -582 b 405 -570 454 -582 428 -570 b 389 -572 399 -570 395 -570 l 363 -572 b 321 -575 348 -572 333 -569 l 321 631 b 323 662 323 641 323 652 b 315 716 323 681 321 698 b 304 736 314 723 317 736 l 302 736 b 281 716 294 734 285 729 b 275 665 276 700 275 683 l 275 382 b 276 99 275 288 275 193 b 279 -170 278 10 276 -81 b 284 -399 282 -246 284 -323 b 282 -629 284 -475 282 -553 b 289 -721 282 -660 289 -690 b 300 -736 289 -727 291 -736 b 312 -724 307 -736 310 -730 b 321 -667 323 -706 321 -687 l 321 -632 l 328 -644 l 340 -657 b 510 -757 386 -707 445 -740 b 615 -770 546 -766 580 -770 z"
                },
                fClef: {
                    x_min: 0,
                    x_max: 776,
                    y_min: -496,
                    y_max: 216,
                    ha: 712,
                    o: "m 402 -706 b 804 -405 592 -678 716 -566 b 876 -53 861 -298 874 -183 b 868 33 876 -32 873 1 b 560 311 845 217 723 311 b 524 310 549 311 536 311 b 131 134 373 297 239 242 b 17 -29 84 86 37 39 b 9 -89 12 -50 9 -71 b 112 -238 9 -154 43 -206 b 124 -243 117 -239 120 -242 b 186 -261 145 -255 166 -261 b 268 -228 215 -261 242 -249 b 351 -59 325 -181 351 -124 b 343 10 351 -36 348 -13 b 340 36 341 19 340 27 b 409 105 340 75 363 102 b 441 107 420 107 431 107 b 624 36 510 107 573 86 b 744 -200 688 -27 724 -109 b 747 -230 747 -210 747 -222 b 717 -323 747 -264 736 -292 b 608 -445 688 -370 654 -410 b 307 -541 518 -513 415 -541 l 213 -541 b 39 -521 154 -541 96 -539 b 0 -552 17 -514 0 -531 b 1 -564 0 -556 0 -560 b 17 -611 6 -580 10 -596 b 101 -694 35 -648 50 -684 b 288 -714 164 -707 225 -714 b 402 -706 325 -714 363 -711 z m 1018 92 b 1080 118 1041 91 1068 96 b 1117 219 1099 150 1117 180 b 1113 252 1117 229 1116 240 b 1045 288 1102 297 1068 276 b 1017 262 1028 297 1024 274 b 984 124 989 220 996 170 b 1008 91 979 108 986 91 z m 972 -281 b 1070 -148 1024 -279 1070 -210 b 1025 -105 1070 -105 1045 -112 b 989 -127 1004 -96 998 -114 b 949 -249 963 -164 963 -209 b 969 -281 943 -265 949 -281 z"
                },
                unpitchedPercussionClef1: {
                    x_min: 0,
                    x_max: 379,
                    y_min: -250,
                    y_max: 250,
                    ha: 500,
                    o: "m 481 -360 b 507 -357 491 -360 500 -360 b 546 -295 541 -346 547 -325 b 536 79 543 -170 540 -46 b 523 311 533 157 534 235 b 475 359 518 340 508 359 b 425 360 459 359 442 360 b 400 359 416 360 409 360 b 337 294 348 353 340 347 l 337 -73 b 336 -264 337 -137 337 -200 b 343 -294 336 -274 338 -284 b 481 -360 359 -330 431 -360 z m 144 -341 b 207 -320 167 -341 189 -331 b 217 -301 215 -315 217 -308 b 210 -262 217 -289 210 -275 b 228 187 212 -112 209 37 b 228 287 228 220 229 253 b 174 353 228 336 222 343 b 120 359 157 357 138 359 b 48 357 96 359 72 356 b 17 323 29 357 19 344 b 7 120 16 255 9 187 b 6 -109 6 43 6 -33 l 6 -204 b 0 -251 6 -220 0 -235 b 3 -269 0 -256 0 -262 b 127 -340 24 -330 79 -328 b 144 -341 132 -341 138 -341 z"
                },
                "6stringTabClef": {
                    x_min: 0,
                    x_max: 438,
                    y_min: -768,
                    y_max: 767,
                    ha: 1535,
                    o: "m 369 438 b 374 439 370 438 372 438 b 384 462 383 444 384 452 l 384 474 b 390 697 386 547 390 622 b 373 1002 390 799 390 901 l 533 1002 b 560 1001 541 1004 552 1001 b 573 1007 567 1001 572 1002 b 546 1050 579 1025 559 1038 b 536 1056 543 1053 539 1053 b 324 1104 472 1102 397 1104 b 72 1090 238 1104 154 1099 b 55 1093 66 1090 60 1092 b 37 1073 46 1093 37 1089 b 60 1045 37 1061 48 1051 b 203 1001 105 1022 151 1001 b 233 1004 213 1001 223 1002 b 246 1005 238 1004 243 1005 b 272 975 264 1005 272 996 l 272 965 b 258 596 264 842 265 719 b 315 474 253 540 272 504 l 343 455 b 369 438 351 448 357 438 z m 114 -320 b 127 -304 120 -320 124 -315 b 171 -174 141 -261 158 -219 b 222 -135 179 -147 196 -137 b 426 -122 289 -131 359 -128 b 498 -164 462 -120 482 -127 b 628 -301 521 -226 575 -264 b 631 -288 631 -295 631 -291 b 628 -269 631 -281 629 -276 b 569 -134 616 -220 589 -179 b 408 225 514 -14 462 107 b 314 357 384 274 351 318 b 278 380 298 372 288 379 b 251 351 268 380 261 372 b 4 -209 156 171 75 -17 b 0 -228 1 -215 0 -222 b 19 -258 0 -240 7 -249 b 102 -314 45 -279 75 -294 b 114 -320 107 -318 111 -320 z m 425 6 b 360 20 403 17 382 20 b 274 14 331 20 302 14 l 246 14 l 340 206 b 425 6 369 137 395 75 z m 245 -1106 b 281 -1104 256 -1106 269 -1106 b 511 -888 400 -1094 511 -1035 b 454 -688 511 -814 504 -744 b 448 -678 449 -685 448 -681 b 454 -667 448 -675 449 -671 b 504 -497 503 -619 507 -559 b 324 -288 500 -383 436 -308 b 295 -287 314 -287 304 -287 l 282 -287 b 115 -330 223 -287 168 -307 b 94 -366 102 -336 94 -348 l 94 -370 b 96 -435 96 -392 96 -413 b 73 -858 89 -576 71 -717 b 78 -919 73 -878 78 -899 b 72 -950 78 -930 76 -940 b 63 -992 66 -965 63 -978 b 66 -1015 63 -999 65 -1008 b 173 -1104 84 -1106 84 -1106 b 245 -1106 197 -1104 220 -1104 z m 161 -622 b 147 -618 156 -622 151 -621 b 140 -600 141 -612 140 -606 b 144 -564 140 -589 144 -575 b 143 -554 144 -560 144 -557 l 143 -546 b 220 -451 144 -467 143 -465 b 278 -445 239 -446 259 -444 b 418 -497 328 -445 376 -461 b 429 -516 426 -504 429 -510 b 415 -533 429 -521 423 -527 b 219 -608 357 -579 287 -590 b 215 -609 217 -608 216 -609 b 161 -622 197 -609 177 -622 z m 154 -953 b 130 -933 135 -953 130 -948 l 130 -865 l 128 -865 b 135 -788 130 -838 124 -808 b 203 -769 145 -769 180 -776 b 259 -762 223 -765 242 -762 b 441 -852 330 -762 386 -805 b 449 -867 446 -858 449 -863 b 436 -884 449 -874 444 -878 b 318 -942 402 -914 363 -935 b 154 -953 264 -950 209 -953 z"
                },
                timeSig0: {
                    x_min: 20,
                    x_max: 513,
                    y_min: -358,
                    y_max: 359,
                    ha: 717,
                    o: "m 341 -516 b 420 -510 367 -516 395 -514 b 675 -338 533 -494 622 -448 b 737 -92 716 -256 734 -171 b 739 -35 739 -73 739 -53 b 680 305 739 86 720 207 b 400 517 622 449 537 517 b 337 514 380 517 359 517 b 289 507 321 511 305 513 b 91 317 192 477 127 412 b 29 9 50 212 29 108 b 217 -458 29 -157 88 -312 b 341 -516 251 -494 291 -518 z m 412 -452 b 359 -425 393 -452 376 -444 b 187 14 242 -301 179 -158 b 268 334 193 127 212 235 b 387 448 295 383 330 428 b 406 452 395 451 400 452 b 428 444 413 452 420 449 b 517 324 471 413 497 372 b 586 -29 560 222 586 86 b 556 -271 586 -112 585 -193 b 468 -422 536 -327 508 -377 b 412 -452 449 -442 431 -452 z"
                },
                timeSig1: {
                    x_min: 20,
                    x_max: 283,
                    y_min: -364,
                    y_max: 366,
                    ha: 730,
                    o: "m 264 -524 b 357 -510 297 -524 325 -516 b 374 -490 369 -508 374 -501 b 380 -438 376 -472 380 -455 l 406 246 b 408 301 408 265 408 282 b 400 445 408 348 405 396 b 288 527 395 491 338 527 b 253 520 276 527 264 526 b 240 508 249 517 245 513 b 49 409 192 445 127 413 b 29 396 33 408 29 403 b 32 380 29 392 30 386 b 59 363 36 366 49 364 b 164 348 95 356 130 348 b 222 357 183 348 203 351 b 238 361 228 360 233 360 b 252 334 248 361 252 353 b 243 59 252 242 249 150 b 219 -490 229 -124 233 -307 b 264 -524 217 -516 232 -524 z"
                },
                timeSig2: {
                    x_min: 20,
                    x_max: 660,
                    y_min: -379,
                    y_max: 382,
                    ha: 761,
                    o: "m 99 -543 b 130 -533 111 -550 121 -540 b 255 -448 168 -501 213 -475 b 338 -425 282 -431 310 -425 b 392 -431 356 -425 374 -426 b 485 -462 423 -438 454 -451 b 648 -497 540 -482 595 -497 b 834 -441 711 -497 773 -480 b 950 -242 906 -395 958 -334 b 942 -210 950 -230 950 -215 b 912 -220 932 -204 920 -213 b 861 -264 894 -235 877 -248 b 775 -317 835 -289 808 -305 b 675 -334 742 -328 708 -334 b 510 -295 619 -334 563 -318 b 372 -264 465 -278 420 -264 b 305 -272 350 -264 328 -266 b 331 -242 318 -256 324 -249 b 490 -73 386 -187 438 -131 b 675 340 595 43 664 180 b 677 369 677 350 677 360 b 556 536 677 461 638 508 b 468 550 526 546 497 550 b 297 508 409 550 353 533 b 111 354 220 475 168 412 b 29 197 65 308 29 261 b 32 164 29 187 29 176 b 29 140 33 157 29 147 b 43 125 29 132 32 125 b 73 147 55 125 65 138 b 86 163 79 153 82 158 b 238 320 134 219 183 272 b 425 389 292 367 360 389 b 575 341 480 389 531 373 b 606 298 590 330 606 317 b 600 278 606 292 603 285 b 501 107 576 217 544 158 b 304 -104 439 33 372 -35 b 111 -356 230 -180 167 -265 b 84 -446 92 -386 84 -415 b 86 -481 84 -458 85 -469 b 88 -514 88 -491 88 -503 b 99 -543 89 -526 91 -537 z"
                },
                timeSig3: {
                    x_min: 20,
                    x_max: 540,
                    y_min: -392,
                    y_max: 392,
                    ha: 784,
                    o: "m 216 -540 b 354 -564 264 -556 310 -564 b 605 -465 445 -564 530 -530 b 729 -161 697 -383 729 -275 b 724 -82 729 -135 727 -108 b 589 95 716 -1 670 62 b 523 114 567 102 546 108 b 750 418 606 213 677 315 b 778 503 769 444 778 472 b 773 540 778 514 776 527 b 750 564 769 557 762 564 b 736 562 746 564 742 563 b 641 552 704 553 672 552 b 402 554 562 552 481 554 l 346 554 b 84 546 258 554 170 554 b 36 501 55 543 40 531 b 29 412 30 472 32 442 b 52 384 27 393 32 384 l 56 384 b 210 392 107 389 158 392 l 602 392 b 354 108 523 285 445 192 b 246 -65 300 58 246 12 b 252 -108 246 -78 248 -92 l 252 -111 b 264 -141 251 -122 251 -135 b 291 -132 274 -145 284 -140 b 425 -72 328 -95 377 -84 b 475 -65 442 -68 459 -65 b 592 -108 517 -65 557 -79 b 645 -179 615 -125 645 -147 b 642 -194 645 -184 644 -189 b 485 -376 616 -278 569 -344 b 361 -399 444 -392 402 -399 b 151 -340 289 -399 219 -376 b 88 -275 122 -323 98 -310 b 71 -249 86 -268 85 -249 b 63 -251 68 -249 66 -249 b 36 -288 48 -255 36 -266 b 55 -423 33 -336 45 -377 b 101 -482 60 -448 78 -468 b 216 -540 138 -504 174 -526 z"
                },
                timeSig4: {
                    x_min: 20,
                    x_max: 633,
                    y_min: -490,
                    y_max: 491,
                    ha: 981,
                    o: "m 608 -704 b 641 -684 622 -708 634 -696 b 667 -602 660 -660 662 -631 b 685 -190 683 -465 680 -327 l 685 -176 b 831 -127 736 -166 783 -148 b 912 0 901 -94 913 -76 b 886 53 912 36 904 52 b 848 40 877 53 864 49 l 838 36 b 687 -13 789 14 739 -3 b 681 177 687 50 684 114 b 672 338 678 230 677 285 b 654 373 671 350 672 373 b 622 340 636 373 624 361 b 615 262 621 314 613 288 b 619 -22 616 167 619 72 b 569 -22 602 -23 585 -23 b 305 -3 481 -16 395 -1 b 210 -9 274 -3 242 -4 b 301 163 242 52 268 108 b 513 552 377 288 459 412 b 536 652 526 585 536 618 b 533 683 536 662 534 672 b 520 707 531 691 531 707 b 487 693 508 708 494 704 b 474 668 482 684 477 677 b 384 490 454 603 418 547 b 253 281 343 419 295 351 b 73 -13 194 181 145 78 b 29 -108 50 -42 29 -72 b 37 -147 29 -121 32 -134 b 50 -186 43 -160 50 -173 b 68 -216 52 -207 56 -215 b 92 -207 73 -216 82 -213 b 288 -166 156 -180 220 -166 b 556 -186 377 -166 467 -180 b 586 -189 566 -187 576 -187 b 616 -186 596 -189 606 -189 b 606 -432 613 -268 612 -350 b 596 -625 603 -495 596 -559 b 598 -670 596 -641 596 -655 b 608 -704 598 -683 596 -700 z"
                },
                timeSig5: {
                    x_min: 20,
                    x_max: 583,
                    y_min: -389,
                    y_max: 389,
                    ha: 778,
                    o: "m 132 -536 b 249 -560 168 -553 209 -559 b 507 -462 351 -560 454 -514 b 677 -183 588 -384 642 -289 b 694 -85 688 -150 694 -117 b 540 138 694 12 642 94 b 422 173 501 154 462 167 b 400 187 408 174 400 177 b 405 202 400 190 402 196 b 428 284 416 228 426 255 b 469 312 431 307 442 312 b 757 372 569 312 662 343 b 840 490 821 392 840 432 b 812 560 840 540 834 560 b 763 546 801 560 785 556 b 757 543 762 546 759 544 b 465 484 665 505 570 484 b 396 484 452 484 425 487 b 353 454 377 482 366 474 b 281 300 323 405 304 351 b 245 164 262 255 245 212 b 246 144 245 158 246 151 b 233 63 249 115 243 89 b 225 35 228 50 225 40 b 264 14 225 22 236 19 b 445 -26 325 7 387 0 b 569 -151 501 -52 547 -89 b 575 -180 573 -161 575 -170 b 527 -275 575 -217 547 -245 b 347 -367 484 -334 419 -367 b 261 -351 318 -367 289 -363 b 95 -300 206 -333 154 -307 b 55 -321 73 -297 65 -302 b 29 -468 29 -367 40 -419 b 56 -505 26 -482 36 -500 b 132 -536 82 -514 108 -524 z"
                },
                timeSig6: {
                    x_min: 20,
                    x_max: 565,
                    y_min: -363,
                    y_max: 363,
                    ha: 726,
                    o: "m 390 -518 b 621 -458 469 -507 549 -494 b 814 -134 753 -390 814 -281 b 652 59 814 -16 750 58 b 580 48 629 59 606 55 b 233 -334 392 -9 276 -138 b 115 -228 181 -314 143 -278 b 98 -160 104 -206 98 -183 b 107 -109 98 -144 101 -127 b 167 37 124 -59 145 -12 b 508 340 236 189 347 292 b 575 353 530 347 553 353 b 648 327 600 353 625 346 b 665 320 654 321 661 320 b 687 336 674 320 681 325 b 703 405 697 359 703 382 b 684 472 703 429 697 451 b 593 523 664 504 631 521 b 576 521 588 523 582 523 b 297 403 472 508 380 465 b 115 177 217 344 164 264 b 29 -121 60 82 29 -17 b 53 -278 29 -173 36 -225 b 226 -497 82 -374 131 -454 b 347 -523 265 -514 305 -523 b 390 -518 361 -523 376 -521 z m 351 -357 b 312 -351 337 -356 320 -363 b 325 -315 304 -340 320 -327 b 543 -120 373 -222 448 -158 b 622 -104 570 -108 596 -102 b 717 -132 655 -104 687 -112 b 740 -167 732 -143 740 -153 b 730 -196 740 -176 737 -184 b 563 -321 690 -258 634 -300 b 359 -357 497 -341 428 -354 z"
                },
                timeSig7: {
                    x_min: 20,
                    x_max: 592,
                    y_min: -345,
                    y_max: 345,
                    ha: 690,
                    o: "m 253 -497 b 318 -485 276 -497 297 -487 b 366 -441 348 -482 360 -468 b 487 -104 390 -323 433 -210 b 835 403 580 82 701 246 b 852 436 847 416 852 428 b 815 467 852 451 840 461 b 762 474 798 471 779 474 b 674 445 732 474 701 465 b 603 410 652 431 628 420 b 383 360 533 379 459 360 b 200 435 315 360 249 382 b 88 494 168 469 131 485 b 66 497 81 495 73 497 b 33 484 52 497 39 492 b 50 436 22 469 39 451 b 295 310 114 360 199 324 b 406 301 331 304 369 301 b 593 324 468 301 530 308 b 585 307 589 314 588 310 b 265 -249 451 137 338 -46 b 207 -442 242 -312 223 -377 b 204 -462 206 -449 204 -456 b 253 -497 204 -487 220 -497 z"
                },
                timeSig8: {
                    x_min: 20,
                    x_max: 504,
                    y_min: -428,
                    y_max: 428,
                    ha: 856,
                    o: "m 265 -616 b 289 -615 274 -616 281 -616 b 710 -271 492 -592 657 -485 b 726 -148 721 -229 727 -187 b 585 108 726 -48 687 42 b 572 127 576 114 573 120 b 576 144 572 132 575 138 b 598 301 590 196 598 249 b 586 413 598 338 593 376 b 356 616 559 531 467 616 b 233 582 317 616 275 606 b 29 233 101 505 29 384 b 104 9 29 153 46 72 b 189 -48 127 -16 160 -27 b 92 -158 141 -73 114 -114 b 37 -343 63 -217 50 -279 b 33 -390 35 -359 33 -374 b 265 -616 33 -524 148 -616 z m 258 105 b 124 148 215 105 167 117 b 96 196 105 163 96 177 b 99 217 96 202 96 209 b 197 384 120 281 151 337 b 350 451 242 429 297 451 b 516 364 412 451 472 422 b 530 331 523 354 530 343 l 530 327 l 530 320 b 468 151 520 261 507 200 b 419 122 455 135 442 125 b 258 105 370 117 320 105 z m 328 -438 b 158 -276 233 -436 160 -359 b 166 -239 158 -264 161 -252 b 230 -157 176 -203 202 -179 b 367 -72 274 -125 320 -98 b 448 -49 396 -56 423 -49 b 562 -118 491 -49 528 -72 b 611 -251 590 -157 611 -199 b 569 -341 611 -288 595 -318 b 328 -438 500 -402 416 -432 z"
                },
                timeSig9: {
                    x_min: 20,
                    x_max: 494,
                    y_min: -421,
                    y_max: 421,
                    ha: 842,
                    o: "m 235 -606 b 361 -564 275 -606 318 -593 b 619 -229 487 -482 566 -366 b 706 127 664 -114 694 4 b 711 233 708 163 711 197 b 700 346 711 271 708 308 b 389 606 658 517 530 606 b 351 605 376 606 364 606 b 56 272 171 586 56 441 b 96 98 56 216 69 156 b 334 -53 144 -3 238 -53 b 544 36 408 -53 484 -24 b 652 176 586 78 622 124 b 631 71 645 141 639 105 b 467 -302 599 -63 562 -196 b 271 -442 412 -364 354 -422 b 225 -448 255 -446 239 -448 b 95 -305 148 -448 98 -395 b 89 -255 95 -288 94 -271 b 73 -233 86 -246 85 -233 b 52 -248 65 -233 56 -239 b 29 -317 42 -271 30 -291 b 49 -448 29 -361 40 -405 b 235 -606 69 -541 144 -606 z m 340 104 b 144 209 264 108 194 141 b 127 258 132 225 127 240 b 137 297 127 271 130 284 b 366 449 184 396 269 449 b 517 408 415 449 467 436 b 595 348 546 392 572 372 b 616 305 608 336 616 321 b 609 281 616 298 613 289 b 340 104 557 184 477 104 z"
                },
                timeSigCommon: {
                    x_min: 20,
                    x_max: 585,
                    y_min: -298,
                    y_max: 294,
                    ha: 592,
                    o: "m 444 -405 b 829 -45 626 -346 740 -207 b 842 26 842 -23 842 1 b 821 58 842 39 841 58 b 795 40 811 58 802 48 b 765 3 785 29 773 16 b 469 -223 690 -104 596 -183 b 354 -242 431 -235 392 -242 b 180 -177 292 -242 235 -223 b 135 -99 154 -157 140 -131 b 132 -59 134 -85 132 -72 b 141 7 132 -37 135 -16 b 449 274 189 160 297 243 b 477 278 459 276 468 276 b 546 203 517 278 539 253 b 517 157 550 177 533 166 b 485 143 507 153 497 143 l 482 143 b 467 148 478 143 472 144 b 374 183 438 170 406 181 b 264 118 333 183 292 161 b 238 48 246 92 238 69 b 261 -9 238 29 245 10 b 383 -73 287 -39 337 -73 b 412 -68 392 -73 402 -72 b 631 164 526 -27 586 59 b 649 252 644 193 649 222 b 636 328 649 278 645 304 b 504 423 615 400 579 429 b 242 318 408 415 317 387 b 29 -158 104 190 29 33 b 30 -176 29 -164 29 -170 b 115 -364 42 -246 52 -315 b 307 -429 177 -410 240 -429 b 444 -405 351 -429 397 -420 z"
                },
                timeSigCutCommon: {
                    x_min: 20,
                    x_max: 695,
                    y_min: -687,
                    y_max: 687,
                    ha: 1374,
                    o: "m 564 -989 b 595 -945 585 -991 589 -963 l 599 -922 b 605 -628 600 -824 603 -726 l 609 -399 b 878 -251 706 -363 798 -320 b 996 -85 932 -204 976 -153 b 1001 -63 998 -78 1001 -71 b 989 -46 1001 -56 998 -49 b 978 -43 985 -45 982 -43 b 950 -59 968 -43 959 -49 b 733 -216 894 -132 815 -177 b 611 -259 694 -235 652 -249 b 616 -20 612 -179 615 -99 b 680 29 642 -7 665 9 b 698 43 685 36 690 40 b 870 251 792 82 840 160 b 877 294 874 265 877 279 b 818 410 877 338 855 382 b 683 458 779 442 730 448 b 625 468 664 462 644 465 l 625 514 b 638 958 626 662 636 811 b 626 989 638 979 635 989 b 603 981 621 989 613 986 b 422 840 534 945 481 888 b 412 805 412 832 413 818 b 426 713 410 773 420 743 b 445 678 429 690 435 678 b 474 691 452 678 461 683 b 563 755 503 710 530 732 b 564 724 564 740 564 733 b 559 469 563 639 560 554 b 462 454 526 469 494 464 b 112 143 302 399 199 281 b 33 -94 66 71 45 -10 b 29 -148 30 -112 29 -131 b 105 -351 29 -223 52 -291 b 359 -455 171 -426 258 -451 b 517 -431 409 -451 464 -446 l 539 -422 l 539 -477 b 533 -739 536 -563 539 -651 b 530 -824 531 -768 530 -795 b 546 -948 530 -865 533 -907 b 564 -989 552 -962 543 -989 z m 410 -288 b 193 -197 328 -288 253 -264 b 141 -60 160 -161 141 -108 b 157 6 141 -35 147 -12 b 259 158 189 58 217 112 b 438 291 311 215 364 266 b 528 305 468 301 498 305 b 554 304 537 305 546 304 b 553 212 554 274 554 242 b 426 115 498 199 446 164 b 416 68 419 99 416 84 b 425 12 416 49 420 30 b 474 -39 432 -17 448 -32 b 513 -43 487 -42 498 -43 b 547 -40 524 -43 536 -42 l 543 -272 b 461 -285 516 -278 488 -281 b 410 -288 444 -287 426 -288 z m 694 197 b 668 203 685 197 677 199 b 621 216 654 210 638 215 b 622 294 622 242 622 268 b 706 268 651 287 678 278 b 746 235 721 261 734 249 b 752 222 749 230 752 226 b 743 213 752 219 749 215 b 694 197 727 206 711 197 z"
                },
                timeSigPlus: {
                    x_min: 0,
                    x_max: 661,
                    y_min: -358,
                    y_max: 358,
                    ha: 716,
                    o: "m 605 -516 b 629 -490 624 -516 629 -507 b 628 -475 629 -485 628 -481 b 613 -131 624 -405 616 -174 b 612 -96 612 -114 612 -96 l 647 -98 b 897 -115 730 -99 814 -109 b 940 -89 919 -117 935 -109 b 952 -24 946 -69 952 -46 b 948 9 952 -14 950 -3 b 912 39 942 26 933 37 b 609 60 822 48 609 60 b 616 392 609 60 608 291 b 567 488 619 436 605 467 b 511 516 550 498 531 514 b 498 511 507 516 503 514 b 478 446 475 501 480 469 b 467 150 474 348 469 249 b 465 59 465 121 465 59 l 372 49 b 73 14 272 36 173 24 b 49 13 65 13 56 13 b 0 -33 9 13 0 6 b 60 -141 0 -117 6 -140 b 112 -135 73 -141 91 -140 b 413 -102 213 -125 314 -112 b 464 -98 441 -99 464 -98 l 464 -145 b 477 -456 464 -249 468 -353 b 526 -510 478 -488 491 -507 b 589 -513 546 -511 569 -510 b 605 -516 595 -514 600 -516 z"
                },
                timeSigPlusSmall: {
                    x_min: 0,
                    x_max: 418,
                    y_min: -197,
                    y_max: 199,
                    ha: 396,
                    o: "m 301 -284 b 330 -238 320 -284 324 -255 b 348 -46 350 -176 341 -111 b 374 -20 351 -27 356 -23 b 481 -17 409 -16 445 -17 b 566 -9 510 -17 537 -16 b 602 3 579 -7 602 -16 b 566 29 602 19 582 24 b 526 33 553 32 539 33 b 384 39 478 36 432 39 b 356 62 363 39 356 42 l 356 68 b 359 177 359 104 359 141 l 359 251 b 341 287 359 264 361 285 b 311 255 324 287 314 272 b 310 228 311 246 310 236 l 301 69 b 275 39 301 49 295 39 l 271 39 b 210 40 251 40 230 40 b 167 39 196 40 181 40 b 89 40 141 37 115 40 b 24 30 68 40 46 37 b 0 17 17 27 0 30 l 0 13 b 27 -17 3 0 7 -13 b 91 -22 49 -22 71 -22 b 153 -22 115 -22 137 -20 l 275 -22 b 295 -40 289 -22 295 -27 l 295 -48 b 288 -235 288 -109 287 -171 b 287 -264 288 -243 287 -253 b 301 -284 287 -275 289 -284 z"
                },
                timeSigMinus: {
                    x_min: 0,
                    x_max: 662,
                    y_min: -54,
                    y_max: 55,
                    ha: 109,
                    o: "m 39 -78 b 49 -76 42 -78 45 -76 b 452 -75 94 -75 272 -75 b 861 -76 632 -75 814 -76 b 953 -20 927 -79 953 -66 b 948 27 953 -7 950 9 b 946 37 948 30 948 35 b 896 79 940 63 929 79 b 471 78 827 78 648 78 l 42 78 b 0 37 14 78 0 69 b 23 -66 0 0 17 -32 b 39 -78 24 -75 32 -76 z"
                },
                timeSigParensRight: {
                    x_min: 0,
                    x_max: 274,
                    y_min: -723,
                    y_max: 725,
                    ha: 1448,
                    o: "m 37 -1038 b 69 -1031 48 -1044 59 -1038 b 88 -1015 76 -1027 82 -1021 b 164 -886 120 -976 147 -933 b 333 -351 233 -711 292 -534 b 395 118 366 -204 399 -59 b 389 245 392 144 392 194 b 120 996 369 521 265 766 b 68 1044 99 1030 84 1044 b 19 988 50 1044 36 1024 b 0 922 7 965 0 945 b 20 858 0 901 6 881 b 259 215 141 660 236 449 b 271 -1 266 143 271 71 b 252 -239 271 -82 265 -161 b 148 -667 228 -384 183 -524 b 39 -1009 120 -785 66 -893 b 33 -1031 37 -1017 33 -1024 b 37 -1038 33 -1034 35 -1037 z"
                },
                timeSigParensRightSmall: {
                    x_min: 0,
                    x_max: 154,
                    y_min: -422,
                    y_max: 422,
                    ha: 844,
                    o: "m 43 -608 b 60 -598 48 -608 53 -605 b 117 -511 82 -572 102 -543 b 222 23 193 -350 219 -177 b 213 166 225 55 216 109 b 115 531 206 294 174 416 b 45 603 99 562 76 588 b 30 608 39 606 35 608 b 10 598 23 608 17 603 b 0 546 3 590 0 570 b 23 451 0 507 9 458 b 102 351 66 429 84 390 b 167 42 150 252 167 148 b 163 -49 167 12 166 -19 b 35 -449 151 -192 121 -330 b 14 -504 22 -467 14 -485 b 17 -527 14 -511 16 -520 l 30 -590 b 43 -608 33 -603 37 -608 z"
                },
                timeSigParensLeft: {
                    x_min: 1,
                    x_max: 400,
                    y_min: -728,
                    y_max: 728,
                    ha: 1456,
                    o: "m 562 -1048 b 573 -1043 566 -1048 570 -1047 b 553 -988 582 -1025 564 -1004 b 472 -884 527 -952 497 -920 b 210 -354 366 -717 275 -541 b 148 -6 170 -240 148 -124 b 160 148 148 45 153 96 b 315 678 189 331 242 508 b 431 901 350 755 380 834 b 459 950 451 926 461 939 b 435 995 459 962 451 972 b 364 1048 405 1034 383 1048 b 305 996 343 1048 325 1028 b 127 624 226 881 174 753 b 1 30 56 432 9 235 b 1 -32 1 9 0 -12 b 180 -629 13 -245 92 -438 b 363 -936 230 -739 298 -835 b 526 -1041 402 -995 448 -1041 b 562 -1048 537 -1040 552 -1048 z"
                },
                timeSigParensLeftSmall: {
                    x_min: 0,
                    x_max: 173,
                    y_min: -405,
                    y_max: 404,
                    ha: 809,
                    o: "m 197 -583 b 222 -553 212 -582 219 -566 b 229 -497 226 -534 229 -516 b 213 -425 229 -472 225 -448 b 102 -177 173 -344 132 -262 b 62 30 78 -111 58 -42 b 91 183 66 82 75 134 b 215 426 118 271 156 356 b 249 552 246 465 252 505 b 230 582 249 563 246 582 b 197 563 219 582 206 576 b 71 356 144 500 105 429 b 0 50 26 259 3 158 b 13 -112 4 -3 7 -58 b 176 -559 29 -275 105 -416 b 196 -583 180 -569 186 -583 z"
                },
                noteheadDoubleWhole: {
                    x_min: 0,
                    x_max: 614,
                    y_min: -223,
                    y_max: 223,
                    ha: 446,
                    o: "m 35 -321 b 62 -266 58 -318 58 -288 l 62 -194 b 63 50 62 -114 63 -32 b 60 189 63 96 63 143 b 43 300 59 226 60 265 b 29 321 40 308 39 321 l 26 321 b 0 292 13 318 0 310 b 0 248 0 278 -1 262 b 6 147 4 215 6 181 b 4 48 6 114 4 81 b 6 0 4 32 6 16 b 7 -36 7 -12 7 -24 l 7 -52 b 6 -156 7 -86 6 -121 b 19 -275 6 -196 9 -236 b 35 -321 23 -291 16 -323 z m 847 -314 b 871 -288 860 -315 867 -300 b 884 -187 881 -255 886 -222 b 876 115 878 -86 876 14 b 877 255 876 161 876 209 b 868 291 877 268 873 279 b 855 304 867 301 863 304 b 844 301 852 304 848 304 b 822 265 825 292 822 278 b 824 251 822 259 822 255 b 822 170 822 225 822 197 l 822 -20 b 835 -284 827 -86 825 -186 b 847 -314 837 -295 835 -311 z m 757 -291 b 793 -171 796 -255 792 -212 b 795 -49 795 -131 795 -91 b 786 207 795 36 791 121 b 779 240 786 217 783 229 b 766 258 776 246 776 258 b 762 256 765 258 763 256 b 739 236 752 253 740 252 b 733 177 737 216 732 197 b 737 20 737 125 739 73 l 737 -107 b 740 -202 737 -138 739 -170 b 757 -291 740 -230 743 -261 z m 128 -261 b 144 -251 135 -264 141 -256 b 158 -203 156 -236 157 -220 b 161 -137 161 -181 161 -158 b 157 30 161 -81 157 -26 b 158 76 157 45 157 60 l 158 101 b 156 225 158 141 158 183 b 137 253 156 235 154 253 l 134 253 b 109 222 120 251 109 242 b 104 91 108 179 104 134 b 108 -58 104 42 109 -9 b 107 -105 108 -73 108 -89 b 105 -127 107 -112 107 -120 b 118 -245 105 -167 114 -204 b 128 -261 118 -252 121 -259 z m 488 -242 b 693 -79 595 -249 685 -166 l 693 -55 b 690 0 693 -36 691 -17 b 540 187 684 84 621 164 b 449 200 508 196 480 200 b 210 104 363 200 282 163 b 186 56 196 92 186 76 b 207 -82 186 9 192 -37 b 300 -204 225 -132 248 -181 b 488 -242 356 -229 415 -240 z m 490 -88 b 449 -86 477 -88 464 -88 b 287 -56 399 -85 341 -78 b 258 -33 275 -52 258 -48 b 282 -7 258 -20 272 -13 b 458 43 340 23 399 43 b 580 14 497 43 537 35 b 618 -20 606 1 619 -9 b 592 -58 618 -30 609 -42 b 490 -88 562 -82 528 -88 z"
                },
                noteheadWhole: {
                    x_min: 0,
                    x_max: 380,
                    y_min: -186,
                    y_max: 165,
                    ha: 351,
                    o: "m 547 40 b 223 -268 543 -151 367 -259 b 102 -233 180 -271 143 -248 l 62 -216 b 0 -127 22 -197 0 -166 b 6 -91 0 -115 1 -104 b 122 141 33 -9 69 71 b 327 238 170 204 249 238 b 514 158 397 238 467 212 b 547 40 544 125 549 84 z m 248 -107 b 384 -63 295 -102 341 -88 b 426 -23 402 -53 415 -40 b 435 3 432 -14 435 -6 b 413 32 435 14 428 24 b 301 73 376 49 343 73 b 272 69 291 73 282 72 b 121 -35 207 53 157 20 b 111 -58 117 -42 111 -50 b 125 -75 111 -65 115 -71 b 248 -107 164 -89 202 -107 z"
                },
                noteheadHalf: {
                    x_min: 0,
                    x_max: 334,
                    y_min: -174,
                    y_max: 175,
                    ha: 349,
                    o: "m 480 56 b 167 -251 478 -115 331 -251 b 94 -242 143 -251 118 -248 b 9 -141 43 -229 20 -192 b 0 -68 3 -115 0 -91 b 284 249 0 95 127 200 b 304 252 289 251 297 252 b 481 78 374 252 481 170 b 480 56 481 71 481 63 z m 213 -102 b 399 6 274 -81 341 -48 b 402 17 400 7 402 13 b 399 27 402 22 400 26 b 311 94 373 53 353 88 b 292 95 305 95 300 95 b 130 27 230 95 181 55 b 69 -62 98 9 62 -29 b 161 -98 76 -98 128 -91 b 213 -102 174 -101 186 -101 z"
                },
                noteheadBlack: {
                    x_min: 0,
                    x_max: 334,
                    y_min: -164,
                    y_max: 164,
                    ha: 328,
                    o: "m 112 -233 b 141 -236 122 -235 131 -236 b 481 104 279 -236 485 -48 b 403 222 477 141 478 192 b 334 236 382 232 359 236 b 1 -59 180 236 13 59 b 0 -85 1 -68 0 -76 b 112 -233 0 -157 32 -215 z"
                },
                noteheadXDoubleWhole: {
                    x_min: 0,
                    x_max: 730,
                    y_min: -266,
                    y_max: 267,
                    ha: 533,
                    o: "m 1018 -373 b 1032 -361 1025 -376 1028 -367 b 1051 -287 1047 -338 1051 -314 b 1050 -252 1051 -276 1051 -264 b 1030 186 1031 -107 1037 40 b 1031 266 1028 213 1031 239 b 1018 363 1031 300 1028 331 b 1005 384 1015 373 1017 384 l 1004 384 b 984 363 992 384 986 373 b 982 343 982 356 982 348 b 981 235 982 307 981 271 b 996 -285 981 60 986 -112 b 1009 -360 998 -311 1005 -336 b 1018 -373 1011 -364 1014 -373 z m 16 -383 b 49 -328 39 -367 48 -350 b 69 56 58 -202 62 -73 b 75 212 72 107 72 160 b 78 278 76 233 78 255 b 59 382 78 312 73 347 b 29 328 33 372 29 350 b 13 -29 29 209 23 88 b 3 -222 7 -95 10 -157 b 0 -265 1 -236 0 -252 b 16 -383 0 -304 6 -343 z m 923 -314 b 955 -240 948 -289 952 -265 b 965 -65 962 -181 965 -125 b 963 0 965 -45 965 -22 b 962 111 960 37 962 73 b 953 240 962 154 960 197 b 939 275 952 253 952 275 b 913 239 924 274 913 258 b 913 173 914 217 913 194 b 914 135 913 160 913 147 b 920 27 919 98 920 63 b 909 -128 920 -26 917 -78 b 906 -179 906 -147 906 -163 b 923 -314 906 -223 913 -266 z m 121 -301 b 143 -272 134 -301 138 -284 b 147 -255 145 -268 145 -261 b 173 160 161 -117 166 22 b 173 233 173 184 174 209 b 157 264 171 243 171 264 b 137 235 143 264 138 249 b 132 207 135 226 132 216 b 121 43 128 153 124 96 b 105 -186 117 -36 105 -111 b 111 -269 105 -215 107 -242 b 121 -301 114 -281 104 -300 z m 210 -238 b 376 -193 274 -239 327 -226 b 471 -134 406 -173 439 -154 b 534 -94 491 -120 513 -107 b 671 -192 579 -127 624 -161 b 733 -226 691 -204 708 -228 b 746 -225 737 -228 742 -226 b 845 -204 782 -226 814 -213 b 868 -194 854 -203 865 -203 b 852 -173 871 -183 860 -179 b 661 -40 789 -128 724 -84 b 642 -27 654 -36 648 -32 b 861 114 716 17 791 63 b 886 132 870 120 886 121 l 886 137 b 852 164 883 151 867 161 b 776 176 827 170 801 176 b 685 145 744 176 714 168 b 530 45 638 107 583 76 b 403 132 487 73 444 101 b 279 176 364 161 324 171 b 223 160 259 176 229 176 b 258 115 215 141 242 127 b 431 -17 314 71 372 26 b 173 -196 341 -73 253 -130 b 157 -209 168 -200 157 -203 b 158 -215 157 -212 157 -215 b 183 -236 166 -223 168 -235 b 210 -238 194 -236 206 -239 z m 768 -207 b 533 -40 687 -150 609 -94 b 321 -173 462 -85 392 -130 b 261 -194 304 -184 287 -196 b 239 -193 253 -196 246 -194 b 387 -95 294 -157 340 -125 b 505 -20 426 -71 465 -45 l 484 -4 b 353 89 441 27 396 56 b 320 115 341 96 330 107 b 297 141 311 124 297 132 b 300 148 297 144 298 145 b 336 135 311 164 324 143 b 528 -4 400 89 464 42 l 723 121 b 770 140 737 131 753 138 b 792 132 779 140 789 141 b 778 115 795 122 783 120 b 586 -6 714 75 651 35 b 557 -24 576 -13 567 -19 b 726 -147 613 -66 670 -109 b 768 -207 744 -161 765 -173 z"
                },
                noteheadXWhole: {
                    x_min: 0,
                    x_max: 506,
                    y_min: -143,
                    y_max: 144,
                    ha: 287,
                    o: "m 53 -206 b 219 -163 117 -207 170 -196 b 314 -102 249 -141 282 -122 b 377 -63 334 -89 356 -76 b 514 -161 422 -96 468 -128 b 576 -196 534 -174 552 -196 b 589 -193 580 -196 585 -196 b 688 -174 625 -194 657 -181 b 711 -158 698 -171 711 -173 b 696 -143 711 -151 701 -147 b 503 -9 632 -98 567 -52 l 485 4 b 704 145 559 49 634 95 b 729 164 711 150 729 151 l 729 168 b 696 196 726 183 710 193 b 621 207 671 202 645 207 b 528 177 589 207 557 200 b 373 76 480 140 426 108 b 246 164 330 104 287 132 b 122 206 207 193 167 203 b 66 192 102 207 72 207 b 99 147 58 173 85 158 b 274 14 157 102 215 58 b 16 -164 184 -42 96 -98 b 0 -179 12 -168 0 -170 b 1 -183 0 -180 0 -183 b 26 -204 6 -193 12 -204 b 53 -206 37 -206 49 -206 z m 611 -177 b 376 -9 530 -118 452 -63 l 164 -143 b 104 -164 147 -154 130 -164 b 82 -161 96 -164 89 -164 b 230 -65 137 -125 183 -95 l 347 12 b 327 26 341 16 334 22 l 196 121 b 163 147 184 128 173 137 b 140 173 154 154 140 163 b 143 180 140 176 141 177 b 179 166 154 194 167 174 l 372 27 l 566 153 b 613 171 580 161 596 170 b 635 160 624 171 635 174 b 621 147 635 153 626 150 l 429 24 b 400 6 419 19 409 13 b 569 -117 456 -35 513 -75 b 611 -177 588 -130 608 -143 z"
                },
                noteheadXHalf: {
                    x_min: 0,
                    x_max: 421,
                    y_min: -146,
                    y_max: 151,
                    ha: 297,
                    o: "m 490 -209 b 539 -207 505 -207 521 -207 b 606 -209 560 -207 583 -209 b 598 -196 602 -203 600 -199 l 406 -19 l 540 130 b 547 144 546 135 547 140 b 536 156 547 148 543 153 b 488 192 518 166 503 176 b 416 217 471 209 444 217 b 323 180 380 217 344 204 l 264 115 b 239 138 256 122 248 131 b 33 197 180 196 108 200 b 3 186 23 197 6 193 b 19 154 -1 174 10 163 b 171 12 69 107 120 59 b 19 -157 120 -45 69 -101 b 0 -177 14 -163 0 -166 b 1 -181 0 -179 0 -180 b 39 -203 9 -197 22 -203 l 186 -203 b 197 -202 190 -202 193 -200 l 213 -202 b 262 -180 228 -202 246 -199 l 314 -122 b 490 -209 363 -170 412 -216 z m 435 -148 b 291 -30 379 -112 337 -69 l 213 -118 b 190 -137 207 -125 202 -137 b 145 -111 173 -130 154 -127 b 160 -79 137 -98 151 -88 b 238 16 184 -48 212 -16 b 141 99 204 43 173 72 l 124 117 b 115 132 121 121 115 127 b 118 137 115 134 117 137 b 141 132 127 147 135 138 l 253 36 b 347 150 285 75 315 112 b 370 164 354 160 363 163 b 403 145 382 164 393 156 b 416 127 412 140 416 132 b 405 102 416 118 412 111 l 307 -10 b 413 -105 343 -42 379 -73 b 435 -148 425 -115 436 -125 z"
                },
                noteheadXBlack: {
                    x_min: 0,
                    x_max: 289,
                    y_min: -156,
                    y_max: 157,
                    ha: 313,
                    o: "m 23 -225 b 69 -204 40 -223 56 -219 b 137 -131 92 -180 115 -157 l 209 -50 b 377 -197 264 -101 321 -148 b 403 -210 384 -203 393 -210 l 408 -210 b 416 -192 416 -207 416 -199 l 416 -186 b 403 -148 416 -171 413 -158 b 344 -81 384 -125 367 -101 b 252 -1 312 -55 282 -29 b 377 157 297 49 340 101 b 402 202 387 170 402 187 b 395 217 402 207 400 213 b 376 226 389 223 382 226 b 334 192 360 226 346 204 b 206 42 289 143 248 94 b 96 161 167 81 131 120 b 60 193 86 174 76 189 b 33 206 52 196 42 206 b 22 199 29 206 26 204 b 10 173 14 190 10 181 b 22 147 10 166 14 157 b 148 7 62 98 104 52 b 164 -7 154 1 158 -3 b 10 -189 111 -66 55 -122 b 0 -212 6 -197 0 -203 b 1 -217 0 -213 0 -216 b 23 -225 4 -226 14 -222 z"
                },
                noteheadCircleXDoubleWhole: {
                    x_min: 0,
                    x_max: 437,
                    y_min: -220,
                    y_max: 219,
                    ha: 439,
                    o: "m 10 -304 b 40 -206 43 -275 37 -239 b 55 168 48 -81 50 45 b 53 269 56 202 55 236 b 33 315 52 287 46 314 b 3 269 9 317 4 291 b 0 239 1 259 0 249 l 0 -196 b 10 -304 1 -232 7 -268 z m 592 -317 b 621 -220 619 -287 621 -253 b 622 -121 622 -187 622 -154 b 625 -20 622 -88 622 -55 b 629 101 628 20 629 60 b 628 220 629 141 628 181 b 618 253 628 232 625 243 b 608 275 613 259 616 274 b 602 272 606 275 603 275 b 575 249 590 269 575 266 l 575 246 b 573 222 575 239 573 230 l 573 -50 b 592 -317 575 -137 570 -225 z m 79 -285 b 114 -6 96 -261 109 -131 b 117 -63 114 -24 114 -45 b 249 -242 124 -151 166 -212 b 324 -256 275 -252 300 -256 b 504 -137 406 -256 478 -209 b 505 -265 504 -180 505 -222 b 513 -282 505 -269 510 -275 b 533 -248 526 -272 528 -261 b 540 -174 539 -223 540 -199 l 540 -127 b 553 207 546 -16 549 95 b 543 232 553 216 554 232 b 518 207 530 233 518 222 b 511 118 520 177 510 148 l 511 92 b 330 216 488 174 420 223 b 301 215 320 216 311 216 b 122 65 202 204 151 163 b 114 9 117 46 114 27 b 115 75 114 32 115 53 b 101 248 115 157 109 228 b 76 206 78 242 76 225 l 76 91 b 75 -26 76 52 76 13 b 69 -189 72 -81 66 -134 b 79 -285 71 -219 76 -249 z m 317 4 b 219 109 285 40 252 75 l 209 120 b 331 153 248 141 289 151 b 420 137 360 153 390 147 b 446 120 435 131 442 127 l 436 108 l 328 -7 z m 215 -131 b 216 -101 215 -122 215 -114 b 219 -45 217 -82 219 -63 b 197 94 219 3 213 49 l 197 95 b 199 94 199 95 199 94 l 310 -27 b 233 -108 285 -55 259 -81 z m 442 -141 b 432 -122 441 -134 436 -128 l 344 -26 l 426 58 l 445 81 b 444 75 445 78 444 76 b 428 -13 433 46 428 16 b 446 -104 428 -45 433 -75 b 452 -122 449 -111 452 -117 b 442 -141 452 -131 448 -137 z m 323 -190 b 272 -180 305 -187 288 -184 b 217 -158 239 -173 225 -168 l 327 -45 b 330 -48 328 -46 328 -48 b 432 -150 363 -82 393 -121 b 323 -190 400 -174 364 -189 z"
                },
                noteheadCircleXWhole: {
                    x_min: 0,
                    x_max: 323,
                    y_min: -190,
                    y_max: 184,
                    ha: 374,
                    o: "m 156 -258 b 240 -274 184 -268 213 -274 b 455 -101 347 -274 441 -202 b 465 19 462 -60 465 -22 b 464 71 465 36 465 52 b 246 265 455 194 370 274 b 216 264 236 265 226 264 b 12 94 102 251 45 203 b 0 13 3 66 1 40 b 4 -55 0 -10 3 -32 b 156 -258 14 -154 60 -222 z m 245 10 b 233 23 242 14 238 19 b 121 144 196 65 158 104 l 109 154 b 249 192 156 179 202 192 b 351 174 284 192 317 186 b 380 154 366 168 376 163 b 379 153 380 154 380 153 b 369 141 376 148 372 145 b 245 10 327 98 287 53 z m 115 -131 b 118 -96 117 -121 117 -111 b 121 -27 120 -73 121 -50 b 98 124 121 24 115 75 b 96 127 96 125 98 125 b 99 125 98 127 98 125 b 225 -12 140 79 181 33 l 138 -105 b 115 -131 131 -114 122 -121 z m 376 -143 b 363 -121 374 -134 369 -128 b 265 -12 331 -85 298 -48 l 357 85 b 379 111 364 94 372 101 b 377 102 379 108 377 105 b 359 4 364 71 359 37 b 382 -99 359 -32 366 -66 b 387 -121 384 -108 386 -115 b 376 -143 387 -130 382 -135 z m 239 -197 b 181 -187 220 -194 200 -192 b 121 -161 145 -177 128 -173 b 243 -33 161 -118 203 -75 l 248 -36 b 364 -153 285 -75 320 -118 b 239 -197 327 -180 287 -197 z"
                },
                noteheadCircleXHalf: {
                    x_min: 0,
                    x_max: 309,
                    y_min: -179,
                    y_max: 179,
                    ha: 358,
                    o: "m 232 -258 b 435 -94 328 -258 412 -196 b 445 6 444 -60 445 -27 b 444 69 445 27 445 48 b 258 258 439 170 374 258 l 230 258 l 207 256 b 14 107 111 248 45 202 b 0 12 4 75 0 43 b 12 -82 0 -20 4 -50 b 144 -242 27 -160 69 -212 b 232 -258 174 -252 203 -258 z m 192 60 b 115 141 166 88 141 115 l 108 150 b 226 189 141 173 186 189 b 253 186 236 189 245 187 b 305 180 271 183 288 183 b 192 60 268 140 229 101 z m 56 -78 b 45 6 43 -56 45 -23 b 65 84 49 39 50 45 b 85 121 72 96 78 107 b 95 124 88 124 92 127 b 171 39 120 95 145 68 z m 360 -132 b 348 -112 359 -124 353 -118 l 300 -58 l 387 37 b 410 63 397 48 405 56 b 413 26 412 52 413 40 b 360 -132 413 -42 393 -95 z m 232 -183 b 184 -177 217 -183 202 -181 l 281 -78 b 348 -143 301 -101 323 -122 b 232 -183 318 -168 279 -183 z"
                },
                noteheadCircleX: {
                    x_min: 0,
                    x_max: 344,
                    y_min: -179,
                    y_max: 175,
                    ha: 354,
                    o: "m 99 -210 b 236 -258 137 -242 186 -258 b 418 -183 305 -258 374 -230 b 495 33 475 -120 495 -48 b 494 66 495 45 494 55 b 302 252 487 183 405 256 b 181 243 262 249 222 248 b 46 171 128 236 79 219 b 0 19 14 127 0 73 b 99 -210 0 -68 35 -156 z m 245 42 l 124 156 b 200 176 145 166 170 173 b 337 183 245 181 291 184 b 377 176 351 183 364 180 b 245 42 333 131 288 86 z m 392 -99 l 285 3 l 400 121 b 418 154 409 131 418 140 b 465 50 448 130 465 94 b 405 -112 462 -17 439 -73 z m 89 -120 b 48 0 56 -82 48 -42 b 89 112 48 35 59 76 b 109 101 96 111 102 108 l 210 7 l 187 -17 b 89 -120 151 -53 125 -82 z m 176 -183 b 127 -163 158 -179 141 -171 l 252 -32 l 372 -144 b 233 -189 334 -173 285 -189 b 176 -183 215 -189 196 -187 z"
                },
                noteheadCircledDoubleWhole: {
                    x_min: 0,
                    x_max: 672,
                    y_min: -291,
                    y_max: 291,
                    ha: 582,
                    o: "m 27 -419 b 43 -369 37 -403 43 -387 b 49 -82 45 -272 49 -177 b 50 370 50 69 50 219 b 30 419 50 389 50 419 b 7 369 7 419 7 389 b 0 -284 4 151 1 -66 b 16 -418 0 -328 10 -373 z m 945 -374 b 968 -282 963 -343 968 -312 b 966 -245 968 -269 968 -258 b 958 -45 959 -179 962 -111 b 948 262 949 56 952 160 b 936 377 946 301 946 340 b 922 399 933 386 933 399 l 919 397 b 897 374 909 396 899 389 b 894 308 897 353 893 331 b 904 120 899 246 903 183 b 913 -111 907 43 909 -35 b 927 -297 916 -173 919 -235 b 945 -374 930 -320 927 -347 z m 95 -347 b 120 -292 115 -325 117 -310 b 124 -223 122 -269 124 -246 b 122 -141 124 -196 122 -168 b 121 -85 121 -122 121 -104 b 462 -297 170 -209 300 -297 b 727 -219 543 -294 639 -271 b 828 -118 773 -190 808 -157 b 842 -268 831 -168 834 -219 b 851 -288 844 -275 840 -287 b 865 -272 861 -289 863 -279 b 873 -225 871 -256 873 -240 b 873 -171 873 -207 871 -190 b 858 196 868 -48 863 75 b 848 295 857 229 854 262 b 840 315 848 301 850 315 l 837 315 b 816 295 827 314 816 307 b 809 216 815 268 808 243 b 815 102 812 179 814 140 b 672 295 780 176 733 240 b 500 370 621 340 566 370 b 436 361 480 370 459 367 b 120 95 288 321 183 233 l 120 256 b 115 287 120 266 118 276 b 104 305 112 292 115 305 l 101 305 b 82 284 91 304 82 297 b 76 216 81 262 76 239 b 84 -253 78 59 79 -96 b 95 -347 84 -282 89 -311 z m 780 -33 b 779 -24 780 -30 779 -27 b 704 92 766 22 743 62 b 544 173 655 128 599 147 b 400 206 497 194 448 204 b 307 193 369 206 338 202 b 202 118 264 181 226 153 b 235 168 212 135 222 151 b 505 337 302 262 396 312 b 523 338 511 337 517 338 b 611 288 559 338 586 312 b 763 62 678 225 733 151 b 780 -33 776 26 782 -4 z m 435 -88 b 337 -23 387 -88 354 -65 b 333 6 334 -14 333 -6 b 366 86 333 35 344 66 b 456 122 390 111 423 121 b 602 27 517 122 582 88 b 606 1 605 19 606 10 b 575 -49 606 -20 596 -36 b 435 -88 530 -76 481 -82 z m 441 -269 b 194 -96 327 -262 249 -194 b 167 1 176 -62 167 -30 b 177 59 167 22 171 42 b 174 39 176 52 174 46 b 266 -104 174 -27 210 -73 b 511 -151 346 -148 435 -144 l 552 -151 b 740 -104 616 -145 683 -141 b 776 -66 756 -94 769 -81 b 700 -174 766 -105 740 -140 b 441 -269 632 -232 533 -268 z"
                },
                noteheadCircledWhole: {
                    x_min: -50,
                    x_max: 472,
                    y_min: -231,
                    y_max: 232,
                    ha: 463,
                    o: "m 289 -333 b 553 -255 370 -330 465 -307 b 680 -62 635 -206 680 -138 b 662 22 680 -36 674 -7 b 500 259 626 112 573 193 b 327 334 448 304 393 334 b 264 325 307 334 287 331 b -59 49 111 284 4 193 b -72 -19 -68 26 -72 4 b 289 -333 -72 -192 84 -334 z m 608 -69 b 605 -60 606 -66 606 -63 b 530 56 592 -14 570 26 b 372 137 482 92 425 111 b 228 170 324 158 275 168 b 134 157 196 170 166 166 b 29 82 91 145 53 117 b 60 132 37 99 49 115 b 333 301 128 226 223 276 b 350 302 338 301 344 302 b 438 252 386 302 413 276 b 590 26 505 189 560 115 b 608 -69 603 -10 608 -40 z m 262 -124 b 164 -59 215 -124 180 -101 b 160 -32 161 -50 160 -42 b 193 50 160 -3 171 30 b 284 86 217 75 251 85 b 429 -9 344 86 409 52 b 433 -36 432 -17 433 -26 b 402 -85 433 -56 423 -72 b 262 -124 357 -112 307 -118 z m 268 -305 b 22 -132 154 -298 76 -230 b -6 -33 3 -98 -6 -65 b 3 23 -6 -14 -3 6 b 1 3 1 16 1 10 b 94 -140 1 -63 37 -109 b 338 -187 173 -184 261 -180 l 379 -187 b 566 -140 444 -181 510 -177 b 602 -102 582 -130 595 -117 b 526 -210 592 -141 567 -176 b 268 -305 459 -268 360 -304 z"
                },
                noteheadCircledHalf: {
                    x_min: -50,
                    x_max: 393,
                    y_min: -175,
                    y_max: 175,
                    ha: 350,
                    o: "m 540 39 b 408 187 503 94 464 148 b 259 252 356 223 301 252 b 35 192 160 252 95 229 b -68 50 -17 160 -53 112 b -72 13 -71 37 -72 24 b 69 -204 -72 -79 -1 -161 b 246 -252 125 -238 186 -252 b 500 -164 336 -252 426 -219 b 566 -42 543 -132 566 -88 b 540 39 566 -14 557 14 z m 9 -42 b 12 -68 10 -50 10 -59 b -7 6 3 -46 -4 -22 b 131 189 1 98 55 153 b 243 220 167 206 204 215 b 261 222 249 222 255 222 b 377 161 308 222 341 189 b 435 89 402 141 420 117 b 431 92 433 89 432 91 b 346 120 402 102 372 107 b 253 143 314 135 282 143 b 85 79 193 143 138 115 b 9 -42 45 52 10 13 z m 356 39 b 343 1 356 24 351 12 b 206 -111 304 -46 259 -84 b 181 -118 196 -115 189 -118 b 156 -71 163 -118 154 -102 b 238 35 164 -22 199 9 b 324 66 264 52 294 59 b 356 39 348 71 356 62 z m 488 -78 b 392 -176 471 -125 433 -154 b 246 -225 346 -200 297 -217 b 230 -226 240 -226 235 -226 b 157 -204 203 -226 180 -215 b 78 -154 128 -190 101 -174 b 232 -184 128 -171 180 -184 b 344 -161 269 -184 307 -179 b 491 -39 405 -135 455 -94 b 500 -23 495 -33 497 -29 b 488 -78 500 -40 494 -59 z"
                },
                noteheadCircledBlack: {
                    x_min: -70,
                    x_max: 326,
                    y_min: -168,
                    y_max: 192,
                    ha: 360,
                    o: "m 176 -239 b 190 -242 180 -240 186 -240 b 262 -232 213 -242 238 -235 b 469 -19 384 -225 469 -131 b 467 22 469 -6 468 9 b 383 194 455 86 436 151 b 183 276 315 249 251 275 b 32 236 134 276 85 264 b -94 88 -30 207 -75 160 b -101 30 -98 69 -101 49 b 176 -239 -101 -107 9 -251 z m 177 -212 b -30 -27 81 -213 -13 -131 b -33 17 -33 -13 -33 3 b 127 226 -33 111 14 187 b 194 239 151 233 173 238 b 301 203 232 239 266 226 b 364 134 330 184 350 160 b 233 181 341 160 279 180 b 192 171 216 181 202 179 b 13 1 117 131 46 86 b 3 -48 6 -17 3 -33 b 60 -115 3 -79 20 -101 b 203 -135 105 -131 151 -138 b 229 -138 212 -137 220 -137 b 295 -122 251 -138 274 -135 b 400 -33 337 -99 373 -71 b 228 -206 393 -125 330 -192 b 177 -212 209 -209 192 -213 z"
                },
                noteheadDoubleWholeSquare: {
                    x_min: 0,
                    x_max: 474,
                    y_min: -209,
                    y_max: 211,
                    ha: 420,
                    o: "m 648 -301 b 668 -287 658 -304 665 -295 b 683 -209 678 -262 683 -235 b 677 258 681 -55 678 102 b 672 284 677 266 677 276 b 661 304 670 291 672 304 l 658 304 b 635 279 647 301 635 297 b 629 240 635 266 629 252 l 629 236 b 631 225 629 232 631 228 b 583 194 631 197 611 194 l 528 194 b 125 207 393 194 259 202 b 89 207 114 209 101 206 b 63 210 79 207 71 207 b 52 229 55 213 52 220 b 55 258 52 238 55 248 b 53 266 55 261 55 264 b 36 298 48 276 53 298 l 35 298 b 4 264 14 298 7 284 b 0 187 0 238 0 213 b 4 50 0 143 3 96 b 6 -10 6 30 6 10 b 4 -130 6 -50 4 -91 b 12 -268 4 -176 6 -222 b 19 -287 13 -275 10 -284 b 35 -275 26 -288 30 -281 b 52 -220 50 -261 48 -239 b 75 -199 55 -206 58 -199 l 141 -197 l 274 -197 l 634 -197 b 639 -281 635 -219 636 -251 b 648 -301 641 -288 638 -300 z m 72 -66 b 55 -56 59 -69 55 -65 l 55 -50 b 53 53 55 -16 55 20 b 69 73 53 69 60 72 l 79 72 b 330 65 163 66 246 63 l 592 65 b 634 81 606 65 618 71 b 635 -30 634 39 635 6 b 605 -58 635 -49 628 -58 b 451 -60 553 -60 503 -60 b 219 -59 373 -60 295 -59 l 166 -59 b 72 -66 134 -59 104 -60 z"
                },
                noteheadSquareWhite: {
                    x_min: 0,
                    x_max: 350,
                    y_min: -131,
                    y_max: 131,
                    ha: 262,
                    o: "m 468 -189 b 485 -187 474 -189 480 -189 b 500 -176 495 -187 500 -183 b 498 -168 500 -174 498 -171 b 497 -166 498 -167 497 -167 l 498 -164 b 504 -154 503 -163 504 -158 b 503 -138 504 -150 503 -144 l 503 -135 l 503 -94 b 492 66 500 -45 494 10 b 488 135 492 89 488 112 b 484 150 488 141 485 145 b 482 154 482 151 482 153 b 429 189 472 177 456 189 b 53 184 304 186 179 186 l 39 184 b 33 181 36 183 35 183 b 12 160 20 181 12 177 b 0 -109 9 71 4 -19 b 19 -137 0 -125 7 -134 b 23 -151 19 -141 20 -145 b 85 -187 37 -173 55 -187 b 468 -189 212 -187 340 -187 z m 246 -125 l 63 -125 b 66 -111 65 -122 66 -117 b 73 72 69 -50 71 10 l 73 130 b 88 128 78 128 82 128 b 148 130 108 130 128 130 b 271 128 190 130 230 128 l 271 130 l 420 130 b 428 20 425 92 425 56 l 436 -127 l 246 -127 z"
                },
                noteheadSquareBlack: {
                    x_min: 0,
                    x_max: 342,
                    y_min: -130,
                    y_max: 132,
                    ha: 262,
                    o: "m 217 190 b 439 186 304 190 372 190 b 467 180 448 184 458 183 b 492 145 484 176 492 167 b 490 -124 490 56 490 -33 b 488 -141 490 -130 488 -135 b 456 -170 488 -163 478 -168 b 118 -183 344 -176 230 -181 b 29 -184 89 -183 60 -192 b 0 -148 4 -180 0 -168 b 1 29 1 -89 1 -30 l 1 156 b 36 190 3 187 4 190 b 217 190 102 192 168 190 z"
                },
                noteheadTriangleDownDoubleWhole: {
                    x_min: 0,
                    x_max: 510,
                    y_min: -213,
                    y_max: 213,
                    ha: 426,
                    o: "m 16 -307 b 30 -289 26 -307 29 -297 b 43 -236 36 -272 42 -253 l 65 219 b 59 285 62 240 69 264 b 46 307 55 294 58 307 l 43 307 b 19 279 30 304 20 295 b 13 184 17 248 14 216 b 1 -125 9 81 7 -23 b 0 -163 0 -138 0 -150 b 6 -287 0 -204 4 -245 b 16 -307 6 -295 7 -305 z m 707 -294 b 734 -213 733 -271 734 -242 b 729 245 733 -60 730 92 b 719 285 729 259 724 272 b 707 298 716 291 714 298 l 703 298 b 685 284 696 297 687 292 b 683 253 683 274 683 264 b 691 -181 685 108 685 -36 b 707 -294 693 -217 690 -256 z m 108 -238 b 125 -203 125 -238 121 -216 b 127 -190 127 -199 127 -194 b 120 -138 127 -173 120 -156 l 120 -66 b 114 167 120 12 118 89 l 118 161 b 314 -153 184 58 248 -48 b 350 -184 327 -173 338 -184 b 387 -154 361 -184 374 -174 b 567 108 449 -68 508 20 b 626 193 588 137 608 164 b 615 -132 622 85 619 -24 l 615 -166 b 619 -207 615 -180 615 -194 b 638 -226 622 -217 629 -225 b 651 -209 648 -226 649 -216 b 658 -177 655 -199 658 -187 l 658 -171 b 667 49 655 -98 667 -23 b 665 88 667 62 667 75 b 665 220 665 135 667 179 b 641 265 664 238 660 265 b 626 243 629 265 626 255 b 628 222 626 236 628 228 b 612 225 624 223 619 225 b 384 223 537 223 461 223 l 384 225 l 170 225 b 131 215 157 225 144 222 b 112 200 122 210 117 206 b 88 266 111 225 108 249 b 75 239 76 259 75 249 b 73 147 75 207 73 179 b 82 -189 73 35 79 -78 b 84 -203 82 -194 82 -199 b 108 -238 86 -219 91 -238 z m 361 -79 b 295 78 336 -26 314 26 b 284 151 287 101 284 125 b 310 177 284 171 291 177 b 419 176 346 176 383 174 l 423 176 b 445 153 441 176 445 168 l 445 147 b 361 -79 442 65 415 -10 z"
                },
                noteheadTriangleDownWhole: {
                    x_min: 0,
                    x_max: 366,
                    y_min: -145,
                    y_max: 138,
                    ha: 283,
                    o: "m 242 -209 b 279 -180 253 -209 266 -200 b 459 84 341 -92 400 -4 b 520 170 480 112 501 141 b 527 189 524 177 527 183 b 504 199 527 196 520 199 l 55 199 b 23 190 45 199 33 196 b 0 161 9 181 0 173 b 10 135 0 154 3 145 b 206 -177 76 32 140 -73 b 242 -209 219 -199 230 -209 z m 253 -105 b 187 52 228 -52 206 0 b 176 127 179 76 176 101 b 197 151 176 144 181 151 l 202 151 b 256 150 220 151 238 150 b 311 151 275 150 294 151 b 337 128 331 151 337 144 l 337 122 b 253 -105 334 39 307 -35 z"
                },
                noteheadTriangleDownHalf: {
                    x_min: 0,
                    x_max: 341,
                    y_min: -159,
                    y_max: 159,
                    ha: 318,
                    o: "m 266 -229 b 282 -215 274 -229 278 -225 b 487 153 350 -92 418 30 b 491 170 490 158 491 164 b 480 189 491 177 487 183 b 425 215 464 202 448 213 b 33 226 297 217 168 222 b 13 229 29 223 22 229 b 1 222 9 229 4 228 b 14 184 -4 207 7 196 b 210 -176 81 65 145 -56 b 253 -225 222 -194 230 -213 b 266 -229 259 -226 264 -228 z m 134 22 b 147 43 138 27 141 37 b 206 163 174 79 179 127 b 213 170 209 166 212 167 l 340 167 b 193 -75 287 89 251 1 b 190 -82 192 -76 190 -79 z"
                },
                noteheadTriangleDownBlack: {
                    x_min: 0,
                    x_max: 346,
                    y_min: -149,
                    y_max: 149,
                    ha: 298,
                    o: "m 229 -215 b 259 -202 238 -215 248 -210 b 284 -173 269 -194 278 -184 l 482 173 b 498 209 488 184 498 194 b 481 215 492 215 487 215 b 63 213 343 215 203 213 b 12 197 45 213 29 206 b 0 180 4 193 0 187 b 3 168 0 177 1 173 b 13 150 6 163 9 156 l 196 -189 b 229 -215 206 -206 216 -215 z"
                },
                noteheadTriangleUpDoubleWhole: {
                    x_min: 0,
                    x_max: 510,
                    y_min: -213,
                    y_max: 213,
                    ha: 426,
                    o: "m 16 -307 b 30 -289 26 -307 29 -297 b 43 -236 36 -272 42 -253 l 65 219 b 59 285 62 240 69 264 b 46 307 55 294 58 307 l 43 307 b 19 279 30 304 20 295 b 13 184 17 248 14 216 b 1 -125 9 81 7 -23 b 0 -163 0 -138 0 -150 b 6 -287 0 -204 4 -245 b 16 -307 6 -295 7 -305 z m 707 -298 b 734 -217 733 -275 734 -246 b 729 240 733 -65 730 88 b 719 281 729 255 724 268 b 707 294 716 287 714 294 l 703 294 b 685 279 696 292 687 288 b 683 249 683 269 683 259 b 691 -186 685 104 685 -40 b 707 -298 693 -222 690 -261 z m 88 -266 b 112 -200 108 -249 111 -225 b 131 -215 117 -206 122 -210 b 170 -225 144 -222 157 -225 l 384 -225 l 384 -223 b 612 -225 461 -223 537 -223 b 628 -222 619 -225 624 -223 b 641 -265 628 -238 622 -265 b 665 -220 660 -265 664 -238 b 665 -88 667 -179 665 -135 b 667 -49 667 -75 667 -62 b 658 171 667 23 655 98 b 651 209 660 184 655 197 b 638 226 649 216 648 226 b 619 207 629 225 622 217 b 615 166 615 194 615 180 l 615 132 b 626 -193 619 24 622 -85 b 567 -108 608 -164 588 -137 b 387 154 508 -20 449 68 b 350 184 374 174 361 184 b 314 153 338 184 327 173 b 118 -161 248 48 184 -58 l 114 -167 b 120 66 118 -89 120 -12 l 120 138 b 127 190 120 156 127 173 b 125 203 127 194 127 199 b 108 238 121 216 125 238 b 84 203 91 238 86 219 b 82 189 82 199 82 194 b 73 -147 79 78 73 -35 b 75 -239 73 -179 75 -207 b 88 -266 75 -249 76 -259 z m 310 -177 b 284 -151 291 -177 284 -171 b 295 -78 284 -125 287 -101 b 361 79 314 -26 336 26 b 445 -147 415 10 442 -65 b 423 -176 446 -166 442 -176 l 419 -176 b 310 -177 383 -174 346 -176 z"
                },
                noteheadTriangleUpWhole: {
                    x_min: 0,
                    x_max: 366,
                    y_min: -145,
                    y_max: 138,
                    ha: 283,
                    o: "m 504 -209 b 527 -199 520 -209 527 -206 b 520 -180 527 -193 524 -187 b 459 -94 501 -151 480 -122 b 279 170 400 -6 341 82 b 242 199 266 190 253 199 b 206 167 230 199 219 189 b 10 -145 140 63 76 -42 b 0 -171 3 -156 0 -164 b 23 -200 0 -183 9 -192 b 55 -209 33 -206 45 -209 z m 202 -161 b 176 -137 183 -163 176 -156 b 187 -62 176 -111 179 -86 b 253 95 206 -10 228 42 b 337 -132 307 24 334 -49 b 311 -161 338 -153 334 -161 b 256 -160 294 -161 275 -160 b 202 -161 238 -160 220 -161 z"
                },
                noteheadTriangleUpHalf: {
                    x_min: 0,
                    x_max: 341,
                    y_min: -159,
                    y_max: 159,
                    ha: 318,
                    o: "m 458 -226 b 478 -229 462 -223 469 -229 b 490 -222 482 -229 487 -228 b 477 -184 495 -207 484 -196 b 281 176 410 -65 346 56 b 238 225 269 194 261 213 b 225 229 232 226 228 228 b 209 215 217 229 213 225 b 4 -153 141 92 73 -30 b 0 -170 1 -158 0 -164 b 12 -189 0 -177 4 -183 b 66 -215 27 -202 43 -213 b 458 -226 194 -217 323 -222 z m 151 -167 b 298 75 204 -89 240 -1 b 301 82 300 76 301 79 l 357 -22 b 344 -43 353 -27 350 -37 b 285 -163 317 -79 312 -127 b 278 -170 282 -166 279 -167 z"
                },
                noteheadTriangleUpBlack: {
                    x_min: 0,
                    x_max: 346,
                    y_min: -149,
                    y_max: 149,
                    ha: 298,
                    o: "m 481 -215 b 498 -209 487 -215 492 -215 b 482 -173 498 -194 488 -184 l 284 173 b 259 202 278 184 269 194 b 229 215 248 210 238 215 b 196 189 216 215 206 206 l 13 -150 b 3 -168 9 -156 6 -163 b 0 -180 1 -173 0 -177 b 12 -197 0 -187 4 -193 b 63 -213 29 -206 45 -213 b 481 -215 203 -213 343 -215 z"
                },
                noteheadSlashedDoubleWhole1: {
                    x_min: 0,
                    x_max: 697,
                    y_min: -290,
                    y_max: 290,
                    ha: 580,
                    o: "m 20 -418 b 42 -376 40 -418 37 -392 b 43 -356 45 -370 43 -363 l 43 -348 b 50 -197 43 -298 49 -248 b 78 317 58 -24 69 147 b 72 387 75 343 82 366 b 52 418 68 397 69 418 l 49 416 b 24 380 33 413 24 399 b 19 235 23 333 20 284 b 7 -82 14 130 10 24 b 0 -264 6 -143 0 -203 b 10 -382 0 -302 1 -343 b 20 -418 13 -393 6 -418 z m 976 -344 b 991 -331 985 -346 988 -337 b 1004 -271 999 -312 1004 -292 l 1004 -194 b 996 184 1004 -68 1001 59 b 996 281 996 216 998 249 b 984 379 995 314 991 347 b 971 397 981 392 976 396 b 952 386 965 397 959 392 b 943 361 943 380 945 370 b 937 288 939 337 937 312 b 945 158 937 245 942 203 b 959 -248 950 23 953 -112 b 966 -325 960 -274 963 -300 b 976 -344 966 -334 968 -344 z m 102 -331 b 124 -272 120 -314 122 -294 b 135 -278 127 -276 131 -278 l 141 -278 b 320 -199 206 -262 272 -252 b 348 -171 328 -189 338 -180 b 482 -199 392 -190 436 -199 b 704 -173 576 -199 641 -187 b 847 -82 760 -158 809 -130 l 855 -69 l 855 -73 b 863 -229 857 -125 860 -177 b 876 -255 863 -239 863 -255 b 893 -233 886 -255 888 -242 b 900 -189 899 -219 900 -203 l 900 66 b 900 192 899 108 900 150 b 893 301 900 228 899 265 b 877 325 890 310 893 325 l 876 325 b 855 301 865 324 855 315 b 850 202 852 268 847 235 b 854 50 854 151 854 101 b 821 99 847 68 835 85 b 733 167 795 127 765 148 b 831 253 766 196 799 225 b 851 265 837 258 844 261 b 829 282 840 275 835 279 b 772 295 815 291 795 295 b 685 271 739 295 704 287 b 624 215 665 252 645 233 l 566 232 b 527 239 553 236 540 239 b 490 228 514 239 501 236 b 451 219 475 217 467 219 b 275 176 389 219 331 200 b 184 53 216 150 184 105 b 199 -14 184 32 189 10 b 262 -108 215 -52 236 -82 l 125 -230 b 134 225 130 -78 132 73 b 135 269 134 239 135 255 b 121 330 135 291 132 311 b 95 287 99 323 95 307 b 92 124 94 233 95 179 b 85 -143 88 36 85 -53 b 89 -300 85 -196 86 -248 b 102 -331 89 -311 89 -323 z m 367 -14 b 350 43 359 3 351 22 b 392 122 350 82 363 107 b 544 171 439 150 492 160 b 572 168 554 174 563 171 z m 564 -132 b 467 -105 528 -138 497 -121 b 442 -89 458 -101 449 -95 l 658 101 b 690 30 677 82 690 59 b 688 10 690 24 690 17 b 564 -132 678 -45 611 -127 z"
                },
                noteheadSlashedWhole1: {
                    x_min: -76,
                    x_max: 498,
                    y_min: -168,
                    y_max: 168,
                    ha: 336,
                    o: "m -79 -242 b 55 -202 -32 -236 14 -228 l 145 -143 b 333 -171 203 -166 265 -171 b 429 -164 361 -174 395 -168 b 582 -130 481 -158 534 -154 b 657 -20 631 -105 657 -65 b 619 68 657 9 644 40 b 552 120 599 89 577 107 b 582 138 562 127 572 132 b 717 226 625 167 668 194 b 638 242 688 236 662 242 b 543 213 603 242 573 232 b 455 154 514 194 484 174 b 325 199 412 167 367 179 b 233 215 298 210 265 215 b 75 156 173 215 124 186 b 0 27 24 122 0 76 b 66 -98 0 -17 22 -63 b 72 -102 69 -99 71 -101 b -89 -209 17 -137 -36 -173 b -109 -225 -95 -213 -109 -216 b -108 -229 -109 -226 -108 -228 b -85 -242 -104 -239 -95 -242 z m 181 -29 b 167 14 171 -13 167 1 b 187 62 167 30 173 46 b 301 137 217 99 258 118 b 312 138 304 138 308 138 l 317 138 b 389 109 340 125 364 118 l 383 105 z m 337 -109 b 239 -82 301 -107 268 -99 l 468 65 b 482 24 477 53 482 40 b 480 4 482 19 481 12 b 337 -109 467 -56 399 -111 z"
                },
                noteheadSlashedHalf1: {
                    x_min: -79,
                    x_max: 471,
                    y_min: -184,
                    y_max: 184,
                    ha: 368,
                    o: "m -112 -251 b -94 -265 -107 -261 -101 -264 b -52 -242 -79 -265 -63 -249 l 89 -148 b 212 -180 125 -170 167 -179 b 238 -177 220 -180 229 -179 l 262 -180 b 346 -171 289 -180 318 -176 b 576 -91 431 -166 507 -140 b 641 4 619 -60 641 -29 b 592 96 641 35 625 65 l 583 104 b 533 147 567 121 550 134 l 613 200 b 678 261 636 216 664 232 b 658 265 671 264 664 265 b 611 248 641 265 625 258 l 491 171 b 337 204 444 194 392 204 b 281 200 318 204 300 204 b 27 62 180 187 92 145 b -1 -19 9 37 -1 10 b 36 -107 -1 -50 12 -82 b 52 -121 42 -112 46 -117 l -72 -203 b -112 -251 -91 -216 -122 -233 z m 161 -49 b 158 -29 160 -42 158 -35 b 183 33 158 -7 167 16 b 395 137 239 95 311 122 b 420 125 405 134 413 130 z m 276 -128 b 261 -131 271 -130 266 -131 b 181 -86 233 -131 203 -114 l 454 94 l 468 72 b 481 36 477 60 481 49 b 469 1 481 26 477 14 b 276 -128 422 -66 354 -105 z"
                },
                noteheadSlashedBlack1: {
                    x_min: -110,
                    x_max: 452,
                    y_min: -190,
                    y_max: 190,
                    ha: 380,
                    o: "m -131 -274 b -102 -262 -121 -272 -111 -266 b 7 -186 -65 -239 -29 -212 b 50 -157 22 -176 36 -166 b 105 -176 65 -166 84 -173 b 207 -183 140 -181 173 -183 b 239 -184 219 -184 229 -184 b 428 -91 327 -184 377 -150 b 487 43 461 -52 487 -7 b 482 76 487 53 485 65 b 459 128 478 95 469 112 b 507 161 475 138 491 150 l 651 262 b 622 274 641 271 632 274 b 605 271 616 274 611 272 b 514 233 573 262 541 252 l 422 167 b 317 203 392 190 354 203 b 271 196 301 203 285 200 b 168 157 236 186 200 173 b 6 -16 94 120 33 68 b -1 -62 1 -32 -1 -48 b 17 -125 -1 -86 4 -108 b -81 -196 -16 -148 -48 -173 b -145 -242 -102 -212 -128 -219 b -158 -256 -150 -246 -158 -251 b -157 -261 -158 -258 -157 -259 b -131 -274 -153 -269 -141 -274 z"
                },
                noteheadSlashedDoubleWhole2: {
                    x_min: 0,
                    x_max: 697,
                    y_min: -295,
                    y_max: 295,
                    ha: 590,
                    o: "m 870 -338 b 891 -315 884 -341 887 -325 b 906 -183 907 -274 903 -228 b 914 186 912 -60 904 62 b 914 240 914 203 916 222 b 916 276 913 251 916 265 b 899 300 916 289 913 300 b 871 253 874 300 871 274 b 858 -168 871 111 858 -27 b 860 -235 858 -190 860 -213 l 736 -131 b 834 -20 799 -111 834 -69 b 789 85 834 13 819 49 b 683 160 760 118 723 140 b 383 216 589 209 487 215 b 330 213 364 217 347 216 b 228 300 295 242 261 271 b 86 347 184 337 138 348 b 58 343 76 347 63 350 l 58 360 b 35 425 58 384 53 423 b 6 382 9 425 6 403 l 6 131 b 0 -164 6 33 4 -66 b 24 -327 -1 -216 6 -271 b 50 -262 46 -305 50 -284 l 50 -154 b 52 -45 50 -118 50 -81 b 58 325 55 79 58 202 b 73 310 60 320 68 315 b 94 294 79 304 86 298 b 89 271 89 287 89 278 l 89 94 b 104 -194 101 -20 88 -108 b 118 -245 107 -213 104 -248 b 140 -190 140 -243 140 -212 l 140 -62 b 132 258 140 46 138 153 l 132 259 l 235 173 b 193 132 219 161 204 148 b 153 26 167 101 153 63 b 164 -35 153 7 157 -16 b 341 -170 196 -114 261 -158 b 433 -177 372 -174 403 -177 b 619 -157 497 -177 559 -170 l 706 -230 b 799 -276 736 -258 765 -276 b 818 -274 806 -276 812 -276 l 861 -274 b 863 -312 861 -287 863 -300 b 870 -338 864 -321 858 -337 z m 966 -425 b 986 -397 979 -425 982 -408 b 991 -373 989 -390 989 -382 b 995 -239 991 -328 995 -284 b 1004 334 1001 -49 1002 143 b 995 380 1005 350 1005 367 b 982 402 989 386 992 402 l 978 400 b 949 374 965 396 950 390 b 948 333 948 360 948 346 l 948 -37 b 949 -84 949 -52 949 -68 b 946 -248 949 -132 946 -189 b 953 -396 946 -297 948 -346 b 966 -425 955 -408 950 -425 z m 624 -36 b 416 140 554 22 485 81 b 482 156 439 150 461 154 b 625 81 537 156 588 124 b 647 27 639 63 647 46 b 624 -36 647 7 638 -14 z m 469 -117 b 320 14 386 -118 320 -60 b 343 81 320 37 327 60 l 547 -95 b 469 -117 521 -105 494 -111 z"
                },
                noteheadSlashedWhole2: {
                    x_min: -83,
                    x_max: 510,
                    y_min: -201,
                    y_max: 198,
                    ha: 399,
                    o: "m 734 -289 b 696 -245 726 -266 710 -256 b 586 -164 660 -217 622 -192 l 589 -161 b 654 -50 631 -135 654 -94 b 616 40 654 -19 641 13 b 305 174 536 127 420 174 b 171 151 261 174 215 167 b 166 150 170 151 168 150 b 86 209 140 170 112 189 b -94 284 32 249 -22 289 l -108 285 b -120 274 -114 285 -120 284 b -104 251 -120 266 -112 258 b 71 124 -46 209 12 166 l 85 114 b 36 72 66 102 50 89 b 0 -30 12 40 0 4 b 122 -186 0 -96 45 -160 b 343 -222 194 -210 268 -222 b 514 -197 410 -220 467 -213 l 554 -228 b 734 -289 609 -268 668 -275 z m 477 -82 b 268 73 408 -30 338 22 l 301 91 b 336 101 314 96 324 101 b 370 88 347 101 359 96 b 459 9 405 66 436 43 b 481 -56 474 -13 481 -35 b 477 -82 481 -65 480 -73 z m 310 -161 b 216 -143 276 -161 246 -156 b 166 -72 181 -128 166 -105 b 168 -46 166 -65 167 -55 b 206 26 176 -16 189 7 b 436 -140 282 -29 360 -84 b 382 -158 420 -150 402 -157 b 310 -161 357 -161 333 -161 z"
                },
                noteheadSlashedHalf2: {
                    x_min: -73,
                    x_max: 454,
                    y_min: -188,
                    y_max: 188,
                    ha: 376,
                    o: "m 654 -271 b 603 -202 649 -233 625 -217 b 481 -115 563 -173 523 -144 b 564 -60 510 -101 539 -82 b 615 40 596 -33 615 4 b 609 69 615 50 613 60 b 505 167 590 120 554 151 b 336 190 451 184 392 190 b 124 134 259 190 189 171 l -42 248 b -88 271 -56 256 -75 271 b -101 265 -94 271 -98 269 b -105 252 -104 259 -105 255 b -66 210 -105 235 -82 222 l 85 107 b 0 -24 42 73 0 35 b 183 -183 0 -118 75 -184 b 262 -176 206 -180 233 -177 b 438 -135 324 -171 383 -158 b 570 -228 482 -166 527 -197 b 654 -271 595 -243 621 -259 z m 393 -53 l 311 4 l 225 65 b 392 134 274 102 331 122 b 455 50 425 141 455 101 b 439 -3 455 35 451 14 b 393 -53 425 -22 409 -37 z m 287 -121 b 246 -130 272 -127 259 -130 b 171 -89 215 -130 189 -115 b 156 -40 161 -73 156 -58 b 186 29 156 -17 166 7 l 192 35 l 359 -82 b 287 -121 337 -98 312 -111 z"
                },
                noteheadSlashedBlack2: {
                    x_min: -84,
                    x_max: 405,
                    y_min: -189,
                    y_max: 189,
                    ha: 378,
                    o: "m 557 -265 b 573 -272 562 -268 567 -272 b 583 -261 577 -272 580 -269 b 575 -242 580 -253 579 -248 b 524 -190 563 -220 544 -204 b 405 -99 485 -160 445 -130 b 497 50 449 -60 482 -9 b 500 72 498 58 500 65 b 478 122 500 91 492 107 b 331 186 438 167 387 186 b 120 131 258 186 186 167 l 107 124 b -52 242 53 163 1 203 b -89 265 -63 251 -76 259 b -107 272 -95 268 -101 272 b -117 266 -109 272 -114 271 b -121 251 -120 262 -121 256 b -114 235 -121 245 -120 239 b -60 186 -96 217 -81 199 b 63 95 -20 156 22 125 b -1 -35 26 66 -1 27 b 137 -183 -1 -130 46 -183 b 174 -180 148 -183 161 -181 l 245 -171 b 366 -128 289 -166 331 -150 l 426 -171 b 557 -265 469 -203 514 -233 z"
                },
                noteheadDiamondDoubleWhole: {
                    x_min: 0,
                    x_max: 429,
                    y_min: -221,
                    y_max: 221,
                    ha: 442,
                    o: "m 22 -318 b 42 -294 33 -318 37 -302 b 46 -266 45 -285 45 -275 b 50 -219 49 -249 50 -233 b 48 -153 50 -197 49 -176 b 43 120 43 -62 43 29 l 43 253 b 37 298 43 269 45 284 b 26 318 35 305 35 318 l 24 318 b 1 295 13 317 3 308 b 0 268 0 285 0 276 l 0 -121 b 10 -291 0 -177 1 -235 b 22 -318 12 -301 10 -318 z m 593 -312 b 618 -256 611 -294 616 -276 l 618 -186 b 611 253 618 -40 612 108 b 605 276 611 261 608 268 b 589 295 600 284 600 297 b 567 272 577 294 569 285 l 567 251 b 575 -197 573 102 575 -48 b 593 -312 575 -233 579 -271 z m 99 -268 b 114 -256 107 -269 111 -262 b 127 -196 124 -238 125 -217 b 128 -144 128 -179 128 -161 b 122 -9 128 -99 125 -55 l 135 -19 b 344 -179 206 -71 276 -122 b 370 -190 354 -186 363 -190 b 395 -173 379 -190 386 -184 b 492 -33 426 -127 459 -79 b 491 -86 491 -50 491 -68 b 507 -251 491 -138 495 -193 b 534 -184 530 -228 533 -206 b 541 144 537 -75 539 35 b 530 204 541 164 539 186 b 520 220 528 210 528 220 b 500 203 511 219 503 213 b 498 192 498 200 498 194 l 498 176 b 494 7 497 120 497 63 l 490 12 l 287 176 b 258 190 279 181 274 190 b 212 153 239 186 225 168 l 127 40 b 121 32 124 37 122 35 b 118 114 120 59 118 86 b 102 249 117 158 122 206 b 75 219 85 246 79 236 b 72 187 72 209 72 197 b 76 117 72 164 75 141 b 85 -151 79 27 79 -62 b 91 -251 86 -184 91 -217 b 99 -268 91 -258 92 -266 z m 392 -128 b 374 -122 387 -134 380 -127 l 180 29 b 170 45 173 35 170 39 b 176 56 170 48 173 52 b 236 122 204 101 219 122 b 308 76 252 122 272 107 l 433 -26 b 449 -50 439 -32 449 -36 b 392 -128 432 -75 413 -102 z"
                },
                noteheadDiamondWhole: {
                    x_min: 0,
                    x_max: 271,
                    y_min: -132,
                    y_max: 132,
                    ha: 264,
                    o: "m 230 -177 b 256 -190 240 -186 249 -190 b 281 -173 265 -190 272 -184 b 382 -29 314 -124 347 -76 b 390 -10 387 -22 390 -14 b 376 12 390 -3 386 4 b 173 177 308 66 240 121 b 144 190 166 183 160 190 b 98 153 127 186 112 170 b 13 40 69 115 42 76 b 0 13 4 29 0 20 b 22 -19 0 3 7 -9 b 230 -177 92 -69 163 -122 z m 279 -128 b 261 -122 274 -134 266 -127 l 66 30 b 56 45 59 35 56 39 b 62 56 56 48 59 52 b 122 122 91 101 105 122 b 194 76 138 122 158 107 l 320 -26 b 336 -50 325 -32 336 -35 b 279 -128 318 -75 300 -102 z"
                },
                noteheadDiamondHalf: {
                    x_min: 0,
                    x_max: 295,
                    y_min: -148,
                    y_max: 148,
                    ha: 296,
                    o: "m 228 -207 b 245 -213 235 -210 240 -213 b 264 -203 252 -213 258 -210 b 415 -46 314 -150 364 -98 b 425 -27 420 -40 425 -35 b 416 -10 425 -22 422 -16 b 217 200 350 60 284 131 b 194 213 212 207 204 213 b 170 196 181 213 177 203 b 14 33 118 143 68 86 b 0 7 4 23 0 16 b 17 -20 0 -1 6 -10 b 118 -114 52 -50 82 -85 b 228 -207 156 -144 184 -184 z m 209 -157 b 134 -69 177 -138 141 -115 b 130 -26 131 -55 130 -40 b 215 148 130 42 160 99 b 225 156 217 151 220 156 b 230 153 226 156 228 156 b 323 -26 276 104 321 55 b 298 -75 324 -42 315 -59 b 265 -109 287 -86 276 -99 b 209 -157 245 -125 228 -167 z"
                },
                noteheadDiamondBlack: {
                    x_min: 0,
                    x_max: 310,
                    y_min: -146,
                    y_max: 146,
                    ha: 292,
                    o: "m 266 -210 b 289 -194 278 -209 284 -200 b 406 -76 330 -156 367 -115 b 446 -23 433 -49 446 -36 b 412 29 446 -10 435 3 b 405 36 409 30 408 33 b 252 196 354 89 304 143 b 225 210 243 204 235 210 b 204 202 219 210 212 209 b 10 24 141 141 75 82 b 0 9 4 19 0 14 b 9 -6 0 4 3 0 l 232 -192 b 266 -210 242 -200 256 -204 z"
                },
                noteheadParenthesis: {
                    x_min: -70,
                    x_max: 329,
                    y_min: -196,
                    y_max: 201,
                    ha: 397,
                    o: "m 344 -279 b 382 -262 361 -288 370 -272 b 405 -233 390 -255 399 -245 b 474 9 455 -158 468 -73 b 416 228 474 78 448 174 b 364 282 403 249 387 271 b 344 289 359 285 350 288 b 331 279 338 289 333 287 b 325 248 328 269 325 258 b 338 225 325 238 328 229 b 412 138 379 207 396 174 b 445 1 433 92 445 45 b 346 -217 445 -81 410 -154 b 336 -252 340 -223 336 -238 b 344 -279 336 -265 338 -276 z m 19 -274 b 35 -282 24 -279 30 -281 b 49 -265 42 -282 46 -275 b 52 -243 50 -256 52 -249 b 36 -210 52 -230 49 -220 b -60 -59 -16 -173 -35 -114 b -73 9 -69 -39 -73 -16 b 33 223 -73 92 -24 189 b 50 265 43 229 50 249 b 33 288 50 278 46 289 b 4 272 23 288 14 275 b -9 261 0 269 -4 265 b -101 23 -58 193 -105 124 b -37 -206 -104 -52 -75 -130 b 19 -274 -23 -232 -6 -255 z"
                },
                noteheadParenthesisRight: {
                    x_min: -30,
                    x_max: 82,
                    y_min: -199,
                    y_max: 206,
                    ha: 405,
                    o: "m -17 -282 b 24 -264 -6 -297 12 -272 b 60 -219 40 -253 52 -236 b 117 1 96 -150 112 -75 b 118 16 118 6 118 12 b 109 73 118 36 112 55 b 4 279 99 154 68 226 b -23 297 -4 287 -13 297 b -37 289 -27 297 -32 294 b -43 266 -42 285 -43 276 b -32 225 -43 251 -37 229 b 84 -7 48 170 84 82 b 32 -184 84 -69 65 -132 b -10 -222 22 -200 4 -209 b -24 -258 -20 -232 -24 -245 b -17 -282 -24 -266 -22 -276 z"
                },
                noteheadParenthesisLeft: {
                    x_min: 0,
                    x_max: 106,
                    y_min: -197,
                    y_max: 197,
                    ha: 394,
                    o: "m 134 -284 b 138 -281 135 -284 137 -284 b 145 -268 144 -278 145 -274 l 144 -253 b 107 -180 138 -225 121 -204 b 42 13 71 -120 42 -56 b 49 73 42 32 43 52 b 137 210 62 128 95 171 b 153 255 147 219 153 239 b 145 278 153 265 151 274 b 130 284 140 281 135 284 b 98 259 117 284 108 268 b 0 37 35 203 1 131 b 118 -268 9 -69 53 -173 b 134 -284 121 -274 127 -284 z"
                },
                noteheadMoonBlack: {
                    x_min: 0,
                    x_max: 328,
                    y_min: -125,
                    y_max: 125,
                    ha: 250,
                    o: "m 353 -160 b 465 -40 412 -140 451 -102 b 472 30 471 -17 472 6 b 469 124 472 60 469 92 b 406 179 469 170 459 177 l 128 179 b 37 180 98 179 68 179 b 0 141 7 180 0 170 b 3 -20 3 88 3 33 b 69 -134 3 -72 26 -109 b 240 -180 125 -164 181 -180 b 353 -160 278 -180 315 -174 z"
                },
                noteheadTriangleLeftBlack: {
                    x_min: 0,
                    x_max: 391,
                    y_min: -142,
                    y_max: 142,
                    ha: 284,
                    o: "m 138 -204 b 318 -197 197 -199 258 -197 l 431 -197 b 544 -192 469 -196 507 -193 b 563 -184 552 -190 560 -193 b 553 -167 564 -177 559 -171 l 540 -157 b 232 60 436 -85 334 -12 l 50 190 b 20 204 42 197 32 204 b 10 202 17 204 14 204 b 0 184 1 197 0 192 b 1 164 0 177 1 170 b 6 -150 3 59 6 -45 b 39 -193 7 -176 17 -186 b 138 -204 72 -204 105 -204 z"
                },
                noteheadTriangleRightBlack: {
                    x_min: 0,
                    x_max: 398,
                    y_min: -139,
                    y_max: 140,
                    ha: 279,
                    o: "m 543 -200 b 573 -176 566 -200 573 -194 l 573 -168 b 554 141 566 -66 560 37 b 520 197 553 167 546 187 b 495 202 511 200 504 202 b 454 184 481 202 467 196 l 35 -137 b 0 -171 22 -147 -4 -154 b 52 -199 6 -193 33 -193 b 69 -199 58 -200 63 -199 z"
                },
                noteheadTriangleRoundDownBlack: {
                    x_min: 0,
                    x_max: 334,
                    y_min: -134,
                    y_max: 136,
                    ha: 270,
                    o: "m 252 -192 b 285 -176 269 -196 276 -187 b 468 52 346 -99 406 -23 b 481 79 477 62 481 71 b 465 104 481 88 475 95 b 441 124 456 109 449 117 b 249 196 380 174 314 194 b 13 104 157 196 69 154 b 0 86 6 98 0 92 b 7 69 0 82 3 76 b 202 -164 73 -7 137 -85 b 252 -192 216 -181 235 -186 z"
                },
                augmentationDot: {
                    x_min: 0,
                    x_max: 96,
                    y_min: -57,
                    y_max: 57,
                    ha: 114,
                    o: "m 13 -82 b 16 -81 14 -82 14 -82 b 105 -73 46 -76 75 -76 b 131 -48 121 -72 131 -60 b 138 26 134 -24 138 0 b 137 48 138 33 138 40 b 108 82 134 71 125 82 b 95 81 104 82 99 82 b 33 71 75 78 53 75 b 4 46 20 68 6 62 b 0 -66 1 9 0 -29 b 13 -82 0 -73 1 -82 z"
                },
                tremolo1: {
                    x_min: -158,
                    x_max: 156,
                    y_min: -88,
                    y_max: 88,
                    ha: 176,
                    o: "m -206 -127 b -194 -125 -203 -127 -199 -127 b 173 -36 -72 -94 50 -65 b 220 16 202 -29 215 -12 b 225 50 223 30 225 45 b 216 107 226 76 222 91 b 194 127 210 120 204 127 b 183 124 192 127 189 127 l -192 33 b -226 -9 -213 27 -222 14 b -228 -32 -226 -16 -228 -23 b -222 -108 -228 -58 -222 -82 b -206 -127 -222 -120 -217 -127 z"
                },
                flag8thUp: {
                    x_min: 0,
                    x_max: 261,
                    y_min: -819,
                    y_max: 0,
                    ha: 819,
                    o: "m 265 -1171 b 351 -1035 301 -1130 336 -1087 b 376 -867 369 -979 376 -923 b 367 -755 376 -829 373 -792 b 233 -422 350 -632 311 -520 b 131 -291 199 -379 166 -334 b 65 -125 91 -239 66 -192 b 62 -75 65 -112 62 -91 b 42 0 62 -49 52 -24 l 35 0 b 0 -63 6 -13 0 -36 l 0 -144 b 96 -445 0 -255 29 -356 b 177 -547 124 -478 150 -514 b 308 -831 246 -629 298 -721 b 317 -890 310 -851 317 -871 b 311 -919 317 -900 315 -910 b 256 -1005 297 -950 282 -984 b 228 -1068 233 -1024 228 -1045 b 230 -1106 228 -1080 229 -1093 b 240 -1162 232 -1125 239 -1143 b 251 -1179 242 -1174 246 -1179 b 265 -1171 255 -1179 259 -1176 z"
                },
                flag8thDown: {
                    x_min: 0,
                    x_max: 261,
                    y_min: 0,
                    y_max: 819,
                    ha: 819,
                    o: "m 265 1171 b 251 1179 259 1176 255 1179 b 240 1162 246 1179 242 1174 b 230 1106 239 1143 232 1125 b 228 1068 229 1093 228 1080 b 256 1005 228 1045 233 1024 b 311 919 282 984 297 950 b 317 890 315 910 317 900 b 308 831 317 871 310 851 b 177 547 298 721 246 629 b 96 445 150 514 124 478 b 0 144 29 356 0 255 l 0 63 b 35 0 0 36 6 13 l 42 0 b 62 75 52 24 62 49 b 59 117 62 91 59 104 b 131 291 60 183 91 239 b 233 422 166 334 199 379 b 367 755 311 520 350 632 b 376 867 373 792 376 829 b 351 1035 376 923 369 979 b 265 1171 336 1087 301 1130 z"
                },
                flag16thUp: {
                    x_min: 0,
                    x_max: 327,
                    y_min: -819,
                    y_max: 0,
                    ha: 819,
                    o: "m 415 -1179 b 435 -1168 423 -1182 429 -1174 b 451 -1138 442 -1159 446 -1149 b 465 -1020 464 -1102 467 -1064 b 461 -962 464 -1004 464 -984 b 471 -821 467 -916 472 -870 b 465 -721 472 -791 467 -756 b 415 -520 459 -651 441 -585 b 200 -245 370 -408 284 -327 b 96 -114 160 -206 118 -168 b 75 -24 84 -85 85 -53 b 59 0 72 -16 72 0 b 53 -1 58 0 56 -1 b 27 -32 40 -6 27 -10 b 29 -68 27 -43 29 -55 b 10 -79 20 -69 13 -72 b 1 -109 6 -89 1 -99 b 0 -170 0 -130 0 -148 b 35 -410 0 -252 12 -333 b 258 -793 76 -557 156 -681 b 409 -1158 350 -896 410 -1014 b 415 -1179 409 -1165 405 -1175 z m 413 -816 b 331 -681 392 -769 364 -723 b 145 -420 266 -596 189 -521 b 86 -281 125 -374 102 -330 b 156 -370 105 -312 128 -343 b 318 -539 210 -425 269 -478 b 413 -816 383 -621 420 -713 z"
                },
                flag16thDown: {
                    x_min: 0,
                    x_max: 327,
                    y_min: 0,
                    y_max: 819,
                    ha: 819,
                    o: "m 59 0 b 75 24 72 0 72 16 b 96 114 85 53 84 85 b 200 245 118 168 160 206 b 415 520 284 327 370 408 b 465 721 441 585 459 651 b 471 821 467 756 472 791 b 461 962 472 870 467 916 b 465 1020 464 984 464 1004 b 451 1138 467 1064 464 1102 b 435 1168 446 1149 442 1159 b 418 1179 431 1172 425 1179 l 415 1179 b 408 1169 409 1176 408 1174 b 409 1158 408 1165 409 1161 b 258 793 410 1014 350 896 b 35 410 156 681 76 557 b 0 170 12 333 0 252 l 0 88 b 29 7 0 71 6 23 b 59 0 33 4 58 0 z m 86 281 b 145 420 102 330 125 374 b 331 681 189 521 266 596 b 413 816 364 723 392 769 b 415 791 413 808 415 799 b 318 539 415 698 377 613 b 156 370 269 478 210 425 b 86 281 128 343 105 312 z"
                },
                flag32ndUp: {
                    x_min: 0,
                    x_max: 268,
                    y_min: -849,
                    y_max: 149,
                    ha: 999,
                    o: "m 323 -1223 b 351 -1198 337 -1227 344 -1210 b 359 -1184 354 -1194 356 -1188 b 386 -999 377 -1122 387 -1060 b 341 -783 386 -927 372 -855 b 330 -736 334 -769 330 -753 b 333 -708 330 -727 330 -717 b 344 -621 340 -678 344 -649 b 341 -579 344 -608 343 -593 b 328 -500 338 -553 328 -526 b 331 -475 328 -491 328 -484 b 347 -370 343 -438 348 -402 b 151 27 348 -212 288 -56 b 53 176 98 59 50 102 b 45 197 53 183 48 192 b 33 215 40 203 40 216 l 30 215 b 6 194 22 212 9 209 b 0 120 3 170 -1 145 b 0 -43 4 65 0 13 b 0 -98 0 -60 1 -79 b 4 -276 0 -157 6 -216 b 7 -456 4 -337 7 -397 b 66 -638 7 -523 22 -585 b 158 -724 94 -671 127 -697 b 318 -1011 246 -801 295 -899 b 321 -1044 321 -1021 321 -1032 b 312 -1152 321 -1080 312 -1116 b 317 -1192 312 -1165 314 -1179 b 323 -1223 320 -1202 311 -1220 z m 285 -376 b 121 -180 249 -289 173 -245 b 91 -105 104 -158 92 -135 b 288 -354 181 -144 288 -269 b 285 -376 288 -363 287 -370 z m 275 -657 b 111 -492 226 -589 163 -547 b 65 -376 78 -456 66 -418 b 71 -323 65 -360 68 -341 b 275 -657 164 -418 265 -504 z"
                },
                flag32ndDown: {
                    x_min: -3,
                    x_max: 268,
                    y_min: -169,
                    y_max: 829,
                    ha: 999,
                    o: "m 323 1194 b 317 1164 311 1191 320 1174 b 312 1123 314 1151 312 1136 b 321 1015 312 1087 321 1051 b 318 982 321 1004 321 992 b 158 696 295 870 246 772 b 66 609 127 668 94 642 b 7 428 22 556 7 494 b 4 248 7 369 4 308 b -1 78 6 187 -10 137 b 0 14 0 59 0 32 l 0 -148 b 6 -223 0 -174 3 -199 b 30 -243 9 -238 22 -240 l 33 -243 b 45 -226 40 -245 40 -232 b 53 -204 48 -220 53 -212 b 151 -56 50 -131 98 -88 b 347 341 288 27 348 183 b 331 446 348 373 343 409 b 328 471 328 455 328 462 b 341 550 328 497 338 524 b 344 592 343 564 344 579 b 333 680 344 621 340 649 b 330 707 330 688 330 698 b 341 755 330 724 334 740 b 386 971 372 827 386 899 b 359 1155 387 1031 377 1093 b 351 1169 356 1159 354 1165 b 323 1194 344 1181 337 1198 z m 275 628 b 71 294 265 475 164 389 b 65 347 68 312 65 331 b 111 464 66 389 78 428 b 275 628 163 518 226 560 z m 285 347 b 288 325 287 341 288 334 b 91 76 288 240 181 115 b 121 151 92 107 104 130 b 285 347 173 216 249 261 z"
                },
                flag64thUp: {
                    x_min: -4,
                    x_max: 282,
                    y_min: -824,
                    y_max: 347,
                    ha: 1171,
                    o: "m 350 -1185 b 380 -1162 364 -1189 374 -1175 b 406 -1022 399 -1119 406 -1071 b 359 -798 406 -945 384 -871 b 348 -756 353 -785 348 -772 b 350 -744 348 -753 350 -749 b 363 -621 356 -704 363 -664 b 360 -580 363 -608 363 -593 b 359 -560 359 -573 359 -567 b 373 -490 359 -536 366 -513 b 393 -346 386 -444 393 -395 b 387 -269 393 -320 390 -294 b 348 -127 382 -219 348 -173 b 351 -104 348 -120 348 -111 b 353 -65 351 -91 353 -78 b 341 37 353 -26 348 6 b 226 215 323 108 278 164 b 86 336 181 258 127 288 b 62 395 72 353 62 370 b 42 481 62 423 55 454 b 27 500 37 488 36 500 b 24 498 26 500 26 500 b -1 480 14 497 1 492 b -6 444 -4 467 -6 455 l -6 435 b -1 341 -1 403 -1 372 l -1 266 b 6 156 -1 230 0 193 b 13 35 12 117 13 75 l 13 -35 b 14 -85 13 -52 14 -68 b 29 -276 19 -150 33 -213 b 20 -448 24 -334 20 -392 b 24 -534 20 -477 22 -505 b 114 -708 30 -605 59 -664 b 197 -780 143 -732 171 -755 b 344 -1153 301 -884 341 -1011 b 343 -1172 344 -1159 343 -1166 b 350 -1185 343 -1176 344 -1182 z m 287 -88 b 62 193 186 -17 79 48 b 229 52 121 144 174 98 b 289 -33 256 29 274 -3 b 295 -56 294 -42 295 -49 b 287 -88 295 -66 292 -76 z m 298 -410 b 118 -235 238 -351 176 -295 b 76 -88 82 -197 78 -147 b 268 -252 137 -153 203 -202 b 330 -360 304 -279 330 -315 b 323 -402 330 -373 327 -387 b 311 -418 318 -413 315 -418 b 298 -410 307 -418 302 -415 z m 300 -691 b 117 -508 243 -616 168 -575 b 82 -408 94 -480 82 -448 b 84 -379 82 -397 82 -387 b 259 -553 135 -451 206 -492 b 301 -667 287 -583 301 -619 b 300 -691 301 -674 301 -683 z"
                },
                flag64thDown: {
                    x_min: -5,
                    x_max: 281,
                    y_min: -375,
                    y_max: 796,
                    ha: 1171,
                    o: "m 348 1145 b 341 1132 343 1142 341 1136 b 343 1113 341 1126 343 1119 b 196 740 340 971 300 844 b 112 668 170 714 141 691 b 23 494 58 624 29 564 b 19 408 20 465 19 436 b 27 236 19 351 23 294 b 13 45 32 173 17 109 b 12 -6 13 27 12 12 l 12 -75 b 4 -196 12 -115 10 -157 b -3 -307 -1 -233 -3 -271 l -3 -382 b -7 -475 -3 -412 -3 -444 l -7 -484 b -3 -520 -7 -495 -6 -507 b 23 -539 0 -533 13 -537 b 26 -540 24 -540 24 -540 b 40 -521 35 -540 36 -528 b 60 -435 53 -494 60 -464 b 85 -376 60 -410 71 -393 b 225 -255 125 -328 180 -298 b 340 -78 276 -204 321 -148 b 351 24 347 -46 351 -14 b 350 63 351 37 350 50 b 347 86 347 71 347 79 b 386 229 347 132 380 179 b 392 305 389 253 392 279 b 372 449 392 354 384 403 b 357 520 364 472 357 495 b 359 540 357 527 357 533 b 361 580 361 553 361 567 b 348 704 361 624 354 664 b 347 716 348 708 347 713 b 357 757 347 732 351 744 b 405 982 383 831 405 904 b 379 1122 405 1031 397 1079 b 348 1145 373 1135 363 1149 z m 298 651 b 300 626 300 642 300 634 b 258 513 300 579 285 543 b 82 338 204 452 134 410 b 81 367 81 347 81 357 b 115 468 81 408 92 439 b 298 651 167 534 242 576 z m 297 370 b 310 377 301 374 305 377 b 321 361 314 377 317 373 b 328 320 325 347 328 333 b 266 212 328 275 302 239 b 75 48 202 161 135 112 b 117 194 76 107 81 157 b 297 370 174 255 236 311 z m 285 48 b 294 16 291 36 294 26 b 288 -7 294 9 292 1 b 228 -92 272 -37 255 -69 b 60 -233 173 -138 120 -184 b 285 48 78 -88 184 -23 z"
                },
                flag128thUp: {
                    x_min: 0,
                    x_max: 252,
                    y_min: -804,
                    y_max: 530,
                    ha: 1334,
                    o: "m 298 -1158 b 328 -1126 312 -1158 320 -1139 b 330 -1116 330 -1123 330 -1119 b 347 -996 343 -1076 347 -1037 b 328 -837 347 -943 338 -890 b 320 -778 324 -816 320 -798 b 330 -733 320 -763 323 -749 b 340 -665 338 -714 337 -688 b 341 -645 340 -660 341 -652 b 333 -534 341 -609 333 -572 b 343 -471 333 -513 334 -492 b 361 -366 356 -436 361 -402 b 331 -202 361 -311 348 -256 b 328 -187 330 -197 328 -193 b 331 -179 328 -184 328 -181 b 363 -55 353 -137 363 -96 b 337 79 363 -12 351 33 b 327 114 333 92 327 104 b 344 144 327 124 331 132 b 359 174 353 150 357 163 b 361 228 360 193 361 210 b 243 517 361 337 325 435 b 147 596 213 546 179 569 b 75 708 111 626 75 655 b 62 744 75 723 68 733 b 50 763 58 752 58 763 b 46 762 49 763 48 762 b 17 742 36 757 22 757 b 0 697 14 726 0 711 b 1 595 0 662 3 631 b 0 469 0 552 0 511 b 1 429 0 456 0 442 b 22 289 6 382 22 337 b 24 128 22 238 24 184 b 22 66 24 108 23 86 b 19 -19 20 37 19 10 b 20 -132 19 -56 20 -95 b 13 -276 20 -180 19 -229 b 9 -359 10 -304 9 -330 b 12 -487 9 -402 12 -445 b 56 -582 12 -526 29 -554 b 197 -742 107 -632 160 -681 b 288 -1100 265 -851 276 -976 b 288 -1122 288 -1107 287 -1115 b 287 -1145 289 -1129 287 -1138 b 298 -1158 287 -1153 288 -1158 z m 304 150 b 75 475 229 256 112 334 b 304 150 233 357 305 287 z m 271 -73 b 127 72 233 -14 179 26 b 81 167 96 98 81 127 b 84 194 81 176 82 184 b 271 -73 148 102 242 39 z m 279 -396 b 132 -223 233 -330 180 -279 b 81 -112 104 -192 81 -156 b 82 -91 81 -105 81 -98 b 279 -396 167 -125 269 -281 z m 249 -609 b 69 -357 197 -520 88 -471 b 249 -609 131 -441 229 -498 z"
                },
                flag128thDown: {
                    x_min: -1,
                    x_max: 252,
                    y_min: -580,
                    y_max: 754,
                    ha: 1334,
                    o: "m 298 1086 b 287 1073 288 1086 287 1081 b 288 1050 287 1066 289 1057 b 288 1028 287 1043 288 1035 b 197 670 276 904 265 779 b 56 510 160 609 107 560 b 12 415 29 482 12 454 b 9 287 12 373 9 330 b 13 204 9 258 10 232 b 20 60 19 157 20 108 b 19 -53 20 23 19 -16 b 22 -138 19 -82 20 -109 b 24 -200 23 -158 24 -180 b 22 -361 24 -256 22 -310 b 1 -501 22 -409 6 -454 b 0 -541 0 -514 0 -528 b 0 -667 0 -583 -3 -624 b 0 -809 0 -675 -3 -791 b 46 -834 4 -825 36 -829 b 50 -835 48 -834 49 -835 b 62 -816 58 -835 58 -824 b 75 -780 68 -805 75 -795 b 147 -668 75 -727 111 -698 b 243 -589 179 -641 213 -618 b 361 -300 325 -507 361 -409 b 359 -246 361 -282 360 -265 b 344 -216 357 -235 353 -222 b 327 -186 331 -204 327 -196 b 337 -151 327 -176 333 -164 b 363 -17 351 -105 363 -60 b 331 107 363 24 353 65 b 328 115 328 109 328 112 b 331 130 328 121 330 125 b 361 294 348 184 361 239 b 343 399 361 330 356 364 b 333 462 334 420 333 441 b 341 573 333 500 341 537 b 340 593 341 580 340 588 b 330 661 337 616 338 642 b 320 706 323 677 320 691 b 328 765 320 726 324 744 b 347 924 338 818 347 871 b 330 1044 347 965 343 1004 b 328 1054 330 1047 330 1051 b 298 1086 320 1067 312 1086 z m 249 537 b 69 285 229 426 131 369 b 249 537 88 399 197 448 z m 279 324 b 82 19 269 209 167 53 b 81 40 81 26 81 33 b 132 151 81 84 104 120 b 279 324 180 207 233 258 z m 271 1 b 84 -266 242 -111 148 -174 b 81 -239 82 -256 81 -248 b 127 -144 81 -199 96 -170 b 271 1 179 -98 233 -58 z m 304 -222 b 75 -547 305 -359 233 -429 b 304 -222 112 -406 229 -328 z"
                },
                accidentalFlat: {
                    x_min: 1,
                    x_max: 209,
                    y_min: -208,
                    y_max: 472,
                    ha: 680,
                    o: "m 29 -300 b 46 -289 33 -300 39 -297 b 107 -243 65 -274 86 -258 b 301 127 233 -153 301 -30 b 298 186 301 147 301 166 b 190 297 291 256 251 297 b 147 289 177 297 163 294 b 86 265 127 284 107 274 l 85 264 l 85 301 b 91 465 85 356 88 410 b 94 559 91 497 94 527 b 84 651 94 589 91 621 b 66 680 81 661 81 680 l 65 680 b 37 645 49 678 37 665 b 33 523 36 605 32 563 l 33 478 b 26 223 33 393 29 308 b 1 -141 22 101 1 -19 b 17 -287 1 -189 4 -239 b 29 -300 20 -295 23 -300 z m 68 -105 b 76 12 71 -68 72 -29 b 81 107 79 43 81 75 l 86 109 b 171 135 114 121 141 135 b 204 128 181 135 193 132 b 238 92 228 120 239 108 b 230 63 238 84 236 75 b 68 -105 193 -10 132 -59 z"
                },
                accidentalNatural: {
                    x_min: 0,
                    x_max: 214,
                    y_min: -456,
                    y_max: 462,
                    ha: 918,
                    o: "m 255 -657 b 281 -624 271 -657 275 -636 b 285 -599 282 -615 285 -608 b 292 -300 288 -500 289 -400 b 289 -161 292 -253 289 -207 b 300 128 292 -65 297 32 b 304 168 300 128 302 150 l 304 173 l 305 190 l 305 199 l 307 225 b 304 259 307 229 310 246 b 272 298 297 274 302 305 b 63 266 204 279 134 272 b 72 514 68 348 72 432 b 71 595 72 541 72 567 b 56 665 71 619 66 642 b 17 579 9 651 17 608 b 3 144 19 433 7 289 b 0 -7 1 94 0 43 b 3 -134 0 -50 1 -92 b 7 -219 3 -163 7 -192 b 35 -251 7 -243 17 -251 b 49 -249 39 -251 43 -251 l 223 -223 l 230 -222 l 230 -359 b 223 -516 230 -410 223 -464 b 236 -619 223 -550 226 -585 b 255 -657 240 -634 236 -657 z m 58 -63 b 55 81 56 -14 53 33 l 56 99 b 85 99 65 99 75 98 b 232 108 134 104 183 107 l 240 109 l 236 66 b 232 -48 235 29 232 -10 b 58 -81 174 -63 115 -73 z"
                },
                accidentalSharp: {
                    x_min: -22,
                    x_max: 390,
                    y_min: -384,
                    y_max: 383,
                    ha: 767,
                    o: "m 202 -553 b 219 -526 213 -552 216 -536 b 226 -471 225 -507 226 -488 b 225 -425 226 -455 225 -441 b 226 -392 225 -415 225 -402 b 233 -305 229 -363 232 -334 l 297 -292 b 331 -469 300 -353 311 -412 b 347 -485 333 -477 338 -485 b 363 -469 356 -487 359 -477 b 374 -418 373 -454 374 -435 b 376 -382 376 -405 376 -393 b 372 -276 376 -347 373 -311 l 455 -259 b 550 -156 534 -243 544 -232 b 550 -109 550 -137 552 -124 b 526 -78 549 -91 541 -78 l 523 -78 b 507 -79 517 -78 513 -78 b 403 -101 474 -88 438 -95 l 379 -105 b 382 -42 380 -85 380 -63 b 384 96 383 4 384 50 b 503 131 425 107 464 118 b 549 173 524 138 543 150 b 562 249 554 199 562 223 b 554 294 562 264 560 279 b 536 315 549 308 544 315 l 533 315 b 517 312 528 315 523 315 b 382 266 472 294 428 279 l 377 344 b 359 531 374 406 372 469 b 348 552 356 539 357 552 l 347 552 l 343 552 b 315 528 331 549 317 544 l 315 501 b 320 249 315 416 318 333 l 243 232 b 239 361 243 275 242 318 b 226 425 238 383 238 403 b 199 359 194 409 199 382 b 193 223 196 312 194 268 b 72 202 153 215 112 209 b 4 118 13 192 4 183 b 10 66 0 102 12 84 b 33 29 7 39 14 30 b 48 32 37 29 42 30 b 187 55 95 39 141 46 l 183 -75 b 176 -145 181 -99 179 -122 b 16 -179 122 -156 69 -166 b -32 -232 -14 -186 -32 -197 b -17 -331 -32 -266 -19 -298 b -1 -356 -17 -347 -13 -354 b 12 -353 1 -356 6 -354 b 167 -320 63 -341 115 -331 b 166 -377 166 -338 166 -357 b 189 -526 166 -428 171 -477 b 202 -553 192 -536 189 -553 z m 240 -132 b 243 -37 242 -101 242 -69 b 245 65 245 -3 245 30 b 315 79 269 69 292 73 b 301 -120 308 13 305 -53 z"
                },
                accidentalDoubleSharp: {
                    x_min: 0,
                    x_max: 287,
                    y_min: -159,
                    y_max: 159,
                    ha: 318,
                    o: "m 84 -229 b 107 -216 91 -229 98 -225 b 200 -125 138 -186 167 -154 b 232 -95 212 -115 222 -105 b 347 -189 271 -125 310 -157 b 370 -200 356 -196 363 -200 b 396 -179 380 -200 389 -192 b 412 -102 410 -154 406 -125 b 377 -27 410 -69 400 -46 l 325 14 b 402 91 350 42 374 68 b 413 127 410 96 413 107 b 382 200 409 148 397 176 b 350 229 370 220 360 229 b 314 210 340 229 328 223 b 274 174 300 199 285 187 b 212 104 252 151 232 128 b 92 187 173 132 132 161 b 78 193 86 192 82 193 b 68 190 75 193 72 193 b 48 179 62 186 53 187 b 40 137 43 168 40 154 b 81 16 40 92 56 32 b 107 -3 89 10 98 4 b 14 -94 76 -32 45 -62 b 0 -124 6 -102 0 -114 b 12 -154 0 -134 3 -144 b 62 -215 26 -176 48 -193 b 84 -229 69 -225 76 -229 z"
                },
                accidentalDoubleFlat: {
                    x_min: 0,
                    x_max: 359,
                    y_min: -220,
                    y_max: 446,
                    ha: 666,
                    o: "m 43 -317 b 72 -301 55 -317 63 -310 b 160 -186 108 -268 134 -226 b 236 -60 186 -145 212 -102 b 233 -131 235 -85 233 -108 b 239 -220 233 -161 235 -190 b 259 -246 240 -233 239 -240 b 301 -228 284 -252 291 -238 b 465 -7 369 -163 416 -85 b 517 173 500 48 517 108 b 451 307 517 229 505 284 b 409 315 436 312 422 315 b 331 287 382 315 356 305 b 311 274 324 282 320 274 l 310 274 l 310 566 b 305 621 310 585 312 603 b 294 642 301 628 305 642 l 292 642 b 264 622 282 641 266 636 b 253 575 259 606 256 590 b 246 418 248 523 246 471 b 248 243 246 360 248 302 l 248 187 b 164 238 220 225 193 238 b 85 213 140 238 112 226 b 84 229 85 220 84 225 b 86 315 85 258 86 287 b 81 528 86 386 82 458 b 71 582 81 547 78 566 b 56 603 66 590 68 603 l 53 603 b 23 580 40 600 26 598 b 19 537 20 566 19 552 b 20 514 19 530 19 521 b 26 390 24 472 26 432 b 14 66 26 282 16 174 b 0 -168 13 -12 0 -91 b 12 -279 0 -206 3 -242 b 30 -314 16 -294 14 -308 b 43 -317 35 -317 39 -317 z m 301 -72 b 302 7 302 -45 302 -19 l 302 86 b 351 158 304 121 321 145 b 383 166 361 163 373 166 b 435 143 402 166 419 157 b 445 127 441 138 445 132 b 441 114 445 122 444 118 b 301 -72 397 49 354 -14 z m 75 -147 b 73 30 75 -86 75 -29 b 118 82 73 62 92 76 b 132 84 124 84 128 84 b 190 52 156 84 174 69 b 193 40 192 49 193 45 b 192 33 193 37 193 35 b 75 -147 157 -30 125 -95 z"
                },
                accidentalParensLeft: {
                    x_min: 0,
                    x_max: 130,
                    y_min: -270,
                    y_max: 268,
                    ha: 538,
                    o: "m 107 -389 b 127 -374 114 -389 120 -384 b 141 -347 132 -367 137 -357 b 151 -294 148 -330 151 -311 b 122 -207 151 -265 141 -236 b 63 -65 94 -164 72 -117 b 59 -10 60 -46 59 -27 b 145 223 59 78 94 153 b 187 354 176 262 189 305 b 177 384 187 364 190 380 b 143 373 166 387 153 383 b 124 354 137 367 130 361 b 0 -35 33 240 0 108 l 0 -92 b 85 -372 4 -193 27 -287 b 107 -389 92 -383 99 -389 z"
                },
                accidentalParensRight: {
                    x_min: 0,
                    x_max: 139,
                    y_min: -275,
                    y_max: 277,
                    ha: 552,
                    o: "m 58 -396 b 96 -354 75 -396 85 -370 b 200 13 168 -238 200 -111 b 153 268 200 109 184 190 b 49 392 131 320 101 364 b 26 399 40 397 33 399 b 0 366 10 399 0 387 b 0 318 -1 350 0 334 l 0 291 b 27 238 -3 266 7 253 b 143 9 105 180 143 98 b 141 -20 143 -1 143 -10 b 63 -225 135 -92 108 -164 b 36 -307 45 -251 36 -278 b 40 -344 36 -320 37 -331 b 42 -356 42 -347 42 -351 b 58 -396 42 -374 37 -396 z"
                },
                accidentalQuarterToneFlatStein: {
                    x_min: 0,
                    x_max: 208,
                    y_min: -240,
                    y_max: 440,
                    ha: 680,
                    o: "m 272 -346 b 284 -333 278 -346 281 -341 b 300 -187 297 -285 300 -235 b 275 177 300 -65 279 55 b 268 432 272 262 268 347 l 268 477 b 264 599 269 517 265 559 b 236 634 264 619 252 632 l 235 634 b 217 605 220 634 220 615 b 207 513 210 575 207 543 b 210 419 207 481 210 451 b 216 255 213 364 216 310 l 216 217 l 215 219 b 154 243 194 228 174 238 b 111 251 138 248 124 251 b 3 140 50 251 10 210 b 0 81 0 120 0 101 b 194 -289 0 -76 68 -199 b 255 -336 215 -304 236 -320 b 272 -346 262 -343 268 -346 z m 233 -151 b 71 17 168 -105 108 -56 b 63 46 65 29 63 37 b 96 82 62 62 73 73 b 130 89 108 86 120 89 b 215 63 160 89 187 75 l 220 60 b 225 -35 220 29 222 -3 b 233 -151 229 -75 230 -114 z"
                },
                accidentalThreeQuarterTonesFlatZimmermann: {
                    x_min: 0,
                    x_max: 422,
                    y_min: -240,
                    y_max: 440,
                    ha: 680,
                    o: "m 272 -346 b 284 -333 278 -346 281 -341 b 300 -187 297 -285 300 -235 b 275 177 300 -65 279 55 b 268 432 272 262 268 347 l 268 477 b 264 599 269 517 265 559 b 236 634 264 619 252 632 l 235 634 b 217 605 220 634 220 615 b 207 513 210 575 207 543 b 210 419 207 481 210 451 b 216 255 213 364 216 310 l 216 217 l 215 219 b 154 243 194 228 174 238 b 111 251 138 248 124 251 b 3 140 50 251 10 210 b 0 81 0 120 0 101 b 194 -289 0 -76 68 -199 b 255 -336 215 -304 236 -320 b 272 -346 262 -343 268 -346 z m 336 -346 b 353 -336 340 -346 346 -343 b 413 -289 372 -320 393 -304 b 608 81 540 -199 608 -76 b 605 140 608 101 608 120 b 497 251 598 210 557 251 b 454 243 484 251 469 248 b 393 219 433 238 413 228 l 392 217 l 392 255 b 397 419 392 310 395 364 b 400 513 397 451 400 481 b 390 605 400 543 397 575 b 373 634 387 615 387 634 l 372 634 b 344 599 356 632 344 619 b 340 477 343 559 338 517 l 340 432 b 333 177 340 347 336 262 b 308 -187 328 55 308 -65 b 324 -333 308 -235 311 -285 b 336 -346 327 -341 330 -346 z m 233 -151 b 71 17 168 -105 108 -56 b 63 46 65 29 63 37 b 96 82 62 62 73 73 b 130 89 108 86 120 89 b 215 63 160 89 187 75 l 220 60 b 225 -35 220 29 222 -3 b 233 -151 229 -75 230 -114 z m 374 -151 b 383 -35 377 -114 379 -75 b 387 60 386 -3 387 29 l 393 63 b 478 89 420 75 448 89 b 511 82 488 89 500 86 b 544 46 534 73 546 62 b 537 17 544 37 543 29 b 374 -151 500 -56 439 -105 z"
                },
                accidentalQuarterToneSharpStein: {
                    x_min: 0,
                    x_max: 300,
                    y_min: -338,
                    y_max: 351,
                    ha: 689,
                    o: "m 194 -487 b 225 -432 215 -469 223 -452 b 238 -232 229 -366 236 -298 b 377 -199 285 -220 331 -209 b 418 -164 397 -193 410 -181 b 432 -88 428 -138 432 -114 b 412 -42 432 -55 428 -42 b 389 -46 406 -42 399 -43 l 235 -85 b 233 -20 235 -63 233 -42 b 233 105 232 22 233 63 b 312 121 259 111 285 117 b 406 226 390 134 400 145 b 373 284 409 268 402 284 b 344 281 364 284 356 282 b 232 258 307 276 269 266 b 230 308 232 275 232 291 b 210 505 229 374 232 441 b 183 471 189 501 184 490 b 180 406 181 449 180 428 b 184 246 180 353 184 300 b 48 222 140 236 94 228 b 0 168 6 216 0 209 b 7 86 1 141 4 114 b 27 66 9 73 13 66 l 35 66 b 184 94 85 66 135 84 b 187 -1 184 62 186 30 b 190 -96 189 -33 190 -65 l 112 -114 b 35 -213 27 -132 35 -132 b 33 -253 35 -226 35 -240 b 49 -276 33 -269 37 -276 b 62 -275 52 -276 56 -276 l 186 -245 l 186 -256 b 179 -387 180 -300 177 -343 b 194 -487 180 -419 179 -454 z"
                },
                accidentalThreeQuarterTonesSharpStein: {
                    x_min: -23,
                    x_max: 388,
                    y_min: -373,
                    y_max: 445,
                    ha: 818,
                    o: "m 114 -537 b 138 -475 137 -518 138 -495 b 147 -292 138 -413 144 -353 b 212 -278 168 -287 190 -282 b 243 -444 215 -333 225 -389 b 261 -467 248 -454 251 -465 b 281 -446 272 -469 276 -455 b 292 -347 292 -416 288 -384 b 288 -262 289 -320 288 -291 l 374 -245 b 376 -311 374 -266 374 -288 b 390 -456 379 -357 379 -405 b 416 -396 412 -436 415 -418 b 423 -287 420 -360 423 -323 b 422 -235 423 -269 423 -252 b 451 -229 432 -233 441 -232 b 547 -98 524 -215 547 -199 l 547 -89 b 521 -49 546 -59 540 -49 b 497 -52 516 -49 507 -49 b 418 -68 469 -56 444 -63 b 423 52 419 -29 422 12 b 426 140 425 81 425 109 b 495 160 449 145 472 153 b 552 219 526 170 546 189 b 559 279 557 240 553 262 b 530 341 559 324 552 341 b 490 331 520 341 507 338 b 432 311 471 324 452 318 b 449 552 436 392 442 471 b 452 588 451 563 452 575 b 446 622 452 599 451 611 b 436 641 444 629 448 641 b 418 628 428 641 420 636 b 409 602 413 621 410 611 b 386 297 396 501 390 399 b 297 274 356 288 327 281 b 291 403 295 317 294 360 b 274 550 288 452 284 501 b 259 569 271 564 265 569 b 240 559 253 569 248 563 b 230 537 232 554 230 546 l 230 488 b 233 369 230 448 232 409 b 236 261 236 333 238 297 b 156 245 210 255 183 251 b 154 396 154 295 154 346 b 150 416 154 403 153 410 b 140 438 145 423 150 438 l 138 438 b 118 413 128 436 118 428 b 112 354 118 393 114 374 b 109 238 109 315 109 276 b 49 226 89 233 69 230 b 3 163 16 222 3 202 b 7 91 3 138 9 114 b 29 62 7 69 13 62 b 39 63 32 62 35 63 b 104 73 60 66 82 71 b 101 -10 104 46 102 17 l 92 -132 l 10 -150 b -33 -204 -19 -157 -33 -170 b -19 -310 -32 -240 -19 -274 b -6 -324 -19 -321 -13 -324 b 6 -323 -1 -324 1 -324 b 82 -307 32 -317 58 -311 b 81 -376 82 -330 81 -353 b 114 -537 81 -431 94 -484 z m 294 -92 b 297 -37 295 -73 295 -56 b 300 49 300 -9 300 20 l 300 108 b 379 127 325 114 353 120 b 374 -76 376 59 374 -9 b 294 -92 347 -82 320 -86 z m 154 -120 b 157 20 154 -73 156 -26 b 158 82 158 40 158 62 b 230 95 183 86 206 89 b 225 0 229 63 226 32 b 217 -107 223 -35 220 -71 z"
                },
                accidentalBuyukMucennebFlat: {
                    x_min: 2,
                    x_max: 287,
                    y_min: -248,
                    y_max: 432,
                    ha: 680,
                    o: "m 410 128 b 302 239 403 199 363 239 b 259 232 289 239 275 236 b 199 207 239 226 219 216 l 197 206 l 197 243 l 197 251 b 347 317 248 272 298 295 b 376 347 360 324 372 334 b 389 435 387 376 393 405 b 348 454 384 462 377 465 b 202 387 300 432 251 409 b 203 408 203 395 203 402 l 203 431 b 347 490 252 451 300 469 b 376 517 360 495 372 505 b 389 599 387 546 393 572 b 348 616 384 625 377 628 l 203 556 b 196 593 202 569 199 582 b 179 622 193 603 193 622 l 177 622 b 150 588 161 621 150 608 b 147 533 150 570 148 552 b 29 488 108 517 69 503 b 3 455 12 482 3 472 b 12 353 1 422 9 389 b 145 408 56 372 101 389 b 145 363 145 392 145 377 l 29 315 b 3 281 12 310 3 298 b 12 170 1 245 9 209 l 141 226 b 138 166 140 206 138 186 b 114 -199 134 43 115 -76 b 130 -344 114 -246 117 -297 b 141 -357 132 -353 135 -357 b 158 -347 145 -357 151 -354 b 219 -301 177 -331 199 -315 b 413 69 346 -210 413 -88 b 410 128 413 89 413 108 z m 350 35 b 343 6 350 26 348 17 b 180 -163 308 -69 245 -117 b 189 -46 183 -125 184 -86 b 193 49 192 -14 193 17 l 199 52 b 284 78 226 63 253 78 b 317 71 294 78 305 75 b 350 35 340 62 351 50 z"
                },
                accidentalBuyukMucennebSharp: {
                    x_min: -1,
                    x_max: 467,
                    y_min: -460,
                    y_max: 350,
                    ha: 810,
                    o: "m 230 -662 b 256 -615 249 -647 255 -631 b 264 -495 261 -575 264 -534 b 261 -361 264 -451 262 -406 b 415 -324 312 -348 363 -336 b 416 -445 415 -364 416 -405 b 431 -593 416 -492 419 -541 b 458 -533 454 -573 456 -554 b 464 -418 462 -494 464 -455 b 459 -314 464 -383 462 -348 b 531 -298 484 -308 508 -304 b 570 -259 554 -292 566 -278 b 579 -192 575 -236 579 -215 b 576 -164 579 -183 577 -173 b 556 -143 573 -147 567 -143 b 543 -144 553 -143 549 -143 b 459 -164 516 -151 487 -157 b 462 -102 459 -144 461 -122 l 608 -76 b 667 -24 639 -71 660 -53 b 672 19 671 -9 671 9 l 672 46 b 641 108 668 94 662 108 b 605 101 632 108 621 105 l 580 96 b 469 72 544 88 507 79 b 471 131 469 91 471 111 b 521 141 488 135 504 138 b 573 197 550 148 570 167 b 577 271 576 222 577 246 b 553 300 577 291 567 300 b 537 297 549 300 543 298 b 480 285 517 292 498 288 b 491 410 482 327 485 369 b 494 445 492 422 494 433 b 488 482 494 458 492 469 b 477 504 487 490 491 504 b 455 484 467 504 458 495 b 451 464 452 478 452 471 b 433 275 442 402 438 338 b 282 246 383 265 333 255 l 291 346 b 294 382 292 359 294 370 b 287 418 294 395 292 406 b 276 435 284 423 289 435 b 259 423 269 435 264 429 b 251 397 255 416 252 406 b 235 239 242 346 239 292 b 166 228 212 235 189 232 b 118 170 134 223 112 207 b 120 140 120 160 120 150 b 120 84 120 121 118 102 b 131 69 120 75 122 69 b 138 71 132 69 135 71 b 226 85 168 75 197 81 b 223 30 226 66 225 49 l 223 17 l 45 -22 b -1 -92 13 -29 -1 -48 b 1 -171 -1 -118 3 -145 b 12 -187 0 -184 4 -187 b 22 -186 14 -187 17 -187 b 115 -164 53 -179 84 -170 b 217 -145 150 -158 183 -153 b 215 -225 216 -173 216 -199 l 203 -229 b 132 -275 141 -246 132 -249 b 134 -315 132 -285 134 -298 b 135 -382 134 -336 132 -359 b 144 -396 135 -386 134 -396 b 151 -395 145 -396 148 -396 b 215 -376 171 -387 193 -382 b 216 -516 215 -422 215 -468 b 230 -662 217 -563 219 -611 z m 271 27 b 274 94 272 50 274 72 b 425 122 324 102 374 112 l 425 101 b 422 62 423 88 423 75 z m 262 -177 b 264 -137 264 -164 264 -151 b 418 -109 315 -128 366 -120 b 415 -174 416 -131 416 -153 b 262 -213 364 -186 312 -199 z"
                },
                accidentalBakiyeFlat: {
                    x_min: 2,
                    x_max: 287,
                    y_min: -236,
                    y_max: 444,
                    ha: 680,
                    o: "m 141 -340 b 158 -330 145 -340 151 -337 b 219 -284 177 -314 199 -298 b 413 86 346 -193 413 -71 b 410 145 413 107 413 125 b 302 256 403 216 363 256 b 259 249 289 256 275 253 b 199 225 239 243 219 233 l 197 223 l 197 261 b 199 334 197 285 199 310 b 347 406 249 357 298 382 b 376 439 360 413 372 425 b 390 516 384 465 390 490 b 389 537 390 523 390 530 b 372 564 384 556 382 564 b 348 557 367 564 359 562 b 204 487 300 537 253 510 b 206 518 206 497 206 507 b 196 611 206 549 203 580 b 179 639 193 621 193 639 l 177 639 b 150 605 161 638 150 625 b 145 482 148 564 144 523 l 145 458 b 29 405 107 439 68 420 b 3 366 12 397 3 386 b 12 243 1 325 9 287 b 143 307 56 265 99 285 l 138 183 b 114 -181 134 60 114 -59 b 130 -327 114 -229 117 -279 b 141 -340 132 -336 135 -340 z m 180 -145 b 189 -29 183 -108 184 -69 b 193 66 192 3 193 35 l 199 69 b 284 95 226 81 253 95 b 317 88 294 95 305 92 b 350 52 340 79 351 68 b 343 23 350 43 348 35 b 180 -145 305 -50 245 -99 z"
                },
                accidentalKomaSharp: {
                    x_min: 0,
                    x_max: 300,
                    y_min: -338,
                    y_max: 351,
                    ha: 689,
                    o: "m 194 -487 b 225 -432 215 -469 223 -452 b 238 -232 229 -366 236 -298 b 377 -199 285 -220 331 -209 b 418 -164 397 -193 410 -181 b 432 -88 428 -138 432 -114 b 412 -42 432 -55 428 -42 b 389 -46 406 -42 399 -43 l 235 -85 b 233 -20 235 -63 233 -42 b 233 105 232 22 233 63 b 312 121 259 111 285 117 b 406 226 390 134 400 145 b 373 284 409 268 402 284 b 344 281 364 284 356 282 b 232 258 307 276 269 266 b 230 308 232 275 232 291 b 210 505 229 374 232 441 b 183 471 189 501 184 490 b 180 406 181 449 180 428 b 184 246 180 353 184 300 b 48 222 140 236 94 228 b 0 168 6 216 0 209 b 7 86 1 141 4 114 b 27 66 9 73 13 66 l 35 66 b 184 94 85 66 135 84 b 187 -1 184 62 186 30 b 190 -96 189 -33 190 -65 l 112 -114 b 35 -213 27 -132 35 -132 b 33 -253 35 -226 35 -240 b 49 -276 33 -269 37 -276 b 62 -275 52 -276 56 -276 l 186 -245 l 186 -256 b 179 -387 180 -300 177 -343 b 194 -487 180 -419 179 -454 z"
                },
                accidentalKucukMucennebSharp: {
                    x_min: 0,
                    x_max: 359,
                    y_min: -420,
                    y_max: 343,
                    ha: 763,
                    o: "m 236 -605 b 262 -543 256 -583 261 -564 b 269 -423 268 -503 269 -464 b 266 -340 269 -396 268 -367 l 361 -318 b 405 -276 384 -312 399 -298 b 413 -189 412 -248 416 -219 b 395 -164 412 -171 409 -164 b 382 -166 392 -164 387 -164 b 264 -193 343 -176 304 -184 b 269 -102 265 -163 268 -132 b 454 -62 331 -89 392 -78 b 501 -23 477 -58 494 -45 b 517 62 511 6 517 33 b 487 112 517 95 513 112 b 471 111 482 112 477 112 b 274 66 406 95 340 81 b 276 138 275 91 276 114 b 350 154 301 144 325 148 b 402 203 377 160 396 176 b 412 284 408 230 412 258 b 392 311 412 302 406 311 b 372 308 386 311 379 310 b 287 291 343 301 314 297 l 295 405 b 298 441 297 416 298 428 b 292 475 298 452 297 464 b 282 494 289 482 294 494 b 264 481 274 494 266 490 b 255 455 259 474 256 464 b 239 282 248 397 243 340 b 148 268 209 278 179 274 b 62 164 62 252 62 253 l 62 132 b 79 108 60 117 65 108 l 86 108 l 230 130 b 229 92 230 118 229 105 b 228 56 228 79 228 68 b 66 20 173 43 120 32 b 0 -59 6 7 3 1 l 0 -138 b 14 -160 -1 -156 4 -160 b 27 -158 19 -160 23 -160 b 222 -112 92 -141 157 -127 b 220 -203 220 -143 220 -173 b 147 -217 196 -207 171 -213 b 89 -288 92 -228 89 -229 b 95 -347 85 -305 96 -325 b 112 -374 92 -366 98 -374 b 125 -373 117 -374 121 -374 l 220 -351 b 222 -458 220 -386 220 -422 b 236 -605 223 -504 225 -552 z"
                },
                accidentalKoron: {
                    x_min: 0,
                    x_max: 303,
                    y_min: -462,
                    y_max: 180,
                    ha: 642,
                    o: "m 59 -665 b 72 -649 69 -662 72 -657 b 69 -626 72 -642 69 -634 b 69 -622 69 -625 69 -624 l 69 -600 b 55 -156 60 -456 68 -311 b 86 -170 66 -166 76 -170 b 112 -163 95 -170 104 -166 b 390 -35 204 -120 298 -78 b 436 -1 409 -27 436 -27 b 396 46 436 22 413 33 l 382 55 b 46 243 271 121 157 179 b 12 259 29 253 17 259 b 0 219 1 259 0 248 b 3 -372 0 22 3 -176 b 6 -616 3 -454 6 -536 b 59 -665 6 -638 40 -671 z m 55 199 b 363 24 156 141 258 84 b 55 -118 259 -24 160 -69 z"
                },
                accidentalSori: {
                    x_min: 0,
                    x_max: 434,
                    y_min: -295,
                    y_max: 325,
                    ha: 620,
                    o: "m 194 -425 b 196 -409 194 -418 196 -413 b 194 -194 196 -337 196 -266 b 364 -127 251 -171 308 -150 b 361 -321 363 -192 364 -256 b 410 -387 360 -357 373 -377 b 413 -373 412 -382 413 -377 b 418 -114 418 -287 418 -200 l 418 -105 b 595 -35 477 -82 536 -59 b 625 0 612 -27 625 -22 b 593 48 624 23 618 39 l 419 117 b 423 370 419 202 423 285 b 426 403 423 382 426 393 b 418 436 426 415 425 426 b 384 468 409 449 399 468 b 369 448 370 468 369 459 b 369 436 369 444 369 441 l 369 428 l 369 423 b 367 138 369 328 367 233 l 353 143 l 192 207 l 192 367 b 173 406 192 383 184 396 b 151 422 167 413 160 422 b 144 420 148 422 147 422 b 137 403 138 416 137 410 l 137 392 l 137 229 b 33 271 102 243 68 256 b 13 276 26 274 19 276 b 0 262 6 276 0 272 b 35 199 1 239 0 212 l 138 160 b 140 -148 138 58 138 -45 b 56 -181 111 -158 84 -170 b 24 -215 35 -189 24 -199 b 29 -235 24 -220 26 -228 b 49 -253 35 -249 42 -253 b 78 -240 59 -253 69 -243 b 140 -216 98 -233 120 -225 l 140 -356 b 194 -425 140 -406 141 -406 z m 194 -125 b 193 138 194 -37 193 50 b 315 89 233 122 275 107 b 366 71 333 84 350 76 b 364 -58 366 27 366 -16 b 194 -125 308 -81 251 -104 z m 419 49 l 526 7 l 485 -10 l 419 -36 z"
                },
                articAccentAbove: {
                    x_min: 0,
                    x_max: 425,
                    y_min: 0,
                    y_max: 326,
                    ha: 326,
                    o: "m 27 1 b 78 12 46 0 62 6 b 347 112 168 45 253 91 b 521 184 409 128 459 167 b 608 259 557 194 589 220 b 612 274 611 265 612 271 b 598 292 612 281 608 287 b 477 347 559 312 518 331 b 176 465 374 384 275 425 b 156 469 168 468 161 469 b 125 456 145 469 137 465 b 53 370 96 432 78 399 b 45 353 48 363 45 357 b 68 333 45 344 52 337 b 360 225 166 298 262 261 b 192 154 302 203 249 171 b 13 36 120 132 53 105 b 0 13 9 29 0 22 l 0 9 b 16 0 3 1 10 0 l 26 0 b 27 1 27 0 27 0 z"
                },
                articAccentBelow: {
                    x_min: 0,
                    x_max: 425,
                    y_min: -326,
                    y_max: 0,
                    ha: 326,
                    o: "m 26 -469 l 27 -469 b 78 -458 46 -469 62 -464 b 347 -357 168 -426 253 -380 b 521 -285 409 -341 459 -302 b 608 -210 557 -276 589 -249 b 612 -196 611 -204 612 -200 b 598 -179 612 -189 608 -183 b 477 -122 559 -157 518 -138 b 176 -4 374 -85 275 -45 b 156 0 168 -1 161 0 b 125 -13 145 0 137 -4 b 53 -99 96 -37 78 -71 b 45 -117 48 -107 45 -112 b 68 -137 45 -125 52 -132 b 360 -245 166 -171 262 -209 b 192 -315 302 -266 249 -300 b 13 -433 120 -337 53 -366 b 0 -456 9 -442 0 -448 l 0 -461 b 16 -469 3 -468 10 -469 z"
                },
                articTenutoAbove: {
                    x_min: 0,
                    x_max: 471,
                    y_min: 0,
                    y_max: 56,
                    ha: 56,
                    o: "m 137 0 b 197 1 156 0 179 1 b 409 6 268 1 338 6 b 482 4 432 6 459 6 b 556 0 508 3 534 0 b 651 10 588 0 621 3 b 678 27 662 12 678 10 b 654 59 680 45 672 53 b 511 75 606 73 560 73 b 255 81 426 78 341 81 b 160 79 222 81 193 79 l 36 79 b 1 71 24 78 7 85 b 19 32 -3 56 9 43 b 45 16 26 24 36 20 b 137 0 76 3 108 0 z"
                },
                articTenutoBelow: {
                    x_min: 0,
                    x_max: 471,
                    y_min: -59,
                    y_max: -3,
                    ha: 56,
                    o: "m 137 -85 b 197 -84 156 -85 179 -84 b 409 -79 268 -84 338 -79 b 482 -81 432 -79 459 -79 b 556 -85 508 -82 534 -85 b 651 -75 588 -85 621 -82 b 678 -58 662 -73 678 -75 b 654 -26 680 -40 672 -32 b 511 -10 606 -12 560 -12 b 255 -4 426 -7 341 -4 b 160 -6 222 -4 193 -6 l 36 -6 b 1 -14 24 -7 7 0 b 19 -53 -3 -29 9 -42 b 45 -69 26 -60 36 -65 b 137 -85 76 -82 108 -85 z"
                },
                articStaccatoAbove: {
                    x_min: 1,
                    x_max: 112,
                    y_min: 0,
                    y_max: 156,
                    ha: 156,
                    o: "m 98 0 b 132 23 109 0 122 7 b 161 112 150 50 161 79 b 158 148 161 124 161 137 b 125 186 154 167 131 167 b 63 225 117 215 85 216 b 23 197 45 222 30 219 b 3 91 12 163 12 127 b 19 66 0 79 4 69 b 65 27 40 62 53 46 b 98 0 76 9 88 0 z"
                },
                articStaccatoBelow: {
                    x_min: 1,
                    x_max: 112,
                    y_min: -156,
                    y_max: 0,
                    ha: 156,
                    o: "m 132 -202 b 161 -112 151 -174 163 -145 b 158 -76 161 -101 161 -88 b 125 -39 153 -58 131 -58 b 63 0 115 -10 85 -9 b 23 -27 45 -3 30 -6 b 3 -134 12 -62 10 -98 b 19 -158 0 -145 4 -156 b 65 -197 40 -164 53 -179 b 98 -225 75 -216 88 -225 b 132 -202 109 -225 122 -217 z"
                },
                articStaccatissimoAbove: {
                    x_min: 0,
                    x_max: 139,
                    y_min: 0,
                    y_max: 411,
                    ha: 411,
                    o: "m 104 0 b 144 115 143 29 138 75 b 197 423 158 217 180 320 b 200 454 199 433 200 444 b 181 540 200 482 193 513 b 112 592 167 573 141 592 b 55 567 92 592 72 585 b 0 490 32 546 3 527 l 0 484 b 27 279 14 416 14 347 b 84 20 43 193 52 104 b 96 0 86 13 92 6 z"
                },
                articStaccatissimoBelow: {
                    x_min: 0,
                    x_max: 139,
                    y_min: -411,
                    y_max: 0,
                    ha: 411,
                    o: "m 88 -592 b 145 -567 108 -592 128 -585 b 200 -490 168 -546 197 -527 l 200 -484 b 173 -279 186 -416 186 -347 b 117 -20 157 -193 148 -104 b 104 0 114 -13 108 -6 l 96 0 b 56 -115 58 -29 62 -75 b 3 -423 42 -217 20 -320 b 0 -454 1 -433 0 -444 b 19 -540 0 -482 7 -513 b 88 -592 33 -573 59 -592 z"
                },
                articMarcatoAbove: {
                    x_min: 0,
                    x_max: 396,
                    y_min: 0,
                    y_max: 328,
                    ha: 328,
                    o: "m 477 0 b 510 13 488 0 500 6 b 570 124 546 40 563 81 b 547 183 570 147 560 166 b 356 422 487 265 405 330 b 346 442 354 429 350 436 l 346 444 b 318 465 340 456 330 464 l 312 469 b 274 449 294 480 284 461 b 242 413 262 438 253 425 b 56 196 177 343 112 274 b 1 56 26 154 13 105 b 27 20 -4 35 9 20 b 42 23 32 20 37 20 b 84 53 59 29 72 39 b 255 269 141 125 193 200 b 275 229 262 255 266 242 b 448 14 324 151 390 86 b 477 0 456 4 467 0 z"
                },
                articMarcatoBelow: {
                    x_min: 0,
                    x_max: 396,
                    y_min: -328,
                    y_max: 0,
                    ha: 328,
                    o: "m 258 -469 b 297 -449 276 -480 287 -461 b 328 -413 308 -438 317 -425 b 514 -196 393 -343 458 -274 b 569 -56 544 -154 557 -105 b 543 -20 575 -35 562 -20 b 528 -23 539 -20 533 -20 b 487 -53 511 -29 498 -39 b 315 -269 429 -125 377 -200 b 295 -229 308 -255 304 -242 b 122 -14 246 -151 180 -86 b 94 0 114 -4 104 0 b 60 -13 82 0 71 -6 b 0 -124 24 -40 7 -81 b 23 -183 0 -147 10 -166 b 215 -422 84 -265 166 -330 b 225 -442 216 -429 220 -436 l 225 -444 b 252 -465 230 -456 240 -464 z"
                },
                fermataAbove: {
                    x_min: 0,
                    x_max: 472,
                    y_min: 2,
                    y_max: 454,
                    ha: 452,
                    o: "m 39 10 b 78 108 66 37 71 73 b 163 311 92 181 111 252 b 284 423 199 353 239 392 b 373 458 312 444 340 454 b 433 431 395 458 410 446 b 603 153 530 361 596 276 b 595 121 603 144 595 131 l 595 88 b 602 50 596 75 589 55 b 639 73 619 43 631 60 b 651 102 645 82 648 92 b 667 194 660 132 662 163 b 680 278 671 222 672 248 b 560 567 680 386 638 481 b 396 654 508 625 452 649 b 291 632 364 654 325 644 b 161 526 235 613 200 566 b 4 249 85 446 26 357 b 4 174 0 222 -3 196 b 10 19 4 124 4 69 b 29 4 12 6 16 0 b 39 10 35 4 33 4 z m 338 37 b 370 40 350 36 357 36 b 380 75 387 40 380 43 b 389 94 382 79 382 85 b 356 132 389 111 374 122 b 269 154 328 147 300 156 b 225 125 252 154 228 157 b 261 48 222 81 232 56 b 338 37 287 40 312 40 z"
                },
                fermataBelow: {
                    x_min: 0,
                    x_max: 519,
                    y_min: -430,
                    y_max: -1,
                    ha: 429,
                    o: "m 344 -615 b 500 -543 402 -602 452 -576 b 713 -253 605 -471 661 -364 b 746 -98 737 -204 750 -153 b 727 -59 744 -82 744 -59 b 688 -88 711 -59 694 -68 b 678 -109 687 -96 683 -102 b 562 -314 648 -183 611 -252 b 387 -439 516 -373 458 -416 b 328 -449 367 -446 347 -449 b 180 -386 274 -449 225 -423 b 69 -179 111 -330 69 -262 b 75 -121 69 -160 71 -141 b 84 -58 78 -101 84 -79 b 82 -39 84 -52 84 -45 b 68 -1 79 -26 82 -4 b 26 -32 49 0 33 -12 b 20 -52 24 -39 22 -45 b 0 -223 9 -107 -3 -161 b 141 -553 1 -348 27 -468 b 304 -619 192 -590 243 -619 b 344 -615 317 -619 330 -618 z m 415 -190 b 435 -157 429 -192 435 -184 b 308 -27 435 -86 379 -27 b 271 -46 287 -27 272 -35 b 269 -69 269 -55 269 -62 b 364 -183 269 -128 302 -170 z"
                },
                fermataLongAbove: {
                    x_min: 0,
                    x_max: 591,
                    y_min: -6,
                    y_max: 337,
                    ha: 343,
                    o: "m 20 -9 b 36 14 29 -9 35 3 b 49 109 45 45 49 78 b 48 143 49 121 49 131 b 42 312 40 200 45 256 b 63 338 42 331 46 338 b 68 340 65 338 66 338 b 279 333 138 336 209 334 b 760 317 439 330 599 323 b 783 298 775 317 782 315 l 796 161 b 814 17 801 115 802 68 b 851 144 840 45 855 102 b 824 396 842 228 834 312 b 760 468 816 459 812 467 l 55 485 b 1 433 12 487 1 478 l 1 387 b 0 203 1 325 0 264 b 9 17 0 141 3 79 b 20 -9 9 7 6 -9 z m 403 3 b 439 6 413 3 425 4 b 477 42 464 9 474 22 b 478 62 478 49 478 55 l 478 84 b 465 160 478 109 478 135 b 449 173 461 167 459 173 b 354 105 386 179 354 156 b 359 71 354 95 356 84 b 360 65 360 69 360 66 b 403 3 372 14 373 3 z"
                },
                fermataLongBelow: {
                    x_min: 0,
                    x_max: 602,
                    y_min: -335,
                    y_max: 7,
                    ha: 342,
                    o: "m 793 -482 b 851 -444 822 -482 842 -471 b 867 -357 860 -416 867 -387 b 865 -336 867 -350 867 -343 b 851 -189 858 -287 855 -238 b 832 -32 847 -135 840 -84 b 824 -17 832 -26 832 -17 l 822 -17 b 805 -30 816 -19 806 -20 b 798 -88 802 -50 798 -69 b 805 -292 798 -157 801 -225 b 772 -327 806 -318 801 -327 b 360 -324 635 -327 497 -325 b 78 -327 265 -323 171 -327 b 50 -304 59 -327 50 -320 l 50 -297 b 62 -187 55 -261 60 -225 b 71 -60 62 -144 71 -102 b 68 -20 71 -48 71 -33 b 53 10 66 -10 69 10 l 52 10 b 22 -22 37 9 24 -1 b 14 -121 17 -55 16 -89 b 0 -359 10 -200 0 -279 b 6 -452 0 -390 3 -420 b 42 -481 9 -478 20 -481 l 415 -481 l 415 -482 z m 409 -183 b 454 -179 420 -183 435 -181 b 505 -124 487 -176 504 -158 b 505 -89 507 -112 505 -101 b 507 -58 505 -79 507 -68 b 505 -42 507 -52 507 -48 b 485 -10 503 -29 501 -10 b 448 -9 472 -9 461 -9 b 380 -22 425 -9 402 -12 b 363 -46 372 -27 363 -35 l 363 -49 b 364 -114 363 -71 361 -94 b 409 -183 374 -168 377 -183 z"
                },
                fermataVeryLongAbove: {
                    x_min: 0,
                    x_max: 715,
                    y_min: -14,
                    y_max: 437,
                    ha: 451,
                    o: "m 26 -20 b 42 -4 36 -22 39 -12 b 49 53 49 14 49 33 l 49 448 b 69 478 49 467 52 478 l 72 478 b 81 480 75 478 78 478 b 144 477 102 477 122 477 l 207 477 b 943 471 452 477 698 471 b 978 442 966 471 976 467 b 989 99 985 327 985 213 b 999 -19 991 60 995 22 b 1030 62 1028 6 1030 35 b 1021 507 1028 210 1025 359 b 1012 596 1021 537 1017 567 b 976 624 1009 618 998 624 b 507 626 819 624 662 625 b 46 629 353 628 200 629 b 7 590 19 629 7 618 b 0 101 7 428 0 264 b 16 -4 0 65 13 32 b 26 -20 17 -10 22 -19 z m 187 -9 b 207 30 206 -7 204 14 b 207 55 209 37 207 46 b 200 240 210 117 197 179 b 219 262 200 256 203 262 l 223 262 b 456 252 301 258 379 255 l 772 239 b 804 209 792 238 802 235 b 818 69 806 163 809 115 b 834 -4 821 46 816 19 b 857 56 852 13 857 35 b 851 183 857 99 858 141 b 827 360 841 242 841 301 b 786 390 821 383 809 389 b 189 409 588 403 387 402 b 153 377 163 409 153 400 b 173 27 153 259 150 143 b 187 -9 176 13 177 -9 z m 478 3 b 536 10 491 3 510 6 b 582 60 569 14 580 32 l 582 89 l 580 89 b 580 117 580 98 582 107 b 540 171 577 158 572 171 b 521 171 534 171 528 170 b 459 166 500 170 480 168 b 423 132 436 164 423 154 b 428 88 423 118 425 102 b 478 3 438 22 439 4 z"
                },
                fermataVeryLongBelow: {
                    x_min: 0,
                    x_max: 686,
                    y_min: -427,
                    y_max: 30,
                    ha: 457,
                    o: "m 56 -615 b 282 -612 132 -612 207 -613 b 924 -606 497 -608 710 -606 b 973 -570 953 -606 968 -593 b 988 -455 984 -533 991 -494 b 982 -262 984 -390 982 -327 b 976 -69 982 -197 981 -134 b 976 -14 975 -50 976 -33 b 966 43 976 4 975 23 b 940 20 953 37 943 35 b 933 -76 936 -12 933 -45 b 935 -121 933 -91 933 -107 b 940 -307 940 -183 940 -245 l 940 -435 b 919 -458 940 -451 935 -458 b 894 -459 910 -458 903 -458 b 206 -467 665 -461 435 -467 b 88 -467 167 -467 127 -468 b 45 -425 45 -467 42 -465 b 46 -400 46 -416 46 -408 b 43 -325 46 -376 43 -350 b 42 -59 42 -236 42 -148 b 22 17 42 -32 36 -6 b 0 -27 -1 7 0 -10 b 7 -420 0 -158 7 -289 l 7 -474 b 16 -579 7 -510 7 -544 b 56 -615 22 -603 27 -615 z m 789 -390 b 835 -357 816 -392 829 -380 b 850 -256 844 -324 850 -291 b 848 -230 850 -248 850 -239 b 845 -135 845 -199 845 -167 l 845 -72 b 837 23 845 -40 848 -9 b 809 -27 809 14 809 -7 l 809 -222 b 788 -242 809 -238 805 -242 l 203 -229 b 180 -209 186 -229 180 -223 l 180 -160 b 179 -115 180 -145 180 -131 b 179 -50 177 -94 179 -72 b 163 24 179 -26 176 0 b 137 -6 145 19 140 10 b 134 -39 134 -17 134 -27 b 138 -105 134 -60 137 -82 l 138 -197 b 145 -343 138 -246 138 -294 b 179 -377 148 -364 151 -377 b 789 -390 383 -377 586 -380 z m 480 -164 b 566 -65 549 -164 566 -140 b 527 1 566 -10 564 1 b 436 -71 426 1 436 -9 l 436 -88 l 436 -143 b 454 -163 436 -153 439 -161 b 480 -164 464 -163 472 -164 z"
                },
                fermataVeryShortAbove: {
                    x_min: 0,
                    x_max: 711,
                    y_min: -31,
                    y_max: 496,
                    ha: 527,
                    o: "m 1018 -45 b 1024 -1 1021 -29 1024 -14 b 986 105 1024 40 1008 75 b 557 688 845 302 701 495 b 520 714 544 706 531 714 b 480 687 505 714 492 706 b 340 490 433 621 387 556 b 73 127 252 367 168 243 b 0 22 48 95 22 63 b 68 60 33 27 52 42 b 167 170 101 96 132 135 b 494 503 276 279 384 393 b 518 518 504 513 511 518 b 543 501 526 518 533 513 b 923 63 670 356 799 212 b 1018 -45 952 29 984 -4 z m 837 -16 b 838 1 838 -10 838 -4 b 799 82 838 37 818 60 b 560 369 721 179 639 274 b 541 396 553 377 546 386 b 518 422 533 413 527 422 b 491 400 511 422 503 415 b 347 229 445 341 396 285 b 203 45 297 170 239 117 b 184 17 199 36 184 26 b 189 9 184 14 186 12 b 226 26 200 -1 215 19 l 238 35 b 494 245 321 107 408 176 b 510 253 501 251 505 253 b 526 245 514 253 520 251 b 729 73 592 186 660 130 z m 495 0 b 511 6 500 0 505 1 b 556 32 526 16 540 30 b 586 68 583 35 586 50 b 579 115 586 86 582 101 b 533 190 566 168 553 190 b 459 154 516 190 494 177 b 442 122 448 145 442 135 b 445 105 442 117 442 111 b 477 17 456 76 465 46 b 495 0 481 7 487 0 z"
                },
                fermataVeryShortBelow: {
                    x_min: 0,
                    x_max: 697,
                    y_min: -475,
                    y_max: 13,
                    ha: 488,
                    o: "m 507 -383 b 530 -369 514 -383 521 -377 b 775 -130 611 -288 694 -210 b 824 3 811 -94 822 -48 b 789 -7 808 6 799 0 b 521 -212 698 -72 611 -143 b 488 -226 508 -222 498 -226 b 452 -209 477 -226 467 -220 b 202 7 370 -135 285 -65 b 187 19 197 10 193 19 b 179 14 184 19 181 17 b 171 -3 174 10 171 4 b 173 -13 171 -6 171 -9 b 235 -122 186 -53 206 -94 l 484 -370 b 507 -383 492 -379 500 -383 z m 503 -684 b 539 -647 517 -674 528 -661 b 917 -153 665 -482 793 -318 b 999 -24 948 -112 984 -73 b 1004 -10 1001 -20 1004 -16 b 999 -3 1004 -7 1002 -4 b 973 -10 991 1 981 -1 l 963 -23 b 552 -505 825 -184 688 -344 b 528 -521 543 -517 536 -521 b 505 -505 521 -521 514 -516 b 156 -128 393 -374 274 -253 b 27 6 114 -84 72 -39 b 16 17 24 9 22 17 b 9 13 13 17 12 16 b 0 -3 6 10 0 3 b 1 -9 0 -4 0 -7 b 14 -36 4 -17 9 -27 b 117 -179 45 -86 81 -132 b 482 -667 242 -338 360 -504 b 503 -684 487 -672 491 -683 z m 487 -164 b 552 -98 523 -164 552 -137 b 544 -30 550 -78 549 -55 b 521 -1 541 -19 537 -1 l 517 -1 b 446 -29 492 -9 462 0 b 445 -42 444 -32 445 -37 b 464 -145 451 -76 458 -111 b 487 -164 468 -157 467 -164 z"
                },
                fermataShortAbove: {
                    x_min: 0,
                    x_max: 545,
                    y_min: -18,
                    y_max: 348,
                    ha: 366,
                    o: "m 16 -26 b 36 -9 26 -27 30 -16 b 354 340 143 107 249 223 b 369 348 360 346 364 348 b 382 341 373 348 377 346 l 530 199 b 743 0 599 131 672 68 b 753 -7 747 -3 750 -7 b 762 -1 756 -7 759 -6 b 785 84 776 10 785 48 b 768 150 785 112 779 138 l 399 491 b 379 501 392 498 384 501 b 357 488 372 501 364 495 b 27 137 248 370 141 251 b 1 84 12 121 1 105 b 3 69 1 79 1 75 b 0 55 1 65 0 59 b 9 1 0 36 9 20 b 16 -26 10 -7 3 -22 z m 357 24 b 367 27 360 24 363 24 b 431 118 422 42 431 49 b 429 151 431 130 431 141 b 400 193 428 171 429 193 b 333 147 359 193 333 176 b 341 42 333 111 337 78 b 357 24 343 30 346 24 z"
                },
                fermataShortBelow: {
                    x_min: 0,
                    x_max: 565,
                    y_min: -335,
                    y_max: 10,
                    ha: 345,
                    o: "m 386 -482 b 422 -455 395 -482 405 -474 b 732 -117 526 -343 631 -232 b 814 12 765 -79 799 -42 b 752 -22 780 14 768 -7 b 436 -320 645 -120 540 -219 b 419 -328 429 -325 425 -328 b 400 -318 413 -328 408 -325 b 35 0 279 -212 157 -105 b 16 14 29 4 23 14 b 7 12 13 14 10 14 b 0 -3 1 7 0 1 b 7 -23 0 -10 3 -17 b 20 -48 12 -30 14 -39 b 167 -238 60 -117 115 -177 b 351 -455 229 -310 289 -383 b 386 -482 367 -474 377 -482 z m 382 -213 b 406 -207 389 -213 396 -210 b 452 -156 431 -199 446 -180 b 461 -85 456 -132 458 -108 b 448 -32 461 -66 454 -49 b 418 -6 442 -12 431 -6 b 397 -9 410 -6 405 -7 b 348 -50 376 -14 350 -14 b 356 -170 348 -91 354 -130 b 382 -213 357 -199 363 -213 z"
                },
                breathMarkComma: {
                    x_min: 0,
                    x_max: 148,
                    y_min: 0,
                    y_max: 275,
                    ha: 275,
                    o: "m 120 0 b 187 78 156 20 174 48 b 213 209 206 121 213 164 b 206 294 213 238 210 265 b 140 390 200 337 171 367 b 122 396 134 395 128 396 b 68 382 105 396 85 384 b 46 379 60 382 53 382 b 0 328 12 369 0 357 b 1 311 0 323 1 317 b 30 210 4 275 22 243 b 66 167 39 179 46 167 b 94 171 73 167 82 168 b 143 180 109 174 124 180 b 160 179 148 180 154 180 b 120 66 124 145 120 107 b 120 0 120 45 121 23 z"
                },
                breathMarkUpbow: {
                    x_min: 0,
                    x_max: 254,
                    y_min: 0,
                    y_max: 595,
                    ha: 595,
                    o: "m 233 0 b 256 48 251 14 253 30 b 272 183 264 92 265 138 b 311 455 289 274 295 364 b 350 716 327 541 341 628 b 366 815 354 749 366 782 b 359 857 366 829 363 842 b 327 815 334 852 330 832 b 302 674 315 769 310 721 b 248 357 288 567 269 462 b 225 226 240 314 242 268 b 210 251 212 232 213 243 b 69 721 163 408 117 564 b 32 835 58 760 53 801 b 20 851 29 841 27 851 b 14 850 19 851 16 851 b 0 828 6 847 0 838 l 0 825 b 12 765 1 804 7 785 b 194 125 73 552 132 338 b 233 0 206 84 213 42 z"
                },
                caesura: {
                    x_min: 0,
                    x_max: 566,
                    y_min: 0,
                    y_max: 562,
                    ha: 563,
                    o: "m 0 76 b 49 122 24 92 37 107 b 444 613 180 287 305 455 b 528 770 484 660 518 708 b 531 792 530 778 531 785 b 524 808 531 799 530 805 b 490 792 513 815 498 802 b 390 683 456 756 420 721 b 48 262 275 543 164 400 b 0 76 0 207 7 145 z m 226 1 b 248 13 238 -4 243 7 l 353 137 b 759 638 490 302 632 464 b 814 805 795 688 819 740 b 779 786 796 805 788 796 b 628 609 724 732 678 668 b 310 242 523 485 416 363 b 217 69 265 190 217 140 b 222 30 217 58 219 45 b 222 23 222 29 220 26 b 220 12 222 20 220 16 b 226 1 220 7 222 3 z"
                },
                caesuraCurved: {
                    x_min: 0,
                    x_max: 386,
                    y_min: -10,
                    y_max: 584,
                    ha: 594,
                    o: "m 180 -14 b 246 14 213 -13 230 0 b 347 144 288 52 315 99 b 526 471 420 246 488 350 b 556 671 546 537 556 603 b 543 798 556 713 553 756 b 504 837 537 822 521 828 b 490 841 500 840 494 841 b 472 832 482 841 477 838 b 406 678 436 785 406 737 b 410 638 406 665 408 652 b 425 511 419 595 425 553 b 315 186 425 395 387 287 b 180 -14 271 122 228 58 z m 14 24 b 49 39 29 24 40 32 b 120 114 76 60 99 85 b 216 276 156 166 184 223 b 317 626 281 384 317 501 b 315 664 317 639 317 651 b 301 773 314 701 311 737 b 262 808 295 795 278 808 b 245 799 256 808 249 805 b 170 641 209 750 170 706 b 171 621 170 634 170 628 b 177 511 176 585 177 549 b 114 229 177 415 160 320 b 0 26 79 161 42 95 b 14 24 6 24 10 24 z"
                },
                restMaxima: {
                    x_min: 0,
                    x_max: 366,
                    y_min: -255,
                    y_max: 255,
                    ha: 510,
                    o: "m 397 -367 b 504 -343 436 -367 468 -347 b 518 -318 516 -341 518 -330 b 527 -30 518 -217 527 -117 b 526 33 527 -7 527 13 l 526 301 b 501 350 526 323 520 341 b 428 367 477 361 452 367 b 374 359 410 367 393 364 b 357 333 361 354 357 347 b 356 91 357 252 356 171 l 356 30 b 340 -307 357 -82 346 -194 b 397 -367 337 -354 350 -367 z m 46 -357 b 58 -356 49 -357 53 -357 b 154 -333 91 -351 121 -338 b 173 -305 168 -330 173 -320 l 173 302 b 132 356 173 330 157 348 b 68 364 112 363 89 364 b 3 304 19 363 1 348 l 3 4 l 0 4 b 1 -302 0 -98 0 -200 b 46 -357 1 -331 16 -357 z"
                },
                restDoubleWhole: {
                    x_min: 0,
                    x_max: 122,
                    y_min: 0,
                    y_max: 249,
                    ha: 249,
                    o: "m 43 0 b 58 1 48 0 52 0 b 124 20 81 6 102 17 b 176 96 173 27 176 58 b 173 220 174 138 173 179 b 176 304 173 248 176 276 b 140 353 176 331 163 346 b 95 359 125 356 111 359 b 32 346 73 359 52 354 b 0 315 20 340 0 337 b 1 243 0 291 1 268 l 1 174 l 4 174 l 4 48 b 43 0 4 16 17 0 z"
                },
                restWhole: {
                    x_min: 1,
                    x_max: 500,
                    y_min: -120,
                    y_max: 14,
                    ha: 134,
                    o: "m 356 -173 l 356 -171 l 642 -171 b 719 -115 680 -171 717 -145 b 720 -82 719 -104 720 -92 b 711 -20 720 -60 719 -40 b 672 17 704 0 694 10 b 649 20 664 20 657 20 b 605 17 634 20 621 17 b 92 19 433 17 262 17 b 29 7 69 20 49 12 b 9 -17 12 4 9 -6 b 10 -43 9 -26 10 -35 b 1 -84 10 -58 3 -72 b 76 -173 0 -147 7 -173 z"
                },
                restWholeLegerLine: {
                    x_min: -197,
                    x_max: 685,
                    y_min: -157,
                    y_max: 29,
                    ha: 186,
                    o: "m 96 -226 b 167 -223 121 -226 144 -225 b 300 -222 207 -222 252 -222 l 444 -222 b 660 -217 520 -222 595 -222 b 746 -131 703 -216 746 -200 b 744 -62 746 -108 747 -85 b 743 -39 743 -53 743 -46 b 789 -14 743 -16 752 -17 b 883 -16 821 -13 851 -16 b 965 -9 910 -16 937 -14 b 986 3 972 -7 986 -10 l 986 6 b 963 35 984 17 982 32 b 887 42 937 39 913 42 b 39 27 605 42 321 33 l -76 27 b -261 20 -138 27 -200 26 b -282 14 -269 20 -279 23 b -271 -7 -287 4 -276 -1 b -209 -27 -253 -23 -230 -24 b -153 -30 -190 -30 -173 -30 b -48 -29 -118 -30 -82 -27 b 6 -32 -22 -29 -6 -27 b 1 -72 3 -43 1 -58 b 4 -167 1 -105 7 -140 b 53 -223 3 -207 14 -217 b 96 -226 68 -226 82 -226 z"
                },
                restHalf: {
                    x_min: 0,
                    x_max: 518,
                    y_min: 0,
                    y_max: 162,
                    ha: 162,
                    o: "m 98 0 l 556 0 b 665 1 592 0 629 0 b 746 82 720 3 743 29 b 736 174 749 114 740 144 b 670 232 729 215 708 232 b 570 229 636 232 603 229 b 356 233 498 229 426 233 l 73 233 b 0 179 19 233 0 220 b 1 154 0 171 0 164 b 6 95 4 135 6 115 b 98 0 3 27 29 0 z"
                },
                restHalfLegerLine: {
                    x_min: -120,
                    x_max: 448,
                    y_min: -20,
                    y_max: 143,
                    ha: 163,
                    o: "m 397 -29 b 482 -23 426 -29 455 -27 b 526 -24 497 -24 511 -24 b 608 -17 554 -24 582 -23 b 645 -1 622 -14 644 -17 b 615 26 648 13 629 20 b 595 32 608 29 602 30 b 526 37 572 35 549 37 b 498 36 517 37 507 37 b 471 35 487 35 478 35 b 445 53 451 35 445 39 b 449 89 445 60 446 73 l 454 117 b 373 206 456 173 428 206 b 324 204 356 206 340 206 b 209 203 287 203 248 203 b 46 193 156 203 101 202 b 16 170 32 190 19 187 b 9 112 13 151 9 131 b 14 78 9 101 10 89 b 19 59 17 71 19 63 b -4 45 19 49 12 45 l -10 45 b -150 33 -58 45 -104 46 b -173 22 -158 32 -173 33 l -173 19 b -151 -13 -170 6 -168 -10 b -117 -17 -140 -16 -128 -17 b 118 -13 -37 -17 39 -13 b 397 -29 213 -13 308 -29 z"
                },
                restQuarter: {
                    x_min: 0,
                    x_max: 263,
                    y_min: -415,
                    y_max: 415,
                    ha: 830,
                    o: "m 151 -596 b 164 -563 163 -589 161 -575 b 160 -546 164 -557 161 -552 b 124 -396 148 -495 135 -446 b 122 -380 122 -390 122 -384 b 199 -255 122 -331 158 -272 b 228 -256 209 -249 217 -253 b 324 -346 274 -271 298 -310 b 353 -369 331 -356 341 -369 b 360 -367 356 -369 357 -369 b 379 -336 373 -361 379 -348 l 377 -325 b 344 -232 372 -292 366 -258 b 249 -58 301 -180 278 -117 b 242 -36 245 -49 242 -42 b 258 -7 242 -26 248 -17 b 328 78 284 20 311 45 b 354 158 344 104 354 131 b 337 216 354 177 350 196 b 213 435 294 288 249 359 b 115 575 189 487 158 536 b 78 598 105 585 92 598 b 59 592 72 598 66 596 b 39 562 45 583 39 572 b 53 527 39 550 45 539 b 168 344 98 469 125 402 b 187 307 181 328 187 317 b 153 269 187 294 176 284 b 62 213 122 252 91 235 b 40 180 48 203 40 192 b 46 158 40 173 43 166 b 99 65 60 125 79 95 b 183 -79 131 20 160 -29 b 156 -86 173 -88 164 -85 b 0 -261 58 -99 -7 -173 b 96 -557 10 -366 49 -464 b 124 -585 102 -569 109 -580 b 145 -598 132 -588 138 -598 b 151 -596 147 -598 150 -598 z"
                },
                rest8th: {
                    x_min: 0,
                    x_max: 289,
                    y_min: -260,
                    y_max: 261,
                    ha: 521,
                    o: "m 164 -374 b 212 -340 190 -373 203 -357 b 276 -190 238 -292 258 -242 b 410 285 333 -36 359 128 b 416 314 413 294 416 304 l 416 321 b 393 354 415 341 410 354 b 382 353 389 354 386 354 b 292 311 347 347 315 333 b 174 225 256 276 216 251 b 157 219 168 222 163 219 b 140 228 151 219 145 222 b 131 246 134 233 131 240 b 135 262 131 252 132 256 b 147 298 141 272 147 285 b 127 367 147 323 154 354 b 94 376 114 373 102 376 b 48 336 75 376 63 363 b 3 181 20 288 12 235 b 0 150 1 170 0 160 b 109 24 0 84 35 24 b 171 36 127 24 148 27 b 289 101 213 52 248 75 b 164 -374 256 -62 193 -213 z"
                },
                rest16th: {
                    x_min: 0,
                    x_max: 333,
                    y_min: -328,
                    y_max: 244,
                    ha: 572,
                    o: "m 209 -471 b 246 -458 222 -477 236 -468 b 307 -338 279 -425 300 -384 b 324 -226 312 -301 317 -262 b 428 161 350 -94 386 35 b 480 318 445 215 480 259 b 467 347 480 331 477 341 b 445 351 461 350 454 351 b 408 337 432 351 419 347 b 402 333 405 336 403 334 b 223 215 344 294 294 245 b 236 259 229 233 235 246 b 238 276 238 265 238 271 b 212 338 238 302 226 334 b 193 341 206 340 199 341 b 86 289 156 341 104 317 b 59 180 66 255 59 217 b 156 27 59 76 92 27 b 236 46 179 27 204 35 b 338 101 271 59 298 82 b 289 -49 312 49 302 0 b 196 -122 276 -99 235 -107 b 176 -114 187 -127 176 -127 l 176 -111 b 157 -53 177 -88 164 -72 b 69 -9 141 -7 101 -16 b 17 -48 43 -3 29 -27 b 0 -127 4 -73 0 -99 b 6 -186 0 -147 1 -167 b 82 -294 17 -262 37 -294 b 160 -276 102 -294 128 -289 b 219 -242 181 -268 203 -259 b 236 -230 223 -236 229 -230 b 243 -232 239 -230 240 -230 b 235 -275 248 -246 239 -261 b 202 -456 220 -334 202 -395 b 209 -471 202 -462 203 -468 z"
                },
                rest32nd: {
                    x_min: 0,
                    x_max: 347,
                    y_min: -498,
                    y_max: 483,
                    ha: 981,
                    o: "m 177 -716 b 217 -690 194 -720 209 -704 b 233 -655 225 -680 230 -668 b 292 -390 253 -567 275 -480 b 361 -48 312 -275 336 -161 b 452 400 393 102 422 252 b 497 629 467 477 482 553 b 500 647 498 635 500 641 b 480 691 500 665 492 684 b 464 696 475 694 469 696 b 418 674 448 696 431 685 l 361 626 b 333 611 353 618 343 612 b 308 629 325 611 317 616 b 239 667 292 651 265 661 b 204 670 228 668 216 670 b 86 559 141 670 95 628 b 85 537 86 552 85 544 b 107 416 85 495 95 455 b 161 372 114 389 134 372 b 174 373 166 372 170 372 b 226 383 192 374 209 377 b 387 478 285 402 330 444 b 364 386 379 444 364 415 b 276 271 364 323 320 298 b 265 266 272 268 268 266 b 252 276 261 266 256 269 b 143 333 229 311 186 333 b 107 327 130 333 118 330 b 43 243 62 314 46 291 b 58 145 43 210 52 179 b 150 63 68 92 99 63 b 315 132 213 63 259 98 b 266 -58 297 63 281 4 b 207 -101 259 -91 230 -96 b 186 -66 186 -107 199 -75 b 180 -50 181 -63 183 -55 b 101 -3 160 -23 135 -3 b 9 -66 59 -3 20 -32 b 0 -118 3 -84 0 -101 b 10 -196 0 -144 6 -170 b 104 -287 20 -256 52 -287 b 137 -282 114 -287 125 -287 b 184 -269 151 -281 171 -269 b 196 -275 190 -269 193 -271 b 199 -287 197 -278 199 -282 b 184 -343 199 -304 189 -325 b 181 -348 184 -346 183 -347 b 134 -595 158 -429 131 -508 b 156 -677 134 -624 150 -648 b 177 -716 158 -693 160 -713 z"
                },
                rest64th: {
                    x_min: 0,
                    x_max: 428,
                    y_min: -720,
                    y_max: 474,
                    ha: 1194,
                    o: "m 200 -1037 b 229 -1012 215 -1037 222 -1025 b 238 -984 233 -1004 236 -994 b 282 -780 248 -914 265 -848 b 386 -369 317 -644 354 -507 b 491 104 422 -212 451 -53 b 600 541 528 249 550 399 b 616 629 611 570 616 599 b 600 680 616 648 615 671 b 550 665 586 687 566 677 b 480 618 527 649 501 635 b 464 611 474 613 468 611 b 448 622 458 611 454 615 b 366 662 425 651 397 662 b 331 658 354 662 343 661 b 242 572 285 647 253 619 b 236 528 239 557 236 543 b 266 400 236 484 251 442 b 325 373 274 377 301 373 b 436 409 366 373 403 383 l 494 452 b 474 360 485 416 474 389 b 383 248 474 297 435 269 b 320 328 377 288 351 310 b 276 341 305 337 291 341 b 186 269 235 341 194 311 b 181 230 183 256 181 243 b 187 153 181 204 186 179 b 279 63 192 86 233 63 b 304 65 288 63 295 63 b 416 115 344 72 379 92 b 387 -14 406 69 397 27 b 320 -95 380 -52 369 -86 b 318 -79 320 -89 320 -84 b 223 0 305 -29 271 0 b 122 -81 171 0 135 -30 b 118 -127 120 -96 118 -112 l 118 -196 b 137 -242 118 -215 125 -229 b 209 -275 157 -266 181 -275 b 249 -269 222 -275 235 -274 b 318 -248 272 -264 294 -255 b 281 -390 315 -301 292 -344 b 276 -400 279 -393 279 -397 b 259 -420 272 -408 266 -416 b 246 -429 255 -425 251 -429 b 233 -415 242 -429 238 -426 b 176 -359 225 -389 200 -372 b 121 -346 158 -348 140 -346 b 14 -408 73 -346 27 -370 b 0 -498 4 -438 0 -468 b 6 -564 0 -520 3 -543 b 91 -635 12 -611 45 -635 b 131 -629 104 -635 117 -634 b 223 -590 163 -622 190 -603 b 166 -824 203 -671 189 -747 b 148 -912 157 -852 148 -881 b 156 -955 148 -926 150 -940 b 177 -1008 161 -972 170 -991 b 200 -1037 181 -1020 183 -1037 z"
                },
                rest128th: {
                    x_min: 1,
                    x_max: 491,
                    y_min: -711,
                    y_max: 719,
                    ha: 1430,
                    o: "m 233 -1015 b 271 -956 256 -1002 266 -981 l 314 -723 b 393 -350 337 -598 366 -474 b 543 312 442 -128 492 91 b 687 841 583 490 635 665 b 707 958 698 880 707 919 b 706 986 707 968 707 976 b 688 1025 704 999 704 1024 b 670 1027 683 1025 677 1027 b 629 1007 655 1027 639 1022 b 559 945 613 981 586 968 b 541 1004 553 968 559 991 b 456 1035 516 1024 488 1035 b 419 1030 444 1035 431 1034 b 344 953 379 1018 353 995 b 340 900 341 936 340 917 b 341 847 340 881 341 864 b 380 779 340 815 354 793 b 464 763 406 765 435 762 b 592 814 510 763 549 786 b 546 660 575 757 556 710 b 480 585 537 619 517 598 b 478 599 480 590 478 595 b 386 678 472 641 428 678 b 294 612 343 678 304 651 b 279 477 282 567 278 521 b 363 395 281 428 317 395 b 380 396 369 395 374 395 b 488 436 416 403 449 419 b 384 233 469 357 468 275 b 359 291 373 252 377 276 b 282 318 337 310 310 318 b 181 264 243 318 203 298 b 154 107 153 216 154 161 b 242 6 154 42 187 6 b 278 10 253 6 265 7 b 408 88 330 22 366 55 b 387 -1 400 56 393 27 b 301 -112 379 -55 354 -94 b 289 -65 297 -95 302 -79 b 219 -32 269 -42 245 -32 b 183 -37 207 -32 196 -35 b 112 -109 144 -46 121 -71 b 105 -219 104 -145 108 -183 b 186 -315 101 -276 134 -315 b 230 -307 199 -315 215 -312 b 324 -256 264 -295 292 -275 b 180 -491 323 -383 266 -471 b 183 -459 180 -480 180 -469 b 184 -442 184 -454 184 -448 l 184 -436 b 135 -369 184 -403 170 -383 b 102 -363 125 -364 114 -363 b 29 -399 73 -363 45 -376 b 1 -556 -4 -448 6 -503 b 109 -670 -4 -625 43 -670 b 140 -667 118 -670 130 -668 b 253 -616 180 -658 213 -638 b 238 -688 248 -644 242 -665 b 192 -959 220 -779 192 -867 b 193 -992 192 -971 192 -981 b 210 -1024 194 -1014 199 -1024 b 233 -1015 216 -1024 223 -1021 z"
                },
                dynamicPiano: {
                    x_min: -49,
                    x_max: 327,
                    y_min: -142,
                    y_max: 515,
                    ha: 657,
                    o: "m -56 -204 b -42 -202 -52 -204 -46 -203 b -19 -194 -35 -202 -26 -197 b 147 -138 35 -170 91 -151 b 249 -58 194 -127 223 -95 b 262 -29 255 -50 262 -39 b 258 -17 262 -24 261 -20 b 232 -7 252 -10 242 -7 b 210 -12 225 -7 217 -9 b 125 -40 184 -23 157 -30 b 183 140 153 19 171 79 b 251 167 207 144 230 153 b 469 518 383 262 480 382 b 357 687 472 626 420 687 b 315 678 344 687 330 684 b 204 600 279 664 240 634 b 210 704 206 635 209 670 b 215 721 212 710 215 716 b 206 733 215 727 212 730 b 180 742 197 736 189 742 b 164 734 176 742 170 740 b 1 575 108 684 36 645 b -7 557 -1 569 -7 563 b -6 553 -7 556 -7 554 b 7 547 -3 547 3 547 l 17 547 b 82 575 43 547 59 567 l 82 452 b 56 46 82 317 81 180 b 17 -66 49 7 46 -36 b -62 -173 -13 -99 -37 -135 b -71 -192 -66 -179 -71 -184 b -68 -199 -71 -193 -69 -196 b -56 -204 -65 -203 -60 -204 z m 196 258 b 197 266 197 261 197 264 b 200 510 200 347 199 429 b 233 543 210 521 222 533 b 281 560 249 554 266 560 b 340 503 310 560 333 540 b 344 461 343 488 344 474 b 321 323 344 413 333 369 b 268 272 315 300 295 281 b 196 258 245 265 220 261 z"
                },
                dynamicMezzo: {
                    x_min: -18,
                    x_max: 559,
                    y_min: -50,
                    y_max: 365,
                    ha: 415,
                    o: "m 43 -71 b 160 19 86 -71 143 -26 b 230 264 189 99 200 184 b 282 363 243 297 259 327 b 287 320 285 347 287 333 b 284 279 287 305 285 292 l 249 -12 b 275 -43 248 -29 245 -43 b 395 45 321 -43 389 3 b 462 271 406 124 436 197 b 523 387 475 310 490 348 l 523 346 b 504 130 521 274 513 202 b 501 81 501 114 501 98 b 510 3 501 55 504 29 b 580 -72 521 -48 543 -72 b 625 -63 593 -72 608 -69 b 789 50 690 -43 744 -3 b 805 72 795 56 805 63 b 798 85 805 76 802 81 b 778 94 792 91 785 94 b 755 85 770 94 763 91 l 693 40 b 675 33 685 36 680 33 b 658 52 668 33 662 39 b 645 144 651 82 645 112 b 658 448 641 246 660 346 b 606 507 658 485 638 507 b 583 504 599 507 592 505 b 495 446 547 497 521 471 b 420 373 471 423 448 399 b 413 458 418 406 418 432 b 361 507 408 490 386 507 b 320 491 347 507 333 501 b 160 307 256 444 207 382 l 160 337 b 174 488 160 387 174 438 b 156 521 174 501 173 513 b 137 526 148 524 143 526 b 109 513 127 526 118 520 b -16 399 66 477 23 439 b -26 383 -20 395 -26 389 l -26 379 b -14 370 -24 372 -20 370 b -6 372 -12 370 -9 372 b 19 376 4 374 12 376 b 36 359 32 376 36 370 b 30 330 36 350 35 341 l 30 323 b 9 -35 23 203 17 85 b 43 -71 6 -65 19 -71 z"
                },
                dynamicForte: {
                    x_min: -144,
                    x_max: 311,
                    y_min: -115,
                    y_max: 504,
                    ha: 619,
                    o: "m -101 -166 b 173 76 7 -153 150 -30 b 206 344 192 164 202 253 b 268 338 226 343 246 341 b 384 395 317 333 353 361 b 397 419 393 405 397 412 b 367 442 397 429 387 436 b 350 444 361 444 356 444 b 206 455 302 449 255 454 l 206 474 b 202 540 204 495 202 518 b 209 593 202 557 203 576 b 236 624 215 613 225 624 b 265 612 245 624 253 619 b 308 552 287 596 302 577 b 336 533 312 534 323 533 b 448 611 366 533 444 583 b 399 696 452 648 423 671 b 382 706 395 700 387 703 b 308 726 357 720 333 726 b 207 684 272 726 239 711 b 60 455 135 622 60 560 l 10 455 b -23 448 -1 455 -13 454 b -102 372 -55 426 -76 397 b -109 357 -108 367 -109 361 b -95 347 -109 353 -105 348 b -63 346 -84 346 -73 346 b 0 344 -43 344 -22 344 l 63 344 b 53 186 63 291 59 239 b 23 0 46 124 42 60 b -35 -60 10 -42 -6 -60 b -73 -52 -45 -60 -58 -58 b -91 -48 -79 -49 -85 -48 b -109 -53 -96 -48 -102 -49 b -199 -124 -143 -72 -168 -99 b -207 -137 -203 -128 -207 -132 b -194 -148 -207 -141 -203 -145 b -101 -166 -164 -160 -132 -168 z"
                },
                dynamicRinforzando: {
                    x_min: -75,
                    x_max: 322,
                    y_min: -90,
                    y_max: 325,
                    ha: 415,
                    o: "m 23 -130 b 40 -125 27 -130 33 -128 b 128 -9 81 -114 125 -53 b 145 200 132 62 141 130 b 148 238 147 212 148 225 b 308 321 184 291 245 321 b 363 314 325 321 344 318 b 377 310 369 312 373 310 b 384 311 380 310 382 310 b 464 415 410 317 464 389 b 446 433 465 429 455 429 b 390 445 428 441 409 445 b 305 429 361 445 334 438 b 167 346 252 413 202 393 b 153 325 163 338 158 333 b 148 438 154 363 151 399 b 121 468 147 456 134 468 b 101 458 115 468 108 465 b -63 310 46 409 -16 367 b -108 240 -78 289 -98 271 b 32 330 -50 256 -13 297 b 37 304 37 320 37 312 l 37 292 b 10 -101 27 161 20 30 b 23 -130 9 -120 12 -130 z"
                },
                dynamicSforzando: {
                    x_min: 0,
                    x_max: 296,
                    y_min: 0,
                    y_max: 379,
                    ha: 379,
                    o: "m 151 0 b 174 1 160 0 166 0 b 392 158 272 14 346 71 b 405 207 400 174 405 190 b 359 287 405 236 389 265 b 261 325 328 308 294 315 b 168 413 216 340 181 366 b 166 426 167 418 166 423 b 176 438 166 432 167 436 b 199 441 183 441 190 441 b 310 393 238 441 295 422 b 334 370 317 376 325 370 b 363 386 343 370 353 379 b 422 445 386 402 408 420 b 426 458 425 449 426 454 b 422 469 426 462 425 465 b 274 546 395 518 333 546 b 161 503 232 546 190 531 b 86 405 132 472 108 439 b 71 347 75 387 71 367 b 112 256 71 312 85 279 b 209 215 141 232 176 226 b 284 168 238 206 266 197 b 300 131 291 157 300 144 b 298 120 300 127 298 122 b 278 107 294 109 285 108 b 262 108 271 107 266 108 l 259 108 b 114 157 200 107 156 125 b 96 181 104 163 96 170 l 96 184 b 102 202 96 190 102 196 b 96 209 102 204 101 207 b 63 194 82 215 72 204 b 7 109 42 168 26 138 b 0 86 3 101 0 94 b 13 60 0 78 4 68 b 151 0 53 23 101 0 z"
                },
                dynamicZ: {
                    x_min: -43,
                    x_max: 331,
                    y_min: 0,
                    y_max: 328,
                    ha: 328,
                    o: "m -45 0 b -6 16 -32 0 -17 10 b 3 20 -3 16 0 19 b 144 60 49 48 96 60 b 284 22 190 60 238 46 b 348 4 305 10 327 4 b 461 75 393 4 435 30 b 468 91 464 81 467 86 b 456 104 468 95 465 99 b 287 173 402 131 348 167 b 239 176 271 174 255 176 b 168 174 217 176 194 174 b 367 340 236 236 298 294 b 459 423 402 363 432 392 b 477 454 467 431 475 442 b 474 462 477 456 475 459 b 454 472 469 469 462 472 b 432 468 446 472 439 469 b 356 448 406 461 380 455 b 210 422 307 433 258 422 b 109 442 177 422 144 428 b 94 445 104 444 99 445 b 69 433 85 445 76 442 b 27 390 56 419 39 406 b -9 343 16 373 -17 357 b 63 311 3 320 36 314 l 78 311 b 132 307 95 308 114 307 b 240 314 168 307 203 311 l 193 271 b -37 50 117 196 19 145 b -59 7 -46 36 -69 20 b -45 0 -55 3 -50 0 z"
                },
                ornamentTrill: {
                    x_min: 1,
                    x_max: 551,
                    y_min: -18,
                    y_max: 539,
                    ha: 557,
                    o: "m 321 612 b 190 602 278 605 235 605 l 190 638 b 187 693 190 652 190 667 b 161 776 184 717 193 776 b 137 747 150 776 137 766 b 130 654 135 716 131 685 l 130 596 l 52 588 b 4 539 23 585 7 570 b 1 477 3 530 1 500 b 3 448 1 461 3 448 l 3 452 b 53 432 6 436 23 432 b 134 435 75 432 102 433 b 151 117 138 328 147 223 b 170 13 153 82 157 46 b 209 -26 179 -10 193 -26 b 222 -22 213 -26 217 -24 b 269 -17 233 -16 253 -27 b 343 135 325 19 346 66 b 343 158 343 147 344 147 b 323 192 341 171 337 187 b 291 176 311 194 300 184 l 264 148 b 229 131 261 145 238 131 b 212 170 209 131 213 154 b 194 438 203 259 199 348 l 272 442 b 284 452 276 441 279 441 b 305 462 287 461 295 462 l 312 462 b 346 477 325 462 340 464 b 366 560 357 503 366 531 b 321 612 366 598 356 618 z m 759 588 b 711 560 749 592 733 570 b 588 500 671 541 631 521 b 583 533 586 514 586 524 b 560 576 577 549 577 572 b 517 550 541 582 528 564 b 416 423 482 508 452 462 b 382 353 392 397 384 370 b 387 305 380 341 386 318 b 392 275 389 295 392 285 b 409 243 393 262 393 243 b 431 262 419 243 425 255 b 521 373 459 298 488 333 b 523 354 521 366 523 360 b 520 337 523 346 521 340 b 508 295 513 323 508 310 b 530 102 508 279 524 122 b 549 66 533 88 530 66 b 577 99 563 66 572 84 b 580 131 580 109 580 121 l 580 302 b 600 347 580 318 582 337 b 701 392 632 364 665 384 b 793 518 785 409 793 435 b 759 588 793 559 785 576 z"
                },
                ornamentTurn: {
                    x_min: 0,
                    x_max: 574,
                    y_min: 0,
                    y_max: 312,
                    ha: 312,
                    o: "m 651 0 b 816 132 727 0 796 46 b 827 223 822 163 827 193 b 808 340 827 262 821 301 b 665 449 785 408 729 449 b 636 446 655 449 647 448 b 589 384 600 441 586 422 l 602 300 b 611 285 603 291 605 285 b 621 288 613 285 616 287 b 655 295 632 294 644 295 b 711 284 674 295 693 289 b 773 209 740 275 773 232 b 697 156 773 184 734 160 b 664 154 685 154 675 154 b 579 168 635 154 608 158 b 455 242 533 186 495 213 b 261 400 387 291 331 354 b 160 432 225 422 190 432 b 20 328 98 432 49 392 b 0 229 6 295 0 262 b 30 71 0 176 14 122 b 144 3 43 29 96 3 b 168 6 153 3 160 4 b 248 122 233 20 248 39 b 246 147 248 124 248 135 b 226 177 243 164 239 177 b 206 170 220 177 215 174 b 144 154 186 158 166 154 b 79 170 122 154 101 160 b 53 202 62 179 53 189 b 60 228 53 209 55 217 b 161 281 81 261 120 281 b 183 279 168 281 176 281 b 325 190 243 269 284 229 b 572 16 402 124 475 53 b 651 0 598 6 625 0 z"
                },
                ornamentTurnSlash: {
                    x_min: 0,
                    x_max: 574,
                    y_min: -106,
                    y_max: 405,
                    ha: 511,
                    o: "m 441 -153 b 456 -60 455 -118 456 -89 b 455 81 455 -14 455 33 b 572 14 491 55 530 30 b 651 -1 598 4 625 -1 b 816 131 727 -1 796 45 b 827 222 822 161 827 192 b 808 338 827 261 821 300 b 665 448 785 406 729 448 b 636 445 655 448 647 446 b 589 383 600 439 586 420 l 602 298 b 611 284 603 289 605 284 b 621 287 613 284 616 285 b 655 294 632 292 644 294 b 711 282 674 294 693 288 b 773 207 740 274 773 230 b 697 154 773 183 734 158 b 664 153 685 153 675 153 b 579 167 635 153 608 157 b 455 240 533 183 495 212 b 454 242 455 240 455 242 l 454 337 b 452 488 454 386 452 439 b 433 570 452 517 451 546 b 425 583 431 575 431 583 l 422 583 b 403 566 415 582 408 573 b 402 546 400 560 402 553 l 397 287 b 261 399 353 325 310 366 b 160 431 225 420 190 431 b 20 327 98 431 48 390 b 0 228 6 294 0 261 b 30 69 0 174 14 121 b 144 1 43 27 96 1 b 168 4 153 1 160 3 b 248 121 233 19 248 37 b 246 145 248 122 248 134 b 226 176 243 163 239 176 b 206 168 220 176 215 173 b 144 153 186 157 166 153 b 79 168 122 153 101 158 b 53 200 62 177 53 187 b 60 226 53 207 55 216 b 161 279 79 259 120 279 b 183 278 168 279 176 279 b 325 189 243 266 282 226 b 395 130 348 168 372 148 b 393 71 393 109 393 89 b 441 -153 390 -6 402 -78 z"
                },
                ornamentMordent: {
                    x_min: 0,
                    x_max: 700,
                    y_min: 0,
                    y_max: 497,
                    ha: 497,
                    o: "m 513 0 b 528 39 526 14 527 27 b 531 72 531 50 531 60 b 528 138 531 94 528 117 l 528 347 b 552 359 537 354 544 359 b 579 338 560 359 569 353 b 674 217 609 297 639 255 b 719 190 690 200 704 190 b 759 215 732 190 744 197 b 940 395 815 279 877 337 b 1001 490 968 422 986 455 b 1008 513 1004 495 1008 505 b 1002 524 1008 517 1007 521 b 968 516 994 530 978 524 b 960 508 965 513 963 510 b 798 356 900 464 848 410 b 778 341 791 347 783 341 b 757 354 772 341 765 346 b 661 475 720 392 690 432 b 611 517 644 504 629 517 b 563 498 598 517 583 511 b 527 471 550 490 539 481 l 527 570 b 492 716 526 619 523 671 b 472 677 480 704 472 694 b 465 399 474 585 468 491 b 439 366 456 387 448 376 b 384 320 415 336 399 320 b 330 367 369 320 354 336 b 325 376 328 369 327 373 b 226 490 291 413 265 456 b 189 505 213 500 202 505 b 157 491 177 505 167 500 b 0 229 75 420 0 346 b 1 202 0 220 0 212 b 22 215 12 203 16 209 b 124 327 55 252 89 289 b 147 343 132 337 140 343 b 171 323 156 343 164 336 b 266 197 196 276 232 236 b 337 157 291 170 314 157 b 410 207 361 157 386 174 b 461 274 428 229 444 252 b 462 166 461 238 461 202 b 513 0 465 108 487 55 z"
                },
                ornamentShortTrill: {
                    x_min: 0,
                    x_max: 747,
                    y_min: 0,
                    y_max: 243,
                    ha: 243,
                    o: "m 379 0 b 428 14 395 0 410 4 b 474 56 445 26 461 39 b 552 157 500 89 526 122 b 566 168 556 163 560 168 b 575 157 569 168 572 166 b 664 36 592 107 628 72 b 733 1 685 13 710 1 b 802 35 757 1 780 13 b 1007 249 871 105 940 177 b 1067 324 1028 272 1054 295 b 1076 340 1068 330 1076 334 b 1073 346 1076 341 1076 343 b 1057 350 1068 348 1063 350 b 1047 347 1053 350 1050 350 b 1001 310 1031 336 1015 324 l 857 157 b 844 143 852 153 848 143 b 835 150 841 143 838 144 b 757 242 815 186 780 209 b 685 298 739 268 713 284 b 641 310 670 305 655 310 b 590 288 625 310 608 304 b 497 179 554 256 527 215 b 480 164 490 170 485 164 b 462 179 474 164 469 168 b 372 295 436 220 405 258 b 278 344 346 324 312 344 b 199 310 252 344 226 334 b 92 196 161 274 128 233 b 0 24 46 148 23 89 b 42 48 22 27 32 37 b 156 168 84 85 114 132 b 196 192 174 184 186 192 b 228 158 206 192 215 181 b 312 36 252 114 282 75 b 379 0 331 12 354 0 z"
                },
                ornamentTremblement: {
                    x_min: 0,
                    x_max: 982,
                    y_min: 0,
                    y_max: 224,
                    ha: 224,
                    o: "m 0 0 b 63 36 30 12 48 23 b 157 124 94 66 125 94 b 177 135 164 131 170 135 b 196 122 183 135 189 131 b 268 40 217 94 245 68 b 323 6 288 16 304 6 b 369 20 336 6 350 10 b 412 53 384 29 399 40 b 501 145 442 84 472 114 b 523 158 508 154 516 158 b 543 145 528 158 536 154 b 641 45 576 112 608 78 b 698 17 658 27 677 17 b 729 23 708 17 719 20 b 804 65 756 32 780 46 b 904 154 837 95 871 124 b 920 163 910 160 916 163 b 936 153 924 163 930 160 b 1024 60 965 121 996 92 b 1112 13 1053 29 1080 13 b 1184 39 1135 13 1158 22 b 1359 194 1248 84 1305 138 b 1413 301 1388 223 1403 261 b 1404 323 1417 315 1413 323 b 1391 320 1400 323 1395 321 b 1344 294 1375 314 1358 307 b 1224 186 1305 258 1269 216 b 1194 173 1212 179 1202 173 b 1165 193 1184 173 1175 179 b 1096 271 1145 222 1122 248 b 1001 318 1061 302 1031 318 b 903 268 969 318 937 301 b 806 186 871 239 841 210 b 782 174 796 179 789 174 b 756 193 773 174 765 180 b 652 291 729 232 693 266 b 596 308 634 302 615 308 b 530 278 573 308 552 298 l 415 168 b 393 157 408 161 400 157 b 373 171 387 157 380 161 b 305 245 353 197 330 222 b 248 276 285 266 266 278 b 189 245 229 276 210 266 b 81 144 156 209 120 174 b 0 0 33 109 26 56 z"
                },
                ornamentPrecompAppoggTrill: {
                    x_min: 0,
                    x_max: 1066,
                    y_min: -50,
                    y_max: 533,
                    ha: 583,
                    o: "m 187 -46 b 213 -14 197 -37 204 -26 b 285 151 251 36 266 94 b 304 189 294 177 297 189 b 337 168 311 189 320 181 b 458 33 386 131 415 76 b 495 12 472 19 484 12 b 531 40 508 12 518 22 b 580 168 557 79 569 124 b 622 235 592 213 603 235 b 683 194 636 235 655 222 b 838 26 737 140 791 86 b 919 -33 860 -1 881 -39 b 984 53 960 -27 971 19 b 1022 156 998 86 1008 122 b 1054 190 1032 179 1041 190 b 1089 167 1063 190 1074 183 b 1208 32 1129 122 1171 78 b 1244 10 1221 17 1231 10 b 1273 22 1253 10 1263 14 b 1496 206 1352 78 1427 137 b 1535 310 1526 236 1535 272 b 1531 359 1535 325 1534 343 b 1496 343 1515 360 1506 351 l 1309 192 b 1269 167 1289 176 1279 167 b 1234 199 1260 167 1251 177 b 1122 324 1200 243 1168 289 b 1074 344 1106 337 1089 344 b 1014 301 1051 344 1030 328 b 952 144 985 252 971 197 b 933 121 946 128 940 121 b 910 137 927 121 920 125 b 850 210 888 161 870 186 b 687 369 799 266 750 325 b 631 390 665 383 647 390 b 567 327 602 390 580 369 b 527 199 554 284 543 242 b 508 168 520 179 514 168 b 482 192 503 168 495 177 b 353 328 444 240 405 292 b 312 343 338 338 324 343 b 266 297 292 343 276 327 b 204 125 248 239 232 180 b 143 79 193 102 173 79 b 92 122 117 79 105 102 b 81 154 86 131 84 143 b 48 423 59 242 50 333 b 45 544 46 464 45 504 b 53 730 45 606 48 668 b 40 768 55 744 52 766 b 13 730 19 770 14 747 b 0 514 7 658 -1 586 b 26 122 3 383 6 252 b 75 -36 35 66 40 10 b 134 -72 92 -59 112 -72 b 187 -46 151 -72 170 -63 z"
                },
                ornamentPrecompSlideTrillDAnglebert: {
                    x_min: 0,
                    x_max: 1088,
                    y_min: -380,
                    y_max: 252,
                    ha: 632,
                    o: "m 560 -539 b 439 -481 527 -497 484 -485 b 354 -461 409 -478 380 -477 b 131 -154 236 -389 161 -285 b 124 -98 127 -135 124 -117 b 196 55 124 -40 148 10 b 308 99 230 86 268 99 b 399 81 337 99 367 92 b 514 22 441 66 477 43 b 619 -30 567 -9 590 -30 b 719 17 642 -30 670 -16 b 861 131 769 52 818 88 b 899 150 874 144 887 150 b 936 117 913 150 926 138 b 965 43 948 94 956 68 b 1007 -1 973 24 978 -1 b 1048 30 1025 -1 1037 16 b 1070 65 1057 40 1064 52 b 1110 148 1084 92 1096 121 b 1145 190 1120 164 1120 190 b 1191 153 1169 192 1179 168 b 1256 29 1218 115 1231 68 b 1292 1 1267 10 1277 1 b 1320 10 1300 1 1309 4 b 1369 48 1339 19 1355 33 b 1515 196 1418 96 1464 148 b 1567 343 1558 238 1567 287 b 1555 363 1565 357 1562 363 b 1539 356 1551 363 1547 360 b 1433 268 1502 330 1466 301 b 1335 171 1401 236 1374 199 b 1310 163 1325 166 1318 163 b 1286 183 1302 163 1293 168 b 1218 311 1264 226 1247 272 b 1164 351 1200 337 1182 351 b 1110 308 1146 351 1128 337 b 1031 176 1084 265 1058 219 b 1015 161 1025 166 1021 161 b 999 179 1009 161 1005 167 b 955 279 985 213 973 248 b 913 307 943 300 930 307 b 887 302 904 307 896 305 b 852 281 874 298 863 291 b 693 167 804 236 747 204 b 612 140 667 150 639 140 b 549 157 592 140 570 145 b 403 220 503 181 452 202 b 271 248 360 236 315 248 b 179 229 239 248 209 242 b 0 -29 65 180 0 85 b 9 -104 0 -53 3 -78 b 397 -526 56 -317 183 -464 b 505 -547 432 -536 468 -547 b 560 -539 524 -547 541 -544 z"
                },
                ornamentPrecompSlideTrillBach: {
                    x_min: 0,
                    x_max: 1185,
                    y_min: -380,
                    y_max: 465,
                    ha: 845,
                    o: "m 624 -544 b 642 -528 638 -543 642 -537 b 639 -514 642 -524 642 -520 b 590 -444 629 -487 609 -467 b 523 -413 573 -422 553 -410 b 498 -415 514 -415 507 -415 b 399 -389 464 -415 431 -405 b 89 -157 281 -330 176 -255 b 72 -117 78 -144 72 -131 b 73 -101 72 -111 72 -107 b 187 186 91 3 147 91 b 246 230 200 216 222 230 b 300 209 262 230 281 223 b 456 48 359 163 403 101 b 540 -10 494 10 518 -10 b 625 59 566 -10 589 13 b 690 148 648 88 668 118 b 711 167 697 160 704 167 b 733 153 719 167 724 163 b 844 14 769 105 808 60 b 903 -42 873 -23 886 -42 b 973 -1 919 -42 937 -27 b 1008 33 986 7 996 20 b 1048 81 1021 48 1035 65 b 1050 37 1048 66 1050 52 b 1047 -24 1050 17 1048 -3 b 1038 -275 1038 -108 1040 -192 l 1037 -289 b 1045 -302 1037 -295 1038 -301 b 1068 -284 1056 -304 1064 -292 b 1084 -242 1076 -271 1081 -256 b 1099 -109 1096 -199 1099 -154 b 1106 158 1099 -19 1106 71 b 1128 187 1113 167 1120 177 b 1168 223 1143 212 1155 223 b 1210 193 1179 223 1191 213 b 1220 183 1214 190 1215 186 b 1329 36 1261 138 1292 84 b 1374 7 1345 16 1358 7 b 1411 20 1384 7 1395 12 b 1479 84 1437 37 1459 59 b 1610 235 1521 135 1564 186 b 1706 403 1655 282 1695 334 b 1614 346 1663 400 1637 373 b 1464 170 1564 287 1515 228 b 1440 150 1453 156 1447 150 b 1414 173 1433 150 1426 158 b 1283 336 1371 228 1333 288 b 1220 366 1261 356 1240 366 b 1148 318 1194 366 1169 350 b 1103 255 1133 297 1119 275 b 1097 301 1102 271 1100 285 b 1099 334 1099 312 1099 324 b 1092 428 1099 367 1094 397 b 1071 647 1087 501 1079 575 b 1058 670 1071 657 1071 670 b 1035 648 1047 670 1038 661 b 1018 516 1024 605 1015 560 b 1041 203 1025 412 1037 307 b 1043 180 1041 196 1043 187 b 992 127 1027 161 1009 143 b 965 111 981 117 972 111 b 936 132 955 111 946 120 b 829 268 900 179 867 225 b 760 317 801 301 780 317 b 691 258 739 317 719 297 b 605 147 664 219 641 177 b 589 138 599 141 593 138 b 572 148 583 138 579 141 b 415 317 520 206 467 261 b 327 372 390 343 366 366 b 300 373 317 373 308 373 b 154 295 239 373 190 348 b 55 138 120 243 85 192 b 0 -53 22 79 0 13 b 160 -317 0 -156 49 -252 b 209 -354 177 -327 192 -343 b 510 -531 305 -419 397 -495 b 593 -547 537 -540 564 -547 b 624 -544 603 -547 613 -546 z"
                },
                ornamentPrecompTrillSuffixDandrieu: {
                    x_min: 0,
                    x_max: 1003,
                    y_min: -20,
                    y_max: 521,
                    ha: 541,
                    o: "m 791 -16 b 844 33 812 -3 829 14 b 981 271 900 107 937 190 b 994 288 984 278 985 288 b 1009 269 1004 288 1007 278 b 1077 112 1034 217 1051 163 b 1158 43 1103 62 1129 43 b 1231 69 1179 43 1204 55 b 1348 189 1280 98 1315 143 b 1444 451 1407 271 1444 357 b 1431 547 1444 482 1440 514 b 1188 750 1401 665 1299 750 b 1158 747 1178 750 1168 749 b 1079 684 1119 742 1089 727 b 1063 632 1076 665 1071 648 b 1056 609 1058 622 1056 615 b 1071 599 1056 602 1060 599 b 1086 600 1076 599 1080 600 b 1130 605 1102 603 1116 605 b 1244 569 1171 605 1210 595 b 1349 346 1322 511 1349 433 b 1348 312 1349 334 1349 324 b 1289 197 1345 266 1325 228 b 1238 174 1270 181 1253 174 b 1188 215 1220 174 1202 187 b 1145 308 1172 245 1159 276 b 1096 413 1129 343 1120 382 b 1053 438 1084 431 1068 438 b 1011 413 1038 438 1022 431 b 955 324 989 384 971 354 b 850 127 920 258 886 192 b 838 112 847 121 842 112 b 824 128 828 109 825 121 b 802 193 815 150 809 171 b 730 400 779 264 766 337 b 688 431 719 420 703 431 b 647 403 674 431 660 422 b 606 338 632 383 619 361 b 513 167 575 282 546 223 b 480 122 503 150 498 122 b 452 171 459 122 459 153 b 420 255 442 199 432 228 b 337 408 399 308 380 364 b 276 436 317 428 297 436 b 215 397 253 436 230 423 b 23 72 148 289 81 184 b 0 29 17 59 0 40 b 7 17 0 23 1 20 b 59 58 26 7 46 39 b 190 276 111 127 143 206 b 216 301 202 292 207 301 b 245 279 223 301 232 294 b 311 166 278 248 292 206 b 367 16 331 117 346 65 b 402 -19 377 -7 387 -19 b 438 -4 412 -19 423 -13 b 518 88 474 17 495 55 b 628 284 562 150 592 216 b 657 223 648 266 651 243 b 717 13 677 154 696 84 b 755 -29 726 -16 737 -29 b 791 -16 765 -29 776 -24 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefix: {
                    x_min: 0,
                    x_max: 1246,
                    y_min: -30,
                    y_max: 296,
                    ha: 326,
                    o: "m 360 -43 b 559 59 445 -43 503 7 b 698 236 615 111 652 179 b 714 248 704 243 710 248 b 727 235 719 248 721 243 l 848 42 b 883 12 860 22 870 12 b 917 32 891 12 903 19 b 946 62 927 42 939 50 b 1037 192 972 108 1009 147 b 1057 210 1044 204 1051 210 b 1076 190 1063 210 1068 203 l 1176 12 b 1215 -19 1188 -9 1201 -19 b 1250 -6 1225 -19 1237 -14 b 1284 27 1264 3 1274 16 b 1380 190 1323 78 1351 135 b 1395 210 1384 197 1385 210 b 1413 190 1405 210 1410 197 b 1508 40 1436 134 1467 85 b 1564 3 1529 14 1547 3 b 1617 32 1580 3 1597 12 b 1767 238 1678 92 1719 167 b 1794 310 1781 259 1791 282 b 1752 294 1776 317 1764 304 b 1656 164 1711 258 1689 206 b 1629 144 1646 151 1637 144 b 1603 161 1620 144 1613 150 b 1502 315 1562 207 1525 258 b 1452 357 1490 344 1470 357 b 1397 320 1431 357 1411 344 b 1316 170 1368 271 1345 219 b 1280 127 1306 154 1303 127 b 1244 171 1256 127 1254 154 b 1145 337 1210 226 1179 282 b 1110 363 1135 354 1122 363 b 1070 338 1097 363 1084 354 b 1050 311 1063 330 1057 320 b 959 181 1017 271 992 223 b 939 167 950 173 945 167 b 920 184 933 167 927 173 b 818 343 887 238 852 291 b 759 395 795 377 778 395 b 701 344 742 395 724 377 b 698 338 700 341 700 340 b 544 154 652 272 605 207 b 412 98 501 117 458 98 b 304 130 377 98 341 108 b 95 373 204 187 144 275 b 58 426 85 393 82 428 b 19 366 26 426 26 389 b 0 307 13 346 0 327 b 4 287 0 300 1 294 b 174 36 49 194 91 102 b 360 -43 230 -9 289 -43 z"
                },
                ornamentPrecompDoubleCadenceUpperPrefixTurn: {
                    x_min: 0,
                    x_max: 1226,
                    y_min: -237,
                    y_max: 436,
                    ha: 673,
                    o: "m 1279 -341 b 1293 -252 1293 -307 1295 -278 b 1277 36 1287 -156 1282 -59 l 1273 118 b 1318 176 1289 137 1303 157 b 1349 203 1332 193 1342 203 b 1378 168 1359 203 1367 192 b 1456 35 1401 122 1428 78 b 1511 -12 1476 3 1493 -12 b 1568 23 1526 -12 1544 0 b 1597 53 1578 32 1588 42 b 1705 186 1629 101 1669 143 b 1761 284 1728 216 1751 246 b 1765 300 1763 288 1765 295 b 1763 307 1765 302 1765 305 b 1737 302 1754 311 1744 308 b 1718 287 1729 298 1725 292 b 1598 145 1673 245 1637 194 b 1578 130 1590 135 1584 130 b 1557 147 1571 130 1565 135 b 1447 321 1516 202 1488 265 b 1403 351 1433 341 1417 351 b 1358 323 1388 351 1372 341 b 1269 209 1329 285 1299 248 b 1254 521 1264 314 1259 418 b 1228 616 1253 554 1247 588 b 1218 628 1224 621 1223 628 l 1215 628 b 1201 613 1210 626 1202 619 b 1200 600 1200 609 1200 605 l 1200 586 b 1211 348 1204 507 1207 428 b 1217 166 1214 288 1215 226 b 1202 181 1212 168 1208 174 b 1094 334 1168 233 1130 284 b 1048 366 1079 356 1064 366 b 1004 331 1034 366 1018 354 b 904 154 969 275 930 220 b 873 202 887 171 880 187 b 778 356 845 256 819 311 b 737 379 763 372 750 379 b 698 353 724 379 711 370 l 621 232 b 415 114 570 154 495 114 b 302 138 377 114 340 121 b 73 400 187 192 117 284 b 55 420 69 415 62 420 b 42 410 50 420 45 416 b 0 292 23 373 0 334 b 4 262 0 282 1 272 b 168 39 32 168 92 99 b 359 -26 225 -6 292 -26 b 585 76 446 -26 530 10 b 668 202 616 115 641 160 b 693 228 680 219 687 228 b 720 203 700 228 707 219 b 801 63 752 160 775 111 b 844 7 812 42 818 7 b 910 66 877 6 894 39 b 923 94 916 75 919 85 b 995 219 945 137 968 179 b 1025 184 1009 210 1017 197 b 1119 56 1054 141 1087 98 b 1166 20 1138 32 1152 20 b 1215 50 1181 20 1195 30 b 1221 56 1217 52 1218 55 b 1228 -163 1223 -17 1225 -89 b 1279 -341 1231 -223 1251 -278 z"
                },
                ornamentPrecompTrillLowerSuffix: {
                    x_min: 0,
                    x_max: 833,
                    y_min: -309,
                    y_max: 319,
                    ha: 628,
                    o: "m 778 -444 b 801 -445 785 -444 793 -445 b 1037 -338 894 -445 969 -397 b 1200 37 1149 -240 1200 -109 b 1084 406 1200 171 1172 300 b 1024 444 1064 431 1043 444 b 960 390 999 444 978 426 b 841 163 923 314 886 236 b 812 128 832 150 827 128 b 786 167 796 130 793 153 b 660 418 744 251 716 341 b 599 459 639 445 619 459 b 541 410 577 459 557 444 b 439 197 507 340 474 269 b 422 179 435 190 435 179 b 338 393 392 251 379 328 b 275 439 320 423 298 439 b 212 396 253 439 230 425 b 71 219 170 333 128 268 b 0 45 17 173 16 112 b 68 98 32 62 50 78 b 194 264 112 150 153 209 b 230 292 209 282 219 292 b 264 261 240 292 251 282 b 274 242 268 255 269 248 b 346 46 304 179 325 112 b 376 10 351 32 354 10 b 412 35 392 10 403 22 b 452 107 429 56 441 82 b 541 291 481 168 511 230 b 556 307 547 302 552 307 b 573 295 562 307 567 302 b 624 217 595 272 611 246 b 721 1 657 145 685 72 b 755 -27 732 -19 742 -27 b 786 -16 765 -27 775 -24 b 857 73 819 7 840 39 b 952 256 887 134 920 194 b 978 289 963 279 969 289 b 1009 262 985 289 994 281 b 1030 235 1017 253 1024 245 b 1110 -4 1071 161 1099 81 b 1116 -68 1113 -26 1116 -48 b 1009 -243 1116 -140 1090 -200 b 848 -291 956 -272 901 -291 b 730 -261 809 -291 770 -282 b 696 -248 714 -252 703 -248 b 671 -284 684 -248 678 -258 l 662 -312 b 657 -357 658 -330 657 -344 b 744 -439 657 -403 683 -425 z"
                },
                brassScoop: {
                    x_min: 0,
                    x_max: 312,
                    y_min: -390,
                    y_max: 28,
                    ha: 418,
                    o: "m 0 -562 b 393 -256 171 -504 307 -412 b 449 -39 431 -189 449 -115 b 448 -1 449 -26 449 -14 b 433 40 446 14 448 40 b 408 -3 410 40 412 14 b 396 -66 403 -23 402 -46 b 45 -397 346 -243 209 -337 b 0 -451 13 -409 1 -423 b 0 -562 -1 -485 0 -520 z"
                },
                brassDoitMedium: {
                    x_min: 0,
                    x_max: 476,
                    y_min: -50,
                    y_max: 333,
                    ha: 383,
                    o: "m 16 -72 b 27 -71 19 -72 23 -72 b 215 -33 89 -56 153 -48 b 521 114 327 -7 435 35 b 685 432 615 199 691 295 b 670 480 684 449 688 475 b 642 441 654 482 648 456 b 403 183 599 321 513 240 b 79 89 301 130 192 105 b 0 -1 -12 76 0 76 b 0 -50 0 -17 1 -33 b 16 -72 0 -65 3 -72 z"
                },
                brassFallLipShort: {
                    x_min: 0,
                    x_max: 298,
                    y_min: -344,
                    y_max: 65,
                    ha: 409,
                    o: "m 396 -495 b 420 -461 412 -487 418 -474 b 429 -382 428 -435 429 -409 b 426 -330 429 -364 428 -347 b 285 -6 410 -209 356 -104 b 98 94 239 59 173 94 b 39 86 79 94 58 92 b 0 49 20 81 0 73 l 0 -52 b 10 -69 0 -62 1 -69 b 20 -68 13 -69 16 -69 b 88 -56 45 -59 66 -56 b 261 -160 156 -56 213 -95 b 396 -495 333 -259 382 -369 z"
                },
                brassLiftMedium: {
                    x_min: 0,
                    x_max: 807,
                    y_min: 0,
                    y_max: 838,
                    ha: 838,
                    o: "m 50 0 b 55 1 52 0 53 0 b 58 23 65 7 59 16 b 55 58 56 36 55 48 b 130 117 55 99 75 112 b 220 213 202 121 220 141 b 315 308 220 289 238 308 l 336 308 b 408 380 393 310 406 321 b 461 452 409 438 416 452 b 485 451 468 452 477 451 b 569 510 531 448 556 464 b 573 543 572 520 572 531 b 657 619 580 605 595 618 b 698 621 670 619 684 619 b 788 700 749 625 778 649 b 798 778 792 726 793 752 b 873 857 806 841 809 845 b 985 950 927 867 973 887 b 1084 1047 1002 1035 1004 1034 b 1162 1128 1133 1056 1162 1087 b 1146 1182 1162 1145 1158 1164 b 1125 1207 1140 1191 1136 1207 l 1122 1207 b 1110 1191 1113 1205 1110 1198 b 1112 1174 1110 1185 1112 1178 b 1048 1110 1109 1126 1096 1113 b 1028 1109 1043 1110 1035 1109 b 939 1022 969 1102 948 1081 b 845 922 929 949 917 936 b 746 812 773 909 753 886 b 744 780 744 802 744 791 b 635 681 737 700 717 683 b 524 583 553 680 536 665 b 439 510 514 520 503 510 b 357 431 377 510 360 492 l 357 406 b 314 364 356 379 343 364 b 238 361 288 364 264 364 b 173 300 202 357 180 334 b 167 245 168 281 167 262 b 105 174 166 192 157 180 b 75 171 95 173 85 171 b 6 112 30 166 14 153 b 0 73 1 98 0 85 b 37 10 0 45 13 26 b 50 0 42 7 46 0 z"
                },
                brassFallRoughMedium: {
                    x_min: 0,
                    x_max: 791,
                    y_min: 0,
                    y_max: 819,
                    ha: 819,
                    o: "m 1117 0 b 1139 101 1129 26 1139 71 b 1138 121 1139 109 1139 115 b 1084 193 1125 171 1110 193 b 1044 183 1073 193 1060 189 b 1022 177 1035 179 1028 177 b 1007 209 1012 177 1008 186 b 876 324 1004 292 959 330 b 799 317 850 321 825 320 b 759 354 772 314 755 320 b 760 373 760 360 760 366 b 759 392 760 379 760 384 b 681 477 753 451 730 477 b 654 474 672 477 664 475 b 606 467 638 471 622 468 b 586 465 599 465 592 465 b 564 481 570 465 564 469 b 569 505 564 487 566 495 b 575 553 572 521 575 537 b 572 585 575 564 573 575 b 481 665 560 657 539 668 b 412 665 458 664 435 665 b 382 690 392 667 382 672 b 383 700 382 693 383 696 b 386 773 387 724 387 749 b 297 858 382 828 351 857 b 229 861 274 858 251 858 b 190 897 207 863 193 871 b 163 1012 186 936 180 976 b 79 1084 145 1050 124 1084 b 66 1083 75 1084 71 1083 b 43 1096 49 1081 43 1087 b 48 1112 43 1100 45 1106 b 53 1130 52 1119 53 1125 b 39 1169 53 1145 45 1158 b 26 1179 36 1175 30 1179 b 16 1171 22 1179 17 1176 b 0 1103 10 1149 0 1126 b 9 1067 0 1092 1 1079 b 91 1021 26 1031 52 1018 b 145 978 122 1024 141 1011 b 156 913 147 956 151 935 b 291 795 170 831 210 795 b 346 768 337 795 346 796 b 344 743 346 760 344 753 b 343 716 344 733 343 724 b 455 600 343 651 390 602 b 505 605 471 599 490 605 b 528 598 514 605 523 603 b 536 579 534 592 536 586 b 524 523 536 562 526 541 b 523 505 524 517 523 511 b 621 405 523 442 560 405 b 639 406 626 405 634 406 b 677 413 652 408 664 410 b 701 416 687 415 696 416 b 721 392 716 416 721 410 b 720 373 721 386 720 380 b 831 255 714 301 759 252 b 897 261 854 255 876 261 b 926 262 909 261 919 262 b 969 197 963 262 965 252 b 971 184 969 193 971 189 b 1031 115 979 137 998 115 b 1071 122 1043 115 1056 118 b 1096 130 1079 125 1086 127 b 1087 59 1094 107 1087 82 b 1117 0 1087 37 1094 17 z"
                },
                brassBend: {
                    x_min: 0,
                    x_max: 381,
                    y_min: 0,
                    y_max: 367,
                    ha: 367,
                    o: "m 298 0 b 472 50 359 0 418 14 b 537 135 501 71 530 92 b 543 216 543 163 543 190 l 543 266 b 544 308 543 281 543 295 b 549 433 546 354 549 395 b 543 507 549 459 547 482 b 533 528 541 516 544 528 b 511 508 524 528 514 520 b 508 478 510 498 508 488 b 504 318 507 425 504 372 b 505 264 504 300 505 282 b 446 181 505 220 484 199 b 294 150 396 160 344 150 b 92 194 226 150 158 167 b 45 269 62 207 45 230 b 46 359 46 300 46 328 b 37 497 46 405 45 451 b 27 523 36 507 37 523 b 4 498 14 524 6 513 b 3 481 3 492 3 487 b 0 409 1 456 0 433 b 4 228 0 348 4 288 b 3 177 4 210 4 194 b 68 53 1 125 20 84 b 200 10 108 27 154 17 b 298 0 233 4 266 0 z"
                },
                brassMuteClosed: {
                    x_min: 0,
                    x_max: 274,
                    y_min: 0,
                    y_max: 260,
                    ha: 260,
                    o: "m 203 0 b 209 1 206 0 207 0 b 216 13 215 4 216 9 l 215 27 l 215 153 b 216 161 216 156 216 158 b 372 164 268 163 318 164 b 395 184 383 164 395 166 l 395 189 b 357 229 392 209 386 229 b 219 228 311 229 265 228 l 223 310 b 209 357 225 328 219 344 b 189 374 203 364 197 374 b 184 373 187 374 186 373 b 177 359 179 372 177 366 l 177 348 l 173 222 l 39 222 b 0 206 12 222 0 219 b 10 174 0 199 3 189 b 46 157 19 157 30 157 b 108 160 68 158 88 160 b 171 161 130 161 150 161 l 167 58 b 184 16 167 40 171 26 b 203 0 192 12 196 0 z"
                },
                brassMuteOpen: {
                    x_min: 1,
                    x_max: 313,
                    y_min: 0,
                    y_max: 309,
                    ha: 309,
                    o: "m 265 0 b 451 189 363 7 452 88 l 451 215 b 348 383 441 285 405 343 b 209 445 288 426 248 445 b 84 379 168 445 132 420 b 69 364 79 373 73 369 b 1 213 30 323 1 275 b 230 0 1 88 94 0 z m 210 62 b 128 73 181 62 154 66 b 40 171 71 91 42 125 b 52 226 40 187 45 206 b 197 374 79 295 130 344 b 228 382 207 380 217 382 b 300 361 252 382 276 370 b 374 308 328 350 353 331 b 410 223 397 284 410 253 b 393 163 410 202 405 181 b 210 62 354 91 288 63 z"
                },
                brassFlip: {
                    x_min: 0,
                    x_max: 402,
                    y_min: 0,
                    y_max: 361,
                    ha: 361,
                    o: "m 579 0 b 511 153 579 68 557 117 b 52 504 359 271 206 387 b 29 520 45 510 39 520 b 20 517 26 520 23 518 b 0 477 3 510 0 494 l 0 125 b 17 20 1 92 1 56 b 40 84 37 40 40 60 b 42 287 40 151 42 219 l 42 363 z"
                },
                brassJazzTurn: {
                    x_min: 0,
                    x_max: 646,
                    y_min: 0,
                    y_max: 212,
                    ha: 212,
                    o: "m 310 0 b 367 33 327 0 344 10 b 389 55 374 40 382 49 b 490 145 423 85 456 114 b 507 154 495 151 501 154 b 524 144 513 154 517 151 b 598 72 547 120 575 98 b 700 24 625 42 662 24 b 765 43 721 24 744 30 b 893 147 812 72 855 105 b 930 212 910 166 923 186 b 912 215 923 213 917 215 b 871 199 896 215 883 209 b 812 153 852 183 832 167 b 789 144 805 148 796 144 b 773 156 782 144 776 147 b 691 251 757 199 720 222 b 603 301 658 282 631 301 b 527 258 580 301 556 288 b 420 156 494 222 455 190 b 399 143 412 147 405 143 b 377 157 392 143 386 147 b 259 282 340 200 300 242 b 219 305 245 298 232 305 b 177 279 204 305 192 297 b 55 127 137 228 95 177 b 0 52 36 104 20 79 b 14 50 6 50 10 50 b 53 66 32 50 45 58 b 115 131 75 88 98 108 b 135 148 124 143 130 148 b 157 132 141 148 148 143 b 252 33 186 96 219 65 b 310 0 275 12 292 0 z"
                },
                brassSmear: {
                    x_min: 0,
                    x_max: 334,
                    y_min: 0,
                    y_max: 151,
                    ha: 151,
                    o: "m 321 0 b 475 125 390 0 436 43 b 481 143 478 131 481 137 b 475 154 481 147 480 151 b 449 148 468 158 458 154 b 395 132 432 137 413 132 b 343 140 377 132 360 137 b 229 194 301 148 266 173 b 168 217 206 209 186 217 b 109 192 148 217 130 209 b 0 26 59 148 32 89 b 59 63 32 29 45 48 b 98 84 72 78 84 84 b 130 73 108 84 118 81 b 213 26 157 58 183 37 b 321 0 255 9 289 0 z"
                },
                stringsDownBow: {
                    x_min: 0,
                    x_max: 306,
                    y_min: 0,
                    y_max: 366,
                    ha: 366,
                    o: "m 405 0 b 425 17 413 -1 420 9 b 439 66 435 32 439 48 b 441 268 439 137 441 202 b 436 412 441 314 439 361 l 435 413 b 423 469 435 436 431 456 b 344 508 406 501 373 501 b 204 527 298 520 251 527 b 60 498 156 527 108 518 b 7 438 32 485 10 468 l 7 426 b 4 337 7 396 7 367 b 0 140 0 272 0 206 b 1 42 0 107 0 73 b 13 3 1 27 -3 4 b 40 39 29 3 35 24 b 42 53 42 43 40 49 b 49 141 48 84 49 112 b 48 215 49 167 48 192 b 49 252 48 228 48 240 l 49 312 b 130 343 72 331 99 340 b 206 347 156 346 180 347 b 372 314 262 347 318 338 l 390 307 l 390 245 b 390 138 392 212 390 176 b 397 23 390 101 392 62 b 405 0 399 14 393 1 z"
                },
                stringsUpBow: {
                    x_min: 0,
                    x_max: 219,
                    y_min: 0,
                    y_max: 489,
                    ha: 489,
                    o: "m 151 0 b 184 42 170 12 180 26 b 297 554 223 212 261 382 b 315 690 305 598 318 645 b 304 704 315 697 311 704 b 276 670 288 704 282 697 b 157 131 236 490 196 311 l 157 144 b 73 526 134 276 104 396 b 30 677 60 576 52 638 b 13 694 26 684 22 694 b 0 674 9 694 0 691 l 0 671 b 10 603 3 649 6 626 b 105 174 42 461 72 317 b 150 0 117 117 128 58 z"
                },
                stringsHarmonic: {
                    x_min: 0,
                    x_max: 191,
                    y_min: 0,
                    y_max: 202,
                    ha: 202,
                    o: "m 143 0 b 275 122 217 0 275 53 b 127 291 275 206 202 291 b 0 154 63 291 0 222 b 143 0 0 76 71 0 z m 122 68 b 43 105 89 66 59 75 b 39 124 40 111 39 117 b 79 199 39 148 56 180 b 145 226 101 216 122 226 b 199 210 163 226 180 220 b 235 150 223 196 235 173 b 203 92 235 128 225 107 b 122 68 181 76 150 68 z"
                },
                pluckedSnapPizzicatoAbove: {
                    x_min: 0,
                    x_max: 201,
                    y_min: 0,
                    y_max: 325,
                    ha: 325,
                    o: "m 171 0 b 289 99 240 0 289 45 b 258 183 289 130 274 156 b 174 269 236 217 203 240 l 174 408 b 174 429 174 415 176 422 b 131 468 168 451 153 468 b 117 451 120 468 117 461 b 118 429 117 444 118 435 b 115 307 117 389 115 347 b 0 166 59 295 0 223 b 171 0 0 85 89 0 z m 134 55 b 52 131 84 55 52 85 b 115 233 52 179 81 209 b 114 192 114 220 114 206 b 174 120 114 137 114 137 l 174 228 b 233 148 200 207 223 183 b 236 130 235 143 236 135 b 197 72 236 105 223 85 b 134 55 177 60 157 55 z"
                },
                pluckedSnapPizzicatoBelow: {
                    x_min: 0,
                    x_max: 211,
                    y_min: 0,
                    y_max: 307,
                    ha: 307,
                    o: "m 145 7 b 163 0 153 3 158 0 b 173 23 170 0 173 7 l 173 140 l 170 140 l 170 163 l 171 163 b 206 170 179 164 193 166 b 304 287 264 186 304 233 b 281 354 304 308 297 333 b 118 442 240 412 186 439 b 0 324 69 442 0 370 b 115 176 0 266 55 202 l 115 56 b 145 7 114 33 125 19 z m 115 220 b 62 256 92 223 73 230 b 53 292 56 269 53 281 b 78 344 53 311 60 328 b 168 384 105 372 135 384 b 213 376 183 384 199 382 b 253 321 239 366 253 346 b 246 291 253 311 251 301 b 170 226 230 256 203 236 l 170 258 b 148 305 171 278 163 292 b 128 315 143 310 135 315 l 124 315 b 115 301 117 314 115 308 z"
                },
                pluckedLeftHandPizzicato: {
                    x_min: 0,
                    x_max: 271,
                    y_min: 0,
                    y_max: 284,
                    ha: 284,
                    o: "m 213 0 b 223 14 222 0 223 7 b 222 35 223 22 222 29 l 222 176 b 373 170 272 174 323 170 b 390 180 382 170 390 171 l 390 184 b 347 232 386 207 382 232 b 219 238 307 233 266 235 l 219 364 b 171 409 219 395 193 409 b 156 393 160 409 156 402 b 158 370 156 384 158 376 l 158 240 b 16 239 115 240 66 239 b 0 226 7 239 0 238 l 0 223 b 50 179 1 203 29 179 b 158 177 86 179 122 179 l 158 63 b 161 29 158 52 158 40 b 213 0 166 -1 194 1 z"
                },
                keyboardPedalPed: {
                    x_min: 0,
                    x_max: 944,
                    y_min: -13,
                    y_max: 550,
                    ha: 563,
                    o: "m 22 0 b 109 78 53 0 105 46 l 144 333 b 163 376 147 347 140 372 b 364 465 238 390 301 426 b 454 599 416 497 454 540 b 452 618 454 605 454 612 b 320 770 442 694 396 747 b 248 779 295 778 272 779 b 193 778 229 779 212 779 b 160 780 181 778 167 775 b 137 792 153 789 144 791 b 109 789 128 792 118 789 b 7 719 59 789 48 737 b 23 708 16 714 20 708 b 36 710 29 710 33 710 b 53 684 52 710 53 698 l 53 674 b 43 386 53 577 53 482 b 20 164 36 312 30 238 b 1 30 14 120 7 75 b 0 19 0 26 0 22 b 22 0 0 9 4 0 z m 171 425 b 156 442 160 425 156 429 b 157 475 157 452 157 464 b 164 602 161 517 164 560 b 161 698 164 635 163 667 b 184 729 161 720 167 729 l 193 729 b 348 563 278 719 348 641 b 346 539 348 554 347 547 b 171 425 328 459 229 422 z m 979 6 b 1008 13 986 6 995 9 b 1081 101 1047 29 1079 46 b 1116 449 1087 217 1104 333 b 1143 654 1123 518 1133 586 b 1148 685 1145 664 1148 675 b 1140 704 1148 693 1146 700 b 1107 716 1130 713 1119 716 b 1056 706 1092 716 1073 710 b 1037 671 1035 703 1038 685 b 1004 439 1025 595 1014 517 b 986 419 1001 428 999 419 b 979 419 985 419 982 420 b 935 426 965 423 949 425 b 795 376 884 426 838 405 b 664 153 714 323 664 249 b 665 130 664 145 665 138 b 753 29 671 65 704 29 b 815 40 773 29 792 33 b 975 147 873 65 923 101 b 965 45 971 108 968 76 b 979 6 963 17 966 6 z m 393 -17 b 634 145 494 16 579 52 b 638 160 636 151 638 156 b 625 168 638 166 634 168 b 621 167 624 168 622 168 b 524 118 582 164 544 160 b 495 79 517 104 505 92 b 435 33 471 49 452 33 b 380 96 416 33 397 55 b 369 145 373 114 369 131 b 442 225 369 186 395 213 b 468 232 451 228 459 229 b 654 344 539 255 606 285 b 677 395 667 360 677 376 b 672 415 677 402 675 408 b 612 459 661 442 639 455 b 589 461 602 461 592 461 b 348 328 500 461 409 408 b 269 120 302 268 269 199 b 379 -19 269 45 318 -19 b 393 -17 383 -19 389 -19 z m 395 240 b 494 383 418 300 452 344 l 521 405 b 544 419 528 409 536 418 b 554 415 547 419 550 418 b 570 383 564 406 570 396 l 570 379 b 552 331 570 360 562 344 b 395 240 511 285 462 253 z m 827 89 b 792 111 815 89 804 96 b 766 204 775 131 766 158 b 845 360 772 256 799 314 b 871 372 854 369 863 372 b 897 366 880 372 888 369 b 978 279 942 353 963 320 b 976 259 981 272 981 265 b 858 104 942 203 909 147 b 827 89 847 94 837 89 z m 1282 12 b 1336 35 1303 14 1320 23 b 1359 71 1351 45 1359 58 b 1338 102 1359 82 1352 95 b 1254 130 1312 118 1284 130 b 1187 88 1223 130 1202 109 b 1178 65 1182 81 1178 72 b 1195 37 1178 55 1182 45 b 1282 12 1223 23 1253 19 z"
                },
                keyboardPedalUp: {
                    x_min: 0,
                    x_max: 437,
                    y_min: 0,
                    y_max: 461,
                    ha: 461,
                    o: "m 330 0 b 334 1 331 0 333 0 b 340 12 338 4 340 7 l 338 26 b 340 264 338 105 338 184 b 526 95 400 206 461 148 b 559 71 536 88 547 71 b 564 72 560 71 563 71 b 580 121 580 79 580 102 l 580 127 b 543 203 585 158 573 184 b 472 259 518 219 495 238 l 445 285 b 590 292 494 288 541 291 b 622 318 609 294 618 302 b 628 359 625 331 626 346 b 586 402 632 393 621 405 b 464 395 546 399 504 396 l 559 491 b 567 524 567 500 567 510 b 564 543 567 527 567 536 b 539 596 559 563 560 590 b 494 564 521 600 508 577 b 340 413 442 514 390 464 l 340 560 b 287 664 340 600 321 632 b 271 518 274 612 272 566 b 268 445 269 494 269 469 b 117 569 219 488 168 530 b 96 579 109 575 102 579 b 85 560 89 579 85 573 b 124 446 85 518 82 477 b 209 380 153 426 181 403 b 45 374 154 377 99 376 b 0 324 9 374 0 359 b 63 266 0 265 1 265 b 144 272 89 269 117 272 l 196 272 b 108 193 167 246 138 219 b 60 135 76 164 60 151 b 99 73 60 121 73 105 b 104 68 101 72 102 71 b 114 58 107 60 111 58 b 130 66 120 58 124 62 b 259 186 173 107 217 145 b 256 117 259 163 256 140 b 311 13 256 72 271 37 b 330 0 317 10 323 0 z"
                },
                pictChokeCymbal: {
                    x_min: 1,
                    x_max: 147,
                    y_min: 0,
                    y_max: 242,
                    ha: 242,
                    o: "m 79 4 b 207 158 153 32 192 88 b 212 200 210 173 212 187 b 143 336 212 253 187 298 b 98 348 131 344 115 348 b 4 295 60 348 16 327 b 1 276 1 289 1 282 b 9 249 1 266 3 258 b 121 183 35 206 72 183 b 156 186 132 183 144 183 b 26 53 134 115 91 73 b 7 39 13 49 7 45 b 19 20 7 33 12 27 b 59 0 30 9 43 0 b 79 4 65 0 72 1 z"
                },
                wiggleArpeggiatoUp: {
                    x_min: -22,
                    x_max: 300,
                    y_min: 0,
                    y_max: 176,
                    ha: 176,
                    o: "m 173 4 b 196 0 180 1 189 0 b 246 26 215 0 230 9 b 301 117 271 53 285 85 b 312 131 305 125 307 131 b 327 124 315 131 321 128 b 373 86 341 112 353 101 b 412 69 389 75 402 69 b 432 94 425 69 432 79 b 373 181 432 117 413 154 b 235 252 323 216 285 245 b 220 253 229 253 225 253 b 168 215 196 253 181 240 b 111 112 151 180 140 141 b 94 102 105 105 99 102 b 78 111 89 102 84 105 b 0 181 55 135 35 160 b -32 153 -20 194 -32 168 b 0 86 -32 124 -32 109 b 94 36 22 71 73 46 b 173 4 134 16 131 17 z"
                },
                arpeggiatoUp: {
                    x_min: 0,
                    x_max: 262,
                    y_min: 0,
                    y_max: 1459,
                    ha: 1459,
                    o: "m 190 0 b 160 63 187 29 170 45 b 145 108 150 81 145 95 b 183 163 145 128 157 145 b 300 246 222 190 262 216 b 347 318 333 272 347 295 b 301 393 347 341 331 364 b 258 413 289 403 272 408 b 145 449 220 425 183 436 b 117 464 135 452 120 452 b 140 491 115 477 128 484 b 294 593 192 526 243 557 b 330 647 318 611 330 626 b 314 693 330 660 324 675 b 262 736 302 714 285 729 b 170 763 230 744 200 753 b 122 783 153 768 125 768 b 160 831 120 804 143 818 b 288 922 202 861 246 890 b 333 999 318 945 333 972 b 266 1083 333 1032 310 1064 b 189 1115 240 1094 215 1103 b 122 1178 145 1133 122 1153 b 168 1250 122 1200 138 1223 l 180 1257 b 269 1333 210 1283 240 1306 b 305 1405 294 1356 305 1381 b 284 1469 305 1426 298 1447 b 228 1525 269 1492 251 1511 b 183 1600 197 1545 183 1571 b 190 1640 183 1613 184 1626 b 197 1670 193 1650 194 1660 b 272 1735 213 1719 230 1735 b 295 1734 279 1735 287 1735 b 323 1732 305 1732 314 1732 b 350 1731 333 1732 341 1732 b 377 1742 369 1729 377 1732 b 370 1761 377 1747 374 1754 l 301 1898 b 217 2066 274 1954 248 2012 b 186 2101 204 2089 196 2101 b 154 2069 177 2101 167 2091 b 12 1824 105 1987 59 1907 b 0 1787 4 1810 0 1797 b 59 1744 0 1761 20 1745 b 160 1738 92 1744 125 1740 b 145 1692 156 1721 151 1706 b 135 1633 138 1672 135 1652 b 184 1518 135 1591 151 1552 b 229 1475 199 1503 213 1488 b 259 1431 249 1456 259 1444 b 229 1388 259 1420 249 1407 b 151 1325 203 1365 177 1345 b 105 1279 134 1310 118 1296 b 73 1202 84 1251 73 1227 b 108 1123 73 1176 85 1152 b 255 1031 148 1077 199 1051 b 282 1014 274 1025 282 1021 b 262 991 282 1008 275 1001 b 151 914 226 963 189 939 b 79 851 125 896 99 877 b 63 809 69 837 63 824 b 79 769 63 796 68 783 b 202 697 111 729 154 710 b 266 670 225 690 266 688 b 210 622 266 648 232 635 b 82 534 167 593 120 570 b 55 491 63 518 55 505 b 79 448 55 478 63 465 b 255 361 127 395 192 380 b 288 343 269 359 288 357 b 266 312 288 331 275 320 b 144 223 229 278 184 253 b 85 134 104 193 85 166 b 118 53 85 111 96 85 b 190 0 135 29 160 14 z"
                },
                arpeggiatoDown: {
                    x_min: 0,
                    x_max: 218,
                    y_min: 0,
                    y_max: 1440,
                    ha: 1440,
                    o: "m 161 16 b 310 261 210 98 259 180 b 314 275 312 266 314 271 b 302 295 314 282 310 289 b 252 311 287 308 269 311 b 217 310 240 311 229 310 b 190 333 202 310 194 315 b 151 412 186 363 171 389 b 102 501 120 452 102 477 b 150 588 102 524 118 547 b 161 603 154 592 158 598 b 181 661 176 622 181 641 b 173 704 181 675 179 690 b 86 795 156 746 121 770 b 53 829 63 811 53 819 b 78 868 53 840 62 851 b 102 888 85 876 94 883 b 180 956 128 912 156 933 b 216 1028 204 979 216 1002 b 203 1081 216 1044 212 1061 b 115 1171 186 1123 148 1145 b 75 1221 88 1191 75 1207 b 114 1272 75 1237 88 1251 b 173 1308 132 1284 154 1296 b 226 1339 190 1318 209 1328 b 265 1405 253 1359 265 1380 b 258 1447 265 1418 264 1431 b 154 1541 242 1499 199 1521 b 109 1581 124 1555 109 1567 b 141 1627 109 1594 121 1608 b 204 1680 163 1646 184 1662 b 233 1742 223 1699 233 1719 b 226 1777 233 1752 230 1764 b 135 1862 210 1822 173 1840 b 104 1895 114 1875 104 1884 b 118 1930 104 1904 109 1914 b 192 2006 135 1961 161 1986 b 206 2029 203 2013 206 2022 b 192 2064 206 2040 197 2052 b 180 2074 187 2071 184 2074 b 156 2061 171 2074 163 2065 b 84 1983 125 2040 102 2013 b 65 1921 71 1961 65 1941 b 88 1853 65 1899 72 1876 b 171 1784 108 1820 138 1801 b 190 1764 184 1777 190 1770 b 174 1741 190 1757 184 1750 b 107 1683 153 1722 128 1704 b 68 1610 81 1659 68 1636 b 88 1548 68 1591 75 1571 b 177 1470 109 1512 141 1489 b 223 1431 209 1453 223 1443 b 179 1390 223 1420 209 1408 b 128 1361 163 1380 145 1371 b 71 1322 108 1348 88 1338 b 32 1253 45 1300 32 1277 b 48 1198 32 1236 37 1218 b 147 1090 71 1152 108 1120 b 174 1057 166 1076 174 1067 b 153 1022 174 1047 167 1037 b 109 982 140 1008 124 995 b 37 919 85 962 59 942 b 9 860 17 899 9 880 b 26 806 9 844 14 827 b 120 717 50 769 84 740 b 138 691 132 708 138 700 b 130 668 138 684 135 677 b 92 618 118 651 105 635 b 59 531 71 589 59 560 b 84 455 59 507 68 481 b 132 386 98 431 115 408 b 148 341 144 372 148 357 b 144 317 148 333 147 324 b 121 305 140 307 131 305 l 98 305 b 82 304 94 304 88 304 l 32 304 b 0 292 10 304 0 302 b 12 266 0 287 4 279 b 60 164 32 233 46 199 b 127 20 84 117 105 68 b 144 0 132 9 137 0 b 161 16 150 0 154 4 z"
                },
                repeat1Bar: {
                    x_min: 0,
                    x_max: 599,
                    y_min: -250,
                    y_max: 175,
                    ha: 425,
                    o: "m 216 98 b 255 75 236 84 246 75 b 291 104 265 75 274 85 b 323 147 304 117 327 125 b 289 215 323 168 314 184 b 238 252 269 239 253 252 b 187 222 222 252 207 242 b 173 206 183 216 177 212 b 157 170 163 194 157 183 b 174 138 157 160 161 150 b 216 98 189 127 200 109 z m 76 -334 b 181 -285 111 -315 148 -302 b 831 52 396 -168 613 -58 b 863 114 855 63 864 82 b 828 202 855 140 855 176 b 808 213 821 209 815 213 b 793 209 804 213 799 212 l 422 19 b 26 -179 291 -48 164 -124 b 0 -213 10 -186 0 -196 b 3 -232 0 -219 0 -225 b 52 -325 14 -265 37 -294 b 66 -337 55 -331 59 -337 b 76 -334 69 -337 72 -336 z m 769 -360 b 829 -264 779 -360 829 -284 b 769 -176 822 -232 799 -200 b 742 -163 760 -167 750 -163 b 716 -184 733 -163 723 -168 b 683 -228 708 -202 693 -213 b 672 -253 675 -236 672 -245 b 683 -281 672 -262 675 -271 b 752 -353 703 -308 732 -327 b 769 -360 756 -357 763 -360 z"
                },
                repeat2Bars: {
                    x_min: 0,
                    x_max: 775,
                    y_min: -247,
                    y_max: 363,
                    ha: 610,
                    o: "m 909 412 b 873 351 906 384 893 367 b 436 50 729 249 585 147 l 91 -179 b 62 -174 76 -189 68 -183 b 12 -96 48 -147 24 -125 b 36 -16 -7 -53 -6 -43 b 220 104 96 24 158 65 b 819 507 425 232 624 369 b 881 495 852 530 861 528 b 909 412 899 469 900 439 z m 333 338 b 302 240 330 307 317 274 b 276 235 297 225 287 228 l 233 269 b 203 376 186 307 183 318 b 225 441 212 397 217 419 b 246 454 228 452 232 458 b 333 338 284 441 333 380 z m 1116 228 b 1067 158 1115 192 1092 174 b 910 59 1015 125 963 92 b 478 -240 762 -33 622 -140 b 311 -350 423 -279 366 -314 b 285 -344 298 -360 289 -356 b 239 -258 272 -314 251 -288 b 261 -196 228 -228 235 -210 b 517 -29 348 -144 436 -91 b 1030 321 681 98 861 202 b 1093 307 1060 343 1076 340 b 1116 228 1107 281 1109 252 z m 1070 -105 b 1020 -210 1057 -143 1038 -176 b 998 -210 1014 -219 1004 -215 l 924 -153 b 913 -88 899 -135 897 -112 b 949 -22 926 -66 939 -45 b 998 -7 960 6 976 9 b 1070 -105 1032 -32 1058 -63 z"
                },
                repeat4Bars: {
                    x_min: 0,
                    x_max: 1374,
                    y_min: -304,
                    y_max: 304,
                    ha: 608,
                    o: "m 78 -266 b 92 -258 82 -266 88 -264 b 114 -240 98 -251 107 -246 b 638 107 289 -125 467 -14 b 873 271 716 161 793 216 b 907 337 894 285 906 305 b 887 400 901 354 897 379 b 852 438 877 426 867 438 b 814 420 842 438 829 432 b 135 -33 592 262 366 111 b 12 -121 92 -60 48 -84 b 0 -144 4 -128 0 -135 b 4 -160 0 -148 1 -154 b 63 -255 17 -196 45 -223 b 78 -266 68 -262 72 -266 z m 291 148 b 325 223 302 148 308 170 b 333 256 328 235 330 246 b 264 363 330 305 298 336 b 242 373 255 369 248 373 b 220 347 232 373 225 364 b 202 288 216 327 213 305 b 190 252 193 275 190 262 b 222 200 190 232 202 215 b 291 148 264 170 279 148 z m 815 -367 b 829 -359 819 -367 824 -364 b 851 -343 835 -353 844 -347 b 1375 6 1027 -228 1205 -117 l 1610 170 b 1644 235 1632 184 1643 203 b 1626 300 1639 253 1634 276 b 1590 337 1614 325 1604 337 b 1551 320 1580 337 1567 330 b 873 -135 1329 161 1103 10 b 749 -222 829 -161 785 -184 b 737 -245 742 -230 737 -238 b 742 -261 737 -249 739 -255 b 802 -357 755 -297 782 -325 b 815 -367 805 -363 809 -367 z m 396 -360 b 408 -356 400 -360 403 -359 b 609 -223 471 -307 543 -269 b 896 -19 706 -156 795 -81 b 1164 154 985 37 1074 96 b 1214 223 1189 170 1211 187 b 1176 321 1204 253 1205 292 b 1159 330 1169 327 1165 330 b 1145 324 1155 330 1151 328 b 1048 258 1113 302 1081 278 b 357 -202 809 117 598 -65 b 333 -238 341 -212 333 -223 b 338 -262 333 -245 334 -253 b 384 -350 350 -294 372 -318 b 396 -360 386 -354 390 -360 z m 1162 -438 b 1174 -433 1166 -438 1169 -436 b 1374 -300 1237 -384 1309 -346 b 1660 -96 1470 -233 1561 -158 b 1930 76 1751 -39 1840 19 b 1979 147 1954 92 1977 109 b 1943 243 1968 177 1971 216 b 1924 253 1935 251 1930 253 b 1911 248 1920 253 1915 252 b 1814 181 1878 225 1848 202 b 1123 -279 1575 40 1364 -141 b 1099 -315 1106 -289 1099 -300 b 1103 -338 1099 -321 1100 -330 b 1149 -426 1115 -370 1138 -396 b 1162 -438 1151 -432 1156 -438 z m 1875 -295 b 1882 -291 1878 -295 1879 -294 b 1934 -189 1904 -258 1921 -223 b 1872 -96 1925 -147 1901 -120 b 1840 -78 1858 -84 1848 -78 b 1812 -109 1830 -78 1823 -88 l 1777 -173 b 1770 -199 1773 -181 1770 -190 b 1786 -230 1770 -210 1774 -220 b 1862 -289 1809 -253 1837 -269 b 1875 -295 1865 -292 1871 -295 z"
                },
                repeatBarSlash: {
                    x_min: 0,
                    x_max: 630,
                    y_min: -225,
                    y_max: 265,
                    ha: 490,
                    o: "m 78 -324 b 92 -314 82 -325 88 -321 b 114 -298 96 -307 107 -302 b 638 49 289 -183 467 -72 b 873 215 716 104 792 161 b 907 279 894 229 906 248 b 887 344 901 298 897 321 b 852 382 877 369 867 380 b 814 363 842 383 829 376 b 135 -91 603 192 364 55 b 12 -177 92 -118 45 -137 b 0 -202 4 -186 0 -192 b 4 -217 0 -206 1 -212 b 63 -312 17 -253 42 -284 b 78 -324 68 -318 72 -323 z"
                },
                csymDiminished: {
                    x_min: 0,
                    x_max: 506,
                    y_min: 0,
                    y_max: 500,
                    ha: 500,
                    o: "m 397 0 b 729 265 576 -1 729 95 b 711 367 729 297 723 331 b 472 670 668 498 586 595 b 315 720 423 701 372 720 b 253 713 295 720 275 719 b 32 514 144 687 75 615 b 0 374 12 468 0 420 b 27 251 0 333 9 292 b 140 117 52 196 92 153 b 397 0 223 52 317 4 z m 340 95 b 132 314 233 84 122 216 b 324 589 145 438 200 539 b 415 611 360 603 389 611 b 544 505 469 611 505 576 b 590 392 564 471 583 432 b 596 343 593 374 596 359 b 340 95 596 210 485 96 z"
                },
                csymHalfDiminished: {
                    x_min: -32,
                    x_max: 496,
                    y_min: -33,
                    y_max: 492,
                    ha: 525,
                    o: "m -29 -48 b 0 -36 -19 -48 -9 -40 b 17 -20 7 -32 12 -24 b 134 94 56 19 95 56 b 372 0 207 43 282 0 b 455 13 397 0 426 4 b 677 258 556 45 671 141 b 678 289 677 268 678 278 b 593 539 678 380 654 467 b 592 541 593 540 592 540 l 684 632 b 713 678 700 647 711 665 b 714 691 714 684 714 688 b 707 704 714 698 711 701 b 691 708 701 707 696 708 b 660 691 680 708 670 701 l 552 585 b 478 634 530 606 507 624 b 361 684 438 648 397 661 b 301 703 341 697 320 703 b 226 677 275 703 251 693 b 27 449 140 618 72 543 b 0 324 9 410 -4 370 b 88 128 -1 243 30 177 b -30 -7 43 86 0 46 b -46 -33 -35 -16 -46 -24 b -42 -42 -46 -36 -45 -39 b -29 -48 -37 -46 -33 -48 z m 141 179 b 121 251 128 200 121 225 b 128 297 121 265 124 281 b 351 575 163 420 248 505 b 377 582 359 579 369 580 b 501 536 422 586 468 567 b 141 179 382 416 261 298 z m 281 105 b 179 137 240 105 206 117 b 210 168 189 147 200 157 l 537 487 b 547 455 541 477 544 467 b 556 370 552 426 556 397 b 429 154 556 274 503 207 b 281 105 384 122 336 105 z"
                },
                csymAugmented: {
                    x_min: 0,
                    x_max: 530,
                    y_min: 0,
                    y_max: 539,
                    ha: 539,
                    o: "m 380 0 b 393 14 384 4 390 9 b 397 46 397 24 397 36 l 397 333 b 736 327 511 331 624 330 b 763 343 755 327 763 333 b 755 361 763 348 760 354 b 635 431 726 402 688 431 l 390 431 l 390 485 b 386 606 392 526 386 566 b 392 664 386 625 387 645 b 395 690 393 672 395 681 b 376 753 395 711 389 734 b 357 776 372 762 369 776 b 350 775 354 776 353 776 b 327 740 337 769 327 759 b 327 621 328 700 327 661 b 330 438 328 559 328 498 l 29 438 b 4 431 20 438 7 442 b 0 413 3 425 0 419 b 7 399 0 408 1 403 b 131 338 45 369 85 340 b 331 334 199 336 265 334 b 333 163 333 276 333 220 b 366 13 333 109 348 63 b 380 0 367 7 374 4 z"
                },
                csymMajorSeventh: {
                    x_min: 0,
                    x_max: 593,
                    y_min: 0,
                    y_max: 569,
                    ha: 569,
                    o: "m 124 1 l 497 27 b 819 50 605 35 711 43 b 854 98 847 52 855 63 b 812 200 845 128 835 166 b 564 585 730 328 648 456 b 435 786 521 652 480 720 b 397 819 419 809 408 819 b 369 792 387 819 379 811 b 7 173 248 585 128 379 b 0 150 3 166 0 158 b 7 128 0 143 3 135 b 89 10 30 86 65 50 b 109 0 95 1 102 0 z m 163 147 b 153 153 158 147 156 148 b 164 179 147 163 158 170 b 426 644 251 334 338 488 b 442 660 432 655 436 660 b 458 645 446 660 452 655 b 727 220 547 503 636 361 b 736 202 732 213 736 206 b 714 190 736 196 730 192 b 179 148 537 177 359 163 b 163 147 174 150 168 147 z"
                },
                csymMinor: {
                    x_min: 0,
                    x_max: 482,
                    y_min: 193,
                    y_max: 265,
                    ha: 72,
                    o: "m 168 278 b 197 279 177 278 187 278 b 431 292 275 287 353 288 l 431 291 b 661 302 508 295 585 300 b 693 311 672 304 688 300 b 674 346 697 324 685 338 b 564 382 641 366 606 384 l 27 360 b 0 347 17 360 1 366 b 19 314 0 333 3 321 b 168 278 66 291 115 278 z"
                },
                csymParensLeftTall: {
                    x_min: 0,
                    x_max: 185,
                    y_min: 0,
                    y_max: 1034,
                    ha: 1034,
                    o: "m 215 0 b 226 17 223 1 223 10 b 229 37 229 24 229 32 b 220 81 229 52 225 66 b 167 203 206 124 181 160 b 86 616 124 338 89 474 b 82 765 85 665 82 716 b 91 886 82 805 84 845 b 245 1319 120 1038 171 1184 b 266 1397 259 1346 266 1371 b 259 1443 266 1411 264 1427 b 226 1489 253 1463 248 1489 b 193 1454 212 1489 203 1467 b 114 1292 158 1404 140 1346 b 0 806 40 1138 0 978 b 3 721 0 779 0 750 b 1 677 1 707 1 693 b 36 418 1 593 16 504 b 144 96 62 307 95 199 b 196 12 158 66 179 39 b 212 0 200 7 204 0 z"
                },
                csymParensRightTall: {
                    x_min: -40,
                    x_max: 189,
                    y_min: 0,
                    y_max: 1058,
                    ha: 1058,
                    o: "m 30 1 b 63 14 42 -3 55 6 b 122 99 86 40 108 68 b 189 258 145 153 166 204 b 271 667 239 379 268 503 b 246 852 275 708 261 780 b 10 1495 197 1077 128 1295 b -14 1524 4 1505 1 1524 b -16 1522 -14 1524 -16 1524 b -46 1489 -33 1521 -43 1503 b -58 1417 -53 1464 -58 1440 b -36 1335 -58 1390 -52 1364 b 68 1138 0 1270 35 1204 b 163 883 108 1056 137 969 b 206 668 184 814 200 742 b 207 631 207 655 207 642 b 166 426 207 560 192 492 b 46 143 130 330 111 228 b 19 29 19 109 17 69 b 30 1 20 19 24 3 z"
                },
                csymBracketLeftTall: {
                    x_min: 0,
                    x_max: 328,
                    y_min: 2,
                    y_max: 807,
                    ha: 805,
                    o: "m 68 3 b 76 4 71 3 73 3 b 186 13 112 12 150 13 b 240 13 204 13 222 13 l 287 13 b 379 17 317 13 348 13 b 472 121 435 24 472 69 b 467 156 472 132 469 144 b 446 174 462 168 456 174 l 439 174 b 327 166 402 167 364 166 b 265 167 307 166 285 167 l 209 167 b 187 475 199 269 189 372 b 166 985 186 645 187 815 l 377 1002 b 415 1001 389 1002 402 1001 b 456 1027 432 1001 448 1005 b 472 1096 467 1048 472 1073 b 464 1146 472 1113 469 1130 b 439 1162 459 1161 452 1162 b 40 1129 305 1151 173 1139 b 1 1093 17 1128 1 1120 b 0 1009 0 1064 0 1037 b 13 975 0 991 3 981 b 30 670 23 873 30 772 b 29 608 30 649 29 628 l 29 563 b 56 88 29 405 49 246 b 53 22 55 66 55 43 b 68 3 53 12 56 3 z"
                },
                csymBracketRightTall: {
                    x_min: 1,
                    x_max: 306,
                    y_min: 0,
                    y_max: 829,
                    ha: 829,
                    o: "m 117 0 b 372 29 203 -3 287 20 l 373 29 b 406 32 383 30 395 30 b 436 60 428 33 432 43 b 441 109 439 76 441 92 b 433 200 441 140 436 170 b 409 696 422 366 409 530 b 416 887 409 763 416 831 b 415 920 416 899 415 910 l 415 1106 b 412 1135 415 1116 415 1126 l 412 1145 b 373 1189 413 1171 408 1192 b 321 1189 356 1189 338 1189 l 215 1189 l 215 1194 l 56 1194 b 6 1153 27 1195 10 1187 b 1 1064 3 1123 4 1093 b 22 1043 0 1050 6 1043 b 84 1044 42 1044 63 1044 b 264 1038 144 1044 203 1040 b 265 958 264 1011 265 985 b 262 845 265 920 264 883 b 259 710 259 801 259 755 b 279 243 259 554 271 399 b 285 170 281 219 284 194 b 95 151 222 161 158 156 b 29 81 27 147 27 147 l 29 73 b 105 0 33 0 33 0 z"
                },
                csymParensLeftVeryTall: {
                    x_min: 0,
                    x_max: 116,
                    y_min: 0,
                    y_max: 934,
                    ha: 934,
                    o: "m 128 0 b 147 17 137 0 144 9 b 167 102 160 45 167 73 b 158 154 167 120 164 137 b 117 307 141 204 130 256 b 63 698 84 435 71 567 b 62 788 62 729 62 757 b 69 916 62 829 63 873 b 109 1172 81 1001 94 1087 b 132 1320 118 1221 137 1269 b 124 1345 131 1329 134 1342 b 96 1332 114 1346 102 1341 b 71 1269 82 1313 75 1292 b 39 1104 59 1214 48 1159 b 0 742 19 988 0 871 b 10 559 3 688 6 624 b 58 226 16 446 33 336 b 112 20 73 157 94 89 b 128 0 115 13 118 0 z"
                },
                csymParensRightVeryTall: {
                    x_min: -20,
                    x_max: 111,
                    y_min: 0,
                    y_max: 1009,
                    ha: 1009,
                    o: "m -3 0 b 20 22 9 -1 14 12 b 36 56 26 33 32 45 b 99 274 58 128 84 199 b 160 788 135 439 163 605 b 122 1181 164 912 145 1047 b 50 1431 108 1267 86 1351 b 36 1453 48 1439 46 1453 l 35 1453 l 30 1453 b 7 1423 17 1449 7 1440 b 27 1287 9 1377 10 1331 b 96 963 71 1184 85 1074 b 105 818 102 914 105 867 b 91 624 105 753 99 688 b -4 213 72 484 48 344 b -29 101 -19 174 -29 138 b -16 27 -29 76 -24 52 b -3 0 -13 17 -14 3 z"
                },
                csymDiagonalArrangementSlash: {
                    x_min: 0,
                    x_max: 990,
                    y_min: -27,
                    y_max: 1028,
                    ha: 1054,
                    o: "m 14 -37 b 58 -9 35 -45 46 -22 b 392 333 170 105 279 217 l 765 711 b 1372 1329 968 916 1168 1125 b 1424 1439 1403 1359 1417 1397 b 1426 1457 1424 1444 1426 1450 b 1416 1477 1426 1466 1423 1475 b 1374 1462 1400 1485 1385 1473 b 1181 1269 1309 1397 1246 1331 b 736 831 1031 1122 884 979 b 356 452 609 704 485 576 b 32 132 246 347 143 236 b 0 50 7 109 1 84 b 6 9 -1 37 3 23 b 14 -37 10 -9 0 -32 z"
                },
                accidentalNarrowReversedFlat: {
                    x_min: 0,
                    x_max: 208,
                    y_min: -231,
                    y_max: 449,
                    ha: 680,
                    o: "m 272 -333 b 284 -320 278 -333 281 -328 b 300 -174 297 -272 300 -222 b 275 190 298 -52 279 68 b 268 445 272 275 268 360 l 268 490 b 264 612 269 530 265 572 b 236 647 264 632 252 645 l 235 647 b 217 618 220 647 220 628 b 207 526 210 588 207 556 b 210 432 207 494 210 464 b 216 268 213 377 215 323 l 216 230 l 215 232 b 154 256 194 240 174 251 b 111 264 138 261 124 264 b 3 153 50 264 10 223 b 0 94 0 132 0 114 b 194 -276 0 -63 68 -186 b 255 -323 215 -291 236 -307 b 272 -333 262 -330 268 -333 z m 233 -138 b 71 30 168 -92 105 -45 b 63 59 65 42 63 50 b 96 95 62 75 73 86 b 130 102 108 99 120 102 b 215 76 160 102 187 88 l 220 73 b 225 -22 220 42 222 10 b 233 -138 229 -62 230 -101 z"
                },
                accidentalNarrowReversedFlatAndFlat: {
                    x_min: 0,
                    x_max: 335,
                    y_min: -231,
                    y_max: 449,
                    ha: 680,
                    o: "m 151 490 b 148 612 151 530 150 572 b 132 647 148 632 141 645 b 122 618 124 647 124 628 b 117 526 118 588 117 556 b 118 432 117 494 118 464 b 121 268 120 377 121 323 l 121 232 b 86 256 109 240 98 251 b 62 264 78 261 69 264 b 1 153 29 264 6 223 b 0 94 0 132 0 114 b 109 -276 0 -63 37 -186 b 144 -323 121 -291 132 -307 b 153 -333 147 -330 151 -333 b 160 -320 157 -333 158 -328 b 168 -174 167 -272 168 -222 b 154 190 168 -52 157 68 b 151 445 153 275 151 360 z m 480 153 b 372 264 472 223 432 264 b 328 256 359 264 344 261 b 268 232 308 251 288 240 l 266 230 l 266 268 b 272 432 266 323 269 377 b 275 526 272 464 275 494 b 265 618 275 556 272 588 b 248 647 262 628 262 647 l 246 647 b 219 612 230 645 219 632 b 215 490 217 572 213 530 l 215 445 b 207 190 215 360 210 275 b 183 -174 203 68 183 -52 b 199 -320 183 -222 186 -272 b 210 -333 202 -328 204 -333 b 228 -323 215 -333 220 -330 b 288 -276 246 -307 268 -291 b 482 94 415 -186 482 -63 b 480 153 482 114 482 132 z m 40 30 b 36 59 36 42 36 50 b 55 95 35 75 42 86 b 73 102 60 99 68 102 b 121 76 89 102 105 88 l 124 73 b 127 -22 124 42 125 10 l 131 -138 b 40 30 95 -92 60 -43 z m 419 59 b 412 30 419 50 418 42 b 249 -138 374 -43 314 -92 b 258 -22 252 -101 253 -62 b 262 73 261 10 262 42 l 268 76 b 353 102 295 88 323 102 b 386 95 363 102 374 99 b 419 59 409 86 420 75 z"
                },
                accidentalWilsonPlus: {
                    x_min: 0,
                    x_max: 298,
                    y_min: -218,
                    y_max: 218,
                    ha: 436,
                    o: "m 232 -314 b 236 -301 236 -310 236 -305 l 236 -295 b 243 -52 239 -213 242 -132 l 369 62 b 429 200 413 101 425 147 b 416 243 429 216 428 236 b 383 225 406 251 393 232 l 377 220 b 246 98 336 177 291 138 b 249 242 248 145 246 193 b 225 304 251 265 242 287 b 209 314 220 308 215 314 b 204 312 207 314 206 312 b 196 292 196 310 196 300 b 193 184 194 256 194 220 b 187 48 192 140 190 94 b 46 -72 141 7 94 -32 b 0 -163 13 -98 0 -127 b 1 -187 0 -170 0 -179 b 10 -235 4 -203 6 -219 b 20 -255 12 -242 14 -251 b 36 -245 26 -259 30 -249 b 181 -109 85 -200 132 -154 b 176 -258 180 -158 176 -209 b 232 -314 176 -298 186 -307 z"
                },
                accidentalWilsonMinus: {
                    x_min: 0,
                    x_max: 284,
                    y_min: -163,
                    y_max: 163,
                    ha: 326,
                    o: "m 386 -232 b 409 -163 415 -222 408 -180 b 382 -69 410 -120 408 -89 b 32 228 264 30 141 118 b 17 235 26 233 22 235 b 3 219 9 235 3 228 b 0 157 3 199 0 179 b 29 69 0 125 6 95 b 323 -194 115 -29 222 -111 b 374 -235 338 -206 353 -235 b 386 -232 377 -235 382 -233 z"
                }
            },
            fontFamily: "Petaluma",
            resolution: 1e3,
            generatedOn: "2022-12-18T09:07:50.817Z"
        }, Li = {
            csymDiminished: {
                leftSideBearing: -95,
                advanceWidth: 506,
                yOffset: 0
            },
            csymHalfDiminished: {
                leftSideBearing: -32,
                advanceWidth: 506,
                yOffset: 0
            },
            csymAugmented: {
                leftSideBearing: -25,
                advanceWidth: 530,
                yOffset: 0
            },
            csymParensLeftTall: {
                leftSideBearing: 0,
                advanceWidth: 155,
                yOffset: 150
            },
            csymParensRightTall: {
                leftSideBearing: 40,
                advanceWidth: 189,
                yOffset: 150
            },
            csymBracketLeftTall: {
                leftSideBearing: 0,
                advanceWidth: 328,
                yOffset: 0
            },
            csymBracketRightTall: {
                leftSideBearing: 1,
                advanceWidth: 600,
                yOffset: 0
            },
            csymParensLeftVeryTall: {
                leftSideBearing: 0,
                advanceWidth: 210,
                yOffset: 250
            },
            csymParensRightVeryTall: {
                leftSideBearing: -100,
                advanceWidth: 111,
                yOffset: 250
            },
            csymDiagonalArrangementSlash: {
                leftSideBearing: -1,
                advanceWidth: 990,
                yOffset: 0
            },
            csymMinor: {
                leftSideBearing: 0,
                advanceWidth: 482,
                yOffset: 0
            },
            csymMajorSeventh: {
                leftSideBearing: 100,
                yOffset: 0,
                advanceWidth: 600
            },
            accidentalSharp: {
                leftSideBearing: 0,
                advanceWidth: 425,
                yOffset: -422
            },
            accidentalFlat: {
                leftSideBearing: -10,
                advanceWidth: 228,
                yOffset: -284
            }
        };
        const Wi = {
            spacing: 50,
            glyphs: {
                " ": {
                    x_min: 0,
                    x_max: 250,
                    y_min: 0,
                    y_max: 500,
                    ha: 500,
                    leftSideBearing: 0,
                    advanceWidth: 250
                },
                0: {
                    x_min: 33,
                    x_max: 534,
                    y_min: -13,
                    y_max: 751,
                    ha: 764,
                    leftSideBearing: 33,
                    advanceWidth: 570
                },
                1: {
                    x_min: 48,
                    x_max: 235,
                    y_min: -17,
                    y_max: 734,
                    ha: 751,
                    leftSideBearing: 48,
                    advanceWidth: 286
                },
                2: {
                    x_min: 56,
                    x_max: 571,
                    y_min: -19,
                    y_max: 741,
                    ha: 760,
                    leftSideBearing: 56,
                    advanceWidth: 626
                },
                3: {
                    x_min: 50,
                    x_max: 528,
                    y_min: -7,
                    y_max: 731,
                    ha: 738,
                    leftSideBearing: 50,
                    advanceWidth: 589
                },
                4: {
                    x_min: 38,
                    x_max: 564,
                    y_min: -13,
                    y_max: 743,
                    ha: 756,
                    leftSideBearing: 38,
                    advanceWidth: 614
                },
                5: {
                    x_min: 42,
                    x_max: 601,
                    y_min: -34,
                    y_max: 743,
                    ha: 777,
                    leftSideBearing: 42,
                    advanceWidth: 648
                },
                6: {
                    x_min: 47,
                    x_max: 606,
                    y_min: -16,
                    y_max: 743,
                    ha: 759,
                    leftSideBearing: 47,
                    advanceWidth: 667
                },
                7: {
                    x_min: 47,
                    x_max: 567,
                    y_min: 5,
                    y_max: 739,
                    ha: 734,
                    leftSideBearing: 0,
                    advanceWidth: 615
                },
                8: {
                    x_min: 40,
                    x_max: 541,
                    y_min: -15,
                    y_max: 752,
                    ha: 767,
                    leftSideBearing: 40,
                    advanceWidth: 585
                },
                9: {
                    x_min: 40,
                    x_max: 537,
                    y_min: -52,
                    y_max: 736,
                    ha: 788,
                    leftSideBearing: 40,
                    advanceWidth: 592
                },
                "!": {
                    x_min: 49,
                    x_max: 180,
                    y_min: -7,
                    y_max: 761,
                    ha: 768,
                    leftSideBearing: 49,
                    advanceWidth: 230
                },
                '"': {
                    x_min: 39,
                    x_max: 304,
                    y_min: 596,
                    y_max: 804,
                    ha: 208,
                    leftSideBearing: 39,
                    advanceWidth: 353
                },
                "#": {
                    x_min: 33,
                    x_max: 599,
                    y_min: -8,
                    y_max: 765,
                    ha: 773,
                    leftSideBearing: 33,
                    advanceWidth: 648
                },
                $: {
                    x_min: 53,
                    x_max: 495,
                    y_min: -111,
                    y_max: 823,
                    ha: 934,
                    leftSideBearing: 53,
                    advanceWidth: 560
                },
                "%": {
                    x_min: 35,
                    x_max: 656,
                    y_min: -128,
                    y_max: 808,
                    ha: 936,
                    leftSideBearing: 35,
                    advanceWidth: 711
                },
                "&": {
                    x_min: 53,
                    x_max: 441,
                    y_min: -3,
                    y_max: 753,
                    ha: 756,
                    leftSideBearing: 53,
                    advanceWidth: 500
                },
                "'": {
                    x_min: 43,
                    x_max: 161,
                    y_min: 590,
                    y_max: 811,
                    ha: 221,
                    leftSideBearing: 43,
                    advanceWidth: 217
                },
                "(": {
                    x_min: 41,
                    x_max: 311,
                    y_min: -36,
                    y_max: 845,
                    ha: 881,
                    leftSideBearing: 41,
                    advanceWidth: 308
                },
                ")": {
                    x_min: -8,
                    x_max: 257,
                    y_min: -21,
                    y_max: 852,
                    ha: 873,
                    leftSideBearing: -8,
                    advanceWidth: 280
                },
                "*": {
                    x_min: 59,
                    x_max: 539,
                    y_min: 175,
                    y_max: 589,
                    ha: 414,
                    leftSideBearing: 59,
                    advanceWidth: 601
                },
                "+": {
                    x_min: 33,
                    x_max: 361,
                    y_min: 180,
                    y_max: 587,
                    ha: 407,
                    leftSideBearing: 33,
                    advanceWidth: 400
                },
                ",": {
                    x_min: 15,
                    x_max: 176,
                    y_min: -129,
                    y_max: 92,
                    ha: 221,
                    leftSideBearing: 15,
                    advanceWidth: 205
                },
                "-": {
                    x_min: 40,
                    x_max: 380,
                    y_min: 317,
                    y_max: 452,
                    ha: 135,
                    leftSideBearing: 40,
                    advanceWidth: 422
                },
                ".": {
                    x_min: 48,
                    x_max: 185,
                    y_min: -56,
                    y_max: 84,
                    ha: 140,
                    leftSideBearing: 48,
                    advanceWidth: 227
                },
                "/": {
                    x_min: -58,
                    x_max: 654,
                    y_min: -122,
                    y_max: 844,
                    ha: 966,
                    leftSideBearing: -58,
                    advanceWidth: 626
                },
                ":": {
                    x_min: 65,
                    x_max: 225,
                    y_min: 97,
                    y_max: 536,
                    ha: 439,
                    leftSideBearing: 65,
                    advanceWidth: 302
                },
                ";": {
                    x_min: 13,
                    x_max: 295,
                    y_min: -139,
                    y_max: 536,
                    ha: 675,
                    leftSideBearing: 13,
                    advanceWidth: 334
                },
                "<": {
                    x_min: 28,
                    x_max: 438,
                    y_min: -1,
                    y_max: 607,
                    ha: 608,
                    leftSideBearing: 28,
                    advanceWidth: 475
                },
                "=": {
                    x_min: 40,
                    x_max: 383,
                    y_min: 199.9598640852289,
                    y_max: 541,
                    ha: 341.0401359147711,
                    leftSideBearing: 40,
                    advanceWidth: 422
                },
                ">": {
                    x_min: 35,
                    x_max: 421,
                    y_min: 28,
                    y_max: 632,
                    ha: 604,
                    leftSideBearing: 35,
                    advanceWidth: 466
                },
                "?": {
                    x_min: 45,
                    x_max: 548,
                    y_min: -17,
                    y_max: 767,
                    ha: 784,
                    leftSideBearing: 45,
                    advanceWidth: 592
                },
                "@": {
                    x_min: 51,
                    x_max: 730,
                    y_min: -78,
                    y_max: 753,
                    ha: 831,
                    leftSideBearing: 51,
                    advanceWidth: 781
                },
                A: {
                    x_min: 37,
                    x_max: 554,
                    y_min: -4,
                    y_max: 746,
                    ha: 750,
                    leftSideBearing: 37,
                    advanceWidth: 617
                },
                B: {
                    x_min: 37,
                    x_max: 532,
                    y_min: 3,
                    y_max: 783,
                    ha: 780,
                    leftSideBearing: 37,
                    advanceWidth: 579
                },
                C: {
                    x_min: 37,
                    x_max: 583,
                    y_min: -3,
                    y_max: 775,
                    ha: 778,
                    leftSideBearing: 37,
                    advanceWidth: 623
                },
                D: {
                    x_min: 50,
                    x_max: 530,
                    y_min: -15,
                    y_max: 749,
                    ha: 764,
                    leftSideBearing: 50,
                    advanceWidth: 579
                },
                E: {
                    x_min: 45,
                    x_max: 531,
                    y_min: -1,
                    y_max: 743,
                    ha: 744,
                    leftSideBearing: 45,
                    advanceWidth: 585
                },
                F: {
                    x_min: 45,
                    x_max: 459,
                    y_min: 23,
                    y_max: 727,
                    ha: 704,
                    leftSideBearing: 45,
                    advanceWidth: 510
                },
                G: {
                    x_min: 31,
                    x_max: 577,
                    y_min: -8,
                    y_max: 733,
                    ha: 741,
                    leftSideBearing: 31,
                    advanceWidth: 611
                },
                H: {
                    x_min: 37,
                    x_max: 493,
                    y_min: -22,
                    y_max: 758,
                    ha: 780,
                    leftSideBearing: 37,
                    advanceWidth: 535
                },
                I: {
                    x_min: 47,
                    x_max: 501,
                    y_min: -3,
                    y_max: 731,
                    ha: 734,
                    leftSideBearing: 47,
                    advanceWidth: 541
                },
                J: {
                    x_min: 33,
                    x_max: 531,
                    y_min: -23,
                    y_max: 725,
                    ha: 748,
                    leftSideBearing: 33,
                    advanceWidth: 573
                },
                K: {
                    x_min: 43,
                    x_max: 505,
                    y_min: -10,
                    y_max: 740,
                    ha: 750,
                    leftSideBearing: 43,
                    advanceWidth: 560
                },
                L: {
                    x_min: 49,
                    x_max: 457,
                    y_min: -2,
                    y_max: 746,
                    ha: 748,
                    leftSideBearing: 49,
                    advanceWidth: 510
                },
                M: {
                    x_min: 35,
                    x_max: 699,
                    y_min: 1,
                    y_max: 744,
                    ha: 743,
                    leftSideBearing: 35,
                    advanceWidth: 743
                },
                N: {
                    x_min: 34,
                    x_max: 533,
                    y_min: -17,
                    y_max: 761,
                    ha: 778,
                    leftSideBearing: 34,
                    advanceWidth: 579
                },
                O: {
                    x_min: 41,
                    x_max: 608,
                    y_min: -5,
                    y_max: 735,
                    ha: 740,
                    leftSideBearing: 41,
                    advanceWidth: 667
                },
                P: {
                    x_min: 53,
                    x_max: 451,
                    y_min: -18,
                    y_max: 735,
                    ha: 753,
                    leftSideBearing: 53,
                    advanceWidth: 497
                },
                Q: {
                    x_min: 40,
                    x_max: 599,
                    y_min: -67,
                    y_max: 744,
                    ha: 811,
                    leftSideBearing: 40,
                    advanceWidth: 648
                },
                R: {
                    x_min: 39,
                    x_max: 487,
                    y_min: 16,
                    y_max: 735,
                    ha: 719,
                    leftSideBearing: 39,
                    advanceWidth: 535
                },
                S: {
                    x_min: 35,
                    x_max: 552,
                    y_min: -47,
                    y_max: 708,
                    ha: 755,
                    leftSideBearing: 35,
                    advanceWidth: 604
                },
                T: {
                    x_min: 26,
                    x_max: 656,
                    y_min: -13,
                    y_max: 718,
                    ha: 731,
                    leftSideBearing: 26,
                    advanceWidth: 705
                },
                U: {
                    x_min: 41,
                    x_max: 518,
                    y_min: -20,
                    y_max: 748,
                    ha: 768,
                    leftSideBearing: 41,
                    advanceWidth: 567
                },
                V: {
                    x_min: 47,
                    x_max: 509,
                    y_min: -26,
                    y_max: 744,
                    ha: 770,
                    leftSideBearing: 47,
                    advanceWidth: 567
                },
                W: {
                    x_min: 44,
                    x_max: 789,
                    y_min: -35,
                    y_max: 720,
                    ha: 755,
                    leftSideBearing: 44,
                    advanceWidth: 833
                },
                X: {
                    x_min: 63,
                    x_max: 635,
                    y_min: -10,
                    y_max: 745,
                    ha: 755,
                    leftSideBearing: 63,
                    advanceWidth: 680
                },
                Y: {
                    x_min: 43,
                    x_max: 503,
                    y_min: -21,
                    y_max: 734,
                    ha: 755,
                    leftSideBearing: 43,
                    advanceWidth: 541
                },
                Z: {
                    x_min: 42,
                    x_max: 584,
                    y_min: -10,
                    y_max: 739,
                    ha: 749,
                    leftSideBearing: 42,
                    advanceWidth: 629
                },
                "[": {
                    x_min: 46,
                    x_max: 346,
                    y_min: -150,
                    y_max: 884,
                    ha: 1034,
                    leftSideBearing: 46,
                    advanceWidth: 291
                },
                "\\": {
                    x_min: 20,
                    x_max: 616,
                    y_min: -100,
                    y_max: 797,
                    ha: 897,
                    leftSideBearing: 20,
                    advanceWidth: 645
                },
                "]": {
                    x_min: -76,
                    x_max: 226,
                    y_min: -150,
                    y_max: 881,
                    ha: 1031,
                    leftSideBearing: -76,
                    advanceWidth: 297
                },
                "^": {
                    x_min: 43,
                    x_max: 437,
                    y_min: 517,
                    y_max: 812,
                    ha: 295,
                    leftSideBearing: 43,
                    advanceWidth: 478
                },
                _: {
                    x_min: 29,
                    x_max: 563,
                    y_min: -110,
                    y_max: -1,
                    ha: 109,
                    leftSideBearing: 29,
                    advanceWidth: 598
                },
                "`": {
                    x_min: 54,
                    x_max: 321,
                    y_min: 540,
                    y_max: 747,
                    ha: 207,
                    leftSideBearing: 54,
                    advanceWidth: 368
                },
                a: {
                    x_min: 20,
                    x_max: 447,
                    y_min: -17,
                    y_max: 495,
                    ha: 512,
                    leftSideBearing: 20,
                    advanceWidth: 494
                },
                b: {
                    x_min: 37,
                    x_max: 466,
                    y_min: -27,
                    y_max: 770,
                    ha: 797,
                    leftSideBearing: 37,
                    advanceWidth: 510
                },
                c: {
                    x_min: 35,
                    x_max: 456,
                    y_min: -9,
                    y_max: 507,
                    ha: 516,
                    leftSideBearing: 35,
                    advanceWidth: 460
                },
                d: {
                    x_min: 45,
                    x_max: 520,
                    y_min: -15,
                    y_max: 764,
                    ha: 779,
                    leftSideBearing: 45,
                    advanceWidth: 560
                },
                e: {
                    x_min: 33,
                    x_max: 370,
                    y_min: -5,
                    y_max: 501,
                    ha: 506,
                    leftSideBearing: 33,
                    advanceWidth: 397
                },
                f: {
                    x_min: 35,
                    x_max: 411,
                    y_min: -13,
                    y_max: 695,
                    ha: 708,
                    leftSideBearing: 35,
                    advanceWidth: 453
                },
                g: {
                    x_min: 33,
                    x_max: 551,
                    y_min: -257,
                    y_max: 505,
                    ha: 762,
                    leftSideBearing: 33,
                    advanceWidth: 611
                },
                h: {
                    x_min: 32,
                    x_max: 458,
                    y_min: -29,
                    y_max: 743,
                    ha: 772,
                    leftSideBearing: 32,
                    advanceWidth: 491
                },
                i: {
                    x_min: 45,
                    x_max: 167,
                    y_min: -13,
                    y_max: 631,
                    ha: 644,
                    leftSideBearing: 45,
                    advanceWidth: 220
                },
                j: {
                    x_min: -127,
                    x_max: 261,
                    y_min: -231,
                    y_max: 601,
                    ha: 832,
                    leftSideBearing: -127,
                    advanceWidth: 308
                },
                k: {
                    x_min: 39,
                    x_max: 443,
                    y_min: -3,
                    y_max: 700,
                    ha: 703,
                    leftSideBearing: 39,
                    advanceWidth: 497
                },
                l: {
                    x_min: 58,
                    x_max: 168,
                    y_min: -8,
                    y_max: 686,
                    ha: 694,
                    leftSideBearing: 58,
                    advanceWidth: 227
                },
                m: {
                    x_min: 39,
                    x_max: 688,
                    y_min: -14,
                    y_max: 501,
                    ha: 515,
                    leftSideBearing: 39,
                    advanceWidth: 718
                },
                n: {
                    x_min: 45,
                    x_max: 491,
                    y_min: -32,
                    y_max: 512,
                    ha: 544,
                    leftSideBearing: 45,
                    advanceWidth: 541
                },
                o: {
                    x_min: 41,
                    x_max: 424,
                    y_min: -12,
                    y_max: 493,
                    ha: 505,
                    leftSideBearing: 41,
                    advanceWidth: 447
                },
                p: {
                    x_min: 25,
                    x_max: 529,
                    y_min: -260,
                    y_max: 500,
                    ha: 760,
                    leftSideBearing: 25,
                    advanceWidth: 573
                },
                q: {
                    x_min: 53,
                    x_max: 603,
                    y_min: -235,
                    y_max: 514,
                    ha: 749,
                    leftSideBearing: 53,
                    advanceWidth: 623
                },
                r: {
                    x_min: 32,
                    x_max: 407,
                    y_min: -7,
                    y_max: 492,
                    ha: 499,
                    leftSideBearing: 32,
                    advanceWidth: 460
                },
                s: {
                    x_min: 49,
                    x_max: 416,
                    y_min: -12,
                    y_max: 519,
                    ha: 531,
                    leftSideBearing: 49,
                    advanceWidth: 460
                },
                t: {
                    x_min: 32,
                    x_max: 442,
                    y_min: -5,
                    y_max: 684,
                    ha: 689,
                    leftSideBearing: 32,
                    advanceWidth: 469
                },
                u: {
                    x_min: 41,
                    x_max: 487,
                    y_min: -5,
                    y_max: 507,
                    ha: 512,
                    leftSideBearing: 41,
                    advanceWidth: 510
                },
                v: {
                    x_min: 16,
                    x_max: 441,
                    y_min: -20,
                    y_max: 542,
                    ha: 562,
                    leftSideBearing: 16,
                    advanceWidth: 456
                },
                w: {
                    x_min: 39,
                    x_max: 639,
                    y_min: -22,
                    y_max: 505,
                    ha: 527,
                    leftSideBearing: 39,
                    advanceWidth: 661
                },
                x: {
                    x_min: 15,
                    x_max: 505,
                    y_min: -39,
                    y_max: 539,
                    ha: 578,
                    leftSideBearing: 15,
                    advanceWidth: 541
                },
                y: {
                    x_min: -98,
                    x_max: 501,
                    y_min: -242,
                    y_max: 511,
                    ha: 753,
                    leftSideBearing: -98,
                    advanceWidth: 548
                },
                z: {
                    x_min: 27,
                    x_max: 479,
                    y_min: -3,
                    y_max: 494,
                    ha: 497,
                    leftSideBearing: 27,
                    advanceWidth: 494
                },
                "{": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 308
                },
                "|": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 308
                },
                "}": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 308
                },
                "~": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 308
                }
            },
            fontFamily: "PetalumaScript",
            resolution: 1e3,
            generatedOn: "2020-06-14T18:33:25.407Z"
        }, Ui = {
            spacing: 50,
            glyphs: {
                " ": {
                    x_min: 0,
                    x_max: 509,
                    y_min: 0,
                    y_max: 2e3,
                    ha: 2e3,
                    leftSideBearing: 0,
                    advanceWidth: 509
                },
                0: {
                    x_min: 121,
                    x_max: 1048,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 121,
                    advanceWidth: 1168
                },
                1: {
                    x_min: 117,
                    x_max: 767,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 117,
                    advanceWidth: 844
                },
                2: {
                    x_min: 75.8474576645637,
                    x_max: 1040,
                    y_min: 0,
                    y_max: 1477,
                    ha: 1477,
                    leftSideBearing: 75,
                    advanceWidth: 1131
                },
                3: {
                    x_min: 74.85365853658536,
                    x_max: 994,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 74,
                    advanceWidth: 1106
                },
                4: {
                    x_min: 63,
                    x_max: 1114,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 63,
                    advanceWidth: 1187
                },
                5: {
                    x_min: 96.8448275474953,
                    x_max: 982,
                    y_min: -21,
                    y_max: 1456,
                    ha: 1477,
                    leftSideBearing: 96,
                    advanceWidth: 1081
                },
                6: {
                    x_min: 121,
                    x_max: 1067,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 121,
                    advanceWidth: 1144
                },
                7: {
                    x_min: 76,
                    x_max: 1060,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: -30,
                    advanceWidth: 1128
                },
                8: {
                    x_min: 92,
                    x_max: 1039,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 92,
                    advanceWidth: 1131
                },
                9: {
                    x_min: 84,
                    x_max: 1026,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 84,
                    advanceWidth: 1154
                },
                "!": {
                    x_min: 143,
                    x_max: 340,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 143,
                    advanceWidth: 483
                },
                '"': {
                    x_min: 166,
                    x_max: 634,
                    y_min: 1055,
                    y_max: 1560,
                    ha: 505,
                    leftSideBearing: 166,
                    advanceWidth: 770
                },
                "#": {
                    x_min: 63,
                    x_max: 1179,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 63,
                    advanceWidth: 1246
                },
                $: {
                    x_min: 81.92156915727656,
                    x_max: 1012,
                    y_min: -208,
                    y_max: 1693,
                    ha: 1901,
                    leftSideBearing: 81,
                    advanceWidth: 1110
                },
                "%": {
                    x_min: 77,
                    x_max: 1384,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 77,
                    advanceWidth: 1460
                },
                "&": {
                    x_min: 74,
                    x_max: 1242,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 74,
                    advanceWidth: 1289
                },
                "'": {
                    x_min: 166,
                    x_max: 324,
                    y_min: 1055,
                    y_max: 1560,
                    ha: 505,
                    leftSideBearing: 166,
                    advanceWidth: 460
                },
                "(": {
                    x_min: 114,
                    x_max: 650,
                    y_min: -463,
                    y_max: 1636,
                    ha: 2099,
                    leftSideBearing: 114,
                    advanceWidth: 662
                },
                ")": {
                    x_min: 11,
                    x_max: 547,
                    y_min: -463,
                    y_max: 1636,
                    ha: 2099,
                    leftSideBearing: 11,
                    advanceWidth: 654
                },
                "*": {
                    x_min: 66,
                    x_max: 893,
                    y_min: 607,
                    y_max: 1456,
                    ha: 849,
                    leftSideBearing: 66,
                    advanceWidth: 958
                },
                "+": {
                    x_min: 73,
                    x_max: 1071,
                    y_min: 146,
                    y_max: 1206,
                    ha: 1060,
                    leftSideBearing: 73,
                    advanceWidth: 1145
                },
                ",": {
                    x_min: 23,
                    x_max: 315,
                    y_min: -311,
                    y_max: 221,
                    ha: 532,
                    leftSideBearing: 23,
                    advanceWidth: 404
                },
                "-": {
                    x_min: 154,
                    x_max: 643,
                    y_min: 538,
                    y_max: 692,
                    ha: 154,
                    leftSideBearing: 154,
                    advanceWidth: 797
                },
                ".": {
                    x_min: 145,
                    x_max: 342,
                    y_min: 0,
                    y_max: 202,
                    ha: 202,
                    leftSideBearing: 145,
                    advanceWidth: 493
                },
                "/": {
                    x_min: 0,
                    x_max: 774,
                    y_min: -125,
                    y_max: 1456,
                    ha: 1581,
                    leftSideBearing: 0,
                    advanceWidth: 824
                },
                ":": {
                    x_min: 145,
                    x_max: 342,
                    y_min: 0,
                    y_max: 1082,
                    ha: 1082,
                    leftSideBearing: 145,
                    advanceWidth: 419
                },
                ";": {
                    x_min: 53,
                    x_max: 345,
                    y_min: -311,
                    y_max: 1082,
                    ha: 1393,
                    leftSideBearing: 53,
                    advanceWidth: 424
                },
                "<": {
                    x_min: 76,
                    x_max: 892,
                    y_min: 107,
                    y_max: 1013,
                    ha: 906,
                    leftSideBearing: 76,
                    advanceWidth: 1017
                },
                "=": {
                    x_min: 147,
                    x_max: 981,
                    y_min: 407,
                    y_max: 987,
                    ha: 580,
                    leftSideBearing: 147,
                    advanceWidth: 1127
                },
                ">": {
                    x_min: 125,
                    x_max: 980,
                    y_min: 87,
                    y_max: 993,
                    ha: 906,
                    leftSideBearing: 125,
                    advanceWidth: 1060
                },
                "?": {
                    x_min: 65.92660602419838,
                    x_max: 890,
                    y_min: 0,
                    y_max: 1477,
                    ha: 1477,
                    leftSideBearing: 65,
                    advanceWidth: 953
                },
                "@": {
                    x_min: 84.3592218305664,
                    x_max: 1705.2346925277395,
                    y_min: -453,
                    y_max: 1431,
                    ha: 1884,
                    leftSideBearing: 84,
                    advanceWidth: 1821
                },
                A: {
                    x_min: 70,
                    x_max: 1463,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 70,
                    advanceWidth: 1533
                },
                B: {
                    x_min: 81,
                    x_max: 1253,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1322
                },
                C: {
                    x_min: 80,
                    x_max: 1174,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 80,
                    advanceWidth: 1290
                },
                D: {
                    x_min: 81,
                    x_max: 1291,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1356
                },
                E: {
                    x_min: 81,
                    x_max: 1190,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1306
                },
                F: {
                    x_min: 81,
                    x_max: 1176,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1256
                },
                G: {
                    x_min: 80,
                    x_max: 1226,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 80,
                    advanceWidth: 1346
                },
                H: {
                    x_min: 81,
                    x_max: 1497,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1578
                },
                I: {
                    x_min: 81,
                    x_max: 604,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 685
                },
                J: {
                    x_min: 60,
                    x_max: 1100,
                    y_min: -21,
                    y_max: 1456,
                    ha: 1477,
                    leftSideBearing: 60,
                    advanceWidth: 1169
                },
                K: {
                    x_min: 81,
                    x_max: 1427,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1501
                },
                L: {
                    x_min: 81,
                    x_max: 1130,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1210
                },
                M: {
                    x_min: 94,
                    x_max: 1888,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 94,
                    advanceWidth: 1982
                },
                N: {
                    x_min: 83,
                    x_max: 1509,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 83,
                    advanceWidth: 1592
                },
                O: {
                    x_min: 70,
                    x_max: 1281,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 70,
                    advanceWidth: 1351
                },
                P: {
                    x_min: 81,
                    x_max: 1242,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 81,
                    advanceWidth: 1297
                },
                Q: {
                    x_min: 70,
                    x_max: 1348,
                    y_min: -245,
                    y_max: 1477,
                    ha: 1722,
                    leftSideBearing: 70,
                    advanceWidth: 1376
                },
                R: {
                    x_min: 81,
                    x_max: 1285,
                    y_min: 0,
                    y_max: 1455,
                    ha: 1455,
                    leftSideBearing: 81,
                    advanceWidth: 1385
                },
                S: {
                    x_min: 115,
                    x_max: 1116,
                    y_min: -21,
                    y_max: 1477,
                    ha: 1498,
                    leftSideBearing: 115,
                    advanceWidth: 1206
                },
                T: {
                    x_min: 96,
                    x_max: 1306,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 96,
                    advanceWidth: 1406
                },
                U: {
                    x_min: 70,
                    x_max: 1452,
                    y_min: -21,
                    y_max: 1456,
                    ha: 1477,
                    leftSideBearing: 70,
                    advanceWidth: 1522
                },
                V: {
                    x_min: 65,
                    x_max: 1443,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 65,
                    advanceWidth: 1508
                },
                W: {
                    x_min: 72,
                    x_max: 2057,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 72,
                    advanceWidth: 2129
                },
                X: {
                    x_min: 80,
                    x_max: 1449,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 80,
                    advanceWidth: 1529
                },
                Y: {
                    x_min: 65,
                    x_max: 1396,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 65,
                    advanceWidth: 1461
                },
                Z: {
                    x_min: 90,
                    x_max: 1107,
                    y_min: 0,
                    y_max: 1456,
                    ha: 1456,
                    leftSideBearing: 90,
                    advanceWidth: 1197
                },
                "[": {
                    x_min: 157,
                    x_max: 541,
                    y_min: -312,
                    y_max: 1664,
                    ha: 1976,
                    leftSideBearing: 157,
                    advanceWidth: 573
                },
                "\\": {
                    x_min: 36,
                    x_max: 830,
                    y_min: -125,
                    y_max: 1456,
                    ha: 1581,
                    leftSideBearing: 36,
                    advanceWidth: 841
                },
                "]": {
                    x_min: 23,
                    x_max: 408,
                    y_min: -312,
                    y_max: 1664,
                    ha: 1976,
                    leftSideBearing: 23,
                    advanceWidth: 552
                },
                "^": {
                    x_min: 71,
                    x_max: 802,
                    y_min: 729,
                    y_max: 1456,
                    ha: 727,
                    leftSideBearing: 71,
                    advanceWidth: 864
                },
                _: {
                    x_min: 119,
                    x_max: 1041,
                    y_min: -154,
                    y_max: 0,
                    ha: 154,
                    leftSideBearing: 119,
                    advanceWidth: 1168
                },
                "`": {
                    x_min: 40,
                    x_max: 456,
                    y_min: 1288,
                    y_max: 1560,
                    ha: 272,
                    leftSideBearing: 40,
                    advanceWidth: 496
                },
                a: {
                    x_min: 79,
                    x_max: 1053,
                    y_min: -21,
                    y_max: 1102,
                    ha: 1123,
                    leftSideBearing: 79,
                    advanceWidth: 1132
                },
                b: {
                    x_min: -16,
                    x_max: 1071,
                    y_min: -21,
                    y_max: 1560,
                    ha: 1581,
                    leftSideBearing: -16,
                    advanceWidth: 1145
                },
                c: {
                    x_min: 78,
                    x_max: 988,
                    y_min: -21,
                    y_max: 1102,
                    ha: 1123,
                    leftSideBearing: 78,
                    advanceWidth: 1067
                },
                d: {
                    x_min: 78,
                    x_max: 1156,
                    y_min: -21,
                    y_max: 1560,
                    ha: 1581,
                    leftSideBearing: 78,
                    advanceWidth: 1218
                },
                e: {
                    x_min: 74,
                    x_max: 980,
                    y_min: -21,
                    y_max: 1102,
                    ha: 1123,
                    leftSideBearing: 74,
                    advanceWidth: 1059
                },
                f: {
                    x_min: 64,
                    x_max: 731,
                    y_min: 0,
                    y_max: 1581,
                    ha: 1581,
                    leftSideBearing: 64,
                    advanceWidth: 725
                },
                g: {
                    x_min: 78,
                    x_max: 1133,
                    y_min: -437,
                    y_max: 1102,
                    ha: 1539,
                    leftSideBearing: 78,
                    advanceWidth: 1157
                },
                h: {
                    x_min: 49,
                    x_max: 1255,
                    y_min: 0,
                    y_max: 1560,
                    ha: 1560,
                    leftSideBearing: 49,
                    advanceWidth: 1315
                },
                i: {
                    x_min: 67,
                    x_max: 590,
                    y_min: 0,
                    y_max: 1560,
                    ha: 1560,
                    leftSideBearing: 67,
                    advanceWidth: 652
                },
                j: {
                    x_min: -56,
                    x_max: 381,
                    y_min: -437,
                    y_max: 1560,
                    ha: 1997,
                    leftSideBearing: -56,
                    advanceWidth: 525
                },
                k: {
                    x_min: 64,
                    x_max: 1248,
                    y_min: 0,
                    y_max: 1560,
                    ha: 1560,
                    leftSideBearing: 64,
                    advanceWidth: 1287
                },
                l: {
                    x_min: 64,
                    x_max: 587,
                    y_min: 0,
                    y_max: 1560,
                    ha: 1560,
                    leftSideBearing: 64,
                    advanceWidth: 653
                },
                m: {
                    x_min: 74,
                    x_max: 1905,
                    y_min: 0,
                    y_max: 1102,
                    ha: 1102,
                    leftSideBearing: 74,
                    advanceWidth: 1977
                },
                n: {
                    x_min: 74,
                    x_max: 1278,
                    y_min: 0,
                    y_max: 1102,
                    ha: 1102,
                    leftSideBearing: 74,
                    advanceWidth: 1343
                },
                o: {
                    x_min: 78,
                    x_max: 1046,
                    y_min: -21,
                    y_max: 1102,
                    ha: 1123,
                    leftSideBearing: 78,
                    advanceWidth: 1124
                },
                p: {
                    x_min: 34,
                    x_max: 1119,
                    y_min: -416,
                    y_max: 1102,
                    ha: 1518,
                    leftSideBearing: 34,
                    advanceWidth: 1197
                },
                q: {
                    x_min: 78,
                    x_max: 1135,
                    y_min: -416,
                    y_max: 1102,
                    ha: 1518,
                    leftSideBearing: 78,
                    advanceWidth: 1139
                },
                r: {
                    x_min: 72,
                    x_max: 808,
                    y_min: 0,
                    y_max: 1102,
                    ha: 1102,
                    leftSideBearing: 72,
                    advanceWidth: 854
                },
                s: {
                    x_min: 104,
                    x_max: 933,
                    y_min: -21,
                    y_max: 1102,
                    ha: 1123,
                    leftSideBearing: 104,
                    advanceWidth: 1022
                },
                t: {
                    x_min: 24,
                    x_max: 678,
                    y_min: -17,
                    y_max: 1343,
                    ha: 1360,
                    leftSideBearing: 24,
                    advanceWidth: 730
                },
                u: {
                    x_min: 52,
                    x_max: 1181,
                    y_min: -21,
                    y_max: 1082,
                    ha: 1103,
                    leftSideBearing: 52,
                    advanceWidth: 1245
                },
                v: {
                    x_min: 26,
                    x_max: 1176,
                    y_min: 0,
                    y_max: 1082,
                    ha: 1082,
                    leftSideBearing: 26,
                    advanceWidth: 1206
                },
                w: {
                    x_min: 52,
                    x_max: 1777,
                    y_min: 0,
                    y_max: 1082,
                    ha: 1082,
                    leftSideBearing: 52,
                    advanceWidth: 1823
                },
                x: {
                    x_min: 42,
                    x_max: 1163,
                    y_min: 0,
                    y_max: 1082,
                    ha: 1082,
                    leftSideBearing: 42,
                    advanceWidth: 1203
                },
                y: {
                    x_min: 24,
                    x_max: 1172,
                    y_min: -437,
                    y_max: 1082,
                    ha: 1519,
                    leftSideBearing: 24,
                    advanceWidth: 1192
                },
                z: {
                    x_min: 88,
                    x_max: 960,
                    y_min: 0,
                    y_max: 1082,
                    ha: 1082,
                    leftSideBearing: 88,
                    advanceWidth: 1032
                },
                "{": {
                    x_min: 63,
                    x_max: 671,
                    y_min: -364,
                    y_max: 1597,
                    ha: 1961,
                    leftSideBearing: 63,
                    advanceWidth: 701
                },
                "|": {
                    x_min: 150,
                    x_max: 307,
                    y_min: -270,
                    y_max: 1456,
                    ha: 1726,
                    leftSideBearing: 150,
                    advanceWidth: 451
                },
                "}": {
                    x_min: 27,
                    x_max: 635,
                    y_min: -364,
                    y_max: 1597,
                    ha: 1961,
                    leftSideBearing: 27,
                    advanceWidth: 701
                },
                "~": {
                    x_min: 121,
                    x_max: 1257,
                    y_min: 401,
                    y_max: 803,
                    ha: 402,
                    leftSideBearing: 121,
                    advanceWidth: 1386
                }
            },
            fontFamily: "Roboto Slab",
            resolution: 2048,
            generatedOn: "2020-06-15T19:12:58.120Z"
        }, Ii = {
            glyphs: {
                0: {
                    x_min: 86,
                    x_max: 1038,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 86,
                    advanceWidth: 1139
                },
                1: {
                    x_min: 162,
                    x_max: 806,
                    y_min: 0,
                    y_max: 1472,
                    ha: 1472,
                    leftSideBearing: 162,
                    advanceWidth: 1139
                },
                2: {
                    x_min: 51,
                    x_max: 1036,
                    y_min: 0,
                    y_max: 1472,
                    ha: 1472,
                    leftSideBearing: 51,
                    advanceWidth: 1139
                },
                3: {
                    x_min: 77,
                    x_max: 1051,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 77,
                    advanceWidth: 1139
                },
                4: {
                    x_min: 38,
                    x_max: 1092,
                    y_min: 0,
                    y_max: 1472,
                    ha: 1472,
                    leftSideBearing: 38,
                    advanceWidth: 1139
                },
                5: {
                    x_min: 91,
                    x_max: 1077,
                    y_min: -25,
                    y_max: 1446,
                    ha: 1471,
                    leftSideBearing: 91,
                    advanceWidth: 1139
                },
                6: {
                    x_min: 87,
                    x_max: 1066,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 87,
                    advanceWidth: 1139
                },
                7: {
                    x_min: 87,
                    x_max: 1048,
                    y_min: 0,
                    y_max: 1446,
                    ha: 1446,
                    leftSideBearing: 87,
                    advanceWidth: 1139
                },
                8: {
                    x_min: 83,
                    x_max: 1047,
                    y_min: -26,
                    y_max: 1472,
                    ha: 1498,
                    leftSideBearing: 83,
                    advanceWidth: 1139
                },
                9: {
                    x_min: 65,
                    x_max: 1044,
                    y_min: -26,
                    y_max: 1472,
                    ha: 1498,
                    leftSideBearing: 65,
                    advanceWidth: 1139
                },
                " ": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 569
                },
                "!": {
                    x_min: 184,
                    x_max: 488,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 184,
                    advanceWidth: 682
                },
                '"': {
                    x_min: 112,
                    x_max: 869,
                    y_min: 945,
                    y_max: 1466,
                    ha: 521,
                    leftSideBearing: 112,
                    advanceWidth: 971
                },
                "#": {
                    x_min: 18,
                    x_max: 1115,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 18,
                    advanceWidth: 1139
                },
                $: {
                    x_min: 70,
                    x_max: 1048,
                    y_min: -205,
                    y_max: 1584,
                    ha: 1789,
                    leftSideBearing: 70,
                    advanceWidth: 1139
                },
                "%": {
                    x_min: 89,
                    x_max: 1725,
                    y_min: -59,
                    y_max: 1491,
                    ha: 1550,
                    leftSideBearing: 89,
                    advanceWidth: 1821
                },
                "&": {
                    x_min: 90,
                    x_max: 1446,
                    y_min: -38,
                    y_max: 1491,
                    ha: 1529,
                    leftSideBearing: 90,
                    advanceWidth: 1479
                },
                "'": {
                    x_min: 92,
                    x_max: 398,
                    y_min: 945,
                    y_max: 1466,
                    ha: 521,
                    leftSideBearing: 92,
                    advanceWidth: 487
                },
                "(": {
                    x_min: 107,
                    x_max: 616,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 107,
                    advanceWidth: 682
                },
                ")": {
                    x_min: 67,
                    x_max: 576,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 67,
                    advanceWidth: 682
                },
                "*": {
                    x_min: 28,
                    x_max: 753,
                    y_min: 792,
                    y_max: 1491,
                    ha: 699,
                    leftSideBearing: 28,
                    advanceWidth: 797
                },
                "+": {
                    x_min: 85,
                    x_max: 1110,
                    y_min: 211,
                    y_max: 1236,
                    ha: 1025,
                    leftSideBearing: 85,
                    advanceWidth: 1196
                },
                ",": {
                    x_min: 117,
                    x_max: 421,
                    y_min: -327,
                    y_max: 281,
                    ha: 608,
                    leftSideBearing: 117,
                    advanceWidth: 569
                },
                "-": {
                    x_min: 115,
                    x_max: 667,
                    y_min: 391,
                    y_max: 672,
                    ha: 281,
                    leftSideBearing: 115,
                    advanceWidth: 682
                },
                ".": {
                    x_min: 147,
                    x_max: 428,
                    y_min: 0,
                    y_max: 281,
                    ha: 281,
                    leftSideBearing: 147,
                    advanceWidth: 569
                },
                "/": {
                    x_min: -3,
                    x_max: 571,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: -3,
                    advanceWidth: 569
                },
                ":": {
                    x_min: 201,
                    x_max: 482,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 201,
                    advanceWidth: 682
                },
                ";": {
                    x_min: 170,
                    x_max: 474,
                    y_min: -327,
                    y_max: 1062,
                    ha: 1389,
                    leftSideBearing: 170,
                    advanceWidth: 682
                },
                "<": {
                    x_min: 95,
                    x_max: 1100,
                    y_min: 167,
                    y_max: 1281,
                    ha: 1114,
                    leftSideBearing: 95,
                    advanceWidth: 1196
                },
                "=": {
                    x_min: 85,
                    x_max: 1110,
                    y_min: 372,
                    y_max: 1074,
                    ha: 702,
                    leftSideBearing: 85,
                    advanceWidth: 1196
                },
                ">": {
                    x_min: 95,
                    x_max: 1101,
                    y_min: 166,
                    y_max: 1279,
                    ha: 1113,
                    leftSideBearing: 95,
                    advanceWidth: 1196
                },
                "?": {
                    x_min: 106,
                    x_max: 1158,
                    y_min: 0,
                    y_max: 1481,
                    ha: 1481,
                    leftSideBearing: 106,
                    advanceWidth: 1251
                },
                "@": {
                    x_min: 61,
                    x_max: 1990,
                    y_min: -431,
                    y_max: 1492,
                    ha: 1923,
                    leftSideBearing: 61,
                    advanceWidth: 1997
                },
                A: {
                    x_min: 0,
                    x_max: 1471,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 0,
                    advanceWidth: 1479
                },
                B: {
                    x_min: 150,
                    x_max: 1378,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1479
                },
                C: {
                    x_min: 97,
                    x_max: 1374,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 97,
                    advanceWidth: 1479
                },
                D: {
                    x_min: 148,
                    x_max: 1377,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 148,
                    advanceWidth: 1479
                },
                E: {
                    x_min: 149,
                    x_max: 1264,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 149,
                    advanceWidth: 1366
                },
                F: {
                    x_min: 151,
                    x_max: 1156,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 151,
                    advanceWidth: 1251
                },
                G: {
                    x_min: 98,
                    x_max: 1469,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 98,
                    advanceWidth: 1593
                },
                H: {
                    x_min: 150,
                    x_max: 1322,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1479
                },
                I: {
                    x_min: 140,
                    x_max: 436,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 140,
                    advanceWidth: 569
                },
                J: {
                    x_min: 35,
                    x_max: 973,
                    y_min: -25,
                    y_max: 1466,
                    ha: 1491,
                    leftSideBearing: 35,
                    advanceWidth: 1139
                },
                K: {
                    x_min: 153,
                    x_max: 1475,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 153,
                    advanceWidth: 1479
                },
                L: {
                    x_min: 157,
                    x_max: 1189,
                    y_min: 0,
                    y_max: 1454,
                    ha: 1454,
                    leftSideBearing: 157,
                    advanceWidth: 1251
                },
                M: {
                    x_min: 145,
                    x_max: 1561,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 145,
                    advanceWidth: 1706
                },
                N: {
                    x_min: 152,
                    x_max: 1315,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 152,
                    advanceWidth: 1479
                },
                O: {
                    x_min: 89,
                    x_max: 1511,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 89,
                    advanceWidth: 1593
                },
                P: {
                    x_min: 149,
                    x_max: 1272,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 149,
                    advanceWidth: 1366
                },
                Q: {
                    x_min: 89,
                    x_max: 1566,
                    y_min: -147,
                    y_max: 1491,
                    ha: 1638,
                    leftSideBearing: 89,
                    advanceWidth: 1593
                },
                R: {
                    x_min: 150,
                    x_max: 1468,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1479
                },
                S: {
                    x_min: 74,
                    x_max: 1266,
                    y_min: -26,
                    y_max: 1491,
                    ha: 1517,
                    leftSideBearing: 74,
                    advanceWidth: 1366
                },
                T: {
                    x_min: 44,
                    x_max: 1209,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 44,
                    advanceWidth: 1251
                },
                U: {
                    x_min: 147,
                    x_max: 1316,
                    y_min: -25,
                    y_max: 1466,
                    ha: 1491,
                    leftSideBearing: 147,
                    advanceWidth: 1479
                },
                V: {
                    x_min: -1,
                    x_max: 1364,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: -1,
                    advanceWidth: 1366
                },
                W: {
                    x_min: 7,
                    x_max: 1931,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 7,
                    advanceWidth: 1933
                },
                X: {
                    x_min: 0,
                    x_max: 1363,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 0,
                    advanceWidth: 1366
                },
                Y: {
                    x_min: -3,
                    x_max: 1368,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: -3,
                    advanceWidth: 1366
                },
                Z: {
                    x_min: 22,
                    x_max: 1213,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 22,
                    advanceWidth: 1251
                },
                "[": {
                    x_min: 146,
                    x_max: 644,
                    y_min: -413,
                    y_max: 1466,
                    ha: 1879,
                    leftSideBearing: 146,
                    advanceWidth: 682
                },
                "\\": {
                    x_min: -3,
                    x_max: 571,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: -3,
                    advanceWidth: 569
                },
                "]": {
                    x_min: 38,
                    x_max: 536,
                    y_min: -413,
                    y_max: 1466,
                    ha: 1879,
                    leftSideBearing: 38,
                    advanceWidth: 682
                },
                "^": {
                    x_min: 115,
                    x_max: 1080,
                    y_min: 692,
                    y_max: 1491,
                    ha: 799,
                    leftSideBearing: 115,
                    advanceWidth: 1196
                },
                _: {
                    x_min: -19,
                    x_max: 1149,
                    y_min: -405,
                    y_max: -223,
                    ha: 182,
                    leftSideBearing: -19,
                    advanceWidth: 1139
                },
                "`": {
                    x_min: 42,
                    x_max: 495,
                    y_min: 1192,
                    y_max: 1491,
                    ha: 299,
                    leftSideBearing: 42,
                    advanceWidth: 682
                },
                a: {
                    x_min: 73,
                    x_max: 1070,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 73,
                    advanceWidth: 1139
                },
                b: {
                    x_min: 135,
                    x_max: 1172,
                    y_min: -24,
                    y_max: 1466,
                    ha: 1490,
                    leftSideBearing: 135,
                    advanceWidth: 1251
                },
                c: {
                    x_min: 85,
                    x_max: 1087,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 85,
                    advanceWidth: 1139
                },
                d: {
                    x_min: 84,
                    x_max: 1121,
                    y_min: -24,
                    y_max: 1466,
                    ha: 1490,
                    leftSideBearing: 84,
                    advanceWidth: 1251
                },
                e: {
                    x_min: 65,
                    x_max: 1057.2517482517483,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 65,
                    advanceWidth: 1139
                },
                f: {
                    x_min: 24,
                    x_max: 742,
                    y_min: 0,
                    y_max: 1491,
                    ha: 1491,
                    leftSideBearing: 24,
                    advanceWidth: 682
                },
                g: {
                    x_min: 84,
                    x_max: 1120,
                    y_min: -431,
                    y_max: 1086,
                    ha: 1517,
                    leftSideBearing: 84,
                    advanceWidth: 1251
                },
                h: {
                    x_min: 146,
                    x_max: 1113,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 146,
                    advanceWidth: 1251
                },
                i: {
                    x_min: 147,
                    x_max: 428,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 147,
                    advanceWidth: 569
                },
                j: {
                    x_min: -94,
                    x_max: 422,
                    y_min: -431,
                    y_max: 1466,
                    ha: 1897,
                    leftSideBearing: -94,
                    advanceWidth: 569
                },
                k: {
                    x_min: 137,
                    x_max: 1119,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 137,
                    advanceWidth: 1139
                },
                l: {
                    x_min: 147,
                    x_max: 428,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 147,
                    advanceWidth: 569
                },
                m: {
                    x_min: 126,
                    x_max: 1688,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 126,
                    advanceWidth: 1821
                },
                n: {
                    x_min: 145,
                    x_max: 1113,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 145,
                    advanceWidth: 1251
                },
                o: {
                    x_min: 82,
                    x_max: 1178,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 82,
                    advanceWidth: 1251
                },
                p: {
                    x_min: 139,
                    x_max: 1175,
                    y_min: -404,
                    y_max: 1086,
                    ha: 1490,
                    leftSideBearing: 139,
                    advanceWidth: 1251
                },
                q: {
                    x_min: 91,
                    x_max: 1122,
                    y_min: -404,
                    y_max: 1086,
                    ha: 1490,
                    leftSideBearing: 91,
                    advanceWidth: 1251
                },
                r: {
                    x_min: 135,
                    x_max: 823,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 135,
                    advanceWidth: 797
                },
                s: {
                    x_min: 48,
                    x_max: 1040,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 48,
                    advanceWidth: 1139
                },
                t: {
                    x_min: 31,
                    x_max: 657,
                    y_min: -24,
                    y_max: 1437,
                    ha: 1461,
                    leftSideBearing: 31,
                    advanceWidth: 682
                },
                u: {
                    x_min: 141,
                    x_max: 1107,
                    y_min: -24,
                    y_max: 1062,
                    ha: 1086,
                    leftSideBearing: 141,
                    advanceWidth: 1251
                },
                v: {
                    x_min: 11,
                    x_max: 1114,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 11,
                    advanceWidth: 1139
                },
                w: {
                    x_min: 9,
                    x_max: 1592,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 9,
                    advanceWidth: 1593
                },
                x: {
                    x_min: 12,
                    x_max: 1120,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 12,
                    advanceWidth: 1139
                },
                y: {
                    x_min: 14,
                    x_max: 1106,
                    y_min: -431,
                    y_max: 1062,
                    ha: 1493,
                    leftSideBearing: 14,
                    advanceWidth: 1139
                },
                z: {
                    x_min: 34,
                    x_max: 982,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 34,
                    advanceWidth: 1024
                },
                "{": {
                    x_min: 60,
                    x_max: 744,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 60,
                    advanceWidth: 797
                },
                "|": {
                    x_min: 176,
                    x_max: 399,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 176,
                    advanceWidth: 573
                },
                "}": {
                    x_min: 45,
                    x_max: 729,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 45,
                    advanceWidth: 797
                },
                "~": {
                    x_min: 67,
                    x_max: 1129,
                    y_min: 519,
                    y_max: 924,
                    ha: 405,
                    leftSideBearing: 67,
                    advanceWidth: 1196
                }
            },
            fontFamily: "Arial",
            resolution: 2048,
            generatedOn: "2022-11-04T20:05:21.000Z"
        }, Gi = {
            smufl: !1,
            name: "SANS",
            spacing: 50,
            Description: "Built-in sans-serif font",
            bold: !0,
            italic: !0,
            monospaced: !1,
            serifs: !1,
            glyphs: {
                0: {
                    x_min: 85,
                    x_max: 1041,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 85,
                    advanceWidth: 1139
                },
                1: {
                    x_min: 223,
                    x_max: 763,
                    y_min: 0,
                    y_max: 1472,
                    ha: 1472,
                    leftSideBearing: 223,
                    advanceWidth: 1139
                },
                2: {
                    x_min: 61.840001123045234,
                    x_max: 1031,
                    y_min: 0,
                    y_max: 1472,
                    ha: 1472,
                    leftSideBearing: 61,
                    advanceWidth: 1139
                },
                3: {
                    x_min: 86,
                    x_max: 1046,
                    y_min: -26,
                    y_max: 1472,
                    ha: 1498,
                    leftSideBearing: 86,
                    advanceWidth: 1139
                },
                4: {
                    x_min: 26,
                    x_max: 1040,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 26,
                    advanceWidth: 1139
                },
                5: {
                    x_min: 85,
                    x_max: 1057,
                    y_min: -25,
                    y_max: 1446,
                    ha: 1471,
                    leftSideBearing: 85,
                    advanceWidth: 1139
                },
                6: {
                    x_min: 77,
                    x_max: 1045,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 77,
                    advanceWidth: 1139
                },
                7: {
                    x_min: 97,
                    x_max: 1046,
                    y_min: 0,
                    y_max: 1447,
                    ha: 1447,
                    leftSideBearing: 97,
                    advanceWidth: 1139
                },
                8: {
                    x_min: 83,
                    x_max: 1049,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 83,
                    advanceWidth: 1139
                },
                9: {
                    x_min: 85,
                    x_max: 1049,
                    y_min: -25,
                    y_max: 1472,
                    ha: 1497,
                    leftSideBearing: 85,
                    advanceWidth: 1139
                },
                " ": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 569
                },
                "!": {
                    x_min: 176,
                    x_max: 399,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 176,
                    advanceWidth: 569
                },
                '"': {
                    x_min: 94,
                    x_max: 631,
                    y_min: 947,
                    y_max: 1466,
                    ha: 519,
                    leftSideBearing: 94,
                    advanceWidth: 727
                },
                "#": {
                    x_min: 21,
                    x_max: 1113,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 21,
                    advanceWidth: 1139
                },
                $: {
                    x_min: 73,
                    x_max: 1043,
                    y_min: -211,
                    y_max: 1601,
                    ha: 1812,
                    leftSideBearing: 73,
                    advanceWidth: 1139
                },
                "%": {
                    x_min: 119,
                    x_max: 1695,
                    y_min: -54,
                    y_max: 1491,
                    ha: 1545,
                    leftSideBearing: 119,
                    advanceWidth: 1821
                },
                "&": {
                    x_min: 88,
                    x_max: 1319,
                    y_min: -34,
                    y_max: 1491,
                    ha: 1525,
                    leftSideBearing: 88,
                    advanceWidth: 1366
                },
                "'": {
                    x_min: 90,
                    x_max: 295,
                    y_min: 947,
                    y_max: 1466,
                    ha: 519,
                    leftSideBearing: 90,
                    advanceWidth: 391
                },
                "(": {
                    x_min: 124,
                    x_max: 608,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 124,
                    advanceWidth: 682
                },
                ")": {
                    x_min: 124,
                    x_max: 608,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 124,
                    advanceWidth: 682
                },
                "*": {
                    x_min: 64,
                    x_max: 725,
                    y_min: 867,
                    y_max: 1491,
                    ha: 624,
                    leftSideBearing: 64,
                    advanceWidth: 797
                },
                "+": {
                    x_min: 114,
                    x_max: 1082,
                    y_min: 237,
                    y_max: 1206,
                    ha: 969,
                    leftSideBearing: 114,
                    advanceWidth: 1196
                },
                ",": {
                    x_min: 170,
                    x_max: 387,
                    y_min: -290,
                    y_max: 205,
                    ha: 495,
                    leftSideBearing: 170,
                    advanceWidth: 569
                },
                "-": {
                    x_min: 65,
                    x_max: 618,
                    y_min: 440,
                    y_max: 621,
                    ha: 181,
                    leftSideBearing: 65,
                    advanceWidth: 682
                },
                ".": {
                    x_min: 186,
                    x_max: 391,
                    y_min: 0,
                    y_max: 205,
                    ha: 205,
                    leftSideBearing: 186,
                    advanceWidth: 569
                },
                "/": {
                    x_min: 0,
                    x_max: 569,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 0,
                    advanceWidth: 569
                },
                ":": {
                    x_min: 185,
                    x_max: 390,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 185,
                    advanceWidth: 569
                },
                ";": {
                    x_min: 170,
                    x_max: 387,
                    y_min: -290,
                    y_max: 1062,
                    ha: 1352,
                    leftSideBearing: 170,
                    advanceWidth: 569
                },
                "<": {
                    x_min: 112,
                    x_max: 1083,
                    y_min: 226,
                    y_max: 1219,
                    ha: 993,
                    leftSideBearing: 112,
                    advanceWidth: 1196
                },
                "=": {
                    x_min: 114,
                    x_max: 1082,
                    y_min: 417,
                    y_max: 1030,
                    ha: 613,
                    leftSideBearing: 114,
                    advanceWidth: 1196
                },
                ">": {
                    x_min: 112,
                    x_max: 1083,
                    y_min: 226,
                    y_max: 1219,
                    ha: 993,
                    leftSideBearing: 112,
                    advanceWidth: 1196
                },
                "?": {
                    x_min: 90,
                    x_max: 1036,
                    y_min: 0,
                    y_max: 1491,
                    ha: 1491,
                    leftSideBearing: 90,
                    advanceWidth: 1139
                },
                "@": {
                    x_min: 111,
                    x_max: 2005,
                    y_min: -431,
                    y_max: 1493,
                    ha: 1924,
                    leftSideBearing: 111,
                    advanceWidth: 2079
                },
                A: {
                    x_min: -3,
                    x_max: 1369,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: -3,
                    advanceWidth: 1366
                },
                B: {
                    x_min: 150,
                    x_max: 1257,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1366
                },
                C: {
                    x_min: 102,
                    x_max: 1398,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 102,
                    advanceWidth: 1479
                },
                D: {
                    x_min: 158,
                    x_max: 1370,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 158,
                    advanceWidth: 1479
                },
                E: {
                    x_min: 162,
                    x_max: 1256,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 162,
                    advanceWidth: 1366
                },
                F: {
                    x_min: 168,
                    x_max: 1157,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 168,
                    advanceWidth: 1251
                },
                G: {
                    x_min: 109,
                    x_max: 1465,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 109,
                    advanceWidth: 1593
                },
                H: {
                    x_min: 164,
                    x_max: 1314,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 164,
                    advanceWidth: 1479
                },
                I: {
                    x_min: 191,
                    x_max: 385,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 191,
                    advanceWidth: 569
                },
                J: {
                    x_min: 58.84976474807333,
                    x_max: 865,
                    y_min: -25,
                    y_max: 1466,
                    ha: 1491,
                    leftSideBearing: 58,
                    advanceWidth: 1024
                },
                K: {
                    x_min: 150,
                    x_max: 1362,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1366
                },
                L: {
                    x_min: 150,
                    x_max: 1066,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 150,
                    advanceWidth: 1139
                },
                M: {
                    x_min: 152,
                    x_max: 1551,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 152,
                    advanceWidth: 1706
                },
                N: {
                    x_min: 156,
                    x_max: 1311,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 156,
                    advanceWidth: 1479
                },
                O: {
                    x_min: 99,
                    x_max: 1501,
                    y_min: -25,
                    y_max: 1492,
                    ha: 1517,
                    leftSideBearing: 99,
                    advanceWidth: 1593
                },
                P: {
                    x_min: 158,
                    x_max: 1277,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 158,
                    advanceWidth: 1366
                },
                Q: {
                    x_min: 88,
                    x_max: 1518,
                    y_min: -114,
                    y_max: 1492,
                    ha: 1606,
                    leftSideBearing: 88,
                    advanceWidth: 1593
                },
                R: {
                    x_min: 161,
                    x_max: 1453,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 161,
                    advanceWidth: 1479
                },
                S: {
                    x_min: 92,
                    x_max: 1259,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 92,
                    advanceWidth: 1366
                },
                T: {
                    x_min: 48,
                    x_max: 1210,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 48,
                    advanceWidth: 1251
                },
                U: {
                    x_min: 161,
                    x_max: 1314,
                    y_min: -25,
                    y_max: 1466,
                    ha: 1491,
                    leftSideBearing: 161,
                    advanceWidth: 1479
                },
                V: {
                    x_min: 9,
                    x_max: 1350,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 9,
                    advanceWidth: 1366
                },
                W: {
                    x_min: 25,
                    x_max: 1910,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 25,
                    advanceWidth: 1933
                },
                X: {
                    x_min: 9,
                    x_max: 1353,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 9,
                    advanceWidth: 1366
                },
                Y: {
                    x_min: 6,
                    x_max: 1350,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 6,
                    advanceWidth: 1366
                },
                Z: {
                    x_min: 41,
                    x_max: 1200,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 41,
                    advanceWidth: 1251
                },
                "[": {
                    x_min: 139,
                    x_max: 536,
                    y_min: -407,
                    y_max: 1466,
                    ha: 1873,
                    leftSideBearing: 139,
                    advanceWidth: 569
                },
                "\\": {
                    x_min: 0,
                    x_max: 569,
                    y_min: -25,
                    y_max: 1491,
                    ha: 1516,
                    leftSideBearing: 0,
                    advanceWidth: 569
                },
                "]": {
                    x_min: 39,
                    x_max: 436,
                    y_min: -407,
                    y_max: 1466,
                    ha: 1873,
                    leftSideBearing: 39,
                    advanceWidth: 569
                },
                "^": {
                    x_min: 54,
                    x_max: 907,
                    y_min: 690,
                    y_max: 1491,
                    ha: 801,
                    leftSideBearing: 54,
                    advanceWidth: 961
                },
                _: {
                    x_min: -31,
                    x_max: 1162,
                    y_min: -407,
                    y_max: -277,
                    ha: 130,
                    leftSideBearing: -31,
                    advanceWidth: 1139
                },
                "`": {
                    x_min: 89,
                    x_max: 465,
                    y_min: 1194,
                    y_max: 1474,
                    ha: 280,
                    leftSideBearing: 89,
                    advanceWidth: 682
                },
                a: {
                    x_min: 74,
                    x_max: 1052,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 74,
                    advanceWidth: 1139
                },
                b: {
                    x_min: 134,
                    x_max: 1055,
                    y_min: -24,
                    y_max: 1466,
                    ha: 1490,
                    leftSideBearing: 134,
                    advanceWidth: 1139
                },
                c: {
                    x_min: 80,
                    x_max: 1005,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 80,
                    advanceWidth: 1024
                },
                d: {
                    x_min: 70,
                    x_max: 991,
                    y_min: -24,
                    y_max: 1466,
                    ha: 1490,
                    leftSideBearing: 70,
                    advanceWidth: 1139
                },
                e: {
                    x_min: 75,
                    x_max: 1054,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 75,
                    advanceWidth: 1139
                },
                f: {
                    x_min: 19,
                    x_max: 640,
                    y_min: 0,
                    y_max: 1491,
                    ha: 1491,
                    leftSideBearing: 19,
                    advanceWidth: 569
                },
                g: {
                    x_min: 66,
                    x_max: 1002,
                    y_min: -431,
                    y_max: 1086,
                    ha: 1517,
                    leftSideBearing: 66,
                    advanceWidth: 1139
                },
                h: {
                    x_min: 135,
                    x_max: 1e3,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 135,
                    advanceWidth: 1139
                },
                i: {
                    x_min: 136,
                    x_max: 316,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 136,
                    advanceWidth: 455
                },
                j: {
                    x_min: -94,
                    x_max: 314,
                    y_min: -431,
                    y_max: 1466,
                    ha: 1897,
                    leftSideBearing: -94,
                    advanceWidth: 455
                },
                k: {
                    x_min: 136,
                    x_max: 1016,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 136,
                    advanceWidth: 1024
                },
                l: {
                    x_min: 131,
                    x_max: 311,
                    y_min: 0,
                    y_max: 1466,
                    ha: 1466,
                    leftSideBearing: 131,
                    advanceWidth: 455
                },
                m: {
                    x_min: 135,
                    x_max: 1574,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 135,
                    advanceWidth: 1706
                },
                n: {
                    x_min: 135,
                    x_max: 998,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 135,
                    advanceWidth: 1139
                },
                o: {
                    x_min: 68,
                    x_max: 1063,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 68,
                    advanceWidth: 1139
                },
                p: {
                    x_min: 135,
                    x_max: 1057,
                    y_min: -407,
                    y_max: 1086,
                    ha: 1493,
                    leftSideBearing: 135,
                    advanceWidth: 1139
                },
                q: {
                    x_min: 72,
                    x_max: 992,
                    y_min: -407,
                    y_max: 1086,
                    ha: 1493,
                    leftSideBearing: 72,
                    advanceWidth: 1139
                },
                r: {
                    x_min: 133,
                    x_max: 710,
                    y_min: 0,
                    y_max: 1086,
                    ha: 1086,
                    leftSideBearing: 133,
                    advanceWidth: 682
                },
                s: {
                    x_min: 63,
                    x_max: 945,
                    y_min: -24,
                    y_max: 1086,
                    ha: 1110,
                    leftSideBearing: 63,
                    advanceWidth: 1024
                },
                t: {
                    x_min: 36,
                    x_max: 554,
                    y_min: -14,
                    y_max: 1433,
                    ha: 1447,
                    leftSideBearing: 36,
                    advanceWidth: 569
                },
                u: {
                    x_min: 131,
                    x_max: 992,
                    y_min: -24,
                    y_max: 1062,
                    ha: 1086,
                    leftSideBearing: 131,
                    advanceWidth: 1139
                },
                v: {
                    x_min: 26,
                    x_max: 1e3,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 26,
                    advanceWidth: 1024
                },
                w: {
                    x_min: 6,
                    x_max: 1463,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 6,
                    advanceWidth: 1479
                },
                x: {
                    x_min: 15,
                    x_max: 1009,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 15,
                    advanceWidth: 1024
                },
                y: {
                    x_min: 33,
                    x_max: 1006,
                    y_min: -431,
                    y_max: 1062,
                    ha: 1493,
                    leftSideBearing: 33,
                    advanceWidth: 1024
                },
                z: {
                    x_min: 40,
                    x_max: 980,
                    y_min: 0,
                    y_max: 1062,
                    ha: 1062,
                    leftSideBearing: 40,
                    advanceWidth: 1024
                },
                "{": {
                    x_min: 57,
                    x_max: 636,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 57,
                    advanceWidth: 684
                },
                "|": {
                    x_min: 188,
                    x_max: 345,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 188,
                    advanceWidth: 532
                },
                "}": {
                    x_min: 47,
                    x_max: 626,
                    y_min: -431,
                    y_max: 1491,
                    ha: 1922,
                    leftSideBearing: 47,
                    advanceWidth: 684
                },
                "~": {
                    x_min: 87,
                    x_max: 1110,
                    y_min: 557,
                    y_max: 885,
                    ha: 328,
                    leftSideBearing: 87,
                    advanceWidth: 1196
                }
            },
            fontFamily: "sans-serif",
            resolution: 2048,
            generatedOn: "2020-10-18T18:48:11.823Z"
        }, Hi = {
            smufl: !1,
            name: "SERIF",
            spacing: 50,
            Description: "Built-in serif font",
            bold: !0,
            italic: !0,
            monospaced: !1,
            serifs: !0,
            glyphs: {
                0: {
                    x_min: 49,
                    x_max: 975,
                    y_min: -27,
                    y_max: 1383,
                    ha: 1410,
                    leftSideBearing: 49,
                    advanceWidth: 1024
                },
                1: {
                    x_min: 227,
                    x_max: 811,
                    y_min: 0,
                    y_max: 1383,
                    ha: 1383,
                    leftSideBearing: 227,
                    advanceWidth: 1024
                },
                2: {
                    x_min: 61,
                    x_max: 965,
                    y_min: 0,
                    y_max: 1383,
                    ha: 1383,
                    leftSideBearing: 61,
                    advanceWidth: 1024
                },
                3: {
                    x_min: 88,
                    x_max: 883,
                    y_min: -27,
                    y_max: 1383,
                    ha: 1410,
                    leftSideBearing: 88,
                    advanceWidth: 1024
                },
                4: {
                    x_min: 25,
                    x_max: 967,
                    y_min: 0,
                    y_max: 1384,
                    ha: 1384,
                    leftSideBearing: 25,
                    advanceWidth: 1024
                },
                5: {
                    x_min: 66,
                    x_max: 898,
                    y_min: -27,
                    y_max: 1409,
                    ha: 1436,
                    leftSideBearing: 66,
                    advanceWidth: 1024
                },
                6: {
                    x_min: 70,
                    x_max: 958,
                    y_min: -27,
                    y_max: 1401,
                    ha: 1428,
                    leftSideBearing: 70,
                    advanceWidth: 1024
                },
                7: {
                    x_min: 41,
                    x_max: 920,
                    y_min: -16,
                    y_max: 1356,
                    ha: 1372,
                    leftSideBearing: 41,
                    advanceWidth: 1024
                },
                8: {
                    x_min: 115,
                    x_max: 911,
                    y_min: -27,
                    y_max: 1383,
                    ha: 1410,
                    leftSideBearing: 115,
                    advanceWidth: 1024
                },
                9: {
                    x_min: 61,
                    x_max: 940,
                    y_min: -41,
                    y_max: 1383,
                    ha: 1424,
                    leftSideBearing: 61,
                    advanceWidth: 1024
                },
                " ": {
                    x_min: 0,
                    x_max: 0,
                    y_min: 0,
                    y_max: 0,
                    ha: 0,
                    leftSideBearing: 0,
                    advanceWidth: 512
                },
                "!": {
                    x_min: 266,
                    x_max: 488,
                    y_min: -22,
                    y_max: 1383,
                    ha: 1405,
                    leftSideBearing: 266,
                    advanceWidth: 682
                },
                '"': {
                    x_min: 157.2000021972655,
                    x_max: 678.2500021457677,
                    y_min: 881,
                    y_max: 1385,
                    ha: 504,
                    leftSideBearing: 157,
                    advanceWidth: 836
                },
                "#": {
                    x_min: 10,
                    x_max: 1016,
                    y_min: -1,
                    y_max: 1356,
                    ha: 1357,
                    leftSideBearing: 10,
                    advanceWidth: 1024
                },
                $: {
                    x_min: 90,
                    x_max: 936,
                    y_min: -180,
                    y_max: 1492,
                    ha: 1672,
                    leftSideBearing: 90,
                    advanceWidth: 1024
                },
                "%": {
                    x_min: 125,
                    x_max: 1581,
                    y_min: -30,
                    y_max: 1388,
                    ha: 1418,
                    leftSideBearing: 125,
                    advanceWidth: 1706
                },
                "&": {
                    x_min: 86,
                    x_max: 1536,
                    y_min: -28,
                    y_max: 1383,
                    ha: 1411,
                    leftSideBearing: 86,
                    advanceWidth: 1593
                },
                "'": {
                    x_min: 97.20000219726548,
                    x_max: 273.2500021457677,
                    y_min: 881,
                    y_max: 1385,
                    ha: 504,
                    leftSideBearing: 97,
                    advanceWidth: 369
                },
                "(": {
                    x_min: 98,
                    x_max: 623,
                    y_min: -363,
                    y_max: 1383,
                    ha: 1746,
                    leftSideBearing: 98,
                    advanceWidth: 682
                },
                ")": {
                    x_min: 59,
                    x_max: 584,
                    y_min: -363,
                    y_max: 1383,
                    ha: 1746,
                    leftSideBearing: 59,
                    advanceWidth: 682
                },
                "*": {
                    x_min: 137.96078522291893,
                    x_max: 886.039214777081,
                    y_min: 543,
                    y_max: 1383,
                    ha: 840,
                    leftSideBearing: 137,
                    advanceWidth: 1024
                },
                "+": {
                    x_min: 61,
                    x_max: 1093,
                    y_min: 2,
                    y_max: 1034,
                    ha: 1032,
                    leftSideBearing: 61,
                    advanceWidth: 1155
                },
                ",": {
                    x_min: 115,
                    x_max: 399,
                    y_min: -291,
                    y_max: 208,
                    ha: 499,
                    leftSideBearing: 115,
                    advanceWidth: 512
                },
                "-": {
                    x_min: 80,
                    x_max: 584,
                    y_min: 396,
                    y_max: 525,
                    ha: 129,
                    leftSideBearing: 80,
                    advanceWidth: 682
                },
                ".": {
                    x_min: 143,
                    x_max: 371,
                    y_min: -22,
                    y_max: 205,
                    ha: 227,
                    leftSideBearing: 143,
                    advanceWidth: 512
                },
                "/": {
                    x_min: -17,
                    x_max: 586,
                    y_min: -27,
                    y_max: 1383,
                    ha: 1410,
                    leftSideBearing: -17,
                    advanceWidth: 569
                },
                ":": {
                    x_min: 166,
                    x_max: 394,
                    y_min: -22,
                    y_max: 943,
                    ha: 965,
                    leftSideBearing: 166,
                    advanceWidth: 569
                },
                ";": {
                    x_min: 164,
                    x_max: 448,
                    y_min: -290,
                    y_max: 943,
                    ha: 1233,
                    leftSideBearing: 164,
                    advanceWidth: 569
                },
                "<": {
                    x_min: 57,
                    x_max: 1098,
                    y_min: -15,
                    y_max: 1051,
                    ha: 1066,
                    leftSideBearing: 57,
                    advanceWidth: 1155
                },
                "=": {
                    x_min: 61,
                    x_max: 1093,
                    y_min: 246,
                    y_max: 791,
                    ha: 545,
                    leftSideBearing: 61,
                    advanceWidth: 1155
                },
                ">": {
                    x_min: 57,
                    x_max: 1098,
                    y_min: -15,
                    y_max: 1051,
                    ha: 1066,
                    leftSideBearing: 57,
                    advanceWidth: 1155
                },
                "?": {
                    x_min: 139,
                    x_max: 848,
                    y_min: -15,
                    y_max: 1383,
                    ha: 1398,
                    leftSideBearing: 139,
                    advanceWidth: 909
                },
                "@": {
                    x_min: 238,
                    x_max: 1657,
                    y_min: -29,
                    y_max: 1386,
                    ha: 1415,
                    leftSideBearing: 238,
                    advanceWidth: 1886
                },
                A: {
                    x_min: 31,
                    x_max: 1445,
                    y_min: 0,
                    y_max: 1380,
                    ha: 1380,
                    leftSideBearing: 31,
                    advanceWidth: 1479
                },
                B: {
                    x_min: 35,
                    x_max: 1214,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 35,
                    advanceWidth: 1366
                },
                C: {
                    x_min: 57,
                    x_max: 1296,
                    y_min: -28,
                    y_max: 1383,
                    ha: 1411,
                    leftSideBearing: 57,
                    advanceWidth: 1366
                },
                D: {
                    x_min: 33,
                    x_max: 1403,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 33,
                    advanceWidth: 1479
                },
                E: {
                    x_min: 25,
                    x_max: 1222,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 25,
                    advanceWidth: 1251
                },
                F: {
                    x_min: 25,
                    x_max: 1119,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 25,
                    advanceWidth: 1139
                },
                G: {
                    x_min: 66,
                    x_max: 1452,
                    y_min: -28,
                    y_max: 1383,
                    ha: 1411,
                    leftSideBearing: 66,
                    advanceWidth: 1479
                },
                H: {
                    x_min: 39,
                    x_max: 1438,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 39,
                    advanceWidth: 1479
                },
                I: {
                    x_min: 37,
                    x_max: 642,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 37,
                    advanceWidth: 682
                },
                J: {
                    x_min: 20,
                    x_max: 758,
                    y_min: -28,
                    y_max: 1356,
                    ha: 1384,
                    leftSideBearing: 20,
                    advanceWidth: 797
                },
                K: {
                    x_min: 70,
                    x_max: 1479,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 70,
                    advanceWidth: 1479
                },
                L: {
                    x_min: 25,
                    x_max: 1224,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 25,
                    advanceWidth: 1251
                },
                M: {
                    x_min: 25,
                    x_max: 1768,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 25,
                    advanceWidth: 1821
                },
                N: {
                    x_min: 25,
                    x_max: 1450,
                    y_min: -22,
                    y_max: 1356,
                    ha: 1378,
                    leftSideBearing: 25,
                    advanceWidth: 1479
                },
                O: {
                    x_min: 70,
                    x_max: 1409,
                    y_min: -28,
                    y_max: 1383,
                    ha: 1411,
                    leftSideBearing: 70,
                    advanceWidth: 1479
                },
                P: {
                    x_min: 33,
                    x_max: 1110,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 33,
                    advanceWidth: 1139
                },
                Q: {
                    x_min: 70,
                    x_max: 1435,
                    y_min: -364.28571588721996,
                    y_max: 1383,
                    ha: 1747.28571588722,
                    leftSideBearing: 70,
                    advanceWidth: 1479
                },
                R: {
                    x_min: 35,
                    x_max: 1347,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 35,
                    advanceWidth: 1366
                },
                S: {
                    x_min: 86,
                    x_max: 1006,
                    y_min: -28,
                    y_max: 1383,
                    ha: 1411,
                    leftSideBearing: 86,
                    advanceWidth: 1139
                },
                T: {
                    x_min: 35,
                    x_max: 1214,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 35,
                    advanceWidth: 1251
                },
                U: {
                    x_min: 29,
                    x_max: 1444,
                    y_min: -28,
                    y_max: 1356,
                    ha: 1384,
                    leftSideBearing: 29,
                    advanceWidth: 1479
                },
                V: {
                    x_min: 33,
                    x_max: 1428,
                    y_min: -22,
                    y_max: 1356,
                    ha: 1378,
                    leftSideBearing: 33,
                    advanceWidth: 1479
                },
                W: {
                    x_min: 10,
                    x_max: 1906,
                    y_min: -22,
                    y_max: 1356,
                    ha: 1378,
                    leftSideBearing: 10,
                    advanceWidth: 1933
                },
                X: {
                    x_min: 20,
                    x_max: 1449,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 20,
                    advanceWidth: 1479
                },
                Y: {
                    x_min: 45,
                    x_max: 1441,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 45,
                    advanceWidth: 1479
                },
                Z: {
                    x_min: 18,
                    x_max: 1222,
                    y_min: 0,
                    y_max: 1356,
                    ha: 1356,
                    leftSideBearing: 18,
                    advanceWidth: 1251
                },
                "[": {
                    x_min: 180,
                    x_max: 612,
                    y_min: -319,
                    y_max: 1355,
                    ha: 1674,
                    leftSideBearing: 180,
                    advanceWidth: 682
                },
                "\\": {
                    x_min: -17,
                    x_max: 586,
                    y_min: -27,
                    y_max: 1383,
                    ha: 1410,
                    leftSideBearing: -17,
                    advanceWidth: 569
                },
                "]": {
                    x_min: 70,
                    x_max: 502,
                    y_min: -319,
                    y_max: 1355,
                    ha: 1674,
                    leftSideBearing: 70,
                    advanceWidth: 682
                },
                "^": {
                    x_min: 49,
                    x_max: 914,
                    y_min: 608,
                    y_max: 1355,
                    ha: 747,
                    leftSideBearing: 49,
                    advanceWidth: 961
                },
                _: {
                    x_min: 0,
                    x_max: 1024,
                    y_min: -255,
                    y_max: -153,
                    ha: 102,
                    leftSideBearing: 0,
                    advanceWidth: 1024
                },
                "`": {
                    x_min: 39,
                    x_max: 499,
                    y_min: 1037,
                    y_max: 1392.509803639748,
                    ha: 355.50980363974804,
                    leftSideBearing: 39,
                    advanceWidth: 682
                },
                a: {
                    x_min: 76,
                    x_max: 905,
                    y_min: -20,
                    y_max: 942,
                    ha: 962,
                    leftSideBearing: 76,
                    advanceWidth: 909
                },
                b: {
                    x_min: 6,
                    x_max: 958,
                    y_min: -20,
                    y_max: 1399,
                    ha: 1419,
                    leftSideBearing: 6,
                    advanceWidth: 1024
                },
                c: {
                    x_min: 51,
                    x_max: 843,
                    y_min: -20,
                    y_max: 942,
                    ha: 962,
                    leftSideBearing: 51,
                    advanceWidth: 909
                },
                d: {
                    x_min: 55,
                    x_max: 1006,
                    y_min: -20,
                    y_max: 1399,
                    ha: 1419,
                    leftSideBearing: 55,
                    advanceWidth: 1024
                },
                e: {
                    x_min: 51,
                    x_max: 868,
                    y_min: -20,
                    y_max: 942,
                    ha: 962,
                    leftSideBearing: 51,
                    advanceWidth: 909
                },
                f: {
                    x_min: 41,
                    x_max: 783,
                    y_min: 0,
                    y_max: 1399,
                    ha: 1399,
                    leftSideBearing: 41,
                    advanceWidth: 682
                },
                g: {
                    x_min: 57,
                    x_max: 963,
                    y_min: -446,
                    y_max: 942,
                    ha: 1388,
                    leftSideBearing: 57,
                    advanceWidth: 1024
                },
                h: {
                    x_min: 18,
                    x_max: 997,
                    y_min: 0,
                    y_max: 1399,
                    ha: 1399,
                    leftSideBearing: 18,
                    advanceWidth: 1024
                },
                i: {
                    x_min: 33,
                    x_max: 516,
                    y_min: 0,
                    y_max: 1399,
                    ha: 1399,
                    leftSideBearing: 33,
                    advanceWidth: 569
                },
                j: {
                    x_min: -142,
                    x_max: 397,
                    y_min: -446,
                    y_max: 1399,
                    ha: 1845,
                    leftSideBearing: -142,
                    advanceWidth: 569
                },
                k: {
                    x_min: 14,
                    x_max: 1029,
                    y_min: 0,
                    y_max: 1399,
                    ha: 1399,
                    leftSideBearing: 14,
                    advanceWidth: 1024
                },
                l: {
                    x_min: 39,
                    x_max: 523,
                    y_min: 0,
                    y_max: 1399,
                    ha: 1399,
                    leftSideBearing: 39,
                    advanceWidth: 569
                },
                m: {
                    x_min: 33,
                    x_max: 1587,
                    y_min: 0,
                    y_max: 944,
                    ha: 944,
                    leftSideBearing: 33,
                    advanceWidth: 1593
                },
                n: {
                    x_min: 33,
                    x_max: 993,
                    y_min: 0,
                    y_max: 944,
                    ha: 944,
                    leftSideBearing: 33,
                    advanceWidth: 1024
                },
                o: {
                    x_min: 59,
                    x_max: 963,
                    y_min: -20,
                    y_max: 942,
                    ha: 962,
                    leftSideBearing: 59,
                    advanceWidth: 1024
                },
                p: {
                    x_min: 10,
                    x_max: 964,
                    y_min: -443,
                    y_max: 944,
                    ha: 1387,
                    leftSideBearing: 10,
                    advanceWidth: 1024
                },
                q: {
                    x_min: 49,
                    x_max: 999,
                    y_min: -443,
                    y_max: 942.0135137169275,
                    ha: 1385.0135137169275,
                    leftSideBearing: 49,
                    advanceWidth: 1024
                },
                r: {
                    x_min: 10,
                    x_max: 685,
                    y_min: 0,
                    y_max: 944,
                    ha: 944,
                    leftSideBearing: 10,
                    advanceWidth: 682
                },
                s: {
                    x_min: 104,
                    x_max: 713,
                    y_min: -20,
                    y_max: 942.0263161804552,
                    ha: 962.0263161804552,
                    leftSideBearing: 104,
                    advanceWidth: 797
                },
                t: {
                    x_min: 27,
                    x_max: 572,
                    y_min: -18,
                    y_max: 1186,
                    ha: 1204,
                    leftSideBearing: 27,
                    advanceWidth: 569
                },
                u: {
                    x_min: 18,
                    x_max: 981,
                    y_min: -21,
                    y_max: 921,
                    ha: 942,
                    leftSideBearing: 18,
                    advanceWidth: 1024
                },
                v: {
                    x_min: 39,
                    x_max: 976,
                    y_min: -28,
                    y_max: 921,
                    ha: 949,
                    leftSideBearing: 39,
                    advanceWidth: 1024
                },
                w: {
                    x_min: 43,
                    x_max: 1423,
                    y_min: -28,
                    y_max: 921,
                    ha: 949,
                    leftSideBearing: 43,
                    advanceWidth: 1479
                },
                x: {
                    x_min: 35,
                    x_max: 989,
                    y_min: 0,
                    y_max: 921,
                    ha: 921,
                    leftSideBearing: 35,
                    advanceWidth: 1024
                },
                y: {
                    x_min: 29,
                    x_max: 976,
                    y_min: -445,
                    y_max: 921,
                    ha: 1366,
                    leftSideBearing: 29,
                    advanceWidth: 1024
                },
                z: {
                    x_min: 55,
                    x_max: 855,
                    y_min: 0,
                    y_max: 921,
                    ha: 921,
                    leftSideBearing: 55,
                    advanceWidth: 909
                },
                "{": {
                    x_min: 205,
                    x_max: 717,
                    y_min: -377,
                    y_max: 1397,
                    ha: 1774,
                    leftSideBearing: 205,
                    advanceWidth: 983
                },
                "|": {
                    x_min: 137,
                    x_max: 273,
                    y_min: -512,
                    y_max: 1535,
                    ha: 2047,
                    leftSideBearing: 137,
                    advanceWidth: 410
                },
                "}": {
                    x_min: 266,
                    x_max: 778,
                    y_min: -377,
                    y_max: 1397,
                    ha: 1774,
                    leftSideBearing: 266,
                    advanceWidth: 983
                },
                "~": {
                    x_min: 82,
                    x_max: 1028,
                    y_min: 380,
                    y_max: 666,
                    ha: 286,
                    leftSideBearing: 82,
                    advanceWidth: 1108
                }
            },
            fontFamily: "serif",
            resolution: 2048,
            generatedOn: "2020-10-18T19:03:12.514Z"
        };
        class Yi {
            static sortAndUnique(t, e, i) {
                if (t.length > 1) {
                    const b = [];
                    let a;
                    t.sort(e);
                    for(let e = 0; e < t.length; ++e)0 !== e && i(t[e], a) || b.push(t[e]), a = t[e];
                    return b;
                }
                return t;
            }
            static contains(t, e) {
                let i = t.length;
                for(; i--;)if (t[i] === e) return !0;
                return !1;
            }
            static getCanvasContext(t) {
                if (!t) throw new g("BadArgument", "Invalid canvas selector: " + t);
                const e = document.getElementById(t);
                if (!e || !e.getContext) throw new g("UnsupportedBrowserError", "This browser does not support HTML5 Canvas");
                return e.getContext("2d");
            }
            static benchmark(t, e) {
                const i = (new Date).getTime();
                e();
                u(t, (new Date).getTime() - i + "ms");
            }
            static stackTrace() {
                return (new Error).stack;
            }
        }
        return Yi.Flow = ki, F.load("Bravura", Ai, Ni), F.load("Gonville", Mi, Ni), function() {
            const t = JSON.parse(JSON.stringify(Ni)), e = t.chordSymbol;
            e && (e.glyphs = Li), F.load("Petaluma", Ri, t);
        }(), F.load("Custom", Fi, Ni), F.load("Leland", Oi, Ni), ki.setMusicFont("Bravura", "Gonville", "Custom"), function() {
            {
                const t = Ii, { fontFamily: e, resolution: i, glyphs: b } = t;
                F.load(e, t);
                const a = "@";
                rt.registerInfo({
                    family: e,
                    resolution: i,
                    glyphs: b,
                    maxSizeGlyph: a,
                    monospaced: !1,
                    bold: !0,
                    italic: !1,
                    superscriptOffset: .66,
                    subscriptOffset: .66,
                    serifs: !1,
                    description: "Generic SANS font"
                });
            }
            {
                const t = Gi, { fontFamily: e, resolution: i, glyphs: b } = t;
                F.load(e, t);
                const a = "@";
                rt.registerInfo({
                    family: e,
                    resolution: i,
                    glyphs: b,
                    maxSizeGlyph: a,
                    monospaced: !1,
                    bold: !1,
                    italic: !1,
                    superscriptOffset: .66,
                    subscriptOffset: .66,
                    serifs: !1,
                    description: "Generic SANS font"
                });
            }
            {
                const t = Hi, { fontFamily: e, resolution: i, glyphs: b } = t;
                F.load(e, t);
                const a = "@";
                rt.registerInfo({
                    family: e,
                    resolution: i,
                    glyphs: b,
                    maxSizeGlyph: a,
                    monospaced: !1,
                    bold: !1,
                    italic: !1,
                    superscriptOffset: .66,
                    subscriptOffset: .66,
                    serifs: !0,
                    description: "Generic SERIF font"
                });
            }
            {
                const t = Ui, { fontFamily: e, resolution: i, glyphs: b } = t;
                F.load(e, t);
                const a = "b";
                rt.registerInfo({
                    family: e,
                    resolution: i,
                    glyphs: b,
                    maxSizeGlyph: a,
                    monospaced: !1,
                    bold: !1,
                    italic: !1,
                    superscriptOffset: .66,
                    subscriptOffset: .66,
                    serifs: !0,
                    description: "Text font to pair with the Bravura / Gonville music fonts."
                });
            }
            {
                const t = Wi, { fontFamily: e, resolution: i, glyphs: b } = t;
                F.load(e, t);
                const a = "b";
                rt.registerInfo({
                    family: e,
                    resolution: i,
                    glyphs: b,
                    maxSizeGlyph: a,
                    monospaced: !1,
                    bold: !1,
                    italic: !1,
                    superscriptOffset: .66,
                    subscriptOffset: .66,
                    serifs: !1,
                    description: "Text font to pair with the Petaluma music font."
                });
            }
        }(), e = e.default;
    })());

},{}],"9v1kQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tonal = require("tonal");
// Better enharmonic equivalent that prioritizes alphabetical sequences
const getOptimalEnharmonics = (noteNames)=>{
    const result = [
        ...noteNames
    ];
    // Process each note and try to create the best alphabetical sequence
    for(let i = 0; i < result.length; i++){
        const note = (0, _tonal.Note).get(result[i]);
        if (!note.alt) continue; // Skip natural notes
        const enharmonic = (0, _tonal.Note).enharmonic(result[i]);
        if (!enharmonic) continue;
        const currentLetter = note.letter;
        const enhLetter = (0, _tonal.Note).get(enharmonic).letter;
        // Get all letters used so far in the optimized sequence
        const usedLetters = result.slice(0, i).map((n)=>(0, _tonal.Note).get(n).letter);
        // Rule 1: Avoid duplicate letter names if possible
        const currentLetterUsed = usedLetters.includes(currentLetter);
        const enhLetterUsed = usedLetters.includes(enhLetter);
        if (currentLetterUsed && !enhLetterUsed) {
            result[i] = enharmonic;
            continue;
        }
        if (!currentLetterUsed && enhLetterUsed) continue; // Keep current
        // Rule 2: Try to maintain alphabetical progression
        if (i > 0) {
            const prevLetter = (0, _tonal.Note).get(result[i - 1]).letter;
            const prevLetterCode = prevLetter.charCodeAt(0);
            const currentLetterCode = currentLetter.charCodeAt(0);
            const enhLetterCode = enhLetter.charCodeAt(0);
            // Calculate distance in alphabetical sequence (with wrap-around)
            const getDistance = (from, to)=>{
                let dist = to - from;
                if (dist < 0) dist += 7; // Wrap around (A=0, B=1, ..., G=6)
                return dist;
            };
            const currentDistance = getDistance(prevLetterCode, currentLetterCode);
            const enhDistance = getDistance(prevLetterCode, enhLetterCode);
            // Prefer the option that creates a smaller alphabetical jump
            // (but avoid going backwards unless necessary)
            if (enhDistance > 0 && enhDistance < currentDistance) result[i] = enharmonic;
        }
    }
    return result;
};
exports.default = getOptimalEnharmonics;

},{"tonal":"b7q1y","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"3LfGz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * PlayButton Component - Handles audio playback controls
 * 
 * @param {boolean} isPlaying - Whether audio is currently playing
 * @param {Function} onPlay - Callback to start/stop playback
 */ const PlayButton = ({ isPlaying, onPlay })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        className: `play-button-corner ${isPlaying ? 'playing' : ''}`,
        onClick: onPlay,
        title: isPlaying ? 'Stop playback' : 'Play scale',
        children: isPlaying ? "\u23F8" : "\u25B6"
    });
};
exports.default = PlayButton;

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"6CrJb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * TechnicalId Component - Displays the technical scale identifier (s{x}m{x})
 * 
 * @param {number} superscaleIndex - The superscale index
 * @param {number} mode - The mode number
 */ const TechnicalId = ({ superscaleIndex, mode })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "scale-technical-id",
        children: [
            "s",
            superscaleIndex,
            "m",
            mode
        ]
    });
};
exports.default = TechnicalId;

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"HAXPh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * NecklaceVisualization Component - Shows scale as circular necklace representation
 * Visualizes Lyndon word structure and rotational modes
 * 
 * @param {Array} scale - Array of scale intervals
 * @param {number} mode - Current mode (rotation) of the scale
 * @param {number} superscaleIndex - Superscale index for Lyndon word labeling
 */ const NecklaceVisualization = ({ scale, mode = 1, superscaleIndex })=>{
    // Calculate total scale length for proper positioning
    const totalSemitones = scale.reduce((sum, interval)=>sum + interval, 0);
    const beadCount = scale.length + 1; // Include root note
    // SVG dimensions
    const size = 200;
    const center = size / 2;
    const radius = 70;
    const beadRadius = 8;
    // Build positions using chromatic clock positions (0-11 semitones)
    const positions = [];
    let cumulative = 0;
    // First position is the mode root at 0 semitones (12 o'clock)
    positions.push({
        semitones: 0,
        isModeRoot: true,
        isOriginalRoot: mode === 1,
        interval: null,
        clockPosition: 0
    });
    // Calculate where the original root appears in this mode
    // If mode = 10, original root is at position (12 - 10) = 2
    const totalPositions = scale.length + 1; // Include the octave
    const originalRootPosition = mode === 1 ? 0 : (totalPositions - mode) % totalPositions;
    // Add each subsequent scale degree at proper chromatic positions
    scale.forEach((interval, index)=>{
        cumulative += interval;
        const positionIndex = index + 1;
        positions.push({
            semitones: cumulative,
            isModeRoot: false,
            isOriginalRoot: positionIndex === originalRootPosition,
            interval: interval,
            intervalSize: interval,
            clockPosition: cumulative % 12
        });
    });
    // Convert clock positions to angles (12-tone chromatic circle)
    const angleStep = 2 * Math.PI / 12;
    // All notes are uniform circles, intervals shown in connection weight
    const noteRadius = 8;
    const noteStrokeWidth = 2;
    // Get connection stroke width based on interval size
    const getConnectionStyle = (intervalSize)=>{
        if (intervalSize === 1) return {
            strokeWidth: 2,
            opacity: 0.5,
            color: 'rgba(165, 153, 140, 0.6)'
        };
        if (intervalSize === 2) return {
            strokeWidth: 5,
            opacity: 0.85,
            color: 'rgba(74, 69, 62, 0.8)'
        };
        return {
            strokeWidth: 7,
            opacity: 1.0,
            color: 'rgba(74, 69, 62, 1.0)'
        }; // 3+ semitones
    };
    const renderNote = (position, index)=>{
        // Place notes at chromatic clock positions (0-11 semitones)
        const angle = position.clockPosition * angleStep - Math.PI / 2; // Start at 12 o'clock
        const x = center + radius * Math.cos(angle);
        const y = center + radius * Math.sin(angle);
        // Determine note class based on what type of root it is
        // When mode === 1, both isModeRoot and isOriginalRoot are true for the first note
        // In that case, only show the original root (orange), not the mode root (green)
        const noteClass = position.isOriginalRoot && position.isModeRoot ? 'necklace-root' : position.isModeRoot ? 'necklace-mode-root' : position.isOriginalRoot ? 'necklace-root' : 'necklace-note';
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
            cx: x,
            cy: y,
            r: noteRadius,
            className: noteClass
        }, `note-${index}`);
    };
    const renderConnections = ()=>{
        return positions.map((position, index)=>{
            const nextIndex = (index + 1) % positions.length;
            const nextPosition = positions[nextIndex];
            // Get interval size - this is the interval FROM this position TO the next
            const intervalSize = index < scale.length ? scale[index] : scale[scale.length - 1];
            // Calculate positions using chromatic clock positions
            const angle1 = position.clockPosition * angleStep - Math.PI / 2;
            const angle2 = nextPosition.clockPosition * angleStep - Math.PI / 2;
            const x1 = center + radius * Math.cos(angle1);
            const y1 = center + radius * Math.sin(angle1);
            const x2 = center + radius * Math.cos(angle2);
            const y2 = center + radius * Math.sin(angle2);
            // Calculate arc direction - always go clockwise around the circle
            const deltaAngle = (nextPosition.clockPosition - position.clockPosition + 12) % 12;
            const largeArc = deltaAngle > 6 ? 1 : 0;
            const sweep = 1; // Always clockwise
            // Style based on interval size
            const connectionStyle = getConnectionStyle(intervalSize);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: `M ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} ${sweep} ${x2} ${y2}`,
                className: "necklace-connection",
                fill: "none",
                stroke: connectionStyle.color,
                strokeWidth: connectionStyle.strokeWidth,
                opacity: connectionStyle.opacity
            }, `connection-${index}`);
        });
    };
    // Get ordinal suffix for mode number
    const getOrdinal = (n)=>{
        const s = [
            'th',
            'st',
            'nd',
            'rd'
        ];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "necklace-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "necklace-label",
                children: "Necklace Visualization"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "necklace-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "necklace-info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "necklace-legend",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "legend-symbol necklace-mode-symbol"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Mode Root"
                                                })
                                            ]
                                        }),
                                        mode > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "legend-symbol necklace-root-symbol"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Tonic"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "legend-symbol interval-stroke-1"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "1 step"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "legend-symbol interval-stroke-2"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "2 steps"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "legend-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "legend-symbol interval-stroke-3"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "3 steps"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "necklace-visualization",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: size,
                            height: size,
                            viewBox: `0 0 ${size} ${size}`,
                            className: "necklace-svg",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: center,
                                    cy: center,
                                    r: radius + 15,
                                    fill: "none",
                                    stroke: "rgba(0,0,0,0.1)",
                                    strokeWidth: "1",
                                    strokeDasharray: "2,2"
                                }),
                                Array.from({
                                    length: 12
                                }, (_, i)=>{
                                    const angle = i * angleStep - Math.PI / 2;
                                    const innerRadius = radius - 8;
                                    const outerRadius = radius - 2;
                                    const x1 = center + innerRadius * Math.cos(angle);
                                    const y1 = center + innerRadius * Math.sin(angle);
                                    const x2 = center + outerRadius * Math.cos(angle);
                                    const y2 = center + outerRadius * Math.sin(angle);
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: x1,
                                        y1: y1,
                                        x2: x2,
                                        y2: y2,
                                        stroke: "rgba(0,0,0,0.25)",
                                        strokeWidth: "1.5",
                                        className: "clock-tick"
                                    }, `tick-${i}`);
                                }),
                                renderConnections(),
                                positions.slice(0, -1).map(renderNote),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: center,
                                    cy: center,
                                    r: "3",
                                    fill: "rgba(0,0,0,0.3)"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = NecklaceVisualization;

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"d7WpC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * NecklaceButton Component - Toggle button for necklace visualization
 * 
 * @param {boolean} isVisible - Whether necklace is currently visible
 * @param {Function} onToggle - Callback to toggle necklace visibility
 */ const NecklaceButton = ({ isVisible, onToggle })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        className: `necklace-button ${isVisible ? 'active' : ''}`,
        onClick: onToggle,
        title: isVisible ? 'Hide necklace visualization' : 'Show necklace (Lyndon word)',
        children: "\u2B55"
    });
};
exports.default = NecklaceButton;

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"hykr3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * PurchaseModal Component - Handles scale NFT purchases
 * Shows different UI based on ownership status
 */ const PurchaseModal = ({ scaleNumber, scale, superscaleIndex, mode, onClose })=>{
    const [status, setStatus] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [proposedName, setProposedName] = (0, _react.useState)("");
    (0, _react.useEffect)(()=>{
        // Check ownership status directly from Zora's public API
        const checkStatus = async ()=>{
            try {
                // Query Zora's GraphQL API for ownership
                const response = await fetch('https://api.zora.co/graphql', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        query: `
              query TokenOwnership($contractAddress: String!, $tokenId: String!) {
                token(
                  token: {
                    address: $contractAddress
                    tokenId: $tokenId
                  }
                ) {
                  tokenId
                  owner
                  metadata {
                    name
                    description
                  }
                }
              }
            `,
                        variables: {
                            contractAddress: "YOUR_ZORA_CONTRACT_ADDRESS",
                            tokenId: scaleNumber.toString()
                        }
                    })
                });
                const { data } = await response.json();
                if (data?.token?.owner) // Token is owned
                setStatus({
                    available: false,
                    owner: data.token.owner,
                    ownerDisplay: data.token.owner.slice(0, 6) + '...' + data.token.owner.slice(-4),
                    approvedName: data.token.metadata?.name,
                    namedBy: data.token.metadata?.description // Parse from description if stored there
                });
                else // Token not yet minted
                setStatus({
                    available: true,
                    price: "$10"
                });
            } catch (error) {
                console.error("Error checking scale status:", error);
                setStatus({
                    available: true,
                    price: "$10"
                });
            } finally{
                setLoading(false);
            }
        };
        checkStatus();
    }, [
        scaleNumber
    ]);
    const handlePurchase = (method)=>{
        if (method === 'card') {
            // Crossmint handles everything - just redirect to their hosted checkout
            // After purchase, Crossmint will automatically mint the NFT to the buyer
            const crossmintCheckoutUrl = `https://www.crossmint.com/checkout?` + `clientId=YOUR_CROSSMINT_CLIENT_ID&` + `mintConfig.type=erc-721&` + `mintConfig.contractAddress=YOUR_ZORA_CONTRACT_ADDRESS&` + `mintConfig.tokenId=${scaleNumber}&` + `successCallbackURL=${encodeURIComponent(window.location.href)}`;
            window.location.href = crossmintCheckoutUrl;
        } else if (method === 'wallet') // Direct link to Zora's mint page
        // Zora handles the wallet connection and transaction
        window.open(`https://zora.co/collect/base:YOUR_ZORA_CONTRACT_ADDRESS/${scaleNumber}`, '_blank');
    };
    const handleMakeOffer = ()=>{
        // Redirect to Zora marketplace - users can make offers there
        window.open(`https://zora.co/collect/base:YOUR_ZORA_CONTRACT_ADDRESS/${scaleNumber}`, '_blank');
    };
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "purchase-modal",
            onClick: (e)=>e.stopPropagation(),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Loading..."
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "modal-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "purchase-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "modal-close",
                    onClick: onClose,
                    children: "\xd7"
                }),
                status?.available ? // Available for purchase
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                            className: "modal-title",
                            children: [
                                "Purchase Scale #",
                                scaleNumber
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-scale-info",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "modal-description",
                                    children: [
                                        "Superscale ",
                                        superscaleIndex,
                                        ", ",
                                        mode > 1 ? `${mode}th Mode` : 'Original'
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "modal-intervals",
                                    children: scale.join('-')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-price",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "price-label",
                                    children: "Price:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "price-amount",
                                    children: [
                                        status.price || '$10',
                                        " USD"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "purchase-options",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "purchase-button purchase-button--card",
                                    onClick: ()=>handlePurchase('card'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "\uD83D\uDCB3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "button-title",
                                                    children: "Buy with Credit Card"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "button-subtitle",
                                                    children: "No crypto knowledge needed"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "purchase-button purchase-button--wallet",
                                    onClick: ()=>handlePurchase('wallet'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "\uD83E\uDD8A"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "button-title",
                                                    children: "Buy with Wallet"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "button-subtitle",
                                                    children: "Connect MetaMask or WalletConnect"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modal-naming",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "naming-info",
                                children: "After purchase, you'll be able to propose a name for this scale."
                            })
                        })
                    ]
                }) : // Already owned - show marketplace options
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "modal-title",
                            children: status.approvedName || `Scale #${scaleNumber}`
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-scale-info",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "modal-description",
                                    children: [
                                        "Superscale ",
                                        superscaleIndex,
                                        ", ",
                                        mode > 1 ? `${mode}th Mode` : 'Original'
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "modal-intervals",
                                    children: scale.join('-')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "ownership-info",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "ownership-label",
                                    children: "Current Owner:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "ownership-address",
                                    children: status.ownerDisplay || status.owner
                                }),
                                status.approvedName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "ownership-named-by",
                                    children: [
                                        "Named by: ",
                                        status.namedBy
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "marketplace-options",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "marketplace-info",
                                    children: "This scale has been claimed. You can make an offer to the current owner on Zora."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "marketplace-button",
                                    onClick: handleMakeOffer,
                                    children: "View on Zora Marketplace"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = PurchaseModal;

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"1SLqT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NecklaceModal", ()=>NecklaceModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _necklaceVisualization = require("./NecklaceVisualization");
var _necklaceVisualizationDefault = parcelHelpers.interopDefault(_necklaceVisualization);
var _scaleNotation = require("./ScaleNotation");
var _scaleNotationDefault = parcelHelpers.interopDefault(_scaleNotation);
const NecklaceModal = ({ scale, mode, superscaleIndex, scaleNumber, onClose, onPlayScale, onPurchase })=>{
    // Close on ESC key and handle URL cleanup
    (0, _react.useEffect)(()=>{
        const handleEscape = (e)=>{
            if (e.key === 'Escape') handleClose();
        };
        document.addEventListener('keydown', handleEscape);
        // Prevent body scroll when modal is open
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
        };
    }, [
        onClose
    ]);
    const handleClose = ()=>{
        // Clear the hash from URL
        if (window.location.hash) window.history.pushState('', document.title, window.location.pathname + window.location.search);
        onClose();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "necklace-modal-overlay",
        onClick: handleClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "necklace-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "necklace-modal__close",
                    onClick: handleClose,
                    "aria-label": "Close",
                    children: "\xd7"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "necklace-modal__header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                            children: [
                                "Scale #",
                                scaleNumber
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "necklace-modal__subtitle",
                            children: [
                                "Superscale ",
                                superscaleIndex,
                                " \u2022 Mode ",
                                mode
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "necklace-modal__scale-notation",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scaleNotationDefault.default), {
                        scale: scale,
                        onNoteClick: ()=>{}
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "necklace-modal__content",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _necklaceVisualizationDefault.default), {
                        scale: scale,
                        mode: mode,
                        superscaleIndex: superscaleIndex
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "necklace-modal__actions",
                    "data-screenshot-hide": true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "necklace-action-btn necklace-action-btn--play",
                            onClick: onPlayScale,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "\u25B6"
                                }),
                                " Play Scale"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "necklace-action-btn necklace-action-btn--purchase",
                            onClick: onPurchase,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "$"
                                }),
                                " Purchase NFT"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","./NecklaceVisualization":"HAXPh","./ScaleNotation":"7CjhN","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"LHMUK":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"1_1_1_1_1_1_1_1_1_1_1_1":{"name":"Chromatic","source":"https://en.wikipedia.org/wiki/Chromatic_scale"},"2_2_1_2_2_2_1":{"name":"Major (Ionian)","source":"https://en.wikipedia.org/wiki/Major_scale"},"2_1_2_2_1_2_2":{"name":"Natural Minor (Aeolian)","source":"https://en.wikipedia.org/wiki/Minor_scale"},"2_1_2_2_2_1_2":{"name":"Harmonic Minor","source":"https://en.wikipedia.org/wiki/Minor_scale#Harmonic_minor_scale"},"2_1_2_2_2_2_1":{"name":"Melodic Minor (Ascending)","source":"https://en.wikipedia.org/wiki/Minor_scale#Melodic_minor_scale"},"1_2_2_1_2_2_2":{"name":"Dorian","source":"https://en.wikipedia.org/wiki/Dorian_mode"},"1_2_2_2_2_2_1":{"name":"Phrygian","source":"https://en.wikipedia.org/wiki/Phrygian_mode"},"2_2_2_1_2_2_1":{"name":"Lydian","source":"https://en.wikipedia.org/wiki/Lydian_mode"},"2_2_1_2_2_1_2":{"name":"Mixolydian","source":"https://en.wikipedia.org/wiki/Mixolydian_mode"},"1_2_1_2_1_2_2":{"name":"Locrian","source":"https://en.wikipedia.org/wiki/Locrian_mode"},"2_2_3_2_3":{"name":"Pentatonic Major","source":"https://en.wikipedia.org/wiki/Pentatonic_scale#Major_pentatonic_scale"},"3_2_2_3_2":{"name":"Pentatonic Minor","source":"https://en.wikipedia.org/wiki/Pentatonic_scale#Minor_pentatonic_scale"},"3_2_1_1_3_2":{"name":"Blues Scale","source":"https://en.wikipedia.org/wiki/Blues_scale"},"2_1_3_1_1_3_1":{"name":"Hungarian Minor","source":"https://en.wikipedia.org/wiki/Hungarian_minor_scale"},"1_3_1_2_1_3_1":{"name":"Hungarian Major","source":"https://en.wikipedia.org/wiki/Hungarian_major_scale"},"1_4_2_1_4":{"name":"Hirajoshi","source":"https://en.wikipedia.org/wiki/Hiraj\u014Dshi_scale"},"2_3_2_2_3":{"name":"Yo Scale","source":"https://en.wikipedia.org/wiki/Yo_scale"},"4_2_1_4_1":{"name":"In Scale","source":"https://en.wikipedia.org/wiki/In_scale"},"1_4_1_4_2":{"name":"Insen Scale","source":"https://en.wikipedia.org/wiki/Insen_scale"},"2_1_4_1_4":{"name":"Iwato Scale","source":"https://en.wikipedia.org/wiki/Iwato_scale"},"3_1_3_1_3_1":{"name":"Whole-Tone","source":"https://en.wikipedia.org/wiki/Whole_tone_scale"},"2_1_1_1_2_1_1_1_2":{"name":"Bebop Dominant","source":"https://en.wikipedia.org/wiki/Bebop_scale#Bebop_dominant_scale"},"2_2_1_2_1_1_2_1":{"name":"Bebop Major","source":"https://en.wikipedia.org/wiki/Bebop_scale#Bebop_major_scale"},"2_1_2_2_1_1_2_1":{"name":"Bebop Minor","source":"https://en.wikipedia.org/wiki/Bebop_scale#Bebop_dorian_scale"},"1_2_1_2_1_2_1_2":{"name":"Diminished (Half-Whole)","source":"https://en.wikipedia.org/wiki/Octatonic_scale"},"2_1_2_1_2_1_2_1":{"name":"Diminished (Whole-Half)","source":"https://en.wikipedia.org/wiki/Octatonic_scale"},"3_1_1_1_3_1_1_1":{"name":"Spanish 8-Tone","source":"https://en.wikipedia.org/wiki/Spanish_Phrygian_scale"},"2_2_2_2_2_2":{"name":"Whole Tone","source":"https://en.wikipedia.org/wiki/Whole_tone_scale"},"1_3_1_1_3_1_2":{"name":"Phrygian Dominant","source":"https://en.wikipedia.org/wiki/Phrygian_dominant_scale"},"1_3_1_2_1_2_2":{"name":"Double Harmonic Major","source":"https://en.wikipedia.org/wiki/Double_harmonic_scale"},"2_1_3_1_1_2_2":{"name":"Neapolitan Minor","source":"https://en.wikipedia.org/wiki/Neapolitan_scale#Neapolitan_minor_scale"},"1_2_2_2_1_2_2":{"name":"Neapolitan Major","source":"https://en.wikipedia.org/wiki/Neapolitan_scale#Neapolitan_major_scale"},"3_1_2_1_3_2":{"name":"Persian Scale","source":"https://en.wikipedia.org/wiki/Persian_scale"},"1_2_3_1_2_3":{"name":"Prometheus Scale","source":"https://en.wikipedia.org/wiki/Prometheus_scale"},"2_2_2_1_1_2_2":{"name":"Lydian Dominant","source":"https://en.wikipedia.org/wiki/Lydian_dominant_scale"},"1_2_2_2_2_1_2":{"name":"Phrygian Natural 6th","source":"https://en.wikipedia.org/wiki/Dorian_\u266D2_scale"},"2_1_2_1_3_1_2":{"name":"Algerian Scale","source":"https://en.wikipedia.org/wiki/Algerian_scale"},"1_1_3_2_1_1_3":{"name":"Arabian Scale","source":"https://en.wikipedia.org/wiki/Hicaz_scale"},"2_2_1_1_2_2_2":{"name":"Balinese Scale","source":"https://en.wikipedia.org/wiki/Pelog#Balinese_pelog"},"1_2_1_3_1_2_2":{"name":"Byzantine Scale","source":"https://en.wikipedia.org/wiki/Double_harmonic_scale#Byzantine_scale"},"2_1_1_2_2_2_2":{"name":"Enigmatic Scale","source":"https://en.wikipedia.org/wiki/Enigmatic_scale"},"1_1_2_2_2_2_2":{"name":"Flamenco Mode","source":"https://en.wikipedia.org/wiki/Phrygian_dominant_scale#Flamenco_mode"},"3_1_1_2_3_2":{"name":"Gypsy Scale","source":"https://en.wikipedia.org/wiki/Hungarian_minor_scale#Gypsy_scale"},"2_2_2_2_1_1_2":{"name":"Leading Whole Tone","source":"https://en.wikipedia.org/wiki/Leading_whole_tone_scale"},"1_1_1_2_1_1_1_4":{"name":"Mohammedan Scale","source":"https://en.wikipedia.org/wiki/Hicaz_scale#Related_scales"},"2_1_1_3_1_2_2":{"name":"Oriental Scale","source":"https://en.wikipedia.org/wiki/Double_harmonic_scale#Oriental_scale"}}');

},{}],"5zcVT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const FilterControls = ({ onFilterChange, totalScales, filteredCount })=>{
    const [patternSearch, setPatternSearch] = (0, _react.useState)("");
    const [showExamples, setShowExamples] = (0, _react.useState)(false);
    const debounceTimer = (0, _react.useRef)(null);
    const handlePatternChange = (e)=>{
        const value = e.target.value.toLowerCase();
        setPatternSearch(value);
        // Clear existing timer
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
        // Set new timer - 300ms is good for typing speed
        debounceTimer.current = setTimeout(()=>{
            onFilterChange({
                pattern: value
            });
        }, 300);
    };
    const clearFilters = ()=>{
        setPatternSearch("");
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
        onFilterChange({
            pattern: ""
        });
    };
    // Cleanup timer on unmount
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (debounceTimer.current) clearTimeout(debounceTimer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "filter-controls",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "filter-controls-inline",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "pattern-search-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                id: "pattern-search",
                                type: "text",
                                value: patternSearch,
                                onChange: handlePatternChange,
                                placeholder: "Filter: 123, min5, s3m2, ^21...",
                                className: "pattern-input"
                            }),
                            patternSearch && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: clearFilters,
                                className: "clear-pattern",
                                title: "Clear filters",
                                children: "\xd7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "toggle-examples",
                        onClick: ()=>setShowExamples(!showExamples),
                        title: "Show filter examples",
                        children: "?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "filter-count",
                children: filteredCount !== totalScales ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "filtered-count",
                            children: filteredCount
                        }),
                        " of ",
                        totalScales,
                        " scales"
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        totalScales,
                        " scales"
                    ]
                })
            }),
            showExamples && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pattern-examples",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "example-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "123"
                            }),
                            " contains 1-2-3"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "example-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "^21"
                            }),
                            " starts with 2-1"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "example-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "min5"
                            }),
                            " 5+ notes"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "example-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "max8"
                            }),
                            " \u22648 notes"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "example-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "s5"
                            }),
                            " superscale #5"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "example-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "m3"
                            }),
                            " mode 3"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "example-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "n42"
                            }),
                            " scale #42"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "example-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "12,21"
                            }),
                            " 1-2 OR 2-1"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "example-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "12&^3"
                            }),
                            " 1-2 AND starts with 3"
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = FilterControls;

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"aTcna":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ScrollProgressBar = ({ filteredCount })=>{
    const [scrollProgress, setScrollProgress] = (0, _react.useState)(0);
    const [isDragging, setIsDragging] = (0, _react.useState)(false);
    const progressBarRef = (0, _react.useRef)(null);
    // Update scroll progress when content changes
    (0, _react.useEffect)(()=>{
        const handleScroll = ()=>{
            if (isDragging) return; // Don't update while dragging
            const scrollContainer = document.querySelector('.app-content');
            if (!scrollContainer) return;
            const scrollTop = scrollContainer.scrollTop;
            const scrollHeight = scrollContainer.scrollHeight - scrollContainer.clientHeight;
            // Prevent division by zero when content fits in viewport
            if (scrollHeight <= 0) {
                setScrollProgress(0);
                return;
            }
            const progress = scrollTop / scrollHeight * 100;
            setScrollProgress(Math.min(100, Math.max(0, progress)));
        };
        const scrollContainer = document.querySelector('.app-content');
        if (scrollContainer) {
            scrollContainer.addEventListener('scroll', handleScroll);
            // Initial calculation to show cursor from the start
            handleScroll();
        } else {
            // If container not ready, try again shortly
            const timer = setTimeout(()=>{
                const container = document.querySelector('.app-content');
                if (container) {
                    container.addEventListener('scroll', handleScroll);
                    handleScroll();
                }
            }, 100);
            return ()=>clearTimeout(timer);
        }
        return ()=>{
            if (scrollContainer) scrollContainer.removeEventListener('scroll', handleScroll);
        };
    }, [
        isDragging,
        filteredCount
    ]); // Recalculate when filters change
    const scrollToProgress = (progressPercent)=>{
        const scrollContainer = document.querySelector('.app-content');
        if (!scrollContainer) return;
        const scrollHeight = scrollContainer.scrollHeight - scrollContainer.clientHeight;
        const targetScroll = progressPercent / 100 * scrollHeight;
        scrollContainer.scrollTo({
            top: targetScroll,
            behavior: 'smooth'
        });
    };
    const handleBarClick = (e)=>{
        if (e.target.classList.contains('scroll-progress-bar__cursor')) return;
        if (!progressBarRef.current) return;
        const rect = progressBarRef.current.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const progressPercent = clickX / rect.width * 100;
        setScrollProgress(progressPercent);
        scrollToProgress(progressPercent);
    };
    const handleDragStart = (e)=>{
        e.preventDefault();
        setIsDragging(true);
        handleDrag(e);
    };
    const handleDrag = (e)=>{
        if (!progressBarRef.current) return;
        const rect = progressBarRef.current.getBoundingClientRect();
        const dragX = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
        const progressPercent = dragX / rect.width * 100;
        setScrollProgress(progressPercent);
    };
    const handleDragEnd = (e)=>{
        if (isDragging) {
            handleDrag(e);
            scrollToProgress(scrollProgress);
            setIsDragging(false);
        }
    };
    (0, _react.useEffect)(()=>{
        if (isDragging) {
            const handleMouseMove = (e)=>handleDrag(e);
            const handleMouseUp = (e)=>handleDragEnd(e);
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            return ()=>{
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [
        isDragging,
        scrollProgress
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: progressBarRef,
        className: "scroll-progress-bar",
        onClick: handleBarClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "scroll-progress-bar__track"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "scroll-progress-bar__fill",
                style: {
                    width: `${scrollProgress}%`
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "scroll-progress-bar__cursor",
                style: {
                    left: `${scrollProgress}%`
                },
                onMouseDown: handleDragStart
            })
        ]
    });
};
exports.default = ScrollProgressBar;

},{"react/jsx-runtime":"cOZNC","react":"e1Nhq","@parcel/transformer-js/src/esmodule-helpers.js":"9eXmb"}],"dWROg":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("[{\"key\":\"1_1_1_1_1_1_1_1_1_1_1_1\",\"scaleNumber\":1,\"scale\":[1,1,1,1,1,1,1,1,1,1,1,1],\"is_superscale\":true,\"mode\":1,\"superscale_index\":1,\"all_scales_index\":0},{\"key\":\"1_1_1_1_1_1_1_1_1_1_2\",\"scaleNumber\":2,\"scale\":[1,1,1,1,1,1,1,1,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":2,\"all_scales_index\":1},{\"key\":\"1_1_1_1_1_1_1_1_1_2_1\",\"scaleNumber\":3,\"scale\":[1,1,1,1,1,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":2,\"all_scales_index\":2},{\"key\":\"1_1_1_1_1_1_1_1_2_1_1\",\"scaleNumber\":4,\"scale\":[1,1,1,1,1,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":2,\"all_scales_index\":4},{\"key\":\"1_1_1_1_1_1_1_2_1_1_1\",\"scaleNumber\":5,\"scale\":[1,1,1,1,1,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":2,\"all_scales_index\":7},{\"key\":\"1_1_1_1_1_1_2_1_1_1_1\",\"scaleNumber\":6,\"scale\":[1,1,1,1,1,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":2,\"all_scales_index\":13},{\"key\":\"1_1_1_1_1_2_1_1_1_1_1\",\"scaleNumber\":7,\"scale\":[1,1,1,1,1,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":2,\"all_scales_index\":24},{\"key\":\"1_1_1_1_2_1_1_1_1_1_1\",\"scaleNumber\":8,\"scale\":[1,1,1,1,2,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":2,\"all_scales_index\":44},{\"key\":\"1_1_1_2_1_1_1_1_1_1_1\",\"scaleNumber\":9,\"scale\":[1,1,1,2,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":2,\"all_scales_index\":81},{\"key\":\"1_1_2_1_1_1_1_1_1_1_1\",\"scaleNumber\":10,\"scale\":[1,1,2,1,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":2,\"all_scales_index\":149},{\"key\":\"1_2_1_1_1_1_1_1_1_1_1\",\"scaleNumber\":11,\"scale\":[1,2,1,1,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":10,\"superscale_index\":2,\"all_scales_index\":274},{\"key\":\"2_1_1_1_1_1_1_1_1_1_1\",\"scaleNumber\":12,\"scale\":[2,1,1,1,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":11,\"superscale_index\":2,\"all_scales_index\":504},{\"key\":\"1_1_1_1_1_1_1_1_1_3\",\"scaleNumber\":13,\"scale\":[1,1,1,1,1,1,1,1,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":3,\"all_scales_index\":3},{\"key\":\"1_1_1_1_1_1_1_1_3_1\",\"scaleNumber\":14,\"scale\":[1,1,1,1,1,1,1,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":3,\"all_scales_index\":6},{\"key\":\"1_1_1_1_1_1_1_3_1_1\",\"scaleNumber\":15,\"scale\":[1,1,1,1,1,1,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":3,\"all_scales_index\":11},{\"key\":\"1_1_1_1_1_1_3_1_1_1\",\"scaleNumber\":16,\"scale\":[1,1,1,1,1,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":3,\"all_scales_index\":20},{\"key\":\"1_1_1_1_1_3_1_1_1_1\",\"scaleNumber\":17,\"scale\":[1,1,1,1,1,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":3,\"all_scales_index\":37},{\"key\":\"1_1_1_1_3_1_1_1_1_1\",\"scaleNumber\":18,\"scale\":[1,1,1,1,3,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":3,\"all_scales_index\":68},{\"key\":\"1_1_1_3_1_1_1_1_1_1\",\"scaleNumber\":19,\"scale\":[1,1,1,3,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":3,\"all_scales_index\":125},{\"key\":\"1_1_3_1_1_1_1_1_1_1\",\"scaleNumber\":20,\"scale\":[1,1,3,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":3,\"all_scales_index\":230},{\"key\":\"1_3_1_1_1_1_1_1_1_1\",\"scaleNumber\":21,\"scale\":[1,3,1,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":3,\"all_scales_index\":423},{\"key\":\"3_1_1_1_1_1_1_1_1_1\",\"scaleNumber\":22,\"scale\":[3,1,1,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":10,\"superscale_index\":3,\"all_scales_index\":778},{\"key\":\"1_1_1_1_1_1_1_1_2_2\",\"scaleNumber\":23,\"scale\":[1,1,1,1,1,1,1,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":4,\"all_scales_index\":5},{\"key\":\"1_1_1_1_1_1_1_2_2_1\",\"scaleNumber\":24,\"scale\":[1,1,1,1,1,1,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":4,\"all_scales_index\":9},{\"key\":\"1_1_1_1_1_1_2_2_1_1\",\"scaleNumber\":25,\"scale\":[1,1,1,1,1,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":4,\"all_scales_index\":17},{\"key\":\"1_1_1_1_1_2_2_1_1_1\",\"scaleNumber\":26,\"scale\":[1,1,1,1,1,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":4,\"all_scales_index\":31},{\"key\":\"1_1_1_1_2_2_1_1_1_1\",\"scaleNumber\":27,\"scale\":[1,1,1,1,2,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":4,\"all_scales_index\":57},{\"key\":\"1_1_1_2_2_1_1_1_1_1\",\"scaleNumber\":28,\"scale\":[1,1,1,2,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":4,\"all_scales_index\":105},{\"key\":\"1_1_2_2_1_1_1_1_1_1\",\"scaleNumber\":29,\"scale\":[1,1,2,2,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":4,\"all_scales_index\":193},{\"key\":\"1_2_2_1_1_1_1_1_1_1\",\"scaleNumber\":30,\"scale\":[1,2,2,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":4,\"all_scales_index\":355},{\"key\":\"2_2_1_1_1_1_1_1_1_1\",\"scaleNumber\":31,\"scale\":[2,2,1,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":4,\"all_scales_index\":653},{\"key\":\"2_1_1_1_1_1_1_1_1_2\",\"scaleNumber\":32,\"scale\":[2,1,1,1,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":10,\"superscale_index\":4,\"all_scales_index\":505},{\"key\":\"1_1_1_1_1_1_1_2_1_2\",\"scaleNumber\":33,\"scale\":[1,1,1,1,1,1,1,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":5,\"all_scales_index\":8},{\"key\":\"1_1_1_1_1_1_2_1_2_1\",\"scaleNumber\":34,\"scale\":[1,1,1,1,1,1,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":5,\"all_scales_index\":15},{\"key\":\"1_1_1_1_1_2_1_2_1_1\",\"scaleNumber\":35,\"scale\":[1,1,1,1,1,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":5,\"all_scales_index\":28},{\"key\":\"1_1_1_1_2_1_2_1_1_1\",\"scaleNumber\":36,\"scale\":[1,1,1,1,2,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":5,\"all_scales_index\":51},{\"key\":\"1_1_1_2_1_2_1_1_1_1\",\"scaleNumber\":37,\"scale\":[1,1,1,2,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":5,\"all_scales_index\":94},{\"key\":\"1_1_2_1_2_1_1_1_1_1\",\"scaleNumber\":38,\"scale\":[1,1,2,1,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":5,\"all_scales_index\":173},{\"key\":\"1_2_1_2_1_1_1_1_1_1\",\"scaleNumber\":39,\"scale\":[1,2,1,2,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":5,\"all_scales_index\":318},{\"key\":\"2_1_2_1_1_1_1_1_1_1\",\"scaleNumber\":40,\"scale\":[2,1,2,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":5,\"all_scales_index\":585},{\"key\":\"1_2_1_1_1_1_1_1_1_2\",\"scaleNumber\":41,\"scale\":[1,2,1,1,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":9,\"superscale_index\":5,\"all_scales_index\":275},{\"key\":\"2_1_1_1_1_1_1_1_2_1\",\"scaleNumber\":42,\"scale\":[2,1,1,1,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":10,\"superscale_index\":5,\"all_scales_index\":506},{\"key\":\"1_1_1_1_1_1_1_2_3\",\"scaleNumber\":43,\"scale\":[1,1,1,1,1,1,1,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":6,\"all_scales_index\":10},{\"key\":\"1_1_1_1_1_1_2_3_1\",\"scaleNumber\":44,\"scale\":[1,1,1,1,1,1,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":6,\"all_scales_index\":19},{\"key\":\"1_1_1_1_1_2_3_1_1\",\"scaleNumber\":45,\"scale\":[1,1,1,1,1,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":6,\"all_scales_index\":35},{\"key\":\"1_1_1_1_2_3_1_1_1\",\"scaleNumber\":46,\"scale\":[1,1,1,1,2,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":6,\"all_scales_index\":64},{\"key\":\"1_1_1_2_3_1_1_1_1\",\"scaleNumber\":47,\"scale\":[1,1,1,2,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":6,\"all_scales_index\":118},{\"key\":\"1_1_2_3_1_1_1_1_1\",\"scaleNumber\":48,\"scale\":[1,1,2,3,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":6,\"all_scales_index\":217},{\"key\":\"1_2_3_1_1_1_1_1_1\",\"scaleNumber\":49,\"scale\":[1,2,3,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":6,\"all_scales_index\":399},{\"key\":\"2_3_1_1_1_1_1_1_1\",\"scaleNumber\":50,\"scale\":[2,3,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":6,\"all_scales_index\":734},{\"key\":\"3_1_1_1_1_1_1_1_2\",\"scaleNumber\":51,\"scale\":[3,1,1,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":9,\"superscale_index\":6,\"all_scales_index\":779},{\"key\":\"1_1_1_1_1_1_1_3_2\",\"scaleNumber\":52,\"scale\":[1,1,1,1,1,1,1,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":7,\"all_scales_index\":12},{\"key\":\"1_1_1_1_1_1_3_2_1\",\"scaleNumber\":53,\"scale\":[1,1,1,1,1,1,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":7,\"all_scales_index\":22},{\"key\":\"1_1_1_1_1_3_2_1_1\",\"scaleNumber\":54,\"scale\":[1,1,1,1,1,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":7,\"all_scales_index\":41},{\"key\":\"1_1_1_1_3_2_1_1_1\",\"scaleNumber\":55,\"scale\":[1,1,1,1,3,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":7,\"all_scales_index\":75},{\"key\":\"1_1_1_3_2_1_1_1_1\",\"scaleNumber\":56,\"scale\":[1,1,1,3,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":7,\"all_scales_index\":138},{\"key\":\"1_1_3_2_1_1_1_1_1\",\"scaleNumber\":57,\"scale\":[1,1,3,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":7,\"all_scales_index\":254},{\"key\":\"1_3_2_1_1_1_1_1_1\",\"scaleNumber\":58,\"scale\":[1,3,2,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":7,\"all_scales_index\":467},{\"key\":\"3_2_1_1_1_1_1_1_1\",\"scaleNumber\":59,\"scale\":[3,2,1,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":7,\"all_scales_index\":859},{\"key\":\"2_1_1_1_1_1_1_1_3\",\"scaleNumber\":60,\"scale\":[2,1,1,1,1,1,1,1,3],\"is_superscale\":false,\"mode\":9,\"superscale_index\":7,\"all_scales_index\":507},{\"key\":\"1_1_1_1_1_1_2_1_1_2\",\"scaleNumber\":61,\"scale\":[1,1,1,1,1,1,2,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":8,\"all_scales_index\":14},{\"key\":\"1_1_1_1_1_2_1_1_2_1\",\"scaleNumber\":62,\"scale\":[1,1,1,1,1,2,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":8,\"all_scales_index\":26},{\"key\":\"1_1_1_1_2_1_1_2_1_1\",\"scaleNumber\":63,\"scale\":[1,1,1,1,2,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":8,\"all_scales_index\":48},{\"key\":\"1_1_1_2_1_1_2_1_1_1\",\"scaleNumber\":64,\"scale\":[1,1,1,2,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":8,\"all_scales_index\":88},{\"key\":\"1_1_2_1_1_2_1_1_1_1\",\"scaleNumber\":65,\"scale\":[1,1,2,1,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":8,\"all_scales_index\":162},{\"key\":\"1_2_1_1_2_1_1_1_1_1\",\"scaleNumber\":66,\"scale\":[1,2,1,1,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":8,\"all_scales_index\":298},{\"key\":\"2_1_1_2_1_1_1_1_1_1\",\"scaleNumber\":67,\"scale\":[2,1,1,2,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":8,\"all_scales_index\":548},{\"key\":\"1_1_2_1_1_1_1_1_1_2\",\"scaleNumber\":68,\"scale\":[1,1,2,1,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":8,\"all_scales_index\":150},{\"key\":\"1_2_1_1_1_1_1_1_2_1\",\"scaleNumber\":69,\"scale\":[1,2,1,1,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":8,\"all_scales_index\":276},{\"key\":\"2_1_1_1_1_1_1_2_1_1\",\"scaleNumber\":70,\"scale\":[2,1,1,1,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":10,\"superscale_index\":8,\"all_scales_index\":508},{\"key\":\"1_1_1_1_1_1_2_1_3\",\"scaleNumber\":71,\"scale\":[1,1,1,1,1,1,2,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":9,\"all_scales_index\":16},{\"key\":\"1_1_1_1_1_2_1_3_1\",\"scaleNumber\":72,\"scale\":[1,1,1,1,1,2,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":9,\"all_scales_index\":30},{\"key\":\"1_1_1_1_2_1_3_1_1\",\"scaleNumber\":73,\"scale\":[1,1,1,1,2,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":9,\"all_scales_index\":55},{\"key\":\"1_1_1_2_1_3_1_1_1\",\"scaleNumber\":74,\"scale\":[1,1,1,2,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":9,\"all_scales_index\":101},{\"key\":\"1_1_2_1_3_1_1_1_1\",\"scaleNumber\":75,\"scale\":[1,1,2,1,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":9,\"all_scales_index\":186},{\"key\":\"1_2_1_3_1_1_1_1_1\",\"scaleNumber\":76,\"scale\":[1,2,1,3,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":9,\"all_scales_index\":342},{\"key\":\"2_1_3_1_1_1_1_1_1\",\"scaleNumber\":77,\"scale\":[2,1,3,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":9,\"all_scales_index\":629},{\"key\":\"1_3_1_1_1_1_1_1_2\",\"scaleNumber\":78,\"scale\":[1,3,1,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":9,\"all_scales_index\":424},{\"key\":\"3_1_1_1_1_1_1_2_1\",\"scaleNumber\":79,\"scale\":[3,1,1,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":9,\"all_scales_index\":780},{\"key\":\"1_1_1_1_1_1_2_2_2\",\"scaleNumber\":80,\"scale\":[1,1,1,1,1,1,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":10,\"all_scales_index\":18},{\"key\":\"1_1_1_1_1_2_2_2_1\",\"scaleNumber\":81,\"scale\":[1,1,1,1,1,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":10,\"all_scales_index\":33},{\"key\":\"1_1_1_1_2_2_2_1_1\",\"scaleNumber\":82,\"scale\":[1,1,1,1,2,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":10,\"all_scales_index\":61},{\"key\":\"1_1_1_2_2_2_1_1_1\",\"scaleNumber\":83,\"scale\":[1,1,1,2,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":10,\"all_scales_index\":112},{\"key\":\"1_1_2_2_2_1_1_1_1\",\"scaleNumber\":84,\"scale\":[1,1,2,2,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":10,\"all_scales_index\":206},{\"key\":\"1_2_2_2_1_1_1_1_1\",\"scaleNumber\":85,\"scale\":[1,2,2,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":10,\"all_scales_index\":379},{\"key\":\"2_2_2_1_1_1_1_1_1\",\"scaleNumber\":86,\"scale\":[2,2,2,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":10,\"all_scales_index\":697},{\"key\":\"2_2_1_1_1_1_1_1_2\",\"scaleNumber\":87,\"scale\":[2,2,1,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":10,\"all_scales_index\":654},{\"key\":\"2_1_1_1_1_1_1_2_2\",\"scaleNumber\":88,\"scale\":[2,1,1,1,1,1,1,2,2],\"is_superscale\":false,\"mode\":9,\"superscale_index\":10,\"all_scales_index\":509},{\"key\":\"1_1_1_1_1_1_3_1_2\",\"scaleNumber\":89,\"scale\":[1,1,1,1,1,1,3,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":11,\"all_scales_index\":21},{\"key\":\"1_1_1_1_1_3_1_2_1\",\"scaleNumber\":90,\"scale\":[1,1,1,1,1,3,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":11,\"all_scales_index\":39},{\"key\":\"1_1_1_1_3_1_2_1_1\",\"scaleNumber\":91,\"scale\":[1,1,1,1,3,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":11,\"all_scales_index\":72},{\"key\":\"1_1_1_3_1_2_1_1_1\",\"scaleNumber\":92,\"scale\":[1,1,1,3,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":11,\"all_scales_index\":132},{\"key\":\"1_1_3_1_2_1_1_1_1\",\"scaleNumber\":93,\"scale\":[1,1,3,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":11,\"all_scales_index\":243},{\"key\":\"1_3_1_2_1_1_1_1_1\",\"scaleNumber\":94,\"scale\":[1,3,1,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":11,\"all_scales_index\":447},{\"key\":\"3_1_2_1_1_1_1_1_1\",\"scaleNumber\":95,\"scale\":[3,1,2,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":11,\"all_scales_index\":822},{\"key\":\"1_2_1_1_1_1_1_1_3\",\"scaleNumber\":96,\"scale\":[1,2,1,1,1,1,1,1,3],\"is_superscale\":false,\"mode\":8,\"superscale_index\":11,\"all_scales_index\":277},{\"key\":\"2_1_1_1_1_1_1_3_1\",\"scaleNumber\":97,\"scale\":[2,1,1,1,1,1,1,3,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":11,\"all_scales_index\":510},{\"key\":\"1_1_1_1_1_1_3_3\",\"scaleNumber\":98,\"scale\":[1,1,1,1,1,1,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":12,\"all_scales_index\":23},{\"key\":\"1_1_1_1_1_3_3_1\",\"scaleNumber\":99,\"scale\":[1,1,1,1,1,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":12,\"all_scales_index\":43},{\"key\":\"1_1_1_1_3_3_1_1\",\"scaleNumber\":100,\"scale\":[1,1,1,1,3,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":12,\"all_scales_index\":79},{\"key\":\"1_1_1_3_3_1_1_1\",\"scaleNumber\":101,\"scale\":[1,1,1,3,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":12,\"all_scales_index\":145},{\"key\":\"1_1_3_3_1_1_1_1\",\"scaleNumber\":102,\"scale\":[1,1,3,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":12,\"all_scales_index\":267},{\"key\":\"1_3_3_1_1_1_1_1\",\"scaleNumber\":103,\"scale\":[1,3,3,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":12,\"all_scales_index\":491},{\"key\":\"3_3_1_1_1_1_1_1\",\"scaleNumber\":104,\"scale\":[3,3,1,1,1,1,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":12,\"all_scales_index\":903},{\"key\":\"3_1_1_1_1_1_1_3\",\"scaleNumber\":105,\"scale\":[3,1,1,1,1,1,1,3],\"is_superscale\":false,\"mode\":8,\"superscale_index\":12,\"all_scales_index\":781},{\"key\":\"1_1_1_1_1_2_1_1_1_2\",\"scaleNumber\":106,\"scale\":[1,1,1,1,1,2,1,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":13,\"all_scales_index\":25},{\"key\":\"1_1_1_1_2_1_1_1_2_1\",\"scaleNumber\":107,\"scale\":[1,1,1,1,2,1,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":13,\"all_scales_index\":46},{\"key\":\"1_1_1_2_1_1_1_2_1_1\",\"scaleNumber\":108,\"scale\":[1,1,1,2,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":13,\"all_scales_index\":85},{\"key\":\"1_1_2_1_1_1_2_1_1_1\",\"scaleNumber\":109,\"scale\":[1,1,2,1,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":13,\"all_scales_index\":156},{\"key\":\"1_2_1_1_1_2_1_1_1_1\",\"scaleNumber\":110,\"scale\":[1,2,1,1,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":13,\"all_scales_index\":287},{\"key\":\"2_1_1_1_2_1_1_1_1_1\",\"scaleNumber\":111,\"scale\":[2,1,1,1,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":13,\"all_scales_index\":528},{\"key\":\"1_1_1_2_1_1_1_1_1_2\",\"scaleNumber\":112,\"scale\":[1,1,1,2,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":13,\"all_scales_index\":82},{\"key\":\"1_1_2_1_1_1_1_1_2_1\",\"scaleNumber\":113,\"scale\":[1,1,2,1,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":13,\"all_scales_index\":151},{\"key\":\"1_2_1_1_1_1_1_2_1_1\",\"scaleNumber\":114,\"scale\":[1,2,1,1,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":13,\"all_scales_index\":278},{\"key\":\"2_1_1_1_1_1_2_1_1_1\",\"scaleNumber\":115,\"scale\":[2,1,1,1,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":10,\"superscale_index\":13,\"all_scales_index\":511},{\"key\":\"1_1_1_1_1_2_1_1_3\",\"scaleNumber\":116,\"scale\":[1,1,1,1,1,2,1,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":14,\"all_scales_index\":27},{\"key\":\"1_1_1_1_2_1_1_3_1\",\"scaleNumber\":117,\"scale\":[1,1,1,1,2,1,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":14,\"all_scales_index\":50},{\"key\":\"1_1_1_2_1_1_3_1_1\",\"scaleNumber\":118,\"scale\":[1,1,1,2,1,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":14,\"all_scales_index\":92},{\"key\":\"1_1_2_1_1_3_1_1_1\",\"scaleNumber\":119,\"scale\":[1,1,2,1,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":14,\"all_scales_index\":169},{\"key\":\"1_2_1_1_3_1_1_1_1\",\"scaleNumber\":120,\"scale\":[1,2,1,1,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":14,\"all_scales_index\":311},{\"key\":\"2_1_1_3_1_1_1_1_1\",\"scaleNumber\":121,\"scale\":[2,1,1,3,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":14,\"all_scales_index\":572},{\"key\":\"1_1_3_1_1_1_1_1_2\",\"scaleNumber\":122,\"scale\":[1,1,3,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":14,\"all_scales_index\":231},{\"key\":\"1_3_1_1_1_1_1_2_1\",\"scaleNumber\":123,\"scale\":[1,3,1,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":14,\"all_scales_index\":425},{\"key\":\"3_1_1_1_1_1_2_1_1\",\"scaleNumber\":124,\"scale\":[3,1,1,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":14,\"all_scales_index\":782},{\"key\":\"1_1_1_1_1_2_1_2_2\",\"scaleNumber\":125,\"scale\":[1,1,1,1,1,2,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":15,\"all_scales_index\":29},{\"key\":\"1_1_1_1_2_1_2_2_1\",\"scaleNumber\":126,\"scale\":[1,1,1,1,2,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":15,\"all_scales_index\":53},{\"key\":\"1_1_1_2_1_2_2_1_1\",\"scaleNumber\":127,\"scale\":[1,1,1,2,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":15,\"all_scales_index\":98},{\"key\":\"1_1_2_1_2_2_1_1_1\",\"scaleNumber\":128,\"scale\":[1,1,2,1,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":15,\"all_scales_index\":180},{\"key\":\"1_2_1_2_2_1_1_1_1\",\"scaleNumber\":129,\"scale\":[1,2,1,2,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":15,\"all_scales_index\":331},{\"key\":\"2_1_2_2_1_1_1_1_1\",\"scaleNumber\":130,\"scale\":[2,1,2,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":15,\"all_scales_index\":609},{\"key\":\"1_2_2_1_1_1_1_1_2\",\"scaleNumber\":131,\"scale\":[1,2,2,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":15,\"all_scales_index\":356},{\"key\":\"2_2_1_1_1_1_1_2_1\",\"scaleNumber\":132,\"scale\":[2,2,1,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":15,\"all_scales_index\":655},{\"key\":\"2_1_1_1_1_1_2_1_2\",\"scaleNumber\":133,\"scale\":[2,1,1,1,1,1,2,1,2],\"is_superscale\":false,\"mode\":9,\"superscale_index\":15,\"all_scales_index\":512},{\"key\":\"1_1_1_1_1_2_2_1_2\",\"scaleNumber\":134,\"scale\":[1,1,1,1,1,2,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":16,\"all_scales_index\":32},{\"key\":\"1_1_1_1_2_2_1_2_1\",\"scaleNumber\":135,\"scale\":[1,1,1,1,2,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":16,\"all_scales_index\":59},{\"key\":\"1_1_1_2_2_1_2_1_1\",\"scaleNumber\":136,\"scale\":[1,1,1,2,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":16,\"all_scales_index\":109},{\"key\":\"1_1_2_2_1_2_1_1_1\",\"scaleNumber\":137,\"scale\":[1,1,2,2,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":16,\"all_scales_index\":200},{\"key\":\"1_2_2_1_2_1_1_1_1\",\"scaleNumber\":138,\"scale\":[1,2,2,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":16,\"all_scales_index\":368},{\"key\":\"2_2_1_2_1_1_1_1_1\",\"scaleNumber\":139,\"scale\":[2,2,1,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":16,\"all_scales_index\":677},{\"key\":\"2_1_2_1_1_1_1_1_2\",\"scaleNumber\":140,\"scale\":[2,1,2,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":16,\"all_scales_index\":586},{\"key\":\"1_2_1_1_1_1_1_2_2\",\"scaleNumber\":141,\"scale\":[1,2,1,1,1,1,1,2,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":16,\"all_scales_index\":279},{\"key\":\"2_1_1_1_1_1_2_2_1\",\"scaleNumber\":142,\"scale\":[2,1,1,1,1,1,2,2,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":16,\"all_scales_index\":513},{\"key\":\"1_1_1_1_1_2_2_3\",\"scaleNumber\":143,\"scale\":[1,1,1,1,1,2,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":17,\"all_scales_index\":34},{\"key\":\"1_1_1_1_2_2_3_1\",\"scaleNumber\":144,\"scale\":[1,1,1,1,2,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":17,\"all_scales_index\":63},{\"key\":\"1_1_1_2_2_3_1_1\",\"scaleNumber\":145,\"scale\":[1,1,1,2,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":17,\"all_scales_index\":116},{\"key\":\"1_1_2_2_3_1_1_1\",\"scaleNumber\":146,\"scale\":[1,1,2,2,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":17,\"all_scales_index\":213},{\"key\":\"1_2_2_3_1_1_1_1\",\"scaleNumber\":147,\"scale\":[1,2,2,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":17,\"all_scales_index\":392},{\"key\":\"2_2_3_1_1_1_1_1\",\"scaleNumber\":148,\"scale\":[2,2,3,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":17,\"all_scales_index\":721},{\"key\":\"2_3_1_1_1_1_1_2\",\"scaleNumber\":149,\"scale\":[2,3,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":17,\"all_scales_index\":735},{\"key\":\"3_1_1_1_1_1_2_2\",\"scaleNumber\":150,\"scale\":[3,1,1,1,1,1,2,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":17,\"all_scales_index\":783},{\"key\":\"1_1_1_1_1_2_3_2\",\"scaleNumber\":151,\"scale\":[1,1,1,1,1,2,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":18,\"all_scales_index\":36},{\"key\":\"1_1_1_1_2_3_2_1\",\"scaleNumber\":152,\"scale\":[1,1,1,1,2,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":18,\"all_scales_index\":66},{\"key\":\"1_1_1_2_3_2_1_1\",\"scaleNumber\":153,\"scale\":[1,1,1,2,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":18,\"all_scales_index\":122},{\"key\":\"1_1_2_3_2_1_1_1\",\"scaleNumber\":154,\"scale\":[1,1,2,3,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":18,\"all_scales_index\":224},{\"key\":\"1_2_3_2_1_1_1_1\",\"scaleNumber\":155,\"scale\":[1,2,3,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":18,\"all_scales_index\":412},{\"key\":\"2_3_2_1_1_1_1_1\",\"scaleNumber\":156,\"scale\":[2,3,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":18,\"all_scales_index\":758},{\"key\":\"3_2_1_1_1_1_1_2\",\"scaleNumber\":157,\"scale\":[3,2,1,1,1,1,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":18,\"all_scales_index\":860},{\"key\":\"2_1_1_1_1_1_2_3\",\"scaleNumber\":158,\"scale\":[2,1,1,1,1,1,2,3],\"is_superscale\":false,\"mode\":8,\"superscale_index\":18,\"all_scales_index\":514},{\"key\":\"1_1_1_1_1_3_1_1_2\",\"scaleNumber\":159,\"scale\":[1,1,1,1,1,3,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":19,\"all_scales_index\":38},{\"key\":\"1_1_1_1_3_1_1_2_1\",\"scaleNumber\":160,\"scale\":[1,1,1,1,3,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":19,\"all_scales_index\":70},{\"key\":\"1_1_1_3_1_1_2_1_1\",\"scaleNumber\":161,\"scale\":[1,1,1,3,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":19,\"all_scales_index\":129},{\"key\":\"1_1_3_1_1_2_1_1_1\",\"scaleNumber\":162,\"scale\":[1,1,3,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":19,\"all_scales_index\":237},{\"key\":\"1_3_1_1_2_1_1_1_1\",\"scaleNumber\":163,\"scale\":[1,3,1,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":19,\"all_scales_index\":436},{\"key\":\"3_1_1_2_1_1_1_1_1\",\"scaleNumber\":164,\"scale\":[3,1,1,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":19,\"all_scales_index\":802},{\"key\":\"1_1_2_1_1_1_1_1_3\",\"scaleNumber\":165,\"scale\":[1,1,2,1,1,1,1,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":19,\"all_scales_index\":152},{\"key\":\"1_2_1_1_1_1_1_3_1\",\"scaleNumber\":166,\"scale\":[1,2,1,1,1,1,1,3,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":19,\"all_scales_index\":280},{\"key\":\"2_1_1_1_1_1_3_1_1\",\"scaleNumber\":167,\"scale\":[2,1,1,1,1,1,3,1,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":19,\"all_scales_index\":515},{\"key\":\"1_1_1_1_1_3_1_3\",\"scaleNumber\":168,\"scale\":[1,1,1,1,1,3,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":20,\"all_scales_index\":40},{\"key\":\"1_1_1_1_3_1_3_1\",\"scaleNumber\":169,\"scale\":[1,1,1,1,3,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":20,\"all_scales_index\":74},{\"key\":\"1_1_1_3_1_3_1_1\",\"scaleNumber\":170,\"scale\":[1,1,1,3,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":20,\"all_scales_index\":136},{\"key\":\"1_1_3_1_3_1_1_1\",\"scaleNumber\":171,\"scale\":[1,1,3,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":20,\"all_scales_index\":250},{\"key\":\"1_3_1_3_1_1_1_1\",\"scaleNumber\":172,\"scale\":[1,3,1,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":20,\"all_scales_index\":460},{\"key\":\"3_1_3_1_1_1_1_1\",\"scaleNumber\":173,\"scale\":[3,1,3,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":20,\"all_scales_index\":846},{\"key\":\"1_3_1_1_1_1_1_3\",\"scaleNumber\":174,\"scale\":[1,3,1,1,1,1,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":20,\"all_scales_index\":426},{\"key\":\"3_1_1_1_1_1_3_1\",\"scaleNumber\":175,\"scale\":[3,1,1,1,1,1,3,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":20,\"all_scales_index\":784},{\"key\":\"1_1_1_1_1_3_2_2\",\"scaleNumber\":176,\"scale\":[1,1,1,1,1,3,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":21,\"all_scales_index\":42},{\"key\":\"1_1_1_1_3_2_2_1\",\"scaleNumber\":177,\"scale\":[1,1,1,1,3,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":21,\"all_scales_index\":77},{\"key\":\"1_1_1_3_2_2_1_1\",\"scaleNumber\":178,\"scale\":[1,1,1,3,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":21,\"all_scales_index\":142},{\"key\":\"1_1_3_2_2_1_1_1\",\"scaleNumber\":179,\"scale\":[1,1,3,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":21,\"all_scales_index\":261},{\"key\":\"1_3_2_2_1_1_1_1\",\"scaleNumber\":180,\"scale\":[1,3,2,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":21,\"all_scales_index\":480},{\"key\":\"3_2_2_1_1_1_1_1\",\"scaleNumber\":181,\"scale\":[3,2,2,1,1,1,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":21,\"all_scales_index\":883},{\"key\":\"2_2_1_1_1_1_1_3\",\"scaleNumber\":182,\"scale\":[2,2,1,1,1,1,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":21,\"all_scales_index\":656},{\"key\":\"2_1_1_1_1_1_3_2\",\"scaleNumber\":183,\"scale\":[2,1,1,1,1,1,3,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":21,\"all_scales_index\":516},{\"key\":\"1_1_1_1_2_1_1_1_1_2\",\"scaleNumber\":184,\"scale\":[1,1,1,1,2,1,1,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":22,\"all_scales_index\":45},{\"key\":\"1_1_1_2_1_1_1_1_2_1\",\"scaleNumber\":185,\"scale\":[1,1,1,2,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":22,\"all_scales_index\":83},{\"key\":\"1_1_2_1_1_1_1_2_1_1\",\"scaleNumber\":186,\"scale\":[1,1,2,1,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":22,\"all_scales_index\":153},{\"key\":\"1_2_1_1_1_1_2_1_1_1\",\"scaleNumber\":187,\"scale\":[1,2,1,1,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":22,\"all_scales_index\":281},{\"key\":\"2_1_1_1_1_2_1_1_1_1\",\"scaleNumber\":188,\"scale\":[2,1,1,1,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":22,\"all_scales_index\":517},{\"key\":\"1_1_1_1_2_1_1_1_3\",\"scaleNumber\":189,\"scale\":[1,1,1,1,2,1,1,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":23,\"all_scales_index\":47},{\"key\":\"1_1_1_2_1_1_1_3_1\",\"scaleNumber\":190,\"scale\":[1,1,1,2,1,1,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":23,\"all_scales_index\":87},{\"key\":\"1_1_2_1_1_1_3_1_1\",\"scaleNumber\":191,\"scale\":[1,1,2,1,1,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":23,\"all_scales_index\":160},{\"key\":\"1_2_1_1_1_3_1_1_1\",\"scaleNumber\":192,\"scale\":[1,2,1,1,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":23,\"all_scales_index\":294},{\"key\":\"2_1_1_1_3_1_1_1_1\",\"scaleNumber\":193,\"scale\":[2,1,1,1,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":23,\"all_scales_index\":541},{\"key\":\"1_1_1_3_1_1_1_1_2\",\"scaleNumber\":194,\"scale\":[1,1,1,3,1,1,1,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":23,\"all_scales_index\":126},{\"key\":\"1_1_3_1_1_1_1_2_1\",\"scaleNumber\":195,\"scale\":[1,1,3,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":23,\"all_scales_index\":232},{\"key\":\"1_3_1_1_1_1_2_1_1\",\"scaleNumber\":196,\"scale\":[1,3,1,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":23,\"all_scales_index\":427},{\"key\":\"3_1_1_1_1_2_1_1_1\",\"scaleNumber\":197,\"scale\":[3,1,1,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":23,\"all_scales_index\":785},{\"key\":\"1_1_1_1_2_1_1_2_2\",\"scaleNumber\":198,\"scale\":[1,1,1,1,2,1,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":24,\"all_scales_index\":49},{\"key\":\"1_1_1_2_1_1_2_2_1\",\"scaleNumber\":199,\"scale\":[1,1,1,2,1,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":24,\"all_scales_index\":90},{\"key\":\"1_1_2_1_1_2_2_1_1\",\"scaleNumber\":200,\"scale\":[1,1,2,1,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":24,\"all_scales_index\":166},{\"key\":\"1_2_1_1_2_2_1_1_1\",\"scaleNumber\":201,\"scale\":[1,2,1,1,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":24,\"all_scales_index\":305},{\"key\":\"2_1_1_2_2_1_1_1_1\",\"scaleNumber\":202,\"scale\":[2,1,1,2,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":24,\"all_scales_index\":561},{\"key\":\"1_1_2_2_1_1_1_1_2\",\"scaleNumber\":203,\"scale\":[1,1,2,2,1,1,1,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":24,\"all_scales_index\":194},{\"key\":\"1_2_2_1_1_1_1_2_1\",\"scaleNumber\":204,\"scale\":[1,2,2,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":24,\"all_scales_index\":357},{\"key\":\"2_2_1_1_1_1_2_1_1\",\"scaleNumber\":205,\"scale\":[2,2,1,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":24,\"all_scales_index\":657},{\"key\":\"2_1_1_1_1_2_1_1_2\",\"scaleNumber\":206,\"scale\":[2,1,1,1,1,2,1,1,2],\"is_superscale\":false,\"mode\":9,\"superscale_index\":24,\"all_scales_index\":518},{\"key\":\"1_1_1_1_2_1_2_1_2\",\"scaleNumber\":207,\"scale\":[1,1,1,1,2,1,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":25,\"all_scales_index\":52},{\"key\":\"1_1_1_2_1_2_1_2_1\",\"scaleNumber\":208,\"scale\":[1,1,1,2,1,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":25,\"all_scales_index\":96},{\"key\":\"1_1_2_1_2_1_2_1_1\",\"scaleNumber\":209,\"scale\":[1,1,2,1,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":25,\"all_scales_index\":177},{\"key\":\"1_2_1_2_1_2_1_1_1\",\"scaleNumber\":210,\"scale\":[1,2,1,2,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":25,\"all_scales_index\":325},{\"key\":\"2_1_2_1_2_1_1_1_1\",\"scaleNumber\":211,\"scale\":[2,1,2,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":25,\"all_scales_index\":598},{\"key\":\"1_2_1_2_1_1_1_1_2\",\"scaleNumber\":212,\"scale\":[1,2,1,2,1,1,1,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":25,\"all_scales_index\":319},{\"key\":\"2_1_2_1_1_1_1_2_1\",\"scaleNumber\":213,\"scale\":[2,1,2,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":25,\"all_scales_index\":587},{\"key\":\"1_2_1_1_1_1_2_1_2\",\"scaleNumber\":214,\"scale\":[1,2,1,1,1,1,2,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":25,\"all_scales_index\":282},{\"key\":\"2_1_1_1_1_2_1_2_1\",\"scaleNumber\":215,\"scale\":[2,1,1,1,1,2,1,2,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":25,\"all_scales_index\":519},{\"key\":\"1_1_1_1_2_1_2_3\",\"scaleNumber\":216,\"scale\":[1,1,1,1,2,1,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":26,\"all_scales_index\":54},{\"key\":\"1_1_1_2_1_2_3_1\",\"scaleNumber\":217,\"scale\":[1,1,1,2,1,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":26,\"all_scales_index\":100},{\"key\":\"1_1_2_1_2_3_1_1\",\"scaleNumber\":218,\"scale\":[1,1,2,1,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":26,\"all_scales_index\":184},{\"key\":\"1_2_1_2_3_1_1_1\",\"scaleNumber\":219,\"scale\":[1,2,1,2,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":26,\"all_scales_index\":338},{\"key\":\"2_1_2_3_1_1_1_1\",\"scaleNumber\":220,\"scale\":[2,1,2,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":26,\"all_scales_index\":622},{\"key\":\"1_2_3_1_1_1_1_2\",\"scaleNumber\":221,\"scale\":[1,2,3,1,1,1,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":26,\"all_scales_index\":400},{\"key\":\"2_3_1_1_1_1_2_1\",\"scaleNumber\":222,\"scale\":[2,3,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":26,\"all_scales_index\":736},{\"key\":\"3_1_1_1_1_2_1_2\",\"scaleNumber\":223,\"scale\":[3,1,1,1,1,2,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":26,\"all_scales_index\":786},{\"key\":\"1_1_1_1_2_1_3_2\",\"scaleNumber\":224,\"scale\":[1,1,1,1,2,1,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":27,\"all_scales_index\":56},{\"key\":\"1_1_1_2_1_3_2_1\",\"scaleNumber\":225,\"scale\":[1,1,1,2,1,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":27,\"all_scales_index\":103},{\"key\":\"1_1_2_1_3_2_1_1\",\"scaleNumber\":226,\"scale\":[1,1,2,1,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":27,\"all_scales_index\":190},{\"key\":\"1_2_1_3_2_1_1_1\",\"scaleNumber\":227,\"scale\":[1,2,1,3,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":27,\"all_scales_index\":349},{\"key\":\"2_1_3_2_1_1_1_1\",\"scaleNumber\":228,\"scale\":[2,1,3,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":27,\"all_scales_index\":642},{\"key\":\"1_3_2_1_1_1_1_2\",\"scaleNumber\":229,\"scale\":[1,3,2,1,1,1,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":27,\"all_scales_index\":468},{\"key\":\"3_2_1_1_1_1_2_1\",\"scaleNumber\":230,\"scale\":[3,2,1,1,1,1,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":27,\"all_scales_index\":861},{\"key\":\"2_1_1_1_1_2_1_3\",\"scaleNumber\":231,\"scale\":[2,1,1,1,1,2,1,3],\"is_superscale\":false,\"mode\":8,\"superscale_index\":27,\"all_scales_index\":520},{\"key\":\"1_1_1_1_2_2_1_1_2\",\"scaleNumber\":232,\"scale\":[1,1,1,1,2,2,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":28,\"all_scales_index\":58},{\"key\":\"1_1_1_2_2_1_1_2_1\",\"scaleNumber\":233,\"scale\":[1,1,1,2,2,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":28,\"all_scales_index\":107},{\"key\":\"1_1_2_2_1_1_2_1_1\",\"scaleNumber\":234,\"scale\":[1,1,2,2,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":28,\"all_scales_index\":197},{\"key\":\"1_2_2_1_1_2_1_1_1\",\"scaleNumber\":235,\"scale\":[1,2,2,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":28,\"all_scales_index\":362},{\"key\":\"2_2_1_1_2_1_1_1_1\",\"scaleNumber\":236,\"scale\":[2,2,1,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":28,\"all_scales_index\":666},{\"key\":\"2_1_1_2_1_1_1_1_2\",\"scaleNumber\":237,\"scale\":[2,1,1,2,1,1,1,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":28,\"all_scales_index\":549},{\"key\":\"1_1_2_1_1_1_1_2_2\",\"scaleNumber\":238,\"scale\":[1,1,2,1,1,1,1,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":28,\"all_scales_index\":154},{\"key\":\"1_2_1_1_1_1_2_2_1\",\"scaleNumber\":239,\"scale\":[1,2,1,1,1,1,2,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":28,\"all_scales_index\":283},{\"key\":\"2_1_1_1_1_2_2_1_1\",\"scaleNumber\":240,\"scale\":[2,1,1,1,1,2,2,1,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":28,\"all_scales_index\":521},{\"key\":\"1_1_1_1_2_2_1_3\",\"scaleNumber\":241,\"scale\":[1,1,1,1,2,2,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":29,\"all_scales_index\":60},{\"key\":\"1_1_1_2_2_1_3_1\",\"scaleNumber\":242,\"scale\":[1,1,1,2,2,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":29,\"all_scales_index\":111},{\"key\":\"1_1_2_2_1_3_1_1\",\"scaleNumber\":243,\"scale\":[1,1,2,2,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":29,\"all_scales_index\":204},{\"key\":\"1_2_2_1_3_1_1_1\",\"scaleNumber\":244,\"scale\":[1,2,2,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":29,\"all_scales_index\":375},{\"key\":\"2_2_1_3_1_1_1_1\",\"scaleNumber\":245,\"scale\":[2,2,1,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":29,\"all_scales_index\":690},{\"key\":\"2_1_3_1_1_1_1_2\",\"scaleNumber\":246,\"scale\":[2,1,3,1,1,1,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":29,\"all_scales_index\":630},{\"key\":\"1_3_1_1_1_1_2_2\",\"scaleNumber\":247,\"scale\":[1,3,1,1,1,1,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":29,\"all_scales_index\":428},{\"key\":\"3_1_1_1_1_2_2_1\",\"scaleNumber\":248,\"scale\":[3,1,1,1,1,2,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":29,\"all_scales_index\":787},{\"key\":\"1_1_1_1_2_2_2_2\",\"scaleNumber\":249,\"scale\":[1,1,1,1,2,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":30,\"all_scales_index\":62},{\"key\":\"1_1_1_2_2_2_2_1\",\"scaleNumber\":250,\"scale\":[1,1,1,2,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":30,\"all_scales_index\":114},{\"key\":\"1_1_2_2_2_2_1_1\",\"scaleNumber\":251,\"scale\":[1,1,2,2,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":30,\"all_scales_index\":210},{\"key\":\"1_2_2_2_2_1_1_1\",\"scaleNumber\":252,\"scale\":[1,2,2,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":30,\"all_scales_index\":386},{\"key\":\"2_2_2_2_1_1_1_1\",\"scaleNumber\":253,\"scale\":[2,2,2,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":30,\"all_scales_index\":710},{\"key\":\"2_2_2_1_1_1_1_2\",\"scaleNumber\":254,\"scale\":[2,2,2,1,1,1,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":30,\"all_scales_index\":698},{\"key\":\"2_2_1_1_1_1_2_2\",\"scaleNumber\":255,\"scale\":[2,2,1,1,1,1,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":30,\"all_scales_index\":658},{\"key\":\"2_1_1_1_1_2_2_2\",\"scaleNumber\":256,\"scale\":[2,1,1,1,1,2,2,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":30,\"all_scales_index\":522},{\"key\":\"1_1_1_1_2_3_1_2\",\"scaleNumber\":257,\"scale\":[1,1,1,1,2,3,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":31,\"all_scales_index\":65},{\"key\":\"1_1_1_2_3_1_2_1\",\"scaleNumber\":258,\"scale\":[1,1,1,2,3,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":31,\"all_scales_index\":120},{\"key\":\"1_1_2_3_1_2_1_1\",\"scaleNumber\":259,\"scale\":[1,1,2,3,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":31,\"all_scales_index\":221},{\"key\":\"1_2_3_1_2_1_1_1\",\"scaleNumber\":260,\"scale\":[1,2,3,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":31,\"all_scales_index\":406},{\"key\":\"2_3_1_2_1_1_1_1\",\"scaleNumber\":261,\"scale\":[2,3,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":31,\"all_scales_index\":747},{\"key\":\"3_1_2_1_1_1_1_2\",\"scaleNumber\":262,\"scale\":[3,1,2,1,1,1,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":31,\"all_scales_index\":823},{\"key\":\"1_2_1_1_1_1_2_3\",\"scaleNumber\":263,\"scale\":[1,2,1,1,1,1,2,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":31,\"all_scales_index\":284},{\"key\":\"2_1_1_1_1_2_3_1\",\"scaleNumber\":264,\"scale\":[2,1,1,1,1,2,3,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":31,\"all_scales_index\":523},{\"key\":\"1_1_1_1_2_3_3\",\"scaleNumber\":265,\"scale\":[1,1,1,1,2,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":32,\"all_scales_index\":67},{\"key\":\"1_1_1_2_3_3_1\",\"scaleNumber\":266,\"scale\":[1,1,1,2,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":32,\"all_scales_index\":124},{\"key\":\"1_1_2_3_3_1_1\",\"scaleNumber\":267,\"scale\":[1,1,2,3,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":32,\"all_scales_index\":228},{\"key\":\"1_2_3_3_1_1_1\",\"scaleNumber\":268,\"scale\":[1,2,3,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":32,\"all_scales_index\":419},{\"key\":\"2_3_3_1_1_1_1\",\"scaleNumber\":269,\"scale\":[2,3,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":32,\"all_scales_index\":771},{\"key\":\"3_3_1_1_1_1_2\",\"scaleNumber\":270,\"scale\":[3,3,1,1,1,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":32,\"all_scales_index\":904},{\"key\":\"3_1_1_1_1_2_3\",\"scaleNumber\":271,\"scale\":[3,1,1,1,1,2,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":32,\"all_scales_index\":788},{\"key\":\"1_1_1_1_3_1_1_1_2\",\"scaleNumber\":272,\"scale\":[1,1,1,1,3,1,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":33,\"all_scales_index\":69},{\"key\":\"1_1_1_3_1_1_1_2_1\",\"scaleNumber\":273,\"scale\":[1,1,1,3,1,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":33,\"all_scales_index\":127},{\"key\":\"1_1_3_1_1_1_2_1_1\",\"scaleNumber\":274,\"scale\":[1,1,3,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":33,\"all_scales_index\":234},{\"key\":\"1_3_1_1_1_2_1_1_1\",\"scaleNumber\":275,\"scale\":[1,3,1,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":33,\"all_scales_index\":430},{\"key\":\"3_1_1_1_2_1_1_1_1\",\"scaleNumber\":276,\"scale\":[3,1,1,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":33,\"all_scales_index\":791},{\"key\":\"1_1_1_2_1_1_1_1_3\",\"scaleNumber\":277,\"scale\":[1,1,1,2,1,1,1,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":33,\"all_scales_index\":84},{\"key\":\"1_1_2_1_1_1_1_3_1\",\"scaleNumber\":278,\"scale\":[1,1,2,1,1,1,1,3,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":33,\"all_scales_index\":155},{\"key\":\"1_2_1_1_1_1_3_1_1\",\"scaleNumber\":279,\"scale\":[1,2,1,1,1,1,3,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":33,\"all_scales_index\":285},{\"key\":\"2_1_1_1_1_3_1_1_1\",\"scaleNumber\":280,\"scale\":[2,1,1,1,1,3,1,1,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":33,\"all_scales_index\":524},{\"key\":\"1_1_1_1_3_1_1_3\",\"scaleNumber\":281,\"scale\":[1,1,1,1,3,1,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":34,\"all_scales_index\":71},{\"key\":\"1_1_1_3_1_1_3_1\",\"scaleNumber\":282,\"scale\":[1,1,1,3,1,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":34,\"all_scales_index\":131},{\"key\":\"1_1_3_1_1_3_1_1\",\"scaleNumber\":283,\"scale\":[1,1,3,1,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":34,\"all_scales_index\":241},{\"key\":\"1_3_1_1_3_1_1_1\",\"scaleNumber\":284,\"scale\":[1,3,1,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":34,\"all_scales_index\":443},{\"key\":\"3_1_1_3_1_1_1_1\",\"scaleNumber\":285,\"scale\":[3,1,1,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":34,\"all_scales_index\":815},{\"key\":\"1_1_3_1_1_1_1_3\",\"scaleNumber\":286,\"scale\":[1,1,3,1,1,1,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":34,\"all_scales_index\":233},{\"key\":\"1_3_1_1_1_1_3_1\",\"scaleNumber\":287,\"scale\":[1,3,1,1,1,1,3,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":34,\"all_scales_index\":429},{\"key\":\"3_1_1_1_1_3_1_1\",\"scaleNumber\":288,\"scale\":[3,1,1,1,1,3,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":34,\"all_scales_index\":789},{\"key\":\"1_1_1_1_3_1_2_2\",\"scaleNumber\":289,\"scale\":[1,1,1,1,3,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":35,\"all_scales_index\":73},{\"key\":\"1_1_1_3_1_2_2_1\",\"scaleNumber\":290,\"scale\":[1,1,1,3,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":35,\"all_scales_index\":134},{\"key\":\"1_1_3_1_2_2_1_1\",\"scaleNumber\":291,\"scale\":[1,1,3,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":35,\"all_scales_index\":247},{\"key\":\"1_3_1_2_2_1_1_1\",\"scaleNumber\":292,\"scale\":[1,3,1,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":35,\"all_scales_index\":454},{\"key\":\"3_1_2_2_1_1_1_1\",\"scaleNumber\":293,\"scale\":[3,1,2,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":35,\"all_scales_index\":835},{\"key\":\"1_2_2_1_1_1_1_3\",\"scaleNumber\":294,\"scale\":[1,2,2,1,1,1,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":35,\"all_scales_index\":358},{\"key\":\"2_2_1_1_1_1_3_1\",\"scaleNumber\":295,\"scale\":[2,2,1,1,1,1,3,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":35,\"all_scales_index\":659},{\"key\":\"2_1_1_1_1_3_1_2\",\"scaleNumber\":296,\"scale\":[2,1,1,1,1,3,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":35,\"all_scales_index\":525},{\"key\":\"1_1_1_1_3_2_1_2\",\"scaleNumber\":297,\"scale\":[1,1,1,1,3,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":36,\"all_scales_index\":76},{\"key\":\"1_1_1_3_2_1_2_1\",\"scaleNumber\":298,\"scale\":[1,1,1,3,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":36,\"all_scales_index\":140},{\"key\":\"1_1_3_2_1_2_1_1\",\"scaleNumber\":299,\"scale\":[1,1,3,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":36,\"all_scales_index\":258},{\"key\":\"1_3_2_1_2_1_1_1\",\"scaleNumber\":300,\"scale\":[1,3,2,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":36,\"all_scales_index\":474},{\"key\":\"3_2_1_2_1_1_1_1\",\"scaleNumber\":301,\"scale\":[3,2,1,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":36,\"all_scales_index\":872},{\"key\":\"2_1_2_1_1_1_1_3\",\"scaleNumber\":302,\"scale\":[2,1,2,1,1,1,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":36,\"all_scales_index\":588},{\"key\":\"1_2_1_1_1_1_3_2\",\"scaleNumber\":303,\"scale\":[1,2,1,1,1,1,3,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":36,\"all_scales_index\":286},{\"key\":\"2_1_1_1_1_3_2_1\",\"scaleNumber\":304,\"scale\":[2,1,1,1,1,3,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":36,\"all_scales_index\":526},{\"key\":\"1_1_1_1_3_2_3\",\"scaleNumber\":305,\"scale\":[1,1,1,1,3,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":37,\"all_scales_index\":78},{\"key\":\"1_1_1_3_2_3_1\",\"scaleNumber\":306,\"scale\":[1,1,1,3,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":37,\"all_scales_index\":144},{\"key\":\"1_1_3_2_3_1_1\",\"scaleNumber\":307,\"scale\":[1,1,3,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":37,\"all_scales_index\":265},{\"key\":\"1_3_2_3_1_1_1\",\"scaleNumber\":308,\"scale\":[1,3,2,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":37,\"all_scales_index\":487},{\"key\":\"3_2_3_1_1_1_1\",\"scaleNumber\":309,\"scale\":[3,2,3,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":37,\"all_scales_index\":896},{\"key\":\"2_3_1_1_1_1_3\",\"scaleNumber\":310,\"scale\":[2,3,1,1,1,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":37,\"all_scales_index\":737},{\"key\":\"3_1_1_1_1_3_2\",\"scaleNumber\":311,\"scale\":[3,1,1,1,1,3,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":37,\"all_scales_index\":790},{\"key\":\"1_1_1_1_3_3_2\",\"scaleNumber\":312,\"scale\":[1,1,1,1,3,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":38,\"all_scales_index\":80},{\"key\":\"1_1_1_3_3_2_1\",\"scaleNumber\":313,\"scale\":[1,1,1,3,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":38,\"all_scales_index\":147},{\"key\":\"1_1_3_3_2_1_1\",\"scaleNumber\":314,\"scale\":[1,1,3,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":38,\"all_scales_index\":271},{\"key\":\"1_3_3_2_1_1_1\",\"scaleNumber\":315,\"scale\":[1,3,3,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":38,\"all_scales_index\":498},{\"key\":\"3_3_2_1_1_1_1\",\"scaleNumber\":316,\"scale\":[3,3,2,1,1,1,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":38,\"all_scales_index\":916},{\"key\":\"3_2_1_1_1_1_3\",\"scaleNumber\":317,\"scale\":[3,2,1,1,1,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":38,\"all_scales_index\":862},{\"key\":\"2_1_1_1_1_3_3\",\"scaleNumber\":318,\"scale\":[2,1,1,1,1,3,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":38,\"all_scales_index\":527},{\"key\":\"1_1_1_2_1_1_1_2_2\",\"scaleNumber\":319,\"scale\":[1,1,1,2,1,1,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":39,\"all_scales_index\":86},{\"key\":\"1_1_2_1_1_1_2_2_1\",\"scaleNumber\":320,\"scale\":[1,1,2,1,1,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":39,\"all_scales_index\":158},{\"key\":\"1_2_1_1_1_2_2_1_1\",\"scaleNumber\":321,\"scale\":[1,2,1,1,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":39,\"all_scales_index\":291},{\"key\":\"2_1_1_1_2_2_1_1_1\",\"scaleNumber\":322,\"scale\":[2,1,1,1,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":39,\"all_scales_index\":535},{\"key\":\"1_1_1_2_2_1_1_1_2\",\"scaleNumber\":323,\"scale\":[1,1,1,2,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":39,\"all_scales_index\":106},{\"key\":\"1_1_2_2_1_1_1_2_1\",\"scaleNumber\":324,\"scale\":[1,1,2,2,1,1,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":39,\"all_scales_index\":195},{\"key\":\"1_2_2_1_1_1_2_1_1\",\"scaleNumber\":325,\"scale\":[1,2,2,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":39,\"all_scales_index\":359},{\"key\":\"2_2_1_1_1_2_1_1_1\",\"scaleNumber\":326,\"scale\":[2,2,1,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":39,\"all_scales_index\":660},{\"key\":\"2_1_1_1_2_1_1_1_2\",\"scaleNumber\":327,\"scale\":[2,1,1,1,2,1,1,1,2],\"is_superscale\":false,\"mode\":9,\"superscale_index\":39,\"all_scales_index\":529},{\"key\":\"1_1_1_2_1_1_2_1_2\",\"scaleNumber\":328,\"scale\":[1,1,1,2,1,1,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":40,\"all_scales_index\":89},{\"key\":\"1_1_2_1_1_2_1_2_1\",\"scaleNumber\":329,\"scale\":[1,1,2,1,1,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":40,\"all_scales_index\":164},{\"key\":\"1_2_1_1_2_1_2_1_1\",\"scaleNumber\":330,\"scale\":[1,2,1,1,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":40,\"all_scales_index\":302},{\"key\":\"2_1_1_2_1_2_1_1_1\",\"scaleNumber\":331,\"scale\":[2,1,1,2,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":40,\"all_scales_index\":555},{\"key\":\"1_1_2_1_2_1_1_1_2\",\"scaleNumber\":332,\"scale\":[1,1,2,1,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":40,\"all_scales_index\":174},{\"key\":\"1_2_1_2_1_1_1_2_1\",\"scaleNumber\":333,\"scale\":[1,2,1,2,1,1,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":40,\"all_scales_index\":320},{\"key\":\"2_1_2_1_1_1_2_1_1\",\"scaleNumber\":334,\"scale\":[2,1,2,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":40,\"all_scales_index\":589},{\"key\":\"1_2_1_1_1_2_1_1_2\",\"scaleNumber\":335,\"scale\":[1,2,1,1,1,2,1,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":40,\"all_scales_index\":288},{\"key\":\"2_1_1_1_2_1_1_2_1\",\"scaleNumber\":336,\"scale\":[2,1,1,1,2,1,1,2,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":40,\"all_scales_index\":530},{\"key\":\"1_1_1_2_1_1_2_3\",\"scaleNumber\":337,\"scale\":[1,1,1,2,1,1,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":41,\"all_scales_index\":91},{\"key\":\"1_1_2_1_1_2_3_1\",\"scaleNumber\":338,\"scale\":[1,1,2,1,1,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":41,\"all_scales_index\":168},{\"key\":\"1_2_1_1_2_3_1_1\",\"scaleNumber\":339,\"scale\":[1,2,1,1,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":41,\"all_scales_index\":309},{\"key\":\"2_1_1_2_3_1_1_1\",\"scaleNumber\":340,\"scale\":[2,1,1,2,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":41,\"all_scales_index\":568},{\"key\":\"1_1_2_3_1_1_1_2\",\"scaleNumber\":341,\"scale\":[1,1,2,3,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":41,\"all_scales_index\":218},{\"key\":\"1_2_3_1_1_1_2_1\",\"scaleNumber\":342,\"scale\":[1,2,3,1,1,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":41,\"all_scales_index\":401},{\"key\":\"2_3_1_1_1_2_1_1\",\"scaleNumber\":343,\"scale\":[2,3,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":41,\"all_scales_index\":738},{\"key\":\"3_1_1_1_2_1_1_2\",\"scaleNumber\":344,\"scale\":[3,1,1,1,2,1,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":41,\"all_scales_index\":792},{\"key\":\"1_1_1_2_1_1_3_2\",\"scaleNumber\":345,\"scale\":[1,1,1,2,1,1,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":42,\"all_scales_index\":93},{\"key\":\"1_1_2_1_1_3_2_1\",\"scaleNumber\":346,\"scale\":[1,1,2,1,1,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":42,\"all_scales_index\":171},{\"key\":\"1_2_1_1_3_2_1_1\",\"scaleNumber\":347,\"scale\":[1,2,1,1,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":42,\"all_scales_index\":315},{\"key\":\"2_1_1_3_2_1_1_1\",\"scaleNumber\":348,\"scale\":[2,1,1,3,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":42,\"all_scales_index\":579},{\"key\":\"1_1_3_2_1_1_1_2\",\"scaleNumber\":349,\"scale\":[1,1,3,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":42,\"all_scales_index\":255},{\"key\":\"1_3_2_1_1_1_2_1\",\"scaleNumber\":350,\"scale\":[1,3,2,1,1,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":42,\"all_scales_index\":469},{\"key\":\"3_2_1_1_1_2_1_1\",\"scaleNumber\":351,\"scale\":[3,2,1,1,1,2,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":42,\"all_scales_index\":863},{\"key\":\"2_1_1_1_2_1_1_3\",\"scaleNumber\":352,\"scale\":[2,1,1,1,2,1,1,3],\"is_superscale\":false,\"mode\":8,\"superscale_index\":42,\"all_scales_index\":531},{\"key\":\"1_1_1_2_1_2_1_1_2\",\"scaleNumber\":353,\"scale\":[1,1,1,2,1,2,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":43,\"all_scales_index\":95},{\"key\":\"1_1_2_1_2_1_1_2_1\",\"scaleNumber\":354,\"scale\":[1,1,2,1,2,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":43,\"all_scales_index\":175},{\"key\":\"1_2_1_2_1_1_2_1_1\",\"scaleNumber\":355,\"scale\":[1,2,1,2,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":43,\"all_scales_index\":322},{\"key\":\"2_1_2_1_1_2_1_1_1\",\"scaleNumber\":356,\"scale\":[2,1,2,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":43,\"all_scales_index\":592},{\"key\":\"1_2_1_1_2_1_1_1_2\",\"scaleNumber\":357,\"scale\":[1,2,1,1,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":43,\"all_scales_index\":299},{\"key\":\"2_1_1_2_1_1_1_2_1\",\"scaleNumber\":358,\"scale\":[2,1,1,2,1,1,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":43,\"all_scales_index\":550},{\"key\":\"1_1_2_1_1_1_2_1_2\",\"scaleNumber\":359,\"scale\":[1,1,2,1,1,1,2,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":43,\"all_scales_index\":157},{\"key\":\"1_2_1_1_1_2_1_2_1\",\"scaleNumber\":360,\"scale\":[1,2,1,1,1,2,1,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":43,\"all_scales_index\":289},{\"key\":\"2_1_1_1_2_1_2_1_1\",\"scaleNumber\":361,\"scale\":[2,1,1,1,2,1,2,1,1],\"is_superscale\":false,\"mode\":9,\"superscale_index\":43,\"all_scales_index\":532},{\"key\":\"1_1_1_2_1_2_1_3\",\"scaleNumber\":362,\"scale\":[1,1,1,2,1,2,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":44,\"all_scales_index\":97},{\"key\":\"1_1_2_1_2_1_3_1\",\"scaleNumber\":363,\"scale\":[1,1,2,1,2,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":44,\"all_scales_index\":179},{\"key\":\"1_2_1_2_1_3_1_1\",\"scaleNumber\":364,\"scale\":[1,2,1,2,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":44,\"all_scales_index\":329},{\"key\":\"2_1_2_1_3_1_1_1\",\"scaleNumber\":365,\"scale\":[2,1,2,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":44,\"all_scales_index\":605},{\"key\":\"1_2_1_3_1_1_1_2\",\"scaleNumber\":366,\"scale\":[1,2,1,3,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":44,\"all_scales_index\":343},{\"key\":\"2_1_3_1_1_1_2_1\",\"scaleNumber\":367,\"scale\":[2,1,3,1,1,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":44,\"all_scales_index\":631},{\"key\":\"1_3_1_1_1_2_1_2\",\"scaleNumber\":368,\"scale\":[1,3,1,1,1,2,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":44,\"all_scales_index\":431},{\"key\":\"3_1_1_1_2_1_2_1\",\"scaleNumber\":369,\"scale\":[3,1,1,1,2,1,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":44,\"all_scales_index\":793},{\"key\":\"1_1_1_2_1_2_2_2\",\"scaleNumber\":370,\"scale\":[1,1,1,2,1,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":45,\"all_scales_index\":99},{\"key\":\"1_1_2_1_2_2_2_1\",\"scaleNumber\":371,\"scale\":[1,1,2,1,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":45,\"all_scales_index\":182},{\"key\":\"1_2_1_2_2_2_1_1\",\"scaleNumber\":372,\"scale\":[1,2,1,2,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":45,\"all_scales_index\":335},{\"key\":\"2_1_2_2_2_1_1_1\",\"scaleNumber\":373,\"scale\":[2,1,2,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":45,\"all_scales_index\":616},{\"key\":\"1_2_2_2_1_1_1_2\",\"scaleNumber\":374,\"scale\":[1,2,2,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":45,\"all_scales_index\":380},{\"key\":\"2_2_2_1_1_1_2_1\",\"scaleNumber\":375,\"scale\":[2,2,2,1,1,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":45,\"all_scales_index\":699},{\"key\":\"2_2_1_1_1_2_1_2\",\"scaleNumber\":376,\"scale\":[2,2,1,1,1,2,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":45,\"all_scales_index\":661},{\"key\":\"2_1_1_1_2_1_2_2\",\"scaleNumber\":377,\"scale\":[2,1,1,1,2,1,2,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":45,\"all_scales_index\":533},{\"key\":\"1_1_1_2_1_3_1_2\",\"scaleNumber\":378,\"scale\":[1,1,1,2,1,3,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":46,\"all_scales_index\":102},{\"key\":\"1_1_2_1_3_1_2_1\",\"scaleNumber\":379,\"scale\":[1,1,2,1,3,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":46,\"all_scales_index\":188},{\"key\":\"1_2_1_3_1_2_1_1\",\"scaleNumber\":380,\"scale\":[1,2,1,3,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":46,\"all_scales_index\":346},{\"key\":\"2_1_3_1_2_1_1_1\",\"scaleNumber\":381,\"scale\":[2,1,3,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":46,\"all_scales_index\":636},{\"key\":\"1_3_1_2_1_1_1_2\",\"scaleNumber\":382,\"scale\":[1,3,1,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":46,\"all_scales_index\":448},{\"key\":\"3_1_2_1_1_1_2_1\",\"scaleNumber\":383,\"scale\":[3,1,2,1,1,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":46,\"all_scales_index\":824},{\"key\":\"1_2_1_1_1_2_1_3\",\"scaleNumber\":384,\"scale\":[1,2,1,1,1,2,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":46,\"all_scales_index\":290},{\"key\":\"2_1_1_1_2_1_3_1\",\"scaleNumber\":385,\"scale\":[2,1,1,1,2,1,3,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":46,\"all_scales_index\":534},{\"key\":\"1_1_1_2_1_3_3\",\"scaleNumber\":386,\"scale\":[1,1,1,2,1,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":47,\"all_scales_index\":104},{\"key\":\"1_1_2_1_3_3_1\",\"scaleNumber\":387,\"scale\":[1,1,2,1,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":47,\"all_scales_index\":192},{\"key\":\"1_2_1_3_3_1_1\",\"scaleNumber\":388,\"scale\":[1,2,1,3,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":47,\"all_scales_index\":353},{\"key\":\"2_1_3_3_1_1_1\",\"scaleNumber\":389,\"scale\":[2,1,3,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":47,\"all_scales_index\":649},{\"key\":\"1_3_3_1_1_1_2\",\"scaleNumber\":390,\"scale\":[1,3,3,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":47,\"all_scales_index\":492},{\"key\":\"3_3_1_1_1_2_1\",\"scaleNumber\":391,\"scale\":[3,3,1,1,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":47,\"all_scales_index\":905},{\"key\":\"3_1_1_1_2_1_3\",\"scaleNumber\":392,\"scale\":[3,1,1,1,2,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":47,\"all_scales_index\":794},{\"key\":\"1_1_1_2_2_1_1_3\",\"scaleNumber\":393,\"scale\":[1,1,1,2,2,1,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":48,\"all_scales_index\":108},{\"key\":\"1_1_2_2_1_1_3_1\",\"scaleNumber\":394,\"scale\":[1,1,2,2,1,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":48,\"all_scales_index\":199},{\"key\":\"1_2_2_1_1_3_1_1\",\"scaleNumber\":395,\"scale\":[1,2,2,1,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":48,\"all_scales_index\":366},{\"key\":\"2_2_1_1_3_1_1_1\",\"scaleNumber\":396,\"scale\":[2,2,1,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":48,\"all_scales_index\":673},{\"key\":\"2_1_1_3_1_1_1_2\",\"scaleNumber\":397,\"scale\":[2,1,1,3,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":48,\"all_scales_index\":573},{\"key\":\"1_1_3_1_1_1_2_2\",\"scaleNumber\":398,\"scale\":[1,1,3,1,1,1,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":48,\"all_scales_index\":235},{\"key\":\"1_3_1_1_1_2_2_1\",\"scaleNumber\":399,\"scale\":[1,3,1,1,1,2,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":48,\"all_scales_index\":432},{\"key\":\"3_1_1_1_2_2_1_1\",\"scaleNumber\":400,\"scale\":[3,1,1,1,2,2,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":48,\"all_scales_index\":795},{\"key\":\"1_1_1_2_2_1_2_2\",\"scaleNumber\":401,\"scale\":[1,1,1,2,2,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":49,\"all_scales_index\":110},{\"key\":\"1_1_2_2_1_2_2_1\",\"scaleNumber\":402,\"scale\":[1,1,2,2,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":49,\"all_scales_index\":202},{\"key\":\"1_2_2_1_2_2_1_1\",\"scaleNumber\":403,\"scale\":[1,2,2,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":49,\"all_scales_index\":372},{\"key\":\"2_2_1_2_2_1_1_1\",\"scaleNumber\":404,\"scale\":[2,2,1,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":49,\"all_scales_index\":684},{\"key\":\"2_1_2_2_1_1_1_2\",\"scaleNumber\":405,\"scale\":[2,1,2,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":49,\"all_scales_index\":610},{\"key\":\"1_2_2_1_1_1_2_2\",\"scaleNumber\":406,\"scale\":[1,2,2,1,1,1,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":49,\"all_scales_index\":360},{\"key\":\"2_2_1_1_1_2_2_1\",\"scaleNumber\":407,\"scale\":[2,2,1,1,1,2,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":49,\"all_scales_index\":662},{\"key\":\"2_1_1_1_2_2_1_2\",\"scaleNumber\":408,\"scale\":[2,1,1,1,2,2,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":49,\"all_scales_index\":536},{\"key\":\"1_1_1_2_2_2_1_2\",\"scaleNumber\":409,\"scale\":[1,1,1,2,2,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":50,\"all_scales_index\":113},{\"key\":\"1_1_2_2_2_1_2_1\",\"scaleNumber\":410,\"scale\":[1,1,2,2,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":50,\"all_scales_index\":208},{\"key\":\"1_2_2_2_1_2_1_1\",\"scaleNumber\":411,\"scale\":[1,2,2,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":50,\"all_scales_index\":383},{\"key\":\"2_2_2_1_2_1_1_1\",\"scaleNumber\":412,\"scale\":[2,2,2,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":50,\"all_scales_index\":704},{\"key\":\"2_2_1_2_1_1_1_2\",\"scaleNumber\":413,\"scale\":[2,2,1,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":50,\"all_scales_index\":678},{\"key\":\"2_1_2_1_1_1_2_2\",\"scaleNumber\":414,\"scale\":[2,1,2,1,1,1,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":50,\"all_scales_index\":590},{\"key\":\"1_2_1_1_1_2_2_2\",\"scaleNumber\":415,\"scale\":[1,2,1,1,1,2,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":50,\"all_scales_index\":292},{\"key\":\"2_1_1_1_2_2_2_1\",\"scaleNumber\":416,\"scale\":[2,1,1,1,2,2,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":50,\"all_scales_index\":537},{\"key\":\"1_1_1_2_2_2_3\",\"scaleNumber\":417,\"scale\":[1,1,1,2,2,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":51,\"all_scales_index\":115},{\"key\":\"1_1_2_2_2_3_1\",\"scaleNumber\":418,\"scale\":[1,1,2,2,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":51,\"all_scales_index\":212},{\"key\":\"1_2_2_2_3_1_1\",\"scaleNumber\":419,\"scale\":[1,2,2,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":51,\"all_scales_index\":390},{\"key\":\"2_2_2_3_1_1_1\",\"scaleNumber\":420,\"scale\":[2,2,2,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":51,\"all_scales_index\":717},{\"key\":\"2_2_3_1_1_1_2\",\"scaleNumber\":421,\"scale\":[2,2,3,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":51,\"all_scales_index\":722},{\"key\":\"2_3_1_1_1_2_2\",\"scaleNumber\":422,\"scale\":[2,3,1,1,1,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":51,\"all_scales_index\":739},{\"key\":\"3_1_1_1_2_2_2\",\"scaleNumber\":423,\"scale\":[3,1,1,1,2,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":51,\"all_scales_index\":796},{\"key\":\"1_1_1_2_2_3_2\",\"scaleNumber\":424,\"scale\":[1,1,1,2,2,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":52,\"all_scales_index\":117},{\"key\":\"1_1_2_2_3_2_1\",\"scaleNumber\":425,\"scale\":[1,1,2,2,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":52,\"all_scales_index\":215},{\"key\":\"1_2_2_3_2_1_1\",\"scaleNumber\":426,\"scale\":[1,2,2,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":52,\"all_scales_index\":396},{\"key\":\"2_2_3_2_1_1_1\",\"scaleNumber\":427,\"scale\":[2,2,3,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":52,\"all_scales_index\":728},{\"key\":\"2_3_2_1_1_1_2\",\"scaleNumber\":428,\"scale\":[2,3,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":52,\"all_scales_index\":759},{\"key\":\"3_2_1_1_1_2_2\",\"scaleNumber\":429,\"scale\":[3,2,1,1,1,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":52,\"all_scales_index\":864},{\"key\":\"2_1_1_1_2_2_3\",\"scaleNumber\":430,\"scale\":[2,1,1,1,2,2,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":52,\"all_scales_index\":538},{\"key\":\"1_1_1_2_3_1_1_2\",\"scaleNumber\":431,\"scale\":[1,1,1,2,3,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":53,\"all_scales_index\":119},{\"key\":\"1_1_2_3_1_1_2_1\",\"scaleNumber\":432,\"scale\":[1,1,2,3,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":53,\"all_scales_index\":219},{\"key\":\"1_2_3_1_1_2_1_1\",\"scaleNumber\":433,\"scale\":[1,2,3,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":53,\"all_scales_index\":403},{\"key\":\"2_3_1_1_2_1_1_1\",\"scaleNumber\":434,\"scale\":[2,3,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":53,\"all_scales_index\":741},{\"key\":\"3_1_1_2_1_1_1_2\",\"scaleNumber\":435,\"scale\":[3,1,1,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":53,\"all_scales_index\":803},{\"key\":\"1_1_2_1_1_1_2_3\",\"scaleNumber\":436,\"scale\":[1,1,2,1,1,1,2,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":53,\"all_scales_index\":159},{\"key\":\"1_2_1_1_1_2_3_1\",\"scaleNumber\":437,\"scale\":[1,2,1,1,1,2,3,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":53,\"all_scales_index\":293},{\"key\":\"2_1_1_1_2_3_1_1\",\"scaleNumber\":438,\"scale\":[2,1,1,1,2,3,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":53,\"all_scales_index\":539},{\"key\":\"1_1_1_2_3_1_3\",\"scaleNumber\":439,\"scale\":[1,1,1,2,3,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":54,\"all_scales_index\":121},{\"key\":\"1_1_2_3_1_3_1\",\"scaleNumber\":440,\"scale\":[1,1,2,3,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":54,\"all_scales_index\":223},{\"key\":\"1_2_3_1_3_1_1\",\"scaleNumber\":441,\"scale\":[1,2,3,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":54,\"all_scales_index\":410},{\"key\":\"2_3_1_3_1_1_1\",\"scaleNumber\":442,\"scale\":[2,3,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":54,\"all_scales_index\":754},{\"key\":\"3_1_3_1_1_1_2\",\"scaleNumber\":443,\"scale\":[3,1,3,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":54,\"all_scales_index\":847},{\"key\":\"1_3_1_1_1_2_3\",\"scaleNumber\":444,\"scale\":[1,3,1,1,1,2,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":54,\"all_scales_index\":433},{\"key\":\"3_1_1_1_2_3_1\",\"scaleNumber\":445,\"scale\":[3,1,1,1,2,3,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":54,\"all_scales_index\":797},{\"key\":\"1_1_1_2_3_2_2\",\"scaleNumber\":446,\"scale\":[1,1,1,2,3,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":55,\"all_scales_index\":123},{\"key\":\"1_1_2_3_2_2_1\",\"scaleNumber\":447,\"scale\":[1,1,2,3,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":55,\"all_scales_index\":226},{\"key\":\"1_2_3_2_2_1_1\",\"scaleNumber\":448,\"scale\":[1,2,3,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":55,\"all_scales_index\":416},{\"key\":\"2_3_2_2_1_1_1\",\"scaleNumber\":449,\"scale\":[2,3,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":55,\"all_scales_index\":765},{\"key\":\"3_2_2_1_1_1_2\",\"scaleNumber\":450,\"scale\":[3,2,2,1,1,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":55,\"all_scales_index\":884},{\"key\":\"2_2_1_1_1_2_3\",\"scaleNumber\":451,\"scale\":[2,2,1,1,1,2,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":55,\"all_scales_index\":663},{\"key\":\"2_1_1_1_2_3_2\",\"scaleNumber\":452,\"scale\":[2,1,1,1,2,3,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":55,\"all_scales_index\":540},{\"key\":\"1_1_1_3_1_1_1_3\",\"scaleNumber\":453,\"scale\":[1,1,1,3,1,1,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":56,\"all_scales_index\":128},{\"key\":\"1_1_3_1_1_1_3_1\",\"scaleNumber\":454,\"scale\":[1,1,3,1,1,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":56,\"all_scales_index\":236},{\"key\":\"1_3_1_1_1_3_1_1\",\"scaleNumber\":455,\"scale\":[1,3,1,1,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":56,\"all_scales_index\":434},{\"key\":\"3_1_1_1_3_1_1_1\",\"scaleNumber\":456,\"scale\":[3,1,1,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":56,\"all_scales_index\":798},{\"key\":\"1_1_1_3_1_1_2_2\",\"scaleNumber\":457,\"scale\":[1,1,1,3,1,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":57,\"all_scales_index\":130},{\"key\":\"1_1_3_1_1_2_2_1\",\"scaleNumber\":458,\"scale\":[1,1,3,1,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":57,\"all_scales_index\":239},{\"key\":\"1_3_1_1_2_2_1_1\",\"scaleNumber\":459,\"scale\":[1,3,1,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":57,\"all_scales_index\":440},{\"key\":\"3_1_1_2_2_1_1_1\",\"scaleNumber\":460,\"scale\":[3,1,1,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":57,\"all_scales_index\":809},{\"key\":\"1_1_2_2_1_1_1_3\",\"scaleNumber\":461,\"scale\":[1,1,2,2,1,1,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":57,\"all_scales_index\":196},{\"key\":\"1_2_2_1_1_1_3_1\",\"scaleNumber\":462,\"scale\":[1,2,2,1,1,1,3,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":57,\"all_scales_index\":361},{\"key\":\"2_2_1_1_1_3_1_1\",\"scaleNumber\":463,\"scale\":[2,2,1,1,1,3,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":57,\"all_scales_index\":664},{\"key\":\"2_1_1_1_3_1_1_2\",\"scaleNumber\":464,\"scale\":[2,1,1,1,3,1,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":57,\"all_scales_index\":542},{\"key\":\"1_1_1_3_1_2_1_2\",\"scaleNumber\":465,\"scale\":[1,1,1,3,1,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":58,\"all_scales_index\":133},{\"key\":\"1_1_3_1_2_1_2_1\",\"scaleNumber\":466,\"scale\":[1,1,3,1,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":58,\"all_scales_index\":245},{\"key\":\"1_3_1_2_1_2_1_1\",\"scaleNumber\":467,\"scale\":[1,3,1,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":58,\"all_scales_index\":451},{\"key\":\"3_1_2_1_2_1_1_1\",\"scaleNumber\":468,\"scale\":[3,1,2,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":58,\"all_scales_index\":829},{\"key\":\"1_2_1_2_1_1_1_3\",\"scaleNumber\":469,\"scale\":[1,2,1,2,1,1,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":58,\"all_scales_index\":321},{\"key\":\"2_1_2_1_1_1_3_1\",\"scaleNumber\":470,\"scale\":[2,1,2,1,1,1,3,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":58,\"all_scales_index\":591},{\"key\":\"1_2_1_1_1_3_1_2\",\"scaleNumber\":471,\"scale\":[1,2,1,1,1,3,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":58,\"all_scales_index\":295},{\"key\":\"2_1_1_1_3_1_2_1\",\"scaleNumber\":472,\"scale\":[2,1,1,1,3,1,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":58,\"all_scales_index\":543},{\"key\":\"1_1_1_3_1_2_3\",\"scaleNumber\":473,\"scale\":[1,1,1,3,1,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":59,\"all_scales_index\":135},{\"key\":\"1_1_3_1_2_3_1\",\"scaleNumber\":474,\"scale\":[1,1,3,1,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":59,\"all_scales_index\":249},{\"key\":\"1_3_1_2_3_1_1\",\"scaleNumber\":475,\"scale\":[1,3,1,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":59,\"all_scales_index\":458},{\"key\":\"3_1_2_3_1_1_1\",\"scaleNumber\":476,\"scale\":[3,1,2,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":59,\"all_scales_index\":842},{\"key\":\"1_2_3_1_1_1_3\",\"scaleNumber\":477,\"scale\":[1,2,3,1,1,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":59,\"all_scales_index\":402},{\"key\":\"2_3_1_1_1_3_1\",\"scaleNumber\":478,\"scale\":[2,3,1,1,1,3,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":59,\"all_scales_index\":740},{\"key\":\"3_1_1_1_3_1_2\",\"scaleNumber\":479,\"scale\":[3,1,1,1,3,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":59,\"all_scales_index\":799},{\"key\":\"1_1_1_3_1_3_2\",\"scaleNumber\":480,\"scale\":[1,1,1,3,1,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":60,\"all_scales_index\":137},{\"key\":\"1_1_3_1_3_2_1\",\"scaleNumber\":481,\"scale\":[1,1,3,1,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":60,\"all_scales_index\":252},{\"key\":\"1_3_1_3_2_1_1\",\"scaleNumber\":482,\"scale\":[1,3,1,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":60,\"all_scales_index\":464},{\"key\":\"3_1_3_2_1_1_1\",\"scaleNumber\":483,\"scale\":[3,1,3,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":60,\"all_scales_index\":853},{\"key\":\"1_3_2_1_1_1_3\",\"scaleNumber\":484,\"scale\":[1,3,2,1,1,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":60,\"all_scales_index\":470},{\"key\":\"3_2_1_1_1_3_1\",\"scaleNumber\":485,\"scale\":[3,2,1,1,1,3,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":60,\"all_scales_index\":865},{\"key\":\"2_1_1_1_3_1_3\",\"scaleNumber\":486,\"scale\":[2,1,1,1,3,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":60,\"all_scales_index\":544},{\"key\":\"1_1_1_3_2_1_1_2\",\"scaleNumber\":487,\"scale\":[1,1,1,3,2,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":61,\"all_scales_index\":139},{\"key\":\"1_1_3_2_1_1_2_1\",\"scaleNumber\":488,\"scale\":[1,1,3,2,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":61,\"all_scales_index\":256},{\"key\":\"1_3_2_1_1_2_1_1\",\"scaleNumber\":489,\"scale\":[1,3,2,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":61,\"all_scales_index\":471},{\"key\":\"3_2_1_1_2_1_1_1\",\"scaleNumber\":490,\"scale\":[3,2,1,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":61,\"all_scales_index\":866},{\"key\":\"2_1_1_2_1_1_1_3\",\"scaleNumber\":491,\"scale\":[2,1,1,2,1,1,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":61,\"all_scales_index\":551},{\"key\":\"1_1_2_1_1_1_3_2\",\"scaleNumber\":492,\"scale\":[1,1,2,1,1,1,3,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":61,\"all_scales_index\":161},{\"key\":\"1_2_1_1_1_3_2_1\",\"scaleNumber\":493,\"scale\":[1,2,1,1,1,3,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":61,\"all_scales_index\":296},{\"key\":\"2_1_1_1_3_2_1_1\",\"scaleNumber\":494,\"scale\":[2,1,1,1,3,2,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":61,\"all_scales_index\":545},{\"key\":\"1_1_1_3_2_1_3\",\"scaleNumber\":495,\"scale\":[1,1,1,3,2,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":62,\"all_scales_index\":141},{\"key\":\"1_1_3_2_1_3_1\",\"scaleNumber\":496,\"scale\":[1,1,3,2,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":62,\"all_scales_index\":260},{\"key\":\"1_3_2_1_3_1_1\",\"scaleNumber\":497,\"scale\":[1,3,2,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":62,\"all_scales_index\":478},{\"key\":\"3_2_1_3_1_1_1\",\"scaleNumber\":498,\"scale\":[3,2,1,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":62,\"all_scales_index\":879},{\"key\":\"2_1_3_1_1_1_3\",\"scaleNumber\":499,\"scale\":[2,1,3,1,1,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":62,\"all_scales_index\":632},{\"key\":\"1_3_1_1_1_3_2\",\"scaleNumber\":500,\"scale\":[1,3,1,1,1,3,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":62,\"all_scales_index\":435},{\"key\":\"3_1_1_1_3_2_1\",\"scaleNumber\":501,\"scale\":[3,1,1,1,3,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":62,\"all_scales_index\":800},{\"key\":\"1_1_1_3_2_2_2\",\"scaleNumber\":502,\"scale\":[1,1,1,3,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":63,\"all_scales_index\":143},{\"key\":\"1_1_3_2_2_2_1\",\"scaleNumber\":503,\"scale\":[1,1,3,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":63,\"all_scales_index\":263},{\"key\":\"1_3_2_2_2_1_1\",\"scaleNumber\":504,\"scale\":[1,3,2,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":63,\"all_scales_index\":484},{\"key\":\"3_2_2_2_1_1_1\",\"scaleNumber\":505,\"scale\":[3,2,2,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":63,\"all_scales_index\":890},{\"key\":\"2_2_2_1_1_1_3\",\"scaleNumber\":506,\"scale\":[2,2,2,1,1,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":63,\"all_scales_index\":700},{\"key\":\"2_2_1_1_1_3_2\",\"scaleNumber\":507,\"scale\":[2,2,1,1,1,3,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":63,\"all_scales_index\":665},{\"key\":\"2_1_1_1_3_2_2\",\"scaleNumber\":508,\"scale\":[2,1,1,1,3,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":63,\"all_scales_index\":546},{\"key\":\"1_1_1_3_3_1_2\",\"scaleNumber\":509,\"scale\":[1,1,1,3,3,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":64,\"all_scales_index\":146},{\"key\":\"1_1_3_3_1_2_1\",\"scaleNumber\":510,\"scale\":[1,1,3,3,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":64,\"all_scales_index\":269},{\"key\":\"1_3_3_1_2_1_1\",\"scaleNumber\":511,\"scale\":[1,3,3,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":64,\"all_scales_index\":495},{\"key\":\"3_3_1_2_1_1_1\",\"scaleNumber\":512,\"scale\":[3,3,1,2,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":64,\"all_scales_index\":910},{\"key\":\"3_1_2_1_1_1_3\",\"scaleNumber\":513,\"scale\":[3,1,2,1,1,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":64,\"all_scales_index\":825},{\"key\":\"1_2_1_1_1_3_3\",\"scaleNumber\":514,\"scale\":[1,2,1,1,1,3,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":64,\"all_scales_index\":297},{\"key\":\"2_1_1_1_3_3_1\",\"scaleNumber\":515,\"scale\":[2,1,1,1,3,3,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":64,\"all_scales_index\":547},{\"key\":\"1_1_1_3_3_3\",\"scaleNumber\":516,\"scale\":[1,1,1,3,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":65,\"all_scales_index\":148},{\"key\":\"1_1_3_3_3_1\",\"scaleNumber\":517,\"scale\":[1,1,3,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":65,\"all_scales_index\":273},{\"key\":\"1_3_3_3_1_1\",\"scaleNumber\":518,\"scale\":[1,3,3,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":65,\"all_scales_index\":502},{\"key\":\"3_3_3_1_1_1\",\"scaleNumber\":519,\"scale\":[3,3,3,1,1,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":65,\"all_scales_index\":923},{\"key\":\"3_3_1_1_1_3\",\"scaleNumber\":520,\"scale\":[3,3,1,1,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":65,\"all_scales_index\":906},{\"key\":\"3_1_1_1_3_3\",\"scaleNumber\":521,\"scale\":[3,1,1,1,3,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":65,\"all_scales_index\":801},{\"key\":\"1_1_2_1_1_2_1_1_2\",\"scaleNumber\":522,\"scale\":[1,1,2,1,1,2,1,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":66,\"all_scales_index\":163},{\"key\":\"1_2_1_1_2_1_1_2_1\",\"scaleNumber\":523,\"scale\":[1,2,1,1,2,1,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":66,\"all_scales_index\":300},{\"key\":\"2_1_1_2_1_1_2_1_1\",\"scaleNumber\":524,\"scale\":[2,1,1,2,1,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":66,\"all_scales_index\":552},{\"key\":\"1_1_2_1_1_2_1_3\",\"scaleNumber\":525,\"scale\":[1,1,2,1,1,2,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":67,\"all_scales_index\":165},{\"key\":\"1_2_1_1_2_1_3_1\",\"scaleNumber\":526,\"scale\":[1,2,1,1,2,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":67,\"all_scales_index\":304},{\"key\":\"2_1_1_2_1_3_1_1\",\"scaleNumber\":527,\"scale\":[2,1,1,2,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":67,\"all_scales_index\":559},{\"key\":\"1_1_2_1_3_1_1_2\",\"scaleNumber\":528,\"scale\":[1,1,2,1,3,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":67,\"all_scales_index\":187},{\"key\":\"1_2_1_3_1_1_2_1\",\"scaleNumber\":529,\"scale\":[1,2,1,3,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":67,\"all_scales_index\":344},{\"key\":\"2_1_3_1_1_2_1_1\",\"scaleNumber\":530,\"scale\":[2,1,3,1,1,2,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":67,\"all_scales_index\":633},{\"key\":\"1_3_1_1_2_1_1_2\",\"scaleNumber\":531,\"scale\":[1,3,1,1,2,1,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":67,\"all_scales_index\":437},{\"key\":\"3_1_1_2_1_1_2_1\",\"scaleNumber\":532,\"scale\":[3,1,1,2,1,1,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":67,\"all_scales_index\":804},{\"key\":\"1_1_2_1_1_2_2_2\",\"scaleNumber\":533,\"scale\":[1,1,2,1,1,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":68,\"all_scales_index\":167},{\"key\":\"1_2_1_1_2_2_2_1\",\"scaleNumber\":534,\"scale\":[1,2,1,1,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":68,\"all_scales_index\":307},{\"key\":\"2_1_1_2_2_2_1_1\",\"scaleNumber\":535,\"scale\":[2,1,1,2,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":68,\"all_scales_index\":565},{\"key\":\"1_1_2_2_2_1_1_2\",\"scaleNumber\":536,\"scale\":[1,1,2,2,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":68,\"all_scales_index\":207},{\"key\":\"1_2_2_2_1_1_2_1\",\"scaleNumber\":537,\"scale\":[1,2,2,2,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":68,\"all_scales_index\":381},{\"key\":\"2_2_2_1_1_2_1_1\",\"scaleNumber\":538,\"scale\":[2,2,2,1,1,2,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":68,\"all_scales_index\":701},{\"key\":\"2_2_1_1_2_1_1_2\",\"scaleNumber\":539,\"scale\":[2,2,1,1,2,1,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":68,\"all_scales_index\":667},{\"key\":\"2_1_1_2_1_1_2_2\",\"scaleNumber\":540,\"scale\":[2,1,1,2,1,1,2,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":68,\"all_scales_index\":553},{\"key\":\"1_1_2_1_1_3_1_2\",\"scaleNumber\":541,\"scale\":[1,1,2,1,1,3,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":69,\"all_scales_index\":170},{\"key\":\"1_2_1_1_3_1_2_1\",\"scaleNumber\":542,\"scale\":[1,2,1,1,3,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":69,\"all_scales_index\":313},{\"key\":\"2_1_1_3_1_2_1_1\",\"scaleNumber\":543,\"scale\":[2,1,1,3,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":69,\"all_scales_index\":576},{\"key\":\"1_1_3_1_2_1_1_2\",\"scaleNumber\":544,\"scale\":[1,1,3,1,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":69,\"all_scales_index\":244},{\"key\":\"1_3_1_2_1_1_2_1\",\"scaleNumber\":545,\"scale\":[1,3,1,2,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":69,\"all_scales_index\":449},{\"key\":\"3_1_2_1_1_2_1_1\",\"scaleNumber\":546,\"scale\":[3,1,2,1,1,2,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":69,\"all_scales_index\":826},{\"key\":\"1_2_1_1_2_1_1_3\",\"scaleNumber\":547,\"scale\":[1,2,1,1,2,1,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":69,\"all_scales_index\":301},{\"key\":\"2_1_1_2_1_1_3_1\",\"scaleNumber\":548,\"scale\":[2,1,1,2,1,1,3,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":69,\"all_scales_index\":554},{\"key\":\"1_1_2_1_1_3_3\",\"scaleNumber\":549,\"scale\":[1,1,2,1,1,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":70,\"all_scales_index\":172},{\"key\":\"1_2_1_1_3_3_1\",\"scaleNumber\":550,\"scale\":[1,2,1,1,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":70,\"all_scales_index\":317},{\"key\":\"2_1_1_3_3_1_1\",\"scaleNumber\":551,\"scale\":[2,1,1,3,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":70,\"all_scales_index\":583},{\"key\":\"1_1_3_3_1_1_2\",\"scaleNumber\":552,\"scale\":[1,1,3,3,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":70,\"all_scales_index\":268},{\"key\":\"1_3_3_1_1_2_1\",\"scaleNumber\":553,\"scale\":[1,3,3,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":70,\"all_scales_index\":493},{\"key\":\"3_3_1_1_2_1_1\",\"scaleNumber\":554,\"scale\":[3,3,1,1,2,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":70,\"all_scales_index\":907},{\"key\":\"3_1_1_2_1_1_3\",\"scaleNumber\":555,\"scale\":[3,1,1,2,1,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":70,\"all_scales_index\":805},{\"key\":\"1_1_2_1_2_1_1_3\",\"scaleNumber\":556,\"scale\":[1,1,2,1,2,1,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":71,\"all_scales_index\":176},{\"key\":\"1_2_1_2_1_1_3_1\",\"scaleNumber\":557,\"scale\":[1,2,1,2,1,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":71,\"all_scales_index\":324},{\"key\":\"2_1_2_1_1_3_1_1\",\"scaleNumber\":558,\"scale\":[2,1,2,1,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":71,\"all_scales_index\":596},{\"key\":\"1_2_1_1_3_1_1_2\",\"scaleNumber\":559,\"scale\":[1,2,1,1,3,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":71,\"all_scales_index\":312},{\"key\":\"2_1_1_3_1_1_2_1\",\"scaleNumber\":560,\"scale\":[2,1,1,3,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":71,\"all_scales_index\":574},{\"key\":\"1_1_3_1_1_2_1_2\",\"scaleNumber\":561,\"scale\":[1,1,3,1,1,2,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":71,\"all_scales_index\":238},{\"key\":\"1_3_1_1_2_1_2_1\",\"scaleNumber\":562,\"scale\":[1,3,1,1,2,1,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":71,\"all_scales_index\":438},{\"key\":\"3_1_1_2_1_2_1_1\",\"scaleNumber\":563,\"scale\":[3,1,1,2,1,2,1,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":71,\"all_scales_index\":806},{\"key\":\"1_1_2_1_2_1_2_2\",\"scaleNumber\":564,\"scale\":[1,1,2,1,2,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":72,\"all_scales_index\":178},{\"key\":\"1_2_1_2_1_2_2_1\",\"scaleNumber\":565,\"scale\":[1,2,1,2,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":72,\"all_scales_index\":327},{\"key\":\"2_1_2_1_2_2_1_1\",\"scaleNumber\":566,\"scale\":[2,1,2,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":72,\"all_scales_index\":602},{\"key\":\"1_2_1_2_2_1_1_2\",\"scaleNumber\":567,\"scale\":[1,2,1,2,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":72,\"all_scales_index\":332},{\"key\":\"2_1_2_2_1_1_2_1\",\"scaleNumber\":568,\"scale\":[2,1,2,2,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":72,\"all_scales_index\":611},{\"key\":\"1_2_2_1_1_2_1_2\",\"scaleNumber\":569,\"scale\":[1,2,2,1,1,2,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":72,\"all_scales_index\":363},{\"key\":\"2_2_1_1_2_1_2_1\",\"scaleNumber\":570,\"scale\":[2,2,1,1,2,1,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":72,\"all_scales_index\":668},{\"key\":\"2_1_1_2_1_2_1_2\",\"scaleNumber\":571,\"scale\":[2,1,1,2,1,2,1,2],\"is_superscale\":false,\"mode\":8,\"superscale_index\":72,\"all_scales_index\":556},{\"key\":\"1_1_2_1_2_2_1_2\",\"scaleNumber\":572,\"scale\":[1,1,2,1,2,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":73,\"all_scales_index\":181},{\"key\":\"1_2_1_2_2_1_2_1\",\"scaleNumber\":573,\"scale\":[1,2,1,2,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":73,\"all_scales_index\":333},{\"key\":\"2_1_2_2_1_2_1_1\",\"scaleNumber\":574,\"scale\":[2,1,2,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":73,\"all_scales_index\":613},{\"key\":\"1_2_2_1_2_1_1_2\",\"scaleNumber\":575,\"scale\":[1,2,2,1,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":73,\"all_scales_index\":369},{\"key\":\"2_2_1_2_1_1_2_1\",\"scaleNumber\":576,\"scale\":[2,2,1,2,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":73,\"all_scales_index\":679},{\"key\":\"2_1_2_1_1_2_1_2\",\"scaleNumber\":577,\"scale\":[2,1,2,1,1,2,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":73,\"all_scales_index\":593},{\"key\":\"1_2_1_1_2_1_2_2\",\"scaleNumber\":578,\"scale\":[1,2,1,1,2,1,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":73,\"all_scales_index\":303},{\"key\":\"2_1_1_2_1_2_2_1\",\"scaleNumber\":579,\"scale\":[2,1,1,2,1,2,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":73,\"all_scales_index\":557},{\"key\":\"1_1_2_1_2_2_3\",\"scaleNumber\":580,\"scale\":[1,1,2,1,2,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":74,\"all_scales_index\":183},{\"key\":\"1_2_1_2_2_3_1\",\"scaleNumber\":581,\"scale\":[1,2,1,2,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":74,\"all_scales_index\":337},{\"key\":\"2_1_2_2_3_1_1\",\"scaleNumber\":582,\"scale\":[2,1,2,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":74,\"all_scales_index\":620},{\"key\":\"1_2_2_3_1_1_2\",\"scaleNumber\":583,\"scale\":[1,2,2,3,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":74,\"all_scales_index\":393},{\"key\":\"2_2_3_1_1_2_1\",\"scaleNumber\":584,\"scale\":[2,2,3,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":74,\"all_scales_index\":723},{\"key\":\"2_3_1_1_2_1_2\",\"scaleNumber\":585,\"scale\":[2,3,1,1,2,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":74,\"all_scales_index\":742},{\"key\":\"3_1_1_2_1_2_2\",\"scaleNumber\":586,\"scale\":[3,1,1,2,1,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":74,\"all_scales_index\":807},{\"key\":\"1_1_2_1_2_3_2\",\"scaleNumber\":587,\"scale\":[1,1,2,1,2,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":75,\"all_scales_index\":185},{\"key\":\"1_2_1_2_3_2_1\",\"scaleNumber\":588,\"scale\":[1,2,1,2,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":75,\"all_scales_index\":340},{\"key\":\"2_1_2_3_2_1_1\",\"scaleNumber\":589,\"scale\":[2,1,2,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":75,\"all_scales_index\":626},{\"key\":\"1_2_3_2_1_1_2\",\"scaleNumber\":590,\"scale\":[1,2,3,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":75,\"all_scales_index\":413},{\"key\":\"2_3_2_1_1_2_1\",\"scaleNumber\":591,\"scale\":[2,3,2,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":75,\"all_scales_index\":760},{\"key\":\"3_2_1_1_2_1_2\",\"scaleNumber\":592,\"scale\":[3,2,1,1,2,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":75,\"all_scales_index\":867},{\"key\":\"2_1_1_2_1_2_3\",\"scaleNumber\":593,\"scale\":[2,1,1,2,1,2,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":75,\"all_scales_index\":558},{\"key\":\"1_1_2_1_3_1_3\",\"scaleNumber\":594,\"scale\":[1,1,2,1,3,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":76,\"all_scales_index\":189},{\"key\":\"1_2_1_3_1_3_1\",\"scaleNumber\":595,\"scale\":[1,2,1,3,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":76,\"all_scales_index\":348},{\"key\":\"2_1_3_1_3_1_1\",\"scaleNumber\":596,\"scale\":[2,1,3,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":76,\"all_scales_index\":640},{\"key\":\"1_3_1_3_1_1_2\",\"scaleNumber\":597,\"scale\":[1,3,1,3,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":76,\"all_scales_index\":461},{\"key\":\"3_1_3_1_1_2_1\",\"scaleNumber\":598,\"scale\":[3,1,3,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":76,\"all_scales_index\":848},{\"key\":\"1_3_1_1_2_1_3\",\"scaleNumber\":599,\"scale\":[1,3,1,1,2,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":76,\"all_scales_index\":439},{\"key\":\"3_1_1_2_1_3_1\",\"scaleNumber\":600,\"scale\":[3,1,1,2,1,3,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":76,\"all_scales_index\":808},{\"key\":\"1_1_2_1_3_2_2\",\"scaleNumber\":601,\"scale\":[1,1,2,1,3,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":77,\"all_scales_index\":191},{\"key\":\"1_2_1_3_2_2_1\",\"scaleNumber\":602,\"scale\":[1,2,1,3,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":77,\"all_scales_index\":351},{\"key\":\"2_1_3_2_2_1_1\",\"scaleNumber\":603,\"scale\":[2,1,3,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":77,\"all_scales_index\":646},{\"key\":\"1_3_2_2_1_1_2\",\"scaleNumber\":604,\"scale\":[1,3,2,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":77,\"all_scales_index\":481},{\"key\":\"3_2_2_1_1_2_1\",\"scaleNumber\":605,\"scale\":[3,2,2,1,1,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":77,\"all_scales_index\":885},{\"key\":\"2_2_1_1_2_1_3\",\"scaleNumber\":606,\"scale\":[2,2,1,1,2,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":77,\"all_scales_index\":669},{\"key\":\"2_1_1_2_1_3_2\",\"scaleNumber\":607,\"scale\":[2,1,1,2,1,3,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":77,\"all_scales_index\":560},{\"key\":\"1_1_2_2_1_1_2_2\",\"scaleNumber\":608,\"scale\":[1,1,2,2,1,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":78,\"all_scales_index\":198},{\"key\":\"1_2_2_1_1_2_2_1\",\"scaleNumber\":609,\"scale\":[1,2,2,1,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":78,\"all_scales_index\":364},{\"key\":\"2_2_1_1_2_2_1_1\",\"scaleNumber\":610,\"scale\":[2,2,1,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":78,\"all_scales_index\":670},{\"key\":\"2_1_1_2_2_1_1_2\",\"scaleNumber\":611,\"scale\":[2,1,1,2,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":78,\"all_scales_index\":562},{\"key\":\"1_1_2_2_1_2_1_2\",\"scaleNumber\":612,\"scale\":[1,1,2,2,1,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":79,\"all_scales_index\":201},{\"key\":\"1_2_2_1_2_1_2_1\",\"scaleNumber\":613,\"scale\":[1,2,2,1,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":79,\"all_scales_index\":370},{\"key\":\"2_2_1_2_1_2_1_1\",\"scaleNumber\":614,\"scale\":[2,2,1,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":79,\"all_scales_index\":681},{\"key\":\"2_1_2_1_2_1_1_2\",\"scaleNumber\":615,\"scale\":[2,1,2,1,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":79,\"all_scales_index\":599},{\"key\":\"1_2_1_2_1_1_2_2\",\"scaleNumber\":616,\"scale\":[1,2,1,2,1,1,2,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":79,\"all_scales_index\":323},{\"key\":\"2_1_2_1_1_2_2_1\",\"scaleNumber\":617,\"scale\":[2,1,2,1,1,2,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":79,\"all_scales_index\":594},{\"key\":\"1_2_1_1_2_2_1_2\",\"scaleNumber\":618,\"scale\":[1,2,1,1,2,2,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":79,\"all_scales_index\":306},{\"key\":\"2_1_1_2_2_1_2_1\",\"scaleNumber\":619,\"scale\":[2,1,1,2,2,1,2,1],\"is_superscale\":false,\"mode\":8,\"superscale_index\":79,\"all_scales_index\":563},{\"key\":\"1_1_2_2_1_2_3\",\"scaleNumber\":620,\"scale\":[1,1,2,2,1,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":80,\"all_scales_index\":203},{\"key\":\"1_2_2_1_2_3_1\",\"scaleNumber\":621,\"scale\":[1,2,2,1,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":80,\"all_scales_index\":374},{\"key\":\"2_2_1_2_3_1_1\",\"scaleNumber\":622,\"scale\":[2,2,1,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":80,\"all_scales_index\":688},{\"key\":\"2_1_2_3_1_1_2\",\"scaleNumber\":623,\"scale\":[2,1,2,3,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":80,\"all_scales_index\":623},{\"key\":\"1_2_3_1_1_2_2\",\"scaleNumber\":624,\"scale\":[1,2,3,1,1,2,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":80,\"all_scales_index\":404},{\"key\":\"2_3_1_1_2_2_1\",\"scaleNumber\":625,\"scale\":[2,3,1,1,2,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":80,\"all_scales_index\":743},{\"key\":\"3_1_1_2_2_1_2\",\"scaleNumber\":626,\"scale\":[3,1,1,2,2,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":80,\"all_scales_index\":810},{\"key\":\"1_1_2_2_1_3_2\",\"scaleNumber\":627,\"scale\":[1,1,2,2,1,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":81,\"all_scales_index\":205},{\"key\":\"1_2_2_1_3_2_1\",\"scaleNumber\":628,\"scale\":[1,2,2,1,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":81,\"all_scales_index\":377},{\"key\":\"2_2_1_3_2_1_1\",\"scaleNumber\":629,\"scale\":[2,2,1,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":81,\"all_scales_index\":694},{\"key\":\"2_1_3_2_1_1_2\",\"scaleNumber\":630,\"scale\":[2,1,3,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":81,\"all_scales_index\":643},{\"key\":\"1_3_2_1_1_2_2\",\"scaleNumber\":631,\"scale\":[1,3,2,1,1,2,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":81,\"all_scales_index\":472},{\"key\":\"3_2_1_1_2_2_1\",\"scaleNumber\":632,\"scale\":[3,2,1,1,2,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":81,\"all_scales_index\":868},{\"key\":\"2_1_1_2_2_1_3\",\"scaleNumber\":633,\"scale\":[2,1,1,2,2,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":81,\"all_scales_index\":564},{\"key\":\"1_1_2_2_2_1_3\",\"scaleNumber\":634,\"scale\":[1,1,2,2,2,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":82,\"all_scales_index\":209},{\"key\":\"1_2_2_2_1_3_1\",\"scaleNumber\":635,\"scale\":[1,2,2,2,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":82,\"all_scales_index\":385},{\"key\":\"2_2_2_1_3_1_1\",\"scaleNumber\":636,\"scale\":[2,2,2,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":82,\"all_scales_index\":708},{\"key\":\"2_2_1_3_1_1_2\",\"scaleNumber\":637,\"scale\":[2,2,1,3,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":82,\"all_scales_index\":691},{\"key\":\"2_1_3_1_1_2_2\",\"scaleNumber\":638,\"scale\":[2,1,3,1,1,2,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":82,\"all_scales_index\":634},{\"key\":\"1_3_1_1_2_2_2\",\"scaleNumber\":639,\"scale\":[1,3,1,1,2,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":82,\"all_scales_index\":441},{\"key\":\"3_1_1_2_2_2_1\",\"scaleNumber\":640,\"scale\":[3,1,1,2,2,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":82,\"all_scales_index\":811},{\"key\":\"1_1_2_2_2_2_2\",\"scaleNumber\":641,\"scale\":[1,1,2,2,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":83,\"all_scales_index\":211},{\"key\":\"1_2_2_2_2_2_1\",\"scaleNumber\":642,\"scale\":[1,2,2,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":83,\"all_scales_index\":388},{\"key\":\"2_2_2_2_2_1_1\",\"scaleNumber\":643,\"scale\":[2,2,2,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":83,\"all_scales_index\":714},{\"key\":\"2_2_2_2_1_1_2\",\"scaleNumber\":644,\"scale\":[2,2,2,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":83,\"all_scales_index\":711},{\"key\":\"2_2_2_1_1_2_2\",\"scaleNumber\":645,\"scale\":[2,2,2,1,1,2,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":83,\"all_scales_index\":702},{\"key\":\"2_2_1_1_2_2_2\",\"scaleNumber\":646,\"scale\":[2,2,1,1,2,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":83,\"all_scales_index\":671},{\"key\":\"2_1_1_2_2_2_2\",\"scaleNumber\":647,\"scale\":[2,1,1,2,2,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":83,\"all_scales_index\":566},{\"key\":\"1_1_2_2_3_1_2\",\"scaleNumber\":648,\"scale\":[1,1,2,2,3,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":84,\"all_scales_index\":214},{\"key\":\"1_2_2_3_1_2_1\",\"scaleNumber\":649,\"scale\":[1,2,2,3,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":84,\"all_scales_index\":394},{\"key\":\"2_2_3_1_2_1_1\",\"scaleNumber\":650,\"scale\":[2,2,3,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":84,\"all_scales_index\":725},{\"key\":\"2_3_1_2_1_1_2\",\"scaleNumber\":651,\"scale\":[2,3,1,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":84,\"all_scales_index\":748},{\"key\":\"3_1_2_1_1_2_2\",\"scaleNumber\":652,\"scale\":[3,1,2,1,1,2,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":84,\"all_scales_index\":827},{\"key\":\"1_2_1_1_2_2_3\",\"scaleNumber\":653,\"scale\":[1,2,1,1,2,2,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":84,\"all_scales_index\":308},{\"key\":\"2_1_1_2_2_3_1\",\"scaleNumber\":654,\"scale\":[2,1,1,2,2,3,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":84,\"all_scales_index\":567},{\"key\":\"1_1_2_2_3_3\",\"scaleNumber\":655,\"scale\":[1,1,2,2,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":85,\"all_scales_index\":216},{\"key\":\"1_2_2_3_3_1\",\"scaleNumber\":656,\"scale\":[1,2,2,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":85,\"all_scales_index\":398},{\"key\":\"2_2_3_3_1_1\",\"scaleNumber\":657,\"scale\":[2,2,3,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":85,\"all_scales_index\":732},{\"key\":\"2_3_3_1_1_2\",\"scaleNumber\":658,\"scale\":[2,3,3,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":85,\"all_scales_index\":772},{\"key\":\"3_3_1_1_2_2\",\"scaleNumber\":659,\"scale\":[3,3,1,1,2,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":85,\"all_scales_index\":908},{\"key\":\"3_1_1_2_2_3\",\"scaleNumber\":660,\"scale\":[3,1,1,2,2,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":85,\"all_scales_index\":812},{\"key\":\"1_1_2_3_1_1_3\",\"scaleNumber\":661,\"scale\":[1,1,2,3,1,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":86,\"all_scales_index\":220},{\"key\":\"1_2_3_1_1_3_1\",\"scaleNumber\":662,\"scale\":[1,2,3,1,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":86,\"all_scales_index\":405},{\"key\":\"2_3_1_1_3_1_1\",\"scaleNumber\":663,\"scale\":[2,3,1,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":86,\"all_scales_index\":745},{\"key\":\"3_1_1_3_1_1_2\",\"scaleNumber\":664,\"scale\":[3,1,1,3,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":86,\"all_scales_index\":816},{\"key\":\"1_1_3_1_1_2_3\",\"scaleNumber\":665,\"scale\":[1,1,3,1,1,2,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":86,\"all_scales_index\":240},{\"key\":\"1_3_1_1_2_3_1\",\"scaleNumber\":666,\"scale\":[1,3,1,1,2,3,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":86,\"all_scales_index\":442},{\"key\":\"3_1_1_2_3_1_1\",\"scaleNumber\":667,\"scale\":[3,1,1,2,3,1,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":86,\"all_scales_index\":813},{\"key\":\"1_1_2_3_1_2_2\",\"scaleNumber\":668,\"scale\":[1,1,2,3,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":87,\"all_scales_index\":222},{\"key\":\"1_2_3_1_2_2_1\",\"scaleNumber\":669,\"scale\":[1,2,3,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":87,\"all_scales_index\":408},{\"key\":\"2_3_1_2_2_1_1\",\"scaleNumber\":670,\"scale\":[2,3,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":87,\"all_scales_index\":751},{\"key\":\"3_1_2_2_1_1_2\",\"scaleNumber\":671,\"scale\":[3,1,2,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":87,\"all_scales_index\":836},{\"key\":\"1_2_2_1_1_2_3\",\"scaleNumber\":672,\"scale\":[1,2,2,1,1,2,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":87,\"all_scales_index\":365},{\"key\":\"2_2_1_1_2_3_1\",\"scaleNumber\":673,\"scale\":[2,2,1,1,2,3,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":87,\"all_scales_index\":672},{\"key\":\"2_1_1_2_3_1_2\",\"scaleNumber\":674,\"scale\":[2,1,1,2,3,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":87,\"all_scales_index\":569},{\"key\":\"1_1_2_3_2_1_2\",\"scaleNumber\":675,\"scale\":[1,1,2,3,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":88,\"all_scales_index\":225},{\"key\":\"1_2_3_2_1_2_1\",\"scaleNumber\":676,\"scale\":[1,2,3,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":88,\"all_scales_index\":414},{\"key\":\"2_3_2_1_2_1_1\",\"scaleNumber\":677,\"scale\":[2,3,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":88,\"all_scales_index\":762},{\"key\":\"3_2_1_2_1_1_2\",\"scaleNumber\":678,\"scale\":[3,2,1,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":88,\"all_scales_index\":873},{\"key\":\"2_1_2_1_1_2_3\",\"scaleNumber\":679,\"scale\":[2,1,2,1,1,2,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":88,\"all_scales_index\":595},{\"key\":\"1_2_1_1_2_3_2\",\"scaleNumber\":680,\"scale\":[1,2,1,1,2,3,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":88,\"all_scales_index\":310},{\"key\":\"2_1_1_2_3_2_1\",\"scaleNumber\":681,\"scale\":[2,1,1,2,3,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":88,\"all_scales_index\":570},{\"key\":\"1_1_2_3_2_3\",\"scaleNumber\":682,\"scale\":[1,1,2,3,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":89,\"all_scales_index\":227},{\"key\":\"1_2_3_2_3_1\",\"scaleNumber\":683,\"scale\":[1,2,3,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":89,\"all_scales_index\":418},{\"key\":\"2_3_2_3_1_1\",\"scaleNumber\":684,\"scale\":[2,3,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":89,\"all_scales_index\":769},{\"key\":\"3_2_3_1_1_2\",\"scaleNumber\":685,\"scale\":[3,2,3,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":89,\"all_scales_index\":897},{\"key\":\"2_3_1_1_2_3\",\"scaleNumber\":686,\"scale\":[2,3,1,1,2,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":89,\"all_scales_index\":744},{\"key\":\"3_1_1_2_3_2\",\"scaleNumber\":687,\"scale\":[3,1,1,2,3,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":89,\"all_scales_index\":814},{\"key\":\"1_1_2_3_3_2\",\"scaleNumber\":688,\"scale\":[1,1,2,3,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":90,\"all_scales_index\":229},{\"key\":\"1_2_3_3_2_1\",\"scaleNumber\":689,\"scale\":[1,2,3,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":90,\"all_scales_index\":421},{\"key\":\"2_3_3_2_1_1\",\"scaleNumber\":690,\"scale\":[2,3,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":90,\"all_scales_index\":775},{\"key\":\"3_3_2_1_1_2\",\"scaleNumber\":691,\"scale\":[3,3,2,1,1,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":90,\"all_scales_index\":917},{\"key\":\"3_2_1_1_2_3\",\"scaleNumber\":692,\"scale\":[3,2,1,1,2,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":90,\"all_scales_index\":869},{\"key\":\"2_1_1_2_3_3\",\"scaleNumber\":693,\"scale\":[2,1,1,2,3,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":90,\"all_scales_index\":571},{\"key\":\"1_1_3_1_1_3_2\",\"scaleNumber\":694,\"scale\":[1,1,3,1,1,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":91,\"all_scales_index\":242},{\"key\":\"1_3_1_1_3_2_1\",\"scaleNumber\":695,\"scale\":[1,3,1,1,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":91,\"all_scales_index\":445},{\"key\":\"3_1_1_3_2_1_1\",\"scaleNumber\":696,\"scale\":[3,1,1,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":91,\"all_scales_index\":819},{\"key\":\"1_1_3_2_1_1_3\",\"scaleNumber\":697,\"scale\":[1,1,3,2,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":91,\"all_scales_index\":257},{\"key\":\"1_3_2_1_1_3_1\",\"scaleNumber\":698,\"scale\":[1,3,2,1,1,3,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":91,\"all_scales_index\":473},{\"key\":\"3_2_1_1_3_1_1\",\"scaleNumber\":699,\"scale\":[3,2,1,1,3,1,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":91,\"all_scales_index\":870},{\"key\":\"2_1_1_3_1_1_3\",\"scaleNumber\":700,\"scale\":[2,1,1,3,1,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":91,\"all_scales_index\":575},{\"key\":\"1_1_3_1_2_1_3\",\"scaleNumber\":701,\"scale\":[1,1,3,1,2,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":92,\"all_scales_index\":246},{\"key\":\"1_3_1_2_1_3_1\",\"scaleNumber\":702,\"scale\":[1,3,1,2,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":92,\"all_scales_index\":453},{\"key\":\"3_1_2_1_3_1_1\",\"scaleNumber\":703,\"scale\":[3,1,2,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":92,\"all_scales_index\":833},{\"key\":\"1_2_1_3_1_1_3\",\"scaleNumber\":704,\"scale\":[1,2,1,3,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":92,\"all_scales_index\":345},{\"key\":\"2_1_3_1_1_3_1\",\"scaleNumber\":705,\"scale\":[2,1,3,1,1,3,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":92,\"all_scales_index\":635},{\"key\":\"1_3_1_1_3_1_2\",\"scaleNumber\":706,\"scale\":[1,3,1,1,3,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":92,\"all_scales_index\":444},{\"key\":\"3_1_1_3_1_2_1\",\"scaleNumber\":707,\"scale\":[3,1,1,3,1,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":92,\"all_scales_index\":817},{\"key\":\"1_1_3_1_2_2_2\",\"scaleNumber\":708,\"scale\":[1,1,3,1,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":93,\"all_scales_index\":248},{\"key\":\"1_3_1_2_2_2_1\",\"scaleNumber\":709,\"scale\":[1,3,1,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":93,\"all_scales_index\":456},{\"key\":\"3_1_2_2_2_1_1\",\"scaleNumber\":710,\"scale\":[3,1,2,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":93,\"all_scales_index\":839},{\"key\":\"1_2_2_2_1_1_3\",\"scaleNumber\":711,\"scale\":[1,2,2,2,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":93,\"all_scales_index\":382},{\"key\":\"2_2_2_1_1_3_1\",\"scaleNumber\":712,\"scale\":[2,2,2,1,1,3,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":93,\"all_scales_index\":703},{\"key\":\"2_2_1_1_3_1_2\",\"scaleNumber\":713,\"scale\":[2,2,1,1,3,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":93,\"all_scales_index\":674},{\"key\":\"2_1_1_3_1_2_2\",\"scaleNumber\":714,\"scale\":[2,1,1,3,1,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":93,\"all_scales_index\":577},{\"key\":\"1_1_3_1_3_1_2\",\"scaleNumber\":715,\"scale\":[1,1,3,1,3,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":94,\"all_scales_index\":251},{\"key\":\"1_3_1_3_1_2_1\",\"scaleNumber\":716,\"scale\":[1,3,1,3,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":94,\"all_scales_index\":462},{\"key\":\"3_1_3_1_2_1_1\",\"scaleNumber\":717,\"scale\":[3,1,3,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":94,\"all_scales_index\":850},{\"key\":\"1_3_1_2_1_1_3\",\"scaleNumber\":718,\"scale\":[1,3,1,2,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":94,\"all_scales_index\":450},{\"key\":\"3_1_2_1_1_3_1\",\"scaleNumber\":719,\"scale\":[3,1,2,1,1,3,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":94,\"all_scales_index\":828},{\"key\":\"1_2_1_1_3_1_3\",\"scaleNumber\":720,\"scale\":[1,2,1,1,3,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":94,\"all_scales_index\":314},{\"key\":\"2_1_1_3_1_3_1\",\"scaleNumber\":721,\"scale\":[2,1,1,3,1,3,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":94,\"all_scales_index\":578},{\"key\":\"1_1_3_1_3_3\",\"scaleNumber\":722,\"scale\":[1,1,3,1,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":95,\"all_scales_index\":253},{\"key\":\"1_3_1_3_3_1\",\"scaleNumber\":723,\"scale\":[1,3,1,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":95,\"all_scales_index\":466},{\"key\":\"3_1_3_3_1_1\",\"scaleNumber\":724,\"scale\":[3,1,3,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":95,\"all_scales_index\":857},{\"key\":\"1_3_3_1_1_3\",\"scaleNumber\":725,\"scale\":[1,3,3,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":95,\"all_scales_index\":494},{\"key\":\"3_3_1_1_3_1\",\"scaleNumber\":726,\"scale\":[3,3,1,1,3,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":95,\"all_scales_index\":909},{\"key\":\"3_1_1_3_1_3\",\"scaleNumber\":727,\"scale\":[3,1,1,3,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":95,\"all_scales_index\":818},{\"key\":\"1_1_3_2_1_2_2\",\"scaleNumber\":728,\"scale\":[1,1,3,2,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":96,\"all_scales_index\":259},{\"key\":\"1_3_2_1_2_2_1\",\"scaleNumber\":729,\"scale\":[1,3,2,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":96,\"all_scales_index\":476},{\"key\":\"3_2_1_2_2_1_1\",\"scaleNumber\":730,\"scale\":[3,2,1,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":96,\"all_scales_index\":876},{\"key\":\"2_1_2_2_1_1_3\",\"scaleNumber\":731,\"scale\":[2,1,2,2,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":96,\"all_scales_index\":612},{\"key\":\"1_2_2_1_1_3_2\",\"scaleNumber\":732,\"scale\":[1,2,2,1,1,3,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":96,\"all_scales_index\":367},{\"key\":\"2_2_1_1_3_2_1\",\"scaleNumber\":733,\"scale\":[2,2,1,1,3,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":96,\"all_scales_index\":675},{\"key\":\"2_1_1_3_2_1_2\",\"scaleNumber\":734,\"scale\":[2,1,1,3,2,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":96,\"all_scales_index\":580},{\"key\":\"1_1_3_2_2_1_2\",\"scaleNumber\":735,\"scale\":[1,1,3,2,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":97,\"all_scales_index\":262},{\"key\":\"1_3_2_2_1_2_1\",\"scaleNumber\":736,\"scale\":[1,3,2,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":97,\"all_scales_index\":482},{\"key\":\"3_2_2_1_2_1_1\",\"scaleNumber\":737,\"scale\":[3,2,2,1,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":97,\"all_scales_index\":887},{\"key\":\"2_2_1_2_1_1_3\",\"scaleNumber\":738,\"scale\":[2,2,1,2,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":97,\"all_scales_index\":680},{\"key\":\"2_1_2_1_1_3_2\",\"scaleNumber\":739,\"scale\":[2,1,2,1,1,3,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":97,\"all_scales_index\":597},{\"key\":\"1_2_1_1_3_2_2\",\"scaleNumber\":740,\"scale\":[1,2,1,1,3,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":97,\"all_scales_index\":316},{\"key\":\"2_1_1_3_2_2_1\",\"scaleNumber\":741,\"scale\":[2,1,1,3,2,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":97,\"all_scales_index\":581},{\"key\":\"1_1_3_2_2_3\",\"scaleNumber\":742,\"scale\":[1,1,3,2,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":98,\"all_scales_index\":264},{\"key\":\"1_3_2_2_3_1\",\"scaleNumber\":743,\"scale\":[1,3,2,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":98,\"all_scales_index\":486},{\"key\":\"3_2_2_3_1_1\",\"scaleNumber\":744,\"scale\":[3,2,2,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":98,\"all_scales_index\":894},{\"key\":\"2_2_3_1_1_3\",\"scaleNumber\":745,\"scale\":[2,2,3,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":98,\"all_scales_index\":724},{\"key\":\"2_3_1_1_3_2\",\"scaleNumber\":746,\"scale\":[2,3,1,1,3,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":98,\"all_scales_index\":746},{\"key\":\"3_1_1_3_2_2\",\"scaleNumber\":747,\"scale\":[3,1,1,3,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":98,\"all_scales_index\":820},{\"key\":\"1_1_3_2_3_2\",\"scaleNumber\":748,\"scale\":[1,1,3,2,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":99,\"all_scales_index\":266},{\"key\":\"1_3_2_3_2_1\",\"scaleNumber\":749,\"scale\":[1,3,2,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":99,\"all_scales_index\":489},{\"key\":\"3_2_3_2_1_1\",\"scaleNumber\":750,\"scale\":[3,2,3,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":99,\"all_scales_index\":900},{\"key\":\"2_3_2_1_1_3\",\"scaleNumber\":751,\"scale\":[2,3,2,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":99,\"all_scales_index\":761},{\"key\":\"3_2_1_1_3_2\",\"scaleNumber\":752,\"scale\":[3,2,1,1,3,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":99,\"all_scales_index\":871},{\"key\":\"2_1_1_3_2_3\",\"scaleNumber\":753,\"scale\":[2,1,1,3,2,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":99,\"all_scales_index\":582},{\"key\":\"1_1_3_3_1_3\",\"scaleNumber\":754,\"scale\":[1,1,3,3,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":100,\"all_scales_index\":270},{\"key\":\"1_3_3_1_3_1\",\"scaleNumber\":755,\"scale\":[1,3,3,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":100,\"all_scales_index\":497},{\"key\":\"3_3_1_3_1_1\",\"scaleNumber\":756,\"scale\":[3,3,1,3,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":100,\"all_scales_index\":914},{\"key\":\"3_1_3_1_1_3\",\"scaleNumber\":757,\"scale\":[3,1,3,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":100,\"all_scales_index\":849},{\"key\":\"1_3_1_1_3_3\",\"scaleNumber\":758,\"scale\":[1,3,1,1,3,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":100,\"all_scales_index\":446},{\"key\":\"3_1_1_3_3_1\",\"scaleNumber\":759,\"scale\":[3,1,1,3,3,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":100,\"all_scales_index\":821},{\"key\":\"1_1_3_3_2_2\",\"scaleNumber\":760,\"scale\":[1,1,3,3,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":101,\"all_scales_index\":272},{\"key\":\"1_3_3_2_2_1\",\"scaleNumber\":761,\"scale\":[1,3,3,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":101,\"all_scales_index\":500},{\"key\":\"3_3_2_2_1_1\",\"scaleNumber\":762,\"scale\":[3,3,2,2,1,1],\"is_superscale\":false,\"mode\":3,\"superscale_index\":101,\"all_scales_index\":920},{\"key\":\"3_2_2_1_1_3\",\"scaleNumber\":763,\"scale\":[3,2,2,1,1,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":101,\"all_scales_index\":886},{\"key\":\"2_2_1_1_3_3\",\"scaleNumber\":764,\"scale\":[2,2,1,1,3,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":101,\"all_scales_index\":676},{\"key\":\"2_1_1_3_3_2\",\"scaleNumber\":765,\"scale\":[2,1,1,3,3,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":101,\"all_scales_index\":584},{\"key\":\"1_2_1_2_1_2_1_2\",\"scaleNumber\":766,\"scale\":[1,2,1,2,1,2,1,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":102,\"all_scales_index\":326},{\"key\":\"2_1_2_1_2_1_2_1\",\"scaleNumber\":767,\"scale\":[2,1,2,1,2,1,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":102,\"all_scales_index\":600},{\"key\":\"1_2_1_2_1_2_3\",\"scaleNumber\":768,\"scale\":[1,2,1,2,1,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":103,\"all_scales_index\":328},{\"key\":\"2_1_2_1_2_3_1\",\"scaleNumber\":769,\"scale\":[2,1,2,1,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":103,\"all_scales_index\":604},{\"key\":\"1_2_1_2_3_1_2\",\"scaleNumber\":770,\"scale\":[1,2,1,2,3,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":103,\"all_scales_index\":339},{\"key\":\"2_1_2_3_1_2_1\",\"scaleNumber\":771,\"scale\":[2,1,2,3,1,2,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":103,\"all_scales_index\":624},{\"key\":\"1_2_3_1_2_1_2\",\"scaleNumber\":772,\"scale\":[1,2,3,1,2,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":103,\"all_scales_index\":407},{\"key\":\"2_3_1_2_1_2_1\",\"scaleNumber\":773,\"scale\":[2,3,1,2,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":103,\"all_scales_index\":749},{\"key\":\"3_1_2_1_2_1_2\",\"scaleNumber\":774,\"scale\":[3,1,2,1,2,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":103,\"all_scales_index\":830},{\"key\":\"1_2_1_2_1_3_2\",\"scaleNumber\":775,\"scale\":[1,2,1,2,1,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":104,\"all_scales_index\":330},{\"key\":\"2_1_2_1_3_2_1\",\"scaleNumber\":776,\"scale\":[2,1,2,1,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":104,\"all_scales_index\":607},{\"key\":\"1_2_1_3_2_1_2\",\"scaleNumber\":777,\"scale\":[1,2,1,3,2,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":104,\"all_scales_index\":350},{\"key\":\"2_1_3_2_1_2_1\",\"scaleNumber\":778,\"scale\":[2,1,3,2,1,2,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":104,\"all_scales_index\":644},{\"key\":\"1_3_2_1_2_1_2\",\"scaleNumber\":779,\"scale\":[1,3,2,1,2,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":104,\"all_scales_index\":475},{\"key\":\"3_2_1_2_1_2_1\",\"scaleNumber\":780,\"scale\":[3,2,1,2,1,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":104,\"all_scales_index\":874},{\"key\":\"2_1_2_1_2_1_3\",\"scaleNumber\":781,\"scale\":[2,1,2,1,2,1,3],\"is_superscale\":false,\"mode\":7,\"superscale_index\":104,\"all_scales_index\":601},{\"key\":\"1_2_1_2_2_1_3\",\"scaleNumber\":782,\"scale\":[1,2,1,2,2,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":105,\"all_scales_index\":334},{\"key\":\"2_1_2_2_1_3_1\",\"scaleNumber\":783,\"scale\":[2,1,2,2,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":105,\"all_scales_index\":615},{\"key\":\"1_2_2_1_3_1_2\",\"scaleNumber\":784,\"scale\":[1,2,2,1,3,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":105,\"all_scales_index\":376},{\"key\":\"2_2_1_3_1_2_1\",\"scaleNumber\":785,\"scale\":[2,2,1,3,1,2,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":105,\"all_scales_index\":692},{\"key\":\"2_1_3_1_2_1_2\",\"scaleNumber\":786,\"scale\":[2,1,3,1,2,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":105,\"all_scales_index\":637},{\"key\":\"1_3_1_2_1_2_2\",\"scaleNumber\":787,\"scale\":[1,3,1,2,1,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":105,\"all_scales_index\":452},{\"key\":\"3_1_2_1_2_2_1\",\"scaleNumber\":788,\"scale\":[3,1,2,1,2,2,1],\"is_superscale\":false,\"mode\":7,\"superscale_index\":105,\"all_scales_index\":831},{\"key\":\"1_2_1_2_2_2_2\",\"scaleNumber\":789,\"scale\":[1,2,1,2,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":106,\"all_scales_index\":336},{\"key\":\"2_1_2_2_2_2_1\",\"scaleNumber\":790,\"scale\":[2,1,2,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":106,\"all_scales_index\":618},{\"key\":\"1_2_2_2_2_1_2\",\"scaleNumber\":791,\"scale\":[1,2,2,2,2,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":106,\"all_scales_index\":387},{\"key\":\"2_2_2_2_1_2_1\",\"scaleNumber\":792,\"scale\":[2,2,2,2,1,2,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":106,\"all_scales_index\":712},{\"key\":\"2_2_2_1_2_1_2\",\"scaleNumber\":793,\"scale\":[2,2,2,1,2,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":106,\"all_scales_index\":705},{\"key\":\"2_2_1_2_1_2_2\",\"scaleNumber\":794,\"scale\":[2,2,1,2,1,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":106,\"all_scales_index\":682},{\"key\":\"2_1_2_1_2_2_2\",\"scaleNumber\":795,\"scale\":[2,1,2,1,2,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":106,\"all_scales_index\":603},{\"key\":\"1_2_1_2_3_3\",\"scaleNumber\":796,\"scale\":[1,2,1,2,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":107,\"all_scales_index\":341},{\"key\":\"2_1_2_3_3_1\",\"scaleNumber\":797,\"scale\":[2,1,2,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":107,\"all_scales_index\":628},{\"key\":\"1_2_3_3_1_2\",\"scaleNumber\":798,\"scale\":[1,2,3,3,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":107,\"all_scales_index\":420},{\"key\":\"2_3_3_1_2_1\",\"scaleNumber\":799,\"scale\":[2,3,3,1,2,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":107,\"all_scales_index\":773},{\"key\":\"3_3_1_2_1_2\",\"scaleNumber\":800,\"scale\":[3,3,1,2,1,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":107,\"all_scales_index\":911},{\"key\":\"3_1_2_1_2_3\",\"scaleNumber\":801,\"scale\":[3,1,2,1,2,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":107,\"all_scales_index\":832},{\"key\":\"1_2_1_3_1_2_2\",\"scaleNumber\":802,\"scale\":[1,2,1,3,1,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":108,\"all_scales_index\":347},{\"key\":\"2_1_3_1_2_2_1\",\"scaleNumber\":803,\"scale\":[2,1,3,1,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":108,\"all_scales_index\":638},{\"key\":\"1_3_1_2_2_1_2\",\"scaleNumber\":804,\"scale\":[1,3,1,2,2,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":108,\"all_scales_index\":455},{\"key\":\"3_1_2_2_1_2_1\",\"scaleNumber\":805,\"scale\":[3,1,2,2,1,2,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":108,\"all_scales_index\":837},{\"key\":\"1_2_2_1_2_1_3\",\"scaleNumber\":806,\"scale\":[1,2,2,1,2,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":108,\"all_scales_index\":371},{\"key\":\"2_2_1_2_1_3_1\",\"scaleNumber\":807,\"scale\":[2,2,1,2,1,3,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":108,\"all_scales_index\":683},{\"key\":\"2_1_2_1_3_1_2\",\"scaleNumber\":808,\"scale\":[2,1,2,1,3,1,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":108,\"all_scales_index\":606},{\"key\":\"1_2_1_3_2_3\",\"scaleNumber\":809,\"scale\":[1,2,1,3,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":109,\"all_scales_index\":352},{\"key\":\"2_1_3_2_3_1\",\"scaleNumber\":810,\"scale\":[2,1,3,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":109,\"all_scales_index\":648},{\"key\":\"1_3_2_3_1_2\",\"scaleNumber\":811,\"scale\":[1,3,2,3,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":109,\"all_scales_index\":488},{\"key\":\"3_2_3_1_2_1\",\"scaleNumber\":812,\"scale\":[3,2,3,1,2,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":109,\"all_scales_index\":898},{\"key\":\"2_3_1_2_1_3\",\"scaleNumber\":813,\"scale\":[2,3,1,2,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":109,\"all_scales_index\":750},{\"key\":\"3_1_2_1_3_2\",\"scaleNumber\":814,\"scale\":[3,1,2,1,3,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":109,\"all_scales_index\":834},{\"key\":\"1_2_1_3_3_2\",\"scaleNumber\":815,\"scale\":[1,2,1,3,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":110,\"all_scales_index\":354},{\"key\":\"2_1_3_3_2_1\",\"scaleNumber\":816,\"scale\":[2,1,3,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":110,\"all_scales_index\":651},{\"key\":\"1_3_3_2_1_2\",\"scaleNumber\":817,\"scale\":[1,3,3,2,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":110,\"all_scales_index\":499},{\"key\":\"3_3_2_1_2_1\",\"scaleNumber\":818,\"scale\":[3,3,2,1,2,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":110,\"all_scales_index\":918},{\"key\":\"3_2_1_2_1_3\",\"scaleNumber\":819,\"scale\":[3,2,1,2,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":110,\"all_scales_index\":875},{\"key\":\"2_1_2_1_3_3\",\"scaleNumber\":820,\"scale\":[2,1,2,1,3,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":110,\"all_scales_index\":608},{\"key\":\"1_2_2_1_2_2_2\",\"scaleNumber\":821,\"scale\":[1,2,2,1,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":111,\"all_scales_index\":373},{\"key\":\"2_2_1_2_2_2_1\",\"scaleNumber\":822,\"scale\":[2,2,1,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":111,\"all_scales_index\":686},{\"key\":\"2_1_2_2_2_1_2\",\"scaleNumber\":823,\"scale\":[2,1,2,2,2,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":111,\"all_scales_index\":617},{\"key\":\"1_2_2_2_1_2_2\",\"scaleNumber\":824,\"scale\":[1,2,2,2,1,2,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":111,\"all_scales_index\":384},{\"key\":\"2_2_2_1_2_2_1\",\"scaleNumber\":825,\"scale\":[2,2,2,1,2,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":111,\"all_scales_index\":706},{\"key\":\"2_2_1_2_2_1_2\",\"scaleNumber\":826,\"scale\":[2,2,1,2,2,1,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":111,\"all_scales_index\":685},{\"key\":\"2_1_2_2_1_2_2\",\"scaleNumber\":827,\"scale\":[2,1,2,2,1,2,2],\"is_superscale\":false,\"mode\":7,\"superscale_index\":111,\"all_scales_index\":614},{\"key\":\"1_2_2_1_3_3\",\"scaleNumber\":828,\"scale\":[1,2,2,1,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":112,\"all_scales_index\":378},{\"key\":\"2_2_1_3_3_1\",\"scaleNumber\":829,\"scale\":[2,2,1,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":112,\"all_scales_index\":696},{\"key\":\"2_1_3_3_1_2\",\"scaleNumber\":830,\"scale\":[2,1,3,3,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":112,\"all_scales_index\":650},{\"key\":\"1_3_3_1_2_2\",\"scaleNumber\":831,\"scale\":[1,3,3,1,2,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":112,\"all_scales_index\":496},{\"key\":\"3_3_1_2_2_1\",\"scaleNumber\":832,\"scale\":[3,3,1,2,2,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":112,\"all_scales_index\":912},{\"key\":\"3_1_2_2_1_3\",\"scaleNumber\":833,\"scale\":[3,1,2,2,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":112,\"all_scales_index\":838},{\"key\":\"1_2_2_2_2_3\",\"scaleNumber\":834,\"scale\":[1,2,2,2,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":113,\"all_scales_index\":389},{\"key\":\"2_2_2_2_3_1\",\"scaleNumber\":835,\"scale\":[2,2,2,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":113,\"all_scales_index\":716},{\"key\":\"2_2_2_3_1_2\",\"scaleNumber\":836,\"scale\":[2,2,2,3,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":113,\"all_scales_index\":718},{\"key\":\"2_2_3_1_2_2\",\"scaleNumber\":837,\"scale\":[2,2,3,1,2,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":113,\"all_scales_index\":726},{\"key\":\"2_3_1_2_2_2\",\"scaleNumber\":838,\"scale\":[2,3,1,2,2,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":113,\"all_scales_index\":752},{\"key\":\"3_1_2_2_2_2\",\"scaleNumber\":839,\"scale\":[3,1,2,2,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":113,\"all_scales_index\":840},{\"key\":\"1_2_2_2_3_2\",\"scaleNumber\":840,\"scale\":[1,2,2,2,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":114,\"all_scales_index\":391},{\"key\":\"2_2_2_3_2_1\",\"scaleNumber\":841,\"scale\":[2,2,2,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":114,\"all_scales_index\":719},{\"key\":\"2_2_3_2_1_2\",\"scaleNumber\":842,\"scale\":[2,2,3,2,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":114,\"all_scales_index\":729},{\"key\":\"2_3_2_1_2_2\",\"scaleNumber\":843,\"scale\":[2,3,2,1,2,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":114,\"all_scales_index\":763},{\"key\":\"3_2_1_2_2_2\",\"scaleNumber\":844,\"scale\":[3,2,1,2,2,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":114,\"all_scales_index\":877},{\"key\":\"2_1_2_2_2_3\",\"scaleNumber\":845,\"scale\":[2,1,2,2,2,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":114,\"all_scales_index\":619},{\"key\":\"1_2_2_3_1_3\",\"scaleNumber\":846,\"scale\":[1,2,2,3,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":115,\"all_scales_index\":395},{\"key\":\"2_2_3_1_3_1\",\"scaleNumber\":847,\"scale\":[2,2,3,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":115,\"all_scales_index\":727},{\"key\":\"2_3_1_3_1_2\",\"scaleNumber\":848,\"scale\":[2,3,1,3,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":115,\"all_scales_index\":755},{\"key\":\"3_1_3_1_2_2\",\"scaleNumber\":849,\"scale\":[3,1,3,1,2,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":115,\"all_scales_index\":851},{\"key\":\"1_3_1_2_2_3\",\"scaleNumber\":850,\"scale\":[1,3,1,2,2,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":115,\"all_scales_index\":457},{\"key\":\"3_1_2_2_3_1\",\"scaleNumber\":851,\"scale\":[3,1,2,2,3,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":115,\"all_scales_index\":841},{\"key\":\"1_2_2_3_2_2\",\"scaleNumber\":852,\"scale\":[1,2,2,3,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":116,\"all_scales_index\":397},{\"key\":\"2_2_3_2_2_1\",\"scaleNumber\":853,\"scale\":[2,2,3,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":116,\"all_scales_index\":730},{\"key\":\"2_3_2_2_1_2\",\"scaleNumber\":854,\"scale\":[2,3,2,2,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":116,\"all_scales_index\":766},{\"key\":\"3_2_2_1_2_2\",\"scaleNumber\":855,\"scale\":[3,2,2,1,2,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":116,\"all_scales_index\":888},{\"key\":\"2_2_1_2_2_3\",\"scaleNumber\":856,\"scale\":[2,2,1,2,2,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":116,\"all_scales_index\":687},{\"key\":\"2_1_2_2_3_2\",\"scaleNumber\":857,\"scale\":[2,1,2,2,3,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":116,\"all_scales_index\":621},{\"key\":\"1_2_3_1_2_3\",\"scaleNumber\":858,\"scale\":[1,2,3,1,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":117,\"all_scales_index\":409},{\"key\":\"2_3_1_2_3_1\",\"scaleNumber\":859,\"scale\":[2,3,1,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":117,\"all_scales_index\":753},{\"key\":\"3_1_2_3_1_2\",\"scaleNumber\":860,\"scale\":[3,1,2,3,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":117,\"all_scales_index\":843},{\"key\":\"1_2_3_1_3_2\",\"scaleNumber\":861,\"scale\":[1,2,3,1,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":118,\"all_scales_index\":411},{\"key\":\"2_3_1_3_2_1\",\"scaleNumber\":862,\"scale\":[2,3,1,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":118,\"all_scales_index\":756},{\"key\":\"3_1_3_2_1_2\",\"scaleNumber\":863,\"scale\":[3,1,3,2,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":118,\"all_scales_index\":854},{\"key\":\"1_3_2_1_2_3\",\"scaleNumber\":864,\"scale\":[1,3,2,1,2,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":118,\"all_scales_index\":477},{\"key\":\"3_2_1_2_3_1\",\"scaleNumber\":865,\"scale\":[3,2,1,2,3,1],\"is_superscale\":false,\"mode\":5,\"superscale_index\":118,\"all_scales_index\":878},{\"key\":\"2_1_2_3_1_3\",\"scaleNumber\":866,\"scale\":[2,1,2,3,1,3],\"is_superscale\":false,\"mode\":6,\"superscale_index\":118,\"all_scales_index\":625},{\"key\":\"1_2_3_2_1_3\",\"scaleNumber\":867,\"scale\":[1,2,3,2,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":119,\"all_scales_index\":415},{\"key\":\"2_3_2_1_3_1\",\"scaleNumber\":868,\"scale\":[2,3,2,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":119,\"all_scales_index\":764},{\"key\":\"3_2_1_3_1_2\",\"scaleNumber\":869,\"scale\":[3,2,1,3,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":119,\"all_scales_index\":880},{\"key\":\"2_1_3_1_2_3\",\"scaleNumber\":870,\"scale\":[2,1,3,1,2,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":119,\"all_scales_index\":639},{\"key\":\"1_3_1_2_3_2\",\"scaleNumber\":871,\"scale\":[1,3,1,2,3,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":119,\"all_scales_index\":459},{\"key\":\"3_1_2_3_2_1\",\"scaleNumber\":872,\"scale\":[3,1,2,3,2,1],\"is_superscale\":false,\"mode\":6,\"superscale_index\":119,\"all_scales_index\":844},{\"key\":\"1_2_3_2_2_2\",\"scaleNumber\":873,\"scale\":[1,2,3,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":120,\"all_scales_index\":417},{\"key\":\"2_3_2_2_2_1\",\"scaleNumber\":874,\"scale\":[2,3,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":120,\"all_scales_index\":767},{\"key\":\"3_2_2_2_1_2\",\"scaleNumber\":875,\"scale\":[3,2,2,2,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":120,\"all_scales_index\":891},{\"key\":\"2_2_2_1_2_3\",\"scaleNumber\":876,\"scale\":[2,2,2,1,2,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":120,\"all_scales_index\":707},{\"key\":\"2_2_1_2_3_2\",\"scaleNumber\":877,\"scale\":[2,2,1,2,3,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":120,\"all_scales_index\":689},{\"key\":\"2_1_2_3_2_2\",\"scaleNumber\":878,\"scale\":[2,1,2,3,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":120,\"all_scales_index\":627},{\"key\":\"1_2_3_3_3\",\"scaleNumber\":879,\"scale\":[1,2,3,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":121,\"all_scales_index\":422},{\"key\":\"2_3_3_3_1\",\"scaleNumber\":880,\"scale\":[2,3,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":121,\"all_scales_index\":777},{\"key\":\"3_3_3_1_2\",\"scaleNumber\":881,\"scale\":[3,3,3,1,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":121,\"all_scales_index\":924},{\"key\":\"3_3_1_2_3\",\"scaleNumber\":882,\"scale\":[3,3,1,2,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":121,\"all_scales_index\":913},{\"key\":\"3_1_2_3_3\",\"scaleNumber\":883,\"scale\":[3,1,2,3,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":121,\"all_scales_index\":845},{\"key\":\"1_3_1_3_1_3\",\"scaleNumber\":884,\"scale\":[1,3,1,3,1,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":122,\"all_scales_index\":463},{\"key\":\"3_1_3_1_3_1\",\"scaleNumber\":885,\"scale\":[3,1,3,1,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":122,\"all_scales_index\":852},{\"key\":\"1_3_1_3_2_2\",\"scaleNumber\":886,\"scale\":[1,3,1,3,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":123,\"all_scales_index\":465},{\"key\":\"3_1_3_2_2_1\",\"scaleNumber\":887,\"scale\":[3,1,3,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":123,\"all_scales_index\":855},{\"key\":\"1_3_2_2_1_3\",\"scaleNumber\":888,\"scale\":[1,3,2,2,1,3],\"is_superscale\":false,\"mode\":3,\"superscale_index\":123,\"all_scales_index\":483},{\"key\":\"3_2_2_1_3_1\",\"scaleNumber\":889,\"scale\":[3,2,2,1,3,1],\"is_superscale\":false,\"mode\":4,\"superscale_index\":123,\"all_scales_index\":889},{\"key\":\"2_2_1_3_1_3\",\"scaleNumber\":890,\"scale\":[2,2,1,3,1,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":123,\"all_scales_index\":693},{\"key\":\"2_1_3_1_3_2\",\"scaleNumber\":891,\"scale\":[2,1,3,1,3,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":123,\"all_scales_index\":641},{\"key\":\"1_3_2_1_3_2\",\"scaleNumber\":892,\"scale\":[1,3,2,1,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":124,\"all_scales_index\":479},{\"key\":\"3_2_1_3_2_1\",\"scaleNumber\":893,\"scale\":[3,2,1,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":124,\"all_scales_index\":881},{\"key\":\"2_1_3_2_1_3\",\"scaleNumber\":894,\"scale\":[2,1,3,2,1,3],\"is_superscale\":false,\"mode\":3,\"superscale_index\":124,\"all_scales_index\":645},{\"key\":\"1_3_2_2_2_2\",\"scaleNumber\":895,\"scale\":[1,3,2,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":125,\"all_scales_index\":485},{\"key\":\"3_2_2_2_2_1\",\"scaleNumber\":896,\"scale\":[3,2,2,2,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":125,\"all_scales_index\":892},{\"key\":\"2_2_2_2_1_3\",\"scaleNumber\":897,\"scale\":[2,2,2,2,1,3],\"is_superscale\":false,\"mode\":3,\"superscale_index\":125,\"all_scales_index\":713},{\"key\":\"2_2_2_1_3_2\",\"scaleNumber\":898,\"scale\":[2,2,2,1,3,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":125,\"all_scales_index\":709},{\"key\":\"2_2_1_3_2_2\",\"scaleNumber\":899,\"scale\":[2,2,1,3,2,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":125,\"all_scales_index\":695},{\"key\":\"2_1_3_2_2_2\",\"scaleNumber\":900,\"scale\":[2,1,3,2,2,2],\"is_superscale\":false,\"mode\":6,\"superscale_index\":125,\"all_scales_index\":647},{\"key\":\"1_3_2_3_3\",\"scaleNumber\":901,\"scale\":[1,3,2,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":126,\"all_scales_index\":490},{\"key\":\"3_2_3_3_1\",\"scaleNumber\":902,\"scale\":[3,2,3,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":126,\"all_scales_index\":902},{\"key\":\"2_3_3_1_3\",\"scaleNumber\":903,\"scale\":[2,3,3,1,3],\"is_superscale\":false,\"mode\":3,\"superscale_index\":126,\"all_scales_index\":774},{\"key\":\"3_3_1_3_2\",\"scaleNumber\":904,\"scale\":[3,3,1,3,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":126,\"all_scales_index\":915},{\"key\":\"3_1_3_2_3\",\"scaleNumber\":905,\"scale\":[3,1,3,2,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":126,\"all_scales_index\":856},{\"key\":\"1_3_3_2_3\",\"scaleNumber\":906,\"scale\":[1,3,3,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":127,\"all_scales_index\":501},{\"key\":\"3_3_2_3_1\",\"scaleNumber\":907,\"scale\":[3,3,2,3,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":127,\"all_scales_index\":922},{\"key\":\"3_2_3_1_3\",\"scaleNumber\":908,\"scale\":[3,2,3,1,3],\"is_superscale\":false,\"mode\":3,\"superscale_index\":127,\"all_scales_index\":899},{\"key\":\"2_3_1_3_3\",\"scaleNumber\":909,\"scale\":[2,3,1,3,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":127,\"all_scales_index\":757},{\"key\":\"3_1_3_3_2\",\"scaleNumber\":910,\"scale\":[3,1,3,3,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":127,\"all_scales_index\":858},{\"key\":\"1_3_3_3_2\",\"scaleNumber\":911,\"scale\":[1,3,3,3,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":128,\"all_scales_index\":503},{\"key\":\"3_3_3_2_1\",\"scaleNumber\":912,\"scale\":[3,3,3,2,1],\"is_superscale\":false,\"mode\":2,\"superscale_index\":128,\"all_scales_index\":925},{\"key\":\"3_3_2_1_3\",\"scaleNumber\":913,\"scale\":[3,3,2,1,3],\"is_superscale\":false,\"mode\":3,\"superscale_index\":128,\"all_scales_index\":919},{\"key\":\"3_2_1_3_3\",\"scaleNumber\":914,\"scale\":[3,2,1,3,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":128,\"all_scales_index\":882},{\"key\":\"2_1_3_3_3\",\"scaleNumber\":915,\"scale\":[2,1,3,3,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":128,\"all_scales_index\":652},{\"key\":\"2_2_2_2_2_2\",\"scaleNumber\":916,\"scale\":[2,2,2,2,2,2],\"is_superscale\":true,\"mode\":1,\"superscale_index\":129,\"all_scales_index\":715},{\"key\":\"2_2_2_3_3\",\"scaleNumber\":917,\"scale\":[2,2,2,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":130,\"all_scales_index\":720},{\"key\":\"2_2_3_3_2\",\"scaleNumber\":918,\"scale\":[2,2,3,3,2],\"is_superscale\":false,\"mode\":2,\"superscale_index\":130,\"all_scales_index\":733},{\"key\":\"2_3_3_2_2\",\"scaleNumber\":919,\"scale\":[2,3,3,2,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":130,\"all_scales_index\":776},{\"key\":\"3_3_2_2_2\",\"scaleNumber\":920,\"scale\":[3,3,2,2,2],\"is_superscale\":false,\"mode\":4,\"superscale_index\":130,\"all_scales_index\":921},{\"key\":\"3_2_2_2_3\",\"scaleNumber\":921,\"scale\":[3,2,2,2,3],\"is_superscale\":false,\"mode\":5,\"superscale_index\":130,\"all_scales_index\":893},{\"key\":\"2_2_3_2_3\",\"scaleNumber\":922,\"scale\":[2,2,3,2,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":131,\"all_scales_index\":731},{\"key\":\"2_3_2_3_2\",\"scaleNumber\":923,\"scale\":[2,3,2,3,2],\"is_superscale\":false,\"mode\":2,\"superscale_index\":131,\"all_scales_index\":770},{\"key\":\"3_2_3_2_2\",\"scaleNumber\":924,\"scale\":[3,2,3,2,2],\"is_superscale\":false,\"mode\":3,\"superscale_index\":131,\"all_scales_index\":901},{\"key\":\"2_3_2_2_3\",\"scaleNumber\":925,\"scale\":[2,3,2,2,3],\"is_superscale\":false,\"mode\":4,\"superscale_index\":131,\"all_scales_index\":768},{\"key\":\"3_2_2_3_2\",\"scaleNumber\":926,\"scale\":[3,2,2,3,2],\"is_superscale\":false,\"mode\":5,\"superscale_index\":131,\"all_scales_index\":895},{\"key\":\"3_3_3_3\",\"scaleNumber\":927,\"scale\":[3,3,3,3],\"is_superscale\":true,\"mode\":1,\"superscale_index\":132,\"all_scales_index\":926}]");

},{}],"6GJK0":[function() {},{}]},["7TmdX"], "7TmdX", "parcelRequire8a3c", {})

//# sourceMappingURL=app.9d1cadb7.js.map
